
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebf92"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebf92"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("45fvw", function(module, exports) {
//! moment.js
//! version : 2.27.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i;
        for(i = 0; i < arr.length; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m), parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            }), isNowValid = !isNaN(m._d.getTime()) && flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
        }
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentProperties.length > 0) for(i = 0; i < momentProperties.length; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key;
                for(i = 0; i < arguments.length; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {};
    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + "s"] = aliases[shorthand] = unit;
    }
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {};
    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        return mom.isValid() ? mom._d["get" + (mom._isUTC ? "UTC" : "") + unit]() : NaN;
    }
    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === "FullYear" && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                value = toInt(value);
                mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value, mom.month(), daysInMonth(value, mom.month()));
            } else mom._d["set" + (mom._isUTC ? "UTC" : "") + unit](value);
        }
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i;
            for(i = 0; i < prioritized.length; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        for(i = 0; i < token.length; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // ALIASES
    addUnitAlias("month", "M");
    // PRIORITY
    addUnitPriority("month", 8);
    // PARSING
    addRegexToken("M", match1to2);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        var dayOfMonth;
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d["set" + (mom._isUTC ? "UTC" : "") + "Month"](value, dayOfMonth);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortPieces.push(this.monthsShort(mom, ""));
            longPieces.push(this.months(mom, ""));
            mixedPieces.push(this.months(mom, ""));
            mixedPieces.push(this.monthsShort(mom, ""));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for(i = 0; i < 12; i++){
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for(i = 0; i < 24; i++)mixedPieces[i] = regexEscape(mixedPieces[i]);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // ALIASES
    addUnitAlias("year", "y");
    // PRIORITIES
    addUnitPriority("year", 1);
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // ALIASES
    addUnitAlias("week", "w");
    addUnitAlias("isoWeek", "W");
    // PRIORITIES
    addUnitPriority("week", 5);
    addUnitPriority("isoWeek", 5);
    // PARSING
    addRegexToken("w", match1to2);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // ALIASES
    addUnitAlias("day", "d");
    addUnitAlias("weekday", "e");
    addUnitAlias("isoWeekday", "E");
    // PRIORITY
    addUnitPriority("day", 11);
    addUnitPriority("weekday", 11);
    addUnitPriority("isoWeekday", 11);
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // ALIASES
    addUnitAlias("hour", "h");
    // PRIORITY
    addUnitPriority("hour", 13);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2);
    addRegexToken("h", match1to2);
    addRegexToken("k", match1to2);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDates.length; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimes.length; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged and will be removed in an upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        for(i = 0; i < tokens.length; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false;
        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < config._f.length; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < ordering.length; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));
            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    addUnitAlias("weekYear", "gg");
    addUnitAlias("isoWeekYear", "GG");
    // PRIORITY
    addUnitPriority("weekYear", 1);
    addUnitPriority("isoWeekYear", 1);
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday(), this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // ALIASES
    addUnitAlias("quarter", "Q");
    // PRIORITY
    addUnitPriority("quarter", 7);
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // ALIASES
    addUnitAlias("date", "D");
    // PRIORITY
    addUnitPriority("date", 9);
    // PARSING
    addRegexToken("D", match1to2);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // ALIASES
    addUnitAlias("dayOfYear", "DDD");
    // PRIORITY
    addUnitPriority("dayOfYear", 4);
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // ALIASES
    addUnitAlias("minute", "m");
    // PRIORITY
    addUnitPriority("minute", 14);
    // PARSING
    addRegexToken("m", match1to2);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // ALIASES
    addUnitAlias("second", "s");
    // PRIORITY
    addUnitPriority("second", 15);
    // PARSING
    addRegexToken("s", match1to2);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // ALIASES
    addUnitAlias("millisecond", "ms");
    // PRIORITY
    addUnitPriority("millisecond", 16);
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) return NaN;
        return this._milliseconds + this._days * 864e5 + this._months % 12 * 2592e6 + toInt(this._months / 12) * 31536e6;
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y");
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.27.0";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("66e0v", function(module, exports) {
/**
 * DevExtreme (ui/calendar/ui.calendar.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $duKPB = parcelRequire("duKPB");

var $4ZFRo = parcelRequire("4ZFRo");

var $2Mto0 = parcelRequire("2Mto0");
var $470e2b2952413aca$require$noop = $2Mto0.noop;

var $kDRxH = parcelRequire("kDRxH");

var $efpkH = parcelRequire("efpkH");
var $470e2b2952413aca$require$inRange = $efpkH.inRange;

var $7I8Uw = parcelRequire("7I8Uw");
var $470e2b2952413aca$require$extend = $7I8Uw.extend;

var $7KuSv = parcelRequire("7KuSv");

var $4hjO5 = parcelRequire("4hjO5");

var $8xeOM = parcelRequire("8xeOM");

var $aX2Yo = parcelRequire("aX2Yo");

var $1ysc9 = parcelRequire("1ysc9");

var $6jr65 = parcelRequire("6jr65");

var $bvcPv = parcelRequire("bvcPv");

var $beWy7 = parcelRequire("beWy7");

var $PdzUL = parcelRequire("PdzUL");

var $aiwte = parcelRequire("aiwte");

var $c7ml4 = parcelRequire("c7ml4");

var $irv64 = parcelRequire("irv64");

var $cnVbh = parcelRequire("cnVbh");

var $kqsMi = parcelRequire("kqsMi");
var $470e2b2952413aca$require$FunctionTemplate = $kqsMi.FunctionTemplate;
var $470e2b2952413aca$var$CALENDAR_CLASS = "dx-calendar";
var $470e2b2952413aca$var$CALENDAR_BODY_CLASS = "dx-calendar-body";
var $470e2b2952413aca$var$CALENDAR_CELL_CLASS = "dx-calendar-cell";
var $470e2b2952413aca$var$CALENDAR_FOOTER_CLASS = "dx-calendar-footer";
var $470e2b2952413aca$var$CALENDAR_TODAY_BUTTON_CLASS = "dx-calendar-today-button";
var $470e2b2952413aca$var$CALENDAR_HAS_FOOTER_CLASS = "dx-calendar-with-footer";
var $470e2b2952413aca$var$CALENDAR_VIEWS_WRAPPER_CLASS = "dx-calendar-views-wrapper";
var $470e2b2952413aca$var$CALENDAR_VIEW_CLASS = "dx-calendar-view";
var $470e2b2952413aca$var$FOCUSED_STATE_CLASS = "dx-state-focused";
var $470e2b2952413aca$var$ANIMATION_DURATION_SHOW_VIEW = 250;
var $470e2b2952413aca$var$POP_ANIMATION_FROM = .6;
var $470e2b2952413aca$var$POP_ANIMATION_TO = 1;
var $470e2b2952413aca$var$CALENDAR_INPUT_STANDARD_PATTERN = "yyyy-MM-dd";
var $470e2b2952413aca$var$CALENDAR_DATE_VALUE_KEY = "dxDateValueKey";
var $470e2b2952413aca$var$LEVEL_COMPARE_MAP = {
    month: 3,
    year: 2,
    decade: 1,
    century: 0
};
var $470e2b2952413aca$var$ZOOM_LEVEL = {
    MONTH: "month",
    YEAR: "year",
    DECADE: "decade",
    CENTURY: "century"
};
var $470e2b2952413aca$var$Calendar = $4hjO5.inherit({
    _activeStateUnit: "." + $470e2b2952413aca$var$CALENDAR_CELL_CLASS,
    _getDefaultOptions: function() {
        return $470e2b2952413aca$require$extend(this.callBase(), {
            hoverStateEnabled: true,
            activeStateEnabled: true,
            currentDate: new Date,
            value: null,
            dateSerializationFormat: void 0,
            min: new Date(1e3, 0),
            max: new Date(3e3, 0),
            firstDayOfWeek: void 0,
            zoomLevel: $470e2b2952413aca$var$ZOOM_LEVEL.MONTH,
            maxZoomLevel: $470e2b2952413aca$var$ZOOM_LEVEL.MONTH,
            minZoomLevel: $470e2b2952413aca$var$ZOOM_LEVEL.CENTURY,
            showTodayButton: false,
            cellTemplate: "cell",
            disabledDates: null,
            onCellClick: null,
            onContouredChanged: null,
            hasFocus: function(element) {
                return element.hasClass($470e2b2952413aca$var$FOCUSED_STATE_CLASS);
            }
        });
    },
    _defaultOptionsRules: function() {
        return this.callBase().concat([
            {
                device: function() {
                    return "desktop" === $aiwte.real().deviceType && !$aiwte.isSimulator();
                },
                options: {
                    focusStateEnabled: true
                }
            }
        ]);
    },
    _supportedKeys: function() {
        return $470e2b2952413aca$require$extend(this.callBase(), {
            rightArrow: function(e) {
                e.preventDefault();
                if (e.ctrlKey) this._waitRenderView(1);
                else this._moveCurrentDate(1 * this._getRtlCorrection());
            },
            leftArrow: function(e) {
                e.preventDefault();
                if (e.ctrlKey) this._waitRenderView(-1);
                else this._moveCurrentDate(-1 * this._getRtlCorrection());
            },
            upArrow: function(e) {
                e.preventDefault();
                if (e.ctrlKey) this._navigateUp();
                else {
                    if ($c7ml4.isAnimating(this._view.$element())) return;
                    this._moveCurrentDate(-1 * this._view.option("colCount"));
                }
            },
            downArrow: function(e) {
                e.preventDefault();
                if (e.ctrlKey) this._navigateDown();
                else {
                    if ($c7ml4.isAnimating(this._view.$element())) return;
                    this._moveCurrentDate(1 * this._view.option("colCount"));
                }
            },
            home: function(e) {
                e.preventDefault();
                var zoomLevel = this.option("zoomLevel");
                var currentDate = this.option("currentDate");
                var min = this._dateOption("min");
                var date = $beWy7.sameView(zoomLevel, currentDate, min) ? min : $beWy7.getViewFirstCellDate(zoomLevel, currentDate);
                this._moveToClosestAvailableDate(date, 1);
            },
            end: function(e) {
                e.preventDefault();
                var zoomLevel = this.option("zoomLevel");
                var currentDate = this.option("currentDate");
                var max = this._dateOption("max");
                var date = $beWy7.sameView(zoomLevel, currentDate, max) ? max : $beWy7.getViewLastCellDate(zoomLevel, currentDate);
                this._moveToClosestAvailableDate(date, -1);
            },
            pageUp: function(e) {
                e.preventDefault();
                this._waitRenderView(-1);
            },
            pageDown: function(e) {
                e.preventDefault();
                this._waitRenderView(1);
            },
            tab: $470e2b2952413aca$require$noop,
            enter: function(e) {
                if (!this._isMaxZoomLevel()) this._navigateDown();
                else {
                    var value = this._updateTimeComponent(this.option("currentDate"));
                    this._dateValue(value, e);
                }
            }
        });
    },
    _getSerializationFormat: function(optionName) {
        var value = this.option(optionName || "value");
        if (this.option("dateSerializationFormat")) return this.option("dateSerializationFormat");
        if ($kDRxH.isNumeric(value)) return "number";
        if (!$kDRxH.isString(value)) return;
        return $PdzUL.getDateSerializationFormat(value);
    },
    _convertToDate: function(value, optionName) {
        return $PdzUL.deserializeDate(value);
    },
    _dateValue: function(value, dxEvent) {
        if (dxEvent) this._saveValueChangeEvent(dxEvent);
        this._dateOption("value", value);
    },
    _dateOption: function(optionName, optionValue) {
        if (1 === arguments.length) return this._convertToDate(this.option(optionName), optionName);
        var serializationFormat = this._getSerializationFormat(optionName);
        this.option(optionName, $PdzUL.serializeDate(optionValue, serializationFormat));
    },
    _moveCurrentDate: function(offset, baseDate) {
        var currentDate = baseDate || new Date(this.option("currentDate"));
        var maxDate = this._getMaxDate();
        var minDate = this._getMinDate();
        var zoomLevel = this.option("zoomLevel");
        var isCurrentDateInRange = $470e2b2952413aca$require$inRange(currentDate, minDate, maxDate);
        var dateForward = new Date(currentDate);
        var dateBackward = new Date(currentDate);
        var isDateForwardInRange = isCurrentDateInRange;
        var isDateBackwardInRange = isCurrentDateInRange;
        var step = offset || 1;
        while(!offset && (isDateForwardInRange || isDateBackwardInRange) || offset && isDateForwardInRange){
            switch(zoomLevel){
                case $470e2b2952413aca$var$ZOOM_LEVEL.MONTH:
                    dateForward.setDate(dateForward.getDate() + step);
                    dateBackward.setDate(dateBackward.getDate() - step);
                    break;
                case $470e2b2952413aca$var$ZOOM_LEVEL.YEAR:
                    dateForward.setMonth(dateForward.getMonth() + step);
                    dateBackward.setMonth(dateBackward.getMonth() - step);
                    break;
                case $470e2b2952413aca$var$ZOOM_LEVEL.DECADE:
                    dateForward.setFullYear(dateForward.getFullYear() + step);
                    dateBackward.setFullYear(dateBackward.getFullYear() - step);
                    break;
                case $470e2b2952413aca$var$ZOOM_LEVEL.CENTURY:
                    dateForward.setFullYear(dateForward.getFullYear() + 10 * step);
                    dateBackward.setFullYear(dateBackward.getFullYear() - 10 * step);
            }
            if (isDateForwardInRange && !this._view.isDateDisabled(dateForward)) {
                currentDate = dateForward;
                break;
            }
            if (isDateBackwardInRange && !offset && !this._view.isDateDisabled(dateBackward)) {
                currentDate = dateBackward;
                break;
            }
            isDateBackwardInRange = $470e2b2952413aca$require$inRange(dateBackward, minDate, maxDate);
            isDateForwardInRange = $470e2b2952413aca$require$inRange(dateForward, minDate, maxDate);
        }
        this.option("currentDate", currentDate);
    },
    _moveToClosestAvailableDate: function(baseDate, offset) {
        if (this._view.isDateDisabled(baseDate)) this._moveCurrentDate(offset, baseDate);
        else this.option("currentDate", baseDate);
    },
    _init: function() {
        this.callBase();
        this._correctZoomLevel();
        this._initCurrentDate();
        this._initActions();
    },
    _correctZoomLevel: function() {
        var minZoomLevel = this.option("minZoomLevel");
        var maxZoomLevel = this.option("maxZoomLevel");
        var zoomLevel = this.option("zoomLevel");
        if ($470e2b2952413aca$var$LEVEL_COMPARE_MAP[maxZoomLevel] < $470e2b2952413aca$var$LEVEL_COMPARE_MAP[minZoomLevel]) return;
        if ($470e2b2952413aca$var$LEVEL_COMPARE_MAP[zoomLevel] > $470e2b2952413aca$var$LEVEL_COMPARE_MAP[maxZoomLevel]) this.option("zoomLevel", maxZoomLevel);
        else if ($470e2b2952413aca$var$LEVEL_COMPARE_MAP[zoomLevel] < $470e2b2952413aca$var$LEVEL_COMPARE_MAP[minZoomLevel]) this.option("zoomLevel", minZoomLevel);
    },
    _initCurrentDate: function() {
        var currentDate = this._getNormalizedDate(this._dateOption("value")) || this._getNormalizedDate(this.option("currentDate"));
        this.option("currentDate", currentDate);
    },
    _getNormalizedDate: function(date) {
        date = $beWy7.normalizeDate(date, this._getMinDate(), this._getMaxDate());
        return $kDRxH.isDefined(date) ? new Date(date) : date;
    },
    _initActions: function() {
        this._cellClickAction = this._createActionByOption("onCellClick");
        this._onContouredChanged = this._createActionByOption("onContouredChanged");
    },
    _initTemplates: function() {
        this.callBase();
        this._defaultTemplates.cell = new $470e2b2952413aca$require$FunctionTemplate(function(options) {
            var data = options.model;
            $jFnCG(options.container).append($jFnCG("<span>").text(data && data.text || String(data)));
        });
    },
    _updateCurrentDate: function(date) {
        if ($c7ml4.isAnimating(this._$viewsWrapper)) $c7ml4.stop(this._$viewsWrapper, true);
        var min = this._getMinDate();
        var max = this._getMaxDate();
        if (min > max) {
            this.option("currentDate", new Date);
            return;
        }
        var normalizedDate = this._getNormalizedDate(date);
        if (date.getTime() !== normalizedDate.getTime()) {
            this.option("currentDate", new Date(normalizedDate));
            return;
        }
        var offset = this._getViewsOffset(this._view.option("date"), normalizedDate);
        if (0 !== offset && !this._isMaxZoomLevel() && this._isOtherViewCellClicked) offset = 0;
        if (this._view && 0 !== offset && !this._suppressNavigation) this._navigate(offset, normalizedDate);
        else {
            this._renderNavigator();
            this._setViewContoured(normalizedDate);
            this._updateAriaId(normalizedDate);
        }
    },
    _setViewContoured: function(date) {
        if (this.option("hasFocus")(this._focusTarget())) this._view.option("contouredDate", date);
    },
    _getMinDate: function() {
        if (this.min) return this.min;
        this.min = this._dateOption("min") || new Date(1e3, 0);
        return this.min;
    },
    _getMaxDate: function() {
        if (this.max) return this.max;
        this.max = this._dateOption("max") || new Date(3e3, 0);
        return this.max;
    },
    _getViewsOffset: function(startDate, endDate) {
        var zoomLevel = this.option("zoomLevel");
        if (zoomLevel === $470e2b2952413aca$var$ZOOM_LEVEL.MONTH) return this._getMonthsOffset(startDate, endDate);
        var zoomCorrection;
        switch(zoomLevel){
            case $470e2b2952413aca$var$ZOOM_LEVEL.CENTURY:
                zoomCorrection = 100;
                break;
            case $470e2b2952413aca$var$ZOOM_LEVEL.DECADE:
                zoomCorrection = 10;
                break;
            default:
                zoomCorrection = 1;
        }
        return parseInt(endDate.getFullYear() / zoomCorrection) - parseInt(startDate.getFullYear() / zoomCorrection);
    },
    _getMonthsOffset: function(startDate, endDate) {
        var yearOffset = endDate.getFullYear() - startDate.getFullYear();
        var monthOffset = endDate.getMonth() - startDate.getMonth();
        return 12 * yearOffset + monthOffset;
    },
    _waitRenderView: function(offset) {
        if (this._alreadyViewRender) return;
        this._alreadyViewRender = true;
        var date = this._getDateByOffset(offset * this._getRtlCorrection());
        this._moveToClosestAvailableDate(date, offset);
        setTimeout((function() {
            this._alreadyViewRender = false;
        }).bind(this));
    },
    _getRtlCorrection: function() {
        return this.option("rtlEnabled") ? -1 : 1;
    },
    _getDateByOffset: function(offset, date) {
        date = new Date(date || this.option("currentDate"));
        var currentDay = date.getDate();
        var difference = $beWy7.getDifferenceInMonth(this.option("zoomLevel")) * offset;
        date.setDate(1);
        date.setMonth(date.getMonth() + difference);
        var lastDay = $beWy7.getLastMonthDate(date).getDate();
        date.setDate(currentDay > lastDay ? lastDay : currentDay);
        return date;
    },
    _focusTarget: function() {
        return this.$element();
    },
    _initMarkup: function() {
        this._renderSubmitElement();
        this.callBase();
        var $element = this.$element();
        $element.addClass($470e2b2952413aca$var$CALENDAR_CLASS);
        this._renderBody();
        $element.append(this.$body);
        this._renderViews();
        this._renderNavigator();
        $element.append(this._navigator.$element());
        this._renderSwipeable();
        this._renderFooter();
        this._updateAriaSelected();
        this._updateAriaId();
        if (this._view.isDateDisabled(this.option("currentDate"))) this._moveCurrentDate(0);
    },
    _render: function() {
        this.callBase();
        this._setViewContoured(this.option("currentDate"));
    },
    _renderBody: function() {
        if (!this._$viewsWrapper) {
            this.$body = $jFnCG("<div>").addClass($470e2b2952413aca$var$CALENDAR_BODY_CLASS);
            this._$viewsWrapper = $jFnCG("<div>").addClass($470e2b2952413aca$var$CALENDAR_VIEWS_WRAPPER_CLASS);
            this.$body.append(this._$viewsWrapper);
        }
    },
    _renderViews: function() {
        this.$element().addClass($470e2b2952413aca$var$CALENDAR_VIEW_CLASS + "-" + this.option("zoomLevel"));
        var currentDate = this.option("currentDate");
        this._view = this._renderSpecificView(currentDate);
        this._view.option("_keyboardProcessor", this._viewKeyboardProcessor);
        if ($irv64.hasWindow()) {
            var beforeDate = this._getDateByOffset(-1, currentDate);
            this._beforeView = this._isViewAvailable(beforeDate) ? this._renderSpecificView(beforeDate) : null;
            var afterDate = this._getDateByOffset(1, currentDate);
            afterDate.setDate(1);
            this._afterView = this._isViewAvailable(afterDate) ? this._renderSpecificView(afterDate) : null;
        }
        this._translateViews();
    },
    _renderSpecificView: function(date) {
        var specificView = $1ysc9[this.option("zoomLevel")];
        var $view = $jFnCG("<div>").appendTo(this._$viewsWrapper);
        var config = this._viewConfig(date);
        return new specificView($view, config);
    },
    _viewConfig: function(date) {
        var disabledDates = this.option("disabledDates");
        disabledDates = $kDRxH.isFunction(disabledDates) ? this._injectComponent(disabledDates.bind(this)) : disabledDates;
        return {
            date: date,
            min: this._getMinDate(),
            max: this._getMaxDate(),
            firstDayOfWeek: this.option("firstDayOfWeek"),
            value: this._dateOption("value"),
            rtlEnabled: this.option("rtlEnabled"),
            disabled: this.option("disabled"),
            tabIndex: void 0,
            focusStateEnabled: this.option("focusStateEnabled"),
            hoverStateEnabled: this.option("hoverStateEnabled"),
            disabledDates: disabledDates,
            onCellClick: this._cellClickHandler.bind(this),
            cellTemplate: this._getTemplateByOption("cellTemplate"),
            allowValueSelection: this._isMaxZoomLevel()
        };
    },
    _injectComponent: function(func) {
        var that = this;
        return function(params) {
            $470e2b2952413aca$require$extend(params, {
                component: that
            });
            return func(params);
        };
    },
    _isViewAvailable: function(date) {
        var zoomLevel = this.option("zoomLevel");
        var min = $beWy7.getViewMinBoundaryDate(zoomLevel, this._getMinDate());
        var max = $beWy7.getViewMaxBoundaryDate(zoomLevel, this._getMaxDate());
        return $beWy7.dateInRange(date, min, max);
    },
    _translateViews: function() {
        $6jr65.move(this._view.$element(), {
            left: 0,
            top: 0
        });
        this._beforeView && $6jr65.move(this._beforeView.$element(), {
            left: this._getViewPosition(-1),
            top: 0
        });
        this._afterView && $6jr65.move(this._afterView.$element(), {
            left: this._getViewPosition(1),
            top: 0
        });
    },
    _getViewPosition: function(coefficient) {
        var rtlCorrection = this.option("rtlEnabled") && !$bvcPv.msie ? -1 : 1;
        return 100 * coefficient * rtlCorrection + "%";
    },
    _cellClickHandler: function(e) {
        var zoomLevel = this.option("zoomLevel");
        var nextView = $beWy7.getViewDown(zoomLevel);
        var isMaxZoomLevel = this._isMaxZoomLevel();
        if (nextView && !isMaxZoomLevel) this._navigateDown(e.event.currentTarget);
        else {
            var newValue = this._updateTimeComponent(e.value);
            this._dateValue(newValue, e.event);
            this._cellClickAction(e);
        }
    },
    _updateTimeComponent: function(date) {
        var result = new Date(date);
        var currentValue = this._dateOption("value");
        if (currentValue) {
            result.setHours(currentValue.getHours());
            result.setMinutes(currentValue.getMinutes());
            result.setSeconds(currentValue.getSeconds());
            result.setMilliseconds(currentValue.getMilliseconds());
        }
        return result;
    },
    _isMaxZoomLevel: function() {
        return this.option("zoomLevel") === this.option("maxZoomLevel");
    },
    _navigateDown: function(cell) {
        var zoomLevel = this.option("zoomLevel");
        if (this._isMaxZoomLevel()) return;
        var nextView = $beWy7.getViewDown(zoomLevel);
        if (!nextView) return;
        var newCurrentDate = this._view.option("contouredDate") || this._view.option("date");
        if (cell) newCurrentDate = $jFnCG(cell).data($470e2b2952413aca$var$CALENDAR_DATE_VALUE_KEY);
        this._isOtherViewCellClicked = true;
        this.option("currentDate", newCurrentDate);
        this.option("zoomLevel", nextView);
        this._isOtherViewCellClicked = false;
        this._renderNavigator();
        this._animateShowView();
        this._setViewContoured(this._getNormalizedDate(newCurrentDate));
    },
    _renderNavigator: function() {
        if (!this._navigator) this._navigator = new $aX2Yo($jFnCG("<div>"), this._navigatorConfig());
        this._navigator.option("text", this._view.getNavigatorCaption());
        this._updateButtonsVisibility();
    },
    _navigatorConfig: function() {
        return {
            text: this._view.getNavigatorCaption(),
            onClick: this._navigatorClickHandler.bind(this),
            onCaptionClick: this._navigateUp.bind(this),
            rtlEnabled: this.option("rtlEnabled")
        };
    },
    _navigatorClickHandler: function(e) {
        var currentDate = this._getDateByOffset(e.direction, this.option("currentDate"));
        this._moveToClosestAvailableDate(currentDate, 1 * e.direction);
        this._updateNavigatorCaption(-e.direction * this._getRtlCorrection());
    },
    _navigateUp: function() {
        var zoomLevel = this.option("zoomLevel");
        var nextView = $beWy7.getViewUp(zoomLevel);
        if (!nextView || this._isMinZoomLevel(zoomLevel)) return;
        var contouredDate = this._view.option("contouredDate");
        this.option("zoomLevel", nextView);
        this.option("currentDate", contouredDate || this._view.option("date"));
        this._renderNavigator();
        this._animateShowView().done((function() {
            this._setViewContoured(contouredDate);
        }).bind(this));
    },
    _isMinZoomLevel: function(zoomLevel) {
        var min = this._getMinDate();
        var max = this._getMaxDate();
        return $beWy7.sameView(zoomLevel, min, max) || this.option("minZoomLevel") === zoomLevel;
    },
    _updateButtonsVisibility: function() {
        this._navigator.toggleButton("next", !$kDRxH.isDefined(this._getRequiredView("next")));
        this._navigator.toggleButton("prev", !$kDRxH.isDefined(this._getRequiredView("prev")));
    },
    _renderSwipeable: function() {
        if (!this._swipeable) this._swipeable = this._createComponent(this.$element(), $8xeOM, {
            onStart: this._swipeStartHandler.bind(this),
            onUpdated: this._swipeUpdateHandler.bind(this),
            onEnd: this._swipeEndHandler.bind(this),
            itemSizeFunc: this._viewWidth.bind(this)
        });
    },
    _swipeStartHandler: function(e) {
        $c7ml4.stop(this._$viewsWrapper, true);
        e.event.maxLeftOffset = this._getRequiredView("next") ? 1 : 0;
        e.event.maxRightOffset = this._getRequiredView("prev") ? 1 : 0;
    },
    _getRequiredView: function(name) {
        var view;
        var isRtl = this.option("rtlEnabled");
        if ("next" === name) view = isRtl ? this._beforeView : this._afterView;
        else if ("prev" === name) view = isRtl ? this._afterView : this._beforeView;
        return view;
    },
    _swipeUpdateHandler: function(e) {
        var offset = e.event.offset;
        $6jr65.move(this._$viewsWrapper, {
            left: offset * this._viewWidth(),
            top: 0
        });
        this._updateNavigatorCaption(offset);
    },
    _swipeEndHandler: function(e) {
        var targetOffset = e.event.targetOffset;
        var moveOffset = !targetOffset ? 0 : targetOffset / Math.abs(targetOffset);
        if (0 === moveOffset) {
            this._animateWrapper(0, $470e2b2952413aca$var$ANIMATION_DURATION_SHOW_VIEW);
            return;
        }
        var date = this._getDateByOffset(-moveOffset * this._getRtlCorrection());
        if (this._isDateInInvalidRange(date)) {
            if (moveOffset >= 0) date = new Date(this._getMinDate());
            else date = new Date(this._getMaxDate());
        }
        this.option("currentDate", date);
    },
    _viewWidth: function() {
        if (!this._viewWidthValue) this._viewWidthValue = this.$element().width();
        return this._viewWidthValue;
    },
    _updateNavigatorCaption: function(offset) {
        offset *= this._getRtlCorrection();
        var view = this._view;
        if (offset > .5 && this._beforeView) view = this._beforeView;
        else if (offset < -0.5 && this._afterView) view = this._afterView;
        this._navigator.option("text", view.getNavigatorCaption());
    },
    _isDateInInvalidRange: function(date) {
        if (this._view.isBoundary(date)) return;
        var min = this._getMinDate();
        var max = this._getMaxDate();
        var normalizedDate = $beWy7.normalizeDate(date, min, max);
        return normalizedDate === min || normalizedDate === max;
    },
    _renderFooter: function() {
        var showTodayButton = this.option("showTodayButton");
        if (showTodayButton) {
            var $todayButton = this._createComponent($jFnCG("<a>"), $7KuSv, {
                focusStateEnabled: false,
                text: $cnVbh.format("dxCalendar-todayButtonText"),
                onClick: (function() {
                    this._toTodayView();
                }).bind(this),
                integrationOptions: {}
            }).$element().addClass($470e2b2952413aca$var$CALENDAR_TODAY_BUTTON_CLASS);
            this._$footer = $jFnCG("<div>").addClass($470e2b2952413aca$var$CALENDAR_FOOTER_CLASS).append($todayButton);
            this.$element().append(this._$footer);
        }
        this.$element().toggleClass($470e2b2952413aca$var$CALENDAR_HAS_FOOTER_CLASS, showTodayButton);
    },
    _renderSubmitElement: function() {
        this._$submitElement = $jFnCG("<input>").attr("type", "hidden").appendTo(this.$element());
        this._setSubmitValue(this.option("value"));
    },
    _setSubmitValue: function(value) {
        var dateValue = this._convertToDate(value);
        this._getSubmitElement().val($PdzUL.serializeDate(dateValue, $470e2b2952413aca$var$CALENDAR_INPUT_STANDARD_PATTERN));
    },
    _getSubmitElement: function() {
        return this._$submitElement;
    },
    _animateShowView: function() {
        $c7ml4.stop(this._view.$element(), true);
        return this._popAnimationView(this._view, $470e2b2952413aca$var$POP_ANIMATION_FROM, $470e2b2952413aca$var$POP_ANIMATION_TO, $470e2b2952413aca$var$ANIMATION_DURATION_SHOW_VIEW).promise();
    },
    _popAnimationView: function(view, from, to, duration) {
        return $c7ml4.animate(view.$element(), {
            type: "pop",
            from: {
                scale: from,
                opacity: from
            },
            to: {
                scale: to,
                opacity: to
            },
            duration: duration
        });
    },
    _navigate: function(offset, value) {
        if (0 !== offset && 1 !== Math.abs(offset) && this._isViewAvailable(value)) {
            var newView = this._renderSpecificView(value);
            if (offset > 0) {
                this._afterView && this._afterView.$element().remove();
                this._afterView = newView;
            } else {
                this._beforeView && this._beforeView.$element().remove();
                this._beforeView = newView;
            }
            this._translateViews();
        }
        var rtlCorrection = this._getRtlCorrection();
        var offsetSign = offset > 0 ? 1 : offset < 0 ? -1 : 0;
        var endPosition = -rtlCorrection * offsetSign * this._viewWidth();
        var viewsWrapperPosition = this._$viewsWrapper.position().left;
        if (viewsWrapperPosition !== endPosition) {
            if (this._preventViewChangeAnimation) this._wrapperAnimationEndHandler(offset, value);
            else this._animateWrapper(endPosition, $470e2b2952413aca$var$ANIMATION_DURATION_SHOW_VIEW).done(this._wrapperAnimationEndHandler.bind(this, offset, value));
        }
    },
    _animateWrapper: function(to, duration) {
        return $c7ml4.animate(this._$viewsWrapper, {
            type: "slide",
            from: {
                left: this._$viewsWrapper.position().left
            },
            to: {
                left: to
            },
            duration: duration
        });
    },
    _toTodayView: function() {
        var today = new Date;
        if (this._isMaxZoomLevel()) {
            this._dateOption("value", today);
            return;
        }
        this._preventViewChangeAnimation = true;
        this.option("zoomLevel", this.option("maxZoomLevel"));
        this._dateOption("value", today);
        this._animateShowView();
        this._preventViewChangeAnimation = false;
    },
    _wrapperAnimationEndHandler: function(offset, newDate) {
        this._rearrangeViews(offset);
        this._translateViews();
        this._resetLocation();
        this._renderNavigator();
        this._setViewContoured(newDate);
        this._updateAriaId(newDate);
    },
    _rearrangeViews: function(offset) {
        if (0 === offset) return;
        var viewOffset;
        var viewToCreateKey;
        var viewToRemoveKey;
        if (offset < 0) {
            viewOffset = 1;
            viewToCreateKey = "_beforeView";
            viewToRemoveKey = "_afterView";
        } else {
            viewOffset = -1;
            viewToCreateKey = "_afterView";
            viewToRemoveKey = "_beforeView";
        }
        if (!this[viewToCreateKey]) return;
        var destinationDate = this[viewToCreateKey].option("date");
        if (this[viewToRemoveKey]) this[viewToRemoveKey].$element().remove();
        if (offset === viewOffset) this[viewToRemoveKey] = this._view;
        else {
            this[viewToRemoveKey] = this._renderSpecificView(this._getDateByOffset(viewOffset, destinationDate));
            this._view.$element().remove();
        }
        this._view = this[viewToCreateKey];
        var dateByOffset = this._getDateByOffset(-viewOffset, destinationDate);
        this[viewToCreateKey] = this._isViewAvailable(dateByOffset) ? this._renderSpecificView(dateByOffset) : null;
    },
    _resetLocation: function() {
        $6jr65.move(this._$viewsWrapper, {
            left: 0,
            top: 0
        });
    },
    _clean: function() {
        this.callBase();
        this._clearViewWidthCache();
        delete this._$viewsWrapper;
        delete this._navigator;
        delete this._$footer;
    },
    _clearViewWidthCache: function() {
        delete this._viewWidthValue;
    },
    _disposeViews: function() {
        this._view.$element().remove();
        this._beforeView && this._beforeView.$element().remove();
        this._afterView && this._afterView.$element().remove();
        delete this._view;
        delete this._beforeView;
        delete this._afterView;
    },
    _refreshViews: function() {
        this._disposeViews();
        this._renderViews();
    },
    _visibilityChanged: function() {
        this._translateViews();
    },
    _focusInHandler: function() {
        this.callBase.apply(this, arguments);
        this._view.option("contouredDate", this.option("currentDate"));
    },
    _focusOutHandler: function() {
        this.callBase.apply(this, arguments);
        this._view.option("contouredDate", null);
    },
    _updateViewsValue: function(value) {
        var newValue = value ? new Date(value) : null;
        this._view.option("value", newValue);
        this._beforeView && this._beforeView.option("value", newValue);
        this._afterView && this._afterView.option("value", newValue);
    },
    _updateAriaSelected: function(value, previousValue) {
        value = value || this._dateOption("value");
        var $prevSelectedCell = this._view._getCellByDate(previousValue);
        var $selectedCell = this._view._getCellByDate(value);
        this.setAria("selected", void 0, $prevSelectedCell);
        this.setAria("selected", true, $selectedCell);
        if (value && this.option("currentDate").getTime() === value.getTime()) this._updateAriaId(value);
    },
    _updateAriaId: function(value) {
        value = value || this.option("currentDate");
        var ariaId = "dx-" + new $duKPB;
        var $newCell = this._view._getCellByDate(value);
        this.setAria("id", ariaId, $newCell);
        this.setAria("activedescendant", ariaId);
        this._onContouredChanged(ariaId);
    },
    _suppressingNavigation: function(callback, args) {
        this._suppressNavigation = true;
        callback.apply(this, args);
        delete this._suppressNavigation;
    },
    _optionChanged: function(args) {
        var value = args.value;
        var previousValue = args.previousValue;
        switch(args.name){
            case "width":
                this.callBase(args);
                this._clearViewWidthCache();
                break;
            case "min":
            case "max":
                this.min = void 0;
                this.max = void 0;
                this._suppressingNavigation(this._updateCurrentDate, [
                    this.option("currentDate")
                ]);
                this._refreshViews();
                this._renderNavigator();
                break;
            case "firstDayOfWeek":
                this._refreshViews();
                this._updateButtonsVisibility();
                break;
            case "currentDate":
                this.setAria("id", void 0, this._view._getCellByDate(previousValue));
                this._updateCurrentDate(value);
                break;
            case "zoomLevel":
                this.$element().removeClass($470e2b2952413aca$var$CALENDAR_VIEW_CLASS + "-" + previousValue);
                this._correctZoomLevel();
                this._refreshViews();
                this._renderNavigator();
                this._updateAriaId();
                break;
            case "minZoomLevel":
            case "maxZoomLevel":
                this._correctZoomLevel();
                this._updateButtonsVisibility();
                break;
            case "value":
                value = this._convertToDate(value);
                previousValue = this._convertToDate(previousValue);
                this._updateAriaSelected(value, previousValue);
                this.option("currentDate", $kDRxH.isDefined(value) ? new Date(value) : new Date);
                this._updateViewsValue(value);
                this._setSubmitValue(value);
                this.callBase(args);
                break;
            case "disabled":
                this._view.option("disabled", value);
                this.callBase(args);
                break;
            case "onCellClick":
                this._view.option("onCellClick", value);
                break;
            case "onContouredChanged":
                this._onContouredChanged = this._createActionByOption("onContouredChanged");
                break;
            case "disabledDates":
            case "dateSerializationFormat":
            case "cellTemplate":
            case "showTodayButton":
                this._invalidate();
                break;
            case "hasFocus":
                break;
            default:
                this.callBase(args);
        }
    }
});
$4ZFRo("dxCalendar", $470e2b2952413aca$var$Calendar);
module.exports = $470e2b2952413aca$var$Calendar;

});
parcelRegister("jFnCG", function(module, exports) {
/**
 * DevExtreme (core/renderer.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $cP5uf = parcelRequire("cP5uf");
module.exports = $cP5uf.get();

});
parcelRegister("cP5uf", function(module, exports) {
/**
 * DevExtreme (core/renderer_base.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $8ulMI = parcelRequire("8ulMI");

var $445Bz = parcelRequire("445Bz");

var $irv64 = parcelRequire("irv64");
var $955e810e43335224$var$window = $irv64.getWindow();

var $kDRxH = parcelRequire("kDRxH");

var $9Z7y9 = parcelRequire("9Z7y9");

var $5szhX = parcelRequire("5szhX");

var $8PQvD = parcelRequire("8PQvD");
var $955e810e43335224$var$renderer = function(selector, context) {
    return new $955e810e43335224$var$initRender(selector, context);
};
var $955e810e43335224$var$initRender = function(selector, context) {
    if (!selector) {
        this.length = 0;
        return this;
    }
    if ("string" === typeof selector) {
        if ("body" === selector) {
            this[0] = context ? context.body : $445Bz.getBody();
            this.length = 1;
            return this;
        }
        context = context || $445Bz.getDocument();
        if ("<" === selector[0]) {
            this[0] = $445Bz.createElement(selector.slice(1, -1), context);
            this.length = 1;
            return this;
        }
        [].push.apply(this, $445Bz.querySelectorAll(context, selector));
        return this;
    } else {
        if ($445Bz.isNode(selector) || $kDRxH.isWindow(selector)) {
            this[0] = selector;
            this.length = 1;
            return this;
        } else if (Array.isArray(selector)) {
            [].push.apply(this, selector);
            return this;
        }
    }
    return $955e810e43335224$var$renderer(selector.toArray ? selector.toArray() : [
        selector
    ]);
};
$955e810e43335224$var$renderer.fn = {
    dxRenderer: true
};
$955e810e43335224$var$initRender.prototype = $955e810e43335224$var$renderer.fn;
var $955e810e43335224$var$repeatMethod = function(methodName, args) {
    for(var i = 0; i < this.length; i++){
        var item = $955e810e43335224$var$renderer(this[i]);
        item[methodName].apply(item, args);
    }
    return this;
};
var $955e810e43335224$var$setAttributeValue = function(element, attrName, value) {
    if (void 0 !== value && null !== value) $445Bz.setAttribute(element, attrName, value);
    else $445Bz.removeAttribute(element, attrName);
};
$955e810e43335224$var$initRender.prototype.show = function() {
    return this.toggle(true);
};
$955e810e43335224$var$initRender.prototype.hide = function() {
    return this.toggle(false);
};
$955e810e43335224$var$initRender.prototype.toggle = function(value) {
    if (this[0]) this.toggleClass("dx-state-invisible", !value);
    return this;
};
$955e810e43335224$var$initRender.prototype.attr = function(attrName, value) {
    if (this.length > 1 && arguments.length > 1) return $955e810e43335224$var$repeatMethod.call(this, "attr", arguments);
    if (!this[0]) {
        if ($kDRxH.isObject(attrName) || void 0 !== value) return this;
        else return;
    }
    if (!this[0].getAttribute) return this.prop(attrName, value);
    if ("string" === typeof attrName && 1 === arguments.length) {
        var result = this[0].getAttribute(attrName);
        return null == result ? void 0 : result;
    } else {
        if ($kDRxH.isPlainObject(attrName)) for(var key in attrName)this.attr(key, attrName[key]);
        else $955e810e43335224$var$setAttributeValue(this[0], attrName, value);
    }
    return this;
};
$955e810e43335224$var$initRender.prototype.removeAttr = function(attrName) {
    this[0] && $445Bz.removeAttribute(this[0], attrName);
    return this;
};
$955e810e43335224$var$initRender.prototype.prop = function(propName, value) {
    if (!this[0]) return this;
    if ("string" === typeof propName && 1 === arguments.length) return this[0][propName];
    else {
        if ($kDRxH.isPlainObject(propName)) for(var key in propName)this.prop(key, propName[key]);
        else $445Bz.setProperty(this[0], propName, value);
    }
    return this;
};
$955e810e43335224$var$initRender.prototype.addClass = function(className) {
    return this.toggleClass(className, true);
};
$955e810e43335224$var$initRender.prototype.removeClass = function(className) {
    return this.toggleClass(className, false);
};
$955e810e43335224$var$initRender.prototype.hasClass = function(className) {
    if (!this[0] || void 0 === this[0].className) return false;
    var classNames = className.split(" ");
    for(var i = 0; i < classNames.length; i++)if (this[0].classList) {
        if (this[0].classList.contains(classNames[i])) return true;
    } else {
        var _className = $kDRxH.isString(this[0].className) ? this[0].className : $445Bz.getAttribute(this[0], "class");
        if ((_className || "").split(" ").indexOf(classNames[i]) >= 0) return true;
    }
    return false;
};
$955e810e43335224$var$initRender.prototype.toggleClass = function(className, value) {
    if (this.length > 1) return $955e810e43335224$var$repeatMethod.call(this, "toggleClass", arguments);
    if (!this[0] || !className) return this;
    value = void 0 === value ? !this.hasClass(className) : value;
    var classNames = className.split(" ");
    for(var i = 0; i < classNames.length; i++)$445Bz.setClass(this[0], classNames[i], value);
    return this;
};
[
    "width",
    "height",
    "outerWidth",
    "outerHeight",
    "innerWidth",
    "innerHeight"
].forEach(function(methodName) {
    var partialName = methodName.toLowerCase().indexOf("width") >= 0 ? "Width" : "Height";
    var propName = partialName.toLowerCase();
    var isOuter = 0 === methodName.indexOf("outer");
    var isInner = 0 === methodName.indexOf("inner");
    $955e810e43335224$var$initRender.prototype[methodName] = function(value) {
        if (this.length > 1 && arguments.length > 0) return $955e810e43335224$var$repeatMethod.call(this, methodName, arguments);
        var element = this[0];
        if (!element) return;
        if ($kDRxH.isWindow(element)) return isOuter ? element["inner" + partialName] : $445Bz.getDocumentElement()["client" + partialName];
        if ($445Bz.isDocument(element)) {
            var documentElement = $445Bz.getDocumentElement();
            var body = $445Bz.getBody();
            return Math.max(body["scroll" + partialName], body["offset" + partialName], documentElement["scroll" + partialName], documentElement["offset" + partialName], documentElement["client" + partialName]);
        }
        if (0 === arguments.length || "boolean" === typeof value) {
            var include = {
                paddings: isInner || isOuter,
                borders: isOuter,
                margins: value
            };
            return $5szhX.getSize(element, propName, include);
        }
        if (void 0 === value || null === value) return this;
        if ($kDRxH.isNumeric(value)) {
            var elementStyles = $955e810e43335224$var$window.getComputedStyle(element);
            var sizeAdjustment = $5szhX.getElementBoxParams(propName, elementStyles);
            var isBorderBox = "border-box" === elementStyles.boxSizing;
            value = Number(value);
            if (isOuter) value -= isBorderBox ? 0 : sizeAdjustment.border + sizeAdjustment.padding;
            else {
                if (isInner) value += isBorderBox ? sizeAdjustment.border : -sizeAdjustment.padding;
                else if (isBorderBox) value += sizeAdjustment.border + sizeAdjustment.padding;
            }
        }
        value += $kDRxH.isNumeric(value) ? "px" : "";
        $445Bz.setStyle(element, propName, value);
        return this;
    };
});
$955e810e43335224$var$initRender.prototype.html = function(value) {
    if (!arguments.length) return this[0].innerHTML;
    this.empty();
    if ("string" === typeof value && !$8PQvD.isTablePart(value) || "number" === typeof value) {
        this[0].innerHTML = value;
        return this;
    }
    return this.append($8PQvD.parseHTML(value));
};
var $955e810e43335224$var$appendElements = function(element, nextSibling) {
    if (!this[0] || !element) return;
    if ("string" === typeof element) element = $8PQvD.parseHTML(element);
    else {
        if (element.nodeType) element = [
            element
        ];
        else if ($kDRxH.isNumeric(element)) element = [
            $445Bz.createTextNode(element)
        ];
    }
    for(var i = 0; i < element.length; i++){
        var item = element[i];
        var container = this[0];
        var wrapTR = "TABLE" === container.tagName && "TR" === item.tagName;
        if (wrapTR && container.tBodies && container.tBodies.length) container = container.tBodies[0];
        $445Bz.insertElement(container, item.nodeType ? item : item[0], nextSibling);
    }
};
var $955e810e43335224$var$setCss = function(name, value) {
    if (!this[0] || !this[0].style) return;
    if (null === value || "number" === typeof value && isNaN(value)) return;
    name = $9Z7y9.styleProp(name);
    for(var i = 0; i < this.length; i++)this[i].style[name] = $9Z7y9.normalizeStyleProp(name, value);
};
$955e810e43335224$var$initRender.prototype.css = function(name, value) {
    if ($kDRxH.isString(name)) {
        if (2 === arguments.length) $955e810e43335224$var$setCss.call(this, name, value);
        else {
            if (!this[0]) return;
            name = $9Z7y9.styleProp(name);
            var result = $955e810e43335224$var$window.getComputedStyle(this[0])[name] || this[0].style[name];
            return $kDRxH.isNumeric(result) ? result.toString() : result;
        }
    } else {
        if ($kDRxH.isPlainObject(name)) for(var key in name)$955e810e43335224$var$setCss.call(this, key, name[key]);
    }
    return this;
};
$955e810e43335224$var$initRender.prototype.prepend = function(element) {
    if (arguments.length > 1) {
        for(var i = 0; i < arguments.length; i++)this.prepend(arguments[i]);
        return this;
    }
    $955e810e43335224$var$appendElements.apply(this, [
        element,
        this[0].firstChild
    ]);
    return this;
};
$955e810e43335224$var$initRender.prototype.append = function(element) {
    if (arguments.length > 1) {
        for(var i = 0; i < arguments.length; i++)this.append(arguments[i]);
        return this;
    }
    $955e810e43335224$var$appendElements.apply(this, [
        element
    ]);
    return this;
};
$955e810e43335224$var$initRender.prototype.prependTo = function(element) {
    if (this.length > 1) {
        for(var i = this.length - 1; i >= 0; i--)$955e810e43335224$var$renderer(this[i]).prependTo(element);
        return this;
    }
    element = $955e810e43335224$var$renderer(element);
    if (element[0]) $445Bz.insertElement(element[0], this[0], element[0].firstChild);
    return this;
};
$955e810e43335224$var$initRender.prototype.appendTo = function(element) {
    if (this.length > 1) return $955e810e43335224$var$repeatMethod.call(this, "appendTo", arguments);
    $445Bz.insertElement($955e810e43335224$var$renderer(element)[0], this[0]);
    return this;
};
$955e810e43335224$var$initRender.prototype.insertBefore = function(element) {
    if (element && element[0]) $445Bz.insertElement(element[0].parentNode, this[0], element[0]);
    return this;
};
$955e810e43335224$var$initRender.prototype.insertAfter = function(element) {
    if (element && element[0]) $445Bz.insertElement(element[0].parentNode, this[0], element[0].nextSibling);
    return this;
};
$955e810e43335224$var$initRender.prototype.before = function(element) {
    if (this[0]) $445Bz.insertElement(this[0].parentNode, element[0], this[0]);
    return this;
};
$955e810e43335224$var$initRender.prototype.after = function(element) {
    if (this[0]) $445Bz.insertElement(this[0].parentNode, element[0], this[0].nextSibling);
    return this;
};
$955e810e43335224$var$initRender.prototype.wrap = function(wrapper) {
    if (this[0]) {
        var wrap = $955e810e43335224$var$renderer(wrapper);
        wrap.insertBefore(this);
        wrap.append(this);
    }
    return this;
};
$955e810e43335224$var$initRender.prototype.wrapInner = function(wrapper) {
    var contents = this.contents();
    if (contents.length) contents.wrap(wrapper);
    else this.append(wrapper);
    return this;
};
$955e810e43335224$var$initRender.prototype.replaceWith = function(element) {
    if (!(element && element[0])) return;
    if (element.is(this)) return this;
    element.insertBefore(this);
    this.remove();
    return element;
};
$955e810e43335224$var$initRender.prototype.remove = function() {
    if (this.length > 1) return $955e810e43335224$var$repeatMethod.call(this, "remove", arguments);
    $8ulMI.cleanDataRecursive(this[0], true);
    $445Bz.removeElement(this[0]);
    return this;
};
$955e810e43335224$var$initRender.prototype.detach = function() {
    if (this.length > 1) return $955e810e43335224$var$repeatMethod.call(this, "detach", arguments);
    $445Bz.removeElement(this[0]);
    return this;
};
$955e810e43335224$var$initRender.prototype.empty = function() {
    if (this.length > 1) return $955e810e43335224$var$repeatMethod.call(this, "empty", arguments);
    $8ulMI.cleanDataRecursive(this[0]);
    $445Bz.setText(this[0], "");
    return this;
};
$955e810e43335224$var$initRender.prototype.clone = function() {
    var result = [];
    for(var i = 0; i < this.length; i++)result.push(this[i].cloneNode(true));
    return $955e810e43335224$var$renderer(result);
};
$955e810e43335224$var$initRender.prototype.text = function(value) {
    if (!arguments.length) {
        var result = "";
        for(var i = 0; i < this.length; i++)result += this[i] && this[i].textContent || "";
        return result;
    }
    var text = $kDRxH.isFunction(value) ? value() : value;
    $8ulMI.cleanDataRecursive(this[0], false);
    $445Bz.setText(this[0], $kDRxH.isDefined(text) ? text : "");
    return this;
};
$955e810e43335224$var$initRender.prototype.val = function(value) {
    if (1 === arguments.length) return this.prop("value", $kDRxH.isDefined(value) ? value : "");
    return this.prop("value");
};
$955e810e43335224$var$initRender.prototype.contents = function() {
    if (!this[0]) return $955e810e43335224$var$renderer();
    var result = [];
    result.push.apply(result, this[0].childNodes);
    return $955e810e43335224$var$renderer(result);
};
$955e810e43335224$var$initRender.prototype.find = function(selector) {
    var result = $955e810e43335224$var$renderer();
    if (!selector) return result;
    var nodes = [];
    var i;
    if ("string" === typeof selector) {
        selector = selector.trim();
        for(i = 0; i < this.length; i++){
            var element = this[i];
            if ($445Bz.isElementNode(element)) {
                var elementId = element.getAttribute("id");
                var queryId = elementId || "dx-query-children";
                if (!elementId) $955e810e43335224$var$setAttributeValue(element, "id", queryId);
                queryId = "[id='" + queryId + "'] ";
                var querySelector = queryId + selector.replace(/([^\\])(,)/g, "$1, " + queryId);
                nodes.push.apply(nodes, $445Bz.querySelectorAll(element, querySelector));
                $955e810e43335224$var$setAttributeValue(element, "id", elementId);
            } else if ($445Bz.isDocument(element)) nodes.push.apply(nodes, $445Bz.querySelectorAll(element, selector));
        }
    } else for(i = 0; i < this.length; i++){
        selector = $445Bz.isNode(selector) ? selector : selector[0];
        if (this[i] !== selector && this[i].contains(selector)) nodes.push(selector);
    }
    return result.add(nodes);
};
var $955e810e43335224$var$isVisible = function(_, element) {
    if (!element.nodeType) return true;
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
};
$955e810e43335224$var$initRender.prototype.filter = function(selector) {
    if (!selector) return $955e810e43335224$var$renderer();
    if (":visible" === selector) return this.filter($955e810e43335224$var$isVisible);
    else {
        if (":hidden" === selector) return this.filter(function(_, element) {
            return !$955e810e43335224$var$isVisible(_, element);
        });
    }
    var result = [];
    for(var i = 0; i < this.length; i++){
        var item = this[i];
        if ($445Bz.isElementNode(item) && "string" === $kDRxH.type(selector)) $445Bz.elementMatches(item, selector) && result.push(item);
        else if ($445Bz.isNode(selector) || $kDRxH.isWindow(selector)) selector === item && result.push(item);
        else {
            if ($kDRxH.isFunction(selector)) selector.call(item, i, item) && result.push(item);
            else for(var j = 0; j < selector.length; j++)selector[j] === item && result.push(item);
        }
    }
    return $955e810e43335224$var$renderer(result);
};
$955e810e43335224$var$initRender.prototype.not = function(selector) {
    var result = [];
    var nodes = this.filter(selector).toArray();
    for(var i = 0; i < this.length; i++)if (nodes.indexOf(this[i]) === -1) result.push(this[i]);
    return $955e810e43335224$var$renderer(result);
};
$955e810e43335224$var$initRender.prototype.is = function(selector) {
    return !!this.filter(selector).length;
};
$955e810e43335224$var$initRender.prototype.children = function(selector) {
    var result = [];
    for(var i = 0; i < this.length; i++){
        var nodes = this[i] ? this[i].childNodes : [];
        for(var j = 0; j < nodes.length; j++)if ($445Bz.isElementNode(nodes[j])) result.push(nodes[j]);
    }
    result = $955e810e43335224$var$renderer(result);
    return selector ? result.filter(selector) : result;
};
$955e810e43335224$var$initRender.prototype.siblings = function() {
    var element = this[0];
    if (!element || !element.parentNode) return $955e810e43335224$var$renderer();
    var result = [];
    var parentChildNodes = element.parentNode.childNodes || [];
    for(var i = 0; i < parentChildNodes.length; i++){
        var node = parentChildNodes[i];
        if ($445Bz.isElementNode(node) && node !== element) result.push(node);
    }
    return $955e810e43335224$var$renderer(result);
};
$955e810e43335224$var$initRender.prototype.each = function(callback) {
    for(var i = 0; i < this.length; i++){
        if (false === callback.call(this[i], i, this[i])) break;
    }
};
$955e810e43335224$var$initRender.prototype.index = function(element) {
    if (!element) return this.parent().children().index(this);
    element = $955e810e43335224$var$renderer(element);
    return this.toArray().indexOf(element[0]);
};
$955e810e43335224$var$initRender.prototype.get = function(index) {
    return this[index < 0 ? this.length + index : index];
};
$955e810e43335224$var$initRender.prototype.eq = function(index) {
    index = index < 0 ? this.length + index : index;
    return $955e810e43335224$var$renderer(this[index]);
};
$955e810e43335224$var$initRender.prototype.first = function() {
    return this.eq(0);
};
$955e810e43335224$var$initRender.prototype.last = function() {
    return this.eq(-1);
};
$955e810e43335224$var$initRender.prototype.parent = function(selector) {
    if (!this[0]) return $955e810e43335224$var$renderer();
    var result = $955e810e43335224$var$renderer(this[0].parentNode);
    return !selector || result.is(selector) ? result : $955e810e43335224$var$renderer();
};
$955e810e43335224$var$initRender.prototype.parents = function(selector) {
    var result = [];
    var parent = this.parent();
    while(parent && parent[0] && !$445Bz.isDocument(parent[0])){
        if ($445Bz.isElementNode(parent[0])) {
            if (!selector || selector && parent.is(selector)) result.push(parent.get(0));
        }
        parent = parent.parent();
    }
    return $955e810e43335224$var$renderer(result);
};
$955e810e43335224$var$initRender.prototype.closest = function(selector) {
    if (this.is(selector)) return this;
    var parent = this.parent();
    while(parent && parent.length){
        if (parent.is(selector)) return parent;
        parent = parent.parent();
    }
    return $955e810e43335224$var$renderer();
};
$955e810e43335224$var$initRender.prototype.next = function(selector) {
    if (!this[0]) return $955e810e43335224$var$renderer();
    var next = $955e810e43335224$var$renderer(this[0].nextSibling);
    if (!arguments.length) return next;
    while(next && next.length){
        if (next.is(selector)) return next;
        next = next.next();
    }
    return $955e810e43335224$var$renderer();
};
$955e810e43335224$var$initRender.prototype.prev = function() {
    if (!this[0]) return $955e810e43335224$var$renderer();
    return $955e810e43335224$var$renderer(this[0].previousSibling);
};
$955e810e43335224$var$initRender.prototype.add = function(selector) {
    var targets = $955e810e43335224$var$renderer(selector);
    var result = this.toArray();
    for(var i = 0; i < targets.length; i++){
        var target = targets[i];
        if (result.indexOf(target) === -1) result.push(target);
    }
    return $955e810e43335224$var$renderer(result);
};
var $955e810e43335224$var$emptyArray = [];
$955e810e43335224$var$initRender.prototype.splice = function() {
    return $955e810e43335224$var$renderer($955e810e43335224$var$emptyArray.splice.apply(this, arguments));
};
$955e810e43335224$var$initRender.prototype.slice = function() {
    return $955e810e43335224$var$renderer($955e810e43335224$var$emptyArray.slice.apply(this, arguments));
};
$955e810e43335224$var$initRender.prototype.toArray = function() {
    return $955e810e43335224$var$emptyArray.slice.call(this);
};
var $955e810e43335224$var$getWindowByElement = function(element) {
    return $kDRxH.isWindow(element) ? element : element.defaultView;
};
$955e810e43335224$var$initRender.prototype.offset = function() {
    if (!this[0]) return;
    if (!this[0].getClientRects().length) return {
        top: 0,
        left: 0
    };
    var rect = this[0].getBoundingClientRect();
    var win = $955e810e43335224$var$getWindowByElement(this[0].ownerDocument);
    var docElem = this[0].ownerDocument.documentElement;
    return {
        top: rect.top + win.pageYOffset - docElem.clientTop,
        left: rect.left + win.pageXOffset - docElem.clientLeft
    };
};
$955e810e43335224$var$initRender.prototype.offsetParent = function() {
    if (!this[0]) return $955e810e43335224$var$renderer();
    var offsetParent = $955e810e43335224$var$renderer(this[0].offsetParent);
    while(offsetParent[0] && "static" === offsetParent.css("position"))offsetParent = $955e810e43335224$var$renderer(offsetParent[0].offsetParent);
    offsetParent = offsetParent[0] ? offsetParent : $955e810e43335224$var$renderer($445Bz.getDocumentElement());
    return offsetParent;
};
$955e810e43335224$var$initRender.prototype.position = function() {
    if (!this[0]) return;
    var offset;
    var marginTop = parseFloat(this.css("marginTop"));
    var marginLeft = parseFloat(this.css("marginLeft"));
    if ("fixed" === this.css("position")) {
        offset = this[0].getBoundingClientRect();
        return {
            top: offset.top - marginTop,
            left: offset.left - marginLeft
        };
    }
    offset = this.offset();
    var offsetParent = this.offsetParent();
    var parentOffset = {
        top: 0,
        left: 0
    };
    if ("HTML" !== offsetParent[0].nodeName) parentOffset = offsetParent.offset();
    parentOffset = {
        top: parentOffset.top + parseFloat(offsetParent.css("borderTopWidth")),
        left: parentOffset.left + parseFloat(offsetParent.css("borderLeftWidth"))
    };
    return {
        top: offset.top - parentOffset.top - marginTop,
        left: offset.left - parentOffset.left - marginLeft
    };
};
[
    {
        name: "scrollLeft",
        offsetProp: "pageXOffset",
        scrollWindow: function(win, value) {
            win.scrollTo(value, win.pageYOffset);
        }
    },
    {
        name: "scrollTop",
        offsetProp: "pageYOffset",
        scrollWindow: function(win, value) {
            win.scrollTo(win.pageXOffset, value);
        }
    }
].forEach(function(directionStrategy) {
    var propName = directionStrategy.name;
    $955e810e43335224$var$initRender.prototype[propName] = function(value) {
        if (!this[0]) return;
        var window = $955e810e43335224$var$getWindowByElement(this[0]);
        if (void 0 === value) return window ? window[directionStrategy.offsetProp] : this[0][propName];
        if (window) directionStrategy.scrollWindow(window, value);
        else this[0][propName] = value;
        return this;
    };
});
$955e810e43335224$var$initRender.prototype.data = function(key, value) {
    if (!this[0]) return;
    if (arguments.length < 2) return $8ulMI.data.call($955e810e43335224$var$renderer, this[0], key);
    $8ulMI.data.call($955e810e43335224$var$renderer, this[0], key, value);
    return this;
};
$955e810e43335224$var$initRender.prototype.removeData = function(key) {
    this[0] && $8ulMI.removeData(this[0], key);
    return this;
};
var $955e810e43335224$var$rendererWrapper = function() {
    return $955e810e43335224$var$renderer.apply(this, arguments);
};
Object.defineProperty($955e810e43335224$var$rendererWrapper, "fn", {
    enumerable: true,
    configurable: true,
    get: function() {
        return $955e810e43335224$var$renderer.fn;
    },
    set: function(value) {
        $955e810e43335224$var$renderer.fn = value;
    }
});
module.exports = {
    set: function(strategy) {
        $955e810e43335224$var$renderer = strategy;
    },
    get: function() {
        return $955e810e43335224$var$rendererWrapper;
    }
};

});
parcelRegister("8ulMI", function(module, exports) {

$parcel$export(module.exports, "setDataStrategy", () => $62e2061466b1008c$export$19ac0b14569bcaea, (v) => $62e2061466b1008c$export$19ac0b14569bcaea = v);
$parcel$export(module.exports, "getDataStrategy", () => $62e2061466b1008c$export$da68e08875c2ed1d, (v) => $62e2061466b1008c$export$da68e08875c2ed1d = v);
$parcel$export(module.exports, "data", () => $62e2061466b1008c$export$4051a07651545597, (v) => $62e2061466b1008c$export$4051a07651545597 = v);
$parcel$export(module.exports, "strategyChanging", () => $62e2061466b1008c$export$e0ed1cba125eba32, (v) => $62e2061466b1008c$export$e0ed1cba125eba32 = v);
$parcel$export(module.exports, "beforeCleanData", () => $62e2061466b1008c$export$e3a86a7b5668951d, (v) => $62e2061466b1008c$export$e3a86a7b5668951d = v);
$parcel$export(module.exports, "afterCleanData", () => $62e2061466b1008c$export$f846ad5ef0792b38, (v) => $62e2061466b1008c$export$f846ad5ef0792b38 = v);
$parcel$export(module.exports, "cleanData", () => $62e2061466b1008c$export$a9069348538b0415, (v) => $62e2061466b1008c$export$a9069348538b0415 = v);
$parcel$export(module.exports, "removeData", () => $62e2061466b1008c$export$33f1b464f736cf21, (v) => $62e2061466b1008c$export$33f1b464f736cf21 = v);
$parcel$export(module.exports, "cleanDataRecursive", () => $62e2061466b1008c$export$767bfdaeab3dae01, (v) => $62e2061466b1008c$export$767bfdaeab3dae01 = v);
/**
 * DevExtreme (core/element_data.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $62e2061466b1008c$export$19ac0b14569bcaea;
var $62e2061466b1008c$export$da68e08875c2ed1d;
var $62e2061466b1008c$export$4051a07651545597;
var $62e2061466b1008c$export$e0ed1cba125eba32;
var $62e2061466b1008c$export$e3a86a7b5668951d;
var $62e2061466b1008c$export$f846ad5ef0792b38;
var $62e2061466b1008c$export$a9069348538b0415;
var $62e2061466b1008c$export$33f1b464f736cf21;
var $62e2061466b1008c$export$767bfdaeab3dae01;
"use strict";

var $5ySaA = parcelRequire("5ySaA");

var $445Bz = parcelRequire("445Bz");

var $e1LMc = parcelRequire("e1LMc");

var $2vY9D = parcelRequire("2vY9D");
var $62e2061466b1008c$var$dataMap = new $5ySaA;
var $62e2061466b1008c$var$strategy;
var $62e2061466b1008c$var$strategyChanging = new $2vY9D;
var $62e2061466b1008c$var$beforeCleanData = function() {};
var $62e2061466b1008c$var$afterCleanData = function() {};
var $62e2061466b1008c$var$setDataStrategy = $62e2061466b1008c$export$19ac0b14569bcaea = function(value) {
    $62e2061466b1008c$var$strategyChanging.fire(value);
    $62e2061466b1008c$var$strategy = value;
    var cleanData = $62e2061466b1008c$var$strategy.cleanData;
    $62e2061466b1008c$var$strategy.cleanData = function(nodes) {
        $62e2061466b1008c$var$beforeCleanData(nodes);
        var result = cleanData.call(this, nodes);
        $62e2061466b1008c$var$afterCleanData(nodes);
        return result;
    };
};
$62e2061466b1008c$var$setDataStrategy({
    data: function() {
        var element = arguments[0];
        var key = arguments[1];
        var value = arguments[2];
        if (!element) return;
        var elementData = $62e2061466b1008c$var$dataMap.get(element);
        if (!elementData) {
            elementData = {};
            $62e2061466b1008c$var$dataMap.set(element, elementData);
        }
        if (void 0 === key) return elementData;
        if (2 === arguments.length) return elementData[key];
        elementData[key] = value;
        return value;
    },
    removeData: function(element, key) {
        if (!element) return;
        if (void 0 === key) $62e2061466b1008c$var$dataMap.delete(element);
        else {
            var elementData = $62e2061466b1008c$var$dataMap.get(element);
            if (elementData) delete elementData[key];
        }
    },
    cleanData: function(elements) {
        for(var i = 0; i < elements.length; i++){
            $e1LMc.off(elements[i]);
            $62e2061466b1008c$var$dataMap.delete(elements[i]);
        }
    }
});
$62e2061466b1008c$export$19ac0b14569bcaea = $62e2061466b1008c$var$setDataStrategy;
$62e2061466b1008c$export$da68e08875c2ed1d = function() {
    return $62e2061466b1008c$var$strategy;
};
$62e2061466b1008c$export$4051a07651545597 = function() {
    return $62e2061466b1008c$var$strategy.data.apply(this, arguments);
};
$62e2061466b1008c$export$e0ed1cba125eba32 = $62e2061466b1008c$var$strategyChanging;
$62e2061466b1008c$export$e3a86a7b5668951d = function(callback) {
    $62e2061466b1008c$var$beforeCleanData = callback;
};
$62e2061466b1008c$export$f846ad5ef0792b38 = function(callback) {
    $62e2061466b1008c$var$afterCleanData = callback;
};
$62e2061466b1008c$export$a9069348538b0415 = function(nodes) {
    return $62e2061466b1008c$var$strategy.cleanData.call(this, nodes);
};
$62e2061466b1008c$export$33f1b464f736cf21 = function(element, key) {
    return $62e2061466b1008c$var$strategy.removeData.call(this, element, key);
};
$62e2061466b1008c$export$767bfdaeab3dae01 = function(element, cleanSelf) {
    if (!$445Bz.isElementNode(element)) return;
    var childElements = element.getElementsByTagName("*");
    $62e2061466b1008c$var$strategy.cleanData(childElements);
    if (cleanSelf) $62e2061466b1008c$var$strategy.cleanData([
        element
    ]);
};

});
parcelRegister("5ySaA", function(module, exports) {
/**
 * DevExtreme (core/polyfills/weak_map.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $aLQK5 = parcelRequire("aLQK5");
var $40ca25ba2f22c3e5$require$inArray = $aLQK5.inArray;

var $irv64 = parcelRequire("irv64");
var $40ca25ba2f22c3e5$var$weakMap = $irv64.hasWindow() ? $irv64.getWindow().WeakMap : WeakMap;
if (!$40ca25ba2f22c3e5$var$weakMap) $40ca25ba2f22c3e5$var$weakMap = function() {
    var keys = [];
    var values = [];
    this.set = function(key, value) {
        var index = $40ca25ba2f22c3e5$require$inArray(key, keys);
        if (index === -1) {
            keys.push(key);
            values.push(value);
        } else values[index] = value;
    };
    this.get = function(key) {
        var index = $40ca25ba2f22c3e5$require$inArray(key, keys);
        if (index === -1) return;
        return values[index];
    };
    this.has = function(key) {
        var index = $40ca25ba2f22c3e5$require$inArray(key, keys);
        if (index === -1) return false;
        return true;
    };
    this.delete = function(key) {
        var index = $40ca25ba2f22c3e5$require$inArray(key, keys);
        if (index === -1) return;
        keys.splice(index, 1);
        values.splice(index, 1);
    };
};
module.exports = $40ca25ba2f22c3e5$var$weakMap;

});
parcelRegister("aLQK5", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $7d7734b5db088a44$export$dd1bc94b04021eeb, (v) => $7d7734b5db088a44$export$dd1bc94b04021eeb = v);
$parcel$export(module.exports, "wrapToArray", () => $7d7734b5db088a44$export$210ae1b469bb1ff9, (v) => $7d7734b5db088a44$export$210ae1b469bb1ff9 = v);
$parcel$export(module.exports, "inArray", () => $7d7734b5db088a44$export$6632823c2c02cb2c, (v) => $7d7734b5db088a44$export$6632823c2c02cb2c = v);
$parcel$export(module.exports, "merge", () => $7d7734b5db088a44$export$4950aa0f605343fb, (v) => $7d7734b5db088a44$export$4950aa0f605343fb = v);
$parcel$export(module.exports, "find", () => $7d7734b5db088a44$export$71aa6c912b956294, (v) => $7d7734b5db088a44$export$71aa6c912b956294 = v);
/**
 * DevExtreme (core/utils/array.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $7d7734b5db088a44$export$dd1bc94b04021eeb;
var $7d7734b5db088a44$export$210ae1b469bb1ff9;
var $7d7734b5db088a44$export$bc86dfbf7795668c;
var $7d7734b5db088a44$export$2e2262a44ac61957;
var $7d7734b5db088a44$export$e9607c52c6889017;
var $7d7734b5db088a44$export$6632823c2c02cb2c;
var $7d7734b5db088a44$export$4950aa0f605343fb;
var $7d7734b5db088a44$export$71aa6c912b956294;
"use strict";

var $kDRxH = parcelRequire("kDRxH");
var $7d7734b5db088a44$require$isDefined = $kDRxH.isDefined;

var $4Pwuy = parcelRequire("4Pwuy");
var $7d7734b5db088a44$require$each = $4Pwuy.each;

var $6l2Qk = parcelRequire("6l2Qk");

var $1JvXr = parcelRequire("1JvXr");
var $7d7734b5db088a44$var$isEmpty = function(entity) {
    return Array.isArray(entity) && !entity.length;
};
var $7d7734b5db088a44$var$wrapToArray = function(entity) {
    return Array.isArray(entity) ? entity : [
        entity
    ];
};
var $7d7734b5db088a44$var$intersection = function(a, b) {
    if (!Array.isArray(a) || 0 === a.length || !Array.isArray(b) || 0 === b.length) return [];
    var result = [];
    $7d7734b5db088a44$require$each(a, function(_, value) {
        var index = $7d7734b5db088a44$var$inArray(value, b);
        if (index !== -1) result.push(value);
    });
    return result;
};
var $7d7734b5db088a44$var$removeDuplicates = function(from, what) {
    if (!Array.isArray(from) || 0 === from.length) return [];
    if (!Array.isArray(what) || 0 === what.length) return from.slice();
    var result = [];
    $7d7734b5db088a44$require$each(from, function(_, value) {
        var index = $7d7734b5db088a44$var$inArray(value, what);
        if (index === -1) result.push(value);
    });
    return result;
};
var $7d7734b5db088a44$var$normalizeIndexes = function(items, indexParameterName, currentItem, needIndexCallback) {
    var indexedItems = {};
    var parameterIndex = 0;
    var useLegacyVisibleIndex = $1JvXr().useLegacyVisibleIndex;
    $7d7734b5db088a44$require$each(items, function(index, item) {
        index = item[indexParameterName];
        if (index >= 0) {
            indexedItems[index] = indexedItems[index] || [];
            if (item === currentItem) indexedItems[index].unshift(item);
            else indexedItems[index].push(item);
        } else item[indexParameterName] = void 0;
    });
    if (!useLegacyVisibleIndex) $7d7734b5db088a44$require$each(items, function() {
        if (!$7d7734b5db088a44$require$isDefined(this[indexParameterName]) && (!needIndexCallback || needIndexCallback(this))) {
            while(indexedItems[parameterIndex])parameterIndex++;
            indexedItems[parameterIndex] = [
                this
            ];
            parameterIndex++;
        }
    });
    parameterIndex = 0;
    $6l2Qk.orderEach(indexedItems, function(index, items) {
        $7d7734b5db088a44$require$each(items, function() {
            if (index >= 0) this[indexParameterName] = parameterIndex++;
        });
    });
    if (useLegacyVisibleIndex) $7d7734b5db088a44$require$each(items, function() {
        if (!$7d7734b5db088a44$require$isDefined(this[indexParameterName]) && (!needIndexCallback || needIndexCallback(this))) this[indexParameterName] = parameterIndex++;
    });
    return parameterIndex;
};
var $7d7734b5db088a44$var$inArray = function(value, object) {
    if (!object) return -1;
    var array = Array.isArray(object) ? object : object.toArray();
    return array.indexOf(value);
};
var $7d7734b5db088a44$var$merge = function(array1, array2) {
    for(var i = 0; i < array2.length; i++)array1[array1.length] = array2[i];
    return array1;
};
var $7d7734b5db088a44$var$find = function(array, condition) {
    for(var i = 0; i < array.length; i++){
        if (condition(array[i])) return array[i];
    }
};
$7d7734b5db088a44$export$dd1bc94b04021eeb = $7d7734b5db088a44$var$isEmpty;
$7d7734b5db088a44$export$210ae1b469bb1ff9 = $7d7734b5db088a44$var$wrapToArray;
$7d7734b5db088a44$export$bc86dfbf7795668c = $7d7734b5db088a44$var$intersection;
$7d7734b5db088a44$export$2e2262a44ac61957 = $7d7734b5db088a44$var$removeDuplicates;
$7d7734b5db088a44$export$e9607c52c6889017 = $7d7734b5db088a44$var$normalizeIndexes;
$7d7734b5db088a44$export$6632823c2c02cb2c = $7d7734b5db088a44$var$inArray;
$7d7734b5db088a44$export$4950aa0f605343fb = $7d7734b5db088a44$var$merge;
$7d7734b5db088a44$export$71aa6c912b956294 = $7d7734b5db088a44$var$find;

});
parcelRegister("kDRxH", function(module, exports) {

$parcel$export(module.exports, "isBoolean", () => $f070fb9adece1ed4$export$f9ce7b637dfbe238, (v) => $f070fb9adece1ed4$export$f9ce7b637dfbe238 = v);
$parcel$export(module.exports, "isExponential", () => $f070fb9adece1ed4$export$cf027eaeece0ea06, (v) => $f070fb9adece1ed4$export$cf027eaeece0ea06 = v);
$parcel$export(module.exports, "isDate", () => $f070fb9adece1ed4$export$871608497c498473, (v) => $f070fb9adece1ed4$export$871608497c498473 = v);
$parcel$export(module.exports, "isDefined", () => $f070fb9adece1ed4$export$4e62c701997796c1, (v) => $f070fb9adece1ed4$export$4e62c701997796c1 = v);
$parcel$export(module.exports, "isFunction", () => $f070fb9adece1ed4$export$f6e2535fb5126e54, (v) => $f070fb9adece1ed4$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isString", () => $f070fb9adece1ed4$export$844ec244b1367d54, (v) => $f070fb9adece1ed4$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "isNumeric", () => $f070fb9adece1ed4$export$e90fb89750dba83f, (v) => $f070fb9adece1ed4$export$e90fb89750dba83f = v);
$parcel$export(module.exports, "isObject", () => $f070fb9adece1ed4$export$a6cdc56e425d0d0a, (v) => $f070fb9adece1ed4$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "isEmptyObject", () => $f070fb9adece1ed4$export$83b788b1a3698c03, (v) => $f070fb9adece1ed4$export$83b788b1a3698c03 = v);
$parcel$export(module.exports, "isPlainObject", () => $f070fb9adece1ed4$export$53b83ca8eaab0383, (v) => $f070fb9adece1ed4$export$53b83ca8eaab0383 = v);
$parcel$export(module.exports, "isPrimitive", () => $f070fb9adece1ed4$export$c3825b437cbdea5c, (v) => $f070fb9adece1ed4$export$c3825b437cbdea5c = v);
$parcel$export(module.exports, "isWindow", () => $f070fb9adece1ed4$export$5a096129d439f843, (v) => $f070fb9adece1ed4$export$5a096129d439f843 = v);
$parcel$export(module.exports, "isRenderer", () => $f070fb9adece1ed4$export$e7e5fb26b3a31a43, (v) => $f070fb9adece1ed4$export$e7e5fb26b3a31a43 = v);
$parcel$export(module.exports, "isPromise", () => $f070fb9adece1ed4$export$4369c812aac99591, (v) => $f070fb9adece1ed4$export$4369c812aac99591 = v);
$parcel$export(module.exports, "isDeferred", () => $f070fb9adece1ed4$export$2af51d8f0fd79769, (v) => $f070fb9adece1ed4$export$2af51d8f0fd79769 = v);
$parcel$export(module.exports, "type", () => $f070fb9adece1ed4$export$bf9fb029d174d554, (v) => $f070fb9adece1ed4$export$bf9fb029d174d554 = v);
/**
 * DevExtreme (core/utils/type.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $f070fb9adece1ed4$export$f9ce7b637dfbe238;
var $f070fb9adece1ed4$export$cf027eaeece0ea06;
var $f070fb9adece1ed4$export$871608497c498473;
var $f070fb9adece1ed4$export$4e62c701997796c1;
var $f070fb9adece1ed4$export$f6e2535fb5126e54;
var $f070fb9adece1ed4$export$844ec244b1367d54;
var $f070fb9adece1ed4$export$e90fb89750dba83f;
var $f070fb9adece1ed4$export$a6cdc56e425d0d0a;
var $f070fb9adece1ed4$export$83b788b1a3698c03;
var $f070fb9adece1ed4$export$53b83ca8eaab0383;
var $f070fb9adece1ed4$export$c3825b437cbdea5c;
var $f070fb9adece1ed4$export$5a096129d439f843;
var $f070fb9adece1ed4$export$e7e5fb26b3a31a43;
var $f070fb9adece1ed4$export$4369c812aac99591;
var $f070fb9adece1ed4$export$2af51d8f0fd79769;
var $f070fb9adece1ed4$export$bf9fb029d174d554;
"use strict";
function $f070fb9adece1ed4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $f070fb9adece1ed4$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $f070fb9adece1ed4$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f070fb9adece1ed4$var$_typeof(obj);
}
var $f070fb9adece1ed4$var$types = {
    "[object Array]": "array",
    "[object Date]": "date",
    "[object Object]": "object",
    "[object String]": "string",
    "[object Null]": "null"
};
var $f070fb9adece1ed4$var$type = function(object) {
    var typeOfObject = Object.prototype.toString.call(object);
    return "object" === $f070fb9adece1ed4$var$_typeof(object) ? $f070fb9adece1ed4$var$types[typeOfObject] || "object" : $f070fb9adece1ed4$var$_typeof(object);
};
var $f070fb9adece1ed4$var$isBoolean = function(object) {
    return "boolean" === typeof object;
};
var $f070fb9adece1ed4$var$isExponential = function(value) {
    return $f070fb9adece1ed4$var$isNumeric(value) && value.toString().indexOf("e") !== -1;
};
var $f070fb9adece1ed4$var$isDate = function(object) {
    return "date" === $f070fb9adece1ed4$var$type(object);
};
var $f070fb9adece1ed4$var$isDefined = function(object) {
    return null !== object && void 0 !== object;
};
var $f070fb9adece1ed4$var$isFunction = function(object) {
    return "function" === typeof object;
};
var $f070fb9adece1ed4$var$isString = function(object) {
    return "string" === typeof object;
};
var $f070fb9adece1ed4$var$isNumeric = function(object) {
    return "number" === typeof object && isFinite(object) || !isNaN(object - parseFloat(object));
};
var $f070fb9adece1ed4$var$isObject = function(object) {
    return "object" === $f070fb9adece1ed4$var$type(object);
};
var $f070fb9adece1ed4$var$isEmptyObject = function(object) {
    var property;
    for(property in object)return false;
    return true;
};
var $f070fb9adece1ed4$var$isPlainObject = function(object) {
    if (!object || "[object Object]" !== Object.prototype.toString.call(object)) return false;
    var proto = Object.getPrototypeOf(object);
    var ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return "function" === typeof ctor && Object.toString.call(ctor) === Object.toString.call(Object);
};
var $f070fb9adece1ed4$var$isPrimitive = function(value) {
    return [
        "object",
        "array",
        "function"
    ].indexOf($f070fb9adece1ed4$var$type(value)) === -1;
};
var $f070fb9adece1ed4$var$isWindow = function(object) {
    return null != object && object === object.window;
};
var $f070fb9adece1ed4$var$isRenderer = function(object) {
    return !!(object.jquery || object.dxRenderer);
};
var $f070fb9adece1ed4$var$isPromise = function(object) {
    return object && $f070fb9adece1ed4$var$isFunction(object.then);
};
var $f070fb9adece1ed4$var$isDeferred = function(object) {
    return object && $f070fb9adece1ed4$var$isFunction(object.done) && $f070fb9adece1ed4$var$isFunction(object.fail);
};
$f070fb9adece1ed4$export$f9ce7b637dfbe238 = $f070fb9adece1ed4$var$isBoolean;
$f070fb9adece1ed4$export$cf027eaeece0ea06 = $f070fb9adece1ed4$var$isExponential;
$f070fb9adece1ed4$export$871608497c498473 = $f070fb9adece1ed4$var$isDate;
$f070fb9adece1ed4$export$4e62c701997796c1 = $f070fb9adece1ed4$var$isDefined;
$f070fb9adece1ed4$export$f6e2535fb5126e54 = $f070fb9adece1ed4$var$isFunction;
$f070fb9adece1ed4$export$844ec244b1367d54 = $f070fb9adece1ed4$var$isString;
$f070fb9adece1ed4$export$e90fb89750dba83f = $f070fb9adece1ed4$var$isNumeric;
$f070fb9adece1ed4$export$a6cdc56e425d0d0a = $f070fb9adece1ed4$var$isObject;
$f070fb9adece1ed4$export$83b788b1a3698c03 = $f070fb9adece1ed4$var$isEmptyObject;
$f070fb9adece1ed4$export$53b83ca8eaab0383 = $f070fb9adece1ed4$var$isPlainObject;
$f070fb9adece1ed4$export$c3825b437cbdea5c = $f070fb9adece1ed4$var$isPrimitive;
$f070fb9adece1ed4$export$5a096129d439f843 = $f070fb9adece1ed4$var$isWindow;
$f070fb9adece1ed4$export$e7e5fb26b3a31a43 = $f070fb9adece1ed4$var$isRenderer;
$f070fb9adece1ed4$export$4369c812aac99591 = $f070fb9adece1ed4$var$isPromise;
$f070fb9adece1ed4$export$2af51d8f0fd79769 = $f070fb9adece1ed4$var$isDeferred;
$f070fb9adece1ed4$export$bf9fb029d174d554 = $f070fb9adece1ed4$var$type;

});

parcelRegister("4Pwuy", function(module, exports) {

$parcel$export(module.exports, "map", () => $384521102f19f8f1$export$871de8747c9eaa88, (v) => $384521102f19f8f1$export$871de8747c9eaa88 = v);
$parcel$export(module.exports, "each", () => $384521102f19f8f1$export$79b2f7037acddd43, (v) => $384521102f19f8f1$export$79b2f7037acddd43 = v);
$parcel$export(module.exports, "reverseEach", () => $384521102f19f8f1$export$c1dd39eaaee75f84, (v) => $384521102f19f8f1$export$c1dd39eaaee75f84 = v);
/**
 * DevExtreme (core/utils/iterator.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $384521102f19f8f1$export$871de8747c9eaa88;
var $384521102f19f8f1$export$79b2f7037acddd43;
var $384521102f19f8f1$export$c1dd39eaaee75f84;
"use strict";
var $384521102f19f8f1$var$map = function(values, callback) {
    if (Array.isArray(values)) return values.map(callback);
    var result = [];
    for(var key in values)result.push(callback(values[key], key));
    return result;
};
var $384521102f19f8f1$var$each = function(values, callback) {
    if (!values) return;
    if ("length" in values) for(var i = 0; i < values.length; i++){
        if (false === callback.call(values[i], i, values[i])) break;
    }
    else for(var key in values){
        if (false === callback.call(values[key], key, values[key])) break;
    }
    return values;
};
var $384521102f19f8f1$var$reverseEach = function(array, callback) {
    if (!array || !("length" in array) || 0 === array.length) return;
    for(var i = array.length - 1; i >= 0; i--){
        if (false === callback.call(array[i], i, array[i])) break;
    }
};
$384521102f19f8f1$export$871de8747c9eaa88 = $384521102f19f8f1$var$map;
$384521102f19f8f1$export$79b2f7037acddd43 = $384521102f19f8f1$var$each;
$384521102f19f8f1$export$c1dd39eaaee75f84 = $384521102f19f8f1$var$reverseEach;

});

parcelRegister("6l2Qk", function(module, exports) {

$parcel$export(module.exports, "clone", () => $49d6e8cafafc7082$export$9cd59f9826255e47, (v) => $49d6e8cafafc7082$export$9cd59f9826255e47 = v);
$parcel$export(module.exports, "orderEach", () => $49d6e8cafafc7082$export$bb2eef2b4cf75f1d, (v) => $49d6e8cafafc7082$export$bb2eef2b4cf75f1d = v);
$parcel$export(module.exports, "deepExtendArraySafe", () => $49d6e8cafafc7082$export$46d2b27597d35977, (v) => $49d6e8cafafc7082$export$46d2b27597d35977 = v);
/**
 * DevExtreme (core/utils/object.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $49d6e8cafafc7082$export$9cd59f9826255e47;
var $49d6e8cafafc7082$export$bb2eef2b4cf75f1d;
var $49d6e8cafafc7082$export$46d2b27597d35977;
"use strict";

var $kDRxH = parcelRequire("kDRxH");

var $ht93C = parcelRequire("ht93C");
var $49d6e8cafafc7082$var$clone = function() {
    function Clone() {}
    return function(obj) {
        Clone.prototype = obj;
        return new Clone;
    };
}();
var $49d6e8cafafc7082$var$orderEach = function(map, func) {
    var keys = [];
    var key;
    var i;
    for(key in map)if (Object.prototype.hasOwnProperty.call(map, key)) keys.push(key);
    keys.sort(function(x, y) {
        var isNumberX = $kDRxH.isNumeric(x);
        var isNumberY = $kDRxH.isNumeric(y);
        if (isNumberX && isNumberY) return x - y;
        if (isNumberX && !isNumberY) return -1;
        if (!isNumberX && isNumberY) return 1;
        if (x < y) return -1;
        if (x > y) return 1;
        return 0;
    });
    for(i = 0; i < keys.length; i++){
        key = keys[i];
        func(key, map[key]);
    }
};
var $49d6e8cafafc7082$var$assignValueToProperty = function(target, property, value, assignByReference) {
    if (!assignByReference && $ht93C.isWrapped(target[property])) $ht93C.assign(target[property], value);
    else target[property] = value;
};
var $49d6e8cafafc7082$var$deepExtendArraySafe = function deepExtendArraySafe(target, changes, extendComplexObject, assignByReference) {
    var prevValue;
    var newValue;
    for(var name in changes){
        prevValue = target[name];
        newValue = changes[name];
        if ("__proto__" === name || target === newValue) continue;
        if ($kDRxH.isPlainObject(newValue)) {
            var goDeeper = extendComplexObject ? $kDRxH.isObject(prevValue) : $kDRxH.isPlainObject(prevValue);
            newValue = deepExtendArraySafe(goDeeper ? prevValue : {}, newValue, extendComplexObject, assignByReference);
        }
        if (void 0 !== newValue && prevValue !== newValue) $49d6e8cafafc7082$var$assignValueToProperty(target, name, newValue, assignByReference);
    }
    return target;
};
$49d6e8cafafc7082$export$9cd59f9826255e47 = $49d6e8cafafc7082$var$clone;
$49d6e8cafafc7082$export$bb2eef2b4cf75f1d = $49d6e8cafafc7082$var$orderEach;
$49d6e8cafafc7082$export$46d2b27597d35977 = $49d6e8cafafc7082$var$deepExtendArraySafe;

});
parcelRegister("ht93C", function(module, exports) {
/**
 * DevExtreme (core/utils/variable_wrapper.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $6S06l = parcelRequire("6S06l");
var $cb7c2bb6f05b2a36$require$logger = $6S06l.logger;

var $6LNcw = parcelRequire("6LNcw");
module.exports = $6LNcw({
    isWrapped: function() {
        return false;
    },
    isWritableWrapped: function() {
        return false;
    },
    wrap: function(value) {
        return value;
    },
    unwrap: function(value) {
        return value;
    },
    assign: function() {
        $cb7c2bb6f05b2a36$require$logger.error("Method 'assign' should not be used for not wrapped variables. Use 'isWrapped' method for ensuring.");
    }
});

});
parcelRegister("6S06l", function(module, exports) {

$parcel$export(module.exports, "logger", () => $5007dd5a81bd9bbd$export$af88d00dbe7f521, (v) => $5007dd5a81bd9bbd$export$af88d00dbe7f521 = v);
/**
 * DevExtreme (core/utils/console.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $5007dd5a81bd9bbd$export$af88d00dbe7f521;
var $5007dd5a81bd9bbd$export$1c9f709888824e05;
"use strict";

var $kDRxH = parcelRequire("kDRxH");
var $5007dd5a81bd9bbd$require$isFunction = $kDRxH.isFunction;
var $5007dd5a81bd9bbd$var$noop = function() {};
var $5007dd5a81bd9bbd$var$getConsoleMethod = function(method) {
    if ("undefined" === typeof console || !$5007dd5a81bd9bbd$require$isFunction(console[method])) return $5007dd5a81bd9bbd$var$noop;
    return console[method].bind(console);
};
var $5007dd5a81bd9bbd$var$logger = {
    info: $5007dd5a81bd9bbd$var$getConsoleMethod("info"),
    warn: $5007dd5a81bd9bbd$var$getConsoleMethod("warn"),
    error: $5007dd5a81bd9bbd$var$getConsoleMethod("error")
};
var $5007dd5a81bd9bbd$var$debug = function() {
    function assert(condition, message) {
        if (!condition) throw new Error(message);
    }
    function assertParam(parameter, message) {
        assert(null !== parameter && void 0 !== parameter, message);
    }
    return {
        assert: assert,
        assertParam: assertParam
    };
}();
$5007dd5a81bd9bbd$export$af88d00dbe7f521 = $5007dd5a81bd9bbd$var$logger;
$5007dd5a81bd9bbd$export$1c9f709888824e05 = $5007dd5a81bd9bbd$var$debug;

});

parcelRegister("6LNcw", function(module, exports) {
/**
 * DevExtreme (core/utils/dependency_injector.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";




module.exports = function(object) {
    var extend = (parcelRequire("7I8Uw")).extend;
    var isFunction = (parcelRequire("kDRxH")).isFunction;
    var each = (parcelRequire("4Pwuy")).each;
    var Class = (parcelRequire("k7aJb"));
    var BaseClass = Class.inherit(object);
    var InjectedClass = BaseClass;
    var instance = new InjectedClass(object);
    var initialFields = {};
    var injectFields = function(injectionObject, initial) {
        each(injectionObject, function(key) {
            if (isFunction(instance[key])) {
                if (initial || !object[key]) object[key] = function() {
                    return instance[key].apply(object, arguments);
                };
            } else {
                if (initial) initialFields[key] = object[key];
                object[key] = instance[key];
            }
        });
    };
    injectFields(object, true);
    object.inject = function(injectionObject) {
        InjectedClass = InjectedClass.inherit(injectionObject);
        instance = new InjectedClass;
        injectFields(injectionObject);
    };
    object.resetInjection = function() {
        extend(object, initialFields);
        InjectedClass = BaseClass;
        instance = new BaseClass;
    };
    return object;
};

});
parcelRegister("7I8Uw", function(module, exports) {

$parcel$export(module.exports, "extend", () => $59d38df09b55c08d$export$8b58be045bf06082, (v) => $59d38df09b55c08d$export$8b58be045bf06082 = v);
$parcel$export(module.exports, "extendFromObject", () => $59d38df09b55c08d$export$65230a64bf15fbb5, (v) => $59d38df09b55c08d$export$65230a64bf15fbb5 = v);
/**
 * DevExtreme (core/utils/extend.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $59d38df09b55c08d$export$8b58be045bf06082;
var $59d38df09b55c08d$export$65230a64bf15fbb5;
"use strict";

var $kDRxH = parcelRequire("kDRxH");
var $59d38df09b55c08d$require$isPlainObject = $kDRxH.isPlainObject;
var $59d38df09b55c08d$var$extendFromObject = function(target, source, overrideExistingValues) {
    target = target || {};
    for(var prop in source)if (Object.prototype.hasOwnProperty.call(source, prop)) {
        var value = source[prop];
        if (!(prop in target) || overrideExistingValues) target[prop] = value;
    }
    return target;
};
var $59d38df09b55c08d$var$extend = function extend(target) {
    target = target || {};
    var i = 1;
    var deep = false;
    if ("boolean" === typeof target) {
        deep = target;
        target = arguments[1] || {};
        i++;
    }
    for(; i < arguments.length; i++){
        var source = arguments[i];
        if (null == source) continue;
        for(var key in source){
            var targetValue = target[key];
            var sourceValue = source[key];
            var sourceValueIsArray = false;
            var clone;
            if ("__proto__" === key || target === sourceValue) continue;
            if (deep && sourceValue && ($59d38df09b55c08d$require$isPlainObject(sourceValue) || (sourceValueIsArray = Array.isArray(sourceValue)))) {
                if (sourceValueIsArray) clone = targetValue && Array.isArray(targetValue) ? targetValue : [];
                else clone = targetValue && $59d38df09b55c08d$require$isPlainObject(targetValue) ? targetValue : {};
                target[key] = extend(deep, clone, sourceValue);
            } else if (void 0 !== sourceValue) target[key] = sourceValue;
        }
    }
    return target;
};
$59d38df09b55c08d$export$8b58be045bf06082 = $59d38df09b55c08d$var$extend;
$59d38df09b55c08d$export$65230a64bf15fbb5 = $59d38df09b55c08d$var$extendFromObject;

});

parcelRegister("k7aJb", function(module, exports) {
/**
 * DevExtreme (core/class.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $7sX7V = parcelRequire("7sX7V");

var $kDRxH = parcelRequire("kDRxH");
var $ea4cc86bc559b4a0$var$wrapOverridden = function(baseProto, methodName, method) {
    return function() {
        var prevCallBase = this.callBase;
        this.callBase = baseProto[methodName];
        try {
            return method.apply(this, arguments);
        } finally{
            this.callBase = prevCallBase;
        }
    };
};
var $ea4cc86bc559b4a0$var$clonePrototype = function(obj) {
    var func = function() {};
    func.prototype = obj.prototype;
    return new func;
};
var $ea4cc86bc559b4a0$var$redefine = function(members) {
    var that = this;
    var overridden;
    var memberName;
    var member;
    if (!members) return that;
    for(memberName in members){
        member = members[memberName];
        overridden = "function" === typeof that.prototype[memberName] && "function" === typeof member;
        that.prototype[memberName] = overridden ? $ea4cc86bc559b4a0$var$wrapOverridden(that.parent.prototype, memberName, member) : member;
    }
    return that;
};
var $ea4cc86bc559b4a0$var$include = function() {
    var classObj = this;
    var argument;
    var name;
    var i;
    var hasClassObjOwnProperty = Object.prototype.hasOwnProperty.bind(classObj);
    var isES6Class = !hasClassObjOwnProperty("_includedCtors") && !hasClassObjOwnProperty("_includedPostCtors");
    if (isES6Class) {
        classObj._includedCtors = classObj._includedCtors.slice(0);
        classObj._includedPostCtors = classObj._includedPostCtors.slice(0);
    }
    for(i = 0; i < arguments.length; i++){
        argument = arguments[i];
        if (argument.ctor) classObj._includedCtors.push(argument.ctor);
        if (argument.postCtor) classObj._includedPostCtors.push(argument.postCtor);
        for(name in argument){
            if ("ctor" === name || "postCtor" === name) continue;
            classObj.prototype[name] = argument[name];
        }
    }
    return classObj;
};
var $ea4cc86bc559b4a0$var$subclassOf = function(parentClass) {
    var hasParentProperty = Object.prototype.hasOwnProperty.bind(this)("parent");
    var isES6Class = !hasParentProperty && this.parent;
    if (isES6Class) {
        var baseClass = Object.getPrototypeOf(this);
        return baseClass === parentClass || baseClass.subclassOf(parentClass);
    } else {
        if (this.parent === parentClass) return true;
        if (!this.parent || !this.parent.subclassOf) return false;
        return this.parent.subclassOf(parentClass);
    }
};
var $ea4cc86bc559b4a0$var$abstract = function() {
    throw $7sX7V.Error("E0001");
};
var $ea4cc86bc559b4a0$var$copyStatic = function() {
    var hasOwn = Object.prototype.hasOwnProperty;
    return function(source, destination) {
        for(var key in source){
            if (!hasOwn.call(source, key)) return;
            destination[key] = source[key];
        }
    };
}();
var $ea4cc86bc559b4a0$var$classImpl = function() {};
$ea4cc86bc559b4a0$var$classImpl.inherit = function(members) {
    var inheritor = function() {
        if (!this || $kDRxH.isWindow(this) || "function" !== typeof this.constructor) throw $7sX7V.Error("E0003");
        var instance = this;
        var ctor = instance.ctor;
        var includedCtors = instance.constructor._includedCtors;
        var includedPostCtors = instance.constructor._includedPostCtors;
        var i;
        for(i = 0; i < includedCtors.length; i++)includedCtors[i].call(instance);
        if (ctor) ctor.apply(instance, arguments);
        for(i = 0; i < includedPostCtors.length; i++)includedPostCtors[i].call(instance);
    };
    inheritor.prototype = $ea4cc86bc559b4a0$var$clonePrototype(this);
    $ea4cc86bc559b4a0$var$copyStatic(this, inheritor);
    inheritor.inherit = this.inherit;
    inheritor.abstract = $ea4cc86bc559b4a0$var$abstract;
    inheritor.redefine = $ea4cc86bc559b4a0$var$redefine;
    inheritor.include = $ea4cc86bc559b4a0$var$include;
    inheritor.subclassOf = $ea4cc86bc559b4a0$var$subclassOf;
    inheritor.parent = this;
    inheritor._includedCtors = this._includedCtors ? this._includedCtors.slice(0) : [];
    inheritor._includedPostCtors = this._includedPostCtors ? this._includedPostCtors.slice(0) : [];
    inheritor.prototype.constructor = inheritor;
    inheritor.redefine(members);
    return inheritor;
};
$ea4cc86bc559b4a0$var$classImpl.abstract = $ea4cc86bc559b4a0$var$abstract;
module.exports = $ea4cc86bc559b4a0$var$classImpl;

});
parcelRegister("7sX7V", function(module, exports) {
/**
 * DevExtreme (core/errors.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $iwn67 = parcelRequire("iwn67");
module.exports = $iwn67({
    E0001: "Method is not implemented",
    E0002: "Member name collision: {0}",
    E0003: "A class must be instantiated using the 'new' keyword",
    E0004: "The NAME property of the component is not specified",
    E0005: "Unknown device",
    E0006: "Unknown endpoint key is requested",
    E0007: "'Invalidate' method is called outside the update transaction",
    E0008: "Type of the option name is not appropriate to create an action",
    E0009: "Component '{0}' has not been initialized for an element",
    E0010: "Animation configuration with the '{0}' type requires '{1}' configuration as {2}",
    E0011: "Unknown animation type '{0}'",
    E0012: "jQuery version is too old. Please upgrade jQuery to 1.10.0 or later",
    E0013: "KnockoutJS version is too old. Please upgrade KnockoutJS to 2.3.0 or later",
    E0014: "The 'release' method shouldn't be called for an unlocked Lock object",
    E0015: "Queued task returned an unexpected result",
    E0017: "Event namespace is not defined",
    E0018: "DevExpress.ui.DevExpressPopup widget is required",
    E0020: "Template engine '{0}' is not supported",
    E0021: "Unknown theme is set: {0}",
    E0022: "LINK[rel=DevExpress-theme] tags must go before DevExpress included scripts",
    E0023: "Template name is not specified",
    E0024: "DevExtreme bundle already included",
    E0025: "Unexpected argument type",
    E0100: "Unknown validation type is detected",
    E0101: "Misconfigured range validation rule is detected",
    E0102: "Misconfigured comparison validation rule is detected",
    E0103: "validationCallback of an asynchronous rule should return a jQuery or a native promise",
    E0110: "Unknown validation group is detected",
    E0120: "Adapter for a DevExpressValidator component cannot be configured",
    E0121: "The 'customItem' field of the 'onCustomItemCreating' function's parameter should contain a custom item or Promise that is resolved after the item is created.",
    W0000: "'{0}' is deprecated in {1}. {2}",
    W0001: "{0} - '{1}' option is deprecated in {2}. {3}",
    W0002: "{0} - '{1}' method is deprecated in {2}. {3}",
    W0003: "{0} - '{1}' property is deprecated in {2}. {3}",
    W0004: "Timeout for theme loading is over: {0}",
    W0005: "'{0}' event is deprecated in {1}. {2}",
    W0006: "Invalid recurrence rule: '{0}'",
    W0007: "'{0}' Globalize culture is not defined",
    W0008: "Invalid view name: '{0}'",
    W0009: "Invalid time zone name: '{0}'",
    W0010: "{0} is deprecated in {1}. {2}",
    W0011: "Number parsing is invoked while the parser is not defined",
    W0012: "Date parsing is invoked while the parser is not defined",
    W0013: "'{0}' file is deprecated in {1}. {2}",
    W0014: "{0} - '{1}' type is deprecated in {2}. {3}",
    W0015: "Instead of returning a value from the '{0}' function, write it into the '{1}' field of the function's parameter.",
    W0016: 'The "{0}" option does not accept the "{1}" value since v.{2}. {3}.'
});

});
parcelRegister("iwn67", function(module, exports) {
/**
 * DevExtreme (core/utils/error.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $7I8Uw = parcelRequire("7I8Uw");
var $d7bd21e092ddaa9b$require$extend = $7I8Uw.extend;

var $6S06l = parcelRequire("6S06l");

var $ksvsU = parcelRequire("ksvsU");

var $c20dO = parcelRequire("c20dO");
var $d7bd21e092ddaa9b$var$ERROR_URL = "http://js.devexpress.com/error/" + $c20dO.split(".").slice(0, 2).join("_") + "/";
module.exports = function(baseErrors, errors) {
    var exports = {
        ERROR_MESSAGES: $d7bd21e092ddaa9b$require$extend(errors, baseErrors),
        Error: function() {
            return makeError([].slice.call(arguments));
        },
        log: function(id) {
            var method = "log";
            if (/^E\d+$/.test(id)) method = "error";
            else if (/^W\d+$/.test(id)) method = "warn";
            $6S06l.logger[method]("log" === method ? id : combineMessage([].slice.call(arguments)));
        }
    };
    var combineMessage = function(args) {
        var id = args[0];
        args = args.slice(1);
        return formatMessage(id, formatDetails(id, args));
    };
    var formatDetails = function(id, args) {
        args = [
            exports.ERROR_MESSAGES[id]
        ].concat(args);
        return $ksvsU.format.apply(this, args).replace(/\.*\s*?$/, "");
    };
    var formatMessage = function(id, details) {
        return $ksvsU.format.apply(this, [
            "{0} - {1}. See:\n{2}",
            id,
            details,
            getErrorUrl(id)
        ]);
    };
    var makeError = function(args) {
        var id = args[0];
        args = args.slice(1);
        var details = formatDetails(id, args);
        var url = getErrorUrl(id);
        var message = formatMessage(id, details);
        return $d7bd21e092ddaa9b$require$extend(new Error(message), {
            __id: id,
            __details: details,
            url: url
        });
    };
    var getErrorUrl = function(id) {
        return $d7bd21e092ddaa9b$var$ERROR_URL + id;
    };
    return exports;
};

});
parcelRegister("ksvsU", function(module, exports) {

$parcel$export(module.exports, "encodeHtml", () => $ee4ed48240e268a3$export$4db3f3504654268f, (v) => $ee4ed48240e268a3$export$4db3f3504654268f = v);
$parcel$export(module.exports, "quadToObject", () => $ee4ed48240e268a3$export$5f705bd4c44a1383, (v) => $ee4ed48240e268a3$export$5f705bd4c44a1383 = v);
$parcel$export(module.exports, "format", () => $ee4ed48240e268a3$export$d9468344d3651243, (v) => $ee4ed48240e268a3$export$d9468344d3651243 = v);
$parcel$export(module.exports, "isEmpty", () => $ee4ed48240e268a3$export$dd1bc94b04021eeb, (v) => $ee4ed48240e268a3$export$dd1bc94b04021eeb = v);
/**
 * DevExtreme (core/utils/string.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $ee4ed48240e268a3$export$4db3f3504654268f;
var $ee4ed48240e268a3$export$5f705bd4c44a1383;
var $ee4ed48240e268a3$export$d9468344d3651243;
var $ee4ed48240e268a3$export$b8b3234b4edfc4c2;
var $ee4ed48240e268a3$export$dd1bc94b04021eeb;
"use strict";
function $ee4ed48240e268a3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $ee4ed48240e268a3$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $ee4ed48240e268a3$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ee4ed48240e268a3$var$_typeof(obj);
}

var $kDRxH = parcelRequire("kDRxH");
var $ee4ed48240e268a3$var$encodeHtml = function() {
    var encodeRegExp = [
        new RegExp("&", "g"),
        new RegExp('"', "g"),
        new RegExp("'", "g"),
        new RegExp("<", "g"),
        new RegExp(">", "g")
    ];
    return function(str) {
        return String(str).replace(encodeRegExp[0], "&amp;").replace(encodeRegExp[1], "&quot;").replace(encodeRegExp[2], "&#39;").replace(encodeRegExp[3], "&lt;").replace(encodeRegExp[4], "&gt;");
    };
}();
var $ee4ed48240e268a3$var$splitQuad = function(raw) {
    switch($ee4ed48240e268a3$var$_typeof(raw)){
        case "string":
            return raw.split(/\s+/, 4);
        case "object":
            return [
                raw.x || raw.h || raw.left,
                raw.y || raw.v || raw.top,
                raw.x || raw.h || raw.right,
                raw.y || raw.v || raw.bottom
            ];
        case "number":
            return [
                raw
            ];
        default:
            return raw;
    }
};
var $ee4ed48240e268a3$var$quadToObject = function(raw) {
    var quad = $ee4ed48240e268a3$var$splitQuad(raw);
    var left = parseInt(quad && quad[0], 10);
    var top = parseInt(quad && quad[1], 10);
    var right = parseInt(quad && quad[2], 10);
    var bottom = parseInt(quad && quad[3], 10);
    if (!isFinite(left)) left = 0;
    if (!isFinite(top)) top = left;
    if (!isFinite(right)) right = left;
    if (!isFinite(bottom)) bottom = top;
    return {
        top: top,
        right: right,
        bottom: bottom,
        left: left
    };
};
var $ee4ed48240e268a3$var$stringFormat = function() {
    var s = arguments[0];
    var values = [].slice.call(arguments).slice(1);
    var replaceDollarCount;
    var reg;
    var value;
    if ($kDRxH.isFunction(s)) return s.apply(this, values);
    for(var i = 0; i < values.length; i++){
        reg = new RegExp("\\{" + i + "\\}", "gm");
        value = values[i];
        if ("string" === $kDRxH.type(value) && value.indexOf("$") >= 0) {
            replaceDollarCount = "$".replace("$", "$$").length;
            value = value.replace("$", 1 === replaceDollarCount ? "$$$$" : "$$");
        }
        s = s.replace(reg, value);
    }
    return s;
};
var $ee4ed48240e268a3$var$replaceAll = function() {
    var quote = function(str) {
        return (str + "").replace(/([+*?.[^\]$(){}><|=!:])/g, "\\$1");
    };
    return function(text, searchToken, replacementToken) {
        return text.replace(new RegExp("(" + quote(searchToken) + ")", "gi"), replacementToken);
    };
}();
var $ee4ed48240e268a3$var$isEmpty = function() {
    var SPACE_REGEXP = /\s/g;
    return function(text) {
        return !text || !text.replace(SPACE_REGEXP, "");
    };
}();
$ee4ed48240e268a3$export$4db3f3504654268f = $ee4ed48240e268a3$var$encodeHtml;
$ee4ed48240e268a3$export$5f705bd4c44a1383 = $ee4ed48240e268a3$var$quadToObject;
$ee4ed48240e268a3$export$d9468344d3651243 = $ee4ed48240e268a3$var$stringFormat;
$ee4ed48240e268a3$export$b8b3234b4edfc4c2 = $ee4ed48240e268a3$var$replaceAll;
$ee4ed48240e268a3$export$dd1bc94b04021eeb = $ee4ed48240e268a3$var$isEmpty;

});

parcelRegister("c20dO", function(module, exports) {
/**
 * DevExtreme (core/version.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
module.exports = "19.2.9";

});







parcelRegister("1JvXr", function(module, exports) {
/**
 * DevExtreme (core/config.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $7I8Uw = parcelRequire("7I8Uw");
var $1432c89119156e89$var$_extend2 = $1432c89119156e89$var$_interopRequireDefault($7I8Uw);

var $7sX7V = parcelRequire("7sX7V");
var $1432c89119156e89$var$_errors2 = $1432c89119156e89$var$_interopRequireDefault($7sX7V);
function $1432c89119156e89$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $1432c89119156e89$var$config = {
    rtlEnabled: false,
    defaultCurrency: "USD",
    oDataFilterToLower: true,
    serverDecimalSeparator: ".",
    decimalSeparator: ".",
    thousandsSeparator: ",",
    forceIsoDateParsing: true,
    wrapActionsBeforeExecute: true,
    useLegacyStoreResult: false,
    useJQuery: void 0,
    editorStylingMode: void 0,
    useLegacyVisibleIndex: false,
    floatingActionButtonConfig: {
        icon: "add",
        closeIcon: "close",
        label: "",
        position: {
            at: "right bottom",
            my: "right bottom",
            offset: {
                x: -16,
                y: -16
            }
        },
        maxSpeedDialActionCount: 5,
        shading: false,
        direction: "auto"
    },
    optionsParser: function(optionsString) {
        if ("{" !== optionsString.trim().charAt(0)) optionsString = "{" + optionsString + "}";
        try {
            return new Function("return " + optionsString)();
        } catch (ex) {
            throw $1432c89119156e89$var$_errors2.default.Error("E3018", ex, optionsString);
        }
    }
};
var $1432c89119156e89$var$deprecatedFields = [
    "decimalSeparator",
    "thousandsSeparator"
];
var $1432c89119156e89$var$configMethod = function() {
    if (!arguments.length) return $1432c89119156e89$var$config;
    var newConfig = arguments.length <= 0 ? void 0 : arguments[0];
    $1432c89119156e89$var$deprecatedFields.forEach(function(deprecatedField) {
        if (newConfig[deprecatedField]) {
            var message = "Now, the ".concat(deprecatedField, " is selected based on the specified locale.");
            $1432c89119156e89$var$_errors2.default.log("W0003", "config", deprecatedField, "19.2", message);
        }
    });
    $1432c89119156e89$var$_extend2.default.extend($1432c89119156e89$var$config, newConfig);
};
if ("undefined" !== typeof DevExpress && DevExpress.config) $1432c89119156e89$var$configMethod(DevExpress.config);
module.exports = $1432c89119156e89$var$configMethod;
module.exports.default = module.exports;

});


parcelRegister("irv64", function(module, exports) {
/**
 * DevExtreme (core/utils/window.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $445Bz = parcelRequire("445Bz");
var $d6d2ded5d2d37e6c$var$_hasWindow = "undefined" !== typeof window;
var $d6d2ded5d2d37e6c$var$windowObject = $d6d2ded5d2d37e6c$var$_hasWindow && window;
if (!$d6d2ded5d2d37e6c$var$windowObject) {
    $d6d2ded5d2d37e6c$var$windowObject = {};
    $d6d2ded5d2d37e6c$var$windowObject.window = $d6d2ded5d2d37e6c$var$windowObject;
}
module.exports = {
    hasWindow: function() {
        return $d6d2ded5d2d37e6c$var$_hasWindow;
    },
    getWindow: function() {
        return $d6d2ded5d2d37e6c$var$windowObject;
    },
    hasProperty: function(prop) {
        return this.hasWindow() && prop in $d6d2ded5d2d37e6c$var$windowObject;
    },
    defaultScreenFactorFunc: function(width) {
        if (width < 768) return "xs";
        else {
            if (width < 992) return "sm";
            else {
                if (width < 1200) return "md";
                else return "lg";
            }
        }
    },
    getCurrentScreenFactor: function(screenFactorCallback) {
        var screenFactorFunc = screenFactorCallback || this.defaultScreenFactorFunc;
        var windowWidth = $445Bz.getDocumentElement().clientWidth;
        return screenFactorFunc(windowWidth);
    },
    getNavigator: function() {
        return this.hasWindow() ? $d6d2ded5d2d37e6c$var$windowObject.navigator : {
            userAgent: ""
        };
    }
};

});
parcelRegister("445Bz", function(module, exports) {
/**
 * DevExtreme (core/dom_adapter.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $6LNcw = parcelRequire("6LNcw");
var $2f5be22f1428613b$var$_dependency_injector2 = $2f5be22f1428613b$var$_interopRequireDefault($6LNcw);

var $2Mto0 = parcelRequire("2Mto0");
function $2f5be22f1428613b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $2f5be22f1428613b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $2f5be22f1428613b$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $2f5be22f1428613b$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2f5be22f1428613b$var$_typeof(obj);
}
var $2f5be22f1428613b$var$ELEMENT_NODE = 1;
var $2f5be22f1428613b$var$TEXT_NODE = 3;
var $2f5be22f1428613b$var$DOCUMENT_NODE = 9;
var $2f5be22f1428613b$var$nativeDOMAdapterStrategy = {
    querySelectorAll: function(element, selector) {
        return element.querySelectorAll(selector);
    },
    elementMatches: function(element, selector) {
        var _this = this;
        var matches = element.matches || element.matchesSelector || element.mozMatchesSelector || element.msMatchesSelector || element.oMatchesSelector || element.webkitMatchesSelector || function(selector) {
            var doc = element.document || element.ownerDocument;
            if (!doc) return false;
            var items = _this.querySelectorAll(doc, selector);
            for(var i = 0; i < items.length; i++){
                if (items[i] === element) return true;
            }
        };
        return matches.call(element, selector);
    },
    createElement: function(tagName, context) {
        context = context || this._document;
        return context.createElement(tagName);
    },
    createElementNS: function(ns, tagName, context) {
        context = context || this._document;
        return context.createElementNS(ns, tagName);
    },
    createTextNode: function(text, context) {
        context = context || this._document;
        return context.createTextNode(text);
    },
    isNode: function(element) {
        return "object" === $2f5be22f1428613b$var$_typeof(element) && "nodeType" in element;
    },
    isElementNode: function(element) {
        return element && element.nodeType === $2f5be22f1428613b$var$ELEMENT_NODE;
    },
    isTextNode: function(element) {
        return element && element.nodeType === $2f5be22f1428613b$var$TEXT_NODE;
    },
    isDocument: function(element) {
        return element && element.nodeType === $2f5be22f1428613b$var$DOCUMENT_NODE;
    },
    removeElement: function(element) {
        var parentNode = element && element.parentNode;
        if (parentNode) parentNode.removeChild(element);
    },
    insertElement: function(parentElement, newElement, nextSiblingElement) {
        if (parentElement && newElement && parentElement !== newElement) {
            if (nextSiblingElement) parentElement.insertBefore(newElement, nextSiblingElement);
            else parentElement.appendChild(newElement);
        }
    },
    getAttribute: function(element, name) {
        return element.getAttribute(name);
    },
    setAttribute: function(element, name, value) {
        element.setAttribute(name, value);
    },
    removeAttribute: function(element, name) {
        element.removeAttribute(name);
    },
    setProperty: function(element, name, value) {
        element[name] = value;
    },
    setText: function(element, text) {
        if (element) element.textContent = text;
    },
    setClass: function(element, className, isAdd) {
        if (1 === element.nodeType && className) {
            if (element.classList) {
                if (isAdd) element.classList.add(className);
                else element.classList.remove(className);
            } else {
                var classNameSupported = "string" === typeof element.className;
                var elementClass = classNameSupported ? element.className : this.getAttribute(element, "class") || "";
                var classNames = elementClass.split(" ");
                var classIndex = classNames.indexOf(className);
                var resultClassName;
                if (isAdd && classIndex < 0) resultClassName = elementClass ? elementClass + " " + className : className;
                if (!isAdd && classIndex >= 0) {
                    classNames.splice(classIndex, 1);
                    resultClassName = classNames.join(" ");
                }
                if (void 0 !== resultClassName) {
                    if (classNameSupported) element.className = resultClassName;
                    else this.setAttribute(element, "class", resultClassName);
                }
            }
        }
    },
    setStyle: function(element, name, value) {
        element.style[name] = value || "";
    },
    _document: "undefined" === typeof document ? void 0 : document,
    getDocument: function() {
        return this._document;
    },
    getActiveElement: function() {
        return this._document.activeElement;
    },
    getBody: function() {
        return this._document.body;
    },
    createDocumentFragment: function() {
        return this._document.createDocumentFragment();
    },
    getDocumentElement: function() {
        return this._document.documentElement;
    },
    getLocation: function() {
        return this._document.location;
    },
    getSelection: function() {
        return this._document.selection;
    },
    getReadyState: function() {
        return this._document.readyState;
    },
    getHead: function() {
        return this._document.head;
    },
    hasDocumentProperty: function(property) {
        return property in this._document;
    },
    listen: function(element, event, callback, options) {
        if (!element || !("addEventListener" in element)) return $2Mto0.noop;
        element.addEventListener(event, callback, options);
        return function() {
            element.removeEventListener(event, callback);
        };
    }
};
module.exports = (0, $2f5be22f1428613b$var$_dependency_injector2.default)($2f5be22f1428613b$var$nativeDOMAdapterStrategy);

});
parcelRegister("2Mto0", function(module, exports) {

$parcel$export(module.exports, "ensureDefined", () => $2066dbf5cfb8397c$export$e700b866474dec26, (v) => $2066dbf5cfb8397c$export$e700b866474dec26 = v);
$parcel$export(module.exports, "executeAsync", () => $2066dbf5cfb8397c$export$565669a538b226a6, (v) => $2066dbf5cfb8397c$export$565669a538b226a6 = v);
$parcel$export(module.exports, "deferRender", () => $2066dbf5cfb8397c$export$9f991a1dc8c2af5b, (v) => $2066dbf5cfb8397c$export$9f991a1dc8c2af5b = v);
$parcel$export(module.exports, "deferRenderer", () => $2066dbf5cfb8397c$export$420e8e898c79212f, (v) => $2066dbf5cfb8397c$export$420e8e898c79212f = v);
$parcel$export(module.exports, "deferUpdate", () => $2066dbf5cfb8397c$export$5c2413d24bb6a40f, (v) => $2066dbf5cfb8397c$export$5c2413d24bb6a40f = v);
$parcel$export(module.exports, "deferUpdater", () => $2066dbf5cfb8397c$export$e749563bae0b9d5c, (v) => $2066dbf5cfb8397c$export$e749563bae0b9d5c = v);
$parcel$export(module.exports, "pairToObject", () => $2066dbf5cfb8397c$export$aa6ab5672b20676f, (v) => $2066dbf5cfb8397c$export$aa6ab5672b20676f = v);
$parcel$export(module.exports, "splitPair", () => $2066dbf5cfb8397c$export$430720914e9be270, (v) => $2066dbf5cfb8397c$export$430720914e9be270 = v);
$parcel$export(module.exports, "findBestMatches", () => $2066dbf5cfb8397c$export$6a7738807e7f2c17, (v) => $2066dbf5cfb8397c$export$6a7738807e7f2c17 = v);
$parcel$export(module.exports, "normalizeKey", () => $2066dbf5cfb8397c$export$e0c709538cb8ae18, (v) => $2066dbf5cfb8397c$export$e0c709538cb8ae18 = v);
$parcel$export(module.exports, "denormalizeKey", () => $2066dbf5cfb8397c$export$4f22be2962df6eb9, (v) => $2066dbf5cfb8397c$export$4f22be2962df6eb9 = v);
$parcel$export(module.exports, "getKeyHash", () => $2066dbf5cfb8397c$export$ac5b0c7e11c08cd4, (v) => $2066dbf5cfb8397c$export$ac5b0c7e11c08cd4 = v);
$parcel$export(module.exports, "escapeRegExp", () => $2066dbf5cfb8397c$export$7c57da42ce8e346f, (v) => $2066dbf5cfb8397c$export$7c57da42ce8e346f = v);
$parcel$export(module.exports, "applyServerDecimalSeparator", () => $2066dbf5cfb8397c$export$2ad35a62dfcae12a, (v) => $2066dbf5cfb8397c$export$2ad35a62dfcae12a = v);
$parcel$export(module.exports, "noop", () => $2066dbf5cfb8397c$export$8793edee2d425525, (v) => $2066dbf5cfb8397c$export$8793edee2d425525 = v);
$parcel$export(module.exports, "asyncNoop", () => $2066dbf5cfb8397c$export$21e1ac03cdd918b0, (v) => $2066dbf5cfb8397c$export$21e1ac03cdd918b0 = v);
$parcel$export(module.exports, "grep", () => $2066dbf5cfb8397c$export$41ee50d8efec7aa7, (v) => $2066dbf5cfb8397c$export$41ee50d8efec7aa7 = v);
$parcel$export(module.exports, "equalByValue", () => $2066dbf5cfb8397c$export$e45a697a0958a5f, (v) => $2066dbf5cfb8397c$export$e45a697a0958a5f = v);
/**
 * DevExtreme (core/utils/common.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $2066dbf5cfb8397c$export$e700b866474dec26;
var $2066dbf5cfb8397c$export$565669a538b226a6;
var $2066dbf5cfb8397c$export$9f991a1dc8c2af5b;
var $2066dbf5cfb8397c$export$420e8e898c79212f;
var $2066dbf5cfb8397c$export$5c2413d24bb6a40f;
var $2066dbf5cfb8397c$export$e749563bae0b9d5c;
var $2066dbf5cfb8397c$export$aa6ab5672b20676f;
var $2066dbf5cfb8397c$export$430720914e9be270;
var $2066dbf5cfb8397c$export$6a7738807e7f2c17;
var $2066dbf5cfb8397c$export$e0c709538cb8ae18;
var $2066dbf5cfb8397c$export$4f22be2962df6eb9;
var $2066dbf5cfb8397c$export$ac5b0c7e11c08cd4;
var $2066dbf5cfb8397c$export$7c57da42ce8e346f;
var $2066dbf5cfb8397c$export$2ad35a62dfcae12a;
var $2066dbf5cfb8397c$export$8793edee2d425525;
var $2066dbf5cfb8397c$export$21e1ac03cdd918b0;
var $2066dbf5cfb8397c$export$41ee50d8efec7aa7;
var $2066dbf5cfb8397c$export$e45a697a0958a5f;
"use strict";

var $1JvXr = parcelRequire("1JvXr");
var $2066dbf5cfb8397c$var$_config2 = $2066dbf5cfb8397c$var$_interopRequireDefault($1JvXr);

var $duKPB = parcelRequire("duKPB");
var $2066dbf5cfb8397c$var$_guid2 = $2066dbf5cfb8397c$var$_interopRequireDefault($duKPB);

var $2F60d = parcelRequire("2F60d");

var $kpjzB = parcelRequire("kpjzB");

var $4Pwuy = parcelRequire("4Pwuy");

var $kDRxH = parcelRequire("kDRxH");
function $2066dbf5cfb8397c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $2066dbf5cfb8397c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $2066dbf5cfb8397c$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $2066dbf5cfb8397c$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $2066dbf5cfb8397c$var$_typeof(obj);
}
var $2066dbf5cfb8397c$var$ensureDefined = function(value, defaultValue) {
    return (0, $kDRxH.isDefined)(value) ? value : defaultValue;
};
var $2066dbf5cfb8397c$var$executeAsync = function(action, context) {
    var deferred = new $2F60d.Deferred;
    var normalizedContext = context || this;
    var task = {
        promise: deferred.promise(),
        abort: function() {
            clearTimeout(timerId);
            deferred.rejectWith(normalizedContext);
        }
    };
    var callback = function() {
        var result = action.call(normalizedContext);
        if (result && result.done && (0, $kDRxH.isFunction)(result.done)) result.done(function() {
            deferred.resolveWith(normalizedContext);
        });
        else deferred.resolveWith(normalizedContext);
    };
    var timerId = (arguments[2] || setTimeout)(callback, "number" === typeof context ? context : 0);
    return task;
};
var $2066dbf5cfb8397c$var$delayedFuncs = [];
var $2066dbf5cfb8397c$var$delayedNames = [];
var $2066dbf5cfb8397c$var$delayedDeferreds = [];
var $2066dbf5cfb8397c$var$executingName;
var $2066dbf5cfb8397c$var$deferExecute = function(name, func, deferred) {
    if ($2066dbf5cfb8397c$var$executingName && $2066dbf5cfb8397c$var$executingName !== name) {
        $2066dbf5cfb8397c$var$delayedFuncs.push(func);
        $2066dbf5cfb8397c$var$delayedNames.push(name);
        deferred = deferred || new $2F60d.Deferred;
        $2066dbf5cfb8397c$var$delayedDeferreds.push(deferred);
        return deferred;
    } else {
        var oldExecutingName = $2066dbf5cfb8397c$var$executingName;
        var currentDelayedCount = $2066dbf5cfb8397c$var$delayedDeferreds.length;
        $2066dbf5cfb8397c$var$executingName = name;
        var result = func();
        if (!result) {
            if ($2066dbf5cfb8397c$var$delayedDeferreds.length > currentDelayedCount) result = $2F60d.when.apply(this, $2066dbf5cfb8397c$var$delayedDeferreds.slice(currentDelayedCount));
            else if (deferred) deferred.resolve();
        }
        $2066dbf5cfb8397c$var$executingName = oldExecutingName;
        if (deferred && result && result.done) result.done(deferred.resolve).fail(deferred.reject);
        if (!$2066dbf5cfb8397c$var$executingName && $2066dbf5cfb8397c$var$delayedFuncs.length) ("render" === $2066dbf5cfb8397c$var$delayedNames.shift() ? $2066dbf5cfb8397c$var$deferRender : $2066dbf5cfb8397c$var$deferUpdate)($2066dbf5cfb8397c$var$delayedFuncs.shift(), $2066dbf5cfb8397c$var$delayedDeferreds.shift());
        return result || (0, $2F60d.when)();
    }
};
var $2066dbf5cfb8397c$var$deferRender = function(func, deferred) {
    return $2066dbf5cfb8397c$var$deferExecute("render", func, deferred);
};
var $2066dbf5cfb8397c$var$deferUpdate = function(func, deferred) {
    return $2066dbf5cfb8397c$var$deferExecute("update", func, deferred);
};
var $2066dbf5cfb8397c$var$deferRenderer = function(func) {
    return function() {
        var that = this;
        return $2066dbf5cfb8397c$var$deferExecute("render", function() {
            return func.call(that);
        });
    };
};
var $2066dbf5cfb8397c$var$deferUpdater = function(func) {
    return function() {
        var that = this;
        return $2066dbf5cfb8397c$var$deferExecute("update", function() {
            return func.call(that);
        });
    };
};
var $2066dbf5cfb8397c$var$findBestMatches = function(targetFilter, items, mapFn) {
    var bestMatches = [];
    var maxMatchCount = 0;
    (0, $4Pwuy.each)(items, function(index, itemSrc) {
        var matchCount = 0;
        var item = mapFn ? mapFn(itemSrc) : itemSrc;
        (0, $4Pwuy.each)(targetFilter, function(paramName, targetValue) {
            var value = item[paramName];
            if (void 0 === value) return;
            if ($2066dbf5cfb8397c$var$match(value, targetValue)) {
                matchCount++;
                return;
            }
            matchCount = -1;
            return false;
        });
        if (matchCount < maxMatchCount) return;
        if (matchCount > maxMatchCount) {
            bestMatches.length = 0;
            maxMatchCount = matchCount;
        }
        bestMatches.push(itemSrc);
    });
    return bestMatches;
};
var $2066dbf5cfb8397c$var$match = function(value, targetValue) {
    if (Array.isArray(value) && Array.isArray(targetValue)) {
        var mismatch = false;
        (0, $4Pwuy.each)(value, function(index, valueItem) {
            if (valueItem !== targetValue[index]) {
                mismatch = true;
                return false;
            }
        });
        if (mismatch) return false;
        return true;
    }
    if (value === targetValue) return true;
    return false;
};
var $2066dbf5cfb8397c$var$splitPair = function(raw) {
    switch($2066dbf5cfb8397c$var$_typeof(raw)){
        case "string":
            return raw.split(/\s+/, 2);
        case "object":
            return [
                raw.x || raw.h,
                raw.y || raw.v
            ];
        case "number":
            return [
                raw
            ];
        default:
            return raw;
    }
};
var $2066dbf5cfb8397c$var$normalizeKey = function(id) {
    var key = (0, $kDRxH.isString)(id) ? id : id.toString();
    var arr = key.match(/[^a-zA-Z0-9_]/g);
    arr && (0, $4Pwuy.each)(arr, function(_, sign) {
        key = key.replace(sign, "__" + sign.charCodeAt() + "__");
    });
    return key;
};
var $2066dbf5cfb8397c$var$denormalizeKey = function(key) {
    var arr = key.match(/__\d+__/g);
    arr && arr.forEach(function(char) {
        var charCode = parseInt(char.replace("__", ""));
        key = key.replace(char, String.fromCharCode(charCode));
    });
    return key;
};
var $2066dbf5cfb8397c$var$pairToObject = function(raw, preventRound) {
    var pair = $2066dbf5cfb8397c$var$splitPair(raw);
    var h = preventRound ? parseFloat(pair && pair[0]) : parseInt(pair && pair[0], 10);
    var v = preventRound ? parseFloat(pair && pair[1]) : parseInt(pair && pair[1], 10);
    if (!isFinite(h)) h = 0;
    if (!isFinite(v)) v = h;
    return {
        h: h,
        v: v
    };
};
var $2066dbf5cfb8397c$var$getKeyHash = function(key) {
    if (key instanceof $2066dbf5cfb8397c$var$_guid2.default) return key.toString();
    else {
        if ((0, $kDRxH.isObject)(key) || Array.isArray(key)) try {
            var keyHash = JSON.stringify(key);
            return "{}" === keyHash ? key : keyHash;
        } catch (e) {
            return key;
        }
    }
    return key;
};
var $2066dbf5cfb8397c$var$escapeRegExp = function(string) {
    return string.replace(/[[\]{}\-()*+?.\\^$|\s]/g, "\\$&");
};
var $2066dbf5cfb8397c$var$applyServerDecimalSeparator = function(value) {
    var separator = (0, $2066dbf5cfb8397c$var$_config2.default)().serverDecimalSeparator;
    if ((0, $kDRxH.isDefined)(value)) value = value.toString().replace(".", separator);
    return value;
};
var $2066dbf5cfb8397c$var$noop = function() {};
var $2066dbf5cfb8397c$var$asyncNoop = function() {
    return (new $2F60d.Deferred).resolve().promise();
};
var $2066dbf5cfb8397c$var$grep = function(elements, checkFunction, invert) {
    var result = [];
    var expectedCheck = !invert;
    for(var i = 0; i < elements.length; i++){
        var check = !!checkFunction(elements[i], i);
        if (check === expectedCheck) result.push(elements[i]);
    }
    return result;
};
var $2066dbf5cfb8397c$var$arraysEqualByValue = function(array1, array2, depth) {
    if (array1.length !== array2.length) return false;
    for(var i = 0; i < array1.length; i++){
        if (!$2066dbf5cfb8397c$var$equalByValue(array1[i], array2[i], depth + 1)) return false;
    }
    return true;
};
var $2066dbf5cfb8397c$var$objectsEqualByValue = function(object1, object2, depth, strict) {
    for(var propertyName in object1){
        if (Object.prototype.hasOwnProperty.call(object1, propertyName) && !$2066dbf5cfb8397c$var$equalByValue(object1[propertyName], object2[propertyName], depth + 1, strict)) return false;
    }
    for(var _propertyName in object2){
        if (!(_propertyName in object1)) return false;
    }
    return true;
};
var $2066dbf5cfb8397c$var$maxEqualityDepth = 3;
var $2066dbf5cfb8397c$var$equalByValue = function(object1, object2) {
    var depth = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0;
    var strict = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : true;
    object1 = (0, $kpjzB.toComparable)(object1, true);
    object2 = (0, $kpjzB.toComparable)(object2, true);
    var comparisonResult = strict ? object1 === object2 : object1 == object2;
    if (comparisonResult || depth >= $2066dbf5cfb8397c$var$maxEqualityDepth) return true;
    if ((0, $kDRxH.isObject)(object1) && (0, $kDRxH.isObject)(object2)) return $2066dbf5cfb8397c$var$objectsEqualByValue(object1, object2, depth, strict);
    else {
        if (Array.isArray(object1) && Array.isArray(object2)) return $2066dbf5cfb8397c$var$arraysEqualByValue(object1, object2, depth);
    }
    return false;
};
$2066dbf5cfb8397c$export$e700b866474dec26 = $2066dbf5cfb8397c$var$ensureDefined;
$2066dbf5cfb8397c$export$565669a538b226a6 = $2066dbf5cfb8397c$var$executeAsync;
$2066dbf5cfb8397c$export$9f991a1dc8c2af5b = $2066dbf5cfb8397c$var$deferRender;
$2066dbf5cfb8397c$export$420e8e898c79212f = $2066dbf5cfb8397c$var$deferRenderer;
$2066dbf5cfb8397c$export$5c2413d24bb6a40f = $2066dbf5cfb8397c$var$deferUpdate;
$2066dbf5cfb8397c$export$e749563bae0b9d5c = $2066dbf5cfb8397c$var$deferUpdater;
$2066dbf5cfb8397c$export$aa6ab5672b20676f = $2066dbf5cfb8397c$var$pairToObject;
$2066dbf5cfb8397c$export$430720914e9be270 = $2066dbf5cfb8397c$var$splitPair;
$2066dbf5cfb8397c$export$6a7738807e7f2c17 = $2066dbf5cfb8397c$var$findBestMatches;
$2066dbf5cfb8397c$export$e0c709538cb8ae18 = $2066dbf5cfb8397c$var$normalizeKey;
$2066dbf5cfb8397c$export$4f22be2962df6eb9 = $2066dbf5cfb8397c$var$denormalizeKey;
$2066dbf5cfb8397c$export$ac5b0c7e11c08cd4 = $2066dbf5cfb8397c$var$getKeyHash;
$2066dbf5cfb8397c$export$7c57da42ce8e346f = $2066dbf5cfb8397c$var$escapeRegExp;
$2066dbf5cfb8397c$export$2ad35a62dfcae12a = $2066dbf5cfb8397c$var$applyServerDecimalSeparator;
$2066dbf5cfb8397c$export$8793edee2d425525 = $2066dbf5cfb8397c$var$noop;
$2066dbf5cfb8397c$export$21e1ac03cdd918b0 = $2066dbf5cfb8397c$var$asyncNoop;
$2066dbf5cfb8397c$export$41ee50d8efec7aa7 = $2066dbf5cfb8397c$var$grep;
$2066dbf5cfb8397c$export$e45a697a0958a5f = $2066dbf5cfb8397c$var$equalByValue;

});
parcelRegister("duKPB", function(module, exports) {
/**
 * DevExtreme (core/guid.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $k7aJb = parcelRequire("k7aJb");
var $9d32676f41f6dc0b$var$Guid = $k7aJb.inherit({
    ctor: function(value) {
        if (value) value = String(value);
        this._value = this._normalize(value || this._generate());
    },
    _normalize: function(value) {
        value = value.replace(/[^a-f0-9]/gi, "").toLowerCase();
        while(value.length < 32)value += "0";
        return [
            value.substr(0, 8),
            value.substr(8, 4),
            value.substr(12, 4),
            value.substr(16, 4),
            value.substr(20, 12)
        ].join("-");
    },
    _generate: function() {
        var value = "";
        for(var i = 0; i < 32; i++)value += Math.round(15 * Math.random()).toString(16);
        return value;
    },
    toString: function() {
        return this._value;
    },
    valueOf: function() {
        return this._value;
    },
    toJSON: function() {
        return this._value;
    }
});
module.exports = $9d32676f41f6dc0b$var$Guid;
module.exports.default = module.exports;

});

parcelRegister("2F60d", function(module, exports) {

$parcel$export(module.exports, "fromPromise", () => $1f04110d9463f8c7$export$60f45028237c39d1, (v) => $1f04110d9463f8c7$export$60f45028237c39d1 = v);
$parcel$export(module.exports, "Deferred", () => $1f04110d9463f8c7$export$85f6557964517f1a, (v) => $1f04110d9463f8c7$export$85f6557964517f1a = v);
$parcel$export(module.exports, "when", () => $1f04110d9463f8c7$export$a55877ca9db47377, (v) => $1f04110d9463f8c7$export$a55877ca9db47377 = v);
/**
 * DevExtreme (core/utils/deferred.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $1f04110d9463f8c7$export$60f45028237c39d1;
var $1f04110d9463f8c7$export$8dd000f7a8e65512;
var $1f04110d9463f8c7$export$85f6557964517f1a;
var $1f04110d9463f8c7$export$a55877ca9db47377;
"use strict";

var $kDRxH = parcelRequire("kDRxH");
var $1f04110d9463f8c7$var$isPromise = $kDRxH.isPromise;
var $1f04110d9463f8c7$var$isDeferred = $kDRxH.isDeferred;

var $7I8Uw = parcelRequire("7I8Uw");
var $1f04110d9463f8c7$require$extend = $7I8Uw.extend;

var $eKdKS = parcelRequire("eKdKS");
var $1f04110d9463f8c7$var$deferredConfig = [
    {
        method: "resolve",
        handler: "done",
        state: "resolved"
    },
    {
        method: "reject",
        handler: "fail",
        state: "rejected"
    },
    {
        method: "notify",
        handler: "progress"
    }
];
var $1f04110d9463f8c7$var$_Deferred = function() {
    var that = this;
    this._state = "pending";
    this._promise = {};
    $1f04110d9463f8c7$var$deferredConfig.forEach((function(config) {
        var methodName = config.method;
        this[methodName + "Callbacks"] = new $eKdKS;
        this[methodName] = (function() {
            return this[methodName + "With"](this._promise, arguments);
        }).bind(this);
        this._promise[config.handler] = function(handler) {
            if (!handler) return this;
            var callbacks = that[methodName + "Callbacks"];
            if (callbacks.fired()) handler.apply(that[methodName + "Context"], that[methodName + "Args"]);
            else callbacks.add((function(context, args) {
                handler.apply(context, args);
            }).bind(this));
            return this;
        };
    }).bind(this));
    this._promise.always = function(handler) {
        return this.done(handler).fail(handler);
    };
    this._promise.catch = function(handler) {
        return this.then(null, handler);
    };
    this._promise.then = function(resolve, reject) {
        var result = new $1f04110d9463f8c7$var$_Deferred;
        [
            "done",
            "fail"
        ].forEach((function(method) {
            var callback = "done" === method ? resolve : reject;
            this[method](function() {
                if (!callback) {
                    result["done" === method ? "resolve" : "reject"].apply(this, arguments);
                    return;
                }
                var callbackResult = callback && callback.apply(this, arguments);
                if ($1f04110d9463f8c7$var$isDeferred(callbackResult)) callbackResult.done(result.resolve).fail(result.reject);
                else if ($1f04110d9463f8c7$var$isPromise(callbackResult)) callbackResult.then(result.resolve, result.reject);
                else result.resolve.apply(this, $kDRxH.isDefined(callbackResult) ? [
                    callbackResult
                ] : arguments);
            });
        }).bind(this));
        return result.promise();
    };
    this._promise.state = function() {
        return that._state;
    };
    this._promise.promise = function(args) {
        return args ? $1f04110d9463f8c7$require$extend(args, that._promise) : that._promise;
    };
    this._promise.promise(this);
};
$1f04110d9463f8c7$var$deferredConfig.forEach(function(config) {
    var methodName = config.method;
    var state = config.state;
    $1f04110d9463f8c7$var$_Deferred.prototype[methodName + "With"] = function(context, args) {
        var callbacks = this[methodName + "Callbacks"];
        if ("pending" === this.state()) {
            this[methodName + "Args"] = args;
            this[methodName + "Context"] = context;
            if (state) this._state = state;
            callbacks.fire(context, args);
        }
        return this;
    };
});
$1f04110d9463f8c7$export$60f45028237c39d1 = function(promise, context) {
    if ($1f04110d9463f8c7$var$isDeferred(promise)) return promise;
    else if ($1f04110d9463f8c7$var$isPromise(promise)) {
        var d = new $1f04110d9463f8c7$var$_Deferred;
        promise.then(function() {
            d.resolveWith.apply(d, [
                context
            ].concat([
                [].slice.call(arguments)
            ]));
        }, function() {
            d.rejectWith.apply(d, [
                context
            ].concat([
                [].slice.call(arguments)
            ]));
        });
        return d;
    }
    return (new $1f04110d9463f8c7$var$_Deferred).resolveWith(context, [
        promise
    ]);
};
var $1f04110d9463f8c7$var$when = function() {
    if (1 === arguments.length) return $1f04110d9463f8c7$export$60f45028237c39d1(arguments[0]);
    var values = [].slice.call(arguments);
    var contexts = [];
    var resolvedCount = 0;
    var deferred = new $1f04110d9463f8c7$var$_Deferred;
    var updateState = function(i) {
        return function(value) {
            contexts[i] = this;
            values[i] = arguments.length > 1 ? [].slice.call(arguments) : value;
            resolvedCount++;
            if (resolvedCount === values.length) deferred.resolveWith(contexts, values);
        };
    };
    for(var i = 0; i < values.length; i++)if ($1f04110d9463f8c7$var$isDeferred(values[i])) values[i].promise().done(updateState(i)).fail(deferred.reject);
    else resolvedCount++;
    if (resolvedCount === values.length) deferred.resolveWith(contexts, values);
    return deferred.promise();
};
$1f04110d9463f8c7$export$8dd000f7a8e65512 = function(value) {
    $1f04110d9463f8c7$var$_Deferred = value.Deferred;
    $1f04110d9463f8c7$var$when = value.when;
};
$1f04110d9463f8c7$export$85f6557964517f1a = function() {
    return new $1f04110d9463f8c7$var$_Deferred;
};
$1f04110d9463f8c7$export$a55877ca9db47377 = function() {
    return $1f04110d9463f8c7$var$when.apply(this, arguments);
};

});
parcelRegister("eKdKS", function(module, exports) {
/**
 * DevExtreme (core/utils/callbacks.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
var $abc0080d3e8a19f3$var$Callback = function(options) {
    this._options = options || {};
    this._list = [];
    this._queue = [];
    this._firing = false;
    this._fired = false;
    this._firingIndexes = [];
};
$abc0080d3e8a19f3$var$Callback.prototype._fireCore = function(context, args) {
    var firingIndexes = this._firingIndexes;
    var list = this._list;
    var stopOnFalse = this._options.stopOnFalse;
    var step = firingIndexes.length;
    for(firingIndexes[step] = 0; firingIndexes[step] < list.length; firingIndexes[step]++){
        var result = list[firingIndexes[step]].apply(context, args);
        if (false === result && stopOnFalse) break;
    }
    firingIndexes.pop();
};
$abc0080d3e8a19f3$var$Callback.prototype.add = function(fn) {
    if ("function" === typeof fn && (!this._options.unique || !this.has(fn))) this._list.push(fn);
    return this;
};
$abc0080d3e8a19f3$var$Callback.prototype.remove = function(fn) {
    var list = this._list;
    var firingIndexes = this._firingIndexes;
    var index = list.indexOf(fn);
    if (index > -1) {
        list.splice(index, 1);
        if (this._firing && firingIndexes.length) {
            for(var step = 0; step < firingIndexes.length; step++)if (index <= firingIndexes[step]) firingIndexes[step]--;
        }
    }
    return this;
};
$abc0080d3e8a19f3$var$Callback.prototype.has = function(fn) {
    var list = this._list;
    return fn ? list.indexOf(fn) > -1 : !!list.length;
};
$abc0080d3e8a19f3$var$Callback.prototype.empty = function(fn) {
    this._list = [];
    return this;
};
$abc0080d3e8a19f3$var$Callback.prototype.fireWith = function(context, args) {
    var queue = this._queue;
    args = args || [];
    args = args.slice ? args.slice() : args;
    if (this._options.syncStrategy) {
        this._firing = true;
        this._fireCore(context, args);
    } else {
        queue.push([
            context,
            args
        ]);
        if (this._firing) return;
        this._firing = true;
        while(queue.length){
            var memory = queue.shift();
            this._fireCore(memory[0], memory[1]);
        }
    }
    this._firing = false;
    this._fired = true;
    return this;
};
$abc0080d3e8a19f3$var$Callback.prototype.fire = function() {
    this.fireWith(this, arguments);
};
$abc0080d3e8a19f3$var$Callback.prototype.fired = function() {
    return this._fired;
};
var $abc0080d3e8a19f3$var$Callbacks = function(options) {
    return new $abc0080d3e8a19f3$var$Callback(options);
};
module.exports = $abc0080d3e8a19f3$var$Callbacks;

});


parcelRegister("kpjzB", function(module, exports) {

$parcel$export(module.exports, "compileGetter", () => $edb55349926d19d9$export$b94f2b067360ed6e, (v) => $edb55349926d19d9$export$b94f2b067360ed6e = v);
$parcel$export(module.exports, "compileSetter", () => $edb55349926d19d9$export$41547815519095bf, (v) => $edb55349926d19d9$export$41547815519095bf = v);
$parcel$export(module.exports, "toComparable", () => $edb55349926d19d9$export$6a23b1608a834d73, (v) => $edb55349926d19d9$export$6a23b1608a834d73 = v);
$parcel$export(module.exports, "bracketsToDots", () => $edb55349926d19d9$export$da1f5e673e3822fc, (v) => $edb55349926d19d9$export$da1f5e673e3822fc = v);
/**
 * DevExtreme (core/utils/data.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $edb55349926d19d9$export$b94f2b067360ed6e;
var $edb55349926d19d9$export$41547815519095bf;
var $edb55349926d19d9$export$6a23b1608a834d73;
var $edb55349926d19d9$export$da1f5e673e3822fc;
"use strict";

var $7sX7V = parcelRequire("7sX7V");

var $k7aJb = parcelRequire("k7aJb");

var $6l2Qk = parcelRequire("6l2Qk");

var $kDRxH = parcelRequire("kDRxH");

var $4Pwuy = parcelRequire("4Pwuy");
var $edb55349926d19d9$require$each = $4Pwuy.each;

var $ht93C = parcelRequire("ht93C");
var $edb55349926d19d9$var$unwrapVariable = $ht93C.unwrap;
var $edb55349926d19d9$var$isWrapped = $ht93C.isWrapped;
var $edb55349926d19d9$var$assign = $ht93C.assign;
var $edb55349926d19d9$var$bracketsToDots = function(expr) {
    return expr.replace(/\[/g, ".").replace(/\]/g, "");
};
var $edb55349926d19d9$var$readPropValue = function(obj, propName, options) {
    options = options || {};
    if ("this" === propName) return $edb55349926d19d9$var$unwrap(obj, options);
    return $edb55349926d19d9$var$unwrap(obj[propName], options);
};
var $edb55349926d19d9$var$assignPropValue = function(obj, propName, value, options) {
    if ("this" === propName) throw new $7sX7V.Error("E4016");
    var propValue = obj[propName];
    if (options.unwrapObservables && $edb55349926d19d9$var$isWrapped(propValue)) $edb55349926d19d9$var$assign(propValue, value);
    else obj[propName] = value;
};
var $edb55349926d19d9$var$prepareOptions = function(options) {
    options = options || {};
    options.unwrapObservables = void 0 !== options.unwrapObservables ? options.unwrapObservables : true;
    return options;
};
var $edb55349926d19d9$var$unwrap = function(value, options) {
    return options.unwrapObservables ? $edb55349926d19d9$var$unwrapVariable(value) : value;
};
var $edb55349926d19d9$var$compileGetter = function(expr) {
    if (arguments.length > 1) expr = [].slice.call(arguments);
    if (!expr || "this" === expr) return function(obj) {
        return obj;
    };
    if ("string" === typeof expr) {
        expr = $edb55349926d19d9$var$bracketsToDots(expr);
        var path = expr.split(".");
        return function(obj, options) {
            options = $edb55349926d19d9$var$prepareOptions(options);
            var functionAsIs = options.functionsAsIs;
            var hasDefaultValue = "defaultValue" in options;
            var current = $edb55349926d19d9$var$unwrap(obj, options);
            for(var i = 0; i < path.length; i++){
                if (!current) {
                    if (null == current && hasDefaultValue) return options.defaultValue;
                    break;
                }
                var pathPart = path[i];
                if (hasDefaultValue && $kDRxH.isObject(current) && !(pathPart in current)) return options.defaultValue;
                var next = $edb55349926d19d9$var$unwrap(current[pathPart], options);
                if (!functionAsIs && $kDRxH.isFunction(next)) next = next.call(current);
                current = next;
            }
            return current;
        };
    }
    if (Array.isArray(expr)) return $edb55349926d19d9$var$combineGetters(expr);
    if ($kDRxH.isFunction(expr)) return expr;
};
var $edb55349926d19d9$var$combineGetters = function(getters) {
    var compiledGetters = {};
    for(var i = 0, l = getters.length; i < l; i++){
        var getter = getters[i];
        compiledGetters[getter] = $edb55349926d19d9$var$compileGetter(getter);
    }
    return function(obj, options) {
        var result;
        $edb55349926d19d9$require$each(compiledGetters, function(name) {
            var value = this(obj, options);
            var current;
            if (void 0 === value) return;
            current = result || (result = {});
            var path = name.split(".");
            var last = path.length - 1;
            for(var _i = 0; _i < last; _i++){
                var pathItem = path[_i];
                if (!(pathItem in current)) current[pathItem] = {};
                current = current[pathItem];
            }
            current[path[last]] = value;
        });
        return result;
    };
};
var $edb55349926d19d9$var$ensurePropValueDefined = function(obj, propName, value, options) {
    if ($kDRxH.isDefined(value)) return value;
    var newValue = {};
    $edb55349926d19d9$var$assignPropValue(obj, propName, newValue, options);
    return newValue;
};
var $edb55349926d19d9$var$compileSetter = function(expr) {
    expr = $edb55349926d19d9$var$bracketsToDots(expr || "this").split(".");
    var lastLevelIndex = expr.length - 1;
    return function(obj, value, options) {
        options = $edb55349926d19d9$var$prepareOptions(options);
        var currentValue = $edb55349926d19d9$var$unwrap(obj, options);
        expr.forEach(function(propertyName, levelIndex) {
            var propertyValue = $edb55349926d19d9$var$readPropValue(currentValue, propertyName, options);
            var isPropertyFunc = !options.functionsAsIs && $kDRxH.isFunction(propertyValue) && !$edb55349926d19d9$var$isWrapped(propertyValue);
            if (levelIndex === lastLevelIndex) {
                if (options.merge && $kDRxH.isPlainObject(value) && (!$kDRxH.isDefined(propertyValue) || $kDRxH.isPlainObject(propertyValue))) {
                    propertyValue = $edb55349926d19d9$var$ensurePropValueDefined(currentValue, propertyName, propertyValue, options);
                    $6l2Qk.deepExtendArraySafe(propertyValue, value, false, true);
                } else if (isPropertyFunc) currentValue[propertyName](value);
                else $edb55349926d19d9$var$assignPropValue(currentValue, propertyName, value, options);
            } else {
                propertyValue = $edb55349926d19d9$var$ensurePropValueDefined(currentValue, propertyName, propertyValue, options);
                if (isPropertyFunc) propertyValue = propertyValue.call(currentValue);
                currentValue = propertyValue;
            }
        });
    };
};
var $edb55349926d19d9$var$toComparable = function(value, caseSensitive) {
    if (value instanceof Date) return value.getTime();
    if (value && value instanceof $k7aJb && value.valueOf) return value.valueOf();
    if (!caseSensitive && "string" === typeof value) return value.toLowerCase();
    return value;
};
$edb55349926d19d9$export$b94f2b067360ed6e = $edb55349926d19d9$var$compileGetter;
$edb55349926d19d9$export$41547815519095bf = $edb55349926d19d9$var$compileSetter;
$edb55349926d19d9$export$6a23b1608a834d73 = $edb55349926d19d9$var$toComparable;
$edb55349926d19d9$export$da1f5e673e3822fc = $edb55349926d19d9$var$bracketsToDots;

});





parcelRegister("e1LMc", function(module, exports) {
/**
 * DevExtreme (events/core/events_engine.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
function $a3663813d74593dd$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $a3663813d74593dd$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $a3663813d74593dd$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a3663813d74593dd$var$_typeof(obj);
}

var $i1ezC = parcelRequire("i1ezC");

var $7I8Uw = parcelRequire("7I8Uw");
var $a3663813d74593dd$require$extend = $7I8Uw.extend;

var $445Bz = parcelRequire("445Bz");

var $irv64 = parcelRequire("irv64");
var $a3663813d74593dd$var$window = $irv64.getWindow();

var $6LNcw = parcelRequire("6LNcw");

var $kDRxH = parcelRequire("kDRxH");

var $eKdKS = parcelRequire("eKdKS");
var $a3663813d74593dd$var$isWindow = $kDRxH.isWindow;
var $a3663813d74593dd$var$isFunction = $kDRxH.isFunction;
var $a3663813d74593dd$var$isString = $kDRxH.isString;

var $7sX7V = parcelRequire("7sX7V");

var $5ySaA = parcelRequire("5ySaA");

var $7os6p = parcelRequire("7os6p");

var $ePlHj = parcelRequire("ePlHj");
var $a3663813d74593dd$var$EMPTY_EVENT_NAME = "dxEmptyEventType";
var $a3663813d74593dd$var$NATIVE_EVENTS_TO_SUBSCRIBE = {
    mouseenter: "mouseover",
    mouseleave: "mouseout",
    pointerenter: "pointerover",
    pointerleave: "pointerout"
};
var $a3663813d74593dd$var$NATIVE_EVENTS_TO_TRIGGER = {
    focusin: "focus",
    focusout: "blur"
};
var $a3663813d74593dd$var$NO_BUBBLE_EVENTS = [
    "blur",
    "focus",
    "load"
];
var $a3663813d74593dd$var$forcePassiveFalseEventNames = [
    "touchmove",
    "wheel",
    "mousewheel",
    "touchstart"
];
var $a3663813d74593dd$var$matchesSafe = function(target, selector) {
    return !$a3663813d74593dd$var$isWindow(target) && "#document" !== target.nodeName && $445Bz.elementMatches(target, selector);
};
var $a3663813d74593dd$var$elementDataMap = new $5ySaA;
var $a3663813d74593dd$var$guid = 0;
var $a3663813d74593dd$var$skipEvent;
var $a3663813d74593dd$var$special = function() {
    var specialData = {};
    $i1ezC.add(function(eventName, eventObject) {
        specialData[eventName] = eventObject;
    });
    return {
        getField: function(eventName, field) {
            return specialData[eventName] && specialData[eventName][field];
        },
        callMethod: function(eventName, methodName, context, args) {
            return specialData[eventName] && specialData[eventName][methodName] && specialData[eventName][methodName].apply(context, args);
        }
    };
}();
var $a3663813d74593dd$var$applyForEach = function applyForEach(args, method) {
    var element = args[0];
    if (!element) return;
    if ($445Bz.isNode(element) || $a3663813d74593dd$var$isWindow(element)) method.apply($a3663813d74593dd$var$eventsEngine, args);
    else {
        if (!$a3663813d74593dd$var$isString(element) && "length" in element) {
            var itemArgs = Array.prototype.slice.call(args, 0);
            Array.prototype.forEach.call(element, function(itemElement) {
                itemArgs[0] = itemElement;
                applyForEach(itemArgs, method);
            });
        } else throw $7sX7V.Error("E0025");
    }
};
var $a3663813d74593dd$var$getHandler = function(method) {
    return function() {
        $a3663813d74593dd$var$applyForEach(arguments, method);
    };
};
var $a3663813d74593dd$var$detectPassiveEventHandlersSupport = function() {
    var isSupported = false;
    try {
        var options = Object.defineProperty({}, "passive", {
            get: function() {
                isSupported = true;
                return true;
            }
        });
        $a3663813d74593dd$var$window.addEventListener("test", null, options);
    } catch (e) {}
    return isSupported;
};
var $a3663813d74593dd$var$passiveEventHandlersSupported = $ePlHj($a3663813d74593dd$var$detectPassiveEventHandlersSupport);
var $a3663813d74593dd$var$getHandlersController = function(element, eventName) {
    var elementData = $a3663813d74593dd$var$elementDataMap.get(element);
    eventName = eventName || "";
    var eventNameParts = eventName.split(".");
    var namespaces = eventNameParts.slice(1);
    var eventNameIsDefined = !!eventNameParts[0];
    eventName = eventNameParts[0] || $a3663813d74593dd$var$EMPTY_EVENT_NAME;
    if (!elementData) {
        elementData = {};
        $a3663813d74593dd$var$elementDataMap.set(element, elementData);
    }
    if (!elementData[eventName]) elementData[eventName] = {
        handleObjects: [],
        nativeHandler: null
    };
    var eventData = elementData[eventName];
    return {
        addHandler: function(handler, selector, data) {
            var callHandler = function(e, extraParameters) {
                var handlerArgs = [
                    e
                ];
                var target = e.currentTarget;
                var relatedTarget = e.relatedTarget;
                var secondaryTargetIsInside;
                var result;
                if (eventName in $a3663813d74593dd$var$NATIVE_EVENTS_TO_SUBSCRIBE) secondaryTargetIsInside = relatedTarget && target && (relatedTarget === target || target.contains(relatedTarget));
                if (void 0 !== extraParameters) handlerArgs.push(extraParameters);
                $a3663813d74593dd$var$special.callMethod(eventName, "handle", element, [
                    e,
                    data
                ]);
                if (!secondaryTargetIsInside) result = handler.apply(target, handlerArgs);
                if (false === result) {
                    e.preventDefault();
                    e.stopPropagation();
                }
            };
            var wrappedHandler = function(e, extraParameters) {
                if ($a3663813d74593dd$var$skipEvent && e.type === $a3663813d74593dd$var$skipEvent) return;
                e.data = data;
                e.delegateTarget = element;
                if (selector) {
                    var currentTarget = e.target;
                    while(currentTarget && currentTarget !== element){
                        if ($a3663813d74593dd$var$matchesSafe(currentTarget, selector)) {
                            e.currentTarget = currentTarget;
                            callHandler(e, extraParameters);
                        }
                        currentTarget = currentTarget.parentNode;
                    }
                } else {
                    e.currentTarget = e.delegateTarget || e.target;
                    callHandler(e, extraParameters);
                }
            };
            var handleObject = {
                handler: handler,
                wrappedHandler: wrappedHandler,
                selector: selector,
                type: eventName,
                data: data,
                namespace: namespaces.join("."),
                namespaces: namespaces,
                guid: ++$a3663813d74593dd$var$guid
            };
            eventData.handleObjects.push(handleObject);
            var firstHandlerForTheType = 1 === eventData.handleObjects.length;
            var shouldAddNativeListener = firstHandlerForTheType && eventNameIsDefined;
            var nativeListenerOptions;
            if (shouldAddNativeListener) shouldAddNativeListener = !$a3663813d74593dd$var$special.callMethod(eventName, "setup", element, [
                data,
                namespaces,
                handler
            ]);
            if (shouldAddNativeListener) {
                eventData.nativeHandler = $a3663813d74593dd$var$getNativeHandler(eventName);
                if ($a3663813d74593dd$var$passiveEventHandlersSupported() && $a3663813d74593dd$var$forcePassiveFalseEventNames.indexOf(eventName) > -1) nativeListenerOptions = {
                    passive: false
                };
                eventData.removeListener = $445Bz.listen(element, $a3663813d74593dd$var$NATIVE_EVENTS_TO_SUBSCRIBE[eventName] || eventName, eventData.nativeHandler, nativeListenerOptions);
            }
            $a3663813d74593dd$var$special.callMethod(eventName, "add", element, [
                handleObject
            ]);
        },
        removeHandler: function(handler, selector) {
            var removeByEventName = function(eventName) {
                var eventData = elementData[eventName];
                if (!eventData.handleObjects.length) {
                    delete elementData[eventName];
                    return;
                }
                var removedHandler;
                eventData.handleObjects = eventData.handleObjects.filter(function(handleObject) {
                    var skip = namespaces.length && !$a3663813d74593dd$var$isSubset(handleObject.namespaces, namespaces) || handler && handleObject.handler !== handler || selector && handleObject.selector !== selector;
                    if (!skip) {
                        removedHandler = handleObject.handler;
                        $a3663813d74593dd$var$special.callMethod(eventName, "remove", element, [
                            handleObject
                        ]);
                    }
                    return skip;
                });
                var lastHandlerForTheType = !eventData.handleObjects.length;
                var shouldRemoveNativeListener = lastHandlerForTheType && eventName !== $a3663813d74593dd$var$EMPTY_EVENT_NAME;
                if (shouldRemoveNativeListener) {
                    $a3663813d74593dd$var$special.callMethod(eventName, "teardown", element, [
                        namespaces,
                        removedHandler
                    ]);
                    if (eventData.nativeHandler) eventData.removeListener();
                    delete elementData[eventName];
                }
            };
            if (eventNameIsDefined) removeByEventName(eventName);
            else for(var name in elementData)removeByEventName(name);
            var elementDataIsEmpty = 0 === Object.keys(elementData).length;
            if (elementDataIsEmpty) $a3663813d74593dd$var$elementDataMap.delete(element);
        },
        callHandlers: function(event, extraParameters) {
            var forceStop = false;
            var handleCallback = function(handleObject) {
                if (forceStop) return;
                if (!namespaces.length || $a3663813d74593dd$var$isSubset(handleObject.namespaces, namespaces)) {
                    handleObject.wrappedHandler(event, extraParameters);
                    forceStop = event.isImmediatePropagationStopped();
                }
            };
            eventData.handleObjects.forEach(handleCallback);
            if (namespaces.length && elementData[$a3663813d74593dd$var$EMPTY_EVENT_NAME]) elementData[$a3663813d74593dd$var$EMPTY_EVENT_NAME].handleObjects.forEach(handleCallback);
        }
    };
};
var $a3663813d74593dd$var$getNativeHandler = function(subscribeName) {
    return function(event, extraParameters) {
        var handlersController = $a3663813d74593dd$var$getHandlersController(this, subscribeName);
        event = $a3663813d74593dd$var$eventsEngine.Event(event);
        handlersController.callHandlers(event, extraParameters);
    };
};
var $a3663813d74593dd$var$isSubset = function(original, checked) {
    for(var i = 0; i < checked.length; i++){
        if (original.indexOf(checked[i]) < 0) return false;
    }
    return true;
};
var $a3663813d74593dd$var$normalizeOnArguments = function(callback) {
    return function(element, eventName, selector, data, handler) {
        if (!handler) {
            handler = data;
            data = void 0;
        }
        if ("string" !== typeof selector) {
            data = selector;
            selector = void 0;
        }
        if (!handler && "string" === typeof eventName) {
            handler = data || selector;
            selector = void 0;
            data = void 0;
        }
        callback(element, eventName, selector, data, handler);
    };
};
var $a3663813d74593dd$var$normalizeOffArguments = function(callback) {
    return function(element, eventName, selector, handler) {
        if ("function" === typeof selector) {
            handler = selector;
            selector = void 0;
        }
        callback(element, eventName, selector, handler);
    };
};
var $a3663813d74593dd$var$normalizeTriggerArguments = function(callback) {
    return function(element, src, extraParameters) {
        if ("string" === typeof src) src = {
            type: src
        };
        if (!src.target) src.target = element;
        src.currentTarget = element;
        if (!src.delegateTarget) src.delegateTarget = element;
        if (!src.type && src.originalEvent) src.type = src.originalEvent.type;
        callback(element, src instanceof $a3663813d74593dd$var$eventsEngine.Event ? src : $a3663813d74593dd$var$eventsEngine.Event(src), extraParameters);
    };
};
var $a3663813d74593dd$var$normalizeEventArguments = function(callback) {
    return function(src, config) {
        if (!(this instanceof $a3663813d74593dd$var$eventsEngine.Event)) return new $a3663813d74593dd$var$eventsEngine.Event(src, config);
        if (!src) src = {};
        if ("string" === typeof src) src = {
            type: src
        };
        if (!config) config = {};
        callback.call(this, src, config);
    };
};
var $a3663813d74593dd$var$iterate = function(callback) {
    var iterateEventNames = function(element, eventName) {
        if (eventName && eventName.indexOf(" ") > -1) {
            var args = Array.prototype.slice.call(arguments, 0);
            eventName.split(" ").forEach(function(eventName) {
                args[1] = eventName;
                callback.apply(this, args);
            });
        } else callback.apply(this, arguments);
    };
    return function(element, eventName) {
        if ("object" === $a3663813d74593dd$var$_typeof(eventName)) {
            var args = Array.prototype.slice.call(arguments, 0);
            for(var name in eventName){
                args[1] = name;
                args[args.length - 1] = eventName[name];
                iterateEventNames.apply(this, args);
            }
        } else iterateEventNames.apply(this, arguments);
    };
};
var $a3663813d74593dd$var$callNativeMethod = function(eventName, element) {
    var nativeMethodName = $a3663813d74593dd$var$NATIVE_EVENTS_TO_TRIGGER[eventName] || eventName;
    var isLinkClickEvent = function(eventName, element) {
        return "click" === eventName && "a" === element.localName;
    };
    if (isLinkClickEvent(eventName, element)) return;
    if ($a3663813d74593dd$var$isFunction(element[nativeMethodName])) {
        $a3663813d74593dd$var$skipEvent = eventName;
        element[nativeMethodName]();
        $a3663813d74593dd$var$skipEvent = void 0;
    }
};
var $a3663813d74593dd$var$calculateWhich = function(event) {
    var setForMouseEvent = function(event) {
        var mouseEventRegex = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
        return !event.which && void 0 !== event.button && mouseEventRegex.test(event.type);
    };
    var setForKeyEvent = function(event) {
        return null == event.which && 0 === event.type.indexOf("key");
    };
    if (setForKeyEvent(event)) return null != event.charCode ? event.charCode : event.keyCode;
    if (setForMouseEvent(event)) {
        var whichByButton = {
            1: 1,
            2: 3,
            3: 1,
            4: 2
        };
        return whichByButton[event.button];
    }
    return event.which;
};
var $a3663813d74593dd$var$eventsEngine = $6LNcw({
    on: $a3663813d74593dd$var$getHandler($a3663813d74593dd$var$normalizeOnArguments($a3663813d74593dd$var$iterate(function(element, eventName, selector, data, handler) {
        var handlersController = $a3663813d74593dd$var$getHandlersController(element, eventName);
        handlersController.addHandler(handler, selector, data);
    }))),
    one: $a3663813d74593dd$var$getHandler($a3663813d74593dd$var$normalizeOnArguments(function(element, eventName, selector, data, handler) {
        var oneTimeHandler = function oneTimeHandler() {
            $a3663813d74593dd$var$eventsEngine.off(element, eventName, selector, oneTimeHandler);
            handler.apply(this, arguments);
        };
        $a3663813d74593dd$var$eventsEngine.on(element, eventName, selector, data, oneTimeHandler);
    })),
    off: $a3663813d74593dd$var$getHandler($a3663813d74593dd$var$normalizeOffArguments($a3663813d74593dd$var$iterate(function(element, eventName, selector, handler) {
        var handlersController = $a3663813d74593dd$var$getHandlersController(element, eventName);
        handlersController.removeHandler(handler, selector);
    }))),
    trigger: $a3663813d74593dd$var$getHandler($a3663813d74593dd$var$normalizeTriggerArguments(function(element, event, extraParameters) {
        var eventName = event.type;
        var handlersController = $a3663813d74593dd$var$getHandlersController(element, event.type);
        $a3663813d74593dd$var$special.callMethod(eventName, "trigger", element, [
            event,
            extraParameters
        ]);
        handlersController.callHandlers(event, extraParameters);
        var noBubble = $a3663813d74593dd$var$special.getField(eventName, "noBubble") || event.isPropagationStopped() || $a3663813d74593dd$var$NO_BUBBLE_EVENTS.indexOf(eventName) !== -1;
        if (!noBubble) {
            var parents = [];
            var getParents = function getParents(element) {
                var parent = element.parentNode;
                if (parent) {
                    parents.push(parent);
                    getParents(parent);
                }
            };
            getParents(element);
            parents.push($a3663813d74593dd$var$window);
            var i = 0;
            while(parents[i] && !event.isPropagationStopped()){
                var parentDataByEvent = $a3663813d74593dd$var$getHandlersController(parents[i], event.type);
                parentDataByEvent.callHandlers($a3663813d74593dd$require$extend(event, {
                    currentTarget: parents[i]
                }), extraParameters);
                i++;
            }
        }
        if (element.nodeType || $a3663813d74593dd$var$isWindow(element)) {
            $a3663813d74593dd$var$special.callMethod(eventName, "_default", element, [
                event,
                extraParameters
            ]);
            $a3663813d74593dd$var$callNativeMethod(eventName, element);
        }
    })),
    triggerHandler: $a3663813d74593dd$var$getHandler($a3663813d74593dd$var$normalizeTriggerArguments(function(element, event, extraParameters) {
        var handlersController = $a3663813d74593dd$var$getHandlersController(element, event.type);
        handlersController.callHandlers(event, extraParameters);
    }))
});
var $a3663813d74593dd$var$initEvent = function(EventClass) {
    if (EventClass) {
        $a3663813d74593dd$var$eventsEngine.Event = EventClass;
        $a3663813d74593dd$var$eventsEngine.Event.prototype = EventClass.prototype;
    }
};
$a3663813d74593dd$var$initEvent($a3663813d74593dd$var$normalizeEventArguments(function(src, config) {
    var that = this;
    var propagationStopped = false;
    var immediatePropagationStopped = false;
    var defaultPrevented = false;
    $a3663813d74593dd$require$extend(that, src);
    if (src instanceof $a3663813d74593dd$var$eventsEngine.Event || $irv64.hasWindow() && src instanceof $a3663813d74593dd$var$window.Event) {
        that.originalEvent = src;
        that.currentTarget = void 0;
    }
    if (!(src instanceof $a3663813d74593dd$var$eventsEngine.Event)) $a3663813d74593dd$require$extend(that, {
        isPropagationStopped: function() {
            return !!(propagationStopped || that.originalEvent && that.originalEvent.propagationStopped);
        },
        stopPropagation: function() {
            propagationStopped = true;
            that.originalEvent && that.originalEvent.stopPropagation();
        },
        isImmediatePropagationStopped: function() {
            return immediatePropagationStopped;
        },
        stopImmediatePropagation: function() {
            this.stopPropagation();
            immediatePropagationStopped = true;
            that.originalEvent && that.originalEvent.stopImmediatePropagation();
        },
        isDefaultPrevented: function() {
            return !!(defaultPrevented || that.originalEvent && that.originalEvent.defaultPrevented);
        },
        preventDefault: function() {
            defaultPrevented = true;
            that.originalEvent && that.originalEvent.preventDefault();
        }
    });
    $a3663813d74593dd$var$addProperty("which", $a3663813d74593dd$var$calculateWhich, that);
    if (0 === src.type.indexOf("touch")) {
        delete config.pageX;
        delete config.pageY;
    }
    $a3663813d74593dd$require$extend(that, config);
    that.guid = ++$a3663813d74593dd$var$guid;
}));
var $a3663813d74593dd$var$addProperty = function(propName, hook, eventInstance) {
    Object.defineProperty(eventInstance || $a3663813d74593dd$var$eventsEngine.Event.prototype, propName, {
        enumerable: true,
        configurable: true,
        get: function() {
            return this.originalEvent && hook(this.originalEvent);
        },
        set: function(value) {
            Object.defineProperty(this, propName, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: value
            });
        }
    });
};
$7os6p($a3663813d74593dd$var$addProperty);
var $a3663813d74593dd$var$beforeSetStrategy = $eKdKS();
var $a3663813d74593dd$var$afterSetStrategy = $eKdKS();
$a3663813d74593dd$var$eventsEngine.set = function(engine) {
    $a3663813d74593dd$var$beforeSetStrategy.fire();
    $a3663813d74593dd$var$eventsEngine.inject(engine);
    $a3663813d74593dd$var$initEvent(engine.Event);
    $a3663813d74593dd$var$afterSetStrategy.fire();
};
$a3663813d74593dd$var$eventsEngine.subscribeGlobal = function() {
    $a3663813d74593dd$var$applyForEach(arguments, $a3663813d74593dd$var$normalizeOnArguments(function() {
        var args = arguments;
        $a3663813d74593dd$var$eventsEngine.on.apply(this, args);
        $a3663813d74593dd$var$beforeSetStrategy.add(function() {
            var offArgs = Array.prototype.slice.call(args, 0);
            offArgs.splice(3, 1);
            $a3663813d74593dd$var$eventsEngine.off.apply(this, offArgs);
        });
        $a3663813d74593dd$var$afterSetStrategy.add(function() {
            $a3663813d74593dd$var$eventsEngine.on.apply(this, args);
        });
    }));
};
$a3663813d74593dd$var$eventsEngine.forcePassiveFalseEventNames = $a3663813d74593dd$var$forcePassiveFalseEventNames;
$a3663813d74593dd$var$eventsEngine.passiveEventHandlersSupported = $a3663813d74593dd$var$passiveEventHandlersSupported;
module.exports = $a3663813d74593dd$var$eventsEngine;

});
parcelRegister("i1ezC", function(module, exports) {
/**
 * DevExtreme (events/core/event_registrator_callbacks.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $2vY9D = parcelRequire("2vY9D");
module.exports = new $2vY9D;

});
parcelRegister("2vY9D", function(module, exports) {
/**
 * DevExtreme (core/memorized_callbacks.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $4Pwuy = parcelRequire("4Pwuy");
var $1d4d2368cb70b847$require$each = $4Pwuy.each;

var $eKdKS = parcelRequire("eKdKS");
var $1d4d2368cb70b847$var$MemorizedCallbacks = function() {
    var memory = [];
    var callbacks = $eKdKS();
    this.add = function(fn) {
        $1d4d2368cb70b847$require$each(memory, function(_, item) {
            fn.apply(fn, item);
        });
        callbacks.add(fn);
    };
    this.remove = function(fn) {
        callbacks.remove(fn);
    };
    this.fire = function() {
        memory.push(arguments);
        callbacks.fire.apply(callbacks, arguments);
    };
};
module.exports = $1d4d2368cb70b847$var$MemorizedCallbacks;

});


parcelRegister("7os6p", function(module, exports) {
/**
 * DevExtreme (events/core/hook_touch_props.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
var $562092db04784cd2$var$touchPropsToHook = [
    "pageX",
    "pageY",
    "screenX",
    "screenY",
    "clientX",
    "clientY"
];
var $562092db04784cd2$var$touchPropHook = function(name, event) {
    if (event[name] && !event.touches || !event.touches) return event[name];
    var touches = event.touches.length ? event.touches : event.changedTouches;
    if (!touches.length) return;
    return touches[0][name];
};
module.exports = function(callback) {
    $562092db04784cd2$var$touchPropsToHook.forEach(function(name) {
        callback(name, function(event) {
            return $562092db04784cd2$var$touchPropHook(name, event);
        });
    }, this);
};

});

parcelRegister("ePlHj", function(module, exports) {
/**
 * DevExtreme (core/utils/call_once.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
var $acb6a8cf49b47fd3$var$callOnce = function(handler) {
    var result;
    var _wrappedHandler = function() {
        result = handler.apply(this, arguments);
        _wrappedHandler = function() {
            return result;
        };
        return result;
    };
    return function() {
        return _wrappedHandler.apply(this, arguments);
    };
};
module.exports = $acb6a8cf49b47fd3$var$callOnce;

});



parcelRegister("9Z7y9", function(module, exports) {

$parcel$export(module.exports, "styleProp", () => $744faacd67cde365$export$5d4cd24aaf68552c, (v) => $744faacd67cde365$export$5d4cd24aaf68552c = v);
$parcel$export(module.exports, "stylePropPrefix", () => $744faacd67cde365$export$3dcfa7045287299, (v) => $744faacd67cde365$export$3dcfa7045287299 = v);
$parcel$export(module.exports, "normalizeStyleProp", () => $744faacd67cde365$export$84da894514267528, (v) => $744faacd67cde365$export$84da894514267528 = v);
$parcel$export(module.exports, "setWidth", () => $744faacd67cde365$export$67f48e0594af05d, (v) => $744faacd67cde365$export$67f48e0594af05d = v);
$parcel$export(module.exports, "setHeight", () => $744faacd67cde365$export$3f31360357be44e4, (v) => $744faacd67cde365$export$3f31360357be44e4 = v);
/**
 * DevExtreme (core/utils/style.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $744faacd67cde365$export$5d4cd24aaf68552c;
var $744faacd67cde365$export$3dcfa7045287299;
var $744faacd67cde365$export$84da894514267528;
var $744faacd67cde365$export$67f48e0594af05d;
var $744faacd67cde365$export$3f31360357be44e4;
"use strict";

var $ih7fv = parcelRequire("ih7fv");
var $744faacd67cde365$require$camelize = $ih7fv.camelize;

var $ePlHj = parcelRequire("ePlHj");

var $kDRxH = parcelRequire("kDRxH");

var $445Bz = parcelRequire("445Bz");
var $744faacd67cde365$var$jsPrefixes = [
    "",
    "Webkit",
    "Moz",
    "O",
    "Ms"
];
var $744faacd67cde365$var$cssPrefixes = {
    "": "",
    Webkit: "-webkit-",
    Moz: "-moz-",
    O: "-o-",
    ms: "-ms-"
};
var $744faacd67cde365$var$getStyles = $ePlHj(function() {
    return $445Bz.createElement("dx").style;
});
var $744faacd67cde365$var$forEachPrefixes = function(prop, callBack) {
    prop = $744faacd67cde365$require$camelize(prop, true);
    var result;
    for(var i = 0, cssPrefixesCount = $744faacd67cde365$var$jsPrefixes.length; i < cssPrefixesCount; i++){
        var jsPrefix = $744faacd67cde365$var$jsPrefixes[i];
        var prefixedProp = jsPrefix + prop;
        var lowerPrefixedProp = $744faacd67cde365$require$camelize(prefixedProp);
        result = callBack(lowerPrefixedProp, jsPrefix);
        if (void 0 === result) result = callBack(prefixedProp, jsPrefix);
        if (void 0 !== result) break;
    }
    return result || "";
};
var $744faacd67cde365$var$styleProp = function(name) {
    if (name in $744faacd67cde365$var$getStyles()) return name;
    var originalName = name;
    name = name.charAt(0).toUpperCase() + name.substr(1);
    for(var i = 1; i < $744faacd67cde365$var$jsPrefixes.length; i++){
        var prefixedProp = $744faacd67cde365$var$jsPrefixes[i].toLowerCase() + name;
        if (prefixedProp in $744faacd67cde365$var$getStyles()) return prefixedProp;
    }
    return originalName;
};
var $744faacd67cde365$var$stylePropPrefix = function(prop) {
    return $744faacd67cde365$var$forEachPrefixes(prop, function(specific, jsPrefix) {
        if (specific in $744faacd67cde365$var$getStyles()) return $744faacd67cde365$var$cssPrefixes[jsPrefix];
    });
};
var $744faacd67cde365$var$pxExceptions = [
    "fillOpacity",
    "columnCount",
    "flexGrow",
    "flexShrink",
    "fontWeight",
    "lineHeight",
    "opacity",
    "zIndex",
    "zoom"
];
var $744faacd67cde365$var$normalizeStyleProp = function(prop, value) {
    if ($kDRxH.isNumeric(value) && $744faacd67cde365$var$pxExceptions.indexOf(prop) === -1) value += "px";
    return value;
};
var $744faacd67cde365$var$setDimensionProperty = function(elements, propertyName, value) {
    if (elements) {
        value = $kDRxH.isNumeric(value) ? value += "px" : value;
        for(var i = 0; i < elements.length; ++i)elements[i].style[propertyName] = value;
    }
};
var $744faacd67cde365$var$setWidth = function(elements, value) {
    $744faacd67cde365$var$setDimensionProperty(elements, "width", value);
};
var $744faacd67cde365$var$setHeight = function(elements, value) {
    $744faacd67cde365$var$setDimensionProperty(elements, "height", value);
};
$744faacd67cde365$export$5d4cd24aaf68552c = $744faacd67cde365$var$styleProp;
$744faacd67cde365$export$3dcfa7045287299 = $744faacd67cde365$var$stylePropPrefix;
$744faacd67cde365$export$84da894514267528 = $744faacd67cde365$var$normalizeStyleProp;
$744faacd67cde365$export$67f48e0594af05d = $744faacd67cde365$var$setWidth;
$744faacd67cde365$export$3f31360357be44e4 = $744faacd67cde365$var$setHeight;

});
parcelRegister("ih7fv", function(module, exports) {

$parcel$export(module.exports, "dasherize", () => $d4df70102a897250$export$7e9152eee80b168f, (v) => $d4df70102a897250$export$7e9152eee80b168f = v);
$parcel$export(module.exports, "camelize", () => $d4df70102a897250$export$161d051f5dd25de7, (v) => $d4df70102a897250$export$161d051f5dd25de7 = v);
$parcel$export(module.exports, "humanize", () => $d4df70102a897250$export$cfb8c2be79648c4, (v) => $d4df70102a897250$export$cfb8c2be79648c4 = v);
$parcel$export(module.exports, "titleize", () => $d4df70102a897250$export$29d0dd1cc36cee26, (v) => $d4df70102a897250$export$29d0dd1cc36cee26 = v);
/**
 * DevExtreme (core/utils/inflector.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $d4df70102a897250$export$7e9152eee80b168f;
var $d4df70102a897250$export$161d051f5dd25de7;
var $d4df70102a897250$export$cfb8c2be79648c4;
var $d4df70102a897250$export$29d0dd1cc36cee26;
var $d4df70102a897250$export$730f2a930033e8f0;
var $d4df70102a897250$export$4f7dda9d0e7975d;
"use strict";

var $4Pwuy = parcelRequire("4Pwuy");
var $d4df70102a897250$require$map = $4Pwuy.map;
var $d4df70102a897250$var$_normalize = function(text) {
    if (void 0 === text || null === text) return "";
    return String(text);
};
var $d4df70102a897250$var$_upperCaseFirst = function(text) {
    return $d4df70102a897250$var$_normalize(text).charAt(0).toUpperCase() + text.substr(1);
};
var $d4df70102a897250$var$_chop = function(text) {
    return $d4df70102a897250$var$_normalize(text).replace(/([a-z\d])([A-Z])/g, "$1 $2").split(/[\s_-]+/);
};
var $d4df70102a897250$var$dasherize = function(text) {
    return $d4df70102a897250$require$map($d4df70102a897250$var$_chop(text), function(p) {
        return p.toLowerCase();
    }).join("-");
};
var $d4df70102a897250$var$underscore = function(text) {
    return $d4df70102a897250$var$dasherize(text).replace(/-/g, "_");
};
var $d4df70102a897250$var$camelize = function(text, upperFirst) {
    return $d4df70102a897250$require$map($d4df70102a897250$var$_chop(text), function(p, i) {
        p = p.toLowerCase();
        if (upperFirst || i > 0) p = $d4df70102a897250$var$_upperCaseFirst(p);
        return p;
    }).join("");
};
var $d4df70102a897250$var$humanize = function(text) {
    return $d4df70102a897250$var$_upperCaseFirst($d4df70102a897250$var$dasherize(text).replace(/-/g, " "));
};
var $d4df70102a897250$var$titleize = function(text) {
    return $d4df70102a897250$require$map($d4df70102a897250$var$_chop(text), function(p) {
        return $d4df70102a897250$var$_upperCaseFirst(p.toLowerCase());
    }).join(" ");
};
var $d4df70102a897250$var$DIGIT_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
];
var $d4df70102a897250$var$captionize = function(name) {
    var captionList = [];
    var i;
    var char;
    var isPrevCharNewWord = false;
    var isNewWord = false;
    for(i = 0; i < name.length; i++){
        char = name.charAt(i);
        isNewWord = char === char.toUpperCase() && "-" !== char && ")" !== char && "/" !== char || char in $d4df70102a897250$var$DIGIT_CHARS;
        if ("_" === char || "." === char) {
            char = " ";
            isNewWord = true;
        } else if (0 === i) {
            char = char.toUpperCase();
            isNewWord = true;
        } else {
            if (!isPrevCharNewWord && isNewWord) {
                if (captionList.length > 0) captionList.push(" ");
            }
        }
        captionList.push(char);
        isPrevCharNewWord = isNewWord;
    }
    return captionList.join("");
};
$d4df70102a897250$export$7e9152eee80b168f = $d4df70102a897250$var$dasherize;
$d4df70102a897250$export$161d051f5dd25de7 = $d4df70102a897250$var$camelize;
$d4df70102a897250$export$cfb8c2be79648c4 = $d4df70102a897250$var$humanize;
$d4df70102a897250$export$29d0dd1cc36cee26 = $d4df70102a897250$var$titleize;
$d4df70102a897250$export$730f2a930033e8f0 = $d4df70102a897250$var$underscore;
$d4df70102a897250$export$4f7dda9d0e7975d = $d4df70102a897250$var$captionize;

});


parcelRegister("5szhX", function(module, exports) {

$parcel$export(module.exports, "getSize", () => $3f9af0e27e53521d$export$31b21d0167753bb4, (v) => $3f9af0e27e53521d$export$31b21d0167753bb4 = v);
$parcel$export(module.exports, "getElementBoxParams", () => $3f9af0e27e53521d$export$76eaf8e1f54207aa, (v) => $3f9af0e27e53521d$export$76eaf8e1f54207aa = v);
$parcel$export(module.exports, "addOffsetToMaxHeight", () => $3f9af0e27e53521d$export$df512663f252527d, (v) => $3f9af0e27e53521d$export$df512663f252527d = v);
$parcel$export(module.exports, "addOffsetToMinHeight", () => $3f9af0e27e53521d$export$22d3535472655952, (v) => $3f9af0e27e53521d$export$22d3535472655952 = v);
$parcel$export(module.exports, "getVerticalOffsets", () => $3f9af0e27e53521d$export$4a1cba5dfaf0ad4b, (v) => $3f9af0e27e53521d$export$4a1cba5dfaf0ad4b = v);
$parcel$export(module.exports, "getVisibleHeight", () => $3f9af0e27e53521d$export$777feb64bf8da9e0, (v) => $3f9af0e27e53521d$export$777feb64bf8da9e0 = v);
$parcel$export(module.exports, "parseHeight", () => $3f9af0e27e53521d$export$8b327f0960504387, (v) => $3f9af0e27e53521d$export$8b327f0960504387 = v);
/**
 * DevExtreme (core/utils/size.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $3f9af0e27e53521d$export$31b21d0167753bb4;
var $3f9af0e27e53521d$export$76eaf8e1f54207aa;
var $3f9af0e27e53521d$export$df512663f252527d;
var $3f9af0e27e53521d$export$22d3535472655952;
var $3f9af0e27e53521d$export$4a1cba5dfaf0ad4b;
var $3f9af0e27e53521d$export$777feb64bf8da9e0;
var $3f9af0e27e53521d$export$8b327f0960504387;
"use strict";

var $3f9af0e27e53521d$var$window = (parcelRequire("irv64")).getWindow();

var $kDRxH = parcelRequire("kDRxH");
var $3f9af0e27e53521d$var$SPECIAL_HEIGHT_VALUES = [
    "auto",
    "none",
    "inherit",
    "initial"
];
var $3f9af0e27e53521d$var$getSizeByStyles = function(elementStyles, styles) {
    var result = 0;
    styles.forEach(function(style) {
        result += parseFloat(elementStyles[style]) || 0;
    });
    return result;
};
var $3f9af0e27e53521d$var$getElementBoxParams = function(name, elementStyles) {
    var beforeName = "width" === name ? "Left" : "Top";
    var afterName = "width" === name ? "Right" : "Bottom";
    return {
        padding: $3f9af0e27e53521d$var$getSizeByStyles(elementStyles, [
            "padding" + beforeName,
            "padding" + afterName
        ]),
        border: $3f9af0e27e53521d$var$getSizeByStyles(elementStyles, [
            "border" + beforeName + "Width",
            "border" + afterName + "Width"
        ]),
        margin: $3f9af0e27e53521d$var$getSizeByStyles(elementStyles, [
            "margin" + beforeName,
            "margin" + afterName
        ])
    };
};
var $3f9af0e27e53521d$var$getBoxSizingOffset = function(name, elementStyles, boxParams) {
    var size = elementStyles[name];
    if ("border-box" === elementStyles.boxSizing && size.length && "%" !== size[size.length - 1]) return boxParams.border + boxParams.padding;
    return 0;
};
var $3f9af0e27e53521d$var$getSize = function(element, name, include) {
    var elementStyles = $3f9af0e27e53521d$var$window.getComputedStyle(element);
    var boxParams = $3f9af0e27e53521d$var$getElementBoxParams(name, elementStyles);
    var clientRect = element.getClientRects().length;
    var boundingClientRect = element.getBoundingClientRect()[name];
    var result = clientRect ? boundingClientRect : 0;
    if (result <= 0) {
        result = parseFloat(elementStyles[name] || element.style[name]) || 0;
        result -= $3f9af0e27e53521d$var$getBoxSizingOffset(name, elementStyles, boxParams);
    } else result -= boxParams.padding + boxParams.border;
    if (include.paddings) result += boxParams.padding;
    if (include.borders) result += boxParams.border;
    if (include.margins) result += boxParams.margin;
    return result;
};
var $3f9af0e27e53521d$var$getContainerHeight = function(container) {
    return $kDRxH.isWindow(container) ? container.innerHeight : container.offsetHeight;
};
var $3f9af0e27e53521d$var$parseHeight = function(value, container) {
    if (value.indexOf("px") > 0) value = parseInt(value.replace("px", ""));
    else {
        if (value.indexOf("%") > 0) value = parseInt(value.replace("%", "")) * $3f9af0e27e53521d$var$getContainerHeight(container) / 100;
        else if (!isNaN(value)) value = parseInt(value);
    }
    return value;
};
var $3f9af0e27e53521d$var$getHeightWithOffset = function(value, offset, container) {
    if (!value) return null;
    if ($3f9af0e27e53521d$var$SPECIAL_HEIGHT_VALUES.indexOf(value) > -1) return offset ? null : value;
    if ($kDRxH.isString(value)) value = $3f9af0e27e53521d$var$parseHeight(value, container);
    if ($kDRxH.isNumeric(value)) return Math.max(0, value + offset);
    var operationString = offset < 0 ? " - " : " ";
    return "calc(" + value + operationString + Math.abs(offset) + "px)";
};
var $3f9af0e27e53521d$var$addOffsetToMaxHeight = function(value, offset, container) {
    var maxHeight = $3f9af0e27e53521d$var$getHeightWithOffset(value, offset, container);
    return null !== maxHeight ? maxHeight : "none";
};
var $3f9af0e27e53521d$var$addOffsetToMinHeight = function(value, offset, container) {
    var minHeight = $3f9af0e27e53521d$var$getHeightWithOffset(value, offset, container);
    return null !== minHeight ? minHeight : 0;
};
var $3f9af0e27e53521d$var$getVerticalOffsets = function(element, withMargins) {
    if (!element) return 0;
    var boxParams = $3f9af0e27e53521d$var$getElementBoxParams("height", $3f9af0e27e53521d$var$window.getComputedStyle(element));
    return boxParams.padding + boxParams.border + (withMargins ? boxParams.margin : 0);
};
var $3f9af0e27e53521d$var$getVisibleHeight = function(element) {
    if (element) {
        var boundingClientRect = element.getBoundingClientRect();
        if (boundingClientRect.height) return boundingClientRect.height;
    }
    return 0;
};
$3f9af0e27e53521d$export$31b21d0167753bb4 = $3f9af0e27e53521d$var$getSize;
$3f9af0e27e53521d$export$76eaf8e1f54207aa = $3f9af0e27e53521d$var$getElementBoxParams;
$3f9af0e27e53521d$export$df512663f252527d = $3f9af0e27e53521d$var$addOffsetToMaxHeight;
$3f9af0e27e53521d$export$22d3535472655952 = $3f9af0e27e53521d$var$addOffsetToMinHeight;
$3f9af0e27e53521d$export$4a1cba5dfaf0ad4b = $3f9af0e27e53521d$var$getVerticalOffsets;
$3f9af0e27e53521d$export$777feb64bf8da9e0 = $3f9af0e27e53521d$var$getVisibleHeight;
$3f9af0e27e53521d$export$8b327f0960504387 = $3f9af0e27e53521d$var$parseHeight;

});

parcelRegister("8PQvD", function(module, exports) {

$parcel$export(module.exports, "parseHTML", () => $66ebd1613d244ed4$export$8a49393be2d55148, (v) => $66ebd1613d244ed4$export$8a49393be2d55148 = v);
$parcel$export(module.exports, "isTablePart", () => $66ebd1613d244ed4$export$5ae0fa1c625cce34, (v) => $66ebd1613d244ed4$export$5ae0fa1c625cce34 = v);
/**
 * DevExtreme (core/utils/html_parser.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $66ebd1613d244ed4$export$8a49393be2d55148;
var $66ebd1613d244ed4$export$5ae0fa1c625cce34;
"use strict";

var $aLQK5 = parcelRequire("aLQK5");
var $66ebd1613d244ed4$require$merge = $aLQK5.merge;

var $445Bz = parcelRequire("445Bz");
var $66ebd1613d244ed4$var$isTagName = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i;
var $66ebd1613d244ed4$var$tagWrappers = {
    "default": {
        tagsCount: 0,
        startTags: "",
        endTags: ""
    },
    thead: {
        tagsCount: 1,
        startTags: "<table>",
        endTags: "</table>"
    },
    td: {
        tagsCount: 3,
        startTags: "<table><tbody><tr>",
        endTags: "</tr></tbody></table>"
    },
    col: {
        tagsCount: 2,
        startTags: "<table><colgroup>",
        endTags: "</colgroup></table>"
    },
    tr: {
        tagsCount: 2,
        startTags: "<table><tbody>",
        endTags: "</tbody></table>"
    }
};
$66ebd1613d244ed4$var$tagWrappers.tbody = $66ebd1613d244ed4$var$tagWrappers.colgroup = $66ebd1613d244ed4$var$tagWrappers.caption = $66ebd1613d244ed4$var$tagWrappers.tfoot = $66ebd1613d244ed4$var$tagWrappers.thead;
$66ebd1613d244ed4$var$tagWrappers.th = $66ebd1613d244ed4$var$tagWrappers.td;
var $66ebd1613d244ed4$var$parseHTML = function(html) {
    if ("string" !== typeof html) return null;
    var fragment = $445Bz.createDocumentFragment();
    var container = fragment.appendChild($445Bz.createElement("div"));
    var tags = $66ebd1613d244ed4$var$isTagName.exec(html);
    var firstRootTag = tags && tags[1].toLowerCase();
    var tagWrapper = $66ebd1613d244ed4$var$tagWrappers[firstRootTag] || $66ebd1613d244ed4$var$tagWrappers.default;
    container.innerHTML = tagWrapper.startTags + html + tagWrapper.endTags;
    for(var i = 0; i < tagWrapper.tagsCount; i++)container = container.lastChild;
    return $66ebd1613d244ed4$require$merge([], container.childNodes);
};
var $66ebd1613d244ed4$var$isTablePart = function(html) {
    var tags = $66ebd1613d244ed4$var$isTagName.exec(html);
    return tags && tags[1] in $66ebd1613d244ed4$var$tagWrappers;
};
$66ebd1613d244ed4$export$8a49393be2d55148 = $66ebd1613d244ed4$var$parseHTML;
$66ebd1613d244ed4$export$5ae0fa1c625cce34 = $66ebd1613d244ed4$var$isTablePart;

});



parcelRegister("4ZFRo", function(module, exports) {
/**
 * DevExtreme (core/component_registrator.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $cvkYi = parcelRequire("cvkYi");

var $7sX7V = parcelRequire("7sX7V");

var $3fgBn = parcelRequire("3fgBn");
var $3a2d548265837ce9$var$registerComponent = function(name, namespace, componentClass) {
    if (!componentClass) componentClass = namespace;
    else namespace[name] = componentClass;
    $3fgBn.name(componentClass, name);
    $cvkYi.fire(name, componentClass);
};
var $3a2d548265837ce9$var$registerRendererComponent = function(name, componentClass) {
    $jFnCG.fn[name] = function(options) {
        var isMemberInvoke = "string" === typeof options;
        var result;
        if (isMemberInvoke) {
            var memberName = options;
            var memberArgs = [].slice.call(arguments).slice(1);
            this.each(function() {
                var instance = componentClass.getInstance(this);
                if (!instance) throw $7sX7V.Error("E0009", name);
                var member = instance[memberName];
                var memberValue = member.apply(instance, memberArgs);
                if (void 0 === result) result = memberValue;
            });
        } else {
            this.each(function() {
                var instance = componentClass.getInstance(this);
                if (instance) instance.option(options);
                else new componentClass(this, options);
            });
            result = this;
        }
        return result;
    };
};
$cvkYi.add($3a2d548265837ce9$var$registerRendererComponent);
module.exports = $3a2d548265837ce9$var$registerComponent;
module.exports.default = module.exports;

});
parcelRegister("cvkYi", function(module, exports) {
/**
 * DevExtreme (core/component_registrator_callbacks.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $2vY9D = parcelRequire("2vY9D");
module.exports = new $2vY9D;

});

parcelRegister("3fgBn", function(module, exports) {

$parcel$export(module.exports, "name", () => $25cfa69927931de6$export$a8ff84c12d48cfa6, (v) => $25cfa69927931de6$export$a8ff84c12d48cfa6 = v);
$parcel$export(module.exports, "attachInstanceToElement", () => $25cfa69927931de6$export$9c372d83124e863f, (v) => $25cfa69927931de6$export$9c372d83124e863f = v);
$parcel$export(module.exports, "getInstanceByElement", () => $25cfa69927931de6$export$d13f206d638c14c, (v) => $25cfa69927931de6$export$d13f206d638c14c = v);
/**
 * DevExtreme (core/utils/public_component.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $25cfa69927931de6$export$a8ff84c12d48cfa6;
var $25cfa69927931de6$export$9c372d83124e863f;
var $25cfa69927931de6$export$d13f206d638c14c;
"use strict";

var $8ulMI = parcelRequire("8ulMI");

var $e1LMc = parcelRequire("e1LMc");

var $5ySaA = parcelRequire("5ySaA");

var $kDRxH = parcelRequire("kDRxH");
var $25cfa69927931de6$require$isDefined = $kDRxH.isDefined;

var $hw2F9 = parcelRequire("hw2F9");
var $25cfa69927931de6$var$COMPONENT_NAMES_DATA_KEY = "dxComponents";
var $25cfa69927931de6$var$ANONYMOUS_COMPONENT_DATA_KEY = "dxPrivateComponent";
var $25cfa69927931de6$var$componentNames = new $5ySaA;
var $25cfa69927931de6$var$nextAnonymousComponent = 0;
var $25cfa69927931de6$var$getName = $25cfa69927931de6$export$a8ff84c12d48cfa6 = function(componentClass, newName) {
    if ($25cfa69927931de6$require$isDefined(newName)) {
        $25cfa69927931de6$var$componentNames.set(componentClass, newName);
        return;
    }
    if (!$25cfa69927931de6$var$componentNames.has(componentClass)) {
        var generatedName = $25cfa69927931de6$var$ANONYMOUS_COMPONENT_DATA_KEY + $25cfa69927931de6$var$nextAnonymousComponent++;
        $25cfa69927931de6$var$componentNames.set(componentClass, generatedName);
        return generatedName;
    }
    return $25cfa69927931de6$var$componentNames.get(componentClass);
};
$25cfa69927931de6$export$9c372d83124e863f = function($element, componentInstance, disposeFn) {
    var data = $8ulMI.data($element.get(0));
    var name = $25cfa69927931de6$var$getName(componentInstance.constructor);
    data[name] = componentInstance;
    if (disposeFn) $e1LMc.one($element, $hw2F9, function() {
        disposeFn.call(componentInstance);
    });
    if (!data[$25cfa69927931de6$var$COMPONENT_NAMES_DATA_KEY]) data[$25cfa69927931de6$var$COMPONENT_NAMES_DATA_KEY] = [];
    data[$25cfa69927931de6$var$COMPONENT_NAMES_DATA_KEY].push(name);
};
$25cfa69927931de6$export$d13f206d638c14c = function($element, componentClass) {
    var name = $25cfa69927931de6$var$getName(componentClass);
    return $8ulMI.data($element.get(0), name);
};

});
parcelRegister("hw2F9", function(module, exports) {
/**
 * DevExtreme (core/remove_event.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $8ulMI = parcelRequire("8ulMI");
var $cc077d949d8d9b1f$require$beforeCleanData = $8ulMI.beforeCleanData;

var $e1LMc = parcelRequire("e1LMc");

var $cMvU0 = parcelRequire("cMvU0");
var $cc077d949d8d9b1f$var$eventName = "dxremove";
var $cc077d949d8d9b1f$var$eventPropName = "dxRemoveEvent";
$cc077d949d8d9b1f$require$beforeCleanData(function(elements) {
    elements = [].slice.call(elements);
    for(var i = 0; i < elements.length; i++){
        var $element = $jFnCG(elements[i]);
        if ($element.prop($cc077d949d8d9b1f$var$eventPropName)) {
            $element[0][$cc077d949d8d9b1f$var$eventPropName] = null;
            $e1LMc.triggerHandler($element, $cc077d949d8d9b1f$var$eventName);
        }
    }
});
$cMvU0($cc077d949d8d9b1f$var$eventName, {
    noBubble: true,
    setup: function(element) {
        $jFnCG(element).prop($cc077d949d8d9b1f$var$eventPropName, true);
    }
});
module.exports = $cc077d949d8d9b1f$var$eventName;

});
parcelRegister("cMvU0", function(module, exports) {
/**
 * DevExtreme (events/core/event_registrator.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $4Pwuy = parcelRequire("4Pwuy");
var $94e2b6e34fc21a82$require$each = $4Pwuy.each;

var $i1ezC = parcelRequire("i1ezC");
var $94e2b6e34fc21a82$var$registerEvent = function(name, eventObject) {
    var strategy = {};
    if ("noBubble" in eventObject) strategy.noBubble = eventObject.noBubble;
    if ("bindType" in eventObject) strategy.bindType = eventObject.bindType;
    if ("delegateType" in eventObject) strategy.delegateType = eventObject.delegateType;
    $94e2b6e34fc21a82$require$each([
        "setup",
        "teardown",
        "add",
        "remove",
        "trigger",
        "handle",
        "_default",
        "dispose"
    ], function(_, methodName) {
        if (!eventObject[methodName]) return;
        strategy[methodName] = function() {
            var args = [].slice.call(arguments);
            args.unshift(this);
            return eventObject[methodName].apply(eventObject, args);
        };
    });
    $i1ezC.fire(name, strategy);
};
$94e2b6e34fc21a82$var$registerEvent.callbacks = $i1ezC;
module.exports = $94e2b6e34fc21a82$var$registerEvent;

});




parcelRegister("efpkH", function(module, exports) {

$parcel$export(module.exports, "sign", () => $a5f61dfdb3c0e3ec$export$c5552dfdbc7cec71, (v) => $a5f61dfdb3c0e3ec$export$c5552dfdbc7cec71 = v);
$parcel$export(module.exports, "fitIntoRange", () => $a5f61dfdb3c0e3ec$export$ea4b1ae06d86ed23, (v) => $a5f61dfdb3c0e3ec$export$ea4b1ae06d86ed23 = v);
$parcel$export(module.exports, "inRange", () => $a5f61dfdb3c0e3ec$export$ddf89a9c5af38f94, (v) => $a5f61dfdb3c0e3ec$export$ddf89a9c5af38f94 = v);
$parcel$export(module.exports, "adjust", () => $a5f61dfdb3c0e3ec$export$2c0e788bcc82013, (v) => $a5f61dfdb3c0e3ec$export$2c0e788bcc82013 = v);
/**
 * DevExtreme (core/utils/math.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $a5f61dfdb3c0e3ec$export$c5552dfdbc7cec71;
var $a5f61dfdb3c0e3ec$export$ea4b1ae06d86ed23;
var $a5f61dfdb3c0e3ec$export$ddf89a9c5af38f94;
var $a5f61dfdb3c0e3ec$export$2c0e788bcc82013;
var $a5f61dfdb3c0e3ec$export$e0c74b50bbd10f68;
var $a5f61dfdb3c0e3ec$export$970c45b6c2d27918;
var $a5f61dfdb3c0e3ec$export$31e4419873013369;
var $a5f61dfdb3c0e3ec$export$79ee1a1cd43cf60c;
"use strict";

var $kDRxH = parcelRequire("kDRxH");
var $a5f61dfdb3c0e3ec$require$isExponential = $kDRxH.isExponential;
var $a5f61dfdb3c0e3ec$var$sign = function(value) {
    if (0 === value) return 0;
    return value / Math.abs(value);
};
var $a5f61dfdb3c0e3ec$var$fitIntoRange = function(value, minValue, maxValue) {
    var isMinValueUndefined = !minValue && 0 !== minValue;
    var isMaxValueUndefined = !maxValue && 0 !== maxValue;
    isMinValueUndefined && (minValue = !isMaxValueUndefined ? Math.min(value, maxValue) : value);
    isMaxValueUndefined && (maxValue = !isMinValueUndefined ? Math.max(value, minValue) : value);
    return Math.min(Math.max(value, minValue), maxValue);
};
var $a5f61dfdb3c0e3ec$var$inRange = function(value, minValue, maxValue) {
    return value >= minValue && value <= maxValue;
};
function $a5f61dfdb3c0e3ec$var$getExponent(value) {
    return Math.abs(parseInt(value.toExponential().split("e")[1]));
}
function $a5f61dfdb3c0e3ec$var$_isEdgeBug() {
    var value = 3e-4;
    var correctValue = "0.000300";
    var precisionValue = 3;
    return correctValue !== value.toPrecision(precisionValue);
}
function $a5f61dfdb3c0e3ec$var$adjust(value, interval) {
    var precision = $a5f61dfdb3c0e3ec$var$getPrecision(interval || 0) + 2;
    var separatedValue = value.toString().split(".");
    var sourceValue = value;
    var absValue = Math.abs(value);
    var isExponentValue = $a5f61dfdb3c0e3ec$require$isExponential(value);
    var integerPart = absValue > 1 ? 10 : 0;
    if (1 === separatedValue.length) return value;
    if (!isExponentValue) {
        if ($a5f61dfdb3c0e3ec$require$isExponential(interval)) precision = separatedValue[0].length + $a5f61dfdb3c0e3ec$var$getExponent(interval);
        value = absValue;
        value = value - Math.floor(value) + integerPart;
    }
    precision = $a5f61dfdb3c0e3ec$var$_isEdgeBug() && $a5f61dfdb3c0e3ec$var$getExponent(value) > 6 || precision > 7 ? 15 : 7;
    if (!isExponentValue) {
        var separatedAdjustedValue = parseFloat(value.toPrecision(precision)).toString().split(".");
        if (separatedAdjustedValue[0] === integerPart.toString()) return parseFloat(separatedValue[0] + "." + separatedAdjustedValue[1]);
    }
    return parseFloat(sourceValue.toPrecision(precision));
}
function $a5f61dfdb3c0e3ec$var$getPrecision(value) {
    var str = value.toString();
    if (str.indexOf(".") < 0) return 0;
    var mantissa = str.split(".");
    var positionOfDelimiter = mantissa[1].indexOf("e");
    return positionOfDelimiter >= 0 ? positionOfDelimiter : mantissa[1].length;
}
function $a5f61dfdb3c0e3ec$var$getRoot(x, n) {
    if (x < 0 && n % 2 !== 1) return NaN;
    var y = Math.pow(Math.abs(x), 1 / n);
    return n % 2 === 1 && x < 0 ? -y : y;
}
function $a5f61dfdb3c0e3ec$var$solveCubicEquation(a, b, c, d) {
    var min = 1e-8;
    if (Math.abs(a) < min) {
        a = b;
        b = c;
        c = d;
        if (Math.abs(a) < min) {
            a = b;
            b = c;
            if (Math.abs(a) < min) return [];
            return [
                -b / a
            ];
        }
        var D2 = b * b - 4 * a * c;
        if (Math.abs(D2) < min) return [
            -b / (2 * a)
        ];
        else {
            if (D2 > 0) return [
                (-b + Math.sqrt(D2)) / (2 * a),
                (-b - Math.sqrt(D2)) / (2 * a)
            ];
        }
        return [];
    }
    var p = (3 * a * c - b * b) / (3 * a * a);
    var q = (2 * b * b * b - 9 * a * b * c + 27 * a * a * d) / (27 * a * a * a);
    var roots;
    var u;
    if (Math.abs(p) < min) roots = [
        $a5f61dfdb3c0e3ec$var$getRoot(-q, 3)
    ];
    else if (Math.abs(q) < min) roots = [
        0
    ].concat(p < 0 ? [
        Math.sqrt(-p),
        -Math.sqrt(-p)
    ] : []);
    else {
        var D3 = q * q / 4 + p * p * p / 27;
        if (Math.abs(D3) < min) roots = [
            -1.5 * q / p,
            3 * q / p
        ];
        else if (D3 > 0) {
            u = $a5f61dfdb3c0e3ec$var$getRoot(-q / 2 - Math.sqrt(D3), 3);
            roots = [
                u - p / (3 * u)
            ];
        } else {
            u = 2 * Math.sqrt(-p / 3);
            var t = Math.acos(3 * q / p / u) / 3;
            var k = 2 * Math.PI / 3;
            roots = [
                u * Math.cos(t),
                u * Math.cos(t - k),
                u * Math.cos(t - 2 * k)
            ];
        }
    }
    for(var i = 0; i < roots.length; i++)roots[i] -= b / (3 * a);
    return roots;
}
$a5f61dfdb3c0e3ec$export$c5552dfdbc7cec71 = $a5f61dfdb3c0e3ec$var$sign;
$a5f61dfdb3c0e3ec$export$ea4b1ae06d86ed23 = $a5f61dfdb3c0e3ec$var$fitIntoRange;
$a5f61dfdb3c0e3ec$export$ddf89a9c5af38f94 = $a5f61dfdb3c0e3ec$var$inRange;
$a5f61dfdb3c0e3ec$export$2c0e788bcc82013 = $a5f61dfdb3c0e3ec$var$adjust;
$a5f61dfdb3c0e3ec$export$e0c74b50bbd10f68 = $a5f61dfdb3c0e3ec$var$getPrecision;
$a5f61dfdb3c0e3ec$export$970c45b6c2d27918 = $a5f61dfdb3c0e3ec$var$getExponent;
$a5f61dfdb3c0e3ec$export$31e4419873013369 = $a5f61dfdb3c0e3ec$var$getRoot;
$a5f61dfdb3c0e3ec$export$79ee1a1cd43cf60c = $a5f61dfdb3c0e3ec$var$solveCubicEquation;

});

parcelRegister("7KuSv", function(module, exports) {
/**
 * DevExtreme (ui/button.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $5a44c80307d41a7e$var$_renderer2 = $5a44c80307d41a7e$var$_interopRequireDefault($jFnCG);

var $aiwte = parcelRequire("aiwte");
var $5a44c80307d41a7e$var$_devices2 = $5a44c80307d41a7e$var$_interopRequireDefault($aiwte);

var $e1LMc = parcelRequire("e1LMc");
var $5a44c80307d41a7e$var$_events_engine2 = $5a44c80307d41a7e$var$_interopRequireDefault($e1LMc);

var $gysT6 = parcelRequire("gysT6");
var $5a44c80307d41a7e$var$_utils2 = $5a44c80307d41a7e$var$_interopRequireDefault($gysT6);

var $4ZFRo = parcelRequire("4ZFRo");
var $5a44c80307d41a7e$var$_component_registrator2 = $5a44c80307d41a7e$var$_interopRequireDefault($4ZFRo);

var $3LUJe = parcelRequire("3LUJe");
var $5a44c80307d41a7e$var$_themes2 = $5a44c80307d41a7e$var$_interopRequireDefault($3LUJe);

var $ebely = parcelRequire("ebely");
var $5a44c80307d41a7e$var$_validation_engine2 = $5a44c80307d41a7e$var$_interopRequireDefault($ebely);

var $4gmvS = parcelRequire("4gmvS");
var $5a44c80307d41a7e$var$_ui2 = $5a44c80307d41a7e$var$_interopRequireDefault($4gmvS);

var $bXb2w = parcelRequire("bXb2w");

var $7I8Uw = parcelRequire("7I8Uw");

var $kqsMi = parcelRequire("kqsMi");

var $69u7b = parcelRequire("69u7b");

var $5OzEX = parcelRequire("5OzEX");

var $i7ZSP = parcelRequire("i7ZSP");
function $5a44c80307d41a7e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $5a44c80307d41a7e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $5a44c80307d41a7e$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $5a44c80307d41a7e$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $5a44c80307d41a7e$var$_typeof(obj);
}
function $5a44c80307d41a7e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5a44c80307d41a7e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5a44c80307d41a7e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5a44c80307d41a7e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5a44c80307d41a7e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $5a44c80307d41a7e$var$_get(target, property, receiver) {
    if ("undefined" !== typeof Reflect && Reflect.get) $5a44c80307d41a7e$var$_get = Reflect.get;
    else $5a44c80307d41a7e$var$_get = function(target, property, receiver) {
        var base = $5a44c80307d41a7e$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $5a44c80307d41a7e$var$_get(target, property, receiver || target);
}
function $5a44c80307d41a7e$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $5a44c80307d41a7e$var$_getPrototypeOf(object);
        if (null === object) break;
    }
    return object;
}
function $5a44c80307d41a7e$var$_inherits(subClass, superClass) {
    if ("function" !== typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $5a44c80307d41a7e$var$_setPrototypeOf(subClass, superClass);
}
function $5a44c80307d41a7e$var$_setPrototypeOf(o, p) {
    $5a44c80307d41a7e$var$_setPrototypeOf = Object.setPrototypeOf || function(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $5a44c80307d41a7e$var$_setPrototypeOf(o, p);
}
function $5a44c80307d41a7e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5a44c80307d41a7e$var$_isNativeReflectConstruct();
    return function() {
        var result, Super = $5a44c80307d41a7e$var$_getPrototypeOf(Derived);
        if (hasNativeReflectConstruct) {
            var NewTarget = $5a44c80307d41a7e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $5a44c80307d41a7e$var$_possibleConstructorReturn(this, result);
    };
}
function $5a44c80307d41a7e$var$_possibleConstructorReturn(self, call) {
    if (call && ("object" === $5a44c80307d41a7e$var$_typeof(call) || "function" === typeof call)) return call;
    return $5a44c80307d41a7e$var$_assertThisInitialized(self);
}
function $5a44c80307d41a7e$var$_assertThisInitialized(self) {
    if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $5a44c80307d41a7e$var$_isNativeReflectConstruct() {
    if ("undefined" === typeof Reflect || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if ("function" === typeof Proxy) return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $5a44c80307d41a7e$var$_getPrototypeOf(o) {
    $5a44c80307d41a7e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5a44c80307d41a7e$var$_getPrototypeOf(o);
}
var $5a44c80307d41a7e$var$Button = function(_Widget) {
    $5a44c80307d41a7e$var$_inherits(Button, _Widget);
    var _super = $5a44c80307d41a7e$var$_createSuper(Button);
    function Button() {
        var _this;
        $5a44c80307d41a7e$var$_classCallCheck(this, Button);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this._feedbackHideTimeout = 100;
        return _this;
    }
    $5a44c80307d41a7e$var$_createClass(Button, [
        {
            key: "_clean",
            value: function() {
                delete this._inkRipple;
                delete this._$content;
                $5a44c80307d41a7e$var$_get($5a44c80307d41a7e$var$_getPrototypeOf(Button.prototype), "_clean", this).call(this);
            }
        },
        {
            key: "_defaultOptionsRules",
            value: function() {
                return $5a44c80307d41a7e$var$_get($5a44c80307d41a7e$var$_getPrototypeOf(Button.prototype), "_defaultOptionsRules", this).call(this).concat([
                    {
                        device: function() {
                            return "desktop" === $5a44c80307d41a7e$var$_devices2.default.real().deviceType && !$5a44c80307d41a7e$var$_devices2.default.isSimulator();
                        },
                        options: {
                            focusStateEnabled: true
                        }
                    },
                    {
                        device: function() {
                            return $5a44c80307d41a7e$var$_themes2.default.isMaterial($5a44c80307d41a7e$var$_themes2.default.current());
                        },
                        options: {
                            useInkRipple: true
                        }
                    }
                ]);
            }
        },
        {
            key: "_executeClickAction",
            value: function(event) {
                this._clickAction({
                    validationGroup: this._validationGroupConfig,
                    event: event
                });
            }
        },
        {
            key: "_findGroup",
            value: function() {
                var $element = this.$element();
                return this.option("validationGroup") || $5a44c80307d41a7e$var$_validation_engine2.default.findGroup($element, this._modelByElement($element));
            }
        },
        {
            key: "_getAnonymousTemplateName",
            value: function() {
                return "content";
            }
        },
        {
            key: "_getContentData",
            value: function() {
                var _this$option = this.option(), icon = _this$option.icon, text = _this$option.text, type = _this$option.type, _templateData = _this$option._templateData;
                return (0, $7I8Uw.extend)({
                    icon: "back" === type && !icon ? "back" : icon,
                    text: text
                }, _templateData);
            }
        },
        {
            key: "_getDefaultOptions",
            value: function() {
                return (0, $7I8Uw.extend)($5a44c80307d41a7e$var$_get($5a44c80307d41a7e$var$_getPrototypeOf(Button.prototype), "_getDefaultOptions", this).call(this), {
                    hoverStateEnabled: true,
                    onClick: null,
                    type: "normal",
                    text: "",
                    icon: "",
                    iconPosition: "left",
                    validationGroup: void 0,
                    activeStateEnabled: true,
                    template: "content",
                    useSubmitBehavior: false,
                    useInkRipple: false,
                    _templateData: {},
                    stylingMode: "contained"
                });
            }
        },
        {
            key: "_getSubmitAction",
            value: function() {
                var _this2 = this;
                return this._createAction(function(_ref) {
                    var e = _ref.event;
                    if (_this2._needValidate) {
                        var validationGroup = _this2._validationGroupConfig;
                        if (validationGroup) {
                            var _validationGroup$vali = validationGroup.validate(), status = _validationGroup$vali.status, complete = _validationGroup$vali.complete;
                            _this2._validationStatus = status;
                            if ("pending" === status) {
                                _this2._needValidate = false;
                                _this2._setDisabled(true);
                                _this2._waitForValidationCompleting(complete);
                            }
                        }
                    }
                    "valid" !== _this2._validationStatus && e.preventDefault();
                    e.stopPropagation();
                });
            }
        },
        {
            key: "_initMarkup",
            value: function() {
                this.$element().addClass("dx-button");
                this._renderType();
                this._renderStylingMode();
                this.option("useInkRipple") && this._renderInkRipple();
                this._renderClick();
                this.setAria("role", "button");
                this._updateAriaLabel();
                $5a44c80307d41a7e$var$_get($5a44c80307d41a7e$var$_getPrototypeOf(Button.prototype), "_initMarkup", this).call(this);
                this._updateContent();
            }
        },
        {
            key: "_initTemplates",
            value: function() {
                var _this3 = this;
                $5a44c80307d41a7e$var$_get($5a44c80307d41a7e$var$_getPrototypeOf(Button.prototype), "_initTemplates", this).call(this);
                this._defaultTemplates.content = new $kqsMi.FunctionTemplate(function(_ref2) {
                    var _ref2$model = _ref2.model, model = void 0 === _ref2$model ? {} : _ref2$model, container = _ref2.container;
                    var text = model.text, icon = model.icon;
                    var $icon = (0, $69u7b.getImageContainer)(icon);
                    var $textContainer = text && (0, $5a44c80307d41a7e$var$_renderer2.default)("<span>").text(text).addClass("dx-button-text");
                    var $container = (0, $5a44c80307d41a7e$var$_renderer2.default)(container);
                    $container.append($textContainer);
                    if ("left" === _this3.option("iconPosition")) $container.prepend($icon);
                    else {
                        $icon.addClass("dx-icon-right");
                        $container.append($icon);
                    }
                });
            }
        },
        {
            key: "_optionChanged",
            value: function(args) {
                var name = args.name, previousValue = args.previousValue;
                switch(name){
                    case "onClick":
                        this._renderClick();
                        break;
                    case "icon":
                    case "text":
                        this._updateContent();
                        this._updateAriaLabel();
                        break;
                    case "type":
                        this._refreshType(previousValue);
                        this._updateContent();
                        this._updateAriaLabel();
                        break;
                    case "_templateData":
                        break;
                    case "template":
                    case "iconPosition":
                        this._updateContent();
                        break;
                    case "stylingMode":
                        this._renderStylingMode();
                        break;
                    case "useInkRipple":
                    case "useSubmitBehavior":
                        this._invalidate();
                        break;
                    default:
                        $5a44c80307d41a7e$var$_get($5a44c80307d41a7e$var$_getPrototypeOf(Button.prototype), "_optionChanged", this).call(this, args);
                }
            }
        },
        {
            key: "_refreshType",
            value: function(prevType) {
                var type = this.option("type");
                var $element = this.$element();
                prevType && $element.removeClass("dx-button-".concat(prevType)).addClass("dx-button-".concat(type));
                if (!$element.hasClass("dx-button-has-icon") && "back" === type) this._updateContent();
            }
        },
        {
            key: "_renderClick",
            value: function() {
                var actionConfig = {
                    excludeValidators: [
                        "readOnly"
                    ]
                };
                if (this.option("useSubmitBehavior")) actionConfig.afterExecute = function(_ref3) {
                    var component = _ref3.component;
                    return setTimeout(function() {
                        return component._$submitInput.get(0).click();
                    });
                };
                this._clickAction = this._createActionByOption("onClick", actionConfig);
                var $element = this.$element();
                var eventName = (0, $bXb2w.addNamespace)($i7ZSP.name, this.NAME);
                $5a44c80307d41a7e$var$_events_engine2.default.off($element, eventName);
                $5a44c80307d41a7e$var$_events_engine2.default.on($element, eventName, this._executeClickAction.bind(this));
            }
        },
        {
            key: "_renderInkRipple",
            value: function() {
                var _this$option2 = this.option(), text = _this$option2.text, icon = _this$option2.icon, type = _this$option2.type;
                var isOnlyIconButton = !text && icon || "back" === type;
                var config = {};
                if (isOnlyIconButton) (0, $7I8Uw.extend)(config, {
                    waveSizeCoefficient: 1,
                    useHoldAnimation: false,
                    isCentered: true
                });
                this._inkRipple = $5a44c80307d41a7e$var$_utils2.default.render(config);
            }
        },
        {
            key: "_renderStylingMode",
            value: function() {
                var $element = this.$element();
                var stylingMode = this.option("stylingMode");
                var stylingModeClass = "dx-button-mode-".concat(stylingMode);
                [
                    "dx-button-mode-contained",
                    "dx-button-mode-text",
                    "dx-button-mode-outlined"
                ].forEach($element.removeClass.bind($element));
                if ([
                    "contained",
                    "text",
                    "outlined"
                ].indexOf(stylingMode) === -1) {
                    var defaultOptionValue = this._getDefaultOptions().stylingMode;
                    stylingModeClass = "dx-button-mode-".concat(defaultOptionValue);
                }
                $element.addClass(stylingModeClass);
            }
        },
        {
            key: "_renderSubmitInput",
            value: function() {
                var submitAction = this._getSubmitAction();
                this._needValidate = true;
                this._validationStatus = "valid";
                this._$submitInput = (0, $5a44c80307d41a7e$var$_renderer2.default)("<input>").attr("type", "submit").attr("tabindex", -1).addClass("dx-button-submit-input").appendTo(this._$content);
                $5a44c80307d41a7e$var$_events_engine2.default.on(this._$submitInput, "click", function(e) {
                    return submitAction({
                        event: e
                    });
                });
            }
        },
        {
            key: "_renderType",
            value: function() {
                var type = this.option("type");
                type && this.$element().addClass("dx-button-".concat(type));
            }
        },
        {
            key: "_setDisabled",
            value: function(value) {
                this.option("disabled", value);
            }
        },
        {
            key: "_supportedKeys",
            value: function() {
                var _this4 = this;
                var click = function(e) {
                    e.preventDefault();
                    _this4._executeClickAction(e);
                };
                return (0, $7I8Uw.extend)($5a44c80307d41a7e$var$_get($5a44c80307d41a7e$var$_getPrototypeOf(Button.prototype), "_supportedKeys", this).call(this), {
                    space: click,
                    enter: click
                });
            }
        },
        {
            key: "_toggleActiveState",
            value: function($el, value, event) {
                $5a44c80307d41a7e$var$_get($5a44c80307d41a7e$var$_getPrototypeOf(Button.prototype), "_toggleActiveState", this).call(this, $el, value, event);
                if (this._inkRipple) {
                    var config = {
                        element: this._$content,
                        event: event
                    };
                    value ? this._inkRipple.showWave(config) : this._inkRipple.hideWave(config);
                }
            }
        },
        {
            key: "_updateAriaLabel",
            value: function() {
                var icon = this.option("icon");
                var text = this.option("text");
                if ("image" === (0, $69u7b.getImageSourceType)(icon)) icon = icon.indexOf("base64") === -1 ? icon.replace(/.+\/([^.]+)\..+$/, "$1") : "Base64";
                var ariaLabel = text || icon || "";
                ariaLabel = ariaLabel.toString().trim();
                this.setAria("label", ariaLabel.length ? ariaLabel : null);
            }
        },
        {
            key: "_updateContent",
            value: function() {
                var $element = this.$element();
                var data = this._getContentData();
                var icon = data.icon, text = data.text;
                this._$content ? this._$content.empty() : this._$content = (0, $5a44c80307d41a7e$var$_renderer2.default)("<div>").addClass("dx-button-content").appendTo($element);
                $element.toggleClass("dx-button-has-icon", !!icon).toggleClass("dx-button-icon-right", !!icon && "left" !== this.option("iconPosition")).toggleClass("dx-button-has-text", !!text);
                var transclude = this._getAnonymousTemplateName() === this.option("template");
                var template = this._getTemplateByOption("template");
                var $result = (0, $5a44c80307d41a7e$var$_renderer2.default)(template.render({
                    model: data,
                    container: (0, $5OzEX.getPublicElement)(this._$content),
                    transclude: transclude
                }));
                if ($result.hasClass("dx-template-wrapper")) {
                    this._$content.replaceWith($result);
                    this._$content = $result;
                    this._$content.addClass("dx-button-content");
                }
                this.option("useSubmitBehavior") && this._renderSubmitInput();
            }
        },
        {
            key: "_waitForValidationCompleting",
            value: function(complete) {
                var _this5 = this;
                complete.then(function(result) {
                    _this5._validationStatus = result.status;
                    _this5._setDisabled(false);
                    "valid" === _this5._validationStatus && _this5._$submitInput.get(0).click();
                    _this5._needValidate = true;
                    return result;
                });
            }
        },
        {
            key: "_validationGroupConfig",
            get: function() {
                return $5a44c80307d41a7e$var$_validation_engine2.default.getGroupConfig(this._findGroup());
            }
        }
    ]);
    return Button;
}($5a44c80307d41a7e$var$_ui2.default);
(0, $5a44c80307d41a7e$var$_component_registrator2.default)("dxButton", $5a44c80307d41a7e$var$Button);
module.exports = $5a44c80307d41a7e$var$Button;
module.exports.default = module.exports;

});
parcelRegister("aiwte", function(module, exports) {
/**
 * DevExtreme (core/devices.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $irv64 = parcelRequire("irv64");
var $77f4c5ce114e90a7$var$navigator = $irv64.getNavigator();
var $77f4c5ce114e90a7$var$window = $irv64.getWindow();

var $7I8Uw = parcelRequire("7I8Uw");
var $77f4c5ce114e90a7$require$extend = $7I8Uw.extend;

var $kDRxH = parcelRequire("kDRxH");
var $77f4c5ce114e90a7$require$isPlainObject = $kDRxH.isPlainObject;

var $4Pwuy = parcelRequire("4Pwuy");
var $77f4c5ce114e90a7$require$each = $4Pwuy.each;

var $k7aJb = parcelRequire("k7aJb");

var $7sX7V = parcelRequire("7sX7V");

var $eKdKS = parcelRequire("eKdKS");

var $4OGCY = parcelRequire("4OGCY");

var $cWRya = parcelRequire("cWRya");

var $fD0KT = parcelRequire("fD0KT");
var $77f4c5ce114e90a7$require$SessionStorage = $fD0KT.sessionStorage;

var $7wA28 = parcelRequire("7wA28");

var $1JvXr = parcelRequire("1JvXr");
var $77f4c5ce114e90a7$var$KNOWN_UA_TABLE = {
    iPhone: "iPhone",
    iPhone5: "iPhone",
    iPhone6: "iPhone",
    iPhone6plus: "iPhone",
    iPad: "iPad",
    iPadMini: "iPad Mini",
    androidPhone: "Android Mobile",
    androidTablet: "Android",
    msSurface: "Windows ARM Tablet PC",
    desktop: "desktop"
};
var $77f4c5ce114e90a7$var$DEFAULT_DEVICE = {
    deviceType: "desktop",
    platform: "generic",
    version: [],
    phone: false,
    tablet: false,
    android: false,
    ios: false,
    generic: true,
    grade: "A",
    mac: false
};
var $77f4c5ce114e90a7$var$uaParsers = {
    generic: function(userAgent) {
        var isPhone = /windows phone/i.test(userAgent) || userAgent.match(/WPDesktop/);
        var isTablet = !isPhone && /Windows(.*)arm(.*)Tablet PC/i.test(userAgent);
        var isDesktop = !isPhone && !isTablet && /msapphost/i.test(userAgent);
        var isMac = /((intel|ppc) mac os x)/.test(userAgent.toLowerCase());
        if (!(isPhone || isTablet || isDesktop || isMac)) return;
        return {
            deviceType: isPhone ? "phone" : isTablet ? "tablet" : "desktop",
            platform: "generic",
            version: [],
            grade: "A",
            mac: isMac
        };
    },
    ios: function(userAgent) {
        if (!/ip(hone|od|ad)/i.test(userAgent)) return;
        var isPhone = /ip(hone|od)/i.test(userAgent);
        var matches = userAgent.match(/os (\d+)_(\d+)_?(\d+)?/i);
        var version = matches ? [
            parseInt(matches[1], 10),
            parseInt(matches[2], 10),
            parseInt(matches[3] || 0, 10)
        ] : [];
        var isIPhone4 = 480 === $77f4c5ce114e90a7$var$window.screen.height;
        var grade = isIPhone4 ? "B" : "A";
        return {
            deviceType: isPhone ? "phone" : "tablet",
            platform: "ios",
            version: version,
            grade: grade
        };
    },
    android: function(userAgent) {
        if (!/android|htc_|silk/i.test(userAgent)) return;
        var isPhone = /mobile/i.test(userAgent);
        var matches = userAgent.match(/android (\d+)\.?(\d+)?\.?(\d+)?/i);
        var version = matches ? [
            parseInt(matches[1], 10),
            parseInt(matches[2] || 0, 10),
            parseInt(matches[3] || 0, 10)
        ] : [];
        var worseThan4_4 = version.length > 1 && (version[0] < 4 || 4 === version[0] && version[1] < 4);
        var grade = worseThan4_4 ? "B" : "A";
        return {
            deviceType: isPhone ? "phone" : "tablet",
            platform: "android",
            version: version,
            grade: grade
        };
    }
};
var $77f4c5ce114e90a7$var$Devices = $k7aJb.inherit({
    ctor: function(options) {
        this._window = options && options.window || $77f4c5ce114e90a7$var$window;
        this._realDevice = this._getDevice();
        this._currentDevice = void 0;
        this._currentOrientation = void 0;
        this.changed = $eKdKS();
        if ($irv64.hasWindow()) {
            this._recalculateOrientation();
            $4OGCY.add(this._recalculateOrientation.bind(this));
        }
    },
    current: function(deviceOrName) {
        if (deviceOrName) {
            this._currentDevice = this._getDevice(deviceOrName);
            this._forced = true;
            this.changed.fire();
            return;
        }
        if (!this._currentDevice) {
            deviceOrName = void 0;
            try {
                deviceOrName = this._getDeviceOrNameFromWindowScope();
            } catch (e) {
                deviceOrName = this._getDeviceNameFromSessionStorage();
            } finally{
                if (!deviceOrName) deviceOrName = this._getDeviceNameFromSessionStorage();
                if (deviceOrName) this._forced = true;
            }
            this._currentDevice = this._getDevice(deviceOrName);
        }
        return this._currentDevice;
    },
    real: function() {
        return $77f4c5ce114e90a7$require$extend({}, this._realDevice);
    },
    orientation: function() {
        return this._currentOrientation;
    },
    isForced: function() {
        return this._forced;
    },
    isRippleEmulator: function() {
        return !!this._window.tinyHippos;
    },
    _getCssClasses: function(device) {
        var result = [];
        var realDevice = this._realDevice;
        device = device || this.current();
        if (device.deviceType) {
            result.push("dx-device-" + device.deviceType);
            if ("desktop" !== device.deviceType) result.push("dx-device-mobile");
        }
        result.push("dx-device-" + realDevice.platform);
        if (realDevice.version && realDevice.version.length) result.push("dx-device-" + realDevice.platform + "-" + realDevice.version[0]);
        if ($77f4c5ce114e90a7$var$devices.isSimulator()) result.push("dx-simulator");
        if ($1JvXr().rtlEnabled) result.push("dx-rtl");
        return result;
    },
    attachCssClasses: function(element, device) {
        this._deviceClasses = this._getCssClasses(device).join(" ");
        $jFnCG(element).addClass(this._deviceClasses);
    },
    detachCssClasses: function(element) {
        $jFnCG(element).removeClass(this._deviceClasses);
    },
    isSimulator: function() {
        try {
            return this._isSimulator || $irv64.hasWindow() && this._window.top !== this._window.self && this._window.top["dx-force-device"] || this.isRippleEmulator();
        } catch (e) {
            return false;
        }
    },
    forceSimulator: function() {
        this._isSimulator = true;
    },
    _getDevice: function(deviceName) {
        if ("genericPhone" === deviceName) deviceName = {
            deviceType: "phone",
            platform: "generic",
            generic: true
        };
        if ($77f4c5ce114e90a7$require$isPlainObject(deviceName)) return this._fromConfig(deviceName);
        else {
            var ua;
            if (deviceName) {
                ua = $77f4c5ce114e90a7$var$KNOWN_UA_TABLE[deviceName];
                if (!ua) throw $7sX7V.Error("E0005");
            } else ua = $77f4c5ce114e90a7$var$navigator.userAgent;
            return this._fromUA(ua);
        }
    },
    _getDeviceOrNameFromWindowScope: function() {
        var result;
        if ($irv64.hasWindow() && (this._window.top["dx-force-device-object"] || this._window.top["dx-force-device"])) result = this._window.top["dx-force-device-object"] || this._window.top["dx-force-device"];
        return result;
    },
    _getDeviceNameFromSessionStorage: function() {
        var sessionStorage = $77f4c5ce114e90a7$require$SessionStorage();
        if (!sessionStorage) return;
        var deviceOrName = sessionStorage.getItem("dx-force-device");
        try {
            return JSON.parse(deviceOrName);
        } catch (ex) {
            return deviceOrName;
        }
    },
    _fromConfig: function(config) {
        var result = $77f4c5ce114e90a7$require$extend({}, $77f4c5ce114e90a7$var$DEFAULT_DEVICE, this._currentDevice, config);
        var shortcuts = {
            phone: "phone" === result.deviceType,
            tablet: "tablet" === result.deviceType,
            android: "android" === result.platform,
            ios: "ios" === result.platform,
            generic: "generic" === result.platform
        };
        return $77f4c5ce114e90a7$require$extend(result, shortcuts);
    },
    _fromUA: function(ua) {
        var config;
        $77f4c5ce114e90a7$require$each($77f4c5ce114e90a7$var$uaParsers, function(platform, parser) {
            config = parser(ua);
            return !config;
        });
        if (config) return this._fromConfig(config);
        return $77f4c5ce114e90a7$var$DEFAULT_DEVICE;
    },
    _changeOrientation: function() {
        var $window = $jFnCG(this._window);
        var orientation = $window.height() > $window.width() ? "portrait" : "landscape";
        if (this._currentOrientation === orientation) return;
        this._currentOrientation = orientation;
        this.fireEvent("orientationChanged", [
            {
                orientation: orientation
            }
        ]);
    },
    _recalculateOrientation: function() {
        var windowWidth = $jFnCG(this._window).width();
        if (this._currentWidth === windowWidth) return;
        this._currentWidth = windowWidth;
        this._changeOrientation();
    }
}).include($cWRya);
var $77f4c5ce114e90a7$var$devices = new $77f4c5ce114e90a7$var$Devices;
$7wA28.changeCallback.add(function(viewPort, prevViewport) {
    $77f4c5ce114e90a7$var$devices.detachCssClasses(prevViewport);
    $77f4c5ce114e90a7$var$devices.attachCssClasses(viewPort);
});
module.exports = $77f4c5ce114e90a7$var$devices;
module.exports.default = module.exports;

});
parcelRegister("4OGCY", function(module, exports) {
/**
 * DevExtreme (core/utils/resize_callbacks.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $irv64 = parcelRequire("irv64");

var $445Bz = parcelRequire("445Bz");

var $eKdKS = parcelRequire("eKdKS");

var $g4e4U = parcelRequire("g4e4U");

var $ePlHj = parcelRequire("ePlHj");
var $381ce5e9c950fb84$var$resizeCallbacks = function() {
    var prevSize;
    var callbacks = $eKdKS();
    var originalCallbacksAdd = callbacks.add;
    var originalCallbacksRemove = callbacks.remove;
    if (!$irv64.hasWindow()) return callbacks;
    var formatSize = function() {
        var window = $irv64.getWindow();
        return {
            width: window.innerWidth,
            height: window.innerHeight
        };
    };
    var handleResize = function() {
        var now = formatSize();
        if (now.width === prevSize.width && now.height === prevSize.height) return;
        var changedDimension;
        if (now.width === prevSize.width) changedDimension = "height";
        if (now.height === prevSize.height) changedDimension = "width";
        prevSize = now;
        callbacks.fire(changedDimension);
    };
    var setPrevSize = $ePlHj(function() {
        prevSize = formatSize();
    });
    var removeListener;
    callbacks.add = function() {
        var result = originalCallbacksAdd.apply(callbacks, arguments);
        setPrevSize();
        $g4e4U.add(function() {
            if (!removeListener && callbacks.has()) removeListener = $445Bz.listen($irv64.getWindow(), "resize", handleResize);
        });
        return result;
    };
    callbacks.remove = function() {
        var result = originalCallbacksRemove.apply(callbacks, arguments);
        if (!callbacks.has() && removeListener) {
            removeListener();
            removeListener = void 0;
        }
        return result;
    };
    return callbacks;
}();
module.exports = $381ce5e9c950fb84$var$resizeCallbacks;

});
parcelRegister("g4e4U", function(module, exports) {
/**
 * DevExtreme (core/utils/ready_callbacks.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $445Bz = parcelRequire("445Bz");

var $6LNcw = parcelRequire("6LNcw");

var $irv64 = parcelRequire("irv64");

var $ePlHj = parcelRequire("ePlHj");
var $bb27f0b85ee58952$var$callbacks = [];
var $bb27f0b85ee58952$var$isReady = function() {
    return "complete" === $445Bz.getReadyState() || "loading" !== $445Bz.getReadyState() && !$445Bz.getDocumentElement().doScroll;
};
var $bb27f0b85ee58952$var$subscribeReady = $ePlHj(function() {
    var removeListener = $445Bz.listen($445Bz.getDocument(), "DOMContentLoaded", function() {
        $bb27f0b85ee58952$var$readyCallbacks.fire();
        removeListener();
    });
});
var $bb27f0b85ee58952$var$readyCallbacks = {
    add: function(callback) {
        var hasWindow = $irv64.hasWindow();
        if (hasWindow && $bb27f0b85ee58952$var$isReady()) callback();
        else {
            $bb27f0b85ee58952$var$callbacks.push(callback);
            hasWindow && $bb27f0b85ee58952$var$subscribeReady();
        }
    },
    fire: function() {
        $bb27f0b85ee58952$var$callbacks.forEach(function(callback) {
            return callback();
        });
        $bb27f0b85ee58952$var$callbacks = [];
    }
};
module.exports = $6LNcw($bb27f0b85ee58952$var$readyCallbacks);

});


parcelRegister("cWRya", function(module, exports) {
/**
 * DevExtreme (core/events_mixin.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $dEZqA = parcelRequire("dEZqA");

var $4Pwuy = parcelRequire("4Pwuy");
var $96d470bf38c337e5$require$each = $4Pwuy.each;

var $kDRxH = parcelRequire("kDRxH");
var $96d470bf38c337e5$require$isPlainObject = $kDRxH.isPlainObject;
module.exports = {
    ctor: function() {
        this._events = {};
        this.setEventsStrategy(new $dEZqA(this));
    },
    setEventsStrategy: function(strategy) {
        if ("function" === typeof strategy) strategy = strategy(this);
        this._eventsStrategy = strategy;
    },
    hasEvent: function(eventName) {
        return this._eventsStrategy.hasEvent(eventName);
    },
    fireEvent: function(eventName, eventArgs) {
        this._eventsStrategy.fireEvent(eventName, eventArgs);
        return this;
    },
    on: function(eventName, eventHandler) {
        if ($96d470bf38c337e5$require$isPlainObject(eventName)) $96d470bf38c337e5$require$each(eventName, (function(e, h) {
            this.on(e, h);
        }).bind(this));
        else this._eventsStrategy.on(eventName, eventHandler);
        return this;
    },
    off: function(eventName, eventHandler) {
        this._eventsStrategy.off(eventName, eventHandler);
        return this;
    },
    _disposeEvents: function() {
        this._eventsStrategy.dispose();
    }
};

});
parcelRegister("dEZqA", function(module, exports) {
/**
 * DevExtreme (core/events_strategy.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $eKdKS = parcelRequire("eKdKS");

var $kDRxH = parcelRequire("kDRxH");
var $9f1ea918d85e38ee$require$isFunction = $kDRxH.isFunction;

var $4Pwuy = parcelRequire("4Pwuy");
var $9f1ea918d85e38ee$require$each = $4Pwuy.each;

var $k7aJb = parcelRequire("k7aJb");
module.exports = $k7aJb.inherit({
    ctor: function(owner) {
        this._events = {};
        this._owner = owner;
    },
    hasEvent: function(eventName) {
        var callbacks = this._events[eventName];
        if (callbacks) return callbacks.has();
        return false;
    },
    fireEvent: function(eventName, eventArgs) {
        var callbacks = this._events[eventName];
        if (callbacks) callbacks.fireWith(this._owner, eventArgs);
    },
    on: function(eventName, eventHandler) {
        var callbacks = this._events[eventName];
        if (!callbacks) {
            callbacks = $eKdKS();
            this._events[eventName] = callbacks;
        }
        var addFn = callbacks.originalAdd || callbacks.add;
        addFn.call(callbacks, eventHandler);
    },
    off: function(eventName, eventHandler) {
        var callbacks = this._events[eventName];
        if (callbacks) {
            if ($9f1ea918d85e38ee$require$isFunction(eventHandler)) callbacks.remove(eventHandler);
            else callbacks.empty();
        }
    },
    dispose: function() {
        $9f1ea918d85e38ee$require$each(this._events, function() {
            this.empty();
        });
    }
});

});


parcelRegister("fD0KT", function(module, exports) {

$parcel$export(module.exports, "sessionStorage", () => $b60b158aad75f430$export$f119d83aa936d634, (v) => $b60b158aad75f430$export$f119d83aa936d634 = v);
/**
 * DevExtreme (core/utils/storage.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $b60b158aad75f430$export$f119d83aa936d634;
"use strict";

var $b60b158aad75f430$var$window = (parcelRequire("irv64")).getWindow();
var $b60b158aad75f430$var$getSessionStorage = function() {
    var sessionStorage;
    try {
        sessionStorage = $b60b158aad75f430$var$window.sessionStorage;
    } catch (e) {}
    return sessionStorage;
};
$b60b158aad75f430$export$f119d83aa936d634 = $b60b158aad75f430$var$getSessionStorage;

});

parcelRegister("7wA28", function(module, exports) {

$parcel$export(module.exports, "value", () => $57a7790efe36c90d$export$2ab9a8f9f1186f14, (v) => $57a7790efe36c90d$export$2ab9a8f9f1186f14 = v);
$parcel$export(module.exports, "changeCallback", () => $57a7790efe36c90d$export$2004d4da319c8d66, (v) => $57a7790efe36c90d$export$2004d4da319c8d66 = v);
$parcel$export(module.exports, "originalViewPort", () => $57a7790efe36c90d$export$45c50885f51f0f9f, (v) => $57a7790efe36c90d$export$45c50885f51f0f9f = v);
/**
 * DevExtreme (core/utils/view_port.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $57a7790efe36c90d$export$2ab9a8f9f1186f14;
var $57a7790efe36c90d$export$2004d4da319c8d66;
var $57a7790efe36c90d$export$45c50885f51f0f9f;
"use strict";

var $jFnCG = parcelRequire("jFnCG");

var $g4e4U = parcelRequire("g4e4U");
var $57a7790efe36c90d$var$ready = $g4e4U.add;

var $57a7790efe36c90d$var$changeCallback = (parcelRequire("eKdKS"))();
var $57a7790efe36c90d$var$$originalViewPort = $jFnCG();
var $57a7790efe36c90d$var$value = function() {
    var $current;
    return function(element) {
        if (!arguments.length) return $current;
        var $element = $jFnCG(element);
        $57a7790efe36c90d$var$$originalViewPort = $element;
        var isNewViewportFound = !!$element.length;
        var prevViewPort = $57a7790efe36c90d$var$value();
        $current = isNewViewportFound ? $element : $jFnCG("body");
        $57a7790efe36c90d$var$changeCallback.fire(isNewViewportFound ? $57a7790efe36c90d$var$value() : $jFnCG(), prevViewPort);
    };
}();
$57a7790efe36c90d$var$ready(function() {
    $57a7790efe36c90d$var$value(".dx-viewport");
});
$57a7790efe36c90d$export$2ab9a8f9f1186f14 = $57a7790efe36c90d$var$value;
$57a7790efe36c90d$export$2004d4da319c8d66 = $57a7790efe36c90d$var$changeCallback;
$57a7790efe36c90d$export$45c50885f51f0f9f = function() {
    return $57a7790efe36c90d$var$$originalViewPort;
};

});


parcelRegister("gysT6", function(module, exports) {
/**
 * DevExtreme (ui/widget/utils.ink_ripple.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $c0d63ad03a04da0b$var$INKRIPPLE_CLASS = "dx-inkripple";
var $c0d63ad03a04da0b$var$INKRIPPLE_WAVE_CLASS = "dx-inkripple-wave";
var $c0d63ad03a04da0b$var$INKRIPPLE_SHOWING_CLASS = "dx-inkripple-showing";
var $c0d63ad03a04da0b$var$INKRIPPLE_HIDING_CLASS = "dx-inkripple-hiding";
var $c0d63ad03a04da0b$var$DEFAULT_WAVE_SIZE_COEFFICIENT = 2;
var $c0d63ad03a04da0b$var$MAX_WAVE_SIZE = 4e3;
var $c0d63ad03a04da0b$var$ANIMATION_DURATION = 300;
var $c0d63ad03a04da0b$var$HOLD_ANIMATION_DURATION = 1e3;
var $c0d63ad03a04da0b$var$DEFAULT_WAVE_INDEX = 0;
var $c0d63ad03a04da0b$var$render = function(args) {
    args = args || {};
    if (void 0 === args.useHoldAnimation) args.useHoldAnimation = true;
    var config = {
        waveSizeCoefficient: args.waveSizeCoefficient || $c0d63ad03a04da0b$var$DEFAULT_WAVE_SIZE_COEFFICIENT,
        isCentered: args.isCentered || false,
        wavesNumber: args.wavesNumber || 1,
        durations: $c0d63ad03a04da0b$var$getDurations(args.useHoldAnimation)
    };
    return {
        showWave: $c0d63ad03a04da0b$var$showWave.bind(this, config),
        hideWave: $c0d63ad03a04da0b$var$hideWave.bind(this, config)
    };
};
var $c0d63ad03a04da0b$var$getInkRipple = function(element) {
    var result = element.children("." + $c0d63ad03a04da0b$var$INKRIPPLE_CLASS);
    if (0 === result.length) result = $jFnCG("<div>").addClass($c0d63ad03a04da0b$var$INKRIPPLE_CLASS).appendTo(element);
    return result;
};
var $c0d63ad03a04da0b$var$getWaves = function(element, wavesNumber) {
    var inkRipple = $c0d63ad03a04da0b$var$getInkRipple(element);
    var result = inkRipple.children("." + $c0d63ad03a04da0b$var$INKRIPPLE_WAVE_CLASS).toArray();
    for(var i = result.length; i < wavesNumber; i++){
        var $currentWave = $jFnCG("<div>").appendTo(inkRipple).addClass($c0d63ad03a04da0b$var$INKRIPPLE_WAVE_CLASS);
        result.push($currentWave[0]);
    }
    return $jFnCG(result);
};
var $c0d63ad03a04da0b$var$getWaveStyleConfig = function(args, config) {
    var element = config.element;
    var elementWidth = element.outerWidth();
    var elementHeight = element.outerHeight();
    var elementDiagonal = parseInt(Math.sqrt(elementWidth * elementWidth + elementHeight * elementHeight));
    var waveSize = Math.min($c0d63ad03a04da0b$var$MAX_WAVE_SIZE, parseInt(elementDiagonal * args.waveSizeCoefficient));
    var left;
    var top;
    if (args.isCentered) {
        left = (elementWidth - waveSize) / 2;
        top = (elementHeight - waveSize) / 2;
    } else {
        var event = config.event;
        var position = config.element.offset();
        var x = event.pageX - position.left;
        var y = event.pageY - position.top;
        left = x - waveSize / 2;
        top = y - waveSize / 2;
    }
    return {
        left: left,
        top: top,
        height: waveSize,
        width: waveSize
    };
};
var $c0d63ad03a04da0b$var$showWave = function(args, config) {
    var $wave = $c0d63ad03a04da0b$var$getWaves(config.element, args.wavesNumber).eq(config.wave || $c0d63ad03a04da0b$var$DEFAULT_WAVE_INDEX);
    args.hidingTimeout && clearTimeout(args.hidingTimeout);
    $c0d63ad03a04da0b$var$hideSelectedWave($wave);
    $wave.css($c0d63ad03a04da0b$var$getWaveStyleConfig(args, config));
    args.showingTimeout = setTimeout($c0d63ad03a04da0b$var$showingWaveHandler.bind(this, args, $wave), 0);
};
var $c0d63ad03a04da0b$var$showingWaveHandler = function(args, $wave) {
    var durationCss = args.durations.showingScale + "ms";
    $wave.addClass($c0d63ad03a04da0b$var$INKRIPPLE_SHOWING_CLASS).css("transitionDuration", durationCss);
};
var $c0d63ad03a04da0b$var$getDurations = function(useHoldAnimation) {
    return {
        showingScale: useHoldAnimation ? $c0d63ad03a04da0b$var$HOLD_ANIMATION_DURATION : $c0d63ad03a04da0b$var$ANIMATION_DURATION,
        hidingScale: $c0d63ad03a04da0b$var$ANIMATION_DURATION,
        hidingOpacity: $c0d63ad03a04da0b$var$ANIMATION_DURATION
    };
};
var $c0d63ad03a04da0b$var$hideSelectedWave = function($wave) {
    $wave.removeClass($c0d63ad03a04da0b$var$INKRIPPLE_HIDING_CLASS).css("transitionDuration", "");
};
var $c0d63ad03a04da0b$var$hideWave = function(args, config) {
    args.showingTimeout && clearTimeout(args.showingTimeout);
    var $wave = $c0d63ad03a04da0b$var$getWaves(config.element, config.wavesNumber).eq(config.wave || $c0d63ad03a04da0b$var$DEFAULT_WAVE_INDEX);
    var durations = args.durations;
    var durationCss = durations.hidingScale + "ms, " + durations.hidingOpacity + "ms";
    $wave.addClass($c0d63ad03a04da0b$var$INKRIPPLE_HIDING_CLASS).removeClass($c0d63ad03a04da0b$var$INKRIPPLE_SHOWING_CLASS).css("transitionDuration", durationCss);
    var animationDuration = Math.max(durations.hidingScale, durations.hidingOpacity);
    args.hidingTimeout = setTimeout($c0d63ad03a04da0b$var$hideSelectedWave.bind(this, $wave), animationDuration);
};
module.exports = {
    render: $c0d63ad03a04da0b$var$render
};

});

parcelRegister("3LUJe", function(module, exports) {
/**
 * DevExtreme (ui/themes.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $445Bz = parcelRequire("445Bz");

var $irv64 = parcelRequire("irv64");
var $2bf1c3fac99b5ed2$var$window = $irv64.getWindow();

var $2F60d = parcelRequire("2F60d");
var $2bf1c3fac99b5ed2$require$Deferred = $2F60d.Deferred;

var $lrsNa = parcelRequire("lrsNa");

var $5OzEX = parcelRequire("5OzEX");

var $g4e4U = parcelRequire("g4e4U");
var $2bf1c3fac99b5ed2$var$ready = $g4e4U.add;

var $4Pwuy = parcelRequire("4Pwuy");
var $2bf1c3fac99b5ed2$require$each = $4Pwuy.each;

var $aiwte = parcelRequire("aiwte");

var $7wA28 = parcelRequire("7wA28");

var $1V5m6 = parcelRequire("1V5m6");
var $2bf1c3fac99b5ed2$var$viewPort = $7wA28.value;

var $1jnPB = parcelRequire("1jnPB");
var $2bf1c3fac99b5ed2$var$viewPortChanged = $7wA28.changeCallback;
var $2bf1c3fac99b5ed2$var$DX_LINK_SELECTOR = "link[rel=dx-theme]";
var $2bf1c3fac99b5ed2$var$THEME_ATTR = "data-theme";
var $2bf1c3fac99b5ed2$var$ACTIVE_ATTR = "data-active";
var $2bf1c3fac99b5ed2$var$DX_HAIRLINES_CLASS = "dx-hairlines";
var $2bf1c3fac99b5ed2$var$context;
var $2bf1c3fac99b5ed2$var$$activeThemeLink;
var $2bf1c3fac99b5ed2$var$knownThemes;
var $2bf1c3fac99b5ed2$var$currentThemeName;
var $2bf1c3fac99b5ed2$var$pendingThemeName;
var $2bf1c3fac99b5ed2$var$timerId;
var $2bf1c3fac99b5ed2$var$THEME_MARKER_PREFIX = "dx.";
function $2bf1c3fac99b5ed2$var$readThemeMarker() {
    if (!$irv64.hasWindow()) return null;
    var element = $jFnCG("<div>", $2bf1c3fac99b5ed2$var$context).addClass("dx-theme-marker").appendTo($2bf1c3fac99b5ed2$var$context.documentElement);
    var result;
    try {
        result = element.css("fontFamily");
        if (!result) return null;
        result = result.replace(/["']/g, "");
        if (result.substr(0, $2bf1c3fac99b5ed2$var$THEME_MARKER_PREFIX.length) !== $2bf1c3fac99b5ed2$var$THEME_MARKER_PREFIX) return null;
        return result.substr($2bf1c3fac99b5ed2$var$THEME_MARKER_PREFIX.length);
    } finally{
        element.remove();
    }
}
function $2bf1c3fac99b5ed2$var$waitForThemeLoad(themeName) {
    var waitStartTime;
    $2bf1c3fac99b5ed2$var$pendingThemeName = themeName;
    function handleLoaded() {
        $2bf1c3fac99b5ed2$var$pendingThemeName = null;
        $1V5m6.fire();
        $1V5m6.empty();
    }
    if ($2bf1c3fac99b5ed2$var$isPendingThemeLoaded()) handleLoaded();
    else {
        waitStartTime = Date.now();
        $2bf1c3fac99b5ed2$var$timerId = setInterval(function() {
            var isLoaded = $2bf1c3fac99b5ed2$var$isPendingThemeLoaded();
            var isTimeout = !isLoaded && Date.now() - waitStartTime > 15e3;
            if (isTimeout) $lrsNa.log("W0004", $2bf1c3fac99b5ed2$var$pendingThemeName);
            if (isLoaded || isTimeout) {
                clearInterval($2bf1c3fac99b5ed2$var$timerId);
                $2bf1c3fac99b5ed2$var$timerId = void 0;
                handleLoaded();
            }
        }, 10);
    }
}
function $2bf1c3fac99b5ed2$var$isPendingThemeLoaded() {
    return !$2bf1c3fac99b5ed2$var$pendingThemeName || $2bf1c3fac99b5ed2$var$readThemeMarker() === $2bf1c3fac99b5ed2$var$pendingThemeName;
}
function $2bf1c3fac99b5ed2$var$processMarkup() {
    var $allThemeLinks = $jFnCG($2bf1c3fac99b5ed2$var$DX_LINK_SELECTOR, $2bf1c3fac99b5ed2$var$context);
    if (!$allThemeLinks.length) return;
    $2bf1c3fac99b5ed2$var$knownThemes = {};
    $2bf1c3fac99b5ed2$var$$activeThemeLink = $jFnCG($5OzEX.createMarkupFromString("<link rel=stylesheet>"), $2bf1c3fac99b5ed2$var$context);
    $allThemeLinks.each(function() {
        var link = $jFnCG(this, $2bf1c3fac99b5ed2$var$context);
        var fullThemeName = link.attr($2bf1c3fac99b5ed2$var$THEME_ATTR);
        var url = link.attr("href");
        var isActive = "true" === link.attr($2bf1c3fac99b5ed2$var$ACTIVE_ATTR);
        $2bf1c3fac99b5ed2$var$knownThemes[fullThemeName] = {
            url: url,
            isActive: isActive
        };
    });
    $allThemeLinks.last().after($2bf1c3fac99b5ed2$var$$activeThemeLink);
    $allThemeLinks.remove();
}
function $2bf1c3fac99b5ed2$var$resolveFullThemeName(desiredThemeName) {
    var desiredThemeParts = desiredThemeName ? desiredThemeName.split(".") : [];
    var result = null;
    if ($2bf1c3fac99b5ed2$var$knownThemes) {
        if (desiredThemeName in $2bf1c3fac99b5ed2$var$knownThemes) return desiredThemeName;
        $2bf1c3fac99b5ed2$require$each($2bf1c3fac99b5ed2$var$knownThemes, function(knownThemeName, themeData) {
            var knownThemeParts = knownThemeName.split(".");
            if (desiredThemeParts[0] && knownThemeParts[0] !== desiredThemeParts[0]) return;
            if (desiredThemeParts[1] && desiredThemeParts[1] !== knownThemeParts[1]) return;
            if (desiredThemeParts[2] && desiredThemeParts[2] !== knownThemeParts[2]) return;
            if (!result || themeData.isActive) result = knownThemeName;
            if (themeData.isActive) return false;
        });
    }
    return result;
}
function $2bf1c3fac99b5ed2$var$initContext(newContext) {
    try {
        if (newContext !== $2bf1c3fac99b5ed2$var$context) $2bf1c3fac99b5ed2$var$knownThemes = null;
    } catch (x) {
        $2bf1c3fac99b5ed2$var$knownThemes = null;
    }
    $2bf1c3fac99b5ed2$var$context = newContext;
}
function $2bf1c3fac99b5ed2$var$init(options) {
    options = options || {};
    $2bf1c3fac99b5ed2$var$initContext(options.context || $445Bz.getDocument());
    if (!$2bf1c3fac99b5ed2$var$context) return;
    $2bf1c3fac99b5ed2$var$processMarkup();
    $2bf1c3fac99b5ed2$var$currentThemeName = void 0;
    $2bf1c3fac99b5ed2$var$current(options);
}
function $2bf1c3fac99b5ed2$var$current(options) {
    if (!arguments.length) {
        $2bf1c3fac99b5ed2$var$currentThemeName = $2bf1c3fac99b5ed2$var$currentThemeName || $2bf1c3fac99b5ed2$var$readThemeMarker();
        return $2bf1c3fac99b5ed2$var$currentThemeName;
    }
    $2bf1c3fac99b5ed2$var$detachCssClasses($2bf1c3fac99b5ed2$var$viewPort());
    options = options || {};
    if ("string" === typeof options) options = {
        theme: options
    };
    var isAutoInit = options._autoInit;
    var loadCallback = options.loadCallback;
    var currentThemeData;
    $2bf1c3fac99b5ed2$var$currentThemeName = $2bf1c3fac99b5ed2$var$resolveFullThemeName(options.theme || $2bf1c3fac99b5ed2$var$currentThemeName);
    if ($2bf1c3fac99b5ed2$var$currentThemeName) currentThemeData = $2bf1c3fac99b5ed2$var$knownThemes[$2bf1c3fac99b5ed2$var$currentThemeName];
    if (loadCallback) $1V5m6.add(loadCallback);
    if (currentThemeData) {
        $2bf1c3fac99b5ed2$var$$activeThemeLink.attr("href", $2bf1c3fac99b5ed2$var$knownThemes[$2bf1c3fac99b5ed2$var$currentThemeName].url);
        if (($1V5m6.has() || options._forceTimeout) && !$2bf1c3fac99b5ed2$var$timerId) $2bf1c3fac99b5ed2$var$waitForThemeLoad($2bf1c3fac99b5ed2$var$currentThemeName);
        else if ($2bf1c3fac99b5ed2$var$pendingThemeName) $2bf1c3fac99b5ed2$var$pendingThemeName = $2bf1c3fac99b5ed2$var$currentThemeName;
    } else {
        if (isAutoInit) {
            $1V5m6.fire();
            $1V5m6.empty();
        } else throw $lrsNa.Error("E0021", $2bf1c3fac99b5ed2$var$currentThemeName);
    }
    $2bf1c3fac99b5ed2$var$checkThemeDeprecation();
    $2bf1c3fac99b5ed2$var$attachCssClasses($7wA28.originalViewPort(), $2bf1c3fac99b5ed2$var$currentThemeName);
}
function $2bf1c3fac99b5ed2$var$getCssClasses(themeName) {
    themeName = themeName || $2bf1c3fac99b5ed2$var$current();
    var result = [];
    var themeNameParts = themeName && themeName.split(".");
    if (themeNameParts) {
        result.push("dx-theme-" + themeNameParts[0], "dx-theme-" + themeNameParts[0] + "-typography");
        if (themeNameParts.length > 1) result.push("dx-color-scheme-" + themeNameParts[1] + ($2bf1c3fac99b5ed2$var$isMaterial(themeName) ? "-" + themeNameParts[2] : ""));
    }
    return result;
}
var $2bf1c3fac99b5ed2$var$themeClasses;
function $2bf1c3fac99b5ed2$var$attachCssClasses(element, themeName) {
    $2bf1c3fac99b5ed2$var$themeClasses = $2bf1c3fac99b5ed2$var$getCssClasses(themeName).join(" ");
    $jFnCG(element).addClass($2bf1c3fac99b5ed2$var$themeClasses);
    var activateHairlines = function() {
        var pixelRatio = $irv64.hasWindow() && $2bf1c3fac99b5ed2$var$window.devicePixelRatio;
        if (!pixelRatio || pixelRatio < 2) return;
        var $tester = $jFnCG("<div>");
        $tester.css("border", ".5px solid transparent");
        $jFnCG("body").append($tester);
        if (1 === $tester.outerHeight()) {
            $jFnCG(element).addClass($2bf1c3fac99b5ed2$var$DX_HAIRLINES_CLASS);
            $2bf1c3fac99b5ed2$var$themeClasses += " " + $2bf1c3fac99b5ed2$var$DX_HAIRLINES_CLASS;
        }
        $tester.remove();
    };
    activateHairlines();
}
function $2bf1c3fac99b5ed2$var$detachCssClasses(element) {
    $jFnCG(element).removeClass($2bf1c3fac99b5ed2$var$themeClasses);
}
function $2bf1c3fac99b5ed2$var$themeReady(callback) {
    $1V5m6.add(callback);
}
function $2bf1c3fac99b5ed2$var$isTheme(themeRegExp, themeName) {
    if (!themeName) themeName = $2bf1c3fac99b5ed2$var$currentThemeName || $2bf1c3fac99b5ed2$var$readThemeMarker();
    return new RegExp(themeRegExp).test(themeName);
}
function $2bf1c3fac99b5ed2$var$isMaterial(themeName) {
    return $2bf1c3fac99b5ed2$var$isTheme("material", themeName);
}
function $2bf1c3fac99b5ed2$var$isIos7(themeName) {
    return $2bf1c3fac99b5ed2$var$isTheme("ios7", themeName);
}
function $2bf1c3fac99b5ed2$var$isGeneric(themeName) {
    return $2bf1c3fac99b5ed2$var$isTheme("generic", themeName);
}
function $2bf1c3fac99b5ed2$var$isDark(themeName) {
    return $2bf1c3fac99b5ed2$var$isTheme("dark", themeName);
}
function $2bf1c3fac99b5ed2$var$checkThemeDeprecation() {
    if ($2bf1c3fac99b5ed2$var$isIos7()) $lrsNa.log("W0010", "The 'ios7' theme", "19.1", "Use the 'generic' theme instead.");
}
function $2bf1c3fac99b5ed2$var$isWebFontLoaded(text, fontWeight) {
    var testedFont = "Roboto, RobotoFallback, Arial";
    var etalonFont = "Arial";
    var document = $445Bz.getDocument();
    var testElement = document.createElement("span");
    testElement.style.position = "absolute";
    testElement.style.top = "-9999px";
    testElement.style.left = "-9999px";
    testElement.style.visibility = "hidden";
    testElement.style.fontFamily = etalonFont;
    testElement.style.fontSize = "250px";
    testElement.style.fontWeight = fontWeight;
    testElement.innerHTML = text;
    document.body.appendChild(testElement);
    var etalonFontWidth = testElement.offsetWidth;
    testElement.style.fontFamily = testedFont;
    var testedFontWidth = testElement.offsetWidth;
    testElement.parentNode.removeChild(testElement);
    return etalonFontWidth !== testedFontWidth;
}
function $2bf1c3fac99b5ed2$var$waitWebFont(text, fontWeight) {
    var interval = 15;
    var timeout = 2e3;
    return new $1jnPB(function(resolve) {
        var check = function() {
            if ($2bf1c3fac99b5ed2$var$isWebFontLoaded(text, fontWeight)) clear();
        };
        var clear = function() {
            clearInterval(intervalId);
            clearTimeout(timeoutId);
            resolve();
        };
        var intervalId = setInterval(check, interval);
        var timeoutId = setTimeout(clear, timeout);
    });
}
var $2bf1c3fac99b5ed2$var$initDeferred = new $2bf1c3fac99b5ed2$require$Deferred;
function $2bf1c3fac99b5ed2$var$autoInit() {
    $2bf1c3fac99b5ed2$var$init({
        _autoInit: true,
        _forceTimeout: true
    });
    if ($jFnCG($2bf1c3fac99b5ed2$var$DX_LINK_SELECTOR, $2bf1c3fac99b5ed2$var$context).length) throw $lrsNa.Error("E0022");
    $2bf1c3fac99b5ed2$var$initDeferred.resolve();
}
if ($irv64.hasWindow()) $2bf1c3fac99b5ed2$var$autoInit();
else $2bf1c3fac99b5ed2$var$ready($2bf1c3fac99b5ed2$var$autoInit);
$2bf1c3fac99b5ed2$var$viewPortChanged.add(function(viewPort, prevViewPort) {
    $2bf1c3fac99b5ed2$var$initDeferred.done(function() {
        $2bf1c3fac99b5ed2$var$detachCssClasses(prevViewPort);
        $2bf1c3fac99b5ed2$var$attachCssClasses(viewPort);
    });
});
$aiwte.changed.add(function() {
    $2bf1c3fac99b5ed2$var$init({
        _autoInit: true
    });
});
module.exports.current = $2bf1c3fac99b5ed2$var$current;
module.exports.ready = $2bf1c3fac99b5ed2$var$themeReady;
module.exports.init = $2bf1c3fac99b5ed2$var$init;
module.exports.attachCssClasses = $2bf1c3fac99b5ed2$var$attachCssClasses;
module.exports.detachCssClasses = $2bf1c3fac99b5ed2$var$detachCssClasses;
module.exports.waitForThemeLoad = $2bf1c3fac99b5ed2$var$waitForThemeLoad;
module.exports.isMaterial = $2bf1c3fac99b5ed2$var$isMaterial;
module.exports.isIos7 = $2bf1c3fac99b5ed2$var$isIos7;
module.exports.isGeneric = $2bf1c3fac99b5ed2$var$isGeneric;
module.exports.isDark = $2bf1c3fac99b5ed2$var$isDark;
module.exports.isWebFontLoaded = $2bf1c3fac99b5ed2$var$isWebFontLoaded;
module.exports.waitWebFont = $2bf1c3fac99b5ed2$var$waitWebFont;
module.exports.resetTheme = function() {
    $2bf1c3fac99b5ed2$var$$activeThemeLink && $2bf1c3fac99b5ed2$var$$activeThemeLink.attr("href", "about:blank");
    $2bf1c3fac99b5ed2$var$currentThemeName = null;
    $2bf1c3fac99b5ed2$var$pendingThemeName = null;
};
module.exports.default = module.exports;

});
parcelRegister("lrsNa", function(module, exports) {
/**
 * DevExtreme (ui/widget/ui.errors.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $iwn67 = parcelRequire("iwn67");

var $7sX7V = parcelRequire("7sX7V");
module.exports = $iwn67($7sX7V.ERROR_MESSAGES, {
    E1001: "Module '{0}'. Controller '{1}' is already registered",
    E1002: "Module '{0}'. Controller '{1}' does not inherit from DevExpress.ui.dxDataGrid.Controller",
    E1003: "Module '{0}'. View '{1}' is already registered",
    E1004: "Module '{0}'. View '{1}' does not inherit from DevExpress.ui.dxDataGrid.View",
    E1005: "Public method '{0}' is already registered",
    E1006: "Public method '{0}.{1}' does not exist",
    E1007: "State storing cannot be provided due to the restrictions of the browser",
    E1010: "The template does not contain the TextBox widget",
    E1011: 'Items cannot be deleted from the List. Implement the "remove" function in the data store',
    E1012: "Editing type '{0}' with the name '{1}' is unsupported",
    E1016: "Unexpected type of data source is provided for a lookup column",
    E1018: "The 'collapseAll' method cannot be called if you use a remote data source",
    E1019: "Search mode '{0}' is unavailable",
    E1020: "The type cannot be changed after initialization",
    E1021: "{0} '{1}' you are trying to remove does not exist",
    E1022: 'The "markers" option is given an invalid value. Assign an array instead',
    E1023: 'The "routes" option is given an invalid value. Assign an array instead',
    E1025: "This layout is too complex to render",
    E1026: 'The "calculateCustomSummary" function is missing from a field whose "summaryType" option is set to "custom"',
    E1030: "Unknown ScrollView refresh strategy: '{0}'",
    E1031: "Unknown subscription in the Scheduler widget: '{0}'",
    E1032: "Unknown start date in an appointment: '{0}'",
    E1033: "Unknown step in the date navigator: '{0}'",
    E1034: "The browser does not implement an API for saving files",
    E1035: "The editor cannot be created because of an internal error: {0}",
    E1037: "Invalid structure of grouped data",
    E1038: "The browser does not support local storages for local web pages",
    E1039: "A cell's position cannot be calculated",
    E1040: "The '{0}' key value is not unique within the data array",
    E1041: "The '{0}' script is referenced after the DevExtreme scripts or not referenced at all",
    E1042: "{0} requires the key field to be specified",
    E1043: "Changes cannot be processed due to the incorrectly set key",
    E1044: "The key field specified by the keyExpr option does not match the key field specified in the data store",
    E1045: "Editing requires the key field to be specified in the data store",
    E1046: "The '{0}' key field is not found in data objects",
    E1047: 'The "{0}" field is not found in the fields array',
    E1048: 'The "{0}" operation is not found in the filterOperations array',
    E1049: "Column '{0}': filtering is allowed but the 'dataField' or 'name' option is not specified",
    E1050: "The validationRules option does not apply to third-party editors defined in the editCellTemplate",
    E1051: 'HtmlEditor\'s valueType is "{0}", but the {0} converter was not imported.',
    E1052: '{0} should have the "dataSource" option specified',
    E1053: 'The "buttons" option accepts an array that contains only objects or string values',
    E1054: "All text editor buttons must have names",
    E1055: 'One or several text editor buttons have invalid or non-unique "name" values',
    E1056: 'The {0} widget does not support buttons of the "{1}" type',
    E1057: 'The {0} widget does not support asynchronous validation rules in the "{1}" edit mode',
    E1058: 'The "startDayHour" must be earlier than the "endDayHour"',
    W1001: 'The "key" option cannot be modified after initialization',
    W1002: "An item with the key '{0}' does not exist",
    W1003: "A group with the key '{0}' in which you are trying to select items does not exist",
    W1004: "The item '{0}' you are trying to select in the group '{1}' does not exist",
    W1005: "Due to column data types being unspecified, data has been loaded twice in order to apply initial filter settings. To resolve this issue, specify data types for all grid columns.",
    W1006: "The map service returned the following error: '{0}'",
    W1007: "No item with key {0} was found in the data source, but this key was used as the parent key for item {1}",
    W1008: "Cannot scroll to the '{0}' date because it does not exist on the current view",
    W1009: "Searching works only if data is specified using the dataSource option",
    W1010: "The capability to select all items works with source data of plain structure only",
    W1011: 'The "keyExpr" option is not applied when dataSource is not an array',
    W1012: "The '{0}' key field is not found in data objects",
    W1013: 'The "message" field in the dialog component was renamed to "messageHtml". Change your code correspondingly. In addition, if you used HTML code in the message, make sure that it is secure',
    W1014: "The Floating Action Button exceeds the recommended speed dial action count. If you need to display more speed dial actions, increase the maxSpeedDialActionCount option value in the global config.",
    W1015: 'The "cellDuration" should divide the range from the "startDayHour" to the "endDayHour" into even intervals'
});

});

parcelRegister("5OzEX", function(module, exports) {

$parcel$export(module.exports, "setPublicElementWrapper", () => $43bd487defacbb08$export$98ca6cfbd121a38b, (v) => $43bd487defacbb08$export$98ca6cfbd121a38b = v);
$parcel$export(module.exports, "resetActiveElement", () => $43bd487defacbb08$export$d3d8dd668187bb07, (v) => $43bd487defacbb08$export$d3d8dd668187bb07 = v);
$parcel$export(module.exports, "createMarkupFromString", () => $43bd487defacbb08$export$1d3b55adf589ea7, (v) => $43bd487defacbb08$export$1d3b55adf589ea7 = v);
$parcel$export(module.exports, "triggerShownEvent", () => $43bd487defacbb08$export$4e43b9e1134fa3da, (v) => $43bd487defacbb08$export$4e43b9e1134fa3da = v);
$parcel$export(module.exports, "triggerHidingEvent", () => $43bd487defacbb08$export$7d7521d776086d59, (v) => $43bd487defacbb08$export$7d7521d776086d59 = v);
$parcel$export(module.exports, "triggerResizeEvent", () => $43bd487defacbb08$export$88a2f523edad4966, (v) => $43bd487defacbb08$export$88a2f523edad4966 = v);
$parcel$export(module.exports, "getElementOptions", () => $43bd487defacbb08$export$ada2ff834d025202, (v) => $43bd487defacbb08$export$ada2ff834d025202 = v);
$parcel$export(module.exports, "createComponents", () => $43bd487defacbb08$export$4afedffc8025ff06, (v) => $43bd487defacbb08$export$4afedffc8025ff06 = v);
$parcel$export(module.exports, "extractTemplateMarkup", () => $43bd487defacbb08$export$14110de921d49c6a, (v) => $43bd487defacbb08$export$14110de921d49c6a = v);
$parcel$export(module.exports, "normalizeTemplateElement", () => $43bd487defacbb08$export$2d3a143ccafc685d, (v) => $43bd487defacbb08$export$2d3a143ccafc685d = v);
$parcel$export(module.exports, "clearSelection", () => $43bd487defacbb08$export$a3d02541b0ebf605, (v) => $43bd487defacbb08$export$a3d02541b0ebf605 = v);
$parcel$export(module.exports, "uniqueId", () => $43bd487defacbb08$export$8b15d37bc3f197d4, (v) => $43bd487defacbb08$export$8b15d37bc3f197d4 = v);
$parcel$export(module.exports, "closestCommonParent", () => $43bd487defacbb08$export$140fe369b75d9004, (v) => $43bd487defacbb08$export$140fe369b75d9004 = v);
$parcel$export(module.exports, "clipboardText", () => $43bd487defacbb08$export$5e54d945e18a1366, (v) => $43bd487defacbb08$export$5e54d945e18a1366 = v);
$parcel$export(module.exports, "contains", () => $43bd487defacbb08$export$2344b14b097df817, (v) => $43bd487defacbb08$export$2344b14b097df817 = v);
$parcel$export(module.exports, "getPublicElement", () => $43bd487defacbb08$export$f35e2167d0d6fe58, (v) => $43bd487defacbb08$export$f35e2167d0d6fe58 = v);
$parcel$export(module.exports, "createTextElementHiddenCopy", () => $43bd487defacbb08$export$f83b94d14426d495, (v) => $43bd487defacbb08$export$f83b94d14426d495 = v);
/**
 * DevExtreme (core/utils/dom.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $43bd487defacbb08$export$98ca6cfbd121a38b;
var $43bd487defacbb08$export$d3d8dd668187bb07;
var $43bd487defacbb08$export$1d3b55adf589ea7;
var $43bd487defacbb08$export$4e43b9e1134fa3da;
var $43bd487defacbb08$export$7d7521d776086d59;
var $43bd487defacbb08$export$88a2f523edad4966;
var $43bd487defacbb08$export$ada2ff834d025202;
var $43bd487defacbb08$export$4afedffc8025ff06;
var $43bd487defacbb08$export$14110de921d49c6a;
var $43bd487defacbb08$export$2d3a143ccafc685d;
var $43bd487defacbb08$export$a3d02541b0ebf605;
var $43bd487defacbb08$export$8b15d37bc3f197d4;
var $43bd487defacbb08$export$140fe369b75d9004;
var $43bd487defacbb08$export$5e54d945e18a1366;
var $43bd487defacbb08$export$2344b14b097df817;
var $43bd487defacbb08$export$f35e2167d0d6fe58;
var $43bd487defacbb08$export$f83b94d14426d495;
"use strict";

var $jFnCG = parcelRequire("jFnCG");

var $1JvXr = parcelRequire("1JvXr");

var $445Bz = parcelRequire("445Bz");

var $irv64 = parcelRequire("irv64");
var $43bd487defacbb08$var$window = $irv64.getWindow();

var $e1LMc = parcelRequire("e1LMc");

var $aLQK5 = parcelRequire("aLQK5");
var $43bd487defacbb08$require$inArray = $aLQK5.inArray;

var $kDRxH = parcelRequire("kDRxH");
var $43bd487defacbb08$var$isDefined = $kDRxH.isDefined;
var $43bd487defacbb08$var$isRenderer = $kDRxH.isRenderer;

var $8PQvD = parcelRequire("8PQvD");
var $43bd487defacbb08$var$elementStrategy;
var $43bd487defacbb08$var$resetActiveElement = function() {
    var activeElement = $445Bz.getActiveElement();
    var body = $445Bz.getBody();
    if (activeElement && activeElement !== body && activeElement.blur) try {
        activeElement.blur();
    } catch (e) {
        body.blur();
    }
};
var $43bd487defacbb08$var$clearSelection = function() {
    var selection = $43bd487defacbb08$var$window.getSelection();
    if (!selection) return;
    if ("Caret" === selection.type) return;
    if (selection.empty) selection.empty();
    else {
        if (selection.removeAllRanges) try {
            selection.removeAllRanges();
        } catch (e) {}
    }
};
var $43bd487defacbb08$var$closestCommonParent = function(startTarget, endTarget) {
    var $startTarget = $jFnCG(startTarget);
    var $endTarget = $jFnCG(endTarget);
    if ($startTarget[0] === $endTarget[0]) return $startTarget[0];
    var $startParents = $startTarget.parents();
    var $endParents = $endTarget.parents();
    var startingParent = Math.min($startParents.length, $endParents.length);
    for(var i = -startingParent; i < 0; i++){
        if ($startParents.get(i) === $endParents.get(i)) return $startParents.get(i);
    }
};
var $43bd487defacbb08$var$triggerVisibilityChangeEvent = function(eventName) {
    var VISIBILITY_CHANGE_SELECTOR = ".dx-visibility-change-handler";
    return function(element) {
        var $element = $jFnCG(element || "body");
        var changeHandlers = $element.filter(VISIBILITY_CHANGE_SELECTOR).add($element.find(VISIBILITY_CHANGE_SELECTOR));
        for(var i = 0; i < changeHandlers.length; i++)$e1LMc.triggerHandler(changeHandlers[i], eventName);
    };
};
var $43bd487defacbb08$var$uniqueId = function() {
    var counter = 0;
    return function(prefix) {
        return (prefix || "") + counter++;
    };
}();
var $43bd487defacbb08$var$dataOptionsAttributeName = "data-options";
var $43bd487defacbb08$var$getElementOptions = function(element) {
    var optionsString = $jFnCG(element).attr($43bd487defacbb08$var$dataOptionsAttributeName) || "";
    return $1JvXr().optionsParser(optionsString);
};
var $43bd487defacbb08$var$createComponents = function(elements, componentTypes) {
    var result = [];
    var selector = "[" + $43bd487defacbb08$var$dataOptionsAttributeName + "]";
    var $items = elements.find(selector).add(elements.filter(selector));
    $items.each(function(index, element) {
        var $element = $jFnCG(element);
        var options = $43bd487defacbb08$var$getElementOptions(element);
        for(var componentName in options){
            if (!componentTypes || $43bd487defacbb08$require$inArray(componentName, componentTypes) > -1) {
                if ($element[componentName]) {
                    $element[componentName](options[componentName]);
                    result.push($element[componentName]("instance"));
                }
            }
        }
    });
    return result;
};
var $43bd487defacbb08$var$createMarkupFromString = function(str) {
    if (!$43bd487defacbb08$var$window.WinJS) return $jFnCG($8PQvD.parseHTML(str));
    var tempElement = $jFnCG("<div>");
    $43bd487defacbb08$var$window.WinJS.Utilities.setInnerHTMLUnsafe(tempElement.get(0), str);
    return tempElement.contents();
};
var $43bd487defacbb08$var$extractTemplateMarkup = function(element) {
    element = $jFnCG(element);
    var templateTag = element.length && element.filter(function() {
        var $node = $jFnCG(this);
        return $node.is("script[type]") && $node.attr("type").indexOf("script") < 0;
    });
    if (templateTag.length) return templateTag.eq(0).html();
    else {
        element = $jFnCG("<div>").append(element);
        return element.html();
    }
};
var $43bd487defacbb08$var$normalizeTemplateElement = function normalizeTemplateElement(element) {
    var $element = $43bd487defacbb08$var$isDefined(element) && (element.nodeType || $43bd487defacbb08$var$isRenderer(element)) ? $jFnCG(element) : $jFnCG("<div>").html(element).contents();
    if (1 === $element.length) {
        if ($element.is("script")) $element = normalizeTemplateElement($element.html().trim());
        else if ($element.is("table")) $element = $element.children("tbody").contents();
    }
    return $element;
};
var $43bd487defacbb08$var$clipboardText = function(event, text) {
    var clipboard = event.originalEvent && event.originalEvent.clipboardData || $43bd487defacbb08$var$window.clipboardData;
    if (1 === arguments.length) return clipboard && clipboard.getData("Text");
    clipboard && clipboard.setData("Text", text);
};
var $43bd487defacbb08$var$contains = function(container, element) {
    if (!element) return false;
    element = $445Bz.isTextNode(element) ? element.parentNode : element;
    return $445Bz.isDocument(container) ? container.documentElement.contains(element) : container.contains(element);
};
var $43bd487defacbb08$var$getPublicElement = function($element) {
    return $43bd487defacbb08$var$elementStrategy($element);
};
var $43bd487defacbb08$var$setPublicElementWrapper = function(value) {
    $43bd487defacbb08$var$elementStrategy = value;
};
$43bd487defacbb08$var$setPublicElementWrapper(function(element) {
    return element && element.get(0);
});
var $43bd487defacbb08$var$createTextElementHiddenCopy = function(element, text, options) {
    var elementStyles = $43bd487defacbb08$var$window.getComputedStyle($jFnCG(element).get(0));
    var includePaddings = options && options.includePaddings;
    return $jFnCG("<div>").text(text).css({
        fontStyle: elementStyles.fontStyle,
        fontVariant: elementStyles.fontVariant,
        fontWeight: elementStyles.fontWeight,
        fontSize: elementStyles.fontSize,
        fontFamily: elementStyles.fontFamily,
        letterSpacing: elementStyles.letterSpacing,
        border: elementStyles.border,
        paddingTop: includePaddings ? elementStyles.paddingTop : "",
        paddingRight: includePaddings ? elementStyles.paddingRight : "",
        paddingBottom: includePaddings ? elementStyles.paddingBottom : "",
        paddingLeft: includePaddings ? elementStyles.paddingLeft : "",
        visibility: "hidden",
        whiteSpace: "nowrap",
        position: "absolute",
        "float": "left"
    });
};
$43bd487defacbb08$export$98ca6cfbd121a38b = $43bd487defacbb08$var$setPublicElementWrapper;
$43bd487defacbb08$export$d3d8dd668187bb07 = $43bd487defacbb08$var$resetActiveElement;
$43bd487defacbb08$export$1d3b55adf589ea7 = $43bd487defacbb08$var$createMarkupFromString;
$43bd487defacbb08$export$4e43b9e1134fa3da = $43bd487defacbb08$var$triggerVisibilityChangeEvent("dxshown");
$43bd487defacbb08$export$7d7521d776086d59 = $43bd487defacbb08$var$triggerVisibilityChangeEvent("dxhiding");
$43bd487defacbb08$export$88a2f523edad4966 = $43bd487defacbb08$var$triggerVisibilityChangeEvent("dxresize");
$43bd487defacbb08$export$ada2ff834d025202 = $43bd487defacbb08$var$getElementOptions;
$43bd487defacbb08$export$4afedffc8025ff06 = $43bd487defacbb08$var$createComponents;
$43bd487defacbb08$export$14110de921d49c6a = $43bd487defacbb08$var$extractTemplateMarkup;
$43bd487defacbb08$export$2d3a143ccafc685d = $43bd487defacbb08$var$normalizeTemplateElement;
$43bd487defacbb08$export$a3d02541b0ebf605 = $43bd487defacbb08$var$clearSelection;
$43bd487defacbb08$export$8b15d37bc3f197d4 = $43bd487defacbb08$var$uniqueId;
$43bd487defacbb08$export$140fe369b75d9004 = $43bd487defacbb08$var$closestCommonParent;
$43bd487defacbb08$export$5e54d945e18a1366 = $43bd487defacbb08$var$clipboardText;
$43bd487defacbb08$export$2344b14b097df817 = $43bd487defacbb08$var$contains;
$43bd487defacbb08$export$f35e2167d0d6fe58 = $43bd487defacbb08$var$getPublicElement;
$43bd487defacbb08$export$f83b94d14426d495 = $43bd487defacbb08$var$createTextElementHiddenCopy;

});

parcelRegister("1V5m6", function(module, exports) {
/**
 * DevExtreme (ui/themes_callback.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $eKdKS = parcelRequire("eKdKS");
module.exports = new $eKdKS;

});

parcelRegister("1jnPB", function(module, exports) {
/**
 * DevExtreme (core/polyfills/promise.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $2F60d = parcelRequire("2F60d");

var $irv64 = parcelRequire("irv64");
var $0f4a0d33fb13cf93$var$Deferred = $2F60d.Deferred;
var $0f4a0d33fb13cf93$var$when = $2F60d.when;
var $0f4a0d33fb13cf93$var$promise = $irv64.hasWindow() ? $irv64.getWindow().Promise : Promise;
if (!$0f4a0d33fb13cf93$var$promise) {
    $0f4a0d33fb13cf93$var$promise = function(resolver) {
        var d = new $0f4a0d33fb13cf93$var$Deferred;
        resolver(d.resolve.bind(this), d.reject.bind(this));
        return d.promise();
    };
    $0f4a0d33fb13cf93$var$promise.resolve = function(val) {
        return (new $0f4a0d33fb13cf93$var$Deferred).resolve(val).promise();
    };
    $0f4a0d33fb13cf93$var$promise.reject = function(val) {
        return (new $0f4a0d33fb13cf93$var$Deferred).reject(val).promise();
    };
    $0f4a0d33fb13cf93$var$promise.all = function(promises) {
        return $0f4a0d33fb13cf93$var$when.apply(this, promises).then(function() {
            return [].slice.call(arguments);
        });
    };
}
module.exports = $0f4a0d33fb13cf93$var$promise;

});


parcelRegister("ebely", function(module, exports) {
/**
 * DevExtreme (ui/validation_engine.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $k7aJb = parcelRequire("k7aJb");
var $a52d38b3de08237b$var$_class2 = $a52d38b3de08237b$var$_interopRequireDefault($k7aJb);

var $7I8Uw = parcelRequire("7I8Uw");

var $aLQK5 = parcelRequire("aLQK5");

var $4Pwuy = parcelRequire("4Pwuy");

var $cWRya = parcelRequire("cWRya");
var $a52d38b3de08237b$var$_events_mixin2 = $a52d38b3de08237b$var$_interopRequireDefault($cWRya);

var $7sX7V = parcelRequire("7sX7V");
var $a52d38b3de08237b$var$_errors2 = $a52d38b3de08237b$var$_interopRequireDefault($7sX7V);

var $2Mto0 = parcelRequire("2Mto0");

var $kDRxH = parcelRequire("kDRxH");
var $a52d38b3de08237b$var$_type2 = $a52d38b3de08237b$var$_interopRequireDefault($kDRxH);

var $9dtyI = parcelRequire("9dtyI");
var $a52d38b3de08237b$var$_number2 = $a52d38b3de08237b$var$_interopRequireDefault($9dtyI);

var $cnVbh = parcelRequire("cnVbh");
var $a52d38b3de08237b$var$_message2 = $a52d38b3de08237b$var$_interopRequireDefault($cnVbh);

var $1jnPB = parcelRequire("1jnPB");
var $a52d38b3de08237b$var$_promise2 = $a52d38b3de08237b$var$_interopRequireDefault($1jnPB);

var $2F60d = parcelRequire("2F60d");
function $a52d38b3de08237b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $a52d38b3de08237b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $a52d38b3de08237b$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $a52d38b3de08237b$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a52d38b3de08237b$var$_typeof(obj);
}
function $a52d38b3de08237b$var$_inherits(subClass, superClass) {
    if ("function" !== typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $a52d38b3de08237b$var$_setPrototypeOf(subClass, superClass);
}
function $a52d38b3de08237b$var$_setPrototypeOf(o, p) {
    $a52d38b3de08237b$var$_setPrototypeOf = Object.setPrototypeOf || function(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a52d38b3de08237b$var$_setPrototypeOf(o, p);
}
function $a52d38b3de08237b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a52d38b3de08237b$var$_isNativeReflectConstruct();
    return function() {
        var result, Super = $a52d38b3de08237b$var$_getPrototypeOf(Derived);
        if (hasNativeReflectConstruct) {
            var NewTarget = $a52d38b3de08237b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a52d38b3de08237b$var$_possibleConstructorReturn(this, result);
    };
}
function $a52d38b3de08237b$var$_possibleConstructorReturn(self, call) {
    if (call && ("object" === $a52d38b3de08237b$var$_typeof(call) || "function" === typeof call)) return call;
    return $a52d38b3de08237b$var$_assertThisInitialized(self);
}
function $a52d38b3de08237b$var$_assertThisInitialized(self) {
    if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a52d38b3de08237b$var$_isNativeReflectConstruct() {
    if ("undefined" === typeof Reflect || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if ("function" === typeof Proxy) return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a52d38b3de08237b$var$_getPrototypeOf(o) {
    $a52d38b3de08237b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a52d38b3de08237b$var$_getPrototypeOf(o);
}
function $a52d38b3de08237b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a52d38b3de08237b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a52d38b3de08237b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a52d38b3de08237b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a52d38b3de08237b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $a52d38b3de08237b$var$STATUS = {
    valid: "valid",
    invalid: "invalid",
    pending: "pending"
};
var $a52d38b3de08237b$var$BaseRuleValidator = function() {
    function BaseRuleValidator() {
        $a52d38b3de08237b$var$_classCallCheck(this, BaseRuleValidator);
        this.NAME = "base";
    }
    $a52d38b3de08237b$var$_createClass(BaseRuleValidator, [
        {
            key: "defaultMessage",
            value: function(value) {
                return $a52d38b3de08237b$var$_message2.default.getFormatter("validation-".concat(this.NAME))(value);
            }
        },
        {
            key: "defaultFormattedMessage",
            value: function(value) {
                return $a52d38b3de08237b$var$_message2.default.getFormatter("validation-".concat(this.NAME, "-formatted"))(value);
            }
        },
        {
            key: "_isValueEmpty",
            value: function(value) {
                return !$a52d38b3de08237b$var$rulesValidators.required.validate(value, {});
            }
        },
        {
            key: "validate",
            value: function(value, rule) {
                var _this = this;
                var valueArray = Array.isArray(value) ? value : [
                    value
                ];
                var result = true;
                if (valueArray.length) valueArray.every(function(itemValue) {
                    result = _this._validate(itemValue, rule);
                    return result;
                });
                else result = this._validate(null, rule);
                return result;
            }
        }
    ]);
    return BaseRuleValidator;
}();
var $a52d38b3de08237b$var$RequiredRuleValidator = function(_BaseRuleValidator) {
    $a52d38b3de08237b$var$_inherits(RequiredRuleValidator, _BaseRuleValidator);
    var _super = $a52d38b3de08237b$var$_createSuper(RequiredRuleValidator);
    function RequiredRuleValidator() {
        var _this2;
        $a52d38b3de08237b$var$_classCallCheck(this, RequiredRuleValidator);
        _this2 = _super.call(this);
        _this2.NAME = "required";
        return _this2;
    }
    $a52d38b3de08237b$var$_createClass(RequiredRuleValidator, [
        {
            key: "_validate",
            value: function(value, rule) {
                if (!$a52d38b3de08237b$var$_type2.default.isDefined(value)) return false;
                if (false === value) return false;
                value = String(value);
                if (rule.trim || !$a52d38b3de08237b$var$_type2.default.isDefined(rule.trim)) value = value.trim();
                return "" !== value;
            }
        }
    ]);
    return RequiredRuleValidator;
}($a52d38b3de08237b$var$BaseRuleValidator);
var $a52d38b3de08237b$var$NumericRuleValidator = function(_BaseRuleValidator2) {
    $a52d38b3de08237b$var$_inherits(NumericRuleValidator, _BaseRuleValidator2);
    var _super2 = $a52d38b3de08237b$var$_createSuper(NumericRuleValidator);
    function NumericRuleValidator() {
        var _this3;
        $a52d38b3de08237b$var$_classCallCheck(this, NumericRuleValidator);
        _this3 = _super2.call(this);
        _this3.NAME = "numeric";
        return _this3;
    }
    $a52d38b3de08237b$var$_createClass(NumericRuleValidator, [
        {
            key: "_validate",
            value: function(value, rule) {
                if (false !== rule.ignoreEmptyValue && this._isValueEmpty(value)) return true;
                if (rule.useCultureSettings && $a52d38b3de08237b$var$_type2.default.isString(value)) return !isNaN($a52d38b3de08237b$var$_number2.default.parse(value));
                else return $a52d38b3de08237b$var$_type2.default.isNumeric(value);
            }
        }
    ]);
    return NumericRuleValidator;
}($a52d38b3de08237b$var$BaseRuleValidator);
var $a52d38b3de08237b$var$RangeRuleValidator = function(_BaseRuleValidator3) {
    $a52d38b3de08237b$var$_inherits(RangeRuleValidator, _BaseRuleValidator3);
    var _super3 = $a52d38b3de08237b$var$_createSuper(RangeRuleValidator);
    function RangeRuleValidator() {
        var _this4;
        $a52d38b3de08237b$var$_classCallCheck(this, RangeRuleValidator);
        _this4 = _super3.call(this);
        _this4.NAME = "range";
        return _this4;
    }
    $a52d38b3de08237b$var$_createClass(RangeRuleValidator, [
        {
            key: "_validate",
            value: function(value, rule) {
                if (false !== rule.ignoreEmptyValue && this._isValueEmpty(value)) return true;
                var validNumber = $a52d38b3de08237b$var$rulesValidators.numeric.validate(value, rule);
                var validValue = $a52d38b3de08237b$var$_type2.default.isDefined(value) && "" !== value;
                var number = validNumber ? parseFloat(value) : validValue && value.valueOf();
                var min = rule.min;
                var max = rule.max;
                if (!(validNumber || $a52d38b3de08237b$var$_type2.default.isDate(value)) && !validValue) return false;
                if ($a52d38b3de08237b$var$_type2.default.isDefined(min)) {
                    if ($a52d38b3de08237b$var$_type2.default.isDefined(max)) return number >= min && number <= max;
                    return number >= min;
                } else {
                    if ($a52d38b3de08237b$var$_type2.default.isDefined(max)) return number <= max;
                    else throw $a52d38b3de08237b$var$_errors2.default.Error("E0101");
                }
            }
        }
    ]);
    return RangeRuleValidator;
}($a52d38b3de08237b$var$BaseRuleValidator);
var $a52d38b3de08237b$var$StringLengthRuleValidator = function(_BaseRuleValidator4) {
    $a52d38b3de08237b$var$_inherits(StringLengthRuleValidator, _BaseRuleValidator4);
    var _super4 = $a52d38b3de08237b$var$_createSuper(StringLengthRuleValidator);
    function StringLengthRuleValidator() {
        var _this5;
        $a52d38b3de08237b$var$_classCallCheck(this, StringLengthRuleValidator);
        _this5 = _super4.call(this);
        _this5.NAME = "stringLength";
        return _this5;
    }
    $a52d38b3de08237b$var$_createClass(StringLengthRuleValidator, [
        {
            key: "_validate",
            value: function(value, rule) {
                value = $a52d38b3de08237b$var$_type2.default.isDefined(value) ? String(value) : "";
                if (rule.trim || !$a52d38b3de08237b$var$_type2.default.isDefined(rule.trim)) value = value.trim();
                if (rule.ignoreEmptyValue && this._isValueEmpty(value)) return true;
                return $a52d38b3de08237b$var$rulesValidators.range.validate(value.length, (0, $7I8Uw.extend)({}, rule));
            }
        }
    ]);
    return StringLengthRuleValidator;
}($a52d38b3de08237b$var$BaseRuleValidator);
var $a52d38b3de08237b$var$CustomRuleValidator = function(_BaseRuleValidator5) {
    $a52d38b3de08237b$var$_inherits(CustomRuleValidator, _BaseRuleValidator5);
    var _super5 = $a52d38b3de08237b$var$_createSuper(CustomRuleValidator);
    function CustomRuleValidator() {
        var _this6;
        $a52d38b3de08237b$var$_classCallCheck(this, CustomRuleValidator);
        _this6 = _super5.call(this);
        _this6.NAME = "custom";
        return _this6;
    }
    $a52d38b3de08237b$var$_createClass(CustomRuleValidator, [
        {
            key: "validate",
            value: function(value, rule) {
                if (rule.ignoreEmptyValue && this._isValueEmpty(value)) return true;
                var validator = rule.validator;
                var dataGetter = validator && $a52d38b3de08237b$var$_type2.default.isFunction(validator.option) && validator.option("dataGetter");
                var extraParams = $a52d38b3de08237b$var$_type2.default.isFunction(dataGetter) && dataGetter();
                var params = {
                    value: value,
                    validator: validator,
                    rule: rule
                };
                if (extraParams) (0, $7I8Uw.extend)(params, extraParams);
                return rule.validationCallback(params);
            }
        }
    ]);
    return CustomRuleValidator;
}($a52d38b3de08237b$var$BaseRuleValidator);
var $a52d38b3de08237b$var$AsyncRuleValidator = function(_CustomRuleValidator) {
    $a52d38b3de08237b$var$_inherits(AsyncRuleValidator, _CustomRuleValidator);
    var _super6 = $a52d38b3de08237b$var$_createSuper(AsyncRuleValidator);
    function AsyncRuleValidator() {
        var _this7;
        $a52d38b3de08237b$var$_classCallCheck(this, AsyncRuleValidator);
        _this7 = _super6.call(this);
        _this7.NAME = "async";
        return _this7;
    }
    $a52d38b3de08237b$var$_createClass(AsyncRuleValidator, [
        {
            key: "validate",
            value: function(value, rule) {
                if (!$a52d38b3de08237b$var$_type2.default.isDefined(rule.reevaluate)) (0, $7I8Uw.extend)(rule, {
                    reevaluate: true
                });
                if (rule.ignoreEmptyValue && this._isValueEmpty(value)) return true;
                var validator = rule.validator;
                var dataGetter = validator && $a52d38b3de08237b$var$_type2.default.isFunction(validator.option) && validator.option("dataGetter");
                var extraParams = $a52d38b3de08237b$var$_type2.default.isFunction(dataGetter) && dataGetter();
                var params = {
                    value: value,
                    validator: validator,
                    rule: rule
                };
                if (extraParams) (0, $7I8Uw.extend)(params, extraParams);
                var callbackResult = rule.validationCallback(params);
                if (!$a52d38b3de08237b$var$_type2.default.isPromise(callbackResult)) throw $a52d38b3de08237b$var$_errors2.default.Error("E0103");
                return this._getWrappedPromise((0, $2F60d.fromPromise)(callbackResult).promise());
            }
        },
        {
            key: "_getWrappedPromise",
            value: function(promise) {
                var deferred = new $2F60d.Deferred;
                promise.then(function(res) {
                    deferred.resolve(res);
                }, function(err) {
                    var res = {
                        isValid: false
                    };
                    if ($a52d38b3de08237b$var$_type2.default.isDefined(err)) {
                        if ($a52d38b3de08237b$var$_type2.default.isString(err)) res.message = err;
                        else if ($a52d38b3de08237b$var$_type2.default.isObject(err) && $a52d38b3de08237b$var$_type2.default.isDefined(err.message) && $a52d38b3de08237b$var$_type2.default.isString(err.message)) res.message = err.message;
                    }
                    deferred.resolve(res);
                });
                return deferred.promise();
            }
        }
    ]);
    return AsyncRuleValidator;
}($a52d38b3de08237b$var$CustomRuleValidator);
var $a52d38b3de08237b$var$CompareRuleValidator = function(_BaseRuleValidator6) {
    $a52d38b3de08237b$var$_inherits(CompareRuleValidator, _BaseRuleValidator6);
    var _super7 = $a52d38b3de08237b$var$_createSuper(CompareRuleValidator);
    function CompareRuleValidator() {
        var _this8;
        $a52d38b3de08237b$var$_classCallCheck(this, CompareRuleValidator);
        _this8 = _super7.call(this);
        _this8.NAME = "compare";
        return _this8;
    }
    $a52d38b3de08237b$var$_createClass(CompareRuleValidator, [
        {
            key: "_validate",
            value: function(value, rule) {
                if (!rule.comparisonTarget) throw $a52d38b3de08237b$var$_errors2.default.Error("E0102");
                if (rule.ignoreEmptyValue && this._isValueEmpty(value)) return true;
                (0, $7I8Uw.extend)(rule, {
                    reevaluate: true
                });
                var otherValue = rule.comparisonTarget();
                var type = rule.comparisonType || "==";
                switch(type){
                    case "==":
                        return value == otherValue;
                    case "!=":
                        return value != otherValue;
                    case "===":
                        return value === otherValue;
                    case "!==":
                        return value !== otherValue;
                    case ">":
                        return value > otherValue;
                    case ">=":
                        return value >= otherValue;
                    case "<":
                        return value < otherValue;
                    case "<=":
                        return value <= otherValue;
                }
            }
        }
    ]);
    return CompareRuleValidator;
}($a52d38b3de08237b$var$BaseRuleValidator);
var $a52d38b3de08237b$var$PatternRuleValidator = function(_BaseRuleValidator7) {
    $a52d38b3de08237b$var$_inherits(PatternRuleValidator, _BaseRuleValidator7);
    var _super8 = $a52d38b3de08237b$var$_createSuper(PatternRuleValidator);
    function PatternRuleValidator() {
        var _this9;
        $a52d38b3de08237b$var$_classCallCheck(this, PatternRuleValidator);
        _this9 = _super8.call(this);
        _this9.NAME = "pattern";
        return _this9;
    }
    $a52d38b3de08237b$var$_createClass(PatternRuleValidator, [
        {
            key: "_validate",
            value: function(value, rule) {
                if (false !== rule.ignoreEmptyValue && this._isValueEmpty(value)) return true;
                var pattern = rule.pattern;
                if ($a52d38b3de08237b$var$_type2.default.isString(pattern)) pattern = new RegExp(pattern);
                return pattern.test(value);
            }
        }
    ]);
    return PatternRuleValidator;
}($a52d38b3de08237b$var$BaseRuleValidator);
var $a52d38b3de08237b$var$EmailRuleValidator = function(_BaseRuleValidator8) {
    $a52d38b3de08237b$var$_inherits(EmailRuleValidator, _BaseRuleValidator8);
    var _super9 = $a52d38b3de08237b$var$_createSuper(EmailRuleValidator);
    function EmailRuleValidator() {
        var _this10;
        $a52d38b3de08237b$var$_classCallCheck(this, EmailRuleValidator);
        _this10 = _super9.call(this);
        _this10.NAME = "email";
        return _this10;
    }
    $a52d38b3de08237b$var$_createClass(EmailRuleValidator, [
        {
            key: "_validate",
            value: function(value, rule) {
                if (false !== rule.ignoreEmptyValue && this._isValueEmpty(value)) return true;
                return $a52d38b3de08237b$var$rulesValidators.pattern.validate(value, (0, $7I8Uw.extend)({}, rule, {
                    pattern: /^[\d\w._-]+@([\d\w._-]+\.)+[\w]+$/i
                }));
            }
        }
    ]);
    return EmailRuleValidator;
}($a52d38b3de08237b$var$BaseRuleValidator);
var $a52d38b3de08237b$var$rulesValidators = {
    required: new $a52d38b3de08237b$var$RequiredRuleValidator,
    numeric: new $a52d38b3de08237b$var$NumericRuleValidator,
    range: new $a52d38b3de08237b$var$RangeRuleValidator,
    stringLength: new $a52d38b3de08237b$var$StringLengthRuleValidator,
    custom: new $a52d38b3de08237b$var$CustomRuleValidator,
    async: new $a52d38b3de08237b$var$AsyncRuleValidator,
    compare: new $a52d38b3de08237b$var$CompareRuleValidator,
    pattern: new $a52d38b3de08237b$var$PatternRuleValidator,
    email: new $a52d38b3de08237b$var$EmailRuleValidator
};
var $a52d38b3de08237b$var$GroupConfig = $a52d38b3de08237b$var$_class2.default.inherit({
    ctor: function(group) {
        this.group = group;
        this.validators = [];
        this._pendingValidators = [];
        this._onValidatorStatusChanged = this._onValidatorStatusChanged.bind(this);
        this._resetValidationInfo();
    },
    validate: function() {
        var _this11 = this;
        var result = {
            isValid: true,
            brokenRules: [],
            validators: [],
            status: $a52d38b3de08237b$var$STATUS.valid,
            complete: null
        };
        this._unsubscribeFromAllChangeEvents();
        this._pendingValidators = [];
        this._resetValidationInfo();
        (0, $4Pwuy.each)(this.validators, function(_, validator) {
            var validatorResult = validator.validate();
            result.isValid = result.isValid && validatorResult.isValid;
            if (validatorResult.brokenRules) result.brokenRules = result.brokenRules.concat(validatorResult.brokenRules);
            result.validators.push(validator);
            if (validatorResult.status === $a52d38b3de08237b$var$STATUS.pending) _this11._addPendingValidator(validator);
            _this11._subscribeToChangeEvents(validator);
        });
        if (this._pendingValidators.length) result.status = $a52d38b3de08237b$var$STATUS.pending;
        else {
            result.status = result.isValid ? $a52d38b3de08237b$var$STATUS.valid : $a52d38b3de08237b$var$STATUS.invalid;
            this._unsubscribeFromAllChangeEvents();
            this._raiseValidatedEvent(result);
        }
        this._updateValidationInfo(result);
        return (0, $7I8Uw.extend)({}, this._validationInfo.result);
    },
    _subscribeToChangeEvents: function(validator) {
        validator.on("validating", this._onValidatorStatusChanged);
        validator.on("validated", this._onValidatorStatusChanged);
    },
    _unsubscribeFromChangeEvents: function(validator) {
        validator.off("validating", this._onValidatorStatusChanged);
        validator.off("validated", this._onValidatorStatusChanged);
    },
    _unsubscribeFromAllChangeEvents: function() {
        var _this12 = this;
        (0, $4Pwuy.each)(this.validators, function(_, validator) {
            _this12._unsubscribeFromChangeEvents(validator);
        });
    },
    _updateValidationInfo: function(result) {
        this._validationInfo.result = result;
        if (result.status !== $a52d38b3de08237b$var$STATUS.pending) return;
        if (!this._validationInfo.deferred) {
            this._validationInfo.deferred = new $2F60d.Deferred;
            this._validationInfo.result.complete = this._validationInfo.deferred.promise();
        }
    },
    _addPendingValidator: function(validator) {
        var foundValidator = (0, $2Mto0.grep)(this._pendingValidators, function(val) {
            return val === validator;
        })[0];
        if (!foundValidator) this._pendingValidators.push(validator);
    },
    _removePendingValidator: function(validator) {
        var index = (0, $aLQK5.inArray)(validator, this._pendingValidators);
        if (index >= 0) this._pendingValidators.splice(index, 1);
    },
    _orderBrokenRules: function(brokenRules) {
        var orderedRules = [];
        (0, $4Pwuy.each)(this.validators, function(_, validator) {
            var foundRules = (0, $2Mto0.grep)(brokenRules, function(rule) {
                return rule.validator === validator;
            });
            if (foundRules.length) orderedRules = orderedRules.concat(foundRules);
        });
        return orderedRules;
    },
    _updateBrokenRules: function(result) {
        if (!this._validationInfo.result) return;
        var brokenRules = this._validationInfo.result.brokenRules;
        var rules = (0, $2Mto0.grep)(brokenRules, function(rule) {
            return rule.validator !== result.validator;
        });
        if (result.brokenRules) brokenRules = rules.concat(result.brokenRules);
        this._validationInfo.result.brokenRules = this._orderBrokenRules(brokenRules);
    },
    _onValidatorStatusChanged: function(result) {
        if (result.status === $a52d38b3de08237b$var$STATUS.pending) {
            this._addPendingValidator(result.validator);
            return;
        }
        this._resolveIfComplete(result);
    },
    _resolveIfComplete: function(result) {
        this._removePendingValidator(result.validator);
        this._updateBrokenRules(result);
        if (!this._pendingValidators.length) {
            this._unsubscribeFromAllChangeEvents();
            if (!this._validationInfo.result) return;
            this._validationInfo.result.status = 0 === this._validationInfo.result.brokenRules.length ? $a52d38b3de08237b$var$STATUS.valid : $a52d38b3de08237b$var$STATUS.invalid;
            this._validationInfo.result.isValid = this._validationInfo.result.status === $a52d38b3de08237b$var$STATUS.valid;
            var res = (0, $7I8Uw.extend)({}, this._validationInfo.result, {
                complete: null
            });
            var deferred = this._validationInfo.deferred;
            this._resetValidationInfo();
            this._raiseValidatedEvent(res);
            deferred && setTimeout(function() {
                deferred.resolve(res);
            });
        }
    },
    _raiseValidatedEvent: function(result) {
        this.fireEvent("validated", [
            result
        ]);
    },
    _resetValidationInfo: function() {
        this._validationInfo = {
            result: null,
            deferred: null
        };
    },
    _synchronizeValidationInfo: function() {
        if (this._validationInfo.result) this._validationInfo.result.validators = this.validators;
    },
    removeRegisteredValidator: function(validator) {
        var index = (0, $aLQK5.inArray)(validator, this.validators);
        if (index > -1) {
            this.validators.splice(index, 1);
            this._synchronizeValidationInfo();
            this._resolveIfComplete({
                validator: validator
            });
        }
    },
    registerValidator: function(validator) {
        if ((0, $aLQK5.inArray)(validator, this.validators) < 0) {
            this.validators.push(validator);
            this._synchronizeValidationInfo();
        }
    },
    reset: function() {
        (0, $4Pwuy.each)(this.validators, function(_, validator) {
            validator.reset();
        });
        this._pendingValidators = [];
        this._resetValidationInfo();
    }
}).include($a52d38b3de08237b$var$_events_mixin2.default);
var $a52d38b3de08237b$var$ValidationEngine = {
    groups: [],
    getGroupConfig: function(group) {
        var result = (0, $2Mto0.grep)(this.groups, function(config) {
            return config.group === group;
        });
        if (result.length) return result[0];
    },
    findGroup: function($element, model) {
        var $dxGroup = $element.parents(".dx-validationgroup").first();
        if ($dxGroup.length) return $dxGroup.dxValidationGroup("instance");
        return model;
    },
    initGroups: function() {
        this.groups = [];
        this.addGroup();
    },
    addGroup: function(group) {
        var config = this.getGroupConfig(group);
        if (!config) {
            config = new $a52d38b3de08237b$var$GroupConfig(group);
            this.groups.push(config);
        }
        return config;
    },
    removeGroup: function(group) {
        var config = this.getGroupConfig(group);
        var index = (0, $aLQK5.inArray)(config, this.groups);
        if (index > -1) this.groups.splice(index, 1);
        return config;
    },
    _setDefaultMessage: function(info) {
        var rule = info.rule, validator = info.validator, name = info.name;
        if (!$a52d38b3de08237b$var$_type2.default.isDefined(rule.message)) {
            if (validator.defaultFormattedMessage && $a52d38b3de08237b$var$_type2.default.isDefined(name)) rule.message = validator.defaultFormattedMessage(name);
            else rule.message = validator.defaultMessage();
        }
    },
    _addBrokenRule: function(info) {
        var result = info.result, rule = info.rule;
        if (!result.brokenRule) result.brokenRule = rule;
        if (!result.brokenRules) result.brokenRules = [];
        result.brokenRules.push(rule);
    },
    validate: function(value, rules, name) {
        var _this13 = this;
        var result = {
            name: name,
            value: value,
            brokenRule: null,
            brokenRules: null,
            isValid: true,
            validationRules: rules,
            pendingRules: null,
            status: $a52d38b3de08237b$var$STATUS.valid,
            complete: null
        };
        var asyncRuleItems = [];
        (0, $4Pwuy.each)(rules || [], function(_, rule) {
            var ruleValidator = $a52d38b3de08237b$var$rulesValidators[rule.type];
            var ruleValidationResult;
            if (ruleValidator) {
                if ($a52d38b3de08237b$var$_type2.default.isDefined(rule.isValid) && rule.value === value && !rule.reevaluate) {
                    if (!rule.isValid) {
                        result.isValid = false;
                        _this13._addBrokenRule({
                            result: result,
                            rule: rule
                        });
                        return false;
                    }
                    return true;
                }
                rule.value = value;
                if ("async" === rule.type) {
                    asyncRuleItems.push({
                        rule: rule,
                        ruleValidator: ruleValidator
                    });
                    return true;
                }
                ruleValidationResult = ruleValidator.validate(value, rule);
                rule.isValid = ruleValidationResult;
                if (!ruleValidationResult) {
                    result.isValid = false;
                    _this13._setDefaultMessage({
                        rule: rule,
                        validator: ruleValidator,
                        name: name
                    });
                    _this13._addBrokenRule({
                        result: result,
                        rule: rule
                    });
                }
                if (!rule.isValid) return false;
            } else throw $a52d38b3de08237b$var$_errors2.default.Error("E0100");
        });
        if (result.isValid && !result.brokenRules && asyncRuleItems.length) result = this._validateAsyncRules({
            value: value,
            items: asyncRuleItems,
            result: result,
            name: name
        });
        result.status = result.pendingRules ? $a52d38b3de08237b$var$STATUS.pending : result.isValid ? $a52d38b3de08237b$var$STATUS.valid : $a52d38b3de08237b$var$STATUS.invalid;
        return result;
    },
    _validateAsyncRules: function(_ref) {
        var _this14 = this;
        var result = _ref.result, value = _ref.value, items = _ref.items, name = _ref.name;
        var asyncResults = [];
        (0, $4Pwuy.each)(items, function(_, item) {
            var validateResult = item.ruleValidator.validate(value, item.rule);
            if (!$a52d38b3de08237b$var$_type2.default.isPromise(validateResult)) _this14._updateRuleConfig({
                rule: item.rule,
                ruleResult: _this14._getPatchedRuleResult(validateResult),
                validator: item.ruleValidator,
                name: name
            });
            else {
                if (!result.pendingRules) result.pendingRules = [];
                result.pendingRules.push(item.rule);
                var asyncResult = validateResult.then(function(res) {
                    var ruleResult = _this14._getPatchedRuleResult(res);
                    _this14._updateRuleConfig({
                        rule: item.rule,
                        ruleResult: ruleResult,
                        validator: item.ruleValidator,
                        name: name
                    });
                    return ruleResult;
                });
                asyncResults.push(asyncResult);
            }
        });
        if (asyncResults.length) result.complete = $a52d38b3de08237b$var$_promise2.default.all(asyncResults).then(function(values) {
            return _this14._getAsyncRulesResult({
                result: result,
                values: values
            });
        });
        return result;
    },
    _updateRuleConfig: function(_ref2) {
        var rule = _ref2.rule, ruleResult = _ref2.ruleResult, validator = _ref2.validator, name = _ref2.name;
        rule.isValid = ruleResult.isValid;
        if (!ruleResult.isValid) {
            if ($a52d38b3de08237b$var$_type2.default.isDefined(ruleResult.message) && $a52d38b3de08237b$var$_type2.default.isString(ruleResult.message) && ruleResult.message.length) rule.message = ruleResult.message;
            else this._setDefaultMessage({
                rule: rule,
                validator: validator,
                name: name
            });
        }
    },
    _getPatchedRuleResult: function(ruleResult) {
        var result;
        var isValid = true;
        if ($a52d38b3de08237b$var$_type2.default.isObject(ruleResult)) {
            result = (0, $7I8Uw.extend)({}, ruleResult);
            if (!$a52d38b3de08237b$var$_type2.default.isDefined(result.isValid)) result.isValid = isValid;
        } else result = {
            isValid: $a52d38b3de08237b$var$_type2.default.isBoolean(ruleResult) ? ruleResult : isValid
        };
        return result;
    },
    _getAsyncRulesResult: function(_ref3) {
        var _this15 = this;
        var values = _ref3.values, result = _ref3.result;
        (0, $4Pwuy.each)(values, function(index, val) {
            if (false === val.isValid) {
                result.isValid = val.isValid;
                var rule = result.pendingRules[index];
                _this15._addBrokenRule({
                    result: result,
                    rule: rule
                });
            }
        });
        result.pendingRules = null;
        result.complete = null;
        result.status = result.isValid ? $a52d38b3de08237b$var$STATUS.valid : $a52d38b3de08237b$var$STATUS.invalid;
        return result;
    },
    registerValidatorInGroup: function(group, validator) {
        var groupConfig = $a52d38b3de08237b$var$ValidationEngine.addGroup(group);
        groupConfig.registerValidator.call(groupConfig, validator);
    },
    _shouldRemoveGroup: function(group, validatorsInGroup) {
        var isDefaultGroup = void 0 === group;
        var isValidationGroupInstance = group && "dxValidationGroup" === group.NAME;
        return !isDefaultGroup && !isValidationGroupInstance && !validatorsInGroup.length;
    },
    removeRegisteredValidator: function(group, validator) {
        var config = $a52d38b3de08237b$var$ValidationEngine.getGroupConfig(group);
        if (config) {
            config.removeRegisteredValidator.call(config, validator);
            var validatorsInGroup = config.validators;
            if (this._shouldRemoveGroup(group, validatorsInGroup)) this.removeGroup(group);
        }
    },
    initValidationOptions: function(options) {
        var _this16 = this;
        var initedOptions = {};
        if (options) {
            var syncOptions = [
                "isValid",
                "validationStatus",
                "validationError",
                "validationErrors"
            ];
            syncOptions.forEach(function(prop) {
                if (prop in options) (0, $7I8Uw.extend)(initedOptions, _this16.synchronizeValidationOptions({
                    name: prop,
                    value: options[prop]
                }, options));
            });
        }
        return initedOptions;
    },
    synchronizeValidationOptions: function(_ref4, options) {
        var name = _ref4.name, value = _ref4.value;
        switch(name){
            case "validationStatus":
                var isValid = value === $a52d38b3de08237b$var$STATUS.valid || value === $a52d38b3de08237b$var$STATUS.pending;
                return options.isValid !== isValid ? {
                    isValid: isValid
                } : {};
            case "isValid":
                var validationStatus = options.validationStatus;
                var newStatus = validationStatus;
                if (value && validationStatus === $a52d38b3de08237b$var$STATUS.invalid) newStatus = $a52d38b3de08237b$var$STATUS.valid;
                else if (!value && validationStatus !== $a52d38b3de08237b$var$STATUS.invalid) newStatus = $a52d38b3de08237b$var$STATUS.invalid;
                return newStatus !== validationStatus ? {
                    validationStatus: newStatus
                } : {};
            case "validationErrors":
                var validationError = !value || !value.length ? null : value[0];
                return options.validationError !== validationError ? {
                    validationError: validationError
                } : {};
            case "validationError":
                var validationErrors = options.validationErrors;
                if (!value && validationErrors) return {
                    validationErrors: null
                };
                else {
                    if (value && !validationErrors) return {
                        validationErrors: [
                            value
                        ]
                    };
                    else if (value && validationErrors && value !== validationErrors[0]) {
                        validationErrors[0] = value;
                        return {
                            validationErrors: validationErrors.slice()
                        };
                    }
                }
        }
        return {};
    },
    validateGroup: function(group) {
        var groupConfig = $a52d38b3de08237b$var$ValidationEngine.getGroupConfig(group);
        if (!groupConfig) throw $a52d38b3de08237b$var$_errors2.default.Error("E0110");
        return groupConfig.validate();
    },
    resetGroup: function(group) {
        var groupConfig = $a52d38b3de08237b$var$ValidationEngine.getGroupConfig(group);
        if (!groupConfig) throw $a52d38b3de08237b$var$_errors2.default.Error("E0110");
        return groupConfig.reset();
    }
};
$a52d38b3de08237b$var$ValidationEngine.initGroups();
module.exports = $a52d38b3de08237b$var$ValidationEngine;
module.exports.default = module.exports;

});
parcelRegister("9dtyI", function(module, exports) {
/**
 * DevExtreme (localization/number.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $6LNcw = parcelRequire("6LNcw");
var $6b5c41bba4a4960f$var$_dependency_injector2 = $6b5c41bba4a4960f$var$_interopRequireDefault($6LNcw);

var $aLQK5 = parcelRequire("aLQK5");

var $2Mto0 = parcelRequire("2Mto0");

var $4Pwuy = parcelRequire("4Pwuy");

var $kDRxH = parcelRequire("kDRxH");

var $7znai = parcelRequire("7znai");
var $6b5c41bba4a4960f$var$_number2 = $6b5c41bba4a4960f$var$_interopRequireDefault($7znai);

var $1JvXr = parcelRequire("1JvXr");
var $6b5c41bba4a4960f$var$_config2 = $6b5c41bba4a4960f$var$_interopRequireDefault($1JvXr);

var $7sX7V = parcelRequire("7sX7V");
var $6b5c41bba4a4960f$var$_errors2 = $6b5c41bba4a4960f$var$_interopRequireDefault($7sX7V);

var $11IRH = parcelRequire("11IRH");

var $8WMaH = parcelRequire("8WMaH");
var $6b5c41bba4a4960f$var$_currency2 = $6b5c41bba4a4960f$var$_interopRequireDefault($8WMaH);

var $a3Ncl = parcelRequire("a3Ncl");
var $6b5c41bba4a4960f$var$_number4 = $6b5c41bba4a4960f$var$_interopRequireDefault($a3Ncl);
function $6b5c41bba4a4960f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6b5c41bba4a4960f$var$_slicedToArray(arr, i) {
    return $6b5c41bba4a4960f$var$_arrayWithHoles(arr) || $6b5c41bba4a4960f$var$_iterableToArrayLimit(arr, i) || $6b5c41bba4a4960f$var$_unsupportedIterableToArray(arr, i) || $6b5c41bba4a4960f$var$_nonIterableRest();
}
function $6b5c41bba4a4960f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6b5c41bba4a4960f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if ("string" === typeof o) return $6b5c41bba4a4960f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if ("Object" === n && o.constructor) n = o.constructor.name;
    if ("Map" === n || "Set" === n) return Array.from(o);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6b5c41bba4a4960f$var$_arrayLikeToArray(o, minLen);
}
function $6b5c41bba4a4960f$var$_arrayLikeToArray(arr, len) {
    if (null == len || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6b5c41bba4a4960f$var$_iterableToArrayLimit(arr, i) {
    if ("undefined" === typeof Symbol || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = void 0;
    try {
        for(var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && null != _i.return) _i.return();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $6b5c41bba4a4960f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $6b5c41bba4a4960f$var$hasIntl = "undefined" !== typeof Intl;
var $6b5c41bba4a4960f$var$MAX_LARGE_NUMBER_POWER = 4;
var $6b5c41bba4a4960f$var$DECIMAL_BASE = 10;
var $6b5c41bba4a4960f$var$NUMERIC_FORMATS = [
    "currency",
    "fixedpoint",
    "exponential",
    "percent",
    "decimal"
];
var $6b5c41bba4a4960f$var$LargeNumberFormatPostfixes = {
    1: "K",
    2: "M",
    3: "B",
    4: "T"
};
var $6b5c41bba4a4960f$var$LargeNumberFormatPowers = {
    largenumber: "auto",
    thousands: 1,
    millions: 2,
    billions: 3,
    trillions: 4
};
var $6b5c41bba4a4960f$var$numberLocalization = (0, $6b5c41bba4a4960f$var$_dependency_injector2.default)({
    engine: function() {
        return "base";
    },
    numericFormats: $6b5c41bba4a4960f$var$NUMERIC_FORMATS,
    defaultLargeNumberFormatPostfixes: $6b5c41bba4a4960f$var$LargeNumberFormatPostfixes,
    _parseNumberFormatString: function(formatType) {
        var formatObject = {};
        if (!formatType || "string" !== typeof formatType) return;
        var formatList = formatType.toLowerCase().split(" ");
        (0, $4Pwuy.each)(formatList, function(index, value) {
            if ((0, $aLQK5.inArray)(value, $6b5c41bba4a4960f$var$NUMERIC_FORMATS) > -1) formatObject.formatType = value;
            else if (value in $6b5c41bba4a4960f$var$LargeNumberFormatPowers) formatObject.power = $6b5c41bba4a4960f$var$LargeNumberFormatPowers[value];
        });
        if (formatObject.power && !formatObject.formatType) formatObject.formatType = "fixedpoint";
        if (formatObject.formatType) return formatObject;
    },
    _calculateNumberPower: function(value, base, minPower, maxPower) {
        var number = Math.abs(value);
        var power = 0;
        if (number > 1) while(number && number >= base && (void 0 === maxPower || power < maxPower)){
            power++;
            number /= base;
        }
        else {
            if (number > 0 && number < 1) while(number < 1 && (void 0 === minPower || power > minPower)){
                power--;
                number *= base;
            }
        }
        return power;
    },
    _getNumberByPower: function(number, power, base) {
        var result = number;
        while(power > 0){
            result /= base;
            power--;
        }
        while(power < 0){
            result *= base;
            power++;
        }
        return result;
    },
    _formatNumber: function(value, formatObject, formatConfig) {
        var result;
        if ("auto" === formatObject.power) formatObject.power = this._calculateNumberPower(value, 1e3, 0, $6b5c41bba4a4960f$var$MAX_LARGE_NUMBER_POWER);
        if (formatObject.power) value = this._getNumberByPower(value, formatObject.power, 1e3);
        var powerPostfix = this.defaultLargeNumberFormatPostfixes[formatObject.power] || "";
        result = this._formatNumberCore(value, formatObject.formatType, formatConfig);
        result = result.replace(/(\d|.$)(\D*)$/, "$1" + powerPostfix + "$2");
        return result;
    },
    _formatNumberExponential: function(value, formatConfig) {
        var power = this._calculateNumberPower(value, $6b5c41bba4a4960f$var$DECIMAL_BASE);
        var number = this._getNumberByPower(value, power, $6b5c41bba4a4960f$var$DECIMAL_BASE);
        if (void 0 === formatConfig.precision) formatConfig.precision = 1;
        if (number.toFixed(formatConfig.precision || 0) >= $6b5c41bba4a4960f$var$DECIMAL_BASE) {
            power++;
            number /= $6b5c41bba4a4960f$var$DECIMAL_BASE;
        }
        var powString = (power >= 0 ? "+" : "") + power.toString();
        return this._formatNumberCore(number, "fixedpoint", formatConfig) + "E" + powString;
    },
    _addZeroes: function(value, precision) {
        var multiplier = Math.pow(10, precision);
        var sign = value < 0 ? "-" : "";
        value = (Math.abs(value) * multiplier >>> 0) / multiplier;
        var result = value.toString();
        while(result.length < precision)result = "0" + result;
        return sign + result;
    },
    _addGroupSeparators: function(value) {
        var parts = value.toString().split(".");
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, (0, $6b5c41bba4a4960f$var$_config2.default)().thousandsSeparator) + (parts[1] ? (0, $6b5c41bba4a4960f$var$_config2.default)().decimalSeparator + parts[1] : "");
    },
    _formatNumberCore: function(value, format, formatConfig) {
        if ("exponential" === format) return this._formatNumberExponential(value, formatConfig);
        if ("decimal" !== format && null !== formatConfig.precision) formatConfig.precision = formatConfig.precision || 0;
        if ("percent" === format) value = 100 * value;
        if (void 0 !== formatConfig.precision) {
            if ("decimal" === format) value = this._addZeroes(value, formatConfig.precision);
            else value = null === formatConfig.precision ? value.toPrecision() : (0, $11IRH.toFixed)(value, formatConfig.precision);
        }
        if ("decimal" !== format) value = this._addGroupSeparators(value);
        else value = value.toString().replace(".", (0, $6b5c41bba4a4960f$var$_config2.default)().decimalSeparator);
        if ("percent" === format) value += "%";
        return value;
    },
    _normalizeFormat: function(format) {
        if (!format) return {};
        if ("function" === typeof format) return format;
        if (!(0, $kDRxH.isPlainObject)(format)) format = {
            type: format
        };
        return format;
    },
    _getSeparators: function() {
        return {
            decimalSeparator: this.getDecimalSeparator(),
            thousandsSeparator: this.getThousandsSeparator()
        };
    },
    getThousandsSeparator: function() {
        return this.format(1e4, "fixedPoint")[2];
    },
    getDecimalSeparator: function() {
        return this.format(1.2, {
            type: "fixedPoint",
            precision: 1
        })[1];
    },
    convertDigits: function(value, toStandard) {
        var digits = this.format(90, "decimal");
        if ("string" !== typeof value || "0" === digits[1]) return value;
        var fromFirstDigit = toStandard ? digits[1] : "0";
        var toFirstDigit = toStandard ? "0" : digits[1];
        var fromLastDigit = toStandard ? digits[0] : "9";
        var regExp = new RegExp("[" + fromFirstDigit + "-" + fromLastDigit + "]", "g");
        return value.replace(regExp, function(char) {
            return String.fromCharCode(char.charCodeAt(0) + (toFirstDigit.charCodeAt(0) - fromFirstDigit.charCodeAt(0)));
        });
    },
    getSign: function(text, format) {
        if ("-" === text.replace(/[^0-9-]/g, "").charAt(0)) return -1;
        if (!format) return 1;
        var separators = this._getSeparators();
        var regExp = new RegExp("[0-9" + (0, $2Mto0.escapeRegExp)(separators.decimalSeparator + separators.thousandsSeparator) + "]+", "g");
        var negativeEtalon = this.format(-1, format).replace(regExp, "1");
        var cleanedText = text.replace(regExp, "1");
        return cleanedText === negativeEtalon ? -1 : 1;
    },
    format: function(value, _format) {
        if ("number" !== typeof value) return value;
        if ("number" === typeof _format) return value;
        _format = _format && _format.formatter || _format;
        if ("function" === typeof _format) return _format(value);
        _format = this._normalizeFormat(_format);
        if (!_format.type) _format.type = "decimal";
        var numberConfig = this._parseNumberFormatString(_format.type);
        if (!numberConfig) return this.convertDigits($6b5c41bba4a4960f$var$_number2.default.getFormatter(_format.type, this._getSeparators())(value));
        return this._formatNumber(value, numberConfig, _format);
    },
    parse: function(text, format) {
        if (!text) return;
        if (format && format.parser) return format.parser(text);
        text = this.convertDigits(text, true);
        if (format && "string" !== typeof format) $6b5c41bba4a4960f$var$_errors2.default.log("W0011");
        var decimalSeparator = this.getDecimalSeparator();
        var regExp = new RegExp("[^0-9" + (0, $2Mto0.escapeRegExp)(decimalSeparator) + "]", "g");
        var cleanedText = text.replace(regExp, "").replace(decimalSeparator, ".").replace(/\.$/g, "");
        if ("." === cleanedText || "" === cleanedText) return null;
        if (this._calcSignificantDigits(cleanedText) > 15) return NaN;
        var parsed = +cleanedText;
        return parsed * this.getSign(text, format);
    },
    _calcSignificantDigits: function(text) {
        var _text$split = text.split("."), _text$split2 = $6b5c41bba4a4960f$var$_slicedToArray(_text$split, 2), integer = _text$split2[0], fractional = _text$split2[1];
        var calcDigitsAfterLeadingZeros = function(digits) {
            var index = -1;
            for(var i = 0; i < digits.length; i++)if ("0" !== digits[i]) {
                index = i;
                break;
            }
            return index > -1 ? digits.length - index : 0;
        };
        var result = 0;
        if (integer) result += calcDigitsAfterLeadingZeros(integer.split(""));
        if (fractional) result += calcDigitsAfterLeadingZeros(fractional.split("").reverse());
        return result;
    }
});
$6b5c41bba4a4960f$var$numberLocalization.inject($6b5c41bba4a4960f$var$_currency2.default);
if ($6b5c41bba4a4960f$var$hasIntl) $6b5c41bba4a4960f$var$numberLocalization.inject($6b5c41bba4a4960f$var$_number4.default);
module.exports = $6b5c41bba4a4960f$var$numberLocalization;

});
parcelRegister("7znai", function(module, exports) {

$parcel$export(module.exports, "getFormatter", () => $582dc55ef8c1caaf$export$a7f9565e3c81cd54, (v) => $582dc55ef8c1caaf$export$a7f9565e3c81cd54 = v);
$parcel$export(module.exports, "getFormat", () => $582dc55ef8c1caaf$export$f61ac8b6f1f46202, (v) => $582dc55ef8c1caaf$export$f61ac8b6f1f46202 = v);
/**
 * DevExtreme (localization/ldml/number.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $582dc55ef8c1caaf$export$a7f9565e3c81cd54;
var $582dc55ef8c1caaf$export$f61ac8b6f1f46202;
"use strict";

var $efpkH = parcelRequire("efpkH");
var $582dc55ef8c1caaf$require$fitIntoRange = $efpkH.fitIntoRange;

var $11IRH = parcelRequire("11IRH");
var $582dc55ef8c1caaf$require$toFixed = $11IRH.toFixed;
var $582dc55ef8c1caaf$var$DEFAULT_CONFIG = {
    thousandsSeparator: ",",
    decimalSeparator: "."
};
var $582dc55ef8c1caaf$var$ESCAPING_CHAR = "'";
var $582dc55ef8c1caaf$var$MAXIMUM_NUMBER_LENGTH = 15;
function $582dc55ef8c1caaf$var$getGroupSizes(formatString) {
    return formatString.split(",").slice(1).map(function(str) {
        return str.split("").filter(function(char) {
            return "#" === char || "0" === char;
        }).length;
    });
}
function $582dc55ef8c1caaf$var$getSignParts(format) {
    var signParts = format.split(";");
    if (1 === signParts.length) signParts.push("-" + signParts[0]);
    return signParts;
}
function $582dc55ef8c1caaf$var$reverseString(str) {
    return str.toString().split("").reverse().join("");
}
function $582dc55ef8c1caaf$var$isPercentFormat(format) {
    return format.indexOf("%") !== -1 && !format.match(/'[^']*%[^']*'/g);
}
function $582dc55ef8c1caaf$var$getNonRequiredDigitCount(floatFormat) {
    if (!floatFormat) return 0;
    return floatFormat.length - floatFormat.replace(/[#]/g, "").length;
}
function $582dc55ef8c1caaf$var$getRequiredDigitCount(floatFormat) {
    if (!floatFormat) return 0;
    return floatFormat.length - floatFormat.replace(/[0]/g, "").length;
}
function $582dc55ef8c1caaf$var$normalizeValueString(valuePart, minDigitCount, maxDigitCount) {
    if (!valuePart) return "";
    if (valuePart.length > maxDigitCount) valuePart = valuePart.substr(0, maxDigitCount);
    while(valuePart.length > minDigitCount && "0" === valuePart.slice(-1))valuePart = valuePart.substr(0, valuePart.length - 1);
    while(valuePart.length < minDigitCount)valuePart += "0";
    return valuePart;
}
function $582dc55ef8c1caaf$var$applyGroups(valueString, groupSizes, thousandsSeparator) {
    if (!groupSizes.length) return valueString;
    var groups = [];
    var index = 0;
    while(valueString){
        var groupSize = groupSizes[index];
        if (!groupSize) break;
        groups.push(valueString.slice(0, groupSize));
        valueString = valueString.slice(groupSize);
        if (index < groupSizes.length - 1) index++;
    }
    return groups.join(thousandsSeparator);
}
function $582dc55ef8c1caaf$var$formatNumberPart(format, valueString) {
    return format.split($582dc55ef8c1caaf$var$ESCAPING_CHAR).map(function(formatPart, escapeIndex) {
        var isEscape = escapeIndex % 2;
        if (!formatPart && isEscape) return $582dc55ef8c1caaf$var$ESCAPING_CHAR;
        return isEscape ? formatPart : formatPart.replace(/[,#0]+/, valueString);
    }).join("");
}
function $582dc55ef8c1caaf$var$getFloatPointIndex(format) {
    var isEscape = false;
    for(var index = 0; index < format.length; index++){
        if ("'" === format[index]) isEscape = !isEscape;
        if ("." === format[index] && !isEscape) return index;
    }
    return format.length;
}
function $582dc55ef8c1caaf$var$getFormatter(format, config) {
    config = config || $582dc55ef8c1caaf$var$DEFAULT_CONFIG;
    return function(value) {
        if ("number" !== typeof value || isNaN(value)) return "";
        var signFormatParts = $582dc55ef8c1caaf$var$getSignParts(format);
        var isPositiveZero = 1 / value === 1 / 0;
        var isPositive = value > 0 || isPositiveZero;
        var numberFormat = signFormatParts[isPositive ? 0 : 1];
        if ($582dc55ef8c1caaf$var$isPercentFormat(numberFormat)) value = 100 * value;
        if (!isPositive) value = -value;
        var floatPointIndex = $582dc55ef8c1caaf$var$getFloatPointIndex(numberFormat);
        var floatFormatParts = [
            numberFormat.substr(0, floatPointIndex),
            numberFormat.substr(floatPointIndex + 1)
        ];
        var minFloatPrecision = $582dc55ef8c1caaf$var$getRequiredDigitCount(floatFormatParts[1]);
        var maxFloatPrecision = minFloatPrecision + $582dc55ef8c1caaf$var$getNonRequiredDigitCount(floatFormatParts[1]);
        var minIntegerPrecision = $582dc55ef8c1caaf$var$getRequiredDigitCount(floatFormatParts[0]);
        var maxIntegerPrecision = $582dc55ef8c1caaf$var$getNonRequiredDigitCount(floatFormatParts[0]) ? void 0 : minIntegerPrecision;
        var integerLength = Math.floor(value).toString().length;
        var floatPrecision = $582dc55ef8c1caaf$require$fitIntoRange(maxFloatPrecision, 0, $582dc55ef8c1caaf$var$MAXIMUM_NUMBER_LENGTH - integerLength);
        var groupSizes = $582dc55ef8c1caaf$var$getGroupSizes(floatFormatParts[0]).reverse();
        var valueParts = $582dc55ef8c1caaf$require$toFixed(value, floatPrecision < 0 ? 0 : floatPrecision).split(".");
        var valueIntegerPart = $582dc55ef8c1caaf$var$normalizeValueString($582dc55ef8c1caaf$var$reverseString(valueParts[0]), minIntegerPrecision, maxIntegerPrecision);
        var valueFloatPart = $582dc55ef8c1caaf$var$normalizeValueString(valueParts[1], minFloatPrecision, maxFloatPrecision);
        valueIntegerPart = $582dc55ef8c1caaf$var$applyGroups(valueIntegerPart, groupSizes, config.thousandsSeparator);
        var integerString = $582dc55ef8c1caaf$var$reverseString($582dc55ef8c1caaf$var$formatNumberPart($582dc55ef8c1caaf$var$reverseString(floatFormatParts[0]), valueIntegerPart));
        var floatString = maxFloatPrecision ? $582dc55ef8c1caaf$var$formatNumberPart(floatFormatParts[1], valueFloatPart) : "";
        var result = integerString + (floatString.match(/\d/) ? config.decimalSeparator : "") + floatString;
        return result;
    };
}
function $582dc55ef8c1caaf$var$parseValue(text, isPercent, isNegative) {
    var value = (isPercent ? .01 : 1) * parseFloat(text) || 0;
    return isNegative ? -value : value;
}
function $582dc55ef8c1caaf$var$prepareValueText(valueText, formatter, isPercent, isIntegerPart) {
    var nextValueText = valueText;
    var char;
    var text;
    var nextText;
    do {
        if (nextText) {
            char = text.length === nextText.length ? "0" : "1";
            valueText = isIntegerPart ? char + valueText : valueText + char;
        }
        text = nextText || formatter($582dc55ef8c1caaf$var$parseValue(nextValueText, isPercent));
        nextValueText = isIntegerPart ? "1" + nextValueText : nextValueText + "1";
        nextText = formatter($582dc55ef8c1caaf$var$parseValue(nextValueText, isPercent));
    }while (text !== nextText && (isIntegerPart ? text.length === nextText.length : text.length <= nextText.length));
    if (isIntegerPart && nextText.length > text.length) {
        var hasGroups = formatter(12345).indexOf("12345") === -1;
        do valueText = "1" + valueText;
        while (hasGroups && $582dc55ef8c1caaf$var$parseValue(valueText, isPercent) < 1e5);
    }
    return valueText;
}
function $582dc55ef8c1caaf$var$getFormatByValueText(valueText, formatter, isPercent, isNegative) {
    var format = formatter($582dc55ef8c1caaf$var$parseValue(valueText, isPercent, isNegative));
    var valueTextParts = valueText.split(".");
    var valueTextWithModifiedFloat = valueTextParts[0] + ".3" + valueTextParts[1].slice(1);
    var valueWithModifiedFloat = $582dc55ef8c1caaf$var$parseValue(valueTextWithModifiedFloat, isPercent, isNegative);
    var decimalSeparatorIndex = formatter(valueWithModifiedFloat).indexOf("3") - 1;
    format = format.replace(/(\d)\D(\d)/g, "$1,$2");
    if (decimalSeparatorIndex >= 0) format = format.slice(0, decimalSeparatorIndex) + "." + format.slice(decimalSeparatorIndex + 1);
    format = format.replace(/1+/, "1").replace(/1/g, "#");
    if (!isPercent) format = format.replace("%", "'%'");
    return format;
}
function $582dc55ef8c1caaf$var$getFormat(formatter) {
    var valueText = ".";
    var isPercent = formatter(1).indexOf("100") >= 0;
    valueText = $582dc55ef8c1caaf$var$prepareValueText(valueText, formatter, isPercent, true);
    valueText = $582dc55ef8c1caaf$var$prepareValueText(valueText, formatter, isPercent, false);
    var positiveFormat = $582dc55ef8c1caaf$var$getFormatByValueText(valueText, formatter, isPercent, false);
    var negativeFormat = $582dc55ef8c1caaf$var$getFormatByValueText(valueText, formatter, isPercent, true);
    return negativeFormat === "-" + positiveFormat ? positiveFormat : positiveFormat + ";" + negativeFormat;
}
$582dc55ef8c1caaf$export$a7f9565e3c81cd54 = $582dc55ef8c1caaf$var$getFormatter;
$582dc55ef8c1caaf$export$f61ac8b6f1f46202 = $582dc55ef8c1caaf$var$getFormat;

});
parcelRegister("11IRH", function(module, exports) {
/**
 * DevExtreme (localization/utils.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toFixed = void 0;

var $efpkH = parcelRequire("efpkH");
var $0bf8afb87e6c6edd$var$DECIMAL_BASE = 10;
function $0bf8afb87e6c6edd$var$roundByAbs(value) {
    var valueSign = (0, $efpkH.sign)(value);
    return valueSign * Math.round(Math.abs(value));
}
function $0bf8afb87e6c6edd$var$adjustValue(value, precision) {
    var precisionMultiplier = Math.pow($0bf8afb87e6c6edd$var$DECIMAL_BASE, precision);
    var roundMultiplier = precisionMultiplier * $0bf8afb87e6c6edd$var$DECIMAL_BASE;
    var intermediateValue = value * roundMultiplier / $0bf8afb87e6c6edd$var$DECIMAL_BASE;
    return $0bf8afb87e6c6edd$var$roundByAbs(intermediateValue) / precisionMultiplier;
}
function $0bf8afb87e6c6edd$var$toFixed(value, precision) {
    var valuePrecision = precision || 0;
    var adjustedValue = valuePrecision > 0 ? $0bf8afb87e6c6edd$var$adjustValue.apply(void 0, arguments) : value;
    return adjustedValue.toFixed(valuePrecision);
}
module.exports.toFixed = $0bf8afb87e6c6edd$var$toFixed;

});


parcelRegister("8WMaH", function(module, exports) {
/**
 * DevExtreme (localization/currency.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $7I8Uw = parcelRequire("7I8Uw");
module.exports = {
    _formatNumberCore: function(value, format, formatConfig) {
        if ("currency" === format) {
            formatConfig.precision = formatConfig.precision || 0;
            var result = this.format(value, (0, $7I8Uw.extend)({}, formatConfig, {
                type: "fixedpoint"
            }));
            var currencyPart = this.getCurrencySymbol().symbol.replace("$", "$$$$");
            result = result.replace(/^(\D*)(\d.*)/, "$1" + currencyPart + "$2");
            return result;
        }
        return this.callBase.apply(this, arguments);
    },
    getCurrencySymbol: function() {
        return {
            symbol: "$"
        };
    },
    getOpenXmlCurrencyFormat: function() {
        return "$#,##0{0}_);\\($#,##0{0}\\)";
    }
};

});

parcelRegister("a3Ncl", function(module, exports) {
/**
 * DevExtreme (localization/intl/number.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $1JvXr = parcelRequire("1JvXr");
var $753058e5c51a0be7$var$_config2 = $753058e5c51a0be7$var$_interopRequireDefault($1JvXr);

var $gCA0F = parcelRequire("gCA0F");

var $c20dO = parcelRequire("c20dO");
var $753058e5c51a0be7$var$_version2 = $753058e5c51a0be7$var$_interopRequireDefault($c20dO);

var $hwytx = parcelRequire("hwytx");

var $euwbf = parcelRequire("euwbf");
var $753058e5c51a0be7$var$_open_xml_currency_format2 = $753058e5c51a0be7$var$_interopRequireDefault($euwbf);

var $3yD3F = parcelRequire("3yD3F");
var $753058e5c51a0be7$var$_accounting_formats2 = $753058e5c51a0be7$var$_interopRequireDefault($3yD3F);
function $753058e5c51a0be7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $753058e5c51a0be7$var$detectCurrencySymbolRegex = /([^\s0]+)?(\s*)0*[.,]*0*(\s*)([^\s0]+)?/;
var $753058e5c51a0be7$var$formattersCache = {};
var $753058e5c51a0be7$var$getFormatter = function(format) {
    var key = (0, $gCA0F.locale)() + "/" + JSON.stringify(format);
    if (!$753058e5c51a0be7$var$formattersCache[key]) $753058e5c51a0be7$var$formattersCache[key] = new Intl.NumberFormat((0, $gCA0F.locale)(), format).format;
    return $753058e5c51a0be7$var$formattersCache[key];
};
var $753058e5c51a0be7$var$getCurrencyFormatter = function(currency) {
    return new Intl.NumberFormat((0, $gCA0F.locale)(), {
        style: "currency",
        currency: currency
    });
};
module.exports = {
    engine: function() {
        return "intl";
    },
    _formatNumberCore: function(value, format, formatConfig) {
        if ("exponential" === format) return this.callBase.apply(this, arguments);
        return $753058e5c51a0be7$var$getFormatter(this._normalizeFormatConfig(format, formatConfig))(value);
    },
    _normalizeFormatConfig: function(format, formatConfig, value) {
        var config;
        if ("decimal" === format) config = {
            minimumIntegerDigits: formatConfig.precision || void 0,
            useGrouping: false,
            maximumFractionDigits: String(value).length,
            round: value < 0 ? "ceil" : "floor"
        };
        else config = this._getPrecisionConfig(formatConfig.precision);
        if ("percent" === format) config.style = "percent";
        else if ("currency" === format) {
            config.style = "currency";
            config.currency = formatConfig.currency || (0, $753058e5c51a0be7$var$_config2.default)().defaultCurrency;
        }
        return config;
    },
    _getPrecisionConfig: function(precision) {
        var config;
        if (null === precision) config = {
            minimumFractionDigits: 0,
            maximumFractionDigits: 20
        };
        else config = {
            minimumFractionDigits: precision || 0,
            maximumFractionDigits: precision || 0
        };
        return config;
    },
    format: function(value, _format) {
        if ("number" !== typeof value) return value;
        _format = this._normalizeFormat(_format);
        if ("default" === _format.currency) _format.currency = (0, $753058e5c51a0be7$var$_config2.default)().defaultCurrency;
        if (!_format || "function" !== typeof _format && !_format.type && !_format.formatter) return $753058e5c51a0be7$var$getFormatter(_format)(value);
        return this.callBase.apply(this, arguments);
    },
    parse: function(text, format) {
        if ((0, $hwytx.compare)($753058e5c51a0be7$var$_version2.default, "17.2.8") >= 0) return this.callBase.apply(this, arguments);
        if (!text) return;
        if (format && format.parser) return format.parser(text);
        text = this._normalizeNumber(text, format);
        if (text.length > 15) return NaN;
        return parseFloat(text);
    },
    _normalizeNumber: function(text, format) {
        var isExponentialRegexp = /^[-+]?[0-9]*.?[0-9]+([eE][-+]?[0-9]+)+$/;
        var legitDecimalSeparator = ".";
        if (this.convertDigits) text = this.convertDigits(text, true);
        if (isExponentialRegexp.test(text)) return text;
        var decimalSeparator = this._getDecimalSeparator(format);
        var cleanUpRegexp = new RegExp("[^0-9-\\" + decimalSeparator + "]", "g");
        return text.replace(cleanUpRegexp, "").replace(decimalSeparator, legitDecimalSeparator);
    },
    _getDecimalSeparator: function(format) {
        return $753058e5c51a0be7$var$getFormatter(format)(.1)[1];
    },
    _getCurrencySymbolInfo: function(currency) {
        var formatter = $753058e5c51a0be7$var$getCurrencyFormatter(currency);
        return this._extractCurrencySymbolInfo(formatter.format(0));
    },
    _extractCurrencySymbolInfo: function(currencyValueString) {
        var match = $753058e5c51a0be7$var$detectCurrencySymbolRegex.exec(currencyValueString) || [];
        var position = match[1] ? "before" : "after";
        var symbol = match[1] || match[4] || "";
        var delimiter = match[2] || match[3] || "";
        return {
            position: position,
            symbol: symbol,
            delimiter: delimiter
        };
    },
    getCurrencySymbol: function(currency) {
        if (!currency) currency = (0, $753058e5c51a0be7$var$_config2.default)().defaultCurrency;
        var symbolInfo = this._getCurrencySymbolInfo(currency);
        return {
            symbol: symbolInfo.symbol
        };
    },
    getOpenXmlCurrencyFormat: function(currency) {
        var targetCurrency = currency || (0, $753058e5c51a0be7$var$_config2.default)().defaultCurrency;
        var currencySymbol = this._getCurrencySymbolInfo(targetCurrency).symbol;
        var closestAccountingFormat = (0, $gCA0F.getValueByClosestLocale)(function(locale) {
            return $753058e5c51a0be7$var$_accounting_formats2.default[locale];
        });
        return (0, $753058e5c51a0be7$var$_open_xml_currency_format2.default)(currencySymbol, closestAccountingFormat);
    }
};

});
parcelRegister("gCA0F", function(module, exports) {
/**
 * DevExtreme (localization/core.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $6LNcw = parcelRequire("6LNcw");
var $c19c20bb09965db4$var$_dependency_injector2 = $c19c20bb09965db4$var$_interopRequireDefault($6LNcw);

var $laAld = parcelRequire("laAld");
var $c19c20bb09965db4$var$_parent_locales2 = $c19c20bb09965db4$var$_interopRequireDefault($laAld);

var $4ZtDC = parcelRequire("4ZtDC");
var $c19c20bb09965db4$var$_parentLocale2 = $c19c20bb09965db4$var$_interopRequireDefault($4ZtDC);
function $c19c20bb09965db4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $c19c20bb09965db4$var$DEFAULT_LOCALE = "en";
module.exports = (0, $c19c20bb09965db4$var$_dependency_injector2.default)({
    locale: function() {
        var currentLocale = $c19c20bb09965db4$var$DEFAULT_LOCALE;
        return function(locale) {
            if (!locale) return currentLocale;
            currentLocale = locale;
        };
    }(),
    getValueByClosestLocale: function(getter) {
        var locale = this.locale();
        var value = getter(locale);
        var isRootLocale;
        while(!value && !isRootLocale){
            locale = (0, $c19c20bb09965db4$var$_parentLocale2.default)($c19c20bb09965db4$var$_parent_locales2.default, locale);
            if (locale) value = getter(locale);
            else isRootLocale = true;
        }
        if (void 0 === value && locale !== $c19c20bb09965db4$var$DEFAULT_LOCALE) return getter($c19c20bb09965db4$var$DEFAULT_LOCALE);
        return value;
    }
});

});
parcelRegister("laAld", function(module, exports) {
/**
 * DevExtreme (localization/cldr-data/parent_locales.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
module.exports = {
    "en-150": "en-001",
    "en-AG": "en-001",
    "en-AI": "en-001",
    "en-AU": "en-001",
    "en-BB": "en-001",
    "en-BM": "en-001",
    "en-BS": "en-001",
    "en-BW": "en-001",
    "en-BZ": "en-001",
    "en-CA": "en-001",
    "en-CC": "en-001",
    "en-CK": "en-001",
    "en-CM": "en-001",
    "en-CX": "en-001",
    "en-CY": "en-001",
    "en-DG": "en-001",
    "en-DM": "en-001",
    "en-ER": "en-001",
    "en-FJ": "en-001",
    "en-FK": "en-001",
    "en-FM": "en-001",
    "en-GB": "en-001",
    "en-GD": "en-001",
    "en-GG": "en-001",
    "en-GH": "en-001",
    "en-GI": "en-001",
    "en-GM": "en-001",
    "en-GY": "en-001",
    "en-HK": "en-001",
    "en-IE": "en-001",
    "en-IL": "en-001",
    "en-IM": "en-001",
    "en-IN": "en-001",
    "en-IO": "en-001",
    "en-JE": "en-001",
    "en-JM": "en-001",
    "en-KE": "en-001",
    "en-KI": "en-001",
    "en-KN": "en-001",
    "en-KY": "en-001",
    "en-LC": "en-001",
    "en-LR": "en-001",
    "en-LS": "en-001",
    "en-MG": "en-001",
    "en-MO": "en-001",
    "en-MS": "en-001",
    "en-MT": "en-001",
    "en-MU": "en-001",
    "en-MW": "en-001",
    "en-MY": "en-001",
    "en-NA": "en-001",
    "en-NF": "en-001",
    "en-NG": "en-001",
    "en-NR": "en-001",
    "en-NU": "en-001",
    "en-NZ": "en-001",
    "en-PG": "en-001",
    "en-PH": "en-001",
    "en-PK": "en-001",
    "en-PN": "en-001",
    "en-PW": "en-001",
    "en-RW": "en-001",
    "en-SB": "en-001",
    "en-SC": "en-001",
    "en-SD": "en-001",
    "en-SG": "en-001",
    "en-SH": "en-001",
    "en-SL": "en-001",
    "en-SS": "en-001",
    "en-SX": "en-001",
    "en-SZ": "en-001",
    "en-TC": "en-001",
    "en-TK": "en-001",
    "en-TO": "en-001",
    "en-TT": "en-001",
    "en-TV": "en-001",
    "en-TZ": "en-001",
    "en-UG": "en-001",
    "en-VC": "en-001",
    "en-VG": "en-001",
    "en-VU": "en-001",
    "en-WS": "en-001",
    "en-ZA": "en-001",
    "en-ZM": "en-001",
    "en-ZW": "en-001",
    "en-AT": "en-150",
    "en-BE": "en-150",
    "en-CH": "en-150",
    "en-DE": "en-150",
    "en-DK": "en-150",
    "en-FI": "en-150",
    "en-NL": "en-150",
    "en-SE": "en-150",
    "en-SI": "en-150",
    "es-AR": "es-419",
    "es-BO": "es-419",
    "es-BR": "es-419",
    "es-BZ": "es-419",
    "es-CL": "es-419",
    "es-CO": "es-419",
    "es-CR": "es-419",
    "es-CU": "es-419",
    "es-DO": "es-419",
    "es-EC": "es-419",
    "es-GT": "es-419",
    "es-HN": "es-419",
    "es-MX": "es-419",
    "es-NI": "es-419",
    "es-PA": "es-419",
    "es-PE": "es-419",
    "es-PR": "es-419",
    "es-PY": "es-419",
    "es-SV": "es-419",
    "es-US": "es-419",
    "es-UY": "es-419",
    "es-VE": "es-419",
    "pt-AO": "pt-PT",
    "pt-CH": "pt-PT",
    "pt-CV": "pt-PT",
    "pt-FR": "pt-PT",
    "pt-GQ": "pt-PT",
    "pt-GW": "pt-PT",
    "pt-LU": "pt-PT",
    "pt-MO": "pt-PT",
    "pt-MZ": "pt-PT",
    "pt-ST": "pt-PT",
    "pt-TL": "pt-PT",
    "az-Arab": "root",
    "az-Cyrl": "root",
    "blt-Latn": "root",
    "bm-Nkoo": "root",
    "bs-Cyrl": "root",
    "byn-Latn": "root",
    "cu-Glag": "root",
    "dje-Arab": "root",
    "dyo-Arab": "root",
    "en-Dsrt": "root",
    "en-Shaw": "root",
    "ff-Adlm": "root",
    "ff-Arab": "root",
    "ha-Arab": "root",
    "iu-Latn": "root",
    "kk-Arab": "root",
    "ku-Arab": "root",
    "ky-Arab": "root",
    "ky-Latn": "root",
    "ml-Arab": "root",
    "mn-Mong": "root",
    "ms-Arab": "root",
    "pa-Arab": "root",
    "sd-Deva": "root",
    "sd-Khoj": "root",
    "sd-Sind": "root",
    "shi-Latn": "root",
    "so-Arab": "root",
    "sr-Latn": "root",
    "sw-Arab": "root",
    "tg-Arab": "root",
    "ug-Cyrl": "root",
    "uz-Arab": "root",
    "uz-Cyrl": "root",
    "vai-Latn": "root",
    "wo-Arab": "root",
    "yo-Arab": "root",
    "yue-Hans": "root",
    "zh-Hant": "root",
    "zh-Hant-MO": "zh-Hant-HK"
};

});

parcelRegister("4ZtDC", function(module, exports) {
/**
 * DevExtreme (localization/parentLocale.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
var $3a23d96e682b9529$var$PARENT_LOCALE_SEPARATOR = "-";
module.exports = function(parentLocales, locale) {
    var parentLocale = parentLocales[locale];
    if (parentLocale) return "root" !== parentLocale && parentLocale;
    return locale.substr(0, locale.lastIndexOf($3a23d96e682b9529$var$PARENT_LOCALE_SEPARATOR));
};

});


parcelRegister("hwytx", function(module, exports) {

$parcel$export(module.exports, "compare", () => $cc202aede7d45597$export$398604a469f7de9a, (v) => $cc202aede7d45597$export$398604a469f7de9a = v);
/**
 * DevExtreme (core/utils/version.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $cc202aede7d45597$export$398604a469f7de9a;
"use strict";
$cc202aede7d45597$export$398604a469f7de9a = function(x, y, maxLevel) {
    function normalizeArg(value) {
        if ("string" === typeof value) return value.split(".");
        if ("number" === typeof value) return [
            value
        ];
        return value;
    }
    x = normalizeArg(x);
    y = normalizeArg(y);
    var length = Math.max(x.length, y.length);
    if (isFinite(maxLevel)) length = Math.min(length, maxLevel);
    for(var i = 0; i < length; i++){
        var xItem = parseInt(x[i] || 0, 10);
        var yItem = parseInt(y[i] || 0, 10);
        if (xItem < yItem) return -1;
        if (xItem > yItem) return 1;
    }
    return 0;
};

});

parcelRegister("euwbf", function(module, exports) {
/**
 * DevExtreme (localization/open_xml_currency_format.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
module.exports = function(currencySymbol, accountingFormat) {
    if (!accountingFormat) return;
    var encodedCurrencySymbol = currencySymbol;
    if ("string" === typeof currencySymbol) {
        encodedCurrencySymbol = "";
        for(var i = 0; i < currencySymbol.length; i++){
            if ("$" !== currencySymbol[i]) encodedCurrencySymbol += "\\";
            encodedCurrencySymbol += currencySymbol[i];
        }
    }
    var encodeSymbols = {
        ".00": "{0}",
        "'": "\\'",
        "\\(": "\\(",
        "\\)": "\\)",
        " ": "\\ ",
        '"': "&quot;",
        "\\\xa4": encodedCurrencySymbol
    };
    var result = accountingFormat.split(";");
    for(var _i = 0; _i < result.length; _i++){
        for(var symbol in encodeSymbols)if (Object.prototype.hasOwnProperty.call(encodeSymbols, symbol)) result[_i] = result[_i].replace(new RegExp(symbol, "g"), encodeSymbols[symbol]);
    }
    return 2 === result.length ? result[0] + "_);" + result[1] : result[0];
};

});

parcelRegister("3yD3F", function(module, exports) {
/**
 * DevExtreme (localization/cldr-data/accounting_formats.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
module.exports = {
    af: "\xa4#,##0.00;(\xa4#,##0.00)",
    "af-NA": "\xa4#,##0.00;(\xa4#,##0.00)",
    agq: "#,##0.00\xa4",
    ak: "\xa4#,##0.00",
    am: "\xa4#,##0.00;(\xa4#,##0.00)",
    ar: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-AE": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-BH": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-DJ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-DZ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-EG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-EH": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-ER": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-IL": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-IQ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-JO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-KM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-KW": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-LB": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-LY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-MA": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-MR": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-OM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-PS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-QA": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-SA": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-SD": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-SO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-SS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-SY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-TD": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-TN": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ar-YE": "\xa4#,##0.00;(\xa4#,##0.00)",
    as: "\xa4\xa0#,##,##0.00",
    asa: "#,##0.00\xa0\xa4",
    ast: "#,##0.00\xa0\xa4",
    az: "#,##0.00\xa0\xa4",
    "az-Cyrl": "#,##0.00\xa0\xa4",
    "az-Latn": "#,##0.00\xa0\xa4",
    bas: "#,##0.00\xa0\xa4",
    be: "#,##0.00\xa0\xa4",
    bem: "\xa4#,##0.00;(\xa4#,##0.00)",
    bez: "#,##0.00\xa4",
    bg: "0.00\xa0\xa4;(0.00\xa0\xa4)",
    bm: "\xa4#,##0.00;(\xa4#,##0.00)",
    bn: "#,##,##0.00\xa4;(#,##,##0.00\xa4)",
    "bn-IN": "#,##,##0.00\xa4;(#,##,##0.00\xa4)",
    bo: "\xa4\xa0#,##0.00",
    "bo-IN": "\xa4\xa0#,##0.00",
    br: "#,##0.00\xa0\xa4",
    brx: "\xa4\xa0#,##,##0.00",
    bs: "#,##0.00\xa0\xa4",
    "bs-Cyrl": "#,##0.00\xa0\xa4",
    "bs-Latn": "#,##0.00\xa0\xa4",
    ca: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "ca-AD": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "ca-ES-VALENCIA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "ca-FR": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "ca-IT": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    ccp: "#,##,##0.00\xa4;(#,##,##0.00\xa4)",
    "ccp-IN": "#,##,##0.00\xa4;(#,##,##0.00\xa4)",
    ce: "#,##0.00\xa0\xa4",
    ceb: "\xa4#,##0.00;(\xa4#,##0.00)",
    cgg: "\xa4#,##0.00",
    chr: "\xa4#,##0.00;(\xa4#,##0.00)",
    ckb: "\xa4\xa0#,##0.00",
    "ckb-IR": "\xa4\xa0#,##0.00",
    cs: "#,##0.00\xa0\xa4",
    cu: "\xa4\xa0#,##0.00",
    cy: "\xa4#,##0.00;(\xa4#,##0.00)",
    da: "#,##0.00\xa0\xa4",
    "da-GL": "#,##0.00\xa0\xa4",
    dav: "\xa4#,##0.00;(\xa4#,##0.00)",
    de: "#,##0.00\xa0\xa4",
    "de-AT": "#,##0.00\xa0\xa4",
    "de-BE": "#,##0.00\xa0\xa4",
    "de-CH": "#,##0.00\xa0\xa4",
    "de-IT": "#,##0.00\xa0\xa4",
    "de-LI": "#,##0.00\xa0\xa4",
    "de-LU": "#,##0.00\xa0\xa4",
    dje: "#,##0.00\xa4",
    dsb: "#,##0.00\xa0\xa4",
    dua: "#,##0.00\xa0\xa4",
    dyo: "#,##0.00\xa0\xa4",
    dz: "\xa4#,##,##0.00",
    ebu: "\xa4#,##0.00;(\xa4#,##0.00)",
    ee: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ee-TG": "\xa4#,##0.00;(\xa4#,##0.00)",
    el: "#,##0.00\xa0\xa4",
    "el-CY": "#,##0.00\xa0\xa4",
    en: "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-001": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-150": "#,##0.00\xa0\xa4",
    "en-AE": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-AG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-AI": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-AS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-AT": "\xa4\xa0#,##0.00",
    "en-AU": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-BB": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-BE": "#,##0.00\xa0\xa4",
    "en-BI": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-BM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-BS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-BW": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-BZ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-CA": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-CC": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-CH": "\xa4\xa0#,##0.00;\xa4-#,##0.00",
    "en-CK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-CM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-CX": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-CY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-DE": "#,##0.00\xa0\xa4",
    "en-DG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-DK": "#,##0.00\xa0\xa4",
    "en-DM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-ER": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-FI": "#,##0.00\xa0\xa4",
    "en-FJ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-FK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-FM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GB": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GD": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GH": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GI": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GU": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-GY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-HK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-IE": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-IL": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-IM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-IN": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-IO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-JE": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-JM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-KE": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-KI": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-KN": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-KY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-LC": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-LR": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-LS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MH": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MP": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MT": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MU": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MW": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-MY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-NA": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-NF": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-NG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-NL": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "en-NR": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-NU": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-NZ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-PG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-PH": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-PK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-PN": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-PR": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-PW": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-RW": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SB": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SC": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SD": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SE": "#,##0.00\xa0\xa4",
    "en-SG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SH": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SI": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "en-SL": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SX": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-SZ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-TC": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-TK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-TO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-TT": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-TV": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-TZ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-UG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-UM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-US-POSIX": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-VC": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-VG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-VI": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-VU": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-WS": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-ZA": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-ZM": "\xa4#,##0.00;(\xa4#,##0.00)",
    "en-ZW": "\xa4#,##0.00;(\xa4#,##0.00)",
    eo: "\xa4\xa0#,##0.00",
    es: "#,##0.00\xa0\xa4",
    "es-419": "\xa4#,##0.00",
    "es-AR": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "es-BO": "\xa4#,##0.00",
    "es-BR": "\xa4#,##0.00",
    "es-BZ": "\xa4#,##0.00",
    "es-CL": "\xa4#,##0.00",
    "es-CO": "\xa4#,##0.00",
    "es-CR": "\xa4#,##0.00",
    "es-CU": "\xa4#,##0.00",
    "es-DO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "es-EA": "#,##0.00\xa0\xa4",
    "es-EC": "\xa4#,##0.00",
    "es-GQ": "#,##0.00\xa0\xa4",
    "es-GT": "\xa4#,##0.00",
    "es-HN": "\xa4#,##0.00",
    "es-IC": "#,##0.00\xa0\xa4",
    "es-MX": "\xa4#,##0.00",
    "es-NI": "\xa4#,##0.00",
    "es-PA": "\xa4#,##0.00",
    "es-PE": "\xa4#,##0.00",
    "es-PH": "#,##0.00\xa0\xa4",
    "es-PR": "\xa4#,##0.00",
    "es-PY": "\xa4#,##0.00",
    "es-SV": "\xa4#,##0.00",
    "es-US": "\xa4#,##0.00",
    "es-UY": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "es-VE": "\xa4#,##0.00",
    et: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    eu: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    ewo: "#,##0.00\xa0\xa4",
    fa: "\u200E\xa4\xa0#,##0.00;\u200E(\xa4\xa0#,##0.00)",
    "fa-AF": "\xa4\xa0#,##0.00;\u200E(\xa4\xa0#,##0.00)",
    ff: "#,##0.00\xa0\xa4",
    "ff-Latn": "#,##0.00\xa0\xa4",
    "ff-Latn-BF": "#,##0.00\xa0\xa4",
    "ff-Latn-CM": "#,##0.00\xa0\xa4",
    "ff-Latn-GH": "#,##0.00\xa0\xa4",
    "ff-Latn-GM": "#,##0.00\xa0\xa4",
    "ff-Latn-GN": "#,##0.00\xa0\xa4",
    "ff-Latn-GW": "#,##0.00\xa0\xa4",
    "ff-Latn-LR": "#,##0.00\xa0\xa4",
    "ff-Latn-MR": "#,##0.00\xa0\xa4",
    "ff-Latn-NE": "#,##0.00\xa0\xa4",
    "ff-Latn-NG": "#,##0.00\xa0\xa4",
    "ff-Latn-SL": "#,##0.00\xa0\xa4",
    fi: "#,##0.00\xa0\xa4",
    fil: "\xa4#,##0.00;(\xa4#,##0.00)",
    fo: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fo-DK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    fr: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-BE": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-BF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-BI": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-BJ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-BL": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CD": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CG": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CH": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CI": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-CM": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-DJ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-DZ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-GA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-GF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-GN": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-GP": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-GQ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-HT": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-KM": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-LU": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MC": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MG": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-ML": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MQ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MR": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-MU": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-NC": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-NE": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-PF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-PM": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-RE": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-RW": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-SC": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-SN": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-SY": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-TD": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-TG": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-TN": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-VU": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-WF": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "fr-YT": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    fur: "\xa4\xa0#,##0.00",
    fy: "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    ga: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ga-GB": "\xa4#,##0.00;(\xa4#,##0.00)",
    gd: "\xa4#,##0.00;(\xa4#,##0.00)",
    gl: "#,##0.00\xa0\xa4",
    gsw: "#,##0.00\xa0\xa4",
    "gsw-FR": "#,##0.00\xa0\xa4",
    "gsw-LI": "#,##0.00\xa0\xa4",
    gu: "\xa4#,##,##0.00;(\xa4#,##,##0.00)",
    guz: "\xa4#,##0.00;(\xa4#,##0.00)",
    gv: "\xa4#,##0.00",
    ha: "\xa4\xa0#,##0.00",
    "ha-GH": "\xa4\xa0#,##0.00",
    "ha-NE": "\xa4\xa0#,##0.00",
    haw: "\xa4#,##0.00;(\xa4#,##0.00)",
    he: "#,##0.00\xa0\xa4",
    hi: "\xa4#,##,##0.00",
    hr: "#,##0.00\xa0\xa4",
    "hr-BA": "#,##0.00\xa0\xa4",
    hsb: "#,##0.00\xa0\xa4",
    hu: "#,##0.00\xa0\xa4",
    hy: "#,##0.00\xa0\xa4",
    ia: "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    id: "\xa4#,##0.00",
    ig: "\xa4#,##0.00;(\xa4#,##0.00)",
    ii: "\xa4\xa0#,##0.00",
    is: "#,##0.00\xa0\xa4",
    it: "#,##0.00\xa0\xa4",
    "it-CH": "#,##0.00\xa0\xa4",
    "it-SM": "#,##0.00\xa0\xa4",
    "it-VA": "#,##0.00\xa0\xa4",
    ja: "\xa4#,##0.00;(\xa4#,##0.00)",
    jgo: "\xa4\xa0#,##0.00",
    jmc: "\xa4#,##0.00",
    jv: "\xa4\xa0#,##0.00",
    ka: "#,##0.00\xa0\xa4",
    kab: "#,##0.00\xa4",
    kam: "\xa4#,##0.00;(\xa4#,##0.00)",
    kde: "\xa4#,##0.00;(\xa4#,##0.00)",
    kea: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    khq: "#,##0.00\xa4",
    ki: "\xa4#,##0.00;(\xa4#,##0.00)",
    kk: "#,##0.00\xa0\xa4",
    kkj: "\xa4\xa0#,##0.00",
    kl: "\xa4#,##0.00;\xa4-#,##0.00",
    kln: "\xa4#,##0.00;(\xa4#,##0.00)",
    km: "#,##0.00\xa4;(#,##0.00\xa4)",
    kn: "\xa4#,##0.00;(\xa4#,##0.00)",
    ko: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ko-KP": "\xa4#,##0.00;(\xa4#,##0.00)",
    kok: "\xa4#,##0.00;(\xa4#,##0.00)",
    ks: "\xa4\xa0#,##,##0.00",
    ksb: "#,##0.00\xa4",
    ksf: "#,##0.00\xa0\xa4",
    ksh: "#,##0.00\xa0\xa4",
    ku: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    kw: "\xa4#,##0.00",
    ky: "#,##0.00\xa0\xa4",
    lag: "\xa4\xa0#,##0.00",
    lb: "#,##0.00\xa0\xa4",
    lg: "#,##0.00\xa4",
    lkt: "\xa4\xa0#,##0.00",
    ln: "#,##0.00\xa0\xa4",
    "ln-AO": "#,##0.00\xa0\xa4",
    "ln-CF": "#,##0.00\xa0\xa4",
    "ln-CG": "#,##0.00\xa0\xa4",
    lo: "\xa4#,##0.00;\xa4-#,##0.00",
    lrc: "\xa4\xa0#,##0.00",
    "lrc-IQ": "\xa4\xa0#,##0.00",
    lt: "#,##0.00\xa0\xa4",
    lu: "#,##0.00\xa4",
    luo: "#,##0.00\xa4",
    luy: "\xa4#,##0.00;\xa4-\xa0#,##0.00",
    lv: "#,##0.00\xa0\xa4",
    mas: "\xa4#,##0.00;(\xa4#,##0.00)",
    "mas-TZ": "\xa4#,##0.00;(\xa4#,##0.00)",
    mer: "\xa4#,##0.00;(\xa4#,##0.00)",
    mfe: "\xa4\xa0#,##0.00",
    mg: "\xa4#,##0.00",
    mgh: "\xa4\xa0#,##0.00",
    mgo: "\xa4\xa0#,##0.00",
    mi: "\xa4\xa0#,##0.00",
    mk: "#,##0.00\xa0\xa4",
    ml: "\xa4#,##0.00;(\xa4#,##0.00)",
    mn: "\xa4\xa0#,##0.00",
    mr: "\xa4#,##0.00;(\xa4#,##0.00)",
    ms: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ms-BN": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ms-SG": "\xa4#,##0.00;(\xa4#,##0.00)",
    mt: "\xa4#,##0.00",
    mua: "\xa4#,##0.00;(\xa4#,##0.00)",
    my: "\xa4\xa0#,##0.00",
    mzn: "\xa4\xa0#,##0.00",
    naq: "\xa4#,##0.00",
    nb: "\xa4\xa0#,##0.00",
    "nb-SJ": "\xa4\xa0#,##0.00",
    nd: "\xa4#,##0.00;(\xa4#,##0.00)",
    nds: "\xa4\xa0#,##0.00",
    "nds-NL": "\xa4\xa0#,##0.00",
    ne: "\xa4\xa0#,##0.00",
    "ne-IN": "\xa4\xa0#,##0.00",
    nl: "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nl-AW": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nl-BE": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nl-BQ": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nl-CW": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nl-SR": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    "nl-SX": "\xa4\xa0#,##0.00;(\xa4\xa0#,##0.00)",
    nmg: "#,##0.00\xa0\xa4",
    nn: "#,##0.00\xa0\xa4",
    nnh: "\xa4\xa0#,##0.00",
    nus: "\xa4#,##0.00;(\xa4#,##0.00)",
    nyn: "\xa4#,##0.00",
    om: "\xa4#,##0.00",
    "om-KE": "\xa4#,##0.00",
    or: "\xa4#,##0.00;(\xa4#,##0.00)",
    os: "\xa4\xa0#,##0.00",
    "os-RU": "\xa4\xa0#,##0.00",
    pa: "\xa4\xa0#,##0.00",
    "pa-Arab": "\xa4\xa0#,##0.00",
    "pa-Guru": "\xa4\xa0#,##0.00",
    pl: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    prg: "\xa4\xa0#,##0.00",
    ps: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ps-PK": "\xa4#,##0.00;(\xa4#,##0.00)",
    pt: "\xa4\xa0#,##0.00",
    "pt-AO": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-CH": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-CV": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-GQ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-GW": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-LU": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-MO": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-MZ": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-PT": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-ST": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "pt-TL": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    qu: "\xa4\xa0#,##0.00",
    "qu-BO": "\xa4\xa0#,##0.00",
    "qu-EC": "\xa4\xa0#,##0.00",
    rm: "#,##0.00\xa0\xa4",
    rn: "#,##0.00\xa4",
    ro: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "ro-MD": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    rof: "\xa4#,##0.00",
    root: "\xa4\xa0#,##0.00",
    ru: "#,##0.00\xa0\xa4",
    "ru-BY": "#,##0.00\xa0\xa4",
    "ru-KG": "#,##0.00\xa0\xa4",
    "ru-KZ": "#,##0.00\xa0\xa4",
    "ru-MD": "#,##0.00\xa0\xa4",
    "ru-UA": "#,##0.00\xa0\xa4",
    rw: "\xa4\xa0#,##0.00",
    rwk: "#,##0.00\xa4",
    sah: "#,##0.00\xa0\xa4",
    saq: "\xa4#,##0.00;(\xa4#,##0.00)",
    sbp: "#,##0.00\xa4",
    sd: "\xa4\xa0#,##0.00",
    se: "#,##0.00\xa0\xa4",
    "se-FI": "#,##0.00\xa0\xa4",
    "se-SE": "#,##0.00\xa0\xa4",
    seh: "#,##0.00\xa4",
    ses: "#,##0.00\xa4",
    sg: "\xa4#,##0.00;\xa4-#,##0.00",
    shi: "#,##0.00\xa4",
    "shi-Latn": "#,##0.00\xa4",
    "shi-Tfng": "#,##0.00\xa4",
    si: "\xa4#,##0.00;(\xa4#,##0.00)",
    sk: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    sl: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    smn: "#,##0.00\xa0\xa4",
    sn: "\xa4#,##0.00;(\xa4#,##0.00)",
    so: "\xa4#,##0.00;(\xa4#,##0.00)",
    "so-DJ": "\xa4#,##0.00;(\xa4#,##0.00)",
    "so-ET": "\xa4#,##0.00;(\xa4#,##0.00)",
    "so-KE": "\xa4#,##0.00;(\xa4#,##0.00)",
    sq: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sq-MK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sq-XK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    sr: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Cyrl": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Cyrl-BA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Cyrl-ME": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Cyrl-XK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Latn": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Latn-BA": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Latn-ME": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    "sr-Latn-XK": "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    sv: "#,##0.00\xa0\xa4",
    "sv-AX": "#,##0.00\xa0\xa4",
    "sv-FI": "#,##0.00\xa0\xa4",
    sw: "\xa4\xa0#,##0.00",
    "sw-CD": "\xa4\xa0#,##0.00",
    "sw-KE": "\xa4\xa0#,##0.00",
    "sw-UG": "\xa4\xa0#,##0.00",
    ta: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ta-LK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ta-MY": "\xa4#,##0.00;(\xa4#,##0.00)",
    "ta-SG": "\xa4#,##0.00;(\xa4#,##0.00)",
    te: "\xa4#,##0.00;(\xa4#,##0.00)",
    teo: "\xa4#,##0.00;(\xa4#,##0.00)",
    "teo-KE": "\xa4#,##0.00;(\xa4#,##0.00)",
    tg: "#,##0.00\xa0\xa4",
    th: "\xa4#,##0.00;(\xa4#,##0.00)",
    ti: "\xa4#,##0.00",
    "ti-ER": "\xa4#,##0.00",
    tk: "#,##0.00\xa0\xa4",
    to: "\xa4\xa0#,##0.00",
    tr: "\xa4#,##0.00;(\xa4#,##0.00)",
    "tr-CY": "\xa4#,##0.00;(\xa4#,##0.00)",
    tt: "#,##0.00\xa0\xa4",
    twq: "#,##0.00\xa4",
    tzm: "#,##0.00\xa0\xa4",
    ug: "\xa4#,##0.00;(\xa4#,##0.00)",
    uk: "#,##0.00\xa0\xa4",
    ur: "\xa4#,##0.00;(\xa4#,##0.00)",
    "ur-IN": "\xa4#,##0.00;(\xa4#,##0.00)",
    uz: "#,##0.00\xa0\xa4",
    "uz-Arab": "\xa4\xa0#,##0.00",
    "uz-Cyrl": "#,##0.00\xa0\xa4",
    "uz-Latn": "#,##0.00\xa0\xa4",
    vai: "\xa4#,##0.00;(\xa4#,##0.00)",
    "vai-Latn": "\xa4#,##0.00;(\xa4#,##0.00)",
    "vai-Vaii": "\xa4#,##0.00;(\xa4#,##0.00)",
    vi: "#,##0.00\xa0\xa4",
    vo: "\xa4\xa0#,##0.00",
    vun: "\xa4#,##0.00",
    wae: "\xa4\xa0#,##0.00",
    wo: "\xa4\xa0#,##0.00",
    xh: "\xa4#,##0.00",
    xog: "#,##0.00\xa0\xa4",
    yav: "#,##0.00\xa0\xa4;(#,##0.00\xa0\xa4)",
    yi: "\xa4\xa0#,##0.00",
    yo: "\xa4#,##0.00;(\xa4#,##0.00)",
    "yo-BJ": "\xa4#,##0.00;(\xa4#,##0.00)",
    yue: "\xa4#,##0.00;(\xa4#,##0.00)",
    "yue-Hans": "\xa4#,##0.00;(\xa4#,##0.00)",
    "yue-Hant": "\xa4#,##0.00;(\xa4#,##0.00)",
    zgh: "#,##0.00\xa4",
    zh: "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hans": "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hans-HK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hans-MO": "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hans-SG": "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hant": "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hant-HK": "\xa4#,##0.00;(\xa4#,##0.00)",
    "zh-Hant-MO": "\xa4#,##0.00;(\xa4#,##0.00)",
    zu: "\xa4#,##0.00;(\xa4#,##0.00)"
};

});



parcelRegister("cnVbh", function(module, exports) {
/**
 * DevExtreme (localization/message.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $9043fcf4476bdd13$var$_renderer2 = $9043fcf4476bdd13$var$_interopRequireDefault($jFnCG);

var $6LNcw = parcelRequire("6LNcw");
var $9043fcf4476bdd13$var$_dependency_injector2 = $9043fcf4476bdd13$var$_interopRequireDefault($6LNcw);

var $7I8Uw = parcelRequire("7I8Uw");

var $4Pwuy = parcelRequire("4Pwuy");

var $ksvsU = parcelRequire("ksvsU");

var $ih7fv = parcelRequire("ih7fv");

var $gCA0F = parcelRequire("gCA0F");
var $9043fcf4476bdd13$var$_core2 = $9043fcf4476bdd13$var$_interopRequireDefault($gCA0F);

var $etmiG = parcelRequire("etmiG");
var $9043fcf4476bdd13$var$_default_messages2 = $9043fcf4476bdd13$var$_interopRequireDefault($etmiG);
function $9043fcf4476bdd13$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $9043fcf4476bdd13$var$baseDictionary = (0, $7I8Uw.extend)(true, {}, $9043fcf4476bdd13$var$_default_messages2.default);
var $9043fcf4476bdd13$var$getDataByLocale = function(localeData, locale) {
    return localeData[locale] || {};
};
var $9043fcf4476bdd13$var$newMessages = {};
var $9043fcf4476bdd13$var$messageLocalization = (0, $9043fcf4476bdd13$var$_dependency_injector2.default)({
    engine: function() {
        return "base";
    },
    _dictionary: $9043fcf4476bdd13$var$baseDictionary,
    load: function(messages) {
        (0, $7I8Uw.extend)(true, this._dictionary, messages);
    },
    _localizablePrefix: "@",
    setup: function(localizablePrefix) {
        this._localizablePrefix = localizablePrefix;
    },
    localizeString: function(text) {
        var that = this;
        var regex = new RegExp("(^|[^a-zA-Z_0-9" + that._localizablePrefix + "-]+)(" + that._localizablePrefix + "{1,2})([a-zA-Z_0-9-]+)", "g");
        var escapeString = that._localizablePrefix + that._localizablePrefix;
        return text.replace(regex, function(str, prefix, escape, localizationKey) {
            var defaultResult = that._localizablePrefix + localizationKey;
            var result;
            if (escape !== escapeString) result = that.format(localizationKey);
            if (!result) $9043fcf4476bdd13$var$newMessages[localizationKey] = (0, $ih7fv.humanize)(localizationKey);
            return prefix + (result || defaultResult);
        });
    },
    localizeNode: function(node) {
        var that = this;
        (0, $9043fcf4476bdd13$var$_renderer2.default)(node).each(function(index, nodeItem) {
            if (!nodeItem.nodeType) return;
            if (3 === nodeItem.nodeType) nodeItem.nodeValue = that.localizeString(nodeItem.nodeValue);
            else if (!(0, $9043fcf4476bdd13$var$_renderer2.default)(nodeItem).is("iframe")) {
                (0, $4Pwuy.each)(nodeItem.attributes || [], function(index, attr) {
                    if ("string" === typeof attr.value) {
                        var localizedValue = that.localizeString(attr.value);
                        if (attr.value !== localizedValue) attr.value = localizedValue;
                    }
                });
                (0, $9043fcf4476bdd13$var$_renderer2.default)(nodeItem).contents().each(function(index, node) {
                    that.localizeNode(node);
                });
            }
        });
    },
    getMessagesByLocales: function() {
        return this._dictionary;
    },
    getDictionary: function(onlyNew) {
        if (onlyNew) return $9043fcf4476bdd13$var$newMessages;
        return (0, $7I8Uw.extend)({}, $9043fcf4476bdd13$var$newMessages, this.getMessagesByLocales()[$9043fcf4476bdd13$var$_core2.default.locale()]);
    },
    getFormatter: function(key) {
        return this._getFormatterBase(key) || this._getFormatterBase(key, "en");
    },
    _getFormatterBase: function(key, locale) {
        var _this = this;
        var message = $9043fcf4476bdd13$var$_core2.default.getValueByClosestLocale(function(locale) {
            return $9043fcf4476bdd13$var$getDataByLocale(_this._dictionary, locale)[key];
        });
        if (message) return function() {
            var args = 1 === arguments.length && Array.isArray(arguments[0]) ? arguments[0].slice(0) : Array.prototype.slice.call(arguments, 0);
            args.unshift(message);
            return $ksvsU.format.apply(this, args);
        };
    },
    format: function(key) {
        var formatter = this.getFormatter(key);
        var values = Array.prototype.slice.call(arguments, 1);
        return formatter && formatter.apply(this, values) || "";
    }
});
module.exports = $9043fcf4476bdd13$var$messageLocalization;

});
parcelRegister("etmiG", function(module, exports) {
/**
 * DevExtreme (localization/default_messages.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
module.exports = {
    en: {
        Yes: "Yes",
        No: "No",
        Cancel: "Cancel",
        Clear: "Clear",
        Done: "Done",
        Loading: "Loading...",
        Select: "Select...",
        Search: "Search",
        Back: "Back",
        OK: "OK",
        "dxCollectionWidget-noDataText": "No data to display",
        "dxDropDownEditor-selectLabel": "Select",
        "validation-required": "Required",
        "validation-required-formatted": "{0} is required",
        "validation-numeric": "Value must be a number",
        "validation-numeric-formatted": "{0} must be a number",
        "validation-range": "Value is out of range",
        "validation-range-formatted": "{0} is out of range",
        "validation-stringLength": "The length of the value is not correct",
        "validation-stringLength-formatted": "The length of {0} is not correct",
        "validation-custom": "Value is invalid",
        "validation-custom-formatted": "{0} is invalid",
        "validation-async": "Value is invalid",
        "validation-async-formatted": "{0} is invalid",
        "validation-compare": "Values do not match",
        "validation-compare-formatted": "{0} does not match",
        "validation-pattern": "Value does not match pattern",
        "validation-pattern-formatted": "{0} does not match pattern",
        "validation-email": "Email is invalid",
        "validation-email-formatted": "{0} is invalid",
        "validation-mask": "Value is invalid",
        "dxLookup-searchPlaceholder": "Minimum character number: {0}",
        "dxList-pullingDownText": "Pull down to refresh...",
        "dxList-pulledDownText": "Release to refresh...",
        "dxList-refreshingText": "Refreshing...",
        "dxList-pageLoadingText": "Loading...",
        "dxList-nextButtonText": "More",
        "dxList-selectAll": "Select All",
        "dxListEditDecorator-delete": "Delete",
        "dxListEditDecorator-more": "More",
        "dxScrollView-pullingDownText": "Pull down to refresh...",
        "dxScrollView-pulledDownText": "Release to refresh...",
        "dxScrollView-refreshingText": "Refreshing...",
        "dxScrollView-reachBottomText": "Loading...",
        "dxDateBox-simulatedDataPickerTitleTime": "Select time",
        "dxDateBox-simulatedDataPickerTitleDate": "Select date",
        "dxDateBox-simulatedDataPickerTitleDateTime": "Select date and time",
        "dxDateBox-validation-datetime": "Value must be a date or time",
        "dxFileUploader-selectFile": "Select file",
        "dxFileUploader-dropFile": "or Drop file here",
        "dxFileUploader-bytes": "bytes",
        "dxFileUploader-kb": "kb",
        "dxFileUploader-Mb": "Mb",
        "dxFileUploader-Gb": "Gb",
        "dxFileUploader-upload": "Upload",
        "dxFileUploader-uploaded": "Uploaded",
        "dxFileUploader-readyToUpload": "Ready to upload",
        "dxFileUploader-uploadFailedMessage": "Upload failed",
        "dxFileUploader-invalidFileExtension": "File type is not allowed",
        "dxFileUploader-invalidMaxFileSize": "File is too large",
        "dxFileUploader-invalidMinFileSize": "File is too small",
        "dxRangeSlider-ariaFrom": "From",
        "dxRangeSlider-ariaTill": "Till",
        "dxSwitch-switchedOnText": "ON",
        "dxSwitch-switchedOffText": "OFF",
        "dxForm-optionalMark": "optional",
        "dxForm-requiredMessage": "{0} is required",
        "dxNumberBox-invalidValueMessage": "Value must be a number",
        "dxNumberBox-noDataText": "No data",
        "dxDataGrid-columnChooserTitle": "Column Chooser",
        "dxDataGrid-columnChooserEmptyText": "Drag a column here to hide it",
        "dxDataGrid-groupContinuesMessage": "Continues on the next page",
        "dxDataGrid-groupContinuedMessage": "Continued from the previous page",
        "dxDataGrid-groupHeaderText": "Group by This Column",
        "dxDataGrid-ungroupHeaderText": "Ungroup",
        "dxDataGrid-ungroupAllText": "Ungroup All",
        "dxDataGrid-editingEditRow": "Edit",
        "dxDataGrid-editingSaveRowChanges": "Save",
        "dxDataGrid-editingCancelRowChanges": "Cancel",
        "dxDataGrid-editingDeleteRow": "Delete",
        "dxDataGrid-editingUndeleteRow": "Undelete",
        "dxDataGrid-editingConfirmDeleteMessage": "Are you sure you want to delete this record?",
        "dxDataGrid-validationCancelChanges": "Cancel changes",
        "dxDataGrid-groupPanelEmptyText": "Drag a column header here to group by that column",
        "dxDataGrid-noDataText": "No data",
        "dxDataGrid-searchPanelPlaceholder": "Search...",
        "dxDataGrid-filterRowShowAllText": "(All)",
        "dxDataGrid-filterRowResetOperationText": "Reset",
        "dxDataGrid-filterRowOperationEquals": "Equals",
        "dxDataGrid-filterRowOperationNotEquals": "Does not equal",
        "dxDataGrid-filterRowOperationLess": "Less than",
        "dxDataGrid-filterRowOperationLessOrEquals": "Less than or equal to",
        "dxDataGrid-filterRowOperationGreater": "Greater than",
        "dxDataGrid-filterRowOperationGreaterOrEquals": "Greater than or equal to",
        "dxDataGrid-filterRowOperationStartsWith": "Starts with",
        "dxDataGrid-filterRowOperationContains": "Contains",
        "dxDataGrid-filterRowOperationNotContains": "Does not contain",
        "dxDataGrid-filterRowOperationEndsWith": "Ends with",
        "dxDataGrid-filterRowOperationBetween": "Between",
        "dxDataGrid-filterRowOperationBetweenStartText": "Start",
        "dxDataGrid-filterRowOperationBetweenEndText": "End",
        "dxDataGrid-applyFilterText": "Apply filter",
        "dxDataGrid-trueText": "true",
        "dxDataGrid-falseText": "false",
        "dxDataGrid-sortingAscendingText": "Sort Ascending",
        "dxDataGrid-sortingDescendingText": "Sort Descending",
        "dxDataGrid-sortingClearText": "Clear Sorting",
        "dxDataGrid-editingSaveAllChanges": "Save changes",
        "dxDataGrid-editingCancelAllChanges": "Discard changes",
        "dxDataGrid-editingAddRow": "Add a row",
        "dxDataGrid-summaryMin": "Min: {0}",
        "dxDataGrid-summaryMinOtherColumn": "Min of {1} is {0}",
        "dxDataGrid-summaryMax": "Max: {0}",
        "dxDataGrid-summaryMaxOtherColumn": "Max of {1} is {0}",
        "dxDataGrid-summaryAvg": "Avg: {0}",
        "dxDataGrid-summaryAvgOtherColumn": "Avg of {1} is {0}",
        "dxDataGrid-summarySum": "Sum: {0}",
        "dxDataGrid-summarySumOtherColumn": "Sum of {1} is {0}",
        "dxDataGrid-summaryCount": "Count: {0}",
        "dxDataGrid-columnFixingFix": "Fix",
        "dxDataGrid-columnFixingUnfix": "Unfix",
        "dxDataGrid-columnFixingLeftPosition": "To the left",
        "dxDataGrid-columnFixingRightPosition": "To the right",
        "dxDataGrid-exportTo": "Export",
        "dxDataGrid-exportToExcel": "Export to Excel file",
        "dxDataGrid-exporting": "Exporting...",
        "dxDataGrid-excelFormat": "Excel file",
        "dxDataGrid-selectedRows": "Selected rows",
        "dxDataGrid-exportSelectedRows": "Export selected rows",
        "dxDataGrid-exportAll": "Export all data",
        "dxDataGrid-headerFilterEmptyValue": "(Blanks)",
        "dxDataGrid-headerFilterOK": "OK",
        "dxDataGrid-headerFilterCancel": "Cancel",
        "dxDataGrid-ariaColumn": "Column",
        "dxDataGrid-ariaValue": "Value",
        "dxDataGrid-ariaFilterCell": "Filter cell",
        "dxDataGrid-ariaCollapse": "Collapse",
        "dxDataGrid-ariaExpand": "Expand",
        "dxDataGrid-ariaDataGrid": "Data grid",
        "dxDataGrid-ariaSearchInGrid": "Search in data grid",
        "dxDataGrid-ariaSelectAll": "Select all",
        "dxDataGrid-ariaSelectRow": "Select row",
        "dxDataGrid-filterBuilderPopupTitle": "Filter Builder",
        "dxDataGrid-filterPanelCreateFilter": "Create Filter",
        "dxDataGrid-filterPanelClearFilter": "Clear",
        "dxDataGrid-filterPanelFilterEnabledHint": "Enable the filter",
        "dxTreeList-ariaTreeList": "Tree list",
        "dxTreeList-editingAddRowToNode": "Add",
        "dxPager-infoText": "Page {0} of {1} ({2} items)",
        "dxPager-pagesCountText": "of",
        "dxPivotGrid-grandTotal": "Grand Total",
        "dxPivotGrid-total": "{0} Total",
        "dxPivotGrid-fieldChooserTitle": "Field Chooser",
        "dxPivotGrid-showFieldChooser": "Show Field Chooser",
        "dxPivotGrid-expandAll": "Expand All",
        "dxPivotGrid-collapseAll": "Collapse All",
        "dxPivotGrid-sortColumnBySummary": 'Sort "{0}" by This Column',
        "dxPivotGrid-sortRowBySummary": 'Sort "{0}" by This Row',
        "dxPivotGrid-removeAllSorting": "Remove All Sorting",
        "dxPivotGrid-dataNotAvailable": "N/A",
        "dxPivotGrid-rowFields": "Row Fields",
        "dxPivotGrid-columnFields": "Column Fields",
        "dxPivotGrid-dataFields": "Data Fields",
        "dxPivotGrid-filterFields": "Filter Fields",
        "dxPivotGrid-allFields": "All Fields",
        "dxPivotGrid-columnFieldArea": "Drop Column Fields Here",
        "dxPivotGrid-dataFieldArea": "Drop Data Fields Here",
        "dxPivotGrid-rowFieldArea": "Drop Row Fields Here",
        "dxPivotGrid-filterFieldArea": "Drop Filter Fields Here",
        "dxScheduler-editorLabelTitle": "Subject",
        "dxScheduler-editorLabelStartDate": "Start Date",
        "dxScheduler-editorLabelEndDate": "End Date",
        "dxScheduler-editorLabelDescription": "Description",
        "dxScheduler-editorLabelRecurrence": "Repeat",
        "dxScheduler-openAppointment": "Open appointment",
        "dxScheduler-recurrenceNever": "Never",
        "dxScheduler-recurrenceDaily": "Daily",
        "dxScheduler-recurrenceWeekly": "Weekly",
        "dxScheduler-recurrenceMonthly": "Monthly",
        "dxScheduler-recurrenceYearly": "Yearly",
        "dxScheduler-recurrenceRepeatEvery": "Repeat Every",
        "dxScheduler-recurrenceRepeatOn": "Repeat On",
        "dxScheduler-recurrenceEnd": "End repeat",
        "dxScheduler-recurrenceAfter": "After",
        "dxScheduler-recurrenceOn": "On",
        "dxScheduler-recurrenceRepeatDaily": "day(s)",
        "dxScheduler-recurrenceRepeatWeekly": "week(s)",
        "dxScheduler-recurrenceRepeatMonthly": "month(s)",
        "dxScheduler-recurrenceRepeatYearly": "year(s)",
        "dxScheduler-switcherDay": "Day",
        "dxScheduler-switcherWeek": "Week",
        "dxScheduler-switcherWorkWeek": "Work Week",
        "dxScheduler-switcherMonth": "Month",
        "dxScheduler-switcherAgenda": "Agenda",
        "dxScheduler-switcherTimelineDay": "Timeline Day",
        "dxScheduler-switcherTimelineWeek": "Timeline Week",
        "dxScheduler-switcherTimelineWorkWeek": "Timeline Work Week",
        "dxScheduler-switcherTimelineMonth": "Timeline Month",
        "dxScheduler-recurrenceRepeatOnDate": "on date",
        "dxScheduler-recurrenceRepeatCount": "occurrence(s)",
        "dxScheduler-allDay": "All day",
        "dxScheduler-confirmRecurrenceEditMessage": "Do you want to edit only this appointment or the whole series?",
        "dxScheduler-confirmRecurrenceDeleteMessage": "Do you want to delete only this appointment or the whole series?",
        "dxScheduler-confirmRecurrenceEditSeries": "Edit series",
        "dxScheduler-confirmRecurrenceDeleteSeries": "Delete series",
        "dxScheduler-confirmRecurrenceEditOccurrence": "Edit appointment",
        "dxScheduler-confirmRecurrenceDeleteOccurrence": "Delete appointment",
        "dxScheduler-noTimezoneTitle": "No timezone",
        "dxScheduler-moreAppointments": "{0} more",
        "dxCalendar-todayButtonText": "Today",
        "dxCalendar-ariaWidgetName": "Calendar",
        "dxColorView-ariaRed": "Red",
        "dxColorView-ariaGreen": "Green",
        "dxColorView-ariaBlue": "Blue",
        "dxColorView-ariaAlpha": "Transparency",
        "dxColorView-ariaHex": "Color code",
        "dxTagBox-selected": "{0} selected",
        "dxTagBox-allSelected": "All selected ({0})",
        "dxTagBox-moreSelected": "{0} more",
        "vizExport-printingButtonText": "Print",
        "vizExport-titleMenuText": "Exporting/Printing",
        "vizExport-exportButtonText": "{0} file",
        "dxFilterBuilder-and": "And",
        "dxFilterBuilder-or": "Or",
        "dxFilterBuilder-notAnd": "Not And",
        "dxFilterBuilder-notOr": "Not Or",
        "dxFilterBuilder-addCondition": "Add Condition",
        "dxFilterBuilder-addGroup": "Add Group",
        "dxFilterBuilder-enterValueText": "<enter a value>",
        "dxFilterBuilder-filterOperationEquals": "Equals",
        "dxFilterBuilder-filterOperationNotEquals": "Does not equal",
        "dxFilterBuilder-filterOperationLess": "Is less than",
        "dxFilterBuilder-filterOperationLessOrEquals": "Is less than or equal to",
        "dxFilterBuilder-filterOperationGreater": "Is greater than",
        "dxFilterBuilder-filterOperationGreaterOrEquals": "Is greater than or equal to",
        "dxFilterBuilder-filterOperationStartsWith": "Starts with",
        "dxFilterBuilder-filterOperationContains": "Contains",
        "dxFilterBuilder-filterOperationNotContains": "Does not contain",
        "dxFilterBuilder-filterOperationEndsWith": "Ends with",
        "dxFilterBuilder-filterOperationIsBlank": "Is blank",
        "dxFilterBuilder-filterOperationIsNotBlank": "Is not blank",
        "dxFilterBuilder-filterOperationBetween": "Is between",
        "dxFilterBuilder-filterOperationAnyOf": "Is any of",
        "dxFilterBuilder-filterOperationNoneOf": "Is none of",
        "dxHtmlEditor-dialogColorCaption": "Change Font Color",
        "dxHtmlEditor-dialogBackgroundCaption": "Change Background Color",
        "dxHtmlEditor-dialogLinkCaption": "Add Link",
        "dxHtmlEditor-dialogLinkUrlField": "URL",
        "dxHtmlEditor-dialogLinkTextField": "Text",
        "dxHtmlEditor-dialogLinkTargetField": "Open link in new window",
        "dxHtmlEditor-dialogImageCaption": "Add Image",
        "dxHtmlEditor-dialogImageUrlField": "URL",
        "dxHtmlEditor-dialogImageAltField": "Alternate text",
        "dxHtmlEditor-dialogImageWidthField": "Width (px)",
        "dxHtmlEditor-dialogImageHeightField": "Height (px)",
        "dxHtmlEditor-heading": "Heading",
        "dxHtmlEditor-normalText": "Normal text",
        "dxFileManager-newDirectoryName": "Untitled directory",
        "dxFileManager-rootDirectoryName": "Files",
        "dxFileManager-errorNoAccess": "Access denied. The operation cannot be completed.",
        "dxFileManager-errorDirectoryExistsFormat": "Directory '{0}' already exists.",
        "dxFileManager-errorFileExistsFormat": "File '{0}' already exists.",
        "dxFileManager-errorFileNotFoundFormat": "File '{0}' not found.",
        "dxFileManager-errorDirectoryNotFoundFormat": "Directory '{0}' not found.",
        "dxFileManager-errorWrongFileExtension": "File extension is not allowed.",
        "dxFileManager-errorMaxFileSizeExceeded": "File size exceeds the maximum allowed size.",
        "dxFileManager-errorInvalidSymbols": "This name contains invalid characters.",
        "dxFileManager-errorDefault": "Unspecified error.",
        "dxFileManager-commandCreate": "New directory",
        "dxFileManager-commandRename": "Rename",
        "dxFileManager-commandMove": "Move",
        "dxFileManager-commandCopy": "Copy",
        "dxFileManager-commandDelete": "Delete",
        "dxFileManager-commandDownload": "Download",
        "dxFileManager-commandUpload": "Upload files",
        "dxFileManager-commandRefresh": "Refresh",
        "dxFileManager-commandThumbnails": "Thumbnails View",
        "dxFileManager-commandDetails": "Details View",
        "dxFileManager-commandClear": "Clear selection",
        "dxFileManager-dialogDirectoryChooserTitle": "Select Destination Directory",
        "dxFileManager-dialogDirectoryChooserButtonText": "Select",
        "dxFileManager-dialogRenameItemTitle": "Rename",
        "dxFileManager-dialogRenameItemButtonText": "Save",
        "dxFileManager-dialogCreateDirectoryTitle": "New directory",
        "dxFileManager-dialogCreateDirectoryButtonText": "Create",
        "dxFileManager-editingCreateSingleItemProcessingMessage": "Creating a directory inside {0}",
        "dxFileManager-editingCreateSingleItemSuccessMessage": "Created a directory inside {0}",
        "dxFileManager-editingCreateSingleItemErrorMessage": "Directory wasn't created",
        "dxFileManager-editingCreateCommonErrorMessage": "Directory wasn't created",
        "dxFileManager-editingRenameSingleItemProcessingMessage": "Renaming an item inside {0}",
        "dxFileManager-editingRenameSingleItemSuccessMessage": "Renamed an item inside {0}",
        "dxFileManager-editingRenameSingleItemErrorMessage": "Item wasn't renamed",
        "dxFileManager-editingRenameCommonErrorMessage": "Item wasn't renamed",
        "dxFileManager-editingDeleteSingleItemProcessingMessage": "Deleting an item from {0}",
        "dxFileManager-editingDeleteMultipleItemsProcessingMessage": "Deleting {0} items from {1}",
        "dxFileManager-editingDeleteSingleItemSuccessMessage": "Deleted an item from {0}",
        "dxFileManager-editingDeleteMultipleItemsSuccessMessage": "Deleted {0} items from {1}",
        "dxFileManager-editingDeleteSingleItemErrorMessage": "Item wasn't deleted",
        "dxFileManager-editingDeleteMultipleItemsErrorMessage": "{0} items weren't deleted",
        "dxFileManager-editingDeleteCommonErrorMessage": "Some items weren't deleted",
        "dxFileManager-editingMoveSingleItemProcessingMessage": "Moving an item to {0}",
        "dxFileManager-editingMoveMultipleItemsProcessingMessage": "Moving {0} items to {1}",
        "dxFileManager-editingMoveSingleItemSuccessMessage": "Moved an item to {0}",
        "dxFileManager-editingMoveMultipleItemsSuccessMessage": "Moved {0} items to {1}",
        "dxFileManager-editingMoveSingleItemErrorMessage": "Item wasn't moved",
        "dxFileManager-editingMoveMultipleItemsErrorMessage": "{0} items weren't moved",
        "dxFileManager-editingMoveCommonErrorMessage": "Some items weren't moved",
        "dxFileManager-editingCopySingleItemProcessingMessage": "Copying an item to {0}",
        "dxFileManager-editingCopyMultipleItemsProcessingMessage": "Copying {0} items to {1}",
        "dxFileManager-editingCopySingleItemSuccessMessage": "Copied an item to {0}",
        "dxFileManager-editingCopyMultipleItemsSuccessMessage": "Copied {0} items to {1}",
        "dxFileManager-editingCopySingleItemErrorMessage": "Item wasn't copied",
        "dxFileManager-editingCopyMultipleItemsErrorMessage": "{0} items weren't copied",
        "dxFileManager-editingCopyCommonErrorMessage": "Some items weren't copied",
        "dxFileManager-editingUploadSingleItemProcessingMessage": "Uploading an item to {0}",
        "dxFileManager-editingUploadMultipleItemsProcessingMessage": "Uploading {0} items to {1}",
        "dxFileManager-editingUploadSingleItemSuccessMessage": "Uploaded an item to {0}",
        "dxFileManager-editingUploadMultipleItemsSuccessMessage": "Uploaded {0} items to {1}",
        "dxFileManager-editingUploadSingleItemErrorMessage": "Item wasn't uploaded",
        "dxFileManager-editingUploadMultipleItemsErrorMessage": "{0} items weren't uploaded",
        "dxFileManager-editingUploadCanceledMessage": "Canceled",
        "dxFileManager-listDetailsColumnCaptionName": "Name",
        "dxFileManager-listDetailsColumnCaptionDateModified": "Date Modified",
        "dxFileManager-listDetailsColumnCaptionFileSize": "File Size",
        "dxFileManager-listThumbnailsTooltipTextSize": "Size",
        "dxFileManager-listThumbnailsTooltipTextDateModified": "Date Modified",
        "dxFileManager-notificationProgressPanelTitle": "Progress",
        "dxFileManager-notificationProgressPanelEmptyListText": "No operations",
        "dxFileManager-notificationProgressPanelOperationCanceled": "Canceled",
        "dxDiagram-categoryGeneral": "General",
        "dxDiagram-categoryFlowchart": "Flowchart",
        "dxDiagram-categoryOrgChart": "Organizational Chart",
        "dxDiagram-categoryContainers": "Containers",
        "dxDiagram-categoryCustom": "Custom",
        "dxDiagram-commandProperties": "Properties",
        "dxDiagram-commandExport": "Export",
        "dxDiagram-commandExportToSvg": "Export to SVG",
        "dxDiagram-commandExportToPng": "Export to PNG",
        "dxDiagram-commandExportToJpg": "Export to JPEG",
        "dxDiagram-commandUndo": "Undo",
        "dxDiagram-commandRedo": "Redo",
        "dxDiagram-commandFontName": "Font Name",
        "dxDiagram-commandFontSize": "Font Size",
        "dxDiagram-commandBold": "Bold",
        "dxDiagram-commandItalic": "Italic",
        "dxDiagram-commandUnderline": "Underline",
        "dxDiagram-commandTextColor": "Text Color",
        "dxDiagram-commandLineColor": "Line Color",
        "dxDiagram-commandFillColor": "Fill Color",
        "dxDiagram-commandAlignLeft": "Align Left",
        "dxDiagram-commandAlignCenter": "Align Center",
        "dxDiagram-commandAlignRight": "Align Right",
        "dxDiagram-commandConnectorLineType": "Connector Line Type",
        "dxDiagram-commandConnectorLineStraight": "Straight",
        "dxDiagram-commandConnectorLineOrthogonal": "Orthogonal",
        "dxDiagram-commandConnectorLineStart": "Connector Line Start",
        "dxDiagram-commandConnectorLineEnd": "Connector Line End",
        "dxDiagram-commandConnectorLineNone": "None",
        "dxDiagram-commandConnectorLineArrow": "Arrow",
        "dxDiagram-commandAutoLayout": "Auto Layout",
        "dxDiagram-commandAutoLayoutTree": "Tree",
        "dxDiagram-commandAutoLayoutLayered": "Layered",
        "dxDiagram-commandAutoLayoutHorizontal": "Horizontal",
        "dxDiagram-commandAutoLayoutVertical": "Vertical",
        "dxDiagram-commandFullscreen": "Full Screen",
        "dxDiagram-commandUnits": "Units",
        "dxDiagram-commandPageSize": "Page Size",
        "dxDiagram-commandPageOrientation": "Page Orientation",
        "dxDiagram-commandPageOrientationLandscape": "Landscape",
        "dxDiagram-commandPageOrientationPortrait": "Portrait",
        "dxDiagram-commandPageColor": "Page Color",
        "dxDiagram-commandShowGrid": "Show Grid",
        "dxDiagram-commandSnapToGrid": "Snap to Grid",
        "dxDiagram-commandGridSize": "Grid Size",
        "dxDiagram-commandZoomLevel": "Zoom Level",
        "dxDiagram-commandAutoZoom": "Auto Zoom",
        "dxDiagram-commandSimpleView": "Simple View",
        "dxDiagram-commandCut": "Cut",
        "dxDiagram-commandCopy": "Copy",
        "dxDiagram-commandPaste": "Paste",
        "dxDiagram-commandSelectAll": "Select All",
        "dxDiagram-commandDelete": "Delete",
        "dxDiagram-commandBringToFront": "Bring to Front",
        "dxDiagram-commandSendToBack": "Send to Back",
        "dxDiagram-commandLock": "Lock",
        "dxDiagram-commandUnlock": "Unlock",
        "dxDiagram-commandInsertShapeImage": "Insert Image...",
        "dxDiagram-commandEditShapeImage": "Change Image...",
        "dxDiagram-commandDeleteShapeImage": "Delete Image",
        "dxDiagram-unitIn": "in",
        "dxDiagram-unitCm": "cm",
        "dxDiagram-unitPx": "px",
        "dxDiagram-dialogButtonOK": "OK",
        "dxDiagram-dialogButtonCancel": "Cancel",
        "dxDiagram-dialogInsertShapeImageTitle": "Insert Image",
        "dxDiagram-dialogEditShapeImageTitle": "Change Image",
        "dxDiagram-dialogEditShapeImageSelectButton": "Select image",
        "dxDiagram-dialogEditShapeImageLabelText": "or drop file here"
    }
};

});



parcelRegister("4gmvS", function(module, exports) {
/**
 * DevExtreme (ui/widget/ui.widget.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $e1LMc = parcelRequire("e1LMc");

var $jL4UV = parcelRequire("jL4UV");

var $7I8Uw = parcelRequire("7I8Uw");
var $31aa1eaf24b41f79$require$extend = $7I8Uw.extend;

var $aLQK5 = parcelRequire("aLQK5");
var $31aa1eaf24b41f79$require$inArray = $aLQK5.inArray;

var $4Pwuy = parcelRequire("4Pwuy");
var $31aa1eaf24b41f79$require$each = $4Pwuy.each;

var $2Mto0 = parcelRequire("2Mto0");

var $kDRxH = parcelRequire("kDRxH");

var $445Bz = parcelRequire("445Bz");

var $23OYU = parcelRequire("23OYU");

var $2ADoP = parcelRequire("2ADoP");

var $3joCJ = parcelRequire("3joCJ");

var $bXb2w = parcelRequire("bXb2w");

var $fbrwv = parcelRequire("fbrwv");

var $cNbaE = parcelRequire("cNbaE");

var $i7ZSP = parcelRequire("i7ZSP");
var $31aa1eaf24b41f79$var$UI_FEEDBACK = "UIFeedback";
var $31aa1eaf24b41f79$var$WIDGET_CLASS = "dx-widget";
var $31aa1eaf24b41f79$var$ACTIVE_STATE_CLASS = "dx-state-active";
var $31aa1eaf24b41f79$var$DISABLED_STATE_CLASS = "dx-state-disabled";
var $31aa1eaf24b41f79$var$INVISIBLE_STATE_CLASS = "dx-state-invisible";
var $31aa1eaf24b41f79$var$HOVER_STATE_CLASS = "dx-state-hover";
var $31aa1eaf24b41f79$var$FOCUSED_STATE_CLASS = "dx-state-focused";
var $31aa1eaf24b41f79$var$FEEDBACK_SHOW_TIMEOUT = 30;
var $31aa1eaf24b41f79$var$FEEDBACK_HIDE_TIMEOUT = 400;
var $31aa1eaf24b41f79$var$FOCUS_NAMESPACE = "Focus";
var $31aa1eaf24b41f79$var$Widget = $23OYU.inherit({
    _supportedKeys: function() {
        return {};
    },
    _getDefaultOptions: function() {
        return $31aa1eaf24b41f79$require$extend(this.callBase(), {
            disabled: false,
            visible: true,
            hint: void 0,
            activeStateEnabled: false,
            onContentReady: null,
            hoverStateEnabled: false,
            focusStateEnabled: false,
            tabIndex: 0,
            accessKey: null,
            onFocusIn: null,
            onFocusOut: null,
            _keyboardProcessor: void 0
        });
    },
    _feedbackShowTimeout: $31aa1eaf24b41f79$var$FEEDBACK_SHOW_TIMEOUT,
    _feedbackHideTimeout: $31aa1eaf24b41f79$var$FEEDBACK_HIDE_TIMEOUT,
    _init: function() {
        this.callBase();
        this._initContentReadyAction();
    },
    _clearInnerOptionCache: function(optionContainer) {
        this[optionContainer + "Cache"] = {};
    },
    _cacheInnerOptions: function(optionContainer, optionValue) {
        var cacheName = optionContainer + "Cache";
        this[cacheName] = $31aa1eaf24b41f79$require$extend(this[cacheName], optionValue);
    },
    _getOptionsFromContainer: function(_ref) {
        var name = _ref.name, fullName = _ref.fullName, value = _ref.value;
        var options = {};
        if (name === fullName) options = value;
        else {
            var option = fullName.split(".").pop();
            options[option] = value;
        }
        return options;
    },
    _innerOptionChanged: function(innerWidget, args) {
        var options = this._getOptionsFromContainer(args);
        innerWidget && innerWidget.option(options);
        this._cacheInnerOptions(args.name, options);
    },
    _getInnerOptionsCache: function(optionContainer) {
        return this[optionContainer + "Cache"];
    },
    _initInnerOptionCache: function(optionContainer) {
        this._clearInnerOptionCache(optionContainer);
        this._cacheInnerOptions(optionContainer, this.option(optionContainer));
    },
    _bindInnerWidgetOptions: function(innerWidget, optionsContainer) {
        this._options[optionsContainer] = $31aa1eaf24b41f79$require$extend({}, innerWidget.option());
        innerWidget.on("optionChanged", (function(e) {
            this._options[optionsContainer] = $31aa1eaf24b41f79$require$extend({}, e.component.option());
        }).bind(this));
    },
    _getAriaTarget: function() {
        return this._focusTarget();
    },
    _initContentReadyAction: function() {
        this._contentReadyAction = this._createActionByOption("onContentReady", {
            excludeValidators: [
                "disabled",
                "readOnly"
            ]
        });
    },
    _initMarkup: function() {
        this.$element().addClass($31aa1eaf24b41f79$var$WIDGET_CLASS);
        this._toggleDisabledState(this.option("disabled"));
        this._toggleVisibility(this.option("visible"));
        this._renderHint();
        if (this._isFocusable()) this._renderFocusTarget();
        this.callBase();
    },
    _render: function() {
        this.callBase();
        this._renderContent();
        this._renderFocusState();
        this._attachFeedbackEvents();
        this._attachHoverEvents();
    },
    _renderHint: function() {
        var hint = this.option("hint");
        this.$element().attr("title", hint ? hint : null);
    },
    _renderContent: function() {
        var _this = this;
        $2Mto0.deferRender(function() {
            if (_this._disposed) return;
            return _this._renderContentImpl();
        }).done(function() {
            if (_this._disposed) return;
            _this._fireContentReadyAction();
        });
    },
    _renderContentImpl: $2Mto0.noop,
    _fireContentReadyAction: $2Mto0.deferRenderer(function() {
        this._contentReadyAction();
    }),
    _dispose: function() {
        this._contentReadyAction = null;
        this.callBase();
    },
    _resetActiveState: function() {
        this._toggleActiveState(this._eventBindingTarget(), false);
    },
    _clean: function() {
        this._cleanFocusState();
        this._resetActiveState();
        this.callBase();
        this.$element().empty();
    },
    _toggleVisibility: function(visible) {
        this.$element().toggleClass($31aa1eaf24b41f79$var$INVISIBLE_STATE_CLASS, !visible);
        this.setAria("hidden", !visible || void 0);
    },
    _renderFocusState: function() {
        this._attachKeyboardEvents();
        if (!this._isFocusable()) return;
        this._renderFocusTarget();
        this._attachFocusEvents();
        this._renderAccessKey();
    },
    _renderAccessKey: function() {
        var focusTarget = this._focusTarget();
        focusTarget.attr("accesskey", this.option("accessKey"));
        var clickNamespace = $bXb2w.addNamespace($i7ZSP.name, $31aa1eaf24b41f79$var$UI_FEEDBACK);
        $e1LMc.off(focusTarget, clickNamespace);
        this.option("accessKey") && $e1LMc.on(focusTarget, clickNamespace, (function(e) {
            if ($bXb2w.isFakeClickEvent(e)) {
                e.stopImmediatePropagation();
                this.focus();
            }
        }).bind(this));
    },
    _isFocusable: function() {
        return this.option("focusStateEnabled") && !this.option("disabled");
    },
    _eventBindingTarget: function() {
        return this.$element();
    },
    _focusTarget: function() {
        return this._getActiveElement();
    },
    _getActiveElement: function() {
        var activeElement = this._eventBindingTarget();
        if (this._activeStateUnit) activeElement = activeElement.find(this._activeStateUnit).not("." + $31aa1eaf24b41f79$var$DISABLED_STATE_CLASS);
        return activeElement;
    },
    _renderFocusTarget: function() {
        this._focusTarget().attr("tabIndex", this.option("tabIndex"));
    },
    _keyboardEventBindingTarget: function() {
        return this._eventBindingTarget();
    },
    _detachFocusEvents: function() {
        var $element = this._focusEventTarget();
        var namespace = this.NAME + $31aa1eaf24b41f79$var$FOCUS_NAMESPACE;
        var focusEvents = $bXb2w.addNamespace("focusin", namespace);
        focusEvents = focusEvents + " " + $bXb2w.addNamespace("focusout", namespace);
        if ($445Bz.hasDocumentProperty("onbeforeactivate")) focusEvents = focusEvents + " " + $bXb2w.addNamespace("beforeactivate", namespace);
        $e1LMc.off($element, focusEvents);
    },
    _attachFocusEvents: function() {
        var namespace = this.NAME + $31aa1eaf24b41f79$var$FOCUS_NAMESPACE;
        var focusInEvent = $bXb2w.addNamespace("focusin", namespace);
        var focusOutEvent = $bXb2w.addNamespace("focusout", namespace);
        var $focusTarget = this._focusEventTarget();
        $e1LMc.on($focusTarget, focusInEvent, this._focusInHandler.bind(this));
        $e1LMc.on($focusTarget, focusOutEvent, this._focusOutHandler.bind(this));
        if ($445Bz.hasDocumentProperty("onbeforeactivate")) {
            var beforeActivateEvent = $bXb2w.addNamespace("beforeactivate", namespace);
            $e1LMc.on(this._focusEventTarget(), beforeActivateEvent, function(e) {
                if (!$jFnCG(e.target).is($3joCJ.focusable)) e.preventDefault();
            });
        }
    },
    _refreshFocusEvent: function() {
        this._detachFocusEvents();
        this._attachFocusEvents();
    },
    _focusEventTarget: function() {
        return this._focusTarget();
    },
    _focusInHandler: function(e) {
        if (e.isDefaultPrevented()) return;
        var that = this;
        that._createActionByOption("onFocusIn", {
            beforeExecute: function() {
                that._updateFocusState(e, true);
            },
            excludeValidators: [
                "readOnly"
            ]
        })({
            event: e
        });
    },
    _focusOutHandler: function(e) {
        if (e.isDefaultPrevented()) return;
        var that = this;
        that._createActionByOption("onFocusOut", {
            beforeExecute: function() {
                that._updateFocusState(e, false);
            },
            excludeValidators: [
                "readOnly",
                "disabled"
            ]
        })({
            event: e
        });
    },
    _updateFocusState: function(e, isFocused) {
        var target = e.target;
        if ($31aa1eaf24b41f79$require$inArray(target, this._focusTarget()) !== -1) this._toggleFocusClass(isFocused, $jFnCG(target));
    },
    _toggleFocusClass: function(isFocused, $element) {
        var $focusTarget = $element && $element.length ? $element : this._focusTarget();
        $focusTarget.toggleClass($31aa1eaf24b41f79$var$FOCUSED_STATE_CLASS, isFocused);
    },
    _hasFocusClass: function(element) {
        var $focusTarget = $jFnCG(element || this._focusTarget());
        return $focusTarget.hasClass($31aa1eaf24b41f79$var$FOCUSED_STATE_CLASS);
    },
    _isFocused: function() {
        return this._hasFocusClass();
    },
    _attachKeyboardEvents: function() {
        var processor = this.option("_keyboardProcessor");
        if (processor) this._keyboardProcessor = processor.reinitialize(this._keyboardHandler, this);
        else if (this.option("focusStateEnabled")) {
            this._disposeKeyboardProcessor();
            this._keyboardProcessor = new $2ADoP({
                element: this._keyboardEventBindingTarget(),
                handler: this._keyboardHandler,
                focusTarget: this._focusTarget(),
                context: this
            });
        }
    },
    _keyboardHandler: function(options) {
        var e = options.originalEvent;
        var keyName = options.keyName;
        var keyCode = options.which;
        var keys = this._supportedKeys(e);
        var func = keys[keyName] || keys[keyCode];
        if (void 0 !== func) {
            var handler = func.bind(this);
            return handler(e) || false;
        } else return true;
    },
    _refreshFocusState: function() {
        this._cleanFocusState();
        this._renderFocusState();
    },
    _cleanFocusState: function() {
        var $element = this._focusTarget();
        this._detachFocusEvents();
        this._toggleFocusClass(false);
        $element.removeAttr("tabIndex");
        this._disposeKeyboardProcessor();
    },
    _disposeKeyboardProcessor: function() {
        if (this._keyboardProcessor) {
            this._keyboardProcessor.dispose();
            delete this._keyboardProcessor;
        }
    },
    _attachHoverEvents: function() {
        var that = this;
        var hoverableSelector = that._activeStateUnit;
        var nameStart = $bXb2w.addNamespace($fbrwv.start, $31aa1eaf24b41f79$var$UI_FEEDBACK);
        var nameEnd = $bXb2w.addNamespace($fbrwv.end, $31aa1eaf24b41f79$var$UI_FEEDBACK);
        $e1LMc.off(that._eventBindingTarget(), nameStart, hoverableSelector);
        $e1LMc.off(that._eventBindingTarget(), nameEnd, hoverableSelector);
        if (that.option("hoverStateEnabled")) {
            var startAction = new $jL4UV(function(args) {
                that._hoverStartHandler(args.event);
                that._refreshHoveredElement($jFnCG(args.element));
            }, {
                excludeValidators: [
                    "readOnly"
                ]
            });
            var $eventBindingTarget = that._eventBindingTarget();
            $e1LMc.on($eventBindingTarget, nameStart, hoverableSelector, function(e) {
                startAction.execute({
                    element: $jFnCG(e.target),
                    event: e
                });
            });
            $e1LMc.on($eventBindingTarget, nameEnd, hoverableSelector, function(e) {
                that._hoverEndHandler(e);
                that._forgetHoveredElement();
            });
        } else that._toggleHoverClass(false);
    },
    _hoverStartHandler: $2Mto0.noop,
    _hoverEndHandler: $2Mto0.noop,
    _attachFeedbackEvents: function() {
        var that = this;
        var feedbackSelector = that._activeStateUnit;
        var activeEventName = $bXb2w.addNamespace($cNbaE.active, $31aa1eaf24b41f79$var$UI_FEEDBACK);
        var inactiveEventName = $bXb2w.addNamespace($cNbaE.inactive, $31aa1eaf24b41f79$var$UI_FEEDBACK);
        var feedbackAction;
        var feedbackActionDisabled;
        $e1LMc.off(that._eventBindingTarget(), activeEventName, feedbackSelector);
        $e1LMc.off(that._eventBindingTarget(), inactiveEventName, feedbackSelector);
        if (that.option("activeStateEnabled")) {
            var feedbackActionHandler = function(args) {
                var $element = $jFnCG(args.element);
                var value = args.value;
                var dxEvent = args.event;
                that._toggleActiveState($element, value, dxEvent);
            };
            $e1LMc.on(that._eventBindingTarget(), activeEventName, feedbackSelector, {
                timeout: that._feedbackShowTimeout
            }, function(e) {
                feedbackAction = feedbackAction || new $jL4UV(feedbackActionHandler);
                feedbackAction.execute({
                    element: $jFnCG(e.currentTarget),
                    value: true,
                    event: e
                });
            });
            $e1LMc.on(that._eventBindingTarget(), inactiveEventName, feedbackSelector, {
                timeout: that._feedbackHideTimeout
            }, function(e) {
                feedbackActionDisabled = feedbackActionDisabled || new $jL4UV(feedbackActionHandler, {
                    excludeValidators: [
                        "disabled",
                        "readOnly"
                    ]
                });
                feedbackActionDisabled.execute({
                    element: $jFnCG(e.currentTarget),
                    value: false,
                    event: e
                });
            });
        }
    },
    _toggleActiveState: function($element, value) {
        this._toggleHoverClass(!value);
        $element.toggleClass($31aa1eaf24b41f79$var$ACTIVE_STATE_CLASS, value);
    },
    _refreshHoveredElement: function(hoveredElement) {
        var selector = this._activeStateUnit || this._eventBindingTarget();
        this._forgetHoveredElement();
        this._hoveredElement = hoveredElement.closest(selector);
        this._toggleHoverClass(true);
    },
    _forgetHoveredElement: function() {
        this._toggleHoverClass(false);
        delete this._hoveredElement;
    },
    _toggleHoverClass: function(value) {
        if (this._hoveredElement) this._hoveredElement.toggleClass($31aa1eaf24b41f79$var$HOVER_STATE_CLASS, value && this.option("hoverStateEnabled"));
    },
    _toggleDisabledState: function(value) {
        this.$element().toggleClass($31aa1eaf24b41f79$var$DISABLED_STATE_CLASS, Boolean(value));
        this._toggleHoverClass(!value);
        this.setAria("disabled", value || void 0);
    },
    _setWidgetOption: function(widgetName, args) {
        if (!this[widgetName]) return;
        if ($kDRxH.isPlainObject(args[0])) {
            $31aa1eaf24b41f79$require$each(args[0], (function(option, value) {
                this._setWidgetOption(widgetName, [
                    option,
                    value
                ]);
            }).bind(this));
            return;
        }
        var optionName = args[0];
        var value = args[1];
        if (1 === args.length) value = this.option(optionName);
        var widgetOptionMap = this[widgetName + "OptionMap"];
        this[widgetName].option(widgetOptionMap ? widgetOptionMap(optionName) : optionName, value);
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "disabled":
                this._toggleDisabledState(args.value);
                this._refreshFocusState();
                break;
            case "hint":
                this._renderHint();
                break;
            case "activeStateEnabled":
                this._attachFeedbackEvents();
                break;
            case "hoverStateEnabled":
                this._attachHoverEvents();
                break;
            case "tabIndex":
            case "_keyboardProcessor":
            case "focusStateEnabled":
                this._refreshFocusState();
                break;
            case "onFocusIn":
            case "onFocusOut":
                break;
            case "accessKey":
                this._renderAccessKey();
                break;
            case "visible":
                var visible = args.value;
                this._toggleVisibility(visible);
                if (this._isVisibilityChangeSupported()) this._checkVisibilityChanged(args.value ? "shown" : "hiding");
                break;
            case "onContentReady":
                this._initContentReadyAction();
                break;
            default:
                this.callBase(args);
        }
    },
    _isVisible: function() {
        return this.callBase() && this.option("visible");
    },
    beginUpdate: function() {
        this._ready(false);
        this.callBase();
    },
    endUpdate: function() {
        this.callBase();
        if (this._initialized) this._ready(true);
    },
    _ready: function(value) {
        if (0 === arguments.length) return this._isReady;
        this._isReady = value;
    },
    setAria: function() {
        var setAttribute = function(option) {
            var attrName = "role" === option.name || "id" === option.name ? option.name : "aria-" + option.name;
            var attrValue = option.value;
            if ($kDRxH.isDefined(attrValue)) attrValue = attrValue.toString();
            else attrValue = null;
            option.target.attr(attrName, attrValue);
        };
        if (!$kDRxH.isPlainObject(arguments[0])) setAttribute({
            name: arguments[0],
            value: arguments[1],
            target: arguments[2] || this._getAriaTarget()
        });
        else {
            var $target = arguments[1] || this._getAriaTarget();
            $31aa1eaf24b41f79$require$each(arguments[0], function(key, value) {
                setAttribute({
                    name: key,
                    value: value,
                    target: $target
                });
            });
        }
    },
    isReady: function() {
        return this._ready();
    },
    repaint: function() {
        this._refresh();
    },
    focus: function() {
        $e1LMc.trigger(this._focusTarget(), "focus");
    },
    registerKeyHandler: function(key, handler) {
        var currentKeys = this._supportedKeys();
        var addingKeys = {};
        addingKeys[key] = handler;
        this._supportedKeys = function() {
            return $31aa1eaf24b41f79$require$extend(currentKeys, addingKeys);
        };
    }
});
module.exports = $31aa1eaf24b41f79$var$Widget;

});
parcelRegister("jL4UV", function(module, exports) {
/**
 * DevExtreme (core/action.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $1JvXr = parcelRequire("1JvXr");

var $e62638932d012a33$var$window = (parcelRequire("irv64")).getWindow();

var $kDRxH = parcelRequire("kDRxH");

var $4Pwuy = parcelRequire("4Pwuy");
var $e62638932d012a33$require$each = $4Pwuy.each;

var $k7aJb = parcelRequire("k7aJb");

var $7sX7V = parcelRequire("7sX7V");
var $e62638932d012a33$var$Action = $k7aJb.inherit({
    ctor: function(action, config) {
        config = config || {};
        this._action = action;
        this._context = config.context || $e62638932d012a33$var$window;
        this._beforeExecute = config.beforeExecute;
        this._afterExecute = config.afterExecute;
        this._component = config.component;
        this._validatingTargetName = config.validatingTargetName;
        var excludeValidators = this._excludeValidators = {};
        if (config.excludeValidators) for(var i = 0; i < config.excludeValidators.length; i++)excludeValidators[config.excludeValidators[i]] = true;
    },
    execute: function() {
        var e = {
            action: this._action,
            args: Array.prototype.slice.call(arguments),
            context: this._context,
            component: this._component,
            validatingTargetName: this._validatingTargetName,
            cancel: false,
            handled: false
        };
        var beforeExecute = this._beforeExecute;
        var afterExecute = this._afterExecute;
        var argsBag = e.args[0] || {};
        if (!("jQueryEvent" in argsBag) && argsBag.event && $1JvXr().useJQuery) Object.defineProperty(argsBag, "jQueryEvent", {
            get: function() {
                $7sX7V.log("W0003", "Handler argument", "jQueryEvent", "17.2", "Use the 'event' field instead");
                return argsBag.event;
            },
            set: function(value) {
                $7sX7V.log("W0003", "Handler argument", "jQueryEvent", "17.2", "Use the 'event' field instead");
                argsBag.event = value;
            }
        });
        if (!this._validateAction(e)) return;
        beforeExecute && beforeExecute.call(this._context, e);
        if (e.cancel) return;
        var result = this._executeAction(e);
        if (argsBag.cancel) return;
        afterExecute && afterExecute.call(this._context, e);
        return result;
    },
    _validateAction: function(e) {
        var excludeValidators = this._excludeValidators;
        var executors = $e62638932d012a33$var$Action.executors;
        for(var name in executors)if (!excludeValidators[name]) {
            var executor = executors[name];
            if (executor.validate) executor.validate(e);
            if (e.cancel) return false;
        }
        return true;
    },
    _executeAction: function(e) {
        var result;
        var executors = $e62638932d012a33$var$Action.executors;
        for(var name in executors){
            var executor = executors[name];
            if (executor.execute) executor.execute(e);
            if (e.handled) {
                result = e.result;
                break;
            }
        }
        return result;
    }
});
$e62638932d012a33$var$Action.executors = {};
$e62638932d012a33$var$Action.registerExecutor = function(name, executor) {
    if ($kDRxH.isPlainObject(name)) {
        $e62638932d012a33$require$each(name, $e62638932d012a33$var$Action.registerExecutor);
        return;
    }
    $e62638932d012a33$var$Action.executors[name] = executor;
};
$e62638932d012a33$var$Action.unregisterExecutor = function() {
    var args = [].slice.call(arguments);
    $e62638932d012a33$require$each(args, function() {
        delete $e62638932d012a33$var$Action.executors[this];
    });
};
$e62638932d012a33$var$Action.registerExecutor({
    undefined: {
        execute: function(e) {
            if (!e.action) {
                e.result = void 0;
                e.handled = true;
            }
        }
    },
    func: {
        execute: function(e) {
            if ($kDRxH.isFunction(e.action)) {
                e.result = e.action.call(e.context, e.args[0]);
                e.handled = true;
            }
        }
    }
});
var $e62638932d012a33$var$createValidatorByTargetElement = function(condition) {
    return function(e) {
        if (!e.args.length) return;
        var args = e.args[0];
        var element = args[e.validatingTargetName] || args.element;
        if (element && condition($jFnCG(element))) e.cancel = true;
    };
};
$e62638932d012a33$var$Action.registerExecutor({
    disabled: {
        validate: $e62638932d012a33$var$createValidatorByTargetElement(function($target) {
            return $target.is(".dx-state-disabled, .dx-state-disabled *");
        })
    },
    readOnly: {
        validate: $e62638932d012a33$var$createValidatorByTargetElement(function($target) {
            return $target.is(".dx-state-readonly, .dx-state-readonly *");
        })
    }
});
module.exports = $e62638932d012a33$var$Action;

});

parcelRegister("23OYU", function(module, exports) {
/**
 * DevExtreme (core/dom_component_with_template.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $18036872a78cb2cb$var$_renderer2 = $18036872a78cb2cb$var$_interopRequireDefault($jFnCG);

var $kDRxH = parcelRequire("kDRxH");

var $2Mto0 = parcelRequire("2Mto0");

var $7I8Uw = parcelRequire("7I8Uw");

var $7sX7V = parcelRequire("7sX7V");

var $5OzEX = parcelRequire("5OzEX");

var $aiwte = parcelRequire("aiwte");
var $18036872a78cb2cb$var$_devices2 = $18036872a78cb2cb$var$_interopRequireDefault($aiwte);

var $4sKC1 = parcelRequire("4sKC1");
var $18036872a78cb2cb$var$_dom_component2 = $18036872a78cb2cb$var$_interopRequireDefault($4sKC1);

var $gqK38 = parcelRequire("gqK38");

var $9tMwv = parcelRequire("9tMwv");

var $kqsMi = parcelRequire("kqsMi");

var $e5a0x = parcelRequire("e5a0x");

var $4dqlD = parcelRequire("4dqlD");

var $ih7fv = parcelRequire("ih7fv");
function $18036872a78cb2cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $18036872a78cb2cb$var$TEXT_NODE = 3;
var $18036872a78cb2cb$var$ANONYMOUS_TEMPLATE_NAME = "template";
var $18036872a78cb2cb$var$TEMPLATE_SELECTOR = "[data-options*='dxTemplate']";
var $18036872a78cb2cb$var$TEMPLATE_WRAPPER_CLASS = "dx-template-wrapper";
var $18036872a78cb2cb$var$DX_POLYMORPH_WIDGET_TEMPLATE = new $kqsMi.FunctionTemplate(function(options) {
    var widgetName = options.model.widget;
    if (widgetName) {
        var widgetElement = (0, $18036872a78cb2cb$var$_renderer2.default)("<div>");
        var widgetOptions = options.model.options || {};
        if ("button" === widgetName || "tabs" === widgetName || "dropDownMenu" === widgetName) {
            var deprecatedName = widgetName;
            widgetName = (0, $ih7fv.camelize)("dx-" + widgetName);
            (0, $7sX7V.log)("W0001", "dxToolbar - 'widget' item field", deprecatedName, "16.1", "Use: '" + widgetName + "' instead");
        }
        if (options.parent) options.parent._createComponent(widgetElement, widgetName, widgetOptions);
        else widgetElement[widgetName](widgetOptions);
        return widgetElement;
    }
    return (0, $18036872a78cb2cb$var$_renderer2.default)();
});
var $18036872a78cb2cb$var$DOMComponentWithTemplate = $18036872a78cb2cb$var$_dom_component2.default.inherit({
    _getDefaultOptions: function() {
        return (0, $7I8Uw.extend)(this.callBase(), {
            integrationOptions: {
                watchMethod: function(fn, callback, options) {
                    options = options || {};
                    if (!options.skipImmediate) callback(fn());
                    return $2Mto0.noop;
                },
                templates: {
                    "dx-polymorph-widget": $18036872a78cb2cb$var$DX_POLYMORPH_WIDGET_TEMPLATE
                },
                createTemplate: function(element) {
                    return new $gqK38.Template(element);
                }
            }
        });
    },
    _init: function() {
        this.callBase();
        this._tempTemplates = [];
        this._defaultTemplates = {};
        this._initTemplates();
    },
    _dispose: function() {
        this._cleanTemplates();
        this.callBase();
    },
    _cleanTemplates: function() {
        this._tempTemplates.forEach(function(t) {
            t.template.dispose && t.template.dispose();
        });
        this._tempTemplates = [];
    },
    _initTemplates: function() {
        this._extractTemplates();
        this._extractAnonymousTemplate();
    },
    _extractTemplates: function() {
        var templateElements = this.$element().contents().filter($18036872a78cb2cb$var$TEMPLATE_SELECTOR);
        var templatesMap = {};
        templateElements.each(function(_, template) {
            var templateOptions = (0, $5OzEX.getElementOptions)(template).dxTemplate;
            if (!templateOptions) return;
            if (!templateOptions.name) throw (0, $7sX7V.Error)("E0023");
            (0, $18036872a78cb2cb$var$_renderer2.default)(template).addClass($18036872a78cb2cb$var$TEMPLATE_WRAPPER_CLASS).detach();
            templatesMap[templateOptions.name] = templatesMap[templateOptions.name] || [];
            templatesMap[templateOptions.name].push(template);
        });
        for(var templateName in templatesMap){
            var deviceTemplate = this._findTemplateByDevice(templatesMap[templateName]);
            if (deviceTemplate) this._saveTemplate(templateName, deviceTemplate);
        }
    },
    _saveTemplate: function(name, template) {
        var templates = this.option("integrationOptions.templates");
        templates[name] = this._createTemplate(template);
    },
    _findTemplateByDevice: function(templates) {
        var suitableTemplate = (0, $2Mto0.findBestMatches)($18036872a78cb2cb$var$_devices2.default.current(), templates, function(template) {
            return (0, $5OzEX.getElementOptions)(template).dxTemplate;
        })[0];
        templates.forEach(function(template) {
            if (template !== suitableTemplate) (0, $18036872a78cb2cb$var$_renderer2.default)(template).remove();
        });
        return suitableTemplate;
    },
    _extractAnonymousTemplate: function() {
        var templates = this.option("integrationOptions.templates");
        var anonymousTemplateName = this._getAnonymousTemplateName();
        var $anonymousTemplate = this.$element().contents().detach();
        var $notJunkTemplateContent = $anonymousTemplate.filter(function(_, element) {
            var isTextNode = element.nodeType === $18036872a78cb2cb$var$TEXT_NODE;
            var isEmptyText = (0, $18036872a78cb2cb$var$_renderer2.default)(element).text().trim().length < 1;
            return !(isTextNode && isEmptyText);
        });
        var onlyJunkTemplateContent = $notJunkTemplateContent.length < 1;
        if (!templates[anonymousTemplateName] && !onlyJunkTemplateContent) templates[anonymousTemplateName] = this._createTemplate($anonymousTemplate);
    },
    _getAnonymousTemplateName: function() {
        return $18036872a78cb2cb$var$ANONYMOUS_TEMPLATE_NAME;
    },
    _createTemplateIfNeeded: function(templateSource) {
        var templateKey = function(templateSource) {
            return (0, $kDRxH.isRenderer)(templateSource) && templateSource[0] || templateSource;
        };
        var cachedTemplate = this._tempTemplates.filter(function(t) {
            templateSource = templateKey(templateSource);
            return t.source === templateSource;
        })[0];
        if (cachedTemplate) return cachedTemplate.template;
        var template = this._createTemplate(templateSource);
        this._tempTemplates.push({
            template: template,
            source: templateKey(templateSource)
        });
        return template;
    },
    _createTemplate: function(templateSource) {
        templateSource = "string" === typeof templateSource ? (0, $5OzEX.normalizeTemplateElement)(templateSource) : templateSource;
        return this.option("integrationOptions.createTemplate")(templateSource);
    },
    _getTemplateByOption: function(optionName) {
        return this._getTemplate(this.option(optionName));
    },
    _getTemplate: function(templateSource) {
        if ((0, $kDRxH.isFunction)(templateSource)) return new $kqsMi.FunctionTemplate((function(options) {
            var templateSourceResult = templateSource.apply(this, this._getNormalizedTemplateArgs(options));
            if (!(0, $kDRxH.isDefined)(templateSourceResult)) return new $e5a0x.EmptyTemplate;
            var dispose = false;
            var template = this._acquireTemplate(templateSourceResult, (function(templateSource) {
                if (templateSource.nodeType || (0, $kDRxH.isRenderer)(templateSource) && !(0, $18036872a78cb2cb$var$_renderer2.default)(templateSource).is("script")) return new $kqsMi.FunctionTemplate(function() {
                    return templateSource;
                });
                dispose = true;
                return this._createTemplate(templateSource);
            }).bind(this));
            var result = template.render(options);
            dispose && template.dispose && template.dispose();
            return result;
        }).bind(this));
        return this._acquireTemplate(templateSource, this._createTemplateIfNeeded.bind(this));
    },
    _acquireTemplate: function(templateSource, createTemplate) {
        if (null == templateSource) return new $e5a0x.EmptyTemplate;
        if (templateSource instanceof $4dqlD.ChildDefaultTemplate) return this._defaultTemplates[templateSource.name];
        if (templateSource instanceof $9tMwv.TemplateBase) return templateSource;
        if ((0, $kDRxH.isFunction)(templateSource.render) && !(0, $kDRxH.isRenderer)(templateSource)) return this._addOneRenderedCall(templateSource);
        if (templateSource.nodeType || (0, $kDRxH.isRenderer)(templateSource)) return createTemplate((0, $18036872a78cb2cb$var$_renderer2.default)(templateSource));
        if ("string" === typeof templateSource) {
            var nonIntegrationTemplates = this.option("integrationOptions.skipTemplates") || [];
            var integrationTemplate = null;
            if (nonIntegrationTemplates.indexOf(templateSource) === -1) integrationTemplate = this._renderIntegrationTemplate(templateSource);
            return integrationTemplate || this._defaultTemplates[templateSource] || createTemplate(templateSource);
        }
        return this._acquireTemplate(templateSource.toString(), createTemplate);
    },
    _getNormalizedTemplateArgs: function(options) {
        var args = [];
        if ("model" in options) args.push(options.model);
        if ("index" in options) args.push(options.index);
        args.push(options.container);
        return args;
    },
    _addOneRenderedCall: function(template) {
        var _render = template.render.bind(template);
        return (0, $7I8Uw.extend)({}, template, {
            render: function(options) {
                var templateResult = _render(options);
                options && options.onRendered && options.onRendered();
                return templateResult;
            }
        });
    },
    _renderIntegrationTemplate: function(templateSource) {
        var integrationTemplate = this.option("integrationOptions.templates")[templateSource];
        if (integrationTemplate && !(integrationTemplate instanceof $9tMwv.TemplateBase)) {
            var isAsyncTemplate = this.option("templatesRenderAsynchronously");
            if (!isAsyncTemplate) return this._addOneRenderedCall(integrationTemplate);
        }
        return integrationTemplate;
    }
});
module.exports = $18036872a78cb2cb$var$DOMComponentWithTemplate;

});
parcelRegister("4sKC1", function(module, exports) {
/**
 * DevExtreme (core/dom_component.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $33fdef2d6a0fe5f0$var$_renderer2 = $33fdef2d6a0fe5f0$var$_interopRequireDefault($jFnCG);

var $e1LMc = parcelRequire("e1LMc");
var $33fdef2d6a0fe5f0$var$_events_engine2 = $33fdef2d6a0fe5f0$var$_interopRequireDefault($e1LMc);

var $irv64 = parcelRequire("irv64");
var $33fdef2d6a0fe5f0$var$_window2 = $33fdef2d6a0fe5f0$var$_interopRequireDefault($irv64);

var $7I8Uw = parcelRequire("7I8Uw");

var $1JvXr = parcelRequire("1JvXr");
var $33fdef2d6a0fe5f0$var$_config2 = $33fdef2d6a0fe5f0$var$_interopRequireDefault($1JvXr);

var $7sX7V = parcelRequire("7sX7V");
var $33fdef2d6a0fe5f0$var$_errors2 = $33fdef2d6a0fe5f0$var$_interopRequireDefault($7sX7V);

var $5OzEX = parcelRequire("5OzEX");

var $4OGCY = parcelRequire("4OGCY");
var $33fdef2d6a0fe5f0$var$_resize_callbacks2 = $33fdef2d6a0fe5f0$var$_interopRequireDefault($4OGCY);

var $2Mto0 = parcelRequire("2Mto0");
var $33fdef2d6a0fe5f0$var$_common2 = $33fdef2d6a0fe5f0$var$_interopRequireDefault($2Mto0);

var $4Pwuy = parcelRequire("4Pwuy");

var $kDRxH = parcelRequire("kDRxH");

var $aLQK5 = parcelRequire("aLQK5");

var $3fgBn = parcelRequire("3fgBn");
var $33fdef2d6a0fe5f0$var$_public_component2 = $33fdef2d6a0fe5f0$var$_interopRequireDefault($3fgBn);

var $8ulMI = parcelRequire("8ulMI");
var $33fdef2d6a0fe5f0$var$_element_data2 = $33fdef2d6a0fe5f0$var$_interopRequireDefault($8ulMI);

var $2jEQO = parcelRequire("2jEQO");
var $33fdef2d6a0fe5f0$var$_component2 = $33fdef2d6a0fe5f0$var$_interopRequireDefault($2jEQO);
function $33fdef2d6a0fe5f0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $33fdef2d6a0fe5f0$var$abstract = $33fdef2d6a0fe5f0$var$_component2.default.abstract;
var $33fdef2d6a0fe5f0$var$RTL_DIRECTION_CLASS = "dx-rtl";
var $33fdef2d6a0fe5f0$var$VISIBILITY_CHANGE_CLASS = "dx-visibility-change-handler";
var $33fdef2d6a0fe5f0$var$VISIBILITY_CHANGE_EVENTNAMESPACE = "VisibilityChange";
var $33fdef2d6a0fe5f0$var$DOMComponent = $33fdef2d6a0fe5f0$var$_component2.default.inherit({
    _getDefaultOptions: function() {
        return (0, $7I8Uw.extend)(this.callBase(), {
            width: void 0,
            height: void 0,
            rtlEnabled: (0, $33fdef2d6a0fe5f0$var$_config2.default)().rtlEnabled,
            elementAttr: {},
            disabled: false,
            integrationOptions: {}
        });
    },
    ctor: function(element, options) {
        this._createElement(element);
        $33fdef2d6a0fe5f0$var$_public_component2.default.attachInstanceToElement(this._$element, this, this._dispose);
        this.callBase(options);
    },
    _createElement: function(element) {
        this._$element = (0, $33fdef2d6a0fe5f0$var$_renderer2.default)(element);
    },
    _getSynchronizableOptionsForCreateComponent: function() {
        return [
            "rtlEnabled",
            "disabled",
            "templatesRenderAsynchronously"
        ];
    },
    _visibilityChanged: $33fdef2d6a0fe5f0$var$abstract,
    _dimensionChanged: $33fdef2d6a0fe5f0$var$abstract,
    _init: function() {
        this.callBase();
        this._attachWindowResizeCallback();
    },
    _setOptionsByDevice: function(instanceCustomRules) {
        this.callBase([].concat(this.constructor._classCustomRules || [], instanceCustomRules || []));
    },
    _isInitialOptionValue: function(name) {
        var isCustomOption = this.constructor._classCustomRules && Object.prototype.hasOwnProperty.call(this._convertRulesToOptions(this.constructor._classCustomRules), name);
        return !isCustomOption && this.callBase(name);
    },
    _attachWindowResizeCallback: function() {
        if (this._isDimensionChangeSupported()) {
            var windowResizeCallBack = this._windowResizeCallBack = this._dimensionChanged.bind(this);
            $33fdef2d6a0fe5f0$var$_resize_callbacks2.default.add(windowResizeCallBack);
        }
    },
    _isDimensionChangeSupported: function() {
        return this._dimensionChanged !== $33fdef2d6a0fe5f0$var$abstract;
    },
    _renderComponent: function() {
        this._initMarkup();
        if ($33fdef2d6a0fe5f0$var$_window2.default.hasWindow()) this._render();
    },
    _initMarkup: function() {
        this._renderElementAttributes();
        this._toggleRTLDirection(this.option("rtlEnabled"));
        this._renderVisibilityChange();
        this._renderDimensions();
    },
    _render: function() {
        this._attachVisibilityChangeHandlers();
    },
    _renderElementAttributes: function() {
        var attributes = (0, $7I8Uw.extend)({}, this.option("elementAttr"));
        var classNames = attributes.class;
        delete attributes.class;
        this.$element().attr(attributes).addClass(classNames);
    },
    _renderVisibilityChange: function() {
        if (this._isDimensionChangeSupported()) this._attachDimensionChangeHandlers();
        if (!this._isVisibilityChangeSupported()) return;
        this.$element().addClass($33fdef2d6a0fe5f0$var$VISIBILITY_CHANGE_CLASS);
    },
    _renderDimensions: function() {
        var $element = this.$element();
        var element = $element.get(0);
        var width = this._getOptionValue("width", element);
        var height = this._getOptionValue("height", element);
        if (this._isCssUpdateRequired(element, height, width)) $element.css({
            width: null === width ? "" : width,
            height: null === height ? "" : height
        });
    },
    _isCssUpdateRequired: function(element, height, width) {
        return !!((0, $kDRxH.isDefined)(width) || (0, $kDRxH.isDefined)(height) || element.style.width || element.style.height);
    },
    _attachDimensionChangeHandlers: function() {
        var that = this;
        var resizeEventName = "dxresize." + this.NAME + $33fdef2d6a0fe5f0$var$VISIBILITY_CHANGE_EVENTNAMESPACE;
        $33fdef2d6a0fe5f0$var$_events_engine2.default.off(that.$element(), resizeEventName);
        $33fdef2d6a0fe5f0$var$_events_engine2.default.on(that.$element(), resizeEventName, function() {
            that._dimensionChanged();
        });
    },
    _attachVisibilityChangeHandlers: function() {
        if (!this._isVisibilityChangeSupported()) return;
        var that = this;
        var hidingEventName = "dxhiding." + this.NAME + $33fdef2d6a0fe5f0$var$VISIBILITY_CHANGE_EVENTNAMESPACE;
        var shownEventName = "dxshown." + this.NAME + $33fdef2d6a0fe5f0$var$VISIBILITY_CHANGE_EVENTNAMESPACE;
        that._isHidden = !that._isVisible();
        $33fdef2d6a0fe5f0$var$_events_engine2.default.off(that.$element(), hidingEventName);
        $33fdef2d6a0fe5f0$var$_events_engine2.default.on(that.$element(), hidingEventName, function() {
            that._checkVisibilityChanged("hiding");
        });
        $33fdef2d6a0fe5f0$var$_events_engine2.default.off(that.$element(), shownEventName);
        $33fdef2d6a0fe5f0$var$_events_engine2.default.on(that.$element(), shownEventName, function() {
            that._checkVisibilityChanged("shown");
        });
    },
    _isVisible: function() {
        return this.$element().is(":visible");
    },
    _checkVisibilityChanged: function(event) {
        if ("hiding" === event && this._isVisible() && !this._isHidden) {
            this._visibilityChanged(false);
            this._isHidden = true;
        } else if ("shown" === event && this._isVisible() && this._isHidden) {
            this._isHidden = false;
            this._visibilityChanged(true);
        }
    },
    _isVisibilityChangeSupported: function() {
        return this._visibilityChanged !== $33fdef2d6a0fe5f0$var$abstract && $33fdef2d6a0fe5f0$var$_window2.default.hasWindow();
    },
    _clean: $33fdef2d6a0fe5f0$var$_common2.default.noop,
    _modelByElement: function() {
        var modelByElement = this.option("modelByElement") || $33fdef2d6a0fe5f0$var$_common2.default.noop;
        return modelByElement(this.$element());
    },
    _invalidate: function() {
        if (!this._updateLockCount) throw $33fdef2d6a0fe5f0$var$_errors2.default.Error("E0007");
        this._requireRefresh = true;
    },
    _refresh: function() {
        this._clean();
        this._renderComponent();
    },
    _dispose: function() {
        this.callBase();
        this._clean();
        this._detachWindowResizeCallback();
    },
    _detachWindowResizeCallback: function() {
        if (this._isDimensionChangeSupported()) $33fdef2d6a0fe5f0$var$_resize_callbacks2.default.remove(this._windowResizeCallBack);
    },
    _toggleRTLDirection: function(rtl) {
        this.$element().toggleClass($33fdef2d6a0fe5f0$var$RTL_DIRECTION_CLASS, rtl);
    },
    _createComponent: function(element, component, config) {
        var _this = this;
        var that = this;
        config = config || {};
        var synchronizableOptions = $33fdef2d6a0fe5f0$var$_common2.default.grep(this._getSynchronizableOptionsForCreateComponent(), function(value) {
            return !(value in config);
        });
        var nestedComponentOptions = that.option("nestedComponentOptions") || $33fdef2d6a0fe5f0$var$_common2.default.noop;
        var nestedComponentConfig = (0, $7I8Uw.extend)({
            integrationOptions: this.option("integrationOptions")
        }, nestedComponentOptions(this));
        synchronizableOptions.forEach(function(optionName) {
            nestedComponentConfig[optionName] = _this.option(optionName);
        });
        that._extendConfig(config, nestedComponentConfig);
        var instance;
        if ((0, $kDRxH.isString)(component)) {
            var $element = (0, $33fdef2d6a0fe5f0$var$_renderer2.default)(element)[component](config);
            instance = $element[component]("instance");
        } else if (element) {
            instance = component.getInstance(element);
            if (instance) instance.option(config);
            else instance = new component(element, config);
        }
        if (instance) {
            var optionChangedHandler = function(args) {
                if ((0, $aLQK5.inArray)(args.name, synchronizableOptions) >= 0) instance.option(args.name, args.value);
            };
            that.on("optionChanged", optionChangedHandler);
            instance.on("disposing", function() {
                that.off("optionChanged", optionChangedHandler);
            });
        }
        return instance;
    },
    _extendConfig: function(config, extendConfig) {
        (0, $4Pwuy.each)(extendConfig, function(key, value) {
            config[key] = Object.prototype.hasOwnProperty.call(config, key) ? config[key] : value;
        });
    },
    _defaultActionConfig: function() {
        return (0, $7I8Uw.extend)(this.callBase(), {
            context: this._modelByElement(this.$element())
        });
    },
    _defaultActionArgs: function() {
        var model = this._modelByElement(this.$element());
        return (0, $7I8Uw.extend)(this.callBase(), {
            element: this.element(),
            model: model
        });
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "width":
            case "height":
                this._renderDimensions();
                break;
            case "rtlEnabled":
                this._invalidate();
                break;
            case "elementAttr":
                this._renderElementAttributes();
                break;
            case "disabled":
            case "integrationOptions":
                break;
            default:
                this.callBase(args);
        }
    },
    _removeAttributes: function(element) {
        var i = element.attributes.length - 1;
        for(; i >= 0; i--){
            var attribute = element.attributes[i];
            if (!attribute) return;
            var attributeName = attribute.name;
            if (0 === attributeName.indexOf("aria-") || attributeName.indexOf("dx-") !== -1 || "role" === attributeName || "style" === attributeName || "tabindex" === attributeName) element.removeAttribute(attributeName);
        }
    },
    _removeClasses: function(element) {
        var classes = element.className.split(" ").filter(function(cssClass) {
            return 0 !== cssClass.lastIndexOf("dx-", 0);
        });
        element.className = classes.join(" ");
    },
    endUpdate: function() {
        var requireRender = !this._initializing && !this._initialized;
        this.callBase.apply(this, arguments);
        if (!this._updateLockCount) {
            if (requireRender) this._renderComponent();
            else if (this._requireRefresh) {
                this._requireRefresh = false;
                this._refresh();
            }
        }
    },
    $element: function() {
        return this._$element;
    },
    element: function() {
        return (0, $5OzEX.getPublicElement)(this.$element());
    },
    dispose: function() {
        var element = this.$element().get(0);
        $33fdef2d6a0fe5f0$var$_element_data2.default.cleanDataRecursive(element, true);
        element.textContent = "";
        this._removeAttributes(element);
        this._removeClasses(element);
    },
    resetOption: function(optionName) {
        this.callBase(optionName);
        if (("width" === optionName || "height" === optionName) && !(0, $kDRxH.isDefined)(this.initialOption(optionName))) this.$element().css(optionName, "");
    }
});
$33fdef2d6a0fe5f0$var$DOMComponent.getInstance = function(element) {
    return $33fdef2d6a0fe5f0$var$_public_component2.default.getInstanceByElement((0, $33fdef2d6a0fe5f0$var$_renderer2.default)(element), this);
};
$33fdef2d6a0fe5f0$var$DOMComponent.defaultOptions = function(rule) {
    this._classCustomRules = this._classCustomRules || [];
    this._classCustomRules.push(rule);
};
module.exports = $33fdef2d6a0fe5f0$var$DOMComponent;
module.exports.default = module.exports;

});
parcelRegister("2jEQO", function(module, exports) {
/**
 * DevExtreme (core/component.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
function $1afd0b435dcdb65e$var$_toConsumableArray(arr) {
    return $1afd0b435dcdb65e$var$_arrayWithoutHoles(arr) || $1afd0b435dcdb65e$var$_iterableToArray(arr) || $1afd0b435dcdb65e$var$_unsupportedIterableToArray(arr) || $1afd0b435dcdb65e$var$_nonIterableSpread();
}
function $1afd0b435dcdb65e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1afd0b435dcdb65e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if ("string" === typeof o) return $1afd0b435dcdb65e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if ("Object" === n && o.constructor) n = o.constructor.name;
    if ("Map" === n || "Set" === n) return Array.from(o);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1afd0b435dcdb65e$var$_arrayLikeToArray(o, minLen);
}
function $1afd0b435dcdb65e$var$_iterableToArray(iter) {
    if ("undefined" !== typeof Symbol && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $1afd0b435dcdb65e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1afd0b435dcdb65e$var$_arrayLikeToArray(arr);
}
function $1afd0b435dcdb65e$var$_arrayLikeToArray(arr, len) {
    if (null == len || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1afd0b435dcdb65e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1afd0b435dcdb65e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1afd0b435dcdb65e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1afd0b435dcdb65e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1afd0b435dcdb65e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

var $1JvXr = parcelRequire("1JvXr");

var $7I8Uw = parcelRequire("7I8Uw");
var $1afd0b435dcdb65e$require$extend = $7I8Uw.extend;

var $hWrRO = parcelRequire("hWrRO");
var $1afd0b435dcdb65e$require$optionManager = $hWrRO.OptionManager;

var $kpjzB = parcelRequire("kpjzB");
var $1afd0b435dcdb65e$require$bracketsToDots = $kpjzB.bracketsToDots;

var $k7aJb = parcelRequire("k7aJb");

var $jL4UV = parcelRequire("jL4UV");

var $7sX7V = parcelRequire("7sX7V");

var $2Mto0 = parcelRequire("2Mto0");

var $kDRxH = parcelRequire("kDRxH");

var $6l2Qk = parcelRequire("6l2Qk");

var $2F60d = parcelRequire("2F60d");
var $1afd0b435dcdb65e$var$Deferred = $2F60d.Deferred;
var $1afd0b435dcdb65e$var$when = $2F60d.when;

var $eKdKS = parcelRequire("eKdKS");

var $cWRya = parcelRequire("cWRya");

var $3fgBn = parcelRequire("3fgBn");

var $aiwte = parcelRequire("aiwte");
var $1afd0b435dcdb65e$var$isFunction = $kDRxH.isFunction;
var $1afd0b435dcdb65e$var$noop = $2Mto0.noop;
var $1afd0b435dcdb65e$var$PostponedOperations = function() {
    function PostponedOperations() {
        $1afd0b435dcdb65e$var$_classCallCheck(this, PostponedOperations);
        this._postponedOperations = {};
    }
    $1afd0b435dcdb65e$var$_createClass(PostponedOperations, [
        {
            key: "add",
            value: function(key, fn, postponedPromise) {
                if (key in this._postponedOperations) postponedPromise && this._postponedOperations[key].promises.push(postponedPromise);
                else {
                    var completePromise = new $1afd0b435dcdb65e$var$Deferred;
                    this._postponedOperations[key] = {
                        fn: fn,
                        completePromise: completePromise,
                        promises: postponedPromise ? [
                            postponedPromise
                        ] : []
                    };
                }
                return this._postponedOperations[key].completePromise.promise();
            }
        },
        {
            key: "callPostponedOperations",
            value: function() {
                for(var key in this._postponedOperations){
                    var operation = this._postponedOperations[key];
                    if ($kDRxH.isDefined(operation)) {
                        if (operation.promises && operation.promises.length) $1afd0b435dcdb65e$var$when.apply(void 0, $1afd0b435dcdb65e$var$_toConsumableArray(operation.promises)).done(operation.fn).then(operation.completePromise.resolve);
                        else operation.fn().done(operation.completePromise.resolve);
                    }
                }
                this._postponedOperations = {};
            }
        }
    ]);
    return PostponedOperations;
}();
var $1afd0b435dcdb65e$var$normalizeOptions = function(options, value) {
    if ("string" !== typeof options) return options;
    var result = {};
    result[options] = value;
    return result;
};
var $1afd0b435dcdb65e$var$Component = $k7aJb.inherit({
    _setDeprecatedOptions: function() {
        this._deprecatedOptions = {};
    },
    _getDeprecatedOptions: function() {
        return this._deprecatedOptions;
    },
    _getOptionAliasesByName: function(optionName) {
        var _this = this;
        return Object.keys(this._deprecatedOptions).filter(function(aliasName) {
            return optionName === _this._deprecatedOptions[aliasName].alias;
        });
    },
    _getDefaultOptions: function() {
        return {
            onInitialized: null,
            onOptionChanged: null,
            onDisposing: null,
            defaultOptionsRules: null
        };
    },
    _defaultOptionsRules: function() {
        return [];
    },
    _getOptionByRules: function(customRules) {
        var rules = this._defaultOptionsRules();
        if (Array.isArray(customRules)) rules = rules.concat(customRules);
        return this._convertRulesToOptions(rules);
    },
    _setOptionsByDevice: function(customRules) {
        var rulesOptions = this._getOptionByRules(customRules);
        this._setOptionByStealth(rulesOptions);
    },
    _convertRulesToOptions: function(rules) {
        var options = {};
        var currentDevice = $aiwte.current();
        var deviceMatch = function(device, filter) {
            var filterArray = [];
            Array.prototype.push.call(filterArray, filter);
            return 1 === filterArray.length && $kDRxH.isEmptyObject(filterArray[0]) || $2Mto0.findBestMatches(device, filterArray).length > 0;
        };
        for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var deviceFilter = rule.device || {};
            var match;
            if ($1afd0b435dcdb65e$var$isFunction(deviceFilter)) match = deviceFilter(currentDevice);
            else match = deviceMatch(currentDevice, deviceFilter);
            if (match) $1afd0b435dcdb65e$require$extend(options, rule.options);
        }
        return options;
    },
    _isInitialOptionValue: function(name) {
        var optionValue = this.option(name);
        var initialOptionValue = this.initialOption(name);
        var isInitialOption = $1afd0b435dcdb65e$var$isFunction(optionValue) && $1afd0b435dcdb65e$var$isFunction(initialOptionValue) ? optionValue.toString() === initialOptionValue.toString() : $2Mto0.equalByValue(optionValue, initialOptionValue);
        return isInitialOption;
    },
    _setOptionsByReference: function() {
        this._optionsByReference = {};
    },
    _getOptionsByReference: function() {
        return this._optionsByReference;
    },
    ctor: function(options) {
        var _this2 = this;
        this.NAME = $3fgBn.name(this.constructor);
        options = options || {};
        if (options.eventsStrategy) this.setEventsStrategy(options.eventsStrategy);
        this._options = {};
        this._updateLockCount = 0;
        this._optionChangedCallbacks = options._optionChangedCallbacks || $eKdKS();
        this._disposingCallbacks = options._disposingCallbacks || $eKdKS();
        this.postponedOperations = new $1afd0b435dcdb65e$var$PostponedOperations;
        this.beginUpdate();
        try {
            this._setOptionsByReference();
            this._setDeprecatedOptions();
            this._options = this._getDefaultOptions();
            this._optionManager = new $1afd0b435dcdb65e$require$optionManager(this._options, this._getOptionsByReference(), this._deprecatedOptions);
            this._optionManager.onChanging(function(name, previousValue, value) {
                if (_this2._initialized) _this2._optionChanging(name, previousValue, value);
            });
            this._optionManager.onDeprecated(function(option, info) {
                _this2._logDeprecatedWarning(option, info);
            });
            this._optionManager.onChanged(function(name, value, previousValue) {
                _this2._notifyOptionChanged(name, value, previousValue);
            });
            if (options && options.onInitializing) options.onInitializing.apply(this, [
                options
            ]);
            this._setOptionsByDevice(options.defaultOptionsRules);
            this._initOptions(options);
        } finally{
            this.endUpdate();
        }
    },
    _initOptions: function(options) {
        this.option(options);
    },
    _init: function() {
        this._createOptionChangedAction();
        this.on("disposing", (function(args) {
            this._disposingCallbacks.fireWith(this, [
                args
            ]);
        }).bind(this));
    },
    _logDeprecatedWarning: function(option, info) {
        var message = info.message || "Use the '" + info.alias + "' option instead";
        $7sX7V.log("W0001", this.NAME, option, info.since, message);
    },
    _createOptionChangedAction: function() {
        this._optionChangedAction = this._createActionByOption("onOptionChanged", {
            excludeValidators: [
                "disabled",
                "readOnly"
            ]
        });
    },
    _createDisposingAction: function() {
        this._disposingAction = this._createActionByOption("onDisposing", {
            excludeValidators: [
                "disabled",
                "readOnly"
            ]
        });
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "onDisposing":
            case "onInitialized":
                break;
            case "onOptionChanged":
                this._createOptionChangedAction();
                break;
            case "defaultOptionsRules":
        }
    },
    _dispose: function() {
        this._optionChangedCallbacks.empty();
        this._createDisposingAction();
        this._disposingAction();
        this._disposeEvents();
        this._optionManager.dispose();
        this._disposed = true;
    },
    instance: function() {
        return this;
    },
    beginUpdate: function() {
        this._updateLockCount++;
    },
    endUpdate: function() {
        this._updateLockCount = Math.max(this._updateLockCount - 1, 0);
        if (!this._updateLockCount) {
            this.postponedOperations.callPostponedOperations();
            if (!this._initializing && !this._initialized) {
                this._initializing = true;
                try {
                    this._init();
                } finally{
                    this._initializing = false;
                    this._updateLockCount++;
                    this._createActionByOption("onInitialized", {
                        excludeValidators: [
                            "disabled",
                            "readOnly"
                        ]
                    })();
                    this._updateLockCount--;
                    this._initialized = true;
                }
            }
        }
    },
    _optionChanging: $1afd0b435dcdb65e$var$noop,
    _notifyOptionChanged: function(option, value, previousValue) {
        var that = this;
        if (this._initialized) {
            var optionNames = [
                option
            ].concat(that._getOptionAliasesByName(option));
            for(var i = 0; i < optionNames.length; i++){
                var name = optionNames[i];
                var args = {
                    name: name.split(/[.[]/)[0],
                    fullName: name,
                    value: value,
                    previousValue: previousValue
                };
                that._optionChangedCallbacks.fireWith(that, [
                    $1afd0b435dcdb65e$require$extend(that._defaultActionArgs(), args)
                ]);
                that._optionChangedAction($1afd0b435dcdb65e$require$extend({}, args));
                if (!that._disposed && this._cancelOptionChange !== args.name) that._optionChanged(args);
            }
        }
    },
    initialOption: function(optionName) {
        if (!this._initialOptions) {
            this._initialOptions = this._getDefaultOptions();
            var rulesOptions = this._getOptionByRules(this._getOptionByStealth("defaultOptionsRules"));
            this._optionManager.setValueByReference(this._initialOptions, rulesOptions);
        }
        return this._initialOptions[optionName];
    },
    _defaultActionConfig: function() {
        return {
            context: this,
            component: this
        };
    },
    _defaultActionArgs: function() {
        return {
            component: this
        };
    },
    _createAction: function(actionSource, config) {
        var that = this;
        var action;
        return function(e) {
            if (!arguments.length) e = {};
            if (!$kDRxH.isPlainObject(e)) e = {
                actionValue: e
            };
            action = action || new $jL4UV(actionSource, $1afd0b435dcdb65e$require$extend(config, that._defaultActionConfig()));
            return action.execute.call(action, $1afd0b435dcdb65e$require$extend(e, that._defaultActionArgs()));
        };
    },
    _createActionByOption: function(optionName, config) {
        var that = this;
        var action;
        var eventName;
        var actionFunc;
        var result = function() {
            if (!eventName) {
                config = config || {};
                if ("string" !== typeof optionName) throw $7sX7V.Error("E0008");
                if (0 === optionName.indexOf("on")) eventName = that._getEventName(optionName);
                actionFunc = that.option(optionName);
            }
            if (!action && !actionFunc && !config.beforeExecute && !config.afterExecute && !that.hasEvent(eventName)) return;
            if (!action) {
                var beforeExecute = config.beforeExecute;
                config.beforeExecute = function(args) {
                    beforeExecute && beforeExecute.apply(that, arguments);
                    that.fireEvent(eventName, args.args);
                };
                action = that._createAction(actionFunc, config);
            }
            if ($1JvXr().wrapActionsBeforeExecute) {
                var beforeActionExecute = that.option("beforeActionExecute") || $1afd0b435dcdb65e$var$noop;
                var wrappedAction = beforeActionExecute(that, action, config) || action;
                return wrappedAction.apply(that, arguments);
            }
            return action.apply(that, arguments);
        };
        if (!$1JvXr().wrapActionsBeforeExecute) {
            var onActionCreated = that.option("onActionCreated") || $1afd0b435dcdb65e$var$noop;
            result = onActionCreated(that, result, config) || result;
        }
        return result;
    },
    _getOptionByStealth: function(name) {
        return this._optionManager.getValueSilently(name);
    },
    _setOptionByStealth: function(options, value) {
        this._optionManager.setValueSilently($1afd0b435dcdb65e$var$normalizeOptions(options, value));
    },
    _getEventName: function(actionName) {
        return actionName.charAt(2).toLowerCase() + actionName.substr(3);
    },
    hasActionSubscription: function(actionName) {
        return !!this.option(actionName) || this.hasEvent(this._getEventName(actionName));
    },
    isOptionDeprecated: function(name) {
        var deprecatedOptions = this._getDeprecatedOptions();
        return Object.prototype.hasOwnProperty.call(deprecatedOptions, name);
    },
    _setOptionSilent: function(name, value) {
        this._cancelOptionChange = name;
        this.option(name, value);
        this._cancelOptionChange = false;
    },
    _getOptionValue: function(name, context) {
        var value = this.option(name);
        if ($1afd0b435dcdb65e$var$isFunction(value)) return value.bind(context)();
        return value;
    },
    option: function(options, value) {
        if (arguments.length < 2 && "object" !== $kDRxH.type(options)) return this._optionManager.getValue(options);
        this.beginUpdate();
        try {
            this._optionManager.setValue($1afd0b435dcdb65e$var$normalizeOptions(options, value));
        } finally{
            this.endUpdate();
        }
    },
    resetOption: function(name) {
        var _this3 = this;
        if (!name) return;
        var defaultValue;
        if (name.search(/\.|\[/) !== -1) {
            name = $1afd0b435dcdb65e$require$bracketsToDots(name);
            var fullPath = name.split(".");
            fullPath.forEach(function(path) {
                defaultValue = defaultValue ? defaultValue[path] : _this3.initialOption(path);
            });
        } else defaultValue = this.initialOption(name);
        defaultValue = $kDRxH.isObject(defaultValue) ? $6l2Qk.clone(defaultValue) : defaultValue;
        this.beginUpdate();
        this._optionManager.setValue($1afd0b435dcdb65e$var$normalizeOptions(name, defaultValue), false);
        this.endUpdate();
    }
}).include($cWRya);
module.exports = $1afd0b435dcdb65e$var$Component;
module.exports.PostponedOperations = $1afd0b435dcdb65e$var$PostponedOperations;

});
parcelRegister("hWrRO", function(module, exports) {
/**
 * DevExtreme (core/option_manager.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OptionManager = void 0;

var $kpjzB = parcelRequire("kpjzB");
var $d0fd7843f2988ff5$var$_data2 = $d0fd7843f2988ff5$var$_interopRequireDefault($kpjzB);

var $lGExn = parcelRequire("lGExn");

var $kDRxH = parcelRequire("kDRxH");
var $d0fd7843f2988ff5$var$_type2 = $d0fd7843f2988ff5$var$_interopRequireDefault($kDRxH);

var $2Mto0 = parcelRequire("2Mto0");

var $7I8Uw = parcelRequire("7I8Uw");
function $d0fd7843f2988ff5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d0fd7843f2988ff5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d0fd7843f2988ff5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d0fd7843f2988ff5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d0fd7843f2988ff5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d0fd7843f2988ff5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $d0fd7843f2988ff5$var$cachedGetters = {};
var $d0fd7843f2988ff5$var$cachedSetters = {};
var $d0fd7843f2988ff5$var$OptionManager = module.exports.OptionManager = function() {
    function OptionManager(options, optionsByReference, deprecatedOptions) {
        $d0fd7843f2988ff5$var$_classCallCheck(this, OptionManager);
        this._options = options;
        this._optionsByReference = optionsByReference;
        this._deprecatedOptions = deprecatedOptions;
        this._changingCallback;
        this._changedCallback;
        this._deprecatedCallback;
        this._cachedDeprecateNames = [];
    }
    $d0fd7843f2988ff5$var$_createClass(OptionManager, [
        {
            key: "_notifyDeprecated",
            value: function(option) {
                var info = this._deprecatedOptions[option];
                if (info) this._deprecatedCallback(option, info);
            }
        },
        {
            key: "_clearField",
            value: function(options, name) {
                delete options[name];
                var previousFieldName = this._getParentName(name);
                var fieldObject = previousFieldName ? this._getValue(options, previousFieldName, false) : options;
                if (fieldObject) delete fieldObject[this._getFieldName(name)];
            }
        },
        {
            key: "_getParentName",
            value: function(fullName) {
                return fullName.substr(0, fullName.lastIndexOf("."));
            }
        },
        {
            key: "_getFieldName",
            value: function(fullName) {
                return fullName.substr(fullName.lastIndexOf(".") + 1);
            }
        },
        {
            key: "_setField",
            value: function(options, fullName, value) {
                var fieldName = "";
                var fieldObject;
                do {
                    if (fieldName) fieldName = "." + fieldName;
                    fieldName = this._getFieldName(fullName) + fieldName;
                    fullName = this._getParentName(fullName);
                    fieldObject = fullName ? this._getValue(options, fullName, false) : options;
                }while (!fieldObject);
                fieldObject[fieldName] = value;
            }
        },
        {
            key: "_setValue",
            value: function(name, value, merge) {
                if (!$d0fd7843f2988ff5$var$cachedSetters[name]) $d0fd7843f2988ff5$var$cachedSetters[name] = $d0fd7843f2988ff5$var$_data2.default.compileSetter(name);
                var path = name.split(/[.[]/);
                merge = $d0fd7843f2988ff5$var$_type2.default.isDefined(merge) ? merge : !this._optionsByReference[name];
                $d0fd7843f2988ff5$var$cachedSetters[name](this._options, value, {
                    functionsAsIs: true,
                    merge: merge,
                    unwrapObservables: path.length > 1 && !!this._optionsByReference[path[0]]
                });
            }
        },
        {
            key: "_setPreparedValue",
            value: function(name, value, merge) {
                var previousValue = this._getValue(this._options, name, false);
                if ((0, $lGExn.equals)(previousValue, value)) return;
                this._changingCallback(name, previousValue, value);
                this._setValue(name, value, merge);
                this._changedCallback(name, value, previousValue);
            }
        },
        {
            key: "_setRelevantNames",
            value: function(options, name, value) {
                if (!name) return;
                var normalizedName = this._normalizeName(name);
                if (normalizedName && normalizedName !== name) {
                    this._setField(options, normalizedName, value);
                    this._clearField(options, name);
                }
            }
        },
        {
            key: "_normalizeName",
            value: function(name) {
                if (!name) return;
                if (!this._cachedDeprecateNames.length) for(var optionName in this._deprecatedOptions)this._cachedDeprecateNames.push(optionName);
                for(var i = 0; i < this._cachedDeprecateNames.length; i++)if (this._cachedDeprecateNames[i] === name) {
                    var deprecate = this._deprecatedOptions[name];
                    if (deprecate) {
                        this._notifyDeprecated(name);
                        return deprecate.alias || name;
                    }
                }
                return name;
            }
        },
        {
            key: "_prepareRelevantNames",
            value: function(options, name, value) {
                if ($d0fd7843f2988ff5$var$_type2.default.isPlainObject(value)) for(var valueName in value)this._prepareRelevantNames(options, name + "." + valueName, value[valueName]);
                this._setRelevantNames(options, name, value);
            }
        },
        {
            key: "_getValue",
            value: function(options, name, unwrapObservables) {
                var getter = $d0fd7843f2988ff5$var$cachedGetters[name];
                if (!getter) getter = $d0fd7843f2988ff5$var$cachedGetters[name] = $d0fd7843f2988ff5$var$_data2.default.compileGetter(name);
                return getter(options, {
                    functionsAsIs: true,
                    unwrapObservables: unwrapObservables
                });
            }
        },
        {
            key: "onChanging",
            value: function(callBack) {
                this._changingCallback = callBack;
            }
        },
        {
            key: "onChanged",
            value: function(callBack) {
                this._changedCallback = callBack;
            }
        },
        {
            key: "onDeprecated",
            value: function(callBack) {
                this._deprecatedCallback = callBack;
            }
        },
        {
            key: "setValueByReference",
            value: function(options, rulesOptions) {
                (0, $7I8Uw.extend)(true, options, rulesOptions);
                for(var fieldName in this._optionsByReference)if (Object.prototype.hasOwnProperty.call(rulesOptions, fieldName)) options[fieldName] = rulesOptions[fieldName];
            }
        },
        {
            key: "getValue",
            value: function(name) {
                return this._getValue(this._options, this._normalizeName(name));
            }
        },
        {
            key: "setValue",
            value: function(options, merge) {
                for(var optionName in options)this._prepareRelevantNames(options, optionName, options[optionName]);
                for(var _optionName in options)this._setPreparedValue(_optionName, options[_optionName], merge);
            }
        },
        {
            key: "getValueSilently",
            value: function(name) {
                return this._options[name];
            }
        },
        {
            key: "setValueSilently",
            value: function(options) {
                this.setValueByReference(this._options, options);
            }
        },
        {
            key: "dispose",
            value: function() {
                this._changingCallback = $2Mto0.noop;
                this._changedCallback = $2Mto0.noop;
                this._deprecatedCallback = $2Mto0.noop;
            }
        }
    ]);
    return OptionManager;
}();

});
parcelRegister("lGExn", function(module, exports) {

$parcel$export(module.exports, "equals", () => $fc9cf715bec68c0f$export$e9bab7fafb253603, (v) => $fc9cf715bec68c0f$export$e9bab7fafb253603 = v);
/**
 * DevExtreme (core/utils/comparator.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $fc9cf715bec68c0f$export$e9bab7fafb253603;
"use strict";

var $445Bz = parcelRequire("445Bz");
var $fc9cf715bec68c0f$var$_dom_adapter2 = $fc9cf715bec68c0f$var$_interopRequireDefault($445Bz);

var $kpjzB = parcelRequire("kpjzB");

var $kDRxH = parcelRequire("kDRxH");
var $fc9cf715bec68c0f$var$_type2 = $fc9cf715bec68c0f$var$_interopRequireDefault($kDRxH);
function $fc9cf715bec68c0f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $fc9cf715bec68c0f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $fc9cf715bec68c0f$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $fc9cf715bec68c0f$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $fc9cf715bec68c0f$var$_typeof(obj);
}
var $fc9cf715bec68c0f$var$hasNegation = function(oldValue, newValue) {
    return 1 / oldValue === 1 / newValue;
};
var $fc9cf715bec68c0f$var$equals = function(oldValue, newValue) {
    oldValue = (0, $kpjzB.toComparable)(oldValue, true);
    newValue = (0, $kpjzB.toComparable)(newValue, true);
    if (oldValue && newValue && $fc9cf715bec68c0f$var$_type2.default.isRenderer(oldValue) && $fc9cf715bec68c0f$var$_type2.default.isRenderer(newValue)) return newValue.is(oldValue);
    var oldValueIsNaN = oldValue !== oldValue;
    var newValueIsNaN = newValue !== newValue;
    if (oldValueIsNaN && newValueIsNaN) return true;
    if (0 === oldValue && 0 === newValue) return $fc9cf715bec68c0f$var$hasNegation(oldValue, newValue);
    if (null === oldValue || "object" !== $fc9cf715bec68c0f$var$_typeof(oldValue) || $fc9cf715bec68c0f$var$_dom_adapter2.default.isElementNode(oldValue)) return oldValue === newValue;
    return false;
};
$fc9cf715bec68c0f$export$e9bab7fafb253603 = $fc9cf715bec68c0f$var$equals;

});




parcelRegister("gqK38", function(module, exports) {
/**
 * DevExtreme (core/templates/template.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Template = void 0;

var $jFnCG = parcelRequire("jFnCG");
var $bf62cb877eb16c2e$var$_renderer2 = $bf62cb877eb16c2e$var$_interopRequireDefault($jFnCG);

var $9tMwv = parcelRequire("9tMwv");

var $5OzEX = parcelRequire("5OzEX");

var $dMRaC = parcelRequire("dMRaC");
parcelRequire("gVMXw");
function $bf62cb877eb16c2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $bf62cb877eb16c2e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $bf62cb877eb16c2e$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $bf62cb877eb16c2e$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bf62cb877eb16c2e$var$_typeof(obj);
}
function $bf62cb877eb16c2e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bf62cb877eb16c2e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $bf62cb877eb16c2e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $bf62cb877eb16c2e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $bf62cb877eb16c2e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $bf62cb877eb16c2e$var$_inherits(subClass, superClass) {
    if ("function" !== typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $bf62cb877eb16c2e$var$_setPrototypeOf(subClass, superClass);
}
function $bf62cb877eb16c2e$var$_setPrototypeOf(o, p) {
    $bf62cb877eb16c2e$var$_setPrototypeOf = Object.setPrototypeOf || function(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $bf62cb877eb16c2e$var$_setPrototypeOf(o, p);
}
function $bf62cb877eb16c2e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $bf62cb877eb16c2e$var$_isNativeReflectConstruct();
    return function() {
        var result, Super = $bf62cb877eb16c2e$var$_getPrototypeOf(Derived);
        if (hasNativeReflectConstruct) {
            var NewTarget = $bf62cb877eb16c2e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $bf62cb877eb16c2e$var$_possibleConstructorReturn(this, result);
    };
}
function $bf62cb877eb16c2e$var$_possibleConstructorReturn(self, call) {
    if (call && ("object" === $bf62cb877eb16c2e$var$_typeof(call) || "function" === typeof call)) return call;
    return $bf62cb877eb16c2e$var$_assertThisInitialized(self);
}
function $bf62cb877eb16c2e$var$_assertThisInitialized(self) {
    if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $bf62cb877eb16c2e$var$_isNativeReflectConstruct() {
    if ("undefined" === typeof Reflect || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if ("function" === typeof Proxy) return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $bf62cb877eb16c2e$var$_getPrototypeOf(o) {
    $bf62cb877eb16c2e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $bf62cb877eb16c2e$var$_getPrototypeOf(o);
}
(0, $dMRaC.registerTemplateEngine)("default", {
    compile: function(element) {
        return (0, $5OzEX.normalizeTemplateElement)(element);
    },
    render: function(template, model, index) {
        return template.clone();
    }
});
(0, $dMRaC.setTemplateEngine)("default");
var $bf62cb877eb16c2e$var$Template = module.exports.Template = function(_TemplateBase) {
    $bf62cb877eb16c2e$var$_inherits(Template, _TemplateBase);
    var _super = $bf62cb877eb16c2e$var$_createSuper(Template);
    function Template(element) {
        var _this;
        $bf62cb877eb16c2e$var$_classCallCheck(this, Template);
        _this = _super.call(this);
        _this._element = element;
        return _this;
    }
    $bf62cb877eb16c2e$var$_createClass(Template, [
        {
            key: "_renderCore",
            value: function(options) {
                var transclude = options.transclude;
                if (!transclude && !this._compiledTemplate) this._compiledTemplate = (0, $dMRaC.getCurrentTemplateEngine)().compile(this._element);
                return (0, $bf62cb877eb16c2e$var$_renderer2.default)("<div>").append(transclude ? this._element : (0, $dMRaC.getCurrentTemplateEngine)().render(this._compiledTemplate, options.model, options.index)).contents();
            }
        },
        {
            key: "source",
            value: function() {
                return (0, $bf62cb877eb16c2e$var$_renderer2.default)(this._element).clone();
            }
        }
    ]);
    return Template;
}($9tMwv.TemplateBase);

});
parcelRegister("9tMwv", function(module, exports) {
/**
 * DevExtreme (core/templates/template_base.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TemplateBase = module.exports.renderedCallbacks = void 0;

var $jFnCG = parcelRequire("jFnCG");
var $6e6c76391102c04f$var$_renderer2 = $6e6c76391102c04f$var$_interopRequireDefault($jFnCG);

var $445Bz = parcelRequire("445Bz");

var $eKdKS = parcelRequire("eKdKS");
var $6e6c76391102c04f$var$_callbacks2 = $6e6c76391102c04f$var$_interopRequireDefault($eKdKS);

var $5OzEX = parcelRequire("5OzEX");

var $7sX7V = parcelRequire("7sX7V");
var $6e6c76391102c04f$var$_errors2 = $6e6c76391102c04f$var$_interopRequireDefault($7sX7V);
function $6e6c76391102c04f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6e6c76391102c04f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6e6c76391102c04f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6e6c76391102c04f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6e6c76391102c04f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6e6c76391102c04f$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $6e6c76391102c04f$var$renderedCallbacks = module.exports.renderedCallbacks = (0, $6e6c76391102c04f$var$_callbacks2.default)({
    syncStrategy: true
});
var $6e6c76391102c04f$var$TemplateBase = module.exports.TemplateBase = function() {
    function TemplateBase() {
        $6e6c76391102c04f$var$_classCallCheck(this, TemplateBase);
    }
    $6e6c76391102c04f$var$_createClass(TemplateBase, [
        {
            key: "render",
            value: function(options) {
                options = options || {};
                var onRendered = options.onRendered;
                delete options.onRendered;
                var $result = this._renderCore(options);
                this._ensureResultInContainer($result, options.container);
                $6e6c76391102c04f$var$renderedCallbacks.fire($result, options.container);
                onRendered && onRendered();
                return $result;
            }
        },
        {
            key: "_ensureResultInContainer",
            value: function($result, container) {
                if (!container) return;
                var $container = (0, $6e6c76391102c04f$var$_renderer2.default)(container);
                var resultInContainer = (0, $5OzEX.contains)($container.get(0), $result.get(0));
                $container.append($result);
                if (resultInContainer) return;
                var resultInBody = (0, $445Bz.getBody)().contains($container.get(0));
                if (!resultInBody) return;
                (0, $5OzEX.triggerShownEvent)($result);
            }
        },
        {
            key: "_renderCore",
            value: function() {
                throw $6e6c76391102c04f$var$_errors2.default.Error("E0001");
            }
        }
    ]);
    return TemplateBase;
}();

});

parcelRegister("dMRaC", function(module, exports) {
/**
 * DevExtreme (core/templates/template_engine_registry.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.registerTemplateEngine = $a0990092573f6961$var$registerTemplateEngine;
module.exports.setTemplateEngine = $a0990092573f6961$var$setTemplateEngine;
module.exports.getCurrentTemplateEngine = $a0990092573f6961$var$getCurrentTemplateEngine;

var $kDRxH = parcelRequire("kDRxH");

var $7sX7V = parcelRequire("7sX7V");
var $a0990092573f6961$var$_errors2 = $a0990092573f6961$var$_interopRequireDefault($7sX7V);
function $a0990092573f6961$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $a0990092573f6961$var$templateEngines = {};
var $a0990092573f6961$var$currentTemplateEngine;
function $a0990092573f6961$var$registerTemplateEngine(name, templateEngine) {
    $a0990092573f6961$var$templateEngines[name] = templateEngine;
}
function $a0990092573f6961$var$setTemplateEngine(templateEngine) {
    if ((0, $kDRxH.isString)(templateEngine)) {
        $a0990092573f6961$var$currentTemplateEngine = $a0990092573f6961$var$templateEngines[templateEngine];
        if (!$a0990092573f6961$var$currentTemplateEngine) throw $a0990092573f6961$var$_errors2.default.Error("E0020", templateEngine);
    } else $a0990092573f6961$var$currentTemplateEngine = templateEngine;
}
function $a0990092573f6961$var$getCurrentTemplateEngine() {
    return $a0990092573f6961$var$currentTemplateEngine;
}

});

parcelRegister("gVMXw", function(module, exports) {
/**
 * DevExtreme (core/templates/template_engines.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $5OzEX = parcelRequire("5OzEX");

var $dMRaC = parcelRequire("dMRaC");
(0, $dMRaC.registerTemplateEngine)("jquery-tmpl", {
    compile: function(element) {
        return (0, $5OzEX.extractTemplateMarkup)(element);
    },
    render: function(template, data) {
        return jQuery.tmpl(template, data);
    }
});
(0, $dMRaC.registerTemplateEngine)("jsrender", {
    compile: function(element) {
        return (jQuery ? jQuery : jsrender).templates((0, $5OzEX.extractTemplateMarkup)(element));
    },
    render: function(template, data) {
        return template.render(data);
    }
});
(0, $dMRaC.registerTemplateEngine)("mustache", {
    compile: function(element) {
        return (0, $5OzEX.extractTemplateMarkup)(element);
    },
    render: function(template, data) {
        return Mustache.render(template, data);
    }
});
(0, $dMRaC.registerTemplateEngine)("hogan", {
    compile: function(element) {
        return Hogan.compile((0, $5OzEX.extractTemplateMarkup)(element));
    },
    render: function(template, data) {
        return template.render(data);
    }
});
(0, $dMRaC.registerTemplateEngine)("underscore", {
    compile: function(element) {
        return _.template((0, $5OzEX.extractTemplateMarkup)(element));
    },
    render: function(template, data) {
        return template(data);
    }
});
(0, $dMRaC.registerTemplateEngine)("handlebars", {
    compile: function(element) {
        return Handlebars.compile((0, $5OzEX.extractTemplateMarkup)(element));
    },
    render: function(template, data) {
        return template(data);
    }
});
(0, $dMRaC.registerTemplateEngine)("doT", {
    compile: function(element) {
        return doT.template((0, $5OzEX.extractTemplateMarkup)(element));
    },
    render: function(template, data) {
        return template(data);
    }
});

});


parcelRegister("kqsMi", function(module, exports) {
/**
 * DevExtreme (core/templates/function_template.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FunctionTemplate = void 0;

var $9tMwv = parcelRequire("9tMwv");

var $5OzEX = parcelRequire("5OzEX");
function $edec8f14927b83be$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $edec8f14927b83be$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $edec8f14927b83be$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $edec8f14927b83be$var$_typeof(obj);
}
function $edec8f14927b83be$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $edec8f14927b83be$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $edec8f14927b83be$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $edec8f14927b83be$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $edec8f14927b83be$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $edec8f14927b83be$var$_inherits(subClass, superClass) {
    if ("function" !== typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $edec8f14927b83be$var$_setPrototypeOf(subClass, superClass);
}
function $edec8f14927b83be$var$_setPrototypeOf(o, p) {
    $edec8f14927b83be$var$_setPrototypeOf = Object.setPrototypeOf || function(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $edec8f14927b83be$var$_setPrototypeOf(o, p);
}
function $edec8f14927b83be$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $edec8f14927b83be$var$_isNativeReflectConstruct();
    return function() {
        var result, Super = $edec8f14927b83be$var$_getPrototypeOf(Derived);
        if (hasNativeReflectConstruct) {
            var NewTarget = $edec8f14927b83be$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $edec8f14927b83be$var$_possibleConstructorReturn(this, result);
    };
}
function $edec8f14927b83be$var$_possibleConstructorReturn(self, call) {
    if (call && ("object" === $edec8f14927b83be$var$_typeof(call) || "function" === typeof call)) return call;
    return $edec8f14927b83be$var$_assertThisInitialized(self);
}
function $edec8f14927b83be$var$_assertThisInitialized(self) {
    if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $edec8f14927b83be$var$_isNativeReflectConstruct() {
    if ("undefined" === typeof Reflect || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if ("function" === typeof Proxy) return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $edec8f14927b83be$var$_getPrototypeOf(o) {
    $edec8f14927b83be$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $edec8f14927b83be$var$_getPrototypeOf(o);
}
var $edec8f14927b83be$var$FunctionTemplate = module.exports.FunctionTemplate = function(_TemplateBase) {
    $edec8f14927b83be$var$_inherits(FunctionTemplate, _TemplateBase);
    var _super = $edec8f14927b83be$var$_createSuper(FunctionTemplate);
    function FunctionTemplate(render) {
        var _this;
        $edec8f14927b83be$var$_classCallCheck(this, FunctionTemplate);
        _this = _super.call(this);
        _this._render = render;
        return _this;
    }
    $edec8f14927b83be$var$_createClass(FunctionTemplate, [
        {
            key: "_renderCore",
            value: function(options) {
                return (0, $5OzEX.normalizeTemplateElement)(this._render(options));
            }
        }
    ]);
    return FunctionTemplate;
}($9tMwv.TemplateBase);

});

parcelRegister("e5a0x", function(module, exports) {
/**
 * DevExtreme (core/templates/empty_template.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EmptyTemplate = void 0;

var $jFnCG = parcelRequire("jFnCG");
var $a4094ba2ba23f953$var$_renderer2 = $a4094ba2ba23f953$var$_interopRequireDefault($jFnCG);

var $9tMwv = parcelRequire("9tMwv");
function $a4094ba2ba23f953$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $a4094ba2ba23f953$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $a4094ba2ba23f953$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $a4094ba2ba23f953$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a4094ba2ba23f953$var$_typeof(obj);
}
function $a4094ba2ba23f953$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a4094ba2ba23f953$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a4094ba2ba23f953$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a4094ba2ba23f953$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a4094ba2ba23f953$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $a4094ba2ba23f953$var$_inherits(subClass, superClass) {
    if ("function" !== typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $a4094ba2ba23f953$var$_setPrototypeOf(subClass, superClass);
}
function $a4094ba2ba23f953$var$_setPrototypeOf(o, p) {
    $a4094ba2ba23f953$var$_setPrototypeOf = Object.setPrototypeOf || function(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a4094ba2ba23f953$var$_setPrototypeOf(o, p);
}
function $a4094ba2ba23f953$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a4094ba2ba23f953$var$_isNativeReflectConstruct();
    return function() {
        var result, Super = $a4094ba2ba23f953$var$_getPrototypeOf(Derived);
        if (hasNativeReflectConstruct) {
            var NewTarget = $a4094ba2ba23f953$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $a4094ba2ba23f953$var$_possibleConstructorReturn(this, result);
    };
}
function $a4094ba2ba23f953$var$_possibleConstructorReturn(self, call) {
    if (call && ("object" === $a4094ba2ba23f953$var$_typeof(call) || "function" === typeof call)) return call;
    return $a4094ba2ba23f953$var$_assertThisInitialized(self);
}
function $a4094ba2ba23f953$var$_assertThisInitialized(self) {
    if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a4094ba2ba23f953$var$_isNativeReflectConstruct() {
    if ("undefined" === typeof Reflect || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if ("function" === typeof Proxy) return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $a4094ba2ba23f953$var$_getPrototypeOf(o) {
    $a4094ba2ba23f953$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a4094ba2ba23f953$var$_getPrototypeOf(o);
}
var $a4094ba2ba23f953$var$EmptyTemplate = module.exports.EmptyTemplate = function(_TemplateBase) {
    $a4094ba2ba23f953$var$_inherits(EmptyTemplate, _TemplateBase);
    var _super = $a4094ba2ba23f953$var$_createSuper(EmptyTemplate);
    function EmptyTemplate() {
        $a4094ba2ba23f953$var$_classCallCheck(this, EmptyTemplate);
        return _super.apply(this, arguments);
    }
    $a4094ba2ba23f953$var$_createClass(EmptyTemplate, [
        {
            key: "_renderCore",
            value: function() {
                return (0, $a4094ba2ba23f953$var$_renderer2.default)();
            }
        }
    ]);
    return EmptyTemplate;
}($9tMwv.TemplateBase);

});

parcelRegister("4dqlD", function(module, exports) {
/**
 * DevExtreme (core/templates/child_default_template.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ChildDefaultTemplate = void 0;

var $9tMwv = parcelRequire("9tMwv");
function $311cd07e64b34597$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $311cd07e64b34597$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $311cd07e64b34597$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $311cd07e64b34597$var$_typeof(obj);
}
function $311cd07e64b34597$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $311cd07e64b34597$var$_inherits(subClass, superClass) {
    if ("function" !== typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $311cd07e64b34597$var$_setPrototypeOf(subClass, superClass);
}
function $311cd07e64b34597$var$_setPrototypeOf(o, p) {
    $311cd07e64b34597$var$_setPrototypeOf = Object.setPrototypeOf || function(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $311cd07e64b34597$var$_setPrototypeOf(o, p);
}
function $311cd07e64b34597$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $311cd07e64b34597$var$_isNativeReflectConstruct();
    return function() {
        var result, Super = $311cd07e64b34597$var$_getPrototypeOf(Derived);
        if (hasNativeReflectConstruct) {
            var NewTarget = $311cd07e64b34597$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $311cd07e64b34597$var$_possibleConstructorReturn(this, result);
    };
}
function $311cd07e64b34597$var$_possibleConstructorReturn(self, call) {
    if (call && ("object" === $311cd07e64b34597$var$_typeof(call) || "function" === typeof call)) return call;
    return $311cd07e64b34597$var$_assertThisInitialized(self);
}
function $311cd07e64b34597$var$_assertThisInitialized(self) {
    if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $311cd07e64b34597$var$_isNativeReflectConstruct() {
    if ("undefined" === typeof Reflect || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if ("function" === typeof Proxy) return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $311cd07e64b34597$var$_getPrototypeOf(o) {
    $311cd07e64b34597$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $311cd07e64b34597$var$_getPrototypeOf(o);
}
var $311cd07e64b34597$var$ChildDefaultTemplate = module.exports.ChildDefaultTemplate = function(_TemplateBase) {
    $311cd07e64b34597$var$_inherits(ChildDefaultTemplate, _TemplateBase);
    var _super = $311cd07e64b34597$var$_createSuper(ChildDefaultTemplate);
    function ChildDefaultTemplate(name) {
        var _this;
        $311cd07e64b34597$var$_classCallCheck(this, ChildDefaultTemplate);
        _this = _super.call(this);
        _this.name = name;
        return _this;
    }
    return ChildDefaultTemplate;
}($9tMwv.TemplateBase);

});


parcelRegister("2ADoP", function(module, exports) {
/**
 * DevExtreme (ui/widget/ui.keyboard_processor.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $1e2d817d5cea5a9f$var$_renderer2 = $1e2d817d5cea5a9f$var$_interopRequireDefault($jFnCG);

var $e1LMc = parcelRequire("e1LMc");
var $1e2d817d5cea5a9f$var$_events_engine2 = $1e2d817d5cea5a9f$var$_interopRequireDefault($e1LMc);

var $k7aJb = parcelRequire("k7aJb");
var $1e2d817d5cea5a9f$var$_class2 = $1e2d817d5cea5a9f$var$_interopRequireDefault($k7aJb);

var $aLQK5 = parcelRequire("aLQK5");

var $4Pwuy = parcelRequire("4Pwuy");

var $bXb2w = parcelRequire("bXb2w");
function $1e2d817d5cea5a9f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $1e2d817d5cea5a9f$var$COMPOSITION_START_EVENT = "compositionstart";
var $1e2d817d5cea5a9f$var$COMPOSITION_END_EVENT = "compositionend";
var $1e2d817d5cea5a9f$var$KEYDOWN_EVENT = "keydown";
var $1e2d817d5cea5a9f$var$NAMESPACE = "KeyboardProcessor";
var $1e2d817d5cea5a9f$var$KeyboardProcessor = $1e2d817d5cea5a9f$var$_class2.default.inherit({
    _keydown: (0, $bXb2w.addNamespace)($1e2d817d5cea5a9f$var$KEYDOWN_EVENT, $1e2d817d5cea5a9f$var$NAMESPACE),
    _compositionStart: (0, $bXb2w.addNamespace)($1e2d817d5cea5a9f$var$COMPOSITION_START_EVENT, $1e2d817d5cea5a9f$var$NAMESPACE),
    _compositionEnd: (0, $bXb2w.addNamespace)($1e2d817d5cea5a9f$var$COMPOSITION_END_EVENT, $1e2d817d5cea5a9f$var$NAMESPACE),
    ctor: function(options) {
        var _this = this;
        options = options || {};
        if (options.element) this._element = (0, $1e2d817d5cea5a9f$var$_renderer2.default)(options.element);
        if (options.focusTarget) this._focusTarget = options.focusTarget;
        this._handler = options.handler;
        this._context = options.context;
        this._childProcessors = [];
        if (this._element) {
            this._processFunction = function(e) {
                var isNotFocusTarget = _this._focusTarget && _this._focusTarget !== e.target && (0, $aLQK5.inArray)(e.target, _this._focusTarget) < 0;
                var shouldSkipProcessing = _this._isComposingJustFinished && 229 === e.which || _this._isComposing || isNotFocusTarget;
                _this._isComposingJustFinished = false;
                if (!shouldSkipProcessing) _this.process(e);
            };
            this._toggleProcessingWithContext = this.toggleProcessing.bind(this);
            $1e2d817d5cea5a9f$var$_events_engine2.default.on(this._element, this._keydown, this._processFunction);
            $1e2d817d5cea5a9f$var$_events_engine2.default.on(this._element, this._compositionStart, this._toggleProcessingWithContext);
            $1e2d817d5cea5a9f$var$_events_engine2.default.on(this._element, this._compositionEnd, this._toggleProcessingWithContext);
        }
    },
    dispose: function() {
        if (this._element) {
            $1e2d817d5cea5a9f$var$_events_engine2.default.off(this._element, this._keydown, this._processFunction);
            $1e2d817d5cea5a9f$var$_events_engine2.default.off(this._element, this._compositionStart, this._toggleProcessingWithContext);
            $1e2d817d5cea5a9f$var$_events_engine2.default.off(this._element, this._compositionEnd, this._toggleProcessingWithContext);
        }
        this._element = void 0;
        this._handler = void 0;
        this._context = void 0;
        this._childProcessors = void 0;
    },
    clearChildren: function() {
        this._childProcessors = [];
    },
    push: function(child) {
        if (!this._childProcessors) this.clearChildren();
        this._childProcessors.push(child);
        return child;
    },
    attachChildProcessor: function() {
        var childProcessor = new $1e2d817d5cea5a9f$var$KeyboardProcessor;
        this._childProcessors.push(childProcessor);
        return childProcessor;
    },
    reinitialize: function(childHandler, childContext) {
        this._context = childContext;
        this._handler = childHandler;
        return this;
    },
    process: function(e) {
        var args = {
            keyName: (0, $bXb2w.normalizeKeyName)(e),
            key: e.key,
            code: e.code,
            ctrl: e.ctrlKey,
            location: e.location,
            metaKey: e.metaKey,
            shift: e.shiftKey,
            alt: e.altKey,
            which: e.which,
            originalEvent: e
        };
        var handlerResult = this._handler && this._handler.call(this._context, args);
        if (handlerResult && this._childProcessors) (0, $4Pwuy.each)(this._childProcessors, function(index, childProcessor) {
            childProcessor.process(e);
        });
    },
    toggleProcessing: function(_ref) {
        var type = _ref.type;
        this._isComposing = type === $1e2d817d5cea5a9f$var$COMPOSITION_START_EVENT;
        this._isComposingJustFinished = !this._isComposing;
    }
});
module.exports = $1e2d817d5cea5a9f$var$KeyboardProcessor;

});
parcelRegister("bXb2w", function(module, exports) {
/**
 * DevExtreme (events/utils.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $8b3dc4a79db8f251$var$_renderer2 = $8b3dc4a79db8f251$var$_interopRequireDefault($jFnCG);

var $e1LMc = parcelRequire("e1LMc");
var $8b3dc4a79db8f251$var$_events_engine2 = $8b3dc4a79db8f251$var$_interopRequireDefault($e1LMc);

var $7sX7V = parcelRequire("7sX7V");
var $8b3dc4a79db8f251$var$_errors2 = $8b3dc4a79db8f251$var$_interopRequireDefault($7sX7V);

var $3joCJ = parcelRequire("3joCJ");

var $7I8Uw = parcelRequire("7I8Uw");

var $4Pwuy = parcelRequire("4Pwuy");
function $8b3dc4a79db8f251$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $8b3dc4a79db8f251$var$KEY_MAP = {
    backspace: "backspace",
    tab: "tab",
    enter: "enter",
    escape: "escape",
    pageup: "pageUp",
    pagedown: "pageDown",
    end: "end",
    home: "home",
    arrowleft: "leftArrow",
    arrowup: "upArrow",
    arrowright: "rightArrow",
    arrowdown: "downArrow",
    "delete": "del",
    " ": "space",
    f: "F",
    a: "A",
    "*": "asterisk",
    "-": "minus",
    alt: "alt",
    control: "control",
    shift: "shift",
    left: "leftArrow",
    up: "upArrow",
    right: "rightArrow",
    down: "downArrow",
    multiply: "asterisk",
    spacebar: "space",
    del: "del",
    subtract: "minus",
    esc: "escape"
};
var $8b3dc4a79db8f251$var$LEGACY_KEY_CODES = {
    8: "backspace",
    9: "tab",
    13: "enter",
    27: "escape",
    33: "pageUp",
    34: "pageDown",
    35: "end",
    36: "home",
    37: "leftArrow",
    38: "upArrow",
    39: "rightArrow",
    40: "downArrow",
    46: "del",
    32: "space",
    70: "F",
    65: "A",
    106: "asterisk",
    109: "minus",
    189: "minus",
    173: "minus",
    16: "shift",
    17: "control",
    18: "alt"
};
var $8b3dc4a79db8f251$var$eventSource = function() {
    var EVENT_SOURCES_REGEX = {
        dx: /^dx/i,
        mouse: /(mouse|wheel)/i,
        touch: /^touch/i,
        keyboard: /^key/i,
        pointer: /^(ms)?pointer/i
    };
    return function(e) {
        var result = "other";
        (0, $4Pwuy.each)(EVENT_SOURCES_REGEX, function(key) {
            if (this.test(e.type)) {
                result = key;
                return false;
            }
        });
        return result;
    };
}();
var $8b3dc4a79db8f251$var$isDxEvent = function(e) {
    return "dx" === $8b3dc4a79db8f251$var$eventSource(e);
};
var $8b3dc4a79db8f251$var$isNativeMouseEvent = function(e) {
    return "mouse" === $8b3dc4a79db8f251$var$eventSource(e);
};
var $8b3dc4a79db8f251$var$isNativeTouchEvent = function(e) {
    return "touch" === $8b3dc4a79db8f251$var$eventSource(e);
};
var $8b3dc4a79db8f251$var$isPointerEvent = function(e) {
    return "pointer" === $8b3dc4a79db8f251$var$eventSource(e);
};
var $8b3dc4a79db8f251$var$isMouseEvent = function(e) {
    return $8b3dc4a79db8f251$var$isNativeMouseEvent(e) || ($8b3dc4a79db8f251$var$isPointerEvent(e) || $8b3dc4a79db8f251$var$isDxEvent(e)) && "mouse" === e.pointerType;
};
var $8b3dc4a79db8f251$var$isDxMouseWheelEvent = function(e) {
    return e && "dxmousewheel" === e.type;
};
var $8b3dc4a79db8f251$var$isTouchEvent = function(e) {
    return $8b3dc4a79db8f251$var$isNativeTouchEvent(e) || ($8b3dc4a79db8f251$var$isPointerEvent(e) || $8b3dc4a79db8f251$var$isDxEvent(e)) && "touch" === e.pointerType;
};
var $8b3dc4a79db8f251$var$isKeyboardEvent = function(e) {
    return "keyboard" === $8b3dc4a79db8f251$var$eventSource(e);
};
var $8b3dc4a79db8f251$var$isFakeClickEvent = function(e) {
    return 0 === e.screenX && !e.offsetX && 0 === e.pageX;
};
var $8b3dc4a79db8f251$var$eventData = function(e) {
    return {
        x: e.pageX,
        y: e.pageY,
        time: e.timeStamp
    };
};
var $8b3dc4a79db8f251$var$eventDelta = function(from, to) {
    return {
        x: to.x - from.x,
        y: to.y - from.y,
        time: to.time - from.time || 1
    };
};
var $8b3dc4a79db8f251$var$hasTouches = function(e) {
    if ($8b3dc4a79db8f251$var$isNativeTouchEvent(e)) return (e.originalEvent.touches || []).length;
    if ($8b3dc4a79db8f251$var$isDxEvent(e)) return (e.pointers || []).length;
    return 0;
};
var $8b3dc4a79db8f251$var$needSkipEvent = function(e) {
    var target = e.target;
    var $target = (0, $8b3dc4a79db8f251$var$_renderer2.default)(target);
    var touchInInput = $target.is("input, textarea, select");
    if ($target.is(".dx-skip-gesture-event *, .dx-skip-gesture-event")) return true;
    if ($8b3dc4a79db8f251$var$isDxMouseWheelEvent(e)) {
        var isTextArea = $target.is("textarea") && $target.hasClass("dx-texteditor-input");
        if (isTextArea) return false;
        var isContentEditable = target.isContentEditable || target.hasAttribute("contenteditable");
        if (isContentEditable) return false;
        var isInputFocused = $target.is("input[type='number'], textarea, select") && $target.is(":focus");
        return isInputFocused;
    }
    if ($8b3dc4a79db8f251$var$isMouseEvent(e)) return touchInInput || e.which > 1;
    if ($8b3dc4a79db8f251$var$isTouchEvent(e)) return touchInInput && (0, $3joCJ.focused)($target);
};
var $8b3dc4a79db8f251$var$fixMethod = function(e) {
    return e;
};
var $8b3dc4a79db8f251$var$setEventFixMethod = function(func) {
    $8b3dc4a79db8f251$var$fixMethod = func;
};
var $8b3dc4a79db8f251$var$copyEvent = function(originalEvent) {
    return $8b3dc4a79db8f251$var$fixMethod($8b3dc4a79db8f251$var$_events_engine2.default.Event(originalEvent, originalEvent), originalEvent);
};
var $8b3dc4a79db8f251$var$createEvent = function(originalEvent, args) {
    var event = $8b3dc4a79db8f251$var$copyEvent(originalEvent);
    if (args) (0, $7I8Uw.extend)(event, args);
    return event;
};
var $8b3dc4a79db8f251$var$fireEvent = function(props) {
    var event = $8b3dc4a79db8f251$var$createEvent(props.originalEvent, props);
    $8b3dc4a79db8f251$var$_events_engine2.default.trigger(props.delegateTarget || event.target, event);
    return event;
};
var $8b3dc4a79db8f251$var$addNamespace = function addNamespace(eventNames, namespace) {
    if (!namespace) throw $8b3dc4a79db8f251$var$_errors2.default.Error("E0017");
    if ("string" === typeof eventNames) {
        if (eventNames.indexOf(" ") === -1) return eventNames + "." + namespace;
        return addNamespace(eventNames.split(/\s+/g), namespace);
    }
    (0, $4Pwuy.each)(eventNames, function(index, eventName) {
        eventNames[index] = eventName + "." + namespace;
    });
    return eventNames.join(" ");
};
var $8b3dc4a79db8f251$var$normalizeKeyName = function(event) {
    var isKeySupported = !!event.key;
    var key = isKeySupported ? event.key : event.which;
    if (!key) return;
    if (isKeySupported) key = $8b3dc4a79db8f251$var$KEY_MAP[key.toLowerCase()] || key;
    else key = $8b3dc4a79db8f251$var$LEGACY_KEY_CODES[key] || String.fromCharCode(key);
    return key;
};
var $8b3dc4a79db8f251$var$getChar = function(event) {
    return event.key || String.fromCharCode(event.which);
};
module.exports = {
    eventSource: $8b3dc4a79db8f251$var$eventSource,
    isPointerEvent: $8b3dc4a79db8f251$var$isPointerEvent,
    isMouseEvent: $8b3dc4a79db8f251$var$isMouseEvent,
    isDxMouseWheelEvent: $8b3dc4a79db8f251$var$isDxMouseWheelEvent,
    isTouchEvent: $8b3dc4a79db8f251$var$isTouchEvent,
    isKeyboardEvent: $8b3dc4a79db8f251$var$isKeyboardEvent,
    isFakeClickEvent: $8b3dc4a79db8f251$var$isFakeClickEvent,
    hasTouches: $8b3dc4a79db8f251$var$hasTouches,
    eventData: $8b3dc4a79db8f251$var$eventData,
    eventDelta: $8b3dc4a79db8f251$var$eventDelta,
    needSkipEvent: $8b3dc4a79db8f251$var$needSkipEvent,
    createEvent: $8b3dc4a79db8f251$var$createEvent,
    fireEvent: $8b3dc4a79db8f251$var$fireEvent,
    addNamespace: $8b3dc4a79db8f251$var$addNamespace,
    setEventFixMethod: $8b3dc4a79db8f251$var$setEventFixMethod,
    normalizeKeyName: $8b3dc4a79db8f251$var$normalizeKeyName,
    getChar: $8b3dc4a79db8f251$var$getChar
};

});
parcelRegister("3joCJ", function(module, exports) {
/**
 * DevExtreme (ui/widget/selectors.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $445Bz = parcelRequire("445Bz");
var $26963f334f852f59$var$_focusable = function(element, tabIndex) {
    if (!$26963f334f852f59$var$visible(element)) return false;
    var nodeName = element.nodeName.toLowerCase();
    var isTabIndexNotNaN = !isNaN(tabIndex);
    var isDisabled = element.disabled;
    var isDefaultFocus = /^(input|select|textarea|button|object|iframe)$/.test(nodeName);
    var isHyperlink = "a" === nodeName;
    var isFocusable = true;
    var isContentEditable = element.isContentEditable;
    if (isDefaultFocus || isContentEditable) isFocusable = !isDisabled;
    else if (isHyperlink) isFocusable = element.href || isTabIndexNotNaN;
    else isFocusable = isTabIndexNotNaN;
    return isFocusable;
};
var $26963f334f852f59$var$visible = function(element) {
    var $element = $jFnCG(element);
    return $element.is(":visible") && "hidden" !== $element.css("visibility") && "hidden" !== $element.parents().css("visibility");
};
module.exports = {
    focusable: function(index, element) {
        return $26963f334f852f59$var$_focusable(element, $jFnCG(element).attr("tabIndex"));
    },
    tabbable: function(index, element) {
        var tabIndex = $jFnCG(element).attr("tabIndex");
        return (isNaN(tabIndex) || tabIndex >= 0) && $26963f334f852f59$var$_focusable(element, tabIndex);
    },
    focused: function($element) {
        var element = $jFnCG($element).get(0);
        return $445Bz.getActiveElement() === element;
    }
};

});



parcelRegister("fbrwv", function(module, exports) {

$parcel$export(module.exports, "start", () => $b0dd3ba4fba95df4$export$b3571188c770cc5a, (v) => $b0dd3ba4fba95df4$export$b3571188c770cc5a = v);
$parcel$export(module.exports, "end", () => $b0dd3ba4fba95df4$export$bd5df0f255a350f8, (v) => $b0dd3ba4fba95df4$export$bd5df0f255a350f8 = v);
/**
 * DevExtreme (events/hover.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $b0dd3ba4fba95df4$export$b3571188c770cc5a;
var $b0dd3ba4fba95df4$export$bd5df0f255a350f8;
"use strict";

var $e1LMc = parcelRequire("e1LMc");

var $8ulMI = parcelRequire("8ulMI");

var $k7aJb = parcelRequire("k7aJb");

var $aiwte = parcelRequire("aiwte");

var $cMvU0 = parcelRequire("cMvU0");

var $bXb2w = parcelRequire("bXb2w");

var $gP4Gh = parcelRequire("gP4Gh");
var $b0dd3ba4fba95df4$var$HOVERSTART_NAMESPACE = "dxHoverStart";
var $b0dd3ba4fba95df4$var$HOVERSTART = "dxhoverstart";
var $b0dd3ba4fba95df4$var$POINTERENTER_NAMESPACED_EVENT_NAME = $bXb2w.addNamespace($gP4Gh.enter, $b0dd3ba4fba95df4$var$HOVERSTART_NAMESPACE);
var $b0dd3ba4fba95df4$var$HOVEREND_NAMESPACE = "dxHoverEnd";
var $b0dd3ba4fba95df4$var$HOVEREND = "dxhoverend";
var $b0dd3ba4fba95df4$var$POINTERLEAVE_NAMESPACED_EVENT_NAME = $bXb2w.addNamespace($gP4Gh.leave, $b0dd3ba4fba95df4$var$HOVEREND_NAMESPACE);
var $b0dd3ba4fba95df4$var$Hover = $k7aJb.inherit({
    noBubble: true,
    ctor: function() {
        this._handlerArrayKeyPath = this._eventNamespace + "_HandlerStore";
    },
    setup: function(element) {
        $8ulMI.data(element, this._handlerArrayKeyPath, {});
    },
    add: function(element, handleObj) {
        var that = this;
        var handler = function(e) {
            that._handler(e);
        };
        $e1LMc.on(element, this._originalEventName, handleObj.selector, handler);
        $8ulMI.data(element, this._handlerArrayKeyPath)[handleObj.guid] = handler;
    },
    _handler: function(e) {
        if ($bXb2w.isTouchEvent(e) || $aiwte.isSimulator()) return;
        $bXb2w.fireEvent({
            type: this._eventName,
            originalEvent: e,
            delegateTarget: e.delegateTarget
        });
    },
    remove: function(element, handleObj) {
        var handler = $8ulMI.data(element, this._handlerArrayKeyPath)[handleObj.guid];
        $e1LMc.off(element, this._originalEventName, handleObj.selector, handler);
    },
    teardown: function(element) {
        $8ulMI.removeData(element, this._handlerArrayKeyPath);
    }
});
var $b0dd3ba4fba95df4$var$HoverStart = $b0dd3ba4fba95df4$var$Hover.inherit({
    ctor: function() {
        this._eventNamespace = $b0dd3ba4fba95df4$var$HOVERSTART_NAMESPACE;
        this._eventName = $b0dd3ba4fba95df4$var$HOVERSTART;
        this._originalEventName = $b0dd3ba4fba95df4$var$POINTERENTER_NAMESPACED_EVENT_NAME;
        this.callBase();
    },
    _handler: function(e) {
        var pointers = e.pointers || [];
        if (!pointers.length) this.callBase(e);
    }
});
var $b0dd3ba4fba95df4$var$HoverEnd = $b0dd3ba4fba95df4$var$Hover.inherit({
    ctor: function() {
        this._eventNamespace = $b0dd3ba4fba95df4$var$HOVEREND_NAMESPACE;
        this._eventName = $b0dd3ba4fba95df4$var$HOVEREND;
        this._originalEventName = $b0dd3ba4fba95df4$var$POINTERLEAVE_NAMESPACED_EVENT_NAME;
        this.callBase();
    }
});
$cMvU0($b0dd3ba4fba95df4$var$HOVERSTART, new $b0dd3ba4fba95df4$var$HoverStart);
$cMvU0($b0dd3ba4fba95df4$var$HOVEREND, new $b0dd3ba4fba95df4$var$HoverEnd);
$b0dd3ba4fba95df4$export$b3571188c770cc5a = $b0dd3ba4fba95df4$var$HOVERSTART;
$b0dd3ba4fba95df4$export$bd5df0f255a350f8 = $b0dd3ba4fba95df4$var$HOVEREND;

});
parcelRegister("gP4Gh", function(module, exports) {
/**
 * DevExtreme (events/pointer.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $6VAWB = parcelRequire("6VAWB");
var $c3f50a4a44199204$var$_support2 = $c3f50a4a44199204$var$_interopRequireDefault($6VAWB);

var $4Pwuy = parcelRequire("4Pwuy");

var $bvcPv = parcelRequire("bvcPv");
var $c3f50a4a44199204$var$_browser2 = $c3f50a4a44199204$var$_interopRequireDefault($bvcPv);

var $aiwte = parcelRequire("aiwte");
var $c3f50a4a44199204$var$_devices2 = $c3f50a4a44199204$var$_interopRequireDefault($aiwte);

var $cMvU0 = parcelRequire("cMvU0");
var $c3f50a4a44199204$var$_event_registrator2 = $c3f50a4a44199204$var$_interopRequireDefault($cMvU0);

var $a3SFB = parcelRequire("a3SFB");
var $c3f50a4a44199204$var$_touch2 = $c3f50a4a44199204$var$_interopRequireDefault($a3SFB);

var $3l6X8 = parcelRequire("3l6X8");
var $c3f50a4a44199204$var$_mspointer2 = $c3f50a4a44199204$var$_interopRequireDefault($3l6X8);

var $9R24H = parcelRequire("9R24H");
var $c3f50a4a44199204$var$_mouse2 = $c3f50a4a44199204$var$_interopRequireDefault($9R24H);

var $gHnK7 = parcelRequire("gHnK7");
var $c3f50a4a44199204$var$_mouse_and_touch2 = $c3f50a4a44199204$var$_interopRequireDefault($gHnK7);
function $c3f50a4a44199204$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $c3f50a4a44199204$var$getStrategy = function(support, device, browser) {
    if (support.pointerEvents && browser.msie) return $c3f50a4a44199204$var$_mspointer2.default;
    var tablet = device.tablet, phone = device.phone;
    if (support.touch && !(tablet || phone)) return $c3f50a4a44199204$var$_mouse_and_touch2.default;
    if (support.touch) return $c3f50a4a44199204$var$_touch2.default;
    return $c3f50a4a44199204$var$_mouse2.default;
};
var $c3f50a4a44199204$var$EventStrategy = $c3f50a4a44199204$var$getStrategy($c3f50a4a44199204$var$_support2.default, $c3f50a4a44199204$var$_devices2.default.real(), $c3f50a4a44199204$var$_browser2.default);
(0, $4Pwuy.each)($c3f50a4a44199204$var$EventStrategy.map, function(pointerEvent, originalEvents) {
    (0, $c3f50a4a44199204$var$_event_registrator2.default)(pointerEvent, new $c3f50a4a44199204$var$EventStrategy(pointerEvent, originalEvents));
});
var $c3f50a4a44199204$var$pointer = {
    down: "dxpointerdown",
    up: "dxpointerup",
    move: "dxpointermove",
    cancel: "dxpointercancel",
    enter: "dxpointerenter",
    leave: "dxpointerleave",
    over: "dxpointerover",
    out: "dxpointerout"
};
module.exports = $c3f50a4a44199204$var$pointer;

});
parcelRegister("6VAWB", function(module, exports) {

$parcel$export(module.exports, "touchEvents", () => $50b4b946063828cb$export$fa367689c659e65c, (v) => $50b4b946063828cb$export$fa367689c659e65c = v);
$parcel$export(module.exports, "pointerEvents", () => $50b4b946063828cb$export$c731eab7619e00a0, (v) => $50b4b946063828cb$export$c731eab7619e00a0 = v);
$parcel$export(module.exports, "touch", () => $50b4b946063828cb$export$d0b7ea69ab6056df, (v) => $50b4b946063828cb$export$d0b7ea69ab6056df = v);
$parcel$export(module.exports, "transition", () => $50b4b946063828cb$export$66bb15e2994e6a26, (v) => $50b4b946063828cb$export$66bb15e2994e6a26 = v);
$parcel$export(module.exports, "transitionEndEventName", () => $50b4b946063828cb$export$48b356d8c96d83a9, (v) => $50b4b946063828cb$export$48b356d8c96d83a9 = v);
$parcel$export(module.exports, "animation", () => $50b4b946063828cb$export$ecad260a8a5fef4f, (v) => $50b4b946063828cb$export$ecad260a8a5fef4f = v);
$parcel$export(module.exports, "nativeScrolling", () => $50b4b946063828cb$export$4259b5f542d10b5a, (v) => $50b4b946063828cb$export$4259b5f542d10b5a = v);
$parcel$export(module.exports, "styleProp", () => $50b4b946063828cb$export$5d4cd24aaf68552c, (v) => $50b4b946063828cb$export$5d4cd24aaf68552c = v);
$parcel$export(module.exports, "stylePropPrefix", () => $50b4b946063828cb$export$3dcfa7045287299, (v) => $50b4b946063828cb$export$3dcfa7045287299 = v);
$parcel$export(module.exports, "supportProp", () => $50b4b946063828cb$export$8fb65db1a1efa349, (v) => $50b4b946063828cb$export$8fb65db1a1efa349 = v);
$parcel$export(module.exports, "inputType", () => $50b4b946063828cb$export$2611efed378f0f66, (v) => $50b4b946063828cb$export$2611efed378f0f66 = v);
/**
 * DevExtreme (core/utils/support.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $50b4b946063828cb$export$fa367689c659e65c;
var $50b4b946063828cb$export$c731eab7619e00a0;
var $50b4b946063828cb$export$d0b7ea69ab6056df;
var $50b4b946063828cb$export$66bb15e2994e6a26;
var $50b4b946063828cb$export$48b356d8c96d83a9;
var $50b4b946063828cb$export$ecad260a8a5fef4f;
var $50b4b946063828cb$export$4259b5f542d10b5a;
var $50b4b946063828cb$export$5d4cd24aaf68552c;
var $50b4b946063828cb$export$3dcfa7045287299;
var $50b4b946063828cb$export$8fb65db1a1efa349;
var $50b4b946063828cb$export$2611efed378f0f66;
"use strict";

var $aLQK5 = parcelRequire("aLQK5");

var $445Bz = parcelRequire("445Bz");

var $2Mto0 = parcelRequire("2Mto0");

var $ePlHj = parcelRequire("ePlHj");
var $50b4b946063828cb$var$_call_once2 = $50b4b946063828cb$var$_interopRequireDefault($ePlHj);

var $irv64 = parcelRequire("irv64");
var $50b4b946063828cb$var$_window2 = $50b4b946063828cb$var$_interopRequireDefault($irv64);

var $aiwte = parcelRequire("aiwte");
var $50b4b946063828cb$var$_devices2 = $50b4b946063828cb$var$_interopRequireDefault($aiwte);

var $9Z7y9 = parcelRequire("9Z7y9");
var $50b4b946063828cb$var$_style2 = $50b4b946063828cb$var$_interopRequireDefault($9Z7y9);
function $50b4b946063828cb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $50b4b946063828cb$var$_windowUtils$getNavig = $50b4b946063828cb$var$_window2.default.getNavigator(), $50b4b946063828cb$var$maxTouchPoints = $50b4b946063828cb$var$_windowUtils$getNavig.maxTouchPoints, $50b4b946063828cb$var$msMaxTouchPoints = $50b4b946063828cb$var$_windowUtils$getNavig.msMaxTouchPoints, $50b4b946063828cb$var$pointerEnabled = $50b4b946063828cb$var$_windowUtils$getNavig.pointerEnabled;
var $50b4b946063828cb$var$hasProperty = $50b4b946063828cb$var$_window2.default.hasProperty.bind($50b4b946063828cb$var$_window2.default);
var $50b4b946063828cb$var$transitionEndEventNames = {
    webkitTransition: "webkitTransitionEnd",
    MozTransition: "transitionend",
    OTransition: "oTransitionEnd",
    msTransition: "MsTransitionEnd",
    transition: "transitionend"
};
var $50b4b946063828cb$var$supportProp = function(prop) {
    return !!$50b4b946063828cb$var$_style2.default.styleProp(prop);
};
var $50b4b946063828cb$var$isNativeScrollingSupported = function() {
    var _devices$real = $50b4b946063828cb$var$_devices2.default.real(), platform = _devices$real.platform, version = _devices$real.version, isMac = _devices$real.mac;
    var isObsoleteAndroid = version && version[0] < 4 && "android" === platform;
    var isNativeScrollDevice = !isObsoleteAndroid && (0, $aLQK5.inArray)(platform, [
        "ios",
        "android"
    ]) > -1 || isMac;
    return isNativeScrollDevice;
};
var $50b4b946063828cb$var$inputType = function(type) {
    if ("text" === type) return true;
    var input = (0, $445Bz.createElement)("input");
    try {
        input.setAttribute("type", type);
        input.value = "wrongValue";
        return !input.value;
    } catch (e) {
        return false;
    }
};
var $50b4b946063828cb$var$detectTouchEvents = function(hasWindowProperty, maxTouchPoints) {
    return (hasWindowProperty("ontouchstart") || !!maxTouchPoints) && !hasWindowProperty("callPhantom");
};
var $50b4b946063828cb$var$detectPointerEvent = function(hasWindowProperty, pointerEnabled) {
    var isPointerEnabled = (0, $2Mto0.ensureDefined)(pointerEnabled, true);
    var canUsePointerEvent = (0, $2Mto0.ensureDefined)(pointerEnabled, false);
    return hasWindowProperty("PointerEvent") && isPointerEnabled || canUsePointerEvent;
};
var $50b4b946063828cb$var$touchEvents = $50b4b946063828cb$var$detectTouchEvents($50b4b946063828cb$var$hasProperty, $50b4b946063828cb$var$maxTouchPoints);
var $50b4b946063828cb$var$pointerEvents = $50b4b946063828cb$var$detectPointerEvent($50b4b946063828cb$var$hasProperty, $50b4b946063828cb$var$pointerEnabled);
var $50b4b946063828cb$var$touchPointersPresent = !!$50b4b946063828cb$var$maxTouchPoints || !!$50b4b946063828cb$var$msMaxTouchPoints;
$50b4b946063828cb$export$fa367689c659e65c = $50b4b946063828cb$var$touchEvents;
$50b4b946063828cb$export$c731eab7619e00a0 = $50b4b946063828cb$var$pointerEvents;
$50b4b946063828cb$export$d0b7ea69ab6056df = $50b4b946063828cb$var$touchEvents || $50b4b946063828cb$var$pointerEvents && $50b4b946063828cb$var$touchPointersPresent;
$50b4b946063828cb$export$66bb15e2994e6a26 = (0, $50b4b946063828cb$var$_call_once2.default)(function() {
    return $50b4b946063828cb$var$supportProp("transition");
});
$50b4b946063828cb$export$48b356d8c96d83a9 = (0, $50b4b946063828cb$var$_call_once2.default)(function() {
    return $50b4b946063828cb$var$transitionEndEventNames[$50b4b946063828cb$var$_style2.default.styleProp("transition")];
});
$50b4b946063828cb$export$ecad260a8a5fef4f = (0, $50b4b946063828cb$var$_call_once2.default)(function() {
    return $50b4b946063828cb$var$supportProp("animation");
});
$50b4b946063828cb$export$4259b5f542d10b5a = $50b4b946063828cb$var$isNativeScrollingSupported();
$50b4b946063828cb$export$5d4cd24aaf68552c = $50b4b946063828cb$var$_style2.default.styleProp;
$50b4b946063828cb$export$3dcfa7045287299 = $50b4b946063828cb$var$_style2.default.stylePropPrefix;
$50b4b946063828cb$export$8fb65db1a1efa349 = $50b4b946063828cb$var$supportProp;
$50b4b946063828cb$export$2611efed378f0f66 = $50b4b946063828cb$var$inputType;

});

parcelRegister("bvcPv", function(module, exports) {
/**
 * DevExtreme (core/utils/browser.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $7I8Uw = parcelRequire("7I8Uw");
var $85fc8aaca067e6ec$require$extend = $7I8Uw.extend;

var $irv64 = parcelRequire("irv64");
var $85fc8aaca067e6ec$var$navigator = $irv64.getNavigator();
var $85fc8aaca067e6ec$var$webkitRegExp = /(webkit)[ \/]([\w.]+)/;
var $85fc8aaca067e6ec$var$ieRegExp = /(msie) (\d{1,2}\.\d)/;
var $85fc8aaca067e6ec$var$ie11RegExp = /(trident).*rv:(\d{1,2}\.\d)/;
var $85fc8aaca067e6ec$var$msEdge = /(edge)\/((\d+)?[\w.]+)/;
var $85fc8aaca067e6ec$var$mozillaRegExp = /(mozilla)(?:.*? rv:([\w.]+))/;
var $85fc8aaca067e6ec$var$browserFromUA = function(ua) {
    ua = ua.toLowerCase();
    var result = {};
    var matches = $85fc8aaca067e6ec$var$ieRegExp.exec(ua) || $85fc8aaca067e6ec$var$ie11RegExp.exec(ua) || $85fc8aaca067e6ec$var$msEdge.exec(ua) || ua.indexOf("compatible") < 0 && $85fc8aaca067e6ec$var$mozillaRegExp.exec(ua) || $85fc8aaca067e6ec$var$webkitRegExp.exec(ua) || [];
    var browserName = matches[1];
    var browserVersion = matches[2];
    if ("webkit" === browserName) {
        result.webkit = true;
        if (ua.indexOf("chrome") >= 0 || ua.indexOf("crios") >= 0) {
            browserName = "chrome";
            browserVersion = /(?:chrome|crios)\/(\d+\.\d+)/.exec(ua);
            browserVersion = browserVersion && browserVersion[1];
        } else {
            if (ua.indexOf("fxios") >= 0) {
                browserName = "mozilla";
                browserVersion = /fxios\/(\d+\.\d+)/.exec(ua);
                browserVersion = browserVersion && browserVersion[1];
            } else if (ua.indexOf("safari") >= 0 && /version|phantomjs/.test(ua)) {
                browserName = "safari";
                browserVersion = /(?:version|phantomjs)\/([0-9.]+)/.exec(ua);
                browserVersion = browserVersion && browserVersion[1];
            } else {
                browserName = "unknown";
                browserVersion = /applewebkit\/([0-9.]+)/.exec(ua);
                browserVersion = browserVersion && browserVersion[1];
            }
        }
    }
    if ("trident" === browserName || "edge" === browserName) browserName = "msie";
    if (browserName) {
        result[browserName] = true;
        result.version = browserVersion;
    }
    return result;
};
module.exports = $85fc8aaca067e6ec$require$extend({
    _fromUA: $85fc8aaca067e6ec$var$browserFromUA
}, $85fc8aaca067e6ec$var$browserFromUA($85fc8aaca067e6ec$var$navigator.userAgent));

});

parcelRegister("a3SFB", function(module, exports) {
/**
 * DevExtreme (events/pointer/touch.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $aiwte = parcelRequire("aiwte");

var $7I8Uw = parcelRequire("7I8Uw");
var $7534978a19cb7288$require$extend = $7I8Uw.extend;

var $4Pwuy = parcelRequire("4Pwuy");
var $7534978a19cb7288$require$each = $4Pwuy.each;

var $3Jg4v = parcelRequire("3Jg4v");
var $7534978a19cb7288$var$eventMap = {
    dxpointerdown: "touchstart",
    dxpointermove: "touchmove",
    dxpointerup: "touchend",
    dxpointercancel: "touchcancel",
    dxpointerover: "",
    dxpointerout: "",
    dxpointerenter: "",
    dxpointerleave: ""
};
var $7534978a19cb7288$var$normalizeTouchEvent = function(e) {
    var pointers = [];
    $7534978a19cb7288$require$each(e.touches, function(_, touch) {
        pointers.push($7534978a19cb7288$require$extend({
            pointerId: touch.identifier
        }, touch));
    });
    return {
        pointers: pointers,
        pointerId: e.changedTouches[0].identifier
    };
};
var $7534978a19cb7288$var$skipTouchWithSameIdentifier = function(pointerEvent) {
    return "ios" === $aiwte.real().platform && ("dxpointerdown" === pointerEvent || "dxpointerup" === pointerEvent);
};
var $7534978a19cb7288$var$TouchStrategy = $3Jg4v.inherit({
    ctor: function() {
        this.callBase.apply(this, arguments);
        this._pointerId = 0;
    },
    _handler: function(e) {
        if ($7534978a19cb7288$var$skipTouchWithSameIdentifier(this._eventName)) {
            var touch = e.changedTouches[0];
            if (this._pointerId === touch.identifier && 0 !== this._pointerId) return;
            this._pointerId = touch.identifier;
        }
        return this.callBase.apply(this, arguments);
    },
    _fireEvent: function(args) {
        return this.callBase($7534978a19cb7288$require$extend($7534978a19cb7288$var$normalizeTouchEvent(args.originalEvent), args));
    }
});
$7534978a19cb7288$var$TouchStrategy.map = $7534978a19cb7288$var$eventMap;
$7534978a19cb7288$var$TouchStrategy.normalize = $7534978a19cb7288$var$normalizeTouchEvent;
module.exports = $7534978a19cb7288$var$TouchStrategy;

});
parcelRegister("3Jg4v", function(module, exports) {
/**
 * DevExtreme (events/pointer/base.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $e1LMc = parcelRequire("e1LMc");

var $bvcPv = parcelRequire("bvcPv");

var $445Bz = parcelRequire("445Bz");

var $k7aJb = parcelRequire("k7aJb");

var $bXb2w = parcelRequire("bXb2w");
var $2b720a8c9795a176$var$POINTER_EVENTS_NAMESPACE = "dxPointerEvents";
var $2b720a8c9795a176$var$BaseStrategy = $k7aJb.inherit({
    ctor: function(eventName, originalEvents) {
        this._eventName = eventName;
        this._originalEvents = $bXb2w.addNamespace(originalEvents, $2b720a8c9795a176$var$POINTER_EVENTS_NAMESPACE);
        this._handlerCount = 0;
        this.noBubble = this._isNoBubble();
    },
    _isNoBubble: function() {
        var eventName = this._eventName;
        return "dxpointerenter" === eventName || "dxpointerleave" === eventName;
    },
    _handler: function(e) {
        var delegateTarget = this._getDelegateTarget(e);
        return this._fireEvent({
            type: this._eventName,
            pointerType: e.pointerType || $bXb2w.eventSource(e),
            originalEvent: e,
            delegateTarget: delegateTarget,
            timeStamp: $bvcPv.mozilla ? (new Date).getTime() : e.timeStamp
        });
    },
    _getDelegateTarget: function(e) {
        var delegateTarget;
        if (this.noBubble) delegateTarget = e.delegateTarget;
        return delegateTarget;
    },
    _fireEvent: function(args) {
        return $bXb2w.fireEvent(args);
    },
    _setSelector: function(handleObj) {
        this._selector = this.noBubble && handleObj ? handleObj.selector : null;
    },
    _getSelector: function() {
        return this._selector;
    },
    setup: function() {
        return true;
    },
    add: function(element, handleObj) {
        if (this._handlerCount <= 0 || this.noBubble) {
            element = this.noBubble ? element : $445Bz.getDocument();
            this._setSelector(handleObj);
            var that = this;
            $e1LMc.on(element, this._originalEvents, this._getSelector(), function(e) {
                that._handler(e);
            });
        }
        if (!this.noBubble) this._handlerCount++;
    },
    remove: function(handleObj) {
        this._setSelector(handleObj);
        if (!this.noBubble) this._handlerCount--;
    },
    teardown: function(element) {
        if (this._handlerCount && !this.noBubble) return;
        element = this.noBubble ? element : $445Bz.getDocument();
        if (this._originalEvents !== "." + $2b720a8c9795a176$var$POINTER_EVENTS_NAMESPACE) $e1LMc.off(element, this._originalEvents, this._getSelector());
    },
    dispose: function(element) {
        element = this.noBubble ? element : $445Bz.getDocument();
        $e1LMc.off(element, this._originalEvents);
    }
});
module.exports = $2b720a8c9795a176$var$BaseStrategy;

});


parcelRegister("3l6X8", function(module, exports) {
/**
 * DevExtreme (events/pointer/mspointer.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $3Jg4v = parcelRequire("3Jg4v");

var $gAQAb = parcelRequire("gAQAb");

var $7I8Uw = parcelRequire("7I8Uw");
var $26e8b9f3fdbc7b23$require$extend = $7I8Uw.extend;
var $26e8b9f3fdbc7b23$var$eventMap = {
    dxpointerdown: "pointerdown",
    dxpointermove: "pointermove",
    dxpointerup: "pointerup",
    dxpointercancel: "pointercancel",
    dxpointerover: "pointerover",
    dxpointerout: "pointerout",
    dxpointerenter: "pointerenter",
    dxpointerleave: "pointerleave"
};
var $26e8b9f3fdbc7b23$var$observer;
var $26e8b9f3fdbc7b23$var$activated = false;
var $26e8b9f3fdbc7b23$var$activateStrategy = function() {
    if ($26e8b9f3fdbc7b23$var$activated) return;
    $26e8b9f3fdbc7b23$var$observer = new $gAQAb($26e8b9f3fdbc7b23$var$eventMap, function(a, b) {
        return a.pointerId === b.pointerId;
    }, function(e) {
        if (e.isPrimary) $26e8b9f3fdbc7b23$var$observer.reset();
    });
    $26e8b9f3fdbc7b23$var$activated = true;
};
var $26e8b9f3fdbc7b23$var$MsPointerStrategy = $3Jg4v.inherit({
    ctor: function() {
        this.callBase.apply(this, arguments);
        $26e8b9f3fdbc7b23$var$activateStrategy();
    },
    _fireEvent: function(args) {
        return this.callBase($26e8b9f3fdbc7b23$require$extend({
            pointers: $26e8b9f3fdbc7b23$var$observer.pointers(),
            pointerId: args.originalEvent.pointerId
        }, args));
    }
});
$26e8b9f3fdbc7b23$var$MsPointerStrategy.map = $26e8b9f3fdbc7b23$var$eventMap;
$26e8b9f3fdbc7b23$var$MsPointerStrategy.resetObserver = function() {
    $26e8b9f3fdbc7b23$var$observer.reset();
};
module.exports = $26e8b9f3fdbc7b23$var$MsPointerStrategy;

});
parcelRegister("gAQAb", function(module, exports) {
/**
 * DevExtreme (events/pointer/observer.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $4Pwuy = parcelRequire("4Pwuy");
var $c148cbed8744cbe8$require$each = $4Pwuy.each;

var $g4e4U = parcelRequire("g4e4U");

var $445Bz = parcelRequire("445Bz");
var $c148cbed8744cbe8$var$addEventsListener = function(events, handler) {
    $g4e4U.add(function() {
        events.split(" ").forEach(function(event) {
            $445Bz.listen($445Bz.getDocument(), event, handler, true);
        });
    });
};
var $c148cbed8744cbe8$var$Observer = function(eventMap, pointerEquals, onPointerAdding) {
    onPointerAdding = onPointerAdding || function() {};
    var pointers = [];
    var getPointerIndex = function(e) {
        var index = -1;
        $c148cbed8744cbe8$require$each(pointers, function(i, pointer) {
            if (!pointerEquals(e, pointer)) return true;
            index = i;
            return false;
        });
        return index;
    };
    var addPointer = function(e) {
        if (getPointerIndex(e) === -1) {
            onPointerAdding(e);
            pointers.push(e);
        }
    };
    var removePointer = function(e) {
        var index = getPointerIndex(e);
        if (index > -1) pointers.splice(index, 1);
    };
    var updatePointer = function(e) {
        pointers[getPointerIndex(e)] = e;
    };
    $c148cbed8744cbe8$var$addEventsListener(eventMap.dxpointerdown, addPointer);
    $c148cbed8744cbe8$var$addEventsListener(eventMap.dxpointermove, updatePointer);
    $c148cbed8744cbe8$var$addEventsListener(eventMap.dxpointerup, removePointer);
    $c148cbed8744cbe8$var$addEventsListener(eventMap.dxpointercancel, removePointer);
    this.pointers = function() {
        return pointers;
    };
    this.reset = function() {
        pointers = [];
    };
};
module.exports = $c148cbed8744cbe8$var$Observer;

});


parcelRegister("9R24H", function(module, exports) {
/**
 * DevExtreme (events/pointer/mouse.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $7I8Uw = parcelRequire("7I8Uw");
var $72caac50edc8fd83$require$extend = $7I8Uw.extend;

var $3Jg4v = parcelRequire("3Jg4v");

var $gAQAb = parcelRequire("gAQAb");
var $72caac50edc8fd83$var$eventMap = {
    dxpointerdown: "mousedown",
    dxpointermove: "mousemove",
    dxpointerup: "mouseup",
    dxpointercancel: "",
    dxpointerover: "mouseover",
    dxpointerout: "mouseout",
    dxpointerenter: "mouseenter",
    dxpointerleave: "mouseleave"
};
var $72caac50edc8fd83$var$normalizeMouseEvent = function(e) {
    e.pointerId = 1;
    return {
        pointers: $72caac50edc8fd83$var$observer.pointers(),
        pointerId: 1
    };
};
var $72caac50edc8fd83$var$observer;
var $72caac50edc8fd83$var$activated = false;
var $72caac50edc8fd83$var$activateStrategy = function() {
    if ($72caac50edc8fd83$var$activated) return;
    $72caac50edc8fd83$var$observer = new $gAQAb($72caac50edc8fd83$var$eventMap, function() {
        return true;
    });
    $72caac50edc8fd83$var$activated = true;
};
var $72caac50edc8fd83$var$MouseStrategy = $3Jg4v.inherit({
    ctor: function() {
        this.callBase.apply(this, arguments);
        $72caac50edc8fd83$var$activateStrategy();
    },
    _fireEvent: function(args) {
        return this.callBase($72caac50edc8fd83$require$extend($72caac50edc8fd83$var$normalizeMouseEvent(args.originalEvent), args));
    }
});
$72caac50edc8fd83$var$MouseStrategy.map = $72caac50edc8fd83$var$eventMap;
$72caac50edc8fd83$var$MouseStrategy.normalize = $72caac50edc8fd83$var$normalizeMouseEvent;
$72caac50edc8fd83$var$MouseStrategy.activate = $72caac50edc8fd83$var$activateStrategy;
$72caac50edc8fd83$var$MouseStrategy.resetObserver = function() {
    $72caac50edc8fd83$var$observer.reset();
};
module.exports = $72caac50edc8fd83$var$MouseStrategy;

});

parcelRegister("gHnK7", function(module, exports) {
/**
 * DevExtreme (events/pointer/mouse_and_touch.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $7I8Uw = parcelRequire("7I8Uw");
var $c2831458377a1f2f$require$extend = $7I8Uw.extend;

var $3Jg4v = parcelRequire("3Jg4v");

var $9R24H = parcelRequire("9R24H");

var $a3SFB = parcelRequire("a3SFB");

var $bXb2w = parcelRequire("bXb2w");
var $c2831458377a1f2f$var$eventMap = {
    dxpointerdown: "touchstart mousedown",
    dxpointermove: "touchmove mousemove",
    dxpointerup: "touchend mouseup",
    dxpointercancel: "touchcancel",
    dxpointerover: "mouseover",
    dxpointerout: "mouseout",
    dxpointerenter: "mouseenter",
    dxpointerleave: "mouseleave"
};
var $c2831458377a1f2f$var$activated = false;
var $c2831458377a1f2f$var$activateStrategy = function() {
    if ($c2831458377a1f2f$var$activated) return;
    $9R24H.activate();
    $c2831458377a1f2f$var$activated = true;
};
var $c2831458377a1f2f$var$MouseAndTouchStrategy = $3Jg4v.inherit({
    EVENT_LOCK_TIMEOUT: 100,
    ctor: function() {
        this.callBase.apply(this, arguments);
        $c2831458377a1f2f$var$activateStrategy();
    },
    _handler: function(e) {
        var isMouseEvent = $bXb2w.isMouseEvent(e);
        if (!isMouseEvent) this._skipNextEvents = true;
        if (isMouseEvent && this._mouseLocked) return;
        if (isMouseEvent && this._skipNextEvents) {
            this._skipNextEvents = false;
            this._mouseLocked = true;
            clearTimeout(this._unlockMouseTimer);
            var that = this;
            this._unlockMouseTimer = setTimeout(function() {
                that._mouseLocked = false;
            }, this.EVENT_LOCK_TIMEOUT);
            return;
        }
        return this.callBase(e);
    },
    _fireEvent: function(args) {
        var isMouseEvent = $bXb2w.isMouseEvent(args.originalEvent);
        var normalizer = isMouseEvent ? $9R24H.normalize : $a3SFB.normalize;
        return this.callBase($c2831458377a1f2f$require$extend(normalizer(args.originalEvent), args));
    },
    dispose: function() {
        this.callBase();
        this._skipNextEvents = false;
        this._mouseLocked = false;
        clearTimeout(this._unlockMouseTimer);
    }
});
$c2831458377a1f2f$var$MouseAndTouchStrategy.map = $c2831458377a1f2f$var$eventMap;
$c2831458377a1f2f$var$MouseAndTouchStrategy.resetObserver = $9R24H.resetObserver;
module.exports = $c2831458377a1f2f$var$MouseAndTouchStrategy;

});



parcelRegister("cNbaE", function(module, exports) {

$parcel$export(module.exports, "active", () => $9502b9eb105ffccd$export$89da14300d534261, (v) => $9502b9eb105ffccd$export$89da14300d534261 = v);
$parcel$export(module.exports, "inactive", () => $9502b9eb105ffccd$export$3cd3724d2f91e9d3, (v) => $9502b9eb105ffccd$export$3cd3724d2f91e9d3 = v);
/**
 * DevExtreme (events/core/emitter.feedback.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $9502b9eb105ffccd$export$6a9f04c98a658ecb;
var $9502b9eb105ffccd$export$89da14300d534261;
var $9502b9eb105ffccd$export$3cd3724d2f91e9d3;
"use strict";

var $k7aJb = parcelRequire("k7aJb");

var $2Mto0 = parcelRequire("2Mto0");

var $5OzEX = parcelRequire("5OzEX");
var $9502b9eb105ffccd$require$contains = $5OzEX.contains;

var $aiwte = parcelRequire("aiwte");

var $bXb2w = parcelRequire("bXb2w");

var $gP4Gh = parcelRequire("gP4Gh");

var $lTdDg = parcelRequire("lTdDg");

var $fy5D5 = parcelRequire("fy5D5");
var $9502b9eb105ffccd$var$ACTIVE_EVENT_NAME = "dxactive";
var $9502b9eb105ffccd$var$INACTIVE_EVENT_NAME = "dxinactive";
var $9502b9eb105ffccd$var$ACTIVE_TIMEOUT = 30;
var $9502b9eb105ffccd$var$INACTIVE_TIMEOUT = 400;
var $9502b9eb105ffccd$var$FeedbackEvent = $k7aJb.inherit({
    ctor: function(timeout, fire) {
        this._timeout = timeout;
        this._fire = fire;
    },
    start: function() {
        var that = this;
        this._schedule(function() {
            that.force();
        });
    },
    _schedule: function(fn) {
        this.stop();
        this._timer = setTimeout(fn, this._timeout);
    },
    stop: function() {
        clearTimeout(this._timer);
    },
    force: function() {
        if (this._fired) return;
        this.stop();
        this._fire();
        this._fired = true;
    },
    fired: function() {
        return this._fired;
    }
});
var $9502b9eb105ffccd$var$activeFeedback;
var $9502b9eb105ffccd$var$FeedbackEmitter = $lTdDg.inherit({
    ctor: function() {
        this.callBase.apply(this, arguments);
        this._active = new $9502b9eb105ffccd$var$FeedbackEvent(0, $2Mto0.noop);
        this._inactive = new $9502b9eb105ffccd$var$FeedbackEvent(0, $2Mto0.noop);
    },
    configure: function(data, eventName) {
        switch(eventName){
            case $9502b9eb105ffccd$var$ACTIVE_EVENT_NAME:
                data.activeTimeout = data.timeout;
                break;
            case $9502b9eb105ffccd$var$INACTIVE_EVENT_NAME:
                data.inactiveTimeout = data.timeout;
        }
        this.callBase(data);
    },
    start: function(e) {
        if ($9502b9eb105ffccd$var$activeFeedback) {
            var activeChildExists = $9502b9eb105ffccd$require$contains(this.getElement().get(0), $9502b9eb105ffccd$var$activeFeedback.getElement().get(0));
            var childJustActivated = !$9502b9eb105ffccd$var$activeFeedback._active.fired();
            if (activeChildExists && childJustActivated) {
                this._cancel();
                return;
            }
            $9502b9eb105ffccd$var$activeFeedback._inactive.force();
        }
        $9502b9eb105ffccd$var$activeFeedback = this;
        this._initEvents(e);
        this._active.start();
    },
    _initEvents: function(e) {
        var that = this;
        var eventTarget = this._getEmitterTarget(e);
        var mouseEvent = $bXb2w.isMouseEvent(e);
        var isSimulator = $aiwte.isSimulator();
        var deferFeedback = isSimulator || !mouseEvent;
        var activeTimeout = $2Mto0.ensureDefined(this.activeTimeout, $9502b9eb105ffccd$var$ACTIVE_TIMEOUT);
        var inactiveTimeout = $2Mto0.ensureDefined(this.inactiveTimeout, $9502b9eb105ffccd$var$INACTIVE_TIMEOUT);
        this._active = new $9502b9eb105ffccd$var$FeedbackEvent(deferFeedback ? activeTimeout : 0, function() {
            that._fireEvent($9502b9eb105ffccd$var$ACTIVE_EVENT_NAME, e, {
                target: eventTarget
            });
        });
        this._inactive = new $9502b9eb105ffccd$var$FeedbackEvent(deferFeedback ? inactiveTimeout : 0, function() {
            that._fireEvent($9502b9eb105ffccd$var$INACTIVE_EVENT_NAME, e, {
                target: eventTarget
            });
            $9502b9eb105ffccd$var$activeFeedback = null;
        });
    },
    cancel: function(e) {
        this.end(e);
    },
    end: function(e) {
        var skipTimers = e.type !== $gP4Gh.up;
        if (skipTimers) this._active.stop();
        else this._active.force();
        this._inactive.start();
        if (skipTimers) this._inactive.force();
    },
    dispose: function() {
        this._active.stop();
        this._inactive.stop();
        this.callBase();
    },
    lockInactive: function() {
        this._active.force();
        this._inactive.stop();
        $9502b9eb105ffccd$var$activeFeedback = null;
        this._cancel();
        return this._inactive.force.bind(this._inactive);
    }
});
$9502b9eb105ffccd$var$FeedbackEmitter.lock = function(deferred) {
    var lockInactive = $9502b9eb105ffccd$var$activeFeedback ? $9502b9eb105ffccd$var$activeFeedback.lockInactive() : $2Mto0.noop;
    deferred.done(lockInactive);
};
$fy5D5({
    emitter: $9502b9eb105ffccd$var$FeedbackEmitter,
    events: [
        $9502b9eb105ffccd$var$ACTIVE_EVENT_NAME,
        $9502b9eb105ffccd$var$INACTIVE_EVENT_NAME
    ]
});
$9502b9eb105ffccd$export$6a9f04c98a658ecb = $9502b9eb105ffccd$var$FeedbackEmitter.lock;
$9502b9eb105ffccd$export$89da14300d534261 = $9502b9eb105ffccd$var$ACTIVE_EVENT_NAME;
$9502b9eb105ffccd$export$3cd3724d2f91e9d3 = $9502b9eb105ffccd$var$INACTIVE_EVENT_NAME;

});
parcelRegister("lTdDg", function(module, exports) {
/**
 * DevExtreme (events/core/emitter.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $2Mto0 = parcelRequire("2Mto0");
var $fef94f1e6ad3afae$require$noop = $2Mto0.noop;

var $k7aJb = parcelRequire("k7aJb");

var $eKdKS = parcelRequire("eKdKS");

var $7I8Uw = parcelRequire("7I8Uw");
var $fef94f1e6ad3afae$require$extend = $7I8Uw.extend;

var $bXb2w = parcelRequire("bXb2w");
var $fef94f1e6ad3afae$var$Emitter = $k7aJb.inherit({
    ctor: function(element) {
        this._$element = $jFnCG(element);
        this._cancelCallback = $eKdKS();
        this._acceptCallback = $eKdKS();
    },
    getElement: function() {
        return this._$element;
    },
    validate: function(e) {
        return !$bXb2w.isDxMouseWheelEvent(e);
    },
    validatePointers: function(e) {
        return 1 === $bXb2w.hasTouches(e);
    },
    allowInterruptionByMouseWheel: function() {
        return true;
    },
    configure: function(data) {
        $fef94f1e6ad3afae$require$extend(this, data);
    },
    addCancelCallback: function(callback) {
        this._cancelCallback.add(callback);
    },
    removeCancelCallback: function() {
        this._cancelCallback.empty();
    },
    _cancel: function(e) {
        this._cancelCallback.fire(this, e);
    },
    addAcceptCallback: function(callback) {
        this._acceptCallback.add(callback);
    },
    removeAcceptCallback: function() {
        this._acceptCallback.empty();
    },
    _accept: function(e) {
        this._acceptCallback.fire(this, e);
    },
    _requestAccept: function(e) {
        this._acceptRequestEvent = e;
    },
    _forgetAccept: function() {
        this._accept(this._acceptRequestEvent);
        this._acceptRequestEvent = null;
    },
    start: $fef94f1e6ad3afae$require$noop,
    move: $fef94f1e6ad3afae$require$noop,
    end: $fef94f1e6ad3afae$require$noop,
    cancel: $fef94f1e6ad3afae$require$noop,
    reset: function() {
        if (this._acceptRequestEvent) this._accept(this._acceptRequestEvent);
    },
    _fireEvent: function(eventName, e, params) {
        var eventData = $fef94f1e6ad3afae$require$extend({
            type: eventName,
            originalEvent: e,
            target: this._getEmitterTarget(e),
            delegateTarget: this.getElement().get(0)
        }, params);
        e = $bXb2w.fireEvent(eventData);
        if (e.cancel) this._cancel(e);
        return e;
    },
    _getEmitterTarget: function(e) {
        return (this.delegateSelector ? $jFnCG(e.target).closest(this.delegateSelector) : this.getElement()).get(0);
    },
    dispose: $fef94f1e6ad3afae$require$noop
});
module.exports = $fef94f1e6ad3afae$var$Emitter;

});

parcelRegister("fy5D5", function(module, exports) {
/**
 * DevExtreme (events/core/emitter_registrator.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $g4e4U = parcelRequire("g4e4U");

var $445Bz = parcelRequire("445Bz");

var $e1LMc = parcelRequire("e1LMc");

var $8ulMI = parcelRequire("8ulMI");

var $k7aJb = parcelRequire("k7aJb");

var $7I8Uw = parcelRequire("7I8Uw");
var $b51e65e432bf9ef8$require$extend = $7I8Uw.extend;

var $aLQK5 = parcelRequire("aLQK5");
var $b51e65e432bf9ef8$require$inArray = $aLQK5.inArray;

var $4Pwuy = parcelRequire("4Pwuy");
var $b51e65e432bf9ef8$require$each = $4Pwuy.each;

var $cMvU0 = parcelRequire("cMvU0");

var $bXb2w = parcelRequire("bXb2w");

var $gP4Gh = parcelRequire("gP4Gh");

var $bfI7V = parcelRequire("bfI7V");
var $b51e65e432bf9ef8$var$MANAGER_EVENT = "dxEventManager";
var $b51e65e432bf9ef8$var$EMITTER_DATA = "dxEmitter";
var $b51e65e432bf9ef8$var$EventManager = $k7aJb.inherit({
    ctor: function() {
        this._attachHandlers();
        this.reset();
        this._proxiedCancelHandler = this._cancelHandler.bind(this);
        this._proxiedAcceptHandler = this._acceptHandler.bind(this);
    },
    _attachHandlers: function() {
        $g4e4U.add((function() {
            var document = $445Bz.getDocument();
            $e1LMc.subscribeGlobal(document, $bXb2w.addNamespace($gP4Gh.down, $b51e65e432bf9ef8$var$MANAGER_EVENT), this._pointerDownHandler.bind(this));
            $e1LMc.subscribeGlobal(document, $bXb2w.addNamespace($gP4Gh.move, $b51e65e432bf9ef8$var$MANAGER_EVENT), this._pointerMoveHandler.bind(this));
            $e1LMc.subscribeGlobal(document, $bXb2w.addNamespace([
                $gP4Gh.up,
                $gP4Gh.cancel
            ].join(" "), $b51e65e432bf9ef8$var$MANAGER_EVENT), this._pointerUpHandler.bind(this));
            $e1LMc.subscribeGlobal(document, $bXb2w.addNamespace($bfI7V.name, $b51e65e432bf9ef8$var$MANAGER_EVENT), this._mouseWheelHandler.bind(this));
        }).bind(this));
    },
    _eachEmitter: function(callback) {
        var activeEmitters = this._activeEmitters || [];
        var i = 0;
        while(activeEmitters.length > i){
            var emitter = activeEmitters[i];
            if (false === callback(emitter)) break;
            if (activeEmitters[i] === emitter) i++;
        }
    },
    _applyToEmitters: function(method, arg) {
        this._eachEmitter(function(emitter) {
            emitter[method].call(emitter, arg);
        });
    },
    reset: function() {
        this._eachEmitter(this._proxiedCancelHandler);
        this._activeEmitters = [];
    },
    resetEmitter: function(emitter) {
        this._proxiedCancelHandler(emitter);
    },
    _pointerDownHandler: function(e) {
        if ($bXb2w.isMouseEvent(e) && e.which > 1) return;
        this._updateEmitters(e);
    },
    _updateEmitters: function(e) {
        if (!this._isSetChanged(e)) return;
        this._cleanEmitters(e);
        this._fetchEmitters(e);
    },
    _isSetChanged: function(e) {
        var currentSet = this._closestEmitter(e);
        var previousSet = this._emittersSet || [];
        var setChanged = currentSet.length !== previousSet.length;
        $b51e65e432bf9ef8$require$each(currentSet, function(index, emitter) {
            setChanged = setChanged || previousSet[index] !== emitter;
            return !setChanged;
        });
        this._emittersSet = currentSet;
        return setChanged;
    },
    _closestEmitter: function(e) {
        var that = this;
        var result = [];
        var $element = $jFnCG(e.target);
        function handleEmitter(_, emitter) {
            if (!!emitter && emitter.validatePointers(e) && emitter.validate(e)) {
                emitter.addCancelCallback(that._proxiedCancelHandler);
                emitter.addAcceptCallback(that._proxiedAcceptHandler);
                result.push(emitter);
            }
        }
        while($element.length){
            var emitters = $8ulMI.data($element.get(0), $b51e65e432bf9ef8$var$EMITTER_DATA) || [];
            $b51e65e432bf9ef8$require$each(emitters, handleEmitter);
            $element = $element.parent();
        }
        return result;
    },
    _acceptHandler: function(acceptedEmitter, e) {
        var that = this;
        this._eachEmitter(function(emitter) {
            if (emitter !== acceptedEmitter) that._cancelEmitter(emitter, e);
        });
    },
    _cancelHandler: function(canceledEmitter, e) {
        this._cancelEmitter(canceledEmitter, e);
    },
    _cancelEmitter: function(emitter, e) {
        var activeEmitters = this._activeEmitters;
        if (e) emitter.cancel(e);
        else emitter.reset();
        emitter.removeCancelCallback();
        emitter.removeAcceptCallback();
        var emitterIndex = $b51e65e432bf9ef8$require$inArray(emitter, activeEmitters);
        if (emitterIndex > -1) activeEmitters.splice(emitterIndex, 1);
    },
    _cleanEmitters: function(e) {
        this._applyToEmitters("end", e);
        this.reset(e);
    },
    _fetchEmitters: function(e) {
        this._activeEmitters = this._emittersSet.slice();
        this._applyToEmitters("start", e);
    },
    _pointerMoveHandler: function(e) {
        this._applyToEmitters("move", e);
    },
    _pointerUpHandler: function(e) {
        this._updateEmitters(e);
    },
    _mouseWheelHandler: function(e) {
        if (!this._allowInterruptionByMouseWheel()) return;
        e.pointers = [
            null
        ];
        this._pointerDownHandler(e);
        this._adjustWheelEvent(e);
        this._pointerMoveHandler(e);
        e.pointers = [];
        this._pointerUpHandler(e);
    },
    _allowInterruptionByMouseWheel: function() {
        var allowInterruption = true;
        this._eachEmitter(function(emitter) {
            allowInterruption = emitter.allowInterruptionByMouseWheel() && allowInterruption;
            return allowInterruption;
        });
        return allowInterruption;
    },
    _adjustWheelEvent: function(e) {
        var closestGestureEmitter = null;
        this._eachEmitter(function(emitter) {
            if (!emitter.gesture) return;
            var direction = emitter.getDirection(e);
            if ("horizontal" !== direction && !e.shiftKey || "vertical" !== direction && e.shiftKey) {
                closestGestureEmitter = emitter;
                return false;
            }
        });
        if (!closestGestureEmitter) return;
        var direction = closestGestureEmitter.getDirection(e);
        var verticalGestureDirection = "both" === direction && !e.shiftKey || "vertical" === direction;
        var prop = verticalGestureDirection ? "pageY" : "pageX";
        e[prop] += e.delta;
    },
    isActive: function(element) {
        var result = false;
        this._eachEmitter(function(emitter) {
            result = result || emitter.getElement().is(element);
        });
        return result;
    }
});
var $b51e65e432bf9ef8$var$eventManager = new $b51e65e432bf9ef8$var$EventManager;
var $b51e65e432bf9ef8$var$EMITTER_SUBSCRIPTION_DATA = "dxEmitterSubscription";
var $b51e65e432bf9ef8$var$registerEmitter = function(emitterConfig) {
    var emitterClass = emitterConfig.emitter;
    var emitterName = emitterConfig.events[0];
    var emitterEvents = emitterConfig.events;
    $b51e65e432bf9ef8$require$each(emitterEvents, function(_, eventName) {
        $cMvU0(eventName, {
            noBubble: !emitterConfig.bubble,
            setup: function(element) {
                var subscriptions = $8ulMI.data(element, $b51e65e432bf9ef8$var$EMITTER_SUBSCRIPTION_DATA) || {};
                var emitters = $8ulMI.data(element, $b51e65e432bf9ef8$var$EMITTER_DATA) || {};
                var emitter = emitters[emitterName] || new emitterClass(element);
                subscriptions[eventName] = true;
                emitters[emitterName] = emitter;
                $8ulMI.data(element, $b51e65e432bf9ef8$var$EMITTER_DATA, emitters);
                $8ulMI.data(element, $b51e65e432bf9ef8$var$EMITTER_SUBSCRIPTION_DATA, subscriptions);
            },
            add: function(element, handleObj) {
                var emitters = $8ulMI.data(element, $b51e65e432bf9ef8$var$EMITTER_DATA);
                var emitter = emitters[emitterName];
                emitter.configure($b51e65e432bf9ef8$require$extend({
                    delegateSelector: handleObj.selector
                }, handleObj.data), handleObj.type);
            },
            teardown: function(element) {
                var subscriptions = $8ulMI.data(element, $b51e65e432bf9ef8$var$EMITTER_SUBSCRIPTION_DATA);
                var emitters = $8ulMI.data(element, $b51e65e432bf9ef8$var$EMITTER_DATA);
                var emitter = emitters[emitterName];
                delete subscriptions[eventName];
                var disposeEmitter = true;
                $b51e65e432bf9ef8$require$each(emitterEvents, function(_, eventName) {
                    disposeEmitter = disposeEmitter && !subscriptions[eventName];
                    return disposeEmitter;
                });
                if (disposeEmitter) {
                    if ($b51e65e432bf9ef8$var$eventManager.isActive(element)) $b51e65e432bf9ef8$var$eventManager.resetEmitter(emitter);
                    emitter && emitter.dispose();
                    delete emitters[emitterName];
                }
            }
        });
    });
};
module.exports = $b51e65e432bf9ef8$var$registerEmitter;

});
parcelRegister("bfI7V", function(module, exports) {

$parcel$export(module.exports, "name", () => $8313531c6e0b0ff7$export$a8ff84c12d48cfa6, (v) => $8313531c6e0b0ff7$export$a8ff84c12d48cfa6 = v);
/**
 * DevExtreme (events/core/wheel.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $8313531c6e0b0ff7$export$a8ff84c12d48cfa6;
"use strict";

var $jFnCG = parcelRequire("jFnCG");
var $8313531c6e0b0ff7$var$_renderer2 = $8313531c6e0b0ff7$var$_interopRequireDefault($jFnCG);

var $e1LMc = parcelRequire("e1LMc");
var $8313531c6e0b0ff7$var$_events_engine2 = $8313531c6e0b0ff7$var$_interopRequireDefault($e1LMc);

var $cMvU0 = parcelRequire("cMvU0");
var $8313531c6e0b0ff7$var$_event_registrator2 = $8313531c6e0b0ff7$var$_interopRequireDefault($cMvU0);

var $bXb2w = parcelRequire("bXb2w");
function $8313531c6e0b0ff7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $8313531c6e0b0ff7$var$EVENT_NAME = "dxmousewheel";
var $8313531c6e0b0ff7$var$EVENT_NAMESPACE = "dxWheel";
var $8313531c6e0b0ff7$var$NATIVE_EVENT_NAME = "wheel";
var $8313531c6e0b0ff7$var$PIXEL_MODE = 0;
var $8313531c6e0b0ff7$var$DELTA_MUTLIPLIER = 30;
var $8313531c6e0b0ff7$var$wheel = {
    setup: function(element) {
        var $element = (0, $8313531c6e0b0ff7$var$_renderer2.default)(element);
        $8313531c6e0b0ff7$var$_events_engine2.default.on($element, (0, $bXb2w.addNamespace)($8313531c6e0b0ff7$var$NATIVE_EVENT_NAME, $8313531c6e0b0ff7$var$EVENT_NAMESPACE), $8313531c6e0b0ff7$var$wheel._wheelHandler.bind($8313531c6e0b0ff7$var$wheel));
    },
    teardown: function(element) {
        $8313531c6e0b0ff7$var$_events_engine2.default.off(element, ".".concat($8313531c6e0b0ff7$var$EVENT_NAMESPACE));
    },
    _wheelHandler: function(e) {
        var _e$originalEvent = e.originalEvent, deltaMode = _e$originalEvent.deltaMode, deltaY = _e$originalEvent.deltaY, deltaX = _e$originalEvent.deltaX, deltaZ = _e$originalEvent.deltaZ;
        (0, $bXb2w.fireEvent)({
            type: $8313531c6e0b0ff7$var$EVENT_NAME,
            originalEvent: e,
            delta: this._normalizeDelta(deltaY, deltaMode),
            deltaX: deltaX,
            deltaY: deltaY,
            deltaZ: deltaZ,
            deltaMode: deltaMode,
            pointerType: "mouse"
        });
        e.stopPropagation();
    },
    _normalizeDelta: function(delta) {
        var deltaMode = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : $8313531c6e0b0ff7$var$PIXEL_MODE;
        if (deltaMode === $8313531c6e0b0ff7$var$PIXEL_MODE) return -delta;
        else return -$8313531c6e0b0ff7$var$DELTA_MUTLIPLIER * delta;
    }
};
(0, $8313531c6e0b0ff7$var$_event_registrator2.default)($8313531c6e0b0ff7$var$EVENT_NAME, $8313531c6e0b0ff7$var$wheel);
$8313531c6e0b0ff7$export$a8ff84c12d48cfa6 = $8313531c6e0b0ff7$var$EVENT_NAME;

});



parcelRegister("i7ZSP", function(module, exports) {

$parcel$export(module.exports, "name", () => $d328e2312b457e0a$export$a8ff84c12d48cfa6, (v) => $d328e2312b457e0a$export$a8ff84c12d48cfa6 = v);
/**
 * DevExtreme (events/click.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $d328e2312b457e0a$export$a8ff84c12d48cfa6;
"use strict";

var $jFnCG = parcelRequire("jFnCG");

var $e1LMc = parcelRequire("e1LMc");

var $aiwte = parcelRequire("aiwte");

var $445Bz = parcelRequire("445Bz");

var $5OzEX = parcelRequire("5OzEX");

var $fF1Ws = parcelRequire("fF1Ws");

var $bXb2w = parcelRequire("bXb2w");

var $gP4Gh = parcelRequire("gP4Gh");

var $lTdDg = parcelRequire("lTdDg");

var $fy5D5 = parcelRequire("fy5D5");

var $hwytx = parcelRequire("hwytx");
var $d328e2312b457e0a$require$compareVersions = $hwytx.compare;
var $d328e2312b457e0a$var$CLICK_EVENT_NAME = "dxclick";
var $d328e2312b457e0a$var$TOUCH_BOUNDARY = 10;
var $d328e2312b457e0a$var$abs = Math.abs;
var $d328e2312b457e0a$var$isInput = function(element) {
    return $jFnCG(element).is("input, textarea, select, button ,:focus, :focus *");
};
var $d328e2312b457e0a$var$misc = {
    requestAnimationFrame: $fF1Ws.requestAnimationFrame,
    cancelAnimationFrame: $fF1Ws.cancelAnimationFrame
};
var $d328e2312b457e0a$var$ClickEmitter = $lTdDg.inherit({
    ctor: function(element) {
        this.callBase(element);
        this._makeElementClickable($jFnCG(element));
    },
    _makeElementClickable: function($element) {
        if (!$element.attr("onclick")) $element.attr("onclick", "void(0)");
    },
    start: function(e) {
        this._blurPrevented = e.isDefaultPrevented();
        this._startTarget = e.target;
        this._startEventData = $bXb2w.eventData(e);
    },
    end: function(e) {
        if (this._eventOutOfElement(e, this.getElement().get(0)) || e.type === $gP4Gh.cancel) {
            this._cancel(e);
            return;
        }
        if (!$d328e2312b457e0a$var$isInput(e.target) && !this._blurPrevented) $5OzEX.resetActiveElement();
        this._accept(e);
        this._clickAnimationFrame = $d328e2312b457e0a$var$misc.requestAnimationFrame((function() {
            this._fireClickEvent(e);
        }).bind(this));
    },
    _eventOutOfElement: function(e, element) {
        var target = e.target;
        var targetChanged = !$5OzEX.contains(element, target) && element !== target;
        var gestureDelta = $bXb2w.eventDelta($bXb2w.eventData(e), this._startEventData);
        var boundsExceeded = $d328e2312b457e0a$var$abs(gestureDelta.x) > $d328e2312b457e0a$var$TOUCH_BOUNDARY || $d328e2312b457e0a$var$abs(gestureDelta.y) > $d328e2312b457e0a$var$TOUCH_BOUNDARY;
        return targetChanged || boundsExceeded;
    },
    _fireClickEvent: function(e) {
        this._fireEvent($d328e2312b457e0a$var$CLICK_EVENT_NAME, e, {
            target: $5OzEX.closestCommonParent(this._startTarget, e.target)
        });
    },
    dispose: function() {
        $d328e2312b457e0a$var$misc.cancelAnimationFrame(this._clickAnimationFrame);
    }
});
!function() {
    var NATIVE_CLICK_CLASS = "dx-native-click";
    var realDevice = $aiwte.real();
    var useNativeClick = realDevice.generic || realDevice.ios && $d328e2312b457e0a$require$compareVersions(realDevice.version, [
        9,
        3
    ]) >= 0 || realDevice.android && $d328e2312b457e0a$require$compareVersions(realDevice.version, [
        5
    ]) >= 0;
    var isNativeClickEvent = function(target) {
        return useNativeClick || $jFnCG(target).closest("." + NATIVE_CLICK_CLASS).length;
    };
    var prevented = null;
    var lastFiredEvent = null;
    var clickHandler = function(e) {
        var originalEvent = e.originalEvent;
        var eventAlreadyFired = lastFiredEvent === originalEvent || originalEvent && originalEvent.DXCLICK_FIRED;
        var leftButton = !e.which || 1 === e.which;
        if (leftButton && !prevented && isNativeClickEvent(e.target) && !eventAlreadyFired) {
            if (originalEvent) originalEvent.DXCLICK_FIRED = true;
            lastFiredEvent = originalEvent;
            $bXb2w.fireEvent({
                type: $d328e2312b457e0a$var$CLICK_EVENT_NAME,
                originalEvent: e
            });
        }
    };
    $d328e2312b457e0a$var$ClickEmitter = $d328e2312b457e0a$var$ClickEmitter.inherit({
        _makeElementClickable: function($element) {
            if (!isNativeClickEvent($element)) this.callBase($element);
            $e1LMc.on($element, "click", clickHandler);
        },
        configure: function(data) {
            this.callBase(data);
            if (data.useNative) this.getElement().addClass(NATIVE_CLICK_CLASS);
        },
        start: function(e) {
            prevented = null;
            if (!isNativeClickEvent(e.target)) this.callBase(e);
        },
        end: function(e) {
            if (!isNativeClickEvent(e.target)) this.callBase(e);
        },
        cancel: function() {
            prevented = true;
        },
        dispose: function() {
            this.callBase();
            $e1LMc.off(this.getElement(), "click", clickHandler);
        }
    });
}();
!function() {
    var desktopDevice = $aiwte.real().generic;
    if (!desktopDevice) {
        var startTarget = null;
        var blurPrevented = false;
        var pointerDownHandler = function(e) {
            startTarget = e.target;
            blurPrevented = e.isDefaultPrevented();
        };
        var clickHandler = function(e) {
            var $target = $jFnCG(e.target);
            if (!blurPrevented && startTarget && !$target.is(startTarget) && !$jFnCG(startTarget).is("label") && $d328e2312b457e0a$var$isInput($target)) $5OzEX.resetActiveElement();
            startTarget = null;
            blurPrevented = false;
        };
        var NATIVE_CLICK_FIXER_NAMESPACE = "NATIVE_CLICK_FIXER";
        var document = $445Bz.getDocument();
        $e1LMc.subscribeGlobal(document, $bXb2w.addNamespace($gP4Gh.down, NATIVE_CLICK_FIXER_NAMESPACE), pointerDownHandler);
        $e1LMc.subscribeGlobal(document, $bXb2w.addNamespace("click", NATIVE_CLICK_FIXER_NAMESPACE), clickHandler);
    }
}();
$fy5D5({
    emitter: $d328e2312b457e0a$var$ClickEmitter,
    bubble: true,
    events: [
        $d328e2312b457e0a$var$CLICK_EVENT_NAME
    ]
});
$d328e2312b457e0a$export$a8ff84c12d48cfa6 = $d328e2312b457e0a$var$CLICK_EVENT_NAME;

});
parcelRegister("fF1Ws", function(module, exports) {

$parcel$export(module.exports, "requestAnimationFrame", () => $b66c30f4f4981dee$export$6cb2c4c0a22909c0, (v) => $b66c30f4f4981dee$export$6cb2c4c0a22909c0 = v);
$parcel$export(module.exports, "cancelAnimationFrame", () => $b66c30f4f4981dee$export$e00521de187a817a, (v) => $b66c30f4f4981dee$export$e00521de187a817a = v);
/**
 * DevExtreme (animation/frame.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $b66c30f4f4981dee$export$6cb2c4c0a22909c0;
var $b66c30f4f4981dee$export$e00521de187a817a;
"use strict";

var $irv64 = parcelRequire("irv64");
var $b66c30f4f4981dee$var$window = $irv64.hasWindow() ? $irv64.getWindow() : {};

var $ePlHj = parcelRequire("ePlHj");
var $b66c30f4f4981dee$var$FRAME_ANIMATION_STEP_TIME = 1e3 / 60;
var $b66c30f4f4981dee$var$request = function(callback) {
    return setTimeout(callback, $b66c30f4f4981dee$var$FRAME_ANIMATION_STEP_TIME);
};
var $b66c30f4f4981dee$var$cancel = function(requestID) {
    clearTimeout(requestID);
};
var $b66c30f4f4981dee$var$setAnimationFrameMethods = $ePlHj(function() {
    var nativeRequest = $b66c30f4f4981dee$var$window.requestAnimationFrame || $b66c30f4f4981dee$var$window.webkitRequestAnimationFrame || $b66c30f4f4981dee$var$window.mozRequestAnimationFrame || $b66c30f4f4981dee$var$window.oRequestAnimationFrame || $b66c30f4f4981dee$var$window.msRequestAnimationFrame;
    var nativeCancel = $b66c30f4f4981dee$var$window.cancelAnimationFrame || $b66c30f4f4981dee$var$window.webkitCancelAnimationFrame || $b66c30f4f4981dee$var$window.mozCancelAnimationFrame || $b66c30f4f4981dee$var$window.oCancelAnimationFrame || $b66c30f4f4981dee$var$window.msCancelAnimationFrame;
    if (nativeRequest && nativeCancel) {
        $b66c30f4f4981dee$var$request = nativeRequest;
        $b66c30f4f4981dee$var$cancel = nativeCancel;
    }
    if (nativeRequest && !nativeCancel) {
        var canceledRequests = {};
        $b66c30f4f4981dee$var$request = function(callback) {
            var requestId = nativeRequest.call($b66c30f4f4981dee$var$window, function() {
                try {
                    if (requestId in canceledRequests) return;
                    callback.apply(this, arguments);
                } finally{
                    delete canceledRequests[requestId];
                }
            });
            return requestId;
        };
        $b66c30f4f4981dee$var$cancel = function(requestId) {
            canceledRequests[requestId] = true;
        };
    }
});
$b66c30f4f4981dee$export$6cb2c4c0a22909c0 = function() {
    $b66c30f4f4981dee$var$setAnimationFrameMethods();
    return $b66c30f4f4981dee$var$request.apply($b66c30f4f4981dee$var$window, arguments);
};
$b66c30f4f4981dee$export$e00521de187a817a = function() {
    $b66c30f4f4981dee$var$setAnimationFrameMethods();
    $b66c30f4f4981dee$var$cancel.apply($b66c30f4f4981dee$var$window, arguments);
};

});



parcelRegister("69u7b", function(module, exports) {

$parcel$export(module.exports, "getImageSourceType", () => $47aaf1891ef7cdcb$export$37b46305fe706f6c, (v) => $47aaf1891ef7cdcb$export$37b46305fe706f6c = v);
$parcel$export(module.exports, "getImageContainer", () => $47aaf1891ef7cdcb$export$f7dcaa10bf9da214, (v) => $47aaf1891ef7cdcb$export$f7dcaa10bf9da214 = v);
/**
 * DevExtreme (core/utils/icon.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $47aaf1891ef7cdcb$export$37b46305fe706f6c;
var $47aaf1891ef7cdcb$export$f7dcaa10bf9da214;
"use strict";

var $jFnCG = parcelRequire("jFnCG");
var $47aaf1891ef7cdcb$var$_renderer2 = $47aaf1891ef7cdcb$var$_interopRequireDefault($jFnCG);
function $47aaf1891ef7cdcb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $47aaf1891ef7cdcb$var$ICON_CLASS = "dx-icon";
var $47aaf1891ef7cdcb$var$SVG_ICON_CLASS = "dx-svg-icon";
var $47aaf1891ef7cdcb$var$getImageSourceType = function(source) {
    if (!source || "string" !== typeof source) return false;
    if (/^\s*<svg[^>]*>(.|\r\n|\r|\n)*?<\/svg>\s*$/i.test(source)) return "svg";
    if (/data:.*base64|\.|[^<\s]\//.test(source)) return "image";
    if (/^[\w-_]+$/.test(source)) return "dxIcon";
    if (/^\s?([\w-_]\s?)+$/.test(source)) return "fontIcon";
    return false;
};
var $47aaf1891ef7cdcb$var$getImageContainer = function(source) {
    switch($47aaf1891ef7cdcb$var$getImageSourceType(source)){
        case "image":
            return (0, $47aaf1891ef7cdcb$var$_renderer2.default)("<img>").attr("src", source).addClass($47aaf1891ef7cdcb$var$ICON_CLASS);
        case "fontIcon":
            return (0, $47aaf1891ef7cdcb$var$_renderer2.default)("<i>").addClass("".concat($47aaf1891ef7cdcb$var$ICON_CLASS, " ").concat(source));
        case "dxIcon":
            return (0, $47aaf1891ef7cdcb$var$_renderer2.default)("<i>").addClass("".concat($47aaf1891ef7cdcb$var$ICON_CLASS, " ").concat($47aaf1891ef7cdcb$var$ICON_CLASS, "-").concat(source));
        case "svg":
            return (0, $47aaf1891ef7cdcb$var$_renderer2.default)("<i>").addClass("".concat($47aaf1891ef7cdcb$var$ICON_CLASS, " ").concat($47aaf1891ef7cdcb$var$SVG_ICON_CLASS)).append(source);
        default:
            return null;
    }
};
$47aaf1891ef7cdcb$export$37b46305fe706f6c = $47aaf1891ef7cdcb$var$getImageSourceType;
$47aaf1891ef7cdcb$export$f7dcaa10bf9da214 = $47aaf1891ef7cdcb$var$getImageContainer;

});


parcelRegister("4hjO5", function(module, exports) {
/**
 * DevExtreme (ui/editor/editor.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $31d81d2987dfc6ce$var$_renderer2 = $31d81d2987dfc6ce$var$_interopRequireDefault($jFnCG);

var $8ulMI = parcelRequire("8ulMI");
var $31d81d2987dfc6ce$var$_element_data2 = $31d81d2987dfc6ce$var$_interopRequireDefault($8ulMI);

var $eKdKS = parcelRequire("eKdKS");
var $31d81d2987dfc6ce$var$_callbacks2 = $31d81d2987dfc6ce$var$_interopRequireDefault($eKdKS);

var $2Mto0 = parcelRequire("2Mto0");
var $31d81d2987dfc6ce$var$_common2 = $31d81d2987dfc6ce$var$_interopRequireDefault($2Mto0);

var $irv64 = parcelRequire("irv64");
var $31d81d2987dfc6ce$var$_window2 = $31d81d2987dfc6ce$var$_interopRequireDefault($irv64);

var $bXb2w = parcelRequire("bXb2w");

var $1TtsA = parcelRequire("1TtsA");

var $7I8Uw = parcelRequire("7I8Uw");

var $duKPB = parcelRequire("duKPB");
var $31d81d2987dfc6ce$var$_guid2 = $31d81d2987dfc6ce$var$_interopRequireDefault($duKPB);

var $4gmvS = parcelRequire("4gmvS");
var $31d81d2987dfc6ce$var$_ui2 = $31d81d2987dfc6ce$var$_interopRequireDefault($4gmvS);

var $8LFjz = parcelRequire("8LFjz");
var $31d81d2987dfc6ce$var$_overlay2 = $31d81d2987dfc6ce$var$_interopRequireDefault($8LFjz);

var $ebely = parcelRequire("ebely");
var $31d81d2987dfc6ce$var$_validation_engine2 = $31d81d2987dfc6ce$var$_interopRequireDefault($ebely);

var $e1LMc = parcelRequire("e1LMc");
var $31d81d2987dfc6ce$var$_events_engine2 = $31d81d2987dfc6ce$var$_interopRequireDefault($e1LMc);

var $ksvsU = parcelRequire("ksvsU");
function $31d81d2987dfc6ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $31d81d2987dfc6ce$var$READONLY_STATE_CLASS = "dx-state-readonly";
var $31d81d2987dfc6ce$var$INVALID_CLASS = "dx-invalid";
var $31d81d2987dfc6ce$var$INVALID_MESSAGE = "dx-invalid-message";
var $31d81d2987dfc6ce$var$INVALID_MESSAGE_CONTENT = "dx-invalid-message-content";
var $31d81d2987dfc6ce$var$INVALID_MESSAGE_AUTO = "dx-invalid-message-auto";
var $31d81d2987dfc6ce$var$INVALID_MESSAGE_ALWAYS = "dx-invalid-message-always";
var $31d81d2987dfc6ce$var$DX_INVALID_BADGE_CLASS = "dx-show-invalid-badge";
var $31d81d2987dfc6ce$var$VALIDATION_TARGET = "dx-validation-target";
var $31d81d2987dfc6ce$var$VALIDATION_MESSAGE_MIN_WIDTH = 100;
var $31d81d2987dfc6ce$var$VALIDATION_STATUS_VALID = "valid";
var $31d81d2987dfc6ce$var$VALIDATION_STATUS_INVALID = "invalid";
var $31d81d2987dfc6ce$var$READONLY_NAMESPACE = "editorReadOnly";
var $31d81d2987dfc6ce$var$getValidationErrorMessage = function(validationErrors) {
    var validationErrorMessage = "";
    if (validationErrors) validationErrors.forEach(function(err) {
        if (err.message) validationErrorMessage += (validationErrorMessage ? "<br />" : "") + (0, $ksvsU.encodeHtml)(err.message);
    });
    return validationErrorMessage;
};
var $31d81d2987dfc6ce$var$Editor = $31d81d2987dfc6ce$var$_ui2.default.inherit({
    ctor: function() {
        this.showValidationMessageTimeout = null;
        this.validationRequest = (0, $31d81d2987dfc6ce$var$_callbacks2.default)();
        this.callBase.apply(this, arguments);
    },
    _createElement: function(element) {
        this.callBase(element);
        var $element = this.$element();
        if ($element) $31d81d2987dfc6ce$var$_element_data2.default.data($element[0], $31d81d2987dfc6ce$var$VALIDATION_TARGET, this);
    },
    _initOptions: function(options) {
        this.callBase.apply(this, arguments);
        this.option($31d81d2987dfc6ce$var$_validation_engine2.default.initValidationOptions(options));
    },
    _init: function() {
        this.callBase();
        this._initInnerOptionCache("validationTooltipOptions");
        var $element = this.$element();
        $element.addClass($31d81d2987dfc6ce$var$DX_INVALID_BADGE_CLASS);
    },
    _getDefaultOptions: function() {
        return (0, $7I8Uw.extend)(this.callBase(), {
            value: null,
            name: "",
            onValueChanged: null,
            readOnly: false,
            isValid: true,
            validationError: null,
            validationErrors: null,
            validationStatus: $31d81d2987dfc6ce$var$VALIDATION_STATUS_VALID,
            validationMessageMode: "auto",
            validationBoundary: void 0,
            validationMessageOffset: {
                h: 0,
                v: 0
            },
            validationTooltipOptions: {}
        });
    },
    _attachKeyboardEvents: function() {
        if (this.option("readOnly")) return;
        this.callBase();
        if (this._keyboardProcessor) this._attachChildKeyboardEvents();
    },
    _attachChildKeyboardEvents: $31d81d2987dfc6ce$var$_common2.default.noop,
    _setOptionsByReference: function() {
        this.callBase();
        (0, $7I8Uw.extend)(this._optionsByReference, {
            validationError: true
        });
    },
    _createValueChangeAction: function() {
        this._valueChangeAction = this._createActionByOption("onValueChanged", {
            excludeValidators: [
                "disabled",
                "readOnly"
            ]
        });
    },
    _suppressValueChangeAction: function() {
        this._valueChangeActionSuppressed = true;
    },
    _resumeValueChangeAction: function() {
        this._valueChangeActionSuppressed = false;
    },
    _initMarkup: function() {
        this._toggleReadOnlyState();
        this._setSubmitElementName(this.option("name"));
        this.callBase();
        this._renderValidationState();
    },
    _raiseValueChangeAction: function(value, previousValue) {
        if (!this._valueChangeAction) this._createValueChangeAction();
        this._valueChangeAction(this._valueChangeArgs(value, previousValue));
    },
    _valueChangeArgs: function(value, previousValue) {
        return {
            value: value,
            previousValue: previousValue,
            event: this._valueChangeEventInstance
        };
    },
    _saveValueChangeEvent: function(e) {
        this._valueChangeEventInstance = e;
    },
    _focusInHandler: function(e) {
        var _this = this;
        var isValidationMessageShownOnFocus = "auto" === this.option("validationMessageMode");
        if (this._canValueBeChangedByClick() && isValidationMessageShownOnFocus) {
            this._$validationMessage && this._$validationMessage.removeClass($31d81d2987dfc6ce$var$INVALID_MESSAGE_AUTO);
            clearTimeout(this.showValidationMessageTimeout);
            this.showValidationMessageTimeout = setTimeout(function() {
                return _this._$validationMessage && _this._$validationMessage.addClass($31d81d2987dfc6ce$var$INVALID_MESSAGE_AUTO);
            }, 150);
        }
        return this.callBase(e);
    },
    _canValueBeChangedByClick: function() {
        return false;
    },
    _renderValidationState: function() {
        var isValid = this.option("isValid") && this.option("validationStatus") !== $31d81d2987dfc6ce$var$VALIDATION_STATUS_INVALID;
        var validationMessageMode = this.option("validationMessageMode");
        var $element = this.$element();
        var validationErrors = this.option("validationErrors");
        if (!validationErrors && this.option("validationError")) validationErrors = [
            this.option("validationError")
        ];
        $element.toggleClass($31d81d2987dfc6ce$var$INVALID_CLASS, !isValid);
        this.setAria($31d81d2987dfc6ce$var$VALIDATION_STATUS_INVALID, !isValid || void 0);
        if (!$31d81d2987dfc6ce$var$_window2.default.hasWindow()) return;
        if (this._$validationMessage) {
            this._$validationMessage.remove();
            this.setAria("describedby", null);
            this._$validationMessage = null;
        }
        var validationErrorMessage = $31d81d2987dfc6ce$var$getValidationErrorMessage(validationErrors);
        if (!isValid && validationErrorMessage) {
            this._$validationMessage = (0, $31d81d2987dfc6ce$var$_renderer2.default)("<div>").addClass($31d81d2987dfc6ce$var$INVALID_MESSAGE).html(validationErrorMessage).appendTo($element);
            var validationTarget = this._getValidationMessageTarget();
            this._validationMessage = this._createComponent(this._$validationMessage, $31d81d2987dfc6ce$var$_overlay2.default, (0, $7I8Uw.extend)({
                integrationOptions: {},
                templatesRenderAsynchronously: false,
                target: validationTarget,
                shading: false,
                width: "auto",
                height: "auto",
                container: $element,
                position: this._getValidationMessagePosition("below"),
                closeOnOutsideClick: false,
                closeOnTargetScroll: false,
                animation: null,
                visible: true,
                propagateOutsideClick: true,
                _checkParentVisibility: false
            }, this._getInnerOptionsCache("validationTooltipOptions")));
            this._$validationMessage.toggleClass($31d81d2987dfc6ce$var$INVALID_MESSAGE_AUTO, "auto" === validationMessageMode).toggleClass($31d81d2987dfc6ce$var$INVALID_MESSAGE_ALWAYS, "always" === validationMessageMode);
            var messageId = "dx-" + new $31d81d2987dfc6ce$var$_guid2.default;
            this._validationMessage.$content().addClass($31d81d2987dfc6ce$var$INVALID_MESSAGE_CONTENT).attr("id", messageId);
            this.setAria("describedby", messageId);
            this._setValidationMessageMaxWidth();
            this._bindInnerWidgetOptions(this._validationMessage, "validationTooltipOptions");
        }
    },
    _setValidationMessageMaxWidth: function() {
        if (!this._validationMessage) return;
        if (0 === this._getValidationMessageTarget().outerWidth()) {
            this._validationMessage.option("maxWidth", "100%");
            return;
        }
        var validationMessageMaxWidth = Math.max($31d81d2987dfc6ce$var$VALIDATION_MESSAGE_MIN_WIDTH, this._getValidationMessageTarget().outerWidth());
        this._validationMessage.option("maxWidth", validationMessageMaxWidth);
    },
    _getValidationMessageTarget: function() {
        return this.$element();
    },
    _getValidationMessagePosition: function(positionRequest) {
        var rtlEnabled = this.option("rtlEnabled");
        var messagePositionSide = (0, $1TtsA.getDefaultAlignment)(rtlEnabled);
        var messageOriginalOffset = this.option("validationMessageOffset");
        var messageOffset = {
            h: messageOriginalOffset.h,
            v: messageOriginalOffset.v
        };
        var verticalPositions = "below" === positionRequest ? [
            " top",
            " bottom"
        ] : [
            " bottom",
            " top"
        ];
        if (rtlEnabled) messageOffset.h = -messageOffset.h;
        if ("below" !== positionRequest) messageOffset.v = -messageOffset.v;
        return {
            offset: messageOffset,
            boundary: this.option("validationBoundary"),
            my: messagePositionSide + verticalPositions[0],
            at: messagePositionSide + verticalPositions[1],
            collision: "none flip"
        };
    },
    _toggleReadOnlyState: function() {
        var readOnly = this.option("readOnly");
        this._toggleBackspaceHandler(readOnly);
        this.$element().toggleClass($31d81d2987dfc6ce$var$READONLY_STATE_CLASS, !!readOnly);
        this.setAria("readonly", readOnly || void 0);
    },
    _toggleBackspaceHandler: function(isReadOnly) {
        var $eventTarget = this._keyboardEventBindingTarget();
        var eventName = (0, $bXb2w.addNamespace)("keydown", $31d81d2987dfc6ce$var$READONLY_NAMESPACE);
        $31d81d2987dfc6ce$var$_events_engine2.default.off($eventTarget, eventName);
        if (isReadOnly) $31d81d2987dfc6ce$var$_events_engine2.default.on($eventTarget, eventName, function(e) {
            if ("backspace" === (0, $bXb2w.normalizeKeyName)(e)) e.preventDefault();
        });
    },
    _dispose: function() {
        var element = this.$element()[0];
        $31d81d2987dfc6ce$var$_element_data2.default.data(element, $31d81d2987dfc6ce$var$VALIDATION_TARGET, null);
        clearTimeout(this.showValidationMessageTimeout);
        this.callBase();
    },
    _setSubmitElementName: function(name) {
        var $submitElement = this._getSubmitElement();
        if (!$submitElement) return;
        if (name.length > 0) $submitElement.attr("name", name);
        else $submitElement.removeAttr("name");
    },
    _getSubmitElement: function() {
        return null;
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "onValueChanged":
                this._createValueChangeAction();
                break;
            case "isValid":
            case "validationError":
                this.option($31d81d2987dfc6ce$var$_validation_engine2.default.synchronizeValidationOptions(args, this.option()));
                break;
            case "validationErrors":
            case "validationStatus":
                this.option($31d81d2987dfc6ce$var$_validation_engine2.default.synchronizeValidationOptions(args, this.option()));
                this._renderValidationState();
                break;
            case "validationBoundary":
            case "validationMessageMode":
                this._renderValidationState();
                break;
            case "validationTooltipOptions":
                this._innerOptionChanged(this._validationMessage, args);
                break;
            case "readOnly":
                this._toggleReadOnlyState();
                this._refreshFocusState();
                break;
            case "value":
                if (args.value != args.previousValue) this.validationRequest.fire({
                    value: args.value,
                    editor: this
                });
                if (!this._valueChangeActionSuppressed) {
                    this._raiseValueChangeAction(args.value, args.previousValue);
                    this._saveValueChangeEvent(void 0);
                }
                break;
            case "width":
                this.callBase(args);
                this._setValidationMessageMaxWidth();
                break;
            case "name":
                this._setSubmitElementName(args.value);
                break;
            default:
                this.callBase(args);
        }
    },
    reset: function() {
        var defaultOptions = this._getDefaultOptions();
        this.option("value", defaultOptions.value);
    }
});
module.exports = $31d81d2987dfc6ce$var$Editor;

});
parcelRegister("1TtsA", function(module, exports) {

$parcel$export(module.exports, "getDefaultAlignment", () => $1611c7a3bb10c3ba$export$26ebcca015e3a72, (v) => $1611c7a3bb10c3ba$export$26ebcca015e3a72 = v);
$parcel$export(module.exports, "getBoundingRect", () => $1611c7a3bb10c3ba$export$c381147bfed79d9f, (v) => $1611c7a3bb10c3ba$export$c381147bfed79d9f = v);
/**
 * DevExtreme (core/utils/position.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $1611c7a3bb10c3ba$export$26ebcca015e3a72;
var $1611c7a3bb10c3ba$export$c381147bfed79d9f;
"use strict";

var $1JvXr = parcelRequire("1JvXr");
var $1611c7a3bb10c3ba$var$_config2 = $1611c7a3bb10c3ba$var$_interopRequireDefault($1JvXr);

var $kDRxH = parcelRequire("kDRxH");
var $1611c7a3bb10c3ba$var$_type2 = $1611c7a3bb10c3ba$var$_interopRequireDefault($kDRxH);
function $1611c7a3bb10c3ba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $1611c7a3bb10c3ba$var$getDefaultAlignment = function(isRtlEnabled) {
    var rtlEnabled = null !== isRtlEnabled && void 0 !== isRtlEnabled ? isRtlEnabled : (0, $1611c7a3bb10c3ba$var$_config2.default)().rtlEnabled;
    return rtlEnabled ? "right" : "left";
};
var $1611c7a3bb10c3ba$var$getBoundingRect = function(element) {
    if ($1611c7a3bb10c3ba$var$_type2.default.isWindow(element)) return {
        width: element.outerWidth,
        height: element.outerHeight
    };
    var rect;
    try {
        rect = element.getBoundingClientRect();
    } catch (e) {
        rect = {
            width: 0,
            height: 0,
            bottom: 0,
            top: 0,
            left: 0,
            right: 0
        };
    }
    return rect;
};
$1611c7a3bb10c3ba$export$26ebcca015e3a72 = $1611c7a3bb10c3ba$var$getDefaultAlignment;
$1611c7a3bb10c3ba$export$c381147bfed79d9f = $1611c7a3bb10c3ba$var$getBoundingRect;

});

parcelRegister("8LFjz", function(module, exports) {
/**
 * DevExtreme (ui/overlay.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

module.exports = (parcelRequire("Qk4J0"));
module.exports.default = module.exports;

});
parcelRegister("Qk4J0", function(module, exports) {
/**
 * DevExtreme (ui/overlay/ui.overlay.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
function $09d46df6425992c5$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $09d46df6425992c5$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $09d46df6425992c5$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $09d46df6425992c5$var$_typeof(obj);
}

var $jFnCG = parcelRequire("jFnCG");

var $445Bz = parcelRequire("445Bz");

var $irv64 = parcelRequire("irv64");

var $g4e4U = parcelRequire("g4e4U");
var $09d46df6425992c5$require$ready = $g4e4U.add;
var $09d46df6425992c5$var$window = $irv64.getWindow();
var $09d46df6425992c5$var$navigator = $irv64.getNavigator();

var $e1LMc = parcelRequire("e1LMc");

var $c7ml4 = parcelRequire("c7ml4");

var $6jr65 = parcelRequire("6jr65");

var $hwytx = parcelRequire("hwytx");
var $09d46df6425992c5$require$compareVersions = $hwytx.compare;

var $7wA28 = parcelRequire("7wA28");

var $7I8Uw = parcelRequire("7I8Uw");
var $09d46df6425992c5$require$extend = $7I8Uw.extend;

var $aLQK5 = parcelRequire("aLQK5");
var $09d46df6425992c5$require$inArray = $aLQK5.inArray;

var $5OzEX = parcelRequire("5OzEX");
var $09d46df6425992c5$require$getPublicElement = $5OzEX.getPublicElement;
var $09d46df6425992c5$var$viewPortChanged = $7wA28.changeCallback;

var $mN2g9 = parcelRequire("mN2g9");
var $09d46df6425992c5$require$hideTopOverlayCallback = $mN2g9.hideCallback;

var $bgCx6 = parcelRequire("bgCx6");

var $efpkH = parcelRequire("efpkH");
var $09d46df6425992c5$require$fitIntoRange = $efpkH.fitIntoRange;

var $5OzEX = parcelRequire("5OzEX");

var $2Mto0 = parcelRequire("2Mto0");
var $09d46df6425992c5$require$noop = $2Mto0.noop;

var $kDRxH = parcelRequire("kDRxH");

var $4Pwuy = parcelRequire("4Pwuy");
var $09d46df6425992c5$require$each = $4Pwuy.each;

var $aiwte = parcelRequire("aiwte");

var $bvcPv = parcelRequire("bvcPv");

var $4ZFRo = parcelRequire("4ZFRo");

var $4gmvS = parcelRequire("4gmvS");

var $2ADoP = parcelRequire("2ADoP");

var $3joCJ = parcelRequire("3joCJ");

var $cesi3 = parcelRequire("cesi3");

var $bXb2w = parcelRequire("bXb2w");

var $gP4Gh = parcelRequire("gP4Gh");

var $i1UKB = parcelRequire("i1UKB");

var $e5a0x = parcelRequire("e5a0x");
var $09d46df6425992c5$require$EmptyTemplate = $e5a0x.EmptyTemplate;

var $2F60d = parcelRequire("2F60d");
var $09d46df6425992c5$require$Deferred = $2F60d.Deferred;

var $gN9eB = parcelRequire("gN9eB");

var $krF3o = parcelRequire("krF3o");
var $09d46df6425992c5$var$OVERLAY_CLASS = "dx-overlay";
var $09d46df6425992c5$var$OVERLAY_WRAPPER_CLASS = "dx-overlay-wrapper";
var $09d46df6425992c5$var$OVERLAY_CONTENT_CLASS = "dx-overlay-content";
var $09d46df6425992c5$var$OVERLAY_SHADER_CLASS = "dx-overlay-shader";
var $09d46df6425992c5$var$OVERLAY_MODAL_CLASS = "dx-overlay-modal";
var $09d46df6425992c5$var$INNER_OVERLAY_CLASS = "dx-inner-overlay";
var $09d46df6425992c5$var$INVISIBLE_STATE_CLASS = "dx-state-invisible";
var $09d46df6425992c5$var$ANONYMOUS_TEMPLATE_NAME = "content";
var $09d46df6425992c5$var$RTL_DIRECTION_CLASS = "dx-rtl";
var $09d46df6425992c5$var$ACTIONS = [
    "onShowing",
    "onShown",
    "onHiding",
    "onHidden",
    "onPositioning",
    "onPositioned",
    "onResizeStart",
    "onResize",
    "onResizeEnd"
];
var $09d46df6425992c5$var$OVERLAY_STACK = [];
var $09d46df6425992c5$var$DISABLED_STATE_CLASS = "dx-state-disabled";
var $09d46df6425992c5$var$PREVENT_SAFARI_SCROLLING_CLASS = "dx-prevent-safari-scrolling";
var $09d46df6425992c5$var$TAB_KEY = "tab";
var $09d46df6425992c5$var$POSITION_ALIASES = {
    top: {
        my: "top center",
        at: "top center"
    },
    bottom: {
        my: "bottom center",
        at: "bottom center"
    },
    right: {
        my: "right center",
        at: "right center"
    },
    left: {
        my: "left center",
        at: "left center"
    },
    center: {
        my: "center",
        at: "center"
    },
    "right bottom": {
        my: "right bottom",
        at: "right bottom"
    },
    "right top": {
        my: "right top",
        at: "right top"
    },
    "left bottom": {
        my: "left bottom",
        at: "left bottom"
    },
    "left top": {
        my: "left top",
        at: "left top"
    }
};
var $09d46df6425992c5$var$realDevice = $aiwte.real();
var $09d46df6425992c5$var$realVersion = $09d46df6425992c5$var$realDevice.version;
var $09d46df6425992c5$var$firefoxDesktop = $bvcPv.mozilla && "desktop" === $09d46df6425992c5$var$realDevice.deviceType;
var $09d46df6425992c5$var$iOS = "ios" === $09d46df6425992c5$var$realDevice.platform;
var $09d46df6425992c5$var$hasSafariAddressBar = $bvcPv.safari && "desktop" !== $09d46df6425992c5$var$realDevice.deviceType;
var $09d46df6425992c5$var$android4_0nativeBrowser = "android" === $09d46df6425992c5$var$realDevice.platform && 0 === $09d46df6425992c5$require$compareVersions($09d46df6425992c5$var$realVersion, [
    4,
    0
], 2) && $09d46df6425992c5$var$navigator.userAgent.indexOf("Chrome") === -1;
var $09d46df6425992c5$var$forceRepaint = function($element) {
    if ($09d46df6425992c5$var$firefoxDesktop) $element.width();
    if ($09d46df6425992c5$var$android4_0nativeBrowser) {
        var $parents = $element.parents();
        var inScrollView = $parents.is(".dx-scrollable-native");
        if (!inScrollView) {
            $parents.css("backfaceVisibility", "hidden");
            $parents.css("backfaceVisibility");
            $parents.css("backfaceVisibility", "visible");
        }
    }
};
var $09d46df6425992c5$var$getElement = function(value) {
    return value && $jFnCG(value.target || value);
};
$09d46df6425992c5$require$ready(function() {
    $e1LMc.subscribeGlobal($445Bz.getDocument(), $gP4Gh.down, function(e) {
        for(var i = $09d46df6425992c5$var$OVERLAY_STACK.length - 1; i >= 0; i--){
            if (!$09d46df6425992c5$var$OVERLAY_STACK[i]._proxiedDocumentDownHandler(e)) return;
        }
    });
});
var $09d46df6425992c5$var$Overlay = $4gmvS.inherit({
    _supportedKeys: function() {
        var offsetSize = 5;
        var move = function(top, left, e) {
            if (!this.option("dragEnabled")) return;
            e.preventDefault();
            e.stopPropagation();
            var allowedOffsets = this._allowedOffsets();
            var offset = {
                top: $09d46df6425992c5$require$fitIntoRange(top, -allowedOffsets.top, allowedOffsets.bottom),
                left: $09d46df6425992c5$require$fitIntoRange(left, -allowedOffsets.left, allowedOffsets.right)
            };
            this._changePosition(offset);
        };
        return $09d46df6425992c5$require$extend(this.callBase(), {
            escape: function() {
                this.hide();
            },
            upArrow: move.bind(this, -offsetSize, 0),
            downArrow: move.bind(this, offsetSize, 0),
            leftArrow: move.bind(this, 0, -offsetSize),
            rightArrow: move.bind(this, 0, offsetSize)
        });
    },
    _getDefaultOptions: function() {
        return $09d46df6425992c5$require$extend(this.callBase(), {
            activeStateEnabled: false,
            visible: false,
            deferRendering: true,
            shading: true,
            shadingColor: "",
            position: {
                my: "center",
                at: "center"
            },
            width: function() {
                return .8 * $jFnCG($09d46df6425992c5$var$window).width();
            },
            minWidth: null,
            maxWidth: null,
            height: function() {
                return .8 * $jFnCG($09d46df6425992c5$var$window).height();
            },
            minHeight: null,
            maxHeight: null,
            animation: {
                show: {
                    type: "pop",
                    duration: 300,
                    from: {
                        scale: .55
                    }
                },
                hide: {
                    type: "pop",
                    duration: 300,
                    to: {
                        opacity: 0,
                        scale: .55
                    },
                    from: {
                        opacity: 1,
                        scale: 1
                    }
                }
            },
            closeOnOutsideClick: false,
            closeOnBackButton: true,
            onShowing: null,
            onShown: null,
            onHiding: null,
            onHidden: null,
            contentTemplate: "content",
            dragEnabled: false,
            resizeEnabled: false,
            onResizeStart: null,
            onResize: null,
            onResizeEnd: null,
            innerOverlay: false,
            target: void 0,
            container: void 0,
            hideTopOverlayHandler: void 0,
            closeOnTargetScroll: false,
            onPositioned: null,
            boundaryOffset: {
                h: 0,
                v: 0
            },
            propagateOutsideClick: false,
            ignoreChildEvents: true,
            _checkParentVisibility: true
        });
    },
    _defaultOptionsRules: function() {
        return this.callBase().concat([
            {
                device: function() {
                    var realDevice = $aiwte.real();
                    var realPlatform = realDevice.platform;
                    var realVersion = realDevice.version;
                    return "android" === realPlatform && $09d46df6425992c5$require$compareVersions(realVersion, [
                        4,
                        2
                    ]) < 0;
                },
                options: {
                    animation: {
                        show: {
                            type: "fade",
                            duration: 400
                        },
                        hide: {
                            type: "fade",
                            duration: 400,
                            to: {
                                opacity: 0
                            },
                            from: {
                                opacity: 1
                            }
                        }
                    }
                }
            },
            {
                device: function() {
                    return !$irv64.hasWindow();
                },
                options: {
                    width: null,
                    height: null,
                    animation: null,
                    _checkParentVisibility: false
                }
            }
        ]);
    },
    _setOptionsByReference: function() {
        this.callBase();
        $09d46df6425992c5$require$extend(this._optionsByReference, {
            animation: true
        });
    },
    _getAnonymousTemplateName: function() {
        return $09d46df6425992c5$var$ANONYMOUS_TEMPLATE_NAME;
    },
    _wrapper: function() {
        return this._$wrapper;
    },
    _container: function() {
        return this._$content;
    },
    _eventBindingTarget: function() {
        return this._$content;
    },
    _init: function() {
        this.callBase();
        this._initActions();
        this._initCloseOnOutsideClickHandler();
        this._initTabTerminatorHandler();
        this._$wrapper = $jFnCG("<div>").addClass($09d46df6425992c5$var$OVERLAY_WRAPPER_CLASS);
        this._$content = $jFnCG("<div>").addClass($09d46df6425992c5$var$OVERLAY_CONTENT_CLASS);
        this._initInnerOverlayClass();
        var $element = this.$element();
        this._$wrapper.addClass($element.attr("class"));
        $element.addClass($09d46df6425992c5$var$OVERLAY_CLASS);
        this._$wrapper.attr("data-bind", "dxControlsDescendantBindings: true");
        $e1LMc.on(this._$wrapper, "MSPointerDown", $09d46df6425992c5$require$noop);
        $e1LMc.on(this._$wrapper, "focusin", function(e) {
            e.stopPropagation();
        });
        this._toggleViewPortSubscription(true);
    },
    _initOptions: function(options) {
        this._initTarget(options.target);
        var container = void 0 === options.container ? this.option("container") : options.container;
        this._initContainer(container);
        this._initHideTopOverlayHandler(options.hideTopOverlayHandler);
        this.callBase(options);
    },
    _initInnerOverlayClass: function() {
        this._$content.toggleClass($09d46df6425992c5$var$INNER_OVERLAY_CLASS, this.option("innerOverlay"));
    },
    _initTarget: function(target) {
        if (!$kDRxH.isDefined(target)) return;
        var options = this.option();
        $09d46df6425992c5$require$each([
            "position.of",
            "animation.show.from.position.of",
            "animation.show.to.position.of",
            "animation.hide.from.position.of",
            "animation.hide.to.position.of"
        ], function(_, path) {
            var pathParts = path.split(".");
            var option = options;
            while(option)if (1 === pathParts.length) {
                if ($kDRxH.isPlainObject(option)) option[pathParts.shift()] = target;
                break;
            } else option = option[pathParts.shift()];
        });
    },
    _initContainer: function(container) {
        container = void 0 === container ? $7wA28.value() : container;
        var $element = this.$element();
        var $container = $element.closest(container);
        if (!$container.length) $container = $jFnCG(container).first();
        this._$container = $container.length ? $container : $element.parent();
    },
    _initHideTopOverlayHandler: function(handler) {
        this._hideTopOverlayHandler = void 0 !== handler ? handler : this._defaultHideTopOverlayHandler.bind(this);
    },
    _defaultHideTopOverlayHandler: function() {
        this.hide();
    },
    _initActions: function() {
        this._actions = {};
        $09d46df6425992c5$require$each($09d46df6425992c5$var$ACTIONS, (function(_, action) {
            this._actions[action] = this._createActionByOption(action, {
                excludeValidators: [
                    "disabled",
                    "readOnly"
                ]
            }) || $09d46df6425992c5$require$noop;
        }).bind(this));
    },
    _initCloseOnOutsideClickHandler: function() {
        var that = this;
        this._proxiedDocumentDownHandler = function() {
            return that._documentDownHandler.apply(that, arguments);
        };
    },
    _documentDownHandler: function(e) {
        if (this._showAnimationProcessing) this._stopAnimation();
        var closeOnOutsideClick = this.option("closeOnOutsideClick");
        if ($kDRxH.isFunction(closeOnOutsideClick)) closeOnOutsideClick = closeOnOutsideClick(e);
        var $container = this._$content;
        var isAttachedTarget = $jFnCG($09d46df6425992c5$var$window.document).is(e.target) || $5OzEX.contains($09d46df6425992c5$var$window.document, e.target);
        var isInnerOverlay = $jFnCG(e.target).closest("." + $09d46df6425992c5$var$INNER_OVERLAY_CLASS).length;
        var outsideClick = isAttachedTarget && !isInnerOverlay && !($container.is(e.target) || $5OzEX.contains($container.get(0), e.target));
        if (outsideClick && closeOnOutsideClick) this._outsideClickHandler(e);
        return this.option("propagateOutsideClick");
    },
    _outsideClickHandler: function(e) {
        if (this.option("shading")) e.preventDefault();
        this.hide();
    },
    _initTemplates: function() {
        this.callBase();
        this._defaultTemplates.content = new $09d46df6425992c5$require$EmptyTemplate;
    },
    _isTopOverlay: function() {
        var overlayStack = this._overlayStack();
        for(var i = overlayStack.length - 1; i >= 0; i--){
            var tabbableElements = overlayStack[i]._findTabbableBounds();
            if (tabbableElements.first || tabbableElements.last) return overlayStack[i] === this;
        }
        return false;
    },
    _overlayStack: function() {
        return $09d46df6425992c5$var$OVERLAY_STACK;
    },
    _zIndexInitValue: function() {
        return $09d46df6425992c5$var$Overlay.baseZIndex();
    },
    _toggleViewPortSubscription: function(toggle) {
        $09d46df6425992c5$var$viewPortChanged.remove(this._viewPortChangeHandle);
        if (toggle) {
            this._viewPortChangeHandle = this._viewPortChangeHandler.bind(this);
            $09d46df6425992c5$var$viewPortChanged.add(this._viewPortChangeHandle);
        }
    },
    _viewPortChangeHandler: function() {
        this._initContainer(this.option("container"));
        this._refresh();
    },
    _renderVisibilityAnimate: function(visible) {
        this._stopAnimation();
        return visible ? this._show() : this._hide();
    },
    _normalizePosition: function() {
        var position = this.option("position");
        this._position = "function" === typeof position ? position() : position;
    },
    _getAnimationConfig: function() {
        var animation = this.option("animation");
        if ($kDRxH.isFunction(animation)) animation = animation.call(this);
        return animation;
    },
    _show: function() {
        var that = this;
        var deferred = new $09d46df6425992c5$require$Deferred;
        this._parentHidden = this._isParentHidden();
        deferred.done(function() {
            delete that._parentHidden;
        });
        if (this._parentHidden) {
            this._isHidden = true;
            return deferred.resolve();
        }
        if (this._currentVisible) return (new $09d46df6425992c5$require$Deferred).resolve().promise();
        this._currentVisible = true;
        this._isShown = false;
        this._normalizePosition();
        var animation = that._getAnimationConfig() || {};
        var showAnimation = this._normalizeAnimation(animation.show, "to");
        var startShowAnimation = showAnimation && showAnimation.start || $09d46df6425992c5$require$noop;
        var completeShowAnimation = showAnimation && showAnimation.complete || $09d46df6425992c5$require$noop;
        if (this._isHidingActionCanceled) {
            delete this._isHidingActionCanceled;
            deferred.resolve();
        } else {
            var show = (function() {
                this._renderVisibility(true);
                if (this._isShowingActionCanceled) {
                    delete this._isShowingActionCanceled;
                    deferred.resolve();
                    return;
                }
                this._animate(showAnimation, function() {
                    if (that.option("focusStateEnabled")) $e1LMc.trigger(that._focusTarget(), "focus");
                    completeShowAnimation.apply(this, arguments);
                    that._showAnimationProcessing = false;
                    that._isShown = true;
                    that._actions.onShown();
                    that._toggleSafariScrolling(false);
                    deferred.resolve();
                }, function() {
                    startShowAnimation.apply(this, arguments);
                    that._showAnimationProcessing = true;
                });
            }).bind(this);
            if (this.option("templatesRenderAsynchronously")) {
                this._stopShowTimer();
                this._asyncShowTimeout = setTimeout(show);
            } else show();
        }
        return deferred.promise();
    },
    _normalizeAnimation: function(animation, prop) {
        if (animation) {
            animation = $09d46df6425992c5$require$extend({
                type: "slide"
            }, animation);
            if (animation[prop] && "object" === $09d46df6425992c5$var$_typeof(animation[prop])) $09d46df6425992c5$require$extend(animation[prop], {
                position: this._position
            });
        }
        return animation;
    },
    _hide: function() {
        if (!this._currentVisible) return (new $09d46df6425992c5$require$Deferred).resolve().promise();
        this._currentVisible = false;
        var that = this;
        var deferred = new $09d46df6425992c5$require$Deferred;
        var animation = that._getAnimationConfig() || {};
        var hideAnimation = this._normalizeAnimation(animation.hide, "from");
        var startHideAnimation = hideAnimation && hideAnimation.start || $09d46df6425992c5$require$noop;
        var completeHideAnimation = hideAnimation && hideAnimation.complete || $09d46df6425992c5$require$noop;
        var hidingArgs = {
            cancel: false
        };
        if (this._isShowingActionCanceled) deferred.resolve();
        else {
            this._actions.onHiding(hidingArgs);
            that._toggleSafariScrolling(true);
            if (hidingArgs.cancel) {
                this._isHidingActionCanceled = true;
                this.option("visible", true);
                deferred.resolve();
            } else {
                this._forceFocusLost();
                this._toggleShading(false);
                this._toggleSubscriptions(false);
                this._stopShowTimer();
                this._animate(hideAnimation, function() {
                    that._$content.css("pointerEvents", "");
                    that._renderVisibility(false);
                    completeHideAnimation.apply(this, arguments);
                    that._actions.onHidden();
                    deferred.resolve();
                }, function() {
                    that._$content.css("pointerEvents", "none");
                    startHideAnimation.apply(this, arguments);
                });
            }
        }
        return deferred.promise();
    },
    _forceFocusLost: function() {
        var activeElement = $445Bz.getActiveElement();
        var shouldResetActiveElement = !!this._$content.find(activeElement).length;
        if (shouldResetActiveElement) $5OzEX.resetActiveElement();
    },
    _animate: function(animation, completeCallback, startCallback) {
        if (animation) {
            startCallback = startCallback || animation.start || $09d46df6425992c5$require$noop;
            $c7ml4.animate(this._$content, $09d46df6425992c5$require$extend({}, animation, {
                start: startCallback,
                complete: completeCallback
            }));
        } else completeCallback();
    },
    _stopAnimation: function() {
        $c7ml4.stop(this._$content, true);
    },
    _renderVisibility: function(visible) {
        if (visible && this._isParentHidden()) return;
        this._currentVisible = visible;
        this._stopAnimation();
        if (!visible) $5OzEX.triggerHidingEvent(this._$content);
        this._toggleVisibility(visible);
        this._$content.toggleClass($09d46df6425992c5$var$INVISIBLE_STATE_CLASS, !visible);
        this._updateZIndexStackPosition(visible);
        if (visible) {
            this._renderContent();
            var showingArgs = {
                cancel: false
            };
            this._actions.onShowing(showingArgs);
            if (showingArgs.cancel) {
                this._toggleVisibility(false);
                this._$content.toggleClass($09d46df6425992c5$var$INVISIBLE_STATE_CLASS, true);
                this._updateZIndexStackPosition(false);
                this._moveFromContainer();
                this._isShowingActionCanceled = true;
                this.option("visible", false);
                return;
            }
            this._moveToContainer();
            this._renderGeometry();
            $5OzEX.triggerShownEvent(this._$content);
            $5OzEX.triggerResizeEvent(this._$content);
        } else this._moveFromContainer();
        this._toggleShading(visible);
        this._toggleSubscriptions(visible);
    },
    _updateZIndexStackPosition: function(pushToStack) {
        var overlayStack = this._overlayStack();
        var index = $09d46df6425992c5$require$inArray(this, overlayStack);
        if (pushToStack) {
            if (index === -1) {
                this._zIndex = $gN9eB.create(this._zIndexInitValue());
                overlayStack.push(this);
            }
            this._$wrapper.css("zIndex", this._zIndex);
            this._$content.css("zIndex", this._zIndex);
        } else if (index !== -1) {
            overlayStack.splice(index, 1);
            $gN9eB.remove(this._zIndex);
        }
    },
    _toggleShading: function(visible) {
        this._$wrapper.toggleClass($09d46df6425992c5$var$OVERLAY_MODAL_CLASS, this.option("shading") && !this.option("container"));
        this._$wrapper.toggleClass($09d46df6425992c5$var$OVERLAY_SHADER_CLASS, visible && this.option("shading"));
        this._$wrapper.css("backgroundColor", this.option("shading") ? this.option("shadingColor") : "");
        this._toggleTabTerminator(visible && this.option("shading"));
    },
    _initTabTerminatorHandler: function() {
        var that = this;
        this._proxiedTabTerminatorHandler = function() {
            that._tabKeyHandler.apply(that, arguments);
        };
    },
    _toggleTabTerminator: function(enabled) {
        var eventName = $bXb2w.addNamespace("keydown", this.NAME);
        if (enabled) $e1LMc.on($445Bz.getDocument(), eventName, this._proxiedTabTerminatorHandler);
        else $e1LMc.off($445Bz.getDocument(), eventName, this._proxiedTabTerminatorHandler);
    },
    _findTabbableBounds: function() {
        var $elements = this._$wrapper.find("*");
        var elementsCount = $elements.length - 1;
        var result = {
            first: null,
            last: null
        };
        for(var i = 0; i <= elementsCount; i++){
            if (!result.first && $elements.eq(i).is($3joCJ.tabbable)) result.first = $elements.eq(i);
            if (!result.last && $elements.eq(elementsCount - i).is($3joCJ.tabbable)) result.last = $elements.eq(elementsCount - i);
            if (result.first && result.last) break;
        }
        return result;
    },
    _tabKeyHandler: function(e) {
        if ($bXb2w.normalizeKeyName(e) !== $09d46df6425992c5$var$TAB_KEY || !this._isTopOverlay()) return;
        var tabbableElements = this._findTabbableBounds();
        var $firstTabbable = tabbableElements.first;
        var $lastTabbable = tabbableElements.last;
        var isTabOnLast = !e.shiftKey && e.target === $lastTabbable.get(0);
        var isShiftTabOnFirst = e.shiftKey && e.target === $firstTabbable.get(0);
        var isEmptyTabList = 0 === tabbableElements.length;
        var isOutsideTarget = !$5OzEX.contains(this._$wrapper.get(0), e.target);
        if (isTabOnLast || isShiftTabOnFirst || isEmptyTabList || isOutsideTarget) {
            e.preventDefault();
            var $focusElement = e.shiftKey ? $lastTabbable : $firstTabbable;
            $e1LMc.trigger($focusElement, "focusin");
            $e1LMc.trigger($focusElement, "focus");
        }
    },
    _toggleSubscriptions: function(enabled) {
        if ($irv64.hasWindow()) {
            this._toggleHideTopOverlayCallback(enabled);
            this._toggleParentsScrollSubscription(enabled);
        }
    },
    _toggleHideTopOverlayCallback: function(subscribe) {
        if (!this._hideTopOverlayHandler) return;
        if (subscribe && this.option("closeOnBackButton")) $09d46df6425992c5$require$hideTopOverlayCallback.add(this._hideTopOverlayHandler);
        else $09d46df6425992c5$require$hideTopOverlayCallback.remove(this._hideTopOverlayHandler);
    },
    _toggleParentsScrollSubscription: function(subscribe) {
        if (!this._position) return;
        var target = this._position.of || $jFnCG();
        var closeOnScroll = this.option("closeOnTargetScroll");
        var $parents = $09d46df6425992c5$var$getElement(target).parents();
        var scrollEvent = $bXb2w.addNamespace("scroll", this.NAME);
        if ("desktop" === $aiwte.real().deviceType) $parents = $parents.add($09d46df6425992c5$var$window);
        this._proxiedTargetParentsScrollHandler = this._proxiedTargetParentsScrollHandler || (function(e) {
            this._targetParentsScrollHandler(e);
        }).bind(this);
        $e1LMc.off($jFnCG().add(this._$prevTargetParents), scrollEvent, this._proxiedTargetParentsScrollHandler);
        if (subscribe && closeOnScroll) {
            $e1LMc.on($parents, scrollEvent, this._proxiedTargetParentsScrollHandler);
            this._$prevTargetParents = $parents;
        }
    },
    _targetParentsScrollHandler: function(e) {
        var closeHandled = false;
        var closeOnScroll = this.option("closeOnTargetScroll");
        if ($kDRxH.isFunction(closeOnScroll)) closeHandled = closeOnScroll(e);
        if (!closeHandled && !this._showAnimationProcessing) this.hide();
    },
    _render: function() {
        this.callBase();
        this._appendContentToElement();
        this._renderVisibilityAnimate(this.option("visible"));
    },
    _appendContentToElement: function() {
        if (!this._$content.parent().is(this.$element())) this._$content.appendTo(this.$element());
    },
    _renderContent: function() {
        var shouldDeferRendering = !this._currentVisible && this.option("deferRendering");
        var isParentHidden = this.option("visible") && this._isParentHidden();
        if (isParentHidden) {
            this._isHidden = true;
            return;
        }
        if (this._contentAlreadyRendered || shouldDeferRendering) return;
        this._contentAlreadyRendered = true;
        this._appendContentToElement();
        this.callBase();
    },
    _isParentHidden: function() {
        if (!this.option("_checkParentVisibility")) return false;
        if (void 0 !== this._parentHidden) return this._parentHidden;
        var $parent = this.$element().parent();
        if ($parent.is(":visible")) return false;
        var isHidden = false;
        $parent.add($parent.parents()).each(function() {
            var $element = $jFnCG(this);
            if ("none" === $element.css("display")) {
                isHidden = true;
                return false;
            }
        });
        return isHidden || !$445Bz.getBody().contains($parent.get(0));
    },
    _renderContentImpl: function() {
        var _this = this;
        var whenContentRendered = new $09d46df6425992c5$require$Deferred;
        var contentTemplateOption = this.option("contentTemplate");
        var contentTemplate = this._getTemplate(contentTemplateOption);
        var transclude = this._getAnonymousTemplateName() === contentTemplateOption;
        contentTemplate && contentTemplate.render({
            container: $09d46df6425992c5$require$getPublicElement(this.$content()),
            noModel: true,
            transclude: transclude,
            onRendered: function() {
                whenContentRendered.resolve();
            }
        });
        this._renderDrag();
        this._renderResize();
        this._renderScrollTerminator();
        whenContentRendered.done(function() {
            if (_this.option("visible")) _this._moveToContainer();
        });
        return whenContentRendered.promise();
    },
    _renderDrag: function() {
        var $dragTarget = this._getDragTarget();
        if (!$dragTarget) return;
        var startEventName = $bXb2w.addNamespace($cesi3.start, this.NAME);
        var updateEventName = $bXb2w.addNamespace($cesi3.move, this.NAME);
        $e1LMc.off($dragTarget, startEventName);
        $e1LMc.off($dragTarget, updateEventName);
        if (!this.option("dragEnabled")) return;
        $e1LMc.on($dragTarget, startEventName, this._dragStartHandler.bind(this));
        $e1LMc.on($dragTarget, updateEventName, this._dragUpdateHandler.bind(this));
    },
    _renderResize: function() {
        this._resizable = this._createComponent(this._$content, $i1UKB, {
            handles: this.option("resizeEnabled") ? "all" : "none",
            onResizeEnd: this._resizeEndHandler.bind(this),
            onResize: this._actions.onResize.bind(this),
            onResizeStart: this._actions.onResizeStart.bind(this),
            minHeight: 100,
            minWidth: 100,
            area: this._getDragResizeContainer()
        });
    },
    _resizeEndHandler: function() {
        this._positionChangeHandled = true;
        var width = this._resizable.option("width");
        var height = this._resizable.option("height");
        width && this.option("width", width);
        height && this.option("height", height);
        this._actions.onResizeEnd();
    },
    _renderScrollTerminator: function() {
        var $scrollTerminator = this._wrapper();
        var terminatorEventName = $bXb2w.addNamespace($cesi3.move, this.NAME);
        $e1LMc.off($scrollTerminator, terminatorEventName);
        $e1LMc.on($scrollTerminator, terminatorEventName, {
            validate: function() {
                return true;
            },
            getDirection: function() {
                return "both";
            },
            _toggleGestureCover: function(toggle) {
                if (!toggle) this._toggleGestureCoverImpl(toggle);
            },
            _clearSelection: $09d46df6425992c5$require$noop,
            isNative: true
        }, function(e) {
            var originalEvent = e.originalEvent.originalEvent;
            e._cancelPreventDefault = true;
            if (originalEvent && "mousemove" !== originalEvent.type && false !== e.cancelable) e.preventDefault();
        });
    },
    _getDragTarget: function() {
        return this.$content();
    },
    _dragStartHandler: function(e) {
        e.targetElements = [];
        this._prevOffset = {
            x: 0,
            y: 0
        };
        var allowedOffsets = this._allowedOffsets();
        e.maxTopOffset = allowedOffsets.top;
        e.maxBottomOffset = allowedOffsets.bottom;
        e.maxLeftOffset = allowedOffsets.left;
        e.maxRightOffset = allowedOffsets.right;
    },
    _getDragResizeContainer: function() {
        var isContainerDefined = $7wA28.originalViewPort().get(0) || this.option("container");
        var $container = !isContainerDefined ? $jFnCG($09d46df6425992c5$var$window) : this._$container;
        return $container;
    },
    _deltaSize: function() {
        var $content = this._$content;
        var $container = this._getDragResizeContainer();
        var contentWidth = $content.outerWidth();
        var contentHeight = $content.outerHeight();
        var containerWidth = $container.outerWidth();
        var containerHeight = $container.outerHeight();
        if (this._isWindow($container)) {
            var document = $445Bz.getDocument();
            var fullPageHeight = Math.max($jFnCG(document).outerHeight(), containerHeight);
            var fullPageWidth = Math.max($jFnCG(document).outerWidth(), containerWidth);
            containerHeight = fullPageHeight;
            containerWidth = fullPageWidth;
        }
        return {
            width: containerWidth - contentWidth,
            height: containerHeight - contentHeight
        };
    },
    _dragUpdateHandler: function(e) {
        var offset = e.offset;
        var prevOffset = this._prevOffset;
        var targetOffset = {
            top: offset.y - prevOffset.y,
            left: offset.x - prevOffset.x
        };
        this._changePosition(targetOffset);
        this._prevOffset = offset;
    },
    _changePosition: function(offset) {
        var position = $6jr65.locate(this._$content);
        $6jr65.move(this._$content, {
            left: position.left + offset.left,
            top: position.top + offset.top
        });
        this._positionChangeHandled = true;
    },
    _allowedOffsets: function() {
        var position = $6jr65.locate(this._$content);
        var deltaSize = this._deltaSize();
        var isAllowedDrag = deltaSize.height >= 0 && deltaSize.width >= 0;
        var shaderOffset = this.option("shading") && !this.option("container") && !this._isWindow(this._getContainer()) ? $6jr65.locate(this._$wrapper) : {
            top: 0,
            left: 0
        };
        var boundaryOffset = this.option("boundaryOffset");
        return {
            top: isAllowedDrag ? position.top + shaderOffset.top + boundaryOffset.v : 0,
            bottom: isAllowedDrag ? -position.top - shaderOffset.top + deltaSize.height - boundaryOffset.v : 0,
            left: isAllowedDrag ? position.left + shaderOffset.left + boundaryOffset.h : 0,
            right: isAllowedDrag ? -position.left - shaderOffset.left + deltaSize.width - boundaryOffset.h : 0
        };
    },
    _moveFromContainer: function() {
        this._$content.appendTo(this.$element());
        this._detachWrapperToContainer();
    },
    _detachWrapperToContainer: function() {
        this._$wrapper.detach();
    },
    _moveToContainer: function() {
        this._attachWrapperToContainer();
        this._$content.appendTo(this._$wrapper);
    },
    _attachWrapperToContainer: function() {
        var $element = this.$element();
        var containerDefined = void 0 !== this.option("container");
        var renderContainer = containerDefined ? this._$container : $krF3o.getSwatchContainer($element);
        if (renderContainer && renderContainer[0] === $element.parent()[0]) renderContainer = $element;
        this._$wrapper.appendTo(renderContainer);
    },
    _fixHeightAfterSafariAddressBarResizing: function() {
        if (this._isWindow(this._getContainer()) && $09d46df6425992c5$var$hasSafariAddressBar) this._$wrapper.css("minHeight", $09d46df6425992c5$var$window.innerHeight);
    },
    _renderGeometry: function(isDimensionChanged) {
        if (this.option("visible") && $irv64.hasWindow()) this._renderGeometryImpl(isDimensionChanged);
    },
    _renderGeometryImpl: function(isDimensionChanged) {
        this._stopAnimation();
        this._normalizePosition();
        this._renderWrapper();
        this._fixHeightAfterSafariAddressBarResizing();
        this._renderDimensions();
        var resultPosition = this._renderPosition();
        this._actions.onPositioned({
            position: resultPosition
        });
    },
    _fixWrapperPosition: function() {
        this._$wrapper.css("position", this._useFixedPosition() ? "fixed" : "absolute");
    },
    _useFixedPosition: function() {
        var $container = this._getContainer();
        return this._isWindow($container) && (!$09d46df6425992c5$var$iOS || void 0 !== this._bodyScrollTop);
    },
    _toggleSafariScrolling: function(scrollingEnabled) {
        if ($09d46df6425992c5$var$iOS && this._useFixedPosition()) {
            var body = $445Bz.getBody();
            if (scrollingEnabled) {
                $jFnCG(body).removeClass($09d46df6425992c5$var$PREVENT_SAFARI_SCROLLING_CLASS);
                $09d46df6425992c5$var$window.scrollTo(0, this._bodyScrollTop);
                this._bodyScrollTop = void 0;
            } else if (this.option("visible")) {
                this._bodyScrollTop = $09d46df6425992c5$var$window.pageYOffset;
                $jFnCG(body).addClass($09d46df6425992c5$var$PREVENT_SAFARI_SCROLLING_CLASS);
            }
        }
    },
    _renderWrapper: function() {
        this._fixWrapperPosition();
        this._renderWrapperDimensions();
        this._renderWrapperPosition();
    },
    _renderWrapperDimensions: function() {
        var wrapperWidth;
        var wrapperHeight;
        var $container = this._getContainer();
        if (!$container) return;
        var isWindow = this._isWindow($container);
        wrapperWidth = isWindow ? null : $container.outerWidth(), wrapperHeight = isWindow ? null : $container.outerHeight();
        this._$wrapper.css({
            width: wrapperWidth,
            height: wrapperHeight
        });
    },
    _isWindow: function($element) {
        return !!$element && $kDRxH.isWindow($element.get(0));
    },
    _renderWrapperPosition: function() {
        var $container = this._getContainer();
        if ($container) $bgCx6.setup(this._$wrapper, {
            my: "top left",
            at: "top left",
            of: $container
        });
    },
    _getContainer: function() {
        var position = this._position;
        var container = this.option("container");
        var positionOf = null;
        if (!container && position) {
            var isEvent = !!(position.of && position.of.preventDefault);
            positionOf = isEvent ? $09d46df6425992c5$var$window : position.of || $09d46df6425992c5$var$window;
        }
        return $09d46df6425992c5$var$getElement(container || positionOf);
    },
    _renderDimensions: function() {
        var content = this._$content.get(0);
        this._$content.css({
            minWidth: this._getOptionValue("minWidth", content),
            maxWidth: this._getOptionValue("maxWidth", content),
            minHeight: this._getOptionValue("minHeight", content),
            maxHeight: this._getOptionValue("maxHeight", content),
            width: this._getOptionValue("width", content),
            height: this._getOptionValue("height", content)
        });
    },
    _renderPosition: function() {
        if (this._positionChangeHandled) {
            var allowedOffsets = this._allowedOffsets();
            this._changePosition({
                top: $09d46df6425992c5$require$fitIntoRange(0, -allowedOffsets.top, allowedOffsets.bottom),
                left: $09d46df6425992c5$require$fitIntoRange(0, -allowedOffsets.left, allowedOffsets.right)
            });
        } else {
            this._renderOverlayBoundaryOffset();
            $6jr65.resetPosition(this._$content);
            var position = this._transformStringPosition(this._position, $09d46df6425992c5$var$POSITION_ALIASES);
            var resultPosition = $bgCx6.setup(this._$content, position);
            $09d46df6425992c5$var$forceRepaint(this._$content);
            this._actions.onPositioning();
            return resultPosition;
        }
    },
    _transformStringPosition: function(position, positionAliases) {
        if ($kDRxH.isString(position)) position = $09d46df6425992c5$require$extend({}, positionAliases[position]);
        return position;
    },
    _renderOverlayBoundaryOffset: function() {
        var boundaryOffset = this.option("boundaryOffset");
        this._$content.css("margin", boundaryOffset.v + "px " + boundaryOffset.h + "px");
    },
    _focusTarget: function() {
        return this._$content;
    },
    _attachKeyboardEvents: function() {
        this._keyboardProcessor = new $2ADoP({
            element: this._$content,
            handler: this._keyboardHandler,
            context: this
        });
    },
    _keyboardHandler: function(options) {
        var e = options.originalEvent;
        var $target = $jFnCG(e.target);
        if ($target.is(this._$content) || !this.option("ignoreChildEvents")) this.callBase.apply(this, arguments);
    },
    _isVisible: function() {
        return this.option("visible");
    },
    _visibilityChanged: function(visible) {
        if (visible) {
            if (this.option("visible")) this._renderVisibilityAnimate(visible);
        } else this._renderVisibilityAnimate(visible);
    },
    _dimensionChanged: function() {
        this._renderGeometry(true);
    },
    _clean: function() {
        if (!this._contentAlreadyRendered) this.$content().empty();
        this._renderVisibility(false);
        this._stopShowTimer();
        this._cleanFocusState();
    },
    _stopShowTimer: function() {
        if (this._asyncShowTimeout) clearTimeout(this._asyncShowTimeout);
        this._asyncShowTimeout = null;
    },
    _dispose: function() {
        $c7ml4.stop(this._$content, false);
        clearTimeout(this._deferShowTimer);
        this._toggleViewPortSubscription(false);
        this._toggleSubscriptions(false);
        this._updateZIndexStackPosition(false);
        this._toggleTabTerminator(false);
        this._toggleSafariScrolling(true);
        this._actions = null;
        this.callBase();
        $gN9eB.remove(this._zIndex);
        this._$wrapper.remove();
        this._$content.remove();
    },
    _toggleDisabledState: function(value) {
        this.callBase.apply(this, arguments);
        this._$content.toggleClass($09d46df6425992c5$var$DISABLED_STATE_CLASS, Boolean(value));
    },
    _toggleRTLDirection: function(rtl) {
        this._$content.toggleClass($09d46df6425992c5$var$RTL_DIRECTION_CLASS, rtl);
    },
    _optionChanged: function(args) {
        var value = args.value;
        if ($09d46df6425992c5$require$inArray(args.name, $09d46df6425992c5$var$ACTIONS) > -1) {
            this._initActions();
            return;
        }
        switch(args.name){
            case "dragEnabled":
                this._renderDrag();
                this._renderGeometry();
                break;
            case "resizeEnabled":
                this._renderResize();
                this._renderGeometry();
                break;
            case "shading":
            case "shadingColor":
                this._toggleShading(this.option("visible"));
                break;
            case "width":
            case "height":
            case "minWidth":
            case "maxWidth":
            case "minHeight":
            case "maxHeight":
            case "boundaryOffset":
                this._renderGeometry();
                break;
            case "position":
                this._positionChangeHandled = false;
                this._renderGeometry();
                break;
            case "visible":
                this._renderVisibilityAnimate(value).done((function() {
                    if (!this._animateDeferred) return;
                    this._animateDeferred.resolveWith(this);
                }).bind(this));
                break;
            case "target":
                this._initTarget(value);
                this._invalidate();
                break;
            case "container":
                this._initContainer(value);
                this._invalidate();
                break;
            case "innerOverlay":
                this._initInnerOverlayClass();
                break;
            case "deferRendering":
            case "contentTemplate":
                this._contentAlreadyRendered = false;
                this._clean();
                this._invalidate();
                break;
            case "closeOnBackButton":
                this._toggleHideTopOverlayCallback(this.option("visible"));
                break;
            case "closeOnTargetScroll":
                this._toggleParentsScrollSubscription(this.option("visible"));
                break;
            case "closeOnOutsideClick":
            case "animation":
            case "propagateOutsideClick":
                break;
            case "rtlEnabled":
                this._contentAlreadyRendered = false;
                this.callBase(args);
                break;
            default:
                this.callBase(args);
        }
    },
    toggle: function(showing) {
        showing = void 0 === showing ? !this.option("visible") : showing;
        var result = new $09d46df6425992c5$require$Deferred;
        if (showing === this.option("visible")) return result.resolveWith(this, [
            showing
        ]).promise();
        var animateDeferred = new $09d46df6425992c5$require$Deferred;
        this._animateDeferred = animateDeferred;
        this.option("visible", showing);
        animateDeferred.promise().done((function() {
            delete this._animateDeferred;
            result.resolveWith(this, [
                this.option("visible")
            ]);
        }).bind(this));
        return result.promise();
    },
    $content: function() {
        return this._$content;
    },
    show: function() {
        return this.toggle(true);
    },
    hide: function() {
        return this.toggle(false);
    },
    content: function() {
        return $09d46df6425992c5$require$getPublicElement(this._$content);
    },
    repaint: function() {
        if (this._contentAlreadyRendered) {
            this._renderGeometry();
            $5OzEX.triggerResizeEvent(this._$content);
        } else this.callBase();
    }
});
$09d46df6425992c5$var$Overlay.baseZIndex = function(zIndex) {
    return $gN9eB.base(zIndex);
};
$4ZFRo("dxOverlay", $09d46df6425992c5$var$Overlay);
module.exports = $09d46df6425992c5$var$Overlay;

});
parcelRegister("c7ml4", function(module, exports) {
/**
 * DevExtreme (animation/fx.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
function $8d27777ea5674ba0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $8d27777ea5674ba0$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $8d27777ea5674ba0$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $8d27777ea5674ba0$var$_typeof(obj);
}

var $jFnCG = parcelRequire("jFnCG");

var $8d27777ea5674ba0$var$window = (parcelRequire("irv64")).getWindow();

var $e1LMc = parcelRequire("e1LMc");

var $7sX7V = parcelRequire("7sX7V");

var $5OzEX = parcelRequire("5OzEX");
var $8d27777ea5674ba0$require$getPublicElement = $5OzEX.getPublicElement;

var $7I8Uw = parcelRequire("7I8Uw");
var $8d27777ea5674ba0$require$extend = $7I8Uw.extend;

var $kDRxH = parcelRequire("kDRxH");

var $4Pwuy = parcelRequire("4Pwuy");

var $6jr65 = parcelRequire("6jr65");

var $2DhDH = parcelRequire("2DhDH");

var $fF1Ws = parcelRequire("fF1Ws");

var $6VAWB = parcelRequire("6VAWB");

var $bgCx6 = parcelRequire("bgCx6");

var $hw2F9 = parcelRequire("hw2F9");

var $bXb2w = parcelRequire("bXb2w");

var $2F60d = parcelRequire("2F60d");
var $8d27777ea5674ba0$var$when = $2F60d.when;
var $8d27777ea5674ba0$var$Deferred = $2F60d.Deferred;
var $8d27777ea5674ba0$var$removeEventName = $bXb2w.addNamespace($hw2F9, "dxFX");
var $8d27777ea5674ba0$var$isFunction = $kDRxH.isFunction;
var $8d27777ea5674ba0$var$isPlainObject = $kDRxH.isPlainObject;

var $2Mto0 = parcelRequire("2Mto0");
var $8d27777ea5674ba0$require$noop = $2Mto0.noop;
var $8d27777ea5674ba0$var$RELATIVE_VALUE_REGEX = /^([+-])=(.*)/i;
var $8d27777ea5674ba0$var$ANIM_DATA_KEY = "dxAnimData";
var $8d27777ea5674ba0$var$ANIM_QUEUE_KEY = "dxAnimQueue";
var $8d27777ea5674ba0$var$TRANSFORM_PROP = "transform";
var $8d27777ea5674ba0$var$TransitionAnimationStrategy = {
    initAnimation: function($element, config) {
        $element.css({
            transitionProperty: "none"
        });
        if ("string" === typeof config.from) $element.addClass(config.from);
        else $8d27777ea5674ba0$var$setProps($element, config.from);
        var that = this;
        var deferred = new $8d27777ea5674ba0$var$Deferred;
        var cleanupWhen = config.cleanupWhen;
        config.transitionAnimation = {
            deferred: deferred,
            finish: function() {
                that._finishTransition($element);
                if (cleanupWhen) $8d27777ea5674ba0$var$when(deferred, cleanupWhen).always(function() {
                    that._cleanup($element, config);
                });
                else that._cleanup($element, config);
                deferred.resolveWith($element, [
                    config,
                    $element
                ]);
            }
        };
        this._completeAnimationCallback($element, config).done(function() {
            config.transitionAnimation.finish();
        }).fail(function() {
            deferred.rejectWith($element, [
                config,
                $element
            ]);
        });
        if (!config.duration) config.transitionAnimation.finish();
        $element.css("transform");
    },
    animate: function($element, config) {
        this._startAnimation($element, config);
        return config.transitionAnimation.deferred.promise();
    },
    _completeAnimationCallback: function($element, config) {
        var that = this;
        var startTime = Date.now() + config.delay;
        var deferred = new $8d27777ea5674ba0$var$Deferred;
        var transitionEndFired = new $8d27777ea5674ba0$var$Deferred;
        var simulatedTransitionEndFired = new $8d27777ea5674ba0$var$Deferred;
        var simulatedEndEventTimer;
        var transitionEndEventName = $6VAWB.transitionEndEventName() + ".dxFX";
        config.transitionAnimation.cleanup = function() {
            clearTimeout(simulatedEndEventTimer);
            clearTimeout(waitForJSCompleteTimer);
            $e1LMc.off($element, transitionEndEventName);
            $e1LMc.off($element, $8d27777ea5674ba0$var$removeEventName);
        };
        $e1LMc.one($element, transitionEndEventName, function() {
            if (Date.now() - startTime >= config.duration) transitionEndFired.reject();
        });
        $e1LMc.off($element, $8d27777ea5674ba0$var$removeEventName);
        $e1LMc.on($element, $8d27777ea5674ba0$var$removeEventName, function() {
            that.stop($element, config);
            deferred.reject();
        });
        var waitForJSCompleteTimer = setTimeout(function() {
            simulatedEndEventTimer = setTimeout(function() {
                simulatedTransitionEndFired.reject();
            }, config.duration + config.delay + $8d27777ea5674ba0$var$fx._simulatedTransitionEndDelay);
            $8d27777ea5674ba0$var$when(transitionEndFired, simulatedTransitionEndFired).fail((function() {
                deferred.resolve();
            }).bind(this));
        });
        return deferred.promise();
    },
    _startAnimation: function($element, config) {
        $element.css({
            transitionProperty: "all",
            transitionDelay: config.delay + "ms",
            transitionDuration: config.duration + "ms",
            transitionTimingFunction: config.easing
        });
        if ("string" === typeof config.to) $element[0].className += " " + config.to;
        else if (config.to) $8d27777ea5674ba0$var$setProps($element, config.to);
    },
    _finishTransition: function($element) {
        $element.css("transition", "none");
    },
    _cleanup: function($element, config) {
        config.transitionAnimation.cleanup();
        if ("string" === typeof config.from) {
            $element.removeClass(config.from);
            $element.removeClass(config.to);
        }
    },
    stop: function($element, config, jumpToEnd) {
        if (!config) return;
        if (jumpToEnd) config.transitionAnimation.finish();
        else {
            if ($8d27777ea5674ba0$var$isPlainObject(config.to)) $4Pwuy.each(config.to, function(key) {
                $element.css(key, $element.css(key));
            });
            this._finishTransition($element);
            this._cleanup($element, config);
        }
    }
};
var $8d27777ea5674ba0$var$FrameAnimationStrategy = {
    initAnimation: function($element, config) {
        $8d27777ea5674ba0$var$setProps($element, config.from);
    },
    animate: function($element, config) {
        var deferred = new $8d27777ea5674ba0$var$Deferred;
        var that = this;
        if (!config) return deferred.reject().promise();
        $4Pwuy.each(config.to, function(prop) {
            if (void 0 === config.from[prop]) config.from[prop] = that._normalizeValue($element.css(prop));
        });
        if (config.to[$8d27777ea5674ba0$var$TRANSFORM_PROP]) {
            config.from[$8d27777ea5674ba0$var$TRANSFORM_PROP] = that._parseTransform(config.from[$8d27777ea5674ba0$var$TRANSFORM_PROP]);
            config.to[$8d27777ea5674ba0$var$TRANSFORM_PROP] = that._parseTransform(config.to[$8d27777ea5674ba0$var$TRANSFORM_PROP]);
        }
        config.frameAnimation = {
            to: config.to,
            from: config.from,
            currentValue: config.from,
            easing: $2DhDH.convertTransitionTimingFuncToEasing(config.easing),
            duration: config.duration,
            startTime: (new Date).valueOf(),
            finish: function() {
                this.currentValue = this.to;
                this.draw();
                $fF1Ws.cancelAnimationFrame(config.frameAnimation.animationFrameId);
                deferred.resolve();
            },
            draw: function() {
                if (config.draw) {
                    config.draw(this.currentValue);
                    return;
                }
                var currentValue = $8d27777ea5674ba0$require$extend({}, this.currentValue);
                if (currentValue[$8d27777ea5674ba0$var$TRANSFORM_PROP]) currentValue[$8d27777ea5674ba0$var$TRANSFORM_PROP] = $4Pwuy.map(currentValue[$8d27777ea5674ba0$var$TRANSFORM_PROP], function(value, prop) {
                    if ("translate" === prop) return $6jr65.getTranslateCss(value);
                    else {
                        if ("scale" === prop) return "scale(" + value + ")";
                        else {
                            if ("rotate" === prop.substr(0, prop.length - 1)) return prop + "(" + value + "deg)";
                        }
                    }
                }).join(" ");
                $element.css(currentValue);
            }
        };
        if (config.delay) {
            config.frameAnimation.startTime += config.delay;
            config.frameAnimation.delayTimeout = setTimeout(function() {
                that._startAnimation($element, config);
            }, config.delay);
        } else that._startAnimation($element, config);
        return deferred.promise();
    },
    _startAnimation: function($element, config) {
        $e1LMc.off($element, $8d27777ea5674ba0$var$removeEventName);
        $e1LMc.on($element, $8d27777ea5674ba0$var$removeEventName, function() {
            if (config.frameAnimation) $fF1Ws.cancelAnimationFrame(config.frameAnimation.animationFrameId);
        });
        this._animationStep($element, config);
    },
    _parseTransform: function(transformString) {
        var result = {};
        $4Pwuy.each(transformString.match(/(\w|\d)+\([^)]*\)\s*/g), function(i, part) {
            var translateData = $6jr65.parseTranslate(part);
            var scaleData = part.match(/scale\((.+?)\)/);
            var rotateData = part.match(/(rotate.)\((.+)deg\)/);
            if (translateData) result.translate = translateData;
            if (scaleData && scaleData[1]) result.scale = parseFloat(scaleData[1]);
            if (rotateData && rotateData[1]) result[rotateData[1]] = parseFloat(rotateData[2]);
        });
        return result;
    },
    stop: function($element, config, jumpToEnd) {
        var frameAnimation = config && config.frameAnimation;
        if (!frameAnimation) return;
        $fF1Ws.cancelAnimationFrame(frameAnimation.animationFrameId);
        clearTimeout(frameAnimation.delayTimeout);
        if (jumpToEnd) frameAnimation.finish();
        delete config.frameAnimation;
    },
    _animationStep: function($element, config) {
        var frameAnimation = config && config.frameAnimation;
        if (!frameAnimation) return;
        var now = (new Date).valueOf();
        if (now >= frameAnimation.startTime + frameAnimation.duration) {
            frameAnimation.finish();
            return;
        }
        frameAnimation.currentValue = this._calcStepValue(frameAnimation, now - frameAnimation.startTime);
        frameAnimation.draw();
        var that = this;
        frameAnimation.animationFrameId = $fF1Ws.requestAnimationFrame(function() {
            that._animationStep($element, config);
        });
    },
    _calcStepValue: function(frameAnimation, currentDuration) {
        var calcValueRecursively = function calcValueRecursively(from, to) {
            var result = Array.isArray(to) ? [] : {};
            var calcEasedValue = function(propName) {
                var x = currentDuration / frameAnimation.duration;
                var t = currentDuration;
                var b = 1 * from[propName];
                var c = to[propName] - from[propName];
                var d = frameAnimation.duration;
                return $2DhDH.getEasing(frameAnimation.easing)(x, t, b, c, d);
            };
            $4Pwuy.each(to, function(propName, endPropValue) {
                if ("string" === typeof endPropValue && false === parseFloat(endPropValue, 10)) return true;
                result[propName] = "object" === $8d27777ea5674ba0$var$_typeof(endPropValue) ? calcValueRecursively(from[propName], endPropValue) : calcEasedValue(propName);
            });
            return result;
        };
        return calcValueRecursively(frameAnimation.from, frameAnimation.to);
    },
    _normalizeValue: function(value) {
        var numericValue = parseFloat(value, 10);
        if (false === numericValue) return value;
        return numericValue;
    }
};
var $8d27777ea5674ba0$var$FallbackToNoAnimationStrategy = {
    initAnimation: function() {},
    animate: function() {
        return (new $8d27777ea5674ba0$var$Deferred).resolve().promise();
    },
    stop: $8d27777ea5674ba0$require$noop,
    isSynchronous: true
};
var $8d27777ea5674ba0$var$getAnimationStrategy = function(config) {
    config = config || {};
    var animationStrategies = {
        transition: $6VAWB.transition() ? $8d27777ea5674ba0$var$TransitionAnimationStrategy : $8d27777ea5674ba0$var$FrameAnimationStrategy,
        frame: $8d27777ea5674ba0$var$FrameAnimationStrategy,
        noAnimation: $8d27777ea5674ba0$var$FallbackToNoAnimationStrategy
    };
    var strategy = config.strategy || "transition";
    if ("css" === config.type && !$6VAWB.transition()) strategy = "noAnimation";
    return animationStrategies[strategy];
};
var $8d27777ea5674ba0$var$baseConfigValidator = function(config, animationType, validate, typeMessage) {
    $4Pwuy.each([
        "from",
        "to"
    ], function() {
        if (!validate(config[this])) throw $7sX7V.Error("E0010", animationType, this, typeMessage);
    });
};
var $8d27777ea5674ba0$var$isObjectConfigValidator = function(config, animationType) {
    return $8d27777ea5674ba0$var$baseConfigValidator(config, animationType, function(target) {
        return $8d27777ea5674ba0$var$isPlainObject(target);
    }, "a plain object");
};
var $8d27777ea5674ba0$var$isStringConfigValidator = function(config, animationType) {
    return $8d27777ea5674ba0$var$baseConfigValidator(config, animationType, function(target) {
        return "string" === typeof target;
    }, "a string");
};
var $8d27777ea5674ba0$var$CustomAnimationConfigurator = {
    setup: function() {}
};
var $8d27777ea5674ba0$var$CssAnimationConfigurator = {
    validateConfig: function(config) {
        $8d27777ea5674ba0$var$isStringConfigValidator(config, "css");
    },
    setup: function() {}
};
var $8d27777ea5674ba0$var$positionAliases = {
    top: {
        my: "bottom center",
        at: "top center"
    },
    bottom: {
        my: "top center",
        at: "bottom center"
    },
    right: {
        my: "left center",
        at: "right center"
    },
    left: {
        my: "right center",
        at: "left center"
    }
};
var $8d27777ea5674ba0$var$SlideAnimationConfigurator = {
    validateConfig: function(config) {
        $8d27777ea5674ba0$var$isObjectConfigValidator(config, "slide");
    },
    setup: function($element, config) {
        var location = $6jr65.locate($element);
        if ("slide" !== config.type) {
            var positioningConfig = "slideIn" === config.type ? config.from : config.to;
            positioningConfig.position = $8d27777ea5674ba0$require$extend({
                of: $8d27777ea5674ba0$var$window
            }, $8d27777ea5674ba0$var$positionAliases[config.direction]);
            $8d27777ea5674ba0$var$setupPosition($element, positioningConfig);
        }
        this._setUpConfig(location, config.from);
        this._setUpConfig(location, config.to);
        $6jr65.clearCache($element);
    },
    _setUpConfig: function(location, config) {
        config.left = "left" in config ? config.left : "+=0";
        config.top = "top" in config ? config.top : "+=0";
        this._initNewPosition(location, config);
    },
    _initNewPosition: function(location, config) {
        var position = {
            left: config.left,
            top: config.top
        };
        delete config.left;
        delete config.top;
        var relativeValue = this._getRelativeValue(position.left);
        if (void 0 !== relativeValue) position.left = relativeValue + location.left;
        else config.left = 0;
        relativeValue = this._getRelativeValue(position.top);
        if (void 0 !== relativeValue) position.top = relativeValue + location.top;
        else config.top = 0;
        config[$8d27777ea5674ba0$var$TRANSFORM_PROP] = $6jr65.getTranslateCss({
            x: position.left,
            y: position.top
        });
    },
    _getRelativeValue: function(value) {
        var relativeValue;
        if ("string" === typeof value && (relativeValue = $8d27777ea5674ba0$var$RELATIVE_VALUE_REGEX.exec(value))) return parseInt(relativeValue[1] + "1") * relativeValue[2];
    }
};
var $8d27777ea5674ba0$var$FadeAnimationConfigurator = {
    setup: function($element, config) {
        var from = config.from;
        var fromOpacity = $8d27777ea5674ba0$var$isPlainObject(from) ? config.skipElementInitialStyles ? 0 : $element.css("opacity") : String(from);
        var toOpacity;
        switch(config.type){
            case "fadeIn":
                toOpacity = 1;
                break;
            case "fadeOut":
                toOpacity = 0;
                break;
            default:
                toOpacity = String(config.to);
        }
        config.from = {
            visibility: "visible",
            opacity: fromOpacity
        };
        config.to = {
            opacity: toOpacity
        };
    }
};
var $8d27777ea5674ba0$var$PopAnimationConfigurator = {
    validateConfig: function(config) {
        $8d27777ea5674ba0$var$isObjectConfigValidator(config, "pop");
    },
    setup: function($element, config) {
        var from = config.from;
        var to = config.to;
        var fromOpacity = "opacity" in from ? from.opacity : $element.css("opacity");
        var toOpacity = "opacity" in to ? to.opacity : 1;
        var fromScale = "scale" in from ? from.scale : 0;
        var toScale = "scale" in to ? to.scale : 1;
        config.from = {
            opacity: fromOpacity
        };
        var translate = $6jr65.getTranslate($element);
        config.from[$8d27777ea5674ba0$var$TRANSFORM_PROP] = this._getCssTransform(translate, fromScale);
        config.to = {
            opacity: toOpacity
        };
        config.to[$8d27777ea5674ba0$var$TRANSFORM_PROP] = this._getCssTransform(translate, toScale);
    },
    _getCssTransform: function(translate, scale) {
        return $6jr65.getTranslateCss(translate) + "scale(" + scale + ")";
    }
};
var $8d27777ea5674ba0$var$animationConfigurators = {
    custom: $8d27777ea5674ba0$var$CustomAnimationConfigurator,
    slide: $8d27777ea5674ba0$var$SlideAnimationConfigurator,
    slideIn: $8d27777ea5674ba0$var$SlideAnimationConfigurator,
    slideOut: $8d27777ea5674ba0$var$SlideAnimationConfigurator,
    fade: $8d27777ea5674ba0$var$FadeAnimationConfigurator,
    fadeIn: $8d27777ea5674ba0$var$FadeAnimationConfigurator,
    fadeOut: $8d27777ea5674ba0$var$FadeAnimationConfigurator,
    pop: $8d27777ea5674ba0$var$PopAnimationConfigurator,
    css: $8d27777ea5674ba0$var$CssAnimationConfigurator
};
var $8d27777ea5674ba0$var$getAnimationConfigurator = function(config) {
    var result = $8d27777ea5674ba0$var$animationConfigurators[config.type];
    if (!result) throw $7sX7V.Error("E0011", config.type);
    return result;
};
var $8d27777ea5674ba0$var$defaultJSConfig = {
    type: "custom",
    from: {},
    to: {},
    duration: 400,
    start: $8d27777ea5674ba0$require$noop,
    complete: $8d27777ea5674ba0$require$noop,
    easing: "ease",
    delay: 0
};
var $8d27777ea5674ba0$var$defaultCssConfig = {
    duration: 400,
    easing: "ease",
    delay: 0
};
var $8d27777ea5674ba0$var$setupAnimationOnElement = function() {
    var animation = this;
    var $element = animation.element;
    var config = animation.config;
    $8d27777ea5674ba0$var$setupPosition($element, config.from);
    $8d27777ea5674ba0$var$setupPosition($element, config.to);
    animation.configurator.setup($element, config);
    $element.data($8d27777ea5674ba0$var$ANIM_DATA_KEY, animation);
    if ($8d27777ea5674ba0$var$fx.off) {
        config.duration = 0;
        config.delay = 0;
    }
    animation.strategy.initAnimation($element, config);
    if (config.start) {
        var element = $8d27777ea5674ba0$require$getPublicElement($element);
        config.start.apply(this, [
            element,
            config
        ]);
    }
};
var $8d27777ea5674ba0$var$onElementAnimationComplete = function(animation) {
    var $element = animation.element;
    var config = animation.config;
    $element.removeData($8d27777ea5674ba0$var$ANIM_DATA_KEY);
    if (config.complete) {
        var element = $8d27777ea5674ba0$require$getPublicElement($element);
        config.complete.apply(this, [
            element,
            config
        ]);
    }
    animation.deferred.resolveWith(this, [
        $element,
        config
    ]);
};
var $8d27777ea5674ba0$var$startAnimationOnElement = function() {
    var animation = this;
    var $element = animation.element;
    var config = animation.config;
    animation.isStarted = true;
    return animation.strategy.animate($element, config).done(function() {
        $8d27777ea5674ba0$var$onElementAnimationComplete(animation);
    }).fail(function() {
        animation.deferred.rejectWith(this, [
            $element,
            config
        ]);
    });
};
var $8d27777ea5674ba0$var$stopAnimationOnElement = function(jumpToEnd) {
    var animation = this;
    var $element = animation.element;
    var config = animation.config;
    clearTimeout(animation.startTimeout);
    if (!animation.isStarted) animation.start();
    animation.strategy.stop($element, config, jumpToEnd);
};
var $8d27777ea5674ba0$var$scopedRemoveEvent = $bXb2w.addNamespace($hw2F9, "dxFXStartAnimation");
var $8d27777ea5674ba0$var$subscribeToRemoveEvent = function(animation) {
    $e1LMc.off(animation.element, $8d27777ea5674ba0$var$scopedRemoveEvent);
    $e1LMc.on(animation.element, $8d27777ea5674ba0$var$scopedRemoveEvent, function() {
        $8d27777ea5674ba0$var$fx.stop(animation.element);
    });
    animation.deferred.always(function() {
        $e1LMc.off(animation.element, $8d27777ea5674ba0$var$scopedRemoveEvent);
    });
};
var $8d27777ea5674ba0$var$createAnimation = function(element, initialConfig) {
    var defaultConfig = "css" === initialConfig.type ? $8d27777ea5674ba0$var$defaultCssConfig : $8d27777ea5674ba0$var$defaultJSConfig;
    var config = $8d27777ea5674ba0$require$extend(true, {}, defaultConfig, initialConfig);
    var configurator = $8d27777ea5674ba0$var$getAnimationConfigurator(config);
    var strategy = $8d27777ea5674ba0$var$getAnimationStrategy(config);
    var animation = {
        element: $jFnCG(element),
        config: config,
        configurator: configurator,
        strategy: strategy,
        isSynchronous: strategy.isSynchronous,
        setup: $8d27777ea5674ba0$var$setupAnimationOnElement,
        start: $8d27777ea5674ba0$var$startAnimationOnElement,
        stop: $8d27777ea5674ba0$var$stopAnimationOnElement,
        deferred: new $8d27777ea5674ba0$var$Deferred
    };
    if ($8d27777ea5674ba0$var$isFunction(configurator.validateConfig)) configurator.validateConfig(config);
    $8d27777ea5674ba0$var$subscribeToRemoveEvent(animation);
    return animation;
};
var $8d27777ea5674ba0$var$animate = function(element, config) {
    var $element = $jFnCG(element);
    if (!$element.length) return (new $8d27777ea5674ba0$var$Deferred).resolve().promise();
    var animation = $8d27777ea5674ba0$var$createAnimation($element, config);
    $8d27777ea5674ba0$var$pushInAnimationQueue($element, animation);
    return animation.deferred.promise();
};
var $8d27777ea5674ba0$var$pushInAnimationQueue = function($element, animation) {
    var queueData = $8d27777ea5674ba0$var$getAnimQueueData($element);
    $8d27777ea5674ba0$var$writeAnimQueueData($element, queueData);
    queueData.push(animation);
    if (!$8d27777ea5674ba0$var$isAnimating($element)) $8d27777ea5674ba0$var$shiftFromAnimationQueue($element, queueData);
};
var $8d27777ea5674ba0$var$getAnimQueueData = function($element) {
    return $element.data($8d27777ea5674ba0$var$ANIM_QUEUE_KEY) || [];
};
var $8d27777ea5674ba0$var$writeAnimQueueData = function($element, queueData) {
    $element.data($8d27777ea5674ba0$var$ANIM_QUEUE_KEY, queueData);
};
var $8d27777ea5674ba0$var$destroyAnimQueueData = function($element) {
    $element.removeData($8d27777ea5674ba0$var$ANIM_QUEUE_KEY);
};
var $8d27777ea5674ba0$var$isAnimating = function($element) {
    return !!$element.data($8d27777ea5674ba0$var$ANIM_DATA_KEY);
};
var $8d27777ea5674ba0$var$shiftFromAnimationQueue = function shiftFromAnimationQueue($element, queueData) {
    queueData = $8d27777ea5674ba0$var$getAnimQueueData($element);
    if (!queueData.length) return;
    var animation = queueData.shift();
    if (0 === queueData.length) $8d27777ea5674ba0$var$destroyAnimQueueData($element);
    $8d27777ea5674ba0$var$executeAnimation(animation).done(function() {
        if (!$8d27777ea5674ba0$var$isAnimating($element)) shiftFromAnimationQueue($element);
    });
};
var $8d27777ea5674ba0$var$executeAnimation = function(animation) {
    animation.setup();
    if ($8d27777ea5674ba0$var$fx.off || animation.isSynchronous) animation.start();
    else animation.startTimeout = setTimeout(function() {
        animation.start();
    });
    return animation.deferred.promise();
};
var $8d27777ea5674ba0$var$setupPosition = function($element, config) {
    if (!config || !config.position) return;
    var win = $jFnCG($8d27777ea5674ba0$var$window);
    var left = 0;
    var top = 0;
    var position = $bgCx6.calculate($element, config.position);
    var offset = $element.offset();
    var currentPosition = $element.position();
    if (currentPosition.top > offset.top) top = win.scrollTop();
    if (currentPosition.left > offset.left) left = win.scrollLeft();
    $8d27777ea5674ba0$require$extend(config, {
        left: position.h.location - offset.left + currentPosition.left - left,
        top: position.v.location - offset.top + currentPosition.top - top
    });
    delete config.position;
};
var $8d27777ea5674ba0$var$setProps = function($element, props) {
    $4Pwuy.each(props, function(key, value) {
        try {
            $element.css(key, $kDRxH.isFunction(value) ? value() : value);
        } catch (e) {}
    });
};
var $8d27777ea5674ba0$var$stop = function(element, jumpToEnd) {
    var $element = $jFnCG(element);
    var queueData = $8d27777ea5674ba0$var$getAnimQueueData($element);
    $4Pwuy.each(queueData, function(_, animation) {
        animation.config.delay = 0;
        animation.config.duration = 0;
        animation.isSynchronous = true;
    });
    if (!$8d27777ea5674ba0$var$isAnimating($element)) $8d27777ea5674ba0$var$shiftFromAnimationQueue($element, queueData);
    var animation = $element.data($8d27777ea5674ba0$var$ANIM_DATA_KEY);
    if (animation) animation.stop(jumpToEnd);
    $element.removeData($8d27777ea5674ba0$var$ANIM_DATA_KEY);
    $8d27777ea5674ba0$var$destroyAnimQueueData($element);
};
var $8d27777ea5674ba0$var$fx = {
    off: false,
    animationTypes: $8d27777ea5674ba0$var$animationConfigurators,
    animate: $8d27777ea5674ba0$var$animate,
    createAnimation: $8d27777ea5674ba0$var$createAnimation,
    isAnimating: $8d27777ea5674ba0$var$isAnimating,
    stop: $8d27777ea5674ba0$var$stop,
    _simulatedTransitionEndDelay: 100
};
module.exports = $8d27777ea5674ba0$var$fx;
module.exports.default = module.exports;

});
parcelRegister("6jr65", function(module, exports) {

$parcel$export(module.exports, "move", () => $498989617ed99683$export$d947e5f4f4c48d48, (v) => $498989617ed99683$export$d947e5f4f4c48d48 = v);
$parcel$export(module.exports, "locate", () => $498989617ed99683$export$5200e0c7549d7bff, (v) => $498989617ed99683$export$5200e0c7549d7bff = v);
$parcel$export(module.exports, "clearCache", () => $498989617ed99683$export$d2adf65b87e47523, (v) => $498989617ed99683$export$d2adf65b87e47523 = v);
$parcel$export(module.exports, "parseTranslate", () => $498989617ed99683$export$8ea33f091e4ee473, (v) => $498989617ed99683$export$8ea33f091e4ee473 = v);
$parcel$export(module.exports, "getTranslate", () => $498989617ed99683$export$5ec402b7fcf74398, (v) => $498989617ed99683$export$5ec402b7fcf74398 = v);
$parcel$export(module.exports, "getTranslateCss", () => $498989617ed99683$export$869d704b37577f39, (v) => $498989617ed99683$export$869d704b37577f39 = v);
$parcel$export(module.exports, "resetPosition", () => $498989617ed99683$export$ab7d69e250642927, (v) => $498989617ed99683$export$ab7d69e250642927 = v);
/**
 * DevExtreme (animation/translator.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $498989617ed99683$export$d947e5f4f4c48d48;
var $498989617ed99683$export$5200e0c7549d7bff;
var $498989617ed99683$export$d2adf65b87e47523;
var $498989617ed99683$export$8ea33f091e4ee473;
var $498989617ed99683$export$5ec402b7fcf74398;
var $498989617ed99683$export$869d704b37577f39;
var $498989617ed99683$export$ab7d69e250642927;
"use strict";

var $8ulMI = parcelRequire("8ulMI");

var $kDRxH = parcelRequire("kDRxH");
var $498989617ed99683$require$type = $kDRxH.type;
var $498989617ed99683$var$TRANSLATOR_DATA_KEY = "dxTranslator";
var $498989617ed99683$var$TRANSFORM_MATRIX_REGEX = /matrix(3d)?\((.+?)\)/;
var $498989617ed99683$var$TRANSLATE_REGEX = /translate(?:3d)?\((.+?)\)/;
var $498989617ed99683$var$locate = function($element) {
    var translate = $498989617ed99683$var$getTranslate($element);
    return {
        left: translate.x,
        top: translate.y
    };
};
var $498989617ed99683$var$move = function($element, position) {
    var left = position.left;
    var top = position.top;
    var translate;
    if (void 0 === left) {
        translate = $498989617ed99683$var$getTranslate($element);
        translate.y = top || 0;
    } else if (void 0 === top) {
        translate = $498989617ed99683$var$getTranslate($element);
        translate.x = left || 0;
    } else {
        translate = {
            x: left || 0,
            y: top || 0,
            z: 0
        };
        $498989617ed99683$var$cacheTranslate($element, translate);
    }
    $element.css({
        transform: $498989617ed99683$var$getTranslateCss(translate)
    });
    if ($498989617ed99683$var$isPercentValue(left) || $498989617ed99683$var$isPercentValue(top)) $498989617ed99683$var$clearCache($element);
};
var $498989617ed99683$var$isPercentValue = function(value) {
    return "string" === $498989617ed99683$require$type(value) && "%" === value[value.length - 1];
};
var $498989617ed99683$var$getTranslate = function($element) {
    var result = $element.length ? $8ulMI.data($element.get(0), $498989617ed99683$var$TRANSLATOR_DATA_KEY) : null;
    if (!result) {
        var transformValue = $element.css("transform") || $498989617ed99683$var$getTranslateCss({
            x: 0,
            y: 0
        });
        var matrix = transformValue.match($498989617ed99683$var$TRANSFORM_MATRIX_REGEX);
        var is3D = matrix && matrix[1];
        if (matrix) {
            matrix = matrix[2].split(",");
            if ("3d" === is3D) matrix = matrix.slice(12, 15);
            else {
                matrix.push(0);
                matrix = matrix.slice(4, 7);
            }
        } else matrix = [
            0,
            0,
            0
        ];
        result = {
            x: parseFloat(matrix[0]),
            y: parseFloat(matrix[1]),
            z: parseFloat(matrix[2])
        };
        $498989617ed99683$var$cacheTranslate($element, result);
    }
    return result;
};
var $498989617ed99683$var$cacheTranslate = function($element, translate) {
    if ($element.length) $8ulMI.data($element.get(0), $498989617ed99683$var$TRANSLATOR_DATA_KEY, translate);
};
var $498989617ed99683$var$clearCache = function($element) {
    if ($element.length) $8ulMI.removeData($element.get(0), $498989617ed99683$var$TRANSLATOR_DATA_KEY);
};
var $498989617ed99683$var$resetPosition = function($element, finishTransition) {
    var originalTransition;
    var stylesConfig = {
        left: 0,
        top: 0,
        transform: "none"
    };
    if (finishTransition) {
        originalTransition = $element.css("transition");
        stylesConfig.transition = "none";
    }
    $element.css(stylesConfig);
    $498989617ed99683$var$clearCache($element);
    if (finishTransition) {
        $element.get(0).offsetHeight;
        $element.css("transition", originalTransition);
    }
};
var $498989617ed99683$var$parseTranslate = function(translateString) {
    var result = translateString.match($498989617ed99683$var$TRANSLATE_REGEX);
    if (!result || !result[1]) return;
    result = result[1].split(",");
    result = {
        x: parseFloat(result[0]),
        y: parseFloat(result[1]),
        z: parseFloat(result[2])
    };
    return result;
};
var $498989617ed99683$var$getTranslateCss = function(translate) {
    translate.x = translate.x || 0;
    translate.y = translate.y || 0;
    var xValueString = $498989617ed99683$var$isPercentValue(translate.x) ? translate.x : translate.x + "px";
    var yValueString = $498989617ed99683$var$isPercentValue(translate.y) ? translate.y : translate.y + "px";
    return "translate(" + xValueString + ", " + yValueString + ")";
};
$498989617ed99683$export$d947e5f4f4c48d48 = $498989617ed99683$var$move;
$498989617ed99683$export$5200e0c7549d7bff = $498989617ed99683$var$locate;
$498989617ed99683$export$d2adf65b87e47523 = $498989617ed99683$var$clearCache;
$498989617ed99683$export$8ea33f091e4ee473 = $498989617ed99683$var$parseTranslate;
$498989617ed99683$export$5ec402b7fcf74398 = $498989617ed99683$var$getTranslate;
$498989617ed99683$export$869d704b37577f39 = $498989617ed99683$var$getTranslateCss;
$498989617ed99683$export$ab7d69e250642927 = $498989617ed99683$var$resetPosition;

});

parcelRegister("2DhDH", function(module, exports) {

$parcel$export(module.exports, "getEasing", () => $1eace8181ff048aa$export$2bbf531f74195405, (v) => $1eace8181ff048aa$export$2bbf531f74195405 = v);
$parcel$export(module.exports, "convertTransitionTimingFuncToEasing", () => $1eace8181ff048aa$export$fbd16de7de38840, (v) => $1eace8181ff048aa$export$fbd16de7de38840 = v);
/**
 * DevExtreme (animation/easing.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $1eace8181ff048aa$export$f66571144d836f3a;
var $1eace8181ff048aa$export$2bbf531f74195405;
var $1eace8181ff048aa$export$fbd16de7de38840;
"use strict";

var $kDRxH = parcelRequire("kDRxH");
var $1eace8181ff048aa$require$isFunction = $kDRxH.isFunction;
var $1eace8181ff048aa$var$CSS_TRANSITION_EASING_REGEX = /cubic-bezier\((\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\)/;
var $1eace8181ff048aa$var$TransitionTimingFuncMap = {
    linear: "cubic-bezier(0, 0, 1, 1)",
    swing: "cubic-bezier(0.445, 0.05, 0.55, 0.95)",
    ease: "cubic-bezier(0.25, 0.1, 0.25, 1)",
    "ease-in": "cubic-bezier(0.42, 0, 1, 1)",
    "ease-out": "cubic-bezier(0, 0, 0.58, 1)",
    "ease-in-out": "cubic-bezier(0.42, 0, 0.58, 1)"
};
var $1eace8181ff048aa$var$polynomBezier = function(x1, y1, x2, y2) {
    var Cx = 3 * x1;
    var Bx = 3 * (x2 - x1) - Cx;
    var Ax = 1 - Cx - Bx;
    var Cy = 3 * y1;
    var By = 3 * (y2 - y1) - Cy;
    var Ay = 1 - Cy - By;
    var bezierX = function(t) {
        return t * (Cx + t * (Bx + t * Ax));
    };
    var bezierY = function(t) {
        return t * (Cy + t * (By + t * Ay));
    };
    var findXFor = function(t) {
        var x = t;
        var i = 0;
        var z;
        while(i < 14){
            z = bezierX(x) - t;
            if (Math.abs(z) < .001) break;
            x -= z / derivativeX(x);
            i++;
        }
        return x;
    };
    var derivativeX = function(t) {
        return Cx + t * (2 * Bx + 3 * t * Ax);
    };
    return function(t) {
        return bezierY(findXFor(t));
    };
};
var $1eace8181ff048aa$var$easing = {};
var $1eace8181ff048aa$var$convertTransitionTimingFuncToEasing = function(cssTransitionEasing) {
    cssTransitionEasing = $1eace8181ff048aa$var$TransitionTimingFuncMap[cssTransitionEasing] || cssTransitionEasing;
    var coeffs = cssTransitionEasing.match($1eace8181ff048aa$var$CSS_TRANSITION_EASING_REGEX);
    var forceName;
    if (!coeffs) {
        forceName = "linear";
        coeffs = $1eace8181ff048aa$var$TransitionTimingFuncMap[forceName].match($1eace8181ff048aa$var$CSS_TRANSITION_EASING_REGEX);
    }
    coeffs = coeffs.slice(1, 5);
    for(var i = 0; i < coeffs.length; i++)coeffs[i] = parseFloat(coeffs[i]);
    var easingName = forceName || "cubicbezier_" + coeffs.join("_").replace(/\./g, "p");
    if (!$1eace8181ff048aa$require$isFunction($1eace8181ff048aa$var$easing[easingName])) $1eace8181ff048aa$var$easing[easingName] = function(x, t, b, c, d) {
        return c * $1eace8181ff048aa$var$polynomBezier(coeffs[0], coeffs[1], coeffs[2], coeffs[3])(t / d) + b;
    };
    return easingName;
};
$1eace8181ff048aa$export$f66571144d836f3a = function(value) {
    $1eace8181ff048aa$var$easing = value;
};
$1eace8181ff048aa$export$2bbf531f74195405 = function(name) {
    return $1eace8181ff048aa$var$easing[name];
};
$1eace8181ff048aa$export$fbd16de7de38840 = $1eace8181ff048aa$var$convertTransitionTimingFuncToEasing;

});

parcelRegister("bgCx6", function(module, exports) {
/**
 * DevExtreme (animation/position.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $2Mto0 = parcelRequire("2Mto0");

var $4Pwuy = parcelRequire("4Pwuy");
var $833f142a563fa640$require$each = $4Pwuy.each;

var $irv64 = parcelRequire("irv64");
var $833f142a563fa640$var$window = $irv64.getWindow();

var $445Bz = parcelRequire("445Bz");

var $kDRxH = parcelRequire("kDRxH");
var $833f142a563fa640$require$isWindow = $kDRxH.isWindow;

var $7I8Uw = parcelRequire("7I8Uw");
var $833f142a563fa640$require$extend = $7I8Uw.extend;

var $1TtsA = parcelRequire("1TtsA");
var $833f142a563fa640$require$getBoundingRect = $1TtsA.getBoundingRect;

var $bvcPv = parcelRequire("bvcPv");

var $6jr65 = parcelRequire("6jr65");

var $6VAWB = parcelRequire("6VAWB");
var $833f142a563fa640$var$horzRe = /left|right/;
var $833f142a563fa640$var$vertRe = /top|bottom/;
var $833f142a563fa640$var$collisionRe = /fit|flip|none/;
var $833f142a563fa640$var$IS_SAFARI = $bvcPv.safari;
var $833f142a563fa640$var$normalizeAlign = function(raw) {
    var result = {
        h: "center",
        v: "center"
    };
    var pair = $2Mto0.splitPair(raw);
    if (pair) $833f142a563fa640$require$each(pair, function() {
        var w = String(this).toLowerCase();
        if ($833f142a563fa640$var$horzRe.test(w)) result.h = w;
        else if ($833f142a563fa640$var$vertRe.test(w)) result.v = w;
    });
    return result;
};
var $833f142a563fa640$var$normalizeOffset = function(raw) {
    return $2Mto0.pairToObject(raw);
};
var $833f142a563fa640$var$normalizeCollision = function(raw) {
    var pair = $2Mto0.splitPair(raw);
    var h = String(pair && pair[0]).toLowerCase();
    var v = String(pair && pair[1]).toLowerCase();
    if (!$833f142a563fa640$var$collisionRe.test(h)) h = "none";
    if (!$833f142a563fa640$var$collisionRe.test(v)) v = h;
    return {
        h: h,
        v: v
    };
};
var $833f142a563fa640$var$getAlignFactor = function(align) {
    switch(align){
        case "center":
            return .5;
        case "right":
        case "bottom":
            return 1;
        default:
            return 0;
    }
};
var $833f142a563fa640$var$inverseAlign = function(align) {
    switch(align){
        case "left":
            return "right";
        case "right":
            return "left";
        case "top":
            return "bottom";
        case "bottom":
            return "top";
        default:
            return align;
    }
};
var $833f142a563fa640$var$calculateOversize = function(data, bounds) {
    var oversize = 0;
    if (data.myLocation < bounds.min) oversize += bounds.min - data.myLocation;
    if (data.myLocation > bounds.max) oversize += data.myLocation - bounds.max;
    return oversize;
};
var $833f142a563fa640$var$collisionSide = function(direction, data, bounds) {
    if (data.myLocation < bounds.min) return "h" === direction ? "left" : "top";
    if (data.myLocation > bounds.max) return "h" === direction ? "right" : "bottom";
    return "none";
};
var $833f142a563fa640$var$initMyLocation = function(data) {
    data.myLocation = data.atLocation + $833f142a563fa640$var$getAlignFactor(data.atAlign) * data.atSize - $833f142a563fa640$var$getAlignFactor(data.myAlign) * data.mySize + data.offset;
};
var $833f142a563fa640$var$collisionResolvers = {
    fit: function(data, bounds) {
        var result = false;
        if (data.myLocation > bounds.max) {
            data.myLocation = bounds.max;
            result = true;
        }
        if (data.myLocation < bounds.min) {
            data.myLocation = bounds.min;
            result = true;
        }
        data.fit = result;
    },
    flip: function(data, bounds) {
        data.flip = false;
        if ("center" === data.myAlign && "center" === data.atAlign) return;
        if (data.myLocation < bounds.min || data.myLocation > bounds.max) {
            var inverseData = $833f142a563fa640$require$extend({}, data, {
                myAlign: $833f142a563fa640$var$inverseAlign(data.myAlign),
                atAlign: $833f142a563fa640$var$inverseAlign(data.atAlign),
                offset: -data.offset
            });
            $833f142a563fa640$var$initMyLocation(inverseData);
            inverseData.oversize = $833f142a563fa640$var$calculateOversize(inverseData, bounds);
            if (inverseData.myLocation >= bounds.min && inverseData.myLocation <= bounds.max || data.oversize > inverseData.oversize) {
                data.myLocation = inverseData.myLocation;
                data.oversize = inverseData.oversize;
                data.flip = true;
            }
        }
    },
    flipfit: function(data, bounds) {
        this.flip(data, bounds);
        this.fit(data, bounds);
    },
    none: function(data) {
        data.oversize = 0;
    }
};
var $833f142a563fa640$var$scrollbarWidth;
var $833f142a563fa640$var$calculateScrollbarWidth = function() {
    var $scrollDiv = $jFnCG("<div>").css({
        width: 100,
        height: 100,
        overflow: "scroll",
        position: "absolute",
        top: -9999
    }).appendTo($jFnCG("body"));
    var result = $scrollDiv.get(0).offsetWidth - $scrollDiv.get(0).clientWidth;
    $scrollDiv.remove();
    $833f142a563fa640$var$scrollbarWidth = result;
};
var $833f142a563fa640$var$defaultPositionResult = {
    h: {
        location: 0,
        flip: false,
        fit: false,
        oversize: 0
    },
    v: {
        location: 0,
        flip: false,
        fit: false,
        oversize: 0
    }
};
var $833f142a563fa640$var$calculatePosition = function(what, options) {
    var $what = $jFnCG(what);
    var currentOffset = $what.offset();
    var result = $833f142a563fa640$require$extend(true, {}, $833f142a563fa640$var$defaultPositionResult, {
        h: {
            location: currentOffset.left
        },
        v: {
            location: currentOffset.top
        }
    });
    if (!options) return result;
    var my = $833f142a563fa640$var$normalizeAlign(options.my);
    var at = $833f142a563fa640$var$normalizeAlign(options.at);
    var of = $jFnCG(options.of).length && options.of || $833f142a563fa640$var$window;
    var offset = $833f142a563fa640$var$normalizeOffset(options.offset);
    var collision = $833f142a563fa640$var$normalizeCollision(options.collision);
    var boundary = options.boundary;
    var boundaryOffset = $833f142a563fa640$var$normalizeOffset(options.boundaryOffset);
    var h = {
        mySize: $what.outerWidth(),
        myAlign: my.h,
        atAlign: at.h,
        offset: offset.h,
        collision: collision.h,
        boundaryOffset: boundaryOffset.h
    };
    var v = {
        mySize: $what.outerHeight(),
        myAlign: my.v,
        atAlign: at.v,
        offset: offset.v,
        collision: collision.v,
        boundaryOffset: boundaryOffset.v
    };
    if (of.preventDefault) {
        h.atLocation = of.pageX;
        v.atLocation = of.pageY;
        h.atSize = 0;
        v.atSize = 0;
    } else {
        of = $jFnCG(of);
        if ($833f142a563fa640$require$isWindow(of[0])) {
            h.atLocation = of.scrollLeft();
            v.atLocation = of.scrollTop();
            h.atSize = of[0].innerWidth >= of[0].outerWidth ? of[0].innerWidth : of.width();
            v.atSize = of[0].innerHeight >= of[0].outerHeight || $833f142a563fa640$var$IS_SAFARI ? of[0].innerHeight : of.height();
        } else if (9 === of[0].nodeType) {
            h.atLocation = 0;
            v.atLocation = 0;
            h.atSize = of.width();
            v.atSize = of.height();
        } else {
            var ofRect = $833f142a563fa640$require$getBoundingRect(of.get(0));
            var o = of.offset();
            h.atLocation = o.left;
            v.atLocation = o.top;
            h.atSize = ofRect.width;
            v.atSize = ofRect.height;
        }
    }
    $833f142a563fa640$var$initMyLocation(h);
    $833f142a563fa640$var$initMyLocation(v);
    var bounds = function() {
        var win = $jFnCG($833f142a563fa640$var$window);
        var windowWidth = win.width();
        var windowHeight = win.height();
        var left = win.scrollLeft();
        var top = win.scrollTop();
        var documentElement = $445Bz.getDocumentElement();
        var hZoomLevel = $6VAWB.touch ? documentElement.clientWidth / windowWidth : 1;
        var vZoomLevel = $6VAWB.touch ? documentElement.clientHeight / windowHeight : 1;
        if (void 0 === $833f142a563fa640$var$scrollbarWidth) $833f142a563fa640$var$calculateScrollbarWidth();
        var boundaryWidth = windowWidth;
        var boundaryHeight = windowHeight;
        if (boundary) {
            var $boundary = $jFnCG(boundary);
            var boundaryPosition = $boundary.offset();
            left = boundaryPosition.left;
            top = boundaryPosition.top;
            boundaryWidth = $boundary.width();
            boundaryHeight = $boundary.height();
        }
        return {
            h: {
                min: left + h.boundaryOffset,
                max: left + boundaryWidth / hZoomLevel - h.mySize - h.boundaryOffset
            },
            v: {
                min: top + v.boundaryOffset,
                max: top + boundaryHeight / vZoomLevel - v.mySize - v.boundaryOffset
            }
        };
    }();
    h.oversize = $833f142a563fa640$var$calculateOversize(h, bounds.h);
    v.oversize = $833f142a563fa640$var$calculateOversize(v, bounds.v);
    h.collisionSide = $833f142a563fa640$var$collisionSide("h", h, bounds.h);
    v.collisionSide = $833f142a563fa640$var$collisionSide("v", v, bounds.v);
    if ($833f142a563fa640$var$collisionResolvers[h.collision]) $833f142a563fa640$var$collisionResolvers[h.collision](h, bounds.h);
    if ($833f142a563fa640$var$collisionResolvers[v.collision]) $833f142a563fa640$var$collisionResolvers[v.collision](v, bounds.v);
    var preciser = function(number) {
        return options.precise ? number : Math.round(number);
    };
    $833f142a563fa640$require$extend(true, result, {
        h: {
            location: preciser(h.myLocation),
            oversize: preciser(h.oversize),
            fit: h.fit,
            flip: h.flip,
            collisionSide: h.collisionSide
        },
        v: {
            location: preciser(v.myLocation),
            oversize: preciser(v.oversize),
            fit: v.fit,
            flip: v.flip,
            collisionSide: v.collisionSide
        },
        precise: options.precise
    });
    return result;
};
var $833f142a563fa640$var$position = function(what, options) {
    var $what = $jFnCG(what);
    if (!options) return $what.offset();
    $6jr65.resetPosition($what, true);
    var offset = $what.offset();
    var targetPosition = options.h && options.v ? options : $833f142a563fa640$var$calculatePosition($what, options);
    var preciser = function(number) {
        return options.precise ? number : Math.round(number);
    };
    $6jr65.move($what, {
        left: targetPosition.h.location - preciser(offset.left),
        top: targetPosition.v.location - preciser(offset.top)
    });
    return targetPosition;
};
var $833f142a563fa640$var$offset = function(element) {
    element = $jFnCG(element).get(0);
    if ($833f142a563fa640$require$isWindow(element)) return null;
    else {
        if (element && "pageY" in element && "pageX" in element) return {
            top: element.pageY,
            left: element.pageX
        };
    }
    return $jFnCG(element).offset();
};
if (!$833f142a563fa640$var$position.inverseAlign) $833f142a563fa640$var$position.inverseAlign = $833f142a563fa640$var$inverseAlign;
if (!$833f142a563fa640$var$position.normalizeAlign) $833f142a563fa640$var$position.normalizeAlign = $833f142a563fa640$var$normalizeAlign;
module.exports = {
    calculateScrollbarWidth: $833f142a563fa640$var$calculateScrollbarWidth,
    calculate: $833f142a563fa640$var$calculatePosition,
    setup: $833f142a563fa640$var$position,
    offset: $833f142a563fa640$var$offset
};

});


parcelRegister("mN2g9", function(module, exports) {
/**
 * DevExtreme (mobile/hide_top_overlay.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $aLQK5 = parcelRequire("aLQK5");
var $0448179b3e7dfb38$require$inArray = $aLQK5.inArray;
var $0448179b3e7dfb38$var$hideCallback = function() {
    var callbacks = [];
    return {
        add: function(callback) {
            var indexOfCallback = $0448179b3e7dfb38$require$inArray(callback, callbacks);
            if (indexOfCallback === -1) callbacks.push(callback);
        },
        remove: function(callback) {
            var indexOfCallback = $0448179b3e7dfb38$require$inArray(callback, callbacks);
            if (indexOfCallback !== -1) callbacks.splice(indexOfCallback, 1);
        },
        fire: function() {
            var callback = callbacks.pop();
            var result = !!callback;
            if (result) callback();
            return result;
        },
        hasCallback: function() {
            return callbacks.length > 0;
        }
    };
}();
module.exports = function() {
    return $0448179b3e7dfb38$var$hideCallback.fire();
};
module.exports.hideCallback = $0448179b3e7dfb38$var$hideCallback;
module.exports.default = module.exports;

});

parcelRegister("cesi3", function(module, exports) {

$parcel$export(module.exports, "move", () => $8e7cbcafb96e4b80$export$d947e5f4f4c48d48, (v) => $8e7cbcafb96e4b80$export$d947e5f4f4c48d48 = v);
$parcel$export(module.exports, "start", () => $8e7cbcafb96e4b80$export$b3571188c770cc5a, (v) => $8e7cbcafb96e4b80$export$b3571188c770cc5a = v);
$parcel$export(module.exports, "end", () => $8e7cbcafb96e4b80$export$bd5df0f255a350f8, (v) => $8e7cbcafb96e4b80$export$bd5df0f255a350f8 = v);
$parcel$export(module.exports, "enter", () => $8e7cbcafb96e4b80$export$e668df1bcd81e4d2, (v) => $8e7cbcafb96e4b80$export$e668df1bcd81e4d2 = v);
$parcel$export(module.exports, "leave", () => $8e7cbcafb96e4b80$export$33993f1ec7a2167a, (v) => $8e7cbcafb96e4b80$export$33993f1ec7a2167a = v);
$parcel$export(module.exports, "drop", () => $8e7cbcafb96e4b80$export$663103110d94aac9, (v) => $8e7cbcafb96e4b80$export$663103110d94aac9 = v);
/**
 * DevExtreme (events/drag.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $8e7cbcafb96e4b80$export$d947e5f4f4c48d48;
var $8e7cbcafb96e4b80$export$b3571188c770cc5a;
var $8e7cbcafb96e4b80$export$bd5df0f255a350f8;
var $8e7cbcafb96e4b80$export$e668df1bcd81e4d2;
var $8e7cbcafb96e4b80$export$33993f1ec7a2167a;
var $8e7cbcafb96e4b80$export$663103110d94aac9;
"use strict";

var $jFnCG = parcelRequire("jFnCG");

var $8ulMI = parcelRequire("8ulMI");

var $aLQK5 = parcelRequire("aLQK5");
var $8e7cbcafb96e4b80$require$wrapToArray = $aLQK5.wrapToArray;

var $aLQK5 = parcelRequire("aLQK5");
var $8e7cbcafb96e4b80$require$inArray = $aLQK5.inArray;

var $4Pwuy = parcelRequire("4Pwuy");

var $5OzEX = parcelRequire("5OzEX");
var $8e7cbcafb96e4b80$require$contains = $5OzEX.contains;

var $cMvU0 = parcelRequire("cMvU0");

var $bXb2w = parcelRequire("bXb2w");

var $dqZUs = parcelRequire("dqZUs");

var $fy5D5 = parcelRequire("fy5D5");
var $8e7cbcafb96e4b80$var$DRAG_START_EVENT = "dxdragstart";
var $8e7cbcafb96e4b80$var$DRAG_EVENT = "dxdrag";
var $8e7cbcafb96e4b80$var$DRAG_END_EVENT = "dxdragend";
var $8e7cbcafb96e4b80$var$DRAG_ENTER_EVENT = "dxdragenter";
var $8e7cbcafb96e4b80$var$DRAG_LEAVE_EVENT = "dxdragleave";
var $8e7cbcafb96e4b80$var$DROP_EVENT = "dxdrop";
var $8e7cbcafb96e4b80$var$DX_DRAG_EVENTS_COUNT_KEY = "dxDragEventsCount";
var $8e7cbcafb96e4b80$var$knownDropTargets = [];
var $8e7cbcafb96e4b80$var$knownDropTargetSelectors = [];
var $8e7cbcafb96e4b80$var$knownDropTargetConfigs = [];
var $8e7cbcafb96e4b80$var$dropTargetRegistration = {
    setup: function(element, data) {
        var knownDropTarget = $8e7cbcafb96e4b80$require$inArray(element, $8e7cbcafb96e4b80$var$knownDropTargets) !== -1;
        if (!knownDropTarget) {
            $8e7cbcafb96e4b80$var$knownDropTargets.push(element);
            $8e7cbcafb96e4b80$var$knownDropTargetSelectors.push([]);
            $8e7cbcafb96e4b80$var$knownDropTargetConfigs.push(data || {});
        }
    },
    add: function(element, handleObj) {
        var index = $8e7cbcafb96e4b80$require$inArray(element, $8e7cbcafb96e4b80$var$knownDropTargets);
        this.updateEventsCounter(element, handleObj.type, 1);
        var selector = handleObj.selector;
        if ($8e7cbcafb96e4b80$require$inArray(selector, $8e7cbcafb96e4b80$var$knownDropTargetSelectors[index]) === -1) $8e7cbcafb96e4b80$var$knownDropTargetSelectors[index].push(selector);
    },
    updateEventsCounter: function(element, event, value) {
        if ([
            $8e7cbcafb96e4b80$var$DRAG_ENTER_EVENT,
            $8e7cbcafb96e4b80$var$DRAG_LEAVE_EVENT,
            $8e7cbcafb96e4b80$var$DROP_EVENT
        ].indexOf(event) > -1) {
            var eventsCount = $8ulMI.data(element, $8e7cbcafb96e4b80$var$DX_DRAG_EVENTS_COUNT_KEY) || 0;
            $8ulMI.data(element, $8e7cbcafb96e4b80$var$DX_DRAG_EVENTS_COUNT_KEY, Math.max(0, eventsCount + value));
        }
    },
    remove: function(element, handleObj) {
        this.updateEventsCounter(element, handleObj.type, -1);
    },
    teardown: function(element) {
        var handlersCount = $8ulMI.data(element, $8e7cbcafb96e4b80$var$DX_DRAG_EVENTS_COUNT_KEY);
        if (!handlersCount) {
            var index = $8e7cbcafb96e4b80$require$inArray(element, $8e7cbcafb96e4b80$var$knownDropTargets);
            $8e7cbcafb96e4b80$var$knownDropTargets.splice(index, 1);
            $8e7cbcafb96e4b80$var$knownDropTargetSelectors.splice(index, 1);
            $8e7cbcafb96e4b80$var$knownDropTargetConfigs.splice(index, 1);
            $8ulMI.removeData(element, $8e7cbcafb96e4b80$var$DX_DRAG_EVENTS_COUNT_KEY);
        }
    }
};
$cMvU0($8e7cbcafb96e4b80$var$DRAG_ENTER_EVENT, $8e7cbcafb96e4b80$var$dropTargetRegistration);
$cMvU0($8e7cbcafb96e4b80$var$DRAG_LEAVE_EVENT, $8e7cbcafb96e4b80$var$dropTargetRegistration);
$cMvU0($8e7cbcafb96e4b80$var$DROP_EVENT, $8e7cbcafb96e4b80$var$dropTargetRegistration);
var $8e7cbcafb96e4b80$var$getItemDelegatedTargets = function($element) {
    var dropTargetIndex = $8e7cbcafb96e4b80$require$inArray($element.get(0), $8e7cbcafb96e4b80$var$knownDropTargets);
    var dropTargetSelectors = $8e7cbcafb96e4b80$var$knownDropTargetSelectors[dropTargetIndex].filter(function(selector) {
        return selector;
    });
    var $delegatedTargets = $element.find(dropTargetSelectors.join(", "));
    if ($8e7cbcafb96e4b80$require$inArray(void 0, $8e7cbcafb96e4b80$var$knownDropTargetSelectors[dropTargetIndex]) !== -1) $delegatedTargets = $delegatedTargets.add($element);
    return $delegatedTargets;
};
var $8e7cbcafb96e4b80$var$getItemConfig = function($element) {
    var dropTargetIndex = $8e7cbcafb96e4b80$require$inArray($element.get(0), $8e7cbcafb96e4b80$var$knownDropTargets);
    return $8e7cbcafb96e4b80$var$knownDropTargetConfigs[dropTargetIndex];
};
var $8e7cbcafb96e4b80$var$getItemPosition = function(dropTargetConfig, $element) {
    if (dropTargetConfig.itemPositionFunc) return dropTargetConfig.itemPositionFunc($element);
    else return $element.offset();
};
var $8e7cbcafb96e4b80$var$getItemSize = function(dropTargetConfig, $element) {
    if (dropTargetConfig.itemSizeFunc) return dropTargetConfig.itemSizeFunc($element);
    return {
        width: $element.get(0).getBoundingClientRect().width,
        height: $element.get(0).getBoundingClientRect().height
    };
};
var $8e7cbcafb96e4b80$var$DragEmitter = $dqZUs.inherit({
    ctor: function(element) {
        this.callBase(element);
        this.direction = "both";
    },
    _init: function(e) {
        this._initEvent = e;
    },
    _start: function(e) {
        e = this._fireEvent($8e7cbcafb96e4b80$var$DRAG_START_EVENT, this._initEvent);
        this._maxLeftOffset = e.maxLeftOffset;
        this._maxRightOffset = e.maxRightOffset;
        this._maxTopOffset = e.maxTopOffset;
        this._maxBottomOffset = e.maxBottomOffset;
        var dropTargets = $8e7cbcafb96e4b80$require$wrapToArray(e.targetElements || (null === e.targetElements ? [] : $8e7cbcafb96e4b80$var$knownDropTargets));
        this._dropTargets = $4Pwuy.map(dropTargets, function(element) {
            return $jFnCG(element).get(0);
        });
    },
    _move: function(e) {
        var eventData = $bXb2w.eventData(e);
        var dragOffset = this._calculateOffset(eventData);
        e = this._fireEvent($8e7cbcafb96e4b80$var$DRAG_EVENT, e, {
            offset: dragOffset
        });
        this._processDropTargets(e);
        if (!e._cancelPreventDefault) e.preventDefault();
    },
    _calculateOffset: function(eventData) {
        return {
            x: this._calculateXOffset(eventData),
            y: this._calculateYOffset(eventData)
        };
    },
    _calculateXOffset: function(eventData) {
        if ("vertical" !== this.direction) {
            var offset = eventData.x - this._startEventData.x;
            return this._fitOffset(offset, this._maxLeftOffset, this._maxRightOffset);
        }
        return 0;
    },
    _calculateYOffset: function(eventData) {
        if ("horizontal" !== this.direction) {
            var offset = eventData.y - this._startEventData.y;
            return this._fitOffset(offset, this._maxTopOffset, this._maxBottomOffset);
        }
        return 0;
    },
    _fitOffset: function(offset, minOffset, maxOffset) {
        if (null != minOffset) offset = Math.max(offset, -minOffset);
        if (null != maxOffset) offset = Math.min(offset, maxOffset);
        return offset;
    },
    _processDropTargets: function(e) {
        var target = this._findDropTarget(e);
        var sameTarget = target === this._currentDropTarget;
        if (!sameTarget) {
            this._fireDropTargetEvent(e, $8e7cbcafb96e4b80$var$DRAG_LEAVE_EVENT);
            this._currentDropTarget = target;
            this._fireDropTargetEvent(e, $8e7cbcafb96e4b80$var$DRAG_ENTER_EVENT);
        }
    },
    _fireDropTargetEvent: function(event, eventName) {
        if (!this._currentDropTarget) return;
        var eventData = {
            type: eventName,
            originalEvent: event,
            draggingElement: this._$element.get(0),
            target: this._currentDropTarget
        };
        $bXb2w.fireEvent(eventData);
    },
    _findDropTarget: function(e) {
        var that = this;
        var result;
        $4Pwuy.each($8e7cbcafb96e4b80$var$knownDropTargets, function(_, target) {
            if (!that._checkDropTargetActive(target)) return;
            var $target = $jFnCG(target);
            $4Pwuy.each($8e7cbcafb96e4b80$var$getItemDelegatedTargets($target), function(_, delegatedTarget) {
                var $delegatedTarget = $jFnCG(delegatedTarget);
                if (that._checkDropTarget($8e7cbcafb96e4b80$var$getItemConfig($target), $delegatedTarget, e)) result = delegatedTarget;
            });
        });
        return result;
    },
    _checkDropTargetActive: function(target) {
        var active = false;
        $4Pwuy.each(this._dropTargets, function(_, activeTarget) {
            active = active || activeTarget === target || $8e7cbcafb96e4b80$require$contains(activeTarget, target);
            return !active;
        });
        return active;
    },
    _checkDropTarget: function(config, $target, e) {
        var isDraggingElement = $target.get(0) === $jFnCG(e.target).get(0);
        if (isDraggingElement) return false;
        var targetPosition = $8e7cbcafb96e4b80$var$getItemPosition(config, $target);
        if (e.pageX < targetPosition.left) return false;
        if (e.pageY < targetPosition.top) return false;
        var targetSize = $8e7cbcafb96e4b80$var$getItemSize(config, $target);
        if (e.pageX > targetPosition.left + targetSize.width) return false;
        if (e.pageY > targetPosition.top + targetSize.height) return false;
        if (config.checkDropTarget && !config.checkDropTarget($target, e)) return false;
        return $target;
    },
    _end: function(e) {
        var eventData = $bXb2w.eventData(e);
        this._fireEvent($8e7cbcafb96e4b80$var$DRAG_END_EVENT, e, {
            offset: this._calculateOffset(eventData)
        });
        this._fireDropTargetEvent(e, $8e7cbcafb96e4b80$var$DROP_EVENT);
        delete this._currentDropTarget;
    }
});
$fy5D5({
    emitter: $8e7cbcafb96e4b80$var$DragEmitter,
    events: [
        $8e7cbcafb96e4b80$var$DRAG_START_EVENT,
        $8e7cbcafb96e4b80$var$DRAG_EVENT,
        $8e7cbcafb96e4b80$var$DRAG_END_EVENT
    ]
});
$8e7cbcafb96e4b80$export$d947e5f4f4c48d48 = $8e7cbcafb96e4b80$var$DRAG_EVENT;
$8e7cbcafb96e4b80$export$b3571188c770cc5a = $8e7cbcafb96e4b80$var$DRAG_START_EVENT;
$8e7cbcafb96e4b80$export$bd5df0f255a350f8 = $8e7cbcafb96e4b80$var$DRAG_END_EVENT;
$8e7cbcafb96e4b80$export$e668df1bcd81e4d2 = $8e7cbcafb96e4b80$var$DRAG_ENTER_EVENT;
$8e7cbcafb96e4b80$export$33993f1ec7a2167a = $8e7cbcafb96e4b80$var$DRAG_LEAVE_EVENT;
$8e7cbcafb96e4b80$export$663103110d94aac9 = $8e7cbcafb96e4b80$var$DROP_EVENT;

});
parcelRegister("dqZUs", function(module, exports) {
/**
 * DevExtreme (events/gesture/emitter.gesture.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $e1LMc = parcelRequire("e1LMc");

var $aiwte = parcelRequire("aiwte");

var $9Z7y9 = parcelRequire("9Z7y9");

var $ePlHj = parcelRequire("ePlHj");

var $5OzEX = parcelRequire("5OzEX");

var $g4e4U = parcelRequire("g4e4U");
var $9c7dba08845072d8$var$ready = $g4e4U.add;

var $efpkH = parcelRequire("efpkH");

var $2Mto0 = parcelRequire("2Mto0");
var $9c7dba08845072d8$require$noop = $2Mto0.noop;

var $kDRxH = parcelRequire("kDRxH");
var $9c7dba08845072d8$require$isDefined = $kDRxH.isDefined;

var $bXb2w = parcelRequire("bXb2w");

var $lTdDg = parcelRequire("lTdDg");
var $9c7dba08845072d8$var$sign = $efpkH.sign;
var $9c7dba08845072d8$var$abs = Math.abs;
var $9c7dba08845072d8$var$SLEEP = 0;
var $9c7dba08845072d8$var$INITED = 1;
var $9c7dba08845072d8$var$STARTED = 2;
var $9c7dba08845072d8$var$TOUCH_BOUNDARY = 10;
var $9c7dba08845072d8$var$IMMEDIATE_TOUCH_BOUNDARY = 0;
var $9c7dba08845072d8$var$IMMEDIATE_TIMEOUT = 180;
var $9c7dba08845072d8$var$supportPointerEvents = function() {
    return $9Z7y9.styleProp("pointer-events");
};
var $9c7dba08845072d8$var$setGestureCover = $ePlHj(function() {
    var GESTURE_COVER_CLASS = "dx-gesture-cover";
    var isDesktop = "desktop" === $aiwte.real().deviceType;
    if (!$9c7dba08845072d8$var$supportPointerEvents() || !isDesktop) return $9c7dba08845072d8$require$noop;
    var $cover = $jFnCG("<div>").addClass(GESTURE_COVER_CLASS).css("pointerEvents", "none");
    $e1LMc.subscribeGlobal($cover, "dxmousewheel", function(e) {
        e.preventDefault();
    });
    $9c7dba08845072d8$var$ready(function() {
        $cover.appendTo("body");
    });
    return function(toggle, cursor) {
        $cover.css("pointerEvents", toggle ? "all" : "none");
        toggle && $cover.css("cursor", cursor);
    };
});
var $9c7dba08845072d8$var$gestureCover = function(toggle, cursor) {
    var gestureCoverStrategy = $9c7dba08845072d8$var$setGestureCover();
    gestureCoverStrategy(toggle, cursor);
};
var $9c7dba08845072d8$var$GestureEmitter = $lTdDg.inherit({
    gesture: true,
    configure: function(data) {
        this.getElement().css("msTouchAction", data.immediate ? "pinch-zoom" : "");
        this.callBase(data);
    },
    allowInterruptionByMouseWheel: function() {
        return this._stage !== $9c7dba08845072d8$var$STARTED;
    },
    getDirection: function() {
        return this.direction;
    },
    _cancel: function() {
        this.callBase.apply(this, arguments);
        this._toggleGestureCover(false);
        this._stage = $9c7dba08845072d8$var$SLEEP;
    },
    start: function(e) {
        if (e._needSkipEvent || $bXb2w.needSkipEvent(e)) {
            this._cancel(e);
            return;
        }
        this._startEvent = $bXb2w.createEvent(e);
        this._startEventData = $bXb2w.eventData(e);
        this._stage = $9c7dba08845072d8$var$INITED;
        this._init(e);
        this._setupImmediateTimer();
    },
    _setupImmediateTimer: function() {
        clearTimeout(this._immediateTimer);
        this._immediateAccepted = false;
        if (!this.immediate) return;
        this._immediateTimer = setTimeout((function() {
            this._immediateAccepted = true;
        }).bind(this), $9c7dba08845072d8$var$IMMEDIATE_TIMEOUT);
    },
    move: function(e) {
        if (this._stage === $9c7dba08845072d8$var$INITED && this._directionConfirmed(e)) {
            this._stage = $9c7dba08845072d8$var$STARTED;
            this._resetActiveElement();
            this._toggleGestureCover(true);
            this._clearSelection(e);
            this._adjustStartEvent(e);
            this._start(this._startEvent);
            if (this._stage === $9c7dba08845072d8$var$SLEEP) return;
            this._requestAccept(e);
            this._move(e);
            this._forgetAccept();
        } else if (this._stage === $9c7dba08845072d8$var$STARTED) {
            this._clearSelection(e);
            this._move(e);
        }
    },
    _directionConfirmed: function(e) {
        var touchBoundary = this._getTouchBoundary(e);
        var delta = $bXb2w.eventDelta(this._startEventData, $bXb2w.eventData(e));
        var deltaX = $9c7dba08845072d8$var$abs(delta.x);
        var deltaY = $9c7dba08845072d8$var$abs(delta.y);
        var horizontalMove = this._validateMove(touchBoundary, deltaX, deltaY);
        var verticalMove = this._validateMove(touchBoundary, deltaY, deltaX);
        var direction = this.getDirection(e);
        var bothAccepted = "both" === direction && (horizontalMove || verticalMove);
        var horizontalAccepted = "horizontal" === direction && horizontalMove;
        var verticalAccepted = "vertical" === direction && verticalMove;
        return bothAccepted || horizontalAccepted || verticalAccepted || this._immediateAccepted;
    },
    _validateMove: function(touchBoundary, mainAxis, crossAxis) {
        return mainAxis && mainAxis >= touchBoundary && (this.immediate ? mainAxis >= crossAxis : true);
    },
    _getTouchBoundary: function(e) {
        return this.immediate || $bXb2w.isDxMouseWheelEvent(e) ? $9c7dba08845072d8$var$IMMEDIATE_TOUCH_BOUNDARY : $9c7dba08845072d8$var$TOUCH_BOUNDARY;
    },
    _adjustStartEvent: function(e) {
        var touchBoundary = this._getTouchBoundary(e);
        var delta = $bXb2w.eventDelta(this._startEventData, $bXb2w.eventData(e));
        this._startEvent.pageX += $9c7dba08845072d8$var$sign(delta.x) * touchBoundary;
        this._startEvent.pageY += $9c7dba08845072d8$var$sign(delta.y) * touchBoundary;
    },
    _resetActiveElement: function() {
        if ("ios" === $aiwte.real().platform && this.getElement().find(":focus").length) $5OzEX.resetActiveElement();
    },
    _toggleGestureCover: function(toggle) {
        this._toggleGestureCoverImpl(toggle);
    },
    _toggleGestureCoverImpl: function(toggle) {
        var isStarted = this._stage === $9c7dba08845072d8$var$STARTED;
        if (isStarted) $9c7dba08845072d8$var$gestureCover(toggle, this.getElement().css("cursor"));
    },
    _clearSelection: function(e) {
        if ($bXb2w.isDxMouseWheelEvent(e) || $bXb2w.isTouchEvent(e)) return;
        $5OzEX.clearSelection();
    },
    end: function(e) {
        this._toggleGestureCover(false);
        if (this._stage === $9c7dba08845072d8$var$STARTED) this._end(e);
        else if (this._stage === $9c7dba08845072d8$var$INITED) this._stop(e);
        this._stage = $9c7dba08845072d8$var$SLEEP;
    },
    dispose: function() {
        clearTimeout(this._immediateTimer);
        this.callBase.apply(this, arguments);
        this._toggleGestureCover(false);
    },
    _init: $9c7dba08845072d8$require$noop,
    _start: $9c7dba08845072d8$require$noop,
    _move: $9c7dba08845072d8$require$noop,
    _stop: $9c7dba08845072d8$require$noop,
    _end: $9c7dba08845072d8$require$noop
});
$9c7dba08845072d8$var$GestureEmitter.initialTouchBoundary = $9c7dba08845072d8$var$TOUCH_BOUNDARY;
$9c7dba08845072d8$var$GestureEmitter.touchBoundary = function(newBoundary) {
    if ($9c7dba08845072d8$require$isDefined(newBoundary)) {
        $9c7dba08845072d8$var$TOUCH_BOUNDARY = newBoundary;
        return;
    }
    return $9c7dba08845072d8$var$TOUCH_BOUNDARY;
};
module.exports = $9c7dba08845072d8$var$GestureEmitter;

});


parcelRegister("i1UKB", function(module, exports) {
/**
 * DevExtreme (ui/resizable.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $6jr65 = parcelRequire("6jr65");
var $d204578058d79ecb$var$_translator2 = $d204578058d79ecb$var$_interopRequireDefault($6jr65);

var $4ZFRo = parcelRequire("4ZFRo");
var $d204578058d79ecb$var$_component_registrator2 = $d204578058d79ecb$var$_interopRequireDefault($4ZFRo);

var $4sKC1 = parcelRequire("4sKC1");
var $d204578058d79ecb$var$_dom_component2 = $d204578058d79ecb$var$_interopRequireDefault($4sKC1);

var $jFnCG = parcelRequire("jFnCG");
var $d204578058d79ecb$var$_renderer2 = $d204578058d79ecb$var$_interopRequireDefault($jFnCG);

var $aLQK5 = parcelRequire("aLQK5");

var $2Mto0 = parcelRequire("2Mto0");
var $d204578058d79ecb$var$_common2 = $d204578058d79ecb$var$_interopRequireDefault($2Mto0);

var $7I8Uw = parcelRequire("7I8Uw");

var $4Pwuy = parcelRequire("4Pwuy");

var $efpkH = parcelRequire("efpkH");

var $kDRxH = parcelRequire("kDRxH");
var $d204578058d79ecb$var$_type2 = $d204578058d79ecb$var$_interopRequireDefault($kDRxH);

var $irv64 = parcelRequire("irv64");
var $d204578058d79ecb$var$_window2 = $d204578058d79ecb$var$_interopRequireDefault($irv64);

var $e1LMc = parcelRequire("e1LMc");
var $d204578058d79ecb$var$_events_engine2 = $d204578058d79ecb$var$_interopRequireDefault($e1LMc);

var $cesi3 = parcelRequire("cesi3");
var $d204578058d79ecb$var$_drag2 = $d204578058d79ecb$var$_interopRequireDefault($cesi3);

var $1TtsA = parcelRequire("1TtsA");

var $bXb2w = parcelRequire("bXb2w");

var $5OzEX = parcelRequire("5OzEX");
var $d204578058d79ecb$var$_dom2 = $d204578058d79ecb$var$_interopRequireDefault($5OzEX);
function $d204578058d79ecb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $d204578058d79ecb$var$isPlainObject = $d204578058d79ecb$var$_type2.default.isPlainObject;
var $d204578058d79ecb$var$isFunction = $d204578058d79ecb$var$_type2.default.isFunction;
var $d204578058d79ecb$var$RESIZABLE = "dxResizable";
var $d204578058d79ecb$var$RESIZABLE_CLASS = "dx-resizable";
var $d204578058d79ecb$var$RESIZABLE_RESIZING_CLASS = "dx-resizable-resizing";
var $d204578058d79ecb$var$RESIZABLE_HANDLE_CLASS = "dx-resizable-handle";
var $d204578058d79ecb$var$RESIZABLE_HANDLE_TOP_CLASS = "dx-resizable-handle-top";
var $d204578058d79ecb$var$RESIZABLE_HANDLE_BOTTOM_CLASS = "dx-resizable-handle-bottom";
var $d204578058d79ecb$var$RESIZABLE_HANDLE_LEFT_CLASS = "dx-resizable-handle-left";
var $d204578058d79ecb$var$RESIZABLE_HANDLE_RIGHT_CLASS = "dx-resizable-handle-right";
var $d204578058d79ecb$var$RESIZABLE_HANDLE_CORNER_CLASS = "dx-resizable-handle-corner";
var $d204578058d79ecb$var$DRAGSTART_START_EVENT_NAME = (0, $bXb2w.addNamespace)($d204578058d79ecb$var$_drag2.default.start, $d204578058d79ecb$var$RESIZABLE);
var $d204578058d79ecb$var$DRAGSTART_EVENT_NAME = (0, $bXb2w.addNamespace)($d204578058d79ecb$var$_drag2.default.move, $d204578058d79ecb$var$RESIZABLE);
var $d204578058d79ecb$var$DRAGSTART_END_EVENT_NAME = (0, $bXb2w.addNamespace)($d204578058d79ecb$var$_drag2.default.end, $d204578058d79ecb$var$RESIZABLE);
var $d204578058d79ecb$var$SIDE_BORDER_WIDTH_STYLES = {
    left: "borderLeftWidth",
    top: "borderTopWidth",
    right: "borderRightWidth",
    bottom: "borderBottomWidth"
};
var $d204578058d79ecb$var$Resizable = $d204578058d79ecb$var$_dom_component2.default.inherit({
    _getDefaultOptions: function() {
        return (0, $7I8Uw.extend)(this.callBase(), {
            handles: "all",
            step: "1",
            stepPrecision: "simple",
            area: void 0,
            minWidth: 30,
            maxWidth: 1 / 0,
            minHeight: 30,
            maxHeight: 1 / 0,
            onResizeStart: null,
            onResize: null,
            onResizeEnd: null,
            roundStepValue: true
        });
    },
    _init: function() {
        this.callBase();
        this.$element().addClass($d204578058d79ecb$var$RESIZABLE_CLASS);
    },
    _initMarkup: function() {
        this.callBase();
        this._renderHandles();
    },
    _render: function() {
        this.callBase();
        this._renderActions();
    },
    _renderActions: function() {
        this._resizeStartAction = this._createActionByOption("onResizeStart");
        this._resizeEndAction = this._createActionByOption("onResizeEnd");
        this._resizeAction = this._createActionByOption("onResize");
    },
    _renderHandles: function() {
        this._handles = [];
        var handles = this.option("handles");
        if ("none" === handles) return;
        var directions = "all" === handles ? [
            "top",
            "bottom",
            "left",
            "right"
        ] : handles.split(" ");
        (0, $4Pwuy.each)(directions, (function(index, handleName) {
            this._renderHandle(handleName);
        }).bind(this));
        (0, $aLQK5.inArray)("bottom", directions) + 1 && (0, $aLQK5.inArray)("right", directions) + 1 && this._renderHandle("corner-bottom-right");
        (0, $aLQK5.inArray)("bottom", directions) + 1 && (0, $aLQK5.inArray)("left", directions) + 1 && this._renderHandle("corner-bottom-left");
        (0, $aLQK5.inArray)("top", directions) + 1 && (0, $aLQK5.inArray)("right", directions) + 1 && this._renderHandle("corner-top-right");
        (0, $aLQK5.inArray)("top", directions) + 1 && (0, $aLQK5.inArray)("left", directions) + 1 && this._renderHandle("corner-top-left");
        this._attachEventHandlers();
    },
    _renderHandle: function(handleName) {
        var $handle = (0, $d204578058d79ecb$var$_renderer2.default)("<div>").addClass($d204578058d79ecb$var$RESIZABLE_HANDLE_CLASS).addClass($d204578058d79ecb$var$RESIZABLE_HANDLE_CLASS + "-" + handleName).appendTo(this.$element());
        this._handles.push($handle);
    },
    _attachEventHandlers: function() {
        if (this.option("disabled")) return;
        var handlers = {};
        handlers[$d204578058d79ecb$var$DRAGSTART_START_EVENT_NAME] = this._dragStartHandler.bind(this);
        handlers[$d204578058d79ecb$var$DRAGSTART_EVENT_NAME] = this._dragHandler.bind(this);
        handlers[$d204578058d79ecb$var$DRAGSTART_END_EVENT_NAME] = this._dragEndHandler.bind(this);
        this._handles.forEach(function(handleElement) {
            $d204578058d79ecb$var$_events_engine2.default.on(handleElement, handlers, {
                direction: "both",
                immediate: true
            });
        });
    },
    _detachEventHandlers: function() {
        this._handles.forEach(function(handleElement) {
            $d204578058d79ecb$var$_events_engine2.default.off(handleElement);
        });
    },
    _toggleEventHandlers: function(shouldAttachEvents) {
        shouldAttachEvents ? this._attachEventHandlers() : this._detachEventHandlers();
    },
    _dragStartHandler: function(e) {
        var $element = this.$element();
        if ($element.is(".dx-state-disabled, .dx-state-disabled *")) {
            e.cancel = true;
            return;
        }
        this._toggleResizingClass(true);
        this._movingSides = this._getMovingSides(e);
        this._elementLocation = $d204578058d79ecb$var$_translator2.default.locate($element);
        var elementRect = (0, $1TtsA.getBoundingRect)($element.get(0));
        this._elementSize = {
            width: elementRect.width,
            height: elementRect.height
        };
        this._renderDragOffsets(e);
        this._resizeStartAction({
            event: e,
            width: this._elementSize.width,
            height: this._elementSize.height,
            handles: this._movingSides
        });
        e.targetElements = null;
    },
    _toggleResizingClass: function(value) {
        this.$element().toggleClass($d204578058d79ecb$var$RESIZABLE_RESIZING_CLASS, value);
    },
    _renderDragOffsets: function(e) {
        var area = this._getArea();
        if (!area) return;
        var $handle = (0, $d204578058d79ecb$var$_renderer2.default)(e.target).closest("." + $d204578058d79ecb$var$RESIZABLE_HANDLE_CLASS);
        var handleWidth = $handle.outerWidth();
        var handleHeight = $handle.outerHeight();
        var handleOffset = $handle.offset();
        var areaOffset = area.offset;
        var scrollOffset = this._getAreaScrollOffset();
        e.maxLeftOffset = handleOffset.left - areaOffset.left - scrollOffset.scrollX;
        e.maxRightOffset = areaOffset.left + area.width - handleOffset.left - handleWidth + scrollOffset.scrollX;
        e.maxTopOffset = handleOffset.top - areaOffset.top - scrollOffset.scrollY;
        e.maxBottomOffset = areaOffset.top + area.height - handleOffset.top - handleHeight + scrollOffset.scrollY;
    },
    _getBorderWidth: function($element, direction) {
        if ($d204578058d79ecb$var$_type2.default.isWindow($element.get(0))) return 0;
        var borderWidth = $element.css($d204578058d79ecb$var$SIDE_BORDER_WIDTH_STYLES[direction]);
        return parseInt(borderWidth) || 0;
    },
    _dragHandler: function(e) {
        var $element = this.$element();
        var sides = this._movingSides;
        var location = this._elementLocation;
        var size = this._elementSize;
        var offset = this._getOffset(e);
        var width = size.width + offset.x * (sides.left ? -1 : 1);
        var height = size.height + offset.y * (sides.top ? -1 : 1);
        if (offset.x || "strict" === this.option("stepPrecision")) this._renderWidth(width);
        if (offset.y || "strict" === this.option("stepPrecision")) this._renderHeight(height);
        var elementRect = (0, $1TtsA.getBoundingRect)($element.get(0));
        var offsetTop = offset.y - ((elementRect.height || height) - height);
        var offsetLeft = offset.x - ((elementRect.width || width) - width);
        $d204578058d79ecb$var$_translator2.default.move($element, {
            top: location.top + (sides.top ? offsetTop : 0),
            left: location.left + (sides.left ? offsetLeft : 0)
        });
        this._resizeAction({
            event: e,
            width: this.option("width") || width,
            height: this.option("height") || height,
            handles: this._movingSides
        });
        $d204578058d79ecb$var$_dom2.default.triggerResizeEvent($element);
    },
    _getOffset: function(e) {
        var offset = e.offset;
        var steps = $d204578058d79ecb$var$_common2.default.pairToObject(this.option("step"), !this.option("roundStepValue"));
        var sides = this._getMovingSides(e);
        var strictPrecision = "strict" === this.option("stepPrecision");
        if (!sides.left && !sides.right) offset.x = 0;
        if (!sides.top && !sides.bottom) offset.y = 0;
        return strictPrecision ? this._getStrictOffset(offset, steps, sides) : this._getSimpleOffset(offset, steps);
    },
    _getSimpleOffset: function(offset, steps) {
        return {
            x: offset.x - offset.x % steps.h,
            y: offset.y - offset.y % steps.v
        };
    },
    _getStrictOffset: function(offset, steps, sides) {
        var location = this._elementLocation;
        var size = this._elementSize;
        var xPos = sides.left ? location.left : location.left + size.width;
        var yPos = sides.top ? location.top : location.top + size.height;
        var newXShift = (xPos + offset.x) % steps.h;
        var newYShift = (yPos + offset.y) % steps.v;
        var sign = Math.sign || function(x) {
            x = +x;
            if (0 === x || isNaN(x)) return x;
            return x > 0 ? 1 : -1;
        };
        var separatorOffset = function(steps, offset) {
            return (1 + .2 * sign(offset)) % 1 * steps;
        };
        var isSmallOffset = function(offset, steps) {
            return Math.abs(offset) < .2 * steps;
        };
        var newOffsetX = offset.x - newXShift;
        var newOffsetY = offset.y - newYShift;
        if (newXShift > separatorOffset(steps.h, offset.x)) newOffsetX += steps.h;
        if (newYShift > separatorOffset(steps.v, offset.y)) newOffsetY += steps.v;
        return {
            x: (sides.left || sides.right) && !isSmallOffset(offset.x, steps.h) ? newOffsetX : 0,
            y: (sides.top || sides.bottom) && !isSmallOffset(offset.y, steps.v) ? newOffsetY : 0
        };
    },
    _getMovingSides: function(e) {
        var $target = (0, $d204578058d79ecb$var$_renderer2.default)(e.target);
        var hasCornerTopLeftClass = $target.hasClass($d204578058d79ecb$var$RESIZABLE_HANDLE_CORNER_CLASS + "-top-left");
        var hasCornerTopRightClass = $target.hasClass($d204578058d79ecb$var$RESIZABLE_HANDLE_CORNER_CLASS + "-top-right");
        var hasCornerBottomLeftClass = $target.hasClass($d204578058d79ecb$var$RESIZABLE_HANDLE_CORNER_CLASS + "-bottom-left");
        var hasCornerBottomRightClass = $target.hasClass($d204578058d79ecb$var$RESIZABLE_HANDLE_CORNER_CLASS + "-bottom-right");
        return {
            top: $target.hasClass($d204578058d79ecb$var$RESIZABLE_HANDLE_TOP_CLASS) || hasCornerTopLeftClass || hasCornerTopRightClass,
            left: $target.hasClass($d204578058d79ecb$var$RESIZABLE_HANDLE_LEFT_CLASS) || hasCornerTopLeftClass || hasCornerBottomLeftClass,
            bottom: $target.hasClass($d204578058d79ecb$var$RESIZABLE_HANDLE_BOTTOM_CLASS) || hasCornerBottomLeftClass || hasCornerBottomRightClass,
            right: $target.hasClass($d204578058d79ecb$var$RESIZABLE_HANDLE_RIGHT_CLASS) || hasCornerTopRightClass || hasCornerBottomRightClass
        };
    },
    _getArea: function() {
        var area = this.option("area");
        if ($d204578058d79ecb$var$isFunction(area)) area = area.call(this);
        if ($d204578058d79ecb$var$isPlainObject(area)) return this._getAreaFromObject(area);
        return this._getAreaFromElement(area);
    },
    _getAreaScrollOffset: function() {
        var area = this.option("area");
        var isElement = !$d204578058d79ecb$var$isFunction(area) && !$d204578058d79ecb$var$isPlainObject(area);
        var scrollOffset = {
            scrollY: 0,
            scrollX: 0
        };
        if (isElement) {
            var areaElement = (0, $d204578058d79ecb$var$_renderer2.default)(area)[0];
            if ($d204578058d79ecb$var$_type2.default.isWindow(areaElement)) {
                scrollOffset.scrollX = areaElement.pageXOffset;
                scrollOffset.scrollY = areaElement.pageYOffset;
            }
        }
        return scrollOffset;
    },
    _getAreaFromObject: function(area) {
        var result = {
            width: area.right - area.left,
            height: area.bottom - area.top,
            offset: {
                left: area.left,
                top: area.top
            }
        };
        this._correctAreaGeometry(result);
        return result;
    },
    _getAreaFromElement: function(area) {
        var $area = (0, $d204578058d79ecb$var$_renderer2.default)(area);
        var result;
        if ($area.length) {
            result = {
                width: $area.innerWidth(),
                height: $area.innerHeight(),
                offset: (0, $7I8Uw.extend)({
                    top: 0,
                    left: 0
                }, $d204578058d79ecb$var$_type2.default.isWindow($area[0]) ? {} : $area.offset())
            };
            this._correctAreaGeometry(result, $area);
        }
        return result;
    },
    _correctAreaGeometry: function(result, $area) {
        var areaBorderLeft = $area ? this._getBorderWidth($area, "left") : 0;
        var areaBorderTop = $area ? this._getBorderWidth($area, "top") : 0;
        result.offset.left += areaBorderLeft + this._getBorderWidth(this.$element(), "left");
        result.offset.top += areaBorderTop + this._getBorderWidth(this.$element(), "top");
        result.width -= this.$element().outerWidth() - this.$element().innerWidth();
        result.height -= this.$element().outerHeight() - this.$element().innerHeight();
    },
    _dragEndHandler: function(e) {
        var $element = this.$element();
        this._resizeEndAction({
            event: e,
            width: $element.outerWidth(),
            height: $element.outerHeight(),
            handles: this._movingSides
        });
        this._toggleResizingClass(false);
    },
    _renderWidth: function(width) {
        this.option("width", (0, $efpkH.fitIntoRange)(width, this.option("minWidth"), this.option("maxWidth")));
    },
    _renderHeight: function(height) {
        this.option("height", (0, $efpkH.fitIntoRange)(height, this.option("minHeight"), this.option("maxHeight")));
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "disabled":
                this._toggleEventHandlers(!args.value);
                this.callBase(args);
                break;
            case "handles":
                this._invalidate();
                break;
            case "minWidth":
            case "maxWidth":
                $d204578058d79ecb$var$_window2.default.hasWindow() && this._renderWidth(this.$element().outerWidth());
                break;
            case "minHeight":
            case "maxHeight":
                $d204578058d79ecb$var$_window2.default.hasWindow() && this._renderHeight(this.$element().outerHeight());
                break;
            case "onResize":
            case "onResizeStart":
            case "onResizeEnd":
                this._renderActions();
                break;
            case "area":
            case "stepPrecision":
            case "step":
            case "roundStepValue":
                break;
            default:
                this.callBase(args);
        }
    },
    _clean: function() {
        this.$element().find("." + $d204578058d79ecb$var$RESIZABLE_HANDLE_CLASS).remove();
    }
});
(0, $d204578058d79ecb$var$_component_registrator2.default)($d204578058d79ecb$var$RESIZABLE, $d204578058d79ecb$var$Resizable);
module.exports = $d204578058d79ecb$var$Resizable;
module.exports.default = module.exports;

});

parcelRegister("gN9eB", function(module, exports) {
/**
 * DevExtreme (ui/overlay/z_index.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearStack = module.exports.remove = module.exports.create = module.exports.base = void 0;

var $2Mto0 = parcelRequire("2Mto0");
var $c39862b7a8e9abd2$var$baseZIndex = 1500;
var $c39862b7a8e9abd2$var$zIndexStack = [];
var $c39862b7a8e9abd2$var$base = module.exports.base = function(ZIndex) {
    $c39862b7a8e9abd2$var$baseZIndex = (0, $2Mto0.ensureDefined)(ZIndex, $c39862b7a8e9abd2$var$baseZIndex);
    return $c39862b7a8e9abd2$var$baseZIndex;
};
var $c39862b7a8e9abd2$var$create = module.exports.create = function() {
    var baseIndex = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : $c39862b7a8e9abd2$var$baseZIndex;
    var length = $c39862b7a8e9abd2$var$zIndexStack.length;
    var index = (length ? $c39862b7a8e9abd2$var$zIndexStack[length - 1] : baseIndex) + 1;
    $c39862b7a8e9abd2$var$zIndexStack.push(index);
    return index;
};
var $c39862b7a8e9abd2$var$remove = module.exports.remove = function(zIndex) {
    var position = $c39862b7a8e9abd2$var$zIndexStack.indexOf(zIndex);
    if (position >= 0) $c39862b7a8e9abd2$var$zIndexStack.splice(position, 1);
};
var $c39862b7a8e9abd2$var$clearStack = module.exports.clearStack = function() {
    $c39862b7a8e9abd2$var$zIndexStack = [];
};

});

parcelRegister("krF3o", function(module, exports) {
/**
 * DevExtreme (ui/widget/swatch_container.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $7wA28 = parcelRequire("7wA28");
var $ee262cad08307944$var$SWATCH_CONTAINER_CLASS_PREFIX = "dx-swatch-";
var $ee262cad08307944$var$getSwatchContainer = function(element) {
    var $element = $jFnCG(element);
    var swatchContainer = $element.closest('[class^="'.concat($ee262cad08307944$var$SWATCH_CONTAINER_CLASS_PREFIX, '"], [class*=" ').concat($ee262cad08307944$var$SWATCH_CONTAINER_CLASS_PREFIX, '"]'));
    var viewport = $7wA28.value();
    if (!swatchContainer.length) return viewport;
    var swatchClassRegex = new RegExp("(\\s|^)(".concat($ee262cad08307944$var$SWATCH_CONTAINER_CLASS_PREFIX, ".*?)(\\s|$)"));
    var swatchClass = swatchContainer[0].className.match(swatchClassRegex)[2];
    var viewportSwatchContainer = viewport.children("." + swatchClass);
    if (!viewportSwatchContainer.length) viewportSwatchContainer = $jFnCG("<div>").addClass(swatchClass).appendTo(viewport);
    return viewportSwatchContainer;
};
module.exports = {
    getSwatchContainer: $ee262cad08307944$var$getSwatchContainer
};

});




parcelRegister("8xeOM", function(module, exports) {
/**
 * DevExtreme (events/gesture/swipeable.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $l8ZSv = parcelRequire("l8ZSv");

var $e1LMc = parcelRequire("e1LMc");

var $4sKC1 = parcelRequire("4sKC1");

var $4Pwuy = parcelRequire("4Pwuy");
var $636ce659aba714e7$require$each = $4Pwuy.each;

var $bXb2w = parcelRequire("bXb2w");

var $7I8Uw = parcelRequire("7I8Uw");
var $636ce659aba714e7$require$extend = $7I8Uw.extend;

var $3fgBn = parcelRequire("3fgBn");
var $636ce659aba714e7$var$DX_SWIPEABLE = "dxSwipeable";
var $636ce659aba714e7$var$SWIPEABLE_CLASS = "dx-swipeable";
var $636ce659aba714e7$var$ACTION_TO_EVENT_MAP = {
    onStart: $l8ZSv.start,
    onUpdated: $l8ZSv.swipe,
    onEnd: $l8ZSv.end,
    onCancel: "dxswipecancel"
};
var $636ce659aba714e7$var$Swipeable = $4sKC1.inherit({
    _getDefaultOptions: function() {
        return $636ce659aba714e7$require$extend(this.callBase(), {
            elastic: true,
            immediate: false,
            direction: "horizontal",
            itemSizeFunc: null,
            onStart: null,
            onUpdated: null,
            onEnd: null,
            onCancel: null
        });
    },
    _render: function() {
        this.callBase();
        this.$element().addClass($636ce659aba714e7$var$SWIPEABLE_CLASS);
        this._attachEventHandlers();
    },
    _attachEventHandlers: function() {
        this._detachEventHandlers();
        if (this.option("disabled")) return;
        var NAME = this.NAME;
        this._createEventData();
        $636ce659aba714e7$require$each($636ce659aba714e7$var$ACTION_TO_EVENT_MAP, (function(actionName, eventName) {
            var action = this._createActionByOption(actionName, {
                context: this
            });
            eventName = $bXb2w.addNamespace(eventName, NAME);
            $e1LMc.on(this.$element(), eventName, this._eventData, function(e) {
                return action({
                    event: e
                });
            });
        }).bind(this));
    },
    _createEventData: function() {
        this._eventData = {
            elastic: this.option("elastic"),
            itemSizeFunc: this.option("itemSizeFunc"),
            direction: this.option("direction"),
            immediate: this.option("immediate")
        };
    },
    _detachEventHandlers: function() {
        $e1LMc.off(this.$element(), "." + $636ce659aba714e7$var$DX_SWIPEABLE);
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "disabled":
            case "onStart":
            case "onUpdated":
            case "onEnd":
            case "onCancel":
            case "elastic":
            case "immediate":
            case "itemSizeFunc":
            case "direction":
                this._detachEventHandlers();
                this._attachEventHandlers();
                break;
            case "rtlEnabled":
                break;
            default:
                this.callBase(args);
        }
    }
});
$3fgBn.name($636ce659aba714e7$var$Swipeable, $636ce659aba714e7$var$DX_SWIPEABLE);
module.exports = $636ce659aba714e7$var$Swipeable;

});
parcelRegister("l8ZSv", function(module, exports) {

$parcel$export(module.exports, "swipe", () => $f64a5806494fce2f$export$32e668afce77959f, (v) => $f64a5806494fce2f$export$32e668afce77959f = v);
$parcel$export(module.exports, "start", () => $f64a5806494fce2f$export$b3571188c770cc5a, (v) => $f64a5806494fce2f$export$b3571188c770cc5a = v);
$parcel$export(module.exports, "end", () => $f64a5806494fce2f$export$bd5df0f255a350f8, (v) => $f64a5806494fce2f$export$bd5df0f255a350f8 = v);
/**
 * DevExtreme (events/swipe.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $f64a5806494fce2f$export$32e668afce77959f;
var $f64a5806494fce2f$export$b3571188c770cc5a;
var $f64a5806494fce2f$export$bd5df0f255a350f8;
"use strict";

var $bXb2w = parcelRequire("bXb2w");

var $dqZUs = parcelRequire("dqZUs");

var $fy5D5 = parcelRequire("fy5D5");
var $f64a5806494fce2f$var$SWIPE_START_EVENT = "dxswipestart";
var $f64a5806494fce2f$var$SWIPE_EVENT = "dxswipe";
var $f64a5806494fce2f$var$SWIPE_END_EVENT = "dxswipeend";
var $f64a5806494fce2f$var$HorizontalStrategy = {
    defaultItemSizeFunc: function() {
        return this.getElement().width();
    },
    getBounds: function() {
        return [
            this._maxLeftOffset,
            this._maxRightOffset
        ];
    },
    calcOffsetRatio: function(e) {
        var endEventData = $bXb2w.eventData(e);
        return (endEventData.x - (this._savedEventData && this._savedEventData.x || 0)) / this._itemSizeFunc().call(this, e);
    },
    isFastSwipe: function(e) {
        var endEventData = $bXb2w.eventData(e);
        return this.FAST_SWIPE_SPEED_LIMIT * Math.abs(endEventData.x - this._tickData.x) >= endEventData.time - this._tickData.time;
    }
};
var $f64a5806494fce2f$var$VerticalStrategy = {
    defaultItemSizeFunc: function() {
        return this.getElement().height();
    },
    getBounds: function() {
        return [
            this._maxTopOffset,
            this._maxBottomOffset
        ];
    },
    calcOffsetRatio: function(e) {
        var endEventData = $bXb2w.eventData(e);
        return (endEventData.y - (this._savedEventData && this._savedEventData.y || 0)) / this._itemSizeFunc().call(this, e);
    },
    isFastSwipe: function(e) {
        var endEventData = $bXb2w.eventData(e);
        return this.FAST_SWIPE_SPEED_LIMIT * Math.abs(endEventData.y - this._tickData.y) >= endEventData.time - this._tickData.time;
    }
};
var $f64a5806494fce2f$var$STRATEGIES = {
    horizontal: $f64a5806494fce2f$var$HorizontalStrategy,
    vertical: $f64a5806494fce2f$var$VerticalStrategy
};
var $f64a5806494fce2f$var$SwipeEmitter = $dqZUs.inherit({
    TICK_INTERVAL: 300,
    FAST_SWIPE_SPEED_LIMIT: 10,
    ctor: function(element) {
        this.callBase(element);
        this.direction = "horizontal";
        this.elastic = true;
    },
    _getStrategy: function() {
        return $f64a5806494fce2f$var$STRATEGIES[this.direction];
    },
    _defaultItemSizeFunc: function() {
        return this._getStrategy().defaultItemSizeFunc.call(this);
    },
    _itemSizeFunc: function() {
        return this.itemSizeFunc || this._defaultItemSizeFunc;
    },
    _init: function(e) {
        this._tickData = $bXb2w.eventData(e);
    },
    _start: function(e) {
        this._savedEventData = $bXb2w.eventData(e);
        e = this._fireEvent($f64a5806494fce2f$var$SWIPE_START_EVENT, e);
        if (!e.cancel) {
            this._maxLeftOffset = e.maxLeftOffset;
            this._maxRightOffset = e.maxRightOffset;
            this._maxTopOffset = e.maxTopOffset;
            this._maxBottomOffset = e.maxBottomOffset;
        }
    },
    _move: function(e) {
        var strategy = this._getStrategy();
        var moveEventData = $bXb2w.eventData(e);
        var offset = strategy.calcOffsetRatio.call(this, e);
        offset = this._fitOffset(offset, this.elastic);
        if (moveEventData.time - this._tickData.time > this.TICK_INTERVAL) this._tickData = moveEventData;
        this._fireEvent($f64a5806494fce2f$var$SWIPE_EVENT, e, {
            offset: offset
        });
        e.preventDefault();
    },
    _end: function(e) {
        var strategy = this._getStrategy();
        var offsetRatio = strategy.calcOffsetRatio.call(this, e);
        var isFast = strategy.isFastSwipe.call(this, e);
        var startOffset = offsetRatio;
        var targetOffset = this._calcTargetOffset(offsetRatio, isFast);
        startOffset = this._fitOffset(startOffset, this.elastic);
        targetOffset = this._fitOffset(targetOffset, false);
        this._fireEvent($f64a5806494fce2f$var$SWIPE_END_EVENT, e, {
            offset: startOffset,
            targetOffset: targetOffset
        });
    },
    _fitOffset: function(offset, elastic) {
        var strategy = this._getStrategy();
        var bounds = strategy.getBounds.call(this);
        if (offset < -bounds[0]) return elastic ? (-2 * bounds[0] + offset) / 3 : -bounds[0];
        if (offset > bounds[1]) return elastic ? (2 * bounds[1] + offset) / 3 : bounds[1];
        return offset;
    },
    _calcTargetOffset: function(offsetRatio, isFast) {
        var result;
        if (isFast) {
            result = Math.ceil(Math.abs(offsetRatio));
            if (offsetRatio < 0) result = -result;
        } else result = Math.round(offsetRatio);
        return result;
    }
});
$fy5D5({
    emitter: $f64a5806494fce2f$var$SwipeEmitter,
    events: [
        $f64a5806494fce2f$var$SWIPE_START_EVENT,
        $f64a5806494fce2f$var$SWIPE_EVENT,
        $f64a5806494fce2f$var$SWIPE_END_EVENT
    ]
});
$f64a5806494fce2f$export$32e668afce77959f = $f64a5806494fce2f$var$SWIPE_EVENT;
$f64a5806494fce2f$export$b3571188c770cc5a = $f64a5806494fce2f$var$SWIPE_START_EVENT;
$f64a5806494fce2f$export$bd5df0f255a350f8 = $f64a5806494fce2f$var$SWIPE_END_EVENT;

});


parcelRegister("aX2Yo", function(module, exports) {
/**
 * DevExtreme (ui/calendar/ui.calendar.navigator.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $7I8Uw = parcelRequire("7I8Uw");
var $7f91b877f593f744$require$extend = $7I8Uw.extend;

var $4gmvS = parcelRequire("4gmvS");

var $7KuSv = parcelRequire("7KuSv");
var $7f91b877f593f744$var$CALENDAR_NAVIGATOR_CLASS = "dx-calendar-navigator";
var $7f91b877f593f744$var$CALENDAR_NAVIGATOR_PREVIOUS_MONTH_CLASS = "dx-calendar-navigator-previous-month";
var $7f91b877f593f744$var$CALENDAR_NAVIGATOR_NEXT_MONTH_CLASS = "dx-calendar-navigator-next-month";
var $7f91b877f593f744$var$CALENDAR_NAVIGATOR_PREVIOUS_VIEW_CLASS = "dx-calendar-navigator-previous-view";
var $7f91b877f593f744$var$CALENDAR_NAVIGATOR_NEXT_VIEW_CLASS = "dx-calendar-navigator-next-view";
var $7f91b877f593f744$var$CALENDAR_NAVIGATOR_DISABLED_LINK_CLASS = "dx-calendar-disabled-navigator-link";
var $7f91b877f593f744$var$CALENDAR_NAVIGATOR_CAPTION_BUTTON_CLASS = "dx-calendar-caption-button";
var $7f91b877f593f744$var$Navigator = $4gmvS.inherit({
    _getDefaultOptions: function() {
        return $7f91b877f593f744$require$extend(this.callBase(), {
            onClick: null,
            onCaptionClick: null,
            text: ""
        });
    },
    _init: function() {
        this.callBase();
        this._initActions();
    },
    _initActions: function() {
        this._clickAction = this._createActionByOption("onClick");
        this._captionClickAction = this._createActionByOption("onCaptionClick");
    },
    _initMarkup: function() {
        this.callBase();
        this.$element().addClass($7f91b877f593f744$var$CALENDAR_NAVIGATOR_CLASS);
        this._renderButtons();
        this._renderCaption();
    },
    _renderButtons: function() {
        var that = this;
        var direction = this.option("rtlEnabled") ? -1 : 1;
        this._prevButton = this._createComponent($jFnCG("<a>"), $7KuSv, {
            focusStateEnabled: false,
            icon: "chevronleft",
            onClick: function(e) {
                that._clickAction({
                    direction: -direction,
                    event: e
                });
            },
            integrationOptions: {}
        });
        var $prevButton = this._prevButton.$element().addClass($7f91b877f593f744$var$CALENDAR_NAVIGATOR_PREVIOUS_VIEW_CLASS).addClass($7f91b877f593f744$var$CALENDAR_NAVIGATOR_PREVIOUS_MONTH_CLASS);
        this._nextButton = this._createComponent($jFnCG("<a>"), $7KuSv, {
            focusStateEnabled: false,
            icon: "chevronright",
            onClick: function(e) {
                that._clickAction({
                    direction: direction,
                    event: e
                });
            },
            integrationOptions: {}
        });
        var $nextButton = this._nextButton.$element().addClass($7f91b877f593f744$var$CALENDAR_NAVIGATOR_NEXT_VIEW_CLASS).addClass($7f91b877f593f744$var$CALENDAR_NAVIGATOR_NEXT_MONTH_CLASS);
        this._caption = this._createComponent($jFnCG("<a>").addClass($7f91b877f593f744$var$CALENDAR_NAVIGATOR_CAPTION_BUTTON_CLASS), $7KuSv, {
            focusStateEnabled: false,
            onClick: function(e) {
                that._captionClickAction({
                    event: e
                });
            },
            integrationOptions: {}
        });
        var $caption = this._caption.$element();
        this.$element().append($prevButton, $caption, $nextButton);
    },
    _renderCaption: function() {
        this._caption.option("text", this.option("text"));
    },
    toggleButton: function(buttonPrefix, value) {
        var buttonName = "_" + buttonPrefix + "Button";
        var button = this[buttonName];
        if (button) {
            button.option("disabled", value);
            button.$element().toggleClass($7f91b877f593f744$var$CALENDAR_NAVIGATOR_DISABLED_LINK_CLASS, value);
        }
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "text":
                this._renderCaption();
                break;
            default:
                this.callBase(args);
        }
    }
});
module.exports = $7f91b877f593f744$var$Navigator;

});

parcelRegister("1ysc9", function(module, exports) {
/**
 * DevExtreme (ui/calendar/ui.calendar.views.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $121ed655fcdbb0d0$var$_renderer2 = $121ed655fcdbb0d0$var$_interopRequireDefault($jFnCG);

var $7940r = parcelRequire("7940r");
var $121ed655fcdbb0d0$var$_uiCalendar2 = $121ed655fcdbb0d0$var$_interopRequireDefault($7940r);

var $2Mto0 = parcelRequire("2Mto0");

var $beWy7 = parcelRequire("beWy7");

var $7I8Uw = parcelRequire("7I8Uw");

var $jigVH = parcelRequire("jigVH");

var $PdzUL = parcelRequire("PdzUL");

var $kDRxH = parcelRequire("kDRxH");
function $121ed655fcdbb0d0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $121ed655fcdbb0d0$var$CALENDAR_OTHER_MONTH_CLASS = "dx-calendar-other-month";
var $121ed655fcdbb0d0$var$CALENDAR_OTHER_VIEW_CLASS = "dx-calendar-other-view";
var $121ed655fcdbb0d0$var$Views = {
    month: $121ed655fcdbb0d0$var$_uiCalendar2.default.inherit({
        _getViewName: function() {
            return "month";
        },
        _getDefaultOptions: function() {
            return (0, $7I8Uw.extend)(this.callBase(), {
                firstDayOfWeek: void 0,
                rowCount: 6,
                colCount: 7
            });
        },
        _renderImpl: function() {
            this.callBase();
            this._renderHeader();
        },
        _renderBody: function() {
            this.callBase();
            this._$table.find(".".concat($121ed655fcdbb0d0$var$CALENDAR_OTHER_VIEW_CLASS)).addClass($121ed655fcdbb0d0$var$CALENDAR_OTHER_MONTH_CLASS);
        },
        _renderFocusTarget: $2Mto0.noop,
        getCellAriaLabel: function(date) {
            return (0, $jigVH.format)(date, "longdate");
        },
        _renderHeader: function() {
            var $headerRow = (0, $121ed655fcdbb0d0$var$_renderer2.default)("<tr>");
            var $header = (0, $121ed655fcdbb0d0$var$_renderer2.default)("<thead>").append($headerRow);
            this._$table.prepend($header);
            for(var colIndex = 0, colCount = this.option("colCount"); colIndex < colCount; colIndex++)this._renderHeaderCell(colIndex, $headerRow);
        },
        _renderHeaderCell: function(cellIndex, $headerRow) {
            var _this$_getDayCaption = this._getDayCaption(this._getFirstDayOfWeek() + cellIndex), fullCaption = _this$_getDayCaption.full, abbrCaption = _this$_getDayCaption.abbreviated;
            var $cell = (0, $121ed655fcdbb0d0$var$_renderer2.default)("<th>").attr({
                scope: "col",
                abbr: fullCaption
            }).text(abbrCaption);
            this._appendCell($headerRow, $cell);
        },
        getNavigatorCaption: function() {
            return (0, $jigVH.format)(this.option("date"), "monthandyear");
        },
        _isTodayCell: function(cellDate) {
            var today = new Date;
            return (0, $beWy7.sameDate)(cellDate, today);
        },
        _isDateOutOfRange: function(cellDate) {
            var minDate = this.option("min");
            var maxDate = this.option("max");
            return !(0, $beWy7.dateInRange)(cellDate, minDate, maxDate, "date");
        },
        _isOtherView: function(cellDate) {
            return cellDate.getMonth() !== this.option("date").getMonth();
        },
        _getCellText: function(cellDate) {
            return (0, $jigVH.format)(cellDate, "d");
        },
        _getDayCaption: function(day) {
            var daysInWeek = this.option("colCount");
            var dayIndex = day % daysInWeek;
            return {
                full: (0, $jigVH.getDayNames)()[dayIndex],
                abbreviated: (0, $jigVH.getDayNames)("abbreviated")[dayIndex]
            };
        },
        _getFirstCellData: function() {
            var firstDay = (0, $beWy7.getFirstMonthDate)(this.option("date"));
            var firstMonthDayOffset = this._getFirstDayOfWeek() - firstDay.getDay();
            var daysInWeek = this.option("colCount");
            if (firstMonthDayOffset >= 0) firstMonthDayOffset -= daysInWeek;
            firstDay.setDate(firstDay.getDate() + firstMonthDayOffset);
            return firstDay;
        },
        _getNextCellData: function(date) {
            date = new Date(date);
            date.setDate(date.getDate() + 1);
            return date;
        },
        _getFirstDayOfWeek: function() {
            return (0, $kDRxH.isDefined)(this.option("firstDayOfWeek")) ? this.option("firstDayOfWeek") : (0, $jigVH.firstDayOfWeekIndex)();
        },
        _getCellByDate: function(date) {
            return this._$table.find("td[data-value='".concat((0, $PdzUL.serializeDate)(date, (0, $beWy7.getShortDateFormat)()), "']"));
        },
        isBoundary: function(date) {
            return (0, $beWy7.sameMonthAndYear)(date, this.option("min")) || (0, $beWy7.sameMonthAndYear)(date, this.option("max"));
        },
        _getDefaultDisabledDatesHandler: function(disabledDates) {
            return function(args) {
                var isDisabledDate = disabledDates.some(function(item) {
                    return (0, $beWy7.sameDate)(item, args.date);
                });
                if (isDisabledDate) return true;
            };
        }
    }),
    year: $121ed655fcdbb0d0$var$_uiCalendar2.default.inherit({
        _getViewName: function() {
            return "year";
        },
        _isTodayCell: function(cellDate) {
            return (0, $beWy7.sameMonthAndYear)(cellDate, new Date);
        },
        _isDateOutOfRange: function(cellDate) {
            return !(0, $beWy7.dateInRange)(cellDate, (0, $beWy7.getFirstMonthDate)(this.option("min")), (0, $beWy7.getLastMonthDate)(this.option("max")));
        },
        _isOtherView: function() {
            return false;
        },
        _getCellText: function(cellDate) {
            return (0, $jigVH.getMonthNames)("abbreviated")[cellDate.getMonth()];
        },
        _getFirstCellData: function() {
            var data = new Date(this.option("date"));
            data.setDate(1);
            data.setMonth(0);
            return data;
        },
        _getNextCellData: function(date) {
            date = new Date(date);
            date.setMonth(date.getMonth() + 1);
            return date;
        },
        _getCellByDate: function(date) {
            var foundDate = new Date(date);
            foundDate.setDate(1);
            return this._$table.find("td[data-value='".concat((0, $PdzUL.serializeDate)(foundDate, (0, $beWy7.getShortDateFormat)()), "']"));
        },
        getCellAriaLabel: function(date) {
            return (0, $jigVH.format)(date, "monthandyear");
        },
        getNavigatorCaption: function() {
            return (0, $jigVH.format)(this.option("date"), "yyyy");
        },
        isBoundary: function(date) {
            return (0, $beWy7.sameYear)(date, this.option("min")) || (0, $beWy7.sameYear)(date, this.option("max"));
        }
    }),
    decade: $121ed655fcdbb0d0$var$_uiCalendar2.default.inherit({
        _getViewName: function() {
            return "decade";
        },
        _isTodayCell: function(cellDate) {
            return (0, $beWy7.sameYear)(cellDate, new Date);
        },
        _isDateOutOfRange: function(cellDate) {
            var min = this.option("min");
            var max = this.option("max");
            return !(0, $beWy7.dateInRange)(cellDate.getFullYear(), min && min.getFullYear(), max && max.getFullYear());
        },
        _isOtherView: function(cellDate) {
            var date = new Date(cellDate);
            date.setMonth(1);
            return !(0, $beWy7.sameDecade)(date, this.option("date"));
        },
        _getCellText: function(cellDate) {
            return (0, $jigVH.format)(cellDate, "yyyy");
        },
        _getFirstCellData: function() {
            var year = (0, $beWy7.getFirstYearInDecade)(this.option("date")) - 1;
            return new Date(year, 0, 1);
        },
        _getNextCellData: function(date) {
            date = new Date(date);
            date.setFullYear(date.getFullYear() + 1);
            return date;
        },
        getNavigatorCaption: function() {
            var currentDate = this.option("date");
            var firstYearInDecade = (0, $beWy7.getFirstYearInDecade)(currentDate);
            var startDate = new Date(currentDate);
            var endDate = new Date(currentDate);
            startDate.setFullYear(firstYearInDecade);
            endDate.setFullYear(firstYearInDecade + 9);
            return (0, $jigVH.format)(startDate, "yyyy") + "-" + (0, $jigVH.format)(endDate, "yyyy");
        },
        _isValueOnCurrentView: function(currentDate, value) {
            return (0, $beWy7.sameDecade)(currentDate, value);
        },
        _getCellByDate: function(date) {
            var foundDate = new Date(date);
            foundDate.setDate(1);
            foundDate.setMonth(0);
            return this._$table.find("td[data-value='".concat((0, $PdzUL.serializeDate)(foundDate, (0, $beWy7.getShortDateFormat)()), "']"));
        },
        isBoundary: function(date) {
            return (0, $beWy7.sameDecade)(date, this.option("min")) || (0, $beWy7.sameDecade)(date, this.option("max"));
        }
    }),
    century: $121ed655fcdbb0d0$var$_uiCalendar2.default.inherit({
        _getViewName: function() {
            return "century";
        },
        _isTodayCell: function(cellDate) {
            return (0, $beWy7.sameDecade)(cellDate, new Date);
        },
        _isDateOutOfRange: function(cellDate) {
            var decade = (0, $beWy7.getFirstYearInDecade)(cellDate);
            var minDecade = (0, $beWy7.getFirstYearInDecade)(this.option("min"));
            var maxDecade = (0, $beWy7.getFirstYearInDecade)(this.option("max"));
            return !(0, $beWy7.dateInRange)(decade, minDecade, maxDecade);
        },
        _isOtherView: function(cellDate) {
            var date = new Date(cellDate);
            date.setMonth(1);
            return !(0, $beWy7.sameCentury)(date, this.option("date"));
        },
        _getCellText: function(cellDate) {
            var startDate = (0, $jigVH.format)(cellDate, "yyyy");
            var endDate = new Date(cellDate);
            endDate.setFullYear(endDate.getFullYear() + 9);
            return startDate + " - " + (0, $jigVH.format)(endDate, "yyyy");
        },
        _getFirstCellData: function() {
            var decade = (0, $beWy7.getFirstDecadeInCentury)(this.option("date")) - 10;
            return new Date(decade, 0, 1);
        },
        _getNextCellData: function(date) {
            date = new Date(date);
            date.setFullYear(date.getFullYear() + 10);
            return date;
        },
        _getCellByDate: function(date) {
            var foundDate = new Date(date);
            foundDate.setDate(1);
            foundDate.setMonth(0);
            foundDate.setFullYear((0, $beWy7.getFirstYearInDecade)(foundDate));
            return this._$table.find("td[data-value='".concat((0, $PdzUL.serializeDate)(foundDate, (0, $beWy7.getShortDateFormat)()), "']"));
        },
        getNavigatorCaption: function() {
            var currentDate = this.option("date");
            var firstDecadeInCentury = (0, $beWy7.getFirstDecadeInCentury)(currentDate);
            var startDate = new Date(currentDate);
            var endDate = new Date(currentDate);
            startDate.setFullYear(firstDecadeInCentury);
            endDate.setFullYear(firstDecadeInCentury + 99);
            return (0, $jigVH.format)(startDate, "yyyy") + "-" + (0, $jigVH.format)(endDate, "yyyy");
        },
        isBoundary: function(date) {
            return (0, $beWy7.sameCentury)(date, this.option("min")) || (0, $beWy7.sameCentury)(date, this.option("max"));
        }
    })
};
module.exports = $121ed655fcdbb0d0$var$Views;

});
parcelRegister("7940r", function(module, exports) {
/**
 * DevExtreme (ui/calendar/ui.calendar.base_view.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $533c7b38c4d2e2c5$var$_renderer2 = $533c7b38c4d2e2c5$var$_interopRequireDefault($jFnCG);

var $445Bz = parcelRequire("445Bz");
var $533c7b38c4d2e2c5$var$_dom_adapter2 = $533c7b38c4d2e2c5$var$_interopRequireDefault($445Bz);

var $e1LMc = parcelRequire("e1LMc");
var $533c7b38c4d2e2c5$var$_events_engine2 = $533c7b38c4d2e2c5$var$_interopRequireDefault($e1LMc);

var $8ulMI = parcelRequire("8ulMI");
var $533c7b38c4d2e2c5$var$_element_data2 = $533c7b38c4d2e2c5$var$_interopRequireDefault($8ulMI);

var $5OzEX = parcelRequire("5OzEX");
var $533c7b38c4d2e2c5$var$_dom2 = $533c7b38c4d2e2c5$var$_interopRequireDefault($5OzEX);

var $4gmvS = parcelRequire("4gmvS");
var $533c7b38c4d2e2c5$var$_ui2 = $533c7b38c4d2e2c5$var$_interopRequireDefault($4gmvS);

var $beWy7 = parcelRequire("beWy7");

var $7I8Uw = parcelRequire("7I8Uw");

var $2Mto0 = parcelRequire("2Mto0");

var $PdzUL = parcelRequire("PdzUL");

var $cnVbh = parcelRequire("cnVbh");

var $bXb2w = parcelRequire("bXb2w");

var $i7ZSP = parcelRequire("i7ZSP");
function $533c7b38c4d2e2c5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $533c7b38c4d2e2c5$var$abstract = $533c7b38c4d2e2c5$var$_ui2.default.abstract;
var $533c7b38c4d2e2c5$var$CALENDAR_OTHER_VIEW_CLASS = "dx-calendar-other-view";
var $533c7b38c4d2e2c5$var$CALENDAR_CELL_CLASS = "dx-calendar-cell";
var $533c7b38c4d2e2c5$var$CALENDAR_EMPTY_CELL_CLASS = "dx-calendar-empty-cell";
var $533c7b38c4d2e2c5$var$CALENDAR_TODAY_CLASS = "dx-calendar-today";
var $533c7b38c4d2e2c5$var$CALENDAR_SELECTED_DATE_CLASS = "dx-calendar-selected-date";
var $533c7b38c4d2e2c5$var$CALENDAR_CONTOURED_DATE_CLASS = "dx-calendar-contoured-date";
var $533c7b38c4d2e2c5$var$CALENDAR_DXCLICK_EVENT_NAME = (0, $bXb2w.addNamespace)($i7ZSP.name, "dxCalendar");
var $533c7b38c4d2e2c5$var$CALENDAR_DATE_VALUE_KEY = "dxDateValueKey";
var $533c7b38c4d2e2c5$var$BaseView = $533c7b38c4d2e2c5$var$_ui2.default.inherit({
    _getViewName: function() {
        return "base";
    },
    _getDefaultOptions: function() {
        return (0, $7I8Uw.extend)(this.callBase(), {
            date: new Date,
            focusStateEnabled: false,
            cellTemplate: null,
            disabledDates: null,
            onCellClick: null,
            rowCount: 3,
            colCount: 4,
            allowValueSelection: true
        });
    },
    _init: function() {
        this.callBase();
        var value = this.option("value");
        this.option("value", new Date(value));
        if (!this.option("value").valueOf()) this.option("value", new Date(0, 0, 0, 0, 0, 0));
    },
    _initMarkup: function() {
        this.callBase();
        this._renderImpl();
    },
    _renderImpl: function() {
        this.$element().append(this._createTable());
        this._createDisabledDatesHandler();
        this._renderBody();
        this._renderContouredDate();
        this._renderValue();
        this._renderEvents();
    },
    _createTable: function() {
        this._$table = (0, $533c7b38c4d2e2c5$var$_renderer2.default)("<table>");
        this.setAria({
            label: (0, $cnVbh.format)("dxCalendar-ariaWidgetName"),
            role: "grid"
        }, this._$table);
        return this._$table;
    },
    _renderBody: function() {
        this.$body = (0, $533c7b38c4d2e2c5$var$_renderer2.default)("<tbody>").appendTo(this._$table);
        var rowData = {
            cellDate: this._getFirstCellData(),
            prevCellDate: null
        };
        for(var rowIndex = 0, rowCount = this.option("rowCount"); rowIndex < rowCount; rowIndex++){
            rowData.row = this._createRow();
            for(var colIndex = 0, colCount = this.option("colCount"); colIndex < colCount; colIndex++)this._renderCell(rowData, colIndex);
        }
    },
    _createRow: function() {
        var row = $533c7b38c4d2e2c5$var$_dom_adapter2.default.createElement("tr");
        this.setAria("role", "row", (0, $533c7b38c4d2e2c5$var$_renderer2.default)(row));
        this.$body.get(0).appendChild(row);
        return row;
    },
    _appendCell: function(row, cell) {
        if (!this._appendMethodName) this._cacheAppendMethodName();
        (0, $533c7b38c4d2e2c5$var$_renderer2.default)(row)[this._appendMethodName](cell);
    },
    _cacheAppendMethodName: function(rtlEnabled) {
        this._appendMethodName = (null !== rtlEnabled && void 0 !== rtlEnabled ? rtlEnabled : this.option("rtlEnabled")) ? "prepend" : "append";
    },
    _createCell: function(cellDate) {
        var cell = $533c7b38c4d2e2c5$var$_dom_adapter2.default.createElement("td");
        var $cell = (0, $533c7b38c4d2e2c5$var$_renderer2.default)(cell);
        cell.className = this._getClassNameByDate(cellDate);
        cell.setAttribute("data-value", (0, $PdzUL.serializeDate)(cellDate, (0, $beWy7.getShortDateFormat)()));
        $533c7b38c4d2e2c5$var$_element_data2.default.data(cell, $533c7b38c4d2e2c5$var$CALENDAR_DATE_VALUE_KEY, cellDate);
        this.setAria({
            role: "gridcell",
            label: this.getCellAriaLabel(cellDate)
        }, $cell);
        return {
            cell: cell,
            $cell: $cell
        };
    },
    _renderCell: function(params, cellIndex) {
        var cellDate = params.cellDate, prevCellDate = params.prevCellDate, row = params.row;
        if (prevCellDate) (0, $beWy7.fixTimezoneGap)(prevCellDate, cellDate);
        params.prevCellDate = cellDate;
        var _this$_createCell = this._createCell(cellDate), cell = _this$_createCell.cell, $cell = _this$_createCell.$cell;
        var cellTemplate = this.option("cellTemplate");
        this._appendCell(row, cell);
        if (cellTemplate) cellTemplate.render(this._prepareCellTemplateData(cellDate, cellIndex, $cell));
        else cell.innerHTML = this._getCellText(cellDate);
        params.cellDate = this._getNextCellData(cellDate);
    },
    _getClassNameByDate: function(cellDate) {
        var className = $533c7b38c4d2e2c5$var$CALENDAR_CELL_CLASS;
        if (this._isTodayCell(cellDate)) className += " ".concat($533c7b38c4d2e2c5$var$CALENDAR_TODAY_CLASS);
        if (this._isDateOutOfRange(cellDate) || this.isDateDisabled(cellDate)) className += " ".concat($533c7b38c4d2e2c5$var$CALENDAR_EMPTY_CELL_CLASS);
        if (this._isOtherView(cellDate)) className += " ".concat($533c7b38c4d2e2c5$var$CALENDAR_OTHER_VIEW_CLASS);
        return className;
    },
    _prepareCellTemplateData: function(cellDate, cellIndex, $cell) {
        return {
            model: {
                text: this._getCellText(cellDate),
                date: cellDate,
                view: this._getViewName()
            },
            container: $533c7b38c4d2e2c5$var$_dom2.default.getPublicElement($cell),
            index: cellIndex
        };
    },
    _renderEvents: function() {
        var _this = this;
        this._createCellClickAction();
        $533c7b38c4d2e2c5$var$_events_engine2.default.off(this._$table, $533c7b38c4d2e2c5$var$CALENDAR_DXCLICK_EVENT_NAME);
        $533c7b38c4d2e2c5$var$_events_engine2.default.on(this._$table, $533c7b38c4d2e2c5$var$CALENDAR_DXCLICK_EVENT_NAME, "td", function(e) {
            if (!(0, $533c7b38c4d2e2c5$var$_renderer2.default)(e.currentTarget).hasClass($533c7b38c4d2e2c5$var$CALENDAR_EMPTY_CELL_CLASS)) _this._cellClickAction({
                event: e,
                value: (0, $533c7b38c4d2e2c5$var$_renderer2.default)(e.currentTarget).data($533c7b38c4d2e2c5$var$CALENDAR_DATE_VALUE_KEY)
            });
        });
    },
    _createCellClickAction: function() {
        this._cellClickAction = this._createActionByOption("onCellClick");
    },
    _createDisabledDatesHandler: function() {
        var disabledDates = this.option("disabledDates");
        this._disabledDatesHandler = Array.isArray(disabledDates) ? this._getDefaultDisabledDatesHandler(disabledDates) : disabledDates || $2Mto0.noop;
    },
    _getDefaultDisabledDatesHandler: function(disabledDates) {
        return $2Mto0.noop;
    },
    _isTodayCell: $533c7b38c4d2e2c5$var$abstract,
    _isDateOutOfRange: $533c7b38c4d2e2c5$var$abstract,
    isDateDisabled: function(cellDate) {
        var dateParts = {
            date: cellDate,
            view: this._getViewName()
        };
        return this._disabledDatesHandler(dateParts);
    },
    _isOtherView: $533c7b38c4d2e2c5$var$abstract,
    _getCellText: $533c7b38c4d2e2c5$var$abstract,
    _getFirstCellData: $533c7b38c4d2e2c5$var$abstract,
    _getNextCellData: $533c7b38c4d2e2c5$var$abstract,
    _renderContouredDate: function(contouredDate) {
        if (!this.option("focusStateEnabled")) return;
        contouredDate = contouredDate || this.option("contouredDate");
        var $oldContouredCell = this._$table.find(".".concat($533c7b38c4d2e2c5$var$CALENDAR_CONTOURED_DATE_CLASS));
        var $newContouredCell = this._getCellByDate(contouredDate);
        $oldContouredCell.removeClass($533c7b38c4d2e2c5$var$CALENDAR_CONTOURED_DATE_CLASS);
        $newContouredCell.addClass($533c7b38c4d2e2c5$var$CALENDAR_CONTOURED_DATE_CLASS);
    },
    _dispose: function() {
        this._keyboardProcessor = void 0;
        this.callBase();
    },
    _changeValue: function(cellDate) {
        if (cellDate) {
            var value = this.option("value");
            var newValue = value ? new Date(value) : new Date;
            newValue.setDate(cellDate.getDate());
            newValue.setMonth(cellDate.getMonth());
            newValue.setFullYear(cellDate.getFullYear());
            newValue.setDate(cellDate.getDate());
            this.option("value", newValue);
        } else this.option("value", null);
    },
    _renderValue: function() {
        if (!this.option("allowValueSelection")) return;
        var value = this.option("value");
        var selectedCell = this._getCellByDate(value);
        if (this._selectedCell) this._selectedCell.removeClass($533c7b38c4d2e2c5$var$CALENDAR_SELECTED_DATE_CLASS);
        selectedCell.addClass($533c7b38c4d2e2c5$var$CALENDAR_SELECTED_DATE_CLASS);
        this._selectedCell = selectedCell;
    },
    getCellAriaLabel: function(date) {
        return this._getCellText(date);
    },
    _getFirstAvailableDate: function() {
        var date = this.option("date");
        var min = this.option("min");
        date = (0, $beWy7.getFirstDateView)(this._getViewName(), date);
        return new Date(min && date < min ? min : date);
    },
    _getCellByDate: $533c7b38c4d2e2c5$var$abstract,
    isBoundary: $533c7b38c4d2e2c5$var$abstract,
    _optionChanged: function(args) {
        var name = args.name, value = args.value;
        switch(name){
            case "value":
                this._renderValue();
                break;
            case "contouredDate":
                this._renderContouredDate(value);
                break;
            case "onCellClick":
                this._createCellClickAction();
                break;
            case "disabledDates":
            case "cellTemplate":
                this._invalidate();
                break;
            case "rtlEnabled":
                this._cacheAppendMethodName(value);
                this.callBase(args);
                break;
            default:
                this.callBase(args);
        }
    }
});
module.exports = $533c7b38c4d2e2c5$var$BaseView;

});
parcelRegister("beWy7", function(module, exports) {
/**
 * DevExtreme (core/utils/date.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $kDRxH = parcelRequire("kDRxH");

var $efpkH = parcelRequire("efpkH");
var $82ee6b338766db62$require$adjust = $efpkH.adjust;

var $4Pwuy = parcelRequire("4Pwuy");
var $82ee6b338766db62$require$each = $4Pwuy.each;

var $ih7fv = parcelRequire("ih7fv");
var $82ee6b338766db62$require$camelize = $ih7fv.camelize;
var $82ee6b338766db62$var$isObject = $kDRxH.isObject;
var $82ee6b338766db62$var$isString = $kDRxH.isString;
var $82ee6b338766db62$var$isDate = $kDRxH.isDate;
var $82ee6b338766db62$var$isDefined = $kDRxH.isDefined;
var $82ee6b338766db62$var$dateUnitIntervals = [
    "millisecond",
    "second",
    "minute",
    "hour",
    "day",
    "week",
    "month",
    "quarter",
    "year"
];
var $82ee6b338766db62$var$toMilliseconds = function toMilliseconds(value) {
    switch(value){
        case "millisecond":
            return 1;
        case "second":
            return 1e3 * toMilliseconds("millisecond");
        case "minute":
            return 60 * toMilliseconds("second");
        case "hour":
            return 60 * toMilliseconds("minute");
        case "day":
            return 24 * toMilliseconds("hour");
        case "week":
            return 7 * toMilliseconds("day");
        case "month":
            return 30 * toMilliseconds("day");
        case "quarter":
            return 3 * toMilliseconds("month");
        case "year":
            return 365 * toMilliseconds("day");
        default:
            return 0;
    }
};
var $82ee6b338766db62$var$getDatesInterval = function(startDate, endDate, intervalUnit) {
    var delta = endDate.getTime() - startDate.getTime();
    var millisecondCount = $82ee6b338766db62$var$toMilliseconds(intervalUnit) || 1;
    return Math.floor(delta / millisecondCount);
};
var $82ee6b338766db62$var$getNextDateUnit = function(unit, withWeeks) {
    var interval = $82ee6b338766db62$var$getDateUnitInterval(unit);
    switch(interval){
        case "millisecond":
            return "second";
        case "second":
            return "minute";
        case "minute":
            return "hour";
        case "hour":
            return "day";
        case "day":
            return withWeeks ? "week" : "month";
        case "week":
            return "month";
        case "month":
            return "quarter";
        case "quarter":
            return "year";
        case "year":
            return "year";
        default:
            return 0;
    }
};
var $82ee6b338766db62$var$convertMillisecondsToDateUnits = function(value) {
    var dateUnitIntervals = [
        "millisecond",
        "second",
        "minute",
        "hour",
        "day",
        "month",
        "year"
    ];
    var result = {};
    for(var i = dateUnitIntervals.length - 1; i >= 0; i--){
        var dateUnitInterval = dateUnitIntervals[i];
        var dateUnitCount = Math.floor(value / $82ee6b338766db62$var$toMilliseconds(dateUnitInterval));
        if (dateUnitCount > 0) {
            result[dateUnitInterval + "s"] = dateUnitCount;
            value -= $82ee6b338766db62$var$convertDateUnitToMilliseconds(dateUnitInterval, dateUnitCount);
        }
    }
    return result;
};
var $82ee6b338766db62$var$dateToMilliseconds = function(tickInterval) {
    var milliseconds = 0;
    if ($82ee6b338766db62$var$isObject(tickInterval)) $82ee6b338766db62$require$each(tickInterval, function(key, value) {
        milliseconds += $82ee6b338766db62$var$convertDateUnitToMilliseconds(key.substr(0, key.length - 1), value);
    });
    if ($82ee6b338766db62$var$isString(tickInterval)) milliseconds = $82ee6b338766db62$var$convertDateUnitToMilliseconds(tickInterval, 1);
    return milliseconds;
};
var $82ee6b338766db62$var$convertDateUnitToMilliseconds = function(dateUnit, count) {
    return $82ee6b338766db62$var$toMilliseconds(dateUnit) * count;
};
var $82ee6b338766db62$var$getDateUnitInterval = function(tickInterval) {
    var maxInterval = -1;
    if ($82ee6b338766db62$var$isString(tickInterval)) return tickInterval;
    if ($82ee6b338766db62$var$isObject(tickInterval)) {
        $82ee6b338766db62$require$each(tickInterval, function(key, value) {
            for(var i = 0; i < $82ee6b338766db62$var$dateUnitIntervals.length; i++)if (value && (key === $82ee6b338766db62$var$dateUnitIntervals[i] + "s" || key === $82ee6b338766db62$var$dateUnitIntervals[i]) && maxInterval < i) maxInterval = i;
        });
        return $82ee6b338766db62$var$dateUnitIntervals[maxInterval];
    }
    return "";
};
var $82ee6b338766db62$var$tickIntervalToFormatMap = {
    millisecond: "millisecond",
    second: "longtime",
    minute: "shorttime",
    hour: "shorttime",
    day: "day",
    week: "day",
    month: "month",
    quarter: "quarter",
    year: "year"
};
function $82ee6b338766db62$var$getDateFormatByTickInterval(tickInterval) {
    return $82ee6b338766db62$var$tickIntervalToFormatMap[$82ee6b338766db62$var$getDateUnitInterval(tickInterval)] || "";
}
var $82ee6b338766db62$var$getQuarter = function(month) {
    return Math.floor(month / 3);
};
var $82ee6b338766db62$var$getFirstQuarterMonth = function(month) {
    return 3 * $82ee6b338766db62$var$getQuarter(month);
};
var $82ee6b338766db62$var$correctDateWithUnitBeginning = function(date, dateInterval, withCorrection, firstDayOfWeek) {
    date = new Date(date.getTime());
    var oldDate = new Date(date.getTime());
    var dateUnitInterval = $82ee6b338766db62$var$getDateUnitInterval(dateInterval);
    switch(dateUnitInterval){
        case "second":
            date = new Date(1e3 * Math.floor(oldDate.getTime() / 1e3));
            break;
        case "minute":
            date = new Date(6e4 * Math.floor(oldDate.getTime() / 6e4));
            break;
        case "hour":
            date = new Date(36e5 * Math.floor(oldDate.getTime() / 36e5));
            break;
        case "year":
            date.setMonth(0);
        case "month":
            date.setDate(1);
        case "day":
            date.setHours(0, 0, 0, 0);
            break;
        case "week":
            date = $82ee6b338766db62$var$getFirstWeekDate(date, firstDayOfWeek || 0);
            date.setHours(0, 0, 0, 0);
            break;
        case "quarter":
            var firstQuarterMonth = $82ee6b338766db62$var$getFirstQuarterMonth(date.getMonth());
            var month = date.getMonth();
            date.setDate(1);
            date.setHours(0, 0, 0, 0);
            if (month !== firstQuarterMonth) date.setMonth(firstQuarterMonth);
    }
    if (withCorrection && "hour" !== dateUnitInterval && "minute" !== dateUnitInterval && "second" !== dateUnitInterval) $82ee6b338766db62$var$fixTimezoneGap(oldDate, date);
    return date;
};
var $82ee6b338766db62$var$trimTime = function(date) {
    return $82ee6b338766db62$var$dateUtils.correctDateWithUnitBeginning(date, "day");
};
var $82ee6b338766db62$var$setToDayEnd = function(date) {
    var result = $82ee6b338766db62$var$dateUtils.trimTime(date);
    result.setDate(result.getDate() + 1);
    return new Date(result.getTime() - 1);
};
var $82ee6b338766db62$var$getDatesDifferences = function(date1, date2) {
    var counter = 0;
    var differences = {
        year: date1.getFullYear() !== date2.getFullYear(),
        month: date1.getMonth() !== date2.getMonth(),
        day: date1.getDate() !== date2.getDate(),
        hour: date1.getHours() !== date2.getHours(),
        minute: date1.getMinutes() !== date2.getMinutes(),
        second: date1.getSeconds() !== date2.getSeconds(),
        millisecond: date1.getMilliseconds() !== date2.getMilliseconds()
    };
    $82ee6b338766db62$require$each(differences, function(key, value) {
        if (value) counter++;
    });
    if (0 === counter && 0 !== $82ee6b338766db62$var$getTimezonesDifference(date1, date2)) {
        differences.hour = true;
        counter++;
    }
    differences.count = counter;
    return differences;
};
function $82ee6b338766db62$var$addDateInterval(value, interval, dir) {
    var result = new Date(value.getTime());
    var intervalObject = $82ee6b338766db62$var$isString(interval) ? $82ee6b338766db62$var$getDateIntervalByString(interval.toLowerCase()) : $kDRxH.isNumeric(interval) ? $82ee6b338766db62$var$convertMillisecondsToDateUnits(interval) : interval;
    if (intervalObject.years) result.setFullYear(result.getFullYear() + intervalObject.years * dir);
    if (intervalObject.quarters) result.setMonth(result.getMonth() + 3 * intervalObject.quarters * dir);
    if (intervalObject.months) result.setMonth(result.getMonth() + intervalObject.months * dir);
    if (intervalObject.weeks) result.setDate(result.getDate() + 7 * intervalObject.weeks * dir);
    if (intervalObject.days) result.setDate(result.getDate() + intervalObject.days * dir);
    if (intervalObject.hours) result.setTime(result.getTime() + 36e5 * intervalObject.hours * dir);
    if (intervalObject.minutes) result.setTime(result.getTime() + 6e4 * intervalObject.minutes * dir);
    if (intervalObject.seconds) result.setTime(result.getTime() + 1e3 * intervalObject.seconds * dir);
    if (intervalObject.milliseconds) result.setTime(result.getTime() + intervalObject.milliseconds * dir);
    return result;
}
var $82ee6b338766db62$var$addInterval = function(value, interval, isNegative) {
    var dir = isNegative ? -1 : 1;
    return $82ee6b338766db62$var$isDate(value) ? $82ee6b338766db62$var$addDateInterval(value, interval, dir) : $82ee6b338766db62$require$adjust(value + interval * dir, interval);
};
var $82ee6b338766db62$var$getSequenceByInterval = function(min, max, interval) {
    var intervals = [];
    var cur;
    intervals.push($82ee6b338766db62$var$isDate(min) ? new Date(min.getTime()) : min);
    cur = min;
    while(cur < max){
        cur = $82ee6b338766db62$var$addInterval(cur, interval);
        intervals.push(cur);
    }
    return intervals;
};
var $82ee6b338766db62$var$getViewFirstCellDate = function(viewType, date) {
    if ("month" === viewType) return new Date(date.getFullYear(), date.getMonth(), 1);
    if ("year" === viewType) return new Date(date.getFullYear(), 0, date.getDate());
    if ("decade" === viewType) return new Date($82ee6b338766db62$var$getFirstYearInDecade(date), date.getMonth(), date.getDate());
    if ("century" === viewType) return new Date($82ee6b338766db62$var$getFirstDecadeInCentury(date), date.getMonth(), date.getDate());
};
var $82ee6b338766db62$var$getViewLastCellDate = function(viewType, date) {
    if ("month" === viewType) return new Date(date.getFullYear(), date.getMonth(), $82ee6b338766db62$var$getLastMonthDay(date));
    if ("year" === viewType) return new Date(date.getFullYear(), 11, date.getDate());
    if ("decade" === viewType) return new Date($82ee6b338766db62$var$getFirstYearInDecade(date) + 9, date.getMonth(), date.getDate());
    if ("century" === viewType) return new Date($82ee6b338766db62$var$getFirstDecadeInCentury(date) + 90, date.getMonth(), date.getDate());
};
var $82ee6b338766db62$var$getViewMinBoundaryDate = function(viewType, date) {
    var resultDate = new Date(date.getFullYear(), date.getMonth(), 1);
    if ("month" === viewType) return resultDate;
    resultDate.setMonth(0);
    if ("year" === viewType) return resultDate;
    if ("decade" === viewType) resultDate.setFullYear($82ee6b338766db62$var$getFirstYearInDecade(date));
    if ("century" === viewType) resultDate.setFullYear($82ee6b338766db62$var$getFirstDecadeInCentury(date));
    return resultDate;
};
var $82ee6b338766db62$var$getViewMaxBoundaryDate = function(viewType, date) {
    var resultDate = new Date(date);
    resultDate.setDate($82ee6b338766db62$var$getLastMonthDay(date));
    if ("month" === viewType) return resultDate;
    resultDate.setMonth(11);
    resultDate.setDate($82ee6b338766db62$var$getLastMonthDay(resultDate));
    if ("year" === viewType) return resultDate;
    if ("decade" === viewType) resultDate.setFullYear($82ee6b338766db62$var$getFirstYearInDecade(date) + 9);
    if ("century" === viewType) resultDate.setFullYear($82ee6b338766db62$var$getFirstDecadeInCentury(date) + 99);
    return resultDate;
};
var $82ee6b338766db62$var$getLastMonthDay = function(date) {
    var resultDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return resultDate.getDate();
};
var $82ee6b338766db62$var$sameView = function(view, date1, date2) {
    return $82ee6b338766db62$var$dateUtils[$82ee6b338766db62$require$camelize("same " + view)](date1, date2);
};
var $82ee6b338766db62$var$getViewUp = function(typeView) {
    switch(typeView){
        case "month":
            return "year";
        case "year":
            return "decade";
        case "decade":
            return "century";
    }
};
var $82ee6b338766db62$var$getViewDown = function(typeView) {
    switch(typeView){
        case "century":
            return "decade";
        case "decade":
            return "year";
        case "year":
            return "month";
    }
};
var $82ee6b338766db62$var$getDifferenceInMonth = function(typeView) {
    var difference = 1;
    if ("year" === typeView) difference = 12;
    if ("decade" === typeView) difference = 120;
    if ("century" === typeView) difference = 1200;
    return difference;
};
var $82ee6b338766db62$var$getDifferenceInMonthForCells = function(typeView) {
    var difference = 1;
    if ("decade" === typeView) difference = 12;
    if ("century" === typeView) difference = 120;
    return difference;
};
var $82ee6b338766db62$var$getDateIntervalByString = function(intervalString) {
    var result = {};
    switch(intervalString){
        case "year":
            result.years = 1;
            break;
        case "month":
            result.months = 1;
            break;
        case "quarter":
            result.months = 3;
            break;
        case "week":
            result.weeks = 1;
            break;
        case "day":
            result.days = 1;
            break;
        case "hour":
            result.hours = 1;
            break;
        case "minute":
            result.minutes = 1;
            break;
        case "second":
            result.seconds = 1;
            break;
        case "millisecond":
            result.milliseconds = 1;
    }
    return result;
};
var $82ee6b338766db62$var$sameDate = function(date1, date2) {
    return $82ee6b338766db62$var$sameMonthAndYear(date1, date2) && date1.getDate() === date2.getDate();
};
var $82ee6b338766db62$var$sameMonthAndYear = function(date1, date2) {
    return $82ee6b338766db62$var$sameYear(date1, date2) && date1.getMonth() === date2.getMonth();
};
var $82ee6b338766db62$var$sameYear = function(date1, date2) {
    return date1 && date2 && date1.getFullYear() === date2.getFullYear();
};
var $82ee6b338766db62$var$sameDecade = function(date1, date2) {
    if (!$82ee6b338766db62$var$isDefined(date1) || !$82ee6b338766db62$var$isDefined(date2)) return;
    var startDecadeDate1 = date1.getFullYear() - date1.getFullYear() % 10;
    var startDecadeDate2 = date2.getFullYear() - date2.getFullYear() % 10;
    return date1 && date2 && startDecadeDate1 === startDecadeDate2;
};
var $82ee6b338766db62$var$sameCentury = function(date1, date2) {
    if (!$82ee6b338766db62$var$isDefined(date1) || !$82ee6b338766db62$var$isDefined(date2)) return;
    var startCenturyDate1 = date1.getFullYear() - date1.getFullYear() % 100;
    var startCenturyDate2 = date2.getFullYear() - date2.getFullYear() % 100;
    return date1 && date2 && startCenturyDate1 === startCenturyDate2;
};
var $82ee6b338766db62$var$getFirstDecadeInCentury = function(date) {
    return date && date.getFullYear() - date.getFullYear() % 100;
};
var $82ee6b338766db62$var$getFirstYearInDecade = function(date) {
    return date && date.getFullYear() - date.getFullYear() % 10;
};
var $82ee6b338766db62$var$getShortDateFormat = function() {
    return "yyyy/MM/dd";
};
var $82ee6b338766db62$var$getFirstMonthDate = function(date) {
    if (!$82ee6b338766db62$var$isDefined(date)) return;
    var newDate = new Date(date.getFullYear(), date.getMonth(), 1);
    return newDate;
};
var $82ee6b338766db62$var$getLastMonthDate = function(date) {
    if (!$82ee6b338766db62$var$isDefined(date)) return;
    var newDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    return newDate;
};
var $82ee6b338766db62$var$getFirstWeekDate = function(date, firstDayOfWeek) {
    var delta = (date.getDay() - firstDayOfWeek + 7) % 7;
    var result = new Date(date);
    result.setDate(date.getDate() - delta);
    return result;
};
var $82ee6b338766db62$var$normalizeDateByWeek = function(date, currentDate) {
    var differenceInDays = $82ee6b338766db62$var$dateUtils.getDatesInterval(date, currentDate, "day");
    var resultDate = new Date(date);
    if (differenceInDays >= 6) resultDate = new Date(resultDate.setDate(resultDate.getDate() + 7));
    return resultDate;
};
var $82ee6b338766db62$var$dateInRange = function(date, min, max, format) {
    if ("date" === format) {
        min = min && $82ee6b338766db62$var$dateUtils.correctDateWithUnitBeginning(min, "day");
        max = max && $82ee6b338766db62$var$dateUtils.correctDateWithUnitBeginning(max, "day");
        date = date && $82ee6b338766db62$var$dateUtils.correctDateWithUnitBeginning(date, "day");
    }
    return $82ee6b338766db62$var$normalizeDate(date, min, max) === date;
};
var $82ee6b338766db62$var$dateTimeFromDecimal = function(number) {
    var hours = Math.floor(number);
    var minutes = number % 1 * 60;
    return {
        hours: hours,
        minutes: minutes
    };
};
var $82ee6b338766db62$var$roundDateByStartDayHour = function(date, startDayHour) {
    var startTime = this.dateTimeFromDecimal(startDayHour);
    var result = new Date(date);
    if (date.getHours() === startTime.hours && date.getMinutes() < startTime.minutes || date.getHours() < startTime.hours) result.setHours(startTime.hours, startTime.minutes, 0, 0);
    return result;
};
var $82ee6b338766db62$var$normalizeDate = function(date, min, max) {
    var normalizedDate = date;
    if (!$82ee6b338766db62$var$isDefined(date)) return date;
    if ($82ee6b338766db62$var$isDefined(min) && date < min) normalizedDate = min;
    if ($82ee6b338766db62$var$isDefined(max) && date > max) normalizedDate = max;
    return normalizedDate;
};
var $82ee6b338766db62$var$fixTimezoneGap = function(oldDate, newDate) {
    if (!$82ee6b338766db62$var$isDefined(oldDate)) return;
    var diff = newDate.getHours() - oldDate.getHours();
    if (0 === diff) return;
    var sign = 1 === diff || diff === -23 ? -1 : 1;
    var trial = new Date(newDate.getTime() + 36e5 * sign);
    if (sign > 0 || trial.getDate() === newDate.getDate()) newDate.setTime(trial.getTime());
};
var $82ee6b338766db62$var$roundToHour = function(date) {
    date.setHours(date.getHours() + 1);
    date.setMinutes(0);
    return date;
};
var $82ee6b338766db62$var$getTimezonesDifference = function(min, max) {
    return 60 * (max.getTimezoneOffset() - min.getTimezoneOffset()) * 1e3;
};
var $82ee6b338766db62$var$makeDate = function(date) {
    return new Date(date);
};
var $82ee6b338766db62$var$getDatesOfInterval = function(startDate, endDate, step) {
    var result = [];
    var currentDate = new Date(startDate.getTime());
    if (startDate.getTime() === endDate.getTime()) result.push(new Date(startDate.getTime()));
    while(currentDate < endDate){
        result.push(new Date(currentDate.getTime()));
        currentDate = this.addInterval(currentDate, step);
    }
    return result;
};
var $82ee6b338766db62$var$dateUtils = {
    dateUnitIntervals: $82ee6b338766db62$var$dateUnitIntervals,
    convertMillisecondsToDateUnits: $82ee6b338766db62$var$convertMillisecondsToDateUnits,
    dateToMilliseconds: $82ee6b338766db62$var$dateToMilliseconds,
    getNextDateUnit: $82ee6b338766db62$var$getNextDateUnit,
    convertDateUnitToMilliseconds: $82ee6b338766db62$var$convertDateUnitToMilliseconds,
    getDateUnitInterval: $82ee6b338766db62$var$getDateUnitInterval,
    getDateFormatByTickInterval: $82ee6b338766db62$var$getDateFormatByTickInterval,
    getDatesDifferences: $82ee6b338766db62$var$getDatesDifferences,
    correctDateWithUnitBeginning: $82ee6b338766db62$var$correctDateWithUnitBeginning,
    trimTime: $82ee6b338766db62$var$trimTime,
    setToDayEnd: $82ee6b338766db62$var$setToDayEnd,
    roundDateByStartDayHour: $82ee6b338766db62$var$roundDateByStartDayHour,
    dateTimeFromDecimal: $82ee6b338766db62$var$dateTimeFromDecimal,
    addDateInterval: $82ee6b338766db62$var$addDateInterval,
    addInterval: $82ee6b338766db62$var$addInterval,
    getSequenceByInterval: $82ee6b338766db62$var$getSequenceByInterval,
    getDateIntervalByString: $82ee6b338766db62$var$getDateIntervalByString,
    sameDate: $82ee6b338766db62$var$sameDate,
    sameMonthAndYear: $82ee6b338766db62$var$sameMonthAndYear,
    sameMonth: $82ee6b338766db62$var$sameMonthAndYear,
    sameYear: $82ee6b338766db62$var$sameYear,
    sameDecade: $82ee6b338766db62$var$sameDecade,
    sameCentury: $82ee6b338766db62$var$sameCentury,
    sameView: $82ee6b338766db62$var$sameView,
    getDifferenceInMonth: $82ee6b338766db62$var$getDifferenceInMonth,
    getDifferenceInMonthForCells: $82ee6b338766db62$var$getDifferenceInMonthForCells,
    getFirstYearInDecade: $82ee6b338766db62$var$getFirstYearInDecade,
    getFirstDecadeInCentury: $82ee6b338766db62$var$getFirstDecadeInCentury,
    getShortDateFormat: $82ee6b338766db62$var$getShortDateFormat,
    getViewFirstCellDate: $82ee6b338766db62$var$getViewFirstCellDate,
    getViewLastCellDate: $82ee6b338766db62$var$getViewLastCellDate,
    getViewDown: $82ee6b338766db62$var$getViewDown,
    getViewUp: $82ee6b338766db62$var$getViewUp,
    getLastMonthDay: $82ee6b338766db62$var$getLastMonthDay,
    getLastMonthDate: $82ee6b338766db62$var$getLastMonthDate,
    getFirstMonthDate: $82ee6b338766db62$var$getFirstMonthDate,
    getFirstWeekDate: $82ee6b338766db62$var$getFirstWeekDate,
    normalizeDateByWeek: $82ee6b338766db62$var$normalizeDateByWeek,
    getQuarter: $82ee6b338766db62$var$getQuarter,
    getFirstQuarterMonth: $82ee6b338766db62$var$getFirstQuarterMonth,
    dateInRange: $82ee6b338766db62$var$dateInRange,
    roundToHour: $82ee6b338766db62$var$roundToHour,
    normalizeDate: $82ee6b338766db62$var$normalizeDate,
    getViewMinBoundaryDate: $82ee6b338766db62$var$getViewMinBoundaryDate,
    getViewMaxBoundaryDate: $82ee6b338766db62$var$getViewMaxBoundaryDate,
    fixTimezoneGap: $82ee6b338766db62$var$fixTimezoneGap,
    getTimezonesDifference: $82ee6b338766db62$var$getTimezonesDifference,
    makeDate: $82ee6b338766db62$var$makeDate,
    getDatesInterval: $82ee6b338766db62$var$getDatesInterval,
    getDatesOfInterval: $82ee6b338766db62$var$getDatesOfInterval
};
module.exports = $82ee6b338766db62$var$dateUtils;

});

parcelRegister("PdzUL", function(module, exports) {
/**
 * DevExtreme (core/utils/date_serialization.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $1JvXr = parcelRequire("1JvXr");

var $3FzdI = parcelRequire("3FzdI");
var $099f4be56db254c5$require$getLDMLFormatter = $3FzdI.getFormatter;

var $9D9Bh = parcelRequire("9D9Bh");

var $kDRxH = parcelRequire("kDRxH");
var $099f4be56db254c5$var$isString = $kDRxH.isString;
var $099f4be56db254c5$var$isDate = $kDRxH.isDate;
var $099f4be56db254c5$var$isNumber = $kDRxH.isNumeric;
var $099f4be56db254c5$var$NUMBER_SERIALIZATION_FORMAT = "number";
var $099f4be56db254c5$var$DATE_SERIALIZATION_FORMAT = "yyyy/MM/dd";
var $099f4be56db254c5$var$DATETIME_SERIALIZATION_FORMAT = "yyyy/MM/dd HH:mm:ss";
var $099f4be56db254c5$var$ISO8601_PATTERN = /^(\d{4,})(-)?(\d{2})(-)?(\d{2})(?:T(\d{2})(:)?(\d{2})?(:)?(\d{2}(?:\.(\d{1,3})\d*)?)?)?(Z|([+-])(\d{2})(:)?(\d{2})?)?$/;
var $099f4be56db254c5$var$ISO8601_TIME_PATTERN = /^(\d{2}):(\d{2})(:(\d{2}))?$/;
var $099f4be56db254c5$var$ISO8601_PATTERN_PARTS = [
    "",
    "yyyy",
    "",
    "MM",
    "",
    "dd",
    "THH",
    "",
    "mm",
    "",
    "ss",
    ".SSS"
];
var $099f4be56db254c5$var$MILLISECOND_LENGHT = 3;
var $099f4be56db254c5$var$dateParser = function(text, skipISO8601Parsing) {
    var result;
    var parsedValue;
    if ($099f4be56db254c5$var$isString(text) && !skipISO8601Parsing) result = $099f4be56db254c5$var$parseISO8601String(text);
    if (!result) {
        parsedValue = !$099f4be56db254c5$var$isDate(text) && Date.parse(text);
        result = $099f4be56db254c5$var$isNumber(parsedValue) ? new Date(parsedValue) : text;
    }
    return result;
};
var $099f4be56db254c5$var$parseISO8601String = function(text) {
    var parts = text.match($099f4be56db254c5$var$ISO8601_PATTERN);
    var timePart = function(part) {
        return +part || 0;
    };
    if (!parts) {
        parts = text.match($099f4be56db254c5$var$ISO8601_TIME_PATTERN);
        if (parts) return new Date(0, 0, 0, timePart(parts[1]), timePart(parts[2]), timePart(parts[4]));
        return;
    }
    var year = parts[1];
    var month = --parts[3];
    var day = parts[5];
    var timeZoneHour = 0;
    var timeZoneMinute = 0;
    timeZoneHour = timePart(parts[14]);
    timeZoneMinute = timePart(parts[16]);
    if ("-" === parts[13]) {
        timeZoneHour = -timeZoneHour;
        timeZoneMinute = -timeZoneMinute;
    }
    var hour = timePart(parts[6]) - timeZoneHour;
    var minute = timePart(parts[8]) - timeZoneMinute;
    var second = timePart(parts[10]);
    var parseMilliseconds = function(part) {
        part = part || "";
        return timePart(part) * Math.pow(10, $099f4be56db254c5$var$MILLISECOND_LENGHT - part.length);
    };
    var millisecond = parseMilliseconds(parts[11]);
    if (parts[12]) return new Date(Date.UTC(year, month, day, hour, minute, second, millisecond));
    return new Date(year, month, day, hour, minute, second, millisecond);
};
var $099f4be56db254c5$var$getIso8601Format = function(text, useUtc) {
    var parts = text.match($099f4be56db254c5$var$ISO8601_PATTERN);
    var result = "";
    if (!parts) {
        parts = text.match($099f4be56db254c5$var$ISO8601_TIME_PATTERN);
        if (parts) return parts[3] ? "HH:mm:ss" : "HH:mm";
        return;
    }
    for(var i = 1; i < $099f4be56db254c5$var$ISO8601_PATTERN_PARTS.length; i++)if (parts[i]) result += $099f4be56db254c5$var$ISO8601_PATTERN_PARTS[i] || parts[i];
    if ("Z" === parts[12]) result += "'Z'";
    if (parts[14]) {
        if (parts[15]) result += "xxx";
        else if (parts[16]) result += "xx";
        else result += "x";
    }
    return result;
};
var $099f4be56db254c5$var$deserializeDate = function(value) {
    if ("number" === typeof value) return new Date(value);
    return $099f4be56db254c5$var$dateParser(value, !$1JvXr().forceIsoDateParsing);
};
var $099f4be56db254c5$var$serializeDate = function(value, serializationFormat) {
    if (!serializationFormat) return value;
    if (!$099f4be56db254c5$var$isDate(value)) return null;
    if (serializationFormat === $099f4be56db254c5$var$NUMBER_SERIALIZATION_FORMAT) return value && value.valueOf ? value.valueOf() : null;
    return $099f4be56db254c5$require$getLDMLFormatter(serializationFormat, $9D9Bh)(value);
};
var $099f4be56db254c5$var$getDateSerializationFormat = function(value) {
    if ("number" === typeof value) return $099f4be56db254c5$var$NUMBER_SERIALIZATION_FORMAT;
    else if ($099f4be56db254c5$var$isString(value)) {
        var format;
        if ($1JvXr().forceIsoDateParsing) format = $099f4be56db254c5$var$getIso8601Format(value);
        if (format) return format;
        else {
            if (value.indexOf(":") >= 0) return $099f4be56db254c5$var$DATETIME_SERIALIZATION_FORMAT;
            else return $099f4be56db254c5$var$DATE_SERIALIZATION_FORMAT;
        }
    } else {
        if (value) return null;
    }
};
module.exports = {
    dateParser: $099f4be56db254c5$var$dateParser,
    deserializeDate: $099f4be56db254c5$var$deserializeDate,
    serializeDate: $099f4be56db254c5$var$serializeDate,
    getDateSerializationFormat: $099f4be56db254c5$var$getDateSerializationFormat
};

});
parcelRegister("3FzdI", function(module, exports) {

$parcel$export(module.exports, "getFormatter", () => $2ac0856b3b51893e$export$a7f9565e3c81cd54, (v) => $2ac0856b3b51893e$export$a7f9565e3c81cd54 = v);
/**
 * DevExtreme (localization/ldml/date.formatter.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $2ac0856b3b51893e$export$a7f9565e3c81cd54;
"use strict";
function $2ac0856b3b51893e$var$leftPad(text, length) {
    while(text.length < length)text = "0" + text;
    return text;
}
var $2ac0856b3b51893e$var$FORMAT_TYPES = {
    3: "abbreviated",
    4: "wide",
    5: "narrow"
};
var $2ac0856b3b51893e$var$LDML_FORMATTERS = {
    y: function(date, count, useUtc) {
        var year = date[useUtc ? "getUTCFullYear" : "getFullYear"]();
        if (2 === count) year %= 100;
        return $2ac0856b3b51893e$var$leftPad(year.toString(), count);
    },
    M: function(date, count, useUtc, dateParts) {
        var month = date[useUtc ? "getUTCMonth" : "getMonth"]();
        var formatType = $2ac0856b3b51893e$var$FORMAT_TYPES[count];
        if (formatType) return dateParts.getMonthNames(formatType, "format")[month];
        return $2ac0856b3b51893e$var$leftPad((month + 1).toString(), Math.min(count, 2));
    },
    L: function(date, count, useUtc, dateParts) {
        var month = date[useUtc ? "getUTCMonth" : "getMonth"]();
        var formatType = $2ac0856b3b51893e$var$FORMAT_TYPES[count];
        if (formatType) return dateParts.getMonthNames(formatType, "standalone")[month];
        return $2ac0856b3b51893e$var$leftPad((month + 1).toString(), Math.min(count, 2));
    },
    Q: function(date, count, useUtc, dateParts) {
        var month = date[useUtc ? "getUTCMonth" : "getMonth"]();
        var quarter = Math.floor(month / 3);
        var formatType = $2ac0856b3b51893e$var$FORMAT_TYPES[count];
        if (formatType) return dateParts.getQuarterNames(formatType)[quarter];
        return $2ac0856b3b51893e$var$leftPad((quarter + 1).toString(), Math.min(count, 2));
    },
    E: function(date, count, useUtc, dateParts) {
        var day = date[useUtc ? "getUTCDay" : "getDay"]();
        var formatType = $2ac0856b3b51893e$var$FORMAT_TYPES[count < 3 ? 3 : count];
        return dateParts.getDayNames(formatType)[day];
    },
    a: function(date, count, useUtc, dateParts) {
        var hours = date[useUtc ? "getUTCHours" : "getHours"]();
        var period = hours < 12 ? 0 : 1;
        var formatType = $2ac0856b3b51893e$var$FORMAT_TYPES[count];
        return dateParts.getPeriodNames(formatType)[period];
    },
    d: function(date, count, useUtc) {
        return $2ac0856b3b51893e$var$leftPad(date[useUtc ? "getUTCDate" : "getDate"]().toString(), Math.min(count, 2));
    },
    H: function(date, count, useUtc) {
        return $2ac0856b3b51893e$var$leftPad(date[useUtc ? "getUTCHours" : "getHours"]().toString(), Math.min(count, 2));
    },
    h: function(date, count, useUtc) {
        var hours = date[useUtc ? "getUTCHours" : "getHours"]();
        return $2ac0856b3b51893e$var$leftPad((hours % 12 || 12).toString(), Math.min(count, 2));
    },
    m: function(date, count, useUtc) {
        return $2ac0856b3b51893e$var$leftPad(date[useUtc ? "getUTCMinutes" : "getMinutes"]().toString(), Math.min(count, 2));
    },
    s: function(date, count, useUtc) {
        return $2ac0856b3b51893e$var$leftPad(date[useUtc ? "getUTCSeconds" : "getSeconds"]().toString(), Math.min(count, 2));
    },
    S: function(date, count, useUtc) {
        return $2ac0856b3b51893e$var$leftPad(date[useUtc ? "getUTCMilliseconds" : "getMilliseconds"]().toString(), 3).substr(0, count);
    },
    x: function(date, count, useUtc) {
        var timezoneOffset = useUtc ? 0 : date.getTimezoneOffset();
        var signPart = timezoneOffset > 0 ? "-" : "+";
        var timezoneOffsetAbs = Math.abs(timezoneOffset);
        var hours = Math.floor(timezoneOffsetAbs / 60);
        var minutes = timezoneOffsetAbs % 60;
        var hoursPart = $2ac0856b3b51893e$var$leftPad(hours.toString(), 2);
        var minutesPart = $2ac0856b3b51893e$var$leftPad(minutes.toString(), 2);
        return signPart + hoursPart + (count >= 3 ? ":" : "") + (count > 1 || minutes ? minutesPart : "");
    },
    X: function(date, count, useUtc) {
        if (useUtc || !date.getTimezoneOffset()) return "Z";
        return $2ac0856b3b51893e$var$LDML_FORMATTERS.x(date, count, useUtc);
    },
    Z: function(date, count, useUtc) {
        return $2ac0856b3b51893e$var$LDML_FORMATTERS.X(date, count >= 5 ? 3 : 2, useUtc);
    }
};
var $2ac0856b3b51893e$var$getFormatter = function(format, dateParts) {
    return function(date) {
        var charIndex;
        var formatter;
        var char;
        var charCount = 0;
        var separator = "'";
        var isEscaping = false;
        var isCurrentCharEqualsNext;
        var result = "";
        if (!date) return null;
        if (!format) return date;
        var useUtc = "Z" === format[format.length - 1] || "'Z'" === format.slice(-3);
        for(charIndex = 0; charIndex < format.length; charIndex++){
            char = format[charIndex];
            formatter = $2ac0856b3b51893e$var$LDML_FORMATTERS[char];
            isCurrentCharEqualsNext = char === format[charIndex + 1];
            charCount++;
            if (!isCurrentCharEqualsNext) {
                if (formatter && !isEscaping) result += formatter(date, charCount, useUtc, dateParts);
                charCount = 0;
            }
            if (char === separator && !isCurrentCharEqualsNext) isEscaping = !isEscaping;
            else if (isEscaping || !formatter) result += char;
            if (char === separator && isCurrentCharEqualsNext) charIndex++;
        }
        return result;
    };
};
$2ac0856b3b51893e$export$a7f9565e3c81cd54 = $2ac0856b3b51893e$var$getFormatter;

});

parcelRegister("9D9Bh", function(module, exports) {
/**
 * DevExtreme (localization/default_date_names.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $4Pwuy = parcelRequire("4Pwuy");
var $702f33f80babcb76$var$_iterator2 = $702f33f80babcb76$var$_interopRequireDefault($4Pwuy);
function $702f33f80babcb76$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $702f33f80babcb76$var$MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $702f33f80babcb76$var$DAYS = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
];
var $702f33f80babcb76$var$PERIODS = [
    "AM",
    "PM"
];
var $702f33f80babcb76$var$QUARTERS = [
    "Q1",
    "Q2",
    "Q3",
    "Q4"
];
var $702f33f80babcb76$var$cutCaptions = function(captions, format) {
    var lengthByFormat = {
        abbreviated: 3,
        "short": 2,
        narrow: 1
    };
    return $702f33f80babcb76$var$_iterator2.default.map(captions, function(caption) {
        return caption.substr(0, lengthByFormat[format]);
    });
};
module.exports = {
    getMonthNames: function(format) {
        return $702f33f80babcb76$var$cutCaptions($702f33f80babcb76$var$MONTHS, format);
    },
    getDayNames: function(format) {
        return $702f33f80babcb76$var$cutCaptions($702f33f80babcb76$var$DAYS, format);
    },
    getQuarterNames: function(format) {
        return $702f33f80babcb76$var$QUARTERS;
    },
    getPeriodNames: function(format) {
        return $702f33f80babcb76$var$PERIODS;
    }
};

});



parcelRegister("jigVH", function(module, exports) {
/**
 * DevExtreme (localization/date.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $6LNcw = parcelRequire("6LNcw");
var $e0bcd49df8995938$var$_dependency_injector2 = $e0bcd49df8995938$var$_interopRequireDefault($6LNcw);

var $kDRxH = parcelRequire("kDRxH");

var $4Pwuy = parcelRequire("4Pwuy");
var $e0bcd49df8995938$var$_iterator2 = $e0bcd49df8995938$var$_interopRequireDefault($4Pwuy);

var $aLQK5 = parcelRequire("aLQK5");

var $7sX7V = parcelRequire("7sX7V");
var $e0bcd49df8995938$var$_errors2 = $e0bcd49df8995938$var$_interopRequireDefault($7sX7V);

var $3FzdI = parcelRequire("3FzdI");

var $5xOPe = parcelRequire("5xOPe");

var $giGZB = parcelRequire("giGZB");

var $9D9Bh = parcelRequire("9D9Bh");
var $e0bcd49df8995938$var$_default_date_names2 = $e0bcd49df8995938$var$_interopRequireDefault($9D9Bh);

var $l3Vxg = parcelRequire("l3Vxg");
var $e0bcd49df8995938$var$_first_day_of_week_data2 = $e0bcd49df8995938$var$_interopRequireDefault($l3Vxg);

var $gCA0F = parcelRequire("gCA0F");

var $9dtyI = parcelRequire("9dtyI");
var $e0bcd49df8995938$var$_number2 = $e0bcd49df8995938$var$_interopRequireDefault($9dtyI);

var $5EfEA = parcelRequire("5EfEA");
var $e0bcd49df8995938$var$_date5 = $e0bcd49df8995938$var$_interopRequireDefault($5EfEA);
function $e0bcd49df8995938$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $e0bcd49df8995938$var$DEFAULT_DAY_OF_WEEK_INDEX = 0;
var $e0bcd49df8995938$var$hasIntl = "undefined" !== typeof Intl;
var $e0bcd49df8995938$var$FORMATS_TO_PATTERN_MAP = {
    shortdate: "M/d/y",
    shorttime: "h:mm a",
    longdate: "EEEE, MMMM d, y",
    longtime: "h:mm:ss a",
    monthandday: "MMMM d",
    monthandyear: "MMMM y",
    quarterandyear: "QQQ y",
    day: "d",
    year: "y",
    shortdateshorttime: "M/d/y, h:mm a",
    longdatelongtime: "EEEE, MMMM d, y, h:mm:ss a",
    month: "LLLL",
    shortyear: "yy",
    dayofweek: "EEEE",
    quarter: "QQQ",
    hour: "HH",
    minute: "mm",
    second: "ss",
    millisecond: "SSS",
    "datetime-local": "yyyy-MM-ddTHH':'mm':'ss"
};
var $e0bcd49df8995938$var$possiblePartPatterns = {
    year: [
        "y",
        "yy",
        "yyyy"
    ],
    day: [
        "d",
        "dd"
    ],
    month: [
        "M",
        "MM",
        "MMM",
        "MMMM"
    ],
    hours: [
        "H",
        "HH",
        "h",
        "hh",
        "ah"
    ],
    minutes: [
        "m",
        "mm"
    ],
    seconds: [
        "s",
        "ss"
    ],
    milliseconds: [
        "S",
        "SS",
        "SSS"
    ]
};
var $e0bcd49df8995938$var$dateLocalization = (0, $e0bcd49df8995938$var$_dependency_injector2.default)({
    engine: function() {
        return "base";
    },
    _getPatternByFormat: function(format) {
        return $e0bcd49df8995938$var$FORMATS_TO_PATTERN_MAP[format.toLowerCase()];
    },
    _expandPattern: function(pattern) {
        return this._getPatternByFormat(pattern) || pattern;
    },
    formatUsesMonthName: function(format) {
        return this._expandPattern(format).indexOf("MMMM") !== -1;
    },
    formatUsesDayName: function(format) {
        return this._expandPattern(format).indexOf("EEEE") !== -1;
    },
    getFormatParts: function(format) {
        var pattern = this._getPatternByFormat(format) || format;
        var result = [];
        $e0bcd49df8995938$var$_iterator2.default.each(pattern.split(/\W+/), function(_, formatPart) {
            $e0bcd49df8995938$var$_iterator2.default.each($e0bcd49df8995938$var$possiblePartPatterns, function(partName, possiblePatterns) {
                if ((0, $aLQK5.inArray)(formatPart, possiblePatterns) > -1) result.push(partName);
            });
        });
        return result;
    },
    getMonthNames: function(format) {
        return $e0bcd49df8995938$var$_default_date_names2.default.getMonthNames(format);
    },
    getDayNames: function(format) {
        return $e0bcd49df8995938$var$_default_date_names2.default.getDayNames(format);
    },
    getQuarterNames: function(format) {
        return $e0bcd49df8995938$var$_default_date_names2.default.getQuarterNames(format);
    },
    getPeriodNames: function(format) {
        return $e0bcd49df8995938$var$_default_date_names2.default.getPeriodNames(format);
    },
    getTimeSeparator: function() {
        return ":";
    },
    is24HourFormat: function(format) {
        var amTime = new Date(2017, 0, 20, 11, 0, 0, 0);
        var pmTime = new Date(2017, 0, 20, 23, 0, 0, 0);
        var amTimeFormatted = this.format(amTime, format);
        var pmTimeFormatted = this.format(pmTime, format);
        for(var i = 0; i < amTimeFormatted.length; i++){
            if (amTimeFormatted[i] !== pmTimeFormatted[i]) return !isNaN(parseInt(amTimeFormatted[i]));
        }
    },
    format: function(date, _format) {
        if (!date) return;
        if (!_format) return date;
        var formatter;
        if ("function" === typeof _format) formatter = _format;
        else if (_format.formatter) formatter = _format.formatter;
        else {
            _format = _format.type || _format;
            if ((0, $kDRxH.isString)(_format)) {
                _format = $e0bcd49df8995938$var$FORMATS_TO_PATTERN_MAP[_format.toLowerCase()] || _format;
                return $e0bcd49df8995938$var$_number2.default.convertDigits((0, $3FzdI.getFormatter)(_format, this)(date));
            }
        }
        if (!formatter) return;
        return formatter(date);
    },
    parse: function(text, format) {
        var that = this;
        var ldmlFormat;
        if (!text) return;
        if (!format) return this.parse(text, "shortdate");
        if (format.parser) return format.parser(text);
        if ("string" === typeof format && !$e0bcd49df8995938$var$FORMATS_TO_PATTERN_MAP[format.toLowerCase()]) ldmlFormat = format;
        else {
            var formatter = function(value) {
                var text = that.format(value, format);
                return $e0bcd49df8995938$var$_number2.default.convertDigits(text, true);
            };
            try {
                ldmlFormat = (0, $5xOPe.getFormat)(formatter);
            } catch (e) {}
        }
        if (ldmlFormat) {
            text = $e0bcd49df8995938$var$_number2.default.convertDigits(text, true);
            return (0, $giGZB.getParser)(ldmlFormat, this)(text);
        }
        $e0bcd49df8995938$var$_errors2.default.log("W0012");
        var result = new Date(text);
        if (!result || isNaN(result.getTime())) return;
        return result;
    },
    firstDayOfWeekIndex: function() {
        var index = (0, $gCA0F.getValueByClosestLocale)(function(locale) {
            return $e0bcd49df8995938$var$_first_day_of_week_data2.default[locale];
        });
        return void 0 === index ? $e0bcd49df8995938$var$DEFAULT_DAY_OF_WEEK_INDEX : index;
    }
});
if ($e0bcd49df8995938$var$hasIntl) $e0bcd49df8995938$var$dateLocalization.inject($e0bcd49df8995938$var$_date5.default);
module.exports = $e0bcd49df8995938$var$dateLocalization;

});
parcelRegister("5xOPe", function(module, exports) {

$parcel$export(module.exports, "getFormat", () => $409775aecda5c83c$export$f61ac8b6f1f46202, (v) => $409775aecda5c83c$export$f61ac8b6f1f46202 = v);
/**
 * DevExtreme (localization/ldml/date.format.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $409775aecda5c83c$export$f61ac8b6f1f46202;
"use strict";

var $9dtyI = parcelRequire("9dtyI");
var $409775aecda5c83c$var$_number2 = $409775aecda5c83c$var$_interopRequireDefault($9dtyI);
function $409775aecda5c83c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $409775aecda5c83c$var$ARABIC_COMMA = "\u060C";
var $409775aecda5c83c$var$FORMAT_SEPARATORS = " .,:;/\\<>()-[]" + $409775aecda5c83c$var$ARABIC_COMMA;
var $409775aecda5c83c$var$AM_PM_PATTERN = ". m.";
var $409775aecda5c83c$var$checkDigit = function(char) {
    var code = char && $409775aecda5c83c$var$_number2.default.convertDigits(char, false).charCodeAt(0);
    var zeroCode = $409775aecda5c83c$var$_number2.default.convertDigits("0", false).charCodeAt(0);
    return zeroCode <= code && code < zeroCode + 10;
};
var $409775aecda5c83c$var$checkPatternContinue = function(text, index, isDigit) {
    var char = text[index];
    var nextChar = text[index + 1];
    if (!isDigit) {
        if ("." === char || " " === char && text.slice(index - 1, index + 3) === $409775aecda5c83c$var$AM_PM_PATTERN) return true;
        if ("-" === char && !$409775aecda5c83c$var$checkDigit(nextChar)) return true;
    }
    return $409775aecda5c83c$var$FORMAT_SEPARATORS.indexOf(char) < 0 && isDigit === $409775aecda5c83c$var$checkDigit(char);
};
var $409775aecda5c83c$var$getPatternStartIndex = function(defaultPattern, index) {
    if (!$409775aecda5c83c$var$checkDigit(defaultPattern[index])) while(index > 0 && !$409775aecda5c83c$var$checkDigit(defaultPattern[index - 1]) && ("." === defaultPattern[index - 1] || $409775aecda5c83c$var$FORMAT_SEPARATORS.indexOf(defaultPattern[index - 1]) < 0))index--;
    return index;
};
var $409775aecda5c83c$var$getDifference = function(defaultPattern, patterns, processedIndexes, isDigit) {
    var i = 0;
    var result = [];
    var patternsFilter = function(pattern) {
        return defaultPattern[i] !== pattern[i] && (void 0 === isDigit || $409775aecda5c83c$var$checkDigit(defaultPattern[i]) === isDigit);
    };
    if (!Array.isArray(patterns)) patterns = [
        patterns
    ];
    for(i = 0; i < defaultPattern.length; i++)if (processedIndexes.indexOf(i) < 0 && patterns.filter(patternsFilter).length) {
        i = $409775aecda5c83c$var$getPatternStartIndex(defaultPattern, i);
        do {
            isDigit = $409775aecda5c83c$var$checkDigit(defaultPattern[i]);
            if (!result.length && !isDigit && $409775aecda5c83c$var$checkDigit(patterns[0][i])) break;
            result.push(i);
            processedIndexes.unshift(i);
            i++;
        }while (defaultPattern[i] && $409775aecda5c83c$var$checkPatternContinue(defaultPattern, i, isDigit));
        break;
    }
    if (1 === result.length && ("0" === defaultPattern[processedIndexes[0] - 1] || "\u0660" === defaultPattern[processedIndexes[0] - 1])) processedIndexes.unshift(processedIndexes[0] - 1);
    return result;
};
var $409775aecda5c83c$var$replaceCharsCore = function(pattern, indexes, char, patternPositions) {
    var baseCharIndex = indexes[0];
    var patternIndex = baseCharIndex < patternPositions.length ? patternPositions[baseCharIndex] : baseCharIndex;
    indexes.forEach(function(_, index) {
        pattern = pattern.substr(0, patternIndex + index) + (char.length > 1 ? char[index] : char) + pattern.substr(patternIndex + index + 1);
    });
    if (1 === indexes.length) {
        pattern = pattern.replace("0" + char, char + char);
        pattern = pattern.replace("\u0660" + char, char + char);
    }
    return pattern;
};
var $409775aecda5c83c$var$replaceChars = function(pattern, indexes, char, patternPositions) {
    var i;
    var index;
    var patternIndex;
    if (!$409775aecda5c83c$var$checkDigit(pattern[indexes[0]] || "0")) {
        var letterCount = Math.max(indexes.length <= 3 ? 3 : 4, char.length);
        while(indexes.length > letterCount){
            index = indexes.pop();
            patternIndex = patternPositions[index];
            patternPositions[index] = -1;
            for(i = index + 1; i < patternPositions.length; i++)patternPositions[i]--;
            pattern = pattern.substr(0, patternIndex) + pattern.substr(patternIndex + 1);
        }
        index = indexes[indexes.length - 1] + 1, patternIndex = index < patternPositions.length ? patternPositions[index] : index;
        while(indexes.length < letterCount){
            indexes.push(indexes[indexes.length - 1] + 1);
            for(i = index; i < patternPositions.length; i++)patternPositions[i]++;
            pattern = pattern.substr(0, patternIndex) + " " + pattern.substr(patternIndex);
        }
    }
    pattern = $409775aecda5c83c$var$replaceCharsCore(pattern, indexes, char, patternPositions);
    return pattern;
};
var $409775aecda5c83c$var$formatValue = function(value, formatter) {
    if (Array.isArray(value)) return value.map(function(value) {
        return (formatter(value) || "").toString();
    });
    return (formatter(value) || "").toString();
};
var $409775aecda5c83c$var$ESCAPE_CHARS_REGEXP = /[a-zA-Z]/g;
var $409775aecda5c83c$var$escapeChars = function(pattern, defaultPattern, processedIndexes, patternPositions) {
    var escapeIndexes = defaultPattern.split("").map(function(char, index) {
        if (processedIndexes.indexOf(index) < 0 && (char.match($409775aecda5c83c$var$ESCAPE_CHARS_REGEXP) || "'" === char)) return patternPositions[index];
        return -1;
    });
    pattern = pattern.split("").map(function(char, index) {
        var result = char;
        var isCurrentCharEscaped = escapeIndexes.indexOf(index) >= 0;
        var isPrevCharEscaped = index > 0 && escapeIndexes.indexOf(index - 1) >= 0;
        var isNextCharEscaped = escapeIndexes.indexOf(index + 1) >= 0;
        if (isCurrentCharEscaped) {
            if (!isPrevCharEscaped) result = "'" + result;
            if (!isNextCharEscaped) result += "'";
        }
        return result;
    }).join("");
    return pattern;
};
var $409775aecda5c83c$var$getFormat = function(formatter) {
    var processedIndexes = [];
    var defaultPattern = $409775aecda5c83c$var$formatValue(new Date(2009, 8, 8, 6, 5, 4), formatter);
    var patternPositions = defaultPattern.split("").map(function(_, index) {
        return index;
    });
    var result = defaultPattern;
    var replacedPatterns = {};
    var datePatterns = [
        {
            date: new Date(2009, 8, 8, 6, 5, 4, 100),
            pattern: "S"
        },
        {
            date: new Date(2009, 8, 8, 6, 5, 2),
            pattern: "s"
        },
        {
            date: new Date(2009, 8, 8, 6, 2, 4),
            pattern: "m"
        },
        {
            date: new Date(2009, 8, 8, 18, 5, 4),
            pattern: "H",
            isDigit: true
        },
        {
            date: new Date(2009, 8, 8, 2, 5, 4),
            pattern: "h",
            isDigit: true
        },
        {
            date: new Date(2009, 8, 8, 18, 5, 4),
            pattern: "a",
            isDigit: false
        },
        {
            date: new Date(2009, 8, 1, 6, 5, 4),
            pattern: "d"
        },
        {
            date: [
                new Date(2009, 8, 2, 6, 5, 4),
                new Date(2009, 8, 3, 6, 5, 4),
                new Date(2009, 8, 4, 6, 5, 4)
            ],
            pattern: "E"
        },
        {
            date: new Date(2009, 9, 6, 6, 5, 4),
            pattern: "M"
        },
        {
            date: new Date(1998, 8, 8, 6, 5, 4),
            pattern: "y"
        }
    ];
    if (!result) return;
    datePatterns.forEach(function(test) {
        var diff = $409775aecda5c83c$var$getDifference(defaultPattern, $409775aecda5c83c$var$formatValue(test.date, formatter), processedIndexes, test.isDigit);
        var pattern = "M" === test.pattern && !replacedPatterns.d ? "L" : test.pattern;
        result = $409775aecda5c83c$var$replaceChars(result, diff, pattern, patternPositions);
        replacedPatterns[pattern] = diff.length;
    });
    result = $409775aecda5c83c$var$escapeChars(result, defaultPattern, processedIndexes, patternPositions);
    if (processedIndexes.length) return result;
};
$409775aecda5c83c$export$f61ac8b6f1f46202 = $409775aecda5c83c$var$getFormat;

});

parcelRegister("giGZB", function(module, exports) {

$parcel$export(module.exports, "getParser", () => $bddfad3203098fc5$export$d003a19ab753048, (v) => $bddfad3203098fc5$export$d003a19ab753048 = v);
/**
 * DevExtreme (localization/ldml/date.parser.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $bddfad3203098fc5$export$d003a19ab753048;
var $bddfad3203098fc5$export$956ac88d5736f555;
var $bddfad3203098fc5$export$7770e3ec51d24a30;
"use strict";

var $2Mto0 = parcelRequire("2Mto0");
var $bddfad3203098fc5$require$escapeRegExp = $2Mto0.escapeRegExp;
var $bddfad3203098fc5$var$FORMAT_TYPES = {
    3: "abbreviated",
    4: "wide",
    5: "narrow"
};
var $bddfad3203098fc5$var$monthRegExpGenerator = function(count, dateParts) {
    if (count > 2) return Object.keys($bddfad3203098fc5$var$FORMAT_TYPES).map(function(count) {
        return [
            "format",
            "standalone"
        ].map(function(type) {
            return dateParts.getMonthNames($bddfad3203098fc5$var$FORMAT_TYPES[count], type).join("|");
        }).join("|");
    }).join("|");
    return "0?[1-9]|1[012]";
};
var $bddfad3203098fc5$var$PATTERN_REGEXPS = {
    y: function(count) {
        return "[0-9]+";
    },
    M: $bddfad3203098fc5$var$monthRegExpGenerator,
    L: $bddfad3203098fc5$var$monthRegExpGenerator,
    Q: function(count, dateParts) {
        if (count > 2) return dateParts.getQuarterNames($bddfad3203098fc5$var$FORMAT_TYPES[count], "format").join("|");
        return "0?[1-4]";
    },
    E: function(count, dateParts) {
        return "\\D*";
    },
    a: function(count, dateParts) {
        return dateParts.getPeriodNames($bddfad3203098fc5$var$FORMAT_TYPES[count < 3 ? 3 : count], "format").join("|");
    },
    d: function(count) {
        return "0?[1-9]|[12][0-9]|3[01]";
    },
    H: function(count) {
        return "0?[0-9]|1[0-9]|2[0-3]";
    },
    h: function(count) {
        return "0?[1-9]|1[012]";
    },
    m: function(count) {
        return "0?[0-9]|[1-5][0-9]";
    },
    s: function(count) {
        return "0?[0-9]|[1-5][0-9]";
    },
    S: function(count) {
        return "[0-9]{1," + count + "}";
    }
};
var $bddfad3203098fc5$var$parseNumber = Number;
var $bddfad3203098fc5$var$caseInsensitiveIndexOf = function(array, value) {
    return array.map(function(item) {
        return item.toLowerCase();
    }).indexOf(value.toLowerCase());
};
var $bddfad3203098fc5$var$monthPatternParser = function(text, count, dateParts) {
    if (count > 2) return [
        "format",
        "standalone"
    ].map(function(type) {
        return Object.keys($bddfad3203098fc5$var$FORMAT_TYPES).map(function(count) {
            var monthNames = dateParts.getMonthNames($bddfad3203098fc5$var$FORMAT_TYPES[count], type);
            return $bddfad3203098fc5$var$caseInsensitiveIndexOf(monthNames, text);
        });
    }).reduce(function(a, b) {
        return a.concat(b);
    }).filter(function(index) {
        return index >= 0;
    })[0];
    return $bddfad3203098fc5$var$parseNumber(text) - 1;
};
var $bddfad3203098fc5$var$PATTERN_PARSERS = {
    y: function(text, count) {
        var year = $bddfad3203098fc5$var$parseNumber(text);
        if (2 === count) return year < 30 ? 2e3 + year : 1900 + year;
        return year;
    },
    M: $bddfad3203098fc5$var$monthPatternParser,
    L: $bddfad3203098fc5$var$monthPatternParser,
    Q: function(text, count, dateParts) {
        if (count > 2) return dateParts.getQuarterNames($bddfad3203098fc5$var$FORMAT_TYPES[count], "format").indexOf(text);
        return $bddfad3203098fc5$var$parseNumber(text) - 1;
    },
    E: function(text, count, dateParts) {
        var dayNames = dateParts.getDayNames($bddfad3203098fc5$var$FORMAT_TYPES[count < 3 ? 3 : count], "format");
        return $bddfad3203098fc5$var$caseInsensitiveIndexOf(dayNames, text);
    },
    a: function(text, count, dateParts) {
        var periodNames = dateParts.getPeriodNames($bddfad3203098fc5$var$FORMAT_TYPES[count < 3 ? 3 : count], "format");
        return $bddfad3203098fc5$var$caseInsensitiveIndexOf(periodNames, text);
    },
    d: $bddfad3203098fc5$var$parseNumber,
    H: $bddfad3203098fc5$var$parseNumber,
    h: $bddfad3203098fc5$var$parseNumber,
    m: $bddfad3203098fc5$var$parseNumber,
    s: $bddfad3203098fc5$var$parseNumber,
    S: function(text, count) {
        count = Math.max(count, 3);
        text = text.slice(0, 3);
        while(count < 3){
            text += "0";
            count++;
        }
        return $bddfad3203098fc5$var$parseNumber(text);
    }
};
var $bddfad3203098fc5$var$ORDERED_PATTERNS = [
    "y",
    "M",
    "d",
    "h",
    "m",
    "s",
    "S"
];
var $bddfad3203098fc5$var$PATTERN_SETTERS = {
    y: "setFullYear",
    M: "setMonth",
    L: "setMonth",
    a: function(date, value, datePartValues) {
        var hours = date.getHours();
        var hourPartValue = datePartValues.h;
        if (void 0 !== hourPartValue && hourPartValue !== hours) hours--;
        if (!value && 12 === hours) hours = 0;
        else if (value && 12 !== hours) hours += 12;
        date.setHours(hours);
    },
    d: "setDate",
    H: "setHours",
    h: "setHours",
    m: "setMinutes",
    s: "setSeconds",
    S: "setMilliseconds"
};
var $bddfad3203098fc5$var$getSameCharCount = function(text, index) {
    var char = text[index];
    var count = 0;
    do {
        index++;
        count++;
    }while (text[index] === char);
    return count;
};
var $bddfad3203098fc5$var$createPattern = function(char, count) {
    var result = "";
    for(var i = 0; i < count; i++)result += char;
    return result;
};
var $bddfad3203098fc5$var$getRegExpInfo = function(format, dateParts) {
    var regexpText = "";
    var stubText = "";
    var isEscaping;
    var patterns = [];
    var addPreviousStub = function() {
        if (stubText) {
            patterns.push("'" + stubText + "'");
            regexpText += $bddfad3203098fc5$require$escapeRegExp(stubText) + ")";
            stubText = "";
        }
    };
    for(var i = 0; i < format.length; i++){
        var char = format[i];
        var isEscapeChar = "'" === char;
        var regexpPart = $bddfad3203098fc5$var$PATTERN_REGEXPS[char];
        if (isEscapeChar) {
            isEscaping = !isEscaping;
            if ("'" !== format[i - 1]) continue;
        }
        if (regexpPart && !isEscaping) {
            var count = $bddfad3203098fc5$var$getSameCharCount(format, i);
            var pattern = $bddfad3203098fc5$var$createPattern(char, count);
            addPreviousStub();
            patterns.push(pattern);
            regexpText += "(" + regexpPart(count, dateParts) + ")";
            i += count - 1;
        } else {
            if (!stubText) regexpText += "(";
            stubText += char;
        }
    }
    addPreviousStub();
    return {
        patterns: patterns,
        regexp: new RegExp("^" + regexpText + "$", "i")
    };
};
var $bddfad3203098fc5$var$getPatternSetters = function() {
    return $bddfad3203098fc5$var$PATTERN_SETTERS;
};
var $bddfad3203098fc5$var$setPatternPart = function(date, pattern, text, dateParts, datePartValues) {
    var patternChar = pattern[0];
    var partSetter = $bddfad3203098fc5$var$PATTERN_SETTERS[patternChar];
    var partParser = $bddfad3203098fc5$var$PATTERN_PARSERS[patternChar];
    if (partSetter && partParser) {
        var value = partParser(text, pattern.length, dateParts);
        datePartValues[pattern] = value;
        if (date[partSetter]) date[partSetter](value);
        else partSetter(date, value, datePartValues);
    }
};
var $bddfad3203098fc5$var$setPatternPartFromNow = function(date, pattern, now) {
    var setterName = $bddfad3203098fc5$var$PATTERN_SETTERS[pattern];
    var getterName = "g" + setterName.substr(1);
    var value = now[getterName]();
    date[setterName](value);
};
var $bddfad3203098fc5$var$getShortPatterns = function(fullPatterns) {
    return fullPatterns.map(function(pattern) {
        if ("'" === pattern[0]) return "";
        else return "H" === pattern[0] ? "h" : pattern[0];
    });
};
var $bddfad3203098fc5$var$getMaxOrderedPatternIndex = function(patterns) {
    var indexes = patterns.map(function(pattern) {
        return $bddfad3203098fc5$var$ORDERED_PATTERNS.indexOf(pattern);
    });
    return Math.max.apply(Math, indexes);
};
var $bddfad3203098fc5$var$getOrderedFormatPatterns = function(formatPatterns) {
    var otherPatterns = formatPatterns.filter(function(pattern) {
        return $bddfad3203098fc5$var$ORDERED_PATTERNS.indexOf(pattern) < 0;
    });
    return $bddfad3203098fc5$var$ORDERED_PATTERNS.concat(otherPatterns);
};
var $bddfad3203098fc5$var$getParser = function(format, dateParts) {
    var regExpInfo = $bddfad3203098fc5$var$getRegExpInfo(format, dateParts);
    return function(text) {
        var regExpResult = regExpInfo.regexp.exec(text);
        if (regExpResult) {
            var now = new Date;
            var date = new Date(now.getFullYear(), 0, 1);
            var formatPatterns = $bddfad3203098fc5$var$getShortPatterns(regExpInfo.patterns);
            var maxPatternIndex = $bddfad3203098fc5$var$getMaxOrderedPatternIndex(formatPatterns);
            var orderedFormatPatterns = $bddfad3203098fc5$var$getOrderedFormatPatterns(formatPatterns);
            var datePartValues = {};
            orderedFormatPatterns.forEach(function(pattern, index) {
                if (!pattern || index < $bddfad3203098fc5$var$ORDERED_PATTERNS.length && index > maxPatternIndex) return;
                var patternIndex = formatPatterns.indexOf(pattern);
                if (patternIndex >= 0) {
                    var regExpPattern = regExpInfo.patterns[patternIndex];
                    var regExpText = regExpResult[patternIndex + 1];
                    $bddfad3203098fc5$var$setPatternPart(date, regExpPattern, regExpText, dateParts, datePartValues);
                } else $bddfad3203098fc5$var$setPatternPartFromNow(date, pattern, now);
            });
            return date;
        }
        return null;
    };
};
$bddfad3203098fc5$export$d003a19ab753048 = $bddfad3203098fc5$var$getParser;
$bddfad3203098fc5$export$956ac88d5736f555 = $bddfad3203098fc5$var$getRegExpInfo;
$bddfad3203098fc5$export$7770e3ec51d24a30 = $bddfad3203098fc5$var$getPatternSetters;

});

parcelRegister("l3Vxg", function(module, exports) {
/**
 * DevExtreme (localization/cldr-data/first_day_of_week_data.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
module.exports = {
    "af-NA": 1,
    agq: 1,
    ak: 1,
    ar: 6,
    "ar-EH": 1,
    "ar-ER": 1,
    "ar-KM": 1,
    "ar-LB": 1,
    "ar-MA": 1,
    "ar-MR": 1,
    "ar-PS": 1,
    "ar-SO": 1,
    "ar-SS": 1,
    "ar-TD": 1,
    "ar-TN": 1,
    asa: 1,
    ast: 1,
    az: 1,
    "az-Cyrl": 1,
    bas: 1,
    be: 1,
    bem: 1,
    bez: 1,
    bg: 1,
    bm: 1,
    br: 1,
    bs: 1,
    "bs-Cyrl": 1,
    ca: 1,
    ce: 1,
    cgg: 1,
    ckb: 6,
    cs: 1,
    cu: 1,
    cy: 1,
    da: 1,
    de: 1,
    dje: 1,
    dsb: 1,
    dua: 1,
    dyo: 1,
    ee: 1,
    el: 1,
    "en-001": 1,
    "en-AE": 6,
    "en-BI": 1,
    "en-MP": 1,
    "en-SD": 6,
    eo: 1,
    es: 1,
    et: 1,
    eu: 1,
    ewo: 1,
    fa: 6,
    ff: 1,
    fi: 1,
    fo: 1,
    fr: 1,
    "fr-DJ": 6,
    "fr-DZ": 6,
    "fr-SY": 6,
    fur: 1,
    fy: 1,
    ga: 1,
    gd: 1,
    gl: 1,
    gsw: 1,
    gv: 1,
    ha: 1,
    hr: 1,
    hsb: 1,
    hu: 1,
    hy: 1,
    ia: 1,
    ig: 1,
    is: 1,
    it: 1,
    jgo: 1,
    jmc: 1,
    ka: 1,
    kab: 6,
    kde: 1,
    kea: 1,
    khq: 1,
    kk: 1,
    kkj: 1,
    kl: 1,
    "ko-KP": 1,
    ksb: 1,
    ksf: 1,
    ksh: 1,
    ku: 1,
    kw: 1,
    ky: 1,
    lag: 1,
    lb: 1,
    lg: 1,
    ln: 1,
    lrc: 6,
    lt: 1,
    lu: 1,
    lv: 1,
    "mas-TZ": 1,
    mfe: 1,
    mg: 1,
    mgo: 1,
    mi: 1,
    mk: 1,
    mn: 1,
    ms: 1,
    mua: 1,
    mzn: 6,
    naq: 1,
    nb: 1,
    nds: 1,
    nl: 1,
    nmg: 1,
    nn: 1,
    nnh: 1,
    nus: 1,
    nyn: 1,
    os: 1,
    pl: 1,
    prg: 1,
    ps: 6,
    "pt-AO": 1,
    "pt-CH": 1,
    "pt-CV": 1,
    "pt-GQ": 1,
    "pt-GW": 1,
    "pt-LU": 1,
    "pt-ST": 1,
    "pt-TL": 1,
    "qu-BO": 1,
    "qu-EC": 1,
    rm: 1,
    rn: 1,
    ro: 1,
    rof: 1,
    ru: 1,
    rw: 1,
    rwk: 1,
    sah: 1,
    sbp: 1,
    se: 1,
    ses: 1,
    sg: 1,
    shi: 1,
    "shi-Latn": 1,
    si: 1,
    sk: 1,
    sl: 1,
    smn: 1,
    so: 1,
    "so-DJ": 6,
    sq: 1,
    sr: 1,
    "sr-Latn": 1,
    sv: 1,
    sw: 1,
    "ta-LK": 1,
    "ta-MY": 1,
    teo: 1,
    tg: 1,
    "ti-ER": 1,
    tk: 1,
    to: 1,
    tr: 1,
    tt: 1,
    twq: 1,
    tzm: 1,
    uk: 1,
    uz: 1,
    "uz-Arab": 6,
    "uz-Cyrl": 1,
    vai: 1,
    "vai-Latn": 1,
    vi: 1,
    vo: 1,
    vun: 1,
    wae: 1,
    wo: 1,
    xog: 1,
    yav: 1,
    yi: 1,
    yo: 1,
    zgh: 1
};

});

parcelRegister("5EfEA", function(module, exports) {
/**
 * DevExtreme (localization/intl/date.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $7I8Uw = parcelRequire("7I8Uw");

var $gCA0F = parcelRequire("gCA0F");
function $41ccd4a2f6352d1a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $41ccd4a2f6352d1a$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $41ccd4a2f6352d1a$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $41ccd4a2f6352d1a$var$_typeof(obj);
}
var $41ccd4a2f6352d1a$var$SYMBOLS_TO_REMOVE_REGEX = /[\u200E\u200F]/g;
var $41ccd4a2f6352d1a$var$getIntlFormatter = function(format) {
    return function(date) {
        if (!format.timeZoneName) {
            var year = date.getFullYear();
            var recognizableAsTwentyCentury = String(year).length < 3;
            var safeYearShift = 400;
            var temporaryYearValue = recognizableAsTwentyCentury ? year + safeYearShift : year;
            var utcDate = new Date(Date.UTC(temporaryYearValue, date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
            if (recognizableAsTwentyCentury) utcDate.setFullYear(year);
            var utcFormat = (0, $7I8Uw.extend)({
                timeZone: "UTC"
            }, format);
            return $41ccd4a2f6352d1a$var$formatDateTime(utcDate, utcFormat);
        }
        return $41ccd4a2f6352d1a$var$formatDateTime(date, format);
    };
};
var $41ccd4a2f6352d1a$var$formattersCache = {};
var $41ccd4a2f6352d1a$var$getFormatter = function(format) {
    var key = (0, $gCA0F.locale)() + "/" + JSON.stringify(format);
    if (!$41ccd4a2f6352d1a$var$formattersCache[key]) $41ccd4a2f6352d1a$var$formattersCache[key] = new Intl.DateTimeFormat((0, $gCA0F.locale)(), format).format;
    return $41ccd4a2f6352d1a$var$formattersCache[key];
};
var $41ccd4a2f6352d1a$var$formatDateTime = function(date, format) {
    return $41ccd4a2f6352d1a$var$getFormatter(format)(date).replace($41ccd4a2f6352d1a$var$SYMBOLS_TO_REMOVE_REGEX, "");
};
var $41ccd4a2f6352d1a$var$formatNumber = function(number) {
    return new Intl.NumberFormat((0, $gCA0F.locale)()).format(number);
};
var $41ccd4a2f6352d1a$var$getAlternativeNumeralsMap = function() {
    var numeralsMapCache = {};
    return function(locale) {
        if (!(locale in numeralsMapCache)) {
            if ("0" === $41ccd4a2f6352d1a$var$formatNumber(0)) {
                numeralsMapCache[locale] = false;
                return false;
            }
            numeralsMapCache[locale] = {};
            for(var i = 0; i < 10; ++i)numeralsMapCache[locale][$41ccd4a2f6352d1a$var$formatNumber(i)] = i;
        }
        return numeralsMapCache[locale];
    };
}();
var $41ccd4a2f6352d1a$var$normalizeNumerals = function(dateString) {
    var alternativeNumeralsMap = $41ccd4a2f6352d1a$var$getAlternativeNumeralsMap((0, $gCA0F.locale)());
    if (!alternativeNumeralsMap) return dateString;
    return dateString.split("").map(function(sign) {
        return sign in alternativeNumeralsMap ? String(alternativeNumeralsMap[sign]) : sign;
    }).join("");
};
var $41ccd4a2f6352d1a$var$removeLeadingZeroes = function(str) {
    return str.replace(/(\D)0+(\d)/g, "$1$2");
};
var $41ccd4a2f6352d1a$var$dateStringEquals = function(actual, expected) {
    return $41ccd4a2f6352d1a$var$removeLeadingZeroes(actual) === $41ccd4a2f6352d1a$var$removeLeadingZeroes(expected);
};
var $41ccd4a2f6352d1a$var$normalizeMonth = function(text) {
    return text.replace("d\u2019", "de ");
};
var $41ccd4a2f6352d1a$var$intlFormats = {
    day: {
        day: "numeric"
    },
    dayofweek: {
        weekday: "long"
    },
    longdate: {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
    },
    longdatelongtime: {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    },
    longtime: {
        hour: "numeric",
        minute: "numeric",
        second: "numeric"
    },
    month: {
        month: "long"
    },
    monthandday: {
        month: "long",
        day: "numeric"
    },
    monthandyear: {
        year: "numeric",
        month: "long"
    },
    shortdate: {},
    shorttime: {
        hour: "numeric",
        minute: "numeric"
    },
    shortyear: {
        year: "2-digit"
    },
    year: {
        year: "numeric"
    }
};
Object.defineProperty($41ccd4a2f6352d1a$var$intlFormats, "shortdateshorttime", {
    get: function() {
        var defaultOptions = Intl.DateTimeFormat((0, $gCA0F.locale)()).resolvedOptions();
        return {
            year: defaultOptions.year,
            month: defaultOptions.month,
            day: defaultOptions.day,
            hour: "numeric",
            minute: "numeric"
        };
    }
});
var $41ccd4a2f6352d1a$var$getIntlFormat = function(format) {
    return "string" === typeof format && $41ccd4a2f6352d1a$var$intlFormats[format.toLowerCase()];
};
var $41ccd4a2f6352d1a$var$monthNameStrategies = {
    standalone: function(monthIndex, monthFormat) {
        var date = new Date(1999, monthIndex, 13, 1);
        var dateString = $41ccd4a2f6352d1a$var$getIntlFormatter({
            month: monthFormat
        })(date);
        return dateString;
    },
    format: function(monthIndex, monthFormat) {
        var date = new Date(0, monthIndex, 13, 1);
        var dateString = $41ccd4a2f6352d1a$var$normalizeMonth($41ccd4a2f6352d1a$var$getIntlFormatter({
            day: "numeric",
            month: monthFormat
        })(date));
        var parts = dateString.split(" ").filter(function(part) {
            return part.indexOf("13") < 0;
        });
        if (1 === parts.length) return parts[0];
        else {
            if (2 === parts.length) return parts[0].length > parts[1].length ? parts[0] : parts[1];
        }
        return $41ccd4a2f6352d1a$var$monthNameStrategies.standalone(monthIndex, monthFormat);
    }
};
module.exports = {
    engine: function() {
        return "intl";
    },
    getMonthNames: function(format, type) {
        var intlFormats = {
            wide: "long",
            abbreviated: "short",
            narrow: "narrow"
        };
        var monthFormat = intlFormats[format || "wide"];
        type = "format" === type ? type : "standalone";
        return Array.apply(null, new Array(12)).map(function(_, monthIndex) {
            return $41ccd4a2f6352d1a$var$monthNameStrategies[type](monthIndex, monthFormat);
        });
    },
    getDayNames: function(format) {
        var intlFormats = {
            wide: "long",
            abbreviated: "short",
            "short": "narrow",
            narrow: "narrow"
        };
        var getIntlDayNames = function(format) {
            return Array.apply(null, new Array(7)).map(function(_, dayIndex) {
                return $41ccd4a2f6352d1a$var$getIntlFormatter({
                    weekday: format
                })(new Date(0, 0, dayIndex));
            });
        };
        var result = getIntlDayNames(intlFormats[format || "wide"]);
        return result;
    },
    getPeriodNames: function() {
        var hour12Formatter = $41ccd4a2f6352d1a$var$getIntlFormatter({
            hour: "numeric",
            hour12: true
        });
        return [
            1,
            13
        ].map(function(hours) {
            var hourNumberText = $41ccd4a2f6352d1a$var$formatNumber(1);
            var timeParts = hour12Formatter(new Date(0, 0, 1, hours)).split(hourNumberText);
            if (2 !== timeParts.length) return "";
            var biggerPart = timeParts[0].length > timeParts[1].length ? timeParts[0] : timeParts[1];
            return biggerPart.trim();
        });
    },
    format: function(date, _format) {
        if (!date) return;
        if (!_format) return date;
        if ("function" !== typeof _format && !_format.formatter) _format = _format.type || _format;
        var intlFormat = $41ccd4a2f6352d1a$var$getIntlFormat(_format);
        if (intlFormat) return $41ccd4a2f6352d1a$var$getIntlFormatter(intlFormat)(date);
        var formatType = $41ccd4a2f6352d1a$var$_typeof(_format);
        if (_format.formatter || "function" === formatType || "string" === formatType) return this.callBase.apply(this, arguments);
        return $41ccd4a2f6352d1a$var$getIntlFormatter(_format)(date);
    },
    parse: function(dateString, format) {
        var _this = this;
        var formatter;
        if (format && !format.parser && "string" === typeof dateString) {
            dateString = $41ccd4a2f6352d1a$var$normalizeMonth(dateString);
            formatter = function(date) {
                return $41ccd4a2f6352d1a$var$normalizeMonth(_this.format(date, format));
            };
        }
        return this.callBase(dateString, formatter || format);
    },
    _parseDateBySimpleFormat: function(dateString, format) {
        var _this2 = this;
        dateString = $41ccd4a2f6352d1a$var$normalizeNumerals(dateString);
        var formatParts = this.getFormatParts(format);
        var dateParts = dateString.split(/\D+/).filter(function(part) {
            return part.length > 0;
        });
        if (formatParts.length !== dateParts.length) return;
        var dateArgs = this._generateDateArgs(formatParts, dateParts);
        var constructDate = function(dateArgs, ampmShift) {
            var hoursShift = ampmShift ? 12 : 0;
            return new Date(dateArgs.year, dateArgs.month, dateArgs.day, (dateArgs.hours + hoursShift) % 24, dateArgs.minutes, dateArgs.seconds);
        };
        var constructValidDate = function(ampmShift) {
            var parsedDate = constructDate(dateArgs, ampmShift);
            if ($41ccd4a2f6352d1a$var$dateStringEquals($41ccd4a2f6352d1a$var$normalizeNumerals(_this2.format(parsedDate, format)), dateString)) return parsedDate;
        };
        return constructValidDate(false) || constructValidDate(true);
    },
    _generateDateArgs: function(formatParts, dateParts) {
        var currentDate = new Date;
        var dateArgs = {
            year: currentDate.getFullYear(),
            month: currentDate.getMonth(),
            day: currentDate.getDate(),
            hours: 0,
            minutes: 0,
            seconds: 0
        };
        formatParts.forEach(function(formatPart, index) {
            var datePart = dateParts[index];
            var parsed = parseInt(datePart, 10);
            if ("month" === formatPart) parsed -= 1;
            dateArgs[formatPart] = parsed;
        });
        return dateArgs;
    },
    formatUsesMonthName: function(format) {
        if ("object" === $41ccd4a2f6352d1a$var$_typeof(format) && !(format.type || format.format)) return "long" === format.month;
        return this.callBase.apply(this, arguments);
    },
    formatUsesDayName: function(format) {
        if ("object" === $41ccd4a2f6352d1a$var$_typeof(format) && !(format.type || format.format)) return "long" === format.weekday;
        return this.callBase.apply(this, arguments);
    },
    getFormatParts: function(format) {
        if ("string" === typeof format) return this.callBase(format);
        var intlFormat = (0, $7I8Uw.extend)({}, $41ccd4a2f6352d1a$var$intlFormats[format.toLowerCase()]);
        var date = new Date(2001, 2, 4, 5, 6, 7);
        var formattedDate = $41ccd4a2f6352d1a$var$getIntlFormatter(intlFormat)(date);
        formattedDate = $41ccd4a2f6352d1a$var$normalizeNumerals(formattedDate);
        var formatParts = [
            {
                name: "year",
                value: 1
            },
            {
                name: "month",
                value: 3
            },
            {
                name: "day",
                value: 4
            },
            {
                name: "hours",
                value: 5
            },
            {
                name: "minutes",
                value: 6
            },
            {
                name: "seconds",
                value: 7
            }
        ];
        return formatParts.map(function(part) {
            return {
                name: part.name,
                index: formattedDate.indexOf(part.value)
            };
        }).filter(function(part) {
            return part.index > -1;
        }).sort(function(a, b) {
            return a.index - b.index;
        }).map(function(part) {
            return part.name;
        });
    }
};

});




parcelRegister("6JqLo", function(module, exports) {
/**
 * DevExtreme (ui/scroll_view/ui.scroll_view.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $aiwte = parcelRequire("aiwte");

var $irv64 = parcelRequire("irv64");

var $cnVbh = parcelRequire("cnVbh");

var $4ZFRo = parcelRequire("4ZFRo");

var $5OzEX = parcelRequire("5OzEX");
var $4e6bb4b3af0474b6$require$getPublicElement = $5OzEX.getPublicElement;

var $7I8Uw = parcelRequire("7I8Uw");
var $4e6bb4b3af0474b6$require$extend = $7I8Uw.extend;

var $2Mto0 = parcelRequire("2Mto0");
var $4e6bb4b3af0474b6$require$noop = $2Mto0.noop;

var $3DqzC = parcelRequire("3DqzC");

var $2jCgQ = parcelRequire("2jCgQ");

var $lNWpl = parcelRequire("lNWpl");

var $69YDp = parcelRequire("69YDp");

var $gbWer = parcelRequire("gbWer");

var $3LUJe = parcelRequire("3LUJe");

var $DrKoa = parcelRequire("DrKoa");
var $4e6bb4b3af0474b6$var$SCROLLVIEW_CLASS = "dx-scrollview";
var $4e6bb4b3af0474b6$var$SCROLLVIEW_CONTENT_CLASS = $4e6bb4b3af0474b6$var$SCROLLVIEW_CLASS + "-content";
var $4e6bb4b3af0474b6$var$SCROLLVIEW_TOP_POCKET_CLASS = $4e6bb4b3af0474b6$var$SCROLLVIEW_CLASS + "-top-pocket";
var $4e6bb4b3af0474b6$var$SCROLLVIEW_BOTTOM_POCKET_CLASS = $4e6bb4b3af0474b6$var$SCROLLVIEW_CLASS + "-bottom-pocket";
var $4e6bb4b3af0474b6$var$SCROLLVIEW_PULLDOWN_CLASS = $4e6bb4b3af0474b6$var$SCROLLVIEW_CLASS + "-pull-down";
var $4e6bb4b3af0474b6$var$SCROLLVIEW_REACHBOTTOM_CLASS = $4e6bb4b3af0474b6$var$SCROLLVIEW_CLASS + "-scrollbottom";
var $4e6bb4b3af0474b6$var$SCROLLVIEW_REACHBOTTOM_INDICATOR_CLASS = $4e6bb4b3af0474b6$var$SCROLLVIEW_REACHBOTTOM_CLASS + "-indicator";
var $4e6bb4b3af0474b6$var$SCROLLVIEW_REACHBOTTOM_TEXT_CLASS = $4e6bb4b3af0474b6$var$SCROLLVIEW_REACHBOTTOM_CLASS + "-text";
var $4e6bb4b3af0474b6$var$SCROLLVIEW_LOADPANEL = $4e6bb4b3af0474b6$var$SCROLLVIEW_CLASS + "-loadpanel";
var $4e6bb4b3af0474b6$var$refreshStrategies = {
    pullDown: $3DqzC,
    swipeDown: $2jCgQ,
    simulated: $lNWpl
};
var $4e6bb4b3af0474b6$var$isServerSide = !$irv64.hasWindow();
var $4e6bb4b3af0474b6$var$scrollViewServerConfig = {
    finishLoading: $4e6bb4b3af0474b6$require$noop,
    release: $4e6bb4b3af0474b6$require$noop,
    refresh: $4e6bb4b3af0474b6$require$noop,
    _optionChanged: function(args) {
        if ("onUpdated" !== args.name) return this.callBase.apply(this, arguments);
    }
};
var $4e6bb4b3af0474b6$var$ScrollView = $69YDp.inherit($4e6bb4b3af0474b6$var$isServerSide ? $4e6bb4b3af0474b6$var$scrollViewServerConfig : {
    _getDefaultOptions: function() {
        return $4e6bb4b3af0474b6$require$extend(this.callBase(), {
            pullingDownText: $cnVbh.format("dxScrollView-pullingDownText"),
            pulledDownText: $cnVbh.format("dxScrollView-pulledDownText"),
            refreshingText: $cnVbh.format("dxScrollView-refreshingText"),
            reachBottomText: $cnVbh.format("dxScrollView-reachBottomText"),
            onPullDown: null,
            onReachBottom: null,
            refreshStrategy: "pullDown"
        });
    },
    _defaultOptionsRules: function() {
        return this.callBase().concat([
            {
                device: function() {
                    var realDevice = $aiwte.real();
                    return "android" === realDevice.platform;
                },
                options: {
                    refreshStrategy: "swipeDown"
                }
            },
            {
                device: function() {
                    return $3LUJe.isMaterial();
                },
                options: {
                    pullingDownText: "",
                    pulledDownText: "",
                    refreshingText: "",
                    reachBottomText: ""
                }
            }
        ]);
    },
    _init: function() {
        this.callBase();
        this._loadingIndicatorEnabled = true;
    },
    _initScrollableMarkup: function() {
        this.callBase();
        this.$element().addClass($4e6bb4b3af0474b6$var$SCROLLVIEW_CLASS);
        this._initContent();
        this._initTopPocket();
        this._initBottomPocket();
        this._initLoadPanel();
    },
    _initContent: function() {
        var $content = $jFnCG("<div>").addClass($4e6bb4b3af0474b6$var$SCROLLVIEW_CONTENT_CLASS);
        this._$content.wrapInner($content);
    },
    _initTopPocket: function() {
        var $topPocket = this._$topPocket = $jFnCG("<div>").addClass($4e6bb4b3af0474b6$var$SCROLLVIEW_TOP_POCKET_CLASS);
        var $pullDown = this._$pullDown = $jFnCG("<div>").addClass($4e6bb4b3af0474b6$var$SCROLLVIEW_PULLDOWN_CLASS);
        $topPocket.append($pullDown);
        this._$content.prepend($topPocket);
    },
    _initBottomPocket: function() {
        var $bottomPocket = this._$bottomPocket = $jFnCG("<div>").addClass($4e6bb4b3af0474b6$var$SCROLLVIEW_BOTTOM_POCKET_CLASS);
        var $reachBottom = this._$reachBottom = $jFnCG("<div>").addClass($4e6bb4b3af0474b6$var$SCROLLVIEW_REACHBOTTOM_CLASS);
        var $loadContainer = $jFnCG("<div>").addClass($4e6bb4b3af0474b6$var$SCROLLVIEW_REACHBOTTOM_INDICATOR_CLASS);
        var $loadIndicator = new $gbWer($jFnCG("<div>")).$element();
        var $text = this._$reachBottomText = $jFnCG("<div>").addClass($4e6bb4b3af0474b6$var$SCROLLVIEW_REACHBOTTOM_TEXT_CLASS);
        this._updateReachBottomText();
        $reachBottom.append($loadContainer.append($loadIndicator)).append($text);
        $bottomPocket.append($reachBottom);
        this._$content.append($bottomPocket);
    },
    _initLoadPanel: function() {
        var $loadPanelElement = $jFnCG("<div>").addClass($4e6bb4b3af0474b6$var$SCROLLVIEW_LOADPANEL).appendTo(this.$element());
        var loadPanelOptions = {
            shading: false,
            delay: 400,
            message: this.option("refreshingText"),
            position: {
                of: this.$element()
            }
        };
        this._loadPanel = this._createComponent($loadPanelElement, $DrKoa, loadPanelOptions);
    },
    _updateReachBottomText: function() {
        this._$reachBottomText.text(this.option("reachBottomText"));
    },
    _createStrategy: function() {
        var strategyName = this.option("useNative") ? this.option("refreshStrategy") : "simulated";
        var strategyClass = $4e6bb4b3af0474b6$var$refreshStrategies[strategyName];
        if (!strategyClass) throw Error("E1030", this.option("refreshStrategy"));
        this._strategy = new strategyClass(this);
        this._strategy.pullDownCallbacks.add(this._pullDownHandler.bind(this));
        this._strategy.releaseCallbacks.add(this._releaseHandler.bind(this));
        this._strategy.reachBottomCallbacks.add(this._reachBottomHandler.bind(this));
    },
    _createActions: function() {
        this.callBase();
        this._pullDownAction = this._createActionByOption("onPullDown");
        this._reachBottomAction = this._createActionByOption("onReachBottom");
        this._tryRefreshPocketState();
    },
    _tryRefreshPocketState: function() {
        this._pullDownEnable(this.hasActionSubscription("onPullDown"));
        this._reachBottomEnable(this.hasActionSubscription("onReachBottom"));
    },
    on: function(eventName) {
        var result = this.callBase.apply(this, arguments);
        if ("pullDown" === eventName || "reachBottom" === eventName) this._tryRefreshPocketState();
        return result;
    },
    _pullDownEnable: function(enabled) {
        if (0 === arguments.length) return this._pullDownEnabled;
        if (this._$pullDown && this._strategy) {
            this._$pullDown.toggle(enabled);
            this._strategy.pullDownEnable(enabled);
            this._pullDownEnabled = enabled;
        }
    },
    _reachBottomEnable: function(enabled) {
        if (0 === arguments.length) return this._reachBottomEnabled;
        if (this._$reachBottom && this._strategy) {
            this._$reachBottom.toggle(enabled);
            this._strategy.reachBottomEnable(enabled);
            this._reachBottomEnabled = enabled;
        }
    },
    _pullDownHandler: function() {
        this._loadingIndicator(false);
        this._pullDownLoading();
    },
    _loadingIndicator: function(value) {
        if (arguments.length < 1) return this._loadingIndicatorEnabled;
        this._loadingIndicatorEnabled = value;
    },
    _pullDownLoading: function() {
        this.startLoading();
        this._pullDownAction();
    },
    _reachBottomHandler: function() {
        this._loadingIndicator(false);
        this._reachBottomLoading();
    },
    _reachBottomLoading: function() {
        this.startLoading();
        this._reachBottomAction();
    },
    _releaseHandler: function() {
        this.finishLoading();
        this._loadingIndicator(true);
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "onPullDown":
            case "onReachBottom":
                this._createActions();
                break;
            case "pullingDownText":
            case "pulledDownText":
            case "refreshingText":
            case "refreshStrategy":
                this._invalidate();
                break;
            case "reachBottomText":
                this._updateReachBottomText();
                break;
            default:
                this.callBase(args);
        }
    },
    isEmpty: function() {
        return !$jFnCG(this.content()).children().length;
    },
    content: function() {
        return $4e6bb4b3af0474b6$require$getPublicElement(this._$content.children().eq(1));
    },
    release: function(preventReachBottom) {
        if (void 0 !== preventReachBottom) this.toggleLoading(!preventReachBottom);
        return this._strategy.release();
    },
    toggleLoading: function(showOrHide) {
        this._reachBottomEnable(showOrHide);
    },
    isFull: function() {
        return $jFnCG(this.content()).height() > this._$container.height();
    },
    refresh: function() {
        if (!this.hasActionSubscription("onPullDown")) return;
        this._strategy.pendingRelease();
        this._pullDownLoading();
    },
    startLoading: function() {
        if (this._loadingIndicator() && this.$element().is(":visible")) this._loadPanel.show();
        this._lock();
    },
    finishLoading: function() {
        this._loadPanel.hide();
        this._unlock();
    },
    _dispose: function() {
        this._strategy.dispose();
        this.callBase();
        if (this._loadPanel) this._loadPanel.$element().remove();
    }
});
$4ZFRo("dxScrollView", $4e6bb4b3af0474b6$var$ScrollView);
module.exports = $4e6bb4b3af0474b6$var$ScrollView;

});
parcelRegister("3DqzC", function(module, exports) {
/**
 * DevExtreme (ui/scroll_view/ui.scroll_view.native.pull_down.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $eKdKS = parcelRequire("eKdKS");

var $6jr65 = parcelRequire("6jr65");

var $2L3wt = parcelRequire("2L3wt");

var $gbWer = parcelRequire("gbWer");

var $4Pwuy = parcelRequire("4Pwuy");
var $2a59a088da2d01a4$require$each = $4Pwuy.each;

var $bvcPv = parcelRequire("bvcPv");

var $2F60d = parcelRequire("2F60d");
var $2a59a088da2d01a4$require$Deferred = $2F60d.Deferred;
var $2a59a088da2d01a4$var$SCROLLVIEW_PULLDOWN_REFRESHING_CLASS = "dx-scrollview-pull-down-loading";
var $2a59a088da2d01a4$var$SCROLLVIEW_PULLDOWN_READY_CLASS = "dx-scrollview-pull-down-ready";
var $2a59a088da2d01a4$var$SCROLLVIEW_PULLDOWN_IMAGE_CLASS = "dx-scrollview-pull-down-image";
var $2a59a088da2d01a4$var$SCROLLVIEW_PULLDOWN_INDICATOR_CLASS = "dx-scrollview-pull-down-indicator";
var $2a59a088da2d01a4$var$SCROLLVIEW_PULLDOWN_TEXT_CLASS = "dx-scrollview-pull-down-text";
var $2a59a088da2d01a4$var$SCROLLVIEW_PULLDOWN_VISIBLE_TEXT_CLASS = "dx-scrollview-pull-down-text-visible";
var $2a59a088da2d01a4$var$STATE_RELEASED = 0;
var $2a59a088da2d01a4$var$STATE_READY = 1;
var $2a59a088da2d01a4$var$STATE_REFRESHING = 2;
var $2a59a088da2d01a4$var$STATE_LOADING = 3;
var $2a59a088da2d01a4$var$PULLDOWN_RELEASE_TIME = 400;
var $2a59a088da2d01a4$var$PullDownNativeScrollViewStrategy = $2L3wt.inherit({
    _init: function(scrollView) {
        this.callBase(scrollView);
        this._$topPocket = scrollView._$topPocket;
        this._$pullDown = scrollView._$pullDown;
        this._$bottomPocket = scrollView._$bottomPocket;
        this._$refreshingText = scrollView._$refreshingText;
        this._$scrollViewContent = $jFnCG(scrollView.content());
        this._initCallbacks();
    },
    _initCallbacks: function() {
        this.pullDownCallbacks = $eKdKS();
        this.releaseCallbacks = $eKdKS();
        this.reachBottomCallbacks = $eKdKS();
    },
    render: function() {
        this.callBase();
        this._renderPullDown();
        this._releaseState();
    },
    _renderPullDown: function() {
        var $image = $jFnCG("<div>").addClass($2a59a088da2d01a4$var$SCROLLVIEW_PULLDOWN_IMAGE_CLASS);
        var $loadContainer = $jFnCG("<div>").addClass($2a59a088da2d01a4$var$SCROLLVIEW_PULLDOWN_INDICATOR_CLASS);
        var $loadIndicator = new $gbWer($jFnCG("<div>")).$element();
        var $text = this._$pullDownText = $jFnCG("<div>").addClass($2a59a088da2d01a4$var$SCROLLVIEW_PULLDOWN_TEXT_CLASS);
        this._$pullingDownText = $jFnCG("<div>").text(this.option("pullingDownText")).appendTo($text);
        this._$pulledDownText = $jFnCG("<div>").text(this.option("pulledDownText")).appendTo($text);
        this._$refreshingText = $jFnCG("<div>").text(this.option("refreshingText")).appendTo($text);
        this._$pullDown.empty().append($image).append($loadContainer.append($loadIndicator)).append($text);
    },
    _releaseState: function() {
        this._state = $2a59a088da2d01a4$var$STATE_RELEASED;
        this._refreshPullDownText();
    },
    _pushBackFromBoundary: function() {
        if (!this._isLocked() && !this._component.isEmpty()) this.callBase();
    },
    _refreshPullDownText: function() {
        var that = this;
        var pullDownTextItems = [
            {
                element: this._$pullingDownText,
                visibleState: $2a59a088da2d01a4$var$STATE_RELEASED
            },
            {
                element: this._$pulledDownText,
                visibleState: $2a59a088da2d01a4$var$STATE_READY
            },
            {
                element: this._$refreshingText,
                visibleState: $2a59a088da2d01a4$var$STATE_REFRESHING
            }
        ];
        $2a59a088da2d01a4$require$each(pullDownTextItems, function(_, item) {
            var action = that._state === item.visibleState ? "addClass" : "removeClass";
            item.element[action]($2a59a088da2d01a4$var$SCROLLVIEW_PULLDOWN_VISIBLE_TEXT_CLASS);
        });
    },
    update: function() {
        this.callBase();
        this._setTopPocketOffset();
    },
    _updateDimensions: function() {
        this.callBase();
        this._topPocketSize = this._$topPocket.height();
        this._bottomPocketSize = this._$bottomPocket.height();
        if ($bvcPv.msie) this._scrollOffset = Math.round(100 * (this._$container.height() - this._$content.height())) / 100;
        else this._scrollOffset = this._$container.height() - this._$content.height();
    },
    _allowedDirections: function() {
        var allowedDirections = this.callBase();
        allowedDirections.vertical = allowedDirections.vertical || this._pullDownEnabled;
        return allowedDirections;
    },
    _setTopPocketOffset: function() {
        this._$topPocket.css({
            top: -this._topPocketSize
        });
    },
    handleEnd: function() {
        this.callBase();
        this._complete();
    },
    handleStop: function() {
        this.callBase();
        this._complete();
    },
    _complete: function() {
        if (this._state === $2a59a088da2d01a4$var$STATE_READY) {
            this._setPullDownOffset(this._topPocketSize);
            clearTimeout(this._pullDownRefreshTimeout);
            this._pullDownRefreshTimeout = setTimeout((function() {
                this._pullDownRefreshing();
            }).bind(this), 400);
        }
    },
    _setPullDownOffset: function(offset) {
        $6jr65.move(this._$topPocket, {
            top: offset
        });
        $6jr65.move(this._$scrollViewContent, {
            top: offset
        });
    },
    handleScroll: function(e) {
        this.callBase(e);
        if (this._state === $2a59a088da2d01a4$var$STATE_REFRESHING) return;
        var currentLocation = this.location().top;
        var scrollDelta = (this._location || 0) - currentLocation;
        this._location = currentLocation;
        if (this._isPullDown()) this._pullDownReady();
        else if (scrollDelta > 0 && this._isReachBottom()) this._reachBottom();
        else this._stateReleased();
    },
    _isPullDown: function() {
        return this._pullDownEnabled && this._location >= this._topPocketSize;
    },
    _isReachBottom: function() {
        return this._reachBottomEnabled && this._location - (this._scrollOffset + this._bottomPocketSize) <= .5;
    },
    _reachBottom: function() {
        if (this._state === $2a59a088da2d01a4$var$STATE_LOADING) return;
        this._state = $2a59a088da2d01a4$var$STATE_LOADING;
        this.reachBottomCallbacks.fire();
    },
    _pullDownReady: function() {
        if (this._state === $2a59a088da2d01a4$var$STATE_READY) return;
        this._state = $2a59a088da2d01a4$var$STATE_READY;
        this._$pullDown.addClass($2a59a088da2d01a4$var$SCROLLVIEW_PULLDOWN_READY_CLASS);
        this._refreshPullDownText();
    },
    _stateReleased: function() {
        if (this._state === $2a59a088da2d01a4$var$STATE_RELEASED) return;
        this._$pullDown.removeClass($2a59a088da2d01a4$var$SCROLLVIEW_PULLDOWN_REFRESHING_CLASS).removeClass($2a59a088da2d01a4$var$SCROLLVIEW_PULLDOWN_READY_CLASS);
        this._releaseState();
    },
    _pullDownRefreshing: function() {
        if (this._state === $2a59a088da2d01a4$var$STATE_REFRESHING) return;
        this._state = $2a59a088da2d01a4$var$STATE_REFRESHING;
        this._$pullDown.addClass($2a59a088da2d01a4$var$SCROLLVIEW_PULLDOWN_REFRESHING_CLASS).removeClass($2a59a088da2d01a4$var$SCROLLVIEW_PULLDOWN_READY_CLASS);
        this._refreshPullDownText();
        this.pullDownCallbacks.fire();
    },
    pullDownEnable: function(enabled) {
        if (enabled) {
            this._updateDimensions();
            this._setTopPocketOffset();
        }
        this._pullDownEnabled = enabled;
    },
    reachBottomEnable: function(enabled) {
        this._reachBottomEnabled = enabled;
    },
    pendingRelease: function() {
        this._state = $2a59a088da2d01a4$var$STATE_READY;
    },
    release: function() {
        var deferred = new $2a59a088da2d01a4$require$Deferred;
        this._updateDimensions();
        clearTimeout(this._releaseTimeout);
        if (this._state === $2a59a088da2d01a4$var$STATE_LOADING) this._state = $2a59a088da2d01a4$var$STATE_RELEASED;
        this._releaseTimeout = setTimeout((function() {
            this._setPullDownOffset(0);
            this._stateReleased();
            this.releaseCallbacks.fire();
            this._updateAction();
            deferred.resolve();
        }).bind(this), $2a59a088da2d01a4$var$PULLDOWN_RELEASE_TIME);
        return deferred.promise();
    },
    dispose: function() {
        clearTimeout(this._pullDownRefreshTimeout);
        clearTimeout(this._releaseTimeout);
        this.callBase();
    }
});
module.exports = $2a59a088da2d01a4$var$PullDownNativeScrollViewStrategy;

});
parcelRegister("2L3wt", function(module, exports) {
/**
 * DevExtreme (ui/scroll_view/ui.scrollable.native.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $2022b41fbe8f52cc$var$_renderer2 = $2022b41fbe8f52cc$var$_interopRequireDefault($jFnCG);

var $e1LMc = parcelRequire("e1LMc");
var $2022b41fbe8f52cc$var$_events_engine2 = $2022b41fbe8f52cc$var$_interopRequireDefault($e1LMc);

var $bXb2w = parcelRequire("bXb2w");
var $2022b41fbe8f52cc$var$_utils2 = $2022b41fbe8f52cc$var$_interopRequireDefault($bXb2w);

var $2Mto0 = parcelRequire("2Mto0");

var $4Pwuy = parcelRequire("4Pwuy");

var $aiwte = parcelRequire("aiwte");
var $2022b41fbe8f52cc$var$_devices2 = $2022b41fbe8f52cc$var$_interopRequireDefault($aiwte);

var $k7aJb = parcelRequire("k7aJb");
var $2022b41fbe8f52cc$var$_class2 = $2022b41fbe8f52cc$var$_interopRequireDefault($k7aJb);

var $1P6gj = parcelRequire("1P6gj");
var $2022b41fbe8f52cc$var$_ui2 = $2022b41fbe8f52cc$var$_interopRequireDefault($1P6gj);
function $2022b41fbe8f52cc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $2022b41fbe8f52cc$var$SCROLLABLE_NATIVE = "dxNativeScrollable";
var $2022b41fbe8f52cc$var$SCROLLABLE_NATIVE_CLASS = "dx-scrollable-native";
var $2022b41fbe8f52cc$var$SCROLLABLE_SCROLLBAR_SIMULATED = "dx-scrollable-scrollbar-simulated";
var $2022b41fbe8f52cc$var$SCROLLABLE_SCROLLBARS_HIDDEN = "dx-scrollable-scrollbars-hidden";
var $2022b41fbe8f52cc$var$VERTICAL = "vertical";
var $2022b41fbe8f52cc$var$HORIZONTAL = "horizontal";
var $2022b41fbe8f52cc$var$HIDE_SCROLLBAR_TIMEOUT = 500;
var $2022b41fbe8f52cc$var$NativeStrategy = $2022b41fbe8f52cc$var$_class2.default.inherit({
    ctor: function(scrollable) {
        this._init(scrollable);
    },
    _init: function(scrollable) {
        this._component = scrollable;
        this._$element = scrollable.$element();
        this._$container = scrollable._$container;
        this._$content = scrollable._$content;
        this._direction = scrollable.option("direction");
        this._useSimulatedScrollbar = scrollable.option("useSimulatedScrollbar");
        this._showScrollbar = scrollable.option("showScrollbar");
        this.option = scrollable.option.bind(scrollable);
        this._createActionByOption = scrollable._createActionByOption.bind(scrollable);
        this._isLocked = scrollable._isLocked.bind(scrollable);
        this._isDirection = scrollable._isDirection.bind(scrollable);
        this._allowedDirection = scrollable._allowedDirection.bind(scrollable);
    },
    render: function() {
        this._renderPushBackOffset();
        var device = $2022b41fbe8f52cc$var$_devices2.default.real();
        var deviceType = device.platform;
        this._$element.addClass($2022b41fbe8f52cc$var$SCROLLABLE_NATIVE_CLASS).addClass($2022b41fbe8f52cc$var$SCROLLABLE_NATIVE_CLASS + "-" + deviceType).toggleClass($2022b41fbe8f52cc$var$SCROLLABLE_SCROLLBARS_HIDDEN, !this._showScrollbar);
        if (this._showScrollbar && this._useSimulatedScrollbar) this._renderScrollbars();
    },
    updateBounds: $2Mto0.noop,
    _renderPushBackOffset: function() {
        var pushBackValue = this.option("pushBackValue");
        if (!pushBackValue && !this._component._lastPushBackValue) return;
        this._$content.css({
            paddingTop: pushBackValue,
            paddingBottom: pushBackValue
        });
        this._component._lastPushBackValue = pushBackValue;
    },
    _renderScrollbars: function() {
        this._scrollbars = {};
        this._hideScrollbarTimeout = 0;
        this._$element.addClass($2022b41fbe8f52cc$var$SCROLLABLE_SCROLLBAR_SIMULATED);
        this._renderScrollbar($2022b41fbe8f52cc$var$VERTICAL);
        this._renderScrollbar($2022b41fbe8f52cc$var$HORIZONTAL);
    },
    _renderScrollbar: function(direction) {
        if (!this._isDirection(direction)) return;
        this._scrollbars[direction] = new $2022b41fbe8f52cc$var$_ui2.default((0, $2022b41fbe8f52cc$var$_renderer2.default)("<div>").appendTo(this._$element), {
            direction: direction,
            expandable: this._component.option("scrollByThumb")
        });
    },
    handleInit: $2Mto0.noop,
    handleStart: function() {
        this._disablePushBack = true;
    },
    handleMove: function(e) {
        if (this._isLocked()) {
            e.cancel = true;
            return;
        }
        if (this._allowedDirection()) e.originalEvent.isScrollingEvent = true;
    },
    handleEnd: function() {
        this._disablePushBack = false;
    },
    handleCancel: $2Mto0.noop,
    handleStop: $2Mto0.noop,
    _eachScrollbar: function(callback) {
        callback = callback.bind(this);
        (0, $4Pwuy.each)(this._scrollbars || {}, function(direction, scrollbar) {
            callback(scrollbar, direction);
        });
    },
    createActions: function() {
        this._scrollAction = this._createActionByOption("onScroll");
        this._updateAction = this._createActionByOption("onUpdated");
    },
    _createActionArgs: function() {
        var location = this.location();
        var containerElement = this._$container.get(0);
        return {
            event: this._eventForUserAction,
            scrollOffset: {
                top: -location.top,
                left: -location.left
            },
            reachedLeft: this._isDirection($2022b41fbe8f52cc$var$HORIZONTAL) ? location.left >= 0 : void 0,
            reachedRight: this._isDirection($2022b41fbe8f52cc$var$HORIZONTAL) ? Math.abs(location.left) >= containerElement.scrollWidth - containerElement.clientWidth : void 0,
            reachedTop: this._isDirection($2022b41fbe8f52cc$var$VERTICAL) ? location.top >= 0 : void 0,
            reachedBottom: this._isDirection($2022b41fbe8f52cc$var$VERTICAL) ? Math.abs(location.top) >= containerElement.scrollHeight - containerElement.clientHeight - 2 * this.option("pushBackValue") : void 0
        };
    },
    handleScroll: function(e) {
        if (!this._isScrollLocationChanged()) {
            e.stopImmediatePropagation();
            return;
        }
        this._eventForUserAction = e;
        this._moveScrollbars();
        this._scrollAction(this._createActionArgs());
        this._lastLocation = this.location();
        this._pushBackFromBoundary();
    },
    _pushBackFromBoundary: function() {
        var pushBackValue = this.option("pushBackValue");
        if (!pushBackValue || this._disablePushBack) return;
        var scrollOffset = this._containerSize.height - this._contentSize.height;
        var scrollTopPos = this._$container.scrollTop();
        var scrollBottomPos = scrollOffset + scrollTopPos - 2 * pushBackValue;
        if (!scrollTopPos) this._$container.scrollTop(pushBackValue);
        else if (!scrollBottomPos) this._$container.scrollTop(pushBackValue - scrollOffset);
    },
    _isScrollLocationChanged: function() {
        var currentLocation = this.location();
        var lastLocation = this._lastLocation || {};
        var isTopChanged = lastLocation.top !== currentLocation.top;
        var isLeftChanged = lastLocation.left !== currentLocation.left;
        return isTopChanged || isLeftChanged;
    },
    _moveScrollbars: function() {
        this._eachScrollbar(function(scrollbar) {
            scrollbar.moveTo(this.location());
            scrollbar.option("visible", true);
        });
        this._hideScrollbars();
    },
    _hideScrollbars: function() {
        clearTimeout(this._hideScrollbarTimeout);
        this._hideScrollbarTimeout = setTimeout((function() {
            this._eachScrollbar(function(scrollbar) {
                scrollbar.option("visible", false);
            });
        }).bind(this), $2022b41fbe8f52cc$var$HIDE_SCROLLBAR_TIMEOUT);
    },
    location: function() {
        return {
            left: -this._$container.scrollLeft(),
            top: this.option("pushBackValue") - this._$container.scrollTop()
        };
    },
    disabledChanged: $2Mto0.noop,
    update: function() {
        this._update();
        this._updateAction(this._createActionArgs());
    },
    _update: function() {
        this._updateDimensions();
        this._updateScrollbars();
    },
    _updateDimensions: function() {
        this._containerSize = {
            height: this._$container.height(),
            width: this._$container.width()
        };
        this._componentContentSize = {
            height: this._component.$content().height(),
            width: this._component.$content().width()
        };
        this._contentSize = {
            height: this._$content.height(),
            width: this._$content.width()
        };
        this._pushBackFromBoundary();
    },
    _updateScrollbars: function() {
        this._eachScrollbar(function(scrollbar, direction) {
            var dimension = direction === $2022b41fbe8f52cc$var$VERTICAL ? "height" : "width";
            scrollbar.option({
                containerSize: this._containerSize[dimension],
                contentSize: this._componentContentSize[dimension]
            });
            scrollbar.update();
        });
    },
    _allowedDirections: function() {
        return {
            vertical: this._isDirection($2022b41fbe8f52cc$var$VERTICAL) && this._contentSize.height > this._containerSize.height,
            horizontal: this._isDirection($2022b41fbe8f52cc$var$HORIZONTAL) && this._contentSize.width > this._containerSize.width
        };
    },
    dispose: function() {
        var className = this._$element.get(0).className;
        var scrollableNativeRegexp = new RegExp($2022b41fbe8f52cc$var$SCROLLABLE_NATIVE_CLASS + "\\S*", "g");
        if (scrollableNativeRegexp.test(className)) this._$element.removeClass(className.match(scrollableNativeRegexp).join(" "));
        $2022b41fbe8f52cc$var$_events_engine2.default.off(this._$element, "." + $2022b41fbe8f52cc$var$SCROLLABLE_NATIVE);
        $2022b41fbe8f52cc$var$_events_engine2.default.off(this._$container, "." + $2022b41fbe8f52cc$var$SCROLLABLE_NATIVE);
        this._removeScrollbars();
        clearTimeout(this._hideScrollbarTimeout);
    },
    _removeScrollbars: function() {
        this._eachScrollbar(function(scrollbar) {
            scrollbar.$element().remove();
        });
    },
    scrollBy: function(distance) {
        var location = this.location();
        this._$container.scrollTop(Math.round(-location.top - distance.top + this.option("pushBackValue")));
        this._$container.scrollLeft(Math.round(-location.left - distance.left));
    },
    validate: function(e) {
        if (this.option("disabled")) return false;
        if ($2022b41fbe8f52cc$var$_utils2.default.isDxMouseWheelEvent(e) && this._isScrolledInMaxDirection(e)) return false;
        return !!this._allowedDirection();
    },
    _isScrolledInMaxDirection: function(e) {
        var container = this._$container.get(0);
        var result;
        if (e.delta > 0) result = e.shiftKey ? !container.scrollLeft : !container.scrollTop;
        else if (e.shiftKey) result = container.clientWidth + container.scrollLeft >= container.scrollWidth;
        else result = container.clientHeight + container.scrollTop >= container.scrollHeight;
        return result;
    },
    getDirection: function() {
        return this._allowedDirection();
    },
    verticalOffset: function() {
        return this.option("pushBackValue");
    }
});
module.exports = $2022b41fbe8f52cc$var$NativeStrategy;

});
parcelRegister("1P6gj", function(module, exports) {
/**
 * DevExtreme (ui/scroll_view/ui.scrollbar.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $153f6963f4af9a94$var$_renderer2 = $153f6963f4af9a94$var$_interopRequireDefault($jFnCG);

var $445Bz = parcelRequire("445Bz");
var $153f6963f4af9a94$var$_dom_adapter2 = $153f6963f4af9a94$var$_interopRequireDefault($445Bz);

var $e1LMc = parcelRequire("e1LMc");
var $153f6963f4af9a94$var$_events_engine2 = $153f6963f4af9a94$var$_interopRequireDefault($e1LMc);

var $g4e4U = parcelRequire("g4e4U");
var $153f6963f4af9a94$var$_ready_callbacks2 = $153f6963f4af9a94$var$_interopRequireDefault($g4e4U);

var $6jr65 = parcelRequire("6jr65");
var $153f6963f4af9a94$var$_translator2 = $153f6963f4af9a94$var$_interopRequireDefault($6jr65);

var $4gmvS = parcelRequire("4gmvS");
var $153f6963f4af9a94$var$_ui2 = $153f6963f4af9a94$var$_interopRequireDefault($4gmvS);

var $bXb2w = parcelRequire("bXb2w");
var $153f6963f4af9a94$var$_utils2 = $153f6963f4af9a94$var$_interopRequireDefault($bXb2w);

var $2Mto0 = parcelRequire("2Mto0");
var $153f6963f4af9a94$var$_common2 = $153f6963f4af9a94$var$_interopRequireDefault($2Mto0);

var $kDRxH = parcelRequire("kDRxH");

var $7I8Uw = parcelRequire("7I8Uw");

var $gP4Gh = parcelRequire("gP4Gh");
var $153f6963f4af9a94$var$_pointer2 = $153f6963f4af9a94$var$_interopRequireDefault($gP4Gh);
function $153f6963f4af9a94$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $153f6963f4af9a94$var$SCROLLBAR = "dxScrollbar";
var $153f6963f4af9a94$var$SCROLLABLE_SCROLLBAR_CLASS = "dx-scrollable-scrollbar";
var $153f6963f4af9a94$var$SCROLLABLE_SCROLLBAR_ACTIVE_CLASS = "".concat($153f6963f4af9a94$var$SCROLLABLE_SCROLLBAR_CLASS, "-active");
var $153f6963f4af9a94$var$SCROLLABLE_SCROLL_CLASS = "dx-scrollable-scroll";
var $153f6963f4af9a94$var$SCROLLABLE_SCROLL_CONTENT_CLASS = "dx-scrollable-scroll-content";
var $153f6963f4af9a94$var$HOVER_ENABLED_STATE = "dx-scrollbar-hoverable";
var $153f6963f4af9a94$var$HORIZONTAL = "horizontal";
var $153f6963f4af9a94$var$THUMB_MIN_SIZE = 15;
var $153f6963f4af9a94$var$SCROLLBAR_VISIBLE = {
    onScroll: "onScroll",
    onHover: "onHover",
    always: "always",
    never: "never"
};
var $153f6963f4af9a94$var$Scrollbar = $153f6963f4af9a94$var$_ui2.default.inherit({
    _getDefaultOptions: function() {
        return (0, $7I8Uw.extend)(this.callBase(), {
            direction: null,
            visible: false,
            activeStateEnabled: false,
            visibilityMode: $153f6963f4af9a94$var$SCROLLBAR_VISIBLE.onScroll,
            containerSize: 0,
            contentSize: 0,
            expandable: true,
            scaleRatio: 1
        });
    },
    _init: function() {
        this.callBase();
        this._isHovered = false;
    },
    _initMarkup: function() {
        this._renderThumb();
        this.callBase();
    },
    _render: function() {
        this.callBase();
        this._renderDirection();
        this._update();
        this._attachPointerDownHandler();
        this.option("hoverStateEnabled", this._isHoverMode());
        this.$element().toggleClass($153f6963f4af9a94$var$HOVER_ENABLED_STATE, this.option("hoverStateEnabled"));
    },
    _renderThumb: function() {
        this._$thumb = (0, $153f6963f4af9a94$var$_renderer2.default)("<div>").addClass($153f6963f4af9a94$var$SCROLLABLE_SCROLL_CLASS);
        (0, $153f6963f4af9a94$var$_renderer2.default)("<div>").addClass($153f6963f4af9a94$var$SCROLLABLE_SCROLL_CONTENT_CLASS).appendTo(this._$thumb);
        this.$element().addClass($153f6963f4af9a94$var$SCROLLABLE_SCROLLBAR_CLASS).append(this._$thumb);
    },
    isThumb: function($element) {
        return !!this.$element().find($element).length;
    },
    _isHoverMode: function() {
        var visibilityMode = this.option("visibilityMode");
        return (visibilityMode === $153f6963f4af9a94$var$SCROLLBAR_VISIBLE.onHover || visibilityMode === $153f6963f4af9a94$var$SCROLLBAR_VISIBLE.always) && this.option("expandable");
    },
    _renderDirection: function() {
        var direction = this.option("direction");
        this.$element().addClass("dx-scrollbar-" + direction);
        this._dimension = direction === $153f6963f4af9a94$var$HORIZONTAL ? "width" : "height";
        this._prop = direction === $153f6963f4af9a94$var$HORIZONTAL ? "left" : "top";
    },
    _attachPointerDownHandler: function() {
        $153f6963f4af9a94$var$_events_engine2.default.on(this._$thumb, $153f6963f4af9a94$var$_utils2.default.addNamespace($153f6963f4af9a94$var$_pointer2.default.down, $153f6963f4af9a94$var$SCROLLBAR), this.feedbackOn.bind(this));
    },
    feedbackOn: function() {
        this.$element().addClass($153f6963f4af9a94$var$SCROLLABLE_SCROLLBAR_ACTIVE_CLASS);
        $153f6963f4af9a94$var$activeScrollbar = this;
    },
    feedbackOff: function() {
        this.$element().removeClass($153f6963f4af9a94$var$SCROLLABLE_SCROLLBAR_ACTIVE_CLASS);
        $153f6963f4af9a94$var$activeScrollbar = null;
    },
    cursorEnter: function() {
        this._isHovered = true;
        if (this._needScrollbar()) this.option("visible", true);
    },
    cursorLeave: function() {
        this._isHovered = false;
        this.option("visible", false);
    },
    _renderDimensions: function() {
        this._$thumb.css({
            width: this.option("width"),
            height: this.option("height")
        });
    },
    _toggleVisibility: function(visible) {
        if (this.option("visibilityMode") === $153f6963f4af9a94$var$SCROLLBAR_VISIBLE.onScroll) this._$thumb.css("opacity");
        visible = this._adjustVisibility(visible);
        this.option().visible = visible;
        this._$thumb.toggleClass("dx-state-invisible", !visible);
    },
    _adjustVisibility: function(visible) {
        if (this._baseContainerToContentRatio && !this._needScrollbar()) return false;
        switch(this.option("visibilityMode")){
            case $153f6963f4af9a94$var$SCROLLBAR_VISIBLE.onScroll:
                break;
            case $153f6963f4af9a94$var$SCROLLBAR_VISIBLE.onHover:
                visible = visible || !!this._isHovered;
                break;
            case $153f6963f4af9a94$var$SCROLLBAR_VISIBLE.never:
                visible = false;
                break;
            case $153f6963f4af9a94$var$SCROLLBAR_VISIBLE.always:
                visible = true;
        }
        return visible;
    },
    moveTo: function(location) {
        if (this._isHidden()) return;
        if ((0, $kDRxH.isPlainObject)(location)) location = location[this._prop] || 0;
        var scrollBarLocation = {};
        scrollBarLocation[this._prop] = this._calculateScrollBarPosition(location);
        $153f6963f4af9a94$var$_translator2.default.move(this._$thumb, scrollBarLocation);
    },
    _calculateScrollBarPosition: function(location) {
        return -location * this._thumbRatio;
    },
    _update: function() {
        var containerSize = Math.round(this.option("containerSize"));
        var contentSize = Math.round(this.option("contentSize"));
        var baseContainerSize = Math.round(this.option("baseContainerSize"));
        var baseContentSize = Math.round(this.option("baseContentSize"));
        if (isNaN(baseContainerSize)) {
            baseContainerSize = containerSize;
            baseContentSize = contentSize;
        }
        this._baseContainerToContentRatio = baseContentSize ? baseContainerSize / baseContentSize : baseContainerSize;
        this._realContainerToContentRatio = contentSize ? containerSize / contentSize : containerSize;
        var thumbSize = Math.round(Math.max(Math.round(containerSize * this._realContainerToContentRatio), $153f6963f4af9a94$var$THUMB_MIN_SIZE));
        this._thumbRatio = (containerSize - thumbSize) / (this.option("scaleRatio") * (contentSize - containerSize));
        this.option(this._dimension, thumbSize / this.option("scaleRatio"));
        this.$element().css("display", this._needScrollbar() ? "" : "none");
    },
    _isHidden: function() {
        return this.option("visibilityMode") === $153f6963f4af9a94$var$SCROLLBAR_VISIBLE.never;
    },
    _needScrollbar: function() {
        return !this._isHidden() && this._baseContainerToContentRatio < 1;
    },
    containerToContentRatio: function() {
        return this._realContainerToContentRatio;
    },
    _normalizeSize: function(size) {
        return (0, $kDRxH.isPlainObject)(size) ? size[this._dimension] || 0 : size;
    },
    _clean: function() {
        this.callBase();
        if (this === $153f6963f4af9a94$var$activeScrollbar) $153f6963f4af9a94$var$activeScrollbar = null;
        $153f6963f4af9a94$var$_events_engine2.default.off(this._$thumb, "." + $153f6963f4af9a94$var$SCROLLBAR);
    },
    _optionChanged: function(args) {
        if (this._isHidden()) return;
        switch(args.name){
            case "containerSize":
            case "contentSize":
                this.option()[args.name] = this._normalizeSize(args.value);
                this._update();
                break;
            case "baseContentSize":
            case "baseContainerSize":
                this._update();
                break;
            case "visibilityMode":
            case "direction":
                this._invalidate();
                break;
            case "scaleRatio":
                this._update();
                break;
            default:
                this.callBase.apply(this, arguments);
        }
    },
    update: $153f6963f4af9a94$var$_common2.default.deferRenderer(function() {
        this._adjustVisibility() && this.option("visible", true);
    })
});
var $153f6963f4af9a94$var$activeScrollbar = null;
$153f6963f4af9a94$var$_ready_callbacks2.default.add(function() {
    $153f6963f4af9a94$var$_events_engine2.default.subscribeGlobal($153f6963f4af9a94$var$_dom_adapter2.default.getDocument(), $153f6963f4af9a94$var$_utils2.default.addNamespace($153f6963f4af9a94$var$_pointer2.default.up, $153f6963f4af9a94$var$SCROLLBAR), function() {
        if ($153f6963f4af9a94$var$activeScrollbar) $153f6963f4af9a94$var$activeScrollbar.feedbackOff();
    });
});
module.exports = $153f6963f4af9a94$var$Scrollbar;

});


parcelRegister("gbWer", function(module, exports) {
/**
 * DevExtreme (ui/load_indicator.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $irv64 = parcelRequire("irv64");
var $bc9ad81030487d28$var$navigator = $irv64.getNavigator();

var $6VAWB = parcelRequire("6VAWB");

var $3LUJe = parcelRequire("3LUJe");

var $7I8Uw = parcelRequire("7I8Uw");
var $bc9ad81030487d28$require$extend = $7I8Uw.extend;

var $aiwte = parcelRequire("aiwte");

var $4ZFRo = parcelRequire("4ZFRo");

var $4gmvS = parcelRequire("4gmvS");
var $bc9ad81030487d28$var$LOADINDICATOR_CLASS = "dx-loadindicator";
var $bc9ad81030487d28$var$LOADINDICATOR_WRAPPER_CLASS = "dx-loadindicator-wrapper";
var $bc9ad81030487d28$var$LOADINDICATOR_CONTENT_CLASS = "dx-loadindicator-content";
var $bc9ad81030487d28$var$LOADINDICATOR_ICON_CLASS = "dx-loadindicator-icon";
var $bc9ad81030487d28$var$LOADINDICATOR_SEGMENT_CLASS = "dx-loadindicator-segment";
var $bc9ad81030487d28$var$LOADINDICATOR_SEGMENT_INNER_CLASS = "dx-loadindicator-segment-inner";
var $bc9ad81030487d28$var$LOADINDICATOR_IMAGE_CLASS = "dx-loadindicator-image";
var $bc9ad81030487d28$var$LoadIndicator = $4gmvS.inherit({
    _getDefaultOptions: function() {
        return $bc9ad81030487d28$require$extend(this.callBase(), {
            indicatorSrc: "",
            activeStateEnabled: false,
            hoverStateEnabled: false,
            _animatingSegmentCount: 1,
            _animatingSegmentInner: false
        });
    },
    _defaultOptionsRules: function() {
        var themeName = $3LUJe.current();
        return this.callBase().concat([
            {
                device: function() {
                    var realDevice = $aiwte.real();
                    var obsoleteAndroid = "android" === realDevice.platform && !/chrome/i.test($bc9ad81030487d28$var$navigator.userAgent);
                    return obsoleteAndroid;
                },
                options: {
                    viaImage: true
                }
            },
            {
                device: function() {
                    return $3LUJe.isIos7(themeName);
                },
                options: {
                    _animatingSegmentCount: 11
                }
            },
            {
                device: function() {
                    return $3LUJe.isMaterial(themeName);
                },
                options: {
                    _animatingSegmentCount: 2,
                    _animatingSegmentInner: true
                }
            },
            {
                device: function() {
                    return $3LUJe.isGeneric(themeName);
                },
                options: {
                    _animatingSegmentCount: 7
                }
            }
        ]);
    },
    _init: function() {
        this.callBase();
        this.$element().addClass($bc9ad81030487d28$var$LOADINDICATOR_CLASS);
    },
    _initMarkup: function() {
        this.callBase();
        this._renderWrapper();
        this._renderIndicatorContent();
        this._renderMarkup();
    },
    _renderWrapper: function() {
        this._$wrapper = $jFnCG("<div>").addClass($bc9ad81030487d28$var$LOADINDICATOR_WRAPPER_CLASS);
        this.$element().append(this._$wrapper);
    },
    _renderIndicatorContent: function() {
        this._$content = $jFnCG("<div>").addClass($bc9ad81030487d28$var$LOADINDICATOR_CONTENT_CLASS);
        this._$wrapper.append(this._$content);
    },
    _renderMarkup: function() {
        if ($6VAWB.animation() && !this.option("viaImage") && !this.option("indicatorSrc")) this._renderMarkupForAnimation();
        else this._renderMarkupForImage();
    },
    _renderMarkupForAnimation: function() {
        var animatingSegmentInner = this.option("_animatingSegmentInner");
        this._$indicator = $jFnCG("<div>").addClass($bc9ad81030487d28$var$LOADINDICATOR_ICON_CLASS);
        this._$content.append(this._$indicator);
        for(var i = this.option("_animatingSegmentCount"); i >= 0; --i){
            var $segment = $jFnCG("<div>").addClass($bc9ad81030487d28$var$LOADINDICATOR_SEGMENT_CLASS).addClass($bc9ad81030487d28$var$LOADINDICATOR_SEGMENT_CLASS + i);
            if (animatingSegmentInner) $segment.append($jFnCG("<div>").addClass($bc9ad81030487d28$var$LOADINDICATOR_SEGMENT_INNER_CLASS));
            this._$indicator.append($segment);
        }
    },
    _renderMarkupForImage: function() {
        var indicatorSrc = this.option("indicatorSrc");
        this._$wrapper.addClass($bc9ad81030487d28$var$LOADINDICATOR_IMAGE_CLASS);
        if (indicatorSrc) this._$wrapper.css("backgroundImage", "url(" + indicatorSrc + ")");
    },
    _renderDimensions: function() {
        this.callBase();
        this._updateContentSizeForAnimation();
    },
    _updateContentSizeForAnimation: function() {
        if (!this._$indicator) return;
        var width = this.option("width");
        var height = this.option("height");
        if (width || height) {
            width = this.$element().width();
            height = this.$element().height();
            var minDimension = Math.min(height, width);
            this._$wrapper.css({
                height: minDimension,
                width: minDimension,
                fontSize: minDimension
            });
        }
    },
    _clean: function() {
        this.callBase();
        this._removeMarkupForAnimation();
        this._removeMarkupForImage();
    },
    _removeMarkupForAnimation: function() {
        if (!this._$indicator) return;
        this._$indicator.remove();
        delete this._$indicator;
    },
    _removeMarkupForImage: function() {
        this._$wrapper.css("backgroundImage", "none");
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "_animatingSegmentCount":
            case "_animatingSegmentInner":
            case "indicatorSrc":
                this._invalidate();
                break;
            default:
                this.callBase(args);
        }
    }
});
$4ZFRo("dxLoadIndicator", $bc9ad81030487d28$var$LoadIndicator);
module.exports = $bc9ad81030487d28$var$LoadIndicator;
module.exports.default = module.exports;

});


parcelRegister("2jCgQ", function(module, exports) {
/**
 * DevExtreme (ui/scroll_view/ui.scroll_view.native.swipe_down.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $eKdKS = parcelRequire("eKdKS");

var $6jr65 = parcelRequire("6jr65");

var $bXb2w = parcelRequire("bXb2w");

var $2L3wt = parcelRequire("2L3wt");

var $gbWer = parcelRequire("gbWer");

var $2F60d = parcelRequire("2F60d");
var $1afb0adb7eae67ed$require$Deferred = $2F60d.Deferred;
var $1afb0adb7eae67ed$var$SCROLLVIEW_PULLDOWN_DOWN_LOADING_CLASS = "dx-scrollview-pull-down-loading";
var $1afb0adb7eae67ed$var$SCROLLVIEW_PULLDOWN_INDICATOR_CLASS = "dx-scrollview-pull-down-indicator";
var $1afb0adb7eae67ed$var$SCROLLVIEW_PULLDOWN_REFRESHING_CLASS = "dx-scrollview-pull-down-refreshing";
var $1afb0adb7eae67ed$var$PULLDOWN_ICON_CLASS = "dx-icon-pulldown";
var $1afb0adb7eae67ed$var$STATE_RELEASED = 0;
var $1afb0adb7eae67ed$var$STATE_READY = 1;
var $1afb0adb7eae67ed$var$STATE_REFRESHING = 2;
var $1afb0adb7eae67ed$var$STATE_TOUCHED = 4;
var $1afb0adb7eae67ed$var$STATE_PULLED = 5;
var $1afb0adb7eae67ed$var$SwipeDownNativeScrollViewStrategy = $2L3wt.inherit({
    _init: function(scrollView) {
        this.callBase(scrollView);
        this._$topPocket = scrollView._$topPocket;
        this._$bottomPocket = scrollView._$bottomPocket;
        this._$pullDown = scrollView._$pullDown;
        this._$scrollViewContent = scrollView.content();
        this._initCallbacks();
        this._location = 0;
    },
    _initCallbacks: function() {
        this.pullDownCallbacks = $eKdKS();
        this.releaseCallbacks = $eKdKS();
        this.reachBottomCallbacks = $eKdKS();
    },
    render: function() {
        this.callBase();
        this._renderPullDown();
        this._releaseState();
    },
    _renderPullDown: function() {
        var $loadContainer = $jFnCG("<div>").addClass($1afb0adb7eae67ed$var$SCROLLVIEW_PULLDOWN_INDICATOR_CLASS);
        var $loadIndicator = new $gbWer($jFnCG("<div>")).$element();
        this._$icon = $jFnCG("<div>").addClass($1afb0adb7eae67ed$var$PULLDOWN_ICON_CLASS);
        this._$pullDown.empty().append(this._$icon).append($loadContainer.append($loadIndicator));
    },
    _releaseState: function() {
        this._state = $1afb0adb7eae67ed$var$STATE_RELEASED;
        this._releasePullDown();
        this._updateDimensions();
    },
    _releasePullDown: function() {
        this._$pullDown.css({
            opacity: 0
        });
    },
    _updateDimensions: function() {
        this.callBase();
        this._topPocketSize = this._$topPocket.height();
        this._bottomPocketSize = this._$bottomPocket.height();
        this._scrollOffset = this._$container.height() - this._$content.height();
    },
    _allowedDirections: function() {
        var allowedDirections = this.callBase();
        allowedDirections.vertical = allowedDirections.vertical || this._pullDownEnabled;
        return allowedDirections;
    },
    handleInit: function(e) {
        this.callBase(e);
        if (this._state === $1afb0adb7eae67ed$var$STATE_RELEASED && 0 === this._location) {
            this._startClientY = $bXb2w.eventData(e.originalEvent).y;
            this._state = $1afb0adb7eae67ed$var$STATE_TOUCHED;
        }
    },
    handleMove: function(e) {
        this.callBase(e);
        this._deltaY = $bXb2w.eventData(e.originalEvent).y - this._startClientY;
        if (this._state === $1afb0adb7eae67ed$var$STATE_TOUCHED) {
            if (this._pullDownEnabled && this._deltaY > 0) this._state = $1afb0adb7eae67ed$var$STATE_PULLED;
            else this._complete();
        }
        if (this._state === $1afb0adb7eae67ed$var$STATE_PULLED) {
            e.preventDefault();
            this._movePullDown();
        }
    },
    _movePullDown: function() {
        var pullDownHeight = this._getPullDownHeight();
        var top = Math.min(3 * pullDownHeight, this._deltaY + this._getPullDownStartPosition());
        var angle = 180 * top / pullDownHeight / 3;
        this._$pullDown.css({
            opacity: 1
        }).toggleClass($1afb0adb7eae67ed$var$SCROLLVIEW_PULLDOWN_REFRESHING_CLASS, top < pullDownHeight);
        $6jr65.move(this._$pullDown, {
            top: top
        });
        this._$icon.css({
            transform: "rotate(" + angle + "deg)"
        });
    },
    _isPullDown: function() {
        return this._pullDownEnabled && this._state === $1afb0adb7eae67ed$var$STATE_PULLED && this._deltaY >= this._getPullDownHeight() - this._getPullDownStartPosition();
    },
    _getPullDownHeight: function() {
        return Math.round(.05 * this._$element.outerHeight());
    },
    _getPullDownStartPosition: function() {
        return -Math.round(1.5 * this._$pullDown.outerHeight());
    },
    handleEnd: function() {
        if (this._isPullDown()) this._pullDownRefreshing();
        this._complete();
    },
    handleStop: function() {
        this._complete();
    },
    _complete: function() {
        if (this._state === $1afb0adb7eae67ed$var$STATE_TOUCHED || this._state === $1afb0adb7eae67ed$var$STATE_PULLED) this._releaseState();
    },
    handleScroll: function(e) {
        this.callBase(e);
        if (this._state === $1afb0adb7eae67ed$var$STATE_REFRESHING) return;
        var currentLocation = this.location().top;
        var scrollDelta = this._location - currentLocation;
        this._location = currentLocation;
        if (scrollDelta > 0 && this._isReachBottom()) this._reachBottom();
        else this._stateReleased();
    },
    _isReachBottom: function() {
        return this._reachBottomEnabled && this._location <= this._scrollOffset + this._bottomPocketSize;
    },
    _reachBottom: function() {
        this.reachBottomCallbacks.fire();
    },
    _stateReleased: function() {
        if (this._state === $1afb0adb7eae67ed$var$STATE_RELEASED) return;
        this._$pullDown.removeClass($1afb0adb7eae67ed$var$SCROLLVIEW_PULLDOWN_DOWN_LOADING_CLASS);
        this._releaseState();
    },
    _pullDownRefreshing: function() {
        this._state = $1afb0adb7eae67ed$var$STATE_REFRESHING;
        this._pullDownRefreshHandler();
    },
    _pullDownRefreshHandler: function() {
        this._refreshPullDown();
        this.pullDownCallbacks.fire();
    },
    _refreshPullDown: function() {
        this._$pullDown.addClass($1afb0adb7eae67ed$var$SCROLLVIEW_PULLDOWN_DOWN_LOADING_CLASS);
        $6jr65.move(this._$pullDown, {
            top: this._getPullDownHeight()
        });
    },
    pullDownEnable: function(enabled) {
        this._$topPocket.toggle(enabled);
        this._pullDownEnabled = enabled;
    },
    reachBottomEnable: function(enabled) {
        this._reachBottomEnabled = enabled;
    },
    pendingRelease: function() {
        this._state = $1afb0adb7eae67ed$var$STATE_READY;
    },
    release: function() {
        var deferred = new $1afb0adb7eae67ed$require$Deferred;
        this._updateDimensions();
        clearTimeout(this._releaseTimeout);
        this._releaseTimeout = setTimeout((function() {
            this._stateReleased();
            this.releaseCallbacks.fire();
            this._updateAction();
            deferred.resolve();
        }).bind(this), 800);
        return deferred.promise();
    },
    dispose: function() {
        clearTimeout(this._pullDownRefreshTimeout);
        clearTimeout(this._releaseTimeout);
        this.callBase();
    }
});
module.exports = $1afb0adb7eae67ed$var$SwipeDownNativeScrollViewStrategy;

});

parcelRegister("lNWpl", function(module, exports) {
/**
 * DevExtreme (ui/scroll_view/ui.scroll_view.simulated.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $eKdKS = parcelRequire("eKdKS");

var $4Pwuy = parcelRequire("4Pwuy");
var $fdfb7b26d173bffe$require$each = $4Pwuy.each;

var $2Mto0 = parcelRequire("2Mto0");

var $7I8Uw = parcelRequire("7I8Uw");
var $fdfb7b26d173bffe$require$extend = $7I8Uw.extend;
var $fdfb7b26d173bffe$var$math = Math;

var $4pkTa = parcelRequire("4pkTa");

var $gbWer = parcelRequire("gbWer");
var $fdfb7b26d173bffe$var$SCROLLVIEW_PULLDOWN_REFRESHING_CLASS = "dx-scrollview-pull-down-loading";
var $fdfb7b26d173bffe$var$SCROLLVIEW_PULLDOWN_READY_CLASS = "dx-scrollview-pull-down-ready";
var $fdfb7b26d173bffe$var$SCROLLVIEW_PULLDOWN_IMAGE_CLASS = "dx-scrollview-pull-down-image";
var $fdfb7b26d173bffe$var$SCROLLVIEW_PULLDOWN_INDICATOR_CLASS = "dx-scrollview-pull-down-indicator";
var $fdfb7b26d173bffe$var$SCROLLVIEW_PULLDOWN_TEXT_CLASS = "dx-scrollview-pull-down-text";
var $fdfb7b26d173bffe$var$SCROLLVIEW_PULLDOWN_VISIBLE_TEXT_CLASS = "dx-scrollview-pull-down-text-visible";
var $fdfb7b26d173bffe$var$STATE_RELEASED = 0;
var $fdfb7b26d173bffe$var$STATE_READY = 1;
var $fdfb7b26d173bffe$var$STATE_REFRESHING = 2;
var $fdfb7b26d173bffe$var$STATE_LOADING = 3;
var $fdfb7b26d173bffe$var$ScrollViewScroller = $4pkTa.Scroller.inherit({
    ctor: function() {
        this._topPocketSize = 0;
        this.callBase.apply(this, arguments);
        this._initCallbacks();
        this._releaseState();
    },
    _releaseState: function() {
        this._state = $fdfb7b26d173bffe$var$STATE_RELEASED;
        this._refreshPullDownText();
    },
    _refreshPullDownText: function() {
        var that = this;
        var pullDownTextItems = [
            {
                element: this._$pullingDownText,
                visibleState: $fdfb7b26d173bffe$var$STATE_RELEASED
            },
            {
                element: this._$pulledDownText,
                visibleState: $fdfb7b26d173bffe$var$STATE_READY
            },
            {
                element: this._$refreshingText,
                visibleState: $fdfb7b26d173bffe$var$STATE_REFRESHING
            }
        ];
        $fdfb7b26d173bffe$require$each(pullDownTextItems, function(_, item) {
            var action = that._state === item.visibleState ? "addClass" : "removeClass";
            item.element[action]($fdfb7b26d173bffe$var$SCROLLVIEW_PULLDOWN_VISIBLE_TEXT_CLASS);
        });
    },
    _initCallbacks: function() {
        this.pullDownCallbacks = $eKdKS();
        this.releaseCallbacks = $eKdKS();
        this.reachBottomCallbacks = $eKdKS();
    },
    _updateBounds: function() {
        var considerPockets = "horizontal" !== this._direction;
        this._topPocketSize = considerPockets ? Math.round(this._$topPocket[this._dimension]()) : 0;
        this._bottomPocketSize = considerPockets ? Math.round(this._$bottomPocket[this._dimension]()) : 0;
        this.callBase();
        this._bottomBound = this._minOffset + this._bottomPocketSize;
    },
    _updateScrollbar: function() {
        this._scrollbar.option({
            containerSize: this._containerSize(),
            contentSize: this._contentSize() - this._topPocketSize - this._bottomPocketSize,
            scaleRatio: this._getScaleRatio()
        });
    },
    _moveContent: function() {
        this.callBase();
        if (this._isPullDown()) this._pullDownReady();
        else {
            if (this._isReachBottom()) this._reachBottomReady();
            else if (this._state !== $fdfb7b26d173bffe$var$STATE_RELEASED) this._stateReleased();
        }
    },
    _moveScrollbar: function() {
        this._scrollbar.moveTo(this._topPocketSize + this._location);
    },
    _isPullDown: function() {
        return this._pullDownEnabled && this._location >= 0;
    },
    _isReachBottom: function() {
        return this._reachBottomEnabled && this._location - this._bottomBound <= .5;
    },
    _scrollComplete: function() {
        if (this._inBounds() && this._state === $fdfb7b26d173bffe$var$STATE_READY) this._pullDownRefreshing();
        else if (this._inBounds() && this._state === $fdfb7b26d173bffe$var$STATE_LOADING) this._reachBottomLoading();
        else this.callBase();
    },
    _reachBottomReady: function() {
        if (this._state === $fdfb7b26d173bffe$var$STATE_LOADING) return;
        this._state = $fdfb7b26d173bffe$var$STATE_LOADING;
        this._minOffset = this._getMinOffset();
    },
    _getMaxOffset: function() {
        return -this._topPocketSize;
    },
    _getMinOffset: function() {
        return $fdfb7b26d173bffe$var$math.min(this.callBase(), -this._topPocketSize);
    },
    _reachBottomLoading: function() {
        this.reachBottomCallbacks.fire();
    },
    _pullDownReady: function() {
        if (this._state === $fdfb7b26d173bffe$var$STATE_READY) return;
        this._state = $fdfb7b26d173bffe$var$STATE_READY;
        this._maxOffset = 0;
        this._$pullDown.addClass($fdfb7b26d173bffe$var$SCROLLVIEW_PULLDOWN_READY_CLASS);
        this._refreshPullDownText();
    },
    _stateReleased: function() {
        if (this._state === $fdfb7b26d173bffe$var$STATE_RELEASED) return;
        this._releaseState();
        this._updateBounds();
        this._$pullDown.removeClass($fdfb7b26d173bffe$var$SCROLLVIEW_PULLDOWN_REFRESHING_CLASS).removeClass($fdfb7b26d173bffe$var$SCROLLVIEW_PULLDOWN_READY_CLASS);
        this.releaseCallbacks.fire();
    },
    _pullDownRefreshing: function() {
        if (this._state === $fdfb7b26d173bffe$var$STATE_REFRESHING) return;
        this._state = $fdfb7b26d173bffe$var$STATE_REFRESHING;
        this._$pullDown.addClass($fdfb7b26d173bffe$var$SCROLLVIEW_PULLDOWN_REFRESHING_CLASS).removeClass($fdfb7b26d173bffe$var$SCROLLVIEW_PULLDOWN_READY_CLASS);
        this._refreshPullDownText();
        this.pullDownCallbacks.fire();
    },
    _releaseHandler: function() {
        if (this._state === $fdfb7b26d173bffe$var$STATE_RELEASED) this._moveToBounds();
        this._update();
        if (this._releaseTask) this._releaseTask.abort();
        this._releaseTask = $2Mto0.executeAsync(this._release.bind(this));
        return this._releaseTask.promise;
    },
    _release: function() {
        this._stateReleased();
        this._scrollComplete();
    },
    _reachBottomEnablingHandler: function(enabled) {
        if (this._reachBottomEnabled === enabled) return;
        this._reachBottomEnabled = enabled;
        this._updateBounds();
    },
    _pullDownEnablingHandler: function(enabled) {
        if (this._pullDownEnabled === enabled) return;
        this._pullDownEnabled = enabled;
        this._considerTopPocketChange();
        this._updateHandler();
    },
    _considerTopPocketChange: function() {
        this._location -= this._$topPocket.height() || -this._topPocketSize;
        this._maxOffset = 0;
        this._move();
    },
    _pendingReleaseHandler: function() {
        this._state = $fdfb7b26d173bffe$var$STATE_READY;
    },
    dispose: function() {
        if (this._releaseTask) this._releaseTask.abort();
        this.callBase();
    }
});
var $fdfb7b26d173bffe$var$SimulatedScrollViewStrategy = $4pkTa.SimulatedStrategy.inherit({
    _init: function(scrollView) {
        this.callBase(scrollView);
        this._$pullDown = scrollView._$pullDown;
        this._$topPocket = scrollView._$topPocket;
        this._$bottomPocket = scrollView._$bottomPocket;
        this._initCallbacks();
    },
    _initCallbacks: function() {
        this.pullDownCallbacks = $eKdKS();
        this.releaseCallbacks = $eKdKS();
        this.reachBottomCallbacks = $eKdKS();
    },
    render: function() {
        this._renderPullDown();
        this.callBase();
    },
    _renderPullDown: function() {
        var $image = $jFnCG("<div>").addClass($fdfb7b26d173bffe$var$SCROLLVIEW_PULLDOWN_IMAGE_CLASS);
        var $loadContainer = $jFnCG("<div>").addClass($fdfb7b26d173bffe$var$SCROLLVIEW_PULLDOWN_INDICATOR_CLASS);
        var $loadIndicator = new $gbWer($jFnCG("<div>")).$element();
        var $text = this._$pullDownText = $jFnCG("<div>").addClass($fdfb7b26d173bffe$var$SCROLLVIEW_PULLDOWN_TEXT_CLASS);
        this._$pullingDownText = $jFnCG("<div>").text(this.option("pullingDownText")).appendTo($text);
        this._$pulledDownText = $jFnCG("<div>").text(this.option("pulledDownText")).appendTo($text);
        this._$refreshingText = $jFnCG("<div>").text(this.option("refreshingText")).appendTo($text);
        this._$pullDown.empty().append($image).append($loadContainer.append($loadIndicator)).append($text);
    },
    pullDownEnable: function(enabled) {
        this._eventHandler("pullDownEnabling", enabled);
    },
    reachBottomEnable: function(enabled) {
        this._eventHandler("reachBottomEnabling", enabled);
    },
    _createScroller: function(direction) {
        var that = this;
        var scroller = that._scrollers[direction] = new $fdfb7b26d173bffe$var$ScrollViewScroller(that._scrollerOptions(direction));
        scroller.pullDownCallbacks.add(function() {
            that.pullDownCallbacks.fire();
        });
        scroller.releaseCallbacks.add(function() {
            that.releaseCallbacks.fire();
        });
        scroller.reachBottomCallbacks.add(function() {
            that.reachBottomCallbacks.fire();
        });
    },
    _scrollerOptions: function(direction) {
        return $fdfb7b26d173bffe$require$extend(this.callBase(direction), {
            $topPocket: this._$topPocket,
            $bottomPocket: this._$bottomPocket,
            $pullDown: this._$pullDown,
            $pullDownText: this._$pullDownText,
            $pullingDownText: this._$pullingDownText,
            $pulledDownText: this._$pulledDownText,
            $refreshingText: this._$refreshingText
        });
    },
    pendingRelease: function() {
        this._eventHandler("pendingRelease");
    },
    release: function() {
        return this._eventHandler("release").done(this._updateAction);
    },
    location: function location() {
        var location = this.callBase();
        location.top += this._$topPocket.height();
        return location;
    },
    dispose: function() {
        $fdfb7b26d173bffe$require$each(this._scrollers, function() {
            this.dispose();
        });
        this.callBase();
    }
});
module.exports = $fdfb7b26d173bffe$var$SimulatedScrollViewStrategy;

});
parcelRegister("4pkTa", function(module, exports) {

$parcel$export(module.exports, "SimulatedStrategy", () => $3359b346f5edeae6$export$60f43cd0a9d910ac, (v) => $3359b346f5edeae6$export$60f43cd0a9d910ac = v);
$parcel$export(module.exports, "Scroller", () => $3359b346f5edeae6$export$76d6749d1cf8513c, (v) => $3359b346f5edeae6$export$76d6749d1cf8513c = v);
/**
 * DevExtreme (ui/scroll_view/ui.scrollable.simulated.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $3359b346f5edeae6$export$60f43cd0a9d910ac;
var $3359b346f5edeae6$export$76d6749d1cf8513c;
"use strict";

var $jFnCG = parcelRequire("jFnCG");
var $3359b346f5edeae6$var$_renderer2 = $3359b346f5edeae6$var$_interopRequireDefault($jFnCG);

var $445Bz = parcelRequire("445Bz");
var $3359b346f5edeae6$var$_dom_adapter2 = $3359b346f5edeae6$var$_interopRequireDefault($445Bz);

var $e1LMc = parcelRequire("e1LMc");
var $3359b346f5edeae6$var$_events_engine2 = $3359b346f5edeae6$var$_interopRequireDefault($e1LMc);

var $ih7fv = parcelRequire("ih7fv");

var $7I8Uw = parcelRequire("7I8Uw");

var $irv64 = parcelRequire("irv64");

var $4Pwuy = parcelRequire("4Pwuy");

var $kDRxH = parcelRequire("kDRxH");

var $1TtsA = parcelRequire("1TtsA");

var $6jr65 = parcelRequire("6jr65");
var $3359b346f5edeae6$var$_translator2 = $3359b346f5edeae6$var$_interopRequireDefault($6jr65);

var $k7aJb = parcelRequire("k7aJb");
var $3359b346f5edeae6$var$_class2 = $3359b346f5edeae6$var$_interopRequireDefault($k7aJb);

var $ih9Pz = parcelRequire("ih9Pz");
var $3359b346f5edeae6$var$_animator2 = $3359b346f5edeae6$var$_interopRequireDefault($ih9Pz);

var $aiwte = parcelRequire("aiwte");
var $3359b346f5edeae6$var$_devices2 = $3359b346f5edeae6$var$_interopRequireDefault($aiwte);

var $bXb2w = parcelRequire("bXb2w");

var $2Mto0 = parcelRequire("2Mto0");

var $1P6gj = parcelRequire("1P6gj");
var $3359b346f5edeae6$var$_ui2 = $3359b346f5edeae6$var$_interopRequireDefault($1P6gj);

var $2F60d = parcelRequire("2F60d");
function $3359b346f5edeae6$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $3359b346f5edeae6$var$realDevice = $3359b346f5edeae6$var$_devices2.default.real;
var $3359b346f5edeae6$var$isSluggishPlatform = "android" === $3359b346f5edeae6$var$realDevice.platform;
var $3359b346f5edeae6$var$SCROLLABLE_SIMULATED = "dxSimulatedScrollable";
var $3359b346f5edeae6$var$SCROLLABLE_STRATEGY = "dxScrollableStrategy";
var $3359b346f5edeae6$var$SCROLLABLE_SIMULATED_CURSOR = $3359b346f5edeae6$var$SCROLLABLE_SIMULATED + "Cursor";
var $3359b346f5edeae6$var$SCROLLABLE_SIMULATED_KEYBOARD = $3359b346f5edeae6$var$SCROLLABLE_SIMULATED + "Keyboard";
var $3359b346f5edeae6$var$SCROLLABLE_SIMULATED_CLASS = "dx-scrollable-simulated";
var $3359b346f5edeae6$var$SCROLLABLE_SCROLLBARS_HIDDEN = "dx-scrollable-scrollbars-hidden";
var $3359b346f5edeae6$var$SCROLLABLE_SCROLLBARS_ALWAYSVISIBLE = "dx-scrollable-scrollbars-alwaysvisible";
var $3359b346f5edeae6$var$SCROLLABLE_SCROLLBAR_CLASS = "dx-scrollable-scrollbar";
var $3359b346f5edeae6$var$VERTICAL = "vertical";
var $3359b346f5edeae6$var$HORIZONTAL = "horizontal";
var $3359b346f5edeae6$var$ACCELERATION = $3359b346f5edeae6$var$isSluggishPlatform ? .95 : .92;
var $3359b346f5edeae6$var$OUT_BOUNDS_ACCELERATION = .5;
var $3359b346f5edeae6$var$MIN_VELOCITY_LIMIT = 1;
var $3359b346f5edeae6$var$FRAME_DURATION = Math.round(1e3 / 60);
var $3359b346f5edeae6$var$SCROLL_LINE_HEIGHT = 40;
var $3359b346f5edeae6$var$VALIDATE_WHEEL_TIMEOUT = 500;
var $3359b346f5edeae6$var$BOUNCE_MIN_VELOCITY_LIMIT = $3359b346f5edeae6$var$MIN_VELOCITY_LIMIT / 5;
var $3359b346f5edeae6$var$BOUNCE_DURATION = $3359b346f5edeae6$var$isSluggishPlatform ? 300 : 400;
var $3359b346f5edeae6$var$BOUNCE_FRAMES = $3359b346f5edeae6$var$BOUNCE_DURATION / $3359b346f5edeae6$var$FRAME_DURATION;
var $3359b346f5edeae6$var$BOUNCE_ACCELERATION_SUM = (1 - Math.pow($3359b346f5edeae6$var$ACCELERATION, $3359b346f5edeae6$var$BOUNCE_FRAMES)) / (1 - $3359b346f5edeae6$var$ACCELERATION);
var $3359b346f5edeae6$var$KEY_CODES = {
    PAGE_UP: "pageUp",
    PAGE_DOWN: "pageDown",
    END: "end",
    HOME: "home",
    LEFT: "leftArrow",
    UP: "upArrow",
    RIGHT: "rightArrow",
    DOWN: "downArrow",
    TAB: "tab"
};
var $3359b346f5edeae6$var$InertiaAnimator = $3359b346f5edeae6$var$_animator2.default.inherit({
    ctor: function(scroller) {
        this.callBase();
        this.scroller = scroller;
    },
    VELOCITY_LIMIT: $3359b346f5edeae6$var$MIN_VELOCITY_LIMIT,
    _isFinished: function() {
        return Math.abs(this.scroller._velocity) <= this.VELOCITY_LIMIT;
    },
    _step: function() {
        this.scroller._scrollStep(this.scroller._velocity);
        this.scroller._velocity *= this._acceleration();
    },
    _acceleration: function() {
        return this.scroller._inBounds() ? $3359b346f5edeae6$var$ACCELERATION : $3359b346f5edeae6$var$OUT_BOUNDS_ACCELERATION;
    },
    _complete: function() {
        this.scroller._scrollComplete();
    },
    _stop: function() {
        this.scroller._stopComplete();
    }
});
var $3359b346f5edeae6$var$BounceAnimator = $3359b346f5edeae6$var$InertiaAnimator.inherit({
    VELOCITY_LIMIT: $3359b346f5edeae6$var$BOUNCE_MIN_VELOCITY_LIMIT,
    _isFinished: function() {
        return this.scroller._crossBoundOnNextStep() || this.callBase();
    },
    _acceleration: function() {
        return $3359b346f5edeae6$var$ACCELERATION;
    },
    _complete: function() {
        this.scroller._move(this.scroller._bounceLocation);
        this.callBase();
    }
});
var $3359b346f5edeae6$var$Scroller = $3359b346f5edeae6$var$_class2.default.inherit({
    ctor: function(options) {
        this._initOptions(options);
        this._initAnimators();
        this._initScrollbar();
    },
    _initOptions: function(options) {
        var _this = this;
        this._location = 0;
        this._topReached = false;
        this._bottomReached = false;
        this._axis = options.direction === $3359b346f5edeae6$var$HORIZONTAL ? "x" : "y";
        this._prop = options.direction === $3359b346f5edeae6$var$HORIZONTAL ? "left" : "top";
        this._dimension = options.direction === $3359b346f5edeae6$var$HORIZONTAL ? "width" : "height";
        this._scrollProp = options.direction === $3359b346f5edeae6$var$HORIZONTAL ? "scrollLeft" : "scrollTop";
        (0, $4Pwuy.each)(options, function(optionName, optionValue) {
            _this["_" + optionName] = optionValue;
        });
    },
    _initAnimators: function() {
        this._inertiaAnimator = new $3359b346f5edeae6$var$InertiaAnimator(this);
        this._bounceAnimator = new $3359b346f5edeae6$var$BounceAnimator(this);
    },
    _initScrollbar: function() {
        this._scrollbar = new $3359b346f5edeae6$var$_ui2.default((0, $3359b346f5edeae6$var$_renderer2.default)("<div>").appendTo(this._$container), {
            direction: this._direction,
            visible: this._scrollByThumb,
            visibilityMode: this._visibilityModeNormalize(this._scrollbarVisible),
            expandable: this._scrollByThumb
        });
        this._$scrollbar = this._scrollbar.$element();
    },
    _visibilityModeNormalize: function(mode) {
        return true === mode ? "onScroll" : false === mode ? "never" : mode;
    },
    _scrollStep: function(delta) {
        var prevLocation = this._location;
        this._location += delta;
        this._suppressBounce();
        this._move();
        if (Math.abs(prevLocation - this._location) < 1) return;
        $3359b346f5edeae6$var$_events_engine2.default.triggerHandler(this._$container, {
            type: "scroll"
        });
    },
    _suppressBounce: function() {
        if (this._bounceEnabled || this._inBounds(this._location)) return;
        this._velocity = 0;
        this._location = this._boundLocation();
    },
    _boundLocation: function(location) {
        location = void 0 !== location ? location : this._location;
        return Math.max(Math.min(location, this._maxOffset), this._minOffset);
    },
    _move: function(location) {
        this._location = void 0 !== location ? location * this._getScaleRatio() : this._location;
        this._moveContent();
        this._moveScrollbar();
    },
    _moveContent: function() {
        var location = this._location;
        this._$container[this._scrollProp](-location / this._getScaleRatio());
        this._moveContentByTranslator(location);
    },
    _getScaleRatio: function() {
        if ((0, $irv64.hasWindow)() && !this._scaleRatio) {
            var element = this._$element.get(0);
            var realDimension = this._getRealDimension(element, this._dimension);
            var baseDimension = this._getBaseDimension(element, this._dimension);
            this._scaleRatio = Math.round(realDimension / baseDimension * 100) / 100;
        }
        return this._scaleRatio || 1;
    },
    _getRealDimension: function(element, dimension) {
        return Math.round((0, $1TtsA.getBoundingRect)(element)[dimension]);
    },
    _getBaseDimension: function(element, dimension) {
        var dimensionName = "offset" + (0, $ih7fv.titleize)(dimension);
        return element[dimensionName];
    },
    _moveContentByTranslator: function(location) {
        var translateOffset;
        var minOffset = -this._maxScrollPropValue;
        if (location > 0) translateOffset = location;
        else if (location <= minOffset) translateOffset = location - minOffset;
        else translateOffset = location % 1;
        if (this._translateOffset === translateOffset) return;
        var targetLocation = {};
        targetLocation[this._prop] = translateOffset;
        this._translateOffset = translateOffset;
        if (0 === translateOffset) {
            $3359b346f5edeae6$var$_translator2.default.resetPosition(this._$content);
            return;
        }
        $3359b346f5edeae6$var$_translator2.default.move(this._$content, targetLocation);
    },
    _moveScrollbar: function() {
        this._scrollbar.moveTo(this._location);
    },
    _scrollComplete: function() {
        if (this._inBounds()) {
            this._hideScrollbar();
            if (this._completeDeferred) this._completeDeferred.resolve();
        }
        this._scrollToBounds();
    },
    _scrollToBounds: function() {
        if (this._inBounds()) return;
        this._bounceAction();
        this._setupBounce();
        this._bounceAnimator.start();
    },
    _setupBounce: function() {
        var boundLocation = this._bounceLocation = this._boundLocation();
        var bounceDistance = boundLocation - this._location;
        this._velocity = bounceDistance / $3359b346f5edeae6$var$BOUNCE_ACCELERATION_SUM;
    },
    _inBounds: function(location) {
        location = void 0 !== location ? location : this._location;
        return this._boundLocation(location) === location;
    },
    _crossBoundOnNextStep: function() {
        var location = this._location;
        var nextLocation = location + this._velocity;
        return location < this._minOffset && nextLocation >= this._minOffset || location > this._maxOffset && nextLocation <= this._maxOffset;
    },
    _initHandler: function(e) {
        this._stopDeferred = new $2F60d.Deferred;
        this._stopScrolling();
        this._prepareThumbScrolling(e);
        return this._stopDeferred.promise();
    },
    _stopScrolling: (0, $2Mto0.deferRenderer)(function() {
        this._hideScrollbar();
        this._inertiaAnimator.stop();
        this._bounceAnimator.stop();
    }),
    _prepareThumbScrolling: function(e) {
        if ((0, $bXb2w.isDxMouseWheelEvent)(e.originalEvent)) return;
        var $target = (0, $3359b346f5edeae6$var$_renderer2.default)(e.originalEvent.target);
        var scrollbarClicked = this._isScrollbar($target);
        if (scrollbarClicked) this._moveToMouseLocation(e);
        this._thumbScrolling = scrollbarClicked || this._isThumb($target);
        this._crossThumbScrolling = !this._thumbScrolling && this._isAnyThumbScrolling($target);
        if (this._thumbScrolling) this._scrollbar.feedbackOn();
    },
    _isThumbScrollingHandler: function($target) {
        return this._isThumb($target);
    },
    _moveToMouseLocation: function(e) {
        var mouseLocation = e["page" + this._axis.toUpperCase()] - this._$element.offset()[this._prop];
        var location = this._location + mouseLocation / this._containerToContentRatio() - this._$container.height() / 2;
        this._scrollStep(-Math.round(location));
    },
    _stopComplete: function() {
        if (this._stopDeferred) this._stopDeferred.resolve();
    },
    _startHandler: function() {
        this._showScrollbar();
    },
    _moveHandler: function(delta) {
        if (this._crossThumbScrolling) return;
        if (this._thumbScrolling) delta[this._axis] = -Math.round(delta[this._axis] / this._containerToContentRatio());
        this._scrollBy(delta);
    },
    _scrollBy: function(delta) {
        delta = delta[this._axis];
        if (!this._inBounds()) delta *= $3359b346f5edeae6$var$OUT_BOUNDS_ACCELERATION;
        this._scrollStep(delta);
    },
    _scrollByHandler: function(delta) {
        this._scrollBy(delta);
        this._scrollComplete();
    },
    _containerToContentRatio: function() {
        return this._scrollbar.containerToContentRatio();
    },
    _endHandler: function(velocity) {
        this._completeDeferred = new $2F60d.Deferred;
        this._velocity = velocity[this._axis];
        this._inertiaHandler();
        this._resetThumbScrolling();
        return this._completeDeferred.promise();
    },
    _inertiaHandler: function() {
        this._suppressInertia();
        this._inertiaAnimator.start();
    },
    _suppressInertia: function() {
        if (!this._inertiaEnabled || this._thumbScrolling) this._velocity = 0;
    },
    _resetThumbScrolling: function() {
        this._thumbScrolling = false;
        this._crossThumbScrolling = false;
    },
    _stopHandler: function() {
        if (this._thumbScrolling) this._scrollComplete();
        this._resetThumbScrolling();
        this._scrollToBounds();
    },
    _disposeHandler: function() {
        this._stopScrolling();
        this._$scrollbar.remove();
    },
    _updateHandler: function() {
        this._update();
        this._moveToBounds();
    },
    _update: function() {
        var _this2 = this;
        this._stopScrolling();
        return (0, $2Mto0.deferUpdate)(function() {
            _this2._resetScaleRatio();
            _this2._updateLocation();
            _this2._updateBounds();
            _this2._updateScrollbar();
            (0, $2Mto0.deferRender)(function() {
                _this2._moveScrollbar();
                _this2._scrollbar.update();
            });
        });
    },
    _resetScaleRatio: function() {
        this._scaleRatio = null;
    },
    _updateLocation: function() {
        this._location = ($3359b346f5edeae6$var$_translator2.default.locate(this._$content)[this._prop] - this._$container[this._scrollProp]()) * this._getScaleRatio();
    },
    _updateBounds: function() {
        this._maxOffset = Math.round(this._getMaxOffset());
        this._minOffset = Math.round(this._getMinOffset());
    },
    _getMaxOffset: function() {
        return 0;
    },
    _getMinOffset: function() {
        this._maxScrollPropValue = Math.max(this._contentSize() - this._containerSize(), 0);
        return -this._maxScrollPropValue;
    },
    _updateScrollbar: (0, $2Mto0.deferUpdater)(function() {
        var _this3 = this;
        var containerSize = this._containerSize();
        var contentSize = this._contentSize();
        var baseContainerSize = this._getBaseDimension(this._$container.get(0), this._dimension);
        var baseContentSize = this._getBaseDimension(this._$content.get(0), this._dimension);
        (0, $2Mto0.deferRender)(function() {
            _this3._scrollbar.option({
                containerSize: containerSize,
                contentSize: contentSize,
                baseContainerSize: baseContainerSize,
                baseContentSize: baseContentSize,
                scaleRatio: _this3._getScaleRatio()
            });
        });
    }),
    _moveToBounds: (0, $2Mto0.deferRenderer)((0, $2Mto0.deferUpdater)((0, $2Mto0.deferRenderer)(function() {
        var location = this._boundLocation();
        var locationChanged = location !== this._location;
        this._location = location;
        this._move();
        if (locationChanged) this._scrollAction();
    }))),
    _createActionsHandler: function(actions) {
        this._scrollAction = actions.scroll;
        this._bounceAction = actions.bounce;
    },
    _showScrollbar: function() {
        this._scrollbar.option("visible", true);
    },
    _hideScrollbar: function() {
        this._scrollbar.option("visible", false);
    },
    _containerSize: function() {
        return this._getRealDimension(this._$container.get(0), this._dimension);
    },
    _contentSize: function() {
        var isOverflowHidden = "hidden" === this._$content.css("overflow" + this._axis.toUpperCase());
        var contentSize = this._getRealDimension(this._$content.get(0), this._dimension);
        if (!isOverflowHidden) {
            var containerScrollSize = this._$content[0]["scroll" + (0, $ih7fv.titleize)(this._dimension)] * this._getScaleRatio();
            contentSize = Math.max(containerScrollSize, contentSize);
        }
        return contentSize;
    },
    _validateEvent: function(e) {
        var $target = (0, $3359b346f5edeae6$var$_renderer2.default)(e.originalEvent.target);
        return this._isThumb($target) || this._isScrollbar($target) || this._isContent($target);
    },
    _isThumb: function($element) {
        return this._scrollByThumb && this._scrollbar.isThumb($element);
    },
    _isScrollbar: function($element) {
        return this._scrollByThumb && $element && $element.is(this._$scrollbar);
    },
    _isContent: function($element) {
        return this._scrollByContent && !!$element.closest(this._$element).length;
    },
    _reachedMin: function() {
        return this._location <= this._minOffset;
    },
    _reachedMax: function() {
        return this._location >= this._maxOffset;
    },
    _cursorEnterHandler: function() {
        this._resetScaleRatio();
        this._updateScrollbar();
        this._scrollbar.cursorEnter();
    },
    _cursorLeaveHandler: function() {
        this._scrollbar.cursorLeave();
    },
    dispose: $2Mto0.noop
});
var $3359b346f5edeae6$var$hoveredScrollable;
var $3359b346f5edeae6$var$activeScrollable;
var $3359b346f5edeae6$var$SimulatedStrategy = $3359b346f5edeae6$var$_class2.default.inherit({
    ctor: function(scrollable) {
        this._init(scrollable);
    },
    _init: function(scrollable) {
        this._component = scrollable;
        this._$element = scrollable.$element();
        this._$container = scrollable._$container;
        this._$wrapper = scrollable._$wrapper;
        this._$content = scrollable._$content;
        this.option = scrollable.option.bind(scrollable);
        this._createActionByOption = scrollable._createActionByOption.bind(scrollable);
        this._isLocked = scrollable._isLocked.bind(scrollable);
        this._isDirection = scrollable._isDirection.bind(scrollable);
        this._allowedDirection = scrollable._allowedDirection.bind(scrollable);
    },
    render: function() {
        this._$element.addClass($3359b346f5edeae6$var$SCROLLABLE_SIMULATED_CLASS);
        this._createScrollers();
        if (this.option("useKeyboard")) this._$container.prop("tabIndex", 0);
        this._attachKeyboardHandler();
        this._attachCursorHandlers();
    },
    _createScrollers: function() {
        this._scrollers = {};
        if (this._isDirection($3359b346f5edeae6$var$HORIZONTAL)) this._createScroller($3359b346f5edeae6$var$HORIZONTAL);
        if (this._isDirection($3359b346f5edeae6$var$VERTICAL)) this._createScroller($3359b346f5edeae6$var$VERTICAL);
        this._$element.toggleClass($3359b346f5edeae6$var$SCROLLABLE_SCROLLBARS_ALWAYSVISIBLE, "always" === this.option("showScrollbar"));
        this._$element.toggleClass($3359b346f5edeae6$var$SCROLLABLE_SCROLLBARS_HIDDEN, !this.option("showScrollbar"));
    },
    _createScroller: function(direction) {
        this._scrollers[direction] = new $3359b346f5edeae6$var$Scroller(this._scrollerOptions(direction));
    },
    _scrollerOptions: function(direction) {
        return {
            direction: direction,
            $content: this._$content,
            $container: this._$container,
            $wrapper: this._$wrapper,
            $element: this._$element,
            scrollByContent: this.option("scrollByContent"),
            scrollByThumb: this.option("scrollByThumb"),
            scrollbarVisible: this.option("showScrollbar"),
            bounceEnabled: this.option("bounceEnabled"),
            inertiaEnabled: this.option("inertiaEnabled"),
            isAnyThumbScrolling: this._isAnyThumbScrolling.bind(this)
        };
    },
    _applyScaleRatio: function(targetLocation) {
        for(var direction in this._scrollers){
            var prop = this._getPropByDirection(direction);
            if ((0, $kDRxH.isDefined)(targetLocation[prop])) {
                var scroller = this._scrollers[direction];
                targetLocation[prop] *= scroller._getScaleRatio();
            }
        }
        return targetLocation;
    },
    _isAnyThumbScrolling: function($target) {
        var result = false;
        this._eventHandler("isThumbScrolling", $target).done(function(isThumbScrollingVertical, isThumbScrollingHorizontal) {
            result = isThumbScrollingVertical || isThumbScrollingHorizontal;
        });
        return result;
    },
    handleInit: function(e) {
        this._suppressDirections(e);
        this._eventForUserAction = e;
        this._eventHandler("init", e).done(this._stopAction);
    },
    _suppressDirections: function(e) {
        if ((0, $bXb2w.isDxMouseWheelEvent)(e.originalEvent)) {
            this._prepareDirections(true);
            return;
        }
        this._prepareDirections();
        this._eachScroller(function(scroller, direction) {
            var isValid = scroller._validateEvent(e);
            this._validDirections[direction] = isValid;
        });
    },
    _prepareDirections: function(value) {
        value = value || false;
        this._validDirections = {};
        this._validDirections[$3359b346f5edeae6$var$HORIZONTAL] = value;
        this._validDirections[$3359b346f5edeae6$var$VERTICAL] = value;
    },
    _eachScroller: function(callback) {
        callback = callback.bind(this);
        (0, $4Pwuy.each)(this._scrollers, function(direction, scroller) {
            callback(scroller, direction);
        });
    },
    handleStart: function(e) {
        this._eventForUserAction = e;
        this._eventHandler("start").done(this._startAction);
    },
    _saveActive: function() {
        $3359b346f5edeae6$var$activeScrollable = this;
    },
    _resetActive: function() {
        if ($3359b346f5edeae6$var$activeScrollable === this) $3359b346f5edeae6$var$activeScrollable = null;
    },
    handleMove: function(e) {
        if (this._isLocked()) {
            e.cancel = true;
            this._resetActive();
            return;
        }
        this._saveActive();
        e.preventDefault && e.preventDefault();
        this._adjustDistance(e, e.delta);
        this._eventForUserAction = e;
        this._eventHandler("move", e.delta);
    },
    _adjustDistance: function(e, distance) {
        distance.x *= this._validDirections[$3359b346f5edeae6$var$HORIZONTAL];
        distance.y *= this._validDirections[$3359b346f5edeae6$var$VERTICAL];
        var devicePixelRatio = this._tryGetDevicePixelRatio();
        if (devicePixelRatio && (0, $bXb2w.isDxMouseWheelEvent)(e.originalEvent)) {
            distance.x = Math.round(distance.x / devicePixelRatio * 100) / 100;
            distance.y = Math.round(distance.y / devicePixelRatio * 100) / 100;
        }
    },
    _tryGetDevicePixelRatio: function() {
        if ((0, $irv64.hasWindow)()) return (0, $irv64.getWindow)().devicePixelRatio;
    },
    handleEnd: function(e) {
        this._resetActive();
        this._refreshCursorState(e.originalEvent && e.originalEvent.target);
        this._adjustDistance(e, e.velocity);
        this._eventForUserAction = e;
        return this._eventHandler("end", e.velocity).done(this._endAction);
    },
    handleCancel: function(e) {
        this._resetActive();
        this._eventForUserAction = e;
        return this._eventHandler("end", {
            x: 0,
            y: 0
        });
    },
    handleStop: function() {
        this._resetActive();
        this._eventHandler("stop");
    },
    handleScroll: function() {
        this._scrollAction();
    },
    _attachKeyboardHandler: function() {
        $3359b346f5edeae6$var$_events_engine2.default.off(this._$element, ".".concat($3359b346f5edeae6$var$SCROLLABLE_SIMULATED_KEYBOARD));
        if (!this.option("disabled") && this.option("useKeyboard")) $3359b346f5edeae6$var$_events_engine2.default.on(this._$element, (0, $bXb2w.addNamespace)("keydown", $3359b346f5edeae6$var$SCROLLABLE_SIMULATED_KEYBOARD), this._keyDownHandler.bind(this));
    },
    _keyDownHandler: function(e) {
        var _this4 = this;
        clearTimeout(this._updateHandlerTimeout);
        this._updateHandlerTimeout = setTimeout(function() {
            if ((0, $bXb2w.normalizeKeyName)(e) === $3359b346f5edeae6$var$KEY_CODES.TAB) _this4._eachScroller(function(scroller) {
                scroller._updateHandler();
            });
        });
        if (!this._$container.is($3359b346f5edeae6$var$_dom_adapter2.default.getActiveElement())) return;
        var handled = true;
        switch((0, $bXb2w.normalizeKeyName)(e)){
            case $3359b346f5edeae6$var$KEY_CODES.DOWN:
                this._scrollByLine({
                    y: 1
                });
                break;
            case $3359b346f5edeae6$var$KEY_CODES.UP:
                this._scrollByLine({
                    y: -1
                });
                break;
            case $3359b346f5edeae6$var$KEY_CODES.RIGHT:
                this._scrollByLine({
                    x: 1
                });
                break;
            case $3359b346f5edeae6$var$KEY_CODES.LEFT:
                this._scrollByLine({
                    x: -1
                });
                break;
            case $3359b346f5edeae6$var$KEY_CODES.PAGE_DOWN:
                this._scrollByPage(1);
                break;
            case $3359b346f5edeae6$var$KEY_CODES.PAGE_UP:
                this._scrollByPage(-1);
                break;
            case $3359b346f5edeae6$var$KEY_CODES.HOME:
                this._scrollToHome();
                break;
            case $3359b346f5edeae6$var$KEY_CODES.END:
                this._scrollToEnd();
                break;
            default:
                handled = false;
        }
        if (handled) {
            e.stopPropagation();
            e.preventDefault();
        }
    },
    _scrollByLine: function(lines) {
        var devicePixelRatio = this._tryGetDevicePixelRatio();
        var scrollOffset = $3359b346f5edeae6$var$SCROLL_LINE_HEIGHT;
        if (devicePixelRatio) scrollOffset = Math.abs(scrollOffset / devicePixelRatio * 100) / 100;
        this.scrollBy({
            top: (lines.y || 0) * -scrollOffset,
            left: (lines.x || 0) * -scrollOffset
        });
    },
    _scrollByPage: function(page) {
        var prop = this._wheelProp();
        var dimension = this._dimensionByProp(prop);
        var distance = {};
        distance[prop] = page * -this._$container[dimension]();
        this.scrollBy(distance);
    },
    _dimensionByProp: function(prop) {
        return "left" === prop ? "width" : "height";
    },
    _getPropByDirection: function(direction) {
        return direction === $3359b346f5edeae6$var$HORIZONTAL ? "left" : "top";
    },
    _scrollToHome: function() {
        var prop = this._wheelProp();
        var distance = {};
        distance[prop] = 0;
        this._component.scrollTo(distance);
    },
    _scrollToEnd: function() {
        var prop = this._wheelProp();
        var dimension = this._dimensionByProp(prop);
        var distance = {};
        distance[prop] = this._$content[dimension]() - this._$container[dimension]();
        this._component.scrollTo(distance);
    },
    createActions: function() {
        this._startAction = this._createActionHandler("onStart");
        this._stopAction = this._createActionHandler("onStop");
        this._endAction = this._createActionHandler("onEnd");
        this._updateAction = this._createActionHandler("onUpdated");
        this._createScrollerActions();
    },
    _createScrollerActions: function() {
        this._scrollAction = this._createActionHandler("onScroll");
        this._bounceAction = this._createActionHandler("onBounce");
        this._eventHandler("createActions", {
            scroll: this._scrollAction,
            bounce: this._bounceAction
        });
    },
    _createActionHandler: function(optionName) {
        var _arguments = arguments, _this5 = this;
        var actionHandler = this._createActionByOption(optionName);
        return function() {
            actionHandler((0, $7I8Uw.extend)(_this5._createActionArgs(), _arguments));
        };
    },
    _createActionArgs: function() {
        var scrollerX = this._scrollers[$3359b346f5edeae6$var$HORIZONTAL];
        var scrollerY = this._scrollers[$3359b346f5edeae6$var$VERTICAL];
        var location = this.location();
        this._scrollOffset = {
            top: scrollerY && -location.top,
            left: scrollerX && -location.left
        };
        return {
            event: this._eventForUserAction,
            scrollOffset: this._scrollOffset,
            reachedLeft: scrollerX && scrollerX._reachedMax(),
            reachedRight: scrollerX && scrollerX._reachedMin(),
            reachedTop: scrollerY && scrollerY._reachedMax(),
            reachedBottom: scrollerY && scrollerY._reachedMin()
        };
    },
    _eventHandler: function(eventName) {
        var args = [].slice.call(arguments).slice(1);
        var deferreds = (0, $4Pwuy.map)(this._scrollers, function(scroller) {
            return scroller["_" + eventName + "Handler"].apply(scroller, args);
        });
        return $2F60d.when.apply($3359b346f5edeae6$var$_renderer2.default, deferreds).promise();
    },
    location: function location() {
        var location = $3359b346f5edeae6$var$_translator2.default.locate(this._$content);
        location.top -= this._$container.scrollTop();
        location.left -= this._$container.scrollLeft();
        return location;
    },
    disabledChanged: function() {
        this._attachCursorHandlers();
    },
    _attachCursorHandlers: function() {
        $3359b346f5edeae6$var$_events_engine2.default.off(this._$element, ".".concat($3359b346f5edeae6$var$SCROLLABLE_SIMULATED_CURSOR));
        if (!this.option("disabled") && this._isHoverMode()) {
            $3359b346f5edeae6$var$_events_engine2.default.on(this._$element, (0, $bXb2w.addNamespace)("mouseenter", $3359b346f5edeae6$var$SCROLLABLE_SIMULATED_CURSOR), this._cursorEnterHandler.bind(this));
            $3359b346f5edeae6$var$_events_engine2.default.on(this._$element, (0, $bXb2w.addNamespace)("mouseleave", $3359b346f5edeae6$var$SCROLLABLE_SIMULATED_CURSOR), this._cursorLeaveHandler.bind(this));
        }
    },
    _isHoverMode: function() {
        return "onHover" === this.option("showScrollbar");
    },
    _cursorEnterHandler: function(e) {
        e = e || {};
        e.originalEvent = e.originalEvent || {};
        if ($3359b346f5edeae6$var$activeScrollable || e.originalEvent._hoverHandled) return;
        if ($3359b346f5edeae6$var$hoveredScrollable) $3359b346f5edeae6$var$hoveredScrollable._cursorLeaveHandler();
        $3359b346f5edeae6$var$hoveredScrollable = this;
        this._eventHandler("cursorEnter");
        e.originalEvent._hoverHandled = true;
    },
    _cursorLeaveHandler: function(e) {
        if ($3359b346f5edeae6$var$hoveredScrollable !== this || $3359b346f5edeae6$var$activeScrollable === $3359b346f5edeae6$var$hoveredScrollable) return;
        this._eventHandler("cursorLeave");
        $3359b346f5edeae6$var$hoveredScrollable = null;
        this._refreshCursorState(e && e.relatedTarget);
    },
    _refreshCursorState: function(target) {
        if (!this._isHoverMode() && (!target || $3359b346f5edeae6$var$activeScrollable)) return;
        var $target = (0, $3359b346f5edeae6$var$_renderer2.default)(target);
        var $scrollable = $target.closest(".".concat($3359b346f5edeae6$var$SCROLLABLE_SIMULATED_CLASS, ":not(.dx-state-disabled)"));
        var targetScrollable = $scrollable.length && $scrollable.data($3359b346f5edeae6$var$SCROLLABLE_STRATEGY);
        if ($3359b346f5edeae6$var$hoveredScrollable && $3359b346f5edeae6$var$hoveredScrollable !== targetScrollable) $3359b346f5edeae6$var$hoveredScrollable._cursorLeaveHandler();
        if (targetScrollable) targetScrollable._cursorEnterHandler();
    },
    update: function() {
        var _this6 = this;
        var result = this._eventHandler("update").done(this._updateAction);
        return (0, $2F60d.when)(result, (0, $2Mto0.deferUpdate)(function() {
            var allowedDirections = _this6._allowedDirections();
            (0, $2Mto0.deferRender)(function() {
                var touchDirection = allowedDirections.vertical ? "pan-x" : "";
                touchDirection = allowedDirections.horizontal ? "pan-y" : touchDirection;
                touchDirection = allowedDirections.vertical && allowedDirections.horizontal ? "none" : touchDirection;
                _this6._$container.css("touchAction", touchDirection);
            });
            return (0, $2F60d.when)().promise();
        }));
    },
    _allowedDirections: function() {
        var bounceEnabled = this.option("bounceEnabled");
        var verticalScroller = this._scrollers[$3359b346f5edeae6$var$VERTICAL];
        var horizontalScroller = this._scrollers[$3359b346f5edeae6$var$HORIZONTAL];
        return {
            vertical: verticalScroller && (verticalScroller._minOffset < 0 || bounceEnabled),
            horizontal: horizontalScroller && (horizontalScroller._minOffset < 0 || bounceEnabled)
        };
    },
    updateBounds: function() {
        this._scrollers[$3359b346f5edeae6$var$HORIZONTAL] && this._scrollers[$3359b346f5edeae6$var$HORIZONTAL]._updateBounds();
    },
    scrollBy: function(distance) {
        var verticalScroller = this._scrollers[$3359b346f5edeae6$var$VERTICAL];
        var horizontalScroller = this._scrollers[$3359b346f5edeae6$var$HORIZONTAL];
        if (verticalScroller) distance.top = verticalScroller._boundLocation(distance.top + verticalScroller._location) - verticalScroller._location;
        if (horizontalScroller) distance.left = horizontalScroller._boundLocation(distance.left + horizontalScroller._location) - horizontalScroller._location;
        this._prepareDirections(true);
        this._startAction();
        this._eventHandler("scrollBy", {
            x: distance.left,
            y: distance.top
        });
        this._endAction();
    },
    validate: function(e) {
        if (this.option("disabled")) return false;
        if (this.option("bounceEnabled")) return true;
        return (0, $bXb2w.isDxMouseWheelEvent)(e) ? this._validateWheel(e) : this._validateMove(e);
    },
    _validateWheel: function(e) {
        var _this7 = this;
        var scroller = this._scrollers[this._wheelDirection(e)];
        var reachedMin = scroller._reachedMin();
        var reachedMax = scroller._reachedMax();
        var contentGreaterThanContainer = !reachedMin || !reachedMax;
        var locatedNotAtBound = !reachedMin && !reachedMax;
        var scrollFromMin = reachedMin && e.delta > 0;
        var scrollFromMax = reachedMax && e.delta < 0;
        var validated = contentGreaterThanContainer && (locatedNotAtBound || scrollFromMin || scrollFromMax);
        validated = validated || void 0 !== this._validateWheelTimer;
        if (validated) {
            clearTimeout(this._validateWheelTimer);
            this._validateWheelTimer = setTimeout(function() {
                _this7._validateWheelTimer = void 0;
            }, $3359b346f5edeae6$var$VALIDATE_WHEEL_TIMEOUT);
        }
        return validated;
    },
    _validateMove: function(e) {
        if (!this.option("scrollByContent") && !(0, $3359b346f5edeae6$var$_renderer2.default)(e.target).closest(".".concat($3359b346f5edeae6$var$SCROLLABLE_SCROLLBAR_CLASS)).length) return false;
        return this._allowedDirection();
    },
    getDirection: function(e) {
        return (0, $bXb2w.isDxMouseWheelEvent)(e) ? this._wheelDirection(e) : this._allowedDirection();
    },
    _wheelProp: function() {
        return this._wheelDirection() === $3359b346f5edeae6$var$HORIZONTAL ? "left" : "top";
    },
    _wheelDirection: function(e) {
        switch(this.option("direction")){
            case $3359b346f5edeae6$var$HORIZONTAL:
                return $3359b346f5edeae6$var$HORIZONTAL;
            case $3359b346f5edeae6$var$VERTICAL:
                return $3359b346f5edeae6$var$VERTICAL;
            default:
                return e && e.shiftKey ? $3359b346f5edeae6$var$HORIZONTAL : $3359b346f5edeae6$var$VERTICAL;
        }
    },
    verticalOffset: function() {
        return 0;
    },
    dispose: function() {
        this._resetActive();
        if ($3359b346f5edeae6$var$hoveredScrollable === this) $3359b346f5edeae6$var$hoveredScrollable = null;
        this._eventHandler("dispose");
        this._detachEventHandlers();
        this._$element.removeClass($3359b346f5edeae6$var$SCROLLABLE_SIMULATED_CLASS);
        this._eventForUserAction = null;
        clearTimeout(this._validateWheelTimer);
        clearTimeout(this._updateHandlerTimeout);
    },
    _detachEventHandlers: function() {
        $3359b346f5edeae6$var$_events_engine2.default.off(this._$element, ".".concat($3359b346f5edeae6$var$SCROLLABLE_SIMULATED_CURSOR));
        $3359b346f5edeae6$var$_events_engine2.default.off(this._$container, ".".concat($3359b346f5edeae6$var$SCROLLABLE_SIMULATED_KEYBOARD));
    }
});
$3359b346f5edeae6$export$60f43cd0a9d910ac = $3359b346f5edeae6$var$SimulatedStrategy;
$3359b346f5edeae6$export$76d6749d1cf8513c = $3359b346f5edeae6$var$Scroller;

});
parcelRegister("ih9Pz", function(module, exports) {
/**
 * DevExtreme (ui/scroll_view/animator.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $2Mto0 = parcelRequire("2Mto0");
var $d4e170b5791f2649$require$noop = $2Mto0.noop;

var $k7aJb = parcelRequire("k7aJb");
var $d4e170b5791f2649$var$abstract = $k7aJb.abstract;

var $fF1Ws = parcelRequire("fF1Ws");
var $d4e170b5791f2649$var$Animator = $k7aJb.inherit({
    ctor: function() {
        this._finished = true;
        this._stopped = false;
        this._proxiedStepCore = this._stepCore.bind(this);
    },
    start: function() {
        this._stopped = false;
        this._finished = false;
        this._stepCore();
    },
    stop: function() {
        this._stopped = true;
        $fF1Ws.cancelAnimationFrame(this._stepAnimationFrame);
    },
    _stepCore: function() {
        if (this._isStopped()) {
            this._stop();
            return;
        }
        if (this._isFinished()) {
            this._finished = true;
            this._complete();
            return;
        }
        this._step();
        this._stepAnimationFrame = $fF1Ws.requestAnimationFrame(this._proxiedStepCore);
    },
    _step: $d4e170b5791f2649$var$abstract,
    _isFinished: $d4e170b5791f2649$require$noop,
    _stop: $d4e170b5791f2649$require$noop,
    _complete: $d4e170b5791f2649$require$noop,
    _isStopped: function() {
        return this._stopped;
    },
    inProgress: function() {
        return !(this._stopped || this._finished);
    }
});
module.exports = $d4e170b5791f2649$var$Animator;

});



parcelRegister("69YDp", function(module, exports) {
/**
 * DevExtreme (ui/scroll_view/ui.scrollable.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $47c29e214f330261$var$_renderer2 = $47c29e214f330261$var$_interopRequireDefault($jFnCG);

var $e1LMc = parcelRequire("e1LMc");
var $47c29e214f330261$var$_events_engine2 = $47c29e214f330261$var$_interopRequireDefault($e1LMc);

var $6VAWB = parcelRequire("6VAWB");
var $47c29e214f330261$var$_support2 = $47c29e214f330261$var$_interopRequireDefault($6VAWB);

var $bvcPv = parcelRequire("bvcPv");
var $47c29e214f330261$var$_browser2 = $47c29e214f330261$var$_interopRequireDefault($bvcPv);

var $2Mto0 = parcelRequire("2Mto0");
var $47c29e214f330261$var$_common2 = $47c29e214f330261$var$_interopRequireDefault($2Mto0);

var $kDRxH = parcelRequire("kDRxH");
var $47c29e214f330261$var$_type2 = $47c29e214f330261$var$_interopRequireDefault($kDRxH);

var $7I8Uw = parcelRequire("7I8Uw");

var $5OzEX = parcelRequire("5OzEX");

var $irv64 = parcelRequire("irv64");
var $47c29e214f330261$var$_window2 = $47c29e214f330261$var$_interopRequireDefault($irv64);

var $445Bz = parcelRequire("445Bz");
var $47c29e214f330261$var$_dom_adapter2 = $47c29e214f330261$var$_interopRequireDefault($445Bz);

var $aiwte = parcelRequire("aiwte");
var $47c29e214f330261$var$_devices2 = $47c29e214f330261$var$_interopRequireDefault($aiwte);

var $4ZFRo = parcelRequire("4ZFRo");
var $47c29e214f330261$var$_component_registrator2 = $47c29e214f330261$var$_interopRequireDefault($4ZFRo);

var $4sKC1 = parcelRequire("4sKC1");
var $47c29e214f330261$var$_dom_component2 = $47c29e214f330261$var$_interopRequireDefault($4sKC1);

var $3joCJ = parcelRequire("3joCJ");
var $47c29e214f330261$var$_selectors2 = $47c29e214f330261$var$_interopRequireDefault($3joCJ);

var $bXb2w = parcelRequire("bXb2w");
var $47c29e214f330261$var$_utils2 = $47c29e214f330261$var$_interopRequireDefault($bXb2w);

var $7axoe = parcelRequire("7axoe");
var $47c29e214f330261$var$_uiEventsEmitterGesture2 = $47c29e214f330261$var$_interopRequireDefault($7axoe);

var $4pkTa = parcelRequire("4pkTa");
var $47c29e214f330261$var$_uiScrollable2 = $47c29e214f330261$var$_interopRequireDefault($4pkTa);

var $2L3wt = parcelRequire("2L3wt");
var $47c29e214f330261$var$_uiScrollable4 = $47c29e214f330261$var$_interopRequireDefault($2L3wt);

var $2F60d = parcelRequire("2F60d");
function $47c29e214f330261$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $47c29e214f330261$var$SCROLLABLE = "dxScrollable";
var $47c29e214f330261$var$SCROLLABLE_STRATEGY = "dxScrollableStrategy";
var $47c29e214f330261$var$SCROLLABLE_CLASS = "dx-scrollable";
var $47c29e214f330261$var$SCROLLABLE_DISABLED_CLASS = "dx-scrollable-disabled";
var $47c29e214f330261$var$SCROLLABLE_CONTAINER_CLASS = "dx-scrollable-container";
var $47c29e214f330261$var$SCROLLABLE_WRAPPER_CLASS = "dx-scrollable-wrapper";
var $47c29e214f330261$var$SCROLLABLE_CONTENT_CLASS = "dx-scrollable-content";
var $47c29e214f330261$var$SCROLLABLE_CUSTOMIZABLE_SCROLLBARS_CLASS = "dx-scrollable-customizable-scrollbars";
var $47c29e214f330261$var$VERTICAL = "vertical";
var $47c29e214f330261$var$HORIZONTAL = "horizontal";
var $47c29e214f330261$var$BOTH = "both";
var $47c29e214f330261$var$deviceDependentOptions = function() {
    return [
        {
            device: function() {
                return !$47c29e214f330261$var$_support2.default.nativeScrolling;
            },
            options: {
                useNative: false
            }
        },
        {
            device: function(_device) {
                return !$47c29e214f330261$var$_devices2.default.isSimulator() && "desktop" === $47c29e214f330261$var$_devices2.default.real().deviceType && "generic" === _device.platform;
            },
            options: {
                bounceEnabled: false,
                scrollByThumb: true,
                scrollByContent: $47c29e214f330261$var$_support2.default.touch,
                showScrollbar: "onHover"
            }
        }
    ];
};
var $47c29e214f330261$var$Scrollable = $47c29e214f330261$var$_dom_component2.default.inherit({
    _getDefaultOptions: function() {
        return (0, $7I8Uw.extend)(this.callBase(), {
            disabled: false,
            onScroll: null,
            direction: $47c29e214f330261$var$VERTICAL,
            showScrollbar: "onScroll",
            useNative: true,
            bounceEnabled: true,
            scrollByContent: true,
            scrollByThumb: false,
            onUpdated: null,
            onStart: null,
            onEnd: null,
            onBounce: null,
            onStop: null,
            useSimulatedScrollbar: false,
            useKeyboard: true,
            inertiaEnabled: true,
            pushBackValue: 0,
            updateManually: false
        });
    },
    _defaultOptionsRules: function() {
        return this.callBase().concat($47c29e214f330261$var$deviceDependentOptions(), [
            {
                device: function() {
                    return $47c29e214f330261$var$_support2.default.nativeScrolling && "android" === $47c29e214f330261$var$_devices2.default.real().platform && !$47c29e214f330261$var$_browser2.default.mozilla;
                },
                options: {
                    useSimulatedScrollbar: true
                }
            },
            {
                device: function() {
                    return "ios" === $47c29e214f330261$var$_devices2.default.real().platform;
                },
                options: {
                    pushBackValue: 1
                }
            }
        ]);
    },
    _initOptions: function(options) {
        this.callBase(options);
        if (!("useSimulatedScrollbar" in options)) this._setUseSimulatedScrollbar();
    },
    _setUseSimulatedScrollbar: function() {
        if (!this.initialOption("useSimulatedScrollbar")) this.option("useSimulatedScrollbar", !this.option("useNative"));
    },
    _init: function() {
        this.callBase();
        this._initScrollableMarkup();
        this._locked = false;
    },
    _visibilityChanged: function(visible) {
        if (visible) {
            this.update();
            this._updateRtlPosition();
            this._savedScrollOffset && this.scrollTo(this._savedScrollOffset);
            delete this._savedScrollOffset;
        } else this._savedScrollOffset = this.scrollOffset();
    },
    _initScrollableMarkup: function() {
        var $element = this.$element().addClass($47c29e214f330261$var$SCROLLABLE_CLASS);
        var $container = this._$container = (0, $47c29e214f330261$var$_renderer2.default)("<div>").addClass($47c29e214f330261$var$SCROLLABLE_CONTAINER_CLASS);
        var $wrapper = this._$wrapper = (0, $47c29e214f330261$var$_renderer2.default)("<div>").addClass($47c29e214f330261$var$SCROLLABLE_WRAPPER_CLASS);
        var $content = this._$content = (0, $47c29e214f330261$var$_renderer2.default)("<div>").addClass($47c29e214f330261$var$SCROLLABLE_CONTENT_CLASS);
        if ($47c29e214f330261$var$_dom_adapter2.default.hasDocumentProperty("onbeforeactivate") && $47c29e214f330261$var$_browser2.default.msie && $47c29e214f330261$var$_browser2.default.version < 12) $47c29e214f330261$var$_events_engine2.default.on($element, $47c29e214f330261$var$_utils2.default.addNamespace("beforeactivate", $47c29e214f330261$var$SCROLLABLE), function(e) {
            if (!(0, $47c29e214f330261$var$_renderer2.default)(e.target).is($47c29e214f330261$var$_selectors2.default.focusable)) e.preventDefault();
        });
        $content.append($element.contents()).appendTo($container);
        $container.appendTo($wrapper);
        $wrapper.appendTo($element);
    },
    _dimensionChanged: function() {
        this.update();
    },
    _attachNativeScrollbarsCustomizationCss: function() {
        if ("desktop" === $47c29e214f330261$var$_devices2.default.real().deviceType && !($47c29e214f330261$var$_window2.default.getNavigator().platform.indexOf("Mac") > -1 && $47c29e214f330261$var$_browser2.default.webkit)) this.$element().addClass($47c29e214f330261$var$SCROLLABLE_CUSTOMIZABLE_SCROLLBARS_CLASS);
    },
    _initMarkup: function() {
        this.callBase();
        this._renderDirection();
    },
    _render: function() {
        this._renderStrategy();
        this._attachNativeScrollbarsCustomizationCss();
        this._attachEventHandlers();
        this._renderDisabledState();
        this._createActions();
        this.update();
        this.callBase();
        this._updateRtlPosition();
    },
    _updateRtlPosition: function() {
        var _this = this;
        this._updateBounds();
        if (this.option("rtlEnabled") && this.option("direction") !== $47c29e214f330261$var$VERTICAL) $47c29e214f330261$var$_common2.default.deferUpdate(function() {
            var containerElement = _this._container().get(0);
            var maxLeftOffset = containerElement.scrollWidth - containerElement.clientWidth;
            $47c29e214f330261$var$_common2.default.deferRender(function() {
                _this.scrollTo({
                    left: maxLeftOffset
                });
            });
        });
    },
    _updateBounds: function() {
        this._strategy.updateBounds();
    },
    _attachEventHandlers: function() {
        var strategy = this._strategy;
        var initEventData = {
            getDirection: strategy.getDirection.bind(strategy),
            validate: this._validate.bind(this),
            isNative: this.option("useNative"),
            scrollTarget: this._$container
        };
        $47c29e214f330261$var$_events_engine2.default.off(this._$wrapper, "." + $47c29e214f330261$var$SCROLLABLE);
        $47c29e214f330261$var$_events_engine2.default.on(this._$wrapper, $47c29e214f330261$var$_utils2.default.addNamespace($47c29e214f330261$var$_uiEventsEmitterGesture2.default.init, $47c29e214f330261$var$SCROLLABLE), initEventData, this._initHandler.bind(this));
        $47c29e214f330261$var$_events_engine2.default.on(this._$wrapper, $47c29e214f330261$var$_utils2.default.addNamespace($47c29e214f330261$var$_uiEventsEmitterGesture2.default.start, $47c29e214f330261$var$SCROLLABLE), strategy.handleStart.bind(strategy));
        $47c29e214f330261$var$_events_engine2.default.on(this._$wrapper, $47c29e214f330261$var$_utils2.default.addNamespace($47c29e214f330261$var$_uiEventsEmitterGesture2.default.move, $47c29e214f330261$var$SCROLLABLE), strategy.handleMove.bind(strategy));
        $47c29e214f330261$var$_events_engine2.default.on(this._$wrapper, $47c29e214f330261$var$_utils2.default.addNamespace($47c29e214f330261$var$_uiEventsEmitterGesture2.default.end, $47c29e214f330261$var$SCROLLABLE), strategy.handleEnd.bind(strategy));
        $47c29e214f330261$var$_events_engine2.default.on(this._$wrapper, $47c29e214f330261$var$_utils2.default.addNamespace($47c29e214f330261$var$_uiEventsEmitterGesture2.default.cancel, $47c29e214f330261$var$SCROLLABLE), strategy.handleCancel.bind(strategy));
        $47c29e214f330261$var$_events_engine2.default.on(this._$wrapper, $47c29e214f330261$var$_utils2.default.addNamespace($47c29e214f330261$var$_uiEventsEmitterGesture2.default.stop, $47c29e214f330261$var$SCROLLABLE), strategy.handleStop.bind(strategy));
        $47c29e214f330261$var$_events_engine2.default.off(this._$container, "." + $47c29e214f330261$var$SCROLLABLE);
        $47c29e214f330261$var$_events_engine2.default.on(this._$container, $47c29e214f330261$var$_utils2.default.addNamespace("scroll", $47c29e214f330261$var$SCROLLABLE), strategy.handleScroll.bind(strategy));
    },
    _validate: function(e) {
        if (this._isLocked()) return false;
        this._updateIfNeed();
        return this._strategy.validate(e);
    },
    _initHandler: function() {
        var strategy = this._strategy;
        strategy.handleInit.apply(strategy, arguments);
    },
    _renderDisabledState: function() {
        this.$element().toggleClass($47c29e214f330261$var$SCROLLABLE_DISABLED_CLASS, this.option("disabled"));
        if (this.option("disabled")) this._lock();
        else this._unlock();
    },
    _renderDirection: function() {
        this.$element().removeClass("dx-scrollable-" + $47c29e214f330261$var$HORIZONTAL).removeClass("dx-scrollable-" + $47c29e214f330261$var$VERTICAL).removeClass("dx-scrollable-" + $47c29e214f330261$var$BOTH).addClass("dx-scrollable-" + this.option("direction"));
    },
    _renderStrategy: function() {
        this._createStrategy();
        this._strategy.render();
        this.$element().data($47c29e214f330261$var$SCROLLABLE_STRATEGY, this._strategy);
    },
    _createStrategy: function() {
        this._strategy = this.option("useNative") ? new $47c29e214f330261$var$_uiScrollable4.default(this) : new $47c29e214f330261$var$_uiScrollable2.default.SimulatedStrategy(this);
    },
    _createActions: function() {
        this._strategy && this._strategy.createActions();
    },
    _clean: function() {
        this._strategy && this._strategy.dispose();
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "onStart":
            case "onEnd":
            case "onStop":
            case "onUpdated":
            case "onScroll":
            case "onBounce":
                this._createActions();
                break;
            case "direction":
                this._resetInactiveDirection();
                this._invalidate();
                break;
            case "useNative":
                this._setUseSimulatedScrollbar();
                this._invalidate();
                break;
            case "inertiaEnabled":
            case "scrollByContent":
            case "scrollByThumb":
            case "bounceEnabled":
            case "useKeyboard":
            case "showScrollbar":
            case "useSimulatedScrollbar":
            case "pushBackValue":
                this._invalidate();
                break;
            case "disabled":
                this._renderDisabledState();
                this._strategy && this._strategy.disabledChanged();
                break;
            case "updateManually":
                break;
            case "width":
                this.callBase(args);
                this._updateRtlPosition();
                break;
            default:
                this.callBase(args);
        }
    },
    _resetInactiveDirection: function() {
        var inactiveProp = this._getInactiveProp();
        if (!inactiveProp || !$47c29e214f330261$var$_window2.default.hasWindow()) return;
        var scrollOffset = this.scrollOffset();
        scrollOffset[inactiveProp] = 0;
        this.scrollTo(scrollOffset);
    },
    _getInactiveProp: function() {
        var direction = this.option("direction");
        if (direction === $47c29e214f330261$var$VERTICAL) return "left";
        if (direction === $47c29e214f330261$var$HORIZONTAL) return "top";
    },
    _location: function() {
        return this._strategy.location();
    },
    _normalizeLocation: function(location) {
        if ($47c29e214f330261$var$_type2.default.isPlainObject(location)) {
            var left = $47c29e214f330261$var$_common2.default.ensureDefined(location.left, location.x);
            var top = $47c29e214f330261$var$_common2.default.ensureDefined(location.top, location.y);
            return {
                left: $47c29e214f330261$var$_type2.default.isDefined(left) ? -left : void 0,
                top: $47c29e214f330261$var$_type2.default.isDefined(top) ? -top : void 0
            };
        } else {
            var direction = this.option("direction");
            return {
                left: direction !== $47c29e214f330261$var$VERTICAL ? -location : void 0,
                top: direction !== $47c29e214f330261$var$HORIZONTAL ? -location : void 0
            };
        }
    },
    _isLocked: function() {
        return this._locked;
    },
    _lock: function() {
        this._locked = true;
    },
    _unlock: function() {
        if (!this.option("disabled")) this._locked = false;
    },
    _isDirection: function(direction) {
        var current = this.option("direction");
        if (direction === $47c29e214f330261$var$VERTICAL) return current !== $47c29e214f330261$var$HORIZONTAL;
        if (direction === $47c29e214f330261$var$HORIZONTAL) return current !== $47c29e214f330261$var$VERTICAL;
        return current === direction;
    },
    _updateAllowedDirection: function() {
        var allowedDirections = this._strategy._allowedDirections();
        if (this._isDirection($47c29e214f330261$var$BOTH) && allowedDirections.vertical && allowedDirections.horizontal) this._allowedDirectionValue = $47c29e214f330261$var$BOTH;
        else {
            if (this._isDirection($47c29e214f330261$var$HORIZONTAL) && allowedDirections.horizontal) this._allowedDirectionValue = $47c29e214f330261$var$HORIZONTAL;
            else if (this._isDirection($47c29e214f330261$var$VERTICAL) && allowedDirections.vertical) this._allowedDirectionValue = $47c29e214f330261$var$VERTICAL;
            else this._allowedDirectionValue = null;
        }
    },
    _allowedDirection: function() {
        return this._allowedDirectionValue;
    },
    _container: function() {
        return this._$container;
    },
    $content: function() {
        return this._$content;
    },
    content: function() {
        return (0, $5OzEX.getPublicElement)(this._$content);
    },
    scrollOffset: function() {
        var location = this._location();
        return {
            top: -location.top,
            left: -location.left
        };
    },
    scrollTop: function() {
        return this.scrollOffset().top;
    },
    scrollLeft: function() {
        return this.scrollOffset().left;
    },
    clientHeight: function() {
        return this._$container.height();
    },
    scrollHeight: function() {
        return this.$content().outerHeight() - 2 * this._strategy.verticalOffset();
    },
    clientWidth: function() {
        return this._$container.width();
    },
    scrollWidth: function() {
        return this.$content().outerWidth();
    },
    update: function() {
        if (!this._strategy) return;
        return (0, $2F60d.when)(this._strategy.update()).done((function() {
            this._updateAllowedDirection();
        }).bind(this));
    },
    scrollBy: function(distance) {
        distance = this._normalizeLocation(distance);
        if (!distance.top && !distance.left) return;
        this._updateIfNeed();
        this._strategy.scrollBy(distance);
    },
    scrollTo: function(targetLocation) {
        targetLocation = this._normalizeLocation(targetLocation);
        this._updateIfNeed();
        var location = this._location();
        if (!this.option("useNative")) {
            targetLocation = this._strategy._applyScaleRatio(targetLocation);
            location = this._strategy._applyScaleRatio(location);
        }
        var distance = this._normalizeLocation({
            left: location.left - $47c29e214f330261$var$_common2.default.ensureDefined(targetLocation.left, location.left),
            top: location.top - $47c29e214f330261$var$_common2.default.ensureDefined(targetLocation.top, location.top)
        });
        if (!distance.top && !distance.left) return;
        this._strategy.scrollBy(distance);
    },
    scrollToElement: function(element, offset) {
        var $element = (0, $47c29e214f330261$var$_renderer2.default)(element);
        var elementInsideContent = this.$content().find(element).length;
        var elementIsInsideContent = $element.parents("." + $47c29e214f330261$var$SCROLLABLE_CLASS).length - $element.parents("." + $47c29e214f330261$var$SCROLLABLE_CONTENT_CLASS).length === 0;
        if (!elementInsideContent || !elementIsInsideContent) return;
        var scrollPosition = {
            top: 0,
            left: 0
        };
        var direction = this.option("direction");
        if (direction !== $47c29e214f330261$var$VERTICAL) scrollPosition.left = this.getScrollElementPosition($element, $47c29e214f330261$var$HORIZONTAL, offset);
        if (direction !== $47c29e214f330261$var$HORIZONTAL) scrollPosition.top = this.getScrollElementPosition($element, $47c29e214f330261$var$VERTICAL, offset);
        this.scrollTo(scrollPosition);
    },
    getScrollElementPosition: function($element, direction, offset) {
        offset = offset || {};
        var isVertical = direction === $47c29e214f330261$var$VERTICAL;
        var startOffset = (isVertical ? offset.top : offset.left) || 0;
        var endOffset = (isVertical ? offset.bottom : offset.right) || 0;
        var pushBackOffset = isVertical ? this._strategy.verticalOffset() : 0;
        var elementPositionRelativeToContent = this._elementPositionRelativeToContent($element, isVertical ? "top" : "left");
        var elementPosition = elementPositionRelativeToContent - pushBackOffset;
        var elementSize = $element[isVertical ? "outerHeight" : "outerWidth"]();
        var scrollLocation = isVertical ? this.scrollTop() : this.scrollLeft();
        var clientSize = isVertical ? this.clientHeight() : this.clientWidth();
        var startDistance = scrollLocation - elementPosition + startOffset;
        var endDistance = scrollLocation - elementPosition - elementSize + clientSize - endOffset;
        if (startDistance <= 0 && endDistance >= 0) return scrollLocation;
        return scrollLocation - (Math.abs(startDistance) > Math.abs(endDistance) ? endDistance : startDistance);
    },
    _elementPositionRelativeToContent: function($element, prop) {
        var result = 0;
        while(this._hasScrollContent($element)){
            result += $element.position()[prop];
            $element = $element.offsetParent();
        }
        return result;
    },
    _hasScrollContent: function($element) {
        var $content = this.$content();
        return $element.closest($content).length && !$element.is($content);
    },
    _updateIfNeed: function() {
        if (!this.option("updateManually")) this.update();
    }
});
(0, $47c29e214f330261$var$_component_registrator2.default)($47c29e214f330261$var$SCROLLABLE, $47c29e214f330261$var$Scrollable);
module.exports = $47c29e214f330261$var$Scrollable;
module.exports.deviceDependentOptions = $47c29e214f330261$var$deviceDependentOptions;

});
parcelRegister("7axoe", function(module, exports) {
/**
 * DevExtreme (ui/scroll_view/ui.events.emitter.gesture.scroll.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $e1LMc = parcelRequire("e1LMc");

var $k7aJb = parcelRequire("k7aJb");
var $53835e161db515db$var$abstract = $k7aJb.abstract;

var $bXb2w = parcelRequire("bXb2w");

var $dqZUs = parcelRequire("dqZUs");

var $fy5D5 = parcelRequire("fy5D5");

var $fF1Ws = parcelRequire("fF1Ws");

var $53835e161db515db$var$realDevice = (parcelRequire("aiwte")).real();

var $hwytx = parcelRequire("hwytx");
var $53835e161db515db$require$compareVersions = $hwytx.compare;
var $53835e161db515db$var$SCROLL_INIT_EVENT = "dxscrollinit";
var $53835e161db515db$var$SCROLL_START_EVENT = "dxscrollstart";
var $53835e161db515db$var$SCROLL_MOVE_EVENT = "dxscroll";
var $53835e161db515db$var$SCROLL_END_EVENT = "dxscrollend";
var $53835e161db515db$var$SCROLL_STOP_EVENT = "dxscrollstop";
var $53835e161db515db$var$SCROLL_CANCEL_EVENT = "dxscrollcancel";
var $53835e161db515db$var$Locker = $k7aJb.inherit(function() {
    var NAMESPACED_SCROLL_EVENT = $bXb2w.addNamespace("scroll", "dxScrollEmitter");
    return {
        ctor: function(element) {
            this._element = element;
            this._locked = false;
            var that = this;
            this._proxiedScroll = function(e) {
                that._scroll(e);
            };
            $e1LMc.on(this._element, NAMESPACED_SCROLL_EVENT, this._proxiedScroll);
        },
        _scroll: $53835e161db515db$var$abstract,
        check: function(e, callback) {
            if (this._locked) callback();
        },
        dispose: function() {
            $e1LMc.off(this._element, NAMESPACED_SCROLL_EVENT, this._proxiedScroll);
        }
    };
}());
var $53835e161db515db$var$TimeoutLocker = $53835e161db515db$var$Locker.inherit(function() {
    return {
        ctor: function(element, timeout) {
            this.callBase(element);
            this._timeout = timeout;
        },
        _scroll: function() {
            this._prepare();
            this._forget();
        },
        _prepare: function() {
            if (this._timer) this._clearTimer();
            this._locked = true;
        },
        _clearTimer: function() {
            clearTimeout(this._timer);
            this._locked = false;
            this._timer = null;
        },
        _forget: function() {
            var that = this;
            this._timer = setTimeout(function() {
                that._clearTimer();
            }, this._timeout);
        },
        dispose: function() {
            this.callBase();
            this._clearTimer();
        }
    };
}());
var $53835e161db515db$var$WheelLocker = $53835e161db515db$var$TimeoutLocker.inherit(function() {
    var WHEEL_UNLOCK_TIMEOUT = 400;
    return {
        ctor: function(element) {
            this.callBase(element, WHEEL_UNLOCK_TIMEOUT);
            this._lastWheelDirection = null;
        },
        check: function(e, callback) {
            this._checkDirectionChanged(e);
            this.callBase(e, callback);
        },
        _checkDirectionChanged: function(e) {
            if (!$bXb2w.isDxMouseWheelEvent(e)) {
                this._lastWheelDirection = null;
                return;
            }
            var direction = e.shiftKey || false;
            var directionChange = null !== this._lastWheelDirection && direction !== this._lastWheelDirection;
            this._lastWheelDirection = direction;
            this._locked = this._locked && !directionChange;
        }
    };
}());
var $53835e161db515db$var$PointerLocker = $53835e161db515db$var$TimeoutLocker.inherit(function() {
    var POINTER_UNLOCK_TIMEOUT = 400;
    return {
        ctor: function(element) {
            this.callBase(element, POINTER_UNLOCK_TIMEOUT);
        }
    };
}());
!function() {
    var ios8_greater = $53835e161db515db$var$realDevice.ios && $53835e161db515db$require$compareVersions($53835e161db515db$var$realDevice.version, [
        8
    ]) >= 0;
    var android5_greater = $53835e161db515db$var$realDevice.android && $53835e161db515db$require$compareVersions($53835e161db515db$var$realDevice.version, [
        5
    ]) >= 0;
    if (!(ios8_greater || android5_greater)) return;
    $53835e161db515db$var$PointerLocker = $53835e161db515db$var$Locker.inherit(function() {
        return {
            _scroll: function() {
                this._locked = true;
                var that = this;
                $fF1Ws.cancelAnimationFrame(this._scrollFrame);
                this._scrollFrame = $fF1Ws.requestAnimationFrame(function() {
                    that._locked = false;
                });
            },
            check: function(e, callback) {
                $fF1Ws.cancelAnimationFrame(this._scrollFrame);
                $fF1Ws.cancelAnimationFrame(this._checkFrame);
                var that = this;
                var callBase = this.callBase;
                this._checkFrame = $fF1Ws.requestAnimationFrame(function() {
                    callBase.call(that, e, callback);
                    that._locked = false;
                });
            },
            dispose: function() {
                this.callBase();
                $fF1Ws.cancelAnimationFrame(this._scrollFrame);
                $fF1Ws.cancelAnimationFrame(this._checkFrame);
            }
        };
    }());
}();
var $53835e161db515db$var$ScrollEmitter = $dqZUs.inherit(function() {
    var INERTIA_TIMEOUT = 100;
    var VELOCITY_CALC_TIMEOUT = 200;
    var FRAME_DURATION = Math.round(1e3 / 60);
    return {
        ctor: function(element) {
            this.callBase.apply(this, arguments);
            this.direction = "both";
            this._pointerLocker = new $53835e161db515db$var$PointerLocker(element);
            this._wheelLocker = new $53835e161db515db$var$WheelLocker(element);
        },
        validate: function() {
            return true;
        },
        configure: function(data) {
            if (data.scrollTarget) {
                this._pointerLocker.dispose();
                this._wheelLocker.dispose();
                this._pointerLocker = new $53835e161db515db$var$PointerLocker(data.scrollTarget);
                this._wheelLocker = new $53835e161db515db$var$WheelLocker(data.scrollTarget);
            }
            this.callBase(data);
        },
        _init: function(e) {
            this._wheelLocker.check(e, (function() {
                if ($bXb2w.isDxMouseWheelEvent(e)) this._accept(e);
            }).bind(this));
            this._pointerLocker.check(e, (function() {
                var skipCheck = this.isNative && $bXb2w.isMouseEvent(e);
                if (!$bXb2w.isDxMouseWheelEvent(e) && !skipCheck) this._accept(e);
            }).bind(this));
            this._fireEvent($53835e161db515db$var$SCROLL_INIT_EVENT, e);
            this._prevEventData = $bXb2w.eventData(e);
        },
        move: function(e) {
            this.callBase.apply(this, arguments);
            e.isScrollingEvent = this.isNative || e.isScrollingEvent;
        },
        _start: function(e) {
            this._savedEventData = $bXb2w.eventData(e);
            this._fireEvent($53835e161db515db$var$SCROLL_START_EVENT, e);
            this._prevEventData = $bXb2w.eventData(e);
        },
        _move: function(e) {
            var currentEventData = $bXb2w.eventData(e);
            this._fireEvent($53835e161db515db$var$SCROLL_MOVE_EVENT, e, {
                delta: $bXb2w.eventDelta(this._prevEventData, currentEventData)
            });
            var eventDelta = $bXb2w.eventDelta(this._savedEventData, currentEventData);
            if (eventDelta.time > VELOCITY_CALC_TIMEOUT) this._savedEventData = this._prevEventData;
            this._prevEventData = $bXb2w.eventData(e);
        },
        _end: function(e) {
            var endEventDelta = $bXb2w.eventDelta(this._prevEventData, $bXb2w.eventData(e));
            var velocity = {
                x: 0,
                y: 0
            };
            if (!$bXb2w.isDxMouseWheelEvent(e) && endEventDelta.time < INERTIA_TIMEOUT) {
                var eventDelta = $bXb2w.eventDelta(this._savedEventData, this._prevEventData);
                var velocityMultiplier = FRAME_DURATION / eventDelta.time;
                velocity = {
                    x: eventDelta.x * velocityMultiplier,
                    y: eventDelta.y * velocityMultiplier
                };
            }
            this._fireEvent($53835e161db515db$var$SCROLL_END_EVENT, e, {
                velocity: velocity
            });
        },
        _stop: function(e) {
            this._fireEvent($53835e161db515db$var$SCROLL_STOP_EVENT, e);
        },
        cancel: function(e) {
            this.callBase.apply(this, arguments);
            this._fireEvent($53835e161db515db$var$SCROLL_CANCEL_EVENT, e);
        },
        dispose: function() {
            this.callBase.apply(this, arguments);
            this._pointerLocker.dispose();
            this._wheelLocker.dispose();
        },
        _clearSelection: function() {
            if (this.isNative) return;
            return this.callBase.apply(this, arguments);
        },
        _toggleGestureCover: function() {
            if (this.isNative) return;
            return this.callBase.apply(this, arguments);
        }
    };
}());
$fy5D5({
    emitter: $53835e161db515db$var$ScrollEmitter,
    events: [
        $53835e161db515db$var$SCROLL_INIT_EVENT,
        $53835e161db515db$var$SCROLL_START_EVENT,
        $53835e161db515db$var$SCROLL_MOVE_EVENT,
        $53835e161db515db$var$SCROLL_END_EVENT,
        $53835e161db515db$var$SCROLL_STOP_EVENT,
        $53835e161db515db$var$SCROLL_CANCEL_EVENT
    ]
});
module.exports = {
    init: $53835e161db515db$var$SCROLL_INIT_EVENT,
    start: $53835e161db515db$var$SCROLL_START_EVENT,
    move: $53835e161db515db$var$SCROLL_MOVE_EVENT,
    end: $53835e161db515db$var$SCROLL_END_EVENT,
    stop: $53835e161db515db$var$SCROLL_STOP_EVENT,
    cancel: $53835e161db515db$var$SCROLL_CANCEL_EVENT
};

});


parcelRegister("DrKoa", function(module, exports) {
/**
 * DevExtreme (ui/load_panel.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $2Mto0 = parcelRequire("2Mto0");
var $07692aa67f4cdc10$require$noop = $2Mto0.noop;

var $cnVbh = parcelRequire("cnVbh");

var $4ZFRo = parcelRequire("4ZFRo");

var $7I8Uw = parcelRequire("7I8Uw");
var $07692aa67f4cdc10$require$extend = $7I8Uw.extend;

var $gbWer = parcelRequire("gbWer");

var $8LFjz = parcelRequire("8LFjz");

var $2F60d = parcelRequire("2F60d");
var $07692aa67f4cdc10$require$Deferred = $2F60d.Deferred;

var $3LUJe = parcelRequire("3LUJe");
var $07692aa67f4cdc10$var$LOADPANEL_CLASS = "dx-loadpanel";
var $07692aa67f4cdc10$var$LOADPANEL_WRAPPER_CLASS = "dx-loadpanel-wrapper";
var $07692aa67f4cdc10$var$LOADPANEL_INDICATOR_CLASS = "dx-loadpanel-indicator";
var $07692aa67f4cdc10$var$LOADPANEL_MESSAGE_CLASS = "dx-loadpanel-message";
var $07692aa67f4cdc10$var$LOADPANEL_CONTENT_CLASS = "dx-loadpanel-content";
var $07692aa67f4cdc10$var$LOADPANEL_CONTENT_WRAPPER_CLASS = "dx-loadpanel-content-wrapper";
var $07692aa67f4cdc10$var$LOADPANEL_PANE_HIDDEN_CLASS = "dx-loadpanel-pane-hidden";
var $07692aa67f4cdc10$var$LoadPanel = $8LFjz.inherit({
    _supportedKeys: function() {
        return $07692aa67f4cdc10$require$extend(this.callBase(), {
            escape: $07692aa67f4cdc10$require$noop
        });
    },
    _getDefaultOptions: function() {
        return $07692aa67f4cdc10$require$extend(this.callBase(), {
            message: $cnVbh.format("Loading"),
            width: 222,
            height: 90,
            animation: null,
            showIndicator: true,
            indicatorSrc: "",
            showPane: true,
            delay: 0,
            closeOnBackButton: false,
            templatesRenderAsynchronously: false,
            resizeEnabled: false,
            focusStateEnabled: false
        });
    },
    _defaultOptionsRules: function() {
        return this.callBase().concat([
            {
                device: {
                    platform: "generic"
                },
                options: {
                    shadingColor: "transparent"
                }
            },
            {
                device: function() {
                    return $3LUJe.isMaterial();
                },
                options: {
                    message: "",
                    width: 60,
                    height: 60,
                    maxHeight: 60,
                    maxWidth: 60
                }
            }
        ]);
    },
    _init: function() {
        this.callBase.apply(this, arguments);
    },
    _render: function() {
        this.callBase();
        this.$element().addClass($07692aa67f4cdc10$var$LOADPANEL_CLASS);
        this._wrapper().addClass($07692aa67f4cdc10$var$LOADPANEL_WRAPPER_CLASS);
    },
    _renderContentImpl: function() {
        this.callBase();
        this.$content().addClass($07692aa67f4cdc10$var$LOADPANEL_CONTENT_CLASS);
        this._$contentWrapper = $jFnCG("<div>").addClass($07692aa67f4cdc10$var$LOADPANEL_CONTENT_WRAPPER_CLASS);
        this._$contentWrapper.appendTo(this._$content);
        this._togglePaneVisible();
        this._cleanPreviousContent();
        this._renderLoadIndicator();
        this._renderMessage();
    },
    _show: function() {
        var delay = this.option("delay");
        if (!delay) return this.callBase();
        var deferred = new $07692aa67f4cdc10$require$Deferred;
        var callBase = this.callBase.bind(this);
        this._clearShowTimeout();
        this._showTimeout = setTimeout(function() {
            callBase().done(function() {
                deferred.resolve();
            });
        }, delay);
        return deferred.promise();
    },
    _hide: function() {
        this._clearShowTimeout();
        return this.callBase();
    },
    _clearShowTimeout: function() {
        clearTimeout(this._showTimeout);
    },
    _renderMessage: function() {
        if (!this._$contentWrapper) return;
        var message = this.option("message");
        if (!message) return;
        var $message = $jFnCG("<div>").addClass($07692aa67f4cdc10$var$LOADPANEL_MESSAGE_CLASS).text(message);
        this._$contentWrapper.append($message);
    },
    _renderLoadIndicator: function() {
        if (!this._$contentWrapper || !this.option("showIndicator")) return;
        this._$indicator = $jFnCG("<div>").addClass($07692aa67f4cdc10$var$LOADPANEL_INDICATOR_CLASS).appendTo(this._$contentWrapper);
        this._createComponent(this._$indicator, $gbWer, {
            indicatorSrc: this.option("indicatorSrc")
        });
    },
    _cleanPreviousContent: function() {
        this.$content().find("." + $07692aa67f4cdc10$var$LOADPANEL_MESSAGE_CLASS).remove();
        this.$content().find("." + $07692aa67f4cdc10$var$LOADPANEL_INDICATOR_CLASS).remove();
    },
    _togglePaneVisible: function() {
        this.$content().toggleClass($07692aa67f4cdc10$var$LOADPANEL_PANE_HIDDEN_CLASS, !this.option("showPane"));
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "delay":
                break;
            case "message":
            case "showIndicator":
                this._cleanPreviousContent();
                this._renderLoadIndicator();
                this._renderMessage();
                break;
            case "showPane":
                this._togglePaneVisible();
                break;
            case "indicatorSrc":
                if (this._$indicator) this._createComponent(this._$indicator, $gbWer, {
                    indicatorSrc: this.option("indicatorSrc")
                });
                break;
            default:
                this.callBase(args);
        }
    },
    _dispose: function() {
        this._clearShowTimeout();
        this.callBase();
    }
});
$4ZFRo("dxLoadPanel", $07692aa67f4cdc10$var$LoadPanel);
module.exports = $07692aa67f4cdc10$var$LoadPanel;
module.exports.default = module.exports;

});


parcelRegister("9WfTY", function(module, exports) {
/**
 * DevExtreme (ui/text_box/text_box.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $irv64 = parcelRequire("irv64");
var $73c5dd9e5f9e64f7$var$window = $irv64.getWindow();
var $73c5dd9e5f9e64f7$var$navigator = $irv64.getNavigator();

var $bvcPv = parcelRequire("bvcPv");

var $e1LMc = parcelRequire("e1LMc");

var $aiwte = parcelRequire("aiwte");

var $aLQK5 = parcelRequire("aLQK5");
var $73c5dd9e5f9e64f7$require$inArray = $aLQK5.inArray;

var $7I8Uw = parcelRequire("7I8Uw");
var $73c5dd9e5f9e64f7$require$extend = $7I8Uw.extend;

var $4ZFRo = parcelRequire("4ZFRo");

var $tPhLo = parcelRequire("tPhLo");

var $bXb2w = parcelRequire("bXb2w");
var $73c5dd9e5f9e64f7$var$ua = $73c5dd9e5f9e64f7$var$navigator.userAgent;
var $73c5dd9e5f9e64f7$var$ignoreKeys = [
    "backspace",
    "tab",
    "enter",
    "pageUp",
    "pageDown",
    "end",
    "home",
    "leftArrow",
    "rightArrow",
    "downArrow",
    "upArrow",
    "del"
];
var $73c5dd9e5f9e64f7$var$TEXTBOX_CLASS = "dx-textbox";
var $73c5dd9e5f9e64f7$var$SEARCHBOX_CLASS = "dx-searchbox";
var $73c5dd9e5f9e64f7$var$ICON_CLASS = "dx-icon";
var $73c5dd9e5f9e64f7$var$SEARCH_ICON_CLASS = "dx-icon-search";
var $73c5dd9e5f9e64f7$var$TextBox = $tPhLo.inherit({
    ctor: function(element, options) {
        if (options) this._showClearButton = options.showClearButton;
        this.callBase.apply(this, arguments);
    },
    _getDefaultOptions: function() {
        return $73c5dd9e5f9e64f7$require$extend(this.callBase(), {
            value: "",
            mode: "text",
            maxLength: null
        });
    },
    _initMarkup: function() {
        this.$element().addClass($73c5dd9e5f9e64f7$var$TEXTBOX_CLASS);
        this.callBase();
        this.setAria("role", "textbox");
    },
    _renderContentImpl: function() {
        this._renderMaxLengthHandlers();
        this.callBase();
    },
    _renderInputType: function() {
        this.callBase();
        this._renderSearchMode();
    },
    _renderMaxLengthHandlers: function() {
        if (this._isAndroidOrIE()) {
            $e1LMc.on(this._input(), $bXb2w.addNamespace("keydown", this.NAME), this._onKeyDownCutOffHandler.bind(this));
            $e1LMc.on(this._input(), $bXb2w.addNamespace("change", this.NAME), this._onChangeCutOffHandler.bind(this));
        }
    },
    _renderProps: function() {
        this.callBase();
        this._toggleMaxLengthProp();
    },
    _toggleMaxLengthProp: function() {
        var maxLength = this._getMaxLength();
        if (maxLength && maxLength > 0) this._input().attr("maxLength", maxLength);
        else this._input().removeAttr("maxLength");
    },
    _renderSearchMode: function() {
        var $element = this._$element;
        if ("search" === this.option("mode")) {
            $element.addClass($73c5dd9e5f9e64f7$var$SEARCHBOX_CLASS);
            this._renderSearchIcon();
            if (void 0 === this._showClearButton) {
                this._showClearButton = this.option("showClearButton");
                this.option("showClearButton", true);
            }
        } else {
            $element.removeClass($73c5dd9e5f9e64f7$var$SEARCHBOX_CLASS);
            this._$searchIcon && this._$searchIcon.remove();
            this.option("showClearButton", void 0 === this._showClearButton ? this.option("showClearButton") : this._showClearButton);
            delete this._showClearButton;
        }
    },
    _renderSearchIcon: function() {
        var $searchIcon = $jFnCG("<div>").addClass($73c5dd9e5f9e64f7$var$ICON_CLASS).addClass($73c5dd9e5f9e64f7$var$SEARCH_ICON_CLASS);
        $searchIcon.prependTo(this._input().parent());
        this._$searchIcon = $searchIcon;
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "maxLength":
                this._toggleMaxLengthProp();
                this._renderMaxLengthHandlers();
                break;
            case "mask":
                this.callBase(args);
                this._toggleMaxLengthProp();
                break;
            default:
                this.callBase(args);
        }
    },
    _onKeyDownCutOffHandler: function(e) {
        var actualMaxLength = this._getMaxLength();
        if (actualMaxLength) {
            var $input = $jFnCG(e.target);
            var key = $bXb2w.normalizeKeyName(e);
            this._cutOffExtraChar($input);
            return $input.val().length < actualMaxLength || $73c5dd9e5f9e64f7$require$inArray(key, $73c5dd9e5f9e64f7$var$ignoreKeys) !== -1 || "" !== $73c5dd9e5f9e64f7$var$window.getSelection().toString();
        } else return true;
    },
    _onChangeCutOffHandler: function(e) {
        var $input = $jFnCG(e.target);
        if (this.option("maxLength")) this._cutOffExtraChar($input);
    },
    _cutOffExtraChar: function($input) {
        var actualMaxLength = this._getMaxLength();
        var textInput = $input.val();
        if (actualMaxLength && textInput.length > actualMaxLength) $input.val(textInput.substr(0, actualMaxLength));
    },
    _getMaxLength: function() {
        var isMaskSpecified = !!this.option("mask");
        return isMaskSpecified ? null : this.option("maxLength");
    },
    _isAndroidOrIE: function() {
        var realDevice = $aiwte.real();
        var version = realDevice.version.join(".");
        return $bvcPv.msie || "android" === realDevice.platform && version && /^(2\.|4\.1)/.test(version) && !/chrome/i.test($73c5dd9e5f9e64f7$var$ua);
    }
});
$4ZFRo("dxTextBox", $73c5dd9e5f9e64f7$var$TextBox);
module.exports = $73c5dd9e5f9e64f7$var$TextBox;

});
parcelRegister("tPhLo", function(module, exports) {
/**
 * DevExtreme (ui/text_box/ui.text_editor.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $4ZFRo = parcelRequire("4ZFRo");

var $jmoAY = parcelRequire("jmoAY");
$4ZFRo("dxTextEditor", $jmoAY);
module.exports = $jmoAY;

});
parcelRegister("jmoAY", function(module, exports) {
/**
 * DevExtreme (ui/text_box/ui.text_editor.mask.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $brnvh = parcelRequire("brnvh");
var $e1832685225ddf7d$require$caret = $brnvh;

var $aiwte = parcelRequire("aiwte");

var $4Pwuy = parcelRequire("4Pwuy");
var $e1832685225ddf7d$require$each = $4Pwuy.each;

var $bXb2w = parcelRequire("bXb2w");

var $e1LMc = parcelRequire("e1LMc");

var $7I8Uw = parcelRequire("7I8Uw");
var $e1832685225ddf7d$require$extend = $7I8Uw.extend;

var $3joCJ = parcelRequire("3joCJ");
var $e1832685225ddf7d$require$focused = $3joCJ.focused;

var $kDRxH = parcelRequire("kDRxH");
var $e1832685225ddf7d$require$isDefined = $kDRxH.isDefined;

var $cnVbh = parcelRequire("cnVbh");

var $2Mto0 = parcelRequire("2Mto0");
var $e1832685225ddf7d$require$noop = $2Mto0.noop;

var $ksvsU = parcelRequire("ksvsU");

var $bfI7V = parcelRequire("bfI7V");

var $7tLCO = parcelRequire("7tLCO");

var $bObtv = parcelRequire("bObtv");

var $aMVxA = parcelRequire("aMVxA");
var $e1832685225ddf7d$require$DefaultMaskStrategy = $aMVxA.default;

var $9B122 = parcelRequire("9B122");
var $e1832685225ddf7d$require$AndroidMaskStrategy = $9B122.default;
var $e1832685225ddf7d$var$stubCaret = function() {
    return {};
};
var $e1832685225ddf7d$var$EMPTY_CHAR = " ";
var $e1832685225ddf7d$var$ESCAPED_CHAR = "\\";
var $e1832685225ddf7d$var$TEXTEDITOR_MASKED_CLASS = "dx-texteditor-masked";
var $e1832685225ddf7d$var$FORWARD_DIRECTION = "forward";
var $e1832685225ddf7d$var$BACKWARD_DIRECTION = "backward";
var $e1832685225ddf7d$var$buildInMaskRules = {
    0: /[0-9]/,
    9: /[0-9\s]/,
    "#": /[-+0-9\s]/,
    L: function(char) {
        return $e1832685225ddf7d$var$isLiteralChar(char);
    },
    l: function(char) {
        return $e1832685225ddf7d$var$isLiteralChar(char) || $e1832685225ddf7d$var$isSpaceChar(char);
    },
    C: /\S/,
    c: /./,
    A: function(char) {
        return $e1832685225ddf7d$var$isLiteralChar(char) || $e1832685225ddf7d$var$isNumericChar(char);
    },
    a: function(char) {
        return $e1832685225ddf7d$var$isLiteralChar(char) || $e1832685225ddf7d$var$isNumericChar(char) || $e1832685225ddf7d$var$isSpaceChar(char);
    }
};
var $e1832685225ddf7d$var$isNumericChar = function(char) {
    return /[0-9]/.test(char);
};
var $e1832685225ddf7d$var$isLiteralChar = function(char) {
    var code = char.charCodeAt();
    return 64 < code && code < 91 || 96 < code && code < 123 || code > 127;
};
var $e1832685225ddf7d$var$isSpaceChar = function(char) {
    return " " === char;
};
var $e1832685225ddf7d$var$TextEditorMask = $bObtv.inherit({
    _getDefaultOptions: function() {
        return $e1832685225ddf7d$require$extend(this.callBase(), {
            mask: "",
            maskChar: "_",
            maskRules: {},
            maskInvalidMessage: $cnVbh.format("validation-mask"),
            useMaskedValue: false,
            showMaskMode: "always"
        });
    },
    _supportedKeys: function() {
        var that = this;
        var keyHandlerMap = {
            backspace: that._maskStrategy.getHandler("backspace"),
            del: that._maskStrategy.getHandler("del"),
            enter: that._changeHandler
        };
        var result = that.callBase();
        $e1832685225ddf7d$require$each(keyHandlerMap, function(key, callback) {
            var parentHandler = result[key];
            result[key] = function(e) {
                that.option("mask") && callback.call(that, e);
                parentHandler && parentHandler(e);
            };
        });
        return result;
    },
    _getSubmitElement: function() {
        return !this.option("mask") ? this.callBase() : this._$hiddenElement;
    },
    _init: function() {
        this.callBase();
        this._initMaskStrategy();
    },
    _initMaskStrategy: function() {
        var device = $aiwte.real();
        this._maskStrategy = device.android && device.version[0] > 4 ? new $e1832685225ddf7d$require$AndroidMaskStrategy(this) : new $e1832685225ddf7d$require$DefaultMaskStrategy(this);
    },
    _initMarkup: function() {
        this._renderHiddenElement();
        this.callBase();
    },
    _attachMouseWheelEventHandlers: function() {
        var hasMouseWheelHandler = this._onMouseWheel !== $e1832685225ddf7d$require$noop;
        if (!hasMouseWheelHandler) return;
        var input = this._input();
        var eventName = $bXb2w.addNamespace($bfI7V.name, this.NAME);
        var mouseWheelAction = this._createAction((function(e) {
            if ($e1832685225ddf7d$require$focused(input)) {
                var dxEvent = e.event;
                this._onMouseWheel(dxEvent);
                dxEvent.preventDefault();
                dxEvent.stopPropagation();
            }
        }).bind(this));
        $e1LMc.off(input, eventName);
        $e1LMc.on(input, eventName, function(e) {
            mouseWheelAction({
                event: e
            });
        });
    },
    _onMouseWheel: $e1832685225ddf7d$require$noop,
    _render: function() {
        this.callBase();
        this._renderMask();
        this._attachMouseWheelEventHandlers();
    },
    _renderHiddenElement: function() {
        if (this.option("mask")) this._$hiddenElement = $jFnCG("<input>").attr("type", "hidden").appendTo(this._inputWrapper());
    },
    _removeHiddenElement: function() {
        this._$hiddenElement && this._$hiddenElement.remove();
    },
    _renderMask: function() {
        this.$element().removeClass($e1832685225ddf7d$var$TEXTEDITOR_MASKED_CLASS);
        this._maskRulesChain = null;
        this._maskStrategy.detachEvents();
        if (!this.option("mask")) return;
        this.$element().addClass($e1832685225ddf7d$var$TEXTEDITOR_MASKED_CLASS);
        this._maskStrategy.attachEvents();
        this._parseMask();
        this._renderMaskedValue();
    },
    _suppressCaretChanging: function(callback, args) {
        var originalCaret = $e1832685225ddf7d$require$caret;
        $e1832685225ddf7d$require$caret = $e1832685225ddf7d$var$stubCaret;
        try {
            callback.apply(this, args);
        } finally{
            $e1832685225ddf7d$require$caret = originalCaret;
        }
    },
    _changeHandler: function(e) {
        var $input = this._input();
        var inputValue = $input.val();
        if (inputValue === this._changedValue) return;
        this._changedValue = inputValue;
        var changeEvent = $bXb2w.createEvent(e, {
            type: "change"
        });
        $e1LMc.trigger($input, changeEvent);
    },
    _parseMask: function() {
        this._maskRules = $e1832685225ddf7d$require$extend({}, $e1832685225ddf7d$var$buildInMaskRules, this.option("maskRules"));
        this._maskRulesChain = this._parseMaskRule(0);
    },
    _parseMaskRule: function(index) {
        var mask = this.option("mask");
        if (index >= mask.length) return new $7tLCO.EmptyMaskRule;
        var currentMaskChar = mask[index];
        var isEscapedChar = currentMaskChar === $e1832685225ddf7d$var$ESCAPED_CHAR;
        var result = isEscapedChar ? new $7tLCO.StubMaskRule({
            maskChar: mask[index + 1]
        }) : this._getMaskRule(currentMaskChar);
        result.next(this._parseMaskRule(index + 1 + isEscapedChar));
        return result;
    },
    _getMaskRule: function(pattern) {
        var ruleConfig;
        $e1832685225ddf7d$require$each(this._maskRules, function(rulePattern, allowedChars) {
            if (rulePattern === pattern) {
                ruleConfig = {
                    pattern: rulePattern,
                    allowedChars: allowedChars
                };
                return false;
            }
        });
        return $e1832685225ddf7d$require$isDefined(ruleConfig) ? new $7tLCO.MaskRule($e1832685225ddf7d$require$extend({
            maskChar: this.option("maskChar")
        }, ruleConfig)) : new $7tLCO.StubMaskRule({
            maskChar: pattern
        });
    },
    _renderMaskedValue: function() {
        if (!this._maskRulesChain) return;
        var value = this.option("value") || "";
        this._maskRulesChain.clear(this._normalizeChainArguments());
        var chainArgs = {
            length: value.length
        };
        chainArgs[this._isMaskedValueMode() ? "text" : "value"] = value;
        this._handleChain(chainArgs);
        this._displayMask();
    },
    _replaceSelectedText: function(text, selection, char) {
        if (void 0 === char) return text;
        var textBefore = text.slice(0, selection.start);
        var textAfter = text.slice(selection.end);
        var edited = textBefore + char + textAfter;
        return edited;
    },
    _isMaskedValueMode: function() {
        return this.option("useMaskedValue");
    },
    _displayMask: function(caret) {
        caret = caret || this._caret();
        this._renderValue();
        this._caret(caret);
    },
    _isValueEmpty: function() {
        return $ksvsU.isEmpty(this._value);
    },
    _shouldShowMask: function() {
        var showMaskMode = this.option("showMaskMode");
        if ("onFocus" === showMaskMode) return $e1832685225ddf7d$require$focused(this._input()) || !this._isValueEmpty();
        return true;
    },
    _showMaskPlaceholder: function() {
        if (this._shouldShowMask()) {
            var text = this._maskRulesChain.text();
            this.option("text", text);
            if ("onFocus" === this.option("showMaskMode")) this._renderDisplayText(text);
        }
    },
    _renderValue: function() {
        if (this._maskRulesChain) {
            var text = this._maskRulesChain.text();
            this._showMaskPlaceholder();
            if (this._$hiddenElement) {
                var value = this._maskRulesChain.value();
                var hiddenElementValue = this._isMaskedValueMode() ? text : value;
                this._$hiddenElement.val(!$ksvsU.isEmpty(value) ? hiddenElementValue : "");
            }
        }
        return this.callBase();
    },
    _valueChangeEventHandler: function(e) {
        if (!this._maskRulesChain) {
            this.callBase.apply(this, arguments);
            return;
        }
        this._saveValueChangeEvent(e);
        this.option("value", this._convertToValue().replace(/\s+$/, ""));
    },
    _isControlKeyFired: function(e) {
        return this._isControlKey($bXb2w.normalizeKeyName(e)) || e.ctrlKey || e.metaKey;
    },
    _handleChain: function(args) {
        var handledCount = this._maskRulesChain.handle(this._normalizeChainArguments(args));
        this._value = this._maskRulesChain.value();
        this._textValue = this._maskRulesChain.text();
        return handledCount;
    },
    _normalizeChainArguments: function(args) {
        args = args || {};
        args.index = 0;
        args.fullText = this._maskRulesChain.text();
        return args;
    },
    _convertToValue: function(text) {
        if (this._isMaskedValueMode()) text = this._replaceMaskCharWithEmpty(text || this._textValue || "");
        else text = text || this._value || "";
        return text;
    },
    _replaceMaskCharWithEmpty: function(text) {
        return text.replace(new RegExp(this.option("maskChar"), "g"), $e1832685225ddf7d$var$EMPTY_CHAR);
    },
    _maskKeyHandler: function(e, keyHandler) {
        var _this = this;
        if (this.option("readOnly")) return;
        this.setForwardDirection();
        e.preventDefault();
        this._handleSelection();
        var previousText = this._input().val();
        var raiseInputEvent = function() {
            if (previousText !== _this._input().val()) _this._maskStrategy.runWithoutEventProcessing(function() {
                return $e1LMc.trigger(_this._input(), "input");
            });
        };
        var handled = keyHandler();
        if (handled) handled.then(raiseInputEvent);
        else {
            this.setForwardDirection();
            this._adjustCaret();
            this._displayMask();
            this._maskRulesChain.reset();
            raiseInputEvent();
        }
    },
    _handleKey: function(key, direction) {
        this._direction(direction || $e1832685225ddf7d$var$FORWARD_DIRECTION);
        this._adjustCaret(key);
        this._handleKeyChain(key);
        this._moveCaret();
    },
    _handleSelection: function() {
        if (!this._hasSelection()) return;
        var caret = this._caret();
        var emptyChars = new Array(caret.end - caret.start + 1).join($e1832685225ddf7d$var$EMPTY_CHAR);
        this._handleKeyChain(emptyChars);
    },
    _handleKeyChain: function(chars) {
        var caret = this._caret();
        var start = this.isForwardDirection() ? caret.start : caret.start - 1;
        var end = this.isForwardDirection() ? caret.end : caret.end - 1;
        var length = start === end ? 1 : end - start;
        this._handleChain({
            text: chars,
            start: start,
            length: length
        });
    },
    _tryMoveCaretBackward: function() {
        this.setBackwardDirection();
        var currentCaret = this._caret().start;
        this._adjustCaret();
        return !currentCaret || currentCaret !== this._caret().start;
    },
    _adjustCaret: function(char) {
        var caret = this._maskRulesChain.adjustedCaret(this._caret().start, this.isForwardDirection(), char);
        this._caret({
            start: caret,
            end: caret
        });
    },
    _moveCaret: function() {
        var currentCaret = this._caret().start;
        var maskRuleIndex = currentCaret + (this.isForwardDirection() ? 0 : -1);
        var caret = this._maskRulesChain.isAccepted(maskRuleIndex) ? currentCaret + (this.isForwardDirection() ? 1 : -1) : currentCaret;
        this._caret({
            start: caret,
            end: caret
        });
    },
    _caret: function(position) {
        var $input = this._input();
        if (!$input.length) return;
        if (!arguments.length) return $e1832685225ddf7d$require$caret($input);
        $e1832685225ddf7d$require$caret($input, position);
    },
    _hasSelection: function() {
        var caret = this._caret();
        return caret.start !== caret.end;
    },
    _direction: function(direction) {
        if (!arguments.length) return this._typingDirection;
        this._typingDirection = direction;
    },
    setForwardDirection: function() {
        this._direction($e1832685225ddf7d$var$FORWARD_DIRECTION);
    },
    setBackwardDirection: function() {
        this._direction($e1832685225ddf7d$var$BACKWARD_DIRECTION);
    },
    isForwardDirection: function() {
        return this._direction() === $e1832685225ddf7d$var$FORWARD_DIRECTION;
    },
    _clean: function() {
        this._maskStrategy && this._maskStrategy.clean();
        this.callBase();
    },
    _validateMask: function() {
        if (!this._maskRulesChain) return;
        var isValid = $ksvsU.isEmpty(this.option("value")) || this._maskRulesChain.isValid(this._normalizeChainArguments());
        this.option({
            isValid: isValid,
            validationError: isValid ? null : {
                editorSpecific: true,
                message: this.option("maskInvalidMessage")
            }
        });
    },
    _updateHiddenElement: function() {
        this._removeHiddenElement();
        if (this.option("mask")) {
            this._input().removeAttr("name");
            this._renderHiddenElement();
        }
        this._setSubmitElementName(this.option("name"));
    },
    _updateMaskOption: function() {
        this._updateHiddenElement();
        this._renderMask();
        this._validateMask();
    },
    _processEmptyMask: function(mask) {
        if (mask) return;
        var value = this.option("value");
        this.option({
            text: value,
            isValid: true
        });
        this.validationRequest.fire({
            value: value,
            editor: this
        });
        this._renderValue();
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "mask":
                this._updateMaskOption();
                this._processEmptyMask(args.value);
                break;
            case "maskChar":
            case "maskRules":
            case "useMaskedValue":
                this._updateMaskOption();
                break;
            case "value":
                this._renderMaskedValue();
                this._validateMask();
                this.callBase(args);
                this._changedValue = this._input().val();
                break;
            case "maskInvalidMessage":
                break;
            case "showMaskMode":
                this.option("text", "");
                this._renderValue();
                break;
            default:
                this.callBase(args);
        }
    }
});
module.exports = $e1832685225ddf7d$var$TextEditorMask;

});
parcelRegister("brnvh", function(module, exports) {
/**
 * DevExtreme (ui/text_box/utils.caret.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $854472a729bbc15a$var$_renderer2 = $854472a729bbc15a$var$_interopRequireDefault($jFnCG);

var $kDRxH = parcelRequire("kDRxH");

var $bvcPv = parcelRequire("bvcPv");
var $854472a729bbc15a$var$_browser2 = $854472a729bbc15a$var$_interopRequireDefault($bvcPv);

var $aiwte = parcelRequire("aiwte");
var $854472a729bbc15a$var$_devices2 = $854472a729bbc15a$var$_interopRequireDefault($aiwte);

var $445Bz = parcelRequire("445Bz");
var $854472a729bbc15a$var$_dom_adapter2 = $854472a729bbc15a$var$_interopRequireDefault($445Bz);
function $854472a729bbc15a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $854472a729bbc15a$var$_devices$real = $854472a729bbc15a$var$_devices2.default.real(), $854472a729bbc15a$var$ios = $854472a729bbc15a$var$_devices$real.ios, $854472a729bbc15a$var$mac = $854472a729bbc15a$var$_devices$real.mac;
var $854472a729bbc15a$var$isFocusingOnCaretChange = $854472a729bbc15a$var$_browser2.default.msie || $854472a729bbc15a$var$ios || $854472a729bbc15a$var$mac;
var $854472a729bbc15a$var$getCaret = function(input) {
    var range;
    try {
        range = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
    } catch (e) {
        range = {
            start: 0,
            end: 0
        };
    }
    return range;
};
var $854472a729bbc15a$var$setCaret = function(input, position) {
    if (!$854472a729bbc15a$var$_dom_adapter2.default.getBody().contains(input)) return;
    try {
        input.selectionStart = position.start;
        input.selectionEnd = position.end;
    } catch (e) {}
};
var $854472a729bbc15a$var$caret = function(input, position) {
    input = (0, $854472a729bbc15a$var$_renderer2.default)(input).get(0);
    if (!(0, $kDRxH.isDefined)(position)) return $854472a729bbc15a$var$getCaret(input);
    if ($854472a729bbc15a$var$isFocusingOnCaretChange && $854472a729bbc15a$var$_dom_adapter2.default.getActiveElement() !== input) return;
    $854472a729bbc15a$var$setCaret(input, position);
};
module.exports = $854472a729bbc15a$var$caret;

});

parcelRegister("7tLCO", function(module, exports) {

$parcel$export(module.exports, "MaskRule", () => $57202f2946320c62$export$bf065c18701a8c42, (v) => $57202f2946320c62$export$bf065c18701a8c42 = v);
$parcel$export(module.exports, "StubMaskRule", () => $57202f2946320c62$export$afc1d97b4707e7b4, (v) => $57202f2946320c62$export$afc1d97b4707e7b4 = v);
$parcel$export(module.exports, "EmptyMaskRule", () => $57202f2946320c62$export$419e3f205daab13, (v) => $57202f2946320c62$export$419e3f205daab13 = v);
/**
 * DevExtreme (ui/text_box/ui.text_editor.mask.rule.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $57202f2946320c62$export$bf065c18701a8c42;
var $57202f2946320c62$export$afc1d97b4707e7b4;
var $57202f2946320c62$export$419e3f205daab13;
"use strict";

var $k7aJb = parcelRequire("k7aJb");

var $7I8Uw = parcelRequire("7I8Uw");
var $57202f2946320c62$require$extend = $7I8Uw.extend;

var $aLQK5 = parcelRequire("aLQK5");
var $57202f2946320c62$require$inArray = $aLQK5.inArray;

var $kDRxH = parcelRequire("kDRxH");

var $2Mto0 = parcelRequire("2Mto0");
var $57202f2946320c62$require$noop = $2Mto0.noop;
var $57202f2946320c62$var$isFunction = $kDRxH.isFunction;
var $57202f2946320c62$var$EMPTY_CHAR = " ";
var $57202f2946320c62$var$BaseMaskRule = $k7aJb.inherit({
    ctor: function(config) {
        this._value = $57202f2946320c62$var$EMPTY_CHAR;
        $57202f2946320c62$require$extend(this, config);
    },
    next: function(rule) {
        if (!arguments.length) return this._next;
        this._next = rule;
    },
    text: $57202f2946320c62$require$noop,
    value: $57202f2946320c62$require$noop,
    rawValue: $57202f2946320c62$require$noop,
    handle: $57202f2946320c62$require$noop,
    _prepareHandlingArgs: function(args, config) {
        config = config || {};
        var handlingProperty = Object.prototype.hasOwnProperty.call(args, "value") ? "value" : "text";
        args[handlingProperty] = $kDRxH.isDefined(config.str) ? config.str : args[handlingProperty];
        args.start = $kDRxH.isDefined(config.start) ? config.start : args.start;
        args.length = $kDRxH.isDefined(config.length) ? config.length : args.length;
        args.index = args.index + 1;
        return args;
    },
    reset: $57202f2946320c62$require$noop,
    clear: $57202f2946320c62$require$noop,
    first: function(index) {
        index = index || 0;
        return this.next().first(index + 1);
    },
    isAccepted: function() {
        return false;
    },
    adjustedCaret: function(caret, isForwardDirection, char) {
        return isForwardDirection ? this._adjustedForward(caret, 0, char) : this._adjustedBackward(caret, 0, char);
    },
    _adjustedForward: $57202f2946320c62$require$noop,
    _adjustedBackward: $57202f2946320c62$require$noop,
    isValid: $57202f2946320c62$require$noop
});
var $57202f2946320c62$var$EmptyMaskRule = $57202f2946320c62$var$BaseMaskRule.inherit({
    next: $57202f2946320c62$require$noop,
    handle: function() {
        return 0;
    },
    text: function() {
        return "";
    },
    value: function() {
        return "";
    },
    first: function() {
        return 0;
    },
    rawValue: function() {
        return "";
    },
    adjustedCaret: function() {
        return 0;
    },
    isValid: function() {
        return true;
    }
});
var $57202f2946320c62$var$MaskRule = $57202f2946320c62$var$BaseMaskRule.inherit({
    text: function() {
        return (this._value !== $57202f2946320c62$var$EMPTY_CHAR ? this._value : this.maskChar) + this.next().text();
    },
    value: function() {
        return this._value + this.next().value();
    },
    rawValue: function() {
        return this._value + this.next().rawValue();
    },
    handle: function(args) {
        var str = Object.prototype.hasOwnProperty.call(args, "value") ? args.value : args.text;
        if (!str || !str.length || !args.length) return 0;
        if (args.start) return this.next().handle(this._prepareHandlingArgs(args, {
            start: args.start - 1
        }));
        var char = str[0];
        var rest = str.substring(1);
        this._tryAcceptChar(char, args);
        return this._accepted() ? this.next().handle(this._prepareHandlingArgs(args, {
            str: rest,
            length: args.length - 1
        })) + 1 : this.handle(this._prepareHandlingArgs(args, {
            str: rest,
            length: args.length - 1
        }));
    },
    clear: function(args) {
        this._tryAcceptChar($57202f2946320c62$var$EMPTY_CHAR, args);
        this.next().clear(this._prepareHandlingArgs(args));
    },
    reset: function() {
        this._accepted(false);
        this.next().reset();
    },
    _tryAcceptChar: function(char, args) {
        this._accepted(false);
        if (!this._isAllowed(char, args)) return;
        var acceptedChar = char === $57202f2946320c62$var$EMPTY_CHAR ? this.maskChar : char;
        args.fullText = args.fullText.substring(0, args.index) + acceptedChar + args.fullText.substring(args.index + 1);
        this._accepted(true);
        this._value = char;
    },
    _accepted: function(value) {
        if (!arguments.length) return !!this._isAccepted;
        this._isAccepted = !!value;
    },
    first: function(index) {
        return this._value === $57202f2946320c62$var$EMPTY_CHAR ? index || 0 : this.callBase(index);
    },
    _isAllowed: function(char, args) {
        if (char === $57202f2946320c62$var$EMPTY_CHAR) return true;
        return this._isValid(char, args);
    },
    _isValid: function(char, args) {
        var allowedChars = this.allowedChars;
        if (allowedChars instanceof RegExp) return allowedChars.test(char);
        if ($57202f2946320c62$var$isFunction(allowedChars)) return allowedChars(char, args.index, args.fullText);
        if (Array.isArray(allowedChars)) return $57202f2946320c62$require$inArray(char, allowedChars) > -1;
        return allowedChars === char;
    },
    isAccepted: function(caret) {
        return 0 === caret ? this._accepted() : this.next().isAccepted(caret - 1);
    },
    _adjustedForward: function(caret, index, char) {
        if (index >= caret) return index;
        return this.next()._adjustedForward(caret, index + 1, char) || index + 1;
    },
    _adjustedBackward: function(caret, index) {
        if (index >= caret - 1) return caret;
        return this.next()._adjustedBackward(caret, index + 1) || index + 1;
    },
    isValid: function(args) {
        return this._isValid(this._value, args) && this.next().isValid(this._prepareHandlingArgs(args));
    }
});
var $57202f2946320c62$var$StubMaskRule = $57202f2946320c62$var$MaskRule.inherit({
    value: function() {
        return this.next().value();
    },
    handle: function(args) {
        var hasValueProperty = Object.prototype.hasOwnProperty.call(args, "value");
        var str = hasValueProperty ? args.value : args.text;
        if (!str.length || !args.length) return 0;
        if (args.start || hasValueProperty) return this.next().handle(this._prepareHandlingArgs(args, {
            start: args.start && args.start - 1
        }));
        var char = str[0];
        var rest = str.substring(1);
        this._tryAcceptChar(char);
        var nextArgs = this._isAllowed(char) ? this._prepareHandlingArgs(args, {
            str: rest,
            length: args.length - 1
        }) : args;
        return this.next().handle(nextArgs) + 1;
    },
    clear: function(args) {
        this._accepted(false);
        this.next().clear(this._prepareHandlingArgs(args));
    },
    _tryAcceptChar: function(char) {
        this._accepted(this._isValid(char));
    },
    _isValid: function(char) {
        return char === this.maskChar;
    },
    first: function(index) {
        index = index || 0;
        return this.next().first(index + 1);
    },
    _adjustedForward: function(caret, index, char) {
        if (index >= caret && char === this.maskChar) return index;
        if (caret === index + 1 && this._accepted()) return caret;
        return this.next()._adjustedForward(caret, index + 1, char);
    },
    _adjustedBackward: function(caret, index) {
        if (index >= caret - 1) return 0;
        return this.next()._adjustedBackward(caret, index + 1);
    },
    isValid: function(args) {
        return this.next().isValid(this._prepareHandlingArgs(args));
    }
});
$57202f2946320c62$export$bf065c18701a8c42 = $57202f2946320c62$var$MaskRule;
$57202f2946320c62$export$afc1d97b4707e7b4 = $57202f2946320c62$var$StubMaskRule;
$57202f2946320c62$export$419e3f205daab13 = $57202f2946320c62$var$EmptyMaskRule;

});

parcelRegister("bObtv", function(module, exports) {
/**
 * DevExtreme (ui/text_box/ui.text_editor.base.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $898d43dfbe20f852$var$_renderer2 = $898d43dfbe20f852$var$_interopRequireDefault($jFnCG);

var $445Bz = parcelRequire("445Bz");
var $898d43dfbe20f852$var$_dom_adapter2 = $898d43dfbe20f852$var$_interopRequireDefault($445Bz);

var $e1LMc = parcelRequire("e1LMc");
var $898d43dfbe20f852$var$_events_engine2 = $898d43dfbe20f852$var$_interopRequireDefault($e1LMc);

var $5OzEX = parcelRequire("5OzEX");
var $898d43dfbe20f852$var$_dom2 = $898d43dfbe20f852$var$_interopRequireDefault($5OzEX);

var $3joCJ = parcelRequire("3joCJ");

var $kDRxH = parcelRequire("kDRxH");

var $7I8Uw = parcelRequire("7I8Uw");

var $aLQK5 = parcelRequire("aLQK5");

var $4Pwuy = parcelRequire("4Pwuy");

var $aiwte = parcelRequire("aiwte");
var $898d43dfbe20f852$var$_devices2 = $898d43dfbe20f852$var$_interopRequireDefault($aiwte);

var $3LUJe = parcelRequire("3LUJe");
var $898d43dfbe20f852$var$_themes2 = $898d43dfbe20f852$var$_interopRequireDefault($3LUJe);

var $4hjO5 = parcelRequire("4hjO5");
var $898d43dfbe20f852$var$_editor2 = $898d43dfbe20f852$var$_interopRequireDefault($4hjO5);

var $bXb2w = parcelRequire("bXb2w");
var $898d43dfbe20f852$var$_utils2 = $898d43dfbe20f852$var$_interopRequireDefault($bXb2w);

var $gP4Gh = parcelRequire("gP4Gh");
var $898d43dfbe20f852$var$_pointer2 = $898d43dfbe20f852$var$_interopRequireDefault($gP4Gh);

var $lBE6E = parcelRequire("lBE6E");
var $898d43dfbe20f852$var$_uiText_editor2 = $898d43dfbe20f852$var$_interopRequireDefault($lBE6E);

var $fC1Zt = parcelRequire("fC1Zt");
var $898d43dfbe20f852$var$_index2 = $898d43dfbe20f852$var$_interopRequireDefault($fC1Zt);

var $1JvXr = parcelRequire("1JvXr");
var $898d43dfbe20f852$var$_config2 = $898d43dfbe20f852$var$_interopRequireDefault($1JvXr);

var $lrsNa = parcelRequire("lrsNa");
var $898d43dfbe20f852$var$_ui2 = $898d43dfbe20f852$var$_interopRequireDefault($lrsNa);

var $2F60d = parcelRequire("2F60d");

var $gbWer = parcelRequire("gbWer");
var $898d43dfbe20f852$var$_load_indicator2 = $898d43dfbe20f852$var$_interopRequireDefault($gbWer);
function $898d43dfbe20f852$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $898d43dfbe20f852$var$TEXTEDITOR_CLASS = "dx-texteditor";
var $898d43dfbe20f852$var$TEXTEDITOR_INPUT_CONTAINER_CLASS = "dx-texteditor-input-container";
var $898d43dfbe20f852$var$TEXTEDITOR_INPUT_CLASS = "dx-texteditor-input";
var $898d43dfbe20f852$var$TEXTEDITOR_INPUT_SELECTOR = "." + $898d43dfbe20f852$var$TEXTEDITOR_INPUT_CLASS;
var $898d43dfbe20f852$var$TEXTEDITOR_CONTAINER_CLASS = "dx-texteditor-container";
var $898d43dfbe20f852$var$TEXTEDITOR_BUTTONS_CONTAINER_CLASS = "dx-texteditor-buttons-container";
var $898d43dfbe20f852$var$TEXTEDITOR_PLACEHOLDER_CLASS = "dx-placeholder";
var $898d43dfbe20f852$var$TEXTEDITOR_EMPTY_INPUT_CLASS = "dx-texteditor-empty";
var $898d43dfbe20f852$var$TEXTEDITOR_STYLING_MODE_PREFIX = "dx-editor-";
var $898d43dfbe20f852$var$ALLOWED_STYLE_CLASSES = [
    $898d43dfbe20f852$var$TEXTEDITOR_STYLING_MODE_PREFIX + "outlined",
    $898d43dfbe20f852$var$TEXTEDITOR_STYLING_MODE_PREFIX + "filled",
    $898d43dfbe20f852$var$TEXTEDITOR_STYLING_MODE_PREFIX + "underlined"
];
var $898d43dfbe20f852$var$STATE_INVISIBLE_CLASS = "dx-state-invisible";
var $898d43dfbe20f852$var$TEXTEDITOR_PENDING_INDICATOR_CLASS = "dx-pending-indicator";
var $898d43dfbe20f852$var$TEXTEDITOR_VALIDATION_PENDING_CLASS = "dx-validation-pending";
var $898d43dfbe20f852$var$TEXTEDITOR_VALID_CLASS = "dx-valid";
var $898d43dfbe20f852$var$EVENTS_LIST = [
    "KeyDown",
    "KeyPress",
    "KeyUp",
    "Change",
    "Cut",
    "Copy",
    "Paste",
    "Input"
];
var $898d43dfbe20f852$var$CONTROL_KEYS = [
    "tab",
    "enter",
    "shift",
    "control",
    "alt",
    "escape",
    "pageUp",
    "pageDown",
    "end",
    "home",
    "leftArrow",
    "upArrow",
    "rightArrow",
    "downArrow"
];
function $898d43dfbe20f852$var$checkButtonsOptionType(buttons) {
    if ((0, $kDRxH.isDefined)(buttons) && !Array.isArray(buttons)) throw $898d43dfbe20f852$var$_ui2.default.Error("E1053");
}
var $898d43dfbe20f852$var$TextEditorBase = $898d43dfbe20f852$var$_editor2.default.inherit({
    ctor: function(_, options) {
        if (options) $898d43dfbe20f852$var$checkButtonsOptionType(options.buttons);
        this._buttonCollection = new $898d43dfbe20f852$var$_index2.default(this, this._getDefaultButtons());
        this._$beforeButtonsContainer = null;
        this._$afterButtonsContainer = null;
        this.callBase.apply(this, arguments);
    },
    _getDefaultOptions: function() {
        return (0, $7I8Uw.extend)(this.callBase(), {
            buttons: void 0,
            value: "",
            spellcheck: false,
            showClearButton: false,
            valueChangeEvent: "change",
            placeholder: "",
            inputAttr: {},
            onFocusIn: null,
            onFocusOut: null,
            onKeyDown: null,
            onKeyPress: null,
            onKeyUp: null,
            onChange: null,
            onInput: null,
            onCut: null,
            onCopy: null,
            onPaste: null,
            onEnterKey: null,
            mode: "text",
            hoverStateEnabled: true,
            focusStateEnabled: true,
            text: void 0,
            displayValueFormatter: function(value) {
                return (0, $kDRxH.isDefined)(value) && false !== value ? value : "";
            },
            stylingMode: (0, $898d43dfbe20f852$var$_config2.default)().editorStylingMode || "outlined"
        });
    },
    _defaultOptionsRules: function() {
        var themeName = $898d43dfbe20f852$var$_themes2.default.current();
        return this.callBase().concat([
            {
                device: function() {
                    return $898d43dfbe20f852$var$_themes2.default.isMaterial(themeName);
                },
                options: {
                    stylingMode: (0, $898d43dfbe20f852$var$_config2.default)().editorStylingMode || "underlined"
                }
            }
        ]);
    },
    _getDefaultButtons: function() {
        return [
            {
                name: "clear",
                Ctor: $898d43dfbe20f852$var$_uiText_editor2.default
            }
        ];
    },
    _isClearButtonVisible: function() {
        return this.option("showClearButton") && !this.option("readOnly");
    },
    _input: function() {
        return this.$element().find($898d43dfbe20f852$var$TEXTEDITOR_INPUT_SELECTOR).first();
    },
    _isFocused: function() {
        return (0, $3joCJ.focused)(this._input()) || this.callBase();
    },
    _inputWrapper: function() {
        return this.$element();
    },
    _buttonsContainer: function() {
        return this._inputWrapper().find("." + $898d43dfbe20f852$var$TEXTEDITOR_BUTTONS_CONTAINER_CLASS).eq(0);
    },
    _isControlKey: function(key) {
        return $898d43dfbe20f852$var$CONTROL_KEYS.indexOf(key) !== -1;
    },
    _renderStylingMode: function() {
        var _this = this;
        var optionName = "stylingMode";
        var optionValue = this.option(optionName);
        $898d43dfbe20f852$var$ALLOWED_STYLE_CLASSES.forEach(function(className) {
            return _this.$element().removeClass(className);
        });
        var stylingModeClass = $898d43dfbe20f852$var$TEXTEDITOR_STYLING_MODE_PREFIX + optionValue;
        if ($898d43dfbe20f852$var$ALLOWED_STYLE_CLASSES.indexOf(stylingModeClass) === -1) {
            var defaultOptionValue = this._getDefaultOptions()[optionName];
            var platformOptionValue = this._convertRulesToOptions(this._defaultOptionsRules())[optionName];
            stylingModeClass = $898d43dfbe20f852$var$TEXTEDITOR_STYLING_MODE_PREFIX + (platformOptionValue || defaultOptionValue);
        }
        this.$element().addClass(stylingModeClass);
        this._updateButtonsStyling(optionValue);
    },
    _initMarkup: function() {
        this.$element().addClass($898d43dfbe20f852$var$TEXTEDITOR_CLASS);
        this._renderInput();
        this._renderStylingMode();
        this._renderInputType();
        this._renderPlaceholder();
        this._renderProps();
        this.callBase();
        this._renderValue();
    },
    _render: function() {
        this._renderPlaceholder();
        this._refreshValueChangeEvent();
        this._renderEvents();
        this._renderEnterKeyAction();
        this._renderEmptinessEvent();
        this.callBase();
    },
    _renderInput: function() {
        this._$textEditorContainer = (0, $898d43dfbe20f852$var$_renderer2.default)("<div>").addClass($898d43dfbe20f852$var$TEXTEDITOR_CONTAINER_CLASS).appendTo(this.$element());
        this._$textEditorInputContainer = (0, $898d43dfbe20f852$var$_renderer2.default)("<div>").addClass($898d43dfbe20f852$var$TEXTEDITOR_INPUT_CONTAINER_CLASS).appendTo(this._$textEditorContainer);
        this._$textEditorInputContainer.append(this._createInput());
        this._renderButtonContainers();
    },
    _getInputContainer: function() {
        return this._$textEditorInputContainer;
    },
    _renderPendingIndicator: function() {
        this.$element().addClass($898d43dfbe20f852$var$TEXTEDITOR_VALIDATION_PENDING_CLASS);
        var $inputContainer = this._getInputContainer();
        var $indicatorElement = (0, $898d43dfbe20f852$var$_renderer2.default)("<div>").addClass($898d43dfbe20f852$var$TEXTEDITOR_PENDING_INDICATOR_CLASS).appendTo($inputContainer);
        this._pendingIndicator = this._createComponent($indicatorElement, $898d43dfbe20f852$var$_load_indicator2.default);
    },
    _disposePendingIndicator: function() {
        if (!this._pendingIndicator) return;
        this._pendingIndicator.dispose();
        this._pendingIndicator.$element().remove();
        this._pendingIndicator = null;
        this.$element().removeClass($898d43dfbe20f852$var$TEXTEDITOR_VALIDATION_PENDING_CLASS);
    },
    _renderValidationState: function() {
        this.callBase();
        var isPending = "pending" === this.option("validationStatus");
        var $element = this.$element();
        if (isPending) {
            !this._pendingIndicator && this._renderPendingIndicator();
            this._showValidMark = false;
        } else {
            if ("invalid" === this.option("validationStatus")) this._showValidMark = false;
            if (!this._showValidMark) this._showValidMark = "valid" === this.option("validationStatus") && !!this._pendingIndicator;
            this._disposePendingIndicator();
        }
        $element.toggleClass($898d43dfbe20f852$var$TEXTEDITOR_VALID_CLASS, this._showValidMark);
    },
    _renderButtonContainers: function() {
        var buttons = this.option("buttons");
        this._$beforeButtonsContainer = this._buttonCollection.renderBeforeButtons(buttons, this._$textEditorContainer);
        this._$afterButtonsContainer = this._buttonCollection.renderAfterButtons(buttons, this._$textEditorContainer);
    },
    _clean: function() {
        this._buttonCollection.clean();
        this._disposePendingIndicator();
        this._$beforeButtonsContainer = null;
        this._$afterButtonsContainer = null;
        this._$textEditorContainer = null;
        this.callBase();
    },
    _createInput: function() {
        var $input = (0, $898d43dfbe20f852$var$_renderer2.default)("<input>");
        this._applyInputAttributes($input, this.option("inputAttr"));
        return $input;
    },
    _setSubmitElementName: function(name) {
        var inputAttrName = this.option("inputAttr.name");
        return this.callBase(name || inputAttrName || "");
    },
    _applyInputAttributes: function($input, customAttributes) {
        var inputAttributes = (0, $7I8Uw.extend)(this._getDefaultAttributes(), customAttributes);
        $input.attr(inputAttributes).addClass($898d43dfbe20f852$var$TEXTEDITOR_INPUT_CLASS).css("minHeight", this.option("height") ? "0" : "");
    },
    _getDefaultAttributes: function() {
        var defaultAttributes = {
            autocomplete: "off"
        };
        if ($898d43dfbe20f852$var$_devices2.default.real().ios) defaultAttributes.placeholder = "&nbsp;";
        return defaultAttributes;
    },
    _updateButtons: function(names) {
        this._buttonCollection.updateButtons(names);
    },
    _updateButtonsStyling: function(editorStylingMode) {
        var _this2 = this;
        (0, $4Pwuy.each)(this.option("buttons"), function(_, buttonOptions) {
            if (buttonOptions.options && !buttonOptions.options.stylingMode) {
                var buttonInstance = _this2.getButton(buttonOptions.name);
                buttonInstance.option && buttonInstance.option("stylingMode", "underlined" === editorStylingMode ? "text" : "contained");
            }
        });
    },
    _renderValue: function() {
        var renderInputPromise = this._renderInputValue();
        return renderInputPromise.promise();
    },
    _renderInputValue: function(value) {
        value = value || this.option("value");
        var text = this.option("text");
        var displayValue = this.option("displayValue");
        var displayValueFormatter = this.option("displayValueFormatter");
        if (void 0 !== displayValue && null !== value) text = displayValueFormatter(displayValue);
        else if (!(0, $kDRxH.isDefined)(text)) text = displayValueFormatter(value);
        this.option("text", text);
        if (this._input().val() !== ((0, $kDRxH.isDefined)(text) ? text : "")) this._renderDisplayText(text);
        else this._toggleEmptinessEventHandler();
        return (new $2F60d.Deferred).resolve();
    },
    _renderDisplayText: function(text) {
        this._input().val(text);
        this._toggleEmptinessEventHandler();
    },
    _isValueValid: function() {
        if (this._input().length) {
            var validity = this._input().get(0).validity;
            if (validity) return validity.valid;
        }
        return true;
    },
    _toggleEmptiness: function(isEmpty) {
        this.$element().toggleClass($898d43dfbe20f852$var$TEXTEDITOR_EMPTY_INPUT_CLASS, isEmpty);
        this._togglePlaceholder(isEmpty);
    },
    _togglePlaceholder: function(isEmpty) {
        if (!this._$placeholder) return;
        this._$placeholder.toggleClass($898d43dfbe20f852$var$STATE_INVISIBLE_CLASS, !isEmpty);
    },
    _renderProps: function() {
        this._toggleReadOnlyState();
        this._toggleSpellcheckState();
        this._toggleTabIndex();
    },
    _toggleDisabledState: function(value) {
        this.callBase.apply(this, arguments);
        var $input = this._input();
        if (value) $input.attr("disabled", true);
        else $input.removeAttr("disabled");
    },
    _toggleTabIndex: function() {
        var $input = this._input();
        var disabled = this.option("disabled");
        var focusStateEnabled = this.option("focusStateEnabled");
        if (disabled || !focusStateEnabled) $input.attr("tabIndex", -1);
        else $input.removeAttr("tabIndex");
    },
    _toggleReadOnlyState: function() {
        this._input().prop("readOnly", this._readOnlyPropValue());
        this.callBase();
    },
    _readOnlyPropValue: function() {
        return this.option("readOnly");
    },
    _toggleSpellcheckState: function() {
        this._input().prop("spellcheck", this.option("spellcheck"));
    },
    _renderPlaceholder: function() {
        this._renderPlaceholderMarkup();
        this._attachPlaceholderEvents();
    },
    _renderPlaceholderMarkup: function() {
        if (this._$placeholder) {
            this._$placeholder.remove();
            this._$placeholder = null;
        }
        var $input = this._input();
        var placeholderText = this.option("placeholder");
        var $placeholder = this._$placeholder = (0, $898d43dfbe20f852$var$_renderer2.default)("<div>").attr("data-dx_placeholder", placeholderText);
        $placeholder.insertAfter($input);
        $placeholder.addClass($898d43dfbe20f852$var$TEXTEDITOR_PLACEHOLDER_CLASS);
    },
    _attachPlaceholderEvents: function() {
        var _this3 = this;
        var startEvent = $898d43dfbe20f852$var$_utils2.default.addNamespace($898d43dfbe20f852$var$_pointer2.default.up, this.NAME);
        $898d43dfbe20f852$var$_events_engine2.default.on(this._$placeholder, startEvent, function() {
            $898d43dfbe20f852$var$_events_engine2.default.trigger(_this3._input(), "focus");
        });
        this._toggleEmptinessEventHandler();
    },
    _placeholder: function() {
        return this._$placeholder || (0, $898d43dfbe20f852$var$_renderer2.default)();
    },
    _clearValueHandler: function(e) {
        var $input = this._input();
        e.stopPropagation();
        this._saveValueChangeEvent(e);
        this._clearValue();
        !this._isFocused() && $898d43dfbe20f852$var$_events_engine2.default.trigger($input, "focus");
        $898d43dfbe20f852$var$_events_engine2.default.trigger($input, "input");
    },
    _clearValue: function() {
        this.reset();
    },
    _renderEvents: function() {
        var _this4 = this;
        var $input = this._input();
        (0, $4Pwuy.each)($898d43dfbe20f852$var$EVENTS_LIST, function(_, event) {
            if (_this4.hasActionSubscription("on" + event)) {
                var action = _this4._createActionByOption("on" + event, {
                    excludeValidators: [
                        "readOnly"
                    ]
                });
                $898d43dfbe20f852$var$_events_engine2.default.on($input, $898d43dfbe20f852$var$_utils2.default.addNamespace(event.toLowerCase(), _this4.NAME), function(e) {
                    if (_this4._disposed) return;
                    action({
                        event: e
                    });
                });
            }
        });
    },
    _refreshEvents: function() {
        var _this5 = this;
        var $input = this._input();
        (0, $4Pwuy.each)($898d43dfbe20f852$var$EVENTS_LIST, function(_, event) {
            $898d43dfbe20f852$var$_events_engine2.default.off($input, $898d43dfbe20f852$var$_utils2.default.addNamespace(event.toLowerCase(), _this5.NAME));
        });
        this._renderEvents();
    },
    _keyPressHandler: function() {
        this.option("text", this._input().val());
    },
    _keyDownHandler: function(e) {
        var $input = this._input();
        var isCtrlEnter = e.ctrlKey && "enter" === $898d43dfbe20f852$var$_utils2.default.normalizeKeyName(e);
        var isNewValue = $input.val() !== this.option("value");
        if (isCtrlEnter && isNewValue) $898d43dfbe20f852$var$_events_engine2.default.trigger($input, "change");
    },
    _renderValueChangeEvent: function() {
        var keyPressEvent = $898d43dfbe20f852$var$_utils2.default.addNamespace(this._renderValueEventName(), "".concat(this.NAME, "TextChange"));
        var valueChangeEvent = $898d43dfbe20f852$var$_utils2.default.addNamespace(this.option("valueChangeEvent"), "".concat(this.NAME, "ValueChange"));
        var keyDownEvent = $898d43dfbe20f852$var$_utils2.default.addNamespace("keydown", "".concat(this.NAME, "TextChange"));
        var $input = this._input();
        $898d43dfbe20f852$var$_events_engine2.default.on($input, keyPressEvent, this._keyPressHandler.bind(this));
        $898d43dfbe20f852$var$_events_engine2.default.on($input, valueChangeEvent, this._valueChangeEventHandler.bind(this));
        $898d43dfbe20f852$var$_events_engine2.default.on($input, keyDownEvent, this._keyDownHandler.bind(this));
    },
    _cleanValueChangeEvent: function() {
        var valueChangeNamespace = ".".concat(this.NAME, "ValueChange");
        var textChangeNamespace = ".".concat(this.NAME, "TextChange");
        $898d43dfbe20f852$var$_events_engine2.default.off(this._input(), valueChangeNamespace);
        $898d43dfbe20f852$var$_events_engine2.default.off(this._input(), textChangeNamespace);
    },
    _refreshValueChangeEvent: function() {
        this._cleanValueChangeEvent();
        this._renderValueChangeEvent();
    },
    _renderValueEventName: function() {
        return "input change keypress";
    },
    _focusTarget: function() {
        return this._input();
    },
    _focusEventTarget: function() {
        return this.element();
    },
    _preventNestedFocusEvent: function(event) {
        if (event.isDefaultPrevented()) return true;
        var result = this._isNestedTarget(event.relatedTarget);
        if ("focusin" === event.type) result = result && this._isNestedTarget(event.target);
        result && event.preventDefault();
        return result;
    },
    _isNestedTarget: function(target) {
        return !!this.$element().find(target).length;
    },
    _focusClassTarget: function() {
        return this.$element();
    },
    _focusInHandler: function(event) {
        this._preventNestedFocusEvent(event);
        this.callBase.apply(this, arguments);
    },
    _focusOutHandler: function(event) {
        this._preventNestedFocusEvent(event);
        this.callBase.apply(this, arguments);
    },
    _toggleFocusClass: function(isFocused, $element) {
        this.callBase(isFocused, this._focusClassTarget($element));
    },
    _hasFocusClass: function(element) {
        return this.callBase((0, $898d43dfbe20f852$var$_renderer2.default)(element || this.$element()));
    },
    _renderEmptinessEvent: function() {
        var $input = this._input();
        $898d43dfbe20f852$var$_events_engine2.default.on($input, "input blur", this._toggleEmptinessEventHandler.bind(this));
    },
    _toggleEmptinessEventHandler: function() {
        var text = this._input().val();
        var isEmpty = ("" === text || null === text) && this._isValueValid();
        this._toggleEmptiness(isEmpty);
    },
    _valueChangeEventHandler: function(e, formattedValue) {
        this._saveValueChangeEvent(e);
        this.option("value", arguments.length > 1 ? formattedValue : this._input().val());
        this._saveValueChangeEvent(void 0);
    },
    _renderEnterKeyAction: function() {
        this._enterKeyAction = this._createActionByOption("onEnterKey", {
            excludeValidators: [
                "readOnly"
            ]
        });
        $898d43dfbe20f852$var$_events_engine2.default.off(this._input(), "keyup.onEnterKey.dxTextEditor");
        $898d43dfbe20f852$var$_events_engine2.default.on(this._input(), "keyup.onEnterKey.dxTextEditor", this._enterKeyHandlerUp.bind(this));
    },
    _enterKeyHandlerUp: function(e) {
        if (this._disposed) return;
        if ("enter" === $898d43dfbe20f852$var$_utils2.default.normalizeKeyName(e)) this._enterKeyAction({
            event: e
        });
    },
    _updateValue: function() {
        this.option("text", void 0);
        this._renderValue();
    },
    _dispose: function() {
        this._enterKeyAction = void 0;
        this.callBase();
    },
    _getSubmitElement: function() {
        return this._input();
    },
    _optionChanged: function(args) {
        var name = args.name;
        if ((0, $aLQK5.inArray)(name.replace("on", ""), $898d43dfbe20f852$var$EVENTS_LIST) > -1) {
            this._refreshEvents();
            return;
        }
        switch(name){
            case "valueChangeEvent":
                this._refreshValueChangeEvent();
                this._refreshFocusEvent();
                this._refreshEvents();
                break;
            case "onValueChanged":
                this._createValueChangeAction();
                break;
            case "focusStateEnabled":
                this.callBase(args);
                this._toggleTabIndex();
                break;
            case "spellcheck":
                this._toggleSpellcheckState();
                break;
            case "mode":
                this._renderInputType();
                break;
            case "onEnterKey":
                this._renderEnterKeyAction();
                break;
            case "placeholder":
                this._renderPlaceholder();
                break;
            case "readOnly":
            case "disabled":
                this._updateButtons();
                this.callBase(args);
                break;
            case "showClearButton":
                this._updateButtons([
                    "clear"
                ]);
                break;
            case "text":
                break;
            case "value":
                this._updateValue();
                this.callBase(args);
                break;
            case "inputAttr":
                this._applyInputAttributes(this._input(), args.value);
                break;
            case "stylingMode":
                this._renderStylingMode();
                break;
            case "buttons":
                if (args.fullName === args.name) $898d43dfbe20f852$var$checkButtonsOptionType(args.value);
                this._$beforeButtonsContainer && this._$beforeButtonsContainer.remove();
                this._$afterButtonsContainer && this._$afterButtonsContainer.remove();
                this._buttonCollection.clean();
                this._renderButtonContainers();
                break;
            case "displayValueFormatter":
                this._invalidate();
                break;
            default:
                this.callBase(args);
        }
    },
    _renderInputType: function() {
        this._setInputType(this.option("mode"));
    },
    _setInputType: function(type) {
        var input = this._input();
        if ("search" === type) type = "text";
        try {
            input.prop("type", type);
        } catch (e) {
            input.prop("type", "text");
        }
    },
    getButton: function(name) {
        return this._buttonCollection.getButton(name);
    },
    focus: function() {
        $898d43dfbe20f852$var$_events_engine2.default.trigger(this._input(), "focus");
    },
    blur: function() {
        if (this._input().is($898d43dfbe20f852$var$_dom_adapter2.default.getActiveElement())) $898d43dfbe20f852$var$_dom2.default.resetActiveElement();
    },
    reset: function() {
        if (this._showValidMark) {
            this._showValidMark = false;
            this._renderValidationState();
        }
        var defaultOptions = this._getDefaultOptions();
        if (this.option("value") === defaultOptions.value) {
            this.option("text", "");
            this._renderValue();
        } else this.option("value", defaultOptions.value);
    },
    on: function(eventName, eventHandler) {
        var result = this.callBase(eventName, eventHandler);
        var event = eventName.charAt(0).toUpperCase() + eventName.substr(1);
        if ($898d43dfbe20f852$var$EVENTS_LIST.indexOf(event) >= 0) this._refreshEvents();
        return result;
    }
});
module.exports = $898d43dfbe20f852$var$TextEditorBase;

});
parcelRegister("lBE6E", function(module, exports) {
/**
 * DevExtreme (ui/text_box/ui.text_editor.clear.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jFnCG = parcelRequire("jFnCG");
var $fbac29f129b32421$var$_renderer2 = $fbac29f129b32421$var$_interopRequireDefault($jFnCG);

var $e1LMc = parcelRequire("e1LMc");
var $fbac29f129b32421$var$_events_engine2 = $fbac29f129b32421$var$_interopRequireDefault($e1LMc);

var $5Nd2d = parcelRequire("5Nd2d");
var $fbac29f129b32421$var$_button2 = $fbac29f129b32421$var$_interopRequireDefault($5Nd2d);

var $bXb2w = parcelRequire("bXb2w");

var $gP4Gh = parcelRequire("gP4Gh");

var $i7ZSP = parcelRequire("i7ZSP");
function $fbac29f129b32421$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $fbac29f129b32421$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $fbac29f129b32421$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $fbac29f129b32421$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $fbac29f129b32421$var$_typeof(obj);
}
function $fbac29f129b32421$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fbac29f129b32421$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $fbac29f129b32421$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fbac29f129b32421$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fbac29f129b32421$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $fbac29f129b32421$var$_get(target, property, receiver) {
    if ("undefined" !== typeof Reflect && Reflect.get) $fbac29f129b32421$var$_get = Reflect.get;
    else $fbac29f129b32421$var$_get = function(target, property, receiver) {
        var base = $fbac29f129b32421$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $fbac29f129b32421$var$_get(target, property, receiver || target);
}
function $fbac29f129b32421$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $fbac29f129b32421$var$_getPrototypeOf(object);
        if (null === object) break;
    }
    return object;
}
function $fbac29f129b32421$var$_inherits(subClass, superClass) {
    if ("function" !== typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $fbac29f129b32421$var$_setPrototypeOf(subClass, superClass);
}
function $fbac29f129b32421$var$_setPrototypeOf(o, p) {
    $fbac29f129b32421$var$_setPrototypeOf = Object.setPrototypeOf || function(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fbac29f129b32421$var$_setPrototypeOf(o, p);
}
function $fbac29f129b32421$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $fbac29f129b32421$var$_isNativeReflectConstruct();
    return function() {
        var result, Super = $fbac29f129b32421$var$_getPrototypeOf(Derived);
        if (hasNativeReflectConstruct) {
            var NewTarget = $fbac29f129b32421$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $fbac29f129b32421$var$_possibleConstructorReturn(this, result);
    };
}
function $fbac29f129b32421$var$_possibleConstructorReturn(self, call) {
    if (call && ("object" === $fbac29f129b32421$var$_typeof(call) || "function" === typeof call)) return call;
    return $fbac29f129b32421$var$_assertThisInitialized(self);
}
function $fbac29f129b32421$var$_assertThisInitialized(self) {
    if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $fbac29f129b32421$var$_isNativeReflectConstruct() {
    if ("undefined" === typeof Reflect || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if ("function" === typeof Proxy) return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $fbac29f129b32421$var$_getPrototypeOf(o) {
    $fbac29f129b32421$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $fbac29f129b32421$var$_getPrototypeOf(o);
}
var $fbac29f129b32421$var$STATE_INVISIBLE_CLASS = "dx-state-invisible";
var $fbac29f129b32421$var$TEXTEDITOR_CLEAR_BUTTON_CLASS = "dx-clear-button-area";
var $fbac29f129b32421$var$TEXTEDITOR_CLEAR_ICON_CLASS = "dx-icon-clear";
var $fbac29f129b32421$var$TEXTEDITOR_ICON_CLASS = "dx-icon";
var $fbac29f129b32421$var$TEXTEDITOR_SHOW_CLEAR_BUTTON_CLASS = "dx-show-clear-button";
var $fbac29f129b32421$var$ClearButton = function(_TextEditorButton) {
    $fbac29f129b32421$var$_inherits(ClearButton, _TextEditorButton);
    var _super = $fbac29f129b32421$var$_createSuper(ClearButton);
    function ClearButton() {
        $fbac29f129b32421$var$_classCallCheck(this, ClearButton);
        return _super.apply(this, arguments);
    }
    $fbac29f129b32421$var$_createClass(ClearButton, [
        {
            key: "_create",
            value: function() {
                var $element = (0, $fbac29f129b32421$var$_renderer2.default)("<span>").addClass($fbac29f129b32421$var$TEXTEDITOR_CLEAR_BUTTON_CLASS).append((0, $fbac29f129b32421$var$_renderer2.default)("<span>").addClass($fbac29f129b32421$var$TEXTEDITOR_ICON_CLASS).addClass($fbac29f129b32421$var$TEXTEDITOR_CLEAR_ICON_CLASS));
                this._addToContainer($element);
                this.update(true);
                return {
                    instance: $element,
                    $element: $element
                };
            }
        },
        {
            key: "_isVisible",
            value: function() {
                var editor = this.editor;
                return editor._isClearButtonVisible();
            }
        },
        {
            key: "_attachEvents",
            value: function(instance, $button) {
                var editor = this.editor;
                var editorName = editor.NAME;
                $fbac29f129b32421$var$_events_engine2.default.on($button, (0, $bXb2w.addNamespace)($gP4Gh.down, editorName), function(e) {
                    "mouse" === e.pointerType ? e.preventDefault() : editor._clearValueHandler(e);
                });
                $fbac29f129b32421$var$_events_engine2.default.on($button, (0, $bXb2w.addNamespace)($i7ZSP.name, editorName), function(e) {
                    return editor._clearValueHandler(e);
                });
            }
        },
        {
            key: "_legacyRender",
            value: function($editor, isVisible) {
                $editor.toggleClass($fbac29f129b32421$var$TEXTEDITOR_SHOW_CLEAR_BUTTON_CLASS, isVisible);
            }
        },
        {
            key: "update",
            value: function() {
                var rendered = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : false;
                !rendered && $fbac29f129b32421$var$_get($fbac29f129b32421$var$_getPrototypeOf(ClearButton.prototype), "update", this).call(this);
                var editor = this.editor, instance = this.instance;
                var $editor = editor.$element();
                var isVisible = this._isVisible();
                instance && instance.toggleClass($fbac29f129b32421$var$STATE_INVISIBLE_CLASS, !isVisible);
                this._legacyRender($editor, isVisible);
            }
        }
    ]);
    return ClearButton;
}($fbac29f129b32421$var$_button2.default);
module.exports.default = $fbac29f129b32421$var$ClearButton;

});
parcelRegister("5Nd2d", function(module, exports) {
/**
 * DevExtreme (ui/text_box/texteditor_button_collection/button.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jFnCG = parcelRequire("jFnCG");
var $437ba3c73132ec30$var$_renderer2 = $437ba3c73132ec30$var$_interopRequireDefault($jFnCG);
function $437ba3c73132ec30$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $437ba3c73132ec30$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $437ba3c73132ec30$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $437ba3c73132ec30$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $437ba3c73132ec30$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $437ba3c73132ec30$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $437ba3c73132ec30$var$TextEditorButton = function() {
    function TextEditorButton(name, editor, options) {
        $437ba3c73132ec30$var$_classCallCheck(this, TextEditorButton);
        this.instance = null;
        this.$container = null;
        this.$placeMarker = null;
        this.editor = editor;
        this.name = name;
        this.options = options || {};
    }
    $437ba3c73132ec30$var$_createClass(TextEditorButton, [
        {
            key: "_addPlaceMarker",
            value: function($container) {
                this.$placeMarker = (0, $437ba3c73132ec30$var$_renderer2.default)("<div>").appendTo($container);
            }
        },
        {
            key: "_addToContainer",
            value: function($element) {
                var $placeMarker = this.$placeMarker, $container = this.$container;
                $placeMarker ? $placeMarker.replaceWith($element) : $element.appendTo($container);
            }
        },
        {
            key: "_attachEvents",
            value: function() {
                throw "Not implemented";
            }
        },
        {
            key: "_create",
            value: function() {
                throw "Not implemented";
            }
        },
        {
            key: "_isRendered",
            value: function() {
                return !!this.instance;
            }
        },
        {
            key: "_isVisible",
            value: function() {
                var editor = this.editor, options = this.options;
                return options.visible || !editor.option("readOnly");
            }
        },
        {
            key: "_isDisabled",
            value: function() {
                throw "Not implemented";
            }
        },
        {
            key: "_shouldRender",
            value: function() {
                return this._isVisible() && !this._isRendered();
            }
        },
        {
            key: "dispose",
            value: function() {
                var instance = this.instance, $placeMarker = this.$placeMarker;
                if (instance) {
                    instance.dispose ? instance.dispose() : instance.remove();
                    this.instance = null;
                }
                $placeMarker && $placeMarker.remove();
            }
        },
        {
            key: "render",
            value: function() {
                var $container = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.$container;
                this.$container = $container;
                if (this._isVisible()) {
                    var _this$_create = this._create(), instance = _this$_create.instance, $element = _this$_create.$element;
                    this.instance = instance;
                    this._attachEvents(instance, $element);
                } else this._addPlaceMarker($container);
            }
        },
        {
            key: "update",
            value: function() {
                if (this._shouldRender()) this.render();
                return !!this.instance;
            }
        }
    ]);
    return TextEditorButton;
}();
module.exports.default = $437ba3c73132ec30$var$TextEditorButton;

});


parcelRegister("fC1Zt", function(module, exports) {
/**
 * DevExtreme (ui/text_box/texteditor_button_collection/index.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jFnCG = parcelRequire("jFnCG");
var $02eee703bee29331$var$_renderer2 = $02eee703bee29331$var$_interopRequireDefault($jFnCG);

var $jcBGn = parcelRequire("jcBGn");
var $02eee703bee29331$var$_custom2 = $02eee703bee29331$var$_interopRequireDefault($jcBGn);

var $7I8Uw = parcelRequire("7I8Uw");

var $aLQK5 = parcelRequire("aLQK5");

var $lrsNa = parcelRequire("lrsNa");
var $02eee703bee29331$var$_ui2 = $02eee703bee29331$var$_interopRequireDefault($lrsNa);
function $02eee703bee29331$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $02eee703bee29331$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $02eee703bee29331$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $02eee703bee29331$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $02eee703bee29331$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $02eee703bee29331$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $02eee703bee29331$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $02eee703bee29331$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $02eee703bee29331$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $02eee703bee29331$var$_typeof(obj);
}
var $02eee703bee29331$var$TEXTEDITOR_BUTTONS_CONTAINER_CLASS = "dx-texteditor-buttons-container";
function $02eee703bee29331$var$checkButtonInfo(buttonInfo) {
    var checkButtonType = function() {
        if (!buttonInfo || "object" !== $02eee703bee29331$var$_typeof(buttonInfo) || Array.isArray(buttonInfo)) throw $02eee703bee29331$var$_ui2.default.Error("E1053");
    };
    var checkLocation = function() {
        var location = buttonInfo.location;
        if ("location" in buttonInfo && "after" !== location && "before" !== location) buttonInfo.location = "after";
    };
    var checkNameIsDefined = function() {
        if (!("name" in buttonInfo)) throw $02eee703bee29331$var$_ui2.default.Error("E1054");
    };
    var checkNameIsString = function() {
        var name = buttonInfo.name;
        if ("string" !== typeof name) throw $02eee703bee29331$var$_ui2.default.Error("E1055");
    };
    checkButtonType();
    checkNameIsDefined();
    checkNameIsString();
    checkLocation();
}
function $02eee703bee29331$var$checkNamesUniqueness(existingNames, newName) {
    if (existingNames.indexOf(newName) !== -1) throw $02eee703bee29331$var$_ui2.default.Error("E1055", newName);
    existingNames.push(newName);
}
function $02eee703bee29331$var$isPredefinedButtonName(name, predefinedButtonsInfo) {
    return !!(0, $aLQK5.find)(predefinedButtonsInfo, function(info) {
        return info.name === name;
    });
}
var $02eee703bee29331$var$TextEditorButtonCollection = function() {
    function TextEditorButtonCollection(editor, defaultButtonsInfo) {
        $02eee703bee29331$var$_classCallCheck(this, TextEditorButtonCollection);
        this.buttons = [];
        this.defaultButtonsInfo = defaultButtonsInfo;
        this.editor = editor;
    }
    $02eee703bee29331$var$_createClass(TextEditorButtonCollection, [
        {
            key: "_compileButtonInfo",
            value: function(buttons) {
                var _this = this;
                var names = [];
                return buttons.map(function(button) {
                    var isStringButton = "string" === typeof button;
                    if (!isStringButton) $02eee703bee29331$var$checkButtonInfo(button);
                    var isDefaultButton = isStringButton || $02eee703bee29331$var$isPredefinedButtonName(button.name, _this.defaultButtonsInfo);
                    if (isDefaultButton) {
                        var defaultButtonInfo = (0, $aLQK5.find)(_this.defaultButtonsInfo, function(_ref) {
                            var name = _ref.name;
                            return name === button || name === button.name;
                        });
                        if (!defaultButtonInfo) throw $02eee703bee29331$var$_ui2.default.Error("E1056", _this.editor.NAME, button);
                        $02eee703bee29331$var$checkNamesUniqueness(names, button);
                        return defaultButtonInfo;
                    } else {
                        var name = button.name;
                        $02eee703bee29331$var$checkNamesUniqueness(names, name);
                        return (0, $7I8Uw.extend)(button, {
                            Ctor: $02eee703bee29331$var$_custom2.default
                        });
                    }
                });
            }
        },
        {
            key: "_createButton",
            value: function(buttonsInfo) {
                var Ctor = buttonsInfo.Ctor, options = buttonsInfo.options, name = buttonsInfo.name;
                var button = new Ctor(name, this.editor, options);
                this.buttons.push(button);
                return button;
            }
        },
        {
            key: "_renderButtons",
            value: function(buttons, $container, targetLocation) {
                var _this2 = this;
                var $buttonsContainer = null;
                var buttonsInfo = buttons ? this._compileButtonInfo(buttons) : this.defaultButtonsInfo;
                var getButtonsContainer = function() {
                    $buttonsContainer = $buttonsContainer || (0, $02eee703bee29331$var$_renderer2.default)("<div>").addClass($02eee703bee29331$var$TEXTEDITOR_BUTTONS_CONTAINER_CLASS);
                    "before" === targetLocation ? $container.prepend($buttonsContainer) : $container.append($buttonsContainer);
                    return $buttonsContainer;
                };
                buttonsInfo.forEach(function(buttonsInfo) {
                    var _buttonsInfo$location = buttonsInfo.location, location = void 0 === _buttonsInfo$location ? "after" : _buttonsInfo$location;
                    if (location === targetLocation) _this2._createButton(buttonsInfo).render(getButtonsContainer());
                });
                return $buttonsContainer;
            }
        },
        {
            key: "clean",
            value: function() {
                this.buttons.forEach(function(button) {
                    return button.dispose();
                });
                this.buttons = [];
            }
        },
        {
            key: "getButton",
            value: function(buttonName) {
                var button = (0, $aLQK5.find)(this.buttons, function(_ref2) {
                    var name = _ref2.name;
                    return name === buttonName;
                });
                return button && button.instance;
            }
        },
        {
            key: "renderAfterButtons",
            value: function(buttons, $container) {
                return this._renderButtons(buttons, $container, "after");
            }
        },
        {
            key: "renderBeforeButtons",
            value: function(buttons, $container) {
                return this._renderButtons(buttons, $container, "before");
            }
        },
        {
            key: "updateButtons",
            value: function(names) {
                this.buttons.forEach(function(button) {
                    if (!names || names.indexOf(button.name) !== -1) button.update();
                });
            }
        }
    ]);
    return TextEditorButtonCollection;
}();
module.exports.default = $02eee703bee29331$var$TextEditorButtonCollection;

});
parcelRegister("jcBGn", function(module, exports) {
/**
 * DevExtreme (ui/text_box/texteditor_button_collection/custom.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $jFnCG = parcelRequire("jFnCG");
var $dfac5e446b33a24b$var$_renderer2 = $dfac5e446b33a24b$var$_interopRequireDefault($jFnCG);

var $5Nd2d = parcelRequire("5Nd2d");
var $dfac5e446b33a24b$var$_button2 = $dfac5e446b33a24b$var$_interopRequireDefault($5Nd2d);

var $7KuSv = parcelRequire("7KuSv");
var $dfac5e446b33a24b$var$_button4 = $dfac5e446b33a24b$var$_interopRequireDefault($7KuSv);

var $7I8Uw = parcelRequire("7I8Uw");

var $e1LMc = parcelRequire("e1LMc");
var $dfac5e446b33a24b$var$_events_engine2 = $dfac5e446b33a24b$var$_interopRequireDefault($e1LMc);

var $fbrwv = parcelRequire("fbrwv");
var $dfac5e446b33a24b$var$_hover2 = $dfac5e446b33a24b$var$_interopRequireDefault($fbrwv);

var $i7ZSP = parcelRequire("i7ZSP");
var $dfac5e446b33a24b$var$_click2 = $dfac5e446b33a24b$var$_interopRequireDefault($i7ZSP);
function $dfac5e446b33a24b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $dfac5e446b33a24b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $dfac5e446b33a24b$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $dfac5e446b33a24b$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $dfac5e446b33a24b$var$_typeof(obj);
}
function $dfac5e446b33a24b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $dfac5e446b33a24b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $dfac5e446b33a24b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $dfac5e446b33a24b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $dfac5e446b33a24b$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $dfac5e446b33a24b$var$_get(target, property, receiver) {
    if ("undefined" !== typeof Reflect && Reflect.get) $dfac5e446b33a24b$var$_get = Reflect.get;
    else $dfac5e446b33a24b$var$_get = function(target, property, receiver) {
        var base = $dfac5e446b33a24b$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $dfac5e446b33a24b$var$_get(target, property, receiver || target);
}
function $dfac5e446b33a24b$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $dfac5e446b33a24b$var$_getPrototypeOf(object);
        if (null === object) break;
    }
    return object;
}
function $dfac5e446b33a24b$var$_inherits(subClass, superClass) {
    if ("function" !== typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $dfac5e446b33a24b$var$_setPrototypeOf(subClass, superClass);
}
function $dfac5e446b33a24b$var$_setPrototypeOf(o, p) {
    $dfac5e446b33a24b$var$_setPrototypeOf = Object.setPrototypeOf || function(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $dfac5e446b33a24b$var$_setPrototypeOf(o, p);
}
function $dfac5e446b33a24b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $dfac5e446b33a24b$var$_isNativeReflectConstruct();
    return function() {
        var result, Super = $dfac5e446b33a24b$var$_getPrototypeOf(Derived);
        if (hasNativeReflectConstruct) {
            var NewTarget = $dfac5e446b33a24b$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $dfac5e446b33a24b$var$_possibleConstructorReturn(this, result);
    };
}
function $dfac5e446b33a24b$var$_possibleConstructorReturn(self, call) {
    if (call && ("object" === $dfac5e446b33a24b$var$_typeof(call) || "function" === typeof call)) return call;
    return $dfac5e446b33a24b$var$_assertThisInitialized(self);
}
function $dfac5e446b33a24b$var$_assertThisInitialized(self) {
    if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $dfac5e446b33a24b$var$_isNativeReflectConstruct() {
    if ("undefined" === typeof Reflect || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if ("function" === typeof Proxy) return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $dfac5e446b33a24b$var$_getPrototypeOf(o) {
    $dfac5e446b33a24b$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $dfac5e446b33a24b$var$_getPrototypeOf(o);
}
var $dfac5e446b33a24b$var$CUSTOM_BUTTON_HOVERED_CLASS = "dx-custom-button-hovered";
var $dfac5e446b33a24b$var$CustomButton = function(_TextEditorButton) {
    $dfac5e446b33a24b$var$_inherits(CustomButton, _TextEditorButton);
    var _super = $dfac5e446b33a24b$var$_createSuper(CustomButton);
    function CustomButton() {
        $dfac5e446b33a24b$var$_classCallCheck(this, CustomButton);
        return _super.apply(this, arguments);
    }
    $dfac5e446b33a24b$var$_createClass(CustomButton, [
        {
            key: "_attachEvents",
            value: function(instance, $element) {
                var editor = this.editor;
                $dfac5e446b33a24b$var$_events_engine2.default.on($element, $dfac5e446b33a24b$var$_hover2.default.start, function() {
                    editor.$element().addClass($dfac5e446b33a24b$var$CUSTOM_BUTTON_HOVERED_CLASS);
                });
                $dfac5e446b33a24b$var$_events_engine2.default.on($element, $dfac5e446b33a24b$var$_hover2.default.end, function() {
                    editor.$element().removeClass($dfac5e446b33a24b$var$CUSTOM_BUTTON_HOVERED_CLASS);
                });
                $dfac5e446b33a24b$var$_events_engine2.default.on($element, $dfac5e446b33a24b$var$_click2.default.name, function(e) {
                    e.stopPropagation();
                });
            }
        },
        {
            key: "_create",
            value: function() {
                var editor = this.editor;
                var $element = (0, $dfac5e446b33a24b$var$_renderer2.default)("<div>");
                this._addToContainer($element);
                var instance = editor._createComponent($element, $dfac5e446b33a24b$var$_button4.default, (0, $7I8Uw.extend)({}, this.options, {
                    disabled: this._isDisabled(),
                    integrationOptions: this._prepareIntegrationOptions(editor)
                }));
                return {
                    $element: $element,
                    instance: instance
                };
            }
        },
        {
            key: "_prepareIntegrationOptions",
            value: function(editor) {
                return (0, $7I8Uw.extend)({}, editor.option("integrationOptions"), {
                    skipTemplates: [
                        "content"
                    ]
                });
            }
        },
        {
            key: "update",
            value: function() {
                var isUpdated = $dfac5e446b33a24b$var$_get($dfac5e446b33a24b$var$_getPrototypeOf(CustomButton.prototype), "update", this).call(this);
                if (this.instance) this.instance.option("disabled", this._isDisabled());
                return isUpdated;
            }
        },
        {
            key: "_isVisible",
            value: function() {
                var editor = this.editor;
                return editor.option("visible");
            }
        },
        {
            key: "_isDisabled",
            value: function() {
                var isDefinedByUser = void 0 !== this.options.disabled;
                if (isDefinedByUser) return this.instance ? this.instance.option("disabled") : this.options.disabled;
                else return this.editor.option("readOnly");
            }
        }
    ]);
    return CustomButton;
}($dfac5e446b33a24b$var$_button2.default);
module.exports.default = $dfac5e446b33a24b$var$CustomButton;

});



parcelRegister("aMVxA", function(module, exports) {
/**
 * DevExtreme (ui/text_box/ui.text_editor.mask.strategy.default.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $azKQS = parcelRequire("azKQS");
var $7dab0572e5fdfb75$var$_uiText_editorMaskStrategy2 = $7dab0572e5fdfb75$var$_interopRequireDefault($azKQS);

var $bXb2w = parcelRequire("bXb2w");

var $1jnPB = parcelRequire("1jnPB");
var $7dab0572e5fdfb75$var$_promise2 = $7dab0572e5fdfb75$var$_interopRequireDefault($1jnPB);
function $7dab0572e5fdfb75$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $7dab0572e5fdfb75$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $7dab0572e5fdfb75$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $7dab0572e5fdfb75$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $7dab0572e5fdfb75$var$_typeof(obj);
}
function $7dab0572e5fdfb75$var$_toConsumableArray(arr) {
    return $7dab0572e5fdfb75$var$_arrayWithoutHoles(arr) || $7dab0572e5fdfb75$var$_iterableToArray(arr) || $7dab0572e5fdfb75$var$_unsupportedIterableToArray(arr) || $7dab0572e5fdfb75$var$_nonIterableSpread();
}
function $7dab0572e5fdfb75$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7dab0572e5fdfb75$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if ("string" === typeof o) return $7dab0572e5fdfb75$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if ("Object" === n && o.constructor) n = o.constructor.name;
    if ("Map" === n || "Set" === n) return Array.from(o);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7dab0572e5fdfb75$var$_arrayLikeToArray(o, minLen);
}
function $7dab0572e5fdfb75$var$_iterableToArray(iter) {
    if ("undefined" !== typeof Symbol && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $7dab0572e5fdfb75$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $7dab0572e5fdfb75$var$_arrayLikeToArray(arr);
}
function $7dab0572e5fdfb75$var$_arrayLikeToArray(arr, len) {
    if (null == len || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7dab0572e5fdfb75$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7dab0572e5fdfb75$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7dab0572e5fdfb75$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7dab0572e5fdfb75$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7dab0572e5fdfb75$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $7dab0572e5fdfb75$var$_get(target, property, receiver) {
    if ("undefined" !== typeof Reflect && Reflect.get) $7dab0572e5fdfb75$var$_get = Reflect.get;
    else $7dab0572e5fdfb75$var$_get = function(target, property, receiver) {
        var base = $7dab0572e5fdfb75$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $7dab0572e5fdfb75$var$_get(target, property, receiver || target);
}
function $7dab0572e5fdfb75$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $7dab0572e5fdfb75$var$_getPrototypeOf(object);
        if (null === object) break;
    }
    return object;
}
function $7dab0572e5fdfb75$var$_inherits(subClass, superClass) {
    if ("function" !== typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $7dab0572e5fdfb75$var$_setPrototypeOf(subClass, superClass);
}
function $7dab0572e5fdfb75$var$_setPrototypeOf(o, p) {
    $7dab0572e5fdfb75$var$_setPrototypeOf = Object.setPrototypeOf || function(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $7dab0572e5fdfb75$var$_setPrototypeOf(o, p);
}
function $7dab0572e5fdfb75$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7dab0572e5fdfb75$var$_isNativeReflectConstruct();
    return function() {
        var result, Super = $7dab0572e5fdfb75$var$_getPrototypeOf(Derived);
        if (hasNativeReflectConstruct) {
            var NewTarget = $7dab0572e5fdfb75$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $7dab0572e5fdfb75$var$_possibleConstructorReturn(this, result);
    };
}
function $7dab0572e5fdfb75$var$_possibleConstructorReturn(self, call) {
    if (call && ("object" === $7dab0572e5fdfb75$var$_typeof(call) || "function" === typeof call)) return call;
    return $7dab0572e5fdfb75$var$_assertThisInitialized(self);
}
function $7dab0572e5fdfb75$var$_assertThisInitialized(self) {
    if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $7dab0572e5fdfb75$var$_isNativeReflectConstruct() {
    if ("undefined" === typeof Reflect || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if ("function" === typeof Proxy) return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7dab0572e5fdfb75$var$_getPrototypeOf(o) {
    $7dab0572e5fdfb75$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $7dab0572e5fdfb75$var$_getPrototypeOf(o);
}
var $7dab0572e5fdfb75$var$BACKSPACE_INPUT_TYPE = "deleteContentBackward";
var $7dab0572e5fdfb75$var$EMPTY_CHAR = " ";
var $7dab0572e5fdfb75$var$DefaultMaskStrategy = function(_BaseMaskStrategy) {
    $7dab0572e5fdfb75$var$_inherits(DefaultMaskStrategy, _BaseMaskStrategy);
    var _super = $7dab0572e5fdfb75$var$_createSuper(DefaultMaskStrategy);
    function DefaultMaskStrategy() {
        $7dab0572e5fdfb75$var$_classCallCheck(this, DefaultMaskStrategy);
        return _super.apply(this, arguments);
    }
    $7dab0572e5fdfb75$var$_createClass(DefaultMaskStrategy, [
        {
            key: "_getStrategyName",
            value: function() {
                return "default";
            }
        },
        {
            key: "getHandleEventNames",
            value: function() {
                return [].concat($7dab0572e5fdfb75$var$_toConsumableArray($7dab0572e5fdfb75$var$_get($7dab0572e5fdfb75$var$_getPrototypeOf(DefaultMaskStrategy.prototype), "getHandleEventNames", this).call(this)), [
                    "keyPress"
                ]);
            }
        },
        {
            key: "_keyPressHandler",
            value: function(event) {
                if (this._keyPressHandled) return;
                this._keyPressHandled = true;
                if (this.editor._isControlKeyFired(event)) return;
                var editor = this.editor;
                editor._maskKeyHandler(event, function() {
                    return editor._handleKey((0, $bXb2w.getChar)(event));
                });
            }
        },
        {
            key: "_inputHandler",
            value: function(event) {
                if (this._backspaceInputHandled(event.originalEvent && event.originalEvent.inputType)) this._handleBackspaceInput(event);
                if (event.originalEvent) this._autoFillHandler(event);
                if (this._keyPressHandled) return;
                this._keyPressHandled = true;
                var inputValue = this.editorInput().val();
                var caret = this.editorCaret();
                if (!caret.end) return;
                caret.start = caret.end - 1;
                var oldValue = inputValue.substring(0, caret.start) + inputValue.substring(caret.end);
                var char = inputValue[caret.start];
                var editor = this.editor;
                this.editorInput().val(oldValue);
                editor._caret({
                    start: caret.start,
                    end: caret.start
                });
                editor._maskKeyHandler(event, function() {
                    return editor._handleKey(char);
                });
            }
        },
        {
            key: "_backspaceHandler",
            value: function(event) {
                var _this = this;
                var editor = this.editor;
                this._keyPressHandled = true;
                var afterBackspaceHandler = function(needAdjustCaret, callBack) {
                    if (needAdjustCaret) {
                        editor._direction(_this.DIRECTION.FORWARD);
                        editor._adjustCaret();
                    }
                    var currentCaret = _this.editorCaret();
                    return new $7dab0572e5fdfb75$var$_promise2.default(function(resolve) {
                        clearTimeout(_this._backspaceHandlerTimeout);
                        _this._backspaceHandlerTimeout = setTimeout(function() {
                            callBack(currentCaret);
                            resolve();
                        });
                    });
                };
                editor._maskKeyHandler(event, function() {
                    if (editor._hasSelection()) return afterBackspaceHandler(true, function(currentCaret) {
                        editor._displayMask(currentCaret);
                        editor._maskRulesChain.reset();
                    });
                    if (editor._tryMoveCaretBackward()) return afterBackspaceHandler(false, function(currentCaret) {
                        _this.editorCaret(currentCaret);
                    });
                    editor._handleKey($7dab0572e5fdfb75$var$EMPTY_CHAR, _this.DIRECTION.BACKWARD);
                    return afterBackspaceHandler(true, function(currentCaret) {
                        editor._displayMask(currentCaret);
                        editor._maskRulesChain.reset();
                    });
                });
            }
        },
        {
            key: "_backspaceInputHandled",
            value: function(inputType) {
                return inputType === $7dab0572e5fdfb75$var$BACKSPACE_INPUT_TYPE && !this._keyPressHandled;
            }
        },
        {
            key: "_handleBackspaceInput",
            value: function(event) {
                var _this$editorCaret = this.editorCaret(), start = _this$editorCaret.start, end = _this$editorCaret.end;
                this.editorCaret({
                    start: start + 1,
                    end: end + 1
                });
                this._backspaceHandler(event);
            }
        }
    ]);
    return DefaultMaskStrategy;
}($7dab0572e5fdfb75$var$_uiText_editorMaskStrategy2.default);
module.exports.default = $7dab0572e5fdfb75$var$DefaultMaskStrategy;

});
parcelRegister("azKQS", function(module, exports) {
/**
 * DevExtreme (ui/text_box/ui.text_editor.mask.strategy.base.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e1LMc = parcelRequire("e1LMc");
var $7b3184133c36d297$var$_events_engine2 = $7b3184133c36d297$var$_interopRequireDefault($e1LMc);

var $bXb2w = parcelRequire("bXb2w");

var $bvcPv = parcelRequire("bvcPv");
var $7b3184133c36d297$var$_browser2 = $7b3184133c36d297$var$_interopRequireDefault($bvcPv);

var $aLQK5 = parcelRequire("aLQK5");

var $5OzEX = parcelRequire("5OzEX");
function $7b3184133c36d297$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $7b3184133c36d297$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7b3184133c36d297$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $7b3184133c36d297$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7b3184133c36d297$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7b3184133c36d297$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $7b3184133c36d297$var$MASK_EVENT_NAMESPACE = "dxMask";
var $7b3184133c36d297$var$BLUR_EVENT = "blur beforedeactivate";
var $7b3184133c36d297$var$EMPTY_CHAR = " ";
var $7b3184133c36d297$var$BaseMaskStrategy = function() {
    function BaseMaskStrategy(editor) {
        $7b3184133c36d297$var$_classCallCheck(this, BaseMaskStrategy);
        this.editor = editor;
        this.DIRECTION = {
            FORWARD: "forward",
            BACKWARD: "backward"
        };
        this.NAME = this._getStrategyName();
    }
    $7b3184133c36d297$var$_createClass(BaseMaskStrategy, [
        {
            key: "_getStrategyName",
            value: function() {
                return "base";
            }
        },
        {
            key: "editorOption",
            value: function() {
                var _this$editor;
                return (_this$editor = this.editor).option.apply(_this$editor, arguments);
            }
        },
        {
            key: "editorInput",
            value: function() {
                return this.editor._input();
            }
        },
        {
            key: "editorCaret",
            value: function(newCaret) {
                if (!newCaret) return this.editor._caret();
                this.editor._caret(newCaret);
            }
        },
        {
            key: "getHandler",
            value: function(handlerName) {
                var handler = this["_".concat(handlerName, "Handler")] || function() {};
                return handler.bind(this);
            }
        },
        {
            key: "attachEvents",
            value: function() {
                var _this = this;
                var $input = this.editorInput();
                this.getHandleEventNames().forEach(function(eventName) {
                    var subscriptionName = (0, $bXb2w.addNamespace)(eventName.toLowerCase(), $7b3184133c36d297$var$MASK_EVENT_NAMESPACE);
                    $7b3184133c36d297$var$_events_engine2.default.on($input, subscriptionName, _this.getEventHandler(eventName));
                });
                this._attachChangeEventHandlers();
            }
        },
        {
            key: "getHandleEventNames",
            value: function() {
                return [
                    "focusIn",
                    "focusOut",
                    "keyDown",
                    "input",
                    "paste",
                    "cut",
                    "drop"
                ];
            }
        },
        {
            key: "getEventHandler",
            value: function(eventName) {
                return this["_".concat(eventName, "Handler")].bind(this);
            }
        },
        {
            key: "detachEvents",
            value: function() {
                $7b3184133c36d297$var$_events_engine2.default.off(this.editorInput(), ".".concat($7b3184133c36d297$var$MASK_EVENT_NAMESPACE));
            }
        },
        {
            key: "_attachChangeEventHandlers",
            value: function() {
                if ((0, $aLQK5.inArray)("change", this.editorOption("valueChangeEvent").split(" ")) === -1) return;
                $7b3184133c36d297$var$_events_engine2.default.on(this.editorInput(), (0, $bXb2w.addNamespace)($7b3184133c36d297$var$BLUR_EVENT, $7b3184133c36d297$var$MASK_EVENT_NAMESPACE), (function(e) {
                    this._suppressCaretChanging(this._changeHandler, [
                        e
                    ]);
                    this._changeHandler(e);
                }).bind(this.editor));
            }
        },
        {
            key: "_focusInHandler",
            value: function() {
                this.editor._showMaskPlaceholder();
                this.editor._direction(this.DIRECTION.FORWARD);
                if (!this.editor._isValueEmpty() && this.editorOption("isValid")) this.editor._adjustCaret();
                else {
                    var caret = this.editor._maskRulesChain.first();
                    this._caretTimeout = setTimeout((function() {
                        this._caret({
                            start: caret,
                            end: caret
                        });
                    }).bind(this.editor), 0);
                }
            }
        },
        {
            key: "_focusOutHandler",
            value: function(event) {
                this.editor._changeHandler(event);
                if ("onFocus" === this.editorOption("showMaskMode") && this.editor._isValueEmpty()) {
                    this.editorOption("text", "");
                    this.editor._renderDisplayText("");
                }
            }
        },
        {
            key: "_cutHandler",
            value: function(event) {
                var caret = this.editorCaret();
                var selectedText = this.editorInput().val().substring(caret.start, caret.end);
                this.editor._maskKeyHandler(event, function() {
                    return (0, $5OzEX.clipboardText)(event, selectedText);
                });
            }
        },
        {
            key: "_dropHandler",
            value: function() {
                this._clearDragTimer();
                this._dragTimer = setTimeout((function() {
                    this.option("value", this._convertToValue(this._input().val()));
                }).bind(this.editor));
            }
        },
        {
            key: "_clearDragTimer",
            value: function() {
                clearTimeout(this._dragTimer);
            }
        },
        {
            key: "_keyDownHandler",
            value: function() {
                this._keyPressHandled = false;
            }
        },
        {
            key: "_pasteHandler",
            value: function(event) {
                var editor = this.editor;
                this._keyPressHandled = true;
                var caret = this.editorCaret();
                editor._maskKeyHandler(event, function() {
                    var pastedText = (0, $5OzEX.clipboardText)(event);
                    var restText = editor._maskRulesChain.text().substring(caret.end);
                    var accepted = editor._handleChain({
                        text: pastedText,
                        start: caret.start,
                        length: pastedText.length
                    });
                    var newCaret = caret.start + accepted;
                    editor._handleChain({
                        text: restText,
                        start: newCaret,
                        length: restText.length
                    });
                    editor._caret({
                        start: newCaret,
                        end: newCaret
                    });
                });
            }
        },
        {
            key: "_autoFillHandler",
            value: function(event) {
                var _this2 = this;
                var editor = this.editor;
                var inputVal = this.editorInput().val();
                this._inputHandlerTimer = setTimeout(function() {
                    _this2._keyPressHandled = true;
                    if (_this2._isAutoFill()) {
                        _this2._keyPressHandled = true;
                        editor._maskKeyHandler(event, function() {
                            editor._handleChain({
                                text: inputVal,
                                start: 0,
                                length: inputVal.length
                            });
                        });
                        editor._validateMask();
                    }
                });
            }
        },
        {
            key: "_isAutoFill",
            value: function() {
                var $input = this.editor._input();
                var result = false;
                if ($7b3184133c36d297$var$_browser2.default.msie && $7b3184133c36d297$var$_browser2.default.version > 11) result = $input.hasClass("edge-autofilled");
                else if ($7b3184133c36d297$var$_browser2.default.webkit) {
                    var input = $input.get(0);
                    result = input && input.matches(":-webkit-autofill");
                }
                return result;
            }
        },
        {
            key: "runWithoutEventProcessing",
            value: function(action) {
                var keyPressHandled = this._keyPressHandled;
                this._keyPressHandled = true;
                action();
                this._keyPressHandled = keyPressHandled;
            }
        },
        {
            key: "_backspaceHandler",
            value: function() {}
        },
        {
            key: "_delHandler",
            value: function(event) {
                var editor = this.editor;
                this._keyPressHandled = true;
                editor._maskKeyHandler(event, function() {
                    return !editor._hasSelection() && editor._handleKey($7b3184133c36d297$var$EMPTY_CHAR);
                });
            }
        },
        {
            key: "clean",
            value: function() {
                this._clearDragTimer();
                clearTimeout(this._backspaceHandlerTimeout);
                clearTimeout(this._caretTimeout);
                clearTimeout(this._inputHandlerTimer);
            }
        }
    ]);
    return BaseMaskStrategy;
}();
module.exports.default = $7b3184133c36d297$var$BaseMaskStrategy;

});


parcelRegister("9B122", function(module, exports) {
/**
 * DevExtreme (ui/text_box/ui.text_editor.mask.strategy.android.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $azKQS = parcelRequire("azKQS");
var $6fc85ea850bad4dc$var$_uiText_editorMaskStrategy2 = $6fc85ea850bad4dc$var$_interopRequireDefault($azKQS);
function $6fc85ea850bad4dc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $6fc85ea850bad4dc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $6fc85ea850bad4dc$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $6fc85ea850bad4dc$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6fc85ea850bad4dc$var$_typeof(obj);
}
function $6fc85ea850bad4dc$var$_toConsumableArray(arr) {
    return $6fc85ea850bad4dc$var$_arrayWithoutHoles(arr) || $6fc85ea850bad4dc$var$_iterableToArray(arr) || $6fc85ea850bad4dc$var$_unsupportedIterableToArray(arr) || $6fc85ea850bad4dc$var$_nonIterableSpread();
}
function $6fc85ea850bad4dc$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6fc85ea850bad4dc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if ("string" === typeof o) return $6fc85ea850bad4dc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if ("Object" === n && o.constructor) n = o.constructor.name;
    if ("Map" === n || "Set" === n) return Array.from(o);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6fc85ea850bad4dc$var$_arrayLikeToArray(o, minLen);
}
function $6fc85ea850bad4dc$var$_iterableToArray(iter) {
    if ("undefined" !== typeof Symbol && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $6fc85ea850bad4dc$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $6fc85ea850bad4dc$var$_arrayLikeToArray(arr);
}
function $6fc85ea850bad4dc$var$_arrayLikeToArray(arr, len) {
    if (null == len || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6fc85ea850bad4dc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6fc85ea850bad4dc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $6fc85ea850bad4dc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6fc85ea850bad4dc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6fc85ea850bad4dc$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $6fc85ea850bad4dc$var$_get(target, property, receiver) {
    if ("undefined" !== typeof Reflect && Reflect.get) $6fc85ea850bad4dc$var$_get = Reflect.get;
    else $6fc85ea850bad4dc$var$_get = function(target, property, receiver) {
        var base = $6fc85ea850bad4dc$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver);
        return desc.value;
    };
    return $6fc85ea850bad4dc$var$_get(target, property, receiver || target);
}
function $6fc85ea850bad4dc$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $6fc85ea850bad4dc$var$_getPrototypeOf(object);
        if (null === object) break;
    }
    return object;
}
function $6fc85ea850bad4dc$var$_inherits(subClass, superClass) {
    if ("function" !== typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6fc85ea850bad4dc$var$_setPrototypeOf(subClass, superClass);
}
function $6fc85ea850bad4dc$var$_setPrototypeOf(o, p) {
    $6fc85ea850bad4dc$var$_setPrototypeOf = Object.setPrototypeOf || function(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6fc85ea850bad4dc$var$_setPrototypeOf(o, p);
}
function $6fc85ea850bad4dc$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6fc85ea850bad4dc$var$_isNativeReflectConstruct();
    return function() {
        var result, Super = $6fc85ea850bad4dc$var$_getPrototypeOf(Derived);
        if (hasNativeReflectConstruct) {
            var NewTarget = $6fc85ea850bad4dc$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6fc85ea850bad4dc$var$_possibleConstructorReturn(this, result);
    };
}
function $6fc85ea850bad4dc$var$_possibleConstructorReturn(self, call) {
    if (call && ("object" === $6fc85ea850bad4dc$var$_typeof(call) || "function" === typeof call)) return call;
    return $6fc85ea850bad4dc$var$_assertThisInitialized(self);
}
function $6fc85ea850bad4dc$var$_assertThisInitialized(self) {
    if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6fc85ea850bad4dc$var$_isNativeReflectConstruct() {
    if ("undefined" === typeof Reflect || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if ("function" === typeof Proxy) return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6fc85ea850bad4dc$var$_getPrototypeOf(o) {
    $6fc85ea850bad4dc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6fc85ea850bad4dc$var$_getPrototypeOf(o);
}
var $6fc85ea850bad4dc$var$DELETE_INPUT_TYPE = "deleteContentBackward";
var $6fc85ea850bad4dc$var$AndroidMaskStrategy = function(_BaseMaskStrategy) {
    $6fc85ea850bad4dc$var$_inherits(AndroidMaskStrategy, _BaseMaskStrategy);
    var _super = $6fc85ea850bad4dc$var$_createSuper(AndroidMaskStrategy);
    function AndroidMaskStrategy() {
        $6fc85ea850bad4dc$var$_classCallCheck(this, AndroidMaskStrategy);
        return _super.apply(this, arguments);
    }
    $6fc85ea850bad4dc$var$_createClass(AndroidMaskStrategy, [
        {
            key: "_getStrategyName",
            value: function() {
                return "android";
            }
        },
        {
            key: "getHandleEventNames",
            value: function() {
                return [].concat($6fc85ea850bad4dc$var$_toConsumableArray($6fc85ea850bad4dc$var$_get($6fc85ea850bad4dc$var$_getPrototypeOf(AndroidMaskStrategy.prototype), "getHandleEventNames", this).call(this)), [
                    "beforeInput"
                ]);
            }
        },
        {
            key: "_beforeInputHandler",
            value: function() {
                this._prevCaret = this.editorCaret();
            }
        },
        {
            key: "_inputHandler",
            value: function(_ref) {
                var originalEvent = _ref.originalEvent;
                if (!originalEvent) return;
                var inputType = originalEvent.inputType, data = originalEvent.data;
                var currentCaret = this.editorCaret();
                if (inputType === $6fc85ea850bad4dc$var$DELETE_INPUT_TYPE) {
                    var length = this._prevCaret.end - this._prevCaret.start || 1;
                    this.editor.setBackwardDirection();
                    this._updateEditorMask({
                        start: currentCaret.start,
                        length: length,
                        text: this._getEmptyString(length)
                    });
                } else {
                    if (!currentCaret.end) return;
                    this._autoFillHandler(originalEvent);
                    this.editorCaret(currentCaret);
                    var _length = this._prevCaret.end - this._prevCaret.start;
                    var newData = data + (_length ? this._getEmptyString(_length - data.length) : "");
                    this.editor.setForwardDirection();
                    var hasValidChars = this._updateEditorMask({
                        start: this._prevCaret.start,
                        length: _length || newData.length,
                        text: newData
                    });
                    if (!hasValidChars) this.editorCaret(this._prevCaret);
                }
            }
        },
        {
            key: "_getEmptyString",
            value: function(length) {
                return Array(length + 1).join(" ");
            }
        },
        {
            key: "_updateEditorMask",
            value: function(args) {
                var textLength = args.text.length;
                var updatedCharsCount = this.editor._handleChain(args);
                if (this.editor.isForwardDirection()) {
                    var _this$editorCaret = this.editorCaret(), start = _this$editorCaret.start, end = _this$editorCaret.end;
                    var correction = updatedCharsCount - textLength;
                    if (start <= updatedCharsCount && updatedCharsCount > 1) this.editorCaret({
                        start: start + correction,
                        end: end + correction
                    });
                    this.editor.isForwardDirection() && this.editor._adjustCaret();
                }
                this.editor._displayMask();
                return !!updatedCharsCount;
            }
        }
    ]);
    return AndroidMaskStrategy;
}($6fc85ea850bad4dc$var$_uiText_editorMaskStrategy2.default);
module.exports.default = $6fc85ea850bad4dc$var$AndroidMaskStrategy;

});




parcelRegister("7we3r", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    var context = new $ewFRw(defaultConfig);
    var instance = $jJbMR($ewFRw.prototype.request, context);
    // Copy axios.prototype to instance
    $gKvUL.extend(instance, $ewFRw.prototype, context);
    // Copy context to instance
    $gKvUL.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance($lJY4v);
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = $ewFRw;
// Factory for creating new instances
$57966c7e0affc4cb$var$axios.create = function create(instanceConfig) {
    return $57966c7e0affc4cb$var$createInstance($lk5EI($57966c7e0affc4cb$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.Cancel = (parcelRequire("4Tkeq"));

$57966c7e0affc4cb$var$axios.CancelToken = (parcelRequire("lAKPy"));

$57966c7e0affc4cb$var$axios.isCancel = (parcelRequire("7L4QX"));
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$57966c7e0affc4cb$var$axios.spread = (parcelRequire("JEeti"));
module.exports = $57966c7e0affc4cb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {
"use strict";

var $jJbMR = parcelRequire("jJbMR");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $c319b2c832c2914a$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $c319b2c832c2914a$var$isArray(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $c319b2c832c2914a$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBuffer(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $c319b2c832c2914a$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $c319b2c832c2914a$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $c319b2c832c2914a$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $c319b2c832c2914a$var$isDate(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $c319b2c832c2914a$var$isFile(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $c319b2c832c2914a$var$isBlob(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $c319b2c832c2914a$var$isFunction(val) {
    return $c319b2c832c2914a$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $c319b2c832c2914a$var$isStream(val) {
    return $c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $c319b2c832c2914a$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $c319b2c832c2914a$var$trim(str) {
    return str.replace(/^\s*/, "").replace(/\s*$/, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $c319b2c832c2914a$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $c319b2c832c2914a$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === "object" && typeof val === "object") result[key] = $c319b2c832c2914a$var$merge(result[key], val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$deepMerge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === "object" && typeof val === "object") result[key] = $c319b2c832c2914a$var$deepMerge(result[key], val);
        else if (typeof val === "object") result[key] = $c319b2c832c2914a$var$deepMerge({}, val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $c319b2c832c2914a$var$extend(a, b, thisArg) {
    $c319b2c832c2914a$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $jJbMR(val, thisArg);
        else a[key] = val;
    });
    return a;
}
module.exports = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isObject: $c319b2c832c2914a$var$isObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isStandardBrowserEnv: $c319b2c832c2914a$var$isStandardBrowserEnv,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    deepMerge: $c319b2c832c2914a$var$deepMerge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim
};

});
parcelRegister("jJbMR", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("ewFRw", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $a93486d2307f31c3$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $83RYu(),
        response: new $83RYu()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $a93486d2307f31c3$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $lk5EI(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    // Hook up interceptors middleware
    var chain = [
        $dlZEJ,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
$a93486d2307f31c3$var$Axios.prototype.getUri = function getUri(config) {
    config = $lk5EI(this.defaults, config);
    return $cbIsf(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$gKvUL.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request($gKvUL.merge(config || {}, {
            method: method,
            url: url
        }));
    };
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($gKvUL.merge(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($gKvUL.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $gKvUL.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($gKvUL.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $gKvUL.forEach(val, function parseValue(v) {
                if ($gKvUL.isDate(v)) v = v.toISOString();
                else if ($gKvUL.isObject(v)) v = JSON.stringify(v);
                parts.push($8df8fedf1c1e4428$var$encode(key) + "=" + $8df8fedf1c1e4428$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("83RYu", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
function $5de878cd737ef277$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $5de878cd737ef277$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $5de878cd737ef277$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $5de878cd737ef277$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $gKvUL.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $7YJ0v(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $gKvUL.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $gKvUL.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $lJY4v.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $7YJ0v(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$7L4QX(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $7YJ0v(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("7YJ0v", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $gKvUL.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("7L4QX", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("lJY4v", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kiL6T = parcelRequire("kiL6T");
var $fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, value) {
    if (!$gKvUL.isUndefined(headers) && $gKvUL.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $fd3c65eeb28abd71$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("at5cb"));
    else if (typeof $hPtJY !== "undefined" && Object.prototype.toString.call($hPtJY) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("at5cb"));
    return adapter;
}
var $fd3c65eeb28abd71$var$defaults = {
    adapter: $fd3c65eeb28abd71$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kiL6T(headers, "Accept");
            $kiL6T(headers, "Content-Type");
            if ($gKvUL.isFormData(data) || $gKvUL.isArrayBuffer(data) || $gKvUL.isBuffer(data) || $gKvUL.isStream(data) || $gKvUL.isFile(data) || $gKvUL.isBlob(data)) return data;
            if ($gKvUL.isArrayBufferView(data)) return data.buffer;
            if ($gKvUL.isURLSearchParams(data)) {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($gKvUL.isObject(data)) {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, "application/json;charset=utf-8");
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === "string") try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$fd3c65eeb28abd71$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$gKvUL.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = {};
});
$gKvUL.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = $gKvUL.merge($fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $fd3c65eeb28abd71$var$defaults;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRegister("kiL6T", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $gKvUL.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("at5cb", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $cbIsf = parcelRequire("cbIsf");

var $7GD7a = parcelRequire("7GD7a");

var $lDriZ = parcelRequire("lDriZ");

var $889er = parcelRequire("889er");

var $kjF3e = parcelRequire("kjF3e");

module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($gKvUL.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password || "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $7GD7a(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $cbIsf(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $lDriZ(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === "text" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $kk0E9(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($kjF3e("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($kjF3e("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($kjF3e(timeoutErrorMessage, config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($gKvUL.isStandardBrowserEnv()) {
            var cookies = (parcelRequire("8JRzs"));
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $889er(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $gKvUL.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$gKvUL.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== "json") throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (requestData === undefined) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {
"use strict";

var $kjF3e = parcelRequire("kjF3e");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!validateStatus || validateStatus(response.status)) resolve(response);
    else reject($kjF3e("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("kjF3e", function(module, exports) {
"use strict";

var $8v8A7 = parcelRequire("8v8A7");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $8v8A7(error, config, code, request, response);
};

});
parcelRegister("8v8A7", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});



parcelRegister("7GD7a", function(module, exports) {
"use strict";

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$ckHwb(requestedURL)) return $fE4ul(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("ckHwb", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("fE4ul", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("lDriZ", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $fc026bbf9ee156f1$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $gKvUL.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $gKvUL.trim(line.substr(0, i)).toLowerCase();
        val = $gKvUL.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("889er", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $gKvUL.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("8JRzs", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($gKvUL.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($gKvUL.isString(path)) cookie.push("path=" + path);
            if ($gKvUL.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});




parcelRegister("lk5EI", function(module, exports) {
"use strict";

var $gKvUL = parcelRequire("gKvUL");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "params",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "url",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "maxContentLength",
        "validateStatus",
        "maxRedirects",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath"
    ];
    $gKvUL.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
    });
    $gKvUL.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
        if ($gKvUL.isObject(config2[prop])) config[prop] = $gKvUL.deepMerge(config1[prop], config2[prop]);
        else if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if ($gKvUL.isObject(config1[prop])) config[prop] = $gKvUL.deepMerge(config1[prop]);
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    $gKvUL.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys);
    var otherKeys = Object.keys(config2).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $gKvUL.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    return config;
};

});


parcelRegister("4Tkeq", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $38fbfe0afbd5bf1e$var$Cancel(message) {
    this.message = message;
}
$38fbfe0afbd5bf1e$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$38fbfe0afbd5bf1e$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $38fbfe0afbd5bf1e$var$Cancel;

});

parcelRegister("lAKPy", function(module, exports) {
"use strict";

var $4Tkeq = parcelRequire("4Tkeq");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $fb81495929d8a282$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $4Tkeq(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $fb81495929d8a282$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $fb81495929d8a282$var$CancelToken.source = function source() {
    var cancel;
    var token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});



var $45fvw = parcelRequire("45fvw");
var $2aa61a6482d6321b$exports = {};
/**
 * DevExtreme (ui/calendar.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

$2aa61a6482d6321b$exports = (parcelRequire("66e0v"));
$2aa61a6482d6321b$exports.default = $2aa61a6482d6321b$exports;


var $17d3d2d92491e950$exports = {};
/**
 * DevExtreme (ui/toolbar.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $3LUJe = parcelRequire("3LUJe");

var $4ZFRo = parcelRequire("4ZFRo");

var $2Mto0 = parcelRequire("2Mto0");
var $17d3d2d92491e950$require$grep = $2Mto0.grep;

var $7I8Uw = parcelRequire("7I8Uw");
var $17d3d2d92491e950$require$extend = $7I8Uw.extend;

var $aLQK5 = parcelRequire("aLQK5");

var $4Pwuy = parcelRequire("4Pwuy");
var $82371d383bcfde9d$exports = {};
/**
 * DevExtreme (ui/toolbar/ui.toolbar.strategy.action_sheet.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
var $c5879277017430c5$exports = {};
/**
 * DevExtreme (ui/toolbar/ui.toolbar.strategy.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $2Mto0 = parcelRequire("2Mto0");
var $c5879277017430c5$require$noop = $2Mto0.noop;

var $4Pwuy = parcelRequire("4Pwuy");
var $c5879277017430c5$require$each = $4Pwuy.each;

var $7sX7V = parcelRequire("7sX7V");

var $kpjzB = parcelRequire("kpjzB");
var $c5879277017430c5$require$compileGetter = $kpjzB.compileGetter;

var $k7aJb = parcelRequire("k7aJb");

var $7KuSv = parcelRequire("7KuSv");
var $c5879277017430c5$var$abstract = $k7aJb.abstract;
var $c5879277017430c5$var$TOOLBAR_MENU_CONTAINER_CLASS = "dx-toolbar-menu-container";
var $c5879277017430c5$var$TOOLBAR_MENU_BUTTON_CLASS = "dx-toolbar-menu-button";
var $c5879277017430c5$var$ToolbarStrategy = $k7aJb.inherit({
    ctor: function(toolbar) {
        this._toolbar = toolbar;
    },
    render: function() {
        this._renderMenuButton();
        this._renderWidget();
    },
    _widgetOptions: function() {
        var itemClickAction = this._toolbar._createActionByOption("onItemClick");
        return {
            itemTemplate: this._getMenuItemTemplate.bind(this),
            onItemClick: (function(e) {
                this._toggleMenu(false, true);
                itemClickAction(e);
            }).bind(this)
        };
    },
    _getMenuItemTemplate: function() {
        return this._toolbar._getTemplateByOption("menuItemTemplate");
    },
    _renderWidget: function() {
        var $menu = $jFnCG("<div>").appendTo(this._menuContainer());
        this._menu = this._toolbar._createComponent($menu, this._menuWidgetClass(), this._widgetOptions());
        this.renderMenuItems();
    },
    _menuContainer: $c5879277017430c5$var$abstract,
    _menuWidgetClass: $c5879277017430c5$var$abstract,
    _hasVisibleMenuItems: function(items) {
        var menuItems = items || this._toolbar.option("items");
        var result = false;
        var optionGetter = $c5879277017430c5$require$compileGetter("visible");
        var overflowGetter = $c5879277017430c5$require$compileGetter("locateInMenu");
        var menuLocation = false;
        $c5879277017430c5$require$each(menuItems, function(index, item) {
            var itemVisible = optionGetter(item, {
                functionsAsIs: true
            });
            var itemOverflow = overflowGetter(item, {
                functionsAsIs: true
            });
            if ("menu" === item.location) menuLocation = true;
            if (false !== itemVisible && ("auto" === itemOverflow || "always" === itemOverflow || "menu" === item.location)) result = true;
        });
        if (menuLocation) $7sX7V.log("W0001", "dxToolbar - 'location' item field", "menu", "16.1", "Use 'locateInMenu' item field instead.");
        return result;
    },
    _getMenuItems: function() {
        return this._toolbar._getMenuItems();
    },
    _updateMenuVisibility: $c5879277017430c5$require$noop,
    _renderMenuButton: function() {
        var buttonOptions = this._menuButtonOptions();
        this._renderMenuButtonContainer();
        this._$button = $jFnCG("<div>").appendTo(this._$menuButtonContainer).addClass($c5879277017430c5$var$TOOLBAR_MENU_BUTTON_CLASS);
        this._toolbar._createComponent(this._$button, $7KuSv, buttonOptions);
    },
    _menuButtonOptions: function() {
        return {
            onClick: this._menuButtonClickHandler.bind(this)
        };
    },
    _menuButtonClickHandler: function() {
        this._toggleMenu(!this._menuShown, true);
    },
    _renderMenuButtonContainer: function() {
        var $afterSection = this._toolbar._$afterSection;
        this._$menuButtonContainer = $jFnCG("<div>").appendTo($afterSection).addClass(this._toolbar._buttonClass()).addClass($c5879277017430c5$var$TOOLBAR_MENU_CONTAINER_CLASS);
    },
    renderMenuItems: function() {
        this._menu && this._menu.option("items", this._getMenuItems());
    },
    toggleMenuVisibility: function(visible, animate) {
        this._menu && this._toggleMenu(visible, animate);
    },
    _toggleMenu: function(visible) {
        this._menuShown = visible;
    },
    getMenuWidget: function() {
        return this._menu;
    },
    widgetOption: function(name, value) {
        this._menu && this._menu.option(name, value);
    },
    handleToolbarVisibilityChange: $c5879277017430c5$require$noop
});
$c5879277017430c5$exports = $c5879277017430c5$var$ToolbarStrategy;



var $7I8Uw = parcelRequire("7I8Uw");
var $82371d383bcfde9d$require$extend = $7I8Uw.extend;
var $74fa45cb65203b59$exports = {};
/**
 * DevExtreme (ui/action_sheet.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $74fa45cb65203b59$var$window = (parcelRequire("irv64")).getWindow();

var $2Mto0 = parcelRequire("2Mto0");
var $74fa45cb65203b59$require$noop = $2Mto0.noop;

var $cnVbh = parcelRequire("cnVbh");

var $4ZFRo = parcelRequire("4ZFRo");

var $7I8Uw = parcelRequire("7I8Uw");
var $74fa45cb65203b59$require$extend = $7I8Uw.extend;

var $7KuSv = parcelRequire("7KuSv");
var $f4d41dfe58d276dc$exports = {};
/**
 * DevExtreme (ui/collection/ui.collection_widget.edit.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $f4d41dfe58d276dc$var$_renderer2 = $f4d41dfe58d276dc$var$_interopRequireDefault($jFnCG);

var $e1LMc = parcelRequire("e1LMc");
var $f4d41dfe58d276dc$var$_events_engine2 = $f4d41dfe58d276dc$var$_interopRequireDefault($e1LMc);
var $84003155288ca038$exports = {};
/**
 * DevExtreme (ui/collection/ui.collection_widget.base.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $84003155288ca038$var$_renderer2 = $84003155288ca038$var$_interopRequireDefault($jFnCG);

var $e1LMc = parcelRequire("e1LMc");
var $84003155288ca038$var$_events_engine2 = $84003155288ca038$var$_interopRequireDefault($e1LMc);

var $2Mto0 = parcelRequire("2Mto0");
var $84003155288ca038$var$_common2 = $84003155288ca038$var$_interopRequireDefault($2Mto0);

var $5OzEX = parcelRequire("5OzEX");

var $445Bz = parcelRequire("445Bz");
var $84003155288ca038$var$_dom_adapter2 = $84003155288ca038$var$_interopRequireDefault($445Bz);

var $kDRxH = parcelRequire("kDRxH");

var $2F60d = parcelRequire("2F60d");

var $7I8Uw = parcelRequire("7I8Uw");

var $aLQK5 = parcelRequire("aLQK5");

var $4Pwuy = parcelRequire("4Pwuy");
var $84003155288ca038$var$_iterator2 = $84003155288ca038$var$_interopRequireDefault($4Pwuy);

var $jL4UV = parcelRequire("jL4UV");
var $84003155288ca038$var$_action2 = $84003155288ca038$var$_interopRequireDefault($jL4UV);

var $duKPB = parcelRequire("duKPB");
var $84003155288ca038$var$_guid2 = $84003155288ca038$var$_interopRequireDefault($duKPB);

var $4gmvS = parcelRequire("4gmvS");
var $84003155288ca038$var$_ui2 = $84003155288ca038$var$_interopRequireDefault($4gmvS);

var $bXb2w = parcelRequire("bXb2w");
var $84003155288ca038$var$_utils2 = $84003155288ca038$var$_interopRequireDefault($bXb2w);

var $gP4Gh = parcelRequire("gP4Gh");
var $84003155288ca038$var$_pointer2 = $84003155288ca038$var$_interopRequireDefault($gP4Gh);
var $17b240b889a91c20$exports = {};
/**
 * DevExtreme (data_helper.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
/**
 * DevExtreme (data/data_source/data_source.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $45e3ac8fbec1786a$export$accd73d198d77d2f;
var $45e3ac8fbec1786a$export$b542b8cb4d19a8a8;
var $45e3ac8fbec1786a$export$39a9f23879314f2b;
"use strict";

var $k7aJb = parcelRequire("k7aJb");

var $7I8Uw = parcelRequire("7I8Uw");
var $45e3ac8fbec1786a$require$extend = $7I8Uw.extend;

var $2Mto0 = parcelRequire("2Mto0");

var $4Pwuy = parcelRequire("4Pwuy");
var $3695ac098f7ec859$exports = {};
/**
 * DevExtreme (core/utils/ajax.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $2F60d = parcelRequire("2F60d");
var $3695ac098f7ec859$require$Deferred = $2F60d.Deferred;

var $445Bz = parcelRequire("445Bz");
var $42ff0fb102b1a628$exports = {};
/**
 * DevExtreme (core/http_request.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $irv64 = parcelRequire("irv64");
var $42ff0fb102b1a628$var$window = $irv64.getWindow();

var $6LNcw = parcelRequire("6LNcw");
var $42ff0fb102b1a628$var$nativeXMLHttpRequest = {
    getXhr: function() {
        return new $42ff0fb102b1a628$var$window.XMLHttpRequest;
    }
};
$42ff0fb102b1a628$exports = $6LNcw($42ff0fb102b1a628$var$nativeXMLHttpRequest);



var $irv64 = parcelRequire("irv64");
var $3695ac098f7ec859$var$window = $irv64.getWindow();

var $7I8Uw = parcelRequire("7I8Uw");
var $3695ac098f7ec859$require$extendFromObject = $7I8Uw.extendFromObject;

var $kDRxH = parcelRequire("kDRxH");
var $3695ac098f7ec859$require$isDefined = $kDRxH.isDefined;

var $1jnPB = parcelRequire("1jnPB");

var $6LNcw = parcelRequire("6LNcw");
var $3695ac098f7ec859$var$SUCCESS = "success";
var $3695ac098f7ec859$var$ERROR = "error";
var $3695ac098f7ec859$var$TIMEOUT = "timeout";
var $3695ac098f7ec859$var$NO_CONTENT = "nocontent";
var $3695ac098f7ec859$var$PARSER_ERROR = "parsererror";
var $3695ac098f7ec859$var$isStatusSuccess = function(status) {
    return 200 <= status && status < 300;
};
var $3695ac098f7ec859$var$hasContent = function(status) {
    return 204 !== status;
};
var $3695ac098f7ec859$var$paramsConvert = function(params) {
    var result = [];
    for(var name in params){
        var value = params[name];
        if (void 0 === value) continue;
        if (null === value) value = "";
        result.push(encodeURIComponent(name) + "=" + encodeURIComponent(value));
    }
    return result.join("&");
};
var $3695ac098f7ec859$var$createScript = function(options) {
    var script = $445Bz.createElement("script");
    for(var name in options)script[name] = options[name];
    return script;
};
var $3695ac098f7ec859$var$removeScript = function(scriptNode) {
    scriptNode.parentNode.removeChild(scriptNode);
};
var $3695ac098f7ec859$var$appendToHead = function(element) {
    return $445Bz.getHead().appendChild(element);
};
var $3695ac098f7ec859$var$evalScript = function(code) {
    var script = $3695ac098f7ec859$var$createScript({
        text: code
    });
    $3695ac098f7ec859$var$appendToHead(script);
    $3695ac098f7ec859$var$removeScript(script);
};
var $3695ac098f7ec859$var$evalCrossDomainScript = function(url) {
    var script = $3695ac098f7ec859$var$createScript({
        src: url
    });
    return new $1jnPB(function(resolve, reject) {
        var events = {
            load: resolve,
            error: reject
        };
        var loadHandler = function(e) {
            events[e.type]();
            $3695ac098f7ec859$var$removeScript(script);
        };
        for(var event in events)$445Bz.listen(script, event, loadHandler);
        $3695ac098f7ec859$var$appendToHead(script);
    });
};
var $3695ac098f7ec859$var$getAcceptHeader = function(options) {
    var dataType = options.dataType || "*";
    var scriptAccept = "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript";
    var accepts = {
        "*": "*/*",
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript",
        jsonp: scriptAccept,
        script: scriptAccept
    };
    $3695ac098f7ec859$require$extendFromObject(accepts, options.accepts, true);
    return accepts[dataType] ? accepts[dataType] + ("*" !== dataType ? ", */*; q=0.01" : "") : accepts["*"];
};
var $3695ac098f7ec859$var$getContentTypeHeader = function(options) {
    var defaultContentType;
    if (options.data && !options.upload && "GET" !== $3695ac098f7ec859$var$getMethod(options)) defaultContentType = "application/x-www-form-urlencoded;charset=utf-8";
    return options.contentType || defaultContentType;
};
var $3695ac098f7ec859$var$getDataFromResponse = function(xhr) {
    return xhr.responseType && "text" !== xhr.responseType || "string" !== typeof xhr.responseText ? xhr.response : xhr.responseText;
};
var $3695ac098f7ec859$var$postProcess = function(deferred, xhr, dataType) {
    var data = $3695ac098f7ec859$var$getDataFromResponse(xhr);
    switch(dataType){
        case "jsonp":
            $3695ac098f7ec859$var$evalScript(data);
            break;
        case "script":
            $3695ac098f7ec859$var$evalScript(data);
            deferred.resolve(data, $3695ac098f7ec859$var$SUCCESS, xhr);
            break;
        case "json":
            try {
                deferred.resolve(JSON.parse(data), $3695ac098f7ec859$var$SUCCESS, xhr);
            } catch (e) {
                deferred.reject(xhr, $3695ac098f7ec859$var$PARSER_ERROR, e);
            }
            break;
        default:
            deferred.resolve(data, $3695ac098f7ec859$var$SUCCESS, xhr);
    }
};
var $3695ac098f7ec859$var$isCrossDomain = function(url) {
    if (!$irv64.hasWindow()) return true;
    var crossDomain = false;
    var originAnchor = $445Bz.createElement("a");
    var urlAnchor = $445Bz.createElement("a");
    originAnchor.href = $3695ac098f7ec859$var$window.location.href;
    try {
        urlAnchor.href = url;
        urlAnchor.href = urlAnchor.href;
        crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
    } catch (e) {
        crossDomain = true;
    }
    return crossDomain;
};
var $3695ac098f7ec859$var$setHttpTimeout = function(timeout, xhr) {
    return timeout && setTimeout(function() {
        xhr.customStatus = $3695ac098f7ec859$var$TIMEOUT;
        xhr.abort();
    }, timeout);
};
var $3695ac098f7ec859$var$getJsonpOptions = function(options) {
    if ("jsonp" === options.dataType) {
        var random = Math.random().toString().replace(/\D/g, "");
        var callbackName = options.jsonpCallback || "dxCallback" + Date.now() + "_" + random;
        var callbackParameter = options.jsonp || "callback";
        options.data = options.data || {};
        options.data[callbackParameter] = callbackName;
        return callbackName;
    }
};
var $3695ac098f7ec859$var$getRequestOptions = function(options, headers) {
    var params = options.data;
    var paramsAlreadyString = "string" === typeof params;
    var url = options.url || $3695ac098f7ec859$var$window.location.href;
    if (!paramsAlreadyString && !options.cache) {
        params = params || {};
        params._ = Date.now();
    }
    if (params && !options.upload) {
        if (!paramsAlreadyString) params = $3695ac098f7ec859$var$paramsConvert(params);
        if ("GET" === $3695ac098f7ec859$var$getMethod(options)) {
            if ("" !== params) url += (url.indexOf("?") > -1 ? "&" : "?") + params;
            params = null;
        } else if (headers["Content-Type"] && headers["Content-Type"].indexOf("application/x-www-form-urlencoded") > -1) params = params.replace(/%20/g, "+");
    }
    return {
        url: url,
        parameters: params
    };
};
var $3695ac098f7ec859$var$getMethod = function(options) {
    return (options.method || "GET").toUpperCase();
};
var $3695ac098f7ec859$var$getRequestHeaders = function(options) {
    var headers = options.headers || {};
    headers["Content-Type"] = headers["Content-Type"] || $3695ac098f7ec859$var$getContentTypeHeader(options);
    headers.Accept = headers.Accept || $3695ac098f7ec859$var$getAcceptHeader(options);
    if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
    return headers;
};
var $3695ac098f7ec859$var$sendRequest = function(options) {
    var xhr = $42ff0fb102b1a628$exports.getXhr();
    var d = new $3695ac098f7ec859$require$Deferred;
    var result = d.promise();
    var async = $3695ac098f7ec859$require$isDefined(options.async) ? options.async : true;
    var dataType = options.dataType;
    var timeout = options.timeout || 0;
    var timeoutId;
    options.crossDomain = $3695ac098f7ec859$var$isCrossDomain(options.url);
    var needScriptEvaluation = "jsonp" === dataType || "script" === dataType;
    if (void 0 === options.cache) options.cache = !needScriptEvaluation;
    var callbackName = $3695ac098f7ec859$var$getJsonpOptions(options);
    var headers = $3695ac098f7ec859$var$getRequestHeaders(options);
    var requestOptions = $3695ac098f7ec859$var$getRequestOptions(options, headers);
    var url = requestOptions.url;
    var parameters = requestOptions.parameters;
    if (callbackName) $3695ac098f7ec859$var$window[callbackName] = function(data) {
        d.resolve(data, $3695ac098f7ec859$var$SUCCESS, xhr);
    };
    if (options.crossDomain && needScriptEvaluation) {
        var reject = function() {
            d.reject(xhr, $3695ac098f7ec859$var$ERROR);
        };
        var resolve = function() {
            if ("jsonp" === dataType) return;
            d.resolve(null, $3695ac098f7ec859$var$SUCCESS, xhr);
        };
        $3695ac098f7ec859$var$evalCrossDomainScript(url).then(resolve, reject);
        return result;
    }
    if (options.crossDomain && !("withCredentials" in xhr)) {
        d.reject(xhr, $3695ac098f7ec859$var$ERROR);
        return result;
    }
    xhr.open($3695ac098f7ec859$var$getMethod(options), url, async, options.username, options.password);
    if (async) {
        xhr.timeout = timeout;
        timeoutId = $3695ac098f7ec859$var$setHttpTimeout(timeout, xhr, d);
    }
    xhr.onreadystatechange = function(e) {
        if (4 === xhr.readyState) {
            clearTimeout(timeoutId);
            if ($3695ac098f7ec859$var$isStatusSuccess(xhr.status)) {
                if ($3695ac098f7ec859$var$hasContent(xhr.status)) $3695ac098f7ec859$var$postProcess(d, xhr, dataType);
                else d.resolve(null, $3695ac098f7ec859$var$NO_CONTENT, xhr);
            } else d.reject(xhr, xhr.customStatus || $3695ac098f7ec859$var$ERROR);
        }
    };
    if (options.upload) {
        xhr.upload.onprogress = options.upload.onprogress;
        xhr.upload.onloadstart = options.upload.onloadstart;
        xhr.upload.onabort = options.upload.onabort;
    }
    if (options.xhrFields) for(var field in options.xhrFields)xhr[field] = options.xhrFields[field];
    if ("arraybuffer" === options.responseType) xhr.responseType = options.responseType;
    for(var name in headers)if (Object.prototype.hasOwnProperty.call(headers, name) && $3695ac098f7ec859$require$isDefined(headers[name])) xhr.setRequestHeader(name, headers[name]);
    if (options.beforeSend) options.beforeSend(xhr);
    xhr.send(parameters);
    result.abort = function() {
        xhr.abort();
    };
    return result;
};
$3695ac098f7ec859$exports = $6LNcw({
    sendRequest: $3695ac098f7ec859$var$sendRequest
});



var $kDRxH = parcelRequire("kDRxH");
var $94b9773d9b4e83fd$exports = {};
/**
 * DevExtreme (data/utils.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $kDRxH = parcelRequire("kDRxH");
var $94b9773d9b4e83fd$var$_type2 = $94b9773d9b4e83fd$var$_interopRequireDefault($kDRxH);

var $445Bz = parcelRequire("445Bz");
var $94b9773d9b4e83fd$var$_dom_adapter2 = $94b9773d9b4e83fd$var$_interopRequireDefault($445Bz);

var $g4e4U = parcelRequire("g4e4U");

var $irv64 = parcelRequire("irv64");

var $4Pwuy = parcelRequire("4Pwuy");

var $2F60d = parcelRequire("2F60d");

var $2Mto0 = parcelRequire("2Mto0");
function $94b9773d9b4e83fd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $94b9773d9b4e83fd$var$_toConsumableArray(arr) {
    return $94b9773d9b4e83fd$var$_arrayWithoutHoles(arr) || $94b9773d9b4e83fd$var$_iterableToArray(arr) || $94b9773d9b4e83fd$var$_unsupportedIterableToArray(arr) || $94b9773d9b4e83fd$var$_nonIterableSpread();
}
function $94b9773d9b4e83fd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $94b9773d9b4e83fd$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if ("string" === typeof o) return $94b9773d9b4e83fd$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if ("Object" === n && o.constructor) n = o.constructor.name;
    if ("Map" === n || "Set" === n) return Array.from(o);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $94b9773d9b4e83fd$var$_arrayLikeToArray(o, minLen);
}
function $94b9773d9b4e83fd$var$_iterableToArray(iter) {
    if ("undefined" !== typeof Symbol && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $94b9773d9b4e83fd$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $94b9773d9b4e83fd$var$_arrayLikeToArray(arr);
}
function $94b9773d9b4e83fd$var$_arrayLikeToArray(arr, len) {
    if (null == len || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $94b9773d9b4e83fd$var$XHR_ERROR_UNLOAD = "DEVEXTREME_XHR_ERROR_UNLOAD";
var $94b9773d9b4e83fd$var$normalizeBinaryCriterion = function(crit) {
    return [
        crit[0],
        crit.length < 3 ? "=" : String(crit[1]).toLowerCase(),
        crit.length < 2 ? true : crit[crit.length - 1]
    ];
};
var $94b9773d9b4e83fd$var$normalizeSortingInfo = function(info) {
    if (!Array.isArray(info)) info = [
        info
    ];
    return (0, $4Pwuy.map)(info, function(i) {
        var result = {
            selector: (0, $kDRxH.isFunction)(i) || "string" === typeof i ? i : i.getter || i.field || i.selector,
            desc: !!(i.desc || "d" === String(i.dir).charAt(0).toLowerCase())
        };
        if (i.compare) result.compare = i.compare;
        return result;
    });
};
var $94b9773d9b4e83fd$var$errorMessageFromXhr = function() {
    var textStatusMessages = {
        timeout: "Network connection timeout",
        error: "Unspecified network error",
        parsererror: "Unexpected server response"
    };
    var explainTextStatus = function(textStatus) {
        var result = textStatusMessages[textStatus];
        if (!result) return textStatus;
        return result;
    };
    var unloading;
    (0, $g4e4U.add)(function() {
        var window = (0, $irv64.getWindow)();
        $94b9773d9b4e83fd$var$_dom_adapter2.default.listen(window, "beforeunload", function() {
            unloading = true;
        });
    });
    return function(xhr, textStatus) {
        if (unloading) return $94b9773d9b4e83fd$var$XHR_ERROR_UNLOAD;
        if (xhr.status < 400) return explainTextStatus(textStatus);
        return xhr.statusText;
    };
}();
var $94b9773d9b4e83fd$var$aggregators = {
    count: {
        seed: 0,
        step: function(count) {
            return 1 + count;
        }
    },
    sum: {
        seed: 0,
        step: function(sum, item) {
            return sum + item;
        }
    },
    min: {
        step: function(min, item) {
            return item < min ? item : min;
        }
    },
    max: {
        step: function(max, item) {
            return item > max ? item : max;
        }
    },
    avg: {
        seed: [
            0,
            0
        ],
        step: function(pair, value) {
            return [
                pair[0] + value,
                pair[1] + 1
            ];
        },
        finalize: function(pair) {
            return pair[1] ? pair[0] / pair[1] : NaN;
        }
    }
};
var $94b9773d9b4e83fd$var$processRequestResultLock = function() {
    var lockCount = 0;
    var lockDeferred;
    var obtain = function() {
        if (0 === lockCount) lockDeferred = new $2F60d.Deferred;
        lockCount++;
    };
    var release = function() {
        lockCount--;
        if (lockCount < 1) lockDeferred.resolve();
    };
    var promise = function() {
        var deferred = 0 === lockCount ? (new $2F60d.Deferred).resolve() : lockDeferred;
        return deferred.promise();
    };
    var reset = function() {
        lockCount = 0;
        if (lockDeferred) lockDeferred.resolve();
    };
    return {
        obtain: obtain,
        release: release,
        promise: promise,
        reset: reset
    };
}();
function $94b9773d9b4e83fd$var$isDisjunctiveOperator(condition) {
    return /^(or|\|\||\|)$/i.test(condition);
}
function $94b9773d9b4e83fd$var$isConjunctiveOperator(condition) {
    return /^(and|&&|&)$/i.test(condition);
}
var $94b9773d9b4e83fd$var$keysEqual = function(key1, key2) {
    return (0, $2Mto0.equalByValue)(key1, key2, 0, false);
};
var $94b9773d9b4e83fd$var$BASE64_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
var $94b9773d9b4e83fd$var$base64_encode = function(input) {
    if (!Array.isArray(input)) input = $94b9773d9b4e83fd$var$stringToByteArray(String(input));
    var result = "";
    function getBase64Char(index) {
        return $94b9773d9b4e83fd$var$BASE64_CHARS.charAt(index);
    }
    for(var i = 0; i < input.length; i += 3){
        var octet1 = input[i];
        var octet2 = input[i + 1];
        var octet3 = input[i + 2];
        result += (0, $4Pwuy.map)([
            octet1 >> 2,
            (3 & octet1) << 4 | octet2 >> 4,
            isNaN(octet2) ? 64 : (15 & octet2) << 2 | octet3 >> 6,
            isNaN(octet3) ? 64 : 63 & octet3
        ], getBase64Char).join("");
    }
    return result;
};
var $94b9773d9b4e83fd$var$stringToByteArray = function(str) {
    var bytes = [];
    var code;
    var i;
    for(i = 0; i < str.length; i++){
        code = str.charCodeAt(i);
        if (code < 128) bytes.push(code);
        else if (code < 2048) bytes.push(192 + (code >> 6), 128 + (63 & code));
        else {
            if (code < 65536) bytes.push(224 + (code >> 12), 128 + (code >> 6 & 63), 128 + (63 & code));
            else if (code < 2097152) bytes.push(240 + (code >> 18), 128 + (code >> 12 & 63), 128 + (code >> 6 & 63), 128 + (63 & code));
        }
    }
    return bytes;
};
var $94b9773d9b4e83fd$var$isUnaryOperation = function(crit) {
    return "!" === crit[0] && Array.isArray(crit[1]);
};
var $94b9773d9b4e83fd$var$isGroupOperator = function(value) {
    return "and" === value || "or" === value;
};
var $94b9773d9b4e83fd$var$isGroupCriterion = function(crit) {
    var first = crit[0];
    var second = crit[1];
    if (Array.isArray(first)) return true;
    if ($94b9773d9b4e83fd$var$_type2.default.isFunction(first)) {
        if (Array.isArray(second) || $94b9773d9b4e83fd$var$_type2.default.isFunction(second) || $94b9773d9b4e83fd$var$isGroupOperator(second)) return true;
    }
    return false;
};
var $94b9773d9b4e83fd$var$trivialPromise = function() {
    var d = new $2F60d.Deferred;
    return d.resolve.apply(d, arguments).promise();
};
var $94b9773d9b4e83fd$var$rejectedPromise = function() {
    var d = new $2F60d.Deferred;
    return d.reject.apply(d, arguments).promise();
};
function $94b9773d9b4e83fd$var$throttle(func, timeout) {
    var timeoutId;
    var lastArgs;
    return function() {
        var _this = this;
        lastArgs = arguments;
        if (!timeoutId) timeoutId = setTimeout(function() {
            timeoutId = void 0;
            if (lastArgs) func.call(_this, lastArgs);
        }, (0, $kDRxH.isFunction)(timeout) ? timeout() : timeout);
        return timeoutId;
    };
}
function $94b9773d9b4e83fd$var$throttleChanges(func, timeout) {
    var cache = [];
    var throttled = $94b9773d9b4e83fd$var$throttle(function() {
        func.call(this, cache);
        cache = [];
    }, timeout);
    return function(changes) {
        if (Array.isArray(changes)) {
            var _cache;
            (_cache = cache).push.apply(_cache, $94b9773d9b4e83fd$var$_toConsumableArray(changes));
        }
        return throttled.call(this, cache);
    };
}
var $94b9773d9b4e83fd$var$utils = {
    XHR_ERROR_UNLOAD: $94b9773d9b4e83fd$var$XHR_ERROR_UNLOAD,
    normalizeBinaryCriterion: $94b9773d9b4e83fd$var$normalizeBinaryCriterion,
    normalizeSortingInfo: $94b9773d9b4e83fd$var$normalizeSortingInfo,
    errorMessageFromXhr: $94b9773d9b4e83fd$var$errorMessageFromXhr,
    aggregators: $94b9773d9b4e83fd$var$aggregators,
    keysEqual: $94b9773d9b4e83fd$var$keysEqual,
    throttleChanges: $94b9773d9b4e83fd$var$throttleChanges,
    trivialPromise: $94b9773d9b4e83fd$var$trivialPromise,
    rejectedPromise: $94b9773d9b4e83fd$var$rejectedPromise,
    isDisjunctiveOperator: $94b9773d9b4e83fd$var$isDisjunctiveOperator,
    isConjunctiveOperator: $94b9773d9b4e83fd$var$isConjunctiveOperator,
    processRequestResultLock: $94b9773d9b4e83fd$var$processRequestResultLock,
    isUnaryOperation: $94b9773d9b4e83fd$var$isUnaryOperation,
    isGroupCriterion: $94b9773d9b4e83fd$var$isGroupCriterion,
    base64_encode: $94b9773d9b4e83fd$var$base64_encode
};
$94b9773d9b4e83fd$exports = $94b9773d9b4e83fd$var$utils;


var $852ad2a58fe2bfbc$exports = {};

$parcel$export($852ad2a58fe2bfbc$exports, "applyBatch", () => $852ad2a58fe2bfbc$export$65d4799c35eb3744, (v) => $852ad2a58fe2bfbc$export$65d4799c35eb3744 = v);
$parcel$export($852ad2a58fe2bfbc$exports, "update", () => $852ad2a58fe2bfbc$export$722fbec263ad908a, (v) => $852ad2a58fe2bfbc$export$722fbec263ad908a = v);
$parcel$export($852ad2a58fe2bfbc$exports, "insert", () => $852ad2a58fe2bfbc$export$21a5ca8aa77d35ff, (v) => $852ad2a58fe2bfbc$export$21a5ca8aa77d35ff = v);
$parcel$export($852ad2a58fe2bfbc$exports, "remove", () => $852ad2a58fe2bfbc$export$cd7f480d6b8286c3, (v) => $852ad2a58fe2bfbc$export$cd7f480d6b8286c3 = v);
$parcel$export($852ad2a58fe2bfbc$exports, "indexByKey", () => $852ad2a58fe2bfbc$export$ec9c86cc7ac0ca60, (v) => $852ad2a58fe2bfbc$export$ec9c86cc7ac0ca60 = v);
/**
 * DevExtreme (data/array_utils.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $852ad2a58fe2bfbc$export$65d4799c35eb3744;
var $852ad2a58fe2bfbc$export$722fbec263ad908a;
var $852ad2a58fe2bfbc$export$21a5ca8aa77d35ff;
var $852ad2a58fe2bfbc$export$cd7f480d6b8286c3;
var $852ad2a58fe2bfbc$export$ec9c86cc7ac0ca60;
"use strict";

var $kDRxH = parcelRequire("kDRxH");

var $1JvXr = parcelRequire("1JvXr");
var $852ad2a58fe2bfbc$var$_config2 = $852ad2a58fe2bfbc$var$_interopRequireDefault($1JvXr);

var $duKPB = parcelRequire("duKPB");
var $852ad2a58fe2bfbc$var$_guid2 = $852ad2a58fe2bfbc$var$_interopRequireDefault($duKPB);

var $7I8Uw = parcelRequire("7I8Uw");
var $eae26cef6f9ed6fd$exports = {};
/**
 * DevExtreme (data/errors.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $iwn67 = parcelRequire("iwn67");

var $7sX7V = parcelRequire("7sX7V");
var $eae26cef6f9ed6fd$var$handlers = {};
var $eae26cef6f9ed6fd$var$errors = $iwn67($7sX7V.ERROR_MESSAGES, {
    E4000: "[DevExpress.data]: {0}",
    E4001: "Unknown aggregating function is detected: '{0}'",
    E4002: "Unsupported OData protocol version is used",
    E4003: "Unknown filter operation is used: {0}",
    E4004: "The thenby() method is called before the sortby() method",
    E4005: "Store requires a key expression for this operation",
    E4006: "ArrayStore 'data' option must be an array",
    E4007: "Compound keys cannot be auto-generated",
    E4008: "Attempt to insert an item with the a duplicated key",
    E4009: "Data item cannot be found",
    E4010: "CustomStore does not support creating queries",
    E4011: "Custom Store method is not implemented or is not a function: {0}",
    E4012: "Custom Store method returns an invalid value: {0}",
    E4013: "Local Store requires the 'name' configuration option is specified",
    E4014: "Unknown data type is specified for ODataStore: {0}",
    E4015: "Unknown entity name or alias is used: {0}",
    E4016: "The compileSetter(expr) method is called with 'self' passed as a parameter",
    E4017: "Keys cannot be modified",
    E4018: "The server has returned a non-numeric value in a response to an item count request",
    E4019: "Mixing of group operators inside a single group of filter expression is not allowed",
    E4020: "Unknown store type is detected: {0}",
    E4021: "The server response does not provide the totalCount value",
    E4022: "The server response does not provide the groupCount value",
    E4023: "Could not parse the following XML: {0}",
    E4024: "String function {0} cannot be used with the data field {1} of type {2}.",
    W4000: "Data returned from the server has an incorrect structure",
    W4001: 'The {0} field is listed in both "keyType" and "fieldTypes". The value of "fieldTypes" is used.',
    W4002: "Data loading has failed for some cells due to the following error: {0}"
});
function $eae26cef6f9ed6fd$var$handleError(error) {
    var id = "E4000";
    if (error && "__id" in error) id = error.__id;
    $eae26cef6f9ed6fd$var$errors.log(id, error);
}
var $eae26cef6f9ed6fd$var$errorHandler = null;
var $eae26cef6f9ed6fd$var$_errorHandler = function(error) {
    if ($eae26cef6f9ed6fd$var$handlers.errorHandler) $eae26cef6f9ed6fd$var$handlers.errorHandler(error);
};
$eae26cef6f9ed6fd$var$handlers = {
    errors: $eae26cef6f9ed6fd$var$errors,
    errorHandler: $eae26cef6f9ed6fd$var$errorHandler,
    _errorHandler: $eae26cef6f9ed6fd$var$_errorHandler
};
$eae26cef6f9ed6fd$exports = $eae26cef6f9ed6fd$var$handlers;



var $6l2Qk = parcelRequire("6l2Qk");
var $852ad2a58fe2bfbc$var$_object2 = $852ad2a58fe2bfbc$var$_interopRequireDefault($6l2Qk);

function $852ad2a58fe2bfbc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $852ad2a58fe2bfbc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $852ad2a58fe2bfbc$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $852ad2a58fe2bfbc$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $852ad2a58fe2bfbc$var$_typeof(obj);
}
function $852ad2a58fe2bfbc$var$hasKey(target, keyOrKeys) {
    var keys = "string" === typeof keyOrKeys ? keyOrKeys.split() : keyOrKeys.slice();
    while(keys.length){
        var key = keys.shift();
        if (key in target) return true;
    }
    return false;
}
function $852ad2a58fe2bfbc$var$findItems(keyInfo, items, key, groupCount) {
    if (groupCount) for(var i = 0; i < items.length; i++){
        var childItems = items[i].items || items[i].collapsedItems || [];
        var result = $852ad2a58fe2bfbc$var$findItems(keyInfo, childItems || [], key, groupCount - 1);
        if (result) return result;
    }
    else {
        if ($852ad2a58fe2bfbc$var$indexByKey(keyInfo, items, key) >= 0) return items;
    }
}
function $852ad2a58fe2bfbc$var$getItems(keyInfo, items, key, groupCount) {
    if (groupCount) return $852ad2a58fe2bfbc$var$findItems(keyInfo, items, key, groupCount) || [];
    return items;
}
function $852ad2a58fe2bfbc$var$generateDataByKeyMap(keyInfo, array) {
    if (keyInfo.key() && (!array._dataByKeyMap || array._dataByKeyMapLength !== array.length)) {
        var dataByKeyMap = {};
        for(var i = 0, arrayLength = array.length; i < arrayLength; i++)dataByKeyMap[JSON.stringify(keyInfo.keyOf(array[i]))] = array[i];
        array._dataByKeyMap = dataByKeyMap;
        array._dataByKeyMapLength = arrayLength;
    }
}
function $852ad2a58fe2bfbc$var$getCacheValue(array, key) {
    if (array._dataByKeyMap) return array._dataByKeyMap[JSON.stringify(key)];
}
function $852ad2a58fe2bfbc$var$getHasKeyCacheValue(array, key) {
    if (array._dataByKeyMap) return array._dataByKeyMap[JSON.stringify(key)];
    return true;
}
function $852ad2a58fe2bfbc$var$setDataByKeyMapValue(array, key, data) {
    if (array._dataByKeyMap) array._dataByKeyMap[JSON.stringify(key)] = data;
}
function $852ad2a58fe2bfbc$var$applyBatch(keyInfo, array, batchData, groupCount, useInsertIndex) {
    batchData.forEach(function(item) {
        var items = "insert" === item.type ? array : $852ad2a58fe2bfbc$var$getItems(keyInfo, array, item.key, groupCount);
        $852ad2a58fe2bfbc$var$generateDataByKeyMap(keyInfo, items);
        switch(item.type){
            case "update":
                $852ad2a58fe2bfbc$var$update(keyInfo, items, item.key, item.data, true);
                break;
            case "insert":
                $852ad2a58fe2bfbc$var$insert(keyInfo, items, item.data, useInsertIndex && (0, $kDRxH.isDefined)(item.index) ? item.index : -1, true);
                break;
            case "remove":
                $852ad2a58fe2bfbc$var$remove(keyInfo, items, item.key, true);
        }
    });
}
function $852ad2a58fe2bfbc$var$update(keyInfo, array, key, data, isBatch) {
    var target;
    var extendComplexObject = true;
    var keyExpr = keyInfo.key();
    if (keyExpr) {
        if ($852ad2a58fe2bfbc$var$hasKey(data, keyExpr) && !(0, $94b9773d9b4e83fd$exports.keysEqual)(key, keyInfo.keyOf(data))) return !isBatch && (0, $94b9773d9b4e83fd$exports.rejectedPromise)($eae26cef6f9ed6fd$exports.errors.Error("E4017"));
        target = $852ad2a58fe2bfbc$var$getCacheValue(array, key);
        if (!target) {
            var index = $852ad2a58fe2bfbc$var$indexByKey(keyInfo, array, key);
            if (index < 0) return !isBatch && (0, $94b9773d9b4e83fd$exports.rejectedPromise)($eae26cef6f9ed6fd$exports.errors.Error("E4009"));
            target = array[index];
        }
    } else target = key;
    $852ad2a58fe2bfbc$var$_object2.default.deepExtendArraySafe(target, data, extendComplexObject);
    if (!isBatch) {
        if ((0, $852ad2a58fe2bfbc$var$_config2.default)().useLegacyStoreResult) return (0, $94b9773d9b4e83fd$exports.trivialPromise)(key, data);
        else return (0, $94b9773d9b4e83fd$exports.trivialPromise)(target, key);
    }
}
function $852ad2a58fe2bfbc$var$insert(keyInfo, array, data, index, isBatch) {
    var keyValue;
    var keyExpr = keyInfo.key();
    var obj = (0, $kDRxH.isPlainObject)(data) ? (0, $7I8Uw.extend)({}, data) : data;
    if (keyExpr) {
        keyValue = keyInfo.keyOf(obj);
        if (void 0 === keyValue || "object" === $852ad2a58fe2bfbc$var$_typeof(keyValue) && (0, $kDRxH.isEmptyObject)(keyValue)) {
            if (Array.isArray(keyExpr)) throw $eae26cef6f9ed6fd$exports.errors.Error("E4007");
            keyValue = obj[keyExpr] = String(new $852ad2a58fe2bfbc$var$_guid2.default);
        } else {
            if (void 0 !== array[$852ad2a58fe2bfbc$var$indexByKey(keyInfo, array, keyValue)]) return !isBatch && (0, $94b9773d9b4e83fd$exports.rejectedPromise)($eae26cef6f9ed6fd$exports.errors.Error("E4008"));
        }
    } else keyValue = obj;
    if (index >= 0) array.splice(index, 0, obj);
    else array.push(obj);
    $852ad2a58fe2bfbc$var$setDataByKeyMapValue(array, keyValue, obj);
    if (!isBatch) return (0, $94b9773d9b4e83fd$exports.trivialPromise)((0, $852ad2a58fe2bfbc$var$_config2.default)().useLegacyStoreResult ? data : obj, keyValue);
}
function $852ad2a58fe2bfbc$var$remove(keyInfo, array, key, isBatch) {
    var index = $852ad2a58fe2bfbc$var$indexByKey(keyInfo, array, key);
    if (index > -1) array.splice(index, 1);
    if (!isBatch) return (0, $94b9773d9b4e83fd$exports.trivialPromise)(key);
}
function $852ad2a58fe2bfbc$var$indexByKey(keyInfo, array, key) {
    if (!$852ad2a58fe2bfbc$var$getHasKeyCacheValue(array, key)) return -1;
    for(var i = 0, arrayLength = array.length; i < arrayLength; i++){
        if ((0, $94b9773d9b4e83fd$exports.keysEqual)(keyInfo.keyOf(array[i]), key)) return i;
    }
    return -1;
}
$852ad2a58fe2bfbc$export$65d4799c35eb3744 = $852ad2a58fe2bfbc$var$applyBatch;
$852ad2a58fe2bfbc$export$722fbec263ad908a = $852ad2a58fe2bfbc$var$update;
$852ad2a58fe2bfbc$export$21a5ca8aa77d35ff = $852ad2a58fe2bfbc$var$insert;
$852ad2a58fe2bfbc$export$cd7f480d6b8286c3 = $852ad2a58fe2bfbc$var$remove;
$852ad2a58fe2bfbc$export$ec9c86cc7ac0ca60 = $852ad2a58fe2bfbc$var$indexByKey;


var $e14cc89de3dff21c$exports = {};
/**
 * DevExtreme (data/abstract_store.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $k7aJb = parcelRequire("k7aJb");
var $e14cc89de3dff21c$var$abstract = $k7aJb.abstract;

var $cWRya = parcelRequire("cWRya");

var $4Pwuy = parcelRequire("4Pwuy");
var $e14cc89de3dff21c$require$each = $4Pwuy.each;



var $kpjzB = parcelRequire("kpjzB");
var $e14cc89de3dff21c$require$compileGetter = $kpjzB.compileGetter;
var $04f941f354dbda7d$exports = {};
/**
 * DevExtreme (data/store_helper.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $2Mto0 = parcelRequire("2Mto0");
var $04f941f354dbda7d$require$grep = $2Mto0.grep;

var $7I8Uw = parcelRequire("7I8Uw");
var $04f941f354dbda7d$require$extend = $7I8Uw.extend;

var $4Pwuy = parcelRequire("4Pwuy");
var $04f941f354dbda7d$require$each = $4Pwuy.each;
var $2cfb1f60ebaf5f65$exports = {};
/**
 * DevExtreme (data/array_query.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $k7aJb = parcelRequire("k7aJb");

var $kDRxH = parcelRequire("kDRxH");

var $4Pwuy = parcelRequire("4Pwuy");

var $kpjzB = parcelRequire("kpjzB");
var $2cfb1f60ebaf5f65$require$compileGetter = $kpjzB.compileGetter;

var $kpjzB = parcelRequire("kpjzB");
var $2cfb1f60ebaf5f65$require$toComparable = $kpjzB.toComparable;

var $2F60d = parcelRequire("2F60d");
var $2cfb1f60ebaf5f65$require$Deferred = $2F60d.Deferred;


var $2cfb1f60ebaf5f65$var$Iterator = $k7aJb.inherit({
    toArray: function() {
        var result = [];
        this.reset();
        while(this.next())result.push(this.current());
        return result;
    },
    countable: function() {
        return false;
    }
});
var $2cfb1f60ebaf5f65$var$ArrayIterator = $2cfb1f60ebaf5f65$var$Iterator.inherit({
    ctor: function(array) {
        this.array = array;
        this.index = -1;
    },
    next: function() {
        if (this.index + 1 < this.array.length) {
            this.index++;
            return true;
        }
        return false;
    },
    current: function() {
        return this.array[this.index];
    },
    reset: function() {
        this.index = -1;
    },
    toArray: function() {
        return this.array.slice(0);
    },
    countable: function() {
        return true;
    },
    count: function() {
        return this.array.length;
    }
});
var $2cfb1f60ebaf5f65$var$WrappedIterator = $2cfb1f60ebaf5f65$var$Iterator.inherit({
    ctor: function(iter) {
        this.iter = iter;
    },
    next: function() {
        return this.iter.next();
    },
    current: function() {
        return this.iter.current();
    },
    reset: function() {
        return this.iter.reset();
    }
});
var $2cfb1f60ebaf5f65$var$MapIterator = $2cfb1f60ebaf5f65$var$WrappedIterator.inherit({
    ctor: function(iter, mapper) {
        this.callBase(iter);
        this.index = -1;
        this.mapper = mapper;
    },
    current: function() {
        return this.mapper(this.callBase(), this.index);
    },
    next: function() {
        var hasNext = this.callBase();
        if (hasNext) this.index++;
        return hasNext;
    }
});
var $2cfb1f60ebaf5f65$var$defaultCompare = function(xValue, yValue) {
    xValue = $2cfb1f60ebaf5f65$require$toComparable(xValue);
    yValue = $2cfb1f60ebaf5f65$require$toComparable(yValue);
    if (null === xValue && null !== yValue) return -1;
    if (null !== xValue && null === yValue) return 1;
    if (void 0 === xValue && void 0 !== yValue) return 1;
    if (void 0 !== xValue && void 0 === yValue) return -1;
    if (xValue < yValue) return -1;
    if (xValue > yValue) return 1;
    return 0;
};
var $2cfb1f60ebaf5f65$var$SortIterator = $2cfb1f60ebaf5f65$var$Iterator.inherit({
    ctor: function(iter, getter, desc, compare) {
        if (!(iter instanceof $2cfb1f60ebaf5f65$var$MapIterator)) iter = new $2cfb1f60ebaf5f65$var$MapIterator(iter, this._wrap);
        this.iter = iter;
        this.rules = [
            {
                getter: getter,
                desc: desc,
                compare: compare
            }
        ];
    },
    thenBy: function(getter, desc, compare) {
        var result = new $2cfb1f60ebaf5f65$var$SortIterator(this.sortedIter || this.iter, getter, desc, compare);
        if (!this.sortedIter) result.rules = this.rules.concat(result.rules);
        return result;
    },
    next: function() {
        this._ensureSorted();
        return this.sortedIter.next();
    },
    current: function() {
        this._ensureSorted();
        return this.sortedIter.current();
    },
    reset: function() {
        delete this.sortedIter;
    },
    countable: function() {
        return this.sortedIter || this.iter.countable();
    },
    count: function() {
        if (this.sortedIter) return this.sortedIter.count();
        return this.iter.count();
    },
    _ensureSorted: function() {
        var that = this;
        if (that.sortedIter) return;
        $4Pwuy.each(that.rules, function() {
            this.getter = $2cfb1f60ebaf5f65$require$compileGetter(this.getter);
        });
        that.sortedIter = new $2cfb1f60ebaf5f65$var$MapIterator(new $2cfb1f60ebaf5f65$var$ArrayIterator(this.iter.toArray().sort(function(x, y) {
            return that._compare(x, y);
        })), that._unwrap);
    },
    _wrap: function(record, index) {
        return {
            index: index,
            value: record
        };
    },
    _unwrap: function(wrappedItem) {
        return wrappedItem.value;
    },
    _compare: function(x, y) {
        var xIndex = x.index;
        var yIndex = y.index;
        x = x.value;
        y = y.value;
        if (x === y) return xIndex - yIndex;
        for(var i = 0, rulesCount = this.rules.length; i < rulesCount; i++){
            var rule = this.rules[i];
            var xValue = rule.getter(x);
            var yValue = rule.getter(y);
            var compare = rule.compare || $2cfb1f60ebaf5f65$var$defaultCompare;
            var compareResult = compare(xValue, yValue);
            if (compareResult) return rule.desc ? -compareResult : compareResult;
        }
        return xIndex - yIndex;
    }
});
var $2cfb1f60ebaf5f65$var$compileCriteria = function() {
    var compileGroup = function(crit) {
        var ops = [];
        var isConjunctiveOperator = false;
        var isConjunctiveNextOperator = false;
        $4Pwuy.each(crit, function() {
            if (Array.isArray(this) || $kDRxH.isFunction(this)) {
                if (ops.length > 1 && isConjunctiveOperator !== isConjunctiveNextOperator) throw new $eae26cef6f9ed6fd$exports.errors.Error("E4019");
                ops.push($2cfb1f60ebaf5f65$var$compileCriteria(this));
                isConjunctiveOperator = isConjunctiveNextOperator;
                isConjunctiveNextOperator = true;
            } else isConjunctiveNextOperator = $94b9773d9b4e83fd$exports.isConjunctiveOperator(this);
        });
        return function(d) {
            var result = isConjunctiveOperator;
            for(var i = 0; i < ops.length; i++)if (ops[i](d) !== isConjunctiveOperator) {
                result = !isConjunctiveOperator;
                break;
            }
            return result;
        };
    };
    var toString = function(value) {
        return $kDRxH.isDefined(value) ? value.toString() : "";
    };
    var compileBinary = function(crit) {
        crit = $94b9773d9b4e83fd$exports.normalizeBinaryCriterion(crit);
        var getter = $2cfb1f60ebaf5f65$require$compileGetter(crit[0]);
        var op = crit[1];
        var value = crit[2];
        value = $2cfb1f60ebaf5f65$require$toComparable(value);
        switch(op.toLowerCase()){
            case "=":
                return compileEquals(getter, value);
            case "<>":
                return compileEquals(getter, value, true);
            case ">":
                return function(obj) {
                    return $2cfb1f60ebaf5f65$require$toComparable(getter(obj)) > value;
                };
            case "<":
                return function(obj) {
                    return $2cfb1f60ebaf5f65$require$toComparable(getter(obj)) < value;
                };
            case ">=":
                return function(obj) {
                    return $2cfb1f60ebaf5f65$require$toComparable(getter(obj)) >= value;
                };
            case "<=":
                return function(obj) {
                    return $2cfb1f60ebaf5f65$require$toComparable(getter(obj)) <= value;
                };
            case "startswith":
                return function(obj) {
                    return 0 === $2cfb1f60ebaf5f65$require$toComparable(toString(getter(obj))).indexOf(value);
                };
            case "endswith":
                return function(obj) {
                    var getterValue = $2cfb1f60ebaf5f65$require$toComparable(toString(getter(obj)));
                    var searchValue = toString(value);
                    if (getterValue.length < searchValue.length) return false;
                    return getterValue.lastIndexOf(value) === getterValue.length - value.length;
                };
            case "contains":
                return function(obj) {
                    return $2cfb1f60ebaf5f65$require$toComparable(toString(getter(obj))).indexOf(value) > -1;
                };
            case "notcontains":
                return function(obj) {
                    return $2cfb1f60ebaf5f65$require$toComparable(toString(getter(obj))).indexOf(value) === -1;
                };
        }
        throw $eae26cef6f9ed6fd$exports.errors.Error("E4003", op);
    };
    function compileEquals(getter, value, negate) {
        return function(obj) {
            obj = $2cfb1f60ebaf5f65$require$toComparable(getter(obj));
            var result = useStrictComparison(value) ? obj === value : obj == value;
            if (negate) result = !result;
            return result;
        };
    }
    function useStrictComparison(value) {
        return "" === value || 0 === value || false === value;
    }
    function compileUnary(crit) {
        var op = crit[0];
        var criteria = $2cfb1f60ebaf5f65$var$compileCriteria(crit[1]);
        if ("!" === op) return function(obj) {
            return !criteria(obj);
        };
        throw $eae26cef6f9ed6fd$exports.errors.Error("E4003", op);
    }
    return function(crit) {
        if ($kDRxH.isFunction(crit)) return crit;
        if ($94b9773d9b4e83fd$exports.isGroupCriterion(crit)) return compileGroup(crit);
        if ($94b9773d9b4e83fd$exports.isUnaryOperation(crit)) return compileUnary(crit);
        return compileBinary(crit);
    };
}();
var $2cfb1f60ebaf5f65$var$FilterIterator = $2cfb1f60ebaf5f65$var$WrappedIterator.inherit({
    ctor: function(iter, criteria) {
        this.callBase(iter);
        this.criteria = $2cfb1f60ebaf5f65$var$compileCriteria(criteria);
    },
    next: function() {
        while(this.iter.next()){
            if (this.criteria(this.current())) return true;
        }
        return false;
    }
});
var $2cfb1f60ebaf5f65$var$GroupIterator = $2cfb1f60ebaf5f65$var$Iterator.inherit({
    ctor: function(iter, getter) {
        this.iter = iter;
        this.getter = getter;
    },
    next: function() {
        this._ensureGrouped();
        return this.groupedIter.next();
    },
    current: function() {
        this._ensureGrouped();
        return this.groupedIter.current();
    },
    reset: function() {
        delete this.groupedIter;
    },
    countable: function() {
        return !!this.groupedIter;
    },
    count: function() {
        return this.groupedIter.count();
    },
    _ensureGrouped: function() {
        if (this.groupedIter) return;
        var hash = {};
        var keys = [];
        var iter = this.iter;
        var getter = $2cfb1f60ebaf5f65$require$compileGetter(this.getter);
        iter.reset();
        while(iter.next()){
            var current = iter.current();
            var key = getter(current);
            if (key in hash) hash[key].push(current);
            else {
                hash[key] = [
                    current
                ];
                keys.push(key);
            }
        }
        this.groupedIter = new $2cfb1f60ebaf5f65$var$ArrayIterator($4Pwuy.map(keys, function(key) {
            return {
                key: key,
                items: hash[key]
            };
        }));
    }
});
var $2cfb1f60ebaf5f65$var$SelectIterator = $2cfb1f60ebaf5f65$var$WrappedIterator.inherit({
    ctor: function(iter, getter) {
        this.callBase(iter);
        this.getter = $2cfb1f60ebaf5f65$require$compileGetter(getter);
    },
    current: function() {
        return this.getter(this.callBase());
    },
    countable: function() {
        return this.iter.countable();
    },
    count: function() {
        return this.iter.count();
    }
});
var $2cfb1f60ebaf5f65$var$SliceIterator = $2cfb1f60ebaf5f65$var$WrappedIterator.inherit({
    ctor: function(iter, skip, take) {
        this.callBase(iter);
        this.skip = Math.max(0, skip);
        this.take = Math.max(0, take);
        this.pos = 0;
    },
    next: function() {
        if (this.pos >= this.skip + this.take) return false;
        while(this.pos < this.skip && this.iter.next())this.pos++;
        this.pos++;
        return this.iter.next();
    },
    reset: function() {
        this.callBase();
        this.pos = 0;
    },
    countable: function() {
        return this.iter.countable();
    },
    count: function() {
        return Math.min(this.iter.count() - this.skip, this.take);
    }
});
var $2cfb1f60ebaf5f65$var$arrayQueryImpl = function arrayQueryImpl(iter, queryOptions) {
    queryOptions = queryOptions || {};
    if (!(iter instanceof $2cfb1f60ebaf5f65$var$Iterator)) iter = new $2cfb1f60ebaf5f65$var$ArrayIterator(iter);
    var handleError = function(error) {
        var handler = queryOptions.errorHandler;
        if (handler) handler(error);
        $eae26cef6f9ed6fd$exports._errorHandler(error);
    };
    var aggregateCore = function(aggregator) {
        var d = (new $2cfb1f60ebaf5f65$require$Deferred).fail(handleError);
        var seed;
        var step = aggregator.step;
        var finalize = aggregator.finalize;
        try {
            iter.reset();
            if ("seed" in aggregator) seed = aggregator.seed;
            else seed = iter.next() ? iter.current() : NaN;
            var accumulator = seed;
            while(iter.next())accumulator = step(accumulator, iter.current());
            d.resolve(finalize ? finalize(accumulator) : accumulator);
        } catch (x) {
            d.reject(x);
        }
        return d.promise();
    };
    var aggregate = function(seed, step, finalize) {
        if (arguments.length < 2) return aggregateCore({
            step: arguments[0]
        });
        return aggregateCore({
            seed: seed,
            step: step,
            finalize: finalize
        });
    };
    var standardAggregate = function(name) {
        return aggregateCore($94b9773d9b4e83fd$exports.aggregators[name]);
    };
    var select = function(getter) {
        if (!$kDRxH.isFunction(getter) && !Array.isArray(getter)) getter = [].slice.call(arguments);
        return chainQuery(new $2cfb1f60ebaf5f65$var$SelectIterator(iter, getter));
    };
    var selectProp = function(name) {
        return select($2cfb1f60ebaf5f65$require$compileGetter(name));
    };
    var chainQuery = function(iter) {
        return arrayQueryImpl(iter, queryOptions);
    };
    return {
        toArray: function() {
            return iter.toArray();
        },
        enumerate: function() {
            var d = (new $2cfb1f60ebaf5f65$require$Deferred).fail(handleError);
            try {
                d.resolve(iter.toArray());
            } catch (x) {
                d.reject(x);
            }
            return d.promise();
        },
        sortBy: function(getter, desc, compare) {
            return chainQuery(new $2cfb1f60ebaf5f65$var$SortIterator(iter, getter, desc, compare));
        },
        thenBy: function(getter, desc, compare) {
            if (iter instanceof $2cfb1f60ebaf5f65$var$SortIterator) return chainQuery(iter.thenBy(getter, desc, compare));
            throw $eae26cef6f9ed6fd$exports.errors.Error("E4004");
        },
        filter: function(criteria) {
            if (!Array.isArray(criteria)) criteria = [].slice.call(arguments);
            return chainQuery(new $2cfb1f60ebaf5f65$var$FilterIterator(iter, criteria));
        },
        slice: function(skip, take) {
            if (void 0 === take) take = Number.MAX_VALUE;
            return chainQuery(new $2cfb1f60ebaf5f65$var$SliceIterator(iter, skip, take));
        },
        select: select,
        groupBy: function(getter) {
            return chainQuery(new $2cfb1f60ebaf5f65$var$GroupIterator(iter, getter));
        },
        aggregate: aggregate,
        count: function() {
            if (iter.countable()) {
                var d = (new $2cfb1f60ebaf5f65$require$Deferred).fail(handleError);
                try {
                    d.resolve(iter.count());
                } catch (x) {
                    d.reject(x);
                }
                return d.promise();
            }
            return standardAggregate("count");
        },
        sum: function(getter) {
            if (getter) return selectProp(getter).sum();
            return standardAggregate("sum");
        },
        min: function(getter) {
            if (getter) return selectProp(getter).min();
            return standardAggregate("min");
        },
        max: function(getter) {
            if (getter) return selectProp(getter).max();
            return standardAggregate("max");
        },
        avg: function(getter) {
            if (getter) return selectProp(getter).avg();
            return standardAggregate("avg");
        }
    };
};
$2cfb1f60ebaf5f65$exports = $2cfb1f60ebaf5f65$var$arrayQueryImpl;



var $04f941f354dbda7d$require$normalizeSortingInfo = $94b9773d9b4e83fd$exports.normalizeSortingInfo;
function $04f941f354dbda7d$var$multiLevelGroup(query, groupInfo) {
    query = query.groupBy(groupInfo[0].selector);
    if (groupInfo.length > 1) query = query.select(function(g) {
        return $04f941f354dbda7d$require$extend({}, g, {
            items: $04f941f354dbda7d$var$multiLevelGroup($2cfb1f60ebaf5f65$exports(g.items), groupInfo.slice(1)).toArray()
        });
    });
    return query;
}
function $04f941f354dbda7d$var$arrangeSortingInfo(groupInfo, sortInfo) {
    var filteredGroup = [];
    $04f941f354dbda7d$require$each(groupInfo, function(_, group) {
        var collision = $04f941f354dbda7d$require$grep(sortInfo, function(sort) {
            return group.selector === sort.selector;
        });
        if (collision.length < 1) filteredGroup.push(group);
    });
    return filteredGroup.concat(sortInfo);
}
function $04f941f354dbda7d$var$queryByOptions(query, options, isCountQuery) {
    options = options || {};
    var filter = options.filter;
    if (filter) query = query.filter(filter);
    if (isCountQuery) return query;
    var sort = options.sort;
    var select = options.select;
    var group = options.group;
    var skip = options.skip;
    var take = options.take;
    if (group) {
        group = $04f941f354dbda7d$require$normalizeSortingInfo(group);
        group.keepInitialKeyOrder = !!options.group.keepInitialKeyOrder;
    }
    if (sort || group) {
        sort = $04f941f354dbda7d$require$normalizeSortingInfo(sort || []);
        if (group && !group.keepInitialKeyOrder) sort = $04f941f354dbda7d$var$arrangeSortingInfo(group, sort);
        $04f941f354dbda7d$require$each(sort, function(index) {
            query = query[index ? "thenBy" : "sortBy"](this.selector, this.desc, this.compare);
        });
    }
    if (select) query = query.select(select);
    if (group) query = $04f941f354dbda7d$var$multiLevelGroup(query, group);
    if (take || skip) query = query.slice(skip || 0, take);
    return query;
}
$04f941f354dbda7d$exports = {
    multiLevelGroup: $04f941f354dbda7d$var$multiLevelGroup,
    arrangeSortingInfo: $04f941f354dbda7d$var$arrangeSortingInfo,
    queryByOptions: $04f941f354dbda7d$var$queryByOptions
};


var $e14cc89de3dff21c$var$queryByOptions = $04f941f354dbda7d$exports.queryByOptions;

var $2F60d = parcelRequire("2F60d");
var $e14cc89de3dff21c$require$Deferred = $2F60d.Deferred;

var $2Mto0 = parcelRequire("2Mto0");
var $e14cc89de3dff21c$require$noop = $2Mto0.noop;
var $e14cc89de3dff21c$var$storeImpl = {};
var $e14cc89de3dff21c$var$Store = $k7aJb.inherit({
    ctor: function(options) {
        var that = this;
        options = options || {};
        $e14cc89de3dff21c$require$each([
            "onLoaded",
            "onLoading",
            "onInserted",
            "onInserting",
            "onUpdated",
            "onUpdating",
            "onPush",
            "onRemoved",
            "onRemoving",
            "onModified",
            "onModifying"
        ], function(_, optionName) {
            if (optionName in options) that.on(optionName.slice(2).toLowerCase(), options[optionName]);
        });
        this._key = options.key;
        this._errorHandler = options.errorHandler;
        this._useDefaultSearch = true;
    },
    _customLoadOptions: function() {
        return null;
    },
    key: function() {
        return this._key;
    },
    keyOf: function(obj) {
        if (!this._keyGetter) this._keyGetter = $e14cc89de3dff21c$require$compileGetter(this.key());
        return this._keyGetter(obj);
    },
    _requireKey: function() {
        if (!this.key()) throw $eae26cef6f9ed6fd$exports.errors.Error("E4005");
    },
    load: function(options) {
        var that = this;
        options = options || {};
        this.fireEvent("loading", [
            options
        ]);
        return this._withLock(this._loadImpl(options)).done(function(result) {
            that.fireEvent("loaded", [
                result,
                options
            ]);
        });
    },
    _loadImpl: function(options) {
        return $e14cc89de3dff21c$var$queryByOptions(this.createQuery(options), options).enumerate();
    },
    _withLock: function(task) {
        var result = new $e14cc89de3dff21c$require$Deferred;
        task.done(function() {
            var that = this;
            var args = arguments;
            $94b9773d9b4e83fd$exports.processRequestResultLock.promise().done(function() {
                result.resolveWith(that, args);
            });
        }).fail(function() {
            result.rejectWith(this, arguments);
        });
        return result;
    },
    createQuery: $e14cc89de3dff21c$var$abstract,
    totalCount: function(options) {
        return this._totalCountImpl(options);
    },
    _totalCountImpl: function(options) {
        return $e14cc89de3dff21c$var$queryByOptions(this.createQuery(options), options, true).count();
    },
    byKey: function(key, extraOptions) {
        return this._addFailHandlers(this._withLock(this._byKeyImpl(key, extraOptions)));
    },
    _byKeyImpl: $e14cc89de3dff21c$var$abstract,
    insert: function(values) {
        var that = this;
        that.fireEvent("modifying");
        that.fireEvent("inserting", [
            values
        ]);
        return that._addFailHandlers(that._insertImpl(values).done(function(callbackValues, callbackKey) {
            that.fireEvent("inserted", [
                callbackValues,
                callbackKey
            ]);
            that.fireEvent("modified");
        }));
    },
    _insertImpl: $e14cc89de3dff21c$var$abstract,
    update: function(key, values) {
        var that = this;
        that.fireEvent("modifying");
        that.fireEvent("updating", [
            key,
            values
        ]);
        return that._addFailHandlers(that._updateImpl(key, values).done(function() {
            that.fireEvent("updated", [
                key,
                values
            ]);
            that.fireEvent("modified");
        }));
    },
    _updateImpl: $e14cc89de3dff21c$var$abstract,
    push: function(changes) {
        this._pushImpl(changes);
        this.fireEvent("push", [
            changes
        ]);
    },
    _pushImpl: $e14cc89de3dff21c$require$noop,
    remove: function(key) {
        var that = this;
        that.fireEvent("modifying");
        that.fireEvent("removing", [
            key
        ]);
        return that._addFailHandlers(that._removeImpl(key).done(function(callbackKey) {
            that.fireEvent("removed", [
                callbackKey
            ]);
            that.fireEvent("modified");
        }));
    },
    _removeImpl: $e14cc89de3dff21c$var$abstract,
    _addFailHandlers: function(deferred) {
        return deferred.fail(this._errorHandler).fail($eae26cef6f9ed6fd$exports._errorHandler);
    }
}).include($cWRya);
$e14cc89de3dff21c$var$Store.create = function(alias, options) {
    if (!(alias in $e14cc89de3dff21c$var$storeImpl)) throw $eae26cef6f9ed6fd$exports.errors.Error("E4020", alias);
    return new $e14cc89de3dff21c$var$storeImpl[alias](options);
};
$e14cc89de3dff21c$var$Store.registerClass = function(type, alias) {
    if (alias) $e14cc89de3dff21c$var$storeImpl[alias] = type;
    return type;
};
$e14cc89de3dff21c$var$Store.inherit = function(inheritor) {
    return function(members, alias) {
        var type = inheritor.apply(this, [
            members
        ]);
        $e14cc89de3dff21c$var$Store.registerClass(type, alias);
        return type;
    };
}($e14cc89de3dff21c$var$Store.inherit);
$e14cc89de3dff21c$exports = $e14cc89de3dff21c$var$Store;


var $b7fc08c44e7a2da5$exports = {};
/**
 * DevExtreme (data/array_store.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $70c1405d2124b690$exports = {};
/**
 * DevExtreme (data/query.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $7ee1cb086baab0d9$exports = {};
/**
 * DevExtreme (data/remote_query.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
var $71c74ab67559bb33$exports = {};
/**
 * DevExtreme (data/query_adapters.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
$71c74ab67559bb33$exports = {};




var $4Pwuy = parcelRequire("4Pwuy");
var $7ee1cb086baab0d9$require$each = $4Pwuy.each;

var $kDRxH = parcelRequire("kDRxH");
var $7ee1cb086baab0d9$require$isFunction = $kDRxH.isFunction;

var $2F60d = parcelRequire("2F60d");
var $7ee1cb086baab0d9$require$Deferred = $2F60d.Deferred;

var $7ee1cb086baab0d9$var$remoteQueryImpl = function remoteQueryImpl(url, queryOptions, tasks) {
    tasks = tasks || [];
    queryOptions = queryOptions || {};
    var createTask = function(name, args) {
        return {
            name: name,
            args: args
        };
    };
    var exec = function(executorTask) {
        var d = new $7ee1cb086baab0d9$require$Deferred;
        var _adapterFactory;
        var _adapter;
        var _taskQueue;
        var _currentTask;
        var _mergedSortArgs;
        var rejectWithNotify = function(error) {
            var handler = queryOptions.errorHandler;
            if (handler) handler(error);
            $eae26cef6f9ed6fd$exports._errorHandler(error);
            d.reject(error);
        };
        function mergeSortTask(task) {
            switch(task.name){
                case "sortBy":
                    _mergedSortArgs = [
                        task.args
                    ];
                    return true;
                case "thenBy":
                    if (!_mergedSortArgs) throw $eae26cef6f9ed6fd$exports.errors.Error("E4004");
                    _mergedSortArgs.push(task.args);
                    return true;
            }
            return false;
        }
        function unmergeSortTasks() {
            var head = _taskQueue[0];
            var unmergedTasks = [];
            if (head && "multiSort" === head.name) {
                _taskQueue.shift();
                $7ee1cb086baab0d9$require$each(head.args[0], function() {
                    unmergedTasks.push(createTask(unmergedTasks.length ? "thenBy" : "sortBy", this));
                });
            }
            _taskQueue = unmergedTasks.concat(_taskQueue);
        }
        try {
            _adapterFactory = queryOptions.adapter;
            if (!$7ee1cb086baab0d9$require$isFunction(_adapterFactory)) _adapterFactory = $71c74ab67559bb33$exports[_adapterFactory];
            _adapter = _adapterFactory(queryOptions);
            _taskQueue = [].concat(tasks).concat(executorTask);
            var optimize = _adapter.optimize;
            if (optimize) optimize(_taskQueue);
            while(_taskQueue.length){
                _currentTask = _taskQueue[0];
                if (!mergeSortTask(_currentTask)) {
                    if (_mergedSortArgs) {
                        _taskQueue.unshift(createTask("multiSort", [
                            _mergedSortArgs
                        ]));
                        _mergedSortArgs = null;
                        continue;
                    }
                    if ("enumerate" !== String(_currentTask.name)) {
                        if (!_adapter[_currentTask.name] || false === _adapter[_currentTask.name].apply(_adapter, _currentTask.args)) break;
                    }
                }
                _taskQueue.shift();
            }
            unmergeSortTasks();
            _adapter.exec(url).done(function(result, extra) {
                if (!_taskQueue.length) d.resolve(result, extra);
                else {
                    var clientChain = $2cfb1f60ebaf5f65$exports(result, {
                        errorHandler: queryOptions.errorHandler
                    });
                    $7ee1cb086baab0d9$require$each(_taskQueue, function() {
                        clientChain = clientChain[this.name].apply(clientChain, this.args);
                    });
                    clientChain.done(d.resolve).fail(d.reject);
                }
            }).fail(rejectWithNotify);
        } catch (x) {
            rejectWithNotify(x);
        }
        return d.promise();
    };
    var query = {};
    $7ee1cb086baab0d9$require$each([
        "sortBy",
        "thenBy",
        "filter",
        "slice",
        "select",
        "groupBy"
    ], function() {
        var name = String(this);
        query[name] = function() {
            return remoteQueryImpl(url, queryOptions, tasks.concat(createTask(name, arguments)));
        };
    });
    $7ee1cb086baab0d9$require$each([
        "count",
        "min",
        "max",
        "sum",
        "avg",
        "aggregate",
        "enumerate"
    ], function() {
        var name = String(this);
        query[name] = function() {
            return exec.call(this, createTask(name, arguments));
        };
    });
    return query;
};
$7ee1cb086baab0d9$exports = $7ee1cb086baab0d9$var$remoteQueryImpl;


var $70c1405d2124b690$var$queryImpl = {
    array: $2cfb1f60ebaf5f65$exports,
    remote: $7ee1cb086baab0d9$exports
};
var $70c1405d2124b690$var$query = function() {
    var impl = Array.isArray(arguments[0]) ? "array" : "remote";
    return $70c1405d2124b690$var$queryImpl[impl].apply(this, arguments);
};
$70c1405d2124b690$exports = $70c1405d2124b690$var$query;
$70c1405d2124b690$exports.queryImpl = $70c1405d2124b690$var$queryImpl;
$70c1405d2124b690$exports.default = $70c1405d2124b690$exports;


var $b7fc08c44e7a2da5$var$_query2 = $b7fc08c44e7a2da5$var$_interopRequireDefault($70c1405d2124b690$exports);


var $b7fc08c44e7a2da5$var$_abstract_store2 = $b7fc08c44e7a2da5$var$_interopRequireDefault($e14cc89de3dff21c$exports);

var $b7fc08c44e7a2da5$var$_array_utils2 = $b7fc08c44e7a2da5$var$_interopRequireDefault($852ad2a58fe2bfbc$exports);
function $b7fc08c44e7a2da5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $b7fc08c44e7a2da5$var$ArrayStore = $b7fc08c44e7a2da5$var$_abstract_store2.default.inherit({
    ctor: function(options) {
        if (Array.isArray(options)) options = {
            data: options
        };
        else options = options || {};
        this.callBase(options);
        var initialArray = options.data;
        if (initialArray && !Array.isArray(initialArray)) throw $eae26cef6f9ed6fd$exports.errors.Error("E4006");
        this._array = initialArray || [];
    },
    createQuery: function() {
        return (0, $b7fc08c44e7a2da5$var$_query2.default)(this._array, {
            errorHandler: this._errorHandler
        });
    },
    _byKeyImpl: function(key) {
        var index = $b7fc08c44e7a2da5$var$_array_utils2.default.indexByKey(this, this._array, key);
        if (index === -1) return (0, $94b9773d9b4e83fd$exports.rejectedPromise)($eae26cef6f9ed6fd$exports.errors.Error("E4009"));
        return (0, $94b9773d9b4e83fd$exports.trivialPromise)(this._array[index]);
    },
    _insertImpl: function(values) {
        return $b7fc08c44e7a2da5$var$_array_utils2.default.insert(this, this._array, values);
    },
    _pushImpl: function(changes) {
        $b7fc08c44e7a2da5$var$_array_utils2.default.applyBatch(this, this._array, changes);
    },
    _updateImpl: function(key, values) {
        return $b7fc08c44e7a2da5$var$_array_utils2.default.update(this, this._array, key, values);
    },
    _removeImpl: function(key) {
        return $b7fc08c44e7a2da5$var$_array_utils2.default.remove(this, this._array, key);
    },
    clear: function() {
        this.fireEvent("modifying");
        this._array = [];
        this.fireEvent("modified");
    }
}, "array");
$b7fc08c44e7a2da5$exports = $b7fc08c44e7a2da5$var$ArrayStore;
$b7fc08c44e7a2da5$exports.default = $b7fc08c44e7a2da5$exports;


var $e7444c4eb1c17401$exports = {};
/**
 * DevExtreme (data/custom_store.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");



var $kDRxH = parcelRequire("kDRxH");
var $e7444c4eb1c17401$require$isFunction = $kDRxH.isFunction;

var $1JvXr = parcelRequire("1JvXr");

var $e7444c4eb1c17401$require$errors = $eae26cef6f9ed6fd$exports.errors;



var $e7444c4eb1c17401$require$queryByOptions = $04f941f354dbda7d$exports.queryByOptions;

var $2F60d = parcelRequire("2F60d");
var $e7444c4eb1c17401$var$Deferred = $2F60d.Deferred;
var $e7444c4eb1c17401$var$when = $2F60d.when;
var $e7444c4eb1c17401$var$fromPromise = $2F60d.fromPromise;
var $e7444c4eb1c17401$var$TOTAL_COUNT = "totalCount";
var $e7444c4eb1c17401$var$LOAD = "load";
var $e7444c4eb1c17401$var$BY_KEY = "byKey";
var $e7444c4eb1c17401$var$INSERT = "insert";
var $e7444c4eb1c17401$var$UPDATE = "update";
var $e7444c4eb1c17401$var$REMOVE = "remove";
function $e7444c4eb1c17401$var$isPromise(obj) {
    return obj && $e7444c4eb1c17401$require$isFunction(obj.then);
}
function $e7444c4eb1c17401$var$trivialPromise(value) {
    return (new $e7444c4eb1c17401$var$Deferred).resolve(value).promise();
}
function $e7444c4eb1c17401$var$ensureRequiredFuncOption(name, obj) {
    if (!$e7444c4eb1c17401$require$isFunction(obj)) throw $e7444c4eb1c17401$require$errors.Error("E4011", name);
}
function $e7444c4eb1c17401$var$throwInvalidUserFuncResult(name) {
    throw $e7444c4eb1c17401$require$errors.Error("E4012", name);
}
function $e7444c4eb1c17401$var$createUserFuncFailureHandler(pendingDeferred) {
    function errorMessageFromXhr(promiseArguments) {
        var xhr = promiseArguments[0];
        var textStatus = promiseArguments[1];
        if (!xhr || !xhr.getResponseHeader) return null;
        return $94b9773d9b4e83fd$exports.errorMessageFromXhr(xhr, textStatus);
    }
    return function(arg) {
        var error;
        if (arg instanceof Error) error = arg;
        else error = new Error(errorMessageFromXhr(arguments) || arg && String(arg) || "Unknown error");
        if (error.message !== $94b9773d9b4e83fd$exports.XHR_ERROR_UNLOAD) pendingDeferred.reject(error);
    };
}
function $e7444c4eb1c17401$var$invokeUserLoad(store, options) {
    var userFunc = store._loadFunc;
    var userResult;
    $e7444c4eb1c17401$var$ensureRequiredFuncOption($e7444c4eb1c17401$var$LOAD, userFunc);
    userResult = userFunc.apply(store, [
        options
    ]);
    if (Array.isArray(userResult)) userResult = $e7444c4eb1c17401$var$trivialPromise(userResult);
    else {
        if (null === userResult || void 0 === userResult) userResult = $e7444c4eb1c17401$var$trivialPromise([]);
        else if (!$e7444c4eb1c17401$var$isPromise(userResult)) $e7444c4eb1c17401$var$throwInvalidUserFuncResult($e7444c4eb1c17401$var$LOAD);
    }
    return $e7444c4eb1c17401$var$fromPromise(userResult);
}
function $e7444c4eb1c17401$var$invokeUserTotalCountFunc(store, options) {
    var userFunc = store._totalCountFunc;
    var userResult;
    if (!$e7444c4eb1c17401$require$isFunction(userFunc)) throw $e7444c4eb1c17401$require$errors.Error("E4021");
    userResult = userFunc.apply(store, [
        options
    ]);
    if (!$e7444c4eb1c17401$var$isPromise(userResult)) {
        userResult = Number(userResult);
        if (!isFinite(userResult)) $e7444c4eb1c17401$var$throwInvalidUserFuncResult($e7444c4eb1c17401$var$TOTAL_COUNT);
        userResult = $e7444c4eb1c17401$var$trivialPromise(userResult);
    }
    return $e7444c4eb1c17401$var$fromPromise(userResult);
}
function $e7444c4eb1c17401$var$invokeUserByKeyFunc(store, key, extraOptions) {
    var userFunc = store._byKeyFunc;
    var userResult;
    $e7444c4eb1c17401$var$ensureRequiredFuncOption($e7444c4eb1c17401$var$BY_KEY, userFunc);
    userResult = userFunc.apply(store, [
        key,
        extraOptions
    ]);
    if (!$e7444c4eb1c17401$var$isPromise(userResult)) userResult = $e7444c4eb1c17401$var$trivialPromise(userResult);
    return $e7444c4eb1c17401$var$fromPromise(userResult);
}
function $e7444c4eb1c17401$var$runRawLoad(pendingDeferred, store, userFuncOptions, continuation) {
    if (store.__rawData) continuation(store.__rawData);
    else {
        var loadPromise = store.__rawDataPromise || $e7444c4eb1c17401$var$invokeUserLoad(store, userFuncOptions);
        if (store._cacheRawData) store.__rawDataPromise = loadPromise;
        loadPromise.always(function() {
            delete store.__rawDataPromise;
        }).done(function(rawData) {
            if (store._cacheRawData) store.__rawData = rawData;
            continuation(rawData);
        }).fail($e7444c4eb1c17401$var$createUserFuncFailureHandler(pendingDeferred));
    }
}
function $e7444c4eb1c17401$var$runRawLoadWithQuery(pendingDeferred, store, options, countOnly) {
    options = options || {};
    var userFuncOptions = {};
    if ("userData" in options) userFuncOptions.userData = options.userData;
    $e7444c4eb1c17401$var$runRawLoad(pendingDeferred, store, userFuncOptions, function(rawData) {
        var rawDataQuery = $2cfb1f60ebaf5f65$exports(rawData, {
            errorHandler: store._errorHandler
        });
        var itemsQuery;
        var totalCountQuery;
        var waitList = [];
        var items;
        var totalCount;
        if (!countOnly) {
            itemsQuery = $e7444c4eb1c17401$require$queryByOptions(rawDataQuery, options);
            if (itemsQuery === rawDataQuery) items = rawData.slice(0);
            else waitList.push(itemsQuery.enumerate().done(function(asyncResult) {
                items = asyncResult;
            }));
        }
        if (options.requireTotalCount || countOnly) {
            totalCountQuery = $e7444c4eb1c17401$require$queryByOptions(rawDataQuery, options, true);
            if (totalCountQuery === rawDataQuery) totalCount = rawData.length;
            else waitList.push(totalCountQuery.count().done(function(asyncResult) {
                totalCount = asyncResult;
            }));
        }
        $e7444c4eb1c17401$var$when.apply($jFnCG, waitList).done(function() {
            if (countOnly) pendingDeferred.resolve(totalCount);
            else if (options.requireTotalCount) pendingDeferred.resolve(items, {
                totalCount: totalCount
            });
            else pendingDeferred.resolve(items);
        }).fail(function(x) {
            pendingDeferred.reject(x);
        });
    });
}
function $e7444c4eb1c17401$var$runRawLoadWithKey(pendingDeferred, store, key) {
    $e7444c4eb1c17401$var$runRawLoad(pendingDeferred, store, {}, function(rawData) {
        var item;
        for(var i = 0, len = rawData.length; i < len; i++){
            item = rawData[i];
            if ($94b9773d9b4e83fd$exports.keysEqual(store.keyOf(rawData[i]), key)) {
                pendingDeferred.resolve(item);
                return;
            }
        }
        pendingDeferred.reject($e7444c4eb1c17401$require$errors.Error("E4009"));
    });
}
var $e7444c4eb1c17401$var$CustomStore = $e14cc89de3dff21c$exports.inherit({
    ctor: function(options) {
        options = options || {};
        this.callBase(options);
        this._useDefaultSearch = !!options.useDefaultSearch || "raw" === options.loadMode;
        this._loadMode = options.loadMode;
        this._cacheRawData = false !== options.cacheRawData;
        this._loadFunc = options[$e7444c4eb1c17401$var$LOAD];
        this._totalCountFunc = options[$e7444c4eb1c17401$var$TOTAL_COUNT];
        this._byKeyFunc = options[$e7444c4eb1c17401$var$BY_KEY];
        this._insertFunc = options[$e7444c4eb1c17401$var$INSERT];
        this._updateFunc = options[$e7444c4eb1c17401$var$UPDATE];
        this._removeFunc = options[$e7444c4eb1c17401$var$REMOVE];
    },
    createQuery: function() {
        throw $e7444c4eb1c17401$require$errors.Error("E4010");
    },
    clearRawDataCache: function() {
        delete this.__rawData;
    },
    _totalCountImpl: function(options) {
        var d = new $e7444c4eb1c17401$var$Deferred;
        if ("raw" === this._loadMode && !this._totalCountFunc) $e7444c4eb1c17401$var$runRawLoadWithQuery(d, this, options, true);
        else {
            $e7444c4eb1c17401$var$invokeUserTotalCountFunc(this, options).done(function(count) {
                d.resolve(Number(count));
            }).fail($e7444c4eb1c17401$var$createUserFuncFailureHandler(d));
            d = this._addFailHandlers(d);
        }
        return d.promise();
    },
    _pushImpl: function(changes) {
        if (this.__rawData) $852ad2a58fe2bfbc$export$65d4799c35eb3744(this, this.__rawData, changes);
    },
    _loadImpl: function(options) {
        var d = new $e7444c4eb1c17401$var$Deferred;
        if ("raw" === this._loadMode) $e7444c4eb1c17401$var$runRawLoadWithQuery(d, this, options, false);
        else {
            $e7444c4eb1c17401$var$invokeUserLoad(this, options).done(function(data, extra) {
                d.resolve(data, extra);
            }).fail($e7444c4eb1c17401$var$createUserFuncFailureHandler(d));
            d = this._addFailHandlers(d);
        }
        return d.promise();
    },
    _byKeyImpl: function(key, extraOptions) {
        var d = new $e7444c4eb1c17401$var$Deferred;
        if (this._byKeyViaLoad()) {
            this._requireKey();
            $e7444c4eb1c17401$var$runRawLoadWithKey(d, this, key);
        } else $e7444c4eb1c17401$var$invokeUserByKeyFunc(this, key, extraOptions).done(function(obj) {
            d.resolve(obj);
        }).fail($e7444c4eb1c17401$var$createUserFuncFailureHandler(d));
        return d.promise();
    },
    _byKeyViaLoad: function() {
        return "raw" === this._loadMode && !this._byKeyFunc;
    },
    _insertImpl: function(values) {
        var that = this;
        var userFunc = that._insertFunc;
        var userResult;
        var d = new $e7444c4eb1c17401$var$Deferred;
        $e7444c4eb1c17401$var$ensureRequiredFuncOption($e7444c4eb1c17401$var$INSERT, userFunc);
        userResult = userFunc.apply(that, [
            values
        ]);
        if (!$e7444c4eb1c17401$var$isPromise(userResult)) userResult = $e7444c4eb1c17401$var$trivialPromise(userResult);
        $e7444c4eb1c17401$var$fromPromise(userResult).done(function(serverResponse) {
            if ($1JvXr().useLegacyStoreResult) d.resolve(values, serverResponse);
            else d.resolve(serverResponse || values, that.keyOf(serverResponse));
        }).fail($e7444c4eb1c17401$var$createUserFuncFailureHandler(d));
        return d.promise();
    },
    _updateImpl: function(key, values) {
        var userFunc = this._updateFunc;
        var userResult;
        var d = new $e7444c4eb1c17401$var$Deferred;
        $e7444c4eb1c17401$var$ensureRequiredFuncOption($e7444c4eb1c17401$var$UPDATE, userFunc);
        userResult = userFunc.apply(this, [
            key,
            values
        ]);
        if (!$e7444c4eb1c17401$var$isPromise(userResult)) userResult = $e7444c4eb1c17401$var$trivialPromise(userResult);
        $e7444c4eb1c17401$var$fromPromise(userResult).done(function(serverResponse) {
            if ($1JvXr().useLegacyStoreResult) d.resolve(key, values);
            else d.resolve(serverResponse || values, key);
        }).fail($e7444c4eb1c17401$var$createUserFuncFailureHandler(d));
        return d.promise();
    },
    _removeImpl: function(key) {
        var userFunc = this._removeFunc;
        var userResult;
        var d = new $e7444c4eb1c17401$var$Deferred;
        $e7444c4eb1c17401$var$ensureRequiredFuncOption($e7444c4eb1c17401$var$REMOVE, userFunc);
        userResult = userFunc.apply(this, [
            key
        ]);
        if (!$e7444c4eb1c17401$var$isPromise(userResult)) userResult = $e7444c4eb1c17401$var$trivialPromise();
        $e7444c4eb1c17401$var$fromPromise(userResult).done(function() {
            d.resolve(key);
        }).fail($e7444c4eb1c17401$var$createUserFuncFailureHandler(d));
        return d.promise();
    }
});
$e7444c4eb1c17401$exports = $e7444c4eb1c17401$var$CustomStore;
$e7444c4eb1c17401$exports.default = $e7444c4eb1c17401$exports;



var $cWRya = parcelRequire("cWRya");

var $45e3ac8fbec1786a$require$errors = $eae26cef6f9ed6fd$exports.errors;

var $aLQK5 = parcelRequire("aLQK5");
/**
 * DevExtreme (core/utils/queue.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $638ae271a477a9bc$export$185802fd694ee1f5;
var $638ae271a477a9bc$export$513072ba72100d9c;
"use strict";

var $7sX7V = parcelRequire("7sX7V");

var $2F60d = parcelRequire("2F60d");
var $638ae271a477a9bc$require$when = $2F60d.when;
function $638ae271a477a9bc$var$createQueue(discardPendingTasks) {
    var _tasks = [];
    var _busy = false;
    function exec() {
        while(_tasks.length){
            _busy = true;
            var task = _tasks.shift();
            var result = task();
            if (void 0 === result) continue;
            if (result.then) {
                $638ae271a477a9bc$require$when(result).always(exec);
                return;
            }
            throw $7sX7V.Error("E0015");
        }
        _busy = false;
    }
    function add(task, removeTaskCallback) {
        if (!discardPendingTasks) _tasks.push(task);
        else {
            if (_tasks[0] && removeTaskCallback) removeTaskCallback(_tasks[0]);
            _tasks = [
                task
            ];
        }
        if (!_busy) exec();
    }
    function busy() {
        return _busy;
    }
    return {
        add: add,
        busy: busy
    };
}
$638ae271a477a9bc$export$185802fd694ee1f5 = $638ae271a477a9bc$var$createQueue;
$638ae271a477a9bc$export$513072ba72100d9c = $638ae271a477a9bc$var$createQueue().add;



var $2F60d = parcelRequire("2F60d");
var $45e3ac8fbec1786a$var$when = $2F60d.when;
var $45e3ac8fbec1786a$var$Deferred = $2F60d.Deferred;
var $45e3ac8fbec1786a$var$__isString = $kDRxH.isString;
var $45e3ac8fbec1786a$var$__isNumber = $kDRxH.isNumeric;
var $45e3ac8fbec1786a$var$__isBoolean = $kDRxH.isBoolean;
var $45e3ac8fbec1786a$var$__isDefined = $kDRxH.isDefined;
var $45e3ac8fbec1786a$var$CANCELED_TOKEN = "canceled";
function $45e3ac8fbec1786a$var$OperationManager() {
    this._counter = -1;
    this._deferreds = {};
}
$45e3ac8fbec1786a$var$OperationManager.prototype.constructor = $45e3ac8fbec1786a$var$OperationManager;
$45e3ac8fbec1786a$var$OperationManager.prototype.add = function(deferred) {
    this._counter += 1;
    this._deferreds[this._counter] = deferred;
    return this._counter;
};
$45e3ac8fbec1786a$var$OperationManager.prototype.remove = function(operationId) {
    return delete this._deferreds[operationId];
};
$45e3ac8fbec1786a$var$OperationManager.prototype.cancel = function(operationId) {
    if (operationId in this._deferreds) {
        this._deferreds[operationId].reject($45e3ac8fbec1786a$var$CANCELED_TOKEN);
        return true;
    }
    return false;
};
$45e3ac8fbec1786a$var$OperationManager.prototype.cancelAll = function() {
    while(this._counter > -1){
        this.cancel(this._counter);
        this._counter--;
    }
};
function $45e3ac8fbec1786a$var$isPending(deferred) {
    return "pending" === deferred.state();
}
function $45e3ac8fbec1786a$var$normalizeDataSourceOptions(options, normalizationOptions) {
    var store;
    function createCustomStoreFromLoadFunc() {
        var storeConfig = {};
        $4Pwuy.each([
            "useDefaultSearch",
            "key",
            "load",
            "loadMode",
            "cacheRawData",
            "byKey",
            "lookup",
            "totalCount",
            "insert",
            "update",
            "remove"
        ], function() {
            storeConfig[this] = options[this];
            delete options[this];
        });
        return new $e7444c4eb1c17401$exports(storeConfig);
    }
    function createStoreFromConfig(storeConfig) {
        var alias = storeConfig.type;
        delete storeConfig.type;
        return $e14cc89de3dff21c$exports.create(alias, storeConfig);
    }
    function createCustomStoreFromUrl(url) {
        return new $e7444c4eb1c17401$exports({
            load: function() {
                return $3695ac098f7ec859$exports.sendRequest({
                    url: url,
                    dataType: "json"
                });
            },
            loadMode: normalizationOptions && normalizationOptions.fromUrlLoadMode
        });
    }
    if ("string" === typeof options) options = {
        paginate: false,
        store: createCustomStoreFromUrl(options)
    };
    if (void 0 === options) options = [];
    if (Array.isArray(options) || options instanceof $e14cc89de3dff21c$exports) options = {
        store: options
    };
    else options = $45e3ac8fbec1786a$require$extend({}, options);
    if (void 0 === options.store) options.store = [];
    store = options.store;
    if ("load" in options) store = createCustomStoreFromLoadFunc();
    else {
        if (Array.isArray(store)) store = new $b7fc08c44e7a2da5$exports(store);
        else if ($kDRxH.isPlainObject(store)) store = createStoreFromConfig($45e3ac8fbec1786a$require$extend({}, store));
    }
    options.store = store;
    return options;
}
function $45e3ac8fbec1786a$var$normalizeStoreLoadOptionAccessorArguments(originalArguments) {
    switch(originalArguments.length){
        case 0:
            return;
        case 1:
            return originalArguments[0];
    }
    return [].slice.call(originalArguments);
}
function $45e3ac8fbec1786a$var$generateStoreLoadOptionAccessor(optionName) {
    return function() {
        var args = $45e3ac8fbec1786a$var$normalizeStoreLoadOptionAccessorArguments(arguments);
        if (void 0 === args) return this._storeLoadOptions[optionName];
        this._storeLoadOptions[optionName] = args;
    };
}
function $45e3ac8fbec1786a$var$mapDataRespectingGrouping(items, mapper, groupInfo) {
    function mapRecursive(items, level) {
        if (!Array.isArray(items)) return items;
        return level ? mapGroup(items, level) : $4Pwuy.map(items, mapper);
    }
    function mapGroup(group, level) {
        return $4Pwuy.map(group, function(item) {
            var result = {
                key: item.key,
                items: mapRecursive(item.items, level - 1)
            };
            if ("aggregates" in item) result.aggregates = item.aggregates;
            return result;
        });
    }
    return mapRecursive(items, groupInfo ? $94b9773d9b4e83fd$exports.normalizeSortingInfo(groupInfo).length : 0);
}
function $45e3ac8fbec1786a$var$normalizeLoadResult(data, extra) {
    if (data && !Array.isArray(data) && data.data) {
        extra = data;
        data = data.data;
    }
    if (!Array.isArray(data)) data = [
        data
    ];
    return {
        data: data,
        extra: extra
    };
}
var $45e3ac8fbec1786a$var$DataSource = $k7aJb.inherit({
    ctor: function(options) {
        var _this = this;
        var that = this;
        options = $45e3ac8fbec1786a$var$normalizeDataSourceOptions(options);
        var onPushHandler = 0 !== options.pushAggregationTimeout ? $94b9773d9b4e83fd$exports.throttleChanges(this._onPush, function() {
            if (void 0 === options.pushAggregationTimeout) return 5 * that._changedTime;
            return options.pushAggregationTimeout;
        }) : this._onPush;
        this._changedTime = 0;
        this._onPushHandler = function(changes) {
            _this._aggregationTimeoutId = onPushHandler.call(_this, changes);
        };
        this._store = options.store;
        this._store.on("push", this._onPushHandler);
        this._storeLoadOptions = this._extractLoadOptions(options);
        this._mapFunc = options.map;
        this._postProcessFunc = options.postProcess;
        this._pageIndex = void 0 !== options.pageIndex ? options.pageIndex : 0;
        this._pageSize = void 0 !== options.pageSize ? options.pageSize : 20;
        this._loadingCount = 0;
        this._loadQueue = this._createLoadQueue();
        this._searchValue = "searchValue" in options ? options.searchValue : null;
        this._searchOperation = options.searchOperation || "contains";
        this._searchExpr = options.searchExpr;
        this._paginate = options.paginate;
        this._reshapeOnPush = $45e3ac8fbec1786a$var$__isDefined(options.reshapeOnPush) ? options.reshapeOnPush : false;
        $4Pwuy.each([
            "onChanged",
            "onLoadError",
            "onLoadingChanged",
            "onCustomizeLoadResult",
            "onCustomizeStoreLoadOptions"
        ], function(_, optionName) {
            if (optionName in options) that.on(optionName.substr(2, 1).toLowerCase() + optionName.substr(3), options[optionName]);
        });
        this._operationManager = new $45e3ac8fbec1786a$var$OperationManager;
        this._init();
    },
    _init: function() {
        this._items = [];
        this._userData = {};
        this._totalCount = -1;
        this._isLoaded = false;
        if (!$45e3ac8fbec1786a$var$__isDefined(this._paginate)) this._paginate = !this.group();
        this._isLastPage = !this._paginate;
    },
    dispose: function() {
        this._store.off("push", this._onPushHandler);
        this._disposeEvents();
        clearTimeout(this._aggregationTimeoutId);
        delete this._store;
        if (this._delayedLoadTask) this._delayedLoadTask.abort();
        this._operationManager.cancelAll();
        this._disposed = true;
    },
    _extractLoadOptions: function(options) {
        var result = {};
        var names = [
            "sort",
            "filter",
            "select",
            "group",
            "requireTotalCount"
        ];
        var customNames = this._store._customLoadOptions();
        if (customNames) names = names.concat(customNames);
        $4Pwuy.each(names, function() {
            result[this] = options[this];
        });
        return result;
    },
    loadOptions: function() {
        return this._storeLoadOptions;
    },
    items: function() {
        return this._items;
    },
    pageIndex: function(newIndex) {
        if (!$45e3ac8fbec1786a$var$__isNumber(newIndex)) return this._pageIndex;
        this._pageIndex = newIndex;
        this._isLastPage = !this._paginate;
    },
    paginate: function(value) {
        if (!$45e3ac8fbec1786a$var$__isBoolean(value)) return this._paginate;
        if (this._paginate !== value) {
            this._paginate = value;
            this.pageIndex(0);
        }
    },
    pageSize: function(value) {
        if (!$45e3ac8fbec1786a$var$__isNumber(value)) return this._pageSize;
        this._pageSize = value;
    },
    isLastPage: function() {
        return this._isLastPage;
    },
    sort: $45e3ac8fbec1786a$var$generateStoreLoadOptionAccessor("sort"),
    filter: function() {
        var newFilter = $45e3ac8fbec1786a$var$normalizeStoreLoadOptionAccessorArguments(arguments);
        if (void 0 === newFilter) return this._storeLoadOptions.filter;
        this._storeLoadOptions.filter = newFilter;
        this.pageIndex(0);
    },
    group: $45e3ac8fbec1786a$var$generateStoreLoadOptionAccessor("group"),
    select: $45e3ac8fbec1786a$var$generateStoreLoadOptionAccessor("select"),
    requireTotalCount: function(value) {
        if (!$45e3ac8fbec1786a$var$__isBoolean(value)) return this._storeLoadOptions.requireTotalCount;
        this._storeLoadOptions.requireTotalCount = value;
    },
    searchValue: function(value) {
        if (arguments.length < 1) return this._searchValue;
        this._searchValue = value;
        this.pageIndex(0);
    },
    searchOperation: function(op) {
        if (!$45e3ac8fbec1786a$var$__isString(op)) return this._searchOperation;
        this._searchOperation = op;
        this.pageIndex(0);
    },
    searchExpr: function(expr) {
        var argc = arguments.length;
        if (0 === argc) return this._searchExpr;
        if (argc > 1) expr = [].slice.call(arguments);
        this._searchExpr = expr;
        this.pageIndex(0);
    },
    store: function() {
        return this._store;
    },
    key: function() {
        return this._store && this._store.key();
    },
    totalCount: function() {
        return this._totalCount;
    },
    isLoaded: function() {
        return this._isLoaded;
    },
    isLoading: function() {
        return this._loadingCount > 0;
    },
    beginLoading: function() {
        this._changeLoadingCount(1);
    },
    endLoading: function() {
        this._changeLoadingCount(-1);
    },
    _createLoadQueue: function() {
        return $638ae271a477a9bc$export$185802fd694ee1f5();
    },
    _changeLoadingCount: function(increment) {
        var oldLoading = this.isLoading();
        this._loadingCount += increment;
        var newLoading = this.isLoading();
        if (oldLoading ^ newLoading) this.fireEvent("loadingChanged", [
            newLoading
        ]);
    },
    _scheduleLoadCallbacks: function(deferred) {
        var that = this;
        that.beginLoading();
        deferred.always(function() {
            that.endLoading();
        });
    },
    _scheduleFailCallbacks: function(deferred) {
        var that = this;
        deferred.fail(function() {
            if (arguments[0] === $45e3ac8fbec1786a$var$CANCELED_TOKEN) return;
            that.fireEvent("loadError", arguments);
        });
    },
    _fireChanged: function(args) {
        var date = new Date;
        this.fireEvent("changed", args);
        this._changedTime = new Date - date;
    },
    _scheduleChangedCallbacks: function(deferred) {
        var _this2 = this;
        deferred.done(function() {
            _this2._fireChanged();
        });
    },
    loadSingle: function(propName, propValue) {
        var that = this;
        var d = new $45e3ac8fbec1786a$var$Deferred;
        var key = this.key();
        var store = this._store;
        var options = this._createStoreLoadOptions();
        var handleDone = function(data) {
            if (!$45e3ac8fbec1786a$var$__isDefined(data) || $aLQK5.isEmpty(data)) d.reject(new $45e3ac8fbec1786a$require$errors.Error("E4009"));
            else {
                if (!Array.isArray(data)) data = [
                    data
                ];
                d.resolve(that._applyMapFunction(data)[0]);
            }
        };
        this._scheduleFailCallbacks(d);
        if (arguments.length < 2) {
            propValue = propName;
            propName = key;
        }
        delete options.skip;
        delete options.group;
        delete options.refresh;
        delete options.pageIndex;
        delete options.searchString;
        function shouldForceByKey() {
            return store instanceof $e7444c4eb1c17401$exports && !store._byKeyViaLoad();
        }
        (function() {
            if (propName === key || shouldForceByKey()) return store.byKey(propValue, options);
            options.take = 1;
            options.filter = options.filter ? [
                options.filter,
                [
                    propName,
                    propValue
                ]
            ] : [
                propName,
                propValue
            ];
            return store.load(options);
        })().fail(d.reject).done(handleDone);
        return d.promise();
    },
    load: function() {
        var that = this;
        var d = new $45e3ac8fbec1786a$var$Deferred;
        function loadTask() {
            if (that._disposed) return;
            if (!$45e3ac8fbec1786a$var$isPending(d)) return;
            return that._loadFromStore(loadOperation, d);
        }
        this._scheduleLoadCallbacks(d);
        this._scheduleFailCallbacks(d);
        this._scheduleChangedCallbacks(d);
        var loadOperation = this._createLoadOperation(d);
        this.fireEvent("customizeStoreLoadOptions", [
            loadOperation
        ]);
        this._loadQueue.add(function() {
            if ("number" === typeof loadOperation.delay) that._delayedLoadTask = $2Mto0.executeAsync(loadTask, loadOperation.delay);
            else loadTask();
            return d.promise();
        });
        return d.promise({
            operationId: loadOperation.operationId
        });
    },
    _onPush: function(changes) {
        var _this3 = this;
        if (this._reshapeOnPush) this.load();
        else {
            this.fireEvent("changing", [
                {
                    changes: changes
                }
            ]);
            var group = this.group();
            var items = this.items();
            var groupLevel = 0;
            var dataSourceChanges = this.paginate() || group ? changes.filter(function(item) {
                return "update" === item.type;
            }) : changes;
            if (group) groupLevel = Array.isArray(group) ? group.length : 1;
            if (this._mapFunc) dataSourceChanges.forEach(function(item) {
                if ("insert" === item.type) item.data = _this3._mapFunc(item.data);
            });
            $852ad2a58fe2bfbc$export$65d4799c35eb3744(this.store(), items, dataSourceChanges, groupLevel, true);
            this._fireChanged([
                {
                    changes: changes
                }
            ]);
        }
    },
    _createLoadOperation: function(deferred) {
        var id = this._operationManager.add(deferred);
        var options = this._createStoreLoadOptions();
        deferred.always((function() {
            this._operationManager.remove(id);
        }).bind(this));
        return {
            operationId: id,
            storeLoadOptions: options
        };
    },
    reload: function() {
        var store = this.store();
        if (store instanceof $e7444c4eb1c17401$exports) store.clearRawDataCache();
        this._init();
        return this.load();
    },
    cancel: function(operationId) {
        return this._operationManager.cancel(operationId);
    },
    cancelAll: function() {
        return this._operationManager.cancelAll();
    },
    _addSearchOptions: function(storeLoadOptions) {
        if (this._disposed) return;
        if (this.store()._useDefaultSearch) this._addSearchFilter(storeLoadOptions);
        else {
            storeLoadOptions.searchOperation = this._searchOperation;
            storeLoadOptions.searchValue = this._searchValue;
            storeLoadOptions.searchExpr = this._searchExpr;
        }
    },
    _createStoreLoadOptions: function() {
        var result = $45e3ac8fbec1786a$require$extend({}, this._storeLoadOptions);
        this._addSearchOptions(result);
        if (this._paginate) {
            if (this._pageSize) {
                result.skip = this._pageIndex * this._pageSize;
                result.take = this._pageSize;
            }
        }
        result.userData = this._userData;
        return result;
    },
    _addSearchFilter: function(storeLoadOptions) {
        var value = this._searchValue;
        var op = this._searchOperation;
        var selector = this._searchExpr;
        var searchFilter = [];
        if (!value) return;
        if (!selector) selector = "this";
        if (!Array.isArray(selector)) selector = [
            selector
        ];
        $4Pwuy.each(selector, function(i, item) {
            if (searchFilter.length) searchFilter.push("or");
            searchFilter.push([
                item,
                op,
                value
            ]);
        });
        if (storeLoadOptions.filter) storeLoadOptions.filter = [
            searchFilter,
            storeLoadOptions.filter
        ];
        else storeLoadOptions.filter = searchFilter;
    },
    _loadFromStore: function(loadOptions, pendingDeferred) {
        var that = this;
        function handleSuccess(data, extra) {
            function processResult() {
                var loadResult = $45e3ac8fbec1786a$require$extend($45e3ac8fbec1786a$var$normalizeLoadResult(data, extra), loadOptions);
                that.fireEvent("customizeLoadResult", [
                    loadResult
                ]);
                $45e3ac8fbec1786a$var$when(loadResult.data).done(function(data) {
                    loadResult.data = data;
                    that._processStoreLoadResult(loadResult, pendingDeferred);
                }).fail(pendingDeferred.reject);
            }
            if (that._disposed) return;
            if (!$45e3ac8fbec1786a$var$isPending(pendingDeferred)) return;
            processResult();
        }
        if (loadOptions.data) return (new $45e3ac8fbec1786a$var$Deferred).resolve(loadOptions.data).done(handleSuccess);
        return this.store().load(loadOptions.storeLoadOptions).done(handleSuccess).fail(pendingDeferred.reject);
    },
    _processStoreLoadResult: function(loadResult, pendingDeferred) {
        var that = this;
        var data = loadResult.data;
        var extra = loadResult.extra;
        var storeLoadOptions = loadResult.storeLoadOptions;
        function resolvePendingDeferred() {
            that._isLoaded = true;
            that._totalCount = isFinite(extra.totalCount) ? extra.totalCount : -1;
            return pendingDeferred.resolve(data, extra);
        }
        function proceedLoadingTotalCount() {
            that.store().totalCount(storeLoadOptions).done(function(count) {
                extra.totalCount = count;
                resolvePendingDeferred();
            }).fail(pendingDeferred.reject);
        }
        if (that._disposed) return;
        data = that._applyPostProcessFunction(that._applyMapFunction(data));
        if (!$kDRxH.isPlainObject(extra)) extra = {};
        that._items = data;
        if (!data.length || !that._paginate || that._pageSize && data.length < that._pageSize) that._isLastPage = true;
        if (storeLoadOptions.requireTotalCount && !isFinite(extra.totalCount)) proceedLoadingTotalCount();
        else resolvePendingDeferred();
    },
    _applyMapFunction: function(data) {
        if (this._mapFunc) return $45e3ac8fbec1786a$var$mapDataRespectingGrouping(data, this._mapFunc, this.group());
        return data;
    },
    _applyPostProcessFunction: function(data) {
        if (this._postProcessFunc) return this._postProcessFunc(data);
        return data;
    }
}).include($cWRya);
$45e3ac8fbec1786a$export$accd73d198d77d2f = $45e3ac8fbec1786a$var$DataSource;
$45e3ac8fbec1786a$export$b542b8cb4d19a8a8 = $45e3ac8fbec1786a$var$normalizeDataSourceOptions;
$45e3ac8fbec1786a$export$39a9f23879314f2b = $45e3ac8fbec1786a$var$normalizeLoadResult;


var $17b240b889a91c20$require$DataSource = $45e3ac8fbec1786a$export$accd73d198d77d2f;

var $7I8Uw = parcelRequire("7I8Uw");
var $17b240b889a91c20$require$extend = $7I8Uw.extend;

var $17b240b889a91c20$require$normalizeDataSourceOptions = $45e3ac8fbec1786a$export$b542b8cb4d19a8a8;
var $17b240b889a91c20$var$DATA_SOURCE_OPTIONS_METHOD = "_dataSourceOptions";
var $17b240b889a91c20$var$DATA_SOURCE_CHANGED_METHOD = "_dataSourceChangedHandler";
var $17b240b889a91c20$var$DATA_SOURCE_LOAD_ERROR_METHOD = "_dataSourceLoadErrorHandler";
var $17b240b889a91c20$var$DATA_SOURCE_LOADING_CHANGED_METHOD = "_dataSourceLoadingChangedHandler";
var $17b240b889a91c20$var$DATA_SOURCE_FROM_URL_LOAD_MODE_METHOD = "_dataSourceFromUrlLoadMode";
var $17b240b889a91c20$var$SPECIFIC_DATA_SOURCE_OPTION = "_getSpecificDataSourceOption";
var $17b240b889a91c20$var$NORMALIZE_DATA_SOURCE = "_normalizeDataSource";
var $17b240b889a91c20$var$DataHelperMixin = {
    postCtor: function() {
        this.on("disposing", (function() {
            this._disposeDataSource();
        }).bind(this));
    },
    _refreshDataSource: function() {
        this._initDataSource();
        this._loadDataSource();
    },
    _initDataSource: function() {
        var dataSourceOptions = $17b240b889a91c20$var$SPECIFIC_DATA_SOURCE_OPTION in this ? this[$17b240b889a91c20$var$SPECIFIC_DATA_SOURCE_OPTION]() : this.option("dataSource");
        var widgetDataSourceOptions;
        var dataSourceType;
        this._disposeDataSource();
        if (dataSourceOptions) {
            if (dataSourceOptions instanceof $17b240b889a91c20$require$DataSource) {
                this._isSharedDataSource = true;
                this._dataSource = dataSourceOptions;
            } else {
                widgetDataSourceOptions = $17b240b889a91c20$var$DATA_SOURCE_OPTIONS_METHOD in this ? this[$17b240b889a91c20$var$DATA_SOURCE_OPTIONS_METHOD]() : {};
                dataSourceType = this._dataSourceType ? this._dataSourceType() : $17b240b889a91c20$require$DataSource;
                dataSourceOptions = $17b240b889a91c20$require$normalizeDataSourceOptions(dataSourceOptions, {
                    fromUrlLoadMode: $17b240b889a91c20$var$DATA_SOURCE_FROM_URL_LOAD_MODE_METHOD in this && this[$17b240b889a91c20$var$DATA_SOURCE_FROM_URL_LOAD_MODE_METHOD]()
                });
                this._dataSource = new dataSourceType($17b240b889a91c20$require$extend(true, {}, widgetDataSourceOptions, dataSourceOptions));
            }
            if ($17b240b889a91c20$var$NORMALIZE_DATA_SOURCE in this) this._dataSource = this[$17b240b889a91c20$var$NORMALIZE_DATA_SOURCE](this._dataSource);
            this._addDataSourceHandlers();
        }
    },
    _addDataSourceHandlers: function() {
        if ($17b240b889a91c20$var$DATA_SOURCE_CHANGED_METHOD in this) this._addDataSourceChangeHandler();
        if ($17b240b889a91c20$var$DATA_SOURCE_LOAD_ERROR_METHOD in this) this._addDataSourceLoadErrorHandler();
        if ($17b240b889a91c20$var$DATA_SOURCE_LOADING_CHANGED_METHOD in this) this._addDataSourceLoadingChangedHandler();
        this._addReadyWatcher();
    },
    _addReadyWatcher: function() {
        this._dataSource.on("loadingChanged", (function(isLoading) {
            this._ready && this._ready(!isLoading);
        }).bind(this));
    },
    _addDataSourceChangeHandler: function() {
        var dataSource = this._dataSource;
        this._proxiedDataSourceChangedHandler = (function(e) {
            this[$17b240b889a91c20$var$DATA_SOURCE_CHANGED_METHOD](dataSource.items(), e);
        }).bind(this);
        dataSource.on("changed", this._proxiedDataSourceChangedHandler);
    },
    _addDataSourceLoadErrorHandler: function() {
        this._proxiedDataSourceLoadErrorHandler = this[$17b240b889a91c20$var$DATA_SOURCE_LOAD_ERROR_METHOD].bind(this);
        this._dataSource.on("loadError", this._proxiedDataSourceLoadErrorHandler);
    },
    _addDataSourceLoadingChangedHandler: function() {
        this._proxiedDataSourceLoadingChangedHandler = this[$17b240b889a91c20$var$DATA_SOURCE_LOADING_CHANGED_METHOD].bind(this);
        this._dataSource.on("loadingChanged", this._proxiedDataSourceLoadingChangedHandler);
    },
    _loadDataSource: function() {
        if (this._dataSource) {
            var dataSource = this._dataSource;
            if (dataSource.isLoaded()) this._proxiedDataSourceChangedHandler && this._proxiedDataSourceChangedHandler();
            else dataSource.load();
        }
    },
    _loadSingle: function(key, value) {
        key = "this" === key ? this._dataSource.key() || "this" : key;
        return this._dataSource.loadSingle(key, value);
    },
    _isLastPage: function() {
        return !this._dataSource || this._dataSource.isLastPage() || !this._dataSource._pageSize;
    },
    _isDataSourceLoading: function() {
        return this._dataSource && this._dataSource.isLoading();
    },
    _disposeDataSource: function() {
        if (this._dataSource) {
            if (this._isSharedDataSource) {
                delete this._isSharedDataSource;
                this._proxiedDataSourceChangedHandler && this._dataSource.off("changed", this._proxiedDataSourceChangedHandler);
                this._proxiedDataSourceLoadErrorHandler && this._dataSource.off("loadError", this._proxiedDataSourceLoadErrorHandler);
                this._proxiedDataSourceLoadingChangedHandler && this._dataSource.off("loadingChanged", this._proxiedDataSourceLoadingChangedHandler);
            } else this._dataSource.dispose();
            delete this._dataSource;
            delete this._proxiedDataSourceChangedHandler;
            delete this._proxiedDataSourceLoadErrorHandler;
            delete this._proxiedDataSourceLoadingChangedHandler;
        }
    },
    getDataSource: function() {
        return this._dataSource || null;
    }
};
$17b240b889a91c20$exports = $17b240b889a91c20$var$DataHelperMixin;


var $84003155288ca038$var$_data_helper2 = $84003155288ca038$var$_interopRequireDefault($17b240b889a91c20$exports);
var $5bf3215940da1add$exports = {};
/**
 * DevExtreme (ui/collection/item.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $k7aJb = parcelRequire("k7aJb");

var $4Pwuy = parcelRequire("4Pwuy");
var $5bf3215940da1add$require$each = $4Pwuy.each;

var $3fgBn = parcelRequire("3fgBn");
var $5bf3215940da1add$var$INVISIBLE_STATE_CLASS = "dx-state-invisible";
var $5bf3215940da1add$var$DISABLED_STATE_CLASS = "dx-state-disabled";
var $5bf3215940da1add$var$ITEM_CONTENT_PLACEHOLDER_CLASS = "dx-item-content-placeholder";
var $5bf3215940da1add$var$forcibleWatcher = function(watchMethod, fn, callback) {
    var filteredCallback = function() {
        var oldValue;
        return function(value) {
            if (oldValue !== value) {
                callback(value, oldValue);
                oldValue = value;
            }
        };
    }();
    return {
        dispose: watchMethod(fn, filteredCallback),
        force: function() {
            filteredCallback(fn());
        }
    };
};
var $5bf3215940da1add$var$CollectionItem = $k7aJb.inherit({
    ctor: function($element, options, rawData) {
        this._$element = $element;
        this._options = options;
        this._rawData = rawData;
        $3fgBn.attachInstanceToElement($element, this, this._dispose);
        this._render();
    },
    _render: function() {
        var $placeholder = $jFnCG("<div>").addClass($5bf3215940da1add$var$ITEM_CONTENT_PLACEHOLDER_CLASS);
        this._$element.append($placeholder);
        this._watchers = [];
        this._renderWatchers();
    },
    _renderWatchers: function() {
        this._startWatcher("disabled", this._renderDisabled.bind(this));
        this._startWatcher("visible", this._renderVisible.bind(this));
    },
    _startWatcher: function(field, render) {
        var rawData = this._rawData;
        var exprGetter = this._options.fieldGetter(field);
        var watcher = $5bf3215940da1add$var$forcibleWatcher(this._options.watchMethod(), function() {
            return exprGetter(rawData);
        }, (function(value, oldValue) {
            this._dirty = true;
            render(value, oldValue);
        }).bind(this));
        this._watchers.push(watcher);
    },
    setDataField: function() {
        this._dirty = false;
        $5bf3215940da1add$require$each(this._watchers, function(_, watcher) {
            watcher.force();
        });
        if (this._dirty) return true;
    },
    _renderDisabled: function(value, oldValue) {
        this._$element.toggleClass($5bf3215940da1add$var$DISABLED_STATE_CLASS, !!value);
        this._updateOwnerFocus(value);
    },
    _updateOwnerFocus: function(isDisabled) {
        var ownerComponent = this._options.owner;
        if (ownerComponent && isDisabled) ownerComponent._resetItemFocus(this._$element);
    },
    _renderVisible: function(value, oldValue) {
        this._$element.toggleClass($5bf3215940da1add$var$INVISIBLE_STATE_CLASS, void 0 !== value && !value);
    },
    _dispose: function() {
        $5bf3215940da1add$require$each(this._watchers, function(_, watcher) {
            watcher.dispose();
        });
    }
});
$5bf3215940da1add$var$CollectionItem.getInstance = function($element) {
    return $3fgBn.getInstanceByElement($element, this);
};
$5bf3215940da1add$exports = $5bf3215940da1add$var$CollectionItem;


var $84003155288ca038$var$_item2 = $84003155288ca038$var$_interopRequireDefault($5bf3215940da1add$exports);

var $3joCJ = parcelRequire("3joCJ");
var $84003155288ca038$var$_selectors2 = $84003155288ca038$var$_interopRequireDefault($3joCJ);

var $cnVbh = parcelRequire("cnVbh");
var $84003155288ca038$var$_message2 = $84003155288ca038$var$_interopRequireDefault($cnVbh);
var $6051d3abef95c182$exports = {};
/**
 * DevExtreme (events/hold.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $bXb2w = parcelRequire("bXb2w");

var $lTdDg = parcelRequire("lTdDg");

var $fy5D5 = parcelRequire("fy5D5");
var $6051d3abef95c182$var$abs = Math.abs;
var $6051d3abef95c182$var$HOLD_EVENT_NAME = "dxhold";
var $6051d3abef95c182$var$HOLD_TIMEOUT = 750;
var $6051d3abef95c182$var$TOUCH_BOUNDARY = 5;
var $6051d3abef95c182$var$HoldEmitter = $lTdDg.inherit({
    start: function(e) {
        this._startEventData = $bXb2w.eventData(e);
        this._startTimer(e);
    },
    _startTimer: function(e) {
        var holdTimeout = "timeout" in this ? this.timeout : $6051d3abef95c182$var$HOLD_TIMEOUT;
        this._holdTimer = setTimeout((function() {
            this._requestAccept(e);
            this._fireEvent($6051d3abef95c182$var$HOLD_EVENT_NAME, e, {
                target: e.target
            });
            this._forgetAccept();
        }).bind(this), holdTimeout);
    },
    move: function(e) {
        if (this._touchWasMoved(e)) this._cancel(e);
    },
    _touchWasMoved: function(e) {
        var delta = $bXb2w.eventDelta(this._startEventData, $bXb2w.eventData(e));
        return $6051d3abef95c182$var$abs(delta.x) > $6051d3abef95c182$var$TOUCH_BOUNDARY || $6051d3abef95c182$var$abs(delta.y) > $6051d3abef95c182$var$TOUCH_BOUNDARY;
    },
    end: function() {
        this._stopTimer();
    },
    _stopTimer: function() {
        clearTimeout(this._holdTimer);
    },
    cancel: function() {
        this._stopTimer();
    },
    dispose: function() {
        this._stopTimer();
    }
});
$fy5D5({
    emitter: $6051d3abef95c182$var$HoldEmitter,
    bubble: true,
    events: [
        $6051d3abef95c182$var$HOLD_EVENT_NAME
    ]
});
$6051d3abef95c182$exports = {
    name: $6051d3abef95c182$var$HOLD_EVENT_NAME
};


var $84003155288ca038$var$_hold2 = $84003155288ca038$var$_interopRequireDefault($6051d3abef95c182$exports);

var $kpjzB = parcelRequire("kpjzB");

var $i7ZSP = parcelRequire("i7ZSP");
var $84003155288ca038$var$_click2 = $84003155288ca038$var$_interopRequireDefault($i7ZSP);
var $7e4286594eba04f0$exports = {};

$parcel$export($7e4286594eba04f0$exports, "name", () => $7e4286594eba04f0$export$a8ff84c12d48cfa6, (v) => $7e4286594eba04f0$export$a8ff84c12d48cfa6 = v);
/**
 * DevExtreme (events/contextmenu.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $7e4286594eba04f0$export$a8ff84c12d48cfa6;
"use strict";

var $jFnCG = parcelRequire("jFnCG");

var $e1LMc = parcelRequire("e1LMc");

var $6VAWB = parcelRequire("6VAWB");

var $aiwte = parcelRequire("aiwte");

var $k7aJb = parcelRequire("k7aJb");

var $cMvU0 = parcelRequire("cMvU0");

var $bXb2w = parcelRequire("bXb2w");

var $7e4286594eba04f0$var$CONTEXTMENU_NAMESPACE = "dxContexMenu";
var $7e4286594eba04f0$var$CONTEXTMENU_NAMESPACED_EVENT_NAME = $bXb2w.addNamespace("contextmenu", $7e4286594eba04f0$var$CONTEXTMENU_NAMESPACE);
var $7e4286594eba04f0$var$HOLD_NAMESPACED_EVENT_NAME = $bXb2w.addNamespace($6051d3abef95c182$exports.name, $7e4286594eba04f0$var$CONTEXTMENU_NAMESPACE);
var $7e4286594eba04f0$var$CONTEXTMENU_EVENT_NAME = "dxcontextmenu";
var $7e4286594eba04f0$var$ContextMenu = $k7aJb.inherit({
    setup: function(element) {
        var $element = $jFnCG(element);
        $e1LMc.on($element, $7e4286594eba04f0$var$CONTEXTMENU_NAMESPACED_EVENT_NAME, this._contextMenuHandler.bind(this));
        if ($6VAWB.touch || $aiwte.isSimulator()) $e1LMc.on($element, $7e4286594eba04f0$var$HOLD_NAMESPACED_EVENT_NAME, this._holdHandler.bind(this));
    },
    _holdHandler: function(e) {
        if ($bXb2w.isMouseEvent(e) && !$aiwte.isSimulator()) return;
        this._fireContextMenu(e);
    },
    _contextMenuHandler: function(e) {
        this._fireContextMenu(e);
    },
    _fireContextMenu: function(e) {
        return $bXb2w.fireEvent({
            type: $7e4286594eba04f0$var$CONTEXTMENU_EVENT_NAME,
            originalEvent: e
        });
    },
    teardown: function(element) {
        $e1LMc.off(element, "." + $7e4286594eba04f0$var$CONTEXTMENU_NAMESPACE);
    }
});
$cMvU0($7e4286594eba04f0$var$CONTEXTMENU_EVENT_NAME, new $7e4286594eba04f0$var$ContextMenu);
$7e4286594eba04f0$export$a8ff84c12d48cfa6 = $7e4286594eba04f0$var$CONTEXTMENU_EVENT_NAME;


var $84003155288ca038$var$_contextmenu2 = $84003155288ca038$var$_interopRequireDefault($7e4286594eba04f0$exports);
var $46d7ae10a89c38af$exports = {};
/**
 * DevExtreme (core/templates/bindable_template.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty($46d7ae10a89c38af$exports, "__esModule", {
    value: true
});
$46d7ae10a89c38af$exports.BindableTemplate = void 0;

var $jFnCG = parcelRequire("jFnCG");
var $46d7ae10a89c38af$var$_renderer2 = $46d7ae10a89c38af$var$_interopRequireDefault($jFnCG);

var $9tMwv = parcelRequire("9tMwv");

var $e1LMc = parcelRequire("e1LMc");

var $hw2F9 = parcelRequire("hw2F9");
var $46d7ae10a89c38af$var$_remove_event2 = $46d7ae10a89c38af$var$_interopRequireDefault($hw2F9);

var $kDRxH = parcelRequire("kDRxH");
function $46d7ae10a89c38af$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $46d7ae10a89c38af$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $46d7ae10a89c38af$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $46d7ae10a89c38af$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $46d7ae10a89c38af$var$_typeof(obj);
}
function $46d7ae10a89c38af$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $46d7ae10a89c38af$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $46d7ae10a89c38af$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $46d7ae10a89c38af$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $46d7ae10a89c38af$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $46d7ae10a89c38af$var$_inherits(subClass, superClass) {
    if ("function" !== typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $46d7ae10a89c38af$var$_setPrototypeOf(subClass, superClass);
}
function $46d7ae10a89c38af$var$_setPrototypeOf(o, p) {
    $46d7ae10a89c38af$var$_setPrototypeOf = Object.setPrototypeOf || function(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $46d7ae10a89c38af$var$_setPrototypeOf(o, p);
}
function $46d7ae10a89c38af$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $46d7ae10a89c38af$var$_isNativeReflectConstruct();
    return function() {
        var result, Super = $46d7ae10a89c38af$var$_getPrototypeOf(Derived);
        if (hasNativeReflectConstruct) {
            var NewTarget = $46d7ae10a89c38af$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $46d7ae10a89c38af$var$_possibleConstructorReturn(this, result);
    };
}
function $46d7ae10a89c38af$var$_possibleConstructorReturn(self, call) {
    if (call && ("object" === $46d7ae10a89c38af$var$_typeof(call) || "function" === typeof call)) return call;
    return $46d7ae10a89c38af$var$_assertThisInitialized(self);
}
function $46d7ae10a89c38af$var$_assertThisInitialized(self) {
    if (void 0 === self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $46d7ae10a89c38af$var$_isNativeReflectConstruct() {
    if ("undefined" === typeof Reflect || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if ("function" === typeof Proxy) return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $46d7ae10a89c38af$var$_getPrototypeOf(o) {
    $46d7ae10a89c38af$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $46d7ae10a89c38af$var$_getPrototypeOf(o);
}
var $46d7ae10a89c38af$var$watchChanges = function() {
    var globalWatch = function(data, watchMethod, callback) {
        return watchMethod(function() {
            return data;
        }, callback);
    };
    var fieldsWatch = function(data, watchMethod, fields, fieldsMap, callback) {
        var resolvedData = {};
        var missedFields = fields.slice();
        var watchHandlers = fields.map(function(name) {
            var fieldGetter = fieldsMap[name];
            return watchMethod(fieldGetter ? function() {
                return fieldGetter(data);
            } : function() {
                return data[name];
            }, function(value) {
                resolvedData[name] = value;
                if (missedFields.length) {
                    var index = missedFields.indexOf(name);
                    if (index >= 0) missedFields.splice(index, 1);
                }
                if (!missedFields.length) callback(resolvedData);
            });
        });
        return function() {
            watchHandlers.forEach(function(dispose) {
                return dispose();
            });
        };
    };
    return function(rawData, watchMethod, fields, fieldsMap, callback) {
        var fieldsDispose;
        var globalDispose = globalWatch(rawData, watchMethod, function(dataWithRawFields) {
            fieldsDispose && fieldsDispose();
            if ((0, $kDRxH.isPrimitive)(dataWithRawFields)) {
                callback(dataWithRawFields);
                return;
            }
            fieldsDispose = fieldsWatch(dataWithRawFields, watchMethod, fields, fieldsMap, callback);
        });
        return function() {
            fieldsDispose && fieldsDispose();
            globalDispose && globalDispose();
        };
    };
}();
var $46d7ae10a89c38af$var$BindableTemplate = $46d7ae10a89c38af$exports.BindableTemplate = function(_TemplateBase) {
    $46d7ae10a89c38af$var$_inherits(BindableTemplate, _TemplateBase);
    var _super = $46d7ae10a89c38af$var$_createSuper(BindableTemplate);
    function BindableTemplate(render, fields, watchMethod, fieldsMap) {
        var _this;
        $46d7ae10a89c38af$var$_classCallCheck(this, BindableTemplate);
        _this = _super.call(this);
        _this._render = render;
        _this._fields = fields;
        _this._fieldsMap = fieldsMap || {};
        _this._watchMethod = watchMethod;
        return _this;
    }
    $46d7ae10a89c38af$var$_createClass(BindableTemplate, [
        {
            key: "_renderCore",
            value: function(options) {
                var _this2 = this;
                var $container = (0, $46d7ae10a89c38af$var$_renderer2.default)(options.container);
                var dispose = $46d7ae10a89c38af$var$watchChanges(options.model, this._watchMethod, this._fields, this._fieldsMap, function(data) {
                    $container.empty();
                    _this2._render($container, data, options.model);
                });
                (0, $e1LMc.on)($container, $46d7ae10a89c38af$var$_remove_event2.default, dispose);
                return $container.contents();
            }
        }
    ]);
    return BindableTemplate;
}($9tMwv.TemplateBase);


function $84003155288ca038$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $84003155288ca038$var$COLLECTION_CLASS = "dx-collection";
var $84003155288ca038$var$ITEM_CLASS = "dx-item";
var $84003155288ca038$var$CONTENT_CLASS_POSTFIX = "-content";
var $84003155288ca038$var$ITEM_CONTENT_PLACEHOLDER_CLASS = "dx-item-content-placeholder";
var $84003155288ca038$var$ITEM_DATA_KEY = "dxItemData";
var $84003155288ca038$var$ITEM_INDEX_KEY = "dxItemIndex";
var $84003155288ca038$var$ITEM_TEMPLATE_ID_PREFIX = "tmpl-";
var $84003155288ca038$var$ITEMS_SELECTOR = "[data-options*='dxItem']";
var $84003155288ca038$var$SELECTED_ITEM_CLASS = "dx-item-selected";
var $84003155288ca038$var$ITEM_RESPONSE_WAIT_CLASS = "dx-item-response-wait";
var $84003155288ca038$var$EMPTY_COLLECTION = "dx-empty-collection";
var $84003155288ca038$var$TEMPLATE_WRAPPER_CLASS = "dx-template-wrapper";
var $84003155288ca038$var$ITEM_PATH_REGEX = /^([^.]+\[\d+\]\.)+([\w.]+)$/;
var $84003155288ca038$var$FOCUS_UP = "up";
var $84003155288ca038$var$FOCUS_DOWN = "down";
var $84003155288ca038$var$FOCUS_LEFT = "left";
var $84003155288ca038$var$FOCUS_RIGHT = "right";
var $84003155288ca038$var$FOCUS_PAGE_UP = "pageup";
var $84003155288ca038$var$FOCUS_PAGE_DOWN = "pagedown";
var $84003155288ca038$var$FOCUS_LAST = "last";
var $84003155288ca038$var$FOCUS_FIRST = "first";
var $84003155288ca038$var$CollectionWidget = $84003155288ca038$var$_ui2.default.inherit({
    _activeStateUnit: "." + $84003155288ca038$var$ITEM_CLASS,
    _supportedKeys: function() {
        var enter = function(e) {
            var $itemElement = (0, $84003155288ca038$var$_renderer2.default)(this.option("focusedElement"));
            if (!$itemElement.length) return;
            this._itemClickHandler((0, $7I8Uw.extend)({}, e, {
                target: $itemElement,
                currentTarget: $itemElement
            }));
        };
        var space = function(e) {
            e.preventDefault();
            enter.call(this, e);
        };
        var move = function(location, e) {
            e.preventDefault();
            e.stopPropagation();
            this._moveFocus(location, e);
        };
        return (0, $7I8Uw.extend)(this.callBase(), {
            space: space,
            enter: enter,
            leftArrow: move.bind(this, $84003155288ca038$var$FOCUS_LEFT),
            rightArrow: move.bind(this, $84003155288ca038$var$FOCUS_RIGHT),
            upArrow: move.bind(this, $84003155288ca038$var$FOCUS_UP),
            downArrow: move.bind(this, $84003155288ca038$var$FOCUS_DOWN),
            pageUp: move.bind(this, $84003155288ca038$var$FOCUS_UP),
            pageDown: move.bind(this, $84003155288ca038$var$FOCUS_DOWN),
            home: move.bind(this, $84003155288ca038$var$FOCUS_FIRST),
            end: move.bind(this, $84003155288ca038$var$FOCUS_LAST)
        });
    },
    _getDefaultOptions: function() {
        return (0, $7I8Uw.extend)(this.callBase(), {
            selectOnFocus: false,
            loopItemFocus: true,
            items: [],
            itemTemplate: "item",
            onItemRendered: null,
            onItemClick: null,
            onItemHold: null,
            itemHoldTimeout: 750,
            onItemContextMenu: null,
            onFocusedItemChanged: null,
            noDataText: $84003155288ca038$var$_message2.default.format("dxCollectionWidget-noDataText"),
            dataSource: null,
            _itemAttributes: {},
            itemTemplateProperty: "template",
            focusOnSelectedItem: true,
            focusedElement: null,
            displayExpr: void 0,
            disabledExpr: function(data) {
                return data ? data.disabled : void 0;
            },
            visibleExpr: function(data) {
                return data ? data.visible : void 0;
            }
        });
    },
    _getAnonymousTemplateName: function() {
        return "item";
    },
    _init: function() {
        this._compileDisplayGetter();
        this.callBase();
        this._cleanRenderedItems();
        this._refreshDataSource();
    },
    _compileDisplayGetter: function() {
        var displayExpr = this.option("displayExpr");
        this._displayGetter = displayExpr ? (0, $kpjzB.compileGetter)(this.option("displayExpr")) : void 0;
    },
    _initTemplates: function() {
        this._initItemsFromMarkup();
        this.callBase();
        this._initDefaultItemTemplate();
    },
    _initDefaultItemTemplate: function() {
        var fieldsMap = this._getFieldsMap();
        this._defaultTemplates.item = new $46d7ae10a89c38af$exports.BindableTemplate((function($container, data) {
            if ((0, $kDRxH.isPlainObject)(data)) this._prepareDefaultItemTemplate(data, $container);
            else {
                if (fieldsMap && (0, $kDRxH.isFunction)(fieldsMap.text)) data = fieldsMap.text(data);
                $container.text(String($84003155288ca038$var$_common2.default.ensureDefined(data, "")));
            }
        }).bind(this), this._getBindableFields(), this.option("integrationOptions.watchMethod"), fieldsMap);
    },
    _getBindableFields: function() {
        return [
            "text",
            "html"
        ];
    },
    _getFieldsMap: function() {
        if (this._displayGetter) return {
            text: this._displayGetter
        };
    },
    _prepareDefaultItemTemplate: function(data, $container) {
        if ((0, $kDRxH.isDefined)(data.text)) $container.text(data.text);
        if ((0, $kDRxH.isDefined)(data.html)) $container.html(data.html);
    },
    _initItemsFromMarkup: function() {
        var _this = this;
        var $items = this.$element().contents().filter($84003155288ca038$var$ITEMS_SELECTOR);
        if (!$items.length || this.option("items").length) return;
        var items = [].slice.call($items).map(function(item) {
            var $item = (0, $84003155288ca038$var$_renderer2.default)(item);
            var result = (0, $5OzEX.getElementOptions)(item).dxItem;
            var isTemplateRequired = $item.html().trim() && !result.template;
            if (isTemplateRequired) result.template = _this._prepareItemTemplate($item);
            else $item.remove();
            return result;
        });
        this.option("items", items);
    },
    _prepareItemTemplate: function($item) {
        var templateId = $84003155288ca038$var$ITEM_TEMPLATE_ID_PREFIX + new $84003155288ca038$var$_guid2.default;
        var $template = $item.detach().clone().removeAttr("data-options").addClass($84003155288ca038$var$TEMPLATE_WRAPPER_CLASS);
        this._saveTemplate(templateId, $template);
        return templateId;
    },
    _dataSourceOptions: function() {
        return {
            paginate: false
        };
    },
    _cleanRenderedItems: function() {
        this._renderedItemsCount = 0;
    },
    _focusTarget: function() {
        return this.$element();
    },
    _focusInHandler: function(e) {
        this.callBase.apply(this, arguments);
        if ((0, $aLQK5.inArray)(e.target, this._focusTarget()) === -1) return;
        var $focusedElement = (0, $84003155288ca038$var$_renderer2.default)(this.option("focusedElement"));
        if ($focusedElement.length) this._setFocusedItem($focusedElement);
        else {
            var $activeItem = this._getActiveItem();
            if ($activeItem.length) this.option("focusedElement", (0, $5OzEX.getPublicElement)($activeItem));
        }
    },
    _focusOutHandler: function() {
        this.callBase.apply(this, arguments);
        var $target = (0, $84003155288ca038$var$_renderer2.default)(this.option("focusedElement"));
        this._updateFocusedItemState($target, false);
    },
    _getActiveItem: function(last) {
        var $focusedElement = (0, $84003155288ca038$var$_renderer2.default)(this.option("focusedElement"));
        if ($focusedElement.length) return $focusedElement;
        var index = this.option("focusOnSelectedItem") ? this.option("selectedIndex") : 0;
        var activeElements = this._getActiveElement();
        var lastIndex = activeElements.length - 1;
        if (index < 0) index = last ? lastIndex : 0;
        return activeElements.eq(index);
    },
    _moveFocus: function(location) {
        var $items = this._getAvailableItems();
        var $newTarget;
        switch(location){
            case $84003155288ca038$var$FOCUS_PAGE_UP:
            case $84003155288ca038$var$FOCUS_UP:
                $newTarget = this._prevItem($items);
                break;
            case $84003155288ca038$var$FOCUS_PAGE_DOWN:
            case $84003155288ca038$var$FOCUS_DOWN:
                $newTarget = this._nextItem($items);
                break;
            case $84003155288ca038$var$FOCUS_RIGHT:
                $newTarget = this.option("rtlEnabled") ? this._prevItem($items) : this._nextItem($items);
                break;
            case $84003155288ca038$var$FOCUS_LEFT:
                $newTarget = this.option("rtlEnabled") ? this._nextItem($items) : this._prevItem($items);
                break;
            case $84003155288ca038$var$FOCUS_FIRST:
                $newTarget = $items.first();
                break;
            case $84003155288ca038$var$FOCUS_LAST:
                $newTarget = $items.last();
                break;
            default:
                return false;
        }
        if (0 !== $newTarget.length) this.option("focusedElement", (0, $5OzEX.getPublicElement)($newTarget));
    },
    _getVisibleItems: function($itemElements) {
        $itemElements = $itemElements || this._itemElements();
        return $itemElements.filter(":visible");
    },
    _getAvailableItems: function($itemElements) {
        return this._getVisibleItems($itemElements).not(".dx-state-disabled");
    },
    _prevItem: function($items) {
        var $target = this._getActiveItem();
        var targetIndex = $items.index($target);
        var $last = $items.last();
        var $item = (0, $84003155288ca038$var$_renderer2.default)($items[targetIndex - 1]);
        var loop = this.option("loopItemFocus");
        if (0 === $item.length && loop) $item = $last;
        return $item;
    },
    _nextItem: function($items) {
        var $target = this._getActiveItem(true);
        var targetIndex = $items.index($target);
        var $first = $items.first();
        var $item = (0, $84003155288ca038$var$_renderer2.default)($items[targetIndex + 1]);
        var loop = this.option("loopItemFocus");
        if (0 === $item.length && loop) $item = $first;
        return $item;
    },
    _selectFocusedItem: function($target) {
        this.selectItem($target);
    },
    _updateFocusedItemState: function(target, isFocused, needCleanItemId) {
        var $target = (0, $84003155288ca038$var$_renderer2.default)(target);
        if ($target.length) {
            this._refreshActiveDescendant();
            this._refreshItemId($target, needCleanItemId);
            this._toggleFocusClass(isFocused, $target);
        }
    },
    _refreshActiveDescendant: function($target) {
        this.setAria("activedescendant", (0, $kDRxH.isDefined)(this.option("focusedElement")) ? this.getFocusedItemId() : null, $target);
    },
    _refreshItemId: function($target, needCleanItemId) {
        if (!needCleanItemId && this.option("focusedElement")) this.setAria("id", this.getFocusedItemId(), $target);
        else this.setAria("id", null, $target);
    },
    _setFocusedItem: function($target) {
        if (!$target || !$target.length) return;
        this._updateFocusedItemState($target, true);
        this.onFocusedItemChanged(this.getFocusedItemId());
        if (this.option("selectOnFocus")) this._selectFocusedItem($target);
    },
    _findItemElementByItem: function(item) {
        var result = (0, $84003155288ca038$var$_renderer2.default)();
        var that = this;
        this.itemElements().each(function() {
            var $item = (0, $84003155288ca038$var$_renderer2.default)(this);
            if ($item.data(that._itemDataKey()) === item) {
                result = $item;
                return false;
            }
        });
        return result;
    },
    _getIndexByItem: function(item) {
        return this.option("items").indexOf(item);
    },
    _itemOptionChanged: function(item, property, value, oldValue) {
        var $item = this._findItemElementByItem(item);
        if (!$item.length) return;
        if (!this.constructor.ItemClass.getInstance($item).setDataField(property, value)) this._refreshItem($item, item);
        var isDisabling = "disabled" === property && value;
        if (isDisabling) this._resetItemFocus($item);
    },
    _resetItemFocus: function($item) {
        if ($item.is(this.option("focusedElement"))) this.option("focusedElement", null);
    },
    _refreshItem: function($item) {
        var itemData = this._getItemData($item);
        var index = $item.data(this._itemIndexKey());
        this._renderItem(this._renderedItemsCount + index, itemData, null, $item);
    },
    _optionChanged: function(args) {
        if ("items" === args.name) {
            var matches = args.fullName.match($84003155288ca038$var$ITEM_PATH_REGEX);
            if (matches && matches.length) {
                var property = matches[matches.length - 1];
                var itemPath = args.fullName.replace("." + property, "");
                var item = this.option(itemPath);
                this._itemOptionChanged(item, property, args.value, args.previousValue);
                return;
            }
        }
        switch(args.name){
            case "items":
            case "_itemAttributes":
            case "itemTemplateProperty":
            case "showItemDataTitle":
                this._cleanRenderedItems();
                this._invalidate();
                break;
            case "dataSource":
                this._refreshDataSource();
                this._renderEmptyMessage();
                break;
            case "noDataText":
                this._renderEmptyMessage();
                break;
            case "itemTemplate":
                this._invalidate();
                break;
            case "onItemRendered":
                this._createItemRenderAction();
                break;
            case "onItemClick":
                break;
            case "onItemHold":
            case "itemHoldTimeout":
                this._attachHoldEvent();
                break;
            case "onItemContextMenu":
                this._attachContextMenuEvent();
                break;
            case "onFocusedItemChanged":
                this.onFocusedItemChanged = this._createActionByOption("onFocusedItemChanged");
                break;
            case "selectOnFocus":
            case "loopItemFocus":
            case "focusOnSelectedItem":
                break;
            case "focusedElement":
                this._updateFocusedItemState(args.previousValue, false, true);
                this._setFocusedItem((0, $84003155288ca038$var$_renderer2.default)(args.value));
                break;
            case "displayExpr":
                this._compileDisplayGetter();
                this._initDefaultItemTemplate();
                this._invalidate();
                break;
            case "visibleExpr":
            case "disabledExpr":
                this._invalidate();
                break;
            default:
                this.callBase(args);
        }
    },
    _invalidate: function() {
        this.option("focusedElement", null);
        return this.callBase.apply(this, arguments);
    },
    _loadNextPage: function() {
        var dataSource = this._dataSource;
        this._expectNextPageLoading();
        dataSource.pageIndex(1 + dataSource.pageIndex());
        return dataSource.load();
    },
    _expectNextPageLoading: function() {
        this._startIndexForAppendedItems = 0;
    },
    _expectLastItemLoading: function() {
        this._startIndexForAppendedItems = -1;
    },
    _forgetNextPageLoading: function() {
        this._startIndexForAppendedItems = null;
    },
    _dataSourceChangedHandler: function(newItems) {
        var items = this.option("items");
        if (this._initialized && items && this._shouldAppendItems()) {
            this._renderedItemsCount = items.length;
            if (!this._isLastPage() || this._startIndexForAppendedItems !== -1) this.option().items = items.concat(newItems.slice(this._startIndexForAppendedItems));
            this._forgetNextPageLoading();
            this._refreshContent();
        } else this.option("items", newItems.slice());
    },
    _refreshContent: function() {
        this._prepareContent();
        this._renderContent();
    },
    _dataSourceLoadErrorHandler: function() {
        this._forgetNextPageLoading();
        this.option("items", this.option("items"));
    },
    _shouldAppendItems: function() {
        return null != this._startIndexForAppendedItems && this._allowDynamicItemsAppend();
    },
    _allowDynamicItemsAppend: function() {
        return false;
    },
    _clean: function() {
        this._cleanFocusState();
        this._cleanItemContainer();
    },
    _cleanItemContainer: function() {
        (0, $84003155288ca038$var$_renderer2.default)(this._itemContainer()).empty();
    },
    _dispose: function() {
        this.callBase();
        clearTimeout(this._itemFocusTimeout);
    },
    _refresh: function() {
        this._cleanRenderedItems();
        this.callBase.apply(this, arguments);
    },
    _itemContainer: function() {
        return this.$element();
    },
    _itemClass: function() {
        return $84003155288ca038$var$ITEM_CLASS;
    },
    _itemContentClass: function() {
        return this._itemClass() + $84003155288ca038$var$CONTENT_CLASS_POSTFIX;
    },
    _selectedItemClass: function() {
        return $84003155288ca038$var$SELECTED_ITEM_CLASS;
    },
    _itemResponseWaitClass: function() {
        return $84003155288ca038$var$ITEM_RESPONSE_WAIT_CLASS;
    },
    _itemSelector: function() {
        return "." + this._itemClass();
    },
    _itemDataKey: function() {
        return $84003155288ca038$var$ITEM_DATA_KEY;
    },
    _itemIndexKey: function() {
        return $84003155288ca038$var$ITEM_INDEX_KEY;
    },
    _itemElements: function() {
        return this._itemContainer().find(this._itemSelector());
    },
    _initMarkup: function() {
        this.callBase();
        this.onFocusedItemChanged = this._createActionByOption("onFocusedItemChanged");
        this.$element().addClass($84003155288ca038$var$COLLECTION_CLASS);
        this._prepareContent();
    },
    _prepareContent: $84003155288ca038$var$_common2.default.deferRenderer(function() {
        this._renderContentImpl();
    }),
    _renderContent: function() {
        this._fireContentReadyAction();
    },
    _render: function() {
        this.callBase();
        this._attachClickEvent();
        this._attachHoldEvent();
        this._attachContextMenuEvent();
    },
    _attachClickEvent: function() {
        var itemSelector = this._itemSelector();
        var clickEventNamespace = $84003155288ca038$var$_utils2.default.addNamespace($84003155288ca038$var$_click2.default.name, this.NAME);
        var pointerDownEventNamespace = $84003155288ca038$var$_utils2.default.addNamespace($84003155288ca038$var$_pointer2.default.down, this.NAME);
        var that = this;
        var pointerDownAction = new $84003155288ca038$var$_action2.default(function(args) {
            var event = args.event;
            that._itemPointerDownHandler(event);
        });
        $84003155288ca038$var$_events_engine2.default.off(this._itemContainer(), clickEventNamespace, itemSelector);
        $84003155288ca038$var$_events_engine2.default.off(this._itemContainer(), pointerDownEventNamespace, itemSelector);
        $84003155288ca038$var$_events_engine2.default.on(this._itemContainer(), clickEventNamespace, itemSelector, (function(e) {
            this._itemClickHandler(e);
        }).bind(this));
        $84003155288ca038$var$_events_engine2.default.on(this._itemContainer(), pointerDownEventNamespace, itemSelector, function(e) {
            pointerDownAction.execute({
                element: (0, $84003155288ca038$var$_renderer2.default)(e.target),
                event: e
            });
        });
    },
    _itemClickHandler: function(e, args, config) {
        this._itemDXEventHandler(e, "onItemClick", args, config);
    },
    _itemPointerDownHandler: function(e) {
        if (!this.option("focusStateEnabled")) return;
        this._itemFocusHandler = (function() {
            clearTimeout(this._itemFocusTimeout);
            this._itemFocusHandler = null;
            if (e.isDefaultPrevented()) return;
            var $target = (0, $84003155288ca038$var$_renderer2.default)(e.target);
            var $closestItem = $target.closest(this._itemElements());
            var $closestFocusable = this._closestFocusable($target);
            if ($closestItem.length && $closestFocusable && (0, $aLQK5.inArray)($closestFocusable.get(0), this._focusTarget()) !== -1) this.option("focusedElement", (0, $5OzEX.getPublicElement)($closestItem));
        }).bind(this);
        this._itemFocusTimeout = setTimeout(this._forcePointerDownFocus.bind(this));
    },
    _closestFocusable: function($target) {
        if ($target.is($84003155288ca038$var$_selectors2.default.focusable)) return $target;
        else {
            $target = $target.parent();
            while($target.length && !$84003155288ca038$var$_dom_adapter2.default.isDocument($target.get(0))){
                if ($target.is($84003155288ca038$var$_selectors2.default.focusable)) return $target;
                $target = $target.parent();
            }
        }
    },
    _forcePointerDownFocus: function() {
        this._itemFocusHandler && this._itemFocusHandler();
    },
    _updateFocusState: function() {
        this.callBase.apply(this, arguments);
        this._forcePointerDownFocus();
    },
    _attachHoldEvent: function() {
        var $itemContainer = this._itemContainer();
        var itemSelector = this._itemSelector();
        var eventName = $84003155288ca038$var$_utils2.default.addNamespace($84003155288ca038$var$_hold2.default.name, this.NAME);
        $84003155288ca038$var$_events_engine2.default.off($itemContainer, eventName, itemSelector);
        $84003155288ca038$var$_events_engine2.default.on($itemContainer, eventName, itemSelector, {
            timeout: this._getHoldTimeout()
        }, this._itemHoldHandler.bind(this));
    },
    _getHoldTimeout: function() {
        return this.option("itemHoldTimeout");
    },
    _shouldFireHoldEvent: function() {
        return this.hasActionSubscription("onItemHold");
    },
    _itemHoldHandler: function(e) {
        if (this._shouldFireHoldEvent()) this._itemDXEventHandler(e, "onItemHold");
        else e.cancel = true;
    },
    _attachContextMenuEvent: function() {
        var $itemContainer = this._itemContainer();
        var itemSelector = this._itemSelector();
        var eventName = $84003155288ca038$var$_utils2.default.addNamespace($84003155288ca038$var$_contextmenu2.default.name, this.NAME);
        $84003155288ca038$var$_events_engine2.default.off($itemContainer, eventName, itemSelector);
        $84003155288ca038$var$_events_engine2.default.on($itemContainer, eventName, itemSelector, this._itemContextMenuHandler.bind(this));
    },
    _shouldFireContextMenuEvent: function() {
        return this.hasActionSubscription("onItemContextMenu");
    },
    _itemContextMenuHandler: function(e) {
        if (this._shouldFireContextMenuEvent()) this._itemDXEventHandler(e, "onItemContextMenu");
        else e.cancel = true;
    },
    _renderContentImpl: function() {
        var items = this.option("items") || [];
        if (this._renderedItemsCount) this._renderItems(items.slice(this._renderedItemsCount));
        else this._renderItems(items);
    },
    _renderItems: function(items) {
        if (items.length) $84003155288ca038$var$_iterator2.default.each(items, (function(index, itemData) {
            this._renderItem(this._renderedItemsCount + index, itemData);
        }).bind(this));
        this._renderEmptyMessage();
    },
    _renderItem: function(index, itemData, $container, $itemToReplace) {
        $container = $container || this._itemContainer();
        var $itemFrame = this._renderItemFrame(index, itemData, $container, $itemToReplace);
        this._setElementData($itemFrame, itemData, index);
        $itemFrame.attr(this.option("_itemAttributes"));
        this._attachItemClickEvent(itemData, $itemFrame);
        var $itemContent = this._getItemContent($itemFrame);
        var renderContentPromise = this._renderItemContent({
            index: index,
            itemData: itemData,
            container: (0, $5OzEX.getPublicElement)($itemContent),
            contentClass: this._itemContentClass(),
            defaultTemplateName: this.option("itemTemplate")
        });
        var that = this;
        (0, $2F60d.when)(renderContentPromise).done(function($itemContent) {
            that._postprocessRenderItem({
                itemElement: $itemFrame,
                itemContent: $itemContent,
                itemData: itemData,
                itemIndex: index
            });
            that._executeItemRenderAction(index, itemData, (0, $5OzEX.getPublicElement)($itemFrame));
        });
        return $itemFrame;
    },
    _getItemContent: function($itemFrame) {
        var $itemContent = $itemFrame.find("." + $84003155288ca038$var$ITEM_CONTENT_PLACEHOLDER_CLASS);
        $itemContent.removeClass($84003155288ca038$var$ITEM_CONTENT_PLACEHOLDER_CLASS);
        return $itemContent;
    },
    _attachItemClickEvent: function(itemData, $itemElement) {
        if (!itemData || !itemData.onClick) return;
        $84003155288ca038$var$_events_engine2.default.on($itemElement, $84003155288ca038$var$_click2.default.name, (function(e) {
            this._itemEventHandlerByHandler($itemElement, itemData.onClick, {
                event: e
            });
        }).bind(this));
    },
    _renderItemContent: function(args) {
        var itemTemplateName = this._getItemTemplateName(args);
        var itemTemplate = this._getTemplate(itemTemplateName);
        this._addItemContentClasses(args);
        var $templateResult = (0, $84003155288ca038$var$_renderer2.default)(this._createItemByTemplate(itemTemplate, args));
        if (!$templateResult.hasClass($84003155288ca038$var$TEMPLATE_WRAPPER_CLASS)) return args.container;
        return this._renderItemContentByNode(args, $templateResult);
    },
    _renderItemContentByNode: function(args, $node) {
        (0, $84003155288ca038$var$_renderer2.default)(args.container).replaceWith($node);
        args.container = (0, $5OzEX.getPublicElement)($node);
        this._addItemContentClasses(args);
        return $node;
    },
    _addItemContentClasses: function(args) {
        var classes = [
            $84003155288ca038$var$ITEM_CLASS + $84003155288ca038$var$CONTENT_CLASS_POSTFIX,
            args.contentClass
        ];
        (0, $84003155288ca038$var$_renderer2.default)(args.container).addClass(classes.join(" "));
    },
    _appendItemToContainer: function($container, $itemFrame, index) {
        $itemFrame.appendTo($container);
    },
    _renderItemFrame: function(index, itemData, $container, $itemToReplace) {
        var $itemFrame = (0, $84003155288ca038$var$_renderer2.default)("<div>");
        new this.constructor.ItemClass($itemFrame, this._itemOptions(), itemData || {});
        if ($itemToReplace && $itemToReplace.length) $itemToReplace.replaceWith($itemFrame);
        else this._appendItemToContainer.call(this, $container, $itemFrame, index);
        if (this.option("showItemDataTitle")) {
            var displayValue = this._displayGetter ? this._displayGetter(itemData) : itemData;
            $itemFrame.attr("title", displayValue);
        }
        return $itemFrame;
    },
    _itemOptions: function() {
        var that = this;
        return {
            watchMethod: function() {
                return that.option("integrationOptions.watchMethod");
            },
            owner: that,
            fieldGetter: function(field) {
                var expr = that.option(field + "Expr");
                var getter = (0, $kpjzB.compileGetter)(expr);
                return getter;
            }
        };
    },
    _postprocessRenderItem: $84003155288ca038$var$_common2.default.noop,
    _executeItemRenderAction: function(index, itemData, itemElement) {
        this._getItemRenderAction()({
            itemElement: itemElement,
            itemIndex: index,
            itemData: itemData
        });
    },
    _setElementData: function(element, data, index) {
        element.addClass([
            $84003155288ca038$var$ITEM_CLASS,
            this._itemClass()
        ].join(" ")).data(this._itemDataKey(), data).data(this._itemIndexKey(), index);
    },
    _createItemRenderAction: function() {
        return this._itemRenderAction = this._createActionByOption("onItemRendered", {
            element: this.element(),
            excludeValidators: [
                "disabled",
                "readOnly"
            ],
            category: "rendering"
        });
    },
    _getItemRenderAction: function() {
        return this._itemRenderAction || this._createItemRenderAction();
    },
    _getItemTemplateName: function(args) {
        var data = args.itemData;
        var templateProperty = args.templateProperty || this.option("itemTemplateProperty");
        var template = data && data[templateProperty];
        return template || args.defaultTemplateName;
    },
    _createItemByTemplate: function(itemTemplate, renderArgs) {
        return itemTemplate.render({
            model: renderArgs.itemData,
            container: renderArgs.container,
            index: renderArgs.index
        });
    },
    _emptyMessageContainer: function() {
        return this._itemContainer();
    },
    _renderEmptyMessage: function(items) {
        items = items || this.option("items");
        var noDataText = this.option("noDataText");
        var hideNoData = !noDataText || items && items.length || this._isDataSourceLoading();
        if (hideNoData && this._$noData) {
            this._$noData.remove();
            this._$noData = null;
            this.setAria("label", void 0);
        }
        if (!hideNoData) {
            this._$noData = this._$noData || (0, $84003155288ca038$var$_renderer2.default)("<div>").addClass("dx-empty-message");
            this._$noData.appendTo(this._emptyMessageContainer()).html(noDataText);
            this.setAria("label", noDataText);
        }
        this.$element().toggleClass($84003155288ca038$var$EMPTY_COLLECTION, !hideNoData);
    },
    _itemDXEventHandler: function(dxEvent, handlerOptionName, actionArgs, actionConfig) {
        this._itemEventHandler(dxEvent.target, handlerOptionName, (0, $7I8Uw.extend)(actionArgs, {
            event: dxEvent
        }), actionConfig);
    },
    _itemEventHandler: function(initiator, handlerOptionName, actionArgs, actionConfig) {
        var action = this._createActionByOption(handlerOptionName, (0, $7I8Uw.extend)({
            validatingTargetName: "itemElement"
        }, actionConfig));
        return this._itemEventHandlerImpl(initiator, action, actionArgs);
    },
    _itemEventHandlerByHandler: function(initiator, handler, actionArgs, actionConfig) {
        var action = this._createAction(handler, (0, $7I8Uw.extend)({
            validatingTargetName: "itemElement"
        }, actionConfig));
        return this._itemEventHandlerImpl(initiator, action, actionArgs);
    },
    _itemEventHandlerImpl: function(initiator, action, actionArgs) {
        var $itemElement = this._closestItemElement((0, $84003155288ca038$var$_renderer2.default)(initiator));
        var args = (0, $7I8Uw.extend)({}, actionArgs);
        return action((0, $7I8Uw.extend)(actionArgs, this._extendActionArgs($itemElement), args));
    },
    _extendActionArgs: function($itemElement) {
        return {
            itemElement: (0, $5OzEX.getPublicElement)($itemElement),
            itemIndex: this._itemElements().index($itemElement),
            itemData: this._getItemData($itemElement)
        };
    },
    _closestItemElement: function($element) {
        return (0, $84003155288ca038$var$_renderer2.default)($element).closest(this._itemSelector());
    },
    _getItemData: function(itemElement) {
        return (0, $84003155288ca038$var$_renderer2.default)(itemElement).data(this._itemDataKey());
    },
    _getSummaryItemsWidth: function(items, includeMargin) {
        var result = 0;
        if (items) $84003155288ca038$var$_iterator2.default.each(items, function(_, item) {
            result += (0, $84003155288ca038$var$_renderer2.default)(item).outerWidth(includeMargin || false);
        });
        return result;
    },
    getFocusedItemId: function() {
        if (!this._focusedItemId) this._focusedItemId = "dx-" + new $84003155288ca038$var$_guid2.default;
        return this._focusedItemId;
    },
    itemElements: function() {
        return this._itemElements();
    },
    itemsContainer: function() {
        return this._itemContainer();
    }
}).include($84003155288ca038$var$_data_helper2.default);
$84003155288ca038$var$CollectionWidget.ItemClass = $84003155288ca038$var$_item2.default;
$84003155288ca038$exports = $84003155288ca038$var$CollectionWidget;


var $f4d41dfe58d276dc$var$_uiCollection_widget2 = $f4d41dfe58d276dc$var$_interopRequireDefault($84003155288ca038$exports);

var $lrsNa = parcelRequire("lrsNa");
var $f4d41dfe58d276dc$var$_ui2 = $f4d41dfe58d276dc$var$_interopRequireDefault($lrsNa);

var $7I8Uw = parcelRequire("7I8Uw");

var $4Pwuy = parcelRequire("4Pwuy");

var $2Mto0 = parcelRequire("2Mto0");

var $kDRxH = parcelRequire("kDRxH");
var $b1b4a8c126ca0d50$exports = {};
/**
 * DevExtreme (ui/collection/ui.collection_widget.edit.strategy.plain.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
function $b1b4a8c126ca0d50$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $b1b4a8c126ca0d50$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $b1b4a8c126ca0d50$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b1b4a8c126ca0d50$var$_typeof(obj);
}

var $aLQK5 = parcelRequire("aLQK5");
var $b1b4a8c126ca0d50$require$inArray = $aLQK5.inArray;
var $4f53a3ab1d532447$exports = {};
/**
 * DevExtreme (ui/collection/ui.collection_widget.edit.strategy.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $k7aJb = parcelRequire("k7aJb");

var $2Mto0 = parcelRequire("2Mto0");
var $4f53a3ab1d532447$require$equalByValue = $2Mto0.equalByValue;
var $4f53a3ab1d532447$var$abstract = $k7aJb.abstract;
var $4f53a3ab1d532447$var$EditStrategy = $k7aJb.inherit({
    ctor: function(collectionWidget) {
        this._collectionWidget = collectionWidget;
    },
    getIndexByItemData: $4f53a3ab1d532447$var$abstract,
    getItemDataByIndex: $4f53a3ab1d532447$var$abstract,
    getKeysByItems: $4f53a3ab1d532447$var$abstract,
    getItemsByKeys: $4f53a3ab1d532447$var$abstract,
    itemsGetter: $4f53a3ab1d532447$var$abstract,
    getKeyByIndex: function(index) {
        var resultIndex = this._denormalizeItemIndex(index);
        return this.getKeysByItems([
            this.getItemDataByIndex(resultIndex)
        ])[0];
    },
    _equalKeys: function(key1, key2) {
        if (this._collectionWidget._isKeySpecified()) return $4f53a3ab1d532447$require$equalByValue(key1, key2);
        else return key1 === key2;
    },
    beginCache: function() {
        this._cache = {};
    },
    endCache: function() {
        this._cache = null;
    },
    getIndexByKey: $4f53a3ab1d532447$var$abstract,
    getNormalizedIndex: function(value) {
        if (this._isNormalizedItemIndex(value)) return value;
        if (this._isItemIndex(value)) return this._normalizeItemIndex(value);
        if (this._isDOMNode(value)) return this._getNormalizedItemIndex(value);
        return this._normalizeItemIndex(this.getIndexByItemData(value));
    },
    getIndex: function(value) {
        if (this._isNormalizedItemIndex(value)) return this._denormalizeItemIndex(value);
        if (this._isItemIndex(value)) return value;
        if (this._isDOMNode(value)) return this._denormalizeItemIndex(this._getNormalizedItemIndex(value));
        return this.getIndexByItemData(value);
    },
    getItemElement: function(value) {
        if (this._isNormalizedItemIndex(value)) return this._getItemByNormalizedIndex(value);
        if (this._isItemIndex(value)) return this._getItemByNormalizedIndex(this._normalizeItemIndex(value));
        if (this._isDOMNode(value)) return $jFnCG(value);
        var normalizedItemIndex = this._normalizeItemIndex(this.getIndexByItemData(value));
        return this._getItemByNormalizedIndex(normalizedItemIndex);
    },
    deleteItemAtIndex: $4f53a3ab1d532447$var$abstract,
    itemPlacementFunc: function(movingIndex, destinationIndex) {
        return this._itemsFromSameParent(movingIndex, destinationIndex) && movingIndex < destinationIndex ? "after" : "before";
    },
    moveItemAtIndexToIndex: $4f53a3ab1d532447$var$abstract,
    _isNormalizedItemIndex: function(index) {
        return "number" === typeof index && Math.round(index) === index;
    },
    _isDOMNode: function(value) {
        var $value;
        try {
            $value = $jFnCG(value);
        } catch (error) {
            return false;
        }
        return $value && $value.length && $value.get(0).nodeType;
    },
    _isItemIndex: $4f53a3ab1d532447$var$abstract,
    _getNormalizedItemIndex: $4f53a3ab1d532447$var$abstract,
    _normalizeItemIndex: $4f53a3ab1d532447$var$abstract,
    _denormalizeItemIndex: $4f53a3ab1d532447$var$abstract,
    _getItemByNormalizedIndex: $4f53a3ab1d532447$var$abstract,
    _itemsFromSameParent: $4f53a3ab1d532447$var$abstract
});
$4f53a3ab1d532447$exports = $4f53a3ab1d532447$var$EditStrategy;


var $b1b4a8c126ca0d50$var$PlainEditStrategy = $4f53a3ab1d532447$exports.inherit({
    _getPlainItems: function() {
        return this._collectionWidget.option("items") || [];
    },
    getIndexByItemData: function(itemData) {
        var keyOf = this._collectionWidget.keyOf.bind(this._collectionWidget);
        if (keyOf) return this.getIndexByKey(keyOf(itemData));
        else return $b1b4a8c126ca0d50$require$inArray(itemData, this._getPlainItems());
    },
    getItemDataByIndex: function(index) {
        return this._getPlainItems()[index];
    },
    deleteItemAtIndex: function(index) {
        this._getPlainItems().splice(index, 1);
    },
    itemsGetter: function() {
        return this._getPlainItems();
    },
    getKeysByItems: function(items) {
        var keyOf = this._collectionWidget.keyOf.bind(this._collectionWidget);
        var result = items;
        if (keyOf) {
            result = [];
            for(var i = 0; i < items.length; i++)result.push(keyOf(items[i]));
        }
        return result;
    },
    getIndexByKey: function(key) {
        var cache = this._cache;
        var keys = cache && cache.keys || this.getKeysByItems(this._getPlainItems());
        if (cache && !cache.keys) cache.keys = keys;
        if ("object" === $b1b4a8c126ca0d50$var$_typeof(key)) for(var i = 0, length = keys.length; i < length; i++){
            if (this._equalKeys(key, keys[i])) return i;
        }
        else return keys.indexOf(key);
        return -1;
    },
    getItemsByKeys: function(keys, items) {
        return (items || keys).slice();
    },
    moveItemAtIndexToIndex: function(movingIndex, destinationIndex) {
        var items = this._getPlainItems();
        var movedItemData = items[movingIndex];
        items.splice(movingIndex, 1);
        items.splice(destinationIndex, 0, movedItemData);
    },
    _isItemIndex: function(index) {
        return "number" === typeof index && Math.round(index) === index;
    },
    _getNormalizedItemIndex: function(itemElement) {
        return this._collectionWidget._itemElements().index(itemElement);
    },
    _normalizeItemIndex: function(index) {
        return index;
    },
    _denormalizeItemIndex: function(index) {
        return index;
    },
    _getItemByNormalizedIndex: function(index) {
        return index > -1 ? this._collectionWidget._itemElements().eq(index) : null;
    },
    _itemsFromSameParent: function() {
        return true;
    }
});
$b1b4a8c126ca0d50$exports = $b1b4a8c126ca0d50$var$PlainEditStrategy;


var $f4d41dfe58d276dc$var$_uiCollection_widgetEditStrategy2 = $f4d41dfe58d276dc$var$_interopRequireDefault($b1b4a8c126ca0d50$exports);

var $kpjzB = parcelRequire("kpjzB");

var $291c5fbc436a2165$exports = {};
/**
 * DevExtreme (ui/selection/selection.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $k7aJb = parcelRequire("k7aJb");
var $982775d940dbc70d$exports = {};
/**
 * DevExtreme (ui/selection/selection.strategy.deferred.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $kDRxH = parcelRequire("kDRxH");
var $046de5c123515fee$exports = {};
/**
 * DevExtreme (ui/selection/selection.strategy.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";


var $2Mto0 = parcelRequire("2Mto0");

var $kDRxH = parcelRequire("kDRxH");
var $046de5c123515fee$var$getKeyHash = $2Mto0.getKeyHash;

var $k7aJb = parcelRequire("k7aJb");

var $2F60d = parcelRequire("2F60d");
var $046de5c123515fee$require$Deferred = $2F60d.Deferred;
$046de5c123515fee$exports = $k7aJb.inherit({
    ctor: function(options) {
        this.options = options;
        this._setOption("disabledItemKeys", []);
        this._clearItemKeys();
    },
    _clearItemKeys: function() {
        this._setOption("addedItemKeys", []);
        this._setOption("removedItemKeys", []);
        this._setOption("removedItems", []);
        this._setOption("addedItems", []);
    },
    validate: $2Mto0.noop,
    _setOption: function(name, value) {
        this.options[name] = value;
    },
    onSelectionChanged: function onSelectionChanged() {
        var addedItemKeys = this.options.addedItemKeys;
        var removedItemKeys = this.options.removedItemKeys;
        var addedItems = this.options.addedItems;
        var removedItems = this.options.removedItems;
        var selectedItems = this.options.selectedItems;
        var selectedItemKeys = this.options.selectedItemKeys;
        var onSelectionChanged = this.options.onSelectionChanged || $2Mto0.noop;
        this._clearItemKeys();
        onSelectionChanged({
            selectedItems: selectedItems,
            selectedItemKeys: selectedItemKeys,
            addedItemKeys: addedItemKeys,
            removedItemKeys: removedItemKeys,
            addedItems: addedItems,
            removedItems: removedItems
        });
    },
    equalKeys: function(key1, key2) {
        if (this.options.equalByReference) {
            if ($kDRxH.isObject(key1) && $kDRxH.isObject(key2)) return key1 === key2;
        }
        return $2Mto0.equalByValue(key1, key2);
    },
    getSelectableItems: function(items) {
        return items.filter(function(item) {
            return !item.disabled;
        });
    },
    _clearSelection: function(keys, preserve, isDeselect, isSelectAll) {
        keys = keys || [];
        keys = Array.isArray(keys) ? keys : [
            keys
        ];
        this.validate();
        return this.selectedItemKeys(keys, preserve, isDeselect, isSelectAll);
    },
    _loadFilteredData: function(remoteFilter, localFilter, select, isSelectAll) {
        var filterLength = encodeURI(JSON.stringify(remoteFilter)).length;
        var needLoadAllData = this.options.maxFilterLengthInRequest && filterLength > this.options.maxFilterLengthInRequest;
        var deferred = new $046de5c123515fee$require$Deferred;
        var loadOptions = {
            filter: needLoadAllData ? void 0 : remoteFilter,
            select: needLoadAllData ? this.options.dataFields() : select || this.options.dataFields()
        };
        if (remoteFilter && 0 === remoteFilter.length) deferred.resolve([]);
        else this.options.load(loadOptions).done(function(items) {
            var filteredItems = $kDRxH.isPlainObject(items) ? items.data : items;
            if (localFilter && !isSelectAll) filteredItems = filteredItems.filter(localFilter);
            else if (needLoadAllData) filteredItems = $70c1405d2124b690$exports(filteredItems).filter(remoteFilter).toArray();
            deferred.resolve(filteredItems);
        }).fail(deferred.reject.bind(deferred));
        return deferred;
    },
    updateSelectedItemKeyHash: function(keys) {
        for(var i = 0; i < keys.length; i++){
            var keyHash = $046de5c123515fee$var$getKeyHash(keys[i]);
            if (!$kDRxH.isObject(keyHash)) {
                this.options.keyHashIndices[keyHash] = this.options.keyHashIndices[keyHash] || [];
                var keyIndices = this.options.keyHashIndices[keyHash];
                keyIndices.push(i);
            }
        }
    },
    _isAnyItemSelected: function(items) {
        for(var i = 0; i < items.length; i++){
            if (this.options.isItemSelected(items[i])) return;
        }
        return false;
    },
    _getFullSelectAllState: function() {
        var items = this.options.plainItems();
        var dataFilter = this.options.filter();
        var selectedItems = this.options.selectedItems;
        if (dataFilter) selectedItems = $70c1405d2124b690$exports(selectedItems).filter(dataFilter).toArray();
        var selectedItemsLength = selectedItems.length;
        if (!selectedItemsLength) return this._isAnyItemSelected(items);
        if (selectedItemsLength >= this.options.totalCount() - this.options.disabledItemKeys.length) return true;
        return;
    },
    _getVisibleSelectAllState: function() {
        var items = this.getSelectableItems(this.options.plainItems());
        var hasSelectedItems = false;
        var hasUnselectedItems = false;
        for(var i = 0; i < items.length; i++){
            var item = items[i];
            var itemData = this.options.getItemData(item);
            var key = this.options.keyOf(itemData);
            if (this.options.isSelectableItem(item)) {
                if (this.isItemKeySelected(key)) hasSelectedItems = true;
                else hasUnselectedItems = true;
            }
        }
        if (hasSelectedItems) return !hasUnselectedItems ? true : void 0;
        else return false;
    }
});



var $lrsNa = parcelRequire("lrsNa");


var $2F60d = parcelRequire("2F60d");
var $982775d940dbc70d$require$Deferred = $2F60d.Deferred;
$982775d940dbc70d$exports = $046de5c123515fee$exports.inherit({
    getSelectedItems: function() {
        return this._loadFilteredData(this.options.selectionFilter);
    },
    getSelectedItemKeys: function() {
        var d = new $982775d940dbc70d$require$Deferred;
        var that = this;
        var key = this.options.key();
        var select = $kDRxH.isString(key) ? [
            key
        ] : key;
        this._loadFilteredData(this.options.selectionFilter, null, select).done(function(items) {
            var keys = items.map(function(item) {
                return that.options.keyOf(item);
            });
            d.resolve(keys);
        }).fail(d.reject);
        return d.promise();
    },
    selectedItemKeys: function(keys, preserve, isDeselect, isSelectAll) {
        if (isSelectAll) {
            var filter = this.options.filter();
            if (!filter) this._setOption("selectionFilter", isDeselect ? [] : null);
            else this._addSelectionFilter(isDeselect, filter, isSelectAll);
        } else {
            if (!preserve) this._setOption("selectionFilter", []);
            for(var i = 0; i < keys.length; i++)if (isDeselect) this.removeSelectedItem(keys[i]);
            else this.addSelectedItem(keys[i]);
        }
        this.onSelectionChanged();
        return (new $982775d940dbc70d$require$Deferred).resolve();
    },
    setSelectedItems: function(keys) {
        this._setOption("selectionFilter", null);
        for(var i = 0; i < keys.length; i++)this.addSelectedItem(keys[i]);
    },
    isItemDataSelected: function(itemData) {
        return this.isItemKeySelected(itemData);
    },
    isItemKeySelected: function(itemData) {
        var selectionFilter = this.options.selectionFilter;
        if (!selectionFilter) return true;
        return !!$70c1405d2124b690$exports([
            itemData
        ]).filter(selectionFilter).toArray().length;
    },
    _getFilterByKey: function(key) {
        var keyField = this.options.key();
        var filter = [
            keyField,
            "=",
            key
        ];
        if (Array.isArray(keyField)) {
            filter = [];
            for(var i = 0; i < keyField.length; i++){
                filter.push([
                    keyField[i],
                    "=",
                    key[keyField[i]]
                ]);
                if (i !== keyField.length - 1) filter.push("and");
            }
        }
        return filter;
    },
    addSelectedItem: function(key) {
        var filter = this._getFilterByKey(key);
        this._addSelectionFilter(false, filter);
    },
    removeSelectedItem: function(key) {
        var filter = this._getFilterByKey(key);
        this._addSelectionFilter(true, filter);
    },
    validate: function() {
        var key = this.options.key;
        if (key && void 0 === key()) throw $lrsNa.Error("E1042", "Deferred selection");
    },
    _findSubFilter: function(selectionFilter, filter) {
        if (!selectionFilter) return -1;
        var filterString = JSON.stringify(filter);
        for(var index = 0; index < selectionFilter.length; index++){
            var subFilter = selectionFilter[index];
            if (subFilter && JSON.stringify(subFilter) === filterString) return index;
        }
        return -1;
    },
    _isLastSubFilter: function(selectionFilter, filter) {
        if (selectionFilter && filter) return this._findSubFilter(selectionFilter, filter) === selectionFilter.length - 1 || 0 === this._findSubFilter([
            selectionFilter
        ], filter);
        return false;
    },
    _addFilterOperator: function(selectionFilter, filterOperator) {
        if (selectionFilter.length > 1 && $kDRxH.isString(selectionFilter[1]) && selectionFilter[1] !== filterOperator) selectionFilter = [
            selectionFilter
        ];
        if (selectionFilter.length) selectionFilter.push(filterOperator);
        return selectionFilter;
    },
    _denormalizeFilter: function(filter) {
        if (filter && $kDRxH.isString(filter[0])) filter = [
            filter
        ];
        return filter;
    },
    _addSelectionFilter: function(isDeselect, filter, isSelectAll) {
        var that = this;
        var currentFilter = isDeselect ? [
            "!",
            filter
        ] : filter;
        var currentOperation = isDeselect ? "and" : "or";
        var needAddFilter = true;
        var selectionFilter = that.options.selectionFilter || [];
        selectionFilter = that._denormalizeFilter(selectionFilter);
        if (selectionFilter && selectionFilter.length) {
            that._removeSameFilter(selectionFilter, filter, isDeselect, isSelectAll);
            var filterIndex = that._removeSameFilter(selectionFilter, filter, !isDeselect);
            var isKeyOperatorsAfterRemoved = this._isKeyFilter(filter) && this._hasKeyFiltersOnlyStartingFromIndex(selectionFilter, filterIndex);
            needAddFilter = filter.length && !isKeyOperatorsAfterRemoved;
            if (needAddFilter) selectionFilter = that._addFilterOperator(selectionFilter, currentOperation);
        }
        if (needAddFilter) selectionFilter.push(currentFilter);
        selectionFilter = that._normalizeFilter(selectionFilter);
        that._setOption("selectionFilter", !isDeselect && !selectionFilter.length ? null : selectionFilter);
    },
    _normalizeFilter: function(filter) {
        if (filter && 1 === filter.length) filter = filter[0];
        return filter;
    },
    _removeFilterByIndex: function(filter, filterIndex, isSelectAll) {
        var operation = filter[1];
        if (filterIndex > 0) filter.splice(filterIndex - 1, 2);
        else filter.splice(filterIndex, 2);
        if (isSelectAll && "and" === operation) filter.splice(0, filter.length);
    },
    _isSimpleKeyFilter: function(filter, key) {
        return 3 === filter.length && filter[0] === key && "=" === filter[1];
    },
    _isKeyFilter: function(filter) {
        if (2 === filter.length && "!" === filter[0]) return this._isKeyFilter(filter[1]);
        var keyField = this.options.key();
        if (Array.isArray(keyField)) {
            if (filter.length !== 2 * keyField.length - 1) return false;
            for(var i = 0; i < keyField.length; i++){
                if (i > 0 && "and" !== filter[i]) return false;
                if (!this._isSimpleKeyFilter(filter[2 * i], keyField[i])) return false;
            }
            return true;
        }
        return this._isSimpleKeyFilter(filter, keyField);
    },
    _hasKeyFiltersOnlyStartingFromIndex: function(selectionFilter, filterIndex) {
        if (filterIndex >= 0) {
            for(var i = filterIndex; i < selectionFilter.length; i++){
                if ("string" !== typeof selectionFilter[i] && !this._isKeyFilter(selectionFilter[i])) return false;
            }
            return true;
        }
        return false;
    },
    _removeSameFilter: function(selectionFilter, filter, inverted, isSelectAll) {
        filter = inverted ? [
            "!",
            filter
        ] : filter;
        if (JSON.stringify(filter) === JSON.stringify(selectionFilter)) {
            selectionFilter.splice(0, selectionFilter.length);
            return 0;
        }
        var filterIndex = this._findSubFilter(selectionFilter, filter);
        if (filterIndex >= 0) {
            this._removeFilterByIndex(selectionFilter, filterIndex, isSelectAll);
            return filterIndex;
        } else {
            for(var i = 0; i < selectionFilter.length; i++)if (Array.isArray(selectionFilter[i]) && selectionFilter[i].length > 2) {
                var _filterIndex = this._removeSameFilter(selectionFilter[i], filter, false, isSelectAll);
                if (_filterIndex >= 0) {
                    if (!selectionFilter[i].length) this._removeFilterByIndex(selectionFilter, i, isSelectAll);
                    else if (1 === selectionFilter[i].length) selectionFilter[i] = selectionFilter[i][0];
                    return _filterIndex;
                }
            }
            return -1;
        }
    },
    getSelectAllState: function() {
        var filter = this.options.filter();
        var selectionFilter = this.options.selectionFilter;
        if (!selectionFilter) return true;
        if (!selectionFilter.length) return false;
        if (!filter || !filter.length) return;
        selectionFilter = this._denormalizeFilter(selectionFilter);
        if (this._isLastSubFilter(selectionFilter, filter)) return true;
        if (this._isLastSubFilter(selectionFilter, [
            "!",
            filter
        ])) return false;
        return;
    }
});


var $fcf8f6185a088557$exports = {};
/**
 * DevExtreme (ui/selection/selection.strategy.standard.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $2Mto0 = parcelRequire("2Mto0");

var $kDRxH = parcelRequire("kDRxH");
var $fcf8f6185a088557$var$isDefined = $kDRxH.isDefined;
var $fcf8f6185a088557$var$getKeyHash = $2Mto0.getKeyHash;


var $2F60d = parcelRequire("2F60d");
/**
 * DevExtreme (core/utils/selection_filter.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $1b3bc67b7a1615c7$export$6403fdc821a371b0;
"use strict";

var $2Mto0 = parcelRequire("2Mto0");
var $1b3bc67b7a1615c7$require$getKeyHash = $2Mto0.getKeyHash;

var $2Mto0 = parcelRequire("2Mto0");
var $1b3bc67b7a1615c7$require$equalByValue = $2Mto0.equalByValue;

var $kDRxH = parcelRequire("kDRxH");
var $1b3bc67b7a1615c7$var$SelectionFilterCreator = function(selectedItemKeys, isSelectAll) {
    this.getLocalFilter = function(keyGetter, equalKeys, equalByReference, keyExpr) {
        equalKeys = void 0 === equalKeys ? $1b3bc67b7a1615c7$require$equalByValue : equalKeys;
        return functionFilter.bind(this, equalKeys, keyGetter, equalByReference, keyExpr);
    };
    this.getExpr = function(keyExpr) {
        if (!keyExpr) return;
        var filterExpr;
        selectedItemKeys.forEach(function(key, index) {
            filterExpr = filterExpr || [];
            var filterExprPart;
            if (index > 0) filterExpr.push(isSelectAll ? "and" : "or");
            if ($kDRxH.isString(keyExpr)) filterExprPart = getFilterForPlainKey(keyExpr, key);
            else filterExprPart = getFilterForCompositeKey(keyExpr, key);
            filterExpr.push(filterExprPart);
        });
        if (filterExpr && 1 === filterExpr.length) filterExpr = filterExpr[0];
        return filterExpr;
    };
    this.getCombinedFilter = function(keyExpr, dataSourceFilter) {
        var filterExpr = this.getExpr(keyExpr);
        var combinedFilter = filterExpr;
        if (isSelectAll && dataSourceFilter) {
            if (filterExpr) {
                combinedFilter = [];
                combinedFilter.push(filterExpr);
                combinedFilter.push(dataSourceFilter);
            } else combinedFilter = dataSourceFilter;
        }
        return combinedFilter;
    };
    var selectedItemKeyHashesMap;
    var getSelectedItemKeyHashesMap = function(selectedItemKeys) {
        if (!selectedItemKeyHashesMap) {
            selectedItemKeyHashesMap = {};
            for(var i = 0; i < selectedItemKeys.length; i++)selectedItemKeyHashesMap[$1b3bc67b7a1615c7$require$getKeyHash(selectedItemKeys[i])] = true;
        }
        return selectedItemKeyHashesMap;
    };
    var normalizeKeys = function(keys, keyOf, keyExpr) {
        return Array.isArray(keyExpr) ? keys.map(function(key) {
            return keyOf(key);
        }) : keys;
    };
    var functionFilter = function(equalKeys, keyOf, equalByReference, keyExpr, item) {
        var key = keyOf(item);
        var keyHash;
        var i;
        if (!equalByReference) {
            keyHash = $1b3bc67b7a1615c7$require$getKeyHash(key);
            if (!$kDRxH.isObject(keyHash)) {
                var selectedKeyHashesMap = getSelectedItemKeyHashesMap(normalizeKeys(selectedItemKeys, keyOf, keyExpr));
                if (selectedKeyHashesMap[keyHash]) return !isSelectAll;
                return !!isSelectAll;
            }
        }
        for(i = 0; i < selectedItemKeys.length; i++){
            if (equalKeys(selectedItemKeys[i], key)) return !isSelectAll;
        }
        return !!isSelectAll;
    };
    var getFilterForPlainKey = function(keyExpr, keyValue) {
        if (void 0 === keyValue) return;
        return [
            keyExpr,
            isSelectAll ? "<>" : "=",
            keyValue
        ];
    };
    var getFilterForCompositeKey = function(keyExpr, itemKeyValue) {
        var filterExpr = [];
        for(var i = 0, length = keyExpr.length; i < length; i++){
            var currentKeyExpr = keyExpr[i];
            var currentKeyValue = itemKeyValue && itemKeyValue[currentKeyExpr];
            var filterExprPart = getFilterForPlainKey(currentKeyExpr, currentKeyValue);
            if (!filterExprPart) break;
            if (i > 0) filterExpr.push(isSelectAll ? "or" : "and");
            filterExpr.push(filterExprPart);
        }
        return filterExpr;
    };
};
$1b3bc67b7a1615c7$export$6403fdc821a371b0 = $1b3bc67b7a1615c7$var$SelectionFilterCreator;


var $fcf8f6185a088557$require$SelectionFilterCreator = $1b3bc67b7a1615c7$export$6403fdc821a371b0;
var $fcf8f6185a088557$var$when = $2F60d.when;
var $fcf8f6185a088557$var$Deferred = $2F60d.Deferred;

var $lrsNa = parcelRequire("lrsNa");

$fcf8f6185a088557$exports = $046de5c123515fee$exports.inherit({
    ctor: function(options) {
        this.callBase(options);
        this._initSelectedItemKeyHash();
    },
    _initSelectedItemKeyHash: function() {
        this._setOption("keyHashIndices", this.options.equalByReference ? null : {});
    },
    getSelectedItemKeys: function() {
        return this.options.selectedItemKeys.slice(0);
    },
    getSelectedItems: function() {
        return this.options.selectedItems.slice(0);
    },
    _preserveSelectionUpdate: function(items, isDeselect) {
        var keyOf = this.options.keyOf;
        var keyIndicesToRemoveMap;
        var keyIndex;
        var i;
        if (!keyOf) return;
        var isBatchDeselect = isDeselect && items.length > 1 && !this.options.equalByReference;
        if (isBatchDeselect) keyIndicesToRemoveMap = {};
        for(i = 0; i < items.length; i++){
            var item = items[i];
            var key = keyOf(item);
            if (isDeselect) {
                keyIndex = this.removeSelectedItem(key, keyIndicesToRemoveMap);
                if (keyIndicesToRemoveMap && keyIndex >= 0) keyIndicesToRemoveMap[keyIndex] = true;
            } else this.addSelectedItem(key, item);
        }
        if (isBatchDeselect) this._batchRemoveSelectedItems(keyIndicesToRemoveMap);
    },
    _batchRemoveSelectedItems: function(keyIndicesToRemoveMap) {
        var selectedItemKeys = this.options.selectedItemKeys.slice(0);
        var selectedItems = this.options.selectedItems.slice(0);
        this.options.selectedItemKeys.length = 0;
        this.options.selectedItems.length = 0;
        for(var i = 0; i < selectedItemKeys.length; i++)if (!keyIndicesToRemoveMap[i]) {
            this.options.selectedItemKeys.push(selectedItemKeys[i]);
            this.options.selectedItems.push(selectedItems[i]);
        }
        this._initSelectedItemKeyHash();
        this.updateSelectedItemKeyHash(this.options.selectedItemKeys);
    },
    _loadSelectedItemsCore: function(keys, isDeselect, isSelectAll) {
        var deferred = new $fcf8f6185a088557$var$Deferred;
        var key = this.options.key();
        if (!keys.length && !isSelectAll) {
            deferred.resolve([]);
            return deferred;
        }
        var filter = this.options.filter();
        if (isSelectAll && isDeselect && !filter) {
            deferred.resolve(this.getSelectedItems());
            return deferred;
        }
        var selectionFilterCreator = new $fcf8f6185a088557$require$SelectionFilterCreator(keys, isSelectAll);
        var combinedFilter = selectionFilterCreator.getCombinedFilter(key, filter);
        var deselectedItems = [];
        if (isDeselect) deselectedItems = combinedFilter ? $70c1405d2124b690$exports(this.options.selectedItems).filter(combinedFilter).toArray() : this.options.selectedItems.slice(0);
        var filteredItems = deselectedItems.length ? deselectedItems : this.options.plainItems(true).filter(this.options.isSelectableItem).map(this.options.getItemData);
        var localFilter = selectionFilterCreator.getLocalFilter(this.options.keyOf, this.equalKeys.bind(this), this.options.equalByReference, key);
        filteredItems = filteredItems.filter(localFilter);
        if (deselectedItems.length || !isSelectAll && filteredItems.length === keys.length) deferred.resolve(filteredItems);
        else deferred = this._loadFilteredData(combinedFilter, localFilter, null, isSelectAll);
        return deferred;
    },
    _replaceSelectionUpdate: function(items) {
        var internalKeys = [];
        var keyOf = this.options.keyOf;
        if (!keyOf) return;
        for(var i = 0; i < items.length; i++){
            var item = items[i];
            var key = keyOf(item);
            internalKeys.push(key);
        }
        this.setSelectedItems(internalKeys, items);
    },
    _warnOnIncorrectKeys: function(keys) {
        var allowNullValue = this.options.allowNullValue;
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if ((!allowNullValue || null !== key) && !this.isItemKeySelected(key)) $lrsNa.log("W1002", key);
        }
    },
    _loadSelectedItems: function(keys, isDeselect, isSelectAll) {
        var that = this;
        var deferred = new $fcf8f6185a088557$var$Deferred;
        $fcf8f6185a088557$var$when(that._lastLoadDeferred).always(function() {
            that._loadSelectedItemsCore(keys, isDeselect, isSelectAll).done(deferred.resolve).fail(deferred.reject);
        });
        that._lastLoadDeferred = deferred;
        return deferred;
    },
    selectedItemKeys: function(keys, preserve, isDeselect, isSelectAll) {
        var that = this;
        var deferred = that._loadSelectedItems(keys, isDeselect, isSelectAll);
        deferred.done(function(items) {
            if (preserve) that._preserveSelectionUpdate(items, isDeselect);
            else that._replaceSelectionUpdate(items);
            that.onSelectionChanged();
        });
        return deferred;
    },
    addSelectedItem: function(key, itemData) {
        if ($fcf8f6185a088557$var$isDefined(itemData) && itemData.disabled) {
            if (this.options.disabledItemKeys.indexOf(key) === -1) this.options.disabledItemKeys.push(key);
            return;
        }
        var keyHash = this._getKeyHash(key);
        if (this._indexOfSelectedItemKey(keyHash) === -1) {
            if (!$kDRxH.isObject(keyHash) && this.options.keyHashIndices) this.options.keyHashIndices[keyHash] = [
                this.options.selectedItemKeys.length
            ];
            this.options.selectedItemKeys.push(key);
            this.options.addedItemKeys.push(key);
            this.options.addedItems.push(itemData);
            this.options.selectedItems.push(itemData);
        }
    },
    _getSelectedIndexByKey: function(key, ignoreIndicesMap) {
        var selectedItemKeys = this.options.selectedItemKeys;
        for(var index = 0; index < selectedItemKeys.length; index++){
            if ((!ignoreIndicesMap || !ignoreIndicesMap[index]) && this.equalKeys(selectedItemKeys[index], key)) return index;
        }
        return -1;
    },
    _getSelectedIndexByHash: function(key, ignoreIndicesMap) {
        var indices = this.options.keyHashIndices[key];
        if (indices && indices.length > 1 && ignoreIndicesMap) indices = indices.filter(function(index) {
            return !ignoreIndicesMap[index];
        });
        return indices && indices[0] >= 0 ? indices[0] : -1;
    },
    _indexOfSelectedItemKey: function(key, ignoreIndicesMap) {
        var selectedIndex;
        if (this.options.equalByReference) selectedIndex = this.options.selectedItemKeys.indexOf(key);
        else if ($kDRxH.isObject(key)) selectedIndex = this._getSelectedIndexByKey(key, ignoreIndicesMap);
        else selectedIndex = this._getSelectedIndexByHash(key, ignoreIndicesMap);
        return selectedIndex;
    },
    _shiftSelectedKeyIndices: function(keyIndex) {
        for(var currentKeyIndex = keyIndex; currentKeyIndex < this.options.selectedItemKeys.length; currentKeyIndex++){
            var currentKey = this.options.selectedItemKeys[currentKeyIndex];
            var currentKeyHash = $fcf8f6185a088557$var$getKeyHash(currentKey);
            var currentKeyIndices = this.options.keyHashIndices[currentKeyHash];
            if (!currentKeyIndices) continue;
            for(var i = 0; i < currentKeyIndices.length; i++)if (currentKeyIndices[i] > keyIndex) currentKeyIndices[i]--;
        }
    },
    removeSelectedItem: function(key, keyIndicesToRemoveMap) {
        var keyHash = this._getKeyHash(key);
        var isBatchDeselect = !!keyIndicesToRemoveMap;
        var keyIndex = this._indexOfSelectedItemKey(keyHash, keyIndicesToRemoveMap);
        if (keyIndex < 0) return keyIndex;
        this.options.removedItemKeys.push(key);
        this.options.removedItems.push(this.options.selectedItems[keyIndex]);
        if (isBatchDeselect) return keyIndex;
        this.options.selectedItemKeys.splice(keyIndex, 1);
        this.options.selectedItems.splice(keyIndex, 1);
        if ($kDRxH.isObject(keyHash) || !this.options.keyHashIndices) return keyIndex;
        var keyIndices = this.options.keyHashIndices[keyHash];
        if (!keyIndices) return keyIndex;
        keyIndices.shift();
        if (!keyIndices.length) delete this.options.keyHashIndices[keyHash];
        this._shiftSelectedKeyIndices(keyIndex);
        return keyIndex;
    },
    _updateAddedItemKeys: function(keys, items) {
        for(var i = 0; i < keys.length; i++)if (!this.isItemKeySelected(keys[i])) {
            this.options.addedItemKeys.push(keys[i]);
            this.options.addedItems.push(items[i]);
        }
    },
    _updateRemovedItemKeys: function(keys, oldSelectedKeys, oldSelectedItems) {
        for(var i = 0; i < oldSelectedKeys.length; i++)if (!this.isItemKeySelected(oldSelectedKeys[i])) {
            this.options.removedItemKeys.push(oldSelectedKeys[i]);
            this.options.removedItems.push(oldSelectedItems[i]);
        }
    },
    _getKeyHash: function(key) {
        return this.options.equalByReference ? key : $fcf8f6185a088557$var$getKeyHash(key);
    },
    setSelectedItems: function(keys, items) {
        this._updateAddedItemKeys(keys, items);
        var oldSelectedKeys = this.options.selectedItemKeys;
        var oldSelectedItems = this.options.selectedItems;
        if (!this.options.equalByReference) {
            this._initSelectedItemKeyHash();
            this.updateSelectedItemKeyHash(keys);
        }
        this._setOption("selectedItemKeys", keys);
        this._setOption("selectedItems", items);
        this._updateRemovedItemKeys(keys, oldSelectedKeys, oldSelectedItems);
    },
    isItemDataSelected: function(itemData) {
        var key = this.options.keyOf(itemData);
        return this.isItemKeySelected(key);
    },
    isItemKeySelected: function(key) {
        var keyHash = this._getKeyHash(key);
        var index = this._indexOfSelectedItemKey(keyHash);
        return index !== -1;
    },
    getSelectAllState: function(visibleOnly) {
        if (visibleOnly) return this._getVisibleSelectAllState();
        else return this._getFullSelectAllState();
    }
});



var $7I8Uw = parcelRequire("7I8Uw");
var $291c5fbc436a2165$require$extend = $7I8Uw.extend;

var $2Mto0 = parcelRequire("2Mto0");
var $291c5fbc436a2165$require$noop = $2Mto0.noop;

var $kDRxH = parcelRequire("kDRxH");
var $291c5fbc436a2165$require$isDefined = $kDRxH.isDefined;

var $2F60d = parcelRequire("2F60d");
var $291c5fbc436a2165$require$Deferred = $2F60d.Deferred;
$291c5fbc436a2165$exports = $k7aJb.inherit({
    ctor: function(options) {
        this.options = $291c5fbc436a2165$require$extend(this._getDefaultOptions(), options, {
            selectedItemKeys: options.selectedKeys || []
        });
        this._selectionStrategy = this.options.deferred ? new $982775d940dbc70d$exports(this.options) : new $fcf8f6185a088557$exports(this.options);
        this._focusedItemIndex = -1;
        if (!this.options.equalByReference) this._selectionStrategy.updateSelectedItemKeyHash(this.options.selectedItemKeys);
    },
    _getDefaultOptions: function() {
        return {
            allowNullValue: false,
            deferred: false,
            equalByReference: false,
            mode: "multiple",
            selectedItems: [],
            selectionFilter: [],
            maxFilterLengthInRequest: 0,
            onSelectionChanged: $291c5fbc436a2165$require$noop,
            key: $291c5fbc436a2165$require$noop,
            keyOf: function(item) {
                return item;
            },
            load: function() {
                return (new $291c5fbc436a2165$require$Deferred).resolve([]);
            },
            totalCount: function() {
                return -1;
            },
            isSelectableItem: function() {
                return true;
            },
            isItemSelected: function() {
                return false;
            },
            getItemData: function(item) {
                return item;
            },
            dataFields: $291c5fbc436a2165$require$noop,
            filter: $291c5fbc436a2165$require$noop
        };
    },
    validate: function() {
        this._selectionStrategy.validate();
    },
    getSelectedItemKeys: function() {
        return this._selectionStrategy.getSelectedItemKeys();
    },
    getSelectedItems: function() {
        return this._selectionStrategy.getSelectedItems();
    },
    selectionFilter: function(value) {
        if (void 0 === value) return this.options.selectionFilter;
        var filterIsChanged = this.options.selectionFilter !== value && JSON.stringify(this.options.selectionFilter) !== JSON.stringify(value);
        this.options.selectionFilter = value;
        filterIsChanged && this.onSelectionChanged();
    },
    setSelection: function(keys) {
        return this.selectedItemKeys(keys);
    },
    select: function(keys) {
        return this.selectedItemKeys(keys, true);
    },
    deselect: function(keys) {
        return this.selectedItemKeys(keys, true, true);
    },
    selectedItemKeys: function(keys, preserve, isDeselect, isSelectAll) {
        var that = this;
        keys = keys || [];
        keys = Array.isArray(keys) ? keys : [
            keys
        ];
        that.validate();
        return this._selectionStrategy.selectedItemKeys(keys, preserve, isDeselect, isSelectAll);
    },
    clearSelection: function() {
        return this.selectedItemKeys([]);
    },
    _addSelectedItem: function(itemData, key) {
        this._selectionStrategy.addSelectedItem(key, itemData);
    },
    _removeSelectedItem: function(key) {
        this._selectionStrategy.removeSelectedItem(key);
    },
    _setSelectedItems: function(keys, items) {
        this._selectionStrategy.setSelectedItems(keys, items);
    },
    onSelectionChanged: function() {
        this._selectionStrategy.onSelectionChanged();
    },
    changeItemSelection: function(itemIndex, keys) {
        var isSelectedItemsChanged;
        var items = this.options.plainItems();
        var item = items[itemIndex];
        if (!this.isSelectable() || !this.isDataItem(item)) return false;
        var itemData = this.options.getItemData(item);
        var itemKey = this.options.keyOf(itemData);
        keys = keys || {};
        if (keys.shift && "multiple" === this.options.mode && this._focusedItemIndex >= 0) isSelectedItemsChanged = this.changeItemSelectionWhenShiftKeyPressed(itemIndex, items);
        else if (keys.control) {
            this._resetItemSelectionWhenShiftKeyPressed();
            var isSelected = this._selectionStrategy.isItemDataSelected(itemData);
            if ("single" === this.options.mode) this.clearSelectedItems();
            if (isSelected) this._removeSelectedItem(itemKey);
            else this._addSelectedItem(itemData, itemKey);
            isSelectedItemsChanged = true;
        } else {
            this._resetItemSelectionWhenShiftKeyPressed();
            var isKeysEqual = this._selectionStrategy.equalKeys(this.options.selectedItemKeys[0], itemKey);
            if (1 !== this.options.selectedItemKeys.length || !isKeysEqual) {
                this._setSelectedItems([
                    itemKey
                ], [
                    itemData
                ]);
                isSelectedItemsChanged = true;
            }
        }
        if (isSelectedItemsChanged) {
            this._focusedItemIndex = itemIndex;
            this.onSelectionChanged();
            return true;
        }
    },
    isDataItem: function(item) {
        return this.options.isSelectableItem(item);
    },
    isSelectable: function() {
        return "single" === this.options.mode || "multiple" === this.options.mode;
    },
    isItemDataSelected: function(data) {
        return this._selectionStrategy.isItemDataSelected(data);
    },
    isItemSelected: function(arg) {
        return this._selectionStrategy.isItemKeySelected(arg);
    },
    _resetItemSelectionWhenShiftKeyPressed: function() {
        delete this._shiftFocusedItemIndex;
    },
    _resetFocusedItemIndex: function() {
        this._focusedItemIndex = -1;
    },
    changeItemSelectionWhenShiftKeyPressed: function(itemIndex, items) {
        var isSelectedItemsChanged = false;
        var itemIndexStep;
        var index;
        var keyOf = this.options.keyOf;
        var focusedItem = items[this._focusedItemIndex];
        var focusedData = this.options.getItemData(focusedItem);
        var focusedKey = keyOf(focusedData);
        var isFocusedItemSelected = focusedItem && this.isItemDataSelected(focusedData);
        if (!$291c5fbc436a2165$require$isDefined(this._shiftFocusedItemIndex)) this._shiftFocusedItemIndex = this._focusedItemIndex;
        var data;
        var itemKey;
        if (this._shiftFocusedItemIndex !== this._focusedItemIndex) {
            itemIndexStep = this._focusedItemIndex < this._shiftFocusedItemIndex ? 1 : -1;
            for(index = this._focusedItemIndex; index !== this._shiftFocusedItemIndex; index += itemIndexStep)if (this.isDataItem(items[index])) {
                itemKey = keyOf(this.options.getItemData(items[index]));
                this._removeSelectedItem(itemKey);
                isSelectedItemsChanged = true;
            }
        }
        if (itemIndex !== this._shiftFocusedItemIndex) {
            itemIndexStep = itemIndex < this._shiftFocusedItemIndex ? 1 : -1;
            for(index = itemIndex; index !== this._shiftFocusedItemIndex; index += itemIndexStep)if (this.isDataItem(items[index])) {
                data = this.options.getItemData(items[index]);
                itemKey = keyOf(data);
                this._addSelectedItem(data, itemKey);
                isSelectedItemsChanged = true;
            }
        }
        if (this.isDataItem(focusedItem) && !isFocusedItemSelected) {
            this._addSelectedItem(focusedData, focusedKey);
            isSelectedItemsChanged = true;
        }
        return isSelectedItemsChanged;
    },
    clearSelectedItems: function() {
        this._setSelectedItems([], []);
    },
    selectAll: function(isOnePage) {
        this._resetFocusedItemIndex();
        if (isOnePage) return this._onePageSelectAll(false);
        else return this.selectedItemKeys([], true, false, true);
    },
    deselectAll: function(isOnePage) {
        this._resetFocusedItemIndex();
        if (isOnePage) return this._onePageSelectAll(true);
        else return this.selectedItemKeys([], true, true, true);
    },
    _onePageSelectAll: function(isDeselect) {
        var items = this._selectionStrategy.getSelectableItems(this.options.plainItems());
        for(var i = 0; i < items.length; i++){
            var item = items[i];
            if (this.isDataItem(item)) {
                var itemData = this.options.getItemData(item);
                var itemKey = this.options.keyOf(itemData);
                var isSelected = this.isItemSelected(itemKey);
                if (!isSelected && !isDeselect) this._addSelectedItem(itemData, itemKey);
                if (isSelected && isDeselect) this._removeSelectedItem(itemKey);
            }
        }
        this.onSelectionChanged();
        return (new $291c5fbc436a2165$require$Deferred).resolve();
    },
    getSelectAllState: function(visibleOnly) {
        return this._selectionStrategy.getSelectAllState(visibleOnly);
    }
});


var $f4d41dfe58d276dc$var$_selection2 = $f4d41dfe58d276dc$var$_interopRequireDefault($291c5fbc436a2165$exports);

var $2F60d = parcelRequire("2F60d");
function $f4d41dfe58d276dc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $f4d41dfe58d276dc$var$_toConsumableArray(arr) {
    return $f4d41dfe58d276dc$var$_arrayWithoutHoles(arr) || $f4d41dfe58d276dc$var$_iterableToArray(arr) || $f4d41dfe58d276dc$var$_unsupportedIterableToArray(arr) || $f4d41dfe58d276dc$var$_nonIterableSpread();
}
function $f4d41dfe58d276dc$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f4d41dfe58d276dc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if ("string" === typeof o) return $f4d41dfe58d276dc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if ("Object" === n && o.constructor) n = o.constructor.name;
    if ("Map" === n || "Set" === n) return Array.from(o);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f4d41dfe58d276dc$var$_arrayLikeToArray(o, minLen);
}
function $f4d41dfe58d276dc$var$_iterableToArray(iter) {
    if ("undefined" !== typeof Symbol && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $f4d41dfe58d276dc$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f4d41dfe58d276dc$var$_arrayLikeToArray(arr);
}
function $f4d41dfe58d276dc$var$_arrayLikeToArray(arr, len) {
    if (null == len || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $f4d41dfe58d276dc$var$ITEM_DELETING_DATA_KEY = "dxItemDeleting";
var $f4d41dfe58d276dc$var$NOT_EXISTING_INDEX = -1;
var $f4d41dfe58d276dc$var$indexExists = function(index) {
    return index !== $f4d41dfe58d276dc$var$NOT_EXISTING_INDEX;
};
var $f4d41dfe58d276dc$var$CollectionWidget = $f4d41dfe58d276dc$var$_uiCollection_widget2.default.inherit({
    _setOptionsByReference: function() {
        this.callBase();
        (0, $7I8Uw.extend)(this._optionsByReference, {
            selectedItem: true
        });
    },
    _getDefaultOptions: function() {
        return (0, $7I8Uw.extend)(this.callBase(), {
            selectionMode: "none",
            selectionRequired: false,
            selectionByClick: true,
            selectedItems: [],
            selectedItemKeys: [],
            maxFilterLengthInRequest: 1500,
            keyExpr: null,
            selectedIndex: $f4d41dfe58d276dc$var$NOT_EXISTING_INDEX,
            selectedItem: null,
            onSelectionChanged: null,
            onItemReordered: null,
            onItemDeleting: null,
            onItemDeleted: null
        });
    },
    ctor: function(element, options) {
        this._userOptions = options || {};
        this.callBase(element, options);
    },
    _init: function() {
        this._initEditStrategy();
        this.callBase();
        this._initKeyGetter();
        this._initSelectionModule();
        if ("multi" === this.option("selectionMode")) this._showDeprecatedSelectionMode();
    },
    _initKeyGetter: function() {
        this._keyGetter = (0, $kpjzB.compileGetter)(this.option("keyExpr"));
    },
    _getKeysByItems: function(selectedItems) {
        return this._editStrategy.getKeysByItems(selectedItems);
    },
    _getItemsByKeys: function(selectedItemKeys, selectedItems) {
        return this._editStrategy.getItemsByKeys(selectedItemKeys, selectedItems);
    },
    _getKeyByIndex: function(index) {
        return this._editStrategy.getKeyByIndex(index);
    },
    _getIndexByKey: function(key) {
        return this._editStrategy.getIndexByKey(key);
    },
    _getIndexByItemData: function(itemData) {
        return this._editStrategy.getIndexByItemData(itemData);
    },
    _isKeySpecified: function() {
        return !!(this._dataSource && this._dataSource.key());
    },
    _getCombinedFilter: function() {
        return this._dataSource && this._dataSource.filter();
    },
    key: function() {
        if (this.option("keyExpr")) return this.option("keyExpr");
        return this._dataSource && this._dataSource.key();
    },
    keyOf: function(item) {
        var key = item;
        var store = this._dataSource && this._dataSource.store();
        if (this.option("keyExpr")) key = this._keyGetter(item);
        else if (store) key = store.keyOf(item);
        return key;
    },
    _nullValueSelectionSupported: function() {
        return false;
    },
    _initSelectionModule: function() {
        var that = this;
        var itemsGetter = that._editStrategy.itemsGetter;
        this._selection = new $f4d41dfe58d276dc$var$_selection2.default({
            allowNullValue: this._nullValueSelectionSupported(),
            mode: this.option("selectionMode"),
            maxFilterLengthInRequest: this.option("maxFilterLengthInRequest"),
            equalByReference: !this._isKeySpecified(),
            onSelectionChanged: function(args) {
                if (args.addedItemKeys.length || args.removedItemKeys.length) {
                    that.option("selectedItems", that._getItemsByKeys(args.selectedItemKeys, args.selectedItems));
                    that._updateSelectedItems(args);
                }
            },
            filter: that._getCombinedFilter.bind(that),
            totalCount: function() {
                var items = that.option("items");
                var dataSource = that._dataSource;
                return dataSource && dataSource.totalCount() >= 0 ? dataSource.totalCount() : items.length;
            },
            key: that.key.bind(that),
            keyOf: that.keyOf.bind(that),
            load: function(options) {
                if (that._dataSource) {
                    var loadOptions = that._dataSource.loadOptions();
                    options.customQueryParams = loadOptions.customQueryParams;
                    options.userData = that._dataSource._userData;
                }
                var store = that._dataSource && that._dataSource.store();
                if (store) return store.load(options).done(function(loadResult) {
                    if (that._disposed) return;
                    var items = (0, $45e3ac8fbec1786a$export$39a9f23879314f2b)(loadResult).data;
                    that._dataSource._applyMapFunction(items);
                });
                else return (new $2F60d.Deferred).resolve(this.plainItems());
            },
            dataFields: function() {
                return that._dataSource && that._dataSource.select();
            },
            plainItems: itemsGetter.bind(that._editStrategy)
        });
    },
    _initEditStrategy: function() {
        var Strategy = $f4d41dfe58d276dc$var$_uiCollection_widgetEditStrategy2.default;
        this._editStrategy = new Strategy(this);
    },
    _getSelectedItemIndices: function(keys) {
        var that = this;
        var indices = [];
        keys = keys || this._selection.getSelectedItemKeys();
        that._editStrategy.beginCache();
        (0, $4Pwuy.each)(keys, function(_, key) {
            var selectedIndex = that._getIndexByKey(key);
            if ($f4d41dfe58d276dc$var$indexExists(selectedIndex)) indices.push(selectedIndex);
        });
        that._editStrategy.endCache();
        return indices;
    },
    _initMarkup: function() {
        var _this = this;
        this._rendering = true;
        if (!this._dataSource || !this._dataSource.isLoading()) this._syncSelectionOptions().done(function() {
            return _this._normalizeSelectedItems();
        });
        this.callBase();
    },
    _render: function() {
        this.callBase();
        this._rendering = false;
    },
    _fireContentReadyAction: function() {
        this._rendering = false;
        this._rendered = true;
        this.callBase.apply(this, arguments);
    },
    _syncSelectionOptions: function(byOption) {
        byOption = byOption || this._chooseSelectOption();
        var selectedItem;
        var selectedIndex;
        var selectedItemKeys;
        var selectedItems;
        switch(byOption){
            case "selectedIndex":
                selectedItem = this._editStrategy.getItemDataByIndex(this.option("selectedIndex"));
                if ((0, $kDRxH.isDefined)(selectedItem)) {
                    this._setOptionSilent("selectedItems", [
                        selectedItem
                    ]);
                    this._setOptionSilent("selectedItem", selectedItem);
                    this._setOptionSilent("selectedItemKeys", this._editStrategy.getKeysByItems([
                        selectedItem
                    ]));
                } else {
                    this._setOptionSilent("selectedItems", []);
                    this._setOptionSilent("selectedItemKeys", []);
                    this._setOptionSilent("selectedItem", null);
                }
                break;
            case "selectedItems":
                selectedItems = this.option("selectedItems") || [];
                selectedIndex = this._editStrategy.getIndexByItemData(selectedItems[0]);
                if (this.option("selectionRequired") && !$f4d41dfe58d276dc$var$indexExists(selectedIndex)) return this._syncSelectionOptions("selectedIndex");
                this._setOptionSilent("selectedItem", selectedItems[0]);
                this._setOptionSilent("selectedIndex", selectedIndex);
                this._setOptionSilent("selectedItemKeys", this._editStrategy.getKeysByItems(selectedItems));
                break;
            case "selectedItem":
                selectedItem = this.option("selectedItem");
                selectedIndex = this._editStrategy.getIndexByItemData(selectedItem);
                if (this.option("selectionRequired") && !$f4d41dfe58d276dc$var$indexExists(selectedIndex)) return this._syncSelectionOptions("selectedIndex");
                if ((0, $kDRxH.isDefined)(selectedItem)) {
                    this._setOptionSilent("selectedItems", [
                        selectedItem
                    ]);
                    this._setOptionSilent("selectedIndex", selectedIndex);
                    this._setOptionSilent("selectedItemKeys", this._editStrategy.getKeysByItems([
                        selectedItem
                    ]));
                } else {
                    this._setOptionSilent("selectedItems", []);
                    this._setOptionSilent("selectedItemKeys", []);
                    this._setOptionSilent("selectedIndex", $f4d41dfe58d276dc$var$NOT_EXISTING_INDEX);
                }
                break;
            case "selectedItemKeys":
                selectedItemKeys = this.option("selectedItemKeys");
                if (this.option("selectionRequired")) {
                    var selectedItemIndex = this._getIndexByKey(selectedItemKeys[0]);
                    if (!$f4d41dfe58d276dc$var$indexExists(selectedItemIndex)) return this._syncSelectionOptions("selectedIndex");
                }
                return this._selection.setSelection(selectedItemKeys);
        }
        return (new $2F60d.Deferred).resolve().promise();
    },
    _chooseSelectOption: function() {
        var optionName = "selectedIndex";
        var isOptionDefined = (function(optionName) {
            var optionValue = this.option(optionName);
            var length = (0, $kDRxH.isDefined)(optionValue) && optionValue.length;
            return length || optionName in this._userOptions;
        }).bind(this);
        if (isOptionDefined("selectedItems")) optionName = "selectedItems";
        else {
            if (isOptionDefined("selectedItem")) optionName = "selectedItem";
            else if (isOptionDefined("selectedItemKeys")) optionName = "selectedItemKeys";
        }
        return optionName;
    },
    _compareKeys: function(oldKeys, newKeys) {
        if (oldKeys.length !== newKeys.length) return false;
        for(var i = 0; i < newKeys.length; i++){
            if (oldKeys[i] !== newKeys[i]) return false;
        }
        return true;
    },
    _normalizeSelectedItems: function() {
        if ("none" === this.option("selectionMode")) {
            this._setOptionSilent("selectedItems", []);
            this._syncSelectionOptions("selectedItems");
        } else if ("single" === this.option("selectionMode")) {
            var newSelection = this.option("selectedItems");
            if (newSelection.length > 1 || !newSelection.length && this.option("selectionRequired") && this.option("items") && this.option("items").length) {
                var currentSelection = this._selection.getSelectedItems();
                var normalizedSelection = void 0 === newSelection[0] ? currentSelection[0] : newSelection[0];
                if (void 0 === normalizedSelection) normalizedSelection = this._editStrategy.itemsGetter()[0];
                if (this.option("grouped") && normalizedSelection && normalizedSelection.items) normalizedSelection.items = [
                    normalizedSelection.items[0]
                ];
                this._selection.setSelection(this._getKeysByItems([
                    normalizedSelection
                ]));
                this._setOptionSilent("selectedItems", [
                    normalizedSelection
                ]);
                return this._syncSelectionOptions("selectedItems");
            } else this._selection.setSelection(this._getKeysByItems(newSelection));
        } else {
            var newKeys = this._getKeysByItems(this.option("selectedItems"));
            var oldKeys = this._selection.getSelectedItemKeys();
            if (!this._compareKeys(oldKeys, newKeys)) this._selection.setSelection(newKeys);
        }
        return (new $2F60d.Deferred).resolve().promise();
    },
    _itemClickHandler: function(e) {
        this._createAction((function(e) {
            this._itemSelectHandler(e.event);
        }).bind(this), {
            validatingTargetName: "itemElement"
        })({
            itemElement: (0, $f4d41dfe58d276dc$var$_renderer2.default)(e.currentTarget),
            event: e
        });
        this.callBase.apply(this, arguments);
    },
    _itemSelectHandler: function(e) {
        if (!this.option("selectionByClick")) return;
        var $itemElement = e.currentTarget;
        if (this.isItemSelected($itemElement)) this.unselectItem(e.currentTarget);
        else this.selectItem(e.currentTarget);
    },
    _selectedItemElement: function(index) {
        return this._itemElements().eq(index);
    },
    _postprocessRenderItem: function(args) {
        if ("none" !== this.option("selectionMode")) {
            var $itemElement = (0, $f4d41dfe58d276dc$var$_renderer2.default)(args.itemElement);
            var normalizedItemIndex = this._editStrategy.getNormalizedIndex($itemElement);
            var isItemSelected = this._isItemSelected(normalizedItemIndex);
            this._processSelectableItem($itemElement, isItemSelected);
        }
    },
    _processSelectableItem: function($itemElement, isSelected) {
        $itemElement.toggleClass(this._selectedItemClass(), isSelected);
        this._setAriaSelected($itemElement, String(isSelected));
    },
    _updateSelectedItems: function(args) {
        var that = this;
        var addedItemKeys = args.addedItemKeys;
        var removedItemKeys = args.removedItemKeys;
        if (that._rendered && (addedItemKeys.length || removedItemKeys.length)) {
            var selectionChangePromise = that._selectionChangePromise;
            if (!that._rendering) {
                var addedSelection = [];
                var normalizedIndex;
                var removedSelection = [];
                that._editStrategy.beginCache();
                for(var i = 0; i < addedItemKeys.length; i++){
                    normalizedIndex = that._getIndexByKey(addedItemKeys[i]);
                    addedSelection.push(normalizedIndex);
                    that._addSelection(normalizedIndex);
                }
                for(var _i = 0; _i < removedItemKeys.length; _i++){
                    normalizedIndex = that._getIndexByKey(removedItemKeys[_i]);
                    removedSelection.push(normalizedIndex);
                    that._removeSelection(normalizedIndex);
                }
                that._editStrategy.endCache();
                that._updateSelection(addedSelection, removedSelection);
            }
            (0, $2F60d.when)(selectionChangePromise).done(function() {
                that._fireSelectionChangeEvent(args.addedItems, args.removedItems);
            });
        }
    },
    _fireSelectionChangeEvent: function(addedItems, removedItems) {
        this._createActionByOption("onSelectionChanged", {
            excludeValidators: [
                "disabled",
                "readOnly"
            ]
        })({
            addedItems: addedItems,
            removedItems: removedItems
        });
    },
    _updateSelection: $2Mto0.noop,
    _setAriaSelected: function($target, value) {
        this.setAria("selected", value, $target);
    },
    _removeSelection: function(normalizedIndex) {
        var $itemElement = this._editStrategy.getItemElement(normalizedIndex);
        if ($f4d41dfe58d276dc$var$indexExists(normalizedIndex)) {
            this._processSelectableItem($itemElement, false);
            $f4d41dfe58d276dc$var$_events_engine2.default.triggerHandler($itemElement, "stateChanged", false);
        }
    },
    _showDeprecatedSelectionMode: function() {
        $f4d41dfe58d276dc$var$_ui2.default.log("W0001", this.NAME, "selectionMode: 'multi'", "16.1", "Use selectionMode: 'multiple' instead");
        this.option("selectionMode", "multiple");
    },
    _addSelection: function(normalizedIndex) {
        var $itemElement = this._editStrategy.getItemElement(normalizedIndex);
        if ($f4d41dfe58d276dc$var$indexExists(normalizedIndex)) {
            this._processSelectableItem($itemElement, true);
            $f4d41dfe58d276dc$var$_events_engine2.default.triggerHandler($itemElement, "stateChanged", true);
        }
    },
    _isItemSelected: function(index) {
        var key = this._getKeyByIndex(index);
        return this._selection.isItemSelected(key);
    },
    _optionChanged: function(args) {
        var _this2 = this;
        switch(args.name){
            case "selectionMode":
                if ("multi" === args.value) this._showDeprecatedSelectionMode();
                else this._invalidate();
                break;
            case "dataSource":
                if (!args.value || Array.isArray(args.value) && !args.value.length) this.option("selectedItemKeys", []);
                this.callBase(args);
                break;
            case "selectedIndex":
            case "selectedItem":
            case "selectedItems":
            case "selectedItemKeys":
                this._syncSelectionOptions(args.name).done(function() {
                    return _this2._normalizeSelectedItems();
                });
                break;
            case "keyExpr":
                this._initKeyGetter();
                break;
            case "selectionRequired":
                this._normalizeSelectedItems();
                break;
            case "selectionByClick":
            case "onSelectionChanged":
            case "onItemDeleting":
            case "onItemDeleted":
            case "onItemReordered":
            case "maxFilterLengthInRequest":
                break;
            default:
                this.callBase(args);
        }
    },
    _clearSelectedItems: function() {
        this._setOptionSilent("selectedItems", []);
        this._syncSelectionOptions("selectedItems");
    },
    _waitDeletingPrepare: function($itemElement) {
        if ($itemElement.data($f4d41dfe58d276dc$var$ITEM_DELETING_DATA_KEY)) return (new $2F60d.Deferred).resolve().promise();
        $itemElement.data($f4d41dfe58d276dc$var$ITEM_DELETING_DATA_KEY, true);
        var deferred = new $2F60d.Deferred;
        var deletingActionArgs = {
            cancel: false
        };
        var deletePromise = this._itemEventHandler($itemElement, "onItemDeleting", deletingActionArgs, {
            excludeValidators: [
                "disabled",
                "readOnly"
            ]
        });
        (0, $2F60d.when)(deletePromise).always((function(value) {
            var deletePromiseExists = !deletePromise;
            var deletePromiseResolved = !deletePromiseExists && "resolved" === deletePromise.state();
            var argumentsSpecified = !!arguments.length;
            var shouldDelete = deletePromiseExists || deletePromiseResolved && !argumentsSpecified || deletePromiseResolved && value;
            (0, $2F60d.when)((0, $2F60d.fromPromise)(deletingActionArgs.cancel)).always(function() {
                $itemElement.data($f4d41dfe58d276dc$var$ITEM_DELETING_DATA_KEY, false);
            }).done(function(cancel) {
                shouldDelete && !cancel ? deferred.resolve() : deferred.reject();
            }).fail(deferred.reject);
        }).bind(this));
        return deferred.promise();
    },
    _deleteItemFromDS: function($item) {
        if (!this._dataSource) return (new $2F60d.Deferred).resolve().promise();
        var deferred = new $2F60d.Deferred;
        var disabledState = this.option("disabled");
        var dataStore = this._dataSource.store();
        this.option("disabled", true);
        if (!dataStore.remove) throw $f4d41dfe58d276dc$var$_ui2.default.Error("E1011");
        dataStore.remove(dataStore.keyOf(this._getItemData($item))).done(function(key) {
            if (void 0 !== key) deferred.resolve();
            else deferred.reject();
        }).fail(function() {
            deferred.reject();
        });
        deferred.always((function() {
            this.option("disabled", disabledState);
        }).bind(this));
        return deferred;
    },
    _tryRefreshLastPage: function() {
        var deferred = new $2F60d.Deferred;
        if (this._isLastPage() || this.option("grouped")) deferred.resolve();
        else this._refreshLastPage().done(function() {
            deferred.resolve();
        });
        return deferred.promise();
    },
    _refreshLastPage: function() {
        this._expectLastItemLoading();
        return this._dataSource.load();
    },
    _updateSelectionAfterDelete: function(index) {
        var key = this._getKeyByIndex(index);
        this._selection.deselect([
            key
        ]);
    },
    _updateIndicesAfterIndex: function(index) {
        var itemElements = this._itemElements();
        for(var i = index + 1; i < itemElements.length; i++)(0, $f4d41dfe58d276dc$var$_renderer2.default)(itemElements[i]).data(this._itemIndexKey(), i - 1);
    },
    _simulateOptionChange: function(optionName) {
        var optionValue = this.option(optionName);
        if (optionValue instanceof $45e3ac8fbec1786a$export$accd73d198d77d2f) return;
        this._optionChangedAction({
            name: optionName,
            fullName: optionName,
            value: optionValue
        });
    },
    isItemSelected: function(itemElement) {
        return this._isItemSelected(this._editStrategy.getNormalizedIndex(itemElement));
    },
    selectItem: function(itemElement) {
        if ("none" === this.option("selectionMode")) return;
        var itemIndex = this._editStrategy.getNormalizedIndex(itemElement);
        if (!$f4d41dfe58d276dc$var$indexExists(itemIndex)) return;
        var key = this._getKeyByIndex(itemIndex);
        if (this._selection.isItemSelected(key)) return;
        if ("single" === this.option("selectionMode")) this._selection.setSelection([
            key
        ]);
        else {
            var selectedItemKeys = this.option("selectedItemKeys") || [];
            this._selection.setSelection([].concat($f4d41dfe58d276dc$var$_toConsumableArray(selectedItemKeys), [
                key
            ]));
        }
    },
    unselectItem: function(itemElement) {
        var itemIndex = this._editStrategy.getNormalizedIndex(itemElement);
        if (!$f4d41dfe58d276dc$var$indexExists(itemIndex)) return;
        var selectedItemKeys = this._selection.getSelectedItemKeys();
        if (this.option("selectionRequired") && selectedItemKeys.length <= 1) return;
        var key = this._getKeyByIndex(itemIndex);
        if (!this._selection.isItemSelected(key)) return;
        this._selection.deselect([
            key
        ]);
    },
    _deleteItemElementByIndex: function(index) {
        this._updateSelectionAfterDelete(index);
        this._updateIndicesAfterIndex(index);
        this._editStrategy.deleteItemAtIndex(index);
    },
    _afterItemElementDeleted: function($item, deletedActionArgs) {
        var changingOption = this._dataSource ? "dataSource" : "items";
        this._simulateOptionChange(changingOption);
        this._itemEventHandler($item, "onItemDeleted", deletedActionArgs, {
            beforeExecute: function() {
                $item.remove();
            },
            excludeValidators: [
                "disabled",
                "readOnly"
            ]
        });
        this._renderEmptyMessage();
    },
    deleteItem: function(itemElement) {
        var that = this;
        var deferred = new $2F60d.Deferred;
        var $item = this._editStrategy.getItemElement(itemElement);
        var index = this._editStrategy.getNormalizedIndex(itemElement);
        var itemResponseWaitClass = this._itemResponseWaitClass();
        if ($f4d41dfe58d276dc$var$indexExists(index)) this._waitDeletingPrepare($item).done(function() {
            $item.addClass(itemResponseWaitClass);
            var deletedActionArgs = that._extendActionArgs($item);
            that._deleteItemFromDS($item).done(function() {
                that._deleteItemElementByIndex(index);
                that._afterItemElementDeleted($item, deletedActionArgs);
                that._tryRefreshLastPage().done(function() {
                    deferred.resolveWith(that);
                });
            }).fail(function() {
                $item.removeClass(itemResponseWaitClass);
                deferred.rejectWith(that);
            });
        }).fail(function() {
            deferred.rejectWith(that);
        });
        else deferred.rejectWith(that);
        return deferred.promise();
    },
    reorderItem: function(itemElement, toItemElement) {
        var deferred = new $2F60d.Deferred;
        var that = this;
        var strategy = this._editStrategy;
        var $movingItem = strategy.getItemElement(itemElement);
        var $destinationItem = strategy.getItemElement(toItemElement);
        var movingIndex = strategy.getNormalizedIndex(itemElement);
        var destinationIndex = strategy.getNormalizedIndex(toItemElement);
        var changingOption = this._dataSource ? "dataSource" : "items";
        var canMoveItems = $f4d41dfe58d276dc$var$indexExists(movingIndex) && $f4d41dfe58d276dc$var$indexExists(destinationIndex) && movingIndex !== destinationIndex;
        if (canMoveItems) deferred.resolveWith(this);
        else deferred.rejectWith(this);
        return deferred.promise().done(function() {
            $destinationItem[strategy.itemPlacementFunc(movingIndex, destinationIndex)]($movingItem);
            strategy.moveItemAtIndexToIndex(movingIndex, destinationIndex);
            this._updateIndicesAfterIndex(movingIndex);
            that.option("selectedItems", that._getItemsByKeys(that._selection.getSelectedItemKeys(), that._selection.getSelectedItems()));
            if ("items" === changingOption) that._simulateOptionChange(changingOption);
            that._itemEventHandler($movingItem, "onItemReordered", {
                fromIndex: strategy.getIndex(movingIndex),
                toIndex: strategy.getIndex(destinationIndex)
            }, {
                excludeValidators: [
                    "disabled",
                    "readOnly"
                ]
            });
        });
    }
});
$f4d41dfe58d276dc$exports = $f4d41dfe58d276dc$var$CollectionWidget;


var $685b737554cd2492$exports = {};
/**
 * DevExtreme (ui/popup.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $6jr65 = parcelRequire("6jr65");
var $685b737554cd2492$var$_translator2 = $685b737554cd2492$var$_interopRequireDefault($6jr65);

var $4ZFRo = parcelRequire("4ZFRo");
var $685b737554cd2492$var$_component_registrator2 = $685b737554cd2492$var$_interopRequireDefault($4ZFRo);

var $aiwte = parcelRequire("aiwte");
var $685b737554cd2492$var$_devices2 = $685b737554cd2492$var$_interopRequireDefault($aiwte);

var $5OzEX = parcelRequire("5OzEX");
var $685b737554cd2492$var$_dom2 = $685b737554cd2492$var$_interopRequireDefault($5OzEX);

var $jFnCG = parcelRequire("jFnCG");
var $685b737554cd2492$var$_renderer2 = $685b737554cd2492$var$_interopRequireDefault($jFnCG);

var $e5a0x = parcelRequire("e5a0x");

var $aLQK5 = parcelRequire("aLQK5");

var $bvcPv = parcelRequire("bvcPv");
var $685b737554cd2492$var$_browser2 = $685b737554cd2492$var$_interopRequireDefault($bvcPv);

var $2Mto0 = parcelRequire("2Mto0");

var $7I8Uw = parcelRequire("7I8Uw");

var $ih7fv = parcelRequire("ih7fv");

var $4Pwuy = parcelRequire("4Pwuy");

var $5szhX = parcelRequire("5szhX");
var $685b737554cd2492$var$_size2 = $685b737554cd2492$var$_interopRequireDefault($5szhX);

var $1TtsA = parcelRequire("1TtsA");

var $kDRxH = parcelRequire("kDRxH");

var $hwytx = parcelRequire("hwytx");

var $irv64 = parcelRequire("irv64");
var $685b737554cd2492$var$_window2 = $685b737554cd2492$var$_interopRequireDefault($irv64);

var $cnVbh = parcelRequire("cnVbh");
var $685b737554cd2492$var$_message2 = $685b737554cd2492$var$_interopRequireDefault($cnVbh);

var $7KuSv = parcelRequire("7KuSv");
var $685b737554cd2492$var$_button2 = $685b737554cd2492$var$_interopRequireDefault($7KuSv);

var $8LFjz = parcelRequire("8LFjz");
var $685b737554cd2492$var$_overlay2 = $685b737554cd2492$var$_interopRequireDefault($8LFjz);

var $3LUJe = parcelRequire("3LUJe");
var $685b737554cd2492$var$_themes2 = $685b737554cd2492$var$_interopRequireDefault($3LUJe);
function $685b737554cd2492$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $685b737554cd2492$var$window = $685b737554cd2492$var$_window2.default.getWindow();
var $bdbd081a08b7d677$exports = {};
/**
 * DevExtreme (ui/toolbar/ui.toolbar.base.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $bdbd081a08b7d677$var$_renderer2 = $bdbd081a08b7d677$var$_interopRequireDefault($jFnCG);

var $3LUJe = parcelRequire("3LUJe");
var $bdbd081a08b7d677$var$_themes2 = $bdbd081a08b7d677$var$_interopRequireDefault($3LUJe);

var $2Mto0 = parcelRequire("2Mto0");
var $bdbd081a08b7d677$var$_common2 = $bdbd081a08b7d677$var$_interopRequireDefault($2Mto0);

var $kDRxH = parcelRequire("kDRxH");

var $4ZFRo = parcelRequire("4ZFRo");
var $bdbd081a08b7d677$var$_component_registrator2 = $bdbd081a08b7d677$var$_interopRequireDefault($4ZFRo);

var $aLQK5 = parcelRequire("aLQK5");

var $7I8Uw = parcelRequire("7I8Uw");

var $4Pwuy = parcelRequire("4Pwuy");

var $1TtsA = parcelRequire("1TtsA");
var $4ad16c1b0782d4a3$exports = {};
/**
 * DevExtreme (ui/collection/ui.collection_widget.async.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $4ad16c1b0782d4a3$var$_uiCollection_widget2 = $4ad16c1b0782d4a3$var$_interopRequireDefault($f4d41dfe58d276dc$exports);

var $2F60d = parcelRequire("2F60d");

var $2Mto0 = parcelRequire("2Mto0");
function $4ad16c1b0782d4a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $4ad16c1b0782d4a3$var$AsyncCollectionWidget = $4ad16c1b0782d4a3$var$_uiCollection_widget2.default.inherit({
    _initMarkup: function() {
        this._deferredItems = [];
        this.callBase();
    },
    _renderItemContent: function(args) {
        var renderContentDeferred = new $2F60d.Deferred;
        var itemDeferred = new $2F60d.Deferred;
        var that = this;
        this._deferredItems[args.index] = itemDeferred;
        var $itemContent = this.callBase.call(that, args);
        itemDeferred.done(function() {
            renderContentDeferred.resolve($itemContent);
        });
        return renderContentDeferred.promise();
    },
    _createItemByTemplate: function(itemTemplate, renderArgs) {
        var _this = this;
        return itemTemplate.render({
            model: renderArgs.itemData,
            container: renderArgs.container,
            index: renderArgs.index,
            onRendered: function() {
                _this._deferredItems[renderArgs.index].resolve();
            }
        });
    },
    _postProcessRenderItems: $2Mto0.noop,
    _renderItemsAsync: function() {
        var _this2 = this;
        var d = new $2F60d.Deferred;
        $2F60d.when.apply(this, this._deferredItems).done(function() {
            _this2._postProcessRenderItems();
            d.resolve();
        });
        return d.promise();
    },
    _clean: function() {
        this.callBase();
        this._deferredItems = [];
    }
});
$4ad16c1b0782d4a3$exports = $4ad16c1b0782d4a3$var$AsyncCollectionWidget;


var $bdbd081a08b7d677$var$_uiCollection_widget2 = $bdbd081a08b7d677$var$_interopRequireDefault($4ad16c1b0782d4a3$exports);

var $1jnPB = parcelRequire("1jnPB");
var $bdbd081a08b7d677$var$_promise2 = $bdbd081a08b7d677$var$_interopRequireDefault($1jnPB);


var $c7ml4 = parcelRequire("c7ml4");
var $bdbd081a08b7d677$var$_fx2 = $bdbd081a08b7d677$var$_interopRequireDefault($c7ml4);
function $bdbd081a08b7d677$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $bdbd081a08b7d677$var$TOOLBAR_CLASS = "dx-toolbar";
var $bdbd081a08b7d677$var$TOOLBAR_BEFORE_CLASS = "dx-toolbar-before";
var $bdbd081a08b7d677$var$TOOLBAR_CENTER_CLASS = "dx-toolbar-center";
var $bdbd081a08b7d677$var$TOOLBAR_AFTER_CLASS = "dx-toolbar-after";
var $bdbd081a08b7d677$var$TOOLBAR_BOTTOM_CLASS = "dx-toolbar-bottom";
var $bdbd081a08b7d677$var$TOOLBAR_MINI_CLASS = "dx-toolbar-mini";
var $bdbd081a08b7d677$var$TOOLBAR_ITEM_CLASS = "dx-toolbar-item";
var $bdbd081a08b7d677$var$TOOLBAR_LABEL_CLASS = "dx-toolbar-label";
var $bdbd081a08b7d677$var$TOOLBAR_BUTTON_CLASS = "dx-toolbar-button";
var $bdbd081a08b7d677$var$TOOLBAR_ITEMS_CONTAINER_CLASS = "dx-toolbar-items-container";
var $bdbd081a08b7d677$var$TOOLBAR_GROUP_CLASS = "dx-toolbar-group";
var $bdbd081a08b7d677$var$TOOLBAR_COMPACT_CLASS = "dx-toolbar-compact";
var $bdbd081a08b7d677$var$TOOLBAR_LABEL_SELECTOR = "." + $bdbd081a08b7d677$var$TOOLBAR_LABEL_CLASS;
var $bdbd081a08b7d677$var$TEXT_BUTTON_MODE = "text";
var $bdbd081a08b7d677$var$DEFAULT_BUTTON_TYPE = "default";
var $bdbd081a08b7d677$var$TOOLBAR_ITEM_DATA_KEY = "dxToolbarItemDataKey";
var $bdbd081a08b7d677$var$ToolbarBase = $bdbd081a08b7d677$var$_uiCollection_widget2.default.inherit({
    compactMode: false,
    ctor: function(element, options) {
        this._userOptions = options || {};
        this.callBase(element, options);
    },
    _getSynchronizableOptionsForCreateComponent: function() {
        return this.callBase().filter(function(item) {
            return "disabled" !== item;
        });
    },
    _initTemplates: function() {
        this.callBase();
        var template = new $46d7ae10a89c38af$exports.BindableTemplate((function($container, data, rawModel) {
            if ((0, $kDRxH.isPlainObject)(data)) {
                if (data.text) $container.text(data.text).wrapInner("<div>");
                if (data.html) $container.html(data.html);
                if ("dxButton" === data.widget) {
                    if (this.option("useFlatButtons")) {
                        data.options = data.options || {};
                        data.options.stylingMode = data.options.stylingMode || $bdbd081a08b7d677$var$TEXT_BUTTON_MODE;
                    }
                    if (this.option("useDefaultButtons")) {
                        data.options = data.options || {};
                        data.options.type = data.options.type || $bdbd081a08b7d677$var$DEFAULT_BUTTON_TYPE;
                    }
                }
            } else $container.text(String(data));
            this._getTemplate("dx-polymorph-widget").render({
                container: $container,
                model: rawModel,
                parent: this
            });
        }).bind(this), [
            "text",
            "html",
            "widget",
            "options"
        ], this.option("integrationOptions.watchMethod"));
        this._defaultTemplates.item = template;
        this._defaultTemplates.menuItem = template;
    },
    _getDefaultOptions: function() {
        return (0, $7I8Uw.extend)(this.callBase(), {
            renderAs: "topToolbar",
            grouped: false,
            useFlatButtons: false,
            useDefaultButtons: false
        });
    },
    _defaultOptionsRules: function() {
        return this.callBase().concat([
            {
                device: function() {
                    return $bdbd081a08b7d677$var$_themes2.default.isMaterial();
                },
                options: {
                    useFlatButtons: true
                }
            }
        ]);
    },
    _itemContainer: function() {
        return this._$toolbarItemsContainer.find([
            "." + $bdbd081a08b7d677$var$TOOLBAR_BEFORE_CLASS,
            "." + $bdbd081a08b7d677$var$TOOLBAR_CENTER_CLASS,
            "." + $bdbd081a08b7d677$var$TOOLBAR_AFTER_CLASS
        ].join(","));
    },
    _itemClass: function() {
        return $bdbd081a08b7d677$var$TOOLBAR_ITEM_CLASS;
    },
    _itemDataKey: function() {
        return $bdbd081a08b7d677$var$TOOLBAR_ITEM_DATA_KEY;
    },
    _buttonClass: function() {
        return $bdbd081a08b7d677$var$TOOLBAR_BUTTON_CLASS;
    },
    _dimensionChanged: function() {
        this._arrangeItems();
        this._applyCompactMode();
    },
    _initMarkup: function() {
        this._renderToolbar();
        this._renderSections();
        this.callBase();
        this.setAria("role", "toolbar");
    },
    _waitParentAnimationFinished: function() {
        var _this = this;
        var $element = this.$element();
        var timeout = 15;
        return new $bdbd081a08b7d677$var$_promise2.default(function(resolve) {
            var check = function() {
                var readyToResolve = true;
                $element.parents().each(function(_, parent) {
                    if ($bdbd081a08b7d677$var$_fx2.default.isAnimating((0, $bdbd081a08b7d677$var$_renderer2.default)(parent))) {
                        readyToResolve = false;
                        return false;
                    }
                });
                if (readyToResolve) resolve();
                return readyToResolve;
            };
            var runCheck = function runCheck() {
                clearTimeout(_this._waitParentAnimationTimeout);
                _this._waitParentAnimationTimeout = setTimeout(function() {
                    return check() || runCheck();
                }, timeout);
            };
            runCheck();
        });
    },
    _render: function() {
        this.callBase();
        this._renderItemsAsync();
        if ($bdbd081a08b7d677$var$_themes2.default.isMaterial()) $bdbd081a08b7d677$var$_promise2.default.all([
            this._waitParentAnimationFinished(),
            this._checkWebFontForLabelsLoaded()
        ]).then(this._dimensionChanged.bind(this));
    },
    _postProcessRenderItems: function() {
        this._arrangeItems();
    },
    _renderToolbar: function() {
        this.$element().addClass($bdbd081a08b7d677$var$TOOLBAR_CLASS).toggleClass($bdbd081a08b7d677$var$TOOLBAR_BOTTOM_CLASS, "bottomToolbar" === this.option("renderAs"));
        this._$toolbarItemsContainer = (0, $bdbd081a08b7d677$var$_renderer2.default)("<div>").addClass($bdbd081a08b7d677$var$TOOLBAR_ITEMS_CONTAINER_CLASS).appendTo(this.$element());
    },
    _renderSections: function() {
        var $container = this._$toolbarItemsContainer;
        var that = this;
        (0, $4Pwuy.each)([
            "before",
            "center",
            "after"
        ], function() {
            var sectionClass = "dx-toolbar-" + this;
            var $section = $container.find("." + sectionClass);
            if (!$section.length) that["_$" + this + "Section"] = $section = (0, $bdbd081a08b7d677$var$_renderer2.default)("<div>").addClass(sectionClass).appendTo($container);
        });
    },
    _checkWebFontForLabelsLoaded: function() {
        var $labels = this.$element().find($bdbd081a08b7d677$var$TOOLBAR_LABEL_SELECTOR);
        var promises = [];
        $labels.each(function(_, label) {
            var text = (0, $bdbd081a08b7d677$var$_renderer2.default)(label).text();
            var fontWeight = (0, $bdbd081a08b7d677$var$_renderer2.default)(label).css("fontWeight");
            promises.push($bdbd081a08b7d677$var$_themes2.default.waitWebFont(text, fontWeight));
        });
        return $bdbd081a08b7d677$var$_promise2.default.all(promises);
    },
    _arrangeItems: function(elementWidth) {
        elementWidth = elementWidth || this.$element().width();
        this._$centerSection.css({
            margin: "0 auto",
            "float": "none"
        });
        var beforeRect = (0, $1TtsA.getBoundingRect)(this._$beforeSection.get(0));
        var afterRect = (0, $1TtsA.getBoundingRect)(this._$afterSection.get(0));
        this._alignCenterSection(beforeRect, afterRect, elementWidth);
        var $label = this._$toolbarItemsContainer.find($bdbd081a08b7d677$var$TOOLBAR_LABEL_SELECTOR).eq(0);
        var $section = $label.parent();
        if (!$label.length) return;
        var labelOffset = beforeRect.width ? beforeRect.width : $label.position().left;
        var widthBeforeSection = $section.hasClass($bdbd081a08b7d677$var$TOOLBAR_BEFORE_CLASS) ? 0 : labelOffset;
        var widthAfterSection = $section.hasClass($bdbd081a08b7d677$var$TOOLBAR_AFTER_CLASS) ? 0 : afterRect.width;
        var elemsAtSectionWidth = 0;
        $section.children().not($bdbd081a08b7d677$var$TOOLBAR_LABEL_SELECTOR).each(function() {
            elemsAtSectionWidth += (0, $bdbd081a08b7d677$var$_renderer2.default)(this).outerWidth();
        });
        var freeSpace = elementWidth - elemsAtSectionWidth;
        var sectionMaxWidth = Math.max(freeSpace - widthBeforeSection - widthAfterSection, 0);
        if ($section.hasClass($bdbd081a08b7d677$var$TOOLBAR_BEFORE_CLASS)) this._alignSection(this._$beforeSection, sectionMaxWidth);
        else {
            var labelPaddings = $label.outerWidth() - $label.width();
            $label.css("maxWidth", sectionMaxWidth - labelPaddings);
        }
    },
    _alignCenterSection: function(beforeRect, afterRect, elementWidth) {
        this._alignSection(this._$centerSection, elementWidth - beforeRect.width - afterRect.width);
        var isRTL = this.option("rtlEnabled");
        var leftRect = isRTL ? afterRect : beforeRect;
        var rightRect = isRTL ? beforeRect : afterRect;
        var centerRect = (0, $1TtsA.getBoundingRect)(this._$centerSection.get(0));
        if (leftRect.right > centerRect.left || centerRect.right > rightRect.left) this._$centerSection.css({
            marginLeft: leftRect.width,
            marginRight: rightRect.width,
            "float": leftRect.width > rightRect.width ? "none" : "right"
        });
    },
    _alignSection: function($section, maxWidth) {
        var $labels = $section.find($bdbd081a08b7d677$var$TOOLBAR_LABEL_SELECTOR);
        var labels = $labels.toArray();
        maxWidth -= this._getCurrentLabelsPaddings(labels);
        var currentWidth = this._getCurrentLabelsWidth(labels);
        var difference = Math.abs(currentWidth - maxWidth);
        if (maxWidth < currentWidth) {
            labels = labels.reverse();
            this._alignSectionLabels(labels, difference, false);
        } else this._alignSectionLabels(labels, difference, true);
    },
    _alignSectionLabels: function(labels, difference, expanding) {
        var getRealLabelWidth = function(label) {
            return (0, $1TtsA.getBoundingRect)(label).width;
        };
        for(var i = 0; i < labels.length; i++){
            var $label = (0, $bdbd081a08b7d677$var$_renderer2.default)(labels[i]);
            var currentLabelWidth = Math.ceil(getRealLabelWidth(labels[i]));
            var labelMaxWidth;
            if (expanding) $label.css("maxWidth", "inherit");
            var possibleLabelWidth = Math.ceil(expanding ? getRealLabelWidth(labels[i]) : currentLabelWidth);
            if (possibleLabelWidth < difference) {
                labelMaxWidth = expanding ? possibleLabelWidth : 0;
                difference -= possibleLabelWidth;
            } else {
                labelMaxWidth = expanding ? currentLabelWidth + difference : currentLabelWidth - difference;
                $label.css("maxWidth", labelMaxWidth);
                break;
            }
            $label.css("maxWidth", labelMaxWidth);
        }
    },
    _applyCompactMode: function() {
        var $element = this.$element();
        $element.removeClass($bdbd081a08b7d677$var$TOOLBAR_COMPACT_CLASS);
        if (this.option("compactMode") && this._getSummaryItemsWidth(this.itemElements(), true) > $element.width()) $element.addClass($bdbd081a08b7d677$var$TOOLBAR_COMPACT_CLASS);
    },
    _getCurrentLabelsWidth: function(labels) {
        var width = 0;
        labels.forEach(function(label, index) {
            width += (0, $bdbd081a08b7d677$var$_renderer2.default)(label).outerWidth();
        });
        return width;
    },
    _getCurrentLabelsPaddings: function(labels) {
        var padding = 0;
        labels.forEach(function(label, index) {
            padding += (0, $bdbd081a08b7d677$var$_renderer2.default)(label).outerWidth() - (0, $bdbd081a08b7d677$var$_renderer2.default)(label).width();
        });
        return padding;
    },
    _renderItem: function(index, item, itemContainer, $after) {
        var location = item.location || "center";
        var container = itemContainer || this["_$" + location + "Section"];
        var itemHasText = !!(item.text || item.html);
        var itemElement = this.callBase(index, item, container, $after);
        itemElement.toggleClass(this._buttonClass(), !itemHasText).toggleClass($bdbd081a08b7d677$var$TOOLBAR_LABEL_CLASS, itemHasText).addClass(item.cssClass);
        return itemElement;
    },
    _renderGroupedItems: function() {
        var that = this;
        (0, $4Pwuy.each)(this.option("items"), function(groupIndex, group) {
            var groupItems = group.items;
            var $container = (0, $bdbd081a08b7d677$var$_renderer2.default)("<div>").addClass($bdbd081a08b7d677$var$TOOLBAR_GROUP_CLASS);
            var location = group.location || "center";
            if (!groupItems || !groupItems.length) return;
            (0, $4Pwuy.each)(groupItems, function(itemIndex, item) {
                that._renderItem(itemIndex, item, $container, null);
            });
            that._$toolbarItemsContainer.find(".dx-toolbar-" + location).append($container);
        });
    },
    _renderItems: function(items) {
        var grouped = this.option("grouped") && items.length && items[0].items;
        grouped ? this._renderGroupedItems() : this.callBase(items);
    },
    _getToolbarItems: function() {
        return this.option("items") || [];
    },
    _renderContentImpl: function() {
        var items = this._getToolbarItems();
        this.$element().toggleClass($bdbd081a08b7d677$var$TOOLBAR_MINI_CLASS, 0 === items.length);
        if (this._renderedItemsCount) this._renderItems(items.slice(this._renderedItemsCount));
        else this._renderItems(items);
        this._applyCompactMode();
    },
    _renderEmptyMessage: $bdbd081a08b7d677$var$_common2.default.noop,
    _clean: function() {
        this._$toolbarItemsContainer.children().empty();
        this.$element().empty();
    },
    _visibilityChanged: function(visible) {
        if (visible) this._arrangeItems();
    },
    _isVisible: function() {
        return this.$element().width() > 0 && this.$element().height() > 0;
    },
    _getIndexByItem: function(item) {
        return (0, $aLQK5.inArray)(item, this._getToolbarItems());
    },
    _itemOptionChanged: function(item, property, value) {
        this.callBase.apply(this, [
            item,
            property,
            value
        ]);
        this._arrangeItems();
    },
    _optionChanged: function(args) {
        var name = args.name;
        switch(name){
            case "width":
                this.callBase.apply(this, arguments);
                this._dimensionChanged();
                break;
            case "renderAs":
            case "useFlatButtons":
            case "useDefaultButtons":
                this._invalidate();
                break;
            case "compactMode":
                this._applyCompactMode();
                break;
            case "grouped":
                break;
            default:
                this.callBase.apply(this, arguments);
        }
    },
    _dispose: function() {
        this.callBase();
        clearTimeout(this._waitParentAnimationTimeout);
    }
});
(0, $bdbd081a08b7d677$var$_component_registrator2.default)("dxToolbarBase", $bdbd081a08b7d677$var$ToolbarBase);
$bdbd081a08b7d677$exports = $bdbd081a08b7d677$var$ToolbarBase;


var $685b737554cd2492$var$POPUP_CLASS = "dx-popup";
var $685b737554cd2492$var$POPUP_WRAPPER_CLASS = "dx-popup-wrapper";
var $685b737554cd2492$var$POPUP_FULL_SCREEN_CLASS = "dx-popup-fullscreen";
var $685b737554cd2492$var$POPUP_FULL_SCREEN_WIDTH_CLASS = "dx-popup-fullscreen-width";
var $685b737554cd2492$var$POPUP_NORMAL_CLASS = "dx-popup-normal";
var $685b737554cd2492$var$POPUP_CONTENT_CLASS = "dx-popup-content";
var $685b737554cd2492$var$POPUP_DRAGGABLE_CLASS = "dx-popup-draggable";
var $685b737554cd2492$var$POPUP_TITLE_CLASS = "dx-popup-title";
var $685b737554cd2492$var$POPUP_TITLE_CLOSEBUTTON_CLASS = "dx-closebutton";
var $685b737554cd2492$var$POPUP_BOTTOM_CLASS = "dx-popup-bottom";
var $685b737554cd2492$var$TEMPLATE_WRAPPER_CLASS = "dx-template-wrapper";
var $685b737554cd2492$var$POPUP_CONTENT_FLEX_HEIGHT_CLASS = "dx-popup-flex-height";
var $685b737554cd2492$var$POPUP_CONTENT_INHERIT_HEIGHT_CLASS = "dx-popup-inherit-height";
var $685b737554cd2492$var$ALLOWED_TOOLBAR_ITEM_ALIASES = [
    "cancel",
    "clear",
    "done"
];
var $685b737554cd2492$var$BUTTON_DEFAULT_TYPE = "default";
var $685b737554cd2492$var$BUTTON_NORMAL_TYPE = "normal";
var $685b737554cd2492$var$BUTTON_TEXT_MODE = "text";
var $685b737554cd2492$var$BUTTON_CONTAINED_MODE = "contained";
var $685b737554cd2492$var$IS_IE11 = $685b737554cd2492$var$_browser2.default.msie && 11 === parseInt($685b737554cd2492$var$_browser2.default.version);
var $685b737554cd2492$var$IS_OLD_SAFARI = $685b737554cd2492$var$_browser2.default.safari && (0, $hwytx.compare)($685b737554cd2492$var$_browser2.default.version, [
    11
]) < 0;
var $685b737554cd2492$var$HEIGHT_STRATEGIES = {
    "static": "",
    inherit: $685b737554cd2492$var$POPUP_CONTENT_INHERIT_HEIGHT_CLASS,
    flex: $685b737554cd2492$var$POPUP_CONTENT_FLEX_HEIGHT_CLASS
};
var $685b737554cd2492$var$getButtonPlace = function(name) {
    var device = $685b737554cd2492$var$_devices2.default.current();
    var platform = device.platform;
    var toolbar = "bottom";
    var location = "before";
    if ("ios" === platform) switch(name){
        case "cancel":
            toolbar = "top";
            break;
        case "clear":
            toolbar = "top";
            location = "after";
            break;
        case "done":
            location = "after";
    }
    else {
        if ("android" === platform && device.version && parseInt(device.version[0]) > 4) switch(name){
            case "cancel":
                location = "after";
                break;
            case "done":
                location = "after";
        }
        else if ("android" === platform) location = "center";
    }
    return {
        toolbar: toolbar,
        location: location
    };
};
var $685b737554cd2492$var$Popup = $685b737554cd2492$var$_overlay2.default.inherit({
    _getDefaultOptions: function() {
        return (0, $7I8Uw.extend)(this.callBase(), {
            fullScreen: false,
            title: "",
            showTitle: true,
            titleTemplate: "title",
            onTitleRendered: null,
            dragEnabled: false,
            toolbarItems: [],
            showCloseButton: false,
            bottomTemplate: "bottom",
            useDefaultToolbarButtons: false,
            useFlatToolbarButtons: false,
            autoResizeEnabled: true
        });
    },
    _defaultOptionsRules: function() {
        var themeName = $685b737554cd2492$var$_themes2.default.current();
        return this.callBase().concat([
            {
                device: {
                    platform: "ios"
                },
                options: {
                    animation: this._iosAnimation
                }
            },
            {
                device: {
                    platform: "android"
                },
                options: {
                    animation: this._androidAnimation
                }
            },
            {
                device: {
                    platform: "generic"
                },
                options: {
                    showCloseButton: true
                }
            },
            {
                device: function(_device) {
                    return "desktop" === $685b737554cd2492$var$_devices2.default.real().deviceType && "generic" === _device.platform;
                },
                options: {
                    dragEnabled: true
                }
            },
            {
                device: function() {
                    return "desktop" === $685b737554cd2492$var$_devices2.default.real().deviceType && !$685b737554cd2492$var$_devices2.default.isSimulator();
                },
                options: {
                    focusStateEnabled: true
                }
            },
            {
                device: function() {
                    return $685b737554cd2492$var$_themes2.default.isMaterial(themeName);
                },
                options: {
                    useDefaultToolbarButtons: true,
                    useFlatToolbarButtons: true
                }
            }
        ]);
    },
    _iosAnimation: {
        show: {
            type: "slide",
            duration: 400,
            from: {
                position: {
                    my: "top",
                    at: "bottom"
                }
            },
            to: {
                position: {
                    my: "center",
                    at: "center"
                }
            }
        },
        hide: {
            type: "slide",
            duration: 400,
            from: {
                opacity: 1,
                position: {
                    my: "center",
                    at: "center"
                }
            },
            to: {
                opacity: 1,
                position: {
                    my: "top",
                    at: "bottom"
                }
            }
        }
    },
    _androidAnimation: function() {
        var fullScreenConfig = {
            show: {
                type: "slide",
                duration: 300,
                from: {
                    top: "30%",
                    opacity: 0
                },
                to: {
                    top: 0,
                    opacity: 1
                }
            },
            hide: {
                type: "slide",
                duration: 300,
                from: {
                    top: 0,
                    opacity: 1
                },
                to: {
                    top: "30%",
                    opacity: 0
                }
            }
        };
        var defaultConfig = {
            show: {
                type: "fade",
                duration: 400,
                from: 0,
                to: 1
            },
            hide: {
                type: "fade",
                duration: 400,
                from: 1,
                to: 0
            }
        };
        return this.option("fullScreen") ? fullScreenConfig : defaultConfig;
    },
    _init: function() {
        this.callBase();
        this.$element().addClass($685b737554cd2492$var$POPUP_CLASS);
        this._wrapper().addClass($685b737554cd2492$var$POPUP_WRAPPER_CLASS);
        this._$popupContent = this._$content.wrapInner((0, $685b737554cd2492$var$_renderer2.default)("<div>").addClass($685b737554cd2492$var$POPUP_CONTENT_CLASS)).children().eq(0);
    },
    _render: function() {
        var isFullscreen = this.option("fullScreen");
        this._toggleFullScreenClass(isFullscreen);
        this.callBase();
    },
    _toggleFullScreenClass: function(value) {
        this._$content.toggleClass($685b737554cd2492$var$POPUP_FULL_SCREEN_CLASS, value).toggleClass($685b737554cd2492$var$POPUP_NORMAL_CLASS, !value);
    },
    _initTemplates: function() {
        this.callBase();
        this._defaultTemplates.title = new $e5a0x.EmptyTemplate;
        this._defaultTemplates.bottom = new $e5a0x.EmptyTemplate;
    },
    _renderContentImpl: function() {
        this._renderTitle();
        this.callBase();
        this._renderBottom();
    },
    _renderTitle: function() {
        var items = this._getToolbarItems("top");
        var titleText = this.option("title");
        var showTitle = this.option("showTitle");
        if (showTitle && !!titleText) items.unshift({
            location: $685b737554cd2492$var$_devices2.default.current().ios ? "center" : "before",
            text: titleText
        });
        if (showTitle || items.length > 0) {
            this._$title && this._$title.remove();
            var $title = (0, $685b737554cd2492$var$_renderer2.default)("<div>").addClass($685b737554cd2492$var$POPUP_TITLE_CLASS).insertBefore(this.$content());
            this._$title = this._renderTemplateByType("titleTemplate", items, $title).addClass($685b737554cd2492$var$POPUP_TITLE_CLASS);
            this._renderDrag();
            this._executeTitleRenderAction(this._$title);
        } else if (this._$title) this._$title.detach();
    },
    _renderTemplateByType: function(optionName, data, $container, additionalToolbarOptions) {
        var template = this._getTemplateByOption(optionName);
        var toolbarTemplate = template instanceof $e5a0x.EmptyTemplate;
        if (toolbarTemplate) {
            var integrationOptions = (0, $7I8Uw.extend)({}, this.option("integrationOptions"), {
                skipTemplates: [
                    "content",
                    "title"
                ]
            });
            var toolbarOptions = (0, $7I8Uw.extend)(additionalToolbarOptions, {
                items: data,
                rtlEnabled: this.option("rtlEnabled"),
                useDefaultButtons: this.option("useDefaultToolbarButtons"),
                useFlatButtons: this.option("useFlatToolbarButtons"),
                integrationOptions: integrationOptions
            });
            this._getTemplate("dx-polymorph-widget").render({
                container: $container,
                model: {
                    widget: "dxToolbarBase",
                    options: toolbarOptions
                }
            });
            var $toolbar = $container.children("div");
            $container.replaceWith($toolbar);
            return $toolbar;
        } else {
            var $result = (0, $685b737554cd2492$var$_renderer2.default)(template.render({
                container: (0, $5OzEX.getPublicElement)($container)
            }));
            if ($result.hasClass($685b737554cd2492$var$TEMPLATE_WRAPPER_CLASS)) {
                $container.replaceWith($result);
                $container = $result;
            }
            return $container;
        }
    },
    _executeTitleRenderAction: function($titleElement) {
        this._getTitleRenderAction()({
            titleElement: (0, $5OzEX.getPublicElement)($titleElement)
        });
    },
    _getTitleRenderAction: function() {
        return this._titleRenderAction || this._createTitleRenderAction();
    },
    _createTitleRenderAction: function() {
        return this._titleRenderAction = this._createActionByOption("onTitleRendered", {
            element: this.element(),
            excludeValidators: [
                "disabled",
                "readOnly"
            ]
        });
    },
    _getCloseButton: function() {
        return {
            toolbar: "top",
            location: "after",
            template: this._getCloseButtonRenderer()
        };
    },
    _getCloseButtonRenderer: function() {
        return (function(_, __, container) {
            var $button = (0, $685b737554cd2492$var$_renderer2.default)("<div>").addClass($685b737554cd2492$var$POPUP_TITLE_CLOSEBUTTON_CLASS);
            this._createComponent($button, $685b737554cd2492$var$_button2.default, {
                icon: "close",
                onClick: this._createToolbarItemAction(void 0),
                integrationOptions: {}
            });
            (0, $685b737554cd2492$var$_renderer2.default)(container).append($button);
        }).bind(this);
    },
    _getToolbarItems: function(toolbar) {
        var toolbarItems = this.option("toolbarItems");
        var toolbarsItems = [];
        this._toolbarItemClasses = [];
        var currentPlatform = $685b737554cd2492$var$_devices2.default.current().platform;
        var index = 0;
        (0, $4Pwuy.each)(toolbarItems, (function(_, data) {
            var isShortcut = (0, $kDRxH.isDefined)(data.shortcut);
            var item = isShortcut ? $685b737554cd2492$var$getButtonPlace(data.shortcut) : data;
            if (isShortcut && "ios" === currentPlatform && index < 2) {
                item.toolbar = "top";
                index++;
            }
            item.toolbar = data.toolbar || item.toolbar || "top";
            if (item && item.toolbar === toolbar) {
                if (isShortcut) (0, $7I8Uw.extend)(item, {
                    location: data.location
                }, this._getToolbarItemByAlias(data));
                var isLTROrder = "generic" === currentPlatform;
                if ("done" === data.shortcut && isLTROrder || "cancel" === data.shortcut && !isLTROrder) toolbarsItems.unshift(item);
                else toolbarsItems.push(item);
            }
        }).bind(this));
        if ("top" === toolbar && this.option("showCloseButton") && this.option("showTitle")) toolbarsItems.push(this._getCloseButton());
        return toolbarsItems;
    },
    _getLocalizationKey: function(itemType) {
        return "done" === itemType.toLowerCase() ? "OK" : (0, $ih7fv.camelize)(itemType, true);
    },
    _getToolbarItemByAlias: function(data) {
        var that = this;
        var itemType = data.shortcut;
        if ((0, $aLQK5.inArray)(itemType, $685b737554cd2492$var$ALLOWED_TOOLBAR_ITEM_ALIASES) < 0) return false;
        var itemConfig = (0, $7I8Uw.extend)({
            text: $685b737554cd2492$var$_message2.default.format(this._getLocalizationKey(itemType)),
            onClick: this._createToolbarItemAction(data.onClick),
            integrationOptions: {},
            type: that.option("useDefaultToolbarButtons") ? $685b737554cd2492$var$BUTTON_DEFAULT_TYPE : $685b737554cd2492$var$BUTTON_NORMAL_TYPE,
            stylingMode: that.option("useFlatToolbarButtons") ? $685b737554cd2492$var$BUTTON_TEXT_MODE : $685b737554cd2492$var$BUTTON_CONTAINED_MODE
        }, data.options || {});
        var itemClass = $685b737554cd2492$var$POPUP_CLASS + "-" + itemType;
        this._toolbarItemClasses.push(itemClass);
        return {
            template: function(_, __, container) {
                var $toolbarItem = (0, $685b737554cd2492$var$_renderer2.default)("<div>").addClass(itemClass).appendTo(container);
                that._createComponent($toolbarItem, $685b737554cd2492$var$_button2.default, itemConfig);
            }
        };
    },
    _createToolbarItemAction: function(clickAction) {
        return this._createAction(clickAction, {
            afterExecute: function(e) {
                e.component.hide();
            }
        });
    },
    _renderBottom: function() {
        var items = this._getToolbarItems("bottom");
        if (items.length) {
            this._$bottom && this._$bottom.remove();
            var $bottom = (0, $685b737554cd2492$var$_renderer2.default)("<div>").addClass($685b737554cd2492$var$POPUP_BOTTOM_CLASS).insertAfter(this.$content());
            this._$bottom = this._renderTemplateByType("bottomTemplate", items, $bottom, {
                compactMode: true
            }).addClass($685b737554cd2492$var$POPUP_BOTTOM_CLASS);
            this._toggleClasses();
        } else this._$bottom && this._$bottom.detach();
    },
    _toggleClasses: function() {
        var aliases = $685b737554cd2492$var$ALLOWED_TOOLBAR_ITEM_ALIASES;
        (0, $4Pwuy.each)(aliases, (function(_, alias) {
            var className = $685b737554cd2492$var$POPUP_CLASS + "-" + alias;
            if ((0, $aLQK5.inArray)(className, this._toolbarItemClasses) >= 0) {
                this._wrapper().addClass(className + "-visible");
                this._$bottom.addClass(className);
            } else {
                this._wrapper().removeClass(className + "-visible");
                this._$bottom.removeClass(className);
            }
        }).bind(this));
    },
    _getContainer: function() {
        if (this.option("fullScreen")) return (0, $685b737554cd2492$var$_renderer2.default)($685b737554cd2492$var$window);
        return this.callBase();
    },
    _getDragTarget: function() {
        return this.topToolbar();
    },
    _renderGeometryImpl: function(isDimensionChanged) {
        if (!isDimensionChanged) this._resetContentHeight();
        this.callBase.apply(this, arguments);
        this._setContentHeight();
    },
    _resetContentHeight: function() {
        this._$popupContent.css({
            height: "auto",
            maxHeight: "none"
        });
    },
    _renderDrag: function() {
        this.callBase();
        this._$content.toggleClass($685b737554cd2492$var$POPUP_DRAGGABLE_CLASS, this.option("dragEnabled"));
    },
    _renderResize: function() {
        this.callBase();
        this._resizable.option("onResize", (function() {
            this._setContentHeight();
            this._actions.onResize(arguments);
        }).bind(this));
    },
    _setContentHeight: function() {
        (this.option("forceApplyBindings") || $2Mto0.noop)();
        var overlayContent = this.overlayContent().get(0);
        var currentHeightStrategyClass = this._chooseHeightStrategy(overlayContent);
        this.$content().css(this._getHeightCssStyles(currentHeightStrategyClass, overlayContent));
        this._setHeightClasses(this.overlayContent(), currentHeightStrategyClass);
    },
    _heightStrategyChangeOffset: function(currentHeightStrategyClass, popupVerticalPaddings) {
        return currentHeightStrategyClass === $685b737554cd2492$var$HEIGHT_STRATEGIES.flex ? -popupVerticalPaddings : 0;
    },
    _chooseHeightStrategy: function(overlayContent) {
        var isAutoWidth = "auto" === overlayContent.style.width || "" === overlayContent.style.width;
        var currentHeightStrategyClass = $685b737554cd2492$var$HEIGHT_STRATEGIES.static;
        if (this._isAutoHeight() && this.option("autoResizeEnabled")) {
            if (isAutoWidth || $685b737554cd2492$var$IS_OLD_SAFARI) {
                if (!$685b737554cd2492$var$IS_IE11) currentHeightStrategyClass = $685b737554cd2492$var$HEIGHT_STRATEGIES.inherit;
            } else currentHeightStrategyClass = $685b737554cd2492$var$HEIGHT_STRATEGIES.flex;
        }
        return currentHeightStrategyClass;
    },
    _getHeightCssStyles: function(currentHeightStrategyClass, overlayContent) {
        var cssStyles = {};
        var contentMaxHeight = this._getOptionValue("maxHeight", overlayContent);
        var contentMinHeight = this._getOptionValue("minHeight", overlayContent);
        var popupHeightParts = this._splitPopupHeight();
        var toolbarsAndVerticalOffsetsHeight = popupHeightParts.header + popupHeightParts.footer + popupHeightParts.contentVerticalOffsets + popupHeightParts.popupVerticalOffsets + this._heightStrategyChangeOffset(currentHeightStrategyClass, popupHeightParts.popupVerticalPaddings);
        if (currentHeightStrategyClass === $685b737554cd2492$var$HEIGHT_STRATEGIES.static) {
            if (!this._isAutoHeight() || contentMaxHeight || contentMinHeight) {
                var overlayHeight = this.option("fullScreen") ? Math.min((0, $1TtsA.getBoundingRect)(overlayContent).height, $685b737554cd2492$var$_window2.default.getWindow().innerHeight) : (0, $1TtsA.getBoundingRect)(overlayContent).height;
                var contentHeight = overlayHeight - toolbarsAndVerticalOffsetsHeight;
                cssStyles = {
                    height: Math.max(0, contentHeight),
                    minHeight: "auto",
                    maxHeight: "auto"
                };
            }
        } else {
            var container = (0, $685b737554cd2492$var$_renderer2.default)(this._getContainer()).get(0);
            var maxHeightValue = $685b737554cd2492$var$_size2.default.addOffsetToMaxHeight(contentMaxHeight, -toolbarsAndVerticalOffsetsHeight, container);
            var minHeightValue = $685b737554cd2492$var$_size2.default.addOffsetToMinHeight(contentMinHeight, -toolbarsAndVerticalOffsetsHeight, container);
            cssStyles = {
                height: "auto",
                minHeight: minHeightValue,
                maxHeight: maxHeightValue
            };
        }
        return cssStyles;
    },
    _setHeightClasses: function($container, currentClass) {
        var excessClasses = "";
        for(var name in $685b737554cd2492$var$HEIGHT_STRATEGIES)if ($685b737554cd2492$var$HEIGHT_STRATEGIES[name] !== currentClass) excessClasses += " " + $685b737554cd2492$var$HEIGHT_STRATEGIES[name];
        $container.removeClass(excessClasses).addClass(currentClass);
    },
    _isAutoHeight: function() {
        return "auto" === this.overlayContent().get(0).style.height;
    },
    _splitPopupHeight: function() {
        var topToolbar = this.topToolbar();
        var bottomToolbar = this.bottomToolbar();
        return {
            header: $685b737554cd2492$var$_size2.default.getVisibleHeight(topToolbar && topToolbar.get(0)),
            footer: $685b737554cd2492$var$_size2.default.getVisibleHeight(bottomToolbar && bottomToolbar.get(0)),
            contentVerticalOffsets: $685b737554cd2492$var$_size2.default.getVerticalOffsets(this.overlayContent().get(0), true),
            popupVerticalOffsets: $685b737554cd2492$var$_size2.default.getVerticalOffsets(this.$content().get(0), true),
            popupVerticalPaddings: $685b737554cd2492$var$_size2.default.getVerticalOffsets(this.$content().get(0), false)
        };
    },
    _useFixedPosition: function() {
        return this.callBase() || this.option("fullScreen");
    },
    _toggleSafariFullScreen: function(value) {
        var toggleFullScreenBeforeShown = this._useFixedPosition() && value && !this._isShown;
        if (toggleFullScreenBeforeShown) this._bodyScrollTop = value ? $685b737554cd2492$var$window.pageYOffset : void 0;
        else this._toggleSafariScrolling(!value);
    },
    _renderDimensions: function() {
        if (this.option("fullScreen")) this._$content.css({
            width: "100%",
            height: "100%"
        });
        else this.callBase.apply(this, arguments);
        if ($685b737554cd2492$var$_window2.default.hasWindow()) this._renderFullscreenWidthClass();
    },
    _renderFullscreenWidthClass: function() {
        this.overlayContent().toggleClass($685b737554cd2492$var$POPUP_FULL_SCREEN_WIDTH_CLASS, this.overlayContent().outerWidth() === (0, $685b737554cd2492$var$_renderer2.default)($685b737554cd2492$var$window).width());
    },
    refreshPosition: function() {
        this._renderPosition();
    },
    _renderPosition: function() {
        if (this.option("fullScreen")) $685b737554cd2492$var$_translator2.default.move(this._$content, {
            top: 0,
            left: 0
        });
        else {
            (this.option("forceApplyBindings") || $2Mto0.noop)();
            return this.callBase.apply(this, arguments);
        }
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "showTitle":
            case "title":
            case "titleTemplate":
                this._renderTitle();
                this._renderGeometry();
                break;
            case "bottomTemplate":
                this._renderBottom();
                this._renderGeometry();
                break;
            case "onTitleRendered":
                this._createTitleRenderAction(args.value);
                break;
            case "toolbarItems":
            case "useDefaultToolbarButtons":
            case "useFlatToolbarButtons":
                var shouldRenderGeometry = !args.fullName.match(/^toolbarItems((\[\d+\])(\.(options|visible).*)?)?$/);
                this._renderTitle();
                this._renderBottom();
                if (shouldRenderGeometry) this._renderGeometry();
                break;
            case "dragEnabled":
                this._renderDrag();
                break;
            case "autoResizeEnabled":
                this._renderGeometry();
                $685b737554cd2492$var$_dom2.default.triggerResizeEvent(this._$content);
                break;
            case "fullScreen":
                this._toggleFullScreenClass(args.value);
                this._toggleSafariFullScreen(args.value);
                this._renderGeometry();
                $685b737554cd2492$var$_dom2.default.triggerResizeEvent(this._$content);
                break;
            case "showCloseButton":
                this._renderTitle();
                break;
            default:
                this.callBase(args);
        }
    },
    bottomToolbar: function() {
        return this._$bottom;
    },
    topToolbar: function() {
        return this._$title;
    },
    $content: function() {
        return this._$popupContent;
    },
    content: function() {
        return (0, $5OzEX.getPublicElement)(this._$popupContent);
    },
    overlayContent: function() {
        return this._$content;
    }
});
(0, $685b737554cd2492$var$_component_registrator2.default)("dxPopup", $685b737554cd2492$var$Popup);
$685b737554cd2492$exports = $685b737554cd2492$var$Popup;
$685b737554cd2492$exports.default = $685b737554cd2492$exports;


var $6135956410ac0e32$exports = {};
/**
 * DevExtreme (ui/popover.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
function $6135956410ac0e32$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if ("function" === typeof Symbol && "symbol" === typeof Symbol.iterator) $6135956410ac0e32$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $6135956410ac0e32$var$_typeof = function(obj) {
        return obj && "function" === typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6135956410ac0e32$var$_typeof(obj);
}

var $jFnCG = parcelRequire("jFnCG");

var $irv64 = parcelRequire("irv64");
var $6135956410ac0e32$var$window = $irv64.getWindow();

var $5OzEX = parcelRequire("5OzEX");
var $6135956410ac0e32$require$getPublicElement = $5OzEX.getPublicElement;

var $445Bz = parcelRequire("445Bz");

var $e1LMc = parcelRequire("e1LMc");

var $4ZFRo = parcelRequire("4ZFRo");

var $2Mto0 = parcelRequire("2Mto0");

var $7I8Uw = parcelRequire("7I8Uw");
var $6135956410ac0e32$require$extend = $7I8Uw.extend;

var $bvcPv = parcelRequire("bvcPv");

var $6jr65 = parcelRequire("6jr65");

var $bgCx6 = parcelRequire("bgCx6");

var $kDRxH = parcelRequire("kDRxH");

var $efpkH = parcelRequire("efpkH");

var $bXb2w = parcelRequire("bXb2w");


var $1TtsA = parcelRequire("1TtsA");
var $6135956410ac0e32$require$getBoundingRect = $1TtsA.getBoundingRect;
var $6135956410ac0e32$var$POPOVER_CLASS = "dx-popover";
var $6135956410ac0e32$var$POPOVER_WRAPPER_CLASS = "dx-popover-wrapper";
var $6135956410ac0e32$var$POPOVER_ARROW_CLASS = "dx-popover-arrow";
var $6135956410ac0e32$var$POPOVER_WITHOUT_TITLE_CLASS = "dx-popover-without-title";
var $6135956410ac0e32$var$POSITION_FLIP_MAP = {
    left: "right",
    top: "bottom",
    right: "left",
    bottom: "top",
    center: "center"
};
var $6135956410ac0e32$var$WEIGHT_OF_SIDES = {
    left: -1,
    top: -1,
    center: 0,
    right: 1,
    bottom: 1
};
var $6135956410ac0e32$var$POSITION_ALIASES = {
    top: {
        my: "bottom center",
        at: "top center",
        collision: "fit flip"
    },
    bottom: {
        my: "top center",
        at: "bottom center",
        collision: "fit flip"
    },
    right: {
        my: "left center",
        at: "right center",
        collision: "flip fit"
    },
    left: {
        my: "right center",
        at: "left center",
        collision: "flip fit"
    }
};
var $6135956410ac0e32$var$SIDE_BORDER_WIDTH_STYLES = {
    left: "borderLeftWidth",
    top: "borderTopWidth",
    right: "borderRightWidth",
    bottom: "borderBottomWidth"
};
var $6135956410ac0e32$var$isFirefox = $bvcPv.mozilla;
var $6135956410ac0e32$var$getEventName = function(that, optionName) {
    var optionValue = that.option(optionName);
    return $6135956410ac0e32$var$getEventNameByOption(optionValue);
};
var $6135956410ac0e32$var$getEventNameByOption = function(optionValue) {
    return $kDRxH.isObject(optionValue) ? optionValue.name : optionValue;
};
var $6135956410ac0e32$var$getEventDelay = function(that, optionName) {
    var optionValue = that.option(optionName);
    return $kDRxH.isObject(optionValue) && optionValue.delay;
};
var $6135956410ac0e32$var$attachEvent = function(that, name) {
    var target = that.option("target");
    var isSelector = $kDRxH.isString(target);
    var event = $6135956410ac0e32$var$getEventName(that, name + "Event");
    if (!event || that.option("disabled")) return;
    var eventName = $bXb2w.addNamespace(event, that.NAME);
    var action = that._createAction((function() {
        var delay = $6135956410ac0e32$var$getEventDelay(that, name + "Event");
        this._clearEventsTimeouts();
        if (delay) this._timeouts[name] = setTimeout(function() {
            that[name]();
        }, delay);
        else that[name]();
    }).bind(that), {
        validatingTargetName: "target"
    });
    var handler = function(e) {
        action({
            event: e,
            target: $jFnCG(e.currentTarget)
        });
    };
    var EVENT_HANDLER_NAME = "_" + name + "EventHandler";
    if (isSelector) {
        that[EVENT_HANDLER_NAME] = handler;
        $e1LMc.on($445Bz.getDocument(), eventName, target, handler);
    } else {
        var targetElement = $6135956410ac0e32$require$getPublicElement($jFnCG(target));
        that[EVENT_HANDLER_NAME] = void 0;
        $e1LMc.on(targetElement, eventName, handler);
    }
};
var $6135956410ac0e32$var$detachEvent = function(that, target, name, event) {
    var eventName = event || $6135956410ac0e32$var$getEventName(that, name + "Event");
    if (!eventName) return;
    eventName = $bXb2w.addNamespace(eventName, that.NAME);
    var EVENT_HANDLER_NAME = "_" + name + "EventHandler";
    if (that[EVENT_HANDLER_NAME]) $e1LMc.off($445Bz.getDocument(), eventName, target, that[EVENT_HANDLER_NAME]);
    else $e1LMc.off($6135956410ac0e32$require$getPublicElement($jFnCG(target)), eventName);
};
var $6135956410ac0e32$var$Popover = $685b737554cd2492$exports.inherit({
    _getDefaultOptions: function() {
        return $6135956410ac0e32$require$extend(this.callBase(), {
            target: $6135956410ac0e32$var$window,
            shading: false,
            position: "bottom",
            closeOnOutsideClick: true,
            animation: {
                show: {
                    type: "fade",
                    from: 0,
                    to: 1
                },
                hide: {
                    type: "fade",
                    to: 0
                }
            },
            showTitle: false,
            width: "auto",
            height: "auto",
            dragEnabled: false,
            resizeEnabled: false,
            fullScreen: false,
            closeOnTargetScroll: true,
            arrowPosition: "",
            arrowOffset: 0,
            boundaryOffset: {
                h: 10,
                v: 10
            }
        });
    },
    _defaultOptionsRules: function() {
        return [
            {
                device: {
                    platform: "ios"
                },
                options: {
                    arrowPosition: {
                        boundaryOffset: {
                            h: 20,
                            v: -10
                        },
                        collision: "fit"
                    }
                }
            },
            {
                device: function() {
                    return !$irv64.hasWindow();
                },
                options: {
                    animation: null
                }
            }
        ];
    },
    _init: function() {
        this.callBase();
        this._renderArrow();
        this._timeouts = {};
        this.$element().addClass($6135956410ac0e32$var$POPOVER_CLASS);
        this._wrapper().addClass($6135956410ac0e32$var$POPOVER_WRAPPER_CLASS);
    },
    _render: function() {
        this.callBase.apply(this, arguments);
        this._detachEvents(this.option("target"));
        this._attachEvents();
    },
    _detachEvents: function(target) {
        $6135956410ac0e32$var$detachEvent(this, target, "show");
        $6135956410ac0e32$var$detachEvent(this, target, "hide");
    },
    _attachEvents: function() {
        $6135956410ac0e32$var$attachEvent(this, "show");
        $6135956410ac0e32$var$attachEvent(this, "hide");
    },
    _renderArrow: function() {
        this._$arrow = $jFnCG("<div>").addClass($6135956410ac0e32$var$POPOVER_ARROW_CLASS).prependTo(this.overlayContent());
    },
    _documentDownHandler: function(e) {
        if (this._isOutsideClick(e)) return this.callBase(e);
        return true;
    },
    _isOutsideClick: function(e) {
        return !$jFnCG(e.target).closest(this.option("target")).length;
    },
    _animate: function(animation) {
        if (animation && animation.to && "object" === $6135956410ac0e32$var$_typeof(animation.to)) $6135956410ac0e32$require$extend(animation.to, {
            position: this._getContainerPosition()
        });
        this.callBase.apply(this, arguments);
    },
    _stopAnimation: function() {
        this.callBase.apply(this, arguments);
    },
    _renderTitle: function() {
        this._wrapper().toggleClass($6135956410ac0e32$var$POPOVER_WITHOUT_TITLE_CLASS, !this.option("showTitle"));
        this.callBase();
    },
    _renderPosition: function() {
        this.callBase();
        this._renderOverlayPosition();
    },
    _renderOverlayBoundaryOffset: $2Mto0.noop,
    _renderOverlayPosition: function() {
        this._resetOverlayPosition();
        this._updateContentSize();
        var contentPosition = this._getContainerPosition();
        var resultLocation = $bgCx6.setup(this._$content, contentPosition);
        var positionSide = this._getSideByLocation(resultLocation);
        this._togglePositionClass("dx-position-" + positionSide);
        this._toggleFlippedClass(resultLocation.h.flip, resultLocation.v.flip);
        var isArrowVisible = this._isHorizontalSide() || this._isVerticalSide();
        if (isArrowVisible) this._renderArrowPosition(positionSide);
    },
    _resetOverlayPosition: function() {
        this._setContentHeight(true);
        this._togglePositionClass("dx-position-" + this._positionSide);
        $6jr65.move(this._$content, {
            left: 0,
            top: 0
        });
        this._$arrow.css({
            top: "auto",
            right: "auto",
            bottom: "auto",
            left: "auto"
        });
    },
    _updateContentSize: function() {
        if (!this._$popupContent) return;
        var containerLocation = $bgCx6.calculate(this._$content, this._getContainerPosition());
        if (containerLocation.h.oversize > 0 && this._isHorizontalSide() && !containerLocation.h.fit) {
            var newContainerWidth = this._$content.width() - containerLocation.h.oversize;
            this._$content.width(newContainerWidth);
        }
        if (containerLocation.v.oversize > 0 && this._isVerticalSide() && !containerLocation.v.fit) {
            var newOverlayContentHeight = this._$content.height() - containerLocation.v.oversize;
            var newPopupContentHeight = this._$popupContent.height() - containerLocation.v.oversize;
            this._$content.height(newOverlayContentHeight);
            this._$popupContent.height(newPopupContentHeight);
        }
    },
    _getContainerPosition: function() {
        var offset = $2Mto0.pairToObject(this._position.offset || "");
        var hOffset = offset.h;
        var vOffset = offset.v;
        var isVerticalSide = this._isVerticalSide();
        var isHorizontalSide = this._isHorizontalSide();
        if (isVerticalSide || isHorizontalSide) {
            var isPopoverInside = this._isPopoverInside();
            var sign = (isPopoverInside ? -1 : 1) * $6135956410ac0e32$var$WEIGHT_OF_SIDES[this._positionSide];
            var arrowSize = isVerticalSide ? this._$arrow.height() : this._$arrow.width();
            var arrowSizeCorrection = this._getContentBorderWidth(this._positionSide);
            var arrowOffset = sign * (arrowSize - arrowSizeCorrection);
            isVerticalSide ? vOffset += arrowOffset : hOffset += arrowOffset;
        }
        return $6135956410ac0e32$require$extend({}, this._position, {
            offset: hOffset + " " + vOffset
        });
    },
    _getContentBorderWidth: function(side) {
        var borderWidth = this._$content.css($6135956410ac0e32$var$SIDE_BORDER_WIDTH_STYLES[side]);
        return parseInt(borderWidth) || 0;
    },
    _getSideByLocation: function(location) {
        var isFlippedByVertical = location.v.flip;
        var isFlippedByHorizontal = location.h.flip;
        return this._isVerticalSide() && isFlippedByVertical || this._isHorizontalSide() && isFlippedByHorizontal || this._isPopoverInside() ? $6135956410ac0e32$var$POSITION_FLIP_MAP[this._positionSide] : this._positionSide;
    },
    _togglePositionClass: function(positionClass) {
        this._$wrapper.removeClass("dx-position-left dx-position-right dx-position-top dx-position-bottom").addClass(positionClass);
    },
    _toggleFlippedClass: function(isFlippedHorizontal, isFlippedVertical) {
        this._$wrapper.toggleClass("dx-popover-flipped-horizontal", isFlippedHorizontal).toggleClass("dx-popover-flipped-vertical", isFlippedVertical);
    },
    _renderArrowPosition: function(side) {
        var arrowRect = $6135956410ac0e32$require$getBoundingRect(this._$arrow.get(0));
        var arrowFlip = -(this._isVerticalSide(side) ? arrowRect.height : arrowRect.width);
        this._$arrow.css($6135956410ac0e32$var$POSITION_FLIP_MAP[side], arrowFlip);
        var axis = this._isVerticalSide(side) ? "left" : "top";
        var sizeProperty = this._isVerticalSide(side) ? "width" : "height";
        var $target = $jFnCG(this._position.of);
        var targetOffset = $bgCx6.offset($target) || {
            top: 0,
            left: 0
        };
        var contentOffset = $bgCx6.offset(this._$content);
        var arrowSize = arrowRect[sizeProperty];
        var contentLocation = contentOffset[axis];
        var contentSize = $6135956410ac0e32$require$getBoundingRect(this._$content.get(0))[sizeProperty];
        var targetLocation = targetOffset[axis];
        var targetSize = $target.get(0).preventDefault ? 0 : $6135956410ac0e32$require$getBoundingRect($target.get(0))[sizeProperty];
        var min = Math.max(contentLocation, targetLocation);
        var max = Math.min(contentLocation + contentSize, targetLocation + targetSize);
        var arrowLocation;
        if ("start" === this.option("arrowPosition")) arrowLocation = min - contentLocation;
        else if ("end" === this.option("arrowPosition")) arrowLocation = max - contentLocation - arrowSize;
        else arrowLocation = (min + max) / 2 - contentLocation - arrowSize / 2;
        var borderWidth = this._getContentBorderWidth(side);
        var finalArrowLocation = $efpkH.fitIntoRange(arrowLocation - borderWidth + this.option("arrowOffset"), borderWidth, contentSize - arrowSize - 2 * borderWidth);
        this._$arrow.css(axis, finalArrowLocation);
    },
    _isPopoverInside: function() {
        var position = this._transformStringPosition(this.option("position"), $6135956410ac0e32$var$POSITION_ALIASES);
        var my = $bgCx6.setup.normalizeAlign(position.my);
        var at = $bgCx6.setup.normalizeAlign(position.at);
        return my.h === at.h && my.v === at.v;
    },
    _setContentHeight: function(fullUpdate) {
        if (fullUpdate) this.callBase();
    },
    _renderWrapperPosition: function() {
        if (this.option("shading")) this._$wrapper.css({
            top: 0,
            left: 0
        });
    },
    _renderWrapperDimensions: function() {
        if (this.option("shading")) this._$wrapper.css({
            width: "100%",
            height: "100%"
        });
    },
    _normalizePosition: function() {
        var position = $6135956410ac0e32$require$extend({}, this._transformStringPosition(this.option("position"), $6135956410ac0e32$var$POSITION_ALIASES));
        if (!position.of) position.of = this.option("target");
        if (!position.collision) position.collision = "flip";
        if (!position.boundaryOffset) position.boundaryOffset = this.option("boundaryOffset");
        this._positionSide = this._getDisplaySide(position);
        this._position = position;
    },
    _getDisplaySide: function(position) {
        var my = $bgCx6.setup.normalizeAlign(position.my);
        var at = $bgCx6.setup.normalizeAlign(position.at);
        var weightSign = $6135956410ac0e32$var$WEIGHT_OF_SIDES[my.h] === $6135956410ac0e32$var$WEIGHT_OF_SIDES[at.h] && $6135956410ac0e32$var$WEIGHT_OF_SIDES[my.v] === $6135956410ac0e32$var$WEIGHT_OF_SIDES[at.v] ? -1 : 1;
        var horizontalWeight = Math.abs($6135956410ac0e32$var$WEIGHT_OF_SIDES[my.h] - weightSign * $6135956410ac0e32$var$WEIGHT_OF_SIDES[at.h]);
        var verticalWeight = Math.abs($6135956410ac0e32$var$WEIGHT_OF_SIDES[my.v] - weightSign * $6135956410ac0e32$var$WEIGHT_OF_SIDES[at.v]);
        return horizontalWeight > verticalWeight ? at.h : at.v;
    },
    _resetContentHeight: function() {
        this.callBase();
        if ($6135956410ac0e32$var$isFirefox) {
            var originalOverflow = this._$popupContent.css("overflow");
            this._$popupContent.css("overflow", "visible");
            this._$popupContent.css("overflow", originalOverflow);
        }
    },
    _isVerticalSide: function(side) {
        side = side || this._positionSide;
        return "top" === side || "bottom" === side;
    },
    _isHorizontalSide: function(side) {
        side = side || this._positionSide;
        return "left" === side || "right" === side;
    },
    _clearEventTimeout: function(name) {
        clearTimeout(this._timeouts[name]);
    },
    _clearEventsTimeouts: function() {
        this._clearEventTimeout("show");
        this._clearEventTimeout("hide");
    },
    _clean: function() {
        this._detachEvents(this.option("target"));
        this.callBase.apply(this, arguments);
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "boundaryOffset":
            case "arrowPosition":
            case "arrowOffset":
                this._renderGeometry();
                break;
            case "fullScreen":
                if (args.value) this.option("fullScreen", false);
                break;
            case "target":
                args.previousValue && this._detachEvents(args.previousValue);
                this.callBase(args);
                break;
            case "showEvent":
            case "hideEvent":
                var name = args.name.substring(0, 4);
                var event = $6135956410ac0e32$var$getEventNameByOption(args.previousValue);
                this.hide();
                $6135956410ac0e32$var$detachEvent(this, this.option("target"), name, event);
                $6135956410ac0e32$var$attachEvent(this, name);
                break;
            case "visible":
                this._clearEventTimeout(args.value ? "show" : "hide");
                this.callBase(args);
                break;
            default:
                this.callBase(args);
        }
    },
    show: function(target) {
        if (target) this.option("target", target);
        return this.callBase();
    }
});
$4ZFRo("dxPopover", $6135956410ac0e32$var$Popover);
$6135956410ac0e32$exports = $6135956410ac0e32$var$Popover;
$6135956410ac0e32$exports.default = $6135956410ac0e32$exports;



var $74fa45cb65203b59$require$BindableTemplate = $46d7ae10a89c38af$exports.BindableTemplate;

var $2F60d = parcelRequire("2F60d");
var $74fa45cb65203b59$require$Deferred = $2F60d.Deferred;
var $74fa45cb65203b59$var$ACTION_SHEET_CLASS = "dx-actionsheet";
var $74fa45cb65203b59$var$ACTION_SHEET_CONTAINER_CLASS = "dx-actionsheet-container";
var $74fa45cb65203b59$var$ACTION_SHEET_POPUP_WRAPPER_CLASS = "dx-actionsheet-popup-wrapper";
var $74fa45cb65203b59$var$ACTION_SHEET_POPOVER_WRAPPER_CLASS = "dx-actionsheet-popover-wrapper";
var $74fa45cb65203b59$var$ACTION_SHEET_CANCEL_BUTTON_CLASS = "dx-actionsheet-cancel";
var $74fa45cb65203b59$var$ACTION_SHEET_ITEM_CLASS = "dx-actionsheet-item";
var $74fa45cb65203b59$var$ACTION_SHEET_ITEM_DATA_KEY = "dxActionSheetItemData";
var $74fa45cb65203b59$var$ACTION_SHEET_WITHOUT_TITLE_CLASS = "dx-actionsheet-without-title";
var $74fa45cb65203b59$var$ActionSheet = $f4d41dfe58d276dc$exports.inherit({
    _getDefaultOptions: function() {
        return $74fa45cb65203b59$require$extend(this.callBase(), {
            usePopover: false,
            target: null,
            title: "",
            showTitle: true,
            showCancelButton: true,
            cancelText: $cnVbh.format("Cancel"),
            onCancelClick: null,
            visible: false,
            noDataText: "",
            focusStateEnabled: false,
            selectionByClick: false
        });
    },
    _defaultOptionsRules: function() {
        return this.callBase().concat([
            {
                device: {
                    platform: "ios",
                    tablet: true
                },
                options: {
                    usePopover: true
                }
            }
        ]);
    },
    _initTemplates: function() {
        this.callBase();
        this._defaultTemplates.item = new $74fa45cb65203b59$require$BindableTemplate(function($container, data) {
            var button = new $7KuSv($jFnCG("<div>"), $74fa45cb65203b59$require$extend({
                onClick: data && data.click
            }, data));
            $container.append(button.$element());
        }, [
            "disabled",
            "icon",
            "text",
            "type",
            "onClick",
            "click"
        ], this.option("integrationOptions.watchMethod"));
    },
    _itemContainer: function() {
        return this._$itemContainer;
    },
    _itemClass: function() {
        return $74fa45cb65203b59$var$ACTION_SHEET_ITEM_CLASS;
    },
    _itemDataKey: function() {
        return $74fa45cb65203b59$var$ACTION_SHEET_ITEM_DATA_KEY;
    },
    _toggleVisibility: $74fa45cb65203b59$require$noop,
    _renderDimensions: $74fa45cb65203b59$require$noop,
    _initMarkup: function() {
        this.callBase();
        this.$element().addClass($74fa45cb65203b59$var$ACTION_SHEET_CLASS);
        this._createItemContainer();
    },
    _render: function() {
        this._renderPopup();
    },
    _createItemContainer: function() {
        this._$itemContainer = $jFnCG("<div>").addClass($74fa45cb65203b59$var$ACTION_SHEET_CONTAINER_CLASS);
        this._renderDisabled();
    },
    _renderDisabled: function() {
        this._$itemContainer.toggleClass("dx-state-disabled", this.option("disabled"));
    },
    _renderPopup: function() {
        this._$popup = $jFnCG("<div>").appendTo(this.$element());
        this._isPopoverMode() ? this._createPopover() : this._createPopup();
        this._renderPopupTitle();
        this._mapPopupOption("visible");
    },
    _mapPopupOption: function(optionName) {
        this._popup && this._popup.option(optionName, this.option(optionName));
    },
    _isPopoverMode: function() {
        return this.option("usePopover") && this.option("target");
    },
    _renderPopupTitle: function() {
        this._mapPopupOption("showTitle");
        this._popup && this._popup._wrapper().toggleClass($74fa45cb65203b59$var$ACTION_SHEET_WITHOUT_TITLE_CLASS, !this.option("showTitle"));
    },
    _clean: function() {
        if (this._$popup) this._$popup.remove();
        this.callBase();
    },
    _overlayConfig: function() {
        return {
            onInitialized: (function(args) {
                this._popup = args.component;
            }).bind(this),
            disabled: false,
            showTitle: true,
            title: this.option("title"),
            deferRendering: !$74fa45cb65203b59$var$window.angular,
            onContentReady: this._popupContentReadyAction.bind(this),
            onHidden: this.hide.bind(this)
        };
    },
    _createPopover: function() {
        this._createComponent(this._$popup, $6135956410ac0e32$exports, $74fa45cb65203b59$require$extend(this._overlayConfig(), {
            width: this.option("width") || 200,
            height: this.option("height") || "auto",
            target: this.option("target")
        }));
        this._popup._wrapper().addClass($74fa45cb65203b59$var$ACTION_SHEET_POPOVER_WRAPPER_CLASS);
    },
    _createPopup: function() {
        this._createComponent(this._$popup, $685b737554cd2492$exports, $74fa45cb65203b59$require$extend(this._overlayConfig(), {
            dragEnabled: false,
            width: this.option("width") || "100%",
            height: this.option("height") || "auto",
            showCloseButton: false,
            position: {
                my: "bottom",
                at: "bottom",
                of: $74fa45cb65203b59$var$window
            },
            animation: {
                show: {
                    type: "slide",
                    duration: 400,
                    from: {
                        position: {
                            my: "top",
                            at: "bottom",
                            of: $74fa45cb65203b59$var$window
                        }
                    },
                    to: {
                        position: {
                            my: "bottom",
                            at: "bottom",
                            of: $74fa45cb65203b59$var$window
                        }
                    }
                },
                hide: {
                    type: "slide",
                    duration: 400,
                    from: {
                        position: {
                            my: "bottom",
                            at: "bottom",
                            of: $74fa45cb65203b59$var$window
                        }
                    },
                    to: {
                        position: {
                            my: "top",
                            at: "bottom",
                            of: $74fa45cb65203b59$var$window
                        }
                    }
                }
            }
        }));
        this._popup._wrapper().addClass($74fa45cb65203b59$var$ACTION_SHEET_POPUP_WRAPPER_CLASS);
    },
    _popupContentReadyAction: function() {
        this._popup.$content().append(this._$itemContainer);
        this._attachClickEvent();
        this._attachHoldEvent();
        this._prepareContent();
        this._renderContent();
        this._renderCancelButton();
    },
    _renderCancelButton: function() {
        if (this._isPopoverMode()) return;
        if (this._$cancelButton) this._$cancelButton.remove();
        if (this.option("showCancelButton")) {
            var cancelClickAction = this._createActionByOption("onCancelClick") || $74fa45cb65203b59$require$noop;
            var that = this;
            this._$cancelButton = $jFnCG("<div>").addClass($74fa45cb65203b59$var$ACTION_SHEET_CANCEL_BUTTON_CLASS).appendTo(this._popup && this._popup.$content());
            this._createComponent(this._$cancelButton, $7KuSv, {
                disabled: false,
                text: this.option("cancelText"),
                onClick: function(e) {
                    var hidingArgs = {
                        event: e,
                        cancel: false
                    };
                    cancelClickAction(hidingArgs);
                    if (!hidingArgs.cancel) that.hide();
                },
                integrationOptions: {}
            });
        }
    },
    _attachItemClickEvent: $74fa45cb65203b59$require$noop,
    _itemClickHandler: function(e) {
        this.callBase(e);
        if (!$jFnCG(e.target).is(".dx-state-disabled, .dx-state-disabled *")) this.hide();
    },
    _itemHoldHandler: function(e) {
        this.callBase(e);
        if (!$jFnCG(e.target).is(".dx-state-disabled, .dx-state-disabled *")) this.hide();
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "width":
            case "height":
            case "visible":
            case "title":
                this._mapPopupOption(args.name);
                break;
            case "disabled":
                this._renderDisabled();
                break;
            case "showTitle":
                this._renderPopupTitle();
                break;
            case "showCancelButton":
            case "onCancelClick":
            case "cancelText":
                this._renderCancelButton();
                break;
            case "target":
            case "usePopover":
            case "items":
                this._invalidate();
                break;
            default:
                this.callBase(args);
        }
    },
    toggle: function(showing) {
        var that = this;
        var d = new $74fa45cb65203b59$require$Deferred;
        that._popup.toggle(showing).done(function() {
            that.option("visible", showing);
            d.resolveWith(that);
        });
        return d.promise();
    },
    show: function() {
        return this.toggle(true);
    },
    hide: function() {
        return this.toggle(false);
    }
});
$4ZFRo("dxActionSheet", $74fa45cb65203b59$var$ActionSheet);
$74fa45cb65203b59$exports = $74fa45cb65203b59$var$ActionSheet;
$74fa45cb65203b59$exports.default = $74fa45cb65203b59$exports;


var $82371d383bcfde9d$var$ActionSheetStrategy = $c5879277017430c5$exports.inherit({
    NAME: "actionSheet",
    _getMenuItemTemplate: function() {
        return this._toolbar._getTemplate("actionSheetItem");
    },
    render: function() {
        if (!this._hasVisibleMenuItems()) return;
        this.callBase();
    },
    _menuWidgetClass: function() {
        return $74fa45cb65203b59$exports;
    },
    _menuContainer: function() {
        return this._toolbar.$element();
    },
    _widgetOptions: function() {
        return $82371d383bcfde9d$require$extend({}, this.callBase(), {
            target: this._$button,
            showTitle: false
        });
    },
    _menuButtonOptions: function() {
        return $82371d383bcfde9d$require$extend({}, this.callBase(), {
            icon: "overflow"
        });
    },
    _toggleMenu: function() {
        this.callBase.apply(this, arguments);
        this._menu.toggle(this._menuShown);
        this._menuShown = false;
    }
});
$82371d383bcfde9d$exports = $82371d383bcfde9d$var$ActionSheetStrategy;


var $1c014afc280854ff$exports = {};
/**
 * DevExtreme (ui/toolbar/ui.toolbar.strategy.drop_down_menu.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $7I8Uw = parcelRequire("7I8Uw");
var $1c014afc280854ff$require$extend = $7I8Uw.extend;

var $1d90122c979d47ee$exports = {};
/**
 * DevExtreme (ui/toolbar/ui.toolbar.menu.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $4ZFRo = parcelRequire("4ZFRo");

var $4Pwuy = parcelRequire("4Pwuy");
var $1d90122c979d47ee$require$each = $4Pwuy.each;
var $f8c15c4fd57b6899$exports = {};
/**
 * DevExtreme (ui/list/ui.list.base.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $e1LMc = parcelRequire("e1LMc");

var $2Mto0 = parcelRequire("2Mto0");

var $kDRxH = parcelRequire("kDRxH");

var $69u7b = parcelRequire("69u7b");

var $5OzEX = parcelRequire("5OzEX");
var $f8c15c4fd57b6899$require$getPublicElement = $5OzEX.getPublicElement;

var $4Pwuy = parcelRequire("4Pwuy");
var $f8c15c4fd57b6899$require$each = $4Pwuy.each;

var $kpjzB = parcelRequire("kpjzB");
var $f8c15c4fd57b6899$require$compileGetter = $kpjzB.compileGetter;

var $7I8Uw = parcelRequire("7I8Uw");
var $f8c15c4fd57b6899$require$extend = $7I8Uw.extend;

var $c7ml4 = parcelRequire("c7ml4");

var $i7ZSP = parcelRequire("i7ZSP");

var $l8ZSv = parcelRequire("l8ZSv");

var $6VAWB = parcelRequire("6VAWB");

var $cnVbh = parcelRequire("cnVbh");

var $gysT6 = parcelRequire("gysT6");

var $aiwte = parcelRequire("aiwte");
var $475ad97284863a03$exports = {};
/**
 * DevExtreme (ui/list/item.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $475ad97284863a03$var$LIST_ITEM_BADGE_CONTAINER_CLASS = "dx-list-item-badge-container";
var $475ad97284863a03$var$LIST_ITEM_BADGE_CLASS = "dx-list-item-badge";
var $475ad97284863a03$var$BADGE_CLASS = "dx-badge";
var $475ad97284863a03$var$LIST_ITEM_CHEVRON_CONTAINER_CLASS = "dx-list-item-chevron-container";
var $475ad97284863a03$var$LIST_ITEM_CHEVRON_CLASS = "dx-list-item-chevron";
var $475ad97284863a03$var$ListItem = $5bf3215940da1add$exports.inherit({
    _renderWatchers: function() {
        this.callBase();
        this._startWatcher("badge", this._renderBadge.bind(this));
        this._startWatcher("showChevron", this._renderShowChevron.bind(this));
    },
    _renderBadge: function(badge) {
        this._$element.children("." + $475ad97284863a03$var$LIST_ITEM_BADGE_CONTAINER_CLASS).remove();
        if (!badge) return;
        var $badge = $jFnCG("<div>").addClass($475ad97284863a03$var$LIST_ITEM_BADGE_CONTAINER_CLASS).append($jFnCG("<div>").addClass($475ad97284863a03$var$LIST_ITEM_BADGE_CLASS).addClass($475ad97284863a03$var$BADGE_CLASS).text(badge));
        var $chevron = this._$element.children("." + $475ad97284863a03$var$LIST_ITEM_CHEVRON_CONTAINER_CLASS).first();
        $chevron.length > 0 ? $badge.insertBefore($chevron) : $badge.appendTo(this._$element);
    },
    _renderShowChevron: function(showChevron) {
        this._$element.children("." + $475ad97284863a03$var$LIST_ITEM_CHEVRON_CONTAINER_CLASS).remove();
        if (!showChevron) return;
        var $chevronContainer = $jFnCG("<div>").addClass($475ad97284863a03$var$LIST_ITEM_CHEVRON_CONTAINER_CLASS);
        var $chevron = $jFnCG("<div>").addClass($475ad97284863a03$var$LIST_ITEM_CHEVRON_CLASS);
        $chevronContainer.append($chevron).appendTo(this._$element);
    }
});
$475ad97284863a03$exports = $475ad97284863a03$var$ListItem;



var $7KuSv = parcelRequire("7KuSv");

var $bXb2w = parcelRequire("bXb2w");

var $3LUJe = parcelRequire("3LUJe");

var $irv64 = parcelRequire("irv64");
var $a0474e07157c351b$exports = {};
/**
 * DevExtreme (ui/scroll_view.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

$a0474e07157c351b$exports = (parcelRequire("6JqLo"));
$a0474e07157c351b$exports.default = $a0474e07157c351b$exports;



var $69YDp = parcelRequire("69YDp");
var $f8c15c4fd57b6899$require$deviceDependentOptions = $69YDp.deviceDependentOptions;
var $d7e799e8ea22941d$exports = {};
/**
 * DevExtreme (ui/collection/ui.collection_widget.live_update.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty($d7e799e8ea22941d$exports, "__esModule", {
    value: true
});

var $jFnCG = parcelRequire("jFnCG");
var $d7e799e8ea22941d$var$_renderer2 = $d7e799e8ea22941d$var$_interopRequireDefault($jFnCG);

var $d7e799e8ea22941d$var$_uiCollection_widget2 = $d7e799e8ea22941d$var$_interopRequireDefault($f4d41dfe58d276dc$exports);

var $7I8Uw = parcelRequire("7I8Uw");

var $kDRxH = parcelRequire("kDRxH");

var $d7e799e8ea22941d$var$_array_utils2 = $d7e799e8ea22941d$var$_interopRequireDefault($852ad2a58fe2bfbc$exports);


var $2F60d = parcelRequire("2F60d");
var $96ae11c7c79deb14$exports = {};
/**
 * DevExtreme (core/utils/array_compare.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty($96ae11c7c79deb14$exports, "__esModule", {
    value: true
});
$96ae11c7c79deb14$exports.findChanges = void 0;

var $kDRxH = parcelRequire("kDRxH");
var $96ae11c7c79deb14$var$getKeyWrapper = function(item, getKey) {
    var key = getKey(item);
    if ((0, $kDRxH.isObject)(key)) try {
        return JSON.stringify(key);
    } catch (e) {
        return key;
    }
    return key;
};
var $96ae11c7c79deb14$var$getSameNewByOld = function(oldItem, newItems, newIndexByKey, getKey) {
    var key = $96ae11c7c79deb14$var$getKeyWrapper(oldItem, getKey);
    return newItems[newIndexByKey[key]];
};
var $96ae11c7c79deb14$var$findChanges = $96ae11c7c79deb14$exports.findChanges = function(oldItems, newItems, getKey, isItemEquals) {
    var oldIndexByKey = {};
    var newIndexByKey = {};
    var addedCount = 0;
    var removeCount = 0;
    var result = [];
    oldItems.forEach(function(item, index) {
        var key = $96ae11c7c79deb14$var$getKeyWrapper(item, getKey);
        oldIndexByKey[key] = index;
    });
    newItems.forEach(function(item, index) {
        var key = $96ae11c7c79deb14$var$getKeyWrapper(item, getKey);
        newIndexByKey[key] = index;
    });
    var itemCount = Math.max(oldItems.length, newItems.length);
    for(var index = 0; index < itemCount + addedCount; index++){
        var newItem = newItems[index];
        var oldNextIndex = index - addedCount + removeCount;
        var nextOldItem = oldItems[oldNextIndex];
        var isRemoved = !newItem || nextOldItem && !$96ae11c7c79deb14$var$getSameNewByOld(nextOldItem, newItems, newIndexByKey, getKey);
        if (isRemoved) {
            if (nextOldItem) {
                result.push({
                    type: "remove",
                    key: getKey(nextOldItem),
                    index: index,
                    oldItem: nextOldItem
                });
                removeCount++;
                index--;
            }
        } else {
            var key = $96ae11c7c79deb14$var$getKeyWrapper(newItem, getKey);
            var oldIndex = oldIndexByKey[key];
            var oldItem = oldItems[oldIndex];
            if (!oldItem) {
                addedCount++;
                result.push({
                    type: "insert",
                    data: newItem,
                    index: index
                });
            } else {
                if (oldIndex === oldNextIndex) {
                    if (!isItemEquals(oldItem, newItem)) result.push({
                        type: "update",
                        data: newItem,
                        key: getKey(newItem),
                        index: index,
                        oldItem: oldItem
                    });
                } else return;
            }
        }
    }
    return result;
};



var $445Bz = parcelRequire("445Bz");

var $2Mto0 = parcelRequire("2Mto0");
function $d7e799e8ea22941d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $d7e799e8ea22941d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $d7e799e8ea22941d$var$PRIVATE_KEY_FIELD = "__dx_key__";
$d7e799e8ea22941d$exports.default = $d7e799e8ea22941d$var$_uiCollection_widget2.default.inherit({
    _getDefaultOptions: function() {
        return (0, $7I8Uw.extend)(this.callBase(), {
            repaintChangesOnly: false
        });
    },
    ctor: function() {
        var _this = this;
        this.callBase.apply(this, arguments);
        this._customizeStoreLoadOptions = function(e) {
            var dataSource = _this._dataSource;
            if (dataSource && !dataSource.isLoaded()) _this._correctionIndex = 0;
            if (_this._correctionIndex && e.storeLoadOptions) e.storeLoadOptions.skip += _this._correctionIndex;
        }, this._dataSource && this._dataSource.on("customizeStoreLoadOptions", this._customizeStoreLoadOptions);
    },
    reload: function() {
        this._correctionIndex = 0;
    },
    _init: function() {
        this.callBase();
        this._refreshItemsCache();
        this._correctionIndex = 0;
    },
    _findItemElementByKey: function(key) {
        var _this2 = this;
        var result = (0, $d7e799e8ea22941d$var$_renderer2.default)();
        var keyExpr = this.key();
        this.itemElements().each(function(_, item) {
            var $item = (0, $d7e799e8ea22941d$var$_renderer2.default)(item);
            var itemData = _this2._getItemData($item);
            if (keyExpr ? (0, $94b9773d9b4e83fd$exports.keysEqual)(_this2.keyOf(itemData), key) : _this2._isItemEquals(itemData, key)) {
                result = $item;
                return false;
            }
        });
        return result;
    },
    _dataSourceChangedHandler: function(newItems, e) {
        e && e.changes ? this._modifyByChanges(e.changes) : this.callBase(newItems, e);
    },
    _isItemEquals: function(item1, item2) {
        if (item1 && item1[$d7e799e8ea22941d$var$PRIVATE_KEY_FIELD]) item1 = item1.data;
        try {
            return JSON.stringify(item1) === JSON.stringify(item2);
        } catch (e) {
            return item1 === item2;
        }
    },
    _partialRefresh: function() {
        var _this3 = this;
        if (this.option("repaintChangesOnly")) {
            var keyOf = function(data) {
                if (data && void 0 !== data[$d7e799e8ea22941d$var$PRIVATE_KEY_FIELD]) return data[$d7e799e8ea22941d$var$PRIVATE_KEY_FIELD];
                return _this3.keyOf(data);
            };
            var result = (0, $96ae11c7c79deb14$exports.findChanges)(this._itemsCache, this._editStrategy.itemsGetter(), keyOf, this._isItemEquals);
            if (result && this._itemsCache.length) {
                this._modifyByChanges(result, true);
                this._renderEmptyMessage();
                return true;
            } else this._refreshItemsCache();
        }
        return false;
    },
    _refreshItemsCache: function() {
        if (this.option("repaintChangesOnly")) {
            var items = this._editStrategy.itemsGetter();
            try {
                this._itemsCache = (0, $7I8Uw.extend)(true, [], items);
                if (!this.key()) this._itemsCache = this._itemsCache.map(function(itemCache, index) {
                    var _ref;
                    return _ref = {}, $d7e799e8ea22941d$var$_defineProperty(_ref, $d7e799e8ea22941d$var$PRIVATE_KEY_FIELD, items[index]), $d7e799e8ea22941d$var$_defineProperty(_ref, "data", itemCache), _ref;
                });
            } catch (e) {
                this._itemsCache = (0, $7I8Uw.extend)([], items);
            }
        }
    },
    _dispose: function() {
        this._dataSource && this._dataSource.off("customizeStoreLoadOptions", this._customizeStoreLoadOptions);
        this.callBase();
    },
    _updateByChange: function(keyInfo, items, change, isPartialRefresh) {
        var _this4 = this;
        if (isPartialRefresh) this._renderItem(change.index, change.data, null, this._findItemElementByKey(change.key));
        else {
            var changedItem = items[$d7e799e8ea22941d$var$_array_utils2.default.indexByKey(keyInfo, items, change.key)];
            if (changedItem) $d7e799e8ea22941d$var$_array_utils2.default.update(keyInfo, items, change.key, change.data).done(function() {
                _this4._renderItem(items.indexOf(changedItem), changedItem, null, _this4._findItemElementByKey(change.key));
            });
        }
    },
    _insertByChange: function(keyInfo, items, change, isPartialRefresh) {
        var _this5 = this;
        (0, $2F60d.when)(isPartialRefresh || $d7e799e8ea22941d$var$_array_utils2.default.insert(keyInfo, items, change.data, change.index)).done(function() {
            _this5._beforeItemElementInserted(change);
            _this5._renderItem((0, $kDRxH.isDefined)(change.index) ? change.index : items.length, change.data);
            _this5._afterItemElementInserted();
            _this5._correctionIndex++;
        });
    },
    _updateSelectionAfterRemoveByChange: function(removeIndex) {
        var selectedIndex = this.option("selectedIndex");
        if (selectedIndex > removeIndex) this.option("selectedIndex", selectedIndex - 1);
        else if (selectedIndex === removeIndex && 1 === this.option("selectedItems").length) this.option("selectedItems", []);
        else this._normalizeSelectedItems();
    },
    _beforeItemElementInserted: function(change) {
        var selectedIndex = this.option("selectedIndex");
        if (change.index <= selectedIndex) this.option("selectedIndex", selectedIndex + 1);
    },
    _afterItemElementInserted: $2Mto0.noop,
    _removeByChange: function(keyInfo, items, change, isPartialRefresh) {
        var _this6 = this;
        var index = isPartialRefresh ? change.index : $d7e799e8ea22941d$var$_array_utils2.default.indexByKey(keyInfo, items, change.key);
        var removedItem = isPartialRefresh ? change.oldItem : items[index];
        if (removedItem) {
            var $removedItemElement = this._findItemElementByKey(change.key);
            var deletedActionArgs = this._extendActionArgs($removedItemElement);
            this._waitDeletingPrepare($removedItemElement).done(function() {
                if (isPartialRefresh) {
                    _this6._updateIndicesAfterIndex(index - 1);
                    _this6._afterItemElementDeleted($removedItemElement, deletedActionArgs);
                    _this6._updateSelectionAfterRemoveByChange(index);
                } else {
                    _this6._deleteItemElementByIndex(index);
                    _this6._afterItemElementDeleted($removedItemElement, deletedActionArgs);
                }
            });
            this._correctionIndex--;
        }
    },
    _modifyByChanges: function(changes, isPartialRefresh) {
        var _this7 = this;
        var items = this._editStrategy.itemsGetter();
        var keyInfo = {
            key: this.key.bind(this),
            keyOf: this.keyOf.bind(this)
        };
        var dataSource = this._dataSource;
        var paginate = dataSource && dataSource.paginate();
        var group = dataSource && dataSource.group();
        if (paginate || group) changes = changes.filter(function(item) {
            return "insert" !== item.type || void 0 !== item.index;
        });
        changes.forEach(function(change) {
            return _this7["_".concat(change.type, "ByChange")](keyInfo, items, change, isPartialRefresh);
        });
        this._renderedItemsCount = items.length;
        this._refreshItemsCache();
        this._fireContentReadyAction();
    },
    _appendItemToContainer: function($container, $itemFrame, index) {
        var nextSiblingElement = $container.children(this._itemSelector()).get(index);
        (0, $445Bz.insertElement)($container.get(0), $itemFrame.get(0), nextSiblingElement);
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "items":
                var isItemsUpdated = this._partialRefresh(args.value);
                if (!isItemsUpdated) this.callBase(args);
                break;
            case "dataSource":
                if (!this.option("repaintChangesOnly") || !args.value) this.option("items", []);
                this.callBase(args);
                break;
            case "repaintChangesOnly":
                break;
            default:
                this.callBase(args);
        }
    }
});


var $f8c15c4fd57b6899$require$CollectionWidget = $d7e799e8ea22941d$exports.default;

var $f8c15c4fd57b6899$require$BindableTemplate = $46d7ae10a89c38af$exports.BindableTemplate;

var $2F60d = parcelRequire("2F60d");
var $f8c15c4fd57b6899$require$Deferred = $2F60d.Deferred;
var $f2d91940f8416fe3$exports = {};
/**
 * DevExtreme (ui/shared/grouped_data_converter_mixin.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
Object.defineProperty($f2d91940f8416fe3$exports, "__esModule", {
    value: true
});

var $kDRxH = parcelRequire("kDRxH");
var $f2d91940f8416fe3$var$isCorrectStructure = function(data) {
    return Array.isArray(data) && data.every(function(item) {
        var hasTwoFields = 2 === Object.keys(item).length;
        var hasCorrectFields = "key" in item && "items" in item;
        return hasTwoFields && hasCorrectFields && Array.isArray(item.items);
    });
};
$f2d91940f8416fe3$exports.default = {
    _getSpecificDataSourceOption: function() {
        var groupKey = "key";
        var dataSource = this.option("dataSource");
        var hasSimpleItems = false;
        var data = {};
        if (this._getGroupedOption() && $f2d91940f8416fe3$var$isCorrectStructure(dataSource)) {
            data = dataSource.reduce(function(accumulator, item) {
                var items = item.items.map(function(innerItem) {
                    if (!(0, $kDRxH.isObject)(innerItem)) {
                        innerItem = {
                            text: innerItem
                        };
                        hasSimpleItems = true;
                    }
                    if (!(groupKey in innerItem)) innerItem[groupKey] = item.key;
                    return innerItem;
                });
                return accumulator.concat(items);
            }, []);
            dataSource = {
                store: {
                    type: "array",
                    data: data
                },
                group: {
                    selector: "key",
                    keepInitialKeyOrder: true
                }
            };
            if (hasSimpleItems) dataSource.searchExpr = "text";
        }
        return dataSource;
    }
};


var $f8c15c4fd57b6899$require$DataConverterMixin = $f2d91940f8416fe3$exports.default;
var $f8c15c4fd57b6899$var$LIST_CLASS = "dx-list";
var $f8c15c4fd57b6899$var$LIST_ITEM_CLASS = "dx-list-item";
var $f8c15c4fd57b6899$var$LIST_ITEM_SELECTOR = "." + $f8c15c4fd57b6899$var$LIST_ITEM_CLASS;
var $f8c15c4fd57b6899$var$LIST_ITEM_ICON_CONTAINER_CLASS = "dx-list-item-icon-container";
var $f8c15c4fd57b6899$var$LIST_ITEM_ICON_CLASS = "dx-list-item-icon";
var $f8c15c4fd57b6899$var$LIST_GROUP_CLASS = "dx-list-group";
var $f8c15c4fd57b6899$var$LIST_GROUP_HEADER_CLASS = "dx-list-group-header";
var $f8c15c4fd57b6899$var$LIST_GROUP_BODY_CLASS = "dx-list-group-body";
var $f8c15c4fd57b6899$var$LIST_COLLAPSIBLE_GROUPS_CLASS = "dx-list-collapsible-groups";
var $f8c15c4fd57b6899$var$LIST_GROUP_COLLAPSED_CLASS = "dx-list-group-collapsed";
var $f8c15c4fd57b6899$var$LIST_GROUP_HEADER_INDICATOR_CLASS = "dx-list-group-header-indicator";
var $f8c15c4fd57b6899$var$LIST_HAS_NEXT_CLASS = "dx-has-next";
var $f8c15c4fd57b6899$var$LIST_NEXT_BUTTON_CLASS = "dx-list-next-button";
var $f8c15c4fd57b6899$var$WRAP_ITEM_TEXT_CLASS = "dx-wrap-item-text";
var $f8c15c4fd57b6899$var$SELECT_ALL_ITEM_SELECTOR = ".dx-list-select-all";
var $f8c15c4fd57b6899$var$LIST_ITEM_DATA_KEY = "dxListItemData";
var $f8c15c4fd57b6899$var$LIST_FEEDBACK_SHOW_TIMEOUT = 70;
var $f8c15c4fd57b6899$var$groupItemsGetter = $f8c15c4fd57b6899$require$compileGetter("items");
var $f8c15c4fd57b6899$var$ListBase = $f8c15c4fd57b6899$require$CollectionWidget.inherit({
    _activeStateUnit: [
        $f8c15c4fd57b6899$var$LIST_ITEM_SELECTOR,
        $f8c15c4fd57b6899$var$SELECT_ALL_ITEM_SELECTOR
    ].join(","),
    _supportedKeys: function() {
        var that = this;
        var moveFocusPerPage = function(direction) {
            var $item = getEdgeVisibleItem(direction);
            var isFocusedItem = $item.is(that.option("focusedElement"));
            if (isFocusedItem) {
                scrollListTo($item, direction);
                $item = getEdgeVisibleItem(direction);
            }
            that.option("focusedElement", $f8c15c4fd57b6899$require$getPublicElement($item));
            that.scrollToItem($item);
        };
        var getEdgeVisibleItem = function(direction) {
            var scrollTop = that.scrollTop();
            var containerHeight = that.$element().height();
            var $item = $jFnCG(that.option("focusedElement"));
            var isItemVisible = true;
            if (!$item.length) return $jFnCG();
            while(isItemVisible){
                var $nextItem = $item[direction]();
                if (!$nextItem.length) break;
                var nextItemLocation = $nextItem.position().top + $nextItem.outerHeight() / 2;
                isItemVisible = nextItemLocation < containerHeight + scrollTop && nextItemLocation > scrollTop;
                if (isItemVisible) $item = $nextItem;
            }
            return $item;
        };
        var scrollListTo = function($item, direction) {
            var resultPosition = $item.position().top;
            if ("prev" === direction) resultPosition = $item.position().top - that.$element().height() + $item.outerHeight();
            that.scrollTo(resultPosition);
        };
        return $f8c15c4fd57b6899$require$extend(this.callBase(), {
            leftArrow: $2Mto0.noop,
            rightArrow: $2Mto0.noop,
            pageUp: function() {
                moveFocusPerPage("prev");
                return false;
            },
            pageDown: function() {
                moveFocusPerPage("next");
                return false;
            }
        });
    },
    _getDefaultOptions: function() {
        return $f8c15c4fd57b6899$require$extend(this.callBase(), {
            hoverStateEnabled: true,
            pullRefreshEnabled: false,
            scrollingEnabled: true,
            showScrollbar: "onScroll",
            useNativeScrolling: true,
            bounceEnabled: true,
            scrollByContent: true,
            scrollByThumb: false,
            pullingDownText: $cnVbh.format("dxList-pullingDownText"),
            pulledDownText: $cnVbh.format("dxList-pulledDownText"),
            refreshingText: $cnVbh.format("dxList-refreshingText"),
            pageLoadingText: $cnVbh.format("dxList-pageLoadingText"),
            onScroll: null,
            onPullRefresh: null,
            onPageLoading: null,
            pageLoadMode: "scrollBottom",
            nextButtonText: $cnVbh.format("dxList-nextButtonText"),
            onItemSwipe: null,
            grouped: false,
            onGroupRendered: null,
            collapsibleGroups: false,
            groupTemplate: "group",
            indicateLoading: true,
            activeStateEnabled: true,
            _itemAttributes: {
                role: "option"
            },
            _listAttributes: {
                role: "listbox"
            },
            useInkRipple: false,
            wrapItemText: false,
            showChevronExpr: function(data) {
                return data ? data.showChevron : void 0;
            },
            badgeExpr: function(data) {
                return data ? data.badge : void 0;
            }
        });
    },
    _defaultOptionsRules: function() {
        var themeName = $3LUJe.current();
        return this.callBase().concat($f8c15c4fd57b6899$require$deviceDependentOptions(), [
            {
                device: function() {
                    return !$6VAWB.nativeScrolling;
                },
                options: {
                    useNativeScrolling: false
                }
            },
            {
                device: function(_device) {
                    return !$6VAWB.nativeScrolling && !$aiwte.isSimulator() && "desktop" === $aiwte.real().deviceType && "generic" === _device.platform;
                },
                options: {
                    showScrollbar: "onHover",
                    pageLoadMode: "nextButton"
                }
            },
            {
                device: function() {
                    return "desktop" === $aiwte.real().deviceType && !$aiwte.isSimulator();
                },
                options: {
                    focusStateEnabled: true
                }
            },
            {
                device: function() {
                    return $3LUJe.isMaterial(themeName);
                },
                options: {
                    pullingDownText: "",
                    pulledDownText: "",
                    refreshingText: "",
                    pageLoadingText: "",
                    useInkRipple: true
                }
            }
        ]);
    },
    _visibilityChanged: function(visible) {
        if (visible) this._updateLoadingState(true);
    },
    _itemClass: function() {
        return $f8c15c4fd57b6899$var$LIST_ITEM_CLASS;
    },
    _itemDataKey: function() {
        return $f8c15c4fd57b6899$var$LIST_ITEM_DATA_KEY;
    },
    _itemContainer: function() {
        return this._$container;
    },
    _refreshItemElements: function() {
        if (!this.option("grouped")) this._itemElementsCache = this._itemContainer().children(this._itemSelector());
        else this._itemElementsCache = this._itemContainer().children("." + $f8c15c4fd57b6899$var$LIST_GROUP_CLASS).children("." + $f8c15c4fd57b6899$var$LIST_GROUP_BODY_CLASS).children(this._itemSelector());
    },
    _modifyByChanges: function() {
        this.callBase.apply(this, arguments);
        this._refreshItemElements();
        this._updateLoadingState();
    },
    reorderItem: function(itemElement, toItemElement) {
        var promise = this.callBase(itemElement, toItemElement);
        return promise.done(function() {
            this._refreshItemElements();
        });
    },
    deleteItem: function(itemElement) {
        var promise = this.callBase(itemElement);
        return promise.done(function() {
            this._refreshItemElements();
        });
    },
    _itemElements: function() {
        return this._itemElementsCache;
    },
    _itemSelectHandler: function(e) {
        if ("single" === this.option("selectionMode") && this.isItemSelected(e.currentTarget)) return;
        this.callBase(e);
    },
    _allowDynamicItemsAppend: function() {
        return true;
    },
    _init: function() {
        this.callBase();
        this._$container = this.$element();
        this._initScrollView();
        this._feedbackShowTimeout = $f8c15c4fd57b6899$var$LIST_FEEDBACK_SHOW_TIMEOUT;
        this._createGroupRenderAction();
    },
    _scrollBottomMode: function() {
        return "scrollBottom" === this.option("pageLoadMode");
    },
    _nextButtonMode: function() {
        return "nextButton" === this.option("pageLoadMode");
    },
    _dataSourceOptions: function() {
        var scrollBottom = this._scrollBottomMode();
        var nextButton = this._nextButtonMode();
        return $f8c15c4fd57b6899$require$extend(this.callBase(), {
            paginate: $2Mto0.ensureDefined(scrollBottom || nextButton, true)
        });
    },
    _getGroupedOption: function() {
        return this.option("grouped");
    },
    _dataSourceFromUrlLoadMode: function() {
        return "raw";
    },
    _initScrollView: function() {
        var scrollingEnabled = this.option("scrollingEnabled");
        var pullRefreshEnabled = scrollingEnabled && this.option("pullRefreshEnabled");
        var autoPagingEnabled = scrollingEnabled && this._scrollBottomMode() && !!this._dataSource;
        this._scrollView = this._createComponent(this.$element(), $a0474e07157c351b$exports, {
            disabled: this.option("disabled") || !scrollingEnabled,
            onScroll: this._scrollHandler.bind(this),
            onPullDown: pullRefreshEnabled ? this._pullDownHandler.bind(this) : null,
            onReachBottom: autoPagingEnabled ? this._scrollBottomHandler.bind(this) : null,
            showScrollbar: this.option("showScrollbar"),
            useNative: this.option("useNativeScrolling"),
            bounceEnabled: this.option("bounceEnabled"),
            scrollByContent: this.option("scrollByContent"),
            scrollByThumb: this.option("scrollByThumb"),
            pullingDownText: this.option("pullingDownText"),
            pulledDownText: this.option("pulledDownText"),
            refreshingText: this.option("refreshingText"),
            reachBottomText: this.option("pageLoadingText"),
            useKeyboard: false
        });
        this._$container = $jFnCG(this._scrollView.content());
        if (this.option("wrapItemText")) this._$container.addClass($f8c15c4fd57b6899$var$WRAP_ITEM_TEXT_CLASS);
        this._createScrollViewActions();
    },
    _createScrollViewActions: function() {
        this._scrollAction = this._createActionByOption("onScroll");
        this._pullRefreshAction = this._createActionByOption("onPullRefresh");
        this._pageLoadingAction = this._createActionByOption("onPageLoading");
    },
    _scrollHandler: function(e) {
        this._scrollAction && this._scrollAction(e);
    },
    _initTemplates: function() {
        this.callBase();
        this._defaultTemplates.group = new $f8c15c4fd57b6899$require$BindableTemplate(function($container, data) {
            if ($kDRxH.isPlainObject(data)) {
                if (data.key) $container.text(data.key);
            } else $container.text(String(data));
        }, [
            "key"
        ], this.option("integrationOptions.watchMethod"));
    },
    _prepareDefaultItemTemplate: function(data, $container) {
        this.callBase(data, $container);
        if (data.icon) {
            var $icon = $69u7b.getImageContainer(data.icon).addClass($f8c15c4fd57b6899$var$LIST_ITEM_ICON_CLASS);
            var $iconContainer = $jFnCG("<div>").addClass($f8c15c4fd57b6899$var$LIST_ITEM_ICON_CONTAINER_CLASS);
            $iconContainer.append($icon);
            $container.prepend($iconContainer);
        }
    },
    _getBindableFields: function() {
        return [
            "text",
            "html",
            "icon"
        ];
    },
    _updateLoadingState: function(tryLoadMore) {
        var isDataLoaded = !tryLoadMore || this._isLastPage();
        var scrollBottomMode = this._scrollBottomMode();
        var stopLoading = isDataLoaded || !scrollBottomMode;
        var hideLoadIndicator = stopLoading && !this._isDataSourceLoading();
        if (stopLoading || this._scrollViewIsFull()) {
            this._scrollView.release(hideLoadIndicator);
            this._toggleNextButton(this._shouldRenderNextButton() && !this._isLastPage());
            this._loadIndicationSuppressed(false);
        } else this._infiniteDataLoading();
    },
    _shouldRenderNextButton: function() {
        return this._nextButtonMode() && this._dataSource && this._dataSource.isLoaded();
    },
    _dataSourceLoadingChangedHandler: function(isLoading) {
        if (this._loadIndicationSuppressed()) return;
        if (isLoading && this.option("indicateLoading")) this._showLoadingIndicatorTimer = setTimeout((function() {
            var isEmpty = !this._itemElements().length;
            if (this._scrollView && !isEmpty) this._scrollView.startLoading();
        }).bind(this));
        else {
            clearTimeout(this._showLoadingIndicatorTimer);
            this._scrollView && this._scrollView.finishLoading();
        }
    },
    _dataSourceChangedHandler: function(newItems) {
        if (!this._shouldAppendItems() && $irv64.hasWindow()) this._scrollView && this._scrollView.scrollTo(0);
        this.callBase.apply(this, arguments);
    },
    _refreshContent: function() {
        this._prepareContent();
        this._fireContentReadyAction();
    },
    _hideLoadingIfLoadIndicationOff: function() {
        if (!this.option("indicateLoading")) this._dataSourceLoadingChangedHandler(false);
    },
    _loadIndicationSuppressed: function(value) {
        if (!arguments.length) return this._isLoadIndicationSuppressed;
        this._isLoadIndicationSuppressed = value;
    },
    _scrollViewIsFull: function() {
        return !this._scrollView || this._scrollView.isFull();
    },
    _pullDownHandler: function(e) {
        this._pullRefreshAction(e);
        if (this._dataSource && !this._isDataSourceLoading()) {
            this._clearSelectedItems();
            this._dataSource.pageIndex(0);
            this._dataSource.reload();
        } else this._updateLoadingState();
    },
    _infiniteDataLoading: function() {
        var isElementVisible = this.$element().is(":visible");
        if (isElementVisible && !this._scrollViewIsFull() && !this._isDataSourceLoading() && !this._isLastPage()) {
            clearTimeout(this._loadNextPageTimer);
            this._loadNextPageTimer = setTimeout(this._loadNextPage.bind(this));
        }
    },
    _scrollBottomHandler: function(e) {
        this._pageLoadingAction(e);
        if (!this._isDataSourceLoading() && !this._isLastPage()) this._loadNextPage();
        else this._updateLoadingState();
    },
    _renderItems: function(items) {
        if (this.option("grouped")) {
            $f8c15c4fd57b6899$require$each(items, this._renderGroup.bind(this));
            this._attachGroupCollapseEvent();
            this._renderEmptyMessage();
            if ($3LUJe.isMaterial()) this.attachGroupHeaderInkRippleEvents();
        } else this.callBase.apply(this, arguments);
        this._refreshItemElements();
        this._updateLoadingState(true);
    },
    _attachGroupCollapseEvent: function() {
        var eventName = $bXb2w.addNamespace($i7ZSP.name, this.NAME);
        var selector = "." + $f8c15c4fd57b6899$var$LIST_GROUP_HEADER_CLASS;
        var $element = this.$element();
        var collapsibleGroups = this.option("collapsibleGroups");
        $element.toggleClass($f8c15c4fd57b6899$var$LIST_COLLAPSIBLE_GROUPS_CLASS, collapsibleGroups);
        $e1LMc.off($element, eventName, selector);
        if (collapsibleGroups) $e1LMc.on($element, eventName, selector, (function(e) {
            this._createAction((function(e) {
                var $group = $jFnCG(e.event.currentTarget).parent();
                this._collapseGroupHandler($group);
                if (this.option("focusStateEnabled")) this.option("focusedElement", $f8c15c4fd57b6899$require$getPublicElement($group.find("." + $f8c15c4fd57b6899$var$LIST_ITEM_CLASS).eq(0)));
            }).bind(this), {
                validatingTargetName: "element"
            })({
                event: e
            });
        }).bind(this));
    },
    _collapseGroupHandler: function($group, toggle) {
        var deferred = new $f8c15c4fd57b6899$require$Deferred;
        if ($group.hasClass($f8c15c4fd57b6899$var$LIST_GROUP_COLLAPSED_CLASS) === toggle) return deferred.resolve();
        var $groupBody = $group.children("." + $f8c15c4fd57b6899$var$LIST_GROUP_BODY_CLASS);
        var startHeight = $groupBody.outerHeight();
        var endHeight = 0 === startHeight ? $groupBody.height("auto").outerHeight() : 0;
        $group.toggleClass($f8c15c4fd57b6899$var$LIST_GROUP_COLLAPSED_CLASS, toggle);
        $c7ml4.animate($groupBody, {
            type: "custom",
            from: {
                height: startHeight
            },
            to: {
                height: endHeight
            },
            duration: 200,
            complete: (function() {
                this.updateDimensions();
                this._updateLoadingState();
                deferred.resolve();
            }).bind(this)
        });
        return deferred.promise();
    },
    _dataSourceLoadErrorHandler: function() {
        this._forgetNextPageLoading();
        if (this._initialized) {
            this._renderEmptyMessage();
            this._updateLoadingState();
        }
    },
    _initMarkup: function() {
        this._itemElementsCache = $jFnCG();
        this.$element().addClass($f8c15c4fd57b6899$var$LIST_CLASS);
        this.callBase();
        this.option("useInkRipple") && this._renderInkRipple();
        this.setAria("role", this.option("_listAttributes").role);
    },
    _renderInkRipple: function() {
        this._inkRipple = $gysT6.render();
    },
    _toggleActiveState: function($element, value, e) {
        this.callBase.apply(this, arguments);
        var that = this;
        if (!this._inkRipple) return;
        var config = {
            element: $element,
            event: e
        };
        if (value) {
            if ($3LUJe.isMaterial()) this._inkRippleTimer = setTimeout(function() {
                that._inkRipple.showWave(config);
            }, $f8c15c4fd57b6899$var$LIST_FEEDBACK_SHOW_TIMEOUT / 2);
            else that._inkRipple.showWave(config);
        } else {
            clearTimeout(this._inkRippleTimer);
            this._inkRipple.hideWave(config);
        }
    },
    _postprocessRenderItem: function(args) {
        this._refreshItemElements();
        this.callBase.apply(this, arguments);
        if (this.option("onItemSwipe")) this._attachSwipeEvent($jFnCG(args.itemElement));
    },
    _attachSwipeEvent: function($itemElement) {
        var endEventName = $bXb2w.addNamespace($l8ZSv.end, this.NAME);
        $e1LMc.on($itemElement, endEventName, this._itemSwipeEndHandler.bind(this));
    },
    _itemSwipeEndHandler: function(e) {
        this._itemDXEventHandler(e, "onItemSwipe", {
            direction: e.offset < 0 ? "left" : "right"
        });
    },
    _nextButtonHandler: function(e) {
        this._pageLoadingAction(e);
        var source = this._dataSource;
        if (source && !source.isLoading()) {
            this._scrollView.toggleLoading(true);
            this._$nextButton.detach();
            this._loadIndicationSuppressed(true);
            this._loadNextPage();
        }
    },
    _renderGroup: function(index, group) {
        var $groupElement = $jFnCG("<div>").addClass($f8c15c4fd57b6899$var$LIST_GROUP_CLASS).appendTo(this._itemContainer());
        var $groupHeaderElement = $jFnCG("<div>").addClass($f8c15c4fd57b6899$var$LIST_GROUP_HEADER_CLASS).appendTo($groupElement);
        var groupTemplateName = this.option("groupTemplate");
        var groupTemplate = this._getTemplate(group.template || groupTemplateName, group, index, $groupHeaderElement);
        var renderArgs = {
            index: index,
            itemData: group,
            container: $f8c15c4fd57b6899$require$getPublicElement($groupHeaderElement)
        };
        this._createItemByTemplate(groupTemplate, renderArgs);
        if ($3LUJe.isMaterial()) $jFnCG("<div>").addClass($f8c15c4fd57b6899$var$LIST_GROUP_HEADER_INDICATOR_CLASS).prependTo($groupHeaderElement);
        this._renderingGroupIndex = index;
        var $groupBody = $jFnCG("<div>").addClass($f8c15c4fd57b6899$var$LIST_GROUP_BODY_CLASS).appendTo($groupElement);
        $f8c15c4fd57b6899$require$each($f8c15c4fd57b6899$var$groupItemsGetter(group) || [], (function(index, item) {
            this._renderItem(index, item, $groupBody);
        }).bind(this));
        this._groupRenderAction({
            groupElement: $f8c15c4fd57b6899$require$getPublicElement($groupElement),
            groupIndex: index,
            groupData: group
        });
    },
    downInkRippleHandler: function(e) {
        this._toggleActiveState($jFnCG(e.currentTarget), true, e);
    },
    upInkRippleHandler: function(e) {
        this._toggleActiveState($jFnCG(e.currentTarget), false);
    },
    attachGroupHeaderInkRippleEvents: function() {
        var selector = "." + $f8c15c4fd57b6899$var$LIST_GROUP_HEADER_CLASS;
        var $element = this.$element();
        this._downInkRippleHandler = this._downInkRippleHandler || this.downInkRippleHandler.bind(this);
        this._upInkRippleHandler = this._upInkRippleHandler || this.upInkRippleHandler.bind(this);
        var downArguments = [
            $element,
            "dxpointerdown",
            selector,
            this._downInkRippleHandler
        ];
        var upArguments = [
            $element,
            "dxpointerup dxpointerout",
            selector,
            this._upInkRippleHandler
        ];
        $e1LMc.off.apply($e1LMc, downArguments);
        $e1LMc.on.apply($e1LMc, downArguments);
        $e1LMc.off.apply($e1LMc, upArguments);
        $e1LMc.on.apply($e1LMc, upArguments);
    },
    _createGroupRenderAction: function() {
        this._groupRenderAction = this._createActionByOption("onGroupRendered");
    },
    _clean: function() {
        clearTimeout(this._inkRippleTimer);
        if (this._$nextButton) {
            this._$nextButton.remove();
            this._$nextButton = null;
        }
        this.callBase.apply(this, arguments);
    },
    _dispose: function() {
        clearTimeout(this._holdTimer);
        clearTimeout(this._loadNextPageTimer);
        clearTimeout(this._showLoadingIndicatorTimer);
        this.callBase();
    },
    _toggleDisabledState: function(value) {
        this.callBase(value);
        this._scrollView.option("disabled", value || !this.option("scrollingEnabled"));
    },
    _toggleNextButton: function(value) {
        var dataSource = this._dataSource;
        var $nextButton = this._getNextButton();
        this.$element().toggleClass($f8c15c4fd57b6899$var$LIST_HAS_NEXT_CLASS, value);
        if (value && dataSource && dataSource.isLoaded()) $nextButton.appendTo(this._itemContainer());
        if (!value) $nextButton.detach();
    },
    _getNextButton: function() {
        if (!this._$nextButton) this._$nextButton = this._createNextButton();
        return this._$nextButton;
    },
    _createNextButton: function() {
        var $result = $jFnCG("<div>").addClass($f8c15c4fd57b6899$var$LIST_NEXT_BUTTON_CLASS);
        var $button = $jFnCG("<div>").appendTo($result);
        this._createComponent($button, $7KuSv, {
            text: this.option("nextButtonText"),
            onClick: this._nextButtonHandler.bind(this),
            type: $3LUJe.isMaterial() ? "default" : void 0,
            integrationOptions: {}
        });
        return $result;
    },
    _moveFocus: function() {
        this.callBase.apply(this, arguments);
        this.scrollToItem(this.option("focusedElement"));
    },
    _refresh: function() {
        if (!$irv64.hasWindow()) this.callBase();
        else {
            var scrollTop = this._scrollView.scrollTop();
            this.callBase();
            scrollTop && this._scrollView.scrollTo(scrollTop);
        }
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "pageLoadMode":
                this._toggleNextButton(args.value);
                this._initScrollView();
                break;
            case "dataSource":
                this.callBase(args);
                this._initScrollView();
                break;
            case "pullingDownText":
            case "pulledDownText":
            case "refreshingText":
            case "pageLoadingText":
            case "useNative":
            case "showScrollbar":
            case "bounceEnabled":
            case "scrollByContent":
            case "scrollByThumb":
            case "scrollingEnabled":
            case "pullRefreshEnabled":
                this._initScrollView();
                this._updateLoadingState();
                break;
            case "nextButtonText":
            case "onItemSwipe":
            case "useInkRipple":
                this._invalidate();
                break;
            case "onScroll":
            case "onPullRefresh":
            case "onPageLoading":
                this._createScrollViewActions();
                this._invalidate();
                break;
            case "grouped":
            case "collapsibleGroups":
            case "groupTemplate":
                this._invalidate();
                break;
            case "wrapItemText":
                this._$container.toggleClass($f8c15c4fd57b6899$var$WRAP_ITEM_TEXT_CLASS, args.value);
                break;
            case "onGroupRendered":
                this._createGroupRenderAction();
                break;
            case "width":
            case "height":
                this.callBase(args);
                this._scrollView.update();
                break;
            case "indicateLoading":
                this._hideLoadingIfLoadIndicationOff();
                break;
            case "visible":
                this.callBase(args);
                this._scrollView.update();
                break;
            case "rtlEnabled":
                this._initScrollView();
                this.callBase(args);
                break;
            case "showChevronExpr":
            case "badgeExpr":
                this._invalidate();
                break;
            case "_listAttributes":
                break;
            default:
                this.callBase(args);
        }
    },
    _extendActionArgs: function($itemElement) {
        if (!this.option("grouped")) return this.callBase($itemElement);
        var $group = $itemElement.closest("." + $f8c15c4fd57b6899$var$LIST_GROUP_CLASS);
        var $item = $group.find("." + $f8c15c4fd57b6899$var$LIST_ITEM_CLASS);
        return $f8c15c4fd57b6899$require$extend(this.callBase($itemElement), {
            itemIndex: {
                group: $group.index(),
                item: $item.index($itemElement)
            }
        });
    },
    expandGroup: function(groupIndex) {
        var deferred = new $f8c15c4fd57b6899$require$Deferred;
        var $group = this._itemContainer().find("." + $f8c15c4fd57b6899$var$LIST_GROUP_CLASS).eq(groupIndex);
        this._collapseGroupHandler($group, false).done((function() {
            deferred.resolveWith(this);
        }).bind(this));
        return deferred.promise();
    },
    collapseGroup: function(groupIndex) {
        var deferred = new $f8c15c4fd57b6899$require$Deferred;
        var $group = this._itemContainer().find("." + $f8c15c4fd57b6899$var$LIST_GROUP_CLASS).eq(groupIndex);
        this._collapseGroupHandler($group, true).done((function() {
            deferred.resolveWith(this);
        }).bind(this));
        return deferred;
    },
    updateDimensions: function() {
        var that = this;
        var deferred = new $f8c15c4fd57b6899$require$Deferred;
        if (that._scrollView) that._scrollView.update().done(function() {
            !that._scrollViewIsFull() && that._updateLoadingState(true);
            deferred.resolveWith(that);
        });
        else deferred.resolveWith(that);
        return deferred.promise();
    },
    reload: function() {
        this.callBase();
        this.scrollTo(0);
        this._pullDownHandler();
    },
    repaint: function() {
        this.scrollTo(0);
        this.callBase();
    },
    scrollTop: function() {
        return this._scrollView.scrollOffset().top;
    },
    clientHeight: function() {
        return this._scrollView.clientHeight();
    },
    scrollHeight: function() {
        return this._scrollView.scrollHeight();
    },
    scrollBy: function(distance) {
        this._scrollView.scrollBy(distance);
    },
    scrollTo: function(location) {
        this._scrollView.scrollTo(location);
    },
    scrollToItem: function(itemElement) {
        var $item = this._editStrategy.getItemElement(itemElement);
        this._scrollView.scrollToElement($item);
    }
}).include($f8c15c4fd57b6899$require$DataConverterMixin);
$f8c15c4fd57b6899$var$ListBase.ItemClass = $475ad97284863a03$exports;
$f8c15c4fd57b6899$exports = $f8c15c4fd57b6899$var$ListBase;


var $1d90122c979d47ee$var$TOOLBAR_MENU_ACTION_CLASS = "dx-toolbar-menu-action";
var $1d90122c979d47ee$var$TOOLBAR_HIDDEN_BUTTON_CLASS = "dx-toolbar-hidden-button";
var $1d90122c979d47ee$var$TOOLBAR_MENU_SECTION_CLASS = "dx-toolbar-menu-section";
var $1d90122c979d47ee$var$TOOLBAR_MENU_LAST_SECTION_CLASS = "dx-toolbar-menu-last-section";
var $1d90122c979d47ee$var$ToolbarMenu = $f8c15c4fd57b6899$exports.inherit({
    _activeStateUnit: "." + $1d90122c979d47ee$var$TOOLBAR_MENU_ACTION_CLASS,
    _initMarkup: function() {
        this._renderSections();
        this.callBase();
    },
    _getSections: function() {
        return this._itemContainer().children();
    },
    _itemElements: function() {
        return this._getSections().children(this._itemSelector());
    },
    _renderSections: function() {
        var that = this;
        var $container = this._itemContainer();
        $1d90122c979d47ee$require$each([
            "before",
            "center",
            "after",
            "menu"
        ], function() {
            var sectionName = "_$" + this + "Section";
            var $section = that[sectionName];
            if (!$section) that[sectionName] = $section = $jFnCG("<div>").addClass($1d90122c979d47ee$var$TOOLBAR_MENU_SECTION_CLASS);
            $section.appendTo($container);
        });
    },
    _renderItems: function() {
        this.callBase.apply(this, arguments);
        this._updateSections();
    },
    _updateSections: function() {
        var $sections = this.$element().find("." + $1d90122c979d47ee$var$TOOLBAR_MENU_SECTION_CLASS);
        $sections.removeClass($1d90122c979d47ee$var$TOOLBAR_MENU_LAST_SECTION_CLASS);
        $sections.not(":empty").eq(-1).addClass($1d90122c979d47ee$var$TOOLBAR_MENU_LAST_SECTION_CLASS);
    },
    _renderItem: function(index, item, itemContainer, $after) {
        var location = item.location || "menu";
        var $container = this["_$" + location + "Section"];
        var itemElement = this.callBase(index, item, $container, $after);
        if (this._getItemTemplateName({
            itemData: item
        })) itemElement.addClass("dx-toolbar-menu-custom");
        if ("menu" === location || "dxButton" === item.widget || item.isAction) itemElement.addClass($1d90122c979d47ee$var$TOOLBAR_MENU_ACTION_CLASS);
        if ("dxButton" === item.widget) itemElement.addClass($1d90122c979d47ee$var$TOOLBAR_HIDDEN_BUTTON_CLASS);
        itemElement.addClass(item.cssClass);
        return itemElement;
    },
    _getItemTemplateName: function(args) {
        var template = this.callBase(args);
        var data = args.itemData;
        var menuTemplate = data && data.menuItemTemplate;
        return menuTemplate || template;
    },
    _itemClickHandler: function(e, args, config) {
        if ($jFnCG(e.target).closest("." + $1d90122c979d47ee$var$TOOLBAR_MENU_ACTION_CLASS).length) this.callBase(e, args, config);
    },
    _clean: function() {
        this._getSections().empty();
        this.callBase();
    }
});
$4ZFRo("dxToolbarMenu", $1d90122c979d47ee$var$ToolbarMenu);
$1d90122c979d47ee$exports = $1d90122c979d47ee$var$ToolbarMenu;


var $44829b479fecc05f$exports = {};
/**
 * DevExtreme (ui/drop_down_menu.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $44829b479fecc05f$var$window = (parcelRequire("irv64")).getWindow();

var $aiwte = parcelRequire("aiwte");

var $4ZFRo = parcelRequire("4ZFRo");

var $7I8Uw = parcelRequire("7I8Uw");
var $44829b479fecc05f$require$extend = $7I8Uw.extend;

var $4gmvS = parcelRequire("4gmvS");

var $7KuSv = parcelRequire("7KuSv");


var $7e39b6ad1e6ceca3$exports = {};
/**
 * DevExtreme (ui/list.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
var $7dea806eb78546fb$exports = {};
/**
 * DevExtreme (ui/list/ui.list.edit.search.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
var $a05b4d936a1dbd20$exports = {};
/**
 * DevExtreme (ui/list/ui.list.edit.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $a05b4d936a1dbd20$var$_renderer2 = $a05b4d936a1dbd20$var$_interopRequireDefault($jFnCG);

var $bXb2w = parcelRequire("bXb2w");

var $7I8Uw = parcelRequire("7I8Uw");
var $27a1defaa5afe89c$exports = {};
/**
 * DevExtreme (ui/list/ui.list.edit.strategy.grouped.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $kDRxH = parcelRequire("kDRxH");
var $27a1defaa5afe89c$require$isNumeric = $kDRxH.isNumeric;

var $4Pwuy = parcelRequire("4Pwuy");
var $27a1defaa5afe89c$require$each = $4Pwuy.each;

var $27a1defaa5afe89c$require$queryByOptions = $04f941f354dbda7d$exports.queryByOptions;


var $27a1defaa5afe89c$var$LIST_ITEM_CLASS = "dx-list-item";
var $27a1defaa5afe89c$var$LIST_GROUP_CLASS = "dx-list-group";
var $27a1defaa5afe89c$var$SELECTION_SHIFT = 20;
var $27a1defaa5afe89c$var$SELECTION_MASK = 2303;
var $27a1defaa5afe89c$var$combineIndex = function(indices) {
    return (indices.group << $27a1defaa5afe89c$var$SELECTION_SHIFT) + indices.item;
};
var $27a1defaa5afe89c$var$splitIndex = function(combinedIndex) {
    return {
        group: combinedIndex >> $27a1defaa5afe89c$var$SELECTION_SHIFT,
        item: combinedIndex & $27a1defaa5afe89c$var$SELECTION_MASK
    };
};
var $27a1defaa5afe89c$var$GroupedEditStrategy = $b1b4a8c126ca0d50$exports.inherit({
    _groupElements: function() {
        return this._collectionWidget._itemContainer().find("." + $27a1defaa5afe89c$var$LIST_GROUP_CLASS);
    },
    _groupItemElements: function($group) {
        return $group.find("." + $27a1defaa5afe89c$var$LIST_ITEM_CLASS);
    },
    getIndexByItemData: function(itemData) {
        var groups = this._collectionWidget.option("items");
        var index = false;
        if (!itemData) return false;
        if (itemData.items && itemData.items.length) itemData = itemData.items[0];
        $27a1defaa5afe89c$require$each(groups, function(groupIndex, group) {
            if (!group.items) return false;
            $27a1defaa5afe89c$require$each(group.items, function(itemIndex, item) {
                if (item !== itemData) return true;
                index = {
                    group: groupIndex,
                    item: itemIndex
                };
                return false;
            });
            if (index) return false;
        });
        return index;
    },
    getItemDataByIndex: function(index) {
        var items = this._collectionWidget.option("items");
        if ($27a1defaa5afe89c$require$isNumeric(index)) return this.itemsGetter()[index];
        return index && items[index.group] && items[index.group].items[index.item] || null;
    },
    itemsGetter: function() {
        var resultItems = [];
        var items = this._collectionWidget.option("items");
        for(var i = 0; i < items.length; i++)if (items[i] && items[i].items) resultItems = resultItems.concat(items[i].items);
        else resultItems.push(items[i]);
        return resultItems;
    },
    deleteItemAtIndex: function(index) {
        var indices = $27a1defaa5afe89c$var$splitIndex(index);
        var itemGroup = this._collectionWidget.option("items")[indices.group].items;
        itemGroup.splice(indices.item, 1);
    },
    getKeysByItems: function(items) {
        var plainItems = [];
        for(var i = 0; i < items.length; i++)if (items[i] && items[i].items) plainItems = plainItems.concat(items[i].items);
        else plainItems.push(items[i]);
        var result = [];
        for(i = 0; i < plainItems.length; i++)result.push(this._collectionWidget.keyOf(plainItems[i]));
        return result;
    },
    getIndexByKey: function(key, items) {
        var groups = items || this._collectionWidget.option("items");
        var index = -1;
        var that = this;
        $27a1defaa5afe89c$require$each(groups, function(groupIndex, group) {
            if (!group.items) return;
            var keys = that.getKeysByItems(group.items);
            $27a1defaa5afe89c$require$each(keys, function(keyIndex, itemKey) {
                if (that._equalKeys(itemKey, key)) {
                    index = {
                        group: groupIndex,
                        item: keyIndex
                    };
                    return false;
                }
            });
            if (index !== -1) return false;
        });
        return index;
    },
    _getGroups: function(items) {
        var dataSource = this._collectionWidget.getDataSource();
        var group = dataSource && dataSource.group();
        if (group) return $27a1defaa5afe89c$require$queryByOptions($70c1405d2124b690$exports(items), {
            group: group
        }).toArray();
        return this._collectionWidget.option("items");
    },
    getItemsByKeys: function(keys, items) {
        var result = [];
        $27a1defaa5afe89c$require$each(keys, (function(_, key) {
            var getItemMeta = (function(groups) {
                var index = this.getIndexByKey(key, groups);
                var group = index && groups[index.group];
                if (!group) return;
                return {
                    groupKey: group.key,
                    item: group.items[index.item]
                };
            }).bind(this);
            var itemMeta = getItemMeta(this._getGroups(items));
            if (!itemMeta) return;
            var groupKey = itemMeta.groupKey;
            var item = itemMeta.item;
            var selectedGroup;
            $27a1defaa5afe89c$require$each(result, function(_, item) {
                if (item.key === groupKey) {
                    selectedGroup = item;
                    return false;
                }
            });
            if (!selectedGroup) {
                selectedGroup = {
                    key: groupKey,
                    items: []
                };
                result.push(selectedGroup);
            }
            selectedGroup.items.push(item);
        }).bind(this));
        return result;
    },
    moveItemAtIndexToIndex: function(movingIndex, destinationIndex) {
        var items = this._collectionWidget.option("items");
        var movingIndices = $27a1defaa5afe89c$var$splitIndex(movingIndex);
        var destinationIndices = $27a1defaa5afe89c$var$splitIndex(destinationIndex);
        var movingItemGroup = items[movingIndices.group].items;
        var destinationItemGroup = items[destinationIndices.group].items;
        var movedItemData = movingItemGroup[movingIndices.item];
        movingItemGroup.splice(movingIndices.item, 1);
        destinationItemGroup.splice(destinationIndices.item, 0, movedItemData);
    },
    _isItemIndex: function(index) {
        return index && $27a1defaa5afe89c$require$isNumeric(index.group) && $27a1defaa5afe89c$require$isNumeric(index.item);
    },
    _getNormalizedItemIndex: function(itemElement) {
        var $item = $jFnCG(itemElement);
        var $group = $item.closest("." + $27a1defaa5afe89c$var$LIST_GROUP_CLASS);
        if (!$group.length) return -1;
        return $27a1defaa5afe89c$var$combineIndex({
            group: this._groupElements().index($group),
            item: this._groupItemElements($group).index($item)
        });
    },
    _normalizeItemIndex: function(index) {
        return $27a1defaa5afe89c$var$combineIndex(index);
    },
    _denormalizeItemIndex: function(index) {
        return $27a1defaa5afe89c$var$splitIndex(index);
    },
    _getItemByNormalizedIndex: function(index) {
        var indices = $27a1defaa5afe89c$var$splitIndex(index);
        var $group = this._groupElements().eq(indices.group);
        return this._groupItemElements($group).eq(indices.item);
    },
    _itemsFromSameParent: function(firstIndex, secondIndex) {
        return $27a1defaa5afe89c$var$splitIndex(firstIndex).group === $27a1defaa5afe89c$var$splitIndex(secondIndex).group;
    }
});
$27a1defaa5afe89c$exports = $27a1defaa5afe89c$var$GroupedEditStrategy;


var $a05b4d936a1dbd20$var$_uiListEditStrategy2 = $a05b4d936a1dbd20$var$_interopRequireDefault($27a1defaa5afe89c$exports);

var $cnVbh = parcelRequire("cnVbh");
var $dc18b7fa1613351a$exports = {};
/**
 * DevExtreme (ui/list/ui.list.edit.provider.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $2Mto0 = parcelRequire("2Mto0");
var $dc18b7fa1613351a$require$noop = $2Mto0.noop;

var $k7aJb = parcelRequire("k7aJb");

var $7I8Uw = parcelRequire("7I8Uw");
var $dc18b7fa1613351a$require$extend = $7I8Uw.extend;

var $4Pwuy = parcelRequire("4Pwuy");
var $dc18b7fa1613351a$require$each = $4Pwuy.each;

var $lrsNa = parcelRequire("lrsNa");
/**
 * DevExtreme (ui/list/ui.list.edit.decorator_registry.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ var $3dd45f8e64379297$export$4bb7493d241fd8a5;
var $3dd45f8e64379297$export$6503ec6e8aabbaf;
"use strict";

var $7I8Uw = parcelRequire("7I8Uw");
var $3dd45f8e64379297$require$extend = $7I8Uw.extend;
$3dd45f8e64379297$export$4bb7493d241fd8a5 = {};
$3dd45f8e64379297$export$6503ec6e8aabbaf = function(option, type, decoratorClass) {
    var decoratorsRegistry = $3dd45f8e64379297$export$4bb7493d241fd8a5;
    var decoratorConfig = {};
    decoratorConfig[option] = decoratorsRegistry[option] ? decoratorsRegistry[option] : {};
    decoratorConfig[option][type] = decoratorClass;
    decoratorsRegistry = $3dd45f8e64379297$require$extend(decoratorsRegistry, decoratorConfig);
};


/**
 * DevExtreme (ui/list/ui.list.edit.decorator.static.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $7KuSv = parcelRequire("7KuSv");

var $1ff715ca106221b7$require$registerDecorator = $3dd45f8e64379297$export$6503ec6e8aabbaf;
var $df89cd8a75819f4e$exports = {};
/**
 * DevExtreme (ui/list/ui.list.edit.decorator.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $e1LMc = parcelRequire("e1LMc");

var $2Mto0 = parcelRequire("2Mto0");
var $df89cd8a75819f4e$require$noop = $2Mto0.noop;

var $k7aJb = parcelRequire("k7aJb");

var $l8ZSv = parcelRequire("l8ZSv");

var $bXb2w = parcelRequire("bXb2w");
var $df89cd8a75819f4e$var$LIST_EDIT_DECORATOR = "dxListEditDecorator";
var $df89cd8a75819f4e$var$SWIPE_START_EVENT_NAME = $bXb2w.addNamespace($l8ZSv.start, $df89cd8a75819f4e$var$LIST_EDIT_DECORATOR);
var $df89cd8a75819f4e$var$SWIPE_UPDATE_EVENT_NAME = $bXb2w.addNamespace($l8ZSv.swipe, $df89cd8a75819f4e$var$LIST_EDIT_DECORATOR);
var $df89cd8a75819f4e$var$SWIPE_END_EVENT_NAME = $bXb2w.addNamespace($l8ZSv.end, $df89cd8a75819f4e$var$LIST_EDIT_DECORATOR);
var $df89cd8a75819f4e$var$EditDecorator = $k7aJb.inherit({
    ctor: function(list) {
        this._list = list;
        this._init();
    },
    _init: $df89cd8a75819f4e$require$noop,
    _shouldHandleSwipe: false,
    _attachSwipeEvent: function(config) {
        var swipeConfig = {
            itemSizeFunc: (function() {
                if (this._clearSwipeCache) {
                    this._itemWidthCache = this._list.$element().width();
                    this._clearSwipeCache = false;
                }
                return this._itemWidthCache;
            }).bind(this)
        };
        $e1LMc.on(config.$itemElement, $df89cd8a75819f4e$var$SWIPE_START_EVENT_NAME, swipeConfig, this._itemSwipeStartHandler.bind(this));
        $e1LMc.on(config.$itemElement, $df89cd8a75819f4e$var$SWIPE_UPDATE_EVENT_NAME, this._itemSwipeUpdateHandler.bind(this));
        $e1LMc.on(config.$itemElement, $df89cd8a75819f4e$var$SWIPE_END_EVENT_NAME, this._itemSwipeEndHandler.bind(this));
    },
    _itemSwipeStartHandler: function(e) {
        var $itemElement = $jFnCG(e.currentTarget);
        if ($itemElement.is(".dx-state-disabled, .dx-state-disabled *")) {
            e.cancel = true;
            return;
        }
        clearTimeout(this._list._inkRippleTimer);
        this._swipeStartHandler($itemElement, e);
    },
    _itemSwipeUpdateHandler: function(e) {
        var $itemElement = $jFnCG(e.currentTarget);
        this._swipeUpdateHandler($itemElement, e);
    },
    _itemSwipeEndHandler: function(e) {
        var $itemElement = $jFnCG(e.currentTarget);
        this._swipeEndHandler($itemElement, e);
        this._clearSwipeCache = true;
    },
    beforeBag: $df89cd8a75819f4e$require$noop,
    afterBag: $df89cd8a75819f4e$require$noop,
    _commonOptions: function() {
        return {
            activeStateEnabled: this._list.option("activeStateEnabled"),
            hoverStateEnabled: this._list.option("hoverStateEnabled"),
            focusStateEnabled: this._list.option("focusStateEnabled")
        };
    },
    modifyElement: function(config) {
        if (this._shouldHandleSwipe) {
            this._attachSwipeEvent(config);
            this._clearSwipeCache = true;
        }
    },
    afterRender: $df89cd8a75819f4e$require$noop,
    handleClick: $df89cd8a75819f4e$require$noop,
    handleKeyboardEvents: $df89cd8a75819f4e$require$noop,
    handleEnterPressing: $df89cd8a75819f4e$require$noop,
    handleContextMenu: $df89cd8a75819f4e$require$noop,
    _swipeStartHandler: $df89cd8a75819f4e$require$noop,
    _swipeUpdateHandler: $df89cd8a75819f4e$require$noop,
    _swipeEndHandler: $df89cd8a75819f4e$require$noop,
    visibilityChange: $df89cd8a75819f4e$require$noop,
    getExcludedSelectors: $df89cd8a75819f4e$require$noop,
    dispose: $df89cd8a75819f4e$require$noop
});
$df89cd8a75819f4e$exports = $df89cd8a75819f4e$var$EditDecorator;


var $1ff715ca106221b7$var$STATIC_DELETE_BUTTON_CONTAINER_CLASS = "dx-list-static-delete-button-container";
var $1ff715ca106221b7$var$STATIC_DELETE_BUTTON_CLASS = "dx-list-static-delete-button";
$1ff715ca106221b7$require$registerDecorator("delete", "static", $df89cd8a75819f4e$exports.inherit({
    afterBag: function(config) {
        var $itemElement = config.$itemElement;
        var $container = config.$container;
        var $button = $jFnCG("<div>").addClass($1ff715ca106221b7$var$STATIC_DELETE_BUTTON_CLASS);
        this._list._createComponent($button, $7KuSv, {
            icon: "remove",
            onClick: (function(args) {
                args.event.stopPropagation();
                this._deleteItem($itemElement);
            }).bind(this),
            integrationOptions: {}
        });
        $container.addClass($1ff715ca106221b7$var$STATIC_DELETE_BUTTON_CONTAINER_CLASS).append($button);
    },
    _deleteItem: function($itemElement) {
        if ($itemElement.is(".dx-state-disabled, .dx-state-disabled *")) return;
        this._list.deleteItem($itemElement);
    }
}));


var $15e4dbea94be2e8b$exports = {};
/**
 * DevExtreme (ui/list/ui.list.edit.decorator.switchable.button.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $c7ml4 = parcelRequire("c7ml4");

var $7KuSv = parcelRequire("7KuSv");

var $cnVbh = parcelRequire("cnVbh");

var $15e4dbea94be2e8b$require$registerDecorator = $3dd45f8e64379297$export$6503ec6e8aabbaf;
var $b8ea8b28ba8ff899$exports = {};
/**
 * DevExtreme (ui/list/ui.list.edit.decorator.switchable.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $e1LMc = parcelRequire("e1LMc");

var $2Mto0 = parcelRequire("2Mto0");
var $b8ea8b28ba8ff899$require$noop = $2Mto0.noop;

var $b8ea8b28ba8ff899$var$abstract = $df89cd8a75819f4e$exports.abstract;

var $bXb2w = parcelRequire("bXb2w");

var $gP4Gh = parcelRequire("gP4Gh");

var $cNbaE = parcelRequire("cNbaE");
var $b8ea8b28ba8ff899$var$LIST_EDIT_DECORATOR = "dxListEditDecorator";
var $b8ea8b28ba8ff899$var$POINTER_DOWN_EVENT_NAME = $bXb2w.addNamespace($gP4Gh.down, $b8ea8b28ba8ff899$var$LIST_EDIT_DECORATOR);
var $b8ea8b28ba8ff899$var$ACTIVE_EVENT_NAME = $bXb2w.addNamespace($cNbaE.active, $b8ea8b28ba8ff899$var$LIST_EDIT_DECORATOR);
var $b8ea8b28ba8ff899$var$LIST_ITEM_CONTENT_CLASS = "dx-list-item-content";
var $b8ea8b28ba8ff899$var$SWITCHABLE_DELETE_READY_CLASS = "dx-list-switchable-delete-ready";
var $b8ea8b28ba8ff899$var$SWITCHABLE_MENU_SHIELD_POSITIONING_CLASS = "dx-list-switchable-menu-shield-positioning";
var $b8ea8b28ba8ff899$var$SWITCHABLE_DELETE_TOP_SHIELD_CLASS = "dx-list-switchable-delete-top-shield";
var $b8ea8b28ba8ff899$var$SWITCHABLE_DELETE_BOTTOM_SHIELD_CLASS = "dx-list-switchable-delete-bottom-shield";
var $b8ea8b28ba8ff899$var$SWITCHABLE_MENU_ITEM_SHIELD_POSITIONING_CLASS = "dx-list-switchable-menu-item-shield-positioning";
var $b8ea8b28ba8ff899$var$SWITCHABLE_DELETE_ITEM_CONTENT_SHIELD_CLASS = "dx-list-switchable-delete-item-content-shield";
var $b8ea8b28ba8ff899$var$SWITCHABLE_DELETE_BUTTON_CONTAINER_CLASS = "dx-list-switchable-delete-button-container";
var $b8ea8b28ba8ff899$var$SwitchableEditDecorator = $df89cd8a75819f4e$exports.inherit({
    _init: function() {
        this._$topShield = $jFnCG("<div>").addClass($b8ea8b28ba8ff899$var$SWITCHABLE_DELETE_TOP_SHIELD_CLASS);
        this._$bottomShield = $jFnCG("<div>").addClass($b8ea8b28ba8ff899$var$SWITCHABLE_DELETE_BOTTOM_SHIELD_CLASS);
        this._$itemContentShield = $jFnCG("<div>").addClass($b8ea8b28ba8ff899$var$SWITCHABLE_DELETE_ITEM_CONTENT_SHIELD_CLASS);
        $e1LMc.on(this._$topShield, $b8ea8b28ba8ff899$var$POINTER_DOWN_EVENT_NAME, this._cancelDeleteReadyItem.bind(this));
        $e1LMc.on(this._$bottomShield, $b8ea8b28ba8ff899$var$POINTER_DOWN_EVENT_NAME, this._cancelDeleteReadyItem.bind(this));
        this._list.$element().append(this._$topShield.toggle(false)).append(this._$bottomShield.toggle(false));
    },
    handleClick: function() {
        return this._cancelDeleteReadyItem();
    },
    _cancelDeleteReadyItem: function() {
        if (!this._$readyToDeleteItem) return false;
        this._cancelDelete(this._$readyToDeleteItem);
        return true;
    },
    _cancelDelete: function($itemElement) {
        this._toggleDeleteReady($itemElement, false);
    },
    _toggleDeleteReady: function($itemElement, readyToDelete) {
        if (void 0 === readyToDelete) readyToDelete = !this._isReadyToDelete($itemElement);
        this._toggleShields($itemElement, readyToDelete);
        this._toggleScrolling(readyToDelete);
        this._cacheReadyToDeleteItem($itemElement, readyToDelete);
        this._animateToggleDelete($itemElement, readyToDelete);
    },
    _isReadyToDelete: function($itemElement) {
        return $itemElement.hasClass($b8ea8b28ba8ff899$var$SWITCHABLE_DELETE_READY_CLASS);
    },
    _toggleShields: function($itemElement, enabled) {
        this._list.$element().toggleClass($b8ea8b28ba8ff899$var$SWITCHABLE_MENU_SHIELD_POSITIONING_CLASS, enabled);
        this._$topShield.toggle(enabled);
        this._$bottomShield.toggle(enabled);
        if (enabled) this._updateShieldsHeight($itemElement);
        this._toggleContentShield($itemElement, enabled);
    },
    _updateShieldsHeight: function($itemElement) {
        var $list = this._list.$element();
        var listTopOffset = $list.offset().top;
        var listHeight = $list.outerHeight();
        var itemTopOffset = $itemElement.offset().top;
        var itemHeight = $itemElement.outerHeight();
        var dirtyTopShieldHeight = itemTopOffset - listTopOffset;
        var dirtyBottomShieldHeight = listHeight - itemHeight - dirtyTopShieldHeight;
        this._$topShield.height(Math.max(dirtyTopShieldHeight, 0));
        this._$bottomShield.height(Math.max(dirtyBottomShieldHeight, 0));
    },
    _toggleContentShield: function($itemElement, enabled) {
        if (enabled) $itemElement.find("." + $b8ea8b28ba8ff899$var$LIST_ITEM_CONTENT_CLASS).first().append(this._$itemContentShield);
        else this._$itemContentShield.detach();
    },
    _toggleScrolling: function(readyToDelete) {
        var scrollView = this._list.$element().dxScrollView("instance");
        if (readyToDelete) scrollView.on("start", this._cancelScrolling);
        else scrollView.off("start", this._cancelScrolling);
    },
    _cancelScrolling: function(args) {
        args.event.cancel = true;
    },
    _cacheReadyToDeleteItem: function($itemElement, cache) {
        if (cache) this._$readyToDeleteItem = $itemElement;
        else delete this._$readyToDeleteItem;
    },
    _animateToggleDelete: function($itemElement, readyToDelete) {
        if (readyToDelete) {
            this._enablePositioning($itemElement);
            this._prepareDeleteReady($itemElement);
            this._animatePrepareDeleteReady($itemElement);
            $e1LMc.off($itemElement, $gP4Gh.up);
        } else {
            this._forgetDeleteReady($itemElement);
            this._animateForgetDeleteReady($itemElement).done(this._disablePositioning.bind(this, $itemElement));
        }
    },
    _enablePositioning: function($itemElement) {
        $itemElement.addClass($b8ea8b28ba8ff899$var$SWITCHABLE_MENU_ITEM_SHIELD_POSITIONING_CLASS);
        $e1LMc.on($itemElement, $b8ea8b28ba8ff899$var$ACTIVE_EVENT_NAME, $b8ea8b28ba8ff899$require$noop);
        $e1LMc.one($itemElement, $gP4Gh.up, this._disablePositioning.bind(this, $itemElement));
    },
    _disablePositioning: function($itemElement) {
        $itemElement.removeClass($b8ea8b28ba8ff899$var$SWITCHABLE_MENU_ITEM_SHIELD_POSITIONING_CLASS);
        $e1LMc.off($itemElement, $b8ea8b28ba8ff899$var$ACTIVE_EVENT_NAME);
    },
    _prepareDeleteReady: function($itemElement) {
        $itemElement.addClass($b8ea8b28ba8ff899$var$SWITCHABLE_DELETE_READY_CLASS);
    },
    _forgetDeleteReady: function($itemElement) {
        $itemElement.removeClass($b8ea8b28ba8ff899$var$SWITCHABLE_DELETE_READY_CLASS);
    },
    _animatePrepareDeleteReady: $b8ea8b28ba8ff899$var$abstract,
    _animateForgetDeleteReady: $b8ea8b28ba8ff899$var$abstract,
    _getDeleteButtonContainer: function($itemElement) {
        $itemElement = $itemElement || this._$readyToDeleteItem;
        return $itemElement.children("." + $b8ea8b28ba8ff899$var$SWITCHABLE_DELETE_BUTTON_CONTAINER_CLASS);
    },
    _deleteItem: function($itemElement) {
        $itemElement = $itemElement || this._$readyToDeleteItem;
        this._getDeleteButtonContainer($itemElement).detach();
        if ($itemElement.is(".dx-state-disabled, .dx-state-disabled *")) return;
        this._list.deleteItem($itemElement).always(this._cancelDelete.bind(this, $itemElement));
    },
    _isRtlEnabled: function() {
        return this._list.option("rtlEnabled");
    },
    dispose: function() {
        if (this._$topShield) this._$topShield.remove();
        if (this._$bottomShield) this._$bottomShield.remove();
        this.callBase.apply(this, arguments);
    }
});
$b8ea8b28ba8ff899$exports = $b8ea8b28ba8ff899$var$SwitchableEditDecorator;


var $15e4dbea94be2e8b$var$SWITCHABLE_DELETE_BUTTON_CONTAINER_CLASS = "dx-list-switchable-delete-button-container";
var $15e4dbea94be2e8b$var$SWITCHABLE_DELETE_BUTTON_WRAPPER_CLASS = "dx-list-switchable-delete-button-wrapper";
var $15e4dbea94be2e8b$var$SWITCHABLE_DELETE_BUTTON_INNER_WRAPPER_CLASS = "dx-list-switchable-delete-button-inner-wrapper";
var $15e4dbea94be2e8b$var$SWITCHABLE_DELETE_BUTTON_CLASS = "dx-list-switchable-delete-button";
var $15e4dbea94be2e8b$var$SWITCHABLE_DELETE_BUTTON_ANIMATION_DURATION = 200;
var $15e4dbea94be2e8b$var$SwitchableButtonEditDecorator = $b8ea8b28ba8ff899$exports.inherit({
    _init: function() {
        this.callBase.apply(this, arguments);
        var $buttonContainer = $jFnCG("<div>").addClass($15e4dbea94be2e8b$var$SWITCHABLE_DELETE_BUTTON_CONTAINER_CLASS);
        var $buttonWrapper = $jFnCG("<div>").addClass($15e4dbea94be2e8b$var$SWITCHABLE_DELETE_BUTTON_WRAPPER_CLASS);
        var $buttonInnerWrapper = $jFnCG("<div>").addClass($15e4dbea94be2e8b$var$SWITCHABLE_DELETE_BUTTON_INNER_WRAPPER_CLASS);
        var $button = $jFnCG("<div>").addClass($15e4dbea94be2e8b$var$SWITCHABLE_DELETE_BUTTON_CLASS);
        this._list._createComponent($button, $7KuSv, {
            text: $cnVbh.format("dxListEditDecorator-delete"),
            type: "danger",
            onClick: (function(e) {
                this._deleteItem();
                e.event.stopPropagation();
            }).bind(this),
            integrationOptions: {}
        });
        $buttonContainer.append($buttonWrapper);
        $buttonWrapper.append($buttonInnerWrapper);
        $buttonInnerWrapper.append($button);
        this._$buttonContainer = $buttonContainer;
    },
    _enablePositioning: function($itemElement) {
        this.callBase.apply(this, arguments);
        $c7ml4.stop(this._$buttonContainer, true);
        this._$buttonContainer.appendTo($itemElement);
    },
    _disablePositioning: function() {
        this.callBase.apply(this, arguments);
        this._$buttonContainer.detach();
    },
    _animatePrepareDeleteReady: function() {
        var rtl = this._isRtlEnabled();
        var listWidth = this._list.$element().width();
        var buttonWidth = this._buttonWidth();
        var fromValue = rtl ? listWidth : -buttonWidth;
        var toValue = rtl ? listWidth - buttonWidth : 0;
        return $c7ml4.animate(this._$buttonContainer, {
            type: "custom",
            duration: $15e4dbea94be2e8b$var$SWITCHABLE_DELETE_BUTTON_ANIMATION_DURATION,
            from: {
                right: fromValue
            },
            to: {
                right: toValue
            }
        });
    },
    _animateForgetDeleteReady: function() {
        var rtl = this._isRtlEnabled();
        var listWidth = this._list.$element().width();
        var buttonWidth = this._buttonWidth();
        var fromValue = rtl ? listWidth - buttonWidth : 0;
        var toValue = rtl ? listWidth : -buttonWidth;
        return $c7ml4.animate(this._$buttonContainer, {
            type: "custom",
            duration: $15e4dbea94be2e8b$var$SWITCHABLE_DELETE_BUTTON_ANIMATION_DURATION,
            from: {
                right: fromValue
            },
            to: {
                right: toValue
            }
        });
    },
    _buttonWidth: function() {
        if (!this._buttonContainerWidth) this._buttonContainerWidth = this._$buttonContainer.outerWidth();
        return this._buttonContainerWidth;
    },
    dispose: function() {
        if (this._$buttonContainer) this._$buttonContainer.remove();
        this.callBase.apply(this, arguments);
    }
});
var $15e4dbea94be2e8b$var$TOGGLE_DELETE_SWITCH_CONTAINER_CLASS = "dx-list-toggle-delete-switch-container";
var $15e4dbea94be2e8b$var$TOGGLE_DELETE_SWITCH_CLASS = "dx-list-toggle-delete-switch";
$15e4dbea94be2e8b$require$registerDecorator("delete", "toggle", $15e4dbea94be2e8b$var$SwitchableButtonEditDecorator.inherit({
    beforeBag: function(config) {
        var $itemElement = config.$itemElement;
        var $container = config.$container;
        var $toggle = $jFnCG("<div>").addClass($15e4dbea94be2e8b$var$TOGGLE_DELETE_SWITCH_CLASS);
        this._list._createComponent($toggle, $7KuSv, {
            icon: "toggle-delete",
            onClick: (function(e) {
                $c7ml4.stop(this._$buttonContainer, false);
                this._toggleDeleteReady($itemElement);
                e.event.stopPropagation();
            }).bind(this),
            integrationOptions: {}
        });
        $container.addClass($15e4dbea94be2e8b$var$TOGGLE_DELETE_SWITCH_CONTAINER_CLASS);
        $container.append($toggle);
    }
}));
$15e4dbea94be2e8b$require$registerDecorator("delete", "slideButton", $15e4dbea94be2e8b$var$SwitchableButtonEditDecorator.inherit({
    _shouldHandleSwipe: true,
    _swipeEndHandler: function($itemElement, args) {
        if (0 !== args.targetOffset) {
            $c7ml4.stop(this._$buttonContainer, false);
            this._toggleDeleteReady($itemElement);
        }
        return true;
    }
}));
$15e4dbea94be2e8b$exports = $15e4dbea94be2e8b$var$SwitchableButtonEditDecorator;


/**
 * DevExtreme (ui/list/ui.list.edit.decorator.switchable.slide.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $e1LMc = parcelRequire("e1LMc");

var $2Mto0 = parcelRequire("2Mto0");
var $2cc7d45a3e318703$require$noop = $2Mto0.noop;

var $i7ZSP = parcelRequire("i7ZSP");

var $cnVbh = parcelRequire("cnVbh");

var $6jr65 = parcelRequire("6jr65");

var $bXb2w = parcelRequire("bXb2w");

var $cNbaE = parcelRequire("cNbaE");
var $4595a685472f9541$exports = {};
/**
 * DevExtreme (ui/list/ui.list.edit.decorator_menu_helper.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
var $4595a685472f9541$var$EditDecoratorMenuHelperMixin = {
    _menuEnabled: function() {
        return !!this._menuItems().length;
    },
    _menuItems: function() {
        return this._list.option("menuItems");
    },
    _deleteEnabled: function() {
        return this._list.option("allowItemDeleting");
    },
    _fireMenuAction: function($itemElement, action) {
        this._list._itemEventHandlerByHandler($itemElement, action, {}, {
            excludeValidators: [
                "disabled",
                "readOnly"
            ]
        });
    }
};
$4595a685472f9541$exports = $4595a685472f9541$var$EditDecoratorMenuHelperMixin;



var $2cc7d45a3e318703$require$registerDecorator = $3dd45f8e64379297$export$6503ec6e8aabbaf;


var $c7ml4 = parcelRequire("c7ml4");

var $3LUJe = parcelRequire("3LUJe");

var $2cc7d45a3e318703$var$LIST_EDIT_DECORATOR = "dxListEditDecorator";
var $2cc7d45a3e318703$var$CLICK_EVENT_NAME = $bXb2w.addNamespace($i7ZSP.name, $2cc7d45a3e318703$var$LIST_EDIT_DECORATOR);
var $2cc7d45a3e318703$var$ACTIVE_EVENT_NAME = $bXb2w.addNamespace($cNbaE.active, $2cc7d45a3e318703$var$LIST_EDIT_DECORATOR);
var $2cc7d45a3e318703$var$SLIDE_MENU_CLASS = "dx-list-slide-menu";
var $2cc7d45a3e318703$var$SLIDE_MENU_WRAPPER_CLASS = "dx-list-slide-menu-wrapper";
var $2cc7d45a3e318703$var$SLIDE_MENU_CONTENT_CLASS = "dx-list-slide-menu-content";
var $2cc7d45a3e318703$var$SLIDE_MENU_BUTTONS_CONTAINER_CLASS = "dx-list-slide-menu-buttons-container";
var $2cc7d45a3e318703$var$SLIDE_MENU_BUTTONS_CLASS = "dx-list-slide-menu-buttons";
var $2cc7d45a3e318703$var$SLIDE_MENU_BUTTON_CLASS = "dx-list-slide-menu-button";
var $2cc7d45a3e318703$var$SLIDE_MENU_BUTTON_MENU_CLASS = "dx-list-slide-menu-button-menu";
var $2cc7d45a3e318703$var$SLIDE_MENU_BUTTON_DELETE_CLASS = "dx-list-slide-menu-button-delete";
var $2cc7d45a3e318703$var$SLIDE_MENU_ANIMATION_DURATION = 400;
var $2cc7d45a3e318703$var$SLIDE_MENU_ANIMATION_EASING = "cubic-bezier(0.075, 0.82, 0.165, 1)";
$2cc7d45a3e318703$require$registerDecorator("menu", "slide", $b8ea8b28ba8ff899$exports.inherit({
    _shouldHandleSwipe: true,
    _init: function() {
        this.callBase.apply(this, arguments);
        this._$buttonsContainer = $jFnCG("<div>").addClass($2cc7d45a3e318703$var$SLIDE_MENU_BUTTONS_CONTAINER_CLASS);
        $e1LMc.on(this._$buttonsContainer, $2cc7d45a3e318703$var$ACTIVE_EVENT_NAME, $2cc7d45a3e318703$require$noop);
        this._$buttons = $jFnCG("<div>").addClass($2cc7d45a3e318703$var$SLIDE_MENU_BUTTONS_CLASS).appendTo(this._$buttonsContainer);
        this._renderMenu();
        this._renderDeleteButton();
    },
    _renderMenu: function() {
        if (!this._menuEnabled()) return;
        var menuItems = this._menuItems();
        if (1 === menuItems.length) {
            var menuItem = menuItems[0];
            this._renderMenuButton(menuItem.text, (function(e) {
                e.stopPropagation();
                this._fireAction(menuItem);
            }).bind(this));
        } else {
            var $menu = $jFnCG("<div>").addClass($2cc7d45a3e318703$var$SLIDE_MENU_CLASS);
            this._menu = this._list._createComponent($menu, $74fa45cb65203b59$exports, {
                showTitle: false,
                items: menuItems,
                onItemClick: (function(args) {
                    this._fireAction(args.itemData);
                }).bind(this),
                integrationOptions: {}
            });
            $menu.appendTo(this._list.$element());
            var $menuButton = this._renderMenuButton($cnVbh.format("dxListEditDecorator-more"), (function(e) {
                e.stopPropagation();
                this._menu.show();
            }).bind(this));
            this._menu.option("target", $menuButton);
        }
    },
    _renderMenuButton: function(text, action) {
        var $menuButton = $jFnCG("<div>").addClass($2cc7d45a3e318703$var$SLIDE_MENU_BUTTON_CLASS).addClass($2cc7d45a3e318703$var$SLIDE_MENU_BUTTON_MENU_CLASS).text(text);
        this._$buttons.append($menuButton);
        $e1LMc.on($menuButton, $2cc7d45a3e318703$var$CLICK_EVENT_NAME, action);
        return $menuButton;
    },
    _renderDeleteButton: function() {
        if (!this._deleteEnabled()) return;
        var $deleteButton = $jFnCG("<div>").addClass($2cc7d45a3e318703$var$SLIDE_MENU_BUTTON_CLASS).addClass($2cc7d45a3e318703$var$SLIDE_MENU_BUTTON_DELETE_CLASS).text($3LUJe.isMaterial() ? "" : $cnVbh.format("dxListEditDecorator-delete"));
        $e1LMc.on($deleteButton, $2cc7d45a3e318703$var$CLICK_EVENT_NAME, (function(e) {
            e.stopPropagation();
            this._deleteItem();
        }).bind(this));
        this._$buttons.append($deleteButton);
    },
    _fireAction: function(menuItem) {
        this._fireMenuAction($jFnCG(this._cachedNode), menuItem.action);
        this._cancelDeleteReadyItem();
    },
    modifyElement: function(config) {
        this.callBase.apply(this, arguments);
        var $itemElement = config.$itemElement;
        $itemElement.addClass($2cc7d45a3e318703$var$SLIDE_MENU_WRAPPER_CLASS);
        var $slideMenuContent = $jFnCG("<div>").addClass($2cc7d45a3e318703$var$SLIDE_MENU_CONTENT_CLASS);
        $itemElement.wrapInner($slideMenuContent);
    },
    _getDeleteButtonContainer: function() {
        return this._$buttonsContainer;
    },
    handleClick: function(_, e) {
        if ($jFnCG(e.target).closest("." + $2cc7d45a3e318703$var$SLIDE_MENU_CONTENT_CLASS).length) return this.callBase.apply(this, arguments);
        return false;
    },
    _swipeStartHandler: function($itemElement) {
        this._enablePositioning($itemElement);
        this._cacheItemData($itemElement);
        this._setPositions(this._getPositions(0));
    },
    _swipeUpdateHandler: function($itemElement, args) {
        var rtl = this._isRtlEnabled();
        var signCorrection = rtl ? -1 : 1;
        var isItemReadyToDelete = this._isReadyToDelete($itemElement);
        var moveJustStarted = this._getCurrentPositions().content === this._getStartPositions().content;
        if (moveJustStarted && !isItemReadyToDelete && args.offset * signCorrection > 0) {
            args.cancel = true;
            return;
        }
        var offset = this._cachedItemWidth * args.offset;
        var startOffset = isItemReadyToDelete ? -this._cachedButtonWidth * signCorrection : 0;
        var correctedOffset = (offset + startOffset) * signCorrection;
        var percent = correctedOffset < 0 ? Math.abs((offset + startOffset) / this._cachedButtonWidth) : 0;
        this._setPositions(this._getPositions(percent));
        return true;
    },
    _getStartPositions: function() {
        var rtl = this._isRtlEnabled();
        var signCorrection = rtl ? -1 : 1;
        return {
            content: 0,
            buttonsContainer: rtl ? -this._cachedButtonWidth : this._cachedItemWidth,
            buttons: -this._cachedButtonWidth * signCorrection
        };
    },
    _getPositions: function(percent) {
        var rtl = this._isRtlEnabled();
        var signCorrection = rtl ? -1 : 1;
        var startPositions = this._getStartPositions();
        return {
            content: startPositions.content - percent * this._cachedButtonWidth * signCorrection,
            buttonsContainer: startPositions.buttonsContainer - Math.min(percent, 1) * this._cachedButtonWidth * signCorrection,
            buttons: startPositions.buttons + Math.min(percent, 1) * this._cachedButtonWidth * signCorrection
        };
    },
    _getCurrentPositions: function() {
        return {
            content: $6jr65.locate(this._$cachedContent).left,
            buttonsContainer: $6jr65.locate(this._$buttonsContainer).left,
            buttons: $6jr65.locate(this._$buttons).left
        };
    },
    _setPositions: function(positions) {
        $6jr65.move(this._$cachedContent, {
            left: positions.content
        });
        $6jr65.move(this._$buttonsContainer, {
            left: positions.buttonsContainer
        });
        $6jr65.move(this._$buttons, {
            left: positions.buttons
        });
    },
    _cacheItemData: function($itemElement) {
        if ($itemElement[0] === this._cachedNode) return;
        this._$cachedContent = $itemElement.find("." + $2cc7d45a3e318703$var$SLIDE_MENU_CONTENT_CLASS);
        this._cachedItemWidth = $itemElement.outerWidth();
        this._cachedButtonWidth = this._cachedButtonWidth || this._$buttons.outerWidth();
        this._$buttonsContainer.width(this._cachedButtonWidth);
        if (this._$cachedContent.length) this._cachedNode = $itemElement[0];
    },
    _minButtonContainerLeftOffset: function() {
        return this._cachedItemWidth - this._cachedButtonWidth;
    },
    _swipeEndHandler: function($itemElement, args) {
        this._cacheItemData($itemElement);
        var signCorrection = this._isRtlEnabled() ? 1 : -1;
        var offset = this._cachedItemWidth * args.offset;
        var endedAtReadyToDelete = !this._isReadyToDelete($itemElement) && offset * signCorrection > .2 * this._cachedButtonWidth;
        var readyToDelete = args.targetOffset === signCorrection && endedAtReadyToDelete;
        this._toggleDeleteReady($itemElement, readyToDelete);
        return true;
    },
    _enablePositioning: function($itemElement) {
        $c7ml4.stop(this._$cachedContent, true);
        this.callBase.apply(this, arguments);
        this._$buttonsContainer.appendTo($itemElement);
    },
    _disablePositioning: function() {
        this.callBase.apply(this, arguments);
        this._$buttonsContainer.detach();
    },
    _animatePrepareDeleteReady: function() {
        return this._animateToPositions(this._getPositions(1));
    },
    _animateForgetDeleteReady: function($itemElement) {
        this._cacheItemData($itemElement);
        return this._animateToPositions(this._getPositions(0));
    },
    _animateToPositions: function(positions) {
        var that = this;
        var currentPosition = this._getCurrentPositions();
        var durationTimePart = Math.min(Math.abs(currentPosition.content - positions.content) / this._cachedButtonWidth, 1);
        return $c7ml4.animate(this._$cachedContent, {
            from: currentPosition,
            to: positions,
            easing: $2cc7d45a3e318703$var$SLIDE_MENU_ANIMATION_EASING,
            duration: $2cc7d45a3e318703$var$SLIDE_MENU_ANIMATION_DURATION * durationTimePart,
            strategy: "frame",
            draw: function(positions) {
                that._setPositions(positions);
            }
        });
    },
    dispose: function() {
        if (this._menu) this._menu.$element().remove();
        if (this._$buttonsContainer) this._$buttonsContainer.remove();
        this.callBase.apply(this, arguments);
    }
}).include($4595a685472f9541$exports));


/**
 * DevExtreme (ui/list/ui.list.edit.decorator.swipe.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $6jr65 = parcelRequire("6jr65");

var $c7ml4 = parcelRequire("c7ml4");

var $05ec317244df482e$require$registerDecorator = $3dd45f8e64379297$export$6503ec6e8aabbaf;


var $2F60d = parcelRequire("2F60d");
var $05ec317244df482e$require$Deferred = $2F60d.Deferred;
$05ec317244df482e$require$registerDecorator("delete", "swipe", $df89cd8a75819f4e$exports.inherit({
    _shouldHandleSwipe: true,
    _renderItemPosition: function($itemElement, offset, animate) {
        var deferred = new $05ec317244df482e$require$Deferred;
        var itemOffset = offset * this._itemElementWidth;
        if (animate) $c7ml4.animate($itemElement, {
            to: {
                left: itemOffset
            },
            type: "slide",
            complete: function() {
                deferred.resolve($itemElement, offset);
            }
        });
        else {
            $6jr65.move($itemElement, {
                left: itemOffset
            });
            deferred.resolve();
        }
        return deferred.promise();
    },
    _swipeStartHandler: function($itemElement) {
        this._itemElementWidth = $itemElement.width();
        return true;
    },
    _swipeUpdateHandler: function($itemElement, args) {
        this._renderItemPosition($itemElement, args.offset);
        return true;
    },
    _swipeEndHandler: function($itemElement, args) {
        var offset = args.targetOffset;
        this._renderItemPosition($itemElement, offset, true).done((function($itemElement, offset) {
            if (Math.abs(offset)) this._list.deleteItem($itemElement).fail((function() {
                this._renderItemPosition($itemElement, 0, true);
            }).bind(this));
        }).bind(this));
        return true;
    }
}));


/**
 * DevExtreme (ui/list/ui.list.edit.decorator.context.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");


var $cnVbh = parcelRequire("cnVbh");

var $956812fe3091e0da$require$registerDecorator = $3dd45f8e64379297$export$6503ec6e8aabbaf;


var $8LFjz = parcelRequire("8LFjz");

var $956812fe3091e0da$var$CONTEXTMENU_CLASS = "dx-list-context-menu";
var $956812fe3091e0da$var$CONTEXTMENU_MENUCONTENT_CLASS = "dx-list-context-menucontent";
$956812fe3091e0da$require$registerDecorator("menu", "context", $df89cd8a75819f4e$exports.inherit({
    _init: function() {
        var $menu = $jFnCG("<div>").addClass($956812fe3091e0da$var$CONTEXTMENU_CLASS);
        this._list.$element().append($menu);
        this._menu = this._renderOverlay($menu);
    },
    _renderOverlay: function($element) {
        return this._list._createComponent($element, $8LFjz, {
            shading: false,
            deferRendering: true,
            closeOnTargetScroll: true,
            closeOnOutsideClick: function(e) {
                return !$jFnCG(e.target).closest("." + $956812fe3091e0da$var$CONTEXTMENU_CLASS).length;
            },
            animation: {
                show: {
                    type: "slide",
                    duration: 300,
                    from: {
                        height: 0,
                        opacity: 1
                    },
                    to: {
                        height: (function() {
                            return this._$menuList.outerHeight();
                        }).bind(this),
                        opacity: 1
                    }
                },
                hide: {
                    type: "slide",
                    duration: 0,
                    from: {
                        opacity: 1
                    },
                    to: {
                        opacity: 0
                    }
                }
            },
            height: (function() {
                return this._$menuList ? this._$menuList.outerHeight() : 0;
            }).bind(this),
            width: (function() {
                return this._list.$element().outerWidth();
            }).bind(this),
            onContentReady: this._renderMenuContent.bind(this)
        });
    },
    _renderMenuContent: function(e) {
        var $overlayContent = e.component.$content();
        var items = this._menuItems().slice();
        if (this._deleteEnabled()) items.push({
            text: $cnVbh.format("dxListEditDecorator-delete"),
            action: this._deleteItem.bind(this)
        });
        this._$menuList = $jFnCG("<div>");
        this._list._createComponent(this._$menuList, $f8c15c4fd57b6899$exports, {
            items: items,
            onItemClick: this._menuItemClickHandler.bind(this),
            height: "auto",
            integrationOptions: {}
        });
        $overlayContent.addClass($956812fe3091e0da$var$CONTEXTMENU_MENUCONTENT_CLASS);
        $overlayContent.append(this._$menuList);
    },
    _menuItemClickHandler: function(args) {
        this._menu.hide();
        this._fireMenuAction(this._$itemWithMenu, args.itemData.action);
    },
    _deleteItem: function() {
        this._list.deleteItem(this._$itemWithMenu);
    },
    handleContextMenu: function($itemElement) {
        this._$itemWithMenu = $itemElement;
        this._menu.option({
            position: {
                my: "top",
                at: "bottom",
                of: $itemElement,
                collision: "flip"
            }
        });
        this._menu.show();
        return true;
    },
    dispose: function() {
        if (this._menu) this._menu.$element().remove();
        this.callBase.apply(this, arguments);
    }
}).include($4595a685472f9541$exports));


/**
 * DevExtreme (ui/list/ui.list.edit.decorator.selection.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $e1LMc = parcelRequire("e1LMc");

var $i7ZSP = parcelRequire("i7ZSP");

var $7I8Uw = parcelRequire("7I8Uw");
var $a3fbe3e60e53dea1$require$extend = $7I8Uw.extend;

var $lrsNa = parcelRequire("lrsNa");
var $9f4363e8e5bb25c1$exports = {};
/**
 * DevExtreme (ui/check_box.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $e1LMc = parcelRequire("e1LMc");

var $aiwte = parcelRequire("aiwte");

var $7I8Uw = parcelRequire("7I8Uw");
var $9f4363e8e5bb25c1$require$extend = $7I8Uw.extend;

var $gysT6 = parcelRequire("gysT6");

var $4hjO5 = parcelRequire("4hjO5");

var $4ZFRo = parcelRequire("4ZFRo");

var $bXb2w = parcelRequire("bXb2w");

var $i7ZSP = parcelRequire("i7ZSP");
var $9f4363e8e5bb25c1$var$CHECKBOX_CLASS = "dx-checkbox";
var $9f4363e8e5bb25c1$var$CHECKBOX_ICON_CLASS = "dx-checkbox-icon";
var $9f4363e8e5bb25c1$var$CHECKBOX_CHECKED_CLASS = "dx-checkbox-checked";
var $9f4363e8e5bb25c1$var$CHECKBOX_CONTAINER_CLASS = "dx-checkbox-container";
var $9f4363e8e5bb25c1$var$CHECKBOX_TEXT_CLASS = "dx-checkbox-text";
var $9f4363e8e5bb25c1$var$CHECKBOX_HAS_TEXT_CLASS = "dx-checkbox-has-text";
var $9f4363e8e5bb25c1$var$CHECKBOX_INDETERMINATE_CLASS = "dx-checkbox-indeterminate";
var $9f4363e8e5bb25c1$var$CHECKBOX_FEEDBACK_HIDE_TIMEOUT = 100;
var $9f4363e8e5bb25c1$var$CheckBox = $4hjO5.inherit({
    _supportedKeys: function() {
        var click = function(e) {
            e.preventDefault();
            this._clickAction({
                event: e
            });
        };
        return $9f4363e8e5bb25c1$require$extend(this.callBase(), {
            space: click
        });
    },
    _getDefaultOptions: function() {
        return $9f4363e8e5bb25c1$require$extend(this.callBase(), {
            hoverStateEnabled: true,
            activeStateEnabled: true,
            value: false,
            text: "",
            useInkRipple: false
        });
    },
    _defaultOptionsRules: function() {
        return this.callBase().concat([
            {
                device: function() {
                    return "desktop" === $aiwte.real().deviceType && !$aiwte.isSimulator();
                },
                options: {
                    focusStateEnabled: true
                }
            }
        ]);
    },
    _canValueBeChangedByClick: function() {
        return true;
    },
    _feedbackHideTimeout: $9f4363e8e5bb25c1$var$CHECKBOX_FEEDBACK_HIDE_TIMEOUT,
    _initMarkup: function() {
        this._renderSubmitElement();
        this._$container = $jFnCG("<div>").addClass($9f4363e8e5bb25c1$var$CHECKBOX_CONTAINER_CLASS);
        this.setAria("role", "checkbox");
        this.$element().addClass($9f4363e8e5bb25c1$var$CHECKBOX_CLASS);
        this._renderValue();
        this._renderIcon();
        this._renderText();
        this.option("useInkRipple") && this._renderInkRipple();
        this.$element().append(this._$container);
        this.callBase();
    },
    _render: function() {
        this._renderClick();
        this.callBase();
    },
    _renderSubmitElement: function() {
        this._$submitElement = $jFnCG("<input>").attr("type", "hidden").appendTo(this.$element());
    },
    _getSubmitElement: function() {
        return this._$submitElement;
    },
    _renderInkRipple: function() {
        this._inkRipple = $gysT6.render({
            waveSizeCoefficient: 2.5,
            useHoldAnimation: false,
            wavesNumber: 2,
            isCentered: true
        });
    },
    _renderInkWave: function(element, dxEvent, doRender, waveIndex) {
        if (!this._inkRipple) return;
        var config = {
            element: element,
            event: dxEvent,
            wave: waveIndex
        };
        if (doRender) this._inkRipple.showWave(config);
        else this._inkRipple.hideWave(config);
    },
    _updateFocusState: function(e, value) {
        this.callBase.apply(this, arguments);
        this._renderInkWave(this._$icon, e, value, 0);
    },
    _toggleActiveState: function($element, value, e) {
        this.callBase.apply(this, arguments);
        this._renderInkWave(this._$icon, e, value, 1);
    },
    _renderIcon: function() {
        this._$icon = $jFnCG("<span>").addClass($9f4363e8e5bb25c1$var$CHECKBOX_ICON_CLASS).prependTo(this._$container);
    },
    _renderText: function() {
        var textValue = this.option("text");
        if (!textValue) {
            if (this._$text) {
                this._$text.remove();
                this.$element().removeClass($9f4363e8e5bb25c1$var$CHECKBOX_HAS_TEXT_CLASS);
            }
            return;
        }
        if (!this._$text) this._$text = $jFnCG("<span>").addClass($9f4363e8e5bb25c1$var$CHECKBOX_TEXT_CLASS);
        this._$text.text(textValue);
        this._$container.append(this._$text);
        this.$element().addClass($9f4363e8e5bb25c1$var$CHECKBOX_HAS_TEXT_CLASS);
    },
    _renderClick: function() {
        var that = this;
        var eventName = $bXb2w.addNamespace($i7ZSP.name, that.NAME);
        that._clickAction = that._createAction(that._clickHandler);
        $e1LMc.off(that.$element(), eventName);
        $e1LMc.on(that.$element(), eventName, function(e) {
            that._clickAction({
                event: e
            });
        });
    },
    _clickHandler: function(args) {
        var that = args.component;
        that._saveValueChangeEvent(args.event);
        that.option("value", !that.option("value"));
    },
    _renderValue: function() {
        var $element = this.$element();
        var checked = this.option("value");
        var indeterminate = void 0 === checked;
        $element.toggleClass($9f4363e8e5bb25c1$var$CHECKBOX_CHECKED_CLASS, Boolean(checked));
        $element.toggleClass($9f4363e8e5bb25c1$var$CHECKBOX_INDETERMINATE_CLASS, indeterminate);
        this._getSubmitElement().val(checked);
        this.setAria("checked", indeterminate ? "mixed" : checked || "false");
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "useInkRipple":
                this._invalidate();
                break;
            case "value":
                this._renderValue();
                this.callBase(args);
                break;
            case "text":
                this._renderText();
                this._renderDimensions();
                break;
            default:
                this.callBase(args);
        }
    },
    _clean: function() {
        delete this._inkRipple;
        this.callBase();
    }
});
$4ZFRo("dxCheckBox", $9f4363e8e5bb25c1$var$CheckBox);
$9f4363e8e5bb25c1$exports = $9f4363e8e5bb25c1$var$CheckBox;
$9f4363e8e5bb25c1$exports.default = $9f4363e8e5bb25c1$exports;


var $3fe6231be4385fbb$exports = {};
/**
 * DevExtreme (ui/radio_group/radio_button.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");

var $e1LMc = parcelRequire("e1LMc");

var $aiwte = parcelRequire("aiwte");

var $7I8Uw = parcelRequire("7I8Uw");
var $3fe6231be4385fbb$require$extend = $7I8Uw.extend;

var $gysT6 = parcelRequire("gysT6");

var $4ZFRo = parcelRequire("4ZFRo");

var $4hjO5 = parcelRequire("4hjO5");

var $bXb2w = parcelRequire("bXb2w");

var $i7ZSP = parcelRequire("i7ZSP");
var $3fe6231be4385fbb$var$RADIO_BUTTON_CLASS = "dx-radiobutton";
var $3fe6231be4385fbb$var$RADIO_BUTTON_ICON_CLASS = "dx-radiobutton-icon";
var $3fe6231be4385fbb$var$RADIO_BUTTON_ICON_DOT_CLASS = "dx-radiobutton-icon-dot";
var $3fe6231be4385fbb$var$RADIO_BUTTON_CHECKED_CLASS = "dx-radiobutton-checked";
var $3fe6231be4385fbb$var$RADIO_BUTTON_ICON_CHECKED_CLASS = "dx-radiobutton-icon-checked";
var $3fe6231be4385fbb$var$RadioButton = $4hjO5.inherit({
    _supportedKeys: function() {
        var click = function(e) {
            e.preventDefault();
            this._clickAction({
                event: e
            });
        };
        return $3fe6231be4385fbb$require$extend(this.callBase(), {
            space: click
        });
    },
    _getDefaultOptions: function() {
        return $3fe6231be4385fbb$require$extend(this.callBase(), {
            hoverStateEnabled: true,
            activeStateEnabled: true,
            value: false,
            useInkRipple: false
        });
    },
    _canValueBeChangedByClick: function() {
        return true;
    },
    _defaultOptionsRules: function() {
        return this.callBase().concat([
            {
                device: function() {
                    return "desktop" === $aiwte.real().deviceType && !$aiwte.isSimulator();
                },
                options: {
                    focusStateEnabled: true
                }
            }
        ]);
    },
    _init: function() {
        this.callBase();
        this.$element().addClass($3fe6231be4385fbb$var$RADIO_BUTTON_CLASS);
    },
    _initMarkup: function() {
        this.callBase();
        this._renderIcon();
        this.option("useInkRipple") && this._renderInkRipple();
        this._renderCheckedState(this.option("value"));
        this._renderClick();
        this.setAria("role", "radio");
    },
    _renderInkRipple: function() {
        this._inkRipple = $gysT6.render({
            waveSizeCoefficient: 3.3,
            useHoldAnimation: false,
            wavesNumber: 2,
            isCentered: true
        });
    },
    _renderInkWave: function(element, dxEvent, doRender, waveIndex) {
        if (!this._inkRipple) return;
        var config = {
            element: element,
            event: dxEvent,
            wave: waveIndex
        };
        if (doRender) this._inkRipple.showWave(config);
        else this._inkRipple.hideWave(config);
    },
    _updateFocusState: function(e, value) {
        this.callBase.apply(this, arguments);
        this._renderInkWave(this._$icon, e, value, 0);
    },
    _toggleActiveState: function($element, value, e) {
        this.callBase.apply(this, arguments);
        this._renderInkWave(this._$icon, e, value, 1);
    },
    _renderIcon: function() {
        this._$icon = $jFnCG("<div>").addClass($3fe6231be4385fbb$var$RADIO_BUTTON_ICON_CLASS);
        $jFnCG("<div>").addClass($3fe6231be4385fbb$var$RADIO_BUTTON_ICON_DOT_CLASS).appendTo(this._$icon);
        this.$element().append(this._$icon);
    },
    _renderCheckedState: function(checked) {
        this.$element().toggleClass($3fe6231be4385fbb$var$RADIO_BUTTON_CHECKED_CLASS, checked).find("." + $3fe6231be4385fbb$var$RADIO_BUTTON_ICON_CLASS).toggleClass($3fe6231be4385fbb$var$RADIO_BUTTON_ICON_CHECKED_CLASS, checked);
        this.setAria("checked", checked);
    },
    _renderClick: function() {
        var eventName = $bXb2w.addNamespace($i7ZSP.name, this.NAME);
        this._clickAction = this._createAction((function(args) {
            this._clickHandler(args.event);
        }).bind(this));
        $e1LMc.off(this.$element(), eventName);
        $e1LMc.on(this.$element(), eventName, (function(e) {
            this._clickAction({
                event: e
            });
        }).bind(this));
    },
    _clickHandler: function(e) {
        this._saveValueChangeEvent(e);
        this.option("value", true);
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "useInkRipple":
                this._invalidate();
                break;
            case "value":
                this._renderCheckedState(args.value);
                this.callBase(args);
                break;
            default:
                this.callBase(args);
        }
    },
    _clean: function() {
        delete this._inkRipple;
        this.callBase();
    }
});
$4ZFRo("dxRadioButton", $3fe6231be4385fbb$var$RadioButton);
$3fe6231be4385fbb$exports = $3fe6231be4385fbb$var$RadioButton;



var $bXb2w = parcelRequire("bXb2w");

var $a3fbe3e60e53dea1$require$registerDecorator = $3dd45f8e64379297$export$6503ec6e8aabbaf;

var $a3fbe3e60e53dea1$var$SELECT_DECORATOR_ENABLED_CLASS = "dx-list-select-decorator-enabled";
var $a3fbe3e60e53dea1$var$SELECT_DECORATOR_SELECT_ALL_CLASS = "dx-list-select-all";
var $a3fbe3e60e53dea1$var$SELECT_DECORATOR_SELECT_ALL_CHECKBOX_CLASS = "dx-list-select-all-checkbox";
var $a3fbe3e60e53dea1$var$SELECT_DECORATOR_SELECT_ALL_LABEL_CLASS = "dx-list-select-all-label";
var $a3fbe3e60e53dea1$var$SELECT_CHECKBOX_CONTAINER_CLASS = "dx-list-select-checkbox-container";
var $a3fbe3e60e53dea1$var$SELECT_CHECKBOX_CLASS = "dx-list-select-checkbox";
var $a3fbe3e60e53dea1$var$SELECT_RADIO_BUTTON_CONTAINER_CLASS = "dx-list-select-radiobutton-container";
var $a3fbe3e60e53dea1$var$SELECT_RADIO_BUTTON_CLASS = "dx-list-select-radiobutton";
var $a3fbe3e60e53dea1$var$FOCUSED_STATE_CLASS = "dx-state-focused";
var $a3fbe3e60e53dea1$var$CLICK_EVENT_NAME = $bXb2w.addNamespace($i7ZSP.name, "dxListEditDecorator");
$a3fbe3e60e53dea1$require$registerDecorator("selection", "default", $df89cd8a75819f4e$exports.inherit({
    _init: function() {
        this.callBase.apply(this, arguments);
        var selectionMode = this._list.option("selectionMode");
        this._singleStrategy = "single" === selectionMode;
        this._containerClass = this._singleStrategy ? $a3fbe3e60e53dea1$var$SELECT_RADIO_BUTTON_CONTAINER_CLASS : $a3fbe3e60e53dea1$var$SELECT_CHECKBOX_CONTAINER_CLASS;
        this._controlClass = this._singleStrategy ? $a3fbe3e60e53dea1$var$SELECT_RADIO_BUTTON_CLASS : $a3fbe3e60e53dea1$var$SELECT_CHECKBOX_CLASS;
        this._controlWidget = this._singleStrategy ? $3fe6231be4385fbb$exports : $9f4363e8e5bb25c1$exports;
        this._list.$element().addClass($a3fbe3e60e53dea1$var$SELECT_DECORATOR_ENABLED_CLASS);
    },
    beforeBag: function(config) {
        var $itemElement = config.$itemElement;
        var $container = config.$container;
        var $control = $jFnCG("<div>").addClass(this._controlClass);
        new this._controlWidget($control, $a3fbe3e60e53dea1$require$extend(this._commonOptions(), {
            value: this._isSelected($itemElement),
            focusStateEnabled: false,
            hoverStateEnabled: false,
            onValueChanged: (function(e) {
                this._processCheckedState($itemElement, e.value);
                e.event && e.event.stopPropagation();
            }).bind(this)
        }));
        $container.addClass(this._containerClass);
        $container.append($control);
    },
    modifyElement: function(config) {
        this.callBase.apply(this, arguments);
        var $itemElement = config.$itemElement;
        var control = this._controlWidget.getInstance($itemElement.find("." + this._controlClass));
        $e1LMc.on($itemElement, "stateChanged", (function(e, state) {
            control.option("value", state);
        }).bind(this));
    },
    _updateSelectAllState: function() {
        if (!this._$selectAll) return;
        this._selectAllCheckBox.option("value", this._list.isSelectAll());
    },
    afterRender: function() {
        if ("all" !== this._list.option("selectionMode")) return;
        if (!this._$selectAll) this._renderSelectAll();
        else this._updateSelectAllState();
    },
    handleKeyboardEvents: function(currentFocusedIndex, moveFocusUp) {
        var moveFocusDown = !moveFocusUp;
        var list = this._list;
        var $selectAll = this._$selectAll;
        var lastItemIndex = list._getLastItemIndex();
        var isFocusOutOfList = moveFocusUp && 0 === currentFocusedIndex || moveFocusDown && currentFocusedIndex === lastItemIndex;
        var hasSelectAllItem = !!$selectAll;
        if (hasSelectAllItem && isFocusOutOfList) {
            list.option("focusedElement", $selectAll);
            list.scrollToItem(list.option("focusedElement"));
            return true;
        }
        return false;
    },
    handleEnterPressing: function() {
        if (this._$selectAll && this._$selectAll.hasClass($a3fbe3e60e53dea1$var$FOCUSED_STATE_CLASS)) {
            this._selectAllCheckBox.option("value", !this._selectAllCheckBox.option("value"));
            return true;
        }
    },
    _renderSelectAll: function() {
        var $selectAll = this._$selectAll = $jFnCG("<div>").addClass($a3fbe3e60e53dea1$var$SELECT_DECORATOR_SELECT_ALL_CLASS);
        var list = this._list;
        var downArrowHandler = list._supportedKeys().downArrow.bind(list);
        this._selectAllCheckBox = list._createComponent($jFnCG("<div>").addClass($a3fbe3e60e53dea1$var$SELECT_DECORATOR_SELECT_ALL_CHECKBOX_CLASS).appendTo($selectAll), $9f4363e8e5bb25c1$exports, {
            focusStateEnabled: false,
            hoverStateEnabled: false
        });
        this._selectAllCheckBox.registerKeyHandler("downArrow", downArrowHandler);
        $jFnCG("<div>").addClass($a3fbe3e60e53dea1$var$SELECT_DECORATOR_SELECT_ALL_LABEL_CLASS).text(this._list.option("selectAllText")).appendTo($selectAll);
        this._list.itemsContainer().prepend($selectAll);
        this._updateSelectAllState();
        this._attachSelectAllHandler();
    },
    _attachSelectAllHandler: function() {
        this._selectAllCheckBox.option("onValueChanged", this._selectAllHandler.bind(this));
        $e1LMc.off(this._$selectAll, $a3fbe3e60e53dea1$var$CLICK_EVENT_NAME);
        $e1LMc.on(this._$selectAll, $a3fbe3e60e53dea1$var$CLICK_EVENT_NAME, this._selectAllClickHandler.bind(this));
    },
    _selectAllHandler: function(e) {
        e.event && e.event.stopPropagation();
        var isSelectedAll = this._selectAllCheckBox.option("value");
        var result = this._list._createActionByOption("onSelectAllValueChanged")({
            value: isSelectedAll
        });
        if (false === result) return;
        if (true === isSelectedAll) this._selectAllItems();
        else if (false === isSelectedAll) this._unselectAllItems();
    },
    _checkSelectAllCapability: function() {
        var list = this._list;
        var dataSource = list.getDataSource();
        if ("allPages" === list.option("selectAllMode") && list.option("grouped") && (!dataSource || !dataSource.group())) {
            $lrsNa.log("W1010");
            return false;
        }
        return true;
    },
    _selectAllItems: function() {
        if (!this._checkSelectAllCapability()) return;
        this._list._selection.selectAll("page" === this._list.option("selectAllMode"));
    },
    _unselectAllItems: function() {
        if (!this._checkSelectAllCapability()) return;
        this._list._selection.deselectAll("page" === this._list.option("selectAllMode"));
    },
    _selectAllClickHandler: function() {
        this._selectAllCheckBox.option("value", !this._selectAllCheckBox.option("value"));
    },
    _isSelected: function($itemElement) {
        return this._list.isItemSelected($itemElement);
    },
    _processCheckedState: function($itemElement, checked) {
        if (checked) this._list.selectItem($itemElement);
        else this._list.unselectItem($itemElement);
    },
    dispose: function() {
        this._disposeSelectAll();
        this._list.$element().removeClass($a3fbe3e60e53dea1$var$SELECT_DECORATOR_ENABLED_CLASS);
        this.callBase.apply(this, arguments);
    },
    _disposeSelectAll: function() {
        if (this._$selectAll) {
            this._$selectAll.remove();
            this._$selectAll = null;
        }
    }
}));


/**
 * DevExtreme (ui/list/ui.list.edit.decorator.reorder.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $aa311ccc821afd34$var$_renderer2 = $aa311ccc821afd34$var$_interopRequireDefault($jFnCG);

var $e1LMc = parcelRequire("e1LMc");
var $aa311ccc821afd34$var$_events_engine2 = $aa311ccc821afd34$var$_interopRequireDefault($e1LMc);

var $7I8Uw = parcelRequire("7I8Uw");

var $bXb2w = parcelRequire("bXb2w");


var $aa311ccc821afd34$var$_uiListEdit3 = $aa311ccc821afd34$var$_interopRequireDefault($df89cd8a75819f4e$exports);
var $4511cc2bbc1b21c2$exports = {};
/**
 * DevExtreme (ui/sortable.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $4511cc2bbc1b21c2$var$_renderer2 = $4511cc2bbc1b21c2$var$_interopRequireDefault($jFnCG);

var $4ZFRo = parcelRequire("4ZFRo");
var $4511cc2bbc1b21c2$var$_component_registrator2 = $4511cc2bbc1b21c2$var$_interopRequireDefault($4ZFRo);

var $7I8Uw = parcelRequire("7I8Uw");
var $1314eb17fd30e980$exports = {};
/**
 * DevExtreme (ui/draggable.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";
function $1314eb17fd30e980$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1314eb17fd30e980$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1314eb17fd30e980$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1314eb17fd30e980$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1314eb17fd30e980$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

var $jFnCG = parcelRequire("jFnCG");

var $1314eb17fd30e980$var$window = (parcelRequire("irv64")).getWindow();

var $e1LMc = parcelRequire("e1LMc");

var $ksvsU = parcelRequire("ksvsU");

var $4ZFRo = parcelRequire("4ZFRo");

var $6jr65 = parcelRequire("6jr65");

var $ih9Pz = parcelRequire("ih9Pz");

var $bvcPv = parcelRequire("bvcPv");

var $ih7fv = parcelRequire("ih7fv");
var $1314eb17fd30e980$require$dasherize = $ih7fv.dasherize;

var $7I8Uw = parcelRequire("7I8Uw");
var $1314eb17fd30e980$require$extend = $7I8Uw.extend;

var $23OYU = parcelRequire("23OYU");

var $5OzEX = parcelRequire("5OzEX");
var $1314eb17fd30e980$require$getPublicElement = $5OzEX.getPublicElement;

var $bXb2w = parcelRequire("bXb2w");

var $gP4Gh = parcelRequire("gP4Gh");

var $cesi3 = parcelRequire("cesi3");

var $bgCx6 = parcelRequire("bgCx6");

var $kDRxH = parcelRequire("kDRxH");

var $2Mto0 = parcelRequire("2Mto0");
var $1314eb17fd30e980$require$noop = $2Mto0.noop;

var $7wA28 = parcelRequire("7wA28");

var $2Mto0 = parcelRequire("2Mto0");

var $e5a0x = parcelRequire("e5a0x");
var $1314eb17fd30e980$require$EmptyTemplate = $e5a0x.EmptyTemplate;

var $2F60d = parcelRequire("2F60d");

var $1TtsA = parcelRequire("1TtsA");
var $1314eb17fd30e980$require$getBoundingRect = $1TtsA.getBoundingRect;
var $1314eb17fd30e980$var$when = $2F60d.when;
var $1314eb17fd30e980$var$fromPromise = $2F60d.fromPromise;
var $1314eb17fd30e980$var$Deferred = $2F60d.Deferred;
var $1314eb17fd30e980$var$DRAGGABLE = "dxDraggable";
var $1314eb17fd30e980$var$DRAGSTART_EVENT_NAME = $bXb2w.addNamespace($cesi3.start, $1314eb17fd30e980$var$DRAGGABLE);
var $1314eb17fd30e980$var$DRAG_EVENT_NAME = $bXb2w.addNamespace($cesi3.move, $1314eb17fd30e980$var$DRAGGABLE);
var $1314eb17fd30e980$var$DRAGEND_EVENT_NAME = $bXb2w.addNamespace($cesi3.end, $1314eb17fd30e980$var$DRAGGABLE);
var $1314eb17fd30e980$var$DRAG_ENTER_EVENT_NAME = $bXb2w.addNamespace($cesi3.enter, $1314eb17fd30e980$var$DRAGGABLE);
var $1314eb17fd30e980$var$DRAGEND_LEAVE_EVENT_NAME = $bXb2w.addNamespace($cesi3.leave, $1314eb17fd30e980$var$DRAGGABLE);
var $1314eb17fd30e980$var$POINTERDOWN_EVENT_NAME = $bXb2w.addNamespace($gP4Gh.down, $1314eb17fd30e980$var$DRAGGABLE);
var $1314eb17fd30e980$var$CLONE_CLASS = "clone";
var $1314eb17fd30e980$var$targetDraggable;
var $1314eb17fd30e980$var$sourceDraggable;
var $1314eb17fd30e980$var$ScrollHelper = function() {
    function ScrollHelper(orientation, component) {
        $1314eb17fd30e980$var$_classCallCheck(this, ScrollHelper);
        this._preventScroll = true;
        this._component = component;
        if ("vertical" === orientation) {
            this._scrollValue = "scrollTop";
            this._overFlowAttr = "overflowY";
            this._sizeAttr = "height";
            this._scrollSizeProp = "scrollHeight";
            this._limitProps = {
                start: "top",
                end: "bottom"
            };
        } else {
            this._scrollValue = "scrollLeft";
            this._overFlowAttr = "overflowX";
            this._sizeAttr = "width";
            this._scrollSizeProp = "scrollWidth";
            this._limitProps = {
                start: "left",
                end: "right"
            };
        }
    }
    $1314eb17fd30e980$var$_createClass(ScrollHelper, [
        {
            key: "updateScrollable",
            value: function(elements, mousePosition) {
                var that = this;
                if (!elements.some(function(element) {
                    return that._trySetScrollable(element, mousePosition);
                })) {
                    that._$scrollableAtPointer = null;
                    that._scrollSpeed = 0;
                }
            }
        },
        {
            key: "isScrolling",
            value: function() {
                return !!this._scrollSpeed;
            }
        },
        {
            key: "isScrollable",
            value: function($element) {
                var that = this;
                return ("auto" === $element.css(that._overFlowAttr) || $element.hasClass("dx-scrollable-container")) && $element.prop(that._scrollSizeProp) > $element[that._sizeAttr]();
            }
        },
        {
            key: "_trySetScrollable",
            value: function(element, mousePosition) {
                var that = this;
                var $element = $jFnCG(element);
                var distanceToBorders;
                var sensitivity = that._component.option("scrollSensitivity");
                var isScrollable = that.isScrollable($element);
                if (isScrollable) {
                    distanceToBorders = that._calculateDistanceToBorders($element, mousePosition);
                    if (sensitivity > distanceToBorders[that._limitProps.start]) {
                        if (!that._preventScroll) {
                            that._scrollSpeed = -that._calculateScrollSpeed(distanceToBorders[that._limitProps.start]);
                            that._$scrollableAtPointer = $element;
                        }
                    } else {
                        if (sensitivity > distanceToBorders[that._limitProps.end]) {
                            if (!that._preventScroll) {
                                that._scrollSpeed = that._calculateScrollSpeed(distanceToBorders[that._limitProps.end]);
                                that._$scrollableAtPointer = $element;
                            }
                        } else {
                            isScrollable = false;
                            that._preventScroll = false;
                        }
                    }
                }
                return isScrollable;
            }
        },
        {
            key: "_calculateDistanceToBorders",
            value: function($area, mousePosition) {
                var area = $area.get(0);
                var areaBoundingRect;
                if (area) {
                    areaBoundingRect = $1314eb17fd30e980$require$getBoundingRect(area);
                    return {
                        left: mousePosition.x - areaBoundingRect.left,
                        top: mousePosition.y - areaBoundingRect.top,
                        right: areaBoundingRect.right - mousePosition.x,
                        bottom: areaBoundingRect.bottom - mousePosition.y
                    };
                } else return {};
            }
        },
        {
            key: "_calculateScrollSpeed",
            value: function(distance) {
                var component = this._component;
                var sensitivity = component.option("scrollSensitivity");
                var maxSpeed = component.option("scrollSpeed");
                return Math.ceil(Math.pow((sensitivity - distance) / sensitivity, 2) * maxSpeed);
            }
        },
        {
            key: "scrollByStep",
            value: function() {
                var that = this;
                var nextScrollPosition;
                if (that._$scrollableAtPointer && that._scrollSpeed) {
                    if (that._$scrollableAtPointer.hasClass("dx-scrollable-container")) {
                        var $scrollable = that._$scrollableAtPointer.closest(".dx-scrollable");
                        var scrollableInstance = $scrollable.data("dxScrollable") || $scrollable.data("dxScrollView");
                        if (scrollableInstance) {
                            nextScrollPosition = scrollableInstance.scrollOffset();
                            nextScrollPosition[that._limitProps.start] += that._scrollSpeed;
                            scrollableInstance.scrollTo(nextScrollPosition);
                        }
                    } else {
                        nextScrollPosition = that._$scrollableAtPointer[that._scrollValue]() + that._scrollSpeed;
                        that._$scrollableAtPointer[that._scrollValue](nextScrollPosition);
                    }
                    var dragMoveArgs = that._component._dragMoveArgs;
                    if (dragMoveArgs) that._component._dragMoveHandler(dragMoveArgs);
                }
            }
        },
        {
            key: "reset",
            value: function() {
                this._$scrollableAtPointer = null;
                this._scrollSpeed = 0;
                this._preventScroll = true;
            }
        },
        {
            key: "isOutsideScrollable",
            value: function($scrollable, event) {
                if (!$scrollable) return false;
                var scrollableSize = $1314eb17fd30e980$require$getBoundingRect($scrollable.get(0));
                var start = scrollableSize[this._limitProps.start];
                var size = scrollableSize[this._sizeAttr];
                var location = "width" === this._sizeAttr ? event.pageX : event.pageY;
                return location < start || location > start + size;
            }
        }
    ]);
    return ScrollHelper;
}();
var $1314eb17fd30e980$var$ScrollAnimator = $ih9Pz.inherit({
    ctor: function(strategy) {
        this.callBase();
        this._strategy = strategy;
    },
    _step: function() {
        var horizontalScrollHelper = this._strategy._horizontalScrollHelper;
        var verticalScrollHelper = this._strategy._verticalScrollHelper;
        horizontalScrollHelper && horizontalScrollHelper.scrollByStep();
        verticalScrollHelper && verticalScrollHelper.scrollByStep();
    }
});
var $1314eb17fd30e980$var$Draggable = $23OYU.inherit({
    reset: $1314eb17fd30e980$require$noop,
    dragMove: $1314eb17fd30e980$require$noop,
    dragEnter: $1314eb17fd30e980$require$noop,
    dragLeave: $1314eb17fd30e980$require$noop,
    dragEnd: function(sourceEvent) {
        var sourceDraggable = this._getSourceDraggable();
        sourceDraggable._fireRemoveEvent(sourceEvent);
        return (new $1314eb17fd30e980$var$Deferred).resolve();
    },
    _fireRemoveEvent: $1314eb17fd30e980$require$noop,
    _getDefaultOptions: function() {
        return $1314eb17fd30e980$require$extend(this.callBase(), {
            onDragStart: null,
            onDragMove: null,
            onDragEnd: null,
            onDrop: null,
            immediate: true,
            dragDirection: "both",
            boundary: void 0,
            boundOffset: 0,
            allowMoveByClick: false,
            itemData: null,
            container: void 0,
            dragTemplate: void 0,
            contentTemplate: "content",
            handle: "",
            filter: "",
            clone: false,
            autoScroll: true,
            scrollSpeed: 30,
            scrollSensitivity: 60,
            group: void 0,
            data: void 0
        });
    },
    _setOptionsByReference: function() {
        this.callBase.apply(this, arguments);
        $1314eb17fd30e980$require$extend(this._optionsByReference, {
            component: true,
            group: true,
            itemData: true,
            data: true
        });
    },
    _init: function() {
        this.callBase();
        this._attachEventHandlers();
        this._scrollAnimator = new $1314eb17fd30e980$var$ScrollAnimator(this);
        this._horizontalScrollHelper = new $1314eb17fd30e980$var$ScrollHelper("horizontal", this);
        this._verticalScrollHelper = new $1314eb17fd30e980$var$ScrollHelper("vertical", this);
    },
    _normalizeCursorOffset: function(offset) {
        if ($kDRxH.isObject(offset)) offset = {
            h: offset.x,
            v: offset.y
        };
        offset = $2Mto0.splitPair(offset).map(function(value) {
            return parseFloat(value);
        });
        return {
            left: offset[0],
            top: 1 === offset.length ? offset[0] : offset[1]
        };
    },
    _getNormalizedCursorOffset: function(offset, options) {
        if ($kDRxH.isFunction(offset)) offset = offset.call(this, options);
        return this._normalizeCursorOffset(offset);
    },
    _calculateElementOffset: function(options) {
        var elementOffset;
        var dragElementOffset;
        var event = options.event;
        var $element = $jFnCG(options.itemElement);
        var $dragElement = $jFnCG(options.dragElement);
        var isCloned = this._dragElementIsCloned();
        var cursorOffset = this.option("cursorOffset");
        var normalizedCursorOffset = {
            left: 0,
            top: 0
        };
        var currentLocate = this._initialLocate = $6jr65.locate($dragElement);
        if (isCloned || options.initialOffset || cursorOffset) {
            elementOffset = options.initialOffset || $element.offset();
            if (cursorOffset) {
                normalizedCursorOffset = this._getNormalizedCursorOffset(cursorOffset, options);
                if (isFinite(normalizedCursorOffset.left)) elementOffset.left = event.pageX;
                if (isFinite(normalizedCursorOffset.top)) elementOffset.top = event.pageY;
            }
            dragElementOffset = $dragElement.offset();
            elementOffset.top -= dragElementOffset.top + (normalizedCursorOffset.top || 0) - currentLocate.top;
            elementOffset.left -= dragElementOffset.left + (normalizedCursorOffset.left || 0) - currentLocate.left;
        }
        return elementOffset;
    },
    _initPosition: function(options) {
        var $dragElement = $jFnCG(options.dragElement);
        var elementOffset = this._calculateElementOffset(options);
        if (elementOffset) this._move(elementOffset, $dragElement);
        this._startPosition = $6jr65.locate($dragElement);
    },
    _startAnimator: function() {
        if (!this._scrollAnimator.inProgress()) this._scrollAnimator.start();
    },
    _stopAnimator: function() {
        this._scrollAnimator.stop();
    },
    _addWidgetPrefix: function(className) {
        var componentName = this.NAME;
        return $1314eb17fd30e980$require$dasherize(componentName) + (className ? "-" + className : "");
    },
    _getItemsSelector: function() {
        return this.option("filter") || "";
    },
    _$content: function() {
        var $element = this.$element();
        var $wrapper = $element.children(".dx-template-wrapper");
        return $wrapper.length ? $wrapper : $element;
    },
    _attachEventHandlers: function() {
        var _this = this;
        if (this.option("disabled")) return;
        var $element = this._$content();
        var itemsSelector = this._getItemsSelector();
        var allowMoveByClick = this.option("allowMoveByClick");
        var data = {
            direction: this.option("dragDirection"),
            immediate: this.option("immediate"),
            checkDropTarget: function($target, event) {
                var targetGroup = _this.option("group");
                var sourceGroup = _this._getSourceDraggable().option("group");
                var $scrollable = _this._getScrollable($target);
                if (_this._verticalScrollHelper.isOutsideScrollable($scrollable, event) || _this._horizontalScrollHelper.isOutsideScrollable($scrollable, event)) return false;
                return sourceGroup && sourceGroup === targetGroup;
            }
        };
        if (allowMoveByClick) {
            $element = this._getArea();
            $e1LMc.on($element, $1314eb17fd30e980$var$POINTERDOWN_EVENT_NAME, data, this._pointerDownHandler.bind(this));
        }
        if (">" === itemsSelector[0]) itemsSelector = itemsSelector.slice(1);
        $e1LMc.on($element, $1314eb17fd30e980$var$DRAGSTART_EVENT_NAME, itemsSelector, data, this._dragStartHandler.bind(this));
        $e1LMc.on($element, $1314eb17fd30e980$var$DRAG_EVENT_NAME, data, this._dragMoveHandler.bind(this));
        $e1LMc.on($element, $1314eb17fd30e980$var$DRAGEND_EVENT_NAME, data, this._dragEndHandler.bind(this));
        $e1LMc.on($element, $1314eb17fd30e980$var$DRAG_ENTER_EVENT_NAME, data, this._dragEnterHandler.bind(this));
        $e1LMc.on($element, $1314eb17fd30e980$var$DRAGEND_LEAVE_EVENT_NAME, data, this._dragLeaveHandler.bind(this));
    },
    _dragElementIsCloned: function() {
        return this._$dragElement && this._$dragElement.hasClass(this._addWidgetPrefix($1314eb17fd30e980$var$CLONE_CLASS));
    },
    _getDragTemplateArgs: function($element, $container) {
        return {
            container: $1314eb17fd30e980$require$getPublicElement($container),
            model: {
                itemData: this.option("itemData"),
                itemElement: $1314eb17fd30e980$require$getPublicElement($element)
            }
        };
    },
    _createDragElement: function($element) {
        var result = $element;
        var clone = this.option("clone");
        var $container = this._getContainer();
        var template = this.option("dragTemplate");
        if (template) {
            template = this._getTemplate(template);
            result = $jFnCG("<div>").appendTo($container);
            template.render(this._getDragTemplateArgs($element, result));
        } else if (clone) {
            result = $jFnCG("<div>").appendTo($container);
            $element.clone().css({
                width: $element.css("width"),
                height: $element.css("height")
            }).appendTo(result);
        }
        return result.toggleClass(this._addWidgetPrefix($1314eb17fd30e980$var$CLONE_CLASS), result.get(0) !== $element.get(0)).toggleClass("dx-rtl", this.option("rtlEnabled"));
    },
    _resetDragElement: function() {
        if (this._dragElementIsCloned()) this._$dragElement.remove();
        else this._toggleDraggingClass(false);
        this._$dragElement = null;
    },
    _resetSourceElement: function() {
        this._toggleDragSourceClass(false);
        this._$sourceElement = null;
    },
    _detachEventHandlers: function() {
        $e1LMc.off(this._$content(), "." + $1314eb17fd30e980$var$DRAGGABLE);
        $e1LMc.off(this._getArea(), "." + $1314eb17fd30e980$var$DRAGGABLE);
    },
    _move: function(position, $element) {
        $6jr65.move($element || this._$dragElement, position);
    },
    _getDraggableElement: function(e) {
        var $sourceElement = this._getSourceElement();
        if ($sourceElement) return $sourceElement;
        var allowMoveByClick = this.option("allowMoveByClick");
        if (allowMoveByClick) return this.$element();
        var $target = $jFnCG(e && e.target);
        var itemsSelector = this._getItemsSelector();
        if (">" === itemsSelector[0]) {
            var $items = this._$content().find(itemsSelector);
            if (!$items.is($target)) $target = $target.closest($items);
        }
        return $target;
    },
    _getSourceElement: function() {
        var draggable = this._getSourceDraggable();
        return draggable._$sourceElement;
    },
    _pointerDownHandler: function(e) {
        if ($bXb2w.needSkipEvent(e)) return;
        var position = {};
        var $element = this.$element();
        var dragDirection = this.option("dragDirection");
        if ("horizontal" === dragDirection || "both" === dragDirection) position.left = e.pageX - $element.offset().left + $6jr65.locate($element).left - $element.width() / 2;
        if ("vertical" === dragDirection || "both" === dragDirection) position.top = e.pageY - $element.offset().top + $6jr65.locate($element).top - $element.height() / 2;
        this._move(position, $element);
        this._getAction("onDragMove")(this._getEventArgs(e));
    },
    _isValidElement: function(event, $element) {
        var handle = this.option("handle");
        var $target = $jFnCG(event.originalEvent && event.originalEvent.target);
        if (handle && !$target.closest(handle).length) return false;
        if (!$element.length) return false;
        return !$element.is(".dx-state-disabled, .dx-state-disabled *");
    },
    _dragStartHandler: function(e) {
        var $element = this._getDraggableElement(e);
        if (this._$sourceElement) return;
        if (!this._isValidElement(e, $element)) {
            e.cancel = true;
            return;
        }
        var dragStartArgs = this._getDragStartArgs(e, $element);
        this._getAction("onDragStart")(dragStartArgs);
        if (dragStartArgs.cancel) {
            e.cancel = true;
            return;
        }
        this.option("itemData", dragStartArgs.itemData);
        this._setSourceDraggable();
        this._$sourceElement = $element;
        var initialOffset = $element.offset();
        var $dragElement = this._$dragElement = this._createDragElement($element);
        this._toggleDraggingClass(true);
        this._toggleDragSourceClass(true);
        var isFixedPosition = "fixed" === $dragElement.css("position");
        this._initPosition($1314eb17fd30e980$require$extend({}, dragStartArgs, {
            dragElement: $dragElement.get(0),
            initialOffset: isFixedPosition && initialOffset
        }));
        var $area = this._getArea();
        var areaOffset = this._getAreaOffset($area);
        var boundOffset = this._getBoundOffset();
        var areaWidth = $area.outerWidth();
        var areaHeight = $area.outerHeight();
        var elementWidth = $dragElement.width();
        var elementHeight = $dragElement.height();
        var startOffset = {
            left: $dragElement.offset().left - areaOffset.left,
            top: $dragElement.offset().top - areaOffset.top
        };
        if ($area.length) {
            e.maxLeftOffset = startOffset.left - boundOffset.left;
            e.maxRightOffset = areaWidth - startOffset.left - elementWidth - boundOffset.right;
            e.maxTopOffset = startOffset.top - boundOffset.top;
            e.maxBottomOffset = areaHeight - startOffset.top - elementHeight - boundOffset.bottom;
        }
        if (this.option("autoScroll")) this._startAnimator();
    },
    _getAreaOffset: function($area) {
        var offset = $area && $bgCx6.offset($area);
        return offset ? offset : {
            left: 0,
            top: 0
        };
    },
    _toggleDraggingClass: function(value) {
        this._$dragElement && this._$dragElement.toggleClass(this._addWidgetPrefix("dragging"), value);
    },
    _toggleDragSourceClass: function(value, $element) {
        var $sourceElement = $element || this._$sourceElement;
        $sourceElement && $sourceElement.toggleClass(this._addWidgetPrefix("source"), value);
    },
    _getBoundOffset: function() {
        var boundOffset = this.option("boundOffset");
        if ($kDRxH.isFunction(boundOffset)) boundOffset = boundOffset.call(this);
        return $ksvsU.quadToObject(boundOffset);
    },
    _getArea: function() {
        var area = this.option("boundary");
        if ($kDRxH.isFunction(area)) area = area.call(this);
        return $jFnCG(area);
    },
    _getContainer: function() {
        var container = this.option("container");
        if (void 0 === container) container = $7wA28.value();
        return $jFnCG(container);
    },
    _dragMoveHandler: function(e) {
        this._dragMoveArgs = e;
        if (!this._$dragElement) {
            e.cancel = true;
            return;
        }
        var offset = e.offset;
        var startPosition = this._startPosition;
        this._move({
            left: startPosition.left + offset.x,
            top: startPosition.top + offset.y
        });
        this._updateScrollable(e);
        var eventArgs = this._getEventArgs(e);
        this._getAction("onDragMove")(eventArgs);
        if (true === eventArgs.cancel) return;
        var targetDraggable = this._getTargetDraggable();
        targetDraggable.dragMove(e);
    },
    _updateScrollable: function(e) {
        var that = this;
        if (that.option("autoScroll")) {
            var $window = $jFnCG($1314eb17fd30e980$var$window);
            var mousePosition = {
                x: e.pageX - $window.scrollLeft(),
                y: e.pageY - $window.scrollTop()
            };
            var allObjects = that.getElementsFromPoint(mousePosition);
            that._verticalScrollHelper.updateScrollable(allObjects, mousePosition);
            that._horizontalScrollHelper.updateScrollable(allObjects, mousePosition);
        }
    },
    getElementsFromPoint: function(position, dragElement) {
        var ownerDocument = (dragElement || this._$dragElement.get(0)).ownerDocument;
        if ($bvcPv.msie) {
            var msElements = ownerDocument.msElementsFromPoint(position.x, position.y);
            if (msElements) return Array.prototype.slice.call(msElements);
            return [];
        }
        return ownerDocument.elementsFromPoint(position.x, position.y);
    },
    _getScrollable: function($element) {
        var _this2 = this;
        var $scrollable;
        $element.parents().toArray().some(function(parent) {
            var $parent = $jFnCG(parent);
            if (_this2._horizontalScrollHelper.isScrollable($parent) || _this2._verticalScrollHelper.isScrollable($parent)) {
                $scrollable = $parent;
                return true;
            }
        });
        return $scrollable;
    },
    _defaultActionArgs: function() {
        var args = this.callBase.apply(this, arguments);
        var component = this.option("component");
        if (component) {
            args.component = component;
            args.element = component.element();
        }
        return args;
    },
    _getEventArgs: function(e) {
        var sourceDraggable = this._getSourceDraggable();
        var targetDraggable = this._getTargetDraggable();
        return {
            event: e,
            itemData: sourceDraggable.option("itemData"),
            itemElement: $1314eb17fd30e980$require$getPublicElement(sourceDraggable._$sourceElement),
            fromComponent: sourceDraggable.option("component") || sourceDraggable,
            toComponent: targetDraggable.option("component") || targetDraggable,
            fromData: sourceDraggable.option("data"),
            toData: targetDraggable.option("data")
        };
    },
    _getDragStartArgs: function(e, $itemElement) {
        var args = this._getEventArgs(e);
        return {
            event: args.event,
            itemData: args.itemData,
            itemElement: $itemElement,
            fromData: args.fromData
        };
    },
    _revertItemToInitialPosition: function() {
        !this._dragElementIsCloned() && this._move(this._initialLocate, this._$sourceElement);
    },
    _dragEndHandler: function(e) {
        var _this3 = this;
        var d = new $1314eb17fd30e980$var$Deferred;
        var dragEndEventArgs = this._getEventArgs(e);
        var dropEventArgs = this._getEventArgs(e);
        var targetDraggable = this._getTargetDraggable();
        var needRevertPosition = true;
        try {
            this._getAction("onDragEnd")(dragEndEventArgs);
        } finally{
            $1314eb17fd30e980$var$when($1314eb17fd30e980$var$fromPromise(dragEndEventArgs.cancel)).done(function(cancel) {
                if (!cancel) {
                    if (targetDraggable !== _this3) targetDraggable._getAction("onDrop")(dropEventArgs);
                    if (!dropEventArgs.cancel) {
                        needRevertPosition = false;
                        $1314eb17fd30e980$var$when($1314eb17fd30e980$var$fromPromise(targetDraggable.dragEnd(dragEndEventArgs))).always(d.resolve);
                        return;
                    }
                }
                d.resolve();
            }).fail(d.resolve);
            d.done(function() {
                if (needRevertPosition) _this3._revertItemToInitialPosition();
                _this3.reset();
                targetDraggable.reset();
                _this3._stopAnimator();
                _this3._horizontalScrollHelper.reset();
                _this3._verticalScrollHelper.reset();
                _this3._resetDragElement();
                _this3._resetSourceElement();
                _this3._resetTargetDraggable();
                _this3._resetSourceDraggable();
            });
        }
    },
    _isTargetOverAnotherDraggable: function(e) {
        var _this4 = this;
        var sourceDraggable = this._getSourceDraggable();
        if (this === sourceDraggable) return false;
        if (!sourceDraggable._dragElementIsCloned()) return true;
        var $sourceDraggableElement = sourceDraggable.$element();
        var elements = this.getElementsFromPoint({
            x: e.pageX,
            y: e.pageY
        }, e.target);
        var firstWidgetElement = elements.filter(function(element) {
            return $jFnCG(element).hasClass(_this4._addWidgetPrefix());
        })[0];
        return firstWidgetElement !== $sourceDraggableElement.get(0);
    },
    _dragEnterHandler: function(e) {
        if (this._isTargetOverAnotherDraggable(e)) this._setTargetDraggable();
        var sourceDraggable = this._getSourceDraggable();
        sourceDraggable.dragEnter(e);
    },
    _dragLeaveHandler: function(e) {
        this._resetTargetDraggable();
        if (this !== this._getSourceDraggable()) this.reset();
        var sourceDraggable = this._getSourceDraggable();
        sourceDraggable.dragLeave(e);
    },
    _getAction: function(name) {
        return this["_" + name + "Action"] || this._createActionByOption(name);
    },
    _getAnonymousTemplateName: function() {
        return "content";
    },
    _initTemplates: function() {
        if (!this.option("contentTemplate")) return;
        this.callBase.apply(this, arguments);
        this._defaultTemplates.content = new $1314eb17fd30e980$require$EmptyTemplate;
    },
    _render: function() {
        this.callBase();
        this.$element().addClass(this._addWidgetPrefix());
        var transclude = this._getAnonymousTemplateName() === this.option("contentTemplate");
        var template = this._getTemplateByOption("contentTemplate");
        if (template) $jFnCG(template.render({
            container: this.element(),
            transclude: transclude
        }));
    },
    _optionChanged: function(args) {
        var name = args.name;
        switch(name){
            case "onDragStart":
            case "onDragMove":
            case "onDragEnd":
            case "onDrop":
                this["_" + name + "Action"] = this._createActionByOption(name);
                break;
            case "dragTemplate":
            case "contentTemplate":
            case "container":
            case "clone":
                break;
            case "allowMoveByClick":
            case "dragDirection":
            case "disabled":
            case "boundary":
            case "filter":
            case "immediate":
                this._resetDragElement();
                this._detachEventHandlers();
                this._attachEventHandlers();
                break;
            case "autoScroll":
                this._verticalScrollHelper.reset();
                this._horizontalScrollHelper.reset();
                break;
            case "scrollSensitivity":
            case "scrollSpeed":
            case "boundOffset":
            case "handle":
            case "group":
            case "data":
            case "itemData":
                break;
            default:
                this.callBase(args);
        }
    },
    _getTargetDraggable: function() {
        return $1314eb17fd30e980$var$targetDraggable || this;
    },
    _getSourceDraggable: function() {
        return $1314eb17fd30e980$var$sourceDraggable || this;
    },
    _setTargetDraggable: function() {
        var currentGroup = this.option("group");
        var sourceDraggable = this._getSourceDraggable();
        if (currentGroup && currentGroup === sourceDraggable.option("group")) $1314eb17fd30e980$var$targetDraggable = this;
    },
    _setSourceDraggable: function() {
        $1314eb17fd30e980$var$sourceDraggable = this;
    },
    _resetSourceDraggable: function() {
        $1314eb17fd30e980$var$sourceDraggable = null;
    },
    _resetTargetDraggable: function() {
        $1314eb17fd30e980$var$targetDraggable = null;
    },
    _dispose: function() {
        this.callBase();
        this._detachEventHandlers();
        this._resetDragElement();
        this._resetTargetDraggable();
        this._resetSourceDraggable();
        this._$sourceElement = null;
        this._stopAnimator();
    }
});
$4ZFRo($1314eb17fd30e980$var$DRAGGABLE, $1314eb17fd30e980$var$Draggable);
$1314eb17fd30e980$exports = $1314eb17fd30e980$var$Draggable;
$1314eb17fd30e980$exports.default = $1314eb17fd30e980$exports;


var $4511cc2bbc1b21c2$var$_draggable2 = $4511cc2bbc1b21c2$var$_interopRequireDefault($1314eb17fd30e980$exports);

var $5OzEX = parcelRequire("5OzEX");

var $irv64 = parcelRequire("irv64");

var $1TtsA = parcelRequire("1TtsA");

var $6jr65 = parcelRequire("6jr65");
var $4511cc2bbc1b21c2$var$_translator2 = $4511cc2bbc1b21c2$var$_interopRequireDefault($6jr65);

var $c7ml4 = parcelRequire("c7ml4");
var $4511cc2bbc1b21c2$var$_fx2 = $4511cc2bbc1b21c2$var$_interopRequireDefault($c7ml4);

var $2F60d = parcelRequire("2F60d");
function $4511cc2bbc1b21c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $4511cc2bbc1b21c2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $4511cc2bbc1b21c2$var$SORTABLE = "dxSortable";
var $4511cc2bbc1b21c2$var$PLACEHOLDER_CLASS = "placeholder";
var $4511cc2bbc1b21c2$var$CLONE_CLASS = "clone";
var $4511cc2bbc1b21c2$var$isElementVisible = function(itemElement) {
    return (0, $4511cc2bbc1b21c2$var$_renderer2.default)(itemElement).is(":visible");
};
var $4511cc2bbc1b21c2$var$Sortable = $4511cc2bbc1b21c2$var$_draggable2.default.inherit({
    _getDefaultOptions: function() {
        return (0, $7I8Uw.extend)(this.callBase(), {
            clone: true,
            filter: "> *",
            itemOrientation: "vertical",
            dropFeedbackMode: "push",
            allowDropInsideItem: false,
            allowReordering: true,
            moveItemOnDrop: false,
            onDragChange: null,
            onAdd: null,
            onRemove: null,
            onReorder: null,
            onPlaceholderPrepared: null,
            animation: {
                type: "slide",
                duration: 300
            },
            fromIndex: null,
            toIndex: null,
            dropInsideItem: false,
            itemPoints: null
        });
    },
    reset: function() {
        this.option({
            dropInsideItem: false,
            toIndex: null,
            fromIndex: null
        });
        if (this._$placeholderElement) this._$placeholderElement.remove();
        this._$placeholderElement = null;
        if (!this._isIndicateMode() && this._$modifiedItem) {
            this._$modifiedItem.css("marginBottom", this._modifiedItemMargin);
            this._$modifiedItem = null;
        }
    },
    _getPrevVisibleItem: function(items, index) {
        return items.slice(0, index).reverse().filter($4511cc2bbc1b21c2$var$isElementVisible)[0];
    },
    _dragStartHandler: function(e) {
        this.callBase.apply(this, arguments);
        if (true === e.cancel) return;
        var $sourceElement = this._getSourceElement();
        this._updateItemPoints();
        this.option("fromIndex", this._getElementIndex($sourceElement));
    },
    _dragEnterHandler: function() {
        this.callBase.apply(this, arguments);
        if (this === this._getSourceDraggable()) return;
        this._updateItemPoints();
        this.option("fromIndex", -1);
        if (!this._isIndicateMode()) {
            var itemPoints = this.option("itemPoints");
            var lastItemPoint = itemPoints[itemPoints.length - 1];
            if (lastItemPoint) {
                var $element = this.$element();
                var $sourceElement = this._getSourceElement();
                var isVertical = this._isVerticalOrientation();
                var sourceElementSize = isVertical ? $sourceElement.outerHeight(true) : $sourceElement.outerWidth(true);
                var scrollSize = $element.get(0)[isVertical ? "scrollHeight" : "scrollWidth"];
                var scrollPosition = $element.get(0)[isVertical ? "scrollTop" : "scrollLeft"];
                var positionProp = isVertical ? "top" : "left";
                var lastPointPosition = lastItemPoint[positionProp];
                var elementPosition = $element.offset()[positionProp];
                var freeSize = elementPosition + scrollSize - scrollPosition - lastPointPosition;
                if (freeSize < sourceElementSize) {
                    if (isVertical) {
                        var items = this._getItems();
                        var $lastItem = (0, $4511cc2bbc1b21c2$var$_renderer2.default)(this._getPrevVisibleItem(items));
                        this._$modifiedItem = $lastItem;
                        this._modifiedItemMargin = $lastItem.get(0).style.marginBottom;
                        $lastItem.css("marginBottom", sourceElementSize - freeSize);
                        var $sortable = $lastItem.closest(".dx-sortable");
                        var sortable = $sortable.data("dxScrollable") || $sortable.data("dxScrollView");
                        sortable && sortable.update();
                    }
                }
            }
        }
    },
    dragEnter: function() {
        if (this === this._getTargetDraggable()) this.option("toIndex", this.option("fromIndex"));
        else this.option("toIndex", -1);
    },
    dragLeave: function() {
        if (this === this._getTargetDraggable()) this.option("toIndex", -1);
        else this.option("toIndex", this.option("fromIndex"));
    },
    _isInsideTargetDraggable: function(event) {
        var $targetDraggable = this._getTargetDraggable().$element();
        var $scrollable = this._getScrollable($targetDraggable);
        if ($scrollable) {
            var offset = $scrollable.offset();
            var validY = offset.top + $scrollable.height() >= event.pageY && offset.top <= event.pageY;
            var validX = offset.left + $scrollable.width() >= event.pageX && offset.left <= event.pageX;
            return validY && validX;
        }
        return true;
    },
    dragEnd: function(sourceEvent) {
        var $sourceElement = this._getSourceElement();
        var sourceDraggable = this._getSourceDraggable();
        var isSourceDraggable = sourceDraggable.NAME !== this.NAME;
        var toIndex = this.option("toIndex");
        var isInsideTargetDraggable = this._isInsideTargetDraggable(sourceEvent.event);
        if (null !== toIndex && toIndex >= 0 && isInsideTargetDraggable) {
            var cancelAdd;
            var cancelRemove;
            if (sourceDraggable !== this) {
                cancelAdd = this._fireAddEvent(sourceEvent);
                if (!cancelAdd) cancelRemove = this._fireRemoveEvent(sourceEvent);
            }
            if (isSourceDraggable) $4511cc2bbc1b21c2$var$_translator2.default.resetPosition($sourceElement);
            if (this.option("moveItemOnDrop")) !cancelAdd && this._moveItem($sourceElement, toIndex, cancelRemove);
            if (sourceDraggable === this) return this._fireReorderEvent(sourceEvent);
        }
        return (new $2F60d.Deferred).resolve();
    },
    dragMove: function(e) {
        var itemPoints = this.option("itemPoints");
        if (!itemPoints) return;
        var isVertical = this._isVerticalOrientation();
        var axisName = isVertical ? "top" : "left";
        var cursorPosition = isVertical ? e.pageY : e.pageX;
        var rtlEnabled = this.option("rtlEnabled");
        var itemPoint;
        for(var i = itemPoints.length - 1; i >= 0; i--){
            var centerPosition = itemPoints[i + 1] && (itemPoints[i][axisName] + itemPoints[i + 1][axisName]) / 2;
            if ((!isVertical && rtlEnabled ? cursorPosition > centerPosition : centerPosition > cursorPosition) || void 0 === centerPosition) itemPoint = itemPoints[i];
            else break;
        }
        if (itemPoint) {
            this._updatePlaceholderPosition(e, itemPoint);
            if (this._verticalScrollHelper.isScrolling() && this._isIndicateMode()) this._movePlaceholder();
        }
    },
    _isIndicateMode: function() {
        return "indicate" === this.option("dropFeedbackMode") || this.option("allowDropInsideItem");
    },
    _createPlaceholder: function() {
        var $placeholderContainer;
        if (this._isIndicateMode()) $placeholderContainer = (0, $4511cc2bbc1b21c2$var$_renderer2.default)("<div>").addClass(this._addWidgetPrefix($4511cc2bbc1b21c2$var$PLACEHOLDER_CLASS)).insertBefore(this._getSourceDraggable()._$dragElement);
        this._$placeholderElement = $placeholderContainer;
        return $placeholderContainer;
    },
    _getItems: function() {
        var itemsSelector = this._getItemsSelector();
        return this._$content().find(itemsSelector).not("." + this._addWidgetPrefix($4511cc2bbc1b21c2$var$PLACEHOLDER_CLASS)).not("." + this._addWidgetPrefix($4511cc2bbc1b21c2$var$CLONE_CLASS)).toArray();
    },
    _allowReordering: function() {
        var sourceDraggable = this._getSourceDraggable();
        var targetDraggable = this._getTargetDraggable();
        return sourceDraggable !== targetDraggable || this.option("allowReordering");
    },
    _isValidPoint: function(visibleIndex, draggableVisibleIndex, dropInsideItem) {
        var allowDropInsideItem = this.option("allowDropInsideItem");
        var allowReordering = dropInsideItem || this._allowReordering();
        if (!allowReordering && (0 !== visibleIndex || !allowDropInsideItem)) return false;
        if (!this._isIndicateMode()) return true;
        return draggableVisibleIndex === -1 || visibleIndex !== draggableVisibleIndex && (dropInsideItem || visibleIndex !== draggableVisibleIndex + 1);
    },
    _getItemPoints: function() {
        var that = this;
        var result = [];
        var $item;
        var offset;
        var itemWidth;
        var rtlEnabled = that.option("rtlEnabled");
        var isVertical = that._isVerticalOrientation();
        var itemElements = that._getItems();
        var visibleItemElements = itemElements.filter($4511cc2bbc1b21c2$var$isElementVisible);
        var visibleItemCount = visibleItemElements.length;
        var $draggableItem = this._getDraggableElement();
        var draggableVisibleIndex = visibleItemElements.indexOf($draggableItem.get(0));
        if (visibleItemCount) {
            for(var i = 0; i <= visibleItemCount; i++){
                var needCorrectLeftPosition = !isVertical && rtlEnabled ^ i === visibleItemCount;
                var needCorrectTopPosition = isVertical && i === visibleItemCount;
                if (i < visibleItemCount) {
                    $item = (0, $4511cc2bbc1b21c2$var$_renderer2.default)(visibleItemElements[i]);
                    offset = $item.offset();
                    itemWidth = $item.outerWidth();
                }
                result.push({
                    dropInsideItem: false,
                    left: offset.left + (needCorrectLeftPosition ? itemWidth : 0),
                    top: offset.top + (needCorrectTopPosition ? result[i - 1].height : 0),
                    index: i === visibleItemCount ? itemElements.length : itemElements.indexOf($item.get(0)),
                    $item: $item,
                    width: $item.outerWidth(),
                    height: $item.outerHeight(),
                    isValid: that._isValidPoint(i, draggableVisibleIndex)
                });
            }
            if (this.option("allowDropInsideItem")) {
                var points = result;
                result = [];
                for(var _i = 0; _i < points.length; _i++){
                    result.push(points[_i]);
                    if (points[_i + 1]) result.push((0, $7I8Uw.extend)({}, points[_i], {
                        dropInsideItem: true,
                        top: Math.floor((points[_i].top + points[_i + 1].top) / 2),
                        left: Math.floor((points[_i].left + points[_i + 1].left) / 2),
                        isValid: this._isValidPoint(_i, draggableVisibleIndex, true)
                    }));
                }
            }
        } else result.push({
            dropInsideItem: false,
            index: 0,
            isValid: true
        });
        return result;
    },
    _updateItemPoints: function() {
        this.option("itemPoints", this._getItemPoints());
    },
    _getElementIndex: function($itemElement) {
        return this._getItems().indexOf($itemElement.get(0));
    },
    _getDragTemplateArgs: function($element) {
        var args = this.callBase.apply(this, arguments);
        args.model.fromIndex = this._getElementIndex($element);
        return args;
    },
    _togglePlaceholder: function(value) {
        this._$placeholderElement && this._$placeholderElement.toggle(value);
    },
    _isVerticalOrientation: function() {
        return "vertical" === this.option("itemOrientation");
    },
    _normalizeToIndex: function(toIndex, dropInsideItem) {
        var isAnotherDraggable = this._getSourceDraggable() !== this._getTargetDraggable();
        var fromIndex = this.option("fromIndex");
        if (null === toIndex) return fromIndex;
        return Math.max(isAnotherDraggable || fromIndex >= toIndex || dropInsideItem ? toIndex : toIndex - 1, 0);
    },
    _updatePlaceholderPosition: function(e, itemPoint) {
        var sourceDraggable = this._getSourceDraggable();
        var toIndex = this._normalizeToIndex(itemPoint.index, itemPoint.dropInsideItem);
        var eventArgs = (0, $7I8Uw.extend)(this._getEventArgs(e), {
            toIndex: toIndex,
            dropInsideItem: itemPoint.dropInsideItem
        });
        itemPoint.isValid && this._getAction("onDragChange")(eventArgs);
        if (eventArgs.cancel || !itemPoint.isValid) {
            if (!itemPoint.isValid) this.option({
                dropInsideItem: false,
                toIndex: null
            });
            return;
        }
        this.option({
            dropInsideItem: itemPoint.dropInsideItem,
            toIndex: itemPoint.index
        });
        this._getAction("onPlaceholderPrepared")((0, $7I8Uw.extend)(this._getEventArgs(e), {
            placeholderElement: (0, $5OzEX.getPublicElement)(this._$placeholderElement),
            dragElement: (0, $5OzEX.getPublicElement)(sourceDraggable._$dragElement)
        }));
        this._updateItemPoints();
    },
    _makeWidthCorrection: function($item, width) {
        this._$scrollable = this._getScrollable($item);
        if (this._$scrollable && this._$scrollable.width() < width) {
            var scrollableWidth = this._$scrollable.width();
            var offsetLeft = $item.offset().left - this._$scrollable.offset().left;
            var offsetRight = scrollableWidth - $item.outerWidth() - offsetLeft;
            if (offsetLeft > 0) width = scrollableWidth - offsetLeft;
            else if (offsetRight > 0) width = scrollableWidth - offsetRight;
            else width = scrollableWidth;
        }
        return width;
    },
    _updatePlaceholderSizes: function($placeholderElement, itemElement) {
        var that = this;
        var dropInsideItem = that.option("dropInsideItem");
        var $item = itemElement ? (0, $4511cc2bbc1b21c2$var$_renderer2.default)(itemElement) : that._getSourceElement();
        var isVertical = that._isVerticalOrientation();
        var width = "";
        var height = "";
        $placeholderElement.toggleClass(that._addWidgetPrefix("placeholder-inside"), dropInsideItem);
        if (isVertical || dropInsideItem) width = $item.outerWidth();
        if (!isVertical || dropInsideItem) height = $item.outerHeight();
        width = that._makeWidthCorrection($item, width);
        $placeholderElement.css({
            width: width,
            height: height
        });
    },
    _moveItem: function($itemElement, index, cancelRemove) {
        var $prevTargetItemElement;
        var $itemElements = this._getItems();
        var $targetItemElement = $itemElements[index];
        var sourceDraggable = this._getSourceDraggable();
        if (cancelRemove) {
            $itemElement = $itemElement.clone();
            sourceDraggable._toggleDragSourceClass(false, $itemElement);
        }
        if (!$targetItemElement) $prevTargetItemElement = $itemElements[index - 1];
        this._moveItemCore($itemElement, $targetItemElement, $prevTargetItemElement);
    },
    _moveItemCore: function($targetItem, item, prevItem) {
        if (!item && !prevItem) $targetItem.appendTo(this.$element());
        else if (prevItem) $targetItem.insertAfter((0, $4511cc2bbc1b21c2$var$_renderer2.default)(prevItem));
        else $targetItem.insertBefore((0, $4511cc2bbc1b21c2$var$_renderer2.default)(item));
    },
    _getDragStartArgs: function(e, $itemElement) {
        return (0, $7I8Uw.extend)(this.callBase.apply(this, arguments), {
            fromIndex: this._getElementIndex($itemElement)
        });
    },
    _getEventArgs: function(e) {
        var sourceDraggable = this._getSourceDraggable();
        var targetDraggable = this._getTargetDraggable();
        var dropInsideItem = targetDraggable.option("dropInsideItem");
        return (0, $7I8Uw.extend)(this.callBase.apply(this, arguments), {
            fromIndex: sourceDraggable.option("fromIndex"),
            toIndex: this._normalizeToIndex(targetDraggable.option("toIndex"), dropInsideItem),
            dropInsideItem: dropInsideItem
        });
    },
    _optionChanged: function(args) {
        var _this = this;
        var name = args.name;
        switch(name){
            case "onDragChange":
            case "onPlaceholderPrepared":
            case "onAdd":
            case "onRemove":
            case "onReorder":
                this["_" + name + "Action"] = this._createActionByOption(name);
                break;
            case "itemOrientation":
            case "allowDropInsideItem":
            case "moveItemOnDrop":
            case "dropFeedbackMode":
            case "itemPoints":
            case "animation":
            case "allowReordering":
                break;
            case "fromIndex":
                if (!this._$sourceElement) [
                    false,
                    true
                ].forEach(function(isDragSource) {
                    var fromIndex = isDragSource ? args.value : args.previousValue;
                    if (null !== fromIndex) {
                        var $fromElement = (0, $4511cc2bbc1b21c2$var$_renderer2.default)(_this._getItems()[fromIndex]);
                        _this._toggleDragSourceClass(isDragSource, $fromElement);
                    }
                });
                break;
            case "dropInsideItem":
                this._optionChangedDropInsideItem(args);
                break;
            case "toIndex":
                this._optionChangedToIndex(args);
                break;
            default:
                this.callBase(args);
        }
    },
    _optionChangedDropInsideItem: function() {
        if (this._isIndicateMode() && this._$placeholderElement) this._movePlaceholder();
    },
    _isPositionVisible: function(position) {
        var $element = this.$element();
        var scrollContainer;
        if ("hidden" !== $element.css("overflow")) scrollContainer = $element.get(0);
        else $element.parents().each(function() {
            if ("visible" !== (0, $4511cc2bbc1b21c2$var$_renderer2.default)(this).css("overflow")) {
                scrollContainer = this;
                return false;
            }
        });
        if (scrollContainer) {
            var clientRect = (0, $1TtsA.getBoundingRect)(scrollContainer);
            var isVerticalOrientation = this._isVerticalOrientation();
            var start = isVerticalOrientation ? "top" : "left";
            var end = isVerticalOrientation ? "bottom" : "right";
            var window = (0, $irv64.getWindow)();
            var pageOffset = isVerticalOrientation ? window.pageYOffset : window.pageXOffset;
            if (position[start] < clientRect[start] + pageOffset || position[start] > clientRect[end] + pageOffset) return false;
        }
        return true;
    },
    _optionChangedToIndex: function(args) {
        var toIndex = args.value;
        if (this._isIndicateMode()) {
            var showPlaceholder = null !== toIndex && toIndex >= 0;
            this._togglePlaceholder(showPlaceholder);
            if (showPlaceholder) this._movePlaceholder();
        } else this._moveItems(args.previousValue, args.value);
    },
    _makeLeftCorrection: function(left, leftMargin) {
        var that = this;
        var $scrollable = that._$scrollable;
        if ($scrollable && that._isVerticalOrientation() && $scrollable.scrollLeft() > leftMargin) left += $scrollable.scrollLeft() - leftMargin;
        return left;
    },
    _movePlaceholder: function() {
        var that = this;
        var $placeholderElement = that._$placeholderElement || that._createPlaceholder();
        var items = that._getItems();
        var toIndex = that.option("toIndex");
        var itemElement = items[toIndex];
        var isVerticalOrientation = that._isVerticalOrientation();
        var rtlEnabled = this.option("rtlEnabled");
        var dropInsideItem = that.option("dropInsideItem");
        var position = null;
        var leftMargin = 0;
        that._updatePlaceholderSizes($placeholderElement, itemElement);
        if (itemElement) {
            var $itemElement = (0, $4511cc2bbc1b21c2$var$_renderer2.default)(itemElement);
            position = $itemElement.offset();
            leftMargin = parseFloat($itemElement.css("marginLeft"));
            if (!isVerticalOrientation && rtlEnabled && !dropInsideItem) position.left += $itemElement.outerWidth(true);
        } else {
            var prevVisibleItemElement = this._getPrevVisibleItem(items, toIndex);
            if (prevVisibleItemElement) {
                position = (0, $4511cc2bbc1b21c2$var$_renderer2.default)(prevVisibleItemElement).offset();
                if (isVerticalOrientation) position.top += (0, $4511cc2bbc1b21c2$var$_renderer2.default)(prevVisibleItemElement).outerHeight(true);
                else if (!rtlEnabled) position.left += (0, $4511cc2bbc1b21c2$var$_renderer2.default)(prevVisibleItemElement).outerWidth(true);
            }
        }
        if (position && !that._isPositionVisible(position)) position = null;
        if (position) {
            position.left = that._makeLeftCorrection(position.left, leftMargin);
            that._move(position, $placeholderElement);
        }
        $placeholderElement.toggle(!!position);
    },
    _getPositions: function(items, elementSize, fromIndex, toIndex) {
        var positions = [];
        for(var i = 0; i < items.length; i++){
            var position = 0;
            if (null === toIndex || null === fromIndex) {
                positions.push(position);
                continue;
            }
            if (fromIndex === -1) {
                if (i >= toIndex) position = elementSize;
            } else {
                if (toIndex === -1) {
                    if (i > fromIndex) position = -elementSize;
                } else {
                    if (fromIndex < toIndex) {
                        if (i > fromIndex && i < toIndex) position = -elementSize;
                    } else {
                        if (fromIndex > toIndex) {
                            if (i >= toIndex && i < fromIndex) position = elementSize;
                        }
                    }
                }
            }
            positions.push(position);
        }
        return positions;
    },
    _moveItems: function(prevToIndex, toIndex) {
        var fromIndex = this.option("fromIndex");
        var isVerticalOrientation = this._isVerticalOrientation();
        var positionPropName = isVerticalOrientation ? "top" : "left";
        var $draggableItem = this._getDraggableElement();
        var elementSize = isVerticalOrientation ? ($draggableItem.outerHeight() + $draggableItem.outerHeight(true)) / 2 : ($draggableItem.outerWidth() + $draggableItem.outerWidth(true)) / 2;
        var items = this._getItems();
        var prevPositions = this._getPositions(items, elementSize, fromIndex, prevToIndex);
        var positions = this._getPositions(items, elementSize, fromIndex, toIndex);
        var animationConfig = this.option("animation");
        var rtlEnabled = this.option("rtlEnabled");
        for(var i = 0; i < items.length; i++){
            var $item = (0, $4511cc2bbc1b21c2$var$_renderer2.default)(items[i]);
            var prevPosition = prevPositions[i];
            var position = positions[i];
            if (null === toIndex || null === fromIndex) {
                $4511cc2bbc1b21c2$var$_fx2.default.stop($item);
                $4511cc2bbc1b21c2$var$_translator2.default.resetPosition($item);
            } else if (prevPosition !== position) {
                $4511cc2bbc1b21c2$var$_fx2.default.stop($item);
                $4511cc2bbc1b21c2$var$_fx2.default.animate($item, (0, $7I8Uw.extend)({}, animationConfig, {
                    to: $4511cc2bbc1b21c2$var$_defineProperty({}, positionPropName, !isVerticalOrientation && rtlEnabled ? -position : position)
                }));
            }
        }
    },
    _toggleDragSourceClass: function(value, $element) {
        var $sourceElement = $element || this._$sourceElement;
        this.callBase.apply(this, arguments);
        if (!this._isIndicateMode()) $sourceElement && $sourceElement.toggleClass(this._addWidgetPrefix("source-hidden"), value);
    },
    _dispose: function() {
        this.reset();
        this.callBase();
    },
    _fireAddEvent: function(sourceEvent) {
        var args = this._getEventArgs(sourceEvent);
        this._getAction("onAdd")(args);
        return args.cancel;
    },
    _fireRemoveEvent: function(sourceEvent) {
        var sourceDraggable = this._getSourceDraggable();
        var args = this._getEventArgs(sourceEvent);
        sourceDraggable._getAction("onRemove")(args);
        return args.cancel;
    },
    _fireReorderEvent: function(sourceEvent) {
        var args = this._getEventArgs(sourceEvent);
        this._getAction("onReorder")(args);
        return args.promise || (new $2F60d.Deferred).resolve();
    }
});
(0, $4511cc2bbc1b21c2$var$_component_registrator2.default)($4511cc2bbc1b21c2$var$SORTABLE, $4511cc2bbc1b21c2$var$Sortable);
$4511cc2bbc1b21c2$exports = $4511cc2bbc1b21c2$var$Sortable;
$4511cc2bbc1b21c2$exports.default = $4511cc2bbc1b21c2$exports;


var $aa311ccc821afd34$var$_sortable2 = $aa311ccc821afd34$var$_interopRequireDefault($4511cc2bbc1b21c2$exports);
function $aa311ccc821afd34$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $aa311ccc821afd34$var$REORDER_HANDLE_CONTAINER_CLASS = "dx-list-reorder-handle-container";
var $aa311ccc821afd34$var$REORDER_HANDLE_CLASS = "dx-list-reorder-handle";
var $aa311ccc821afd34$var$REORDERING_ITEM_GHOST_CLASS = "dx-list-item-ghost-reordering";
var $aa311ccc821afd34$var$STATE_HOVER_CLASS = "dx-state-hover";
(0, $3dd45f8e64379297$export$6503ec6e8aabbaf)("reorder", "default", $aa311ccc821afd34$var$_uiListEdit3.default.inherit({
    _init: function() {
        var list = this._list;
        this._groupedEnabled = this._list.option("grouped");
        this._lockedDrag = false;
        var filter = this._groupedEnabled ? "> .dx-list-group > .dx-list-group-body > .dx-list-item" : "> .dx-list-item";
        this._sortable = list._createComponent(list._scrollView.content(), $aa311ccc821afd34$var$_sortable2.default, (0, $7I8Uw.extend)({
            component: list,
            contentTemplate: null,
            allowReordering: false,
            filter: filter,
            container: list.$element(),
            dragDirection: list.option("itemDragging.group") ? "both" : "vertical",
            handle: ".".concat($aa311ccc821afd34$var$REORDER_HANDLE_CLASS),
            dragTemplate: this._dragTemplate,
            onDragStart: this._dragStartHandler.bind(this),
            onDragChange: this._dragChangeHandler.bind(this),
            onReorder: this._reorderHandler.bind(this)
        }, list.option("itemDragging")));
    },
    _dragTemplate: function(e) {
        return (0, $aa311ccc821afd34$var$_renderer2.default)(e.itemElement).clone().width((0, $aa311ccc821afd34$var$_renderer2.default)(e.itemElement).width()).addClass($aa311ccc821afd34$var$REORDERING_ITEM_GHOST_CLASS).addClass($aa311ccc821afd34$var$STATE_HOVER_CLASS).toggleClass("dx-rtl", this.option("rtlEnabled"));
    },
    _dragStartHandler: function(e) {
        if (this._lockedDrag) {
            e.cancel = true;
            return;
        }
    },
    _dragChangeHandler: function(e) {
        if (this._groupedEnabled && !this._sameParent(e.fromIndex, e.toIndex)) {
            e.cancel = true;
            return;
        }
    },
    _sameParent: function(fromIndex, toIndex) {
        var $dragging = this._list.getItemElementByFlatIndex(fromIndex);
        var $over = this._list.getItemElementByFlatIndex(toIndex);
        return $over.parent().get(0) === $dragging.parent().get(0);
    },
    _reorderHandler: function(e) {
        var $targetElement = this._list.getItemElementByFlatIndex(e.toIndex);
        this._list.reorderItem((0, $aa311ccc821afd34$var$_renderer2.default)(e.itemElement), $targetElement);
    },
    afterBag: function(config) {
        var _this = this;
        var $handle = (0, $aa311ccc821afd34$var$_renderer2.default)("<div>").addClass($aa311ccc821afd34$var$REORDER_HANDLE_CLASS);
        $aa311ccc821afd34$var$_events_engine2.default.on($handle, "dxpointerdown", function(e) {
            _this._lockedDrag = !(0, $bXb2w.isMouseEvent)(e);
        });
        $aa311ccc821afd34$var$_events_engine2.default.on($handle, "dxhold", {
            timeout: 30
        }, function(e) {
            e.cancel = true;
            _this._lockedDrag = false;
        });
        config.$container.addClass($aa311ccc821afd34$var$REORDER_HANDLE_CONTAINER_CLASS).append($handle);
    }
}));


var $dc18b7fa1613351a$var$editOptionsRegistry = [];
var $dc18b7fa1613351a$var$registerOption = function(enabledFunc, decoratorTypeFunc, decoratorSubTypeFunc) {
    $dc18b7fa1613351a$var$editOptionsRegistry.push({
        enabled: enabledFunc,
        decoratorType: decoratorTypeFunc,
        decoratorSubType: decoratorSubTypeFunc
    });
};
$dc18b7fa1613351a$var$registerOption(function() {
    return this.option("menuItems").length;
}, function() {
    return "menu";
}, function() {
    return this.option("menuMode");
});
$dc18b7fa1613351a$var$registerOption(function() {
    return !this.option("menuItems").length && this.option("allowItemDeleting");
}, function() {
    var mode = this.option("itemDeleteMode");
    return "toggle" === mode || "slideButton" === mode || "swipe" === mode || "static" === mode ? "delete" : "menu";
}, function() {
    var mode = this.option("itemDeleteMode");
    if ("slideItem" === mode) mode = "slide";
    if ("hold" === mode) mode = "context";
    return mode;
});
$dc18b7fa1613351a$var$registerOption(function() {
    return "none" !== this.option("selectionMode") && this.option("showSelectionControls");
}, function() {
    return "selection";
}, function() {
    return "default";
});
$dc18b7fa1613351a$var$registerOption(function() {
    return this.option("itemDragging.allowReordering") || this.option("itemDragging.allowDropInsideItem") || this.option("itemDragging.group");
}, function() {
    return "reorder";
}, function() {
    return "default";
});
var $dc18b7fa1613351a$var$LIST_ITEM_BEFORE_BAG_CLASS = "dx-list-item-before-bag";
var $dc18b7fa1613351a$var$LIST_ITEM_AFTER_BAG_CLASS = "dx-list-item-after-bag";
var $dc18b7fa1613351a$var$DECORATOR_BEFORE_BAG_CREATE_METHOD = "beforeBag";
var $dc18b7fa1613351a$var$DECORATOR_AFTER_BAG_CREATE_METHOD = "afterBag";
var $dc18b7fa1613351a$var$DECORATOR_MODIFY_ELEMENT_METHOD = "modifyElement";
var $dc18b7fa1613351a$var$DECORATOR_AFTER_RENDER_METHOD = "afterRender";
var $dc18b7fa1613351a$var$DECORATOR_GET_EXCLUDED_SELECTORS_METHOD = "getExcludedSelectors";
var $dc18b7fa1613351a$var$EditProvider = $k7aJb.inherit({
    ctor: function(list) {
        this._list = list;
        this._fetchRequiredDecorators();
    },
    dispose: function() {
        if (this._decorators && this._decorators.length) $dc18b7fa1613351a$require$each(this._decorators, function(_, decorator) {
            decorator.dispose();
        });
    },
    _fetchRequiredDecorators: function() {
        this._decorators = [];
        $dc18b7fa1613351a$require$each($dc18b7fa1613351a$var$editOptionsRegistry, (function(_, option) {
            var optionEnabled = option.enabled.call(this._list);
            if (optionEnabled) {
                var decoratorType = option.decoratorType.call(this._list);
                var decoratorSubType = option.decoratorSubType.call(this._list);
                var decorator = this._createDecorator(decoratorType, decoratorSubType);
                this._decorators.push(decorator);
            }
        }).bind(this));
    },
    _createDecorator: function(type, subType) {
        var decoratorClass = this._findDecorator(type, subType);
        return new decoratorClass(this._list);
    },
    _findDecorator: function(type, subType) {
        var foundDecorator = $3dd45f8e64379297$export$4bb7493d241fd8a5[type][subType];
        if (!foundDecorator) throw $lrsNa.Error("E1012", type, subType);
        return foundDecorator;
    },
    modifyItemElement: function(args) {
        var $itemElement = $jFnCG(args.itemElement);
        var config = {
            $itemElement: $itemElement
        };
        this._prependBeforeBags($itemElement, config);
        this._appendAfterBags($itemElement, config);
        this._applyDecorators($dc18b7fa1613351a$var$DECORATOR_MODIFY_ELEMENT_METHOD, config);
    },
    afterItemsRendered: function() {
        this._applyDecorators($dc18b7fa1613351a$var$DECORATOR_AFTER_RENDER_METHOD);
    },
    _prependBeforeBags: function($itemElement, config) {
        var $beforeBags = this._collectDecoratorsMarkup($dc18b7fa1613351a$var$DECORATOR_BEFORE_BAG_CREATE_METHOD, config, $dc18b7fa1613351a$var$LIST_ITEM_BEFORE_BAG_CLASS);
        $itemElement.prepend($beforeBags);
    },
    _appendAfterBags: function($itemElement, config) {
        var $afterBags = this._collectDecoratorsMarkup($dc18b7fa1613351a$var$DECORATOR_AFTER_BAG_CREATE_METHOD, config, $dc18b7fa1613351a$var$LIST_ITEM_AFTER_BAG_CLASS);
        $itemElement.append($afterBags);
    },
    _collectDecoratorsMarkup: function(method, config, containerClass) {
        var $collector = $jFnCG("<div>");
        $dc18b7fa1613351a$require$each(this._decorators, function() {
            var $container = $jFnCG("<div>").addClass(containerClass);
            this[method]($dc18b7fa1613351a$require$extend({
                $container: $container
            }, config));
            if ($container.children().length) $collector.append($container);
        });
        return $collector.children();
    },
    _applyDecorators: function(method, config) {
        $dc18b7fa1613351a$require$each(this._decorators, function() {
            this[method](config);
        });
    },
    _handlerExists: function(name) {
        if (!this._decorators) return false;
        var decorators = this._decorators;
        var length = decorators.length;
        for(var i = 0; i < length; i++){
            if (decorators[i][name] !== $dc18b7fa1613351a$require$noop) return true;
        }
        return false;
    },
    _eventHandler: function(name, $itemElement, e) {
        if (!this._decorators) return false;
        var response = false;
        var decorators = this._decorators;
        var length = decorators.length;
        for(var i = 0; i < length; i++){
            response = decorators[i][name]($itemElement, e);
            if (response) break;
        }
        return response;
    },
    handleClick: function($itemElement, e) {
        return this._eventHandler("handleClick", $itemElement, e);
    },
    handleKeyboardEvents: function(currentFocusedIndex, moveFocusUp) {
        return this._eventHandler("handleKeyboardEvents", currentFocusedIndex, moveFocusUp);
    },
    handleEnterPressing: function() {
        return this._eventHandler("handleEnterPressing");
    },
    contextMenuHandlerExists: function() {
        return this._handlerExists("handleContextMenu");
    },
    handleContextMenu: function($itemElement, e) {
        return this._eventHandler("handleContextMenu", $itemElement, e);
    },
    getExcludedItemSelectors: function() {
        var excludedSelectors = [];
        this._applyDecorators($dc18b7fa1613351a$var$DECORATOR_GET_EXCLUDED_SELECTORS_METHOD, excludedSelectors);
        return excludedSelectors.join(",");
    }
});
$dc18b7fa1613351a$exports = $dc18b7fa1613351a$var$EditProvider;


var $a05b4d936a1dbd20$var$_uiListEdit2 = $a05b4d936a1dbd20$var$_interopRequireDefault($dc18b7fa1613351a$exports);

var $a05b4d936a1dbd20$var$_uiList2 = $a05b4d936a1dbd20$var$_interopRequireDefault($f8c15c4fd57b6899$exports);
function $a05b4d936a1dbd20$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $a05b4d936a1dbd20$var$LIST_ITEM_SELECTED_CLASS = "dx-list-item-selected";
var $a05b4d936a1dbd20$var$LIST_ITEM_RESPONSE_WAIT_CLASS = "dx-list-item-response-wait";
var $a05b4d936a1dbd20$var$ListEdit = $a05b4d936a1dbd20$var$_uiList2.default.inherit({
    _supportedKeys: function() {
        var _this = this;
        var that = this;
        var parent = this.callBase();
        var deleteFocusedItem = function(e) {
            if (that.option("allowItemDeleting")) {
                e.preventDefault();
                that.deleteItem(that.option("focusedElement"));
            }
        };
        var moveFocusedItem = function(e, moveUp) {
            var editStrategy = _this._editStrategy;
            var focusedElement = _this.option("focusedElement");
            var focusedItemIndex = editStrategy.getNormalizedIndex(focusedElement);
            var isLastIndexFocused = focusedItemIndex === _this._getLastItemIndex();
            if (isLastIndexFocused && _this._isDataSourceLoading()) return;
            if (e.shiftKey && that.option("itemDragging.allowReordering")) {
                var nextItemIndex = focusedItemIndex + (moveUp ? -1 : 1);
                var $nextItem = editStrategy.getItemElement(nextItemIndex);
                _this.reorderItem(focusedElement, $nextItem);
                _this.scrollToItem(focusedElement);
                e.preventDefault();
            } else {
                var editProvider = _this._editProvider;
                var isInternalMoving = editProvider.handleKeyboardEvents(focusedItemIndex, moveUp);
                if (!isInternalMoving) moveUp ? parent.upArrow(e) : parent.downArrow(e);
            }
        };
        var enter = function(e) {
            if (!this._editProvider.handleEnterPressing()) parent.enter.apply(this, arguments);
        };
        var space = function(e) {
            if (!this._editProvider.handleEnterPressing()) parent.space.apply(this, arguments);
        };
        return (0, $7I8Uw.extend)({}, parent, {
            del: deleteFocusedItem,
            upArrow: function(e) {
                return moveFocusedItem(e, true);
            },
            downArrow: moveFocusedItem,
            enter: enter,
            space: space
        });
    },
    _updateSelection: function() {
        this._editProvider.afterItemsRendered();
        this.callBase();
    },
    _getLastItemIndex: function() {
        return this._itemElements().length - 1;
    },
    _refreshItemElements: function() {
        this.callBase();
        var excludedSelectors = this._editProvider.getExcludedItemSelectors();
        if (excludedSelectors.length) this._itemElementsCache = this._itemElementsCache.not(excludedSelectors);
    },
    _setDeprecatedOptions: function() {
        this.callBase();
        (0, $7I8Uw.extend)(this._deprecatedOptions, {
            allowItemReordering: {
                since: "19.2",
                alias: "itemDragging.allowReordering"
            }
        });
    },
    _getDefaultOptions: function() {
        return (0, $7I8Uw.extend)(this.callBase(), {
            showSelectionControls: false,
            selectionMode: "none",
            selectAllMode: "page",
            onSelectAllValueChanged: null,
            selectAllText: (0, $cnVbh.format)("dxList-selectAll"),
            menuItems: [],
            menuMode: "context",
            allowItemDeleting: false,
            itemDeleteMode: "static",
            allowItemReordering: false,
            itemDragging: {}
        });
    },
    _defaultOptionsRules: function() {
        return this.callBase().concat([
            {
                device: function(_device) {
                    return "ios" === _device.platform;
                },
                options: {
                    menuMode: "slide",
                    itemDeleteMode: "slideItem"
                }
            },
            {
                device: {
                    platform: "android"
                },
                options: {
                    itemDeleteMode: "swipe"
                }
            }
        ]);
    },
    _init: function() {
        this.callBase();
        this._initEditProvider();
    },
    _initDataSource: function() {
        this.callBase();
        if (!this._isPageSelectAll()) this._dataSource && this._dataSource.requireTotalCount(true);
    },
    _isPageSelectAll: function() {
        return "page" === this.option("selectAllMode");
    },
    _initEditProvider: function() {
        this._editProvider = new $a05b4d936a1dbd20$var$_uiListEdit2.default(this);
    },
    _disposeEditProvider: function() {
        if (this._editProvider) this._editProvider.dispose();
    },
    _refreshEditProvider: function() {
        this._disposeEditProvider();
        this._initEditProvider();
    },
    _initEditStrategy: function() {
        if (this.option("grouped")) this._editStrategy = new $a05b4d936a1dbd20$var$_uiListEditStrategy2.default(this);
        else this.callBase();
    },
    _initMarkup: function() {
        this._refreshEditProvider();
        this.callBase();
    },
    _renderItems: function() {
        this.callBase.apply(this, arguments);
        this._editProvider.afterItemsRendered();
    },
    _selectedItemClass: function() {
        return $a05b4d936a1dbd20$var$LIST_ITEM_SELECTED_CLASS;
    },
    _itemResponseWaitClass: function() {
        return $a05b4d936a1dbd20$var$LIST_ITEM_RESPONSE_WAIT_CLASS;
    },
    _itemClickHandler: function(e) {
        var $itemElement = (0, $a05b4d936a1dbd20$var$_renderer2.default)(e.currentTarget);
        if ($itemElement.is(".dx-state-disabled, .dx-state-disabled *")) return;
        var handledByEditProvider = this._editProvider.handleClick($itemElement, e);
        if (handledByEditProvider) return;
        this.callBase.apply(this, arguments);
    },
    _shouldFireContextMenuEvent: function() {
        return this.callBase.apply(this, arguments) || this._editProvider.contextMenuHandlerExists();
    },
    _itemHoldHandler: function(e) {
        var $itemElement = (0, $a05b4d936a1dbd20$var$_renderer2.default)(e.currentTarget);
        if ($itemElement.is(".dx-state-disabled, .dx-state-disabled *")) return;
        var handledByEditProvider = (0, $bXb2w.isTouchEvent)(e) && this._editProvider.handleContextMenu($itemElement, e);
        if (handledByEditProvider) {
            e.handledByEditProvider = true;
            return;
        }
        this.callBase.apply(this, arguments);
    },
    _itemContextMenuHandler: function(e) {
        var $itemElement = (0, $a05b4d936a1dbd20$var$_renderer2.default)(e.currentTarget);
        if ($itemElement.is(".dx-state-disabled, .dx-state-disabled *")) return;
        var handledByEditProvider = !e.handledByEditProvider && this._editProvider.handleContextMenu($itemElement, e);
        if (handledByEditProvider) {
            e.preventDefault();
            return;
        }
        this.callBase.apply(this, arguments);
    },
    _postprocessRenderItem: function(args) {
        this.callBase.apply(this, arguments);
        this._editProvider.modifyItemElement(args);
    },
    _clean: function() {
        this._disposeEditProvider();
        this.callBase();
    },
    focusListItem: function(index) {
        var $item = this._editStrategy.getItemElement(index);
        this.option("focusedElement", $item);
        this.focus();
        this.scrollToItem(this.option("focusedElement"));
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "selectAllMode":
                this._initDataSource();
                this._dataSource.pageIndex(0);
                this._dataSource.load();
                break;
            case "grouped":
                this._clearSelectedItems();
                delete this._renderingGroupIndex;
                this._initEditStrategy();
                this.callBase(args);
                break;
            case "showSelectionControls":
            case "menuItems":
            case "menuMode":
            case "allowItemDeleting":
            case "itemDeleteMode":
            case "allowItemReordering":
            case "itemDragging":
            case "selectAllText":
                this._invalidate();
                break;
            case "onSelectAllValueChanged":
                break;
            default:
                this.callBase(args);
        }
    },
    selectAll: function() {
        return this._selection.selectAll(this._isPageSelectAll());
    },
    unselectAll: function() {
        return this._selection.deselectAll(this._isPageSelectAll());
    },
    isSelectAll: function() {
        return this._selection.getSelectAllState(this._isPageSelectAll());
    },
    getFlatIndexByItemElement: function(itemElement) {
        return this._itemElements().index(itemElement);
    },
    getItemElementByFlatIndex: function(flatIndex) {
        var $itemElements = this._itemElements();
        if (flatIndex < 0 || flatIndex >= $itemElements.length) return (0, $a05b4d936a1dbd20$var$_renderer2.default)();
        return $itemElements.eq(flatIndex);
    },
    getItemByIndex: function(index) {
        return this._editStrategy.getItemDataByIndex(index);
    }
});
$a05b4d936a1dbd20$exports = $a05b4d936a1dbd20$var$ListEdit;


var $001a89c010abd786$exports = {};
/**
 * DevExtreme (ui/widget/ui.search_box_mixin.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

var $jFnCG = parcelRequire("jFnCG");
var $001a89c010abd786$var$_renderer2 = $001a89c010abd786$var$_interopRequireDefault($jFnCG);

var $7I8Uw = parcelRequire("7I8Uw");

var $cnVbh = parcelRequire("cnVbh");
var $001a89c010abd786$var$_message2 = $001a89c010abd786$var$_interopRequireDefault($cnVbh);
var $225e039e8da4def7$exports = {};
/**
 * DevExtreme (ui/text_box.js)
 * Version: 19.2.9
 * Build date: Thu Jul 09 2020
 *
 * Copyright (c) 2012 - 2020 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */ "use strict";

$225e039e8da4def7$exports = (parcelRequire("9WfTY"));
$225e039e8da4def7$exports.default = $225e039e8da4def7$exports;


var $001a89c010abd786$var$_text_box2 = $001a89c010abd786$var$_interopRequireDefault($225e039e8da4def7$exports);

var $lrsNa = parcelRequire("lrsNa");
var $001a89c010abd786$var$_ui2 = $001a89c010abd786$var$_interopRequireDefault($lrsNa);

var $2F60d = parcelRequire("2F60d");
function $001a89c010abd786$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$001a89c010abd786$exports = {
    _getDefaultOptions: function() {
        return (0, $7I8Uw.extend)(this.callBase(), {
            searchMode: "",
            searchExpr: null,
            searchValue: "",
            searchEnabled: false,
            searchEditorOptions: {}
        });
    },
    _initMarkup: function() {
        this._renderSearch();
        this.callBase();
    },
    _renderSearch: function() {
        var $element = this.$element();
        var searchEnabled = this.option("searchEnabled");
        var searchBoxClassName = this._addWidgetPrefix("search");
        var rootElementClassName = this._addWidgetPrefix("with-search");
        if (!searchEnabled) {
            $element.removeClass(rootElementClassName);
            this._removeSearchBox();
            return;
        }
        var editorOptions = this._getSearchEditorOptions();
        if (this._searchEditor) this._searchEditor.option(editorOptions);
        else {
            $element.addClass(rootElementClassName);
            this._$searchEditorElement = (0, $001a89c010abd786$var$_renderer2.default)("<div>").addClass(searchBoxClassName).prependTo($element);
            this._searchEditor = this._createComponent(this._$searchEditorElement, $001a89c010abd786$var$_text_box2.default, editorOptions);
        }
    },
    _removeSearchBox: function() {
        this._$searchEditorElement && this._$searchEditorElement.remove();
        delete this._$searchEditorElement;
        delete this._searchEditor;
    },
    _getSearchEditorOptions: function() {
        var that = this;
        var userEditorOptions = that.option("searchEditorOptions");
        var searchText = $001a89c010abd786$var$_message2.default.format("Search");
        return (0, $7I8Uw.extend)({
            mode: "search",
            placeholder: searchText,
            tabIndex: that.option("tabIndex"),
            value: that.option("searchValue"),
            valueChangeEvent: "input",
            inputAttr: {
                "aria-label": searchText
            },
            onValueChanged: function(e) {
                var searchTimeout = that.option("searchTimeout");
                that._valueChangeDeferred = new $2F60d.Deferred;
                clearTimeout(that._valueChangeTimeout);
                that._valueChangeDeferred.done((function() {
                    this.option("searchValue", e.value);
                }).bind(that));
                if (e.event && "input" === e.event.type && searchTimeout) that._valueChangeTimeout = setTimeout(function() {
                    that._valueChangeDeferred.resolve();
                }, searchTimeout);
                else that._valueChangeDeferred.resolve();
            }
        }, userEditorOptions);
    },
    _getAriaTarget: function() {
        if (this.option("searchEnabled")) return this._itemContainer(true);
        return this.$element();
    },
    _focusTarget: function() {
        if (this.option("searchEnabled")) return this._itemContainer(true);
        return this.callBase();
    },
    _updateFocusState: function(e, isFocused) {
        if (this.option("searchEnabled")) this._toggleFocusClass(isFocused, this.$element());
        this.callBase(e, isFocused);
    },
    getOperationBySearchMode: function(searchMode) {
        return "equals" === searchMode ? "=" : searchMode;
    },
    _cleanAria: function($target) {
        this.setAria({
            role: null,
            activedescendant: null
        }, $target);
        $target.attr("tabIndex", null);
    },
    _optionChanged: function(args) {
        switch(args.name){
            case "searchEnabled":
            case "searchEditorOptions":
                this._cleanAria(this.option("searchEnabled") ? this.$element() : this._itemContainer());
                this._invalidate();
                break;
            case "searchExpr":
            case "searchMode":
            case "searchValue":
                if (!this._dataSource) {
                    $001a89c010abd786$var$_ui2.default.log("W1009");
                    return;
                }
                if ("searchMode" === args.name) this._dataSource.searchOperation(this.getOperationBySearchMode(args.value));
                else this._dataSource[args.name](args.value);
                this._dataSource.load();
                break;
            case "searchTimeout":
                break;
            default:
                this.callBase(args);
        }
    },
    focus: function() {
        if (!this.option("focusedElement") && this.option("searchEnabled")) {
            this._searchEditor && this._searchEditor.focus();
            return;
        }
        this.callBase();
    },
    _refresh: function() {
        if (this._valueChangeDeferred) this._valueChangeDeferred.resolve();
        this.callBase();
    }
};


var $7dea806eb78546fb$var$ListSearch = $a05b4d936a1dbd20$exports.inherit($001a89c010abd786$exports).inherit({
    _addWidgetPrefix: function(className) {
        return "dx-list-" + className;
    },
    _getCombinedFilter: function() {
        var filter;
        var storeLoadOptions;
        var dataSource = this._dataSource;
        if (dataSource) {
            storeLoadOptions = {
                filter: dataSource.filter()
            };
            dataSource._addSearchFilter(storeLoadOptions);
            filter = storeLoadOptions.filter;
        }
        return filter;
    },
    _initDataSource: function() {
        var value = this.option("searchValue");
        var expr = this.option("searchExpr");
        var mode = this.option("searchMode");
        this.callBase();
        if (this._dataSource) {
            value && value.length && this._dataSource.searchValue(value);
            mode.length && this._dataSource.searchOperation($001a89c010abd786$exports.getOperationBySearchMode(mode));
            expr && this._dataSource.searchExpr(expr);
        }
    }
});
$7dea806eb78546fb$exports = $7dea806eb78546fb$var$ListSearch;



var $4ZFRo = parcelRequire("4ZFRo");
$4ZFRo("dxList", $7dea806eb78546fb$exports);
$7e39b6ad1e6ceca3$exports = $7dea806eb78546fb$exports;
$7e39b6ad1e6ceca3$exports.default = $7e39b6ad1e6ceca3$exports;



var $3LUJe = parcelRequire("3LUJe");

var $4dqlD = parcelRequire("4dqlD");
var $44829b479fecc05f$require$ChildDefaultTemplate = $4dqlD.ChildDefaultTemplate;
var $44829b479fecc05f$var$DROP_DOWN_MENU_CLASS = "dx-dropdownmenu";
var $44829b479fecc05f$var$DROP_DOWN_MENU_POPUP_CLASS = "dx-dropdownmenu-popup";
var $44829b479fecc05f$var$DROP_DOWN_MENU_POPUP_WRAPPER_CLASS = "dx-dropdownmenu-popup-wrapper";
var $44829b479fecc05f$var$DROP_DOWN_MENU_LIST_CLASS = "dx-dropdownmenu-list";
var $44829b479fecc05f$var$DROP_DOWN_MENU_BUTTON_CLASS = "dx-dropdownmenu-button";
var $44829b479fecc05f$var$POPUP_OPTION_MAP = {
    popupWidth: "width",
    popupHeight: "height",
    popupMaxHeight: "maxHeight",
    popupAutoResizeEnabled: "autoResizeEnabled"
};
var $44829b479fecc05f$var$BUTTON_OPTION_MAP = {
    buttonIcon: "icon",
    buttonText: "text",
    buttonWidth: "width",
    buttonHeight: "height",
    buttonTemplate: "template"
};
var $44829b479fecc05f$var$DropDownMenu = $4gmvS.inherit({
    _supportedKeys: function() {
        var extension = {};
        if (!this.option("opened") || !this._list.option("focusedElement")) extension = this._button._supportedKeys();
        return $44829b479fecc05f$require$extend(this.callBase(), extension, {
            tab: function() {
                this._popup && this._popup.hide();
            }
        });
    },
    _getDefaultOptions: function() {
        return $44829b479fecc05f$require$extend(this.callBase(), {
            items: [],
            onItemClick: null,
            dataSource: null,
            itemTemplate: "item",
            buttonText: "",
            buttonIcon: "overflow",
            buttonWidth: void 0,
            buttonHeight: void 0,
            buttonTemplate: "content",
            onButtonClick: null,
            usePopover: false,
            popupWidth: "auto",
            popupHeight: "auto",
            activeStateEnabled: true,
            hoverStateEnabled: true,
            opened: false,
            selectionMode: "none",
            selectedItemKeys: [],
            deferRendering: false,
            popupPosition: {
                my: "top center",
                at: "bottom center",
                collision: "fit flip",
                offset: {
                    v: 1
                }
            },
            popupAnimation: void 0,
            onItemRendered: null,
            menuWidget: $7e39b6ad1e6ceca3$exports,
            popupMaxHeight: void 0,
            closeOnClick: true,
            useInkRipple: false,
            container: void 0,
            popupAutoResizeEnabled: false
        });
    },
    _defaultOptionsRules: function() {
        return this.callBase().concat([
            {
                device: {
                    platform: "ios"
                },
                options: {
                    usePopover: true
                }
            },
            {
                device: {
                    platform: "generic"
                },
                options: {
                    popupPosition: {
                        offset: {
                            v: 4
                        }
                    }
                }
            },
            {
                device: function() {
                    return "desktop" === $aiwte.real().deviceType && !$aiwte.isSimulator();
                },
                options: {
                    focusStateEnabled: true
                }
            },
            {
                device: {
                    platform: "android"
                },
                options: {
                    popupPosition: {
                        my: "top " + (this.option("rtlEnabled") ? "left" : "right"),
                        at: "top " + (this.option("rtlEnabled") ? "left" : "right"),
                        collision: "flipfit"
                    },
                    popupAnimation: {
                        show: {
                            type: "pop",
                            duration: 200,
                            from: {
                                scale: 0
                            },
                            to: {
                                scale: 1
                            }
                        },
                        hide: {
                            type: "pop",
                            duration: 200,
                            from: {
                                scale: 1
                            },
                            to: {
                                scale: 0
                            }
                        }
                    }
                }
            },
            {
                device: function() {
                    return $3LUJe.isMaterial();
                },
                options: {
                    useInkRipple: true
                }
            }
        ]);
    },
    _initOptions: function(options) {
        if ("android" === $aiwte.current().platform) {
            if (!options.popupPosition) options.popupPosition = {
                at: (options.usePopover ? "bottom " : "top ") + (options.rtlEnabled ? "left" : "right")
            };
        }
        this.callBase(options);
    },
    _dataSourceOptions: function() {
        return {
            paginate: false
        };
    },
    _init: function() {
        this.callBase();
        this.$element().addClass($44829b479fecc05f$var$DROP_DOWN_MENU_CLASS);
        this._initDataSource();
        this._initItemClickAction();
        this._initButtonClickAction();
    },
    _initItemClickAction: function() {
        this._itemClickAction = this._createActionByOption("onItemClick");
    },
    _initButtonClickAction: function() {
        this._buttonClickAction = this._createActionByOption("onButtonClick");
    },
    _initTemplates: function() {
        this.callBase();
        this._defaultTemplates.content = new $44829b479fecc05f$require$ChildDefaultTemplate("content");
    },
    _initMarkup: function() {
        this._renderButton();
        this.callBase();
    },
    _render: function() {
        this.callBase();
        this.setAria({
            role: "menubar",
            haspopup: true,
            expanded: this.option("opened")
        });
    },
    _renderContentImpl: function() {
        if (this.option("opened")) this._renderPopup();
    },
    _clean: function() {
        this._cleanFocusState();
        if (this._popup) {
            this._popup.$element().remove();
            delete this._$popup;
        }
    },
    _renderButton: function() {
        var $button = this.$element().addClass($44829b479fecc05f$var$DROP_DOWN_MENU_BUTTON_CLASS);
        var config = this._buttonOptions();
        this._button = this._createComponent($button, $7KuSv, config);
    },
    _toggleActiveState: function($element, value, e) {
        this._button._toggleActiveState($element, value, e);
    },
    _buttonOptions: function() {
        return {
            text: this.option("buttonText"),
            icon: this.option("buttonIcon"),
            width: this.option("buttonWidth"),
            height: this.option("buttonHeight"),
            useInkRipple: this.option("useInkRipple"),
            template: this.option("buttonTemplate"),
            focusStateEnabled: false,
            onClick: (function(e) {
                this.option("opened", !this.option("opened"));
                this._buttonClickAction(e);
            }).bind(this)
        };
    },
    _toggleMenuVisibility: function(opened) {
        var state = void 0 === opened ? !this._popup.option("visible") : opened;
        if (opened) this._renderPopup();
        this._popup.toggle(state);
        this.setAria("expanded", state);
    },
    _renderPopup: function() {
        if (this._$popup) return;
        var $popup = this._$popup = $jFnCG("<div>").appendTo(this.$element());
        var config = this._popupOptions();
        this._popup = this._createComponent($popup, $6135956410ac0e32$exports, config);
    },
    _popupOptions: function() {
        var usePopup = !this.option("usePopover");
        return {
            onInitialized: function(args) {
                args.component._wrapper().addClass($44829b479fecc05f$var$DROP_DOWN_MENU_POPUP_WRAPPER_CLASS).toggleClass($44829b479fecc05f$var$DROP_DOWN_MENU_POPUP_CLASS, usePopup);
            },
            visible: this.option("opened"),
            deferRendering: false,
            contentTemplate: (function(contentElement) {
                this._renderList(contentElement);
            }).bind(this),
            position: this.option("popupPosition"),
            animation: this.option("popupAnimation"),
            onOptionChanged: (function(args) {
                if ("visible" === args.name) this.option("opened", args.value);
            }).bind(this),
            target: this.$element(),
            height: this.option("popupHeight"),
            width: this.option("popupWidth"),
            maxHeight: this.option("popupMaxHeight"),
            container: this.option("container"),
            autoResizeEnabled: this.option("popupAutoResizeEnabled")
        };
    },
    _renderList: function(contentElement) {
        var $content = $jFnCG(contentElement);
        var listConfig = this._listOptions();
        $content.addClass($44829b479fecc05f$var$DROP_DOWN_MENU_LIST_CLASS);
        this._list = this._createComponent($content, this.option("menuWidget"), listConfig);
        this._list._getAriaTarget = (function() {
            return this.$element();
        }).bind(this);
        this._setListDataSource();
        var listMaxHeight = .5 * $jFnCG($44829b479fecc05f$var$window).height();
        if ($content.height() > listMaxHeight) $content.height(listMaxHeight);
    },
    _listOptions: function() {
        return {
            _keyboardProcessor: this._listProcessor,
            pageLoadMode: "scrollBottom",
            indicateLoading: false,
            noDataText: "",
            selectionMode: this.option("selectionMode"),
            selectedItemKeys: this.option("selectedItemKeys"),
            itemTemplate: this.option("itemTemplate"),
            onItemClick: (function(e) {
                if (this.option("closeOnClick")) this.option("opened", false);
                this._itemClickAction(e);
            }).bind(this),
            tabIndex: -1,
            focusStateEnabled: this.option("focusStateEnabled"),
            activeStateEnabled: this.option("activeStateEnabled"),
            onItemRendered: this.option("onItemRendered"),
            _itemAttributes: {
                role: "menuitem"
            }
        };
    },
    _setListDataSource: function() {
        if (this._list) this._list.option("dataSource", this._dataSource || this.option("items"));
        delete this._deferRendering;
    },
    _attachKeyboardEvents: function() {
        this.callBase.apply(this, arguments);
        this._listProcessor = this._keyboardProcessor && this._keyboardProcessor.attachChildProcessor();
        if (this._list) this._list.option("_keyboardProcessor", this._listProcessor);
    },
    _cleanFocusState: function() {
        this.callBase.apply(this, arguments);
        delete this._listProcessor;
    },
    _toggleVisibility: function(visible) {
        this.callBase(visible);
        this._button.option("visible", visible);
    },
    _optionChanged: function(args) {
        var name = args.name;
        var value = args.value;
        switch(name){
            case "items":
            case "dataSource":
                if (this.option("deferRendering") && !this.option("opened")) this._deferRendering = true;
                else {
                    this._refreshDataSource();
                    this._setListDataSource();
                }
                break;
            case "itemTemplate":
                if (this._list) this._list.option(name, this._getTemplate(value));
                break;
            case "onItemClick":
                this._initItemClickAction();
                break;
            case "onButtonClick":
                this._buttonClickAction();
                break;
            case "buttonIcon":
            case "buttonText":
            case "buttonWidth":
            case "buttonHeight":
            case "buttonTemplate":
                this._button.option($44829b479fecc05f$var$BUTTON_OPTION_MAP[name], value);
                this._renderPopup();
                break;
            case "popupWidth":
            case "popupHeight":
            case "popupMaxHeight":
            case "popupAutoResizeEnabled":
                this._popup.option($44829b479fecc05f$var$POPUP_OPTION_MAP[name], value);
                break;
            case "usePopover":
            case "menuWidget":
            case "useInkRipple":
                this._invalidate();
                break;
            case "focusStateEnabled":
            case "activeStateEnabled":
                if (this._list) this._list.option(name, value);
                this.callBase(args);
                break;
            case "selectionMode":
            case "selectedItemKeys":
            case "onItemRendered":
                if (this._list) this._list.option(name, value);
                break;
            case "opened":
                if (this._deferRendering) {
                    this._refreshDataSource();
                    this._setListDataSource();
                }
                this._toggleMenuVisibility(value);
                break;
            case "deferRendering":
            case "popupPosition":
            case "closeOnClick":
                break;
            case "container":
                this._popup && this._popup.option(args.name, args.value);
                break;
            default:
                this.callBase(args);
        }
    },
    open: function() {
        this.option("opened", true);
    },
    close: function() {
        this.option("opened", false);
    }
}).include($17b240b889a91c20$exports);
$4ZFRo("dxDropDownMenu", $44829b479fecc05f$var$DropDownMenu);
$44829b479fecc05f$exports = $44829b479fecc05f$var$DropDownMenu;


var $1c014afc280854ff$var$MENU_INVISIBLE_CLASS = "dx-state-invisible";
var $1c014afc280854ff$var$DropDownMenuStrategy = $c5879277017430c5$exports.inherit({
    NAME: "dropDownMenu",
    render: function() {
        if (!this._hasVisibleMenuItems()) return;
        this._renderMenuButtonContainer();
        this._renderWidget();
    },
    renderMenuItems: function() {
        if (!this._menu) this.render();
        this.callBase();
        if (this._menu && !this._menu.option("items").length) this._menu.close();
    },
    _menuWidgetClass: function() {
        return $44829b479fecc05f$exports;
    },
    _widgetOptions: function() {
        var that = this;
        return $1c014afc280854ff$require$extend(this.callBase(), {
            deferRendering: true,
            container: that._toolbar.option("menuContainer"),
            menuWidget: $1d90122c979d47ee$exports,
            onOptionChanged: function(e) {
                if ("items" === e.name) that._updateMenuVisibility(e.value);
            },
            popupPosition: {
                at: "bottom right",
                my: "top right"
            }
        });
    },
    _updateMenuVisibility: function(menuItems) {
        var items = menuItems || this._getMenuItems();
        var isMenuVisible = items.length && this._hasVisibleMenuItems(items);
        this._toggleMenuVisibility(isMenuVisible);
    },
    _toggleMenuVisibility: function(value) {
        if (!this._menuContainer()) return;
        this._menuContainer().toggleClass($1c014afc280854ff$var$MENU_INVISIBLE_CLASS, !value);
    },
    _menuContainer: function() {
        return this._$menuButtonContainer;
    }
});
$1c014afc280854ff$exports = $1c014afc280854ff$var$DropDownMenuStrategy;




var $4dqlD = parcelRequire("4dqlD");
var $17d3d2d92491e950$require$ChildDefaultTemplate = $4dqlD.ChildDefaultTemplate;
var $17d3d2d92491e950$var$STRATEGIES = {
    actionSheet: $82371d383bcfde9d$exports,
    dropDownMenu: $1c014afc280854ff$exports
};
var $17d3d2d92491e950$var$TOOLBAR_AUTO_HIDE_ITEM_CLASS = "dx-toolbar-item-auto-hide";
var $17d3d2d92491e950$var$TOOLBAR_AUTO_HIDE_TEXT_CLASS = "dx-toolbar-text-auto-hide";
var $17d3d2d92491e950$var$TOOLBAR_HIDDEN_ITEM = "dx-toolbar-item-invisible";
var $17d3d2d92491e950$var$Toolbar = $bdbd081a08b7d677$exports.inherit({
    _getDefaultOptions: function() {
        return $17d3d2d92491e950$require$extend(this.callBase(), {
            menuItemTemplate: "menuItem",
            submenuType: "dropDownMenu",
            menuContainer: void 0
        });
    },
    _defaultOptionsRules: function() {
        var themeName = $3LUJe.current();
        return this.callBase().concat([
            {
                device: function() {
                    return $3LUJe.isIos7(themeName);
                },
                options: {
                    submenuType: "actionSheet"
                }
            }
        ]);
    },
    _dimensionChanged: function(dimension) {
        if ("height" === dimension) return;
        this._menuStrategy.toggleMenuVisibility(false, true);
        this.callBase();
        this._menuStrategy.renderMenuItems();
    },
    _initTemplates: function() {
        this.callBase();
        this._defaultTemplates.actionSheetItem = new $17d3d2d92491e950$require$ChildDefaultTemplate("item");
    },
    _initMarkup: function() {
        this.callBase();
        this._renderMenu();
    },
    _postProcessRenderItems: function() {
        this._hideOverflowItems();
        this._menuStrategy._updateMenuVisibility();
        this.callBase();
        this._menuStrategy.renderMenuItems();
    },
    _renderItem: function(index, item, itemContainer, $after) {
        var itemElement = this.callBase(index, item, itemContainer, $after);
        if ("auto" === item.locateInMenu) itemElement.addClass($17d3d2d92491e950$var$TOOLBAR_AUTO_HIDE_ITEM_CLASS);
        if ("dxButton" === item.widget && "inMenu" === item.showText) itemElement.toggleClass($17d3d2d92491e950$var$TOOLBAR_AUTO_HIDE_TEXT_CLASS);
        return itemElement;
    },
    _getItemsWidth: function() {
        return this._getSummaryItemsWidth([
            this._$beforeSection,
            this._$centerSection,
            this._$afterSection
        ]);
    },
    _hideOverflowItems: function(elementWidth) {
        var overflowItems = this.$element().find("." + $17d3d2d92491e950$var$TOOLBAR_AUTO_HIDE_ITEM_CLASS);
        if (!overflowItems.length) return;
        elementWidth = elementWidth || this.$element().width();
        $jFnCG(overflowItems).removeClass($17d3d2d92491e950$var$TOOLBAR_HIDDEN_ITEM);
        var itemsWidth = this._getItemsWidth();
        while(overflowItems.length && elementWidth < itemsWidth){
            var $item = overflowItems.eq(-1);
            itemsWidth -= $item.outerWidth();
            $item.addClass($17d3d2d92491e950$var$TOOLBAR_HIDDEN_ITEM);
            overflowItems.splice(-1, 1);
        }
    },
    _getMenuItems: function() {
        var that = this;
        var menuItems = $17d3d2d92491e950$require$grep(this.option("items") || [], function(item) {
            return that._isMenuItem(item);
        });
        var $hiddenItems = this._itemContainer().children("." + $17d3d2d92491e950$var$TOOLBAR_AUTO_HIDE_ITEM_CLASS + "." + $17d3d2d92491e950$var$TOOLBAR_HIDDEN_ITEM).not(".dx-state-invisible");
        this._restoreItems = this._restoreItems || [];
        var overflowItems = [].slice.call($hiddenItems).map(function(item) {
            var itemData = that._getItemData(item);
            var $itemContainer = $jFnCG(item).children();
            var $itemMarkup = $itemContainer.children();
            return $17d3d2d92491e950$require$extend({
                menuItemTemplate: function() {
                    that._restoreItems.push({
                        container: $itemContainer,
                        item: $itemMarkup
                    });
                    var $container = $jFnCG("<div>").addClass($17d3d2d92491e950$var$TOOLBAR_AUTO_HIDE_ITEM_CLASS);
                    return $container.append($itemMarkup);
                }
            }, itemData);
        });
        return $aLQK5.merge(overflowItems, menuItems);
    },
    _getToolbarItems: function() {
        var that = this;
        return $17d3d2d92491e950$require$grep(this.option("items") || [], function(item) {
            return !that._isMenuItem(item);
        });
    },
    _renderMenu: function() {
        this._renderMenuStrategy();
        this._menuStrategy.render();
    },
    _renderMenuStrategy: function() {
        var strategyName = this.option("submenuType");
        if (this._requireDropDownStrategy()) strategyName = "dropDownMenu";
        var strategy = $17d3d2d92491e950$var$STRATEGIES[strategyName];
        if (!(this._menuStrategy && this._menuStrategy.NAME === strategyName)) this._menuStrategy = new strategy(this);
    },
    _requireDropDownStrategy: function() {
        var items = this.option("items") || [];
        var result = false;
        $4Pwuy.each(items, function(index, item) {
            if ("auto" === item.locateInMenu) result = true;
            else if ("always" === item.locateInMenu && item.widget) result = true;
        });
        return result;
    },
    _arrangeItems: function() {
        if (this.$element().is(":hidden")) return;
        this._$centerSection.css({
            margin: "0 auto",
            "float": "none"
        });
        $4Pwuy.each(this._restoreItems || [], function(_, obj) {
            $jFnCG(obj.container).append(obj.item);
        });
        this._restoreItems = [];
        var elementWidth = this.$element().width();
        this._hideOverflowItems(elementWidth);
        this.callBase(elementWidth);
    },
    _itemOptionChanged: function(item, property, value) {
        if (this._isMenuItem(item)) this._menuStrategy.renderMenuItems();
        else if (this._isToolbarItem(item)) this.callBase(item, property, value);
        else {
            this.callBase(item, property, value);
            this._menuStrategy.renderMenuItems();
        }
        if ("location" === property) this.repaint();
    },
    _isMenuItem: function(itemData) {
        return "menu" === itemData.location || "always" === itemData.locateInMenu;
    },
    _isToolbarItem: function(itemData) {
        return void 0 === itemData.location || "never" === itemData.locateInMenu;
    },
    _optionChanged: function(args) {
        var name = args.name;
        var value = args.value;
        switch(name){
            case "submenuType":
                this._invalidate();
                break;
            case "visible":
                this.callBase.apply(this, arguments);
                this._menuStrategy.handleToolbarVisibilityChange(value);
                break;
            case "menuItemTemplate":
                this._changeMenuOption("itemTemplate", this._getTemplate(value));
                break;
            case "onItemClick":
                this._changeMenuOption(name, value);
                this.callBase.apply(this, arguments);
                break;
            case "menuContainer":
                this._changeMenuOption("container", value);
                break;
            default:
                this.callBase.apply(this, arguments);
        }
    },
    _changeMenuOption: function(name, value) {
        this._menuStrategy.widgetOption(name, value);
    }
});
$4ZFRo("dxToolbar", $17d3d2d92491e950$var$Toolbar);
$17d3d2d92491e950$exports = $17d3d2d92491e950$var$Toolbar;
$17d3d2d92491e950$exports.default = $17d3d2d92491e950$exports;



var $7KuSv = parcelRequire("7KuSv");
var $b302555736d21bd7$exports = {};

$b302555736d21bd7$exports = (parcelRequire("7we3r"));


class $ca8936ab77f7f82b$export$2c4e825dc9120f87 {
    constructor({ baseURL: baseURL = "/api" } = {}){
        this._baseURL = baseURL;
        this._axious = (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).create({
        });
    }
    async _get(endpoint, options) {
        try {
            const response = await this._axious.get(endpoint, options);
            return response.data;
        } catch (e) {
            throw {
                title: "",
                detail: e.response.data,
                status: e.response.status,
                error: new Error()
            };
        }
    }
    async getCalendar() {
        return await this._get(`${this._baseURL}/calendar.json`);
    }
    async getSpriteManifest(date) {
        return await this._get(`${this._baseURL}/${date}/manifest.json`);
    }
    async getSpriteImage(date, filename, cb) {
        const image = await this.getImage(`${this._baseURL}/${date}/${filename}`);
        if (cb) cb();
        return image;
    }
    async getTileImage(date, filename) {
        return await this.getImage(`${this._baseURL}/${date}/images/${filename}`);
    }
    async loadBLOB(url) {
        const response = await this._get(url, {
            responseType: "arraybuffer"
        });
        return new Blob([
            response
        ]);
    }
    async getImage(url) {
        const blob = await this.loadBLOB(url);
        const URLObject = URL.createObjectURL(blob);
        return this._loadImage(URLObject);
    }
    BLOBtoImage(blob) {
        const URLObject = URL.createObjectURL(blob);
        return this._loadImage(URLObject);
    }
    _loadImage(url) {
        return new Promise((resolve, reject)=>{
            const img = new Image();
            img.addEventListener("load", ()=>resolve(img));
            img.addEventListener("error", ()=>reject());
            img.src = url;
        });
    }
}
var $ca8936ab77f7f82b$export$2e2bcd8739ae039 = new $ca8936ab77f7f82b$export$2c4e825dc9120f87();


const $4f3c384c45386066$var$api = new (0, $ca8936ab77f7f82b$export$2c4e825dc9120f87)({
    baseURL: "/data"
});
(0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).defaultFormat = "YYYYMMDD";
class $4f3c384c45386066$export$2e2bcd8739ae039 {
    constructor(container){
        this.init(container, true);
    }
    async init(container) {
        this._aside = container.querySelector("aside");
        this._main = container.querySelector("main");
        this._thumbs = container.querySelector(".timeline-thumbs");
        this._thumb_size = this._thumbs.offsetHeight;
        this._c = container.querySelector(".calendar-wrapper");
        this._canvas = this.initCanvas(container.querySelector(".view-canvas-wrapper"));
        this._toolbar = this.initToolbar(container.querySelector(".toolbar-wrapper"));
        this.initCalendar(container.querySelector(".calendar-wrapper"));
        this.initViewButtons(container.querySelector(".view-prev-wrapper"), container.querySelector(".view-next-wrapper"));
        this.initTimeline(container.querySelector(".timeline"));
        this.initKeyboardKeysHandler();
        this.updateLoop("30");
        this._timer = null;
    }
    updateLoop(timeout = 60) {
        setTimeout(async ()=>{
            this.updateLoop(timeout);
            await this.updateCalendar();
            await this.updateImageData();
        }, timeout * 1000);
    }
    // 
    getNextImageIndex() {
        return Math.min(this._selectedTileIndex + 1, this._tiles.length - 1);
    }
    getPrevImageIndex() {
        return Math.max(this._selectedTileIndex - 1, 0);
    }
    stopImageSequence() {
        if (this._timer) clearTimeout(this._timer);
        this.drawFullsizeImage(this._selectedTileIndex);
        this._isPlaying = false;
    }
    playImageSequence(newImageIndexFunc) {
        const playDelay = 1000;
        const playInterval = 50;
        const self1 = this;
        function play(timeout) {
            const newImageIndex = newImageIndexFunc();
            if (newImageIndex === self1._selectedTileIndex) {
                self1.stopImageSequence();
                return;
            }
            self1._timer = setTimeout(()=>play(timeout === playDelay ? playInterval : timeout), timeout);
            self1.setTimelineItem(newImageIndex);
            self1.scrollToTimelineThumb(newImageIndex);
            self1._isPlaying = timeout === playInterval;
        }
        play(playDelay);
    }
    initKeyboardKeysHandler() {
        let rightArrowKeyPressed = false;
        let leftArrowKeyPressed = false;
        document.addEventListener("keydown", (e)=>{
            if (e.code === "ArrowRight") {
                if (rightArrowKeyPressed) return;
                rightArrowKeyPressed = true;
                this.playImageSequence(()=>this.getNextImageIndex());
            } else if (e.code === "ArrowLeft") {
                if (leftArrowKeyPressed) return;
                leftArrowKeyPressed = true;
                this.playImageSequence(()=>this.getPrevImageIndex());
            }
        });
        document.addEventListener("keyup", (e)=>{
            if (e.code === "ArrowRight") {
                rightArrowKeyPressed = false;
                this.stopImageSequence();
            } else if (e.code === "ArrowLeft") {
                leftArrowKeyPressed = false;
                this.stopImageSequence();
            }
        });
    }
    initViewButtons(prevButtonContainer, nextButtonContainer) {
        const self1 = this;
        new (0, (/*@__PURE__*/$parcel$interopDefault($7KuSv)))(document.createElement("div"), {
            icon: "chevronleft",
            stylingMode: "text",
            hoverStateEnabled: true,
            activeStateEnabled: true,
            focusStateEnabled: false,
            onInitialized: (e)=>{
                const elem = e.element;
                elem.addEventListener("mousedown", ()=>self1.playImageSequence(()=>self1.getPrevImageIndex()));
                elem.addEventListener("mouseup", ()=>self1.stopImageSequence());
                elem.addEventListener("mouseleave", ()=>self1.stopImageSequence());
                prevButtonContainer.appendChild(elem);
                this._prevImageButton = e.component;
            }
        });
        new (0, (/*@__PURE__*/$parcel$interopDefault($7KuSv)))(document.createElement("div"), {
            icon: "chevronright",
            hoverStateEnabled: true,
            activeStateEnabled: true,
            focusStateEnabled: false,
            stylingMode: "text",
            onInitialized: (e)=>{
                const elem = e.element;
                elem.addEventListener("mousedown", ()=>self1.playImageSequence(()=>self1.getNextImageIndex()));
                elem.addEventListener("mouseup", ()=>self1.stopImageSequence());
                elem.addEventListener("mouseleave", ()=>self1.stopImageSequence());
                nextButtonContainer.appendChild(elem);
                this._nextImageButton = e.component;
            }
        });
    }
    initCanvas(container) {
        const canvas = document.createElement("canvas");
        // square derived from responsive css width of 100%
        canvas.height = canvas.width;
        container.appendChild(canvas);
        return canvas;
    }
    initToolbar(container, showSidebar = true, showThumbIndices = true, autoUpdate = true) {
        this._showThumbIndices = showThumbIndices;
        this._showSidebar = showSidebar;
        this._autoUpdate = autoUpdate;
        if (this._showThumbIndices) this._thumbs.classList.add("with-indices");
        this._toolbarCalendar = document.createElement("div");
        this._toolbarCalendar.classList.add("toolbar-calendar");
        this._timestamp = document.createElement("div");
        this._timestamp.classList.add("toolbar-date");
        this._toolbarCalendar.appendChild(this._timestamp);
        this._timestamp.addEventListener("click", (e)=>{
            if (this._showSidebar) return false;
            if (this._c.parentNode !== this._calendarOrigin) this._calendarOrigin.appendChild(this._c);
            else this._toolbarCalendar.appendChild(this._c);
        });
        const self1 = this;
        return new (0, (/*@__PURE__*/$parcel$interopDefault($17d3d2d92491e950$exports)))(document.createElement("div"), {
            onInitialized: (e)=>{
                container.appendChild(e.element);
            },
            items: [
                {
                    location: "before",
                    template: `<h1>Kiruna</h1>`
                },
                {
                    location: "center",
                    widget: "dxButton",
                    options: {
                        icon: "chevronleft",
                        hint: "Previous day",
                        disabled: true,
                        onInitialized: (e)=>this._prevDateButton = e.component,
                        onClick: (e)=>{
                            const prevCalendarDate = this.getPrevCalendarDate();
                            if (prevCalendarDate) {
                                this.setCalendarDate(prevCalendarDate);
                                this.setToolbarDate(prevCalendarDate);
                            }
                        }
                    }
                },
                {
                    location: "center",
                    template: ()=>this._toolbarCalendar
                },
                {
                    location: "center",
                    widget: "dxButton",
                    options: {
                        icon: "chevronright",
                        hint: "Next day",
                        disabled: true,
                        onInitialized: (e)=>this._nextDateButton = e.component,
                        onClick: (e)=>{
                            const nextCalendarDate = this.getNextCalendarDate();
                            if (nextCalendarDate) {
                                this.setCalendarDate(nextCalendarDate);
                                this.setToolbarDate(nextCalendarDate);
                            }
                        }
                    }
                },
                {
                    location: "after",
                    widget: "dxButton",
                    options: {
                        icon: "refresh",
                        text: "Update",
                        stylingMode: this._autoUpdate ? "contained" : "text",
                        onInitialized: (e)=>this._autoUpdateButton = e.component,
                        onClick: (e)=>this.setAutoUpdate(!this._autoUpdate)
                    }
                },
                {
                    location: "after",
                    widget: "dxButton",
                    options: {
                        icon: "smalliconslayout",
                        text: "Grid",
                        stylingMode: this._grid_view ? "contained" : "text",
                        onInitialized: (e)=>this._gridViewButton = e.component,
                        onClick: (e)=>this.setGridView(!this._grid_view)
                    }
                }
            ]
        });
    }
    initTimeline(container) {
        let scrollTimer = null;
        let grabTimer = null;
        this._preventTimelineScrollHandler = false;
        const self1 = this;
        let mouseMoveX = null;
        let mouseMoveDistance;
        let prevIndexOffset;
        container.addEventListener("mousedown", (e)=>{
            if (this._grid_view) return false;
            document.onselectstart = ()=>false;
            container.classList.add("grab");
            mouseMoveX = e.clientX;
            prevIndexOffset = 0;
        });
        container.addEventListener("mouseup", ()=>{
            if (this._grid_view) return false;
            document.onselectstart = ()=>true;
            container.classList.remove("grab");
            mouseMoveDistance = 0;
            mouseMoveX = null;
        });
        container.addEventListener("mousemove", (e)=>{
            if (this._grid_view) return false;
            if (mouseMoveX === null) return false;
            const moveOffset = mouseMoveX - e.clientX;
            if (mouseMoveDistance * moveOffset >= 0) mouseMoveDistance += moveOffset;
            else {
                mouseMoveDistance = moveOffset;
                prevIndexOffset = 0;
            }
            // const newIndexOffset = this._tiles.length * mouseMoveDistance / container.offsetHeight / 2 >> 0;
            const newIndexOffset = mouseMoveDistance / 50 >> 0;
            if (newIndexOffset === prevIndexOffset) return;
            const newIndex = this._selectedTileIndex + (prevIndexOffset - newIndexOffset);
            this.setTimelineItem(newIndex);
            this.scrollToTimelineThumb(newIndex);
            clearTimeout(grabTimer);
            grabTimer = setTimeout((e)=>{
                this.drawFullsizeImage(self1._selectedTileIndex);
            }, 250);
            prevIndexOffset = newIndexOffset;
            mouseMoveX = e.clientX;
        });
        let lastScrollEventTimestamp = null;
        container.addEventListener("scroll", (e)=>{
            let now = new Date().getTime();
            if (!lastScrollEventTimestamp || now - lastScrollEventTimestamp > 500) {
                lastScrollEventTimestamp = now;
                return false;
            }
            lastScrollEventTimestamp = now;
            if (this._grid_view || this._isPlaying) this._preventTimelineScrollHandler = true;
            if (this._preventTimelineScrollHandler) return;
            try {
                clearTimeout(scrollTimer);
                scrollTimer = null;
            } catch (e) {}
            const newTileindex = e.target.scrollLeft / this._thumb_size >> 0;
            const indexOffset = container.offsetWidth / 2 / this._thumb_size >> 0;
            this.setTimelineItem(newTileindex + indexOffset);
            scrollTimer = setTimeout((e)=>{
                self1.drawFullsizeImage(self1._selectedTileIndex);
            }, 250);
        });
    }
    async initCalendar(container) {
        this._calendarOrigin = container.parentNode;
        const calendarManifest = await $4f3c384c45386066$var$api.getCalendar();
        const calendarInitDate = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(calendarManifest.range[1]).toDate();
        this._calendarManifest = calendarManifest;
        new (0, (/*@__PURE__*/$parcel$interopDefault($2aa61a6482d6321b$exports)))(document.createElement("div"), {
            firstDayOfWeek: 1,
            min: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(calendarManifest.range[0]).toDate(),
            max: (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(calendarManifest.range[1]).toDate(),
            value: calendarInitDate,
            disabledDates: (e)=>{
                const dateString = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(e.date).format();
                return this._calendarManifest.missingDates.includes(dateString);
            },
            onValueChanged: async (e)=>{
                this.setAutoUpdate(false);
                if (this._c.parentNode !== this._calendarOrigin) this._calendarOrigin.appendChild(this._c);
                e.component.option("disabled", true);
                this._prevDateButton.option("disabled", true);
                this._nextDateButton.option("disabled", true);
                this.setToolbarDate(e.value);
                this._calendarDateString = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(e.value).format();
                await this.loadData(this._calendarDateString);
                e.component.option("disabled", false);
                this._prevDateButton.option("disabled", this.getPrevCalendarDate(e.component) ? false : true);
                this._nextDateButton.option("disabled", this.getNextCalendarDate(e.component) ? false : true);
            },
            onInitialized: (e)=>{
                this._calendar = e.component;
                container.appendChild(e.element);
                if (this.getPrevCalendarDate(e.component)) this._prevDateButton.option("disabled", false);
                if (this.getNextCalendarDate(e.component)) this._nextDateButton.option("disabled", false);
                this._calendarDateString = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(calendarInitDate).format();
                this.setToolbarDate(calendarInitDate);
                this.loadData(this._calendarDateString);
            }
        });
    }
    getNextCalendarDate(calendar) {
        if (!calendar) calendar = this._calendar;
        let nextCalendarDay = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(calendar.option("value")).add(1, "d");
        let maxCalendarDay = calendar.option("max");
        while(this._calendarManifest.missingDates.includes(nextCalendarDay.format()))nextCalendarDay.add(1, "d");
        if (nextCalendarDay > maxCalendarDay) return false;
        return nextCalendarDay.toDate();
    }
    getPrevCalendarDate(calendar) {
        if (!calendar) calendar = this._calendar;
        let prevCalendarDay = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(calendar.option("value")).subtract(1, "d");
        let minCalendarDay = calendar.option("min");
        while(this._calendarManifest.missingDates.includes(prevCalendarDay.format()))prevCalendarDay.subtract(1, "d");
        if (prevCalendarDay < minCalendarDay) return false;
        return prevCalendarDay.toDate();
    }
    setCalendarDate(date) {
        this._calendar.option("value", date);
    }
    getCalendarDate() {
        return this._calendar.option("value");
    }
    getLastCalendarDate() {
        return this._calendar.option("max");
    }
    setToolbarDate(date) {
        this._timestamp.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(date).format("YYYY-MM-DD");
    }
    async setAutoUpdate(enable = true) {
        if (this._autoUpdate === enable) return;
        this._autoUpdateButton.option({
            stylingMode: enable ? "contained" : "text"
        });
        if (enable) {
            await this.updateCalendar();
            const lastCalendarDate = this.getLastCalendarDate();
            if (lastCalendarDate.getTime() !== this.getCalendarDate().getTime()) {
                this.setCalendarDate(lastCalendarDate);
                this.setToolbarDate(lastCalendarDate);
            } else {
                //await this.updateImageData();
                const tileIndex = this._tiles.length - 1;
                this.setTimelineItem(tileIndex);
                this.scrollToTimelineThumb(tileIndex);
                if (!this._grid_view) this.drawFullsizeImage(tileIndex);
            }
        }
        this._autoUpdate = enable;
    }
    async updateCalendar() {
        const manifest = await $4f3c384c45386066$var$api.getCalendar();
        const min = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(manifest.range[0]).toDate();
        const max = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(manifest.range[1]).toDate();
        let calendarDate = null;
        if (!this._calendarManifest || this._autoUpdate) calendarDate = max;
        this._calendarManifest = manifest;
        this._calendar.option({
            min: min,
            max: max,
            value: calendarDate ? calendarDate : this.getCalendarDate()
        });
    }
    async updateImageData() {
        const date = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.getCalendarDate()).format();
        const manifest = await $4f3c384c45386066$var$api.getSpriteManifest(date);
        const newTiles = manifest.sprites.reduce((filtered, sprite, index)=>{
            if (index >= this._manifest.sprites.length || sprite.images.length > this._manifest.sprites[index].images.length) for(let i = this._manifest.sprites[index].images.length; i < sprite.images.length; i++)filtered.push({
                ...sprite.images[i],
                offset: [
                    0,
                    0
                ]
            });
            return filtered;
        }, []);
        this._manifest = manifest;
        if (!newTiles.length) return;
        this.updateTimeline(newTiles);
    }
    resizeImage(image, newWidth, newHeight) {
        return new Promise((resolve, reject)=>{
            const canvas = document.createElement("canvas");
            canvas.width = image.width;
            canvas.height = image.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, newWidth, newHeight);
            canvas.toBlob((blob)=>resolve($4f3c384c45386066$var$api.BLOBtoImage(blob)));
        });
    }
    async updateTimeline(newTiles) {
        const date = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw)))(this.getCalendarDate()).format();
        const tileImages = await Promise.all(newTiles.map((tile)=>$4f3c384c45386066$var$api.getTileImage(date, tile.filename)));
        for (const [tileIndex, tile] of newTiles.entries()){
            const tileImage = tileImages[tileIndex];
            this._spriteImages.push(await this.resizeImage(tileImage, this._manifest.tile.width, this._manifest.tile.height));
            URL.revokeObjectURL(tileImage.src);
            this.appendTimelineItem(tile, this._spriteImages.length - 1);
        }
        if (this._autoUpdate && this._tiles.length) {
            const selectedTileIndex = this._tiles.length - 1;
            this.setTimelineItem(selectedTileIndex);
            this.scrollToTimelineThumb(selectedTileIndex);
            if (!this._grid_view) this.drawFullsizeImage(selectedTileIndex);
        }
    }
    createTimeline() {
        this._thumbs.querySelectorAll("*").forEach((elem)=>elem.remove());
        this._tiles = [];
        const self1 = this;
        for (const [spriteIndex, sprite] of this._manifest.sprites.entries())for (const tile of sprite.images)this.appendTimelineItem(tile, spriteIndex);
        this._selectedTileIndex = null;
        if (this._tiles.length) {
            let selectedTileIndex = this._tiles.length - 1;
            this.setTimelineItem(selectedTileIndex);
            this.scrollToTimelineThumb(selectedTileIndex);
            if (!this._grid_view) this.drawFullsizeImage(selectedTileIndex);
        }
    }
    appendTimelineItem(tile, spriteIndex) {
        this._tiles.push({
            tile: tile,
            spriteIndex: spriteIndex
        });
        const tileIndex = this._tiles.length - 1;
        this._preventTimelineScrollHandler = true;
        const wrapper = document.createElement("div");
        wrapper.classList.add("timeline-thumb-item-wrapper");
        const div = document.createElement("div");
        div.classList.add("timeline-thumb-item");
        wrapper.appendChild(div);
        this._thumbs.appendChild(wrapper);
        const canvas = document.createElement("canvas");
        canvas.height = div.offsetHeight;
        canvas.width = div.offsetWidth;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(this._spriteImages[spriteIndex], tile.offset[0], tile.offset[1], this._manifest.tile.width, this._manifest.tile.height, 0, 0, canvas.width, canvas.height);
        div.appendChild(canvas);
        wrapper.setAttribute("data-time", (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).unix(tile.timestamp).utc().format("HH:mm"));
        wrapper.setAttribute("data-index", tileIndex);
        wrapper.addEventListener("click", (e)=>{
            const isSelected = wrapper.classList.contains("selected-tile");
            this.setTimelineItem(tileIndex);
            if (this._grid_view) {
                if (isSelected) this.setGridView(false);
            } else this.drawFullsizeImage(tileIndex);
        });
        return tileIndex;
    }
    async loadData(dateString) {
        this._main.setAttribute("data-loading", 0);
        this._selectedTileIndex = null;
        this._spriteImages = this._spriteImages || [];
        for (const img of this._spriteImages)URL.revokeObjectURL(img.src);
        this._manifest = await $4f3c384c45386066$var$api.getSpriteManifest(dateString);
        let _loadedSprites = 0;
        this._main.setAttribute("data-loading", _loadedSprites);
        this._spriteImages = await Promise.all(this._manifest.sprites.map((sprite, id)=>$4f3c384c45386066$var$api.getSpriteImage(dateString, sprite.filename, ()=>{
                _loadedSprites += 1;
                this._main.setAttribute("data-loading", _loadedSprites / this._manifest.sprites.length * 100 >> 0);
            })));
        this.createTimeline();
        setTimeout(()=>this._main.removeAttribute("data-loading"), 500);
        this._main.tabIndex = -1;
        this._main.focus();
    }
    showThumbIndices(enable = true) {}
    showSidebar(enable = true) {
        if (enable) this._aside.classList.remove("hidden");
        else this._aside.classList.add("hidden");
    }
    setGridView(enable = true) {
        if (enable) {
            this._grid_view = true;
            this._main.classList.add("grid-view");
        } else {
            this._grid_view = false;
            this._main.classList.remove("grid-view");
            this.drawFullsizeImage(this._selectedTileIndex);
        }
        this._preventTimelineScrollHandler = enable;
        this.scrollToTimelineThumb(this._selectedTileIndex);
        this._gridViewButton.option("stylingMode", enable ? "contained" : "text");
    }
    setTimelineItem(index) {
        if (index >= this._tiles.length - 1) this._nextImageButton.option({
            disabled: true
        });
        else this._nextImageButton.option({
            disabled: false
        });
        if (index <= 0) this._prevImageButton.option({
            disabled: true
        });
        else this._prevImageButton.option({
            disabled: false
        });
        if (index > this._tiles.length - 1 || index < 0) return;
        if (index === this._selectedTileIndex) return;
        this.selectTimelineThumb(index);
        this._selectedTileTimestamp = this._tiles[index].tile.timestamp;
        if (!self.grid_view) this.drawTimelineThumb(index);
        this.setAutoUpdate(this.getLastCalendarDate().getTime() === this.getCalendarDate().getTime() && index === this._tiles.length - 1);
    }
    scrollToTimelineThumb(tileIndex) {
        const thumbs = this._thumbs.childNodes;
        const thumb = thumbs[tileIndex];
        if (!thumb) return;
        this._preventTimelineScrollHandler = true;
        thumb.scrollIntoView({
            inline: "center"
        });
        window.scrollTo(0, 0);
        setTimeout(()=>this._preventTimelineScrollHandler = false, 500);
    }
    selectTimelineThumb(tileIndex) {
        if (!this._tiles.length) return;
        const thumbs = this._thumbs.childNodes;
        if (this._selectedTileIndex !== null) thumbs[this._selectedTileIndex].classList.remove("selected-tile");
        thumbs[tileIndex].classList.add("selected-tile");
        this._selectedTileIndex = tileIndex;
    }
    setToolbarTimestamp(tileIndex) {
        const tile = this._tiles[tileIndex];
        this._timestamp.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($45fvw))).unix(tile.tile.timestamp).utc().format("YYYY-MM-DD HH:mm UT");
    }
    drawTimelineThumb(tileIndex) {
        const tile = this._tiles[tileIndex];
        const ctx = this._canvas.getContext("2d");
        ctx.drawImage(this._spriteImages[tile.spriteIndex], tile.tile.offset[0], tile.tile.offset[1], this._manifest.tile.width, this._manifest.tile.height, 0, 0, this._canvas.width, this._canvas.height);
    }
    async drawFullsizeImage(tileIndex) {
        const tile = this._tiles[tileIndex];
        const ctx = this._canvas.getContext("2d");
        if (this._tileImage) URL.revokeObjectURL(this._tileImage.src);
        this._tileImage = await $4f3c384c45386066$var$api.getTileImage(this._calendarDateString, tile.tile.filename);
        ctx.drawImage(this._tileImage, 0, 0, this._tileImage.naturalWidth, this._tileImage.naturalHeight, 0, 0, this._canvas.width, this._canvas.height);
    }
}


window.addEventListener("load", ()=>{
    const appElemSelector = document.querySelector("#app");
    const app = new (0, $4f3c384c45386066$export$2e2bcd8739ae039)(appElemSelector);
});


//# sourceMappingURL=index.a6b8043c.js.map
